webpackJsonp([30],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListingLayout_vue__ = __webpack_require__(217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c9c0198_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListingLayout_vue__ = __webpack_require__(640);
function injectStyle (ssrContext) {
  __webpack_require__(636)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c9c0198"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListingLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c9c0198_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListingLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(206);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6655f76a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(611);
function injectStyle (ssrContext) {
  __webpack_require__(610)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6655f76a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6655f76a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabLayout_vue__ = __webpack_require__(241);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34aff766_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabLayout_vue__ = __webpack_require__(683);
function injectStyle (ssrContext) {
  __webpack_require__(682)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34aff766"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34aff766_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EffectScope */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return computed; });
/* unused harmony export createApp */
/* unused harmony export createRef */
/* unused harmony export customRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Plugin; });
/* unused harmony export defineAsyncComponent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defineComponent; });
/* unused harmony export del */
/* unused harmony export effectScope */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCurrentInstance; });
/* unused harmony export getCurrentScope */
/* unused harmony export h */
/* unused harmony export inject */
/* unused harmony export isRaw */
/* unused harmony export isReactive */
/* unused harmony export isReadonly */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isRef; });
/* unused harmony export markRaw */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return nextTick; });
/* unused harmony export onActivated */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return onBeforeMount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return onBeforeUnmount; });
/* unused harmony export onBeforeUpdate */
/* unused harmony export onDeactivated */
/* unused harmony export onErrorCaptured */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return onMounted; });
/* unused harmony export onScopeDispose */
/* unused harmony export onServerPrefetch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return onUnmounted; });
/* unused harmony export onUpdated */
/* unused harmony export provide */
/* unused harmony export proxyRefs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return reactive; });
/* unused harmony export readonly */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ref; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return set$1; });
/* unused harmony export shallowReactive */
/* unused harmony export shallowReadonly */
/* unused harmony export shallowRef */
/* unused harmony export toRaw */
/* unused harmony export toRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return toRefs; });
/* unused harmony export triggerRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return unref; });
/* unused harmony export useAttrs */
/* unused harmony export useCSSModule */
/* unused harmony export useCssModule */
/* unused harmony export useSlots */
/* unused harmony export version */
/* unused harmony export warn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return watch; });
/* unused harmony export watchEffect */
/* unused harmony export watchPostEffect */
/* unused harmony export watchSyncEffect */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

/**
 * Displays a warning message (using console.error) with a stack trace if the
 * function is called inside of active component.
 *
 * @param message warning message to be displayed
 */
function warn$1(message) {
    var _a;
    warn(message, (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy);
}

var activeEffectScope;
var effectScopeStack = [];
var EffectScopeImpl = /** @class */ (function () {
    function EffectScopeImpl(vm) {
        this.active = true;
        this.effects = [];
        this.cleanups = [];
        this.vm = vm;
    }
    EffectScopeImpl.prototype.run = function (fn) {
        if (this.active) {
            try {
                this.on();
                return fn();
            }
            finally {
                this.off();
            }
        }
        else if ((false)) {
            warn$1("cannot run an inactive effect scope.");
        }
        return;
    };
    EffectScopeImpl.prototype.on = function () {
        if (this.active) {
            effectScopeStack.push(this);
            activeEffectScope = this;
        }
    };
    EffectScopeImpl.prototype.off = function () {
        if (this.active) {
            effectScopeStack.pop();
            activeEffectScope = effectScopeStack[effectScopeStack.length - 1];
        }
    };
    EffectScopeImpl.prototype.stop = function () {
        if (this.active) {
            this.vm.$destroy();
            this.effects.forEach(function (e) { return e.stop(); });
            this.cleanups.forEach(function (cleanup) { return cleanup(); });
            this.active = false;
        }
    };
    return EffectScopeImpl;
}());
var EffectScope = /** @class */ (function (_super) {
    __extends(EffectScope, _super);
    function EffectScope(detached) {
        if (detached === void 0) { detached = false; }
        var _this = this;
        var vm = undefined;
        withCurrentInstanceTrackingDisabled(function () {
            vm = defineComponentInstance(getVueConstructor());
        });
        _this = _super.call(this, vm) || this;
        if (!detached) {
            recordEffectScope(_this);
        }
        return _this;
    }
    return EffectScope;
}(EffectScopeImpl));
function recordEffectScope(effect, scope) {
    var _a;
    scope = scope || activeEffectScope;
    if (scope && scope.active) {
        scope.effects.push(effect);
        return;
    }
    // destory on parent component unmounted
    var vm = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy;
    vm && vm.$on('hook:destroyed', function () { return effect.stop(); });
}
function effectScope(detached) {
    return new EffectScope(detached);
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn) {
    if (activeEffectScope) {
        activeEffectScope.cleanups.push(fn);
    }
    else if ((false)) {
        warn$1("onScopeDispose() is called when there is no active effect scope" +
            " to be associated with.");
    }
}
/**
 * @internal
 **/
function getCurrentScopeVM() {
    var _a, _b;
    return ((_a = getCurrentScope()) === null || _a === void 0 ? void 0 : _a.vm) || ((_b = getCurrentInstance()) === null || _b === void 0 ? void 0 : _b.proxy);
}
/**
 * @internal
 **/
function bindCurrentScopeToVM(vm) {
    if (!vm.scope) {
        var scope_1 = new EffectScopeImpl(vm.proxy);
        vm.scope = scope_1;
        vm.proxy.$on('hook:destroyed', function () { return scope_1.stop(); });
    }
    return vm.scope;
}

var vueDependency = undefined;
try {
    var requiredVue = __webpack_require__(17);
    if (requiredVue && isVue(requiredVue)) {
        vueDependency = requiredVue;
    }
    else if (requiredVue &&
        'default' in requiredVue &&
        isVue(requiredVue.default)) {
        vueDependency = requiredVue.default;
    }
}
catch (_a) {
    // not available
}
var vueConstructor = null;
var currentInstance = null;
var currentInstanceTracking = true;
var PluginInstalledFlag = '__composition_api_installed__';
function isVue(obj) {
    return obj && isFunction(obj) && obj.name === 'Vue';
}
function isVueRegistered(Vue) {
    // resolve issue: https://github.com/vuejs/composition-api/issues/876#issue-1087619365
    return vueConstructor && hasOwn(Vue, PluginInstalledFlag);
}
function getVueConstructor() {
    if ((false)) {
        assert(vueConstructor, "must call Vue.use(VueCompositionAPI) before using any function.");
    }
    return vueConstructor;
}
// returns registered vue or `vue` dependency
function getRegisteredVueOrDefault() {
    var constructor = vueConstructor || vueDependency;
    if ((false)) {
        assert(constructor, "No vue dependency found.");
    }
    return constructor;
}
function setVueConstructor(Vue) {
    // @ts-ignore
    if (false) {
        warn('[vue-composition-api] another instance of Vue installed');
    }
    vueConstructor = Vue;
    Object.defineProperty(Vue, PluginInstalledFlag, {
        configurable: true,
        writable: true,
        value: true,
    });
}
/**
 * For `effectScope` to create instance without populate the current instance
 * @internal
 **/
function withCurrentInstanceTrackingDisabled(fn) {
    var prev = currentInstanceTracking;
    currentInstanceTracking = false;
    try {
        fn();
    }
    finally {
        currentInstanceTracking = prev;
    }
}
function setCurrentInstance(instance) {
    if (!currentInstanceTracking)
        return;
    var prev = currentInstance;
    prev === null || prev === void 0 ? void 0 : prev.scope.off();
    currentInstance = instance;
    currentInstance === null || currentInstance === void 0 ? void 0 : currentInstance.scope.on();
}
function getCurrentInstance() {
    return currentInstance;
}
var instanceMapCache = new WeakMap();
function toVue3ComponentInstance(vm) {
    if (instanceMapCache.has(vm)) {
        return instanceMapCache.get(vm);
    }
    var instance = {
        proxy: vm,
        update: vm.$forceUpdate,
        type: vm.$options,
        uid: vm._uid,
        // $emit is defined on prototype and it expected to be bound
        emit: vm.$emit.bind(vm),
        parent: null,
        root: null, // to be immediately set
    };
    bindCurrentScopeToVM(instance);
    // map vm.$props =
    var instanceProps = [
        'data',
        'props',
        'attrs',
        'refs',
        'vnode',
        'slots',
    ];
    instanceProps.forEach(function (prop) {
        proxy(instance, prop, {
            get: function () {
                return vm["$".concat(prop)];
            },
        });
    });
    proxy(instance, 'isMounted', {
        get: function () {
            // @ts-expect-error private api
            return vm._isMounted;
        },
    });
    proxy(instance, 'isUnmounted', {
        get: function () {
            // @ts-expect-error private api
            return vm._isDestroyed;
        },
    });
    proxy(instance, 'isDeactivated', {
        get: function () {
            // @ts-expect-error private api
            return vm._inactive;
        },
    });
    proxy(instance, 'emitted', {
        get: function () {
            // @ts-expect-error private api
            return vm._events;
        },
    });
    instanceMapCache.set(vm, instance);
    if (vm.$parent) {
        instance.parent = toVue3ComponentInstance(vm.$parent);
    }
    if (vm.$root) {
        instance.root = toVue3ComponentInstance(vm.$root);
    }
    return instance;
}

var toString = function (x) { return Object.prototype.toString.call(x); };
function isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
}
var hasSymbol = typeof Symbol !== 'undefined' &&
    isNative(Symbol) &&
    typeof Reflect !== 'undefined' &&
    isNative(Reflect.ownKeys);
var noopFn = function (_) { return _; };
function proxy(target, key, _a) {
    var get = _a.get, set = _a.set;
    Object.defineProperty(target, key, {
        enumerable: true,
        configurable: true,
        get: get || noopFn,
        set: set || noopFn,
    });
}
function def(obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
        value: val,
        enumerable: !!enumerable,
        writable: true,
        configurable: true,
    });
}
function hasOwn(obj, key) {
    return Object.hasOwnProperty.call(obj, key);
}
function assert(condition, msg) {
    if (!condition) {
        throw new Error("[vue-composition-api] ".concat(msg));
    }
}
function isPrimitive(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        // $flow-disable-line
        typeof value === 'symbol' ||
        typeof value === 'boolean');
}
function isArray(x) {
    return Array.isArray(x);
}
var objectToString = Object.prototype.toString;
var toTypeString = function (value) {
    return objectToString.call(value);
};
var isMap = function (val) {
    return toTypeString(val) === '[object Map]';
};
var isSet = function (val) {
    return toTypeString(val) === '[object Set]';
};
var MAX_VALID_ARRAY_LENGTH = 4294967295; // Math.pow(2, 32) - 1
function isValidArrayIndex(val) {
    var n = parseFloat(String(val));
    return (n >= 0 &&
        Math.floor(n) === n &&
        isFinite(val) &&
        n <= MAX_VALID_ARRAY_LENGTH);
}
function isObject(val) {
    return val !== null && typeof val === 'object';
}
function isPlainObject(x) {
    return toString(x) === '[object Object]';
}
function isFunction(x) {
    return typeof x === 'function';
}
function isUndef(v) {
    return v === undefined || v === null;
}
function warn(msg, vm) {
    var Vue = getRegisteredVueOrDefault();
    if (!Vue || !Vue.util)
        console.warn("[vue-composition-api] ".concat(msg));
    else
        Vue.util.warn(msg, vm);
}
function logError(err, vm, info) {
    if ((false)) {
        warn("Error in ".concat(info, ": \"").concat(err.toString(), "\""), vm);
    }
    if (typeof window !== 'undefined' && typeof console !== 'undefined') {
        console.error(err);
    }
    else {
        throw err;
    }
}
/**
 * Object.is polyfill
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 * */
function isSame(value1, value2) {
    if (value1 === value2) {
        return value1 !== 0 || 1 / value1 === 1 / value2;
    }
    else {
        return value1 !== value1 && value2 !== value2;
    }
}

function getCurrentInstanceForFn(hook, target) {
    target = target || getCurrentInstance();
    if (false) {
        warn("".concat(hook, " is called when there is no active component instance to be ") +
            "associated with. " +
            "Lifecycle injection APIs can only be used during execution of setup().");
    }
    return target;
}
function defineComponentInstance(Ctor, options) {
    if (options === void 0) { options = {}; }
    var silent = Ctor.config.silent;
    Ctor.config.silent = true;
    var vm = new Ctor(options);
    Ctor.config.silent = silent;
    return vm;
}
function isComponentInstance(obj) {
    var Vue = getVueConstructor();
    return Vue && obj instanceof Vue;
}
function createSlotProxy(vm, slotName) {
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!vm.$scopedSlots[slotName]) {
            if ((false))
                return warn("slots.".concat(slotName, "() got called outside of the \"render()\" scope"), vm);
            return;
        }
        return vm.$scopedSlots[slotName].apply(vm, args);
    });
}
function resolveSlots(slots, normalSlots) {
    var res;
    if (!slots) {
        res = {};
    }
    else if (slots._normalized) {
        // fast path 1: child component re-render only, parent did not change
        return slots._normalized;
    }
    else {
        res = {};
        for (var key in slots) {
            if (slots[key] && key[0] !== '$') {
                res[key] = true;
            }
        }
    }
    // expose normal slots on scopedSlots
    for (var key in normalSlots) {
        if (!(key in res)) {
            res[key] = true;
        }
    }
    return res;
}
var vueInternalClasses;
var getVueInternalClasses = function () {
    if (!vueInternalClasses) {
        var vm = defineComponentInstance(getVueConstructor(), {
            computed: {
                value: function () {
                    return 0;
                },
            },
        });
        // to get Watcher class
        var Watcher = vm._computedWatchers.value.constructor;
        // to get Dep class
        var Dep = vm._data.__ob__.dep.constructor;
        vueInternalClasses = {
            Watcher: Watcher,
            Dep: Dep,
        };
        vm.$destroy();
    }
    return vueInternalClasses;
};

function createSymbol(name) {
    return hasSymbol ? Symbol.for(name) : name;
}
var WatcherPreFlushQueueKey = createSymbol('composition-api.preFlushQueue');
var WatcherPostFlushQueueKey = createSymbol('composition-api.postFlushQueue');
// must be a string, symbol key is ignored in reactive
var RefKey = 'composition-api.refKey';

var accessModifiedSet = new WeakMap();
var rawSet = new WeakMap();
var readonlySet = new WeakMap();

/**
 * Set a property on an object. Adds the new property, triggers change
 * notification and intercept it's subsequent access if the property doesn't
 * already exist.
 */
function set$1(target, key, val) {
    var Vue = getVueConstructor();
    // @ts-expect-error https://github.com/vuejs/vue/pull/12132
    var _a = Vue.util, warn = _a.warn, defineReactive = _a.defineReactive;
    if (false) {
        warn("Cannot set reactive property on undefined, null, or primitive value: ".concat(target));
    }
    var ob = target.__ob__;
    function ssrMockReactivity() {
        // in SSR, there is no __ob__. Mock for reactivity check
        if (ob && isObject(val) && !hasOwn(val, '__ob__')) {
            mockReactivityDeep(val);
        }
    }
    if (isArray(target)) {
        if (isValidArrayIndex(key)) {
            target.length = Math.max(target.length, key);
            target.splice(key, 1, val);
            ssrMockReactivity();
            return val;
        }
        else if (key === 'length' && val !== target.length) {
            target.length = val;
            ob === null || ob === void 0 ? void 0 : ob.dep.notify();
            return val;
        }
    }
    if (key in target && !(key in Object.prototype)) {
        target[key] = val;
        ssrMockReactivity();
        return val;
    }
    if (target._isVue || (ob && ob.vmCount)) {
        ("production" !== 'production') &&
            warn('Avoid adding reactive properties to a Vue instance or its root $data ' +
                'at runtime - declare it upfront in the data option.');
        return val;
    }
    if (!ob) {
        target[key] = val;
        return val;
    }
    defineReactive(ob.value, key, val);
    // IMPORTANT: define access control before trigger watcher
    defineAccessControl(target, key, val);
    ssrMockReactivity();
    ob.dep.notify();
    return val;
}

var _isForceTrigger = false;
function isForceTrigger() {
    return _isForceTrigger;
}
function setForceTrigger(v) {
    _isForceTrigger = v;
}

var RefImpl = /** @class */ (function () {
    function RefImpl(_a) {
        var get = _a.get, set = _a.set;
        proxy(this, 'value', {
            get: get,
            set: set,
        });
    }
    return RefImpl;
}());
function createRef(options, isReadonly, isComputed) {
    if (isReadonly === void 0) { isReadonly = false; }
    if (isComputed === void 0) { isComputed = false; }
    var r = new RefImpl(options);
    // add effect to differentiate refs from computed
    if (isComputed)
        r.effect = true;
    // seal the ref, this could prevent ref from being observed
    // It's safe to seal the ref, since we really shouldn't extend it.
    // related issues: #79
    var sealed = Object.seal(r);
    if (isReadonly)
        readonlySet.set(sealed, true);
    return sealed;
}
function ref(raw) {
    var _a;
    if (isRef(raw)) {
        return raw;
    }
    var value = reactive((_a = {}, _a[RefKey] = raw, _a));
    return createRef({
        get: function () { return value[RefKey]; },
        set: function (v) { return (value[RefKey] = v); },
    });
}
function isRef(value) {
    return value instanceof RefImpl;
}
function unref(ref) {
    return isRef(ref) ? ref.value : ref;
}
function toRefs(obj) {
    if (false) {
        warn("toRefs() expects a reactive object but received a plain one.");
    }
    if (!isPlainObject(obj))
        return obj;
    var ret = {};
    for (var key in obj) {
        ret[key] = toRef(obj, key);
    }
    return ret;
}
function customRef(factory) {
    var version = ref(0);
    return createRef(factory(function () { return void version.value; }, function () {
        ++version.value;
    }));
}
function toRef(object, key) {
    if (!(key in object))
        set$1(object, key, undefined);
    var v = object[key];
    if (isRef(v))
        return v;
    return createRef({
        get: function () { return object[key]; },
        set: function (v) { return (object[key] = v); },
    });
}
function shallowRef(raw) {
    var _a;
    if (isRef(raw)) {
        return raw;
    }
    var value = shallowReactive((_a = {}, _a[RefKey] = raw, _a));
    return createRef({
        get: function () { return value[RefKey]; },
        set: function (v) { return (value[RefKey] = v); },
    });
}
function triggerRef(value) {
    if (!isRef(value))
        return;
    setForceTrigger(true);
    value.value = value.value;
    setForceTrigger(false);
}
function proxyRefs(objectWithRefs) {
    var _a, e_1, _b;
    if (isReactive(objectWithRefs)) {
        return objectWithRefs;
    }
    var value = reactive((_a = {}, _a[RefKey] = objectWithRefs, _a));
    def(value, RefKey, value[RefKey], false);
    var _loop_1 = function (key) {
        proxy(value, key, {
            get: function () {
                if (isRef(value[RefKey][key])) {
                    return value[RefKey][key].value;
                }
                return value[RefKey][key];
            },
            set: function (v) {
                if (isRef(value[RefKey][key])) {
                    return (value[RefKey][key].value = unref(v));
                }
                value[RefKey][key] = unref(v);
            },
        });
    };
    try {
        for (var _c = __values(Object.keys(objectWithRefs)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var key = _d.value;
            _loop_1(key);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return value;
}

function isRaw(obj) {
    var _a;
    return Boolean(obj &&
        hasOwn(obj, '__ob__') &&
        typeof obj.__ob__ === 'object' &&
        ((_a = obj.__ob__) === null || _a === void 0 ? void 0 : _a.__raw__));
}
function isReactive(obj) {
    var _a;
    return Boolean(obj &&
        hasOwn(obj, '__ob__') &&
        typeof obj.__ob__ === 'object' &&
        !((_a = obj.__ob__) === null || _a === void 0 ? void 0 : _a.__raw__));
}
/**
 * Proxing property access of target.
 * We can do unwrapping and other things here.
 */
function setupAccessControl(target) {
    if (!isPlainObject(target) ||
        isRaw(target) ||
        isArray(target) ||
        isRef(target) ||
        isComponentInstance(target) ||
        accessModifiedSet.has(target))
        return;
    accessModifiedSet.set(target, true);
    var keys = Object.keys(target);
    for (var i = 0; i < keys.length; i++) {
        defineAccessControl(target, keys[i]);
    }
}
/**
 * Auto unwrapping when access property
 */
function defineAccessControl(target, key, val) {
    if (key === '__ob__')
        return;
    if (isRaw(target[key]))
        return;
    var getter;
    var setter;
    var property = Object.getOwnPropertyDescriptor(target, key);
    if (property) {
        if (property.configurable === false) {
            return;
        }
        getter = property.get;
        setter = property.set;
        if ((!getter || setter) /* not only have getter */ &&
            arguments.length === 2) {
            val = target[key];
        }
    }
    setupAccessControl(val);
    proxy(target, key, {
        get: function getterHandler() {
            var value = getter ? getter.call(target) : val;
            // if the key is equal to RefKey, skip the unwrap logic
            if (key !== RefKey && isRef(value)) {
                return value.value;
            }
            else {
                return value;
            }
        },
        set: function setterHandler(newVal) {
            if (getter && !setter)
                return;
            // If the key is equal to RefKey, skip the unwrap logic
            // If and only if "value" is ref and "newVal" is not a ref,
            // the assignment should be proxied to "value" ref.
            if (key !== RefKey && isRef(val) && !isRef(newVal)) {
                val.value = newVal;
            }
            else if (setter) {
                setter.call(target, newVal);
                val = newVal;
            }
            else {
                val = newVal;
            }
            setupAccessControl(newVal);
        },
    });
}
function observe(obj) {
    var Vue = getRegisteredVueOrDefault();
    var observed;
    if (Vue.observable) {
        observed = Vue.observable(obj);
    }
    else {
        var vm = defineComponentInstance(Vue, {
            data: {
                $$state: obj,
            },
        });
        observed = vm._data.$$state;
    }
    // in SSR, there is no __ob__. Mock for reactivity check
    if (!hasOwn(observed, '__ob__')) {
        mockReactivityDeep(observed);
    }
    return observed;
}
/**
 * Mock __ob__ for object recursively
 */
function mockReactivityDeep(obj, seen) {
    var e_1, _a;
    if (seen === void 0) { seen = new Set(); }
    if (seen.has(obj) || hasOwn(obj, '__ob__') || !Object.isExtensible(obj))
        return;
    def(obj, '__ob__', mockObserver(obj));
    seen.add(obj);
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            var value = obj[key];
            if (!(isPlainObject(value) || isArray(value)) ||
                isRaw(value) ||
                !Object.isExtensible(value)) {
                continue;
            }
            mockReactivityDeep(value, seen);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function mockObserver(value) {
    if (value === void 0) { value = {}; }
    return {
        value: value,
        dep: {
            notify: noopFn,
            depend: noopFn,
            addSub: noopFn,
            removeSub: noopFn,
        },
    };
}
function createObserver() {
    return observe({}).__ob__;
}
function shallowReactive(obj) {
    var e_2, _a;
    if (!isObject(obj)) {
        if ((false)) {
            warn('"shallowReactive()" must be called on an object.');
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        isRaw(obj) ||
        !Object.isExtensible(obj)) {
        return obj;
    }
    var observed = observe(isArray(obj) ? [] : {});
    var ob = observed.__ob__;
    var _loop_1 = function (key) {
        var val = obj[key];
        var getter;
        var setter;
        var property = Object.getOwnPropertyDescriptor(obj, key);
        if (property) {
            if (property.configurable === false) {
                return "continue";
            }
            getter = property.get;
            setter = property.set;
        }
        proxy(observed, key, {
            get: function getterHandler() {
                var _a;
                var value = getter ? getter.call(obj) : val;
                (_a = ob.dep) === null || _a === void 0 ? void 0 : _a.depend();
                return value;
            },
            set: function setterHandler(newVal) {
                var _a;
                if (getter && !setter)
                    return;
                var value = getter ? getter.call(obj) : val;
                if (!isForceTrigger() && value === newVal)
                    return;
                if (setter) {
                    setter.call(obj, newVal);
                }
                else {
                    val = newVal;
                }
                (_a = ob.dep) === null || _a === void 0 ? void 0 : _a.notify();
            },
        });
    };
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            _loop_1(key);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return observed;
}
/**
 * Make obj reactivity
 */
function reactive(obj) {
    if (!isObject(obj)) {
        if ((false)) {
            warn('"reactive()" must be called on an object.');
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        isRaw(obj) ||
        !Object.isExtensible(obj)) {
        return obj;
    }
    var observed = observe(obj);
    setupAccessControl(observed);
    return observed;
}
/**
 * Make sure obj can't be a reactive
 */
function markRaw(obj) {
    if (!(isPlainObject(obj) || isArray(obj)) || !Object.isExtensible(obj)) {
        return obj;
    }
    // set the vue observable flag at obj
    var ob = createObserver();
    ob.__raw__ = true;
    def(obj, '__ob__', ob);
    // mark as Raw
    rawSet.set(obj, true);
    return obj;
}
function toRaw(observed) {
    var _a, _b;
    if (isRaw(observed) || !Object.isExtensible(observed)) {
        return observed;
    }
    return ((_b = (_a = observed) === null || _a === void 0 ? void 0 : _a.__ob__) === null || _b === void 0 ? void 0 : _b.value) || observed;
}

function isReadonly(obj) {
    return readonlySet.has(obj);
}
/**
 * **In @vue/composition-api, `reactive` only provides type-level readonly check**
 *
 * Creates a readonly copy of the original object. Note the returned copy is not
 * made reactive, but `readonly` can be called on an already reactive object.
 */
function readonly(target) {
    if (false) {
        warn("value cannot be made reactive: ".concat(String(target)));
    }
    else {
        readonlySet.set(target, true);
    }
    return target;
}
function shallowReadonly(obj) {
    var e_1, _a;
    if (!isObject(obj)) {
        if ((false)) {
            warn("value cannot be made reactive: ".concat(String(obj)));
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        (!Object.isExtensible(obj) && !isRef(obj))) {
        return obj;
    }
    var readonlyObj = isRef(obj)
        ? new RefImpl({})
        : isReactive(obj)
            ? observe({})
            : {};
    var source = reactive({});
    var ob = source.__ob__;
    var _loop_1 = function (key) {
        var val = obj[key];
        var getter;
        var property = Object.getOwnPropertyDescriptor(obj, key);
        if (property) {
            if (property.configurable === false && !isRef(obj)) {
                return "continue";
            }
            getter = property.get;
        }
        proxy(readonlyObj, key, {
            get: function getterHandler() {
                var value = getter ? getter.call(obj) : val;
                ob.dep.depend();
                return value;
            },
            set: function (v) {
                if ((false)) {
                    warn("Set operation on key \"".concat(key, "\" failed: target is readonly."));
                }
            },
        });
    };
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            _loop_1(key);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    readonlySet.set(readonlyObj, true);
    return readonlyObj;
}

/**
 * Delete a property and trigger change if necessary.
 */
function del(target, key) {
    var Vue = getVueConstructor();
    var warn = Vue.util.warn;
    if (false) {
        warn("Cannot delete reactive property on undefined, null, or primitive value: ".concat(target));
    }
    if (isArray(target) && isValidArrayIndex(key)) {
        target.splice(key, 1);
        return;
    }
    var ob = target.__ob__;
    if (target._isVue || (ob && ob.vmCount)) {
        ("production" !== 'production') &&
            warn('Avoid deleting properties on a Vue instance or its root $data ' +
                '- just set it to null.');
        return;
    }
    if (!hasOwn(target, key)) {
        return;
    }
    delete target[key];
    if (!ob) {
        return;
    }
    ob.dep.notify();
}

var genName = function (name) { return "on".concat(name[0].toUpperCase() + name.slice(1)); };
function createLifeCycle(lifeCyclehook) {
    return function (callback, target) {
        var instance = getCurrentInstanceForFn(genName(lifeCyclehook), target);
        return (instance &&
            injectHookOption(getVueConstructor(), instance, lifeCyclehook, callback));
    };
}
function injectHookOption(Vue, instance, hook, val) {
    var options = instance.proxy.$options;
    var mergeFn = Vue.config.optionMergeStrategies[hook];
    var wrappedHook = wrapHookCall(instance, val);
    options[hook] = mergeFn(options[hook], wrappedHook);
    return wrappedHook;
}
function wrapHookCall(instance, fn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var prev = getCurrentInstance();
        setCurrentInstance(instance);
        try {
            return fn.apply(void 0, __spreadArray([], __read(args), false));
        }
        finally {
            setCurrentInstance(prev);
        }
    };
}
var onBeforeMount = createLifeCycle('beforeMount');
var onMounted = createLifeCycle('mounted');
var onBeforeUpdate = createLifeCycle('beforeUpdate');
var onUpdated = createLifeCycle('updated');
var onBeforeUnmount = createLifeCycle('beforeDestroy');
var onUnmounted = createLifeCycle('destroyed');
var onErrorCaptured = createLifeCycle('errorCaptured');
var onActivated = createLifeCycle('activated');
var onDeactivated = createLifeCycle('deactivated');
var onServerPrefetch = createLifeCycle('serverPrefetch');

var fallbackVM;
function flushPreQueue() {
    flushQueue(this, WatcherPreFlushQueueKey);
}
function flushPostQueue() {
    flushQueue(this, WatcherPostFlushQueueKey);
}
function hasWatchEnv(vm) {
    return vm[WatcherPreFlushQueueKey] !== undefined;
}
function installWatchEnv(vm) {
    vm[WatcherPreFlushQueueKey] = [];
    vm[WatcherPostFlushQueueKey] = [];
    vm.$on('hook:beforeUpdate', flushPreQueue);
    vm.$on('hook:updated', flushPostQueue);
}
function getWatcherOption(options) {
    return __assign({
        immediate: false,
        deep: false,
        flush: 'pre',
    }, options);
}
function getWatchEffectOption(options) {
    return __assign({
        flush: 'pre',
    }, options);
}
function getWatcherVM() {
    var vm = getCurrentScopeVM();
    if (!vm) {
        if (!fallbackVM) {
            fallbackVM = defineComponentInstance(getVueConstructor());
        }
        vm = fallbackVM;
    }
    else if (!hasWatchEnv(vm)) {
        installWatchEnv(vm);
    }
    return vm;
}
function flushQueue(vm, key) {
    var queue = vm[key];
    for (var index = 0; index < queue.length; index++) {
        queue[index]();
    }
    queue.length = 0;
}
function queueFlushJob(vm, fn, mode) {
    // flush all when beforeUpdate and updated are not fired
    var fallbackFlush = function () {
        vm.$nextTick(function () {
            if (vm[WatcherPreFlushQueueKey].length) {
                flushQueue(vm, WatcherPreFlushQueueKey);
            }
            if (vm[WatcherPostFlushQueueKey].length) {
                flushQueue(vm, WatcherPostFlushQueueKey);
            }
        });
    };
    switch (mode) {
        case 'pre':
            fallbackFlush();
            vm[WatcherPreFlushQueueKey].push(fn);
            break;
        case 'post':
            fallbackFlush();
            vm[WatcherPostFlushQueueKey].push(fn);
            break;
        default:
            assert(false, "flush must be one of [\"post\", \"pre\", \"sync\"], but got ".concat(mode));
            break;
    }
}
function createVueWatcher(vm, getter, callback, options) {
    var index = vm._watchers.length;
    // @ts-ignore: use undocumented options
    vm.$watch(getter, callback, {
        immediate: options.immediateInvokeCallback,
        deep: options.deep,
        lazy: options.noRun,
        sync: options.sync,
        before: options.before,
    });
    return vm._watchers[index];
}
// We have to monkeypatch the teardown function so Vue will run
// runCleanup() when it tears down the watcher on unmounted.
function patchWatcherTeardown(watcher, runCleanup) {
    var _teardown = watcher.teardown;
    watcher.teardown = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        _teardown.apply(watcher, args);
        runCleanup();
    };
}
function createWatcher(vm, source, cb, options) {
    var _a;
    if (false) {
        if (options.immediate !== undefined) {
            warn("watch() \"immediate\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
        if (options.deep !== undefined) {
            warn("watch() \"deep\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
    }
    var flushMode = options.flush;
    var isSync = flushMode === 'sync';
    var cleanup;
    var registerCleanup = function (fn) {
        cleanup = function () {
            try {
                fn();
            }
            catch (
            // FIXME: remove any
            error) {
                logError(error, vm, 'onCleanup()');
            }
        };
    };
    // cleanup before running getter again
    var runCleanup = function () {
        if (cleanup) {
            cleanup();
            cleanup = null;
        }
    };
    var createScheduler = function (fn) {
        if (isSync ||
            /* without a current active instance, ignore pre|post mode */ vm ===
                fallbackVM) {
            return fn;
        }
        return (function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return queueFlushJob(vm, function () {
                fn.apply(void 0, __spreadArray([], __read(args), false));
            }, flushMode);
        });
    };
    // effect watch
    if (cb === null) {
        var running_1 = false;
        var getter_1 = function () {
            // preventing the watch callback being call in the same execution
            if (running_1) {
                return;
            }
            try {
                running_1 = true;
                source(registerCleanup);
            }
            finally {
                running_1 = false;
            }
        };
        var watcher_1 = createVueWatcher(vm, getter_1, noopFn, {
            deep: options.deep || false,
            sync: isSync,
            before: runCleanup,
        });
        patchWatcherTeardown(watcher_1, runCleanup);
        // enable the watcher update
        watcher_1.lazy = false;
        var originGet = watcher_1.get.bind(watcher_1);
        // always run watchEffect
        watcher_1.get = createScheduler(originGet);
        return function () {
            watcher_1.teardown();
        };
    }
    var deep = options.deep;
    var isMultiSource = false;
    var getter;
    if (isRef(source)) {
        getter = function () { return source.value; };
    }
    else if (isReactive(source)) {
        getter = function () { return source; };
        deep = true;
    }
    else if (isArray(source)) {
        isMultiSource = true;
        getter = function () {
            return source.map(function (s) {
                if (isRef(s)) {
                    return s.value;
                }
                else if (isReactive(s)) {
                    return traverse(s);
                }
                else if (isFunction(s)) {
                    return s();
                }
                else {
                    ("production" !== 'production') &&
                        warn("Invalid watch source: ".concat(JSON.stringify(s), ".\n          A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."), vm);
                    return noopFn;
                }
            });
        };
    }
    else if (isFunction(source)) {
        getter = source;
    }
    else {
        getter = noopFn;
        ("production" !== 'production') &&
            warn("Invalid watch source: ".concat(JSON.stringify(source), ".\n      A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."), vm);
    }
    if (deep) {
        var baseGetter_1 = getter;
        getter = function () { return traverse(baseGetter_1()); };
    }
    var applyCb = function (n, o) {
        if (!deep &&
            isMultiSource &&
            n.every(function (v, i) { return isSame(v, o[i]); }))
            return;
        // cleanup before running cb again
        runCleanup();
        return cb(n, o, registerCleanup);
    };
    var callback = createScheduler(applyCb);
    if (options.immediate) {
        var originalCallback_1 = callback;
        // `shiftCallback` is used to handle the first sync effect run.
        // The subsequent callbacks will redirect to `callback`.
        var shiftCallback_1 = function (n, o) {
            shiftCallback_1 = originalCallback_1;
            // o is undefined on the first call
            return applyCb(n, isArray(n) ? [] : o);
        };
        callback = function (n, o) {
            return shiftCallback_1(n, o);
        };
    }
    // @ts-ignore: use undocumented option "sync"
    var stop = vm.$watch(getter, callback, {
        immediate: options.immediate,
        deep: deep,
        sync: isSync,
    });
    // Once again, we have to hack the watcher for proper teardown
    var watcher = vm._watchers[vm._watchers.length - 1];
    // if the return value is reactive and deep:true
    // watch for changes, this might happen when new key is added
    if (isReactive(watcher.value) && ((_a = watcher.value.__ob__) === null || _a === void 0 ? void 0 : _a.dep) && deep) {
        watcher.value.__ob__.dep.addSub({
            update: function () {
                // this will force the source to be revaluated and the callback
                // executed if needed
                watcher.run();
            },
        });
    }
    patchWatcherTeardown(watcher, runCleanup);
    return function () {
        stop();
    };
}
function watchEffect(effect, options) {
    var opts = getWatchEffectOption(options);
    var vm = getWatcherVM();
    return createWatcher(vm, effect, null, opts);
}
function watchPostEffect(effect) {
    return watchEffect(effect, { flush: 'post' });
}
function watchSyncEffect(effect) {
    return watchEffect(effect, { flush: 'sync' });
}
// implementation
function watch(source, cb, options) {
    var callback = null;
    if (isFunction(cb)) {
        // source watch
        callback = cb;
    }
    else {
        // effect watch
        if ((false)) {
            warn("`watch(fn, options?)` signature has been moved to a separate API. " +
                "Use `watchEffect(fn, options?)` instead. `watch` now only " +
                "supports `watch(source, cb, options?) signature.");
        }
        options = cb;
        callback = null;
    }
    var opts = getWatcherOption(options);
    var vm = getWatcherVM();
    return createWatcher(vm, source, callback, opts);
}
function traverse(value, seen) {
    if (seen === void 0) { seen = new Set(); }
    if (!isObject(value) || seen.has(value) || rawSet.has(value)) {
        return value;
    }
    seen.add(value);
    if (isRef(value)) {
        traverse(value.value, seen);
    }
    else if (isArray(value)) {
        for (var i = 0; i < value.length; i++) {
            traverse(value[i], seen);
        }
    }
    else if (isSet(value) || isMap(value)) {
        value.forEach(function (v) {
            traverse(v, seen);
        });
    }
    else if (isPlainObject(value)) {
        for (var key in value) {
            traverse(value[key], seen);
        }
    }
    return value;
}

// implement
function computed(getterOrOptions) {
    var vm = getCurrentScopeVM();
    var getter;
    var setter;
    if (isFunction(getterOrOptions)) {
        getter = getterOrOptions;
    }
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var computedSetter;
    var computedGetter;
    if (vm && !vm.$isServer) {
        var _a = getVueInternalClasses(), Watcher_1 = _a.Watcher, Dep_1 = _a.Dep;
        var watcher_1;
        computedGetter = function () {
            if (!watcher_1) {
                watcher_1 = new Watcher_1(vm, getter, noopFn, { lazy: true });
            }
            if (watcher_1.dirty) {
                watcher_1.evaluate();
            }
            if (Dep_1.target) {
                watcher_1.depend();
            }
            return watcher_1.value;
        };
        computedSetter = function (v) {
            if (false) {
                warn('Write operation failed: computed value is readonly.', vm);
                return;
            }
            if (setter) {
                setter(v);
            }
        };
    }
    else {
        // fallback
        var computedHost_1 = defineComponentInstance(getVueConstructor(), {
            computed: {
                $$state: {
                    get: getter,
                    set: setter,
                },
            },
        });
        vm && vm.$on('hook:destroyed', function () { return computedHost_1.$destroy(); });
        computedGetter = function () { return computedHost_1.$$state; };
        computedSetter = function (v) {
            if (false) {
                warn('Write operation failed: computed value is readonly.', vm);
                return;
            }
            computedHost_1.$$state = v;
        };
    }
    return createRef({
        get: computedGetter,
        set: computedSetter,
    }, !setter, true);
}

var NOT_FOUND = {};
function resolveInject(provideKey, vm) {
    var source = vm;
    while (source) {
        // @ts-ignore
        if (source._provided && hasOwn(source._provided, provideKey)) {
            //@ts-ignore
            return source._provided[provideKey];
        }
        source = source.$parent;
    }
    return NOT_FOUND;
}
function provide(key, value) {
    var _a;
    var vm = (_a = getCurrentInstanceForFn('provide')) === null || _a === void 0 ? void 0 : _a.proxy;
    if (!vm)
        return;
    if (!vm._provided) {
        var provideCache_1 = {};
        proxy(vm, '_provided', {
            get: function () { return provideCache_1; },
            set: function (v) { return Object.assign(provideCache_1, v); },
        });
    }
    vm._provided[key] = value;
}
function inject(key, defaultValue, treatDefaultAsFactory) {
    var _a;
    if (treatDefaultAsFactory === void 0) { treatDefaultAsFactory = false; }
    var vm = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy;
    if (!vm) {
        ("production" !== 'production') &&
            warn("inject() can only be used inside setup() or functional components.");
        return;
    }
    if (!key) {
        ("production" !== 'production') && warn("injection \"".concat(String(key), "\" not found."), vm);
        return defaultValue;
    }
    var val = resolveInject(key, vm);
    if (val !== NOT_FOUND) {
        return val;
    }
    if (defaultValue === undefined && ("production" !== 'production')) {
        warn("Injection \"".concat(String(key), "\" not found"), vm);
    }
    return treatDefaultAsFactory && isFunction(defaultValue)
        ? defaultValue()
        : defaultValue;
}

var EMPTY_OBJ = ( false)
    ? Object.freeze({})
    : {};
var useCssModule = function (name) {
    var _a;
    if (name === void 0) { name = '$style'; }
    var instance = getCurrentInstance();
    if (!instance) {
        ("production" !== 'production') && warn("useCssModule must be called inside setup()");
        return EMPTY_OBJ;
    }
    var mod = (_a = instance.proxy) === null || _a === void 0 ? void 0 : _a[name];
    if (!mod) {
        ("production" !== 'production') &&
            warn("Current instance does not have CSS module named \"".concat(name, "\"."));
        return EMPTY_OBJ;
    }
    return mod;
};
/**
 * @deprecated use `useCssModule` instead.
 */
var useCSSModule = useCssModule;

function createApp(rootComponent, rootProps) {
    if (rootProps === void 0) { rootProps = undefined; }
    var V = getVueConstructor();
    var mountedVM = undefined;
    var app = {
        config: V.config,
        use: V.use.bind(V),
        mixin: V.mixin.bind(V),
        component: V.component.bind(V),
        directive: function (name, dir) {
            if (dir) {
                V.directive(name, dir);
                return app;
            }
            else {
                return V.directive(name);
            }
        },
        mount: function (el, hydrating) {
            if (!mountedVM) {
                mountedVM = new V(__assign({ propsData: rootProps }, rootComponent));
                mountedVM.$mount(el, hydrating);
                return mountedVM;
            }
            else {
                if ((false)) {
                    warn("App has already been mounted.\n" +
                        "If you want to remount the same app, move your app creation logic " +
                        "into a factory function and create fresh app instances for each " +
                        "mount - e.g. `const createMyApp = () => createApp(App)`");
                }
                return mountedVM;
            }
        },
        unmount: function () {
            if (mountedVM) {
                mountedVM.$destroy();
                mountedVM = undefined;
            }
            else if ((false)) {
                warn("Cannot unmount an app that is not mounted.");
            }
        },
    };
    return app;
}

var nextTick = function nextTick() {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return (_a = getVueConstructor()) === null || _a === void 0 ? void 0 : _a.nextTick.apply(this, args);
};

var fallbackCreateElement;
var createElement = function createElement() {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var instance = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy;
    if (!instance) {
        ("production" !== 'production') &&
            warn('`createElement()` has been called outside of render function.');
        if (!fallbackCreateElement) {
            fallbackCreateElement = defineComponentInstance(getVueConstructor()).$createElement;
        }
        return fallbackCreateElement.apply(fallbackCreateElement, args);
    }
    return instance.$createElement.apply(instance, args);
};

function useSlots() {
    return getContext().slots;
}
function useAttrs() {
    return getContext().attrs;
}
function getContext() {
    var i = getCurrentInstance();
    if (false) {
        warn("useContext() called without active instance.");
    }
    return i.setupContext;
}

function set(vm, key, value) {
    var state = (vm.__composition_api_state__ =
        vm.__composition_api_state__ || {});
    state[key] = value;
}
function get(vm, key) {
    return (vm.__composition_api_state__ || {})[key];
}
var vmStateManager = {
    set: set,
    get: get,
};

function asVmProperty(vm, propName, propValue) {
    var props = vm.$options.props;
    if (!(propName in vm) && !(props && hasOwn(props, propName))) {
        if (isRef(propValue)) {
            proxy(vm, propName, {
                get: function () { return propValue.value; },
                set: function (val) {
                    propValue.value = val;
                },
            });
        }
        else {
            proxy(vm, propName, {
                get: function () {
                    if (isReactive(propValue)) {
                        propValue.__ob__.dep.depend();
                    }
                    return propValue;
                },
                set: function (val) {
                    propValue = val;
                },
            });
        }
        if ((false)) {
            // expose binding to Vue Devtool as a data property
            // delay this until state has been resolved to prevent repeated works
            vm.$nextTick(function () {
                if (Object.keys(vm._data).indexOf(propName) !== -1) {
                    return;
                }
                if (isRef(propValue)) {
                    proxy(vm._data, propName, {
                        get: function () { return propValue.value; },
                        set: function (val) {
                            propValue.value = val;
                        },
                    });
                }
                else {
                    proxy(vm._data, propName, {
                        get: function () { return propValue; },
                        set: function (val) {
                            propValue = val;
                        },
                    });
                }
            });
        }
    }
    else if ((false)) {
        if (props && hasOwn(props, propName)) {
            warn("The setup binding property \"".concat(propName, "\" is already declared as a prop."), vm);
        }
        else {
            warn("The setup binding property \"".concat(propName, "\" is already declared."), vm);
        }
    }
}
function updateTemplateRef(vm) {
    var rawBindings = vmStateManager.get(vm, 'rawBindings') || {};
    if (!rawBindings || !Object.keys(rawBindings).length)
        return;
    var refs = vm.$refs;
    var oldRefKeys = vmStateManager.get(vm, 'refs') || [];
    for (var index = 0; index < oldRefKeys.length; index++) {
        var key = oldRefKeys[index];
        var setupValue = rawBindings[key];
        if (!refs[key] && setupValue && isRef(setupValue)) {
            setupValue.value = null;
        }
    }
    var newKeys = Object.keys(refs);
    var validNewKeys = [];
    for (var index = 0; index < newKeys.length; index++) {
        var key = newKeys[index];
        var setupValue = rawBindings[key];
        if (refs[key] && setupValue && isRef(setupValue)) {
            setupValue.value = refs[key];
            validNewKeys.push(key);
        }
    }
    vmStateManager.set(vm, 'refs', validNewKeys);
}
function afterRender(vm) {
    var stack = [vm._vnode];
    while (stack.length) {
        var vnode = stack.pop();
        if (vnode.context)
            updateTemplateRef(vnode.context);
        if (vnode.children) {
            for (var i = 0; i < vnode.children.length; ++i) {
                stack.push(vnode.children[i]);
            }
        }
    }
}
function updateVmAttrs(vm, ctx) {
    var e_1, _a;
    if (!vm) {
        return;
    }
    var attrBindings = vmStateManager.get(vm, 'attrBindings');
    if (!attrBindings && !ctx) {
        // fix 840
        return;
    }
    if (!attrBindings) {
        var observedData = reactive({});
        attrBindings = { ctx: ctx, data: observedData };
        vmStateManager.set(vm, 'attrBindings', attrBindings);
        proxy(ctx, 'attrs', {
            get: function () {
                return attrBindings === null || attrBindings === void 0 ? void 0 : attrBindings.data;
            },
            set: function () {
                ("production" !== 'production') &&
                    warn("Cannot assign to '$attrs' because it is a read-only property", vm);
            },
        });
    }
    var source = vm.$attrs;
    var _loop_1 = function (attr) {
        if (!hasOwn(attrBindings.data, attr)) {
            proxy(attrBindings.data, attr, {
                get: function () {
                    // to ensure it always return the latest value
                    return vm.$attrs[attr];
                },
            });
        }
    };
    try {
        for (var _b = __values(Object.keys(source)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var attr = _c.value;
            _loop_1(attr);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function resolveScopedSlots(vm, slotsProxy) {
    var parentVNode = vm.$options._parentVnode;
    if (!parentVNode)
        return;
    var prevSlots = vmStateManager.get(vm, 'slots') || [];
    var curSlots = resolveSlots(parentVNode.data.scopedSlots, vm.$slots);
    // remove staled slots
    for (var index = 0; index < prevSlots.length; index++) {
        var key = prevSlots[index];
        if (!curSlots[key]) {
            delete slotsProxy[key];
        }
    }
    // proxy fresh slots
    var slotNames = Object.keys(curSlots);
    for (var index = 0; index < slotNames.length; index++) {
        var key = slotNames[index];
        if (!slotsProxy[key]) {
            slotsProxy[key] = createSlotProxy(vm, key);
        }
    }
    vmStateManager.set(vm, 'slots', slotNames);
}
function activateCurrentInstance(instance, fn, onError) {
    var preVm = getCurrentInstance();
    setCurrentInstance(instance);
    try {
        return fn(instance);
    }
    catch (
    // FIXME: remove any
    err) {
        if (onError) {
            onError(err);
        }
        else {
            throw err;
        }
    }
    finally {
        setCurrentInstance(preVm);
    }
}

function mixin(Vue) {
    Vue.mixin({
        beforeCreate: functionApiInit,
        mounted: function () {
            afterRender(this);
        },
        beforeUpdate: function () {
            updateVmAttrs(this);
        },
        updated: function () {
            afterRender(this);
        },
    });
    /**
     * Vuex init hook, injected into each instances init hooks list.
     */
    function functionApiInit() {
        var vm = this;
        var $options = vm.$options;
        var setup = $options.setup, render = $options.render;
        if (render) {
            // keep currentInstance accessible for createElement
            $options.render = function () {
                var _this = this;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return activateCurrentInstance(toVue3ComponentInstance(vm), function () {
                    return render.apply(_this, args);
                });
            };
        }
        if (!setup) {
            return;
        }
        if (!isFunction(setup)) {
            if ((false)) {
                warn('The "setup" option should be a function that returns a object in component definitions.', vm);
            }
            return;
        }
        var data = $options.data;
        // wrapper the data option, so we can invoke setup before data get resolved
        $options.data = function wrappedData() {
            initSetup(vm, vm.$props);
            return isFunction(data)
                ? data.call(vm, vm)
                : data || {};
        };
    }
    function initSetup(vm, props) {
        if (props === void 0) { props = {}; }
        var setup = vm.$options.setup;
        var ctx = createSetupContext(vm);
        var instance = toVue3ComponentInstance(vm);
        instance.setupContext = ctx;
        // fake reactive for `toRefs(props)`
        def(props, '__ob__', createObserver());
        // resolve scopedSlots and slots to functions
        resolveScopedSlots(vm, ctx.slots);
        var binding;
        activateCurrentInstance(instance, function () {
            // make props to be fake reactive, this is for `toRefs(props)`
            binding = setup(props, ctx);
        });
        if (!binding)
            return;
        if (isFunction(binding)) {
            // keep typescript happy with the binding type.
            var bindingFunc_1 = binding;
            // keep currentInstance accessible for createElement
            vm.$options.render = function () {
                resolveScopedSlots(vm, ctx.slots);
                return activateCurrentInstance(instance, function () { return bindingFunc_1(); });
            };
            return;
        }
        else if (isObject(binding)) {
            if (isReactive(binding)) {
                binding = toRefs(binding);
            }
            vmStateManager.set(vm, 'rawBindings', binding);
            var bindingObj_1 = binding;
            Object.keys(bindingObj_1).forEach(function (name) {
                var bindingValue = bindingObj_1[name];
                if (!isRef(bindingValue)) {
                    if (!isReactive(bindingValue)) {
                        if (isFunction(bindingValue)) {
                            var copy_1 = bindingValue;
                            bindingValue = bindingValue.bind(vm);
                            Object.keys(copy_1).forEach(function (ele) {
                                bindingValue[ele] = copy_1[ele];
                            });
                        }
                        else if (!isObject(bindingValue)) {
                            bindingValue = ref(bindingValue);
                        }
                        else if (hasReactiveArrayChild(bindingValue)) {
                            // creates a custom reactive properties without make the object explicitly reactive
                            // NOTE we should try to avoid this, better implementation needed
                            customReactive(bindingValue);
                        }
                    }
                    else if (isArray(bindingValue)) {
                        bindingValue = ref(bindingValue);
                    }
                }
                asVmProperty(vm, name, bindingValue);
            });
            return;
        }
        if ((false)) {
            assert(false, "\"setup\" must return a \"Object\" or a \"Function\", got \"".concat(Object.prototype.toString
                .call(binding)
                .slice(8, -1), "\""));
        }
    }
    function customReactive(target, seen) {
        if (seen === void 0) { seen = new Set(); }
        if (seen.has(target))
            return;
        if (!isPlainObject(target) ||
            isRef(target) ||
            isReactive(target) ||
            isRaw(target))
            return;
        var Vue = getVueConstructor();
        // @ts-expect-error https://github.com/vuejs/vue/pull/12132
        var defineReactive = Vue.util.defineReactive;
        Object.keys(target).forEach(function (k) {
            var val = target[k];
            defineReactive(target, k, val);
            if (val) {
                seen.add(val);
                customReactive(val, seen);
            }
            return;
        });
    }
    function hasReactiveArrayChild(target, visited) {
        if (visited === void 0) { visited = new Map(); }
        if (visited.has(target)) {
            return visited.get(target);
        }
        visited.set(target, false);
        if (isArray(target) && isReactive(target)) {
            visited.set(target, true);
            return true;
        }
        if (!isPlainObject(target) || isRaw(target) || isRef(target)) {
            return false;
        }
        return Object.keys(target).some(function (x) {
            return hasReactiveArrayChild(target[x], visited);
        });
    }
    function createSetupContext(vm) {
        var ctx = { slots: {} };
        var propsPlain = [
            'root',
            'parent',
            'refs',
            'listeners',
            'isServer',
            'ssrContext',
        ];
        var methodReturnVoid = ['emit'];
        propsPlain.forEach(function (key) {
            var srcKey = "$".concat(key);
            proxy(ctx, key, {
                get: function () { return vm[srcKey]; },
                set: function () {
                    ("production" !== 'production') &&
                        warn("Cannot assign to '".concat(key, "' because it is a read-only property"), vm);
                },
            });
        });
        updateVmAttrs(vm, ctx);
        methodReturnVoid.forEach(function (key) {
            var srcKey = "$".concat(key);
            proxy(ctx, key, {
                get: function () {
                    return function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        var fn = vm[srcKey];
                        fn.apply(vm, args);
                    };
                },
            });
        });
        if (false) {
            ctx._vm = vm;
        }
        return ctx;
    }
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData(from, to) {
    if (!from)
        return to;
    if (!to)
        return from;
    var key;
    var toVal;
    var fromVal;
    var keys = hasSymbol ? Reflect.ownKeys(from) : Object.keys(from);
    for (var i = 0; i < keys.length; i++) {
        key = keys[i];
        // in case the object is already observed...
        if (key === '__ob__')
            continue;
        toVal = to[key];
        fromVal = from[key];
        if (!hasOwn(to, key)) {
            to[key] = fromVal;
        }
        else if (toVal !== fromVal &&
            isPlainObject(toVal) &&
            !isRef(toVal) &&
            isPlainObject(fromVal) &&
            !isRef(fromVal)) {
            mergeData(fromVal, toVal);
        }
    }
    return to;
}
function install(Vue) {
    if (isVueRegistered(Vue)) {
        if ((false)) {
            warn('[vue-composition-api] already installed. Vue.use(VueCompositionAPI) should be called only once.');
        }
        return;
    }
    if ((false)) {
        if (Vue.version) {
            if (Vue.version[0] !== '2' || Vue.version[1] !== '.') {
                warn("[vue-composition-api] only works with Vue 2, v".concat(Vue.version, " found."));
            }
        }
        else {
            warn('[vue-composition-api] no Vue version found');
        }
    }
    Vue.config.optionMergeStrategies.setup = function (parent, child) {
        return function mergedSetupFn(props, context) {
            return mergeData(isFunction(parent) ? parent(props, context) || {} : undefined, isFunction(child) ? child(props, context) || {} : undefined);
        };
    };
    setVueConstructor(Vue);
    mixin(Vue);
}
var Plugin = {
    install: function (Vue) { return install(Vue); },
};

// implementation, close to no-op
function defineComponent(options) {
    return options;
}

function defineAsyncComponent(source) {
    if (isFunction(source)) {
        source = { loader: source };
    }
    var loader = source.loader, loadingComponent = source.loadingComponent, errorComponent = source.errorComponent, _a = source.delay, delay = _a === void 0 ? 200 : _a, timeout = source.timeout, // undefined = never times out
    _b = source.suspensible, // undefined = never times out
    suspensible = _b === void 0 ? false : _b, // in Vue 3 default is true
    userOnError = source.onError;
    if (false) {
        warn("The suspensiblbe option for async components is not supported in Vue2. It is ignored.");
    }
    var pendingRequest = null;
    var retries = 0;
    var retry = function () {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function () {
        var thisRequest;
        return (pendingRequest ||
            (thisRequest = pendingRequest =
                loader()
                    .catch(function (err) {
                    err = err instanceof Error ? err : new Error(String(err));
                    if (userOnError) {
                        return new Promise(function (resolve, reject) {
                            var userRetry = function () { return resolve(retry()); };
                            var userFail = function () { return reject(err); };
                            userOnError(err, userRetry, userFail, retries + 1);
                        });
                    }
                    else {
                        throw err;
                    }
                })
                    .then(function (comp) {
                    if (thisRequest !== pendingRequest && pendingRequest) {
                        return pendingRequest;
                    }
                    if (false) {
                        warn("Async component loader resolved to undefined. " +
                            "If you are using retry(), make sure to return its return value.");
                    }
                    // interop module default
                    if (comp &&
                        (comp.__esModule || comp[Symbol.toStringTag] === 'Module')) {
                        comp = comp.default;
                    }
                    if (false) {
                        throw new Error("Invalid async component load result: ".concat(comp));
                    }
                    return comp;
                })));
    };
    return function () {
        var component = load();
        return {
            component: component,
            delay: delay,
            timeout: timeout,
            error: errorComponent,
            loading: loadingComponent,
        };
    };
}

var version = "1.4.9";
// auto install when using CDN
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(Plugin);
}




/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var HANDLESUBMIT = {
  data: function data() {
    return {
      formComplete: false,
      wasValidated: false,
      dateOfBirth: '',
      isUnder8: false,
      isUnder13: false,
      isUnder17: false,
      isUnder18: false,
      isUnder21: false,
      isOver55: false,
      password: {
        password: '',
        confirmPassword: ''
      },
      confirmRequired: false
    };
  },
  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;

      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      var forms = document.getElementsByClassName('needs-validation');
      var submitButtons = document.querySelectorAll('button[type=submit]'); // Loop over them and prevent submission

      Array.prototype.filter.call(forms, function (form) {
        form.addEventListener('submit', function (event) {
          submitButtons.forEach(function (element) {
            if (typeof element !== 'undefined') {
              element.setAttribute('disabled', '');
            }
          });

          if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            _this.formComplete = false;
            submitButtons.forEach(function (element) {
              if (typeof element !== 'undefined') {
                element.removeAttribute('disabled');
              }
            });
            var firstInvalid = form.querySelector(':invalid');

            if (firstInvalid) {
              firstInvalid.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }
          } else {
            _this.formComplete = true;
          }

          if (_this.password.password !== _this.password.confirmPassword) {
            _this.password.confirmPassword = '';
            _this.formComplete = false;
            submitButtons.forEach(function (element) {
              if (typeof element !== 'undefined') {
                element.removeAttribute('disabled');
              }
            });
          }

          _this.wasValidated = true;
          form.classList.add('was-validated');
        }, false);
        form.addEventListener('input', function () {
          submitButtons.forEach(function (element) {
            if (typeof element !== 'undefined') {
              element.removeAttribute('disabled');
            }
          });
        });
      });
    },
    checkValidity: function checkValidity() {
      var _this2 = this;

      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      var forms = document.getElementsByClassName('needs-validation'); // Loop over them and prevent submission

      Array.prototype.filter.call(forms, function (form) {
        if (form.checkValidity() === false) {
          event.stopPropagation();
          _this2.formComplete = false;
        } else {
          _this2.formComplete = true;
        }

        if (_this2.password.password !== _this2.password.confirmPassword) {
          _this2.password.confirmPassword = '';
          _this2.formComplete = false;
        }

        _this2.wasValidated = true;
        form.classList.add('was-validated');
      });
    },
    removeValidation: function removeValidation() {
      var _this3 = this;

      var forms = document.getElementsByClassName('needs-validation');
      Array.prototype.filter.call(forms, function (form) {
        _this3.wasValidated = false;
        form.classList.remove('was-validated');
      });
    },
    resetForm: function resetForm() {
      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      var forms = document.getElementsByClassName('needs-validation');
      Array.prototype.filter.call(forms, function (form) {
        form.classList.remove('was-validated');
      });
      this.formComplete = false;
    },
    today: function today() {
      // Get today's date for date field's "max" attribute
      var today = this.$store.state.currentDate ? new Date(this.$store.state.currentDate) : new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();

      if (dd < 10) {
        dd = "0".concat(dd);
      }

      if (mm < 10) {
        mm = "0".concat(mm);
      }

      today = "".concat(yyyy, "-").concat(mm, "-").concat(dd);
      return today;
    }
  },
  watch: {
    dateOfBirth: function dateOfBirth(birth) {
      // When Date Of Birth is changed, determine if they're under 18
      if (birth !== '' && birth !== null) {
        var record = new Date(birth.trim());
        var day = record.getDate();
        var month = record.getMonth();
        var year = record.getFullYear();
        var today = this.$store.state.currentDate ? new Date(this.$store.state.currentDate) : new Date();
        this.isUnder8 = new Date(year + 8, month, day) >= today;
        this.isUnder13 = new Date(year + 13, month, day) >= today;
        this.isUnder17 = new Date(year + 17, month, day) >= today;
        this.isUnder18 = new Date(year + 18, month, day) >= today;
        this.isUnder21 = new Date(year + 21, month, day) >= today;
        this.isOver55 = new Date(year + 55, month, day) <= today;
      } else if (birth === '') {
        this.isUnder8 = true;
        this.isUnder13 = true;
        this.isUnder17 = true;
        this.isUnder18 = true;
        this.isUnder21 = true;
        this.isOver55 = false;
      }
    },
    password: {
      handler: function handler(password) {
        this.confirmRequired = password.password.length > 0 ? true : false;
      },
      deep: true
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (HANDLESUBMIT);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Text_vue__ = __webpack_require__(233);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b333ab8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Text_vue__ = __webpack_require__(668);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Text_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b333ab8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Text_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fb0d14d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataTable_vue__ = __webpack_require__(667);
function injectStyle (ssrContext) {
  __webpack_require__(653)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1fb0d14d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fb0d14d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var LEGACYBROWSERS = {
  methods: {
    isLegacy: function isLegacy() {
      var userAgent = window.navigator.userAgent;
      return userAgent.indexOf('Safari') > 0 && userAgent.indexOf('OS X') > 0 || userAgent.indexOf('Trident') > 0;
    },
    isIOS: function isIOS() {
      var userAgent = window.navigator.userAgent;
      return /iphone|ipod|ipad/.test(userAgent);
    },
    isEdge: function isEdge() {
      var userAgent = window.navigator.userAgent;
      return userAgent.indexOf('Edge') > 0;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (LEGACYBROWSERS);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesktopActionBar_vue__ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6b99414_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesktopActionBar_vue__ = __webpack_require__(734);
function injectStyle (ssrContext) {
  __webpack_require__(733)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b6b99414"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DesktopActionBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6b99414_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DesktopActionBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* Used by DataTables for field selection */

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]());

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var GETSTORE = {
  data: function data() {
    return {
      status: '',
      memberDetails: ''
    };
  },
  mounted: function mounted() {
    this.determineAction();
  },
  methods: {
    determineAction: function determineAction() {
      /* If being passed data (clicking a thing), show the data and save
      * it to the store. If there's no data being passed (clicking back
      * or the breadcrumb, query the store). Different variable
      * depending on whether it's a parent or child profile page. */
      if (this.$route.params && this.$route.params.slug) {
        // Get ID from page slug
        this.getMemberFromAPI(this.$route.params.slug);
      } else if (this.details) {
        // Get ID from passed details prop
        this.getMemberFromAPI(this.details.id);
      } else if (this.userID) {
        // Get ID from passed ID of logged-in user
        this.getMemberFromAPI(this.userID);
      } else {
        // Else, get child ID
        this.memberDetails = this.child ? this.$store.state.childMember : this.$store.state.viewedMember;

        if (this.memberDetails === '') {
          // Probably won't ever happen but if something goes wrong with the above, go back to root
          this.$router.push('/');
        }
      }
    },
    getMemberFromAPI: function getMemberFromAPI(userID) {
      var _this = this;

      if (userID !== localStorage.userID || !this.$isAdmin) {
        var tempUser = [];
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/user/").concat(userID)).then(function (response) {
          if (response.data.status === 'success') {
            tempUser = response.data.data;

            _this.$store.commit('setMember', tempUser); // We're handling date of birth weirdly, just roll with it


            if (tempUser.dob) {
              tempUser.dateOfBirth = tempUser.dob;
            }
          } else if (response.data.status === 'undefined_error') {
            _this.$router.push({
              name: 'Dashboard',
              params: {
                status: "That user couldn't be found."
              }
            });
          }

          if (tempUser === '') {
            _this.$router.push('/');
          }

          _this.status = response.data.status;

          _this.setUser(tempUser);
        });
      }
    },
    setUser: function setUser(tempUser) {
      if (!tempUser.hasOwnProperty('attributes') || tempUser.attributes === null) {
        tempUser.attributes = {
          address: {}
        };
      } else if (!tempUser.attributes.hasOwnProperty('address') || tempUser.attributes.address === null) {
        tempUser.attributes.address = {};
      }

      if (this.child) {
        this.$store.commit('updateChildMember', tempUser);
      } else {
        this.$store.commit('updateViewedMember', tempUser);
      }

      this.memberDetails = tempUser;
      this.memberDetails.getedRole = this.memberDetails.role;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (GETSTORE);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_EventBus__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_actingCommittee__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_actingCommittee__ = __webpack_require__(199);





var http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create();
var ACTION_GATE_STORAGE_KEY = 'actionGateToken';
http.interceptors.request.use(function (config) {
  config.baseURL = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;
  var token = localStorage.getItem('bearer');
  if (token) config.headers.Authorization = "Bearer ".concat(token);
  var acting = JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_4__constants_actingCommittee__["b" /* ACTING_COMMITTEE_STORAGE_KEY */]) || 'null');
  if (acting && acting.id) config.headers[__WEBPACK_IMPORTED_MODULE_4__constants_actingCommittee__["a" /* ACTING_COMMITTEE_HEADER */]] = acting.id;
  var gate = JSON.parse(localStorage.getItem(ACTION_GATE_STORAGE_KEY) || 'null');
  if (gate && gate.expiresAt > Date.now()) config.headers['X-Action-Gate-Token'] = gate.token;
  return config;
});
var TOKEN_CODES = ['token_expired', 'token_invalid', 'token_error'];

function handleResponseError(error) {
  var data = error.response != null ? error.response.data : null;
  var code = data != null ? data.code : null;

  if (TOKEN_CODES.includes(code)) {
    localStorage.removeItem('bearer');
    window.location.href = '/login';
    return Promise.reject(error);
  }

  if (code === 'acting_committee_invalid') {
    Object(__WEBPACK_IMPORTED_MODULE_3__services_actingCommittee__["b" /* setActingCommittee */])(null);
    window.location.href = '/';
    return Promise.reject(error);
  }

  if (code === 'committee_not_financial' && !window.location.pathname.startsWith('/committees/affiliation')) {
    window.location.href = '/committees/affiliation';
    return Promise.reject(error);
  }

  if (code !== 'validation_error' && !error.config.silent) {
    var message = data != null && data.message != null ? data.message : 'A server error occurred. Please try again later.';
    __WEBPACK_IMPORTED_MODULE_2__store_EventBus__["a" /* default */].$emit('http-error', message);
  }

  return Promise.reject(error);
}

http.interceptors.response.use(function (response) {
  var data = response.data;

  if (response.config.silent && !response.config.localSuccess && data.message != null) {
    __WEBPACK_IMPORTED_MODULE_2__store_EventBus__["a" /* default */].$emit('show-success', data.message);
  }

  return response;
}, function (error) {
  var isBlobError = error.response != null && error.response.data instanceof Blob && error.response.data.type === 'application/json';

  if (isBlobError) {
    return error.response.data.text().then(function (text) {
      try {
        error.response.data = JSON.parse(text);
      } catch (_) {// leave error.response.data as-is if it isn't valid JSON
      }

      return handleResponseError(error);
    });
  }

  return handleResponseError(error);
});
/* harmony default export */ __webpack_exports__["a"] = (http);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__(236);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11092ca1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__(675);
function injectStyle (ssrContext) {
  __webpack_require__(674)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11092ca1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11092ca1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppMultiselect_vue__ = __webpack_require__(248);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppMultiselect_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResponsiveTable_vue__ = __webpack_require__(235);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97df8758_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResponsiveTable_vue__ = __webpack_require__(673);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResponsiveTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97df8758_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResponsiveTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getActingCommittee;
/* harmony export (immutable) */ __webpack_exports__["d"] = syncActingCommitteeHeader;
/* harmony export (immutable) */ __webpack_exports__["b"] = setActingCommittee;
/* harmony export (immutable) */ __webpack_exports__["c"] = storeSuperSecretaryFlags;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_actingCommittee__ = __webpack_require__(199);

 // Stored selection: { id, name } or null

function getActingCommittee() {
  try {
    return JSON.parse(localStorage.getItem(__WEBPACK_IMPORTED_MODULE_1__constants_actingCommittee__["b" /* ACTING_COMMITTEE_STORAGE_KEY */]) || 'null');
  } catch (_) {
    return null;
  }
} // `axios` here is the plain instance many views use directly; the shared `http` client reads
// the storage on each request (services/api/http.js).

function syncActingCommitteeHeader() {
  var acting = getActingCommittee();

  if (acting && acting.id) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common[__WEBPACK_IMPORTED_MODULE_1__constants_actingCommittee__["a" /* ACTING_COMMITTEE_HEADER */]] = acting.id;
  } else {
    delete __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common[__WEBPACK_IMPORTED_MODULE_1__constants_actingCommittee__["a" /* ACTING_COMMITTEE_HEADER */]];
  }
}
function setActingCommittee(committee) {
  if (committee && committee.id) {
    localStorage.setItem(__WEBPACK_IMPORTED_MODULE_1__constants_actingCommittee__["b" /* ACTING_COMMITTEE_STORAGE_KEY */], JSON.stringify({
      id: committee.id,
      name: committee.name
    }));
  } else {
    localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_1__constants_actingCommittee__["b" /* ACTING_COMMITTEE_STORAGE_KEY */]);
  }

  syncActingCommitteeHeader();
} // Call after every login / login-as / /auth/me: stores the Super Secretary flags and drops a
// selection that belongs to a previous session.

function storeSuperSecretaryFlags(data) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$resetSelection = _ref.resetSelection,
      resetSelection = _ref$resetSelection === void 0 ? false : _ref$resetSelection;

  localStorage.setItem('is_super_secretary', data.is_super_secretary ? 'true' : 'false');

  if (data.own_committee_id) {
    localStorage.setItem('own_committee_id', data.own_committee_id);
  } else {
    localStorage.removeItem('own_committee_id');
  }

  if (resetSelection || !data.is_super_secretary) setActingCommittee(null);
}

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListNameCell_vue__ = __webpack_require__(237);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac5cab0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListNameCell_vue__ = __webpack_require__(677);
function injectStyle (ssrContext) {
  __webpack_require__(676)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListNameCell_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac5cab0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListNameCell_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }


function fetchData(_x, _x2, _x3) {
  return _fetchData.apply(this, arguments);
}

function _fetchData() {
  _fetchData = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(url, onSuccess, context) {
    var config,
        response,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            config = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
            _context.prev = 1;
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, config);

          case 4:
            response = _context.sent;

            if (response.data.status === 'success') {
              if (typeof onSuccess === 'function') {
                onSuccess.call(context, response);
              }
            } else {
              context.error = response.data.error || 'Unable to receive data from the server. Please reload the page.';
            }

            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);

            if (_context.t0.response && _context.t0.response.data) {
              context.error = _context.t0.response.data.error || 'Unknown server error';
            } else {
              context.error = _context.t0.message || 'Unable to receive data from the server.';
            }

          case 11:
            _context.prev = 11;

            if (context) {
              context.options = context.options || {};
              context.options.loaded = true;
            }

            return _context.finish(11);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8, 11, 14]]);
  }));
  return _fetchData.apply(this, arguments);
}

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__(278);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23abc310_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__(745);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23abc310_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useUserRole;
var ROLES = {
  MEMBER: 'Member',
  VOLUNTEER: 'Volunteer',
  SECRETARY: 'Secretary',
  SECRETARY_ONLY: 'SecretaryOnly',
  ADMIN: 'Admin',
  SUPER_ADMIN: 'SuperAdmin'
};
function useUserRole() {
  var role = localStorage.role || '';
  var isUser = role === ROLES.MEMBER;
  var isVolunteer = role === ROLES.VOLUNTEER;
  var isSecretary = role === ROLES.SECRETARY || role === ROLES.SECRETARY_ONLY; // Secretary who is also a regular member (has their own personal nominations), unlike SecretaryOnly

  var isSecretaryMember = role === ROLES.SECRETARY;
  var isSuperAdmin = role === ROLES.SUPER_ADMIN;
  var isAdmin = role === ROLES.ADMIN || isSuperAdmin;
  var isSecretaryOrAdmin = isSecretary || isAdmin; // CAM-1533: Secretary flagged by an admin; can switch between committees

  var isSuperSecretary = isSecretary && localStorage.is_super_secretary === 'true'; // True while a Super Secretary works on a committee other than their own: Committee page is
  // read-only and Draft Setup is closed (the API enforces both).

  var actingCommitteeId = null;

  try {
    actingCommitteeId = (JSON.parse(localStorage.getItem('actingCommittee') || 'null') || {}).id || null;
  } catch (_) {
    actingCommitteeId = null;
  }

  var isActingForOtherCommittee = isSuperSecretary && !!actingCommitteeId && String(actingCommitteeId) !== String(localStorage.own_committee_id || '');
  return {
    role: role,
    isUser: isUser,
    isVolunteer: isVolunteer,
    isSecretary: isSecretary,
    isSecretaryMember: isSecretaryMember,
    isAdmin: isAdmin,
    isSuperAdmin: isSuperAdmin,
    isSecretaryOrAdmin: isSecretaryOrAdmin,
    isSuperSecretary: isSuperSecretary,
    isActingForOtherCommittee: isActingForOtherCommittee
  };
}

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useServerList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }


var PER_PAGE_OPTIONS = [20, 50, 100, 200];
/**
 * Server-side list plumbing shared by the optimisation of the Horses / Drafts / Members list
 * pages (CAM-1478 / CAM-1479 / CAM-1477): pagination, 3-state sort, per-page, search and any
 * number of extra scalar filters — all fetched from the API and mirrored into the URL query so
 * a reload or "open in new tab" restores the exact same view.
 *
 * @param {(params: object) => Promise} fetchFn  API call, receives the built query params,
 *   must resolve to `{ data: { data: [], meta: { current_page, last_page, total } } }`.
 * @param {object} options
 * @param {string|null} options.defaultSort       column key sorted by default (the "none" state)
 * @param {'asc'|'desc'} options.defaultDirection
 * @param {number} options.defaultPerPage         one of 20 / 50 / 100 / 200
 * @param {object} options.extraFilters           { queryKey: defaultValue } — synced + sent
 * @param {string[]} options.stringMultiFilters    keys (from extraFilters) whose multi-value
 *   state is a string[] (e.g. `relation: ['owner','rider']`) rather than the default number[]
 *   (`zone_id: [1,2]`) — both an empty-array default, so the element type can't be inferred.
 */

function useServerList(fetchFn) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$defaultSort = _ref.defaultSort,
      defaultSort = _ref$defaultSort === void 0 ? null : _ref$defaultSort,
      _ref$defaultDirection = _ref.defaultDirection,
      defaultDirection = _ref$defaultDirection === void 0 ? 'asc' : _ref$defaultDirection,
      _ref$defaultPerPage = _ref.defaultPerPage,
      defaultPerPage = _ref$defaultPerPage === void 0 ? 20 : _ref$defaultPerPage,
      _ref$extraFilters = _ref.extraFilters,
      extraFilters = _ref$extraFilters === void 0 ? {} : _ref$extraFilters,
      _ref$stringMultiFilte = _ref.stringMultiFilters,
      stringMultiFilters = _ref$stringMultiFilte === void 0 ? [] : _ref$stringMultiFilte;

  var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
      proxy = _getCurrentInstance.proxy;

  var router = proxy.$router;
  var rows = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var page = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(1);
  var totalPages = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(1);
  var total = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(0); // An extra filter whose default is an array is multi-value: it travels as a comma-separated
  // string in the URL query and the API request (`?zone_id=1,2`), and is held here as a
  // number[] (or, for a key listed in stringMultiFilters, a string[]). Everything else stays a
  // plain scalar.

  var isMulti = function isMulti(key) {
    return Array.isArray(extraFilters[key]);
  };

  var isStringMulti = function isStringMulti(key) {
    return stringMultiFilters.includes(key);
  };

  var cloneDefault = function cloneDefault(key) {
    return isMulti(key) ? _toConsumableArray(extraFilters[key]) : extraFilters[key];
  };

  function toNumArray(raw) {
    var parts = Array.isArray(raw) ? raw : String(raw).split(',');
    return parts.map(Number).filter(function (n) {
      return Number.isFinite(n) && n !== 0;
    });
  }

  function toStrArray(raw) {
    var parts = Array.isArray(raw) ? raw : String(raw).split(',');
    return parts.map(String).filter(function (s) {
      return s !== '';
    });
  }

  var filters = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])(_objectSpread({
    sort: defaultSort,
    direction: defaultDirection,
    per_page: defaultPerPage,
    search: ''
  }, Object.keys(extraFilters).reduce(function (acc, key) {
    acc[key] = cloneDefault(key);
    return acc;
  }, {}))); // (Re)read the whole table state from the current URL query — called on init and again on every
  // route change, so navigating between two pages that share this component (My Horses <-> Horses)
  // reloads the right view instead of showing the previous one.

  function syncFromQuery() {
    var query = proxy.$route.query;
    page.value = Number(query.page) > 0 ? Number(query.page) : 1;
    filters.sort = query.sort || defaultSort;
    filters.direction = query.direction === 'desc' ? 'desc' : query.sort ? 'asc' : defaultDirection;
    var qpp = Number(query.per_page);
    filters.per_page = PER_PAGE_OPTIONS.includes(qpp) ? qpp : defaultPerPage;
    filters.search = query.search || '';
    Object.keys(extraFilters).forEach(function (key) {
      if (isMulti(key)) {
        filters[key] = query[key] != null ? isStringMulti(key) ? toStrArray(query[key]) : toNumArray(query[key]) : [];
      } else {
        filters[key] = query[key] != null ? query[key] : extraFilters[key];
      }
    });
  }

  syncFromQuery();

  function syncQuery() {
    var query = {};
    if (page.value > 1) query.page = String(page.value);

    if (filters.sort) {
      query.sort = filters.sort;
      query.direction = filters.direction;
    }

    if (filters.per_page !== defaultPerPage) query.per_page = String(filters.per_page);
    if (filters.search) query.search = filters.search;
    Object.keys(extraFilters).forEach(function (key) {
      if (isMulti(key)) {
        if (filters[key] && filters[key].length) query[key] = filters[key].join(',');
      } else if (filters[key] != null && String(filters[key]) !== String(extraFilters[key])) {
        query[key] = String(filters[key]);
      }
    }); // vue-router's location normalisation drops `hash` entirely when the target location has
    // no `path`/`name` of its own and no `hash` is given — it does NOT fall back to the current
    // route's hash the way it does for `path`. Harmless for the plain list pages (no hash), but
    // this composable also backs the Member Profile "Horses" tab (CAM-1505), whose parent tracks
    // the selected tab via `$route.hash` — losing it would silently bounce the user back to the
    // Details tab on the first filter/sort/page click. Pass the current hash through explicitly.

    var location = proxy.$route.hash ? {
      query: query,
      hash: proxy.$route.hash
    } : {
      query: query
    };
    router.replace(location).catch(function () {});
  }

  function buildParams() {
    var params = {
      page: page.value,
      per_page: filters.per_page
    };

    if (filters.sort) {
      params.sort = filters.sort;
      params.direction = filters.direction;
    }

    if (filters.search) params.search = filters.search;
    Object.keys(extraFilters).forEach(function (key) {
      if (isMulti(key)) {
        if (filters[key] && filters[key].length) params[key] = filters[key].join(',');
      } else if (filters[key] != null && filters[key] !== '') {
        params[key] = filters[key];
      }
    });
    return params;
  }

  function fetch() {
    return _fetch.apply(this, arguments);
  }

  function _fetch() {
    _fetch = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var res, body, meta;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              _context.next = 4;
              return fetchFn(buildParams());

            case 4:
              res = _context.sent;
              body = res.data != null ? res.data : {};
              rows.value = body.data != null ? body.data : [];
              meta = body.meta != null ? body.meta : {};
              page.value = meta.current_page != null ? meta.current_page : 1;
              totalPages.value = meta.last_page != null ? meta.last_page : 1;
              total.value = meta.total != null ? meta.total : 0;
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](1);
              rows.value = [];

            case 16:
              _context.prev = 16;
              loading.value = false;
              return _context.finish(16);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 13, 16, 19]]);
    }));
    return _fetch.apply(this, arguments);
  }

  function setPage(p) {
    page.value = p;
    syncQuery();
    fetch();
  } // 3-state cycle — none -> asc -> desc -> none (table.md)


  function setSort(field) {
    if (filters.sort !== field) {
      filters.sort = field;
      filters.direction = 'asc';
    } else if (filters.direction === 'asc') {
      filters.direction = 'desc';
    } else {
      filters.sort = defaultSort;
      filters.direction = defaultDirection;
    }

    page.value = 1;
    syncQuery();
    fetch();
  }

  function setPerPage(n) {
    filters.per_page = Number(n);
    page.value = 1;
    syncQuery();
    fetch();
  }

  function setSearch(value) {
    filters.search = value || '';
    page.value = 1;
    syncQuery();
    fetch();
  }

  function setFilter(key, value) {
    filters[key] = value;
    page.value = 1;
    syncQuery();
    fetch();
  } // Set several filters at once with a single syncQuery()/fetch() — use instead of multiple
  // setFilter() calls in a row (e.g. a group of mutually-exclusive checkboxes clearing each other
  // when one is checked), which would otherwise fire one request per call.


  function setFilters(updates) {
    Object.keys(updates).forEach(function (key) {
      filters[key] = updates[key];
    });
    page.value = 1;
    syncQuery();
    fetch();
  } // Reset one extra filter to its default ("clear this filter" — the × on a single control).


  function clearFilter(key) {
    if (!(key in extraFilters)) return;
    setFilter(key, cloneDefault(key));
  } // Reset search + every extra filter to defaults ("clear all filters"). Sort and page size
  // are view preferences, not filters, so they stay.


  function clearFilters() {
    filters.search = '';
    Object.keys(extraFilters).forEach(function (key) {
      filters[key] = cloneDefault(key);
    });
    page.value = 1;
    syncQuery();
    fetch();
  }

  return {
    rows: rows,
    loading: loading,
    page: page,
    totalPages: totalPages,
    total: total,
    filters: filters,
    perPageOptions: PER_PAGE_OPTIONS,
    fetch: fetch,
    setPage: setPage,
    setSort: setSort,
    setPerPage: setPerPage,
    setSearch: setSearch,
    setFilter: setFilter,
    setFilters: setFilters,
    clearFilter: clearFilter,
    clearFilters: clearFilters,
    syncQuery: syncQuery,
    syncFromQuery: syncFromQuery
  };
}

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterMultiselect_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_624debbc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterMultiselect_vue__ = __webpack_require__(700);
function injectStyle (ssrContext) {
  __webpack_require__(698)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-624debbc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterMultiselect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_624debbc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterMultiselect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseSearchSelect_vue__ = __webpack_require__(313);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_485fc708_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseSearchSelect_vue__ = __webpack_require__(801);
function injectStyle (ssrContext) {
  __webpack_require__(800)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-485fc708"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseSearchSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_485fc708_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseSearchSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PhoneInput_vue__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c6a6dd6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PhoneInput_vue__ = __webpack_require__(624);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PhoneInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c6a6dd6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PhoneInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TestPhoneNumbers_vue__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7218a98_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TestPhoneNumbers_vue__ = __webpack_require__(626);
function injectStyle (ssrContext) {
  __webpack_require__(625)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f7218a98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TestPhoneNumbers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7218a98_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TestPhoneNumbers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__ = __webpack_require__(246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ad92b34_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__ = __webpack_require__(697);
function injectStyle (ssrContext) {
  __webpack_require__(696)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ad92b34_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  getList: function getList(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/members', {
      params: params
    });
  },
  // "Archive" itself lives on the Member Profile page (Tabs/Details.vue) — restore is the only
  // member-lifecycle action this list page performs (the "Deleted" tab's Restore button).
  restore: function restore(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/members/".concat(id, "/restore"), {}, {
      silent: true
    });
  },
  // Shared member pickers (CAM-1477 part 2) — `params.context` is 'owner' or 'competitor'.
  options: function options(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/members/options', {
      params: params
    });
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Details_vue__ = __webpack_require__(255);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39b6fcd2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__ = __webpack_require__(738);
function injectStyle (ssrContext) {
  __webpack_require__(710)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39b6fcd2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39b6fcd2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      appearances: {},
      error: null,
      options: {
        loaded: false
      }
    };
  },
  mounted: function mounted() {
    this.fetchAppearances();
  },
  methods: {
    fetchAppearances: function fetchAppearances() {
      var _this = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(_this.$api, "/v2/appearances/leaderboard")).then(function (response) {
                  if (response.data) {
                    _this.appearances = response.data.data;
                  } else {
                    _this.error = 'Unable to receive data from the server. Please reload the page.';
                  }

                  _this.options.loaded = true;
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LinkRider_vue__ = __webpack_require__(414);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d2c55c4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LinkRider_vue__ = __webpack_require__(1033);
function injectStyle (ssrContext) {
  __webpack_require__(1032)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d2c55c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LinkRider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d2c55c4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LinkRider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  getList: function getList(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/drafts', {
      params: params
    });
  },
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(id));
  },
  availableForSetup: function availableForSetup() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/drafts/available-for-setup');
  },
  availableForNominations: function availableForNominations(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/drafts/available-for-nominations', {
      params: params
    });
  },
  myNominationsSummary: function myNominationsSummary() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/drafts/my-nominations-summary');
  },
  states: function states() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/draft-states');
  },
  setup: function setup(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/v2/drafts/setup', data);
  },
  forEdit: function forEdit(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(id, "/edit"));
  },
  update: function update(id, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put("/v2/drafts/".concat(id), data, {
      silent: true
    });
  },
  setProgramColor: function setProgramColor(id, color) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/drafts/".concat(id, "/program-color"), {
      color: color
    }, {
      silent: true,
      localSuccess: true
    });
  },
  generateProgram: function generateProgram(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/drafts/".concat(id, "/program"), {}, {
      silent: true,
      localSuccess: true
    });
  },
  approveProgram: function approveProgram(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/drafts/".concat(id, "/program/approve"), {}, {
      silent: true,
      localSuccess: true
    });
  },
  publishNominations: function publishNominations(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/drafts/".concat(id, "/nominations-published"), {}, {
      silent: true
    });
  },
  events: function events(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(id, "/events"));
  },
  updateRules: function updateRules(id, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/drafts/".concat(id, "/rules"), data, {
      silent: true,
      localSuccess: true
    });
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete("/v2/drafts/".concat(id), {
      silent: true
    });
  },
  restore: function restore(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/drafts/".concat(id, "/restore"), {}, {
      silent: true
    });
  }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FGroup_vue__ = __webpack_require__(292);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8718ff26_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FGroup_vue__ = __webpack_require__(769);
function injectStyle (ssrContext) {
  __webpack_require__(764)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8718ff26"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8718ff26_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  getList: function getList(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/horses', {
      params: params
    });
  },
  options: function options(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/horses/options', {
      params: params
    });
  },
  search: function search(q) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/horses/search', {
      params: {
        q: q
      }
    });
  },
  previewMerge: function previewMerge(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/v2/horse-merges/preview', data, {
      silent: true,
      localSuccess: true
    });
  },
  merge: function merge(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/v2/horse-merges', data, {
      silent: true,
      localSuccess: true
    });
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectRow_vue__ = __webpack_require__(274);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82af3686_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectRow_vue__ = __webpack_require__(741);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82af3686_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MembershipHistory_vue__ = __webpack_require__(279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_115f8e58_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MembershipHistory_vue__ = __webpack_require__(751);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MembershipHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_115f8e58_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MembershipHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberSearchSelect_vue__ = __webpack_require__(357);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6703a6d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberSearchSelect_vue__ = __webpack_require__(905);
function injectStyle (ssrContext) {
  __webpack_require__(904)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6703a6d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberSearchSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6703a6d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberSearchSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_apiHelpers__ = __webpack_require__(39);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      statistics: null,
      options: {
        loaded: false
      }
    };
  },
  methods: {
    fetchStatistics: function fetchStatistics() {
      var _this = this;

      return new Promise(function (resolve) {
        var _this$entity, _this$entity2;

        _this.options.loaded = false;
        _this.error = null;
        var id = (_this === null || _this === void 0 ? void 0 : (_this$entity = _this.entity) === null || _this$entity === void 0 ? void 0 : _this$entity.id) || _this.$route.params.draft_id;
        var event_id = (_this === null || _this === void 0 ? void 0 : (_this$entity2 = _this.entity) === null || _this$entity2 === void 0 ? void 0 : _this$entity2.event_id) || _this.$route.params.main_event_id;

        if (!id) {
          _this.error = 'ID is missing';
          _this.options.loaded = true;
          resolve();
          return;
        }

        var endpoint = _this.entity.model === 'event' ? "/leaders/events/".concat(event_id, "/statistics") : "/leaders/drafts/".concat(id, "/statistics");
        Object(__WEBPACK_IMPORTED_MODULE_0__mixins_apiHelpers__["a" /* default */])("".concat(_this.$api).concat(endpoint), function (response) {
          _this.statistics = response.data.data;
          resolve();
        }, _this);
      });
    }
  }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistics_vue__ = __webpack_require__(410);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0abb9ac4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Statistics_vue__ = __webpack_require__(1025);
function injectStyle (ssrContext) {
  __webpack_require__(1024)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0abb9ac4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statistics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0abb9ac4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Statistics_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppButton_vue__ = __webpack_require__(287);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b54346c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppButton_vue__ = __webpack_require__(760);
function injectStyle (ssrContext) {
  __webpack_require__(759)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b54346c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b54346c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  getList: function getList(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/committees', {
      params: params
    });
  },
  remove: function remove(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/admin/committee-delete', {
      id: id
    }, {
      silent: true,
      localSuccess: true
    });
  },
  getSecretaries: function getSecretaries() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/committees/secretaries');
  },
  getSwitchable: function getSwitchable(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/committees/switchable', {
      params: params
    });
  },
  drafts: function drafts(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/committees/drafts', {
      params: params
    });
  },
  getBulkMailingOptions: function getBulkMailingOptions() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/committees/bulk-mailing/options');
  },
  getBulkMailingSearch: function getBulkMailingSearch(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/committees/bulk-mailing/search', {
      params: params
    });
  },
  sendBulkMailing: function sendBulkMailing(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/v2/committees/bulk-mailing', data, {
      silent: true
    });
  },
  getUserNominations: function getUserNominations(draftId, userId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/committees/".concat(draftId, "/users/").concat(userId, "/nominations"));
  },
  updateNominationList: function updateNominationList(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch('/v2/committees/nominations/lists', data, {
      silent: true,
      localSuccess: true
    });
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppTooltip_vue__ = __webpack_require__(251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_baa2abf6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppTooltip_vue__ = __webpack_require__(703);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppTooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_baa2abf6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppTooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppearancesDraftsHeader_vue__ = __webpack_require__(407);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a20d342_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppearancesDraftsHeader_vue__ = __webpack_require__(1018);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppearancesDraftsHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a20d342_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppearancesDraftsHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppearancesDraftsDesktopBanner_vue__ = __webpack_require__(408);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4837e65c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppearancesDraftsDesktopBanner_vue__ = __webpack_require__(1020);
function injectStyle (ssrContext) {
  __webpack_require__(1019)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4837e65c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppearancesDraftsDesktopBanner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4837e65c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppearancesDraftsDesktopBanner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBlock;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDoc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blocks_split__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blocks_events__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blocks_secretaries__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__docs__ = __webpack_require__(718);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }





var blocks = {};
[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_0__blocks_split__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_1__blocks_events__["a" /* default */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__blocks_secretaries__["a" /* default */])).forEach(function (block) {
  blocks[block.id] = block;
});
function getBlock(id) {
  return blocks[id] || null;
}
function getDoc(id) {
  return __WEBPACK_IMPORTED_MODULE_3__docs__["a" /* default */][id] || null;
}

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Financials_vue__ = __webpack_require__(270);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08d0c0a4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Financials_vue__ = __webpack_require__(740);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Financials_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08d0c0a4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Financials_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Download_vue__ = __webpack_require__(271);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b3c8e80_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Download_vue__ = __webpack_require__(739);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Download_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b3c8e80_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Download_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__ = __webpack_require__(330);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60fac667_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__ = __webpack_require__(833);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60fac667_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeahead_vue__ = __webpack_require__(342);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a0e87de4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeahead_vue__ = __webpack_require__(861);
function injectStyle (ssrContext) {
  __webpack_require__(855)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a0e87de4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeahead_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a0e87de4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeahead_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoundTabs_vue__ = __webpack_require__(412);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81cea752_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoundTabs_vue__ = __webpack_require__(1031);
function injectStyle (ssrContext) {
  __webpack_require__(1028)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-81cea752"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoundTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81cea752_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoundTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LinkEvent_vue__ = __webpack_require__(413);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67f87fe0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LinkEvent_vue__ = __webpack_require__(1030);
function injectStyle (ssrContext) {
  __webpack_require__(1029)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67f87fe0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LinkEvent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67f87fe0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LinkEvent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageHeading_vue__ = __webpack_require__(322);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_235d9bac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageHeading_vue__ = __webpack_require__(811);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageHeading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_235d9bac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageHeading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FCheckbox_vue__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0db7b825_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FCheckbox_vue__ = __webpack_require__(713);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FCheckbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0db7b825_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FCheckbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FText_vue__ = __webpack_require__(291);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_427a8870_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FText_vue__ = __webpack_require__(770);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_427a8870_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmModal_vue__ = __webpack_require__(268);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a2b2695_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmModal_vue__ = __webpack_require__(735);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a2b2695_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDate;
/* harmony export (immutable) */ __webpack_exports__["b"] = formatDateTime;
/* harmony export (immutable) */ __webpack_exports__["c"] = formatLongDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = formatLongDateTime;
function pad(n) {
  return String(n).padStart(2, '0');
} // DD-MM-YYYY, or 'long' for "Month D, YYYY"
// Reads the date in UTC: values are calendar dates (backend serializes them as UTC midnight),
// so reading with local getters would shift the day for negative-UTC-offset timezones.


function formatDate(value, format) {
  if (!value) return '';
  var d = new Date(value);

  if (format === 'long') {
    return d.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'UTC'
    });
  }

  return "".concat(pad(d.getUTCDate()), "-").concat(pad(d.getUTCMonth() + 1), "-").concat(d.getUTCFullYear());
} // DD-MM-YYYY H:MM am/pm

function formatDateTime(value) {
  if (!value) return '';
  var d = new Date(value);
  var hours24 = d.getHours();
  var ampm = hours24 >= 12 ? 'pm' : 'am';
  var hours12 = hours24 % 12 || 12;
  return "".concat(pad(d.getDate()), "-").concat(pad(d.getMonth() + 1), "-").concat(d.getFullYear(), " ").concat(hours12, ":").concat(pad(d.getMinutes()), " ").concat(ampm);
} // Weekday DD Month YYYY

function formatLongDate(value) {
  if (!value) return '';
  var d = new Date(String(value).replace(' ', 'T'));
  return d.toLocaleDateString('en-AU', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
} // Weekday DD Month YYYY at H:MM am/pm

function formatLongDateTime(value) {
  if (!value) return '';
  var d = new Date(String(value).replace(' ', 'T'));
  var hours24 = d.getHours();
  var ampm = hours24 >= 12 ? 'pm' : 'am';
  var hours12 = hours24 % 12 || 12;
  return "".concat(formatLongDate(value), " at ").concat(hours12, ":").concat(pad(d.getMinutes()), " ").concat(ampm);
}

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useActionGate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_actionGate__ = __webpack_require__(757);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



var STORAGE_KEY = 'actionGateToken';
var GATE_REQUIRED_STATUS = 428;

function readToken() {
  var gate = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
  if (!gate || gate.expiresAt <= Date.now()) return null;
  return gate.token;
}

function storeToken(token, expiresAtSeconds) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({
    token: token,
    expiresAt: expiresAtSeconds * 1000
  }));
}

function isGateRequired(err) {
  return err.response != null && err.response.status === GATE_REQUIRED_STATUS;
}

function useActionGate() {
  var gateVisible = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var gateError = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('');
  var gateLoading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var pending = null;

  function promptForPassword(action) {
    return new Promise(function (resolve, reject) {
      pending = {
        action: action,
        resolve: resolve,
        reject: reject
      };
      gateError.value = '';
      gateVisible.value = true;
    });
  }

  function runGated(_x) {
    return _runGated.apply(this, arguments);
  }

  function _runGated() {
    _runGated = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(action) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!readToken()) {
                _context.next = 12;
                break;
              }

              _context.prev = 1;
              _context.next = 4;
              return action();

            case 4:
              return _context.abrupt("return", _context.sent);

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);

              if (isGateRequired(_context.t0)) {
                _context.next = 11;
                break;
              }

              throw _context.t0;

            case 11:
              return _context.abrupt("return", promptForPassword(action));

            case 12:
              return _context.abrupt("return", promptForPassword(action));

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7]]);
    }));
    return _runGated.apply(this, arguments);
  }

  function submitGatePassword(_x2) {
    return _submitGatePassword.apply(this, arguments);
  }

  function _submitGatePassword() {
    _submitGatePassword = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(password) {
      var _ref, data, _pending, action, resolve, reject, _data;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              gateLoading.value = true;
              gateError.value = '';
              _context2.prev = 2;
              _context2.next = 5;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_actionGate__["a" /* default */].verify(password);

            case 5:
              _ref = _context2.sent;
              data = _ref.data;
              storeToken(data.data.token, data.data.expires_at);
              gateVisible.value = false;
              _pending = pending, action = _pending.action, resolve = _pending.resolve, reject = _pending.reject;
              pending = null;
              _context2.prev = 11;
              _context2.t0 = resolve;
              _context2.next = 15;
              return action();

            case 15:
              _context2.t1 = _context2.sent;
              (0, _context2.t0)(_context2.t1);
              _context2.next = 22;
              break;

            case 19:
              _context2.prev = 19;
              _context2.t2 = _context2["catch"](11);
              reject(_context2.t2);

            case 22:
              _context2.next = 28;
              break;

            case 24:
              _context2.prev = 24;
              _context2.t3 = _context2["catch"](2);
              _data = _context2.t3.response != null ? _context2.t3.response.data : null;
              gateError.value = _data != null && _data.message != null ? _data.message : 'A server error occurred. Please try again later.';

            case 28:
              _context2.prev = 28;
              gateLoading.value = false;
              return _context2.finish(28);

            case 31:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 24, 28, 31], [11, 19]]);
    }));
    return _submitGatePassword.apply(this, arguments);
  }

  function cancelGate() {
    gateVisible.value = false;
    gateError.value = '';

    if (pending) {
      var err = new Error('Action cancelled by user.');
      err.isGateCancelled = true;
      pending.reject(err);
      pending = null;
    }
  }

  return {
    gateVisible: gateVisible,
    gateError: gateError,
    gateLoading: gateLoading,
    runGated: runGated,
    submitGatePassword: submitGatePassword,
    cancelGate: cancelGate
  };
}

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionGateModal_vue__ = __webpack_require__(286);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70ba7392_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionGateModal_vue__ = __webpack_require__(758);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionGateModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70ba7392_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActionGateModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTING_COMMITTEE_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTING_COMMITTEE_STORAGE_KEY; });
// CAM-1533 Super Secretary: the committee a Super Secretary is currently working on is sent on
// every API request in this header (API: App\Http\Middleware\Api -> ActingCommitteeService).
var ACTING_COMMITTEE_HEADER = 'X-Acting-Committee';
var ACTING_COMMITTEE_STORAGE_KEY = 'actingCommittee';

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_handleResize_js__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_getFieldLists_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NavbarTop__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ActingCommitteeBar__ = __webpack_require__(594);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_getFieldLists_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_handleResize_js__["a" /* default */]],
  components: {
    navbar: __WEBPACK_IMPORTED_MODULE_2__components_NavbarTop__["a" /* default */],
    ActingCommitteeBar: __WEBPACK_IMPORTED_MODULE_3__components_ActingCommitteeBar__["a" /* default */]
  },
  methods: {
    isIE: function isIE() {
      var userAgent = window.navigator.userAgent;
      return userAgent.indexOf('Trident') > 0;
    },
    afterEdgeRelease: function afterEdgeRelease() {
      // Only recommending Edge after its Chromium release
      var pickedDatestr = '15-Jan-2020';
      var pickedDate = new Date(Date.parse(pickedDatestr.replace(/-/g, ' ')));
      var todaysDate = this.$store.state.currentDate ? new Date(this.$store.state.currentDate) : new Date();
      return pickedDate <= todaysDate;
    }
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var FIELDLIST = {
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/current-date")).then(function (response) {
      if (response.data.status === 'success') {
        _this.$store.commit('setCurrentDate', response.data.currentDate);
      }
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/public-lists")).then(function (response) {
      if (response.data.status === 'success') {
        // eslint-disable-next-line
        // console.log(response)
        _this.$store.commit('updateCommittees', response.data.committees);

        _this.$store.commit('updateDraftStatus', response.data.draftStatus);

        _this.$store.commit('updateZones', response.data.zones);

        _this.$store.commit('updateEventTypes', response.data.eventTypes);

        _this.$store.commit('updateRiderStatus', response.data.riderStatus);

        _this.$store.commit('updateHorseStatus', response.data.horseStatus);

        _this.$store.commit('updateProducts', response.data.products);

        _this.$store.commit('updateDiscounts', response.data.discounts);

        _this.$store.commit('updateBlocks', response.data.blocks);

        _this.$store.commit('setVehiclesTypes', response.data.vehicleTypes);

        _this.$store.commit('setVehiclesSize', response.data.vehicleSizes);
      }
    }).catch(function (error) {
      // eslint-disable-next-line
      console.log(error);
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = (FIELDLIST);

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slide_toggle__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__["mixin"]],
  components: {
    VueSlideToggle: __WEBPACK_IMPORTED_MODULE_0_vue_slide_toggle__["a" /* VueSlideToggle */]
  },
  data: function data() {
    return {
      hasToken: localStorage.getItem('bearer') ? true : false,
      menuOpen: this.$store.state.menuOpen,
      userToggleOpen: this.$store.state.userToggleOpen,
      userName: "".concat(localStorage.getItem('first_name'), " ").concat(localStorage.getItem('last_name'))
    };
  },
  watch: {
    $route: function $route() {
      this.hasToken = localStorage.getItem('bearer') ? true : false;
      this.userName = "".concat(localStorage.getItem('first_name'), " ").concat(localStorage.getItem('last_name'));
      this.$store.commit('menuClose');
    },
    hasToken: function hasToken() {
      this.userName = "".concat(localStorage.getItem('first_name'), " ").concat(localStorage.getItem('last_name'));
    }
  },
  methods: {
    menuToggle: function menuToggle() {
      this.$store.commit('menuToggle');
    },
    userMenuToggle: function userMenuToggle() {
      this.$store.commit('userMenuToggle');
    },
    userMenuClose: function userMenuClose() {
      this.$store.commit('userMenuClose');
    },
    closeMenus: function closeMenus() {
      this.$store.commit('menuClose');
      this.$store.commit('userMenuClose');
    }
  },
  computed: {
    isDevelopment: function isDevelopment() {
      return "production" === 'development';
    }
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__composables_useUserRole__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_actingCommittee__ = __webpack_require__(37);
//
//
//
//
//
//
//

 // CAM-1533: shown only while a Super Secretary works on a committee other than their own.
// Sticky: sits right under the top bar and stays pinned to the top of the viewport once the top
// bar has scrolled away.

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ActingCommitteeBar',
  computed: {
    // Not reactive to localStorage — re-read on every route change via `$route`
    actingCommittee: function actingCommittee() {
      // eslint-disable-next-line no-unused-expressions
      this.$route;
      return Object(__WEBPACK_IMPORTED_MODULE_0__composables_useUserRole__["a" /* default */])().isActingForOtherCommittee ? Object(__WEBPACK_IMPORTED_MODULE_1__services_actingCommittee__["a" /* getActingCommittee */])() : null;
    }
  },
  methods: {
    // Back to the committee list, ready to pick another committee
    returnToOwnCommittee: function returnToOwnCommittee() {
      Object(__WEBPACK_IMPORTED_MODULE_1__services_actingCommittee__["b" /* setActingCommittee */])(null);
      window.location.assign('/switch-committee');
    }
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_nominations__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_horseMerge__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_publicDraws__ = __webpack_require__(602);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    nominations: __WEBPACK_IMPORTED_MODULE_2__modules_nominations__["a" /* default */],
    horseMerge: __WEBPACK_IMPORTED_MODULE_3__modules_horseMerge__["a" /* default */],
    publicDraws: __WEBPACK_IMPORTED_MODULE_4__modules_publicDraws__["a" /* default */]
  },
  state: {
    invoices: [],
    viewedMember: '',
    childMember: '',
    viewedHorse: '',
    renewMembershipTypes: [],
    selectedRows: [],
    rowsUpdated: false,
    riderStatus: [],
    horseStatus: [],
    products: [],
    discounts: [],
    blocks: [],
    menuOpen: false,
    userToggleOpen: false,
    showExpand: false,
    cartMembers: {},
    listCommittees: {},
    listZones: [],
    listEventTypes: [],
    listDraftStatus: [],
    draft: {},
    placeholder: '',
    member: null,
    listVehiclesTypes: {},
    listVehiclesSizes: []
  },
  mutations: {
    setMember: function setMember(state, newMember) {
      state.member = newMember;
    },
    setCurrentDate: function setCurrentDate(state, currentDate) {
      state.currentDate = currentDate;
    },
    updateZones: function updateZones(state, newList) {
      state.listZones = newList;
    },
    updateEventTypes: function updateEventTypes(state, newTypes) {
      state.listEventTypes = newTypes;
    },
    updatePlaceholder: function updatePlaceholder(state, newPlaceholder) {
      state.placeholder = newPlaceholder;
    },
    updateDraft: function updateDraft(state, newDraft) {
      state.draft = newDraft;
    },
    updateDraftStatus: function updateDraftStatus(state, newDraftStatus) {
      state.listDraftStatus = newDraftStatus;
    },
    updateCommittees: function updateCommittees(state, newCommittees) {
      state.listCommittees = newCommittees;
    },
    updateRiderStatus: function updateRiderStatus(state, newList) {
      state.riderStatus = newList;
    },
    updateHorseStatus: function updateHorseStatus(state, newList) {
      state.horseStatus = newList;
    },
    updateProducts: function updateProducts(state, newList) {
      state.products = newList;
    },
    updateDiscounts: function updateDiscounts(state, newList) {
      state.discounts = newList;
    },
    updateInvoices: function updateInvoices(state, data) {
      state.invoices = data;
    },
    updateViewedMember: function updateViewedMember(state, newMember) {
      state.viewedMember = newMember;
    },
    updateChildMember: function updateChildMember(state, newMember) {
      state.childMember = newMember;
    },
    updateViewedHorse: function updateViewedHorse(state, newHorse) {
      state.viewedHorse = newHorse;
    },
    updateSelectedRows: function updateSelectedRows(state, newRow) {
      if (state.selectedRows.indexOf(newRow) !== -1) {
        var index = state.selectedRows.indexOf(newRow);
        state.selectedRows.splice(index, 1);
        return;
      }

      state.selectedRows.push(newRow);
    },
    setSelectedRows: function setSelectedRows(state, theRows) {
      state.selectedRows = theRows;
    },
    deselectAllRows: function deselectAllRows(state) {
      state.selectedRows.splice(0, state.selectedRows.length);
    },
    updateRenewMembershipTypes: function updateRenewMembershipTypes(state, newRows) {
      state.renewMembershipTypes = newRows;
    },
    menuToggle: function menuToggle(state) {
      state.menuOpen = !state.menuOpen;

      if (state.menuOpen) {
        state.userToggleOpen = false;
      }
    },
    rowsUpdatedToggle: function rowsUpdatedToggle(state) {
      state.rowsUpdated = !state.rowsUpdated;
    },
    userMenuToggle: function userMenuToggle(state) {
      state.userToggleOpen = !state.userToggleOpen;

      if (state.userToggleOpen) {
        state.menuOpen = false;
      }
    },
    menuClose: function menuClose(state) {
      state.menuOpen = false;
    },
    userMenuClose: function userMenuClose(state) {
      state.userToggleOpen = false;
    },
    updateExpand: function updateExpand(state, newState) {
      state.showExpand = newState;
    },
    updateCartMembers: function updateCartMembers(state, newMembers) {
      state.cartMembers = newMembers;
    },
    updateBlocks: function updateBlocks(state, newBlocks) {
      state.blocks = newBlocks;
    },
    setVehiclesTypes: function setVehiclesTypes(state, vehiclesTypes) {
      state.listVehiclesTypes = vehiclesTypes;
    },
    setVehiclesSize: function setVehiclesSize(state, vehiclesSize) {
      state.listVehiclesSizes = vehiclesSize;
    }
  },
  getters: {
    selectedRows: function selectedRows(state) {
      return state.selectedRows;
    },
    getRowState: function getRowState(state) {
      return function (id) {
        return state.selectedRows.some(function (theRow) {
          return theRow.id === id;
        });
      };
    },
    getCommittees: function getCommittees(state) {
      var returning = {}; // eslint-disable-next-line

      if (state.listCommittees.length > 0) {
        returning = state.listCommittees.reduce(function (resultItem, currentArray) {
          resultItem[currentArray.id] = "".concat(currentArray.id, ": ").concat(currentArray.name);
          return resultItem;
        }, {});
      }

      return returning;
    },
    // eslint-disable-next-line eqeqeq
    getCommittee: function getCommittee(state) {
      return function (id) {
        return state.listCommittees.find(function (committee) {
          return committee.id == id;
        });
      };
    },
    getDraftStatus: function getDraftStatus(state) {
      return function (id) {
        return state.listDraftStatus.some(function (status) {
          return status.id === id;
        }) ? state.listDraftStatus.filter(function (status) {
          return status.id === id;
        })[0].name : '';
      };
    },
    getDraftStatusesAdmin: function getDraftStatusesAdmin(state) {
      return state.listDraftStatus.map(function (status) {
        var tempStatus = status;
        tempStatus.nameAdmin = tempStatus.name === 'Pending' ? 'Pending (Hidden)' : tempStatus.name === 'Published' ? 'Published (Visible)' : tempStatus.name;
        return status;
      });
    },
    getMember: function getMember(state) {
      return state.member;
    },
    getCartMembers: function getCartMembers(state) {
      return state.cartMembers;
    }
  }
}));

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_actingCommittee__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_logo__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_logoWhite__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_slide_toggle__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Modal__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* global grecaptcha */

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['newStatus'],
  name: 'Login',
  components: {
    logo: __WEBPACK_IMPORTED_MODULE_2__assets_logo__["a" /* default */],
    'logo-white': __WEBPACK_IMPORTED_MODULE_3__assets_logoWhite__["a" /* default */],
    VueSlideToggle: __WEBPACK_IMPORTED_MODULE_5_vue_slide_toggle__["a" /* VueSlideToggle */],
    modal: __WEBPACK_IMPORTED_MODULE_6__components_Modal__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__["a" /* default */]],
  data: function data() {
    return {
      email: this.$route.query.email,
      forgot: false,
      status: this.newStatus || '',
      message: '',
      showRegisterModal: false,
      processing: [false, false],
      showCaptcha: "production" === 'production' || "production" === 'staging',
      captchaReady: false,
      captchaWidgetId: null,
      maintenance: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get("".concat(this.$api, "/v2/maintenance-status")).then(function (response) {
      _this.maintenance = !!response.data.data.maintenance;
    }).catch(function () {}); // When you navigate to the login page.
    // If logged in, invalidate the auth token.

    if (localStorage.getItem('bearer')) {
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post("".concat(this.$api, "/auth/logout"));
      delete __WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.headers.common.Authorization;
    } // Remove all "session" items.


    localStorage.clear(); // Reset Vuex if you were just logged in

    this.$store.commit('updateChildMember', '');
    this.$store.commit('updateViewedMember', '');

    if (this.showCaptcha) {
      var checkReady = setInterval(function () {
        if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.render === 'function') {
          _this.captchaWidgetId = grecaptcha.render(_this.$refs.recaptcha, {
            sitekey: _this.$captchaSiteKey
          });
          _this.captchaReady = true;
          clearInterval(checkReady);
        }
      }, 100);
    }
  },
  methods: {
    login: function login(event) {
      var _this2 = this;

      event.preventDefault();

      if (!this.email || !this.password) {
        return;
      }

      var token = this.showCaptcha && typeof grecaptcha !== 'undefined' && typeof grecaptcha.getResponse === 'function' ? grecaptcha.getResponse(this.captchaWidgetId) : null;

      if (this.showCaptcha && !token) {
        this.status = 'invalid_captcha';
        this.message = 'Please complete the reCAPTCHA.';
        return;
      }

      this.processing.splice(0, 1, true);
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post("".concat(this.$api, "/auth/login"), {
        email: this.email,
        password: this.password.password,
        recaptcha: token
      }).then(function (response) {
        _this2.processing.splice(0, 1, false); // If we had an auth token in response


        if (response.data.token) {
          // eslint-disable-next-line
          // console.log(response.data)
          localStorage.setItem('bearer', response.data.token); // Attach the token as future headers.

          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.headers.common.Authorization = "Bearer ".concat(response.data.token);
          localStorage.setItem('first_name', response.data.first_name);
          localStorage.setItem('last_name', response.data.last_name);
          localStorage.setItem('role', response.data.role);
          localStorage.setItem('userID', response.data.id);
          localStorage.setItem('is_onboarded', response.data.is_onboarded);
          Object(__WEBPACK_IMPORTED_MODULE_0__services_actingCommittee__["c" /* storeSuperSecretaryFlags */])(response.data, {
            resetSelection: true
          }); // Redirect them to the dashboard

          if (response.data.is_onboarded) {
            _this2.$router.push({
              name: 'Dashboard'
            });
          } else {
            localStorage.setItem('userDetails', JSON.stringify(response.data.userDetails));

            _this2.$router.push({
              name: 'Login Once',
              params: {
                userDetails: response.data.userDetails
              }
            });
          } // Handle errors and display approptiate messages

        } else {
          if (_this2.showCaptcha) {
            grecaptcha.reset(_this2.captchaWidgetId);
          }

          if (response.data.status === 'maintenance') {
            _this2.maintenance = true;
          }

          _this2.status = response.data.status;
          _this2.message = response.data.message;
        }
      }).catch(function (error) {
        _this2.processing.splice(0, 1, false);

        _this2.status = 'undefined_error'; // eslint-disable-next-line

        console.log(error);
      });
    },
    recoverPassword: function recoverPassword() {
      var _this3 = this;

      if (!this.email) {
        return;
      }

      this.processing.splice(1, 1, true);
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post("".concat(this.$api, "/auth/forgot"), {
        email: this.email
      }).then(function (response) {
        _this3.processing.splice(1, 1, false);

        _this3.status = response.data.status;
      }).catch(function (error) {
        _this3.processing.splice(1, 1, false);

        _this3.status = 'undefined_error'; // eslint-disable-next-line

        console.log(error);
      });
    },
    registerModal: function registerModal() {
      this.showRegisterModal = true;
    }
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Modal',
  props: {
    bodyClass: {
      type: [String, Array, Object],
      default: null
    },
    contentClass: {
      type: [String, Array, Object],
      default: null
    },
    size: {
      type: String,
      default: null
    }
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Maintenance'
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoginOnceNav__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LoginOnceWelcome__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LoginOnce1__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LoginOnce2__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LoginOnce4__ = __webpack_require__(631);
//
//
//
//
//
//
//
//
//
//
//
//



 // import page3 from './LoginOnce3'


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['userDetails'],
  name: 'LoginOnce',
  components: {
    navbar: __WEBPACK_IMPORTED_MODULE_0__LoginOnceNav__["a" /* default */],
    welcome: __WEBPACK_IMPORTED_MODULE_1__LoginOnceWelcome__["a" /* default */],
    page1: __WEBPACK_IMPORTED_MODULE_2__LoginOnce1__["a" /* default */],
    page2: __WEBPACK_IMPORTED_MODULE_3__LoginOnce2__["a" /* default */],
    // page3,
    page4: __WEBPACK_IMPORTED_MODULE_4__LoginOnce4__["a" /* default */]
  },
  data: function data() {
    return {
      success: false,
      errors: '',
      errorStatus: '',
      responseStatus: '',
      page: 0,
      maxPage: 0,
      user: this.userDetails
    };
  },
  mounted: function mounted() {
    if (this.userDetails === undefined) {
      if (localStorage.userDetails) {
        this.user = JSON.parse(localStorage.userDetails);
      } else {
        this.$router.push('/login');
      }
    }
  },
  watch: {
    page: function page() {
      this.maxPage = Math.max(this.page, this.maxPage);
    }
  }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['page', 'maxPage'],
  methods: {
    goToPage: function goToPage(pageNumber) {
      this.$emit('proceed', pageNumber);
    }
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['name']
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_legacyBrowsers_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormFields_PhoneInput__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TestPhoneNumbers__ = __webpack_require__(68);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TestPhoneNumbers: __WEBPACK_IMPORTED_MODULE_4__components_TestPhoneNumbers__["a" /* default */],
    PhoneInput: __WEBPACK_IMPORTED_MODULE_3__components_FormFields_PhoneInput__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_legacyBrowsers_js__["a" /* default */]],
  props: ['user'],
  data: function data() {
    return {
      userInfo: this.user,
      processing: false,
      errors: '',
      errorStatus: '',
      dateOfBirth: ''
    };
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },
  watch: {
    userInfo: {
      deep: true,
      immediate: true,
      handler: function handler() {
        if (this.userInfo.dob) {
          this.dateOfBirth = this.userInfo.dob;
        }
      }
    }
  },
  methods: {
    confirm: function confirm() {
      var _this = this;

      setTimeout(function () {
        if (_this.formComplete) {
          _this.saveData();
        }
      }, 10);
    },
    saveData: function saveData() {
      var _this2 = this;

      this.processing = true;
      var member = {
        id: this.userInfo.id,
        title: this.userInfo.title,
        first_name: this.userInfo.first_name,
        last_name: this.userInfo.last_name,
        dob: this.userInfo.dob,
        gender: this.userInfo.gender,
        street_1: this.userInfo.attributes.address.street_1,
        street_2: this.userInfo.attributes.address.street_2,
        suburb: this.userInfo.attributes.address.suburb,
        postcode: this.userInfo.attributes.address.postcode,
        state: this.userInfo.attributes.address.state,
        mobile_phone: this.userInfo.attributes.mobile_phone,
        password: this.password.password,
        password_confirmation: this.password.confirmPassword
      };

      if (this.isUnder18) {
        member.guardian_consent = true;
        member.guardian_first_name = this.userInfo.guardian_first_name;
        member.guardian_last_name = this.userInfo.guardian_last_name;
        member.guardian_phone = this.userInfo.guardian_phone;
        member.guardian_email = this.userInfo.guardian_email;
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/onboarding/primary"), member).then(function (response) {
        _this2.processing = false; // eslint-disable-next-line

        console.log(response);

        if (response.data.status === 'success') {
          // Done
          _this2.$emit('proceed');

          _this2.errors = '';
          _this2.errorStatus = '';
        } else if (response.data.status === 'validation_error' && response.data.errors.dob) {
          // DoB
          _this2.success = '';
          _this2.errorStatus = 'validation_error';
          _this2.errors = "Please include your Date of Birth in the format".concat(_this2.isLegacy() ? ' yyyy-mm-dd' : ' dd/mm/yyyy', ".");
        } else {
          // Error
          _this2.success = '';
          _this2.errors = 'Please ensure all fields are completed.';
        }
      }).catch(function (error) {
        _this2.processing = false;
        _this2.success = '';
        _this2.errors = 'There was a server error. Please try again later.';
        _this2.errorStatus = ''; // eslint-disable-next-line

        console.log(error);
      });
    }
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_phone__ = __webpack_require__(623);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
 // Bare masked <input> for Australian mobiles ("+61 ___ ___ ___"): the prefix is fixed, the user
// types only the 9 national digits. Other attributes (id, class, required, disabled) fall through
// to the input, so it drops into legacy markup that owns its own label/tooltip.
// Non-AU values (legacy "+7…") are shown and edited as plain text so they are never mangled.

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PhoneInput',
  props: {
    value: {
      default: ''
    }
  },
  data: function data() {
    return {
      maskLength: __WEBPACK_IMPORTED_MODULE_0__utils_phone__["a" /* PHONE_MASK_LENGTH */]
    };
  },
  computed: {
    foreign: function foreign() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils_phone__["e" /* isForeignPhone */])(this.value);
    },
    display: function display() {
      return this.foreign ? this.value : Object(__WEBPACK_IMPORTED_MODULE_0__utils_phone__["c" /* applyMask */])(Object(__WEBPACK_IMPORTED_MODULE_0__utils_phone__["f" /* nationalDigits */])(this.value));
    }
  },
  methods: {
    onInput: function onInput(event) {
      var el = event.target;

      if (this.foreign) {
        // Unmasked legacy number: still only "+", digits and spaces — no letters or other symbols
        var clean = el.value.replace(/[^\d+ ]/g, '');
        if (clean !== el.value) el.value = clean;
        this.$emit('input', clean);
        return;
      }

      var caret = el.selectionStart;
      var digitsBeforeCaret = Object(__WEBPACK_IMPORTED_MODULE_0__utils_phone__["f" /* nationalDigits */])(el.value.slice(0, caret == null ? el.value.length : caret)).length;
      this.apply(el, Object(__WEBPACK_IMPORTED_MODULE_0__utils_phone__["f" /* nationalDigits */])(el.value), digitsBeforeCaret);
    },
    onPaste: function onPaste(event) {
      if (this.foreign) return;
      var pasted = (event.clipboardData || window.clipboardData).getData('text');
      var digits = Object(__WEBPACK_IMPORTED_MODULE_0__utils_phone__["f" /* nationalDigits */])(pasted); // A whole number (any common shape) replaces the value; short fragments are inserted natively

      if (digits.length >= 9) {
        event.preventDefault();
        this.apply(event.target, digits, digits.length);
      }
    },
    apply: function apply(el, digits, caretDigits) {
      var masked = Object(__WEBPACK_IMPORTED_MODULE_0__utils_phone__["c" /* applyMask */])(digits);
      el.value = masked;
      var pos = Object(__WEBPACK_IMPORTED_MODULE_0__utils_phone__["d" /* caretAfterDigits */])(Math.min(caretDigits, digits.length));
      el.setSelectionRange(pos, pos);
      this.$emit('input', Object(__WEBPACK_IMPORTED_MODULE_0__utils_phone__["g" /* toModel */])(digits));
    },
    keepCaretAfterPrefix: function keepCaretAfterPrefix(event) {
      if (this.foreign) return;
      var el = event.target; // Defer: the browser places the caret after focus/click handlers run

      setTimeout(function () {
        if (el.selectionStart < __WEBPACK_IMPORTED_MODULE_0__utils_phone__["b" /* PHONE_PREFIX */].length && el.selectionEnd < __WEBPACK_IMPORTED_MODULE_0__utils_phone__["b" /* PHONE_PREFIX */].length) {
          el.setSelectionRange(__WEBPACK_IMPORTED_MODULE_0__utils_phone__["b" /* PHONE_PREFIX */].length, __WEBPACK_IMPORTED_MODULE_0__utils_phone__["b" /* PHONE_PREFIX */].length);
        }
      }, 0);
    },
    onKeydown: function onKeydown(event) {
      if (this.foreign) return;
      var el = event.target;
      var atPrefix = el.selectionStart === el.selectionEnd && el.selectionStart <= __WEBPACK_IMPORTED_MODULE_0__utils_phone__["b" /* PHONE_PREFIX */].length;
      if (event.key === 'Backspace' && atPrefix) event.preventDefault();
    }
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TEST_PHONE_NUMBERS */
//
//
//
//
//
//
//
// Numbers ACMA reserved for film/TV (0491 570 xxx): they are valid mobiles for our validation but
// are never assigned to a real subscriber. Shown only outside production so a tester never types a real number.
var TEST_PHONE_NUMBERS = ['+61 491 570 006', '+61 491 570 156', '+61 491 570 157'];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TestPhoneNumbers',
  data: function data() {
    return {
      numbers: TEST_PHONE_NUMBERS
    };
  },
  computed: {
    visible: function visible() {
      return "production" !== 'production';
    }
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slide_toggle__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_legacyBrowsers_js__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_formValidation_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_legacyBrowsers_js__["a" /* default */]],
  components: {
    VueSlideToggle: __WEBPACK_IMPORTED_MODULE_1_vue_slide_toggle__["a" /* VueSlideToggle */]
  },
  props: ['user'],
  data: function data() {
    return {
      userInfo: this.user.secondaries ? this.user.secondaries : [],
      fieldsValidity: [],
      selectedSection: 0,
      processing: false,
      processing2: false,
      success: '',
      errors: '',
      errorStatus: '',
      dateOfBirth: ''
    };
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },
  watch: {
    userInfo: {
      deep: true,
      handler: function handler() {}
    }
  },
  methods: {
    checkFieldsValidity: function checkFieldsValidity(index) {
      var tempFieldValidity = this.$refs["title".concat(index)][0].checkValidity();
      tempFieldValidity = this.$refs["firstName".concat(index)][0].checkValidity() ? tempFieldValidity : false;
      tempFieldValidity = this.$refs["lastName".concat(index)][0].checkValidity() ? tempFieldValidity : false;
      tempFieldValidity = this.$refs["dob".concat(index)][0].checkValidity() ? tempFieldValidity : false;
      tempFieldValidity = this.$refs["gender".concat(index)][0].checkValidity() ? tempFieldValidity : false;
      this.fieldsValidity.splice(index, 1, tempFieldValidity);
    },
    updateValidity: function updateValidity(index) {
      if (index in this.fieldsValidity) {
        this.checkFieldsValidity(index);
      }
    },
    checkDoB: function checkDoB(index) {
      this.dateOfBirth = this.userInfo[index].dob;
    },
    confirm: function confirm(isComplete) {
      var _this = this;

      this.success = '';
      setTimeout(function () {
        if (_this.formComplete) {
          if (_this.userInfo.length > 0) {
            _this.saveData(isComplete);
          } else {
            _this.$emit('proceed');
          }
        } else {
          _this.userInfo.forEach(function (user, index) {
            _this.checkFieldsValidity(index);
          });
        }
      }, 10);
    },
    saveData: function saveData(isComplete) {
      var _this2 = this;

      if (isComplete) {
        this.processing = true;
      } else {
        this.processing2 = true;
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/onboarding/secondaries-").concat(isComplete ? 'complete' : 'incomplete'), {
        secondaries: this.userInfo
      }).then(function (response) {
        if (isComplete) {
          _this2.processing = false;
        } else {
          _this2.processing2 = false;

          _this2.$router.push('/login');
        } // eslint-disable-next-line


        console.log(response);

        if (response.data.status === 'success') {
          // Done
          _this2.errors = '';
          _this2.errorStatus = '';

          if (isComplete) {
            _this2.$emit('proceed');
          } else {
            _this2.success = 'Your data has been saved.';
          }
        } else if (response.data.status === 'validation_error' && response.data.errors.dob) {
          // DoB
          _this2.success = '';
          _this2.errorStatus = 'validation_error';
          _this2.errors = "Please include your Date of Birth in the format".concat(_this2.isLegacy() ? ' yyyy-mm-dd' : ' dd/mm/yyyy', ".");
        } else {
          // Error
          _this2.success = '';
          _this2.errors = 'Please ensure all fields are completed.';
        }
      }).catch(function (error) {
        if (isComplete) {
          _this2.processing = false;
        } else {
          _this2.processing2 = false;
        }

        _this2.success = '';
        _this2.errors = 'There was a server error. Please try again later.';
        _this2.errorStatus = ''; // eslint-disable-next-line

        console.log(error);
      });
    }
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  data: function data() {
    return {
      userInfo: this.user,
      secondaryInfo: this.user.secondaries ? this.user.secondaries : [],
      horseInfo: this.user.horses ? this.user.horses : [],
      processing: false
    };
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    getAddress: function getAddress(theUserAddress) {
      var tempAddress = theUserAddress.street_1;
      tempAddress = theUserAddress.street_2 ? "".concat(tempAddress, " ").concat(theUserAddress.street_2) : tempAddress;
      tempAddress = theUserAddress.suburb ? "".concat(tempAddress, ", ").concat(theUserAddress.suburb) : tempAddress;
      tempAddress = theUserAddress.postcode ? "".concat(tempAddress, ", ").concat(theUserAddress.postcode) : tempAddress;
      tempAddress = theUserAddress.state ? "".concat(tempAddress, ", ").concat(theUserAddress.state) : tempAddress;
      return tempAddress;
    },
    saveData: function saveData() {
      var _this = this;

      this.processing = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/onboarding/complete")).then(function (response) {
        _this.processing = false; // eslint-disable-next-line
        // console.log(response)

        if (response.data.status === 'success') {
          // Done
          localStorage.setItem('is_onboarded', true);

          _this.$router.push('/');
        }
      }).catch(function (error) {
        _this.processing = false; // eslint-disable-next-line

        console.log(error);
      });
    },
    editPage: function editPage(page) {
      this.$emit('proceed', page);
    }
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DashboardStat__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DashboardBlock__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DashboardNew__ = __webpack_require__(649);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Dashboard',
  props: {
    status: String
  },
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__["a" /* default */],
    'dashboard-stat': __WEBPACK_IMPORTED_MODULE_2__DashboardStat__["a" /* default */],
    'dashboard-block': __WEBPACK_IMPORTED_MODULE_3__DashboardBlock__["a" /* default */],
    'dashboard-new': __WEBPACK_IMPORTED_MODULE_4__DashboardNew__["a" /* default */]
  },
  data: function data() {
    return {
      user: '',
      stats: [],
      blocks: []
    };
  },
  computed: {
    blocksCount: function blocksCount() {
      return this.$store.state.blocks.length;
    }
  },
  watch: {
    blocksCount: function blocksCount() {
      this.blocks = _toConsumableArray(this.$store.state.blocks);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.user = localStorage.getItem('first_name') === 'undefined' ? '' : localStorage.getItem('first_name');

    if (this.blocksCount > 0) {
      this.blocks = _toConsumableArray(this.$store.state.blocks);
    }

    if (this.$isAdmin) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/summary")).then(function (response) {
        if (response.data.status === 'success') {
          _this.stats.push({
            name: 'New Registrations',
            value: response.data.newHorses,
            class: 'horses'
          });

          _this.stats.push({
            name: 'New Members',
            value: response.data.newUsers,
            class: 'members'
          });

          _this.stats.push({
            name: 'Payments Made',
            value: response.data.completedPayments,
            class: 'payments'
          });

          _this.stats.push({
            name: 'Payments To Action',
            value: response.data.pendingInvoices,
            class: 'invoices',
            link: 'Payments'
          });

          _this.stats.push({
            name: 'Pending Horse Updates',
            value: response.data.pendingHorseUpdates,
            class: 'horses',
            link: 'Horse Updates'
          });
        }
      });
    }
  },
  methods: {
    blocksEdited: function blocksEdited() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/current-date")).then(function (response) {
        if (response.data.status === 'success') {
          _this2.$store.commit('setCurrentDate', response.data.currentDate);
        }
      }).catch(function (error) {
        console.log(error);
      });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/public-lists")).then(function (response) {
        if (response.data.status === 'success') {
          _this2.$store.commit('updateZones', response.data.zones);

          _this2.$store.commit('updateRiderStatus', response.data.riderStatus);

          _this2.$store.commit('updateHorseStatus', response.data.horseStatus);

          _this2.$store.commit('updateProducts', response.data.products);

          _this2.$store.commit('updateDiscounts', response.data.discounts);

          _this2.$store.commit('updateBlocks', response.data.blocks);

          if (_this2.blocksCount > 0) {
            _this2.blocks = _toConsumableArray(_this2.$store.state.blocks);
          }
        }
      }).catch(function (error) {
        // eslint-disable-next-line
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_NavbarSide__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Breadcrumb__ = __webpack_require__(220);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This is a consistent layout that should be used for listing pages.
 * Content will be added to the "slot" tags above automagically when
 * this component is added */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Listing-Layout',
  props: {
    noSmPadding: {
      type: Boolean,
      default: false
    }
  },
  components: {
    navbar: __WEBPACK_IMPORTED_MODULE_0__components_NavbarSide__["a" /* default */],
    breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components_Breadcrumb__["a" /* default */]
  }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavbarSide_vue__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73ab9eec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavbarSide_vue__ = __webpack_require__(638);
function injectStyle (ssrContext) {
  __webpack_require__(637)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73ab9eec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavbarSide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73ab9eec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavbarSide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slide_toggle__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__composables_useUserRole__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_actingCommittee__ = __webpack_require__(37);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VueSlideToggle: __WEBPACK_IMPORTED_MODULE_0_vue_slide_toggle__["a" /* VueSlideToggle */]
  },
  data: function data() {
    return {
      navItemList: [],
      loggedInUser: localStorage.role,
      menuCollapsed: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (!localStorage.bearer) {
      this.getList();
      return;
    }

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("".concat(this.$api, "/auth/me")).then(function (response) {
      if (response.data.status === 'acting_committee_invalid') {
        // The committee being worked on is no longer available (e.g. stopped being financial)
        Object(__WEBPACK_IMPORTED_MODULE_3__services_actingCommittee__["b" /* setActingCommittee */])(null);
        window.location.assign('/');
        return;
      }

      if (response.data.status === 'maintenance') {
        localStorage.clear();

        _this.$router.push('/login');

        return;
      }

      if (response.data.role && response.data.role !== localStorage.role) {
        localStorage.setItem('role', response.data.role);
      }

      Object(__WEBPACK_IMPORTED_MODULE_3__services_actingCommittee__["c" /* storeSuperSecretaryFlags */])(response.data);

      _this.getList();
    }).catch(function () {
      _this.getList();
    });
  },
  methods: {
    getList: function getList() {
      this.loggedInUser = localStorage.role;

      var _useUserRole = Object(__WEBPACK_IMPORTED_MODULE_2__composables_useUserRole__["a" /* default */])(),
          isSuperSecretary = _useUserRole.isSuperSecretary;

      this.navItemList = this.$router.options.routes.filter(function (route) {
        return route.meta.showInNavar && !(route.meta.requiresSuperSecretary && !isSuperSecretary) && (route.meta.requiresAuth === localStorage.role || !route.meta.requiresAuth || route.meta.requiresAuth.includes(localStorage.role));
      });
    },
    navPath: function navPath(path) {
      // Route definitions can carry a dynamic segment (e.g. "/committees/dashboard/:draftId?")
      // that Vue Router does not resolve when passed straight through as `to` on a nav link —
      // it navigates to the literal ":draftId" path segment instead. Strip it so nav links
      // always go to the base path.
      return path.split('/:')[0];
    },
    isActive: function isActive(navItem) {
      // Compare route patterns rather than resolved paths, since navItem.path can carry
      // an optional dynamic segment (e.g. "/committees/dashboard/:draftId?") that never
      // equals the resolved "/committees/dashboard/1803" via strict string equality.
      var navItemBase = navItem.path.split('/:')[0];
      var matchedRoute = this.$route.matched[this.$route.matched.length - 1];
      var currentBase = (matchedRoute ? matchedRoute.path : this.$route.path).split('/:')[0];
      if (currentBase === navItemBase) return true; // Child pages (e.g. Draft View/Edit) reference their parent nav item via
      // breadcrumb.link ("committees/dashboard") — match on that so the parent
      // nav link stays highlighted while browsing those child routes.

      var breadcrumb = this.$route.meta && this.$route.meta.breadcrumb;
      return !!breadcrumb && breadcrumb.some(function (item) {
        return item.link && "/".concat(item.link) === navItemBase;
      });
    },
    getChildren: function getChildren(currentItem) {
      // eslint-disable-next-line
      var foundItems = this.navItemList.filter(function (navItem) {
        return navItem.meta.childOf === currentItem.name;
      });
      return foundItems === undefined ? false : foundItems;
    },
    slugify: function slugify(text) {
      return text.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    },
    getChildrenDisplayName: function getChildrenDisplayName(currentItem, index) {
      var children = this.getChildren(currentItem)[index];
      return children.displayName ? children.displayName : children.name;
    }
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8e3766e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(639);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8e3766e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Breadcrumb',
  data: function data() {
    return {
      breadcrumbList: []
    };
  },
  mounted: function mounted() {
    this.updateList();
    this.$root.$on('update-breadcrumb', this.updateBreadcrumb);
  },
  watch: {
    /* This watches the routes and updates the breadcrumb list accordingly, but eslint hates it. */
    // eslint-disable-next-line
    '$route': function $route() {
      this.updateList();
    },

    /* Placeholder can arrive after mount (e.g. draft name fetched async on a direct/refreshed page load) */
    // eslint-disable-next-line
    '$store.state.placeholder': function $storeStatePlaceholder() {
      this.updateList();
    }
  },
  methods: {
    /* Getting breadcrumb list after switching out 'Placeholder' and 'Create'/'Add' text if necessary */
    updateList: function updateList() {
      var _this = this;

      this.$nextTick(function () {
        var theUpdateList = _toConsumableArray(_this.$route.meta.breadcrumb);

        var placeholderPosition = _this.$route.meta.breadcrumb.findIndex(function (bread) {
          return bread.name === 'Placeholder';
        });

        var editPosition = _this.$route.meta.breadcrumb.findIndex(function (bread) {
          return bread.name.includes('Create') || bread.name.includes('Add');
        });

        var membersPosition = _this.$route.meta.breadcrumb.findIndex(function (bread) {
          return bread.name.includes('Members');
        });
        /* If route breadcrumb has 'Placeholder' in it and there's associated data to fill it */


        if (placeholderPosition !== -1 && (_this.$route.params.placeholder || _this.$store.state.placeholder)) {
          theUpdateList[placeholderPosition] = Object.assign({}, theUpdateList[placeholderPosition], {
            name: _this.$route.params.placeholder || _this.$store.state.placeholder
          });
        }

        if (membersPosition !== -1 && _this.$isAdmin) {
          theUpdateList[membersPosition] = Object.assign({}, theUpdateList[membersPosition], {
            name: 'Members',
            link: 'admin-members'
          });
        }
        /* If route breadcrumb has 'Create' or 'Add' in it and there's an 'edit' prop */


        if (editPosition !== -1 && _this.$route.params.edit) {
          theUpdateList[editPosition] = Object.assign({}, theUpdateList[editPosition], {
            name: theUpdateList[editPosition].name.replace('Create', 'Edit').replace('Add', 'Edit')
          });
        }

        _this.breadcrumbList = theUpdateList;
      });
    },
    breadPath: function breadPath(breadItem) {
      /* Get slug (can be expanded to other params later) if told to by router - couldn't find a way to get this in the router file */
      var output = '';

      if (breadItem.routeName) {
        output = {
          name: breadItem.routeName,
          params: {
            draftId: this.$route.params.draftId
          }
        };
      } else if (breadItem.params) {
        output = {
          name: breadItem.name,
          params: {
            slug: this.$route.params.slug
          }
        };
      } else {
        output = "/".concat(breadItem.link);
      }

      return output;
    },
    updateBreadcrumb: function updateBreadcrumb(updated) {
      var idx = this.breadcrumbList.findIndex(function (b) {
        return b.name === updated.name;
      });

      if (idx !== -1) {
        this.$set(this.breadcrumbList, idx, _objectSpread({}, this.breadcrumbList[idx], {
          link: updated.link,
          name: updated.name
        }));
      }
    }
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DashboardStat',
  props: ['stat', 'isEven']
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DashboardForm__ = __webpack_require__(224);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DashboardBlock',
  components: {
    modal: __WEBPACK_IMPORTED_MODULE_1__components_Modal__["a" /* default */],
    'dashboard-form': __WEBPACK_IMPORTED_MODULE_2__DashboardForm__["a" /* default */]
  },
  props: ['block'],
  data: function data() {
    return {
      showModalEdit: false,
      showModalDelete: false,
      loggedInUser: localStorage.role,
      processing: false
    };
  },
  computed: {
    getBackgroundImage: function getBackgroundImage() {
      return {
        backgroundImage: "url(".concat(this.block.image, ")"),
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      };
    }
  },
  methods: {
    editBlock: function editBlock(updatedBlock) {
      this.$emit('editBlock', updatedBlock);
      this.showModalEdit = false;
    },
    removeBlock: function removeBlock(id) {
      var _this = this;

      this.processing = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/block-delete/").concat(id)).then(function (response) {
        if (response.data.status === 'success') {
          _this.processing = false;
          _this.showModalDelete = false;

          _this.$emit('blockRemoved');
        }
      });
    }
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardForm_vue__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb07c114_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardForm_vue__ = __webpack_require__(647);
function injectStyle (ssrContext) {
  __webpack_require__(646)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cb07c114"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb07c114_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DashboardForm',
  props: ['existingBlock'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__["a" /* default */]],
  data: function data() {
    return {
      newBlock: this.existingBlock ? this.existingBlock : {
        image: '',
        style: 'A'
      },
      fileName: '',
      processing: false
    };
  },
  mounted: function mounted() {
    if (this.newBlock.image !== '') {
      this.fileName = this.newBlock.image;
      this.newBlock.link = this.newBlock.link.replace('https://', '');
    }
  },
  methods: {
    submitBlock: function submitBlock() {
      var _this = this;

      setTimeout(function () {
        if (_this.formComplete) {
          var sendBlock = _this.newBlock;

          if (sendBlock.link) {
            sendBlock.link = sendBlock.link.replace('https://', '');
            sendBlock.link = sendBlock.link.replace('http://', '');
            sendBlock.link = sendBlock.link.replace('://', '');
            sendBlock.link = sendBlock.link.replace('//', '');
            sendBlock.link = sendBlock.link.replace(/^/, 'https://');
          }

          var formData = new FormData();
          formData.append('file', _this.newBlock.file);
          formData.append('fields', JSON.stringify(sendBlock));
          _this.processing = true;
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(_this.$api, "/admin/block-create"), formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function () {
            // eslint-disable-next-line
            // console.log(response)
            _this.processing = false;

            _this.$emit('submitBlock', _this.newBlock);
          }).catch(function (error) {
            // eslint-disable-next-line
            console.log(error);
            _this.processing = false;
          });
        }
      }, 10);
    },
    fileUpload: function fileUpload(event) {
      var uploadedFile = event.target.files[0];
      this.newBlock.file = uploadedFile;
      this.newBlock.image = URL.createObjectURL(uploadedFile);
      this.fileName = uploadedFile.name;
    }
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DashboardForm__ = __webpack_require__(224);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DashboardNew',
  components: {
    modal: __WEBPACK_IMPORTED_MODULE_0__components_Modal__["a" /* default */],
    'dashboard-form': __WEBPACK_IMPORTED_MODULE_1__DashboardForm__["a" /* default */]
  },
  data: function data() {
    return {
      showModal: false,
      newBlock: {
        image: null
      }
    };
  },
  methods: {
    addBlock: function addBlock() {
      this.$emit('addBlock', this.newBlock);
      this.newBlock = {
        image: null
      };
      this.showModal = false;
    }
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminUsers',
  props: ['success'],
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__["a" /* default */],
    'data-table': __WEBPACK_IMPORTED_MODULE_2__components_DataTable__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
  },
  data: function data() {
    return {
      error: '',
      rows: [],
      columns: [{
        label: 'First Name',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.first_name\" :link=\"'Admin Profile'\" :row=\"row\" :options=\"{ showLinks: true }\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.first_name);
        }
      }, {
        label: 'Last Name',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.last_name\" :link=\"'Admin Profile'\" :row=\"row\" :options=\"{ showLinks: true }\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.last_name);
        }
      }, {
        label: 'Phone',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.attributes?.phone\" :row=\"row\" />"
        }
      }],
      options: {
        search: true,
        addAdmin: this.$isAdmin
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/admin-list")).then(function (response) {
      if (response.data.status === 'success') {
        _this.error = '';
        _this.rows = response.data.data;
      } else {
        _this.error = 'Unable to receive data from the server. Please reload the page.';
      }
    });
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_EventBus_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datatable__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Filter__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_AdvancedFilter__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DataTableFields_Search__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DataTableFields_ShowEntries__ = __webpack_require__(665);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuejs_datatable__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dataRows: Array,
    dataColumns: Array,
    options: Object,
    // Optional (filterKey, value) => boolean|Promise<boolean> - return false to block the tab switch
    filterGuard: {
      type: Function,
      default: null
    }
  },
  components: {
    rowsFilter: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Filter__["a" /* default */],
    advancedFilter: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_AdvancedFilter__["a" /* default */],
    search: __WEBPACK_IMPORTED_MODULE_5__components_DataTableFields_Search__["a" /* default */],
    'show-entries': __WEBPACK_IMPORTED_MODULE_6__components_DataTableFields_ShowEntries__["a" /* default */]
  },
  model: {
    prop: 'page',
    event: 'change'
  },
  methods: {
    expand: function expand(id) {
      if (this.expanded === id) {
        this.expanded = null;
        return;
      }

      this.expanded = id;
    },
    setActiveFilter: function setActiveFilter(updatedFilter) {
      var _this = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = _this.filterGuard;

                if (!_context.t0) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return _this.filterGuard(updatedFilter.filterKey, updatedFilter.filterChosen);

              case 4:
                _context.t0 = !_context.sent;

              case 5:
                if (!_context.t0) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                _this.activeFilter[updatedFilter.filterKey] = updatedFilter.filterChosen;

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    colorTableFields: function colorTableFields() {
      var _this2 = this;

      var tables = document.querySelectorAll('tbody');
      tables.forEach(function (table) {
        var cellsHtmlCollection = table.getElementsByTagName('tr');

        var cells = _this2.htmlCollectionToArray(cellsHtmlCollection);

        cells.forEach(function (cell) {
          var _cell$querySelector, _cell$querySelector$d;

          var parity = (_cell$querySelector = cell.querySelector('.js-parity')) === null || _cell$querySelector === void 0 ? void 0 : (_cell$querySelector$d = _cell$querySelector.dataset) === null || _cell$querySelector$d === void 0 ? void 0 : _cell$querySelector$d.parity;

          if (!parity) {
            return;
          }

          if (parity === 'even') {
            cell.classList.remove('row-even');
            cell.classList.add('row-odd');
          } else {
            cell.classList.remove('row-odd');
            cell.classList.add('row-even');
          }
        });
      });
    },
    htmlCollectionToArray: function htmlCollectionToArray(htmlCollection) {
      var array = [];

      for (var i = 0; i < htmlCollection.length; i++) {
        array.push(htmlCollection[i]);
      }

      return array;
    }
  },
  data: function data() {
    var _this3 = this;

    return {
      search: '',
      activeFilter: this.options.activeFilter,
      filtering: this.options.activeFilter ? !Object.keys(this.options.activeFilter).every(function (filter) {
        return _this3.options.activeFilter[filter] === 'all';
      }) : false,
      advancedFilterOpen: false,
      columns: this.dataColumns,
      page: 1,
      per_page: 20,
      selected_rows: [],
      expanded: null,
      rowsLength: 0,
      userRole: localStorage.role
    };
  },
  watch: {
    activeFilter: {
      handler: function handler() {
        var _this4 = this;

        this.filtering = !Object.keys(this.activeFilter).every(function (filter) {
          return _this4.activeFilter[filter] === 'all';
        });
      },
      deep: true
    },
    search: function search() {
      // add searching event on all tables on page
      if (this.options.searchOnAllTables) {
        this.$root.$emit('search', this.search);
      }
    }
  },
  computed: {
    filteredRows: function filteredRows() {
      var _this5 = this;

      // eslint-disable-next-line
      var filteredRows = this.dataRows.filter(function (row) {
        // eslint-disable-next-line
        return _this5.options.activeFilter && Object.keys(_this5.options.activeFilter).filter(function (activeFilter) {
          return _this5.options.activeFilter[activeFilter] === row[activeFilter] && row.role !== 'Volunteer' || _this5.options.activeFilter[activeFilter] === 'all' || _this5.options.activeFilter[activeFilter] === true && typeof row[activeFilter] === 'string' || _this5.options.activeFilter[activeFilter] === row.role && _this5.options.activeFilter[activeFilter] !== 0 && _this5.options.activeFilter[activeFilter] !== 1;
        }).length === Object.keys(_this5.options.activeFilter).length;
      });
      this.rowsLength = filteredRows.length;
      return filteredRows;
    },
    visibleColumns: function visibleColumns() {
      return this.columns.filter(function (column) {
        return column.visible;
      });
    }
  },
  created: function created() {
    var _this6 = this;

    __WEBPACK_IMPORTED_MODULE_1__store_EventBus_js__["a" /* default */].$on('selected', function (row) {
      if (!_this6.selected_rows.includes(row)) {
        _this6.selected_rows.push(row);
      }
    });
    __WEBPACK_IMPORTED_MODULE_1__store_EventBus_js__["a" /* default */].$on('selected_rows', function (selected_rows) {
      _this6.selected_rows = selected_rows;
    });
    __WEBPACK_IMPORTED_MODULE_1__store_EventBus_js__["a" /* default */].$on('deselected', function (row) {
      if (_this6.selected_rows.includes(row)) {
        var index = _this6.selected_rows.indexOf(row);

        _this6.selected_rows.splice(index, 1);
      }
    });
    __WEBPACK_IMPORTED_MODULE_1__store_EventBus_js__["a" /* default */].$on('deselect-all', function () {
      _this6.$store.commit('deselectAllRows');

      _this6.selected_rows = _this6.$store.getters.selectedRows; // Vue.set(this, 'selected_rows', [])
    });
    /*
      search listener
      set search value for all tables
     */

    this.$root.$on('search', function (value) {
      _this6.search = value;
    });
  },
  updated: function updated() {
    if (this.options && this.options.groupByZone === true) {
      this.colorTableFields();
    }

    if (this.filteredRows.length > 0 && this.page === 0) {
      this.page = 1;
    }
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['options', 'activeFilter']
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__voerro_vue_tagsinput__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_legacyBrowsers_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_EventBus_js__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['errorStatus', 'loaded'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_legacyBrowsers_js__["a" /* default */]],
  components: {
    'tags-input': __WEBPACK_IMPORTED_MODULE_0__voerro_vue_tagsinput__["a" /* default */]
  },
  data: function data() {
    return {
      selectedFilter: {
        to_date: '',
        from_date: this.getDate()
      },
      processing: !this.loaded || false
    };
  },
  methods: {
    sendFilter: function sendFilter() {
      this.processing = true;
      __WEBPACK_IMPORTED_MODULE_3__store_EventBus_js__["a" /* default */].$emit('filterDate', this.selectedFilter);
    },
    getDate: function getDate() {
      var d = this.$store.state.currentDate ? new Date(this.$store.state.currentDate) : new Date(); // 0 indexed for Jan so add 1 to get current

      var month = d.getMonth() + 1;
      var year = d.getFullYear(); // If the start of the year, subtract a year for last ACA year

      if (month <= 3) {
        year--;
      } // Return the start of the ACA year


      return [year, "04", "01"].join('-');
    }
  },
  mounted: function mounted() {
    this.sendFilter();
  },
  watch: {
    loaded: function loaded() {
      this.processing = !this.loaded;
    }
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    elementId: String,
    instruction: String,
    existingTags: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    value: {
      type: [Array, String],
      default: function _default() {
        return [];
      }
    },
    typeahead: {
      type: Boolean,
      default: false
    },
    typeaheadStyle: {
      type: String,
      default: 'badges'
    },
    typeaheadActivationThreshold: {
      type: Number,
      default: 1
    },
    typeaheadMaxResults: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      default: 'Add a tag'
    },
    limit: {
      type: Number,
      default: 0
    },
    onlyExistingTags: {
      type: Boolean,
      default: false
    },
    deleteOnBackspace: {
      type: Boolean,
      default: true
    },
    allowDuplicates: {
      type: Boolean,
      default: false
    },
    validate: {
      type: Function,
      default: function _default() {
        return true;
      }
    },
    addTagsOnComma: {
      type: Boolean,
      default: false
    },
    wrapperClass: {
      type: String,
      default: 'tags-input-wrapper-default'
    },
    clearSearchResults: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      badgeId: 0,
      tagBadges: [],
      tags: [],
      input: '',
      oldInput: '',
      hiddenInput: '',
      searchResults: [],
      searchSelection: 0
    };
  },
  created: function created() {
    this.tagsFromValue(); // Emit an event

    this.$emit('initialized');
  },
  watch: {
    tags: function tags() {
      // Updating the hidden input
      this.hiddenInput = this.tags.join(','); // Update the bound v-model value

      this.$emit('input', this.tags);
    },
    value: function value() {
      this.tagsFromValue();
    },
    clearSearchResults: function clearSearchResults() {
      if (this.clearSearchResults) {
        this.searchResults = [];
      }
    }
  },
  methods: {
    escapeRegExp: function escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    tagFromInput: function tagFromInput() {
      // If we're choosing a tag from the search results
      if (this.searchResults.length && this.searchSelection >= 0) {
        this.tagFromSearch(this.searchResults[this.searchSelection]);
        this.input = '';
      } else {
        // If we're adding an unexisting tag
        var text = this.input.trim(); // If the new tag is not an empty string and passes validation

        if (!this.onlyExistingTags && text.length && this.validate(text)) {
          this.input = ''; // Determine the tag's slug and text depending on if the tag exists
          // on the site already or not

          var slug = this.makeSlug(text);
          var existingTag = this.existingTags[slug];
          slug = existingTag ? slug : text;
          text = existingTag ? existingTag : text;
          this.addTag(slug, text);
        }
      }
    },
    tagFromSearchOnClick: function tagFromSearchOnClick(tag) {
      this.tagFromSearch(tag);
      this.$refs['taginput'].blur();
    },
    tagFromSearch: function tagFromSearch(tag) {
      this.searchResults = [];
      this.input = '';
      this.oldInput = '';
      this.addTag(tag.slug, tag.text);
    },
    makeSlug: function makeSlug(value) {
      return value.toLowerCase().replace(/\s/g, '-');
    },
    addTag: function addTag(slug, text) {
      // Check if the limit has been reached
      if (this.limit > 0 && this.tags.length >= this.limit) {
        return false;
      } // Attach the tag if it hasn't been attached yet


      if (!this.tagSelected(slug)) {
        this.tagBadges.push(text.replace(/\s/g, '&nbsp;'));
        this.tags.push(slug);
      } // Emit events


      this.$emit('tag-added', slug);
      this.$emit('tags-updated');
    },
    removeLastTag: function removeLastTag() {
      if (!this.input.length && this.deleteOnBackspace) {
        this.removeTag(this.tags.length - 1);
      }
    },
    removeTag: function removeTag(index) {
      var slug = this.tags[index];
      this.tags.splice(index, 1);
      this.tagBadges.splice(index, 1); // Emit events

      this.$emit('tag-removed', slug);
      this.$emit('tags-updated');
    },
    searchTag: function searchTag() {
      if (this.typeahead === true) {
        if (this.oldInput != this.input || !this.searchResults.length && this.typeaheadActivationThreshold == 0) {
          this.searchResults = [];
          this.searchSelection = 0;
          var input = this.input.trim();

          if (input.length && input.length >= this.typeaheadActivationThreshold || this.typeaheadActivationThreshold == 0) {
            for (var slug in this.existingTags) {
              var text = this.existingTags[slug].toLowerCase();

              if (text.search(this.escapeRegExp(input.toLowerCase())) > -1 && !this.tagSelected(slug)) {
                this.searchResults.push({
                  slug: slug,
                  text: this.existingTags[slug]
                });
              }
            } // Sort the search results alphabetically


            this.searchResults.sort(function (a, b) {
              if (a.text < b.text) return -1;
              if (a.text > b.text) return 1;
              return 0;
            }); // Shorten Search results to desired length

            if (this.typeaheadMaxResults > 0) {
              this.searchResults = this.searchResults.slice(0, this.typeaheadMaxResults);
            }
          }

          this.oldInput = this.input;
        }
      }
    },
    onFocus: function onFocus() {
      this.searchTag();
    },
    hideTypeahead: function hideTypeahead() {
      var _this = this;

      if (!this.input.length) {
        this.$nextTick(function () {
          _this.ignoreSearchResults();
        });
      }
    },
    nextSearchResult: function nextSearchResult() {
      if (this.searchSelection + 1 <= this.searchResults.length - 1) {
        this.searchSelection++;
      }
    },
    prevSearchResult: function prevSearchResult() {
      if (this.searchSelection > 0) {
        this.searchSelection--;
      }
    },
    ignoreSearchResults: function ignoreSearchResults() {
      this.searchResults = [];
      this.searchSelection = 0;
    },

    /**
    * Clear the list of selected tags
    */
    clearTags: function clearTags() {
      this.tags.splice(0, this.tags.length);
      this.tagBadges.splice(0, this.tagBadges.length);
    },

    /**
    * Replace the currently selected tags with the tags from the value
    */
    tagsFromValue: function tagsFromValue() {
      if (this.value && this.value.length) {
        var tags = Array.isArray(this.value) ? this.value : this.value.split(',');

        if (this.tags == tags) {
          return;
        }

        this.clearTags();
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = tags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var slug = _step.value;
            var existingTag = this.existingTags[slug];
            var text = existingTag ? existingTag : slug;
            this.addTag(slug, text);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        if (this.tags.length == 0) {
          return;
        }

        this.clearTags();
      }
    },

    /**
    * Check if the tag with the provided slug is already selected
    */
    tagSelected: function tagSelected(slug) {
      var _this2 = this;

      if (this.allowDuplicates) {
        return false;
      }

      if (!slug) {
        return false;
      }

      var searchSlug = this.makeSlug(slug);
      var found = this.tags.find(function (value) {
        return searchSlug == _this2.makeSlug(value);
      });
      return !!found;
    },

    /**
     * Process all the keydown events
     */
    onKeyDown: function onKeyDown(e) {
      // Insert a new tag on comma keydown if the option is enabled
      if (e.key == ',') {
        if (this.addTagsOnComma) {
          // The comma shouldn't actually be inserted
          e.preventDefault(); // Add the inputed tag

          this.tagFromInput();
        }
      }
    }
  }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['options'],
  data: function data() {
    return {
      // `options.initialSearch` lets a page open its list pre-filtered (e.g. the Drafts list
      // "find committee secretaries" icon deep-links to Secretary Users with the committee name).
      search: this.options && this.options.initialSearch || ''
    };
  },
  created: function created() {
    // Propagate a pre-filled search up to the DataTable so the list starts filtered.
    if (this.search) this.$emit('search', this.search);
  },
  watch: {
    search: function search() {
      this.$emit('search', this.search);
    }
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    text: String,
    link: String,
    row: Object,
    options: Object,
    edit: Boolean,
    slug: {
      default: '',
      required: false
    },
    tab: String,
    score: Boolean,
    secretary: Boolean,
    mobile: String,
    draftId: {
      default: null,
      required: false
    },
    id: {
      default: undefined,
      required: false
    }
  },
  computed: {
    resolvedDraftId: function resolvedDraftId() {
      if (this.draftId !== null && this.draftId !== undefined) {
        return this.draftId;
      }

      if (this.link === 'Events') {
        return this.row.id;
      }

      if (this.link === 'Create Event') {
        return this.row.draft_id;
      }

      return undefined;
    },
    resolvedEventId: function resolvedEventId() {
      return this.link === 'Create Event' ? this.row.id : undefined;
    }
  },
  data: function data() {
    return {
      showLinks: this.options && this.options.showLinks,
      showActive: this.options && this.options.showActive,
      showActiveToken: this.options && this.options.showActiveToken,
      showHorseActive: this.options && this.options.showHorseActive,
      showRegistered: this.options && this.options.showRegistered,
      showPrimary: this.options && this.options.showPrimary,
      showPaid: this.options && this.options.showPaid,
      showStatus: this.options && this.options.showStatus,
      inline: this.options && this.options.inline,
      expandMobile: this.options && this.options.expandMobile,
      textBreak: this.options && this.options.textBreak,
      buttonBreak: this.options && this.options.buttonBreak,
      showFinal: this.options && this.options.showFinal,
      hasSeasons: this.options && this.options.hasSeasons,
      showSecretaryOnly: this.options && this.options.showSecretaryOnly,
      showDeleted: this.options && this.options.showDeleted,
      isFinancial: this.row.isFinancial !== undefined ? this.row.isFinancial : this.row.financial,
      isMobile: this.options && this.options.isMobile && this.mobile,
      showJudgeStatus: this.options && this.options.showJudgeStatus,
      showFinancial: this.options && this.options.showFinancial
    };
  },
  watch: {
    row: {
      deep: true,
      handler: function handler() {
        this.isFinancial = this.row.isFinancial !== undefined ? this.row.isFinancial : this.row.financial;
      }
    }
  }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_actingCommittee__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ResponsiveTable__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Pagination__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ListNameCell__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_secretaryListType__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__composables_secretaries_useSecretariesList__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__secretaryUsersColumns__ = __webpack_require__(679);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["c" /* defineComponent */])({
  name: 'SecretaryUsers',
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_3__components_ListingLayout__["a" /* default */],
    ResponsiveTable: __WEBPACK_IMPORTED_MODULE_4__components_ResponsiveTable__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_5__components_Pagination__["a" /* default */],
    ListNameCell: __WEBPACK_IMPORTED_MODULE_6__components_ListNameCell__["a" /* default */]
  },
  setup: function setup() {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var _useSecretariesList = Object(__WEBPACK_IMPORTED_MODULE_8__composables_secretaries_useSecretariesList__["a" /* default */])(),
        rows = _useSecretariesList.rows,
        loading = _useSecretariesList.loading,
        page = _useSecretariesList.page,
        totalPages = _useSecretariesList.totalPages,
        filters = _useSecretariesList.filters,
        perPageOptions = _useSecretariesList.perPageOptions,
        fetch = _useSecretariesList.fetch,
        setPage = _useSecretariesList.setPage,
        setSort = _useSecretariesList.setSort,
        setPerPage = _useSecretariesList.setPerPage,
        setSearch = _useSecretariesList.setSearch,
        setFilter = _useSecretariesList.setFilter;

    var columns = Object(__WEBPACK_IMPORTED_MODULE_9__secretaryUsersColumns__["b" /* buildColumns */])();
    var breakpoints = Object(__WEBPACK_IMPORTED_MODULE_9__secretaryUsersColumns__["a" /* buildBreakpoints */])(); // A member secretary (role=Secretary, has their own personal account) profiles at
    // /members/:slug; a SecretaryOnly account (no personal member account) profiles at
    // /secretary-users/:slug — same conditional link the legacy page used.

    function profileRoute(row) {
      return row.role === 'Secretary' ? {
        name: 'Member Profile',
        params: {
          slug: row.id
        }
      } : {
        name: 'Secretary Profile',
        params: {
          slug: row.id
        }
      };
    }

    var searchInput = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["l" /* ref */])(filters.search || '');
    var successMessage = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["l" /* ref */])('');
    var errorMessage = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["l" /* ref */])(''); // Search-as-you-type with a 500ms debounce; Enter / the icon fire it immediately.

    var searchTimer = null;

    function applySearch() {
      clearTimeout(searchTimer);
      if (searchInput.value !== filters.search) setSearch(searchInput.value);
    }

    Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["p" /* watch */])(searchInput, function (val) {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
        if (val !== filters.search) setSearch(val);
      }, 500);
    });
    Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["h" /* onBeforeUnmount */])(function () {
      return clearTimeout(searchTimer);
    }); // --- Login as secretary ---

    var loggingInId = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["l" /* ref */])(null);

    function login(id) {
      loggingInId.value = id;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("".concat(proxy.$api, "/auth/login-as-user"), {
        id: id
      }).then(function (response) {
        if (response.data.token) {
          localStorage.setItem('bearer', response.data.token);
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.common.Authorization = "Bearer ".concat(response.data.token);
          localStorage.setItem('first_name', response.data.first_name);
          localStorage.setItem('last_name', response.data.last_name);
          localStorage.setItem('role', response.data.role);
          localStorage.setItem('userID', response.data.id);
          localStorage.setItem('is_onboarded', response.data.is_onboarded);
          Object(__WEBPACK_IMPORTED_MODULE_0__services_actingCommittee__["c" /* storeSuperSecretaryFlags */])(response.data, {
            resetSelection: true
          });
          proxy.$router.push('/');
        }
      }).catch(function () {
        errorMessage.value = 'Unable to log in as this secretary. Please try again later.';
      }).finally(function () {
        loggingInId.value = null;
      });
    }

    Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["i" /* onMounted */])(function () {
      return fetch();
    });
    return {
      columns: columns,
      breakpoints: breakpoints,
      rows: rows,
      loading: loading,
      page: page,
      totalPages: totalPages,
      filters: filters,
      perPageOptions: perPageOptions,
      searchInput: searchInput,
      successMessage: successMessage,
      errorMessage: errorMessage,
      setPage: setPage,
      setFilter: setFilter,
      SECRETARY_LIST_TYPE_TABS: __WEBPACK_IMPORTED_MODULE_7__constants_secretaryListType__["b" /* SECRETARY_LIST_TYPE_TABS */],
      setSort: setSort,
      setPerPage: setPerPage,
      applySearch: applySearch,
      profileRoute: profileRoute,
      loggingInId: loggingInId,
      login: login
    };
  }
}));

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // variant bundles the hideHeader/noBorders/noStripes/border/rowBg combo that
// "nested card list" tables (event popups, drill-down rows) all repeated by hand

var VARIANT_PRESETS = {
  default: {},
  nested: {
    hideHeader: true,
    noBorders: true,
    noStripes: true,
    borderColor: 'white',
    borderWidth: '2px',
    rowBg: 'var(--gray-200)'
  },
  compact: {
    noStripes: true
  }
}; // A layout "cell" is one of:
//   'key'                       -> single column
//   ['keyA', 'keyB']            -> merged cell, stacks multiple columns' values together
//   { keys: [...], span, width, class, hideLabel }  -> explicit form for edge cases
//   null                        -> empty spacer cell

function normalizeCell(spec) {
  if (spec == null) return {
    keys: [],
    merged: false
  };
  if (typeof spec === 'string') return {
    keys: [spec],
    merged: false
  };
  if (Array.isArray(spec)) return {
    keys: spec,
    merged: spec.length > 1
  };
  var keys = spec.keys || [];
  return {
    keys: keys,
    merged: keys.length > 1,
    span: spec.span,
    width: spec.width,
    class: spec.class,
    hideLabel: spec.hideLabel
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'ResponsiveTable',
  components: {
    Draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a
  },
  props: {
    // Each column: { key, label, width, minWidth, sortable, cellClass, align }
    // align: 'left' (default) | 'center' | 'right' — applies to both the header and body cells
    columns: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    sort: {
      type: String,
      default: null
    },
    direction: {
      type: String,
      default: 'asc'
    },
    emptyText: {
      type: String,
      default: null
    },
    openId: {
      type: [String, Number],
      default: undefined
    },
    draggable: {
      type: Boolean,
      default: false
    },
    // Optional (row) => class-value function, applied alongside the built-in rtable__record classes
    rowClass: {
      type: Function,
      default: null
    },
    // Sorted ascending: [{ maxWidth: 480, hideHeader, headerRows, accordion, rows: [[cellSpec, ...], ...] }, ...]
    // Applied when the container's width is <= maxWidth. Falls back to one row of all
    // columns (the desktop layout) when the container is wider than every breakpoint.
    // accordion: { summary: [cellSpec, ...] } — when set, `summary` renders as a single always-
    // visible clickable line (with a +/- toggle) and `rows` becomes the detail content, shown
    // only once that record is expanded (reuses the same open-state as `openId`/expand slot).
    breakpoints: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    variant: {
      type: String,
      default: 'default',
      validator: function validator(value) {
        return Object.keys(VARIANT_PRESETS).includes(value);
      }
    },
    hideHeader: {
      type: Boolean,
      default: null
    },
    noBorders: {
      type: Boolean,
      default: null
    },
    noStripes: {
      type: Boolean,
      default: null
    },
    borderColor: {
      type: String,
      default: null
    },
    borderWidth: {
      type: String,
      default: null
    },
    rowBg: {
      type: String,
      default: null
    }
  },
  setup: function setup(props) {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var root = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var containerWidth = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(Infinity);
    var internalOpenId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var ro = null;
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      ro = new ResizeObserver(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
            entry = _ref2[0];

        containerWidth.value = entry.contentRect.width;
      });
      ro.observe(root.value);
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["j" /* onUnmounted */])(function () {
      if (ro) ro.disconnect();
    });
    var cachedRows = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])([function () {
      return props.rows;
    }, function () {
      return props.loading;
    }], function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          rows = _ref4[0],
          loading = _ref4[1];

      if (!loading) cachedRows.value = rows;
    }, {
      immediate: true
    });
    var displayRows = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.loading ? cachedRows.value : props.rows;
    });
    var resolvedOpenId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.openId !== undefined ? props.openId : internalOpenId.value;
    });

    function toggleRow(id) {
      if (props.openId !== undefined) return;
      internalOpenId.value = internalOpenId.value === id ? null : id;
    }

    var hasExpand = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return 'expand' in proxy.$scopedSlots;
    });
    var preset = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return VARIANT_PRESETS[props.variant] || {};
    });
    var effectiveNoBorders = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.noBorders != null ? props.noBorders : Boolean(preset.value.noBorders);
    });
    var effectiveNoStripes = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.noStripes != null ? props.noStripes : Boolean(preset.value.noStripes);
    });
    var effectiveBorderColor = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.borderColor != null ? props.borderColor : preset.value.borderColor;
    });
    var effectiveBorderWidth = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.borderWidth != null ? props.borderWidth : preset.value.borderWidth;
    });
    var effectiveRowBg = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.rowBg != null ? props.rowBg : preset.value.rowBg;
    });
    var sortedBreakpoints = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return _toConsumableArray(props.breakpoints).sort(function (a, b) {
        return a.maxWidth - b.maxWidth;
      });
    }); // null means "no breakpoint matched" i.e. the base/desktop single-row layout applies

    var activeBreakpoint = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return sortedBreakpoints.value.find(function (bp) {
        return containerWidth.value <= bp.maxWidth;
      }) || null;
    }); // A breakpoint's own hideHeader (if set) wins over the base prop/variant preset —
    // lets a table hide its (often redundant, once cells self-label) header only when compact

    var effectiveHideHeader = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var bp = activeBreakpoint.value;
      if (bp && bp.hideHeader != null) return bp.hideHeader;
      return props.hideHeader != null ? props.hideHeader : Boolean(preset.value.hideHeader);
    });
    var baseRows = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return [props.columns.map(function (c) {
        return c.key;
      })];
    });
    var rawLines = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return activeBreakpoint.value ? activeBreakpoint.value.rows : baseRows.value;
    });
    var bodyLines = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return rawLines.value.map(function (line) {
        return line.map(normalizeCell);
      });
    }); // Header mirrors the leading N lines of the body layout, so both stay in sync from one
    // source of truth. A breakpoint can set headerRows to only header its first line(s) —
    // e.g. keep "Effective Date / Actions" as a header but not repeat it for merged/stacked
    // lines below, which already self-label their cells.

    var headerLineCount = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var bp = activeBreakpoint.value;
      if (bp && bp.headerRows != null) return bp.headerRows;
      return bodyLines.value.length;
    });
    var headerLines = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return bodyLines.value.slice(0, headerLineCount.value);
    }); // Present only when the active breakpoint defines accordion.summary — turns bodyLines
    // into collapsed detail content, revealed per-record via the same toggleRow/resolvedOpenId

    var accordionSummary = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var bp = activeBreakpoint.value;
      return bp && bp.accordion ? bp.accordion.summary.map(normalizeCell) : null;
    }); // Accordion detail ignores the rows matrix's grid/line grouping — it's rendered as one
    // flat, plainly-stacked field list (like the old expandedRow pattern), not a mini-table

    var accordionDetailCells = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return accordionSummary.value ? bodyLines.value.reduce(function (acc, line) {
        return acc.concat(line);
      }, []) : [];
    });
    var sortableColumns = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.columns.filter(function (c) {
        return c.sortable;
      });
    });

    function findColumn(key) {
      return props.columns.find(function (c) {
        return c.key === key;
      });
    }

    function labelFor(key) {
      var col = findColumn(key);
      return col ? col.label : key;
    }

    function isSortable(cell) {
      if (cell.merged || !cell.keys.length) return false;
      var col = findColumn(cell.keys[0]);
      return Boolean(col && col.sortable);
    }

    function headerLabel(cell) {
      return cell.keys.map(labelFor).join(' / ');
    }

    function showCellLabel(cell) {
      if (cell.hideLabel) return false;
      return activeBreakpoint.value != null;
    }

    function colTrack(cell) {
      if (cell.width) return cell.width;

      if (!activeBreakpoint.value) {
        var col = findColumn(cell.keys[0]);
        var w = col && col.width || '1fr';
        return col && col.minWidth ? "minmax(".concat(col.minWidth, ", ").concat(w, ")") : w;
      }

      return "".concat(cell.span || 1, "fr");
    }

    function lineStyle(line) {
      return {
        gridTemplateColumns: line.map(colTrack).join(' ')
      };
    } // Same as lineStyle, plus a trailing auto-sized track for the +/- toggle icon


    function summaryLineStyle(line) {
      return {
        gridTemplateColumns: "".concat(line.map(colTrack).join(' '), " auto")
      };
    }

    function rowClasses(row, index) {
      return [{
        'rtable__record--open': resolvedOpenId.value === row.id,
        'rtable__record--odd': index % 2 === 0,
        'rtable__record--accordion': !!accordionSummary.value
      }, props.rowClass ? props.rowClass(row) : null];
    }

    function cellClasses(cell) {
      var fromColumns = cell.keys.map(function (k) {
        return (findColumn(k) || {}).cellClass;
      }).filter(Boolean);
      var col = cell.keys.length ? findColumn(cell.keys[0]) : null;
      var align = col && col.align || 'left';
      var alignClass = align !== 'left' ? "rtable__cell--align-".concat(align) : null;
      return [cell.class, alignClass].concat(_toConsumableArray(fromColumns));
    }

    var cssVars = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var vars = {};
      if (effectiveBorderColor.value != null) vars['--rt-border-color'] = effectiveBorderColor.value;
      if (effectiveBorderWidth.value != null) vars['--rt-border-width'] = effectiveBorderWidth.value;
      if (effectiveRowBg.value != null) vars['--rt-row-bg'] = effectiveRowBg.value;
      return vars;
    });
    var rootClasses = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return {
        'rtable--loading': props.loading,
        'rtable--no-borders': effectiveNoBorders.value,
        'rtable--no-stripes': effectiveNoStripes.value,
        'rtable--accordion': Boolean(accordionSummary.value)
      };
    });
    return {
      root: root,
      displayRows: displayRows,
      resolvedOpenId: resolvedOpenId,
      toggleRow: toggleRow,
      hasExpand: hasExpand,
      effectiveHideHeader: effectiveHideHeader,
      bodyLines: bodyLines,
      headerLines: headerLines,
      accordionSummary: accordionSummary,
      accordionDetailCells: accordionDetailCells,
      sortableColumns: sortableColumns,
      labelFor: labelFor,
      isSortable: isSortable,
      headerLabel: headerLabel,
      showCellLabel: showCellLabel,
      lineStyle: lineStyle,
      summaryLineStyle: summaryLineStyle,
      rowClasses: rowClasses,
      cellClasses: cellClasses,
      cssVars: cssVars,
      rootClasses: rootClasses
    };
  }
}));

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Pagination',
  props: {
    color: {
      type: String,
      required: false
    },
    totalPages: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      default: 1
    },
    onChange: {
      type: Function,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: function currentPage() {
      return this.page;
    },
    visiblePages: function visiblePages() {
      var pages = [];
      var delta = 2;
      var left = Math.max(1, this.currentPage - delta);
      var right = Math.min(this.totalPages, this.currentPage + delta);
      if (left > 1) pages.push({
        key: 1,
        number: 1,
        display: 1
      });
      if (left > 2) pages.push({
        key: 'start-ellipsis',
        disabled: true,
        display: '...'
      });

      for (var i = left; i <= right; i++) {
        pages.push({
          key: i,
          number: i,
          display: i
        });
      }

      if (right < this.totalPages - 1) pages.push({
        key: 'end-ellipsis',
        disabled: true,
        display: '...'
      });
      if (right < this.totalPages) pages.push({
        key: this.totalPages,
        number: this.totalPages,
        display: this.totalPages
      });
      return pages;
    }
  },
  methods: {
    goToPage: function goToPage(page) {
      // Clicking the active page would push the same location and vue-router rejects with NavigationDuplicated
      if (this.disabled || page < 1 || page > this.totalPages || page === this.currentPage) return;
      this.onChange(page);
    }
  }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * The "name" column of a server-list page (Horses / Drafts / Members …): a link to the record's
 * profile plus a wrapping group of status badges. Centralises two things every list page kept
 * re-doing by hand:
 *  - the flex layout (name + badges on one line, badges wrap under the name when narrow);
 *  - neutralising the global `.badge { min-width: 58px }`, which otherwise pads short labels
 *    ("Active", "Published", "Final") and centres them so the badge looks detached from the name.
 *
 * `align="right"` pushes the badge group to the far side of the cell (Horses); the default
 * keeps it tucked against the name (Drafts).
 *
 *   <list-name-cell :label="row.name" :to="{ name: 'Events', params: { draftId: String(row.id) } }">
 *     <template #badges>
 *       <span class="badge alert-success">Published</span>
 *     </template>
 *   </list-name-cell>
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ListNameCell',
  props: {
    label: {
      type: [String, Number],
      default: ''
    },
    // vue-router `to` — omit for a plain (non-linked) name
    to: {
      type: [Object, String],
      default: null
    },
    // where the badge group sits: 'left' (against the name) | 'right' (far edge of the cell)
    align: {
      type: String,
      default: 'left'
    }
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SECRETARY_LIST_TYPE_ALL; });
/* unused harmony export SECRETARY_LIST_TYPE_MEMBER */
/* unused harmony export SECRETARY_LIST_TYPE_SECRETARY_ONLY */
/* unused harmony export SECRETARY_LIST_TYPE_SUPER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SECRETARY_LIST_TYPE_TABS; });
// Mirror of App\Enums\SecretaryListType (campdraftone-api) — `type` filter of /v2/secretaries.
// Keep in sync by hand. Labels stay here: it is a filter, not a stored column (no *_label from API).
var SECRETARY_LIST_TYPE_ALL = 'all';
var SECRETARY_LIST_TYPE_MEMBER = 'member';
var SECRETARY_LIST_TYPE_SECRETARY_ONLY = 'secretary_only';
var SECRETARY_LIST_TYPE_SUPER = 'super';
var SECRETARY_LIST_TYPE_TABS = [{
  value: SECRETARY_LIST_TYPE_ALL,
  label: 'All'
}, {
  value: SECRETARY_LIST_TYPE_MEMBER,
  label: 'Member Secretary'
}, {
  value: SECRETARY_LIST_TYPE_SECRETARY_ONLY,
  label: 'Secretary Only'
}, {
  value: SECRETARY_LIST_TYPE_SUPER,
  label: 'Super Secretary'
}];

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  getList: function getList(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/secretaries', {
      params: params
    });
  },
  setSuperSecretary: function setSuperSecretary(memberId, isSuperSecretary) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/members/".concat(memberId, "/super-secretary"), {
      is_super_secretary: isSuperSecretary
    }, {
      silent: true,
      localSuccess: true
    });
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Account_Register__ = __webpack_require__(684);
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminRegister',
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    register: __WEBPACK_IMPORTED_MODULE_1__views_Account_Register__["a" /* default */]
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_NavbarSide__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Breadcrumb__ = __webpack_require__(220);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This is a consistent layout that should be used for listing pages.
 * Content will be added to the "slot" tags above automagically when
 * this component is added */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Tab-Layout',
  components: {
    navbar: __WEBPACK_IMPORTED_MODULE_0__components_NavbarSide__["a" /* default */],
    breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components_Breadcrumb__["a" /* default */]
  },
  props: {
    fullWidth: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_legacyBrowsers_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RegisterExisting__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RegisterNew__ = __webpack_require__(688);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Register',
  props: ['isAdmin'],
  components: {
    'existing-member': __WEBPACK_IMPORTED_MODULE_3__RegisterExisting__["a" /* default */],
    'new-member': __WEBPACK_IMPORTED_MODULE_4__RegisterNew__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_legacyBrowsers_js__["a" /* default */]],
  data: function data() {
    return {
      loading: false,
      success: false,
      errors: '',
      errorStatus: '',
      responseStatus: '',
      existingMember: false,
      userInfo: {},
      terms: this.isAdmin,
      newMember: this.isAdmin
    };
  },
  methods: {
    register: function register(event) {
      var _this = this;

      event.preventDefault();
      var file = event.target.elements.proofOfAge.files[0];

      if (file && file.size > 1024 * 1024) {
        this.success = '';
        this.errorStatus = 'file';
        this.errors = "The Proof of Age file may not be greater than 1 mb.";
      }

      var fields = event.target.elements; // eslint-disable-next-line

      var data = {
        dob: fields.dateOfBirth.value,
        gender: fields.gender.value,
        rider_status: fields.riderStatus.value,
        boy_status: fields.boyStatus.value,
        title: fields.title.value,
        first_name: fields.firstName.value,
        last_name: fields.lastName.value,
        email: fields.email.value,
        phone: fields.phone.value,
        mobile_phone: fields.mobile.value,
        carbon_copy_mobile: fields.carbon_copy_mobile.value,
        street_1: fields.address.value,
        street_2: fields.address2.value,
        suburb: fields.suburb.value,
        postcode: fields.postcode.value,
        state: fields.state.value,
        terms: this.terms,
        role: this.isAdmin ? fields.role.value : 'member',
        zone: fields.zone.value || null,
        password: fields.password.value,
        password_confirmation: fields.confirmPassword.value
      };

      if (this.isAdmin) {
        data.member_number = fields.memberNumber !== undefined ? fields.memberNumber.value : '';
        data.notes = fields.notes.value;
      }

      this.loading = true;
      var formData = new FormData();
      formData.append('file', file);
      formData.append('fields', JSON.stringify(data));
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/auth/register-new"), formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        var _response$data2, _response$data3;

        // Success
        _this.responseStatus = response.data.status;

        if (response.data.status === 'success') {
          // Show next screen telling them to check their email
          _this.errors = '';
          _this.success = true;
        } else {
          _this.success = false;
          _this.loading = false;
        } // Validation Error


        if (response.data.status === 'validation_error') {
          if (response.data.errors.dob) {
            // DoB
            _this.errorStatus = 'validation_error';
            _this.errors = "Please include your Date of Birth in the format".concat(_this.isLegacy() ? ' yyyy-mm-dd' : ' dd/mm/yyyy', ".");
          } else if (response.data.errors.member_number) {
            _this.errorStatus = 'member_number';
            _this.errors = 'The member number has already been taken.';
          } else if (response.data.errors.mobile_phone) {
            _this.errorStatus = 'mobile_phone';
            _this.errors = 'Please include correct mobile phone number.';
          } else if (response.data.errors.file) {
            _this.errorStatus = 'file';
            _this.errors = 'The Proof of Age file may not be greater than 1 mb.';
          } else if (response.data.errors.carbon_copy_mobile) {
            _this.errorStatus = 'carbon_copy_mobile';
            _this.errors = 'Please include correct CC mobile.';
          } else if (response.data.errors.email) {
            var _response$data, _response$data$errors;

            // Email
            _this.errorStatus = 'email';

            if (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$errors = _response$data.errors) === null || _response$data$errors === void 0 ? void 0 : _response$data$errors.email[0]) {
              _this.errors = response.data.errors.email[0];
            } else {
              _this.errors = 'Please include correct email address.';
            }
          } else {
            // response.data.errors will contain array of error fields
            _this.errors = 'Please ensure all fields are completed.';
          }

          if (response.data.errors.phone) {
            _this.errors += ' Either the Phone or Mobile Phone Numbers is required.';
          }
        } // Email already registered, please log in


        if (response.data.status === 'email_exists') {
          // Please log in
          _this.errors = "An account exists with this email address.".concat(_this.isAdmin ? '' : ' Please Sign In.');
        } // Something went wrong


        if (response.data.status === 'registration_error' || response.data.status === 'undefined_error') {
          // Alert - Something went wrong, please try again later
          _this.errors = 'There was a server error. Please try again later.';
        } // if the request data are invalid


        if ((response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.status) === 'invalid_data' && (response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.message)) {
          var _response$data4;

          _this.errors = response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.message;
        }
      });
    }
  },
  watch: {
    userInfo: {
      handler: function handler() {
        this.errors = '';
      }
    }
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* UNUSED FILE CURRENTLY */
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      password: {
        password: '',
        confirmPassword: ''
      }
    };
  },
  watch: {
    password: {
      handler: function handler(password) {
        this.$emit('input', password);
      },
      deep: true
    }
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_legacyBrowsers_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slide_toggle__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FormFields_PhoneInput__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_TestPhoneNumbers__ = __webpack_require__(68);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TestPhoneNumbers: __WEBPACK_IMPORTED_MODULE_6__components_TestPhoneNumbers__["a" /* default */],
    PhoneInput: __WEBPACK_IMPORTED_MODULE_5__components_FormFields_PhoneInput__["a" /* default */],
    VueSlideToggle: __WEBPACK_IMPORTED_MODULE_4_vue_slide_toggle__["a" /* VueSlideToggle */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_formValidation_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_legacyBrowsers_js__["a" /* default */]],
  props: ['responseStatus', 'errorStatus', 'errors', 'isAdmin'],
  data: function data() {
    return {
      zoneLocations: [],
      zoneNotFound: false,
      zoneFound: false,
      zoneNotSpecified: false,
      warningMessage: '',
      classAdminRight: this.isAdmin ? 'pr-xl-4' : 'pl-xl-4',
      classAdminLeft: this.isAdmin ? 'pl-xl-4' : 'pr-xl-4',
      password: {
        password: '',
        confirmPassword: ''
      },
      userInfo: {},
      ajaxingEmail: false,
      ajaxingName: false,
      emailFound: false,
      nameMatches: false,
      postcode: null,
      suburb: null,
      zone: null,
      cancelToken: __WEBPACK_IMPORTED_MODULE_0_axios___default.a.CancelToken.source(),
      matchingNames: [],
      newMember: this.isAdmin,
      userRole: localStorage.role,
      file_path: '',
      file_name: ''
    };
  },
  watch: {
    password: {
      handler: function handler(password) {
        this.$emit('input', password);
      },
      deep: true
    },
    computedUserInfo: {
      handler: function handler(userInfo, userInfoOld) {
        // Pass form data to parent
        this.$emit('userInfo', userInfo); // If name changed (not email)

        if (!this.matchingNames.length || !userInfo.email && !userInfoOld.email || userInfo.email && userInfoOld.email && userInfo.email === userInfoOld.email) {
          this.closeNames();
          this.getNameMatch();
        } else if ( // If email changed
        userInfo.email && (!userInfoOld.email || userInfo.email !== userInfoOld.email)) {
          this.getEmailMatch();
        }
      },
      deep: true
    },
    newMember: function newMember(_newMember) {
      this.$emit('newMember', _newMember);
    }
  },
  computed: {
    // Necessary because Vue2 doesn't record the old value of a watched Object
    computedUserInfo: function computedUserInfo() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.userInfo);
    }
  },
  created: function created() {
    this.getNameMatch = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(this.matchName, 300);
    this.getEmailMatch = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(this.checkEmail, 300);
    this.getZoneLocations();
  },
  methods: {
    findZone: function findZone() {
      var _this = this;

      var coincidenceZones = [];

      if (this.suburb && this.postcode) {
        coincidenceZones = this.zoneLocations.filter(function (_ref) {
          var suburb = _ref.suburb,
              postcode = _ref.postcode;
          return _this.suburb.toUpperCase() === suburb && _this.postcode === postcode;
        }) || {};
      } else if (this.suburb && !this.postcode) {
        this.warningMessage = 'Please refine the postcode to find zone matches.';
        coincidenceZones = this.zoneLocations.filter(function (_ref2) {
          var suburb = _ref2.suburb;
          return _this.suburb.toUpperCase() === suburb;
        }) || {};
      } else if (this.postcode && !this.suburb) {
        this.warningMessage = 'Please refine the suburb to find zone matches.';
        coincidenceZones = this.zoneLocations.filter(function (_ref3) {
          var postcode = _ref3.postcode;
          return _this.postcode === postcode;
        }) || {};
      }

      if (coincidenceZones.length === 1) {
        this.zoneNotFound = false;
        this.zoneFound = true;
        this.zone = coincidenceZones[0].zone_id;
      } else if (coincidenceZones.length > 1) {
        this.zoneNotSpecified = true;
        this.zoneFound = true;
        this.zoneNotFound = false;
      } else {
        this.zoneNotFound = true;
        this.zoneFound = false;
        this.zoneNotSpecified = false;
      }
    },
    getZoneLocations: function getZoneLocations() {
      var _this2 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _ref4, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(_this2.$api, "/zone-location/list"));

              case 3:
                _ref4 = _context.sent;
                data = _ref4.data.data;
                _this2.zoneLocations = data || [];
                _context.next = 10;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }))();
    },
    // Get difference between old and new values of an Object
    getDifference: function getDifference(userInfo, userInfoOld) {
      function changes(object, base) {
        return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.transform(object, function (result, value, key) {
          if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEqual(value, base[key])) {
            result[key] = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isObject(value) && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isObject(base[key]) ? changes(value, base[key]) : value;
          }
        });
      }

      return changes(userInfo, userInfoOld);
    },
    checkEmail: function checkEmail() {
      var _this3 = this;

      var value = this.userInfo.email;

      if (this.ajaxingEmail !== false) {
        this.cancelToken.cancel('Aborting current request');
        this.ajaxingEmail = false;
        this.emailFound = false;
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/auth/email-exists"), {
        email: value
      }).then(function (response) {
        if (response.data.exists) {
          _this3.emailFound = true;
        } else {
          _this3.emailFound = false;
        }
      });
    },
    closeNames: function closeNames() {
      this.nameMatches = false;
    },
    matchName: function matchName() {
      var _this4 = this;

      if (!this.isAdmin) {
        if (this.ajaxingName !== false) {
          this.cancelToken.cancel('Aborting current request');
          this.ajaxingName = false;
          this.nameMatches = false;
        }

        if (this.userInfo.firstName && this.userInfo.firstName.length > 0 && this.userInfo.lastName && this.userInfo.lastName.length > 0) {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/auth/match-user-by-name"), {
            first_name: this.userInfo.firstName,
            last_name: this.userInfo.lastName
          }).then(function (response) {
            _this4.nameMatches = true;

            if (response.data.matching.length) {
              _this4.matchingNames = response.data.matching;
            } else {
              _this4.matchingNames = [];
            }
          });
        }
      }
    },
    getEmailAndRedirect: function getEmailAndRedirect(member) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/auth/get-email-by-user-id"), {
        id: member.id,
        member_number: member.member_number
      }).then(function (response) {
        if (response.data.email.length) {
          _this5.$router.push({
            name: 'Login',
            query: {
              email: response.data.email
            }
          });
        }
      });
    },
    newMemberToggle: function newMemberToggle() {
      this.newMember = true;
      this.nameMatches = false;
    },
    fileUpload: function fileUpload(event) {
      this.file_name = '';
      var uploadedFile = event.target.files[0];
      this.file = uploadedFile;

      if (uploadedFile) {
        this.file_name = uploadedFile.name;
      }
    },
    deleteAttachment: function deleteAttachment() {
      delete this.file;
      this.file = undefined;
      this.file_name = '';
    }
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_actingCommittee__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ResponsiveTable__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Pagination__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_filters_FilterBar__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_filters_FilterMultiselect__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_filters_FilterCheckbox__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ListNameCell__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AppTooltip__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_api_members__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__composables_members_useMembersList__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__composables_useUserRole__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__columns__ = __webpack_require__(704);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */
















var DEFAULT_CONFIG = {
  title: 'Members'
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["c" /* defineComponent */])({
  name: 'Members',
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_3__components_ListingLayout__["a" /* default */],
    ResponsiveTable: __WEBPACK_IMPORTED_MODULE_4__components_ResponsiveTable__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_5__components_Pagination__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_6__components_Modal__["a" /* default */],
    FilterBar: __WEBPACK_IMPORTED_MODULE_7__components_filters_FilterBar__["a" /* default */],
    FilterMultiselect: __WEBPACK_IMPORTED_MODULE_8__components_filters_FilterMultiselect__["a" /* default */],
    FilterCheckbox: __WEBPACK_IMPORTED_MODULE_9__components_filters_FilterCheckbox__["a" /* default */],
    ListNameCell: __WEBPACK_IMPORTED_MODULE_10__components_ListNameCell__["a" /* default */],
    AppTooltip: __WEBPACK_IMPORTED_MODULE_11__components_AppTooltip__["a" /* default */]
  },
  setup: function setup() {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var store = proxy.$store;

    var _useUserRole = Object(__WEBPACK_IMPORTED_MODULE_14__composables_useUserRole__["a" /* default */])(),
        isAdmin = _useUserRole.isAdmin; // Computed, not a const: the same component instance is reused when navigating between
    // /members and /admin-members (same as Horses/Drafts — see useServerList.js / table.md).


    var config = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return _objectSpread({}, DEFAULT_CONFIG, {}, proxy.$route.meta.memberList || {});
    });

    var _useMembersList = Object(__WEBPACK_IMPORTED_MODULE_13__composables_members_useMembersList__["a" /* default */])(),
        rows = _useMembersList.rows,
        loading = _useMembersList.loading,
        page = _useMembersList.page,
        totalPages = _useMembersList.totalPages,
        filters = _useMembersList.filters,
        perPageOptions = _useMembersList.perPageOptions,
        fetch = _useMembersList.fetch,
        setPage = _useMembersList.setPage,
        setSort = _useMembersList.setSort,
        setPerPage = _useMembersList.setPerPage,
        setSearch = _useMembersList.setSearch,
        setFilter = _useMembersList.setFilter,
        clearFilter = _useMembersList.clearFilter,
        clearFilters = _useMembersList.clearFilters,
        syncFromQuery = _useMembersList.syncFromQuery;

    var isDeletedTab = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return filters.membership_status === 'Deleted';
    });
    var columns = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return Object(__WEBPACK_IMPORTED_MODULE_15__columns__["d" /* buildColumns */])(isAdmin, isDeletedTab.value);
    });
    var breakpoints = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return Object(__WEBPACK_IMPORTED_MODULE_15__columns__["c" /* buildBreakpoints */])(isAdmin, isDeletedTab.value);
    }); // Zone / Status / BoY Status dropdown filter options — same store lookups Horses uses.
    // Status and BoY Status share the single `riderStatus` lookup (Maiden/Novice/Open) —
    // they just filter two different columns (rider_status_id vs boy_status_id).

    var zoneOptions = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return store.state.listZones || [];
    });
    var riderStatusOptions = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return store.state.riderStatus || [];
    });
    var hasActiveFilters = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["a" /* computed */])(function () {
      return Boolean(filters.search) || filters.financial !== 'all' || filters.membership_status !== 'all' || filters.zone_id.length > 0 || filters.status_id.length > 0 || filters.boy_status_id.length > 0 || Boolean(filters.primary_only) || Boolean(filters.secretary_members_only);
    });
    var searchInput = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["l" /* ref */])(filters.search || '');
    var successMessage = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["l" /* ref */])('');
    var errorMessage = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["l" /* ref */])('');

    function zoneCode(id) {
      var zone = (store.state.listZones || []).find(function (z) {
        return z.id === id;
      });
      return zone ? zone.code : 'Unspecified';
    } // Mirrors the legacy Text.vue `showActive` badge: membership_status when it's not the
    // default "Active", otherwise fall back to the Financial/Unfinancial flag.


    function statusBadgeLabel(row) {
      if (row.membership_status !== 'Active') return row.membership_status === 'Onhold' ? 'On Hold' : row.membership_status;
      return row.financial ? 'Financial' : 'Unfinancial';
    }

    function statusBadgeClass(row) {
      if (row.membership_status !== 'Active') {
        if (row.membership_status === 'Lifetime') return 'alert-info';
        if (row.membership_status === 'Archived') return 'alert-dark';
        return 'alert-danger';
      }

      return row.financial ? 'alert-info' : 'alert-warning';
    } // Search-as-you-type with a 500ms debounce; Enter / the icon fire it immediately.


    var searchTimer = null;

    function applySearch() {
      clearTimeout(searchTimer);
      if (searchInput.value !== filters.search) setSearch(searchInput.value);
    } // "Clear all filters" (FilterBar) — wipes search + tabs + dropdowns back to defaults in one shot.


    function clearAll() {
      clearTimeout(searchTimer);
      searchInput.value = '';
      clearFilters();
    }

    Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["p" /* watch */])(searchInput, function (val) {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
        if (val !== filters.search) setSearch(val);
      }, 500);
    });
    Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["h" /* onBeforeUnmount */])(function () {
      return clearTimeout(searchTimer);
    }); // --- Login as member (admin only) ---

    var loggingInId = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["l" /* ref */])(null);

    function login(id) {
      loggingInId.value = id;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("".concat(proxy.$api, "/auth/login-as-user"), {
        id: id
      }).then(function (response) {
        if (response.data.token) {
          localStorage.setItem('bearer', response.data.token);
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.common.Authorization = "Bearer ".concat(response.data.token);
          localStorage.setItem('first_name', response.data.first_name);
          localStorage.setItem('last_name', response.data.last_name);
          localStorage.setItem('role', response.data.role);
          localStorage.setItem('userID', response.data.id);
          localStorage.setItem('is_onboarded', response.data.is_onboarded);
          Object(__WEBPACK_IMPORTED_MODULE_0__services_actingCommittee__["c" /* storeSuperSecretaryFlags */])(response.data, {
            resetSelection: true
          });
          proxy.$router.push('/');
        }
      }).catch(function () {
        errorMessage.value = 'Unable to log in as this member. Please try again later.';
      }).finally(function () {
        loggingInId.value = null;
      });
    } // --- Restore a soft-deleted member (admin only, "Deleted" tab) ---


    var memberToRestore = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["l" /* ref */])(null);
    var restoringId = Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["l" /* ref */])(null);

    function askRestore(row) {
      memberToRestore.value = row;
    }

    function confirmRestore() {
      var row = memberToRestore.value;
      memberToRestore.value = null;
      restoringId.value = row.id;
      successMessage.value = '';
      errorMessage.value = '';
      __WEBPACK_IMPORTED_MODULE_12__services_api_members__["a" /* default */].restore(row.id).then(function (response) {
        successMessage.value = (response.data || {}).message || 'The member has been restored.';
        fetch();
      }).catch(function () {
        errorMessage.value = 'Unable to restore this member. Please try again later.';
      }).finally(function () {
        restoringId.value = null;
      });
    }

    function loadPage() {
      fetch();
    }

    Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["i" /* onMounted */])(loadPage); // Re-load when switching between /members <-> /admin-members — the component instance is
    // kept, so onMounted won't fire again (same reuse issue as Horses/Drafts).

    Object(__WEBPACK_IMPORTED_MODULE_2__vue_composition_api__["p" /* watch */])(function () {
      return proxy.$route.path;
    }, function () {
      clearTimeout(searchTimer);
      syncFromQuery();
      searchInput.value = filters.search || '';
      successMessage.value = '';
      errorMessage.value = '';
      loadPage();
    });
    return {
      config: config,
      isAdmin: isAdmin,
      columns: columns,
      breakpoints: breakpoints,
      rows: rows,
      loading: loading,
      page: page,
      totalPages: totalPages,
      filters: filters,
      perPageOptions: perPageOptions,
      searchInput: searchInput,
      successMessage: successMessage,
      errorMessage: errorMessage,
      FINANCIAL_TABS: __WEBPACK_IMPORTED_MODULE_15__columns__["a" /* FINANCIAL_TABS */],
      MEMBERSHIP_STATUS_TABS: __WEBPACK_IMPORTED_MODULE_15__columns__["b" /* MEMBERSHIP_STATUS_TABS */],
      zoneOptions: zoneOptions,
      riderStatusOptions: riderStatusOptions,
      hasActiveFilters: hasActiveFilters,
      setPage: setPage,
      setSort: setSort,
      setPerPage: setPerPage,
      setFilter: setFilter,
      clearFilter: clearFilter,
      clearAll: clearAll,
      applySearch: applySearch,
      zoneCode: zoneCode,
      statusBadgeLabel: statusBadgeLabel,
      statusBadgeClass: statusBadgeClass,
      loggingInId: loggingInId,
      login: login,
      memberToRestore: memberToRestore,
      restoringId: restoringId,
      askRestore: askRestore,
      confirmRestore: confirmRestore
    };
  }
}));

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Panel that holds a server-list's filter controls (Horses now; Drafts / Members next):
 * a light band that lays the controls out in one wrapping row and shows "Clear all filters"
 * when `active`. Tabs and search stay outside it, where each page already had them.
 *
 * Slot in FilterMultiselect / FilterRadioGroup — they share the `.filter-field` box, and
 * `.filter-bar__row` bottom-aligns each wrapped line so a label-less field (checkbox,
 * clear-all button) lines up with a labelled field's control when they share a row, with
 * no extra markup needed when a label-less field ends up alone on its own row.
 *
 *   <filter-bar :active="hasActiveFilters" @clear="clearFilters">
 *     <filter-multiselect ... />
 *     <filter-radio-group ... />
 *   </filter-bar>
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FilterBar',
  props: {
    // true when any filter is set — toggles the "Clear all filters" button
    active: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppMultiselect__ = __webpack_require__(29);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * One multi-value list filter: a labelled multi-select with a per-filter "Clear".
 * `value` is an array of option ids (see `trackBy`); `input` emits the same shape.
 * Pair with FilterBar + useServerList's array extraFilters / clearFilter / clearFilters.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FilterMultiselect',
  components: {
    AppMultiselect: __WEBPACK_IMPORTED_MODULE_0__components_AppMultiselect__["a" /* default */]
  },
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    optionLabel: {
      type: String,
      default: 'name'
    },
    placeholder: {
      type: String,
      default: 'Any'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fieldId: function fieldId() {
      return "filter-".concat(this.label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''));
    },
    // Ids kept as-is from the prop, compared loosely so number ids match string option ids.
    selectedIds: function selectedIds() {
      return Array.isArray(this.value) ? this.value : [];
    },
    selectedOptions: function selectedOptions() {
      var _this = this;

      return this.options.filter(function (o) {
        return _this.selectedIds.some(function (id) {
          return String(id) === String(o[_this.trackBy]);
        });
      });
    }
  },
  methods: {
    onInput: function onInput(options) {
      var _this2 = this;

      this.$emit('input', (options || []).map(function (o) {
        return o[_this2.trackBy];
      }));
    }
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a,
  props: {
    allowEmpty: {
      type: Boolean,
      default: false
    },
    selectLabel: {
      type: String,
      default: ''
    },
    selectedLabel: {
      type: String,
      default: ''
    },
    deselectLabel: {
      type: String,
      default: ''
    }
  },
  created: function created() {
    this.$on('open', this.ensureDropdownSpace);
    this.$on('open', this.attachViewportListener);
    this.$on('close', this.detachViewportListener);
  },
  beforeDestroy: function beforeDestroy() {
    this.detachViewportListener();
  },
  methods: {
    // window.innerHeight is the layout viewport - on mobile it commonly stays the same size
    // when the on-screen keyboard opens, even though the keyboard covers a large chunk of the
    // actual visible area. window.visualViewport.height tracks what's really visible (shrinks
    // when the keyboard is up), so space calculations need it to avoid sizing/positioning the
    // dropdown against space the keyboard has already covered.
    viewportHeight: function viewportHeight() {
      return window.visualViewport && window.visualViewport.height || window.innerHeight;
    },
    // Re-run while the dropdown is open in case the keyboard opens/closes after activate() -
    // e.g. the field was focused programmatically (no keyboard yet), then the user taps in to
    // type and the keyboard appears, shrinking the space the original calculation assumed.
    // Also watch document.body's size: activate() positions the dropdown against the field's
    // rect at open time, but content elsewhere on the page (e.g. a sibling row's competitor
    // name that resolves once the members list finishes loading from the store) can still grow
    // after that and push this field further down - reproduced with a field whose row shifted
    // ~50px between open and the async label arriving, leaving the already-positioned dropdown
    // sized against space that no longer exists. A body resize (from that reflow, from anywhere
    // on the page) is the general signal to recheck, not just this field's own rect.
    attachViewportListener: function attachViewportListener() {
      var _this = this;

      if (window.visualViewport) {
        this._onViewportResize = function () {
          return _this.adjustPosition();
        };

        window.visualViewport.addEventListener('resize', this._onViewportResize);
      }

      if (typeof ResizeObserver !== 'undefined') {
        this._bodyResizeObserver = new ResizeObserver(function () {
          return _this.adjustPosition();
        });

        this._bodyResizeObserver.observe(document.body);
      }
    },
    detachViewportListener: function detachViewportListener() {
      if (window.visualViewport && this._onViewportResize) {
        window.visualViewport.removeEventListener('resize', this._onViewportResize);
      }

      this._onViewportResize = null;

      if (this._bodyResizeObserver) {
        this._bodyResizeObserver.disconnect();

        this._bodyResizeObserver = null;
      }
    },
    // EXPERIMENT (not a final decision - for visual review): pick the side with more room as
    // before, but don't shrink optimizedHeight to fit whatever's actually there. Always use
    // the full maxHeight, letting the dropdown overlap neighbouring content (or even the
    // screen edge) instead of clamping down to a cramped box. Original clamped version is in
    // git history (this file, previous commit) if this doesn't look right.
    adjustPosition: function adjustPosition() {
      if (typeof window === 'undefined') return;
      var viewportHeight = this.viewportHeight();
      var spaceAbove = this.$el.getBoundingClientRect().top;
      var spaceBelow = viewportHeight - this.$el.getBoundingClientRect().bottom;
      var hasEnoughSpaceBelow = spaceBelow > this.maxHeight;

      if (hasEnoughSpaceBelow || spaceBelow > spaceAbove || this.openDirection === 'below' || this.openDirection === 'bottom') {
        this.prefferedOpenDirection = 'below';
        this.optimizedHeight = this.maxHeight;
      } else {
        this.prefferedOpenDirection = 'above';
        this.optimizedHeight = this.maxHeight;
      }
    },
    // Override of multiselectMixin's activate(): identical except the final `else` branch is
    // guarded. That branch runs when the root div is not searchable, and it's reached via the
    // div's own `@focus="activate()"` binding - so this.$el is already document.activeElement
    // at this point. Calling this.$el.focus() on an element from inside its own native `focus`
    // handler is a re-entrant focus() call, and Chromium answers it by firing a fresh
    // blur+focus pair on the same element instead of treating it as a no-op. HorseSearchSelect
    // reacts to that blur (onFocusOut -> active = false) and to the refocus (onFocusIn), which
    // calls activate() again - landing right back on this same branch forever. Reproduced with
    // a hooked focus()/blur(): EventAddDetails.vue's many-horse-select page pinned one field's
    // input at 250+ focus/blur cycles/sec with no user interaction. Skipping the call when
    // already focused removes the re-entrant trigger; every other activate() caller (keyboard,
    // a genuinely different focused element) is unaffected since the condition is only false
    // when the redundant self-focus is what would have happened.
    activate: function activate() {
      var _this2 = this;

      if (this.isOpen || this.disabled) return;
      this.adjustPosition();

      if (this.groupValues && this.pointer === 0 && this.filteredOptions.length) {
        this.pointer = 1;
      }

      this.isOpen = true;

      if (this.searchable) {
        if (!this.preserveSearch) this.search = '';
        this.$nextTick(function () {
          return _this2.$refs.search && _this2.$refs.search.focus();
        });
      } else if (document.activeElement !== this.$el) {
        this.$el.focus();
      }

      this.$emit('open', this.id);
    },
    // vue-multiselect sizes the dropdown to whatever viewport space is left above/below the
    // field at open time (adjustPosition() in multiselectMixin.js), so the same dropdown can
    // render at full height on one page and shrink down to a single option elsewhere. If
    // neither direction currently has room for a full-height dropdown, scroll the field into
    // view first so the height calculation has something reasonable to work with.
    ensureDropdownSpace: function ensureDropdownSpace() {
      var rect = this.$el.getBoundingClientRect();
      var hasSpaceBelow = this.viewportHeight() - rect.bottom >= this.maxHeight;
      var hasSpaceAbove = rect.top >= this.maxHeight;

      if (!hasSpaceBelow && !hasSpaceAbove) {
        this.$el.scrollIntoView({
          block: 'center',
          behavior: 'instant'
        });
      }

      this.adjustPosition();
    }
  }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterCheckbox_vue__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f595086_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterCheckbox_vue__ = __webpack_require__(702);
function injectStyle (ssrContext) {
  __webpack_require__(701)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f595086"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterCheckbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f595086_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterCheckbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * One independent boolean filter as a single checkbox — additive on top of whatever else is
 * selected (unlike FilterRadioGroup, which is a single-value, mutually-exclusive choice).
 * `value` / `input` travel as '' (off) / '1' (on) to match useServerList's plain-scalar
 * extraFilters convention (a real JS boolean default would always be sent, see useServerList.js).
 * Pair with FilterBar + a scalar useServerList extraFilter.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FilterCheckbox',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Boolean, Number],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checked: function checked() {
      return this.value === '1' || this.value === true || this.value === 1;
    },
    fieldId: function fieldId() {
      return "filter-cb-".concat(this.label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''));
    }
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppTooltip',
  props: {
    text: {
      type: String,
      default: ''
    },
    align: {
      type: String,
      default: 'left'
    }
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useMembersList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_members__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__composables_useServerList__ = __webpack_require__(58);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/**
 * Members list — /members (Secretary) and /admin-members (Admin/SuperAdmin) both use this, as
 * does the Horse Profile "Members" tab (CAM-1504, mirrors the Member Profile "Horses" tab —
 * CAM-1505 — in the opposite direction). Unlike Horses/Drafts there is no per-role dataset scope
 * here (the page was never member-family scoped — 'secretary' middleware just covers Secretary
 * through SuperAdmin); the only per-role difference (the Login column/action) is UI-only and
 * handled in the view via `$isAdmin`.
 *
 * @param {number|import('@vue/composition-api').Ref<number>|null} horseId  the Horse Profile
 *   "Members" tab passes the profile's horse id so the list is scoped to that horse's
 *   owners/riders and their whole account family instead of every member. Backend requires no
 *   extra gate for this param — GET /v2/members is already secretary-gated for every caller.
 */

function useMembersList() {
  var horseId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var getList = function getList(params) {
    var hid = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["o" /* unref */])(horseId);
    return __WEBPACK_IMPORTED_MODULE_1__services_api_members__["a" /* default */].getList(hid ? _objectSpread({}, params, {
      horse_id: hid
    }) : params);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2__composables_useServerList__["a" /* default */])(getList, {
    defaultSort: 'last_name',
    defaultDirection: 'asc',
    defaultPerPage: 20,
    extraFilters: {
      // 'all' | '1' (Financial) | '0' (Unfinancial) | 'Volunteer'
      financial: 'all',
      // 'all' | Onhold | Archived | Lifetime | Suspended | Deleted
      membership_status: 'all',
      // Multi-value dropdown filters (CAM-1477 follow-up) — array default => CSV in the URL/request.
      zone_id: [],
      // Current rider_status_id, as opposed to boy_status_id below.
      status_id: [],
      boy_status_id: [],
      // '' (all) | '1' (primary accounts only, hides secondaries)
      primary_only: '',
      // '' (all) | '1' (admin only — role=Secretary, i.e. a secretary who's also a member)
      secretary_members_only: '',
      // 'owner' | 'rider' | 'family' — only meaningful together with `horseId` (Horse Profile
      // "Members" tab); a no-op filter for the plain /members and /admin-members pages.
      relation: []
    },
    stringMultiFilters: ['relation']
  });
}

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ResponsiveTable__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pagination__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ListNameCell__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_api_members__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__columns__ = __webpack_require__(707);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var PER_PAGE_OPTIONS = [20, 50, 100, 200];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["c" /* defineComponent */])({
  name: 'MemberJoin',
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_2__components_ListingLayout__["a" /* default */],
    ResponsiveTable: __WEBPACK_IMPORTED_MODULE_3__components_ResponsiveTable__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_4__components_Pagination__["a" /* default */],
    ListNameCell: __WEBPACK_IMPORTED_MODULE_5__components_ListNameCell__["a" /* default */]
  },
  props: {
    primary: {
      type: Object,
      default: undefined
    }
  },
  setup: function setup(props) {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var store = proxy.$store;
    Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["g" /* onBeforeMount */])(function () {
      if (props.primary === undefined) {
        if (proxy.$isAdmin) proxy.$router.push('/admin-members');
        proxy.$router.push('/members');
      }
    }); // Deliberately NOT useServerList here (unlike Members.vue/Horses.vue): that composable syncs
    // state via `router.replace({ query })` on every search/page/sort change. This route has no
    // dynamic path segment, so vue-router's matcher (normalizeLocation/match, vue-router 3.1.5)
    // resolves a query-only replace by path and rebuilds `route.params` from scratch — wiping the
    // in-memory `primary` object this whole page depends on (it never lived in the URL, only in
    // route.params from the router.push() that opened this page). Kept as page-local state with
    // no router calls instead — this screen was never reload/bookmark-safe anyway (a hard refresh
    // already loses `primary` today, hence the existing beforeMount redirect-if-undefined below).

    var rows = Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["l" /* ref */])([]);
    var loading = Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["l" /* ref */])(false);
    var page = Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["l" /* ref */])(1);
    var totalPages = Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["l" /* ref */])(1);
    var perPageOptions = PER_PAGE_OPTIONS;
    var filters = Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["k" /* reactive */])({
      sort: 'last_name',
      direction: 'asc',
      per_page: 20,
      search: '',
      financial: 'all'
    });

    function buildParams() {
      var params = {
        page: page.value,
        per_page: filters.per_page,
        primary_only: 1
      };

      if (filters.sort) {
        params.sort = filters.sort;
        params.direction = filters.direction;
      }

      if (filters.search) params.search = filters.search;
      if (filters.financial !== 'all') params.financial = filters.financial;
      return params;
    }

    function fetch() {
      return _fetch.apply(this, arguments);
    }

    function _fetch() {
      _fetch = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var res, body, meta;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading.value = true;
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__services_api_members__["a" /* default */].getList(buildParams());

              case 4:
                res = _context.sent;
                body = res.data != null ? res.data : {};
                rows.value = body.data != null ? body.data : [];
                meta = body.meta != null ? body.meta : {};
                page.value = meta.current_page != null ? meta.current_page : 1;
                totalPages.value = meta.last_page != null ? meta.last_page : 1;
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](1);
                rows.value = [];

              case 15:
                _context.prev = 15;
                loading.value = false;
                return _context.finish(15);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 12, 15, 18]]);
      }));
      return _fetch.apply(this, arguments);
    }

    function setPage(p) {
      page.value = p;
      fetch();
    }

    function setSort(field) {
      if (filters.sort !== field) {
        filters.sort = field;
        filters.direction = 'asc';
      } else if (filters.direction === 'asc') {
        filters.direction = 'desc';
      } else {
        filters.sort = 'last_name';
        filters.direction = 'asc';
      }

      page.value = 1;
      fetch();
    }

    function setPerPage(n) {
      filters.per_page = Number(n);
      page.value = 1;
      fetch();
    }

    function setSearch(value) {
      filters.search = value || '';
      page.value = 1;
      fetch();
    }

    function setFilter(key, value) {
      filters[key] = value;
      page.value = 1;
      fetch();
    }

    var columns = Object(__WEBPACK_IMPORTED_MODULE_7__columns__["c" /* buildColumns */])();
    var breakpoints = Object(__WEBPACK_IMPORTED_MODULE_7__columns__["b" /* buildBreakpoints */])();

    function zoneCode(id) {
      var zone = (store.state.listZones || []).find(function (z) {
        return z.id === id;
      });
      return zone ? zone.code : 'Unspecified';
    } // Mirrors Members.vue's status badge (same Text.vue `showActive` rule the legacy page used
    // on this column too — see the `showActive: true` option on the old Last Name template cell).


    function statusBadgeLabel(row) {
      if (row.membership_status !== 'Active') return row.membership_status === 'Onhold' ? 'On Hold' : row.membership_status;
      return row.financial ? 'Financial' : 'Unfinancial';
    }

    function statusBadgeClass(row) {
      if (row.membership_status !== 'Active') {
        if (row.membership_status === 'Lifetime') return 'alert-info';
        if (row.membership_status === 'Archived') return 'alert-dark';
        return 'alert-danger';
      }

      return row.financial ? 'alert-info' : 'alert-warning';
    }

    var searchInput = Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["l" /* ref */])(filters.search || '');
    var searchTimer = null;

    function applySearch() {
      clearTimeout(searchTimer);
      if (searchInput.value !== filters.search) setSearch(searchInput.value);
    }

    Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["h" /* onBeforeUnmount */])(function () {
      return clearTimeout(searchTimer);
    });
    Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["p" /* watch */])(searchInput, function (val) {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
        if (val !== filters.search) setSearch(val);
      }, 500);
    }); // Selection lives here, keyed by id, entirely separate from `rows` (the currently loaded
    // page). Unlike the shared Vuex `selectedRows`/`updateSelectedRows` pattern used by
    // DataTable-based pages elsewhere (HorseRegister, NominateRookie), it survives pagination,
    // sorting and search without needing the underlying row objects to keep the same identity —
    // see the CAM-1477 part 2 task file for why that global pattern doesn't survive a refetch.

    var selected = Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["l" /* ref */])([]);

    function isSelected(id) {
      return selected.value.some(function (row) {
        return row.id === id;
      });
    }

    function toggleSelect(row) {
      var index = selected.value.findIndex(function (r) {
        return r.id === row.id;
      });
      if (index !== -1) selected.value.splice(index, 1);else selected.value.push(row);
    }

    var successMessage = Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["l" /* ref */])('');
    var errorMessage = Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["l" /* ref */])('');

    function joinMembers() {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(proxy.$api, "/admin/join"), {
        primary_id: props.primary.id,
        secondary_ids: selected.value.map(function (row) {
          return row.id;
        })
      }).then(function (response) {
        if (response.data.status === 'success') {
          proxy.$router.push({
            name: 'Member Profile',
            params: {
              details: props.primary,
              tab: 'membership',
              success: 'The members have been joined successfully.'
            }
          });
          errorMessage.value = '';
        } else if (response.data.status === 'existing_child') {
          successMessage.value = '';
          errorMessage.value = "".concat(response.data.data.map(function (obj) {
            return obj.name;
          }).join(', '), " are already part of another membership.");
        } else if (response.data.status === 'is_parent') {
          successMessage.value = '';
          errorMessage.value = "".concat(response.data.data.map(function (obj) {
            return obj.name;
          }).join(', '), " are already in another membership. Only members not in existing memberships can be joined.");
        } else if (response.data.status === 'self_join') {
          successMessage.value = '';
          errorMessage.value = "You've attempted to join a user to itself. Please select different users.";
        }
      }).catch(function (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      });
    }

    Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["i" /* onMounted */])(fetch);
    return {
      columns: columns,
      breakpoints: breakpoints,
      rows: rows,
      loading: loading,
      page: page,
      totalPages: totalPages,
      filters: filters,
      perPageOptions: perPageOptions,
      searchInput: searchInput,
      applySearch: applySearch,
      setFilter: setFilter,
      setPage: setPage,
      setSort: setSort,
      setPerPage: setPerPage,
      FINANCIAL_TABS: __WEBPACK_IMPORTED_MODULE_7__columns__["a" /* FINANCIAL_TABS */],
      zoneCode: zoneCode,
      statusBadgeLabel: statusBadgeLabel,
      statusBadgeClass: statusBadgeClass,
      selected: selected,
      isSelected: isSelected,
      toggleSelect: toggleSelect,
      successMessage: successMessage,
      errorMessage: errorMessage,
      joinMembers: joinMembers
    };
  }
}));

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_memberProfileStore_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Members_Tabs_Details__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Members_Tabs_Financials__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_MyMembership_MyMembershipMembership__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Members_Tabs_Membership__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Members_Tabs_MembershipHistory__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Members_Tabs_JudgePerformance__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Members_Tabs_BOYHistory__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Members_Tabs_Horses__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MemberProfileScore__ = __webpack_require__(783);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */
// /members/member-profile











var TAB_PANE_ROW = 'tab-pane row mx-0 show active';
var TAB_PANE_CARD = 'tab-pane col-12 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active';
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MemberProfile',
  props: ['details', 'tab', 'success', 'renewing', 'preselectedYear', 'completePaymentProfile', 'returnTo'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__store_memberProfileStore_js__["a" /* default */]],
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */]
  },
  data: function data() {
    return {
      selectedTab: this.$route.hash ? this.$route.hash.slice(1) : this.tab || 'details',
      renew: this.renewing ? this.renewing : false,
      userRole: localStorage.role,
      child: this.details ? this.details.primary ? true : false : false
    };
  },
  mounted: function mounted() {
    if (!this.renewing) {
      // Fresh visit (not coming back from the cart) — selection made for another member must not carry over
      this.$store.commit('deselectAllRows');

      if (this.child) {
        this.$store.commit('updateViewedMember', '');
      } else {
        this.$store.commit('updateChildMember', '');
      }
    }

    if (this.$route.params && this.$route.params.score) {
      // Go to score tab if coming from another score tab
      this.selectTab('score');
    }
  },
  computed: {
    showJudgePerformanceRating: function showJudgePerformanceRating() {
      var _this$memberDetails$j;

      return Boolean((_this$memberDetails$j = this.memberDetails.judge) === null || _this$memberDetails$j === void 0 ? void 0 : _this$memberDetails$j.id);
    },
    hasMemberDetails: function hasMemberDetails() {
      return Boolean(this.memberDetails);
    },
    isPrivileged: function isPrivileged() {
      return this.userRole === 'Admin' || this.userRole === 'SuperAdmin';
    },
    isSecretaryOrAdmin: function isSecretaryOrAdmin() {
      return this.isPrivileged || this.userRole === 'Secretary' || this.userRole === 'SecretaryOnly';
    },
    isMemberOrAbove: function isMemberOrAbove() {
      return this.isPrivileged || this.userRole === 'Member';
    },
    isNotVolunteer: function isNotVolunteer() {
      return this.hasMemberDetails && this.memberDetails.getedRole !== 'Volunteer';
    },
    // Single source of truth for every tab on this page — add/remove/reorder tabs here only.
    tabs: function tabs() {
      var _this = this;

      return [{
        key: 'details',
        label: 'Details',
        component: __WEBPACK_IMPORTED_MODULE_2__views_Members_Tabs_Details__["a" /* default */],
        show: true,
        props: {
          memberDetails: this.memberDetails,
          completePaymentProfile: this.completePaymentProfile,
          returnTo: this.returnTo
        },
        on: {
          renew: function renew() {
            _this.renew = true;

            _this.selectTab('membership');
          }
        },
        wrapperClass: TAB_PANE_ROW
      }, {
        key: 'membership',
        label: 'Membership',
        component: this.isPrivileged && !this.renew ? __WEBPACK_IMPORTED_MODULE_5__views_Members_Tabs_Membership__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_4__views_MyMembership_MyMembershipMembership__["a" /* default */],
        show: this.hasMemberDetails,
        props: {
          my: false,
          child: this.child,
          memberDetails: this.memberDetails,
          preselectedYear: this.preselectedYear,
          success: this.success,
          renew: this.renew
        },
        on: {
          noRenew: function noRenew() {
            _this.renew = false;
          }
        },
        wrapperClass: TAB_PANE_ROW
      }, {
        key: 'financials',
        label: 'Financials',
        component: __WEBPACK_IMPORTED_MODULE_3__views_Members_Tabs_Financials__["a" /* default */],
        show: this.hasMemberDetails && this.isMemberOrAbove && this.isNotVolunteer,
        props: {
          memberID: this.memberDetails.id
        },
        wrapperClass: TAB_PANE_CARD
      }, {
        key: 'score',
        label: 'Results',
        component: __WEBPACK_IMPORTED_MODULE_10__MemberProfileScore__["a" /* default */],
        show: this.hasMemberDetails,
        props: {},
        wrapperClass: TAB_PANE_CARD
      }, {
        key: 'history',
        label: 'History',
        component: __WEBPACK_IMPORTED_MODULE_6__views_Members_Tabs_MembershipHistory__["a" /* default */],
        show: this.hasMemberDetails && this.isMemberOrAbove && this.isNotVolunteer,
        props: {
          memberID: this.memberDetails.id,
          membership_options: this.memberDetails.membership_options
        },
        wrapperClass: TAB_PANE_CARD
      }, {
        key: 'horses',
        label: 'Horses',
        component: __WEBPACK_IMPORTED_MODULE_9__views_Members_Tabs_Horses__["a" /* default */],
        show: this.hasMemberDetails && this.isSecretaryOrAdmin,
        props: {
          memberId: this.memberDetails.id
        },
        // Wider than the other CARD tabs (col-xl-9 cap) — the filter bar + table need the room,
        // same reasoning as Details/Membership. Horses.vue provides its own card styling.
        wrapperClass: TAB_PANE_ROW
      }, {
        key: 'judge-performance',
        label: 'Judge Performance',
        component: __WEBPACK_IMPORTED_MODULE_7__views_Members_Tabs_JudgePerformance__["a" /* default */],
        show: this.hasMemberDetails && this.isPrivileged && this.showJudgePerformanceRating,
        props: {
          memberId: this.memberDetails.id
        },
        wrapperClass: TAB_PANE_CARD
      }, {
        key: 'boy-history',
        label: 'BOY History',
        component: __WEBPACK_IMPORTED_MODULE_8__views_Members_Tabs_BOYHistory__["a" /* default */],
        show: this.isPrivileged,
        props: {
          memberID: this.$route.params.slug
        },
        wrapperClass: TAB_PANE_CARD
      }];
    },
    visibleTabs: function visibleTabs() {
      return this.tabs.filter(function (t) {
        return t.show;
      });
    },
    currentTab: function currentTab() {
      var _this2 = this;

      return this.visibleTabs.find(function (t) {
        return t.key === _this2.selectedTab;
      }) || this.visibleTabs[0] || null;
    }
  },
  methods: {
    selectTab: function selectTab(key) {
      this.selectedTab = key;

      if (this.$route.hash !== "#".concat(key)) {
        this.$router.replace({
          hash: "#".concat(key)
        }).catch(function () {});
      }
    }
  },
  watch: {
    '$route': function $route(to, from) {
      // eslint-disable-line
      if (to.params.slug !== from.params.slug) {
        // Navigating to a different member — reset and refetch
        this.selectedTab = 'loading';
        this.getMemberFromAPI(to.params.slug);
      } else if (to.hash !== from.hash) {
        // Same member, tab changed (e.g. browser back/forward) — no refetch needed
        this.selectedTab = to.hash ? to.hash.slice(1) : 'details';
      }
    },
    // After getting user details from back-end, change tab off loading
    memberDetails: function memberDetails() {
      if (this.selectedTab === 'loading') {
        this.selectedTab = this.$route.hash ? this.$route.hash.slice(1) : 'details';
      }
    }
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_actingCommittee__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Members_SuperSecretaryToggle__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slide_toggle__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_legacyBrowsers_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_calcType_js__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DesktopActionBar__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ConfirmModal__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_FormFields_PhoneInput__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_PhoneBeforeFix__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_TestPhoneNumbers__ = __webpack_require__(68);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






 // import eventBus from '@/store/EventBus.js'






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MembersProfileDetails',
  props: ['memberDetails', 'split', 'my', 'completePaymentProfile', 'returnTo'],
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_formValidation_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_legacyBrowsers_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_calcType_js__["a" /* default */]],
  components: {
    TestPhoneNumbers: __WEBPACK_IMPORTED_MODULE_11__components_TestPhoneNumbers__["a" /* default */],
    PhoneInput: __WEBPACK_IMPORTED_MODULE_9__components_FormFields_PhoneInput__["a" /* default */],
    PhoneBeforeFix: __WEBPACK_IMPORTED_MODULE_10__components_PhoneBeforeFix__["a" /* default */],
    VueSlideToggle: __WEBPACK_IMPORTED_MODULE_3_vue_slide_toggle__["a" /* VueSlideToggle */],
    DesktopActionBar: __WEBPACK_IMPORTED_MODULE_7__components_DesktopActionBar__["a" /* default */],
    ConfirmModal: __WEBPACK_IMPORTED_MODULE_8__components_ConfirmModal__["a" /* default */],
    SuperSecretaryToggle: __WEBPACK_IMPORTED_MODULE_2__components_Members_SuperSecretaryToggle__["a" /* default */]
  },
  data: function data() {
    return {
      zoneLocations: [],
      zoneNotFound: false,
      zoneFound: false,
      selectedSection: this.completePaymentProfile ? 'contact' : 'details',
      success: '',
      errors: '',
      errorStatus: '',
      memberUpdate: {
        judge: {
          status: null,
          judge_email: '',
          judge_phone: '',
          is_call_first: false,
          judge_app_id: null
        },
        attributes: {
          status: null,
          address: {}
        },
        zone: {},
        dateOfBirth: '',
        guardian: {
          consent: false
        },
        vehicles: {
          registration: '',
          size: '',
          type: ''
        }
      },
      loggedInRole: localStorage.role,
      loggedInId: localStorage.userID,
      deleteConfirm: false,
      deleting: false,
      loggingIn: false,
      processing: false,
      disableField: false,
      file_name: '',
      file: '',
      file_path: '',
      exists_file_name: '',
      judge_application_file: '',
      vehicle: {
        registration: '',
        size: '',
        type: ''
      },
      vehicleErrors: ''
    };
  },
  mounted: function mounted() {
    this.initialiseMember();
    this.getZoneLocations();
  },
  watch: {
    memberDetails: {
      handler: function handler() {
        var _this$memberUpdate$at;

        this.errors = '';

        if (!this.memberUpdate.hasOwnProperty('id')) {
          this.memberUpdate = this.memberDetails;
        } else {
          this.initialiseMember();
        } // Create attributes object if it doesn't exist


        if (this.memberUpdate.attributes === null) {
          this.memberUpdate.attributes = {
            address: {}
          };
        } else if (this.memberUpdate.attributes.address === null) {
          this.memberUpdate.attributes.address = {};
        } // Create attributes object if it doesn't exist


        if (this.memberUpdate.judge === null) {
          this.memberUpdate.judge = {
            status: null,
            judge_email: '',
            judge_phone: '',
            is_call_first: false,
            judge_app_id: null
          };
        } // Create guardian object if it doesn't exist


        if (this.memberUpdate.guardian === null) {
          this.memberUpdate.guardian = {
            consent: false
          };
        }

        if (this.memberDetails.password) {
          this.password = {
            password: this.memberDetails.password,
            confirmPassword: this.memberDetails.password
          };
        }

        if ((this.loggedInRole === 'Admin' || this.loggedInRole === 'SuperAdmin') && this.memberUpdate.hasOwnProperty('user_memberships') && this.memberUpdate.user_memberships.length) {
          var effective_date = new Date(Math.max.apply(Math, _toConsumableArray(this.memberUpdate.user_memberships.map(function (e) {
            return new Date(e.effective_date);
          })))).toISOString().substring(0, 10);
          this.effective_date = effective_date;
          this.memberUpdate.effective_date = effective_date;
        }

        if (this.memberUpdate.hasOwnProperty("dateOfBirth")) {
          this.dateOfBirth = this.memberUpdate.dateOfBirth;
        } else if (this.memberDetails.hasOwnProperty("dob")) {
          this.dateOfBirth = this.memberDetails.dob;
          this.memberUpdate.dateOfBirth = this.memberDetails.dob;
        }

        if (((_this$memberUpdate$at = this.memberUpdate.attributes.bank_bsb) === null || _this$memberUpdate$at === void 0 ? void 0 : _this$memberUpdate$at.length) > 7) {
          this.memberUpdate.attributes.bank_bsb = this.memberUpdate.attributes.bank_bsb.slice(0, 7);
        }
      },
      deep: true
    }
  },
  computed: {
    phonesBeforeFix: function phonesBeforeFix() {
      return this.memberDetails && this.memberDetails.phones_before_fix || {};
    },
    deleteConfirmMessage: function deleteConfirmMessage() {
      var message = "You are about to delete ".concat(this.memberDetails.first_name, " ").concat(this.memberDetails.last_name, ". Are you sure?");

      if (this.memberDetails.primary === null && this.memberDetails.secondaries && this.memberDetails.secondaries.length > 0) {
        // TODO: cascading delete of secondary accounts is not implemented yet — this is a heads-up only for now.
        message += ' This is a primary account — deleting it will also delete all of its secondary accounts.';
      }

      return message;
    }
  },
  methods: {
    deleteMember: function deleteMember() {
      var _this = this;

      this.deleting = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("".concat(this.$api, "/v2/members/").concat(this.memberUpdate.id)).then(function () {
        _this.$router.push('/admin-members');
      }).catch(function (error) {
        _this.deleting = false;
        _this.deleteConfirm = false;
        _this.errors = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'There was a server error. Please try again later.';
      });
    },
    // Same as the "Login" column button in the members list (Members/Listing/Members.vue).
    loginAsMember: function loginAsMember() {
      var _this2 = this;

      if (this.loggingIn) return;
      this.loggingIn = true;
      var id = this.memberDetails.parent_id || this.memberDetails.id;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("".concat(this.$api, "/auth/login-as-user"), {
        id: id
      }).then(function (response) {
        if (response.data.token) {
          localStorage.setItem('bearer', response.data.token);
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.common.Authorization = "Bearer ".concat(response.data.token);
          localStorage.setItem('first_name', response.data.first_name);
          localStorage.setItem('last_name', response.data.last_name);
          localStorage.setItem('role', response.data.role);
          localStorage.setItem('userID', response.data.id);
          localStorage.setItem('is_onboarded', response.data.is_onboarded);
          Object(__WEBPACK_IMPORTED_MODULE_0__services_actingCommittee__["c" /* storeSuperSecretaryFlags */])(response.data, {
            resetSelection: true
          });

          _this2.$router.push('/');
        } else {
          _this2.loggingIn = false;
          _this2.errors = 'Unable to log in as this member.';
        }
      }).catch(function () {
        _this2.loggingIn = false;
        _this2.errors = 'Unable to log in as this member.';
      });
    },
    addVehicle: function addVehicle() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("".concat(this.$api, "/saveVehicle/"), {
        vehicle: this.vehicle,
        user_id: this.memberUpdate.id
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this3.memberUpdate.vehicles.push({
            id: response.data.vehicle.id,
            registration: response.data.vehicle.registration,
            size: response.data.vehicle.size,
            type: response.data.vehicle.type
          });

          _this3.vehicle = {
            registration: '',
            size: '',
            type: ''
          };
        } else if (response.data.status === 'validation_error' && response.data.errors['vehicle.registration']) {
          _this3.success = '';
          _this3.errorStatus = 'vehicle_registration';
          _this3.vehicleErrors = "".concat(response.data.errors['vehicle.registration'][0]);
        } else if (response.data.status === 'validation_error' && response.data.errors['vehicle.size']) {
          _this3.success = '';
          _this3.errorStatus = 'vehicle_size';
          _this3.vehicleErrors = "".concat(response.data.errors['vehicle.size'][0]);
        } else if (response.data.status === 'validation_error' && response.data.errors['vehicle.type']) {
          _this3.success = '';
          _this3.errorStatus = 'vehicle_type';
          _this3.vehicleErrors = "".concat(response.data.errors['vehicle.type'][0]);
        }
      }).catch(function () {
        _this3.vehicleErrors = 'Something went wrong. Please, reload page and try again.';
      });
    },
    removeVehicle: function removeVehicle(vehicle_id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("".concat(this.$api, "/removeVehicle/").concat(vehicle_id)).then(function (response) {
        if (response.data.status === 'success') {
          var i = _this4.memberUpdate.vehicles.map(function (item) {
            return item.id;
          }).indexOf(vehicle_id);

          _this4.memberUpdate.vehicles.splice(i, 1);
        }
      }).catch(function () {
        _this4.vehicleErrors = 'Something went wrong. Please, reload page and try again.';
      });
    },
    findZoneBy: function findZoneBy(value) {
      var _this5 = this;

      var zone = {};

      if (value === 'postcode') {
        zone = this.zoneLocations.find(function (_ref) {
          var postcode = _ref.postcode;
          return _this5.memberUpdate.attributes.address.postcode === postcode;
        }) || {};

        if (zone.suburb) {
          this.memberUpdate.attributes.address.suburb = zone.suburb;
        }
      } else if (value === 'suburb') {
        zone = this.zoneLocations.find(function (_ref2) {
          var suburb = _ref2.suburb;
          return _this5.memberUpdate.attributes.address.suburb.toUpperCase() === suburb.toUpperCase();
        }) || {};

        if (zone.postcode) {
          this.memberUpdate.attributes.address.postcode = zone.postcode;
        }
      }

      this.memberUpdate.attributes.zone_id = zone.zone_id;

      if (zone.zone_id) {
        this.zoneNotFound = false;
        this.zoneFound = true;
      } else {
        this.zoneNotFound = true;
        this.zoneFound = false;
      }
    },
    getZoneLocations: function getZoneLocations() {
      var _this6 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _ref3, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("".concat(_this6.$api, "/zone-location/list"));

              case 3:
                _ref3 = _context.sent;
                data = _ref3.data.data;
                _this6.zoneLocations = data || [];
                _context.next = 10;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }))();
    },
    initialiseMember: function initialiseMember() {
      var _this7 = this;

      if (this.memberDetails) {
        this.disableField = Number(localStorage.userID) !== this.memberDetails.id && (this.loggedInRole === 'Secretary' || this.loggedInRole === 'SecretaryOnly') && Number(localStorage.userID) !== this.memberDetails.parent_id;
        this.memberUpdate = this.memberDetails; // Create attributes object if it doesn't exist

        if (this.memberUpdate.attributes === null) {
          this.memberUpdate.attributes = {
            address: {}
          };
        } // Create guardian object if it doesn't exist


        if (this.memberUpdate.guardian === null) {
          this.memberUpdate.guardian = {
            consent: false
          };
        }

        if (this.memberDetails.password && (this.loggedInRole === 'Admin' || this.loggedInRole === 'SuperAdmin')) {
          this.password = {
            password: this.memberDetails.password,
            confirmPassword: this.memberDetails.password
          };
        }

        if (this.memberDetails.judge === null) {
          this.memberDetails.judge = {
            status: null,
            judge_email: '',
            judge_phone: '',
            is_call_first: false,
            judge_app_id: null
          };
        }

        this.file_path = this.memberDetails.age_proof_file_path;
        this.exists_file_name = this.memberDetails.age_proof_file_name;

        if (this.memberDetails.judge.judge_app_id !== null) {
          this.judge_application_file = this.memberDetails.judge_applications.find(function (app) {
            return app.id === _this7.memberDetails.judge.judge_app_id;
          }).file_path;
        }

        if (this.memberDetails.vehicles) {
          this.memberUpdate.vehicles = this.memberDetails.vehicles;
        }
      }
    },
    updateMember: function updateMember(member) {
      var _this8 = this;

      if (!this.errors) {
        if (this.file && this.file.size > 1024 * 1024) {
          this.success = '';
          this.errorStatus = 'file';
          this.errors = "The Proof of Age file may not be greater than 1 mb.";
        }

        this.processing = true;
        var formData = new FormData();
        formData.append('file', this.file);
        formData.append('fields', JSON.stringify(member));
        var postURL = this.memberDetails.primary === null ? "".concat(this.$api, "/user/").concat(this.memberUpdate.id) : "".concat(this.$api, "/update-secondary");
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(postURL, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function (response) {
          _this8.processing = false;

          if (response.data.status === 'success') {
            // Done
            _this8.success = 'The member has been updated successfully.';
            _this8.errors = '';
            _this8.errorStatus = '';
            _this8.memberDetails.getedRole = _this8.memberDetails.role;

            if (_this8.returnTo) {
              _this8.$router.push(_this8.returnTo);
            } else {
              location.reload();
            }
          } else {
            _this8.fieldsValidation(response);
          }
        }).catch(function (error) {
          _this8.processing = false;
          _this8.success = '';

          if (error.response.status === 413) {
            _this8.errorStatus = 'file';
            _this8.errors = "The Proof of Age file may not be greater than 1 mb.";
          }

          _this8.errors = 'There was a server error. Please try again later.';
          _this8.errorStatus = ''; // eslint-disable-next-line

          console.log(error);
        });
      }
    },
    splitMember: function splitMember(member) {
      var _this9 = this;

      this.processing = true;
      var formData = new FormData();
      formData.append('file', this.file);
      formData.append('fields', JSON.stringify(member));
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("".concat(this.$api, "/admin/split"), formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        _this9.processing = false;

        if (response.data.status === 'success') {
          // Done
          _this9.success = 'The member has been updated successfully.';
          _this9.errors = '';
          _this9.errorStatus = '';
          _this9.memberDetails.getedRole = _this9.memberDetails.role;
          location.reload();
        } else {
          _this9.fieldsValidation(response);
        }
      }).catch(function (error) {
        _this9.processing = false;
        _this9.success = '';
        _this9.errors = 'There was a server error. Please try again later.'; // eslint-disable-next-line

        console.log(error);
      });
    },
    update: function update(event) {
      var _this10 = this;

      event.preventDefault();
      var member = {
        id: this.memberUpdate.id,
        title: this.memberUpdate.title,
        first_name: this.memberUpdate.first_name,
        secondary_email: this.memberUpdate.secondary_email,
        secondary_phone: this.memberUpdate.secondary_phone,
        last_name: this.memberUpdate.last_name,
        dob: this.memberUpdate.dateOfBirth,
        gender: this.memberUpdate.gender,
        rider_status_id: this.memberUpdate.rider_status_id,
        membership_status: this.memberUpdate.membership_status,
        member_number: this.memberUpdate.member_number,
        membership_type_id: this.memberUpdate.membership_type_id,
        email: this.memberUpdate.attributes.email,
        phone: this.memberUpdate.attributes.phone,
        mobile_phone: this.memberUpdate.attributes.mobile_phone ? this.memberUpdate.attributes.mobile_phone : '',
        carbon_copy_mobile: this.memberUpdate.carbon_copy_mobile,
        street_1: this.memberUpdate.attributes.address.street_1,
        street_2: this.memberUpdate.attributes.address.street_2 ? this.memberUpdate.attributes.address.street_2 : null,
        suburb: this.memberUpdate.attributes.address.suburb,
        postcode: this.memberUpdate.attributes.address.postcode,
        state: this.memberUpdate.attributes.address.state,
        zone_id: this.memberUpdate.attributes.zone_id,
        primary_id: this.memberUpdate.primary ? this.memberUpdate.primary.id : null,
        notes: this.memberUpdate.notes,
        boy_status_id: this.memberUpdate.boy_status_id,
        role: this.memberUpdate.role ? this.memberUpdate.role : 'Member',
        abn: this.memberUpdate.attributes.abn,
        bank_account_name: this.memberUpdate.attributes.bank_account_name,
        bank_bsb: this.memberUpdate.attributes.bank_bsb,
        bank_account_number: this.memberUpdate.attributes.bank_account_number,
        gst_registered: this.memberDetails.attributes.gst_registered ? this.memberDetails.attributes.gst_registered : null,
        effective_date: this.memberUpdate.effective_date !== '' ? this.memberUpdate.effective_date : null,
        file_path: this.file_path,
        // Judge
        judge_status: this.memberDetails.judge ? this.memberDetails.judge.status : null,
        judge_email: this.memberUpdate.judge ? this.memberUpdate.judge.judge_email : null,
        judge_phone: this.memberUpdate.judge ? this.memberUpdate.judge.judge_phone : null,
        is_call_first: this.memberDetails.judge ? this.memberDetails.judge.is_call_first : null
      };

      if (this.password.password.length > 0) {
        member.password = this.password.password;
        member.password_confirmation = this.password.confirmPassword;
      }

      if (this.isUnder17) {
        member.guardian = this.memberUpdate.guardian;
      }

      setTimeout(function () {
        if (_this10.formComplete) {
          if (_this10.split) {
            _this10.splitMember(member);
          } else {
            _this10.updateMember(member);
          }
        }
      }, 10);
    },
    joinMembers: function joinMembers() {
      this.$store.commit('deselectAllRows');
      this.$router.push({
        name: 'Join Members',
        params: {
          primary: this.memberDetails
        }
      });
    },
    downloadAgeProofFile: function downloadAgeProofFile(user_id) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("".concat(this.$api, "/user/download/").concat(user_id)).then(function (response) {
        window.open(response.data.path, '_blank');
      });
    },
    fileUpload: function fileUpload(event) {
      this.errorStatus = '';
      this.errors = '';
      this.file_name = '';
      var uploadedFile = event.target.files[0];
      this.file = uploadedFile;

      if (uploadedFile && uploadedFile.size > 1024 * 1024) {
        this.success = '';
        this.errorStatus = 'file';
        this.errors = "The Proof of Age file may not be greater than 1 mb.";
      }

      if (uploadedFile) {
        this.file_name = uploadedFile.name;
      }
    },
    deleteAttachment: function deleteAttachment() {
      delete this.file;
      this.file = undefined;
      this.file_name = '';
      this.errorStatus = '';
      this.errors = '';
    },
    deleteExistsAttachment: function deleteExistsAttachment() {
      this.file_path = '';
      this.exists_file_name = '';
    },
    makeJudge: function makeJudge() {
      var _this11 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("".concat(this.$api, "/judges"), {
        user_id: this.memberUpdate.id,
        status: this.memberUpdate.judge.status ? this.memberUpdate.judge.status : '',
        judge_email: this.memberUpdate.judge.judge_email ? this.memberUpdate.judge.judge_email : '',
        judge_phone: this.memberUpdate.judge.judge_phone ? this.memberUpdate.judge.judge_phone : '',
        is_call_first: this.memberUpdate.judge.is_call_first
      }).then(function (response) {
        _this11.processing = false;

        if (response.data.status === 'success') {
          // Done
          _this11.success = 'The member was successfully made a judge.';
          _this11.errors = '';
          _this11.errorStatus = '';
          _this11.memberDetails.getedRole = _this11.memberDetails.role;
          location.reload();
        } else if (response.data.status === 'validation_error' && response.data.errors.judge_email) {
          _this11.success = '';
          _this11.errorStatus = 'judge_email';
          _this11.errors = "Please enter the correct email address";
        } else if (response.data.status === 'validation_error' && response.data.errors.judge_phone) {
          _this11.success = '';
          _this11.errorStatus = 'judge_phone';
          _this11.errors = "Please enter the correct mobile phone number";
        }
      });
    },
    downloadJudgeApplication: function downloadJudgeApplication(id) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("".concat(this.$api, "/admin/judges-app-download/").concat(id)).then(function (response) {
        window.open(response.data.path, '_blank');
      });
    },
    fieldsValidation: function fieldsValidation(data) {
      var _data$data4, _data$data5;

      if (data.data.status === 'validation_error') {
        var _data$data2, _data$data2$errors, _data$data3, _data$data3$errors;

        if (data.data.errors.dob) {
          // DoB
          this.success = '';
          this.errorStatus = 'dob';
          this.errors = "Please include your Date of Birth in the format".concat(this.isLegacy() ? ' yyyy-mm-dd' : ' dd/mm/yyyy', ".");
        } else if (data.data.errors.email) {
          var _data$data, _data$data$errors;

          // Email
          this.success = '';
          this.errorStatus = 'email';

          if (data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : (_data$data$errors = _data$data.errors) === null || _data$data$errors === void 0 ? void 0 : _data$data$errors.email[0]) {
            this.errors = data.data.errors.email[0];
          } else {
            this.errors = 'Please include correct email address.';
          }
        } else if (data.data.errors.secondary_phone) {
          // Phone Exists
          this.success = '';
          this.errorStatus = 'incorrect_phone';
          this.errors = "Please include correct phone number";
        } else if (data.data.errors.member_number) {
          // Member number Exists
          this.success = '';
          this.errorStatus = 'member_number';
          this.errors = "The member number has already been taken.";
        } else if (data.data.errors.mobile_phone) {
          // Mobile Phone Correct
          this.success = '';
          this.errorStatus = 'mobile_phone';
          this.errors = "Please enter correct mobile number";
        } else if (data.data.errors.bank_account_name) {
          // Bank account name is not empty
          this.success = '';
          this.errorStatus = 'bank_account_name';
          this.errors = "Please enter the bank account name";
        } else if (data.data.errors.carbon_copy_mobile) {
          // Carbon Copy Mobile Correct
          this.success = '';
          this.errorStatus = 'carbon_copy_mobile';
          this.errors = "Please enter correct CC mobile";
        } else if (data.data.errors.abn) {
          // ABN must be 11 digits
          this.success = '';
          this.errorStatus = 'abn';
          this.errors = "ABN must be 11 digits.";
        } else if (data.data.errors.secondary_email) {
          // Secondary email
          this.success = '';
          this.errorStatus = 'secondary_email';
          this.errors = "Please include correct email address.";
        } else if (data.data.errors.bank_bsb) {
          // Bank BSB must be 6 digits
          this.success = '';
          this.errorStatus = 'bank_bsb';
          this.errors = "Please enter the bank's BSB in the format XXX-YYY.";
        } else if (data.data.errors.bank_account_number) {
          // Bank Account Number
          this.success = '';
          this.errorStatus = 'bank_account_number';
          this.errors = "Please enter the correct Bank Account Number.";
        } else if (data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : (_data$data2$errors = _data$data2.errors) === null || _data$data2$errors === void 0 ? void 0 : _data$data2$errors.judge_phone) {
          // Bank Account Number
          this.success = '';
          this.errorStatus = 'judge_phone';
          this.errors = "Please enter the correct judge phone number.";
        } else if (data === null || data === void 0 ? void 0 : (_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : (_data$data3$errors = _data$data3.errors) === null || _data$data3$errors === void 0 ? void 0 : _data$data3$errors.file) {
          // Proof of Age file type
          this.success = '';
          this.errorStatus = 'file';
          this.errors = data.data.errors.file[0];
        }
      } else if ((data === null || data === void 0 ? void 0 : (_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : _data$data4.status) === 'invalid_data' && (data === null || data === void 0 ? void 0 : (_data$data5 = data.data) === null || _data$data5 === void 0 ? void 0 : _data$data5.message)) {
        // Error
        this.success = '';
        this.errors = data.data.message;
      } else {
        // Error
        this.success = '';
        this.errors = 'Please ensure all fields are completed.';
      }
    },
    validateBankAccountNumber: function validateBankAccountNumber(event) {
      var text = event.target.value.trim();
      this.memberDetails.attributes.bank_account_number = text.replace(/[^0-9]/, '');
    },
    validateBankBsb: function validateBankBsb(event) {
      var _event$data;

      var value = event.target.value.replaceAll(/[^0-9]/g, '');
      var valueLength = value.length;
      var newValue = value;

      if (event.data === '-' && valueLength < 3 || event.inputType === 'insertFromPaste' || ((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.match(/[0-9]/)) && valueLength === 3 || valueLength > 2) {
        newValue = "".concat(value.replaceAll(/[^0-9]/g, '').slice(0, 3), "-").concat(value.replaceAll(/[^0-9]/g, '').slice(3));
      }

      if ((event.inputType === 'deleteContentBackward' || event.inputType === 'deleteContentForward') && valueLength === 3 || valueLength < 3) {
        newValue = value.replaceAll(/[^0-9]/g, '');
      }

      this.memberDetails.attributes.bank_bsb = newValue;
    }
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SuperSecretaryToggle_vue__ = __webpack_require__(257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c460468_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SuperSecretaryToggle_vue__ = __webpack_require__(732);
function injectStyle (ssrContext) {
  __webpack_require__(711)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c460468"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SuperSecretaryToggle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c460468_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SuperSecretaryToggle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormFields_FCheckbox__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Docs_DocModal__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_EventBus__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_secretaries__ = __webpack_require__(239);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // Admin-only (CAM-1533). Persists on change via its own endpoint, independent of the profile
// form, and reports the outcome through the page's AppAlert (EventBus show-success / http-error).

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SuperSecretaryToggle',
  components: {
    FCheckbox: __WEBPACK_IMPORTED_MODULE_0__components_FormFields_FCheckbox__["a" /* default */],
    DocModal: __WEBPACK_IMPORTED_MODULE_1__components_Docs_DocModal__["a" /* default */]
  },
  props: {
    memberId: {
      type: [Number, String],
      required: true
    },
    value: {
      type: Boolean,
      default: false
    },
    // Show the result right of the checkbox instead of the page-level AppAlert
    inlineAlert: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      checked: this.value,
      processing: false,
      inlineMessage: null,
      messageTimer: null,
      messageSeq: 0,
      showDoc: false
    };
  },
  watch: {
    value: function value(v) {
      this.checked = v;
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.messageTimer);
  },
  methods: {
    notify: function notify(type, text) {
      var _this = this;

      if (!this.inlineAlert) {
        __WEBPACK_IMPORTED_MODULE_2__store_EventBus__["a" /* default */].$emit(type === 'success' ? 'show-success' : 'http-error', text);
        return;
      }

      clearTimeout(this.messageTimer);
      this.inlineMessage = {
        type: type,
        text: text,
        id: ++this.messageSeq
      };
      this.messageTimer = setTimeout(function () {
        _this.inlineMessage = null;
      }, 5000);
    },
    save: function save(checked) {
      var _this2 = this;

      this.processing = true; // Optimistic: the box reflects the click while the request is in flight; reverted on failure

      this.checked = checked;
      __WEBPACK_IMPORTED_MODULE_3__services_api_secretaries__["a" /* default */].setSuperSecretary(this.memberId, checked).then(function (response) {
        _this2.$emit('input', checked);

        _this2.notify('success', response.data.message || 'Super Secretary updated.');
      }).catch(function (error) {
        _this2.checked = !checked;
        var data = error.response && error.response.data;

        _this2.notify('warning', data && data.message || 'Unable to update Super Secretary. Please try again.');
      }).finally(function () {
        _this2.processing = false;
      });
    }
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppCheckbox__ = __webpack_require__(440);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FCheckbox',
  components: {
    AppCheckbox: __WEBPACK_IMPORTED_MODULE_0__components_AppCheckbox__["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: String,
    id: {
      type: String,
      required: true
    },
    disabled: Boolean,
    hint: String,
    lockIfTrue: {
      type: Boolean,
      default: false
    },
    fontNormal: {
      type: Boolean,
      default: false
    },
    required: Boolean,
    error: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      lockedOnMount: false
    };
  },
  created: function created() {
    if (this.lockIfTrue && this.value === true) {
      this.lockedOnMount = true;
    }
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppCheckbox',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    labelClass: {
      type: [String, Array, Object],
      default: null
    }
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Docs_DocContent__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__docs__ = __webpack_require__(137);
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 // A modal showing a doc (`doc` id) or an ad-hoc list of `sections`; the title defaults to the doc's.

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DocModal',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__components_Modal__["a" /* default */],
    DocContent: __WEBPACK_IMPORTED_MODULE_1__components_Docs_DocContent__["a" /* default */]
  },
  props: {
    doc: {
      type: String,
      default: null
    },
    sections: {
      type: Array,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    context: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    docTitle: function docTitle() {
      var doc = this.doc ? Object(__WEBPACK_IMPORTED_MODULE_2__docs__["b" /* getDoc */])(this.doc) : null;
      return doc ? doc.title : '';
    }
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__docs__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Docs_DocBlock__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Docs_DocAccordion__ = __webpack_require__(727);
//
//
//
//
//
//
//
//
//
//
//


 // Renders a doc (`doc` id from src/docs/docs.js) or an ad-hoc list of `sections`
// (block ids and/or accordions, same shape as in docs.js).

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DocContent',
  components: {
    DocBlock: __WEBPACK_IMPORTED_MODULE_1__components_Docs_DocBlock__["a" /* default */],
    DocAccordion: __WEBPACK_IMPORTED_MODULE_2__components_Docs_DocAccordion__["a" /* default */]
  },
  props: {
    doc: {
      type: String,
      default: null
    },
    sections: {
      type: Array,
      default: null
    },
    // Data for dynamic items, e.g. { eventTypes }
    context: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    resolvedSections: function resolvedSections() {
      var list = this.sections || (this.doc && Object(__WEBPACK_IMPORTED_MODULE_0__docs__["b" /* getDoc */])(this.doc) ? Object(__WEBPACK_IMPORTED_MODULE_0__docs__["b" /* getDoc */])(this.doc).sections : []);
      return list.map(function (section) {
        if (typeof section === 'string') return {
          block: section
        };
        var nested = section.doc && Object(__WEBPACK_IMPORTED_MODULE_0__docs__["b" /* getDoc */])(section.doc) ? Object(__WEBPACK_IMPORTED_MODULE_0__docs__["b" /* getDoc */])(section.doc).sections : section.sections;
        return {
          accordion: true,
          title: section.title,
          sections: nested || []
        };
      });
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__docs__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Docs_DocText__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Docs_DocEventTypesTable__ = __webpack_require__(723);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 // Dynamic body items ({ dynamic: 'name' }) are rendered by the components registered here.

var DYNAMIC_COMPONENTS = {
  'event-types-table': __WEBPACK_IMPORTED_MODULE_2__components_Docs_DocEventTypesTable__["a" /* default */]
}; // One reusable doc block. Pass either `id` (a block from src/docs/blocks) or a `block` object.

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DocBlock',
  components: {
    DocText: __WEBPACK_IMPORTED_MODULE_1__components_Docs_DocText__["a" /* default */]
  },
  props: {
    id: {
      type: String,
      default: null
    },
    block: {
      type: Object,
      default: null
    },
    // Data for dynamic items, e.g. { eventTypes }
    context: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    resolved: function resolved() {
      return this.block || (this.id ? Object(__WEBPACK_IMPORTED_MODULE_0__docs__["a" /* getBlock */])(this.id) : null);
    },
    dynamicComponents: function dynamicComponents() {
      return DYNAMIC_COMPONENTS;
    }
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
// Doc text with **bold** markers, rendered without v-html.
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DocText',
  props: {
    text: {
      type: String,
      required: true
    }
  },
  computed: {
    segments: function segments() {
      return this.text.split(/(\*\*[^*]+\*\*)/).filter(function (part) {
        return part !== '';
      }).map(function (part) {
        return part.startsWith('**') ? {
          bold: true,
          text: part.slice(2, -2)
        } : {
          bold: false,
          text: part
        };
      });
    }
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__docs_eventTypeDefaults__ = __webpack_require__(724);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
 // Dynamic doc element: renders from `context.eventTypes` (the event types API list), so the
// table can never drift from the defaults the form really applies. Renders nothing without it.

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DocEventTypesTable',
  props: {
    context: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    rows: function rows() {
      return (this.context.eventTypes || []).map(function (type) {
        return {
          id: type.id,
          name: type.name,
          rounds: Object(__WEBPACK_IMPORTED_MODULE_0__docs_eventTypeDefaults__["c" /* roundsText */])(type.defaults || {}),
          riders: Object(__WEBPACK_IMPORTED_MODULE_0__docs_eventTypeDefaults__["b" /* ridersText */])(type.defaults || {}),
          horses: Object(__WEBPACK_IMPORTED_MODULE_0__docs_eventTypeDefaults__["a" /* horsesText */])(type.defaults || {})
        };
      });
    }
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// A collapsible docs section (closed by default). Never submits a surrounding form.
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DocAccordion',
  props: {
    title: {
      type: String,
      required: true
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isOpen: this.open
    };
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var CALCTYPE = {
  data: function data() {
    return {
      membershipTypeOptions: []
    };
  },
  methods: {
    calcType: function calcType(index) {
      var _this = this;

      if (index === -1 && this.memberUpdate.hasOwnProperty('dateOfBirth')) {
        this.dateOfBirth = this.memberUpdate.dateOfBirth;
        this.$nextTick(function () {
          // eslint-disable-next-line
          // console.log(this.$store.state.products)
          if (_this.isUnder17 === false) {
            var tempProducts = _this.$store.state.products.filter(function (item) {
              return item.type === 'Membership' || item.type === 'Addon';
            }).filter(function (product) {
              var requirements = JSON.parse(product.requirements);

              if (requirements) {
                if (requirements.min_age && requirements.max_age) {
                  return requirements.min_age <= 17 && requirements.max_age >= 17;
                } else if (requirements.min_age) {
                  return requirements.min_age <= 17;
                } else if (requirements.max_age) {
                  return requirements.max_age >= 17;
                }
              }

              return false;
            });

            _this.membershipTypeOptions = _toConsumableArray(tempProducts);
          } else if (_this.isUnder8) {
            var _tempProducts = _this.$store.state.products.filter(function (item) {
              return item.type === 'Membership' || item.type === 'Addon';
            }).filter(function (product) {
              var requirements = JSON.parse(product.requirements);

              if (requirements) {
                if (requirements.max_age) {
                  return requirements.max_age < 8;
                }
              }

              return false;
            });

            _this.membershipTypeOptions = _toConsumableArray(_tempProducts);
          } else if (_this.isUnder13) {
            var _tempProducts2 = _this.$store.state.products.filter(function (item) {
              return item.type === 'Membership' || item.type === 'Addon';
            }).filter(function (product) {
              var requirements = JSON.parse(product.requirements);

              if (requirements) {
                if (requirements.min_age && requirements.max_age) {
                  return requirements.min_age >= 8 && requirements.max_age <= 12;
                }
              }

              return false;
            });

            _this.membershipTypeOptions = _toConsumableArray(_tempProducts2);
          } else if (_this.isUnder17) {
            var _tempProducts3 = _this.$store.state.products.filter(function (item) {
              return item.type === 'Membership' || item.type === 'Addon';
            }).filter(function (product) {
              var requirements = JSON.parse(product.requirements);

              if (requirements) {
                if (requirements.min_age && requirements.max_age) {
                  return requirements.min_age >= 13 && requirements.max_age <= 16;
                }
              }

              return false;
            });

            _this.membershipTypeOptions = _toConsumableArray(_tempProducts3);
          }
        });
      } else if (this.memberUpdate[index].hasOwnProperty('dateOfBirth')) {
        this.dateOfBirth = this.memberUpdate[index].dateOfBirth;
        this.$nextTick(function () {
          // this.$refs.membershipType[index]
          // eslint-disable-next-line
          // console.log(this.$store.state.products)
          if (_this.isUnder17 === false) {
            var tempProducts = _this.$store.state.products.filter(function (item) {
              return item.type === 'Membership' || item.type === 'Addon';
            }).filter(function (product) {
              var requirements = JSON.parse(product.requirements);

              if (requirements) {
                if (requirements.min_age && requirements.max_age) {
                  return requirements.min_age <= 17 && requirements.max_age >= 17;
                } else if (requirements.min_age) {
                  return requirements.min_age <= 17;
                } else if (requirements.max_age) {
                  return requirements.max_age >= 17;
                }
              }

              return false;
            });

            _this.membershipTypeOptions.splice(index, 1, tempProducts);
          } else if (_this.isUnder8) {
            var _tempProducts4 = _this.$store.state.products.filter(function (item) {
              return item.type === 'Membership' || item.type === 'Addon';
            }).filter(function (product) {
              var requirements = JSON.parse(product.requirements);

              if (requirements) {
                if (requirements.max_age) {
                  return requirements.max_age < 8;
                }
              }

              return false;
            });

            _this.membershipTypeOptions.splice(index, 1, _tempProducts4);
          } else if (_this.isUnder13) {
            var _tempProducts5 = _this.$store.state.products.filter(function (item) {
              return item.type === 'Membership' || item.type === 'Addon';
            }).filter(function (product) {
              var requirements = JSON.parse(product.requirements);

              if (requirements) {
                if (requirements.min_age && requirements.max_age) {
                  return requirements.min_age >= 8 && requirements.max_age <= 12;
                }
              }

              return false;
            });

            _this.membershipTypeOptions.splice(index, 1, _tempProducts5);
          } else if (_this.isUnder17) {
            var _tempProducts6 = _this.$store.state.products.filter(function (item) {
              return item.type === 'Membership' || item.type === 'Addon';
            }).filter(function (product) {
              var requirements = JSON.parse(product.requirements);

              if (requirements) {
                if (requirements.min_age && requirements.max_age) {
                  return requirements.min_age >= 13 && requirements.max_age <= 16;
                }
              }

              return false;
            });

            _this.membershipTypeOptions.splice(index, 1, _tempProducts6);
          }
        });
      }
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (CALCTYPE);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DesktopActionBar'
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ConfirmModal',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__components_Modal__["a" /* default */]
  },
  props: {
    // Fallback body; ignored when slot content is provided
    message: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
// Admin-only (the API only sends phones_before_fix to admins): read-only value a phone had before
// the CAM-1532 normalization, shown under the field so a number that went wrong can be traced back.
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PhoneBeforeFix',
  props: {
    value: {
      type: String,
      default: ''
    }
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Download__ = __webpack_require__(139);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MembersProfileFinancials',
  props: ['memberID'],
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_1__components_DataTable__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */],
    tableDownloadTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Download__["a" /* default */]
  },
  data: function data() {
    return {
      isAdmin: this.$isAdmin,
      columns: [{
        label: 'Invoice No.',
        field: 'id',
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.invoice_number\" :row=\"row\" :options=\"{}\" />"
        },
        representedAs: 'id'
      }, {
        label: 'Amount',
        field: 'total',
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"'$' + row.displayTotal\" :row=\"row\" :options=\"{ showPaid: true }\" />"
        },
        representedAs: 'total'
      }, {
        label: 'Date',
        field: 'paid_date',
        sortable: true,
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.paid_date ? new Date(row.paid_date).toLocaleString('en-AU').substring(0, 10) : new Date(row.created_at.replace(/-/g, '/')).toLocaleString('en-AU').substring(0, 10)\" :row=\"row\" :options=\"{}\" />"
        },
        representedAs: "new Date(row.paid_date).toLocaleString('en-AU').substring(0, 10)"
      }, {
        label: 'Purchase',
        field: 'type',
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.type.charAt(0).toUpperCase() + row.type.slice(1)\" :row=\"row\" :options=\"{}\" />"
        },
        representedAs: 'type'
      }, {
        label: 'Download',
        align: 'left',
        sortable: false,
        filterable: false,
        headerClass: 'column-lg-small d-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableDownloadTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Download__["a" /* default */]
          },
          template: "<tableDownloadTemplate :row=\"row\" />"
        }
      }],
      options: {
        filter: {
          status: [{
            name: 'All',
            value: 'all'
          }, {
            name: 'Paid',
            value: 'paid'
          }, {
            name: 'Pending',
            value: 'pending'
          }]
        },
        activeFilter: {
          status: 'all'
        },
        search: true,
        loaded: false
      }
    };
  },
  computed: {
    invoicesWithTotal: function invoicesWithTotal() {
      var _this = this;

      return this.$store.state.invoices.map(function (row) {
        return _objectSpread({}, row, {
          displayTotal: _this.getDisplayTotal(row)
        });
      });
    }
  },
  methods: {
    getDisplayTotal: function getDisplayTotal(row) {
      var fee = parseFloat(row.processing_fee || 0);

      if (Number.isFinite(fee) && fee > 0) {
        return row.total_with_fee;
      }

      return row.total;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/invoices/").concat(this.memberID)).then(function (response) {
      _this2.options.loaded = true;

      if (response.data.status === 'success') {
        response.data.data.map(function (item) {
          if (item.type === 'rookie-nomination') {
            var season = "".concat(item.items[0].productable.start_year, "/").concat(item.items[0].productable.start_year + 1);
            item.type = "".concat(item.type.charAt(0).toUpperCase()).concat(item.type.slice(1), "-").concat(season);
          }

          return item;
        });

        _this2.$store.commit('updateInvoices', response.data.data);
      }
    }).catch(function (error) {
      // eslint-disable-next-line
      console.log(error);
    });
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Download',
  props: ['row']
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyMembershipMembership_vue__ = __webpack_require__(273);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb6e4646_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyMembershipMembership_vue__ = __webpack_require__(744);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyMembershipMembership_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb6e4646_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyMembershipMembership_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_SelectRow__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DataTableFields_Dropdown__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DesktopActionBar__ = __webpack_require__(15);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  filters: {
    commaSeparateUsers: function commaSeparateUsers(list, index) {
      return "".concat(list[index].first_name, " ").concat(list[index].last_name).concat(index === list.length - 1 ? '' : ',');
    }
  },
  name: 'MembersProfileMembership',
  props: ['memberDetails', 'renew', 'child', 'preselectedYear'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__["a" /* default */]],
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_2__components_DataTable__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */],
    tableSelectRowTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_SelectRow__["a" /* default */],
    tableDropdownTemplate: __WEBPACK_IMPORTED_MODULE_5__components_DataTableFields_Dropdown__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_6__components_Modal__["a" /* default */],
    DesktopActionBar: __WEBPACK_IMPORTED_MODULE_7__components_DesktopActionBar__["a" /* default */]
  },
  data: function data() {
    return {
      showModal: false,
      user: localStorage.role,
      currentUser: localStorage.userID,
      showSeasonInfoModal: false,
      showSeasonConfirmModal: false,
      memberUpdate: [],
      storeMember: this.child ? this.$store.state.childMember : this.$store.state.viewedMember,
      rows: [],
      columns: [{
        label: 'First Name',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.first_name\" :link=\"'Member Profile'\" :slug=\"row.id\" :tab=\"'loading'\" :row=\"row\" :options=\"{ showLinks: true }\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.first_name);
        }
      }, {
        label: 'Last Name',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.last_name\" :link=\"'Member Profile'\" :slug=\"row.id\" :tab=\"'loading'\" :row=\"row\" :options=\"{ showLinks: true, showActive: true }\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.last_name);
        }
      }, {
        label: 'Membership No.',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        filterable: false,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.member_number\" :row=\"row\" :options=\"{ showPrimary: true }\" />"
        },
        representedAs: 'member_number'
      }, {
        label: 'Membership Type',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        filterable: false,
        sortable: this.renew ? false : true,
        component: {
          props: ['row'],
          components: {
            tableDropdownTemplate: __WEBPACK_IMPORTED_MODULE_5__components_DataTableFields_Dropdown__["a" /* default */],
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: this.renew ? "<tableDropdownTemplate :row=\"row\" :options=\"{ showIfInactive: true }\" />" : "<tableTextTemplate :row=\"row\" />"
        },
        representedAs: 'type'
      }],
      options: {
        loading: true,
        flexWrap: true
      },
      showMemberModal: false,
      processing: false,
      selectedSeason: this.preselectedYear || false
    };
  },
  mounted: function mounted() {
    this.refreshUserData();
  },
  methods: {
    deselectAll: function deselectAll() {
      this.$store.commit('deselectAllRows');
      this.$emit('noRenew');
    },
    getTotal: function getTotal() {
      this.memberUpdate.forEach(function (member) {
        member.type = member.membership_type ? member.membership_type.name : null;
        member.typeId = member.membership_type ? member.membership_type.id : null;
        member.price = member.membership_type ? member.membership_type.price : null;
      });
    },
    getProductYears: function getProductYears() {
      var products = []; // eslint-disable-line prefer-const

      var years = []; // eslint-disable-line prefer-const

      var distinctYears = []; // eslint-disable-line prefer-const

      this.rows.forEach(function (row) {
        row.product_options.forEach(function (product) {
          products.push(product);
        });
      });
      distinctYears = _toConsumableArray(new Set(products.map(function (product) {
        return product.start_year;
      })));
      distinctYears.forEach(function (year) {
        if (year) {
          var description = "January 1, ".concat(year, " to December 31, ").concat(year);
          years.push({
            year: year,
            description: description
          });
        }
      });
      return years;
    },
    setSelectedSeason: function setSelectedSeason(event) {
      this.$store.commit('deselectAllRows');
      this.rows.forEach(function (row) {
        return delete row.membership_type;
      });
      this.memberUpdate = [];
      this.selectedSeason = event.target.value;
      this.filterProductOptions(event.target.value);
    },
    filterProductOptions: function filterProductOptions(year) {
      var _this = this;

      this.rows.forEach(function (row) {
        row.filtered_product_options = row.product_options.filter(function (product) {
          return parseInt(product.start_year, 10) === parseInt(year, 10) && product.active;
        });
        row.selectedSeason = _this.selectedSeason; // row.isFinancial = row.financial_years ? row.financial_years[row.selectedSeason] : false

        row.isFinancial = row.financial;
      });
    },
    memberModal: function memberModal() {
      this.showMemberModal = true;
    },
    // Get user list
    refreshUserData: function refreshUserData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/user/").concat(this.storeMember ? this.storeMember.id : this.memberDetails.id)).then(function (response) {
        _this2.updateList(response.data.data);
      }).catch(function () {
        _this2.updateList(_this2.memberDetails);
      });
    },
    // Update user list
    updateList: function updateList(member) {
      var _pop;

      var tempRows = [];

      if (member.primary) {
        tempRows = [member.primary, member].concat(_toConsumableArray(member.primary.secondaries));
      } else {
        tempRows = [member].concat(_toConsumableArray(member.secondaries));
      }

      tempRows = tempRows.filter(function (thing, index, self) {
        return !thing.deleted_at && index === self.findIndex(function (t) {
          return t.id === thing.id;
        });
      });
      tempRows.forEach(function (row) {
        row.filtered_product_options = [];
      });
      this.rows = _toConsumableArray(tempRows);
      this.selectedSeason = this.preselectedYear || ((_pop = _toConsumableArray(this.getProductYears()).pop()) === null || _pop === void 0 ? void 0 : _pop.year);
      this.filterProductOptions(this.selectedSeason);

      if (this.renew) {
        this.memberUpdate = _toConsumableArray(this.$store.state.selectedRows);
        this.getTotal();
      } // Add checkbox field if renewing memberships


      if (this.renew) {
        this.columns.unshift({
          label: '',
          field: '',
          headerClass: 'column-lg-small d-none d-lg-table-cell',
          visible: true,
          component: {
            props: ['row'],
            components: {
              tableSelectRowTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_SelectRow__["a" /* default */]
            },
            template: "<tableSelectRowTemplate :row=\"row\" :options=\"{ showIfInactive: true }\" />"
          }
        });
      }

      this.options.loading = false;
    },
    checkSeason: function checkSeason() {
      var _this3 = this;

      this.checkValidity();
      setTimeout(function () {
        if (_this3.formComplete) {
          _this3.showSeasonConfirmModal = true;
        }
      }, 1);
    },
    checkout: function checkout() {
      var _this4 = this;

      this.processing = true;
      setTimeout(function () {
        if (_this4.$store.getters.selectedRows.length && _this4.formComplete) {
          _this4.memberUpdate = _toConsumableArray(_this4.$store.getters.selectedRows);

          _this4.memberUpdate.forEach(function (member, index) {
            _this4.$store.state.renewMembershipTypes.forEach(function (typeRow) {
              if (typeRow.id === member.id && typeRow.membership_type) {
                _this4.memberUpdate[index].membership_type = typeRow.membership_type;
                _this4.memberUpdate[index].type = typeRow.membership_type;

                _this4.$store.commit('setSelectedRows', _this4.memberUpdate);
              }
            });
          });

          var tempRows = [];
          var parentId = _this4.$store.state.selectedRows.some(function (row) {
            return row.parent_id;
          }) ? _this4.$store.state.selectedRows.find(function (row) {
            return row.parent_id;
          }).parent_id : _this4.$store.state.selectedRows[0].id;

          _this4.$store.getters.selectedRows.map(function (item, index) {
            return tempRows.splice(index, 1, item);
          });

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(_this4.$api, "/total-cart"), {
            data: tempRows.map(function (user) {
              return user.type.id;
            }),
            user_id: parentId
          }).then(function (response) {
            _this4.processing = false;

            if (response.data.status === 'success') {
              var users = response.data;
              tempRows.map(function (item) {
                // assign user attributes to every user (accessed user is the only one with these attributes)
                var tempItem = item;
                tempItem.attributes = _this4.memberDetails.attributes;
                tempItem.parent_id = parentId;
                return tempItem;
              });
              users.users = tempRows;
              users.payer_user_id = parentId;
              users.payer_email = _this4.memberDetails.attributes && _this4.memberDetails.attributes.email ? _this4.memberDetails.attributes.email : '';

              _this4.$store.commit('updateCartMembers', users);

              _this4.$router.push({
                name: 'My Membership Cart',
                params: {
                  backTo: 'pay',
                  preselectedYear: String(_this4.selectedSeason)
                }
              });
            }
          }).catch(function (error) {
            _this4.processing = false; // eslint-disable-next-line

            console.log(error);
          });
        } else {
          _this4.processing = false;
        }
      }, 10);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$emit('noRenew');
  },
  computed: {
    rowsUpdated: function rowsUpdated() {
      return this.$store.state.rowsUpdated;
    },
    selectedRows: function selectedRows() {
      return this.$store.state.selectedRows;
    },
    viewedMember: function viewedMember() {
      return this.$store.state.viewedMember;
    },
    childMember: function childMember() {
      return this.$store.state.childMember;
    }
  },
  watch: {
    selectedRows: {
      deep: true,
      handler: function handler() {
        this.memberUpdate = _toConsumableArray(this.$store.state.selectedRows);
        this.getTotal();
      }
    },
    rowsUpdated: function rowsUpdated() {
      this.memberUpdate = _toConsumableArray(this.$store.state.selectedRows);
      this.getTotal();
    },
    viewedMember: {
      deep: true,
      handler: function handler() {
        this.rows = this.renew ? this.$store.state.viewedMember ? [this.$store.state.viewedMember] : this.memberDetails.financial === 0 ? [this.memberDetails] : [] : [this.memberDetails];
        this.rows = this.rows.concat(this.renew ? this.$store.state.viewedMember ? this.$store.state.viewedMember.secondaries.filter(function (member) {
          return member.primary !== null;
        }) : this.$store.state.viewedMember.primary ? this.$store.state.viewedMember.primary.secondaries.filter(function (member) {
          return member.primary !== null;
        }) : this.memberDetails.secondaries.filter(function (member) {
          return member.financial === 0;
        }) : this.memberDetails.secondaries); // Archived (soft-deleted) primary/secondary members are never offered for payment here.

        this.rows = this.rows.filter(function (row) {
          return !row.deleted_at;
        });
      }
    },
    childMember: {
      deep: true,
      handler: function handler() {
        if (this.$isAdmin && this.child) {
          this.rows = this.renew ? this.$store.state.childMember ? [this.$store.state.childMember] : this.memberDetails.financial === 0 ? [this.memberDetails] : [] : [this.memberDetails];
          this.rows = this.rows.concat(this.renew ? this.$store.state.childMember ? this.$store.state.childMember.primary ? this.$store.state.childMember.primary.secondaries.filter(function (member) {
            return member.primary !== null;
          }) : this.$store.state.childMember.secondaries.filter(function (member) {
            return member.primary !== null;
          }) : this.memberDetails.secondaries.filter(function (member) {
            return member.financial === 0;
          }) : this.memberDetails.primary.secondaries); // Archived (soft-deleted) primary/secondary members are never offered for payment here.

          this.rows = this.rows.filter(function (row) {
            return !row.deleted_at;
          });
        }
      }
    }
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_EventBus_js__ = __webpack_require__(18);
//
//
//
//
//
//
//
 // v-show on line 2 because the condition bugs out when changing year for some reason if it's a v-if, despite the condition being identical to the one in dropdown.

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['row', 'options'],
  data: function data() {
    return {
      showIfInactive: this.options ? this.options.showIfInactive : false,
      requireFinancial: this.options ? this.options.requireFinancial : false
    };
  },
  methods: {
    selectRow: function selectRow() {
      if (this.requireFinancial && !this.row.is_financial) {
        __WEBPACK_IMPORTED_MODULE_0__store_EventBus_js__["a" /* default */].$emit('financial-error', 'The horse owner is not financial. Please renew your membership before registering this horse.');
        this.$refs.checkbox.checked = false;
        return;
      }

      __WEBPACK_IMPORTED_MODULE_0__store_EventBus_js__["a" /* default */].$emit('financial-error', '');
      this.$store.commit('updateSelectedRows', this.row);
    }
  },
  computed: {
    selected: function selected() {
      return this.$store.getters.getRowState(this.row.id);
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['row', 'options'],
  data: function data() {
    return {
      selected: '',
      required: false,
      showIfInactive: this.options ? this.options.showIfInactive : false
    };
  },
  methods: {
    selectMembership: function selectMembership() {
      var _this = this;

      var tempTypes = this.$store.state.renewMembershipTypes;

      if (tempTypes.some(function (item) {
        return item.id === _this.row.id;
      })) {
        tempTypes = tempTypes.map(function (item) {
          if (item.id === _this.row.id) {
            item.membership_type = _this.row.filtered_product_options.find(function (product) {
              return product.id === Number(_this.selected);
            });
          }

          return item;
        });
      } else {
        var tempItem = this.row;
        tempItem.membership_type = this.row.filtered_product_options.find(function (product) {
          return product.id === Number(_this.selected);
        });
        tempTypes.splice(0, 0, tempItem);
      }

      this.$store.commit('updateRenewMembershipTypes', tempTypes);

      if (!this.$store.getters.getRowState(this.row.id)) {
        this.$store.commit('updateSelectedRows', this.row);
      }

      this.$store.commit('rowsUpdatedToggle');
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      if (!_this2.$store.getters.getRowState(_this2.row.id)) {
        _this2.selected = '';
      } else {
        _this2.selected = _this2.$store.getters.selectedRows.find(function (theRow) {
          return theRow.id === _this2.row.id;
        }).typeId;

        _this2.selectMembership();
      }
    });
  },
  computed: {
    selectedRows: {
      get: function get() {
        var theRows = this.$store.getters.selectedRows;
        return theRows;
      }
    }
  },
  watch: {
    selectedRows: {
      deep: true,
      handler: function handler(theRows) {
        var _this3 = this;

        this.required = theRows.some(function (theRow) {
          return theRow.id === _this3.row.id;
        });

        if (!this.$store.getters.getRowState(this.row.id)) {
          this.selected = '';
        }
      }
    },
    row: {
      deep: true,
      handler: function handler() {
        var _this4 = this;

        this.$nextTick(function () {
          var theRow = _this4.selectedRows.some(function (row) {
            return row.id === _this4.row.id;
          });

          _this4.selected = theRow ? theRow.typeId ? theRow.typeId : '' : '';
        });
      }
    }
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Membership_vue__ = __webpack_require__(277);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19463204_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Membership_vue__ = __webpack_require__(746);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Membership_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19463204_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Membership_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Button__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_EventBus_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DesktopActionBar__ = __webpack_require__(15);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MembersProfileMembership',
  props: ['memberDetails', 'my', 'success'],
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_1__components_DataTable__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */],
    tableButtonTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Button__["a" /* default */],
    DesktopActionBar: __WEBPACK_IMPORTED_MODULE_5__components_DesktopActionBar__["a" /* default */]
  },
  data: function data() {
    return {
      rows: [],
      columns: [{
        label: 'First Name',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.first_name\" :link=\"'Member Profile'\" :slug=\"row.id\" :tab=\"'loading'\" :row=\"row\" :options=\"{ showLinks: !row.deleted_at }\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.first_name);
        }
      }, {
        label: 'Last Name',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.last_name\" :link=\"'Member Profile'\" :slug=\"row.id\" :tab=\"'loading'\" :row=\"row\" :options=\"{ showLinks: !row.deleted_at, showActive: true, showDeleted: true }\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.last_name);
        }
      }, {
        label: 'Membership No.',
        field: 'member_number',
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.member_number\" :row=\"row\" :options=\"{ showPrimary: true }\" />"
        },
        representedAs: 'member_number'
      }, {
        label: 'Action',
        field: '',
        align: 'left',
        sortable: false,
        filterable: false,
        headerClass: 'column-lg-small d-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableButtonTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Button__["a" /* default */]
          },
          template: "<tableButtonTemplate v-if=\"!row.deleted_at\" :text=\"!row.parent_id ? '' : 'Split'\" :link=\"'Member Profile Split'\" :row=\"row\" :split=\"true\" />"
        }
      }],
      options: {
        loading: true
      }
    };
  },
  mounted: function mounted() {
    this.$store.commit('deselectAllRows');

    if (this.memberDetails) {
      this.refreshUserData();
    }

    if (this.$isAdmin) {
      this.columns.splice(-1, 0, {
        label: 'Effective Date',
        field: 'effective_date',
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.effective_date ? new Date(row.effective_date).toLocaleString('en-AU').substring(0, 10) : ''\" :row=\"row\" :options=\"{ showPrimary: true }\" />"
        },
        representedAs: 'effective_date'
      });
    }
  },
  watch: {
    memberDetails: {
      handler: function handler() {
        var tempRows = [];

        if (this.memberDetails.primary) {
          tempRows = [this.memberDetails.primary, this.memberDetails].concat(_toConsumableArray(this.memberDetails.primary.secondaries));
        } else {
          tempRows = [this.memberDetails].concat(_toConsumableArray(this.memberDetails.secondaries));
        }

        tempRows = tempRows.filter(function (thing, index, self) {
          return index === self.findIndex(function (t) {
            return t.id === thing.id;
          });
        });
        this.rows = _toConsumableArray(tempRows);
      },
      deep: true
    }
  },
  methods: {
    addMembers: function addMembers() {
      __WEBPACK_IMPORTED_MODULE_4__store_EventBus_js__["a" /* default */].$emit('deselect-all');
      this.$store.commit('deselectAllRows');
      this.$router.push({
        name: 'Add Members'
      });
    },
    // Get user list
    refreshUserData: function refreshUserData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/user/").concat(this.memberDetails.id)).then(function (response) {
        _this.updateList(response.data.data);
      }).catch(function () {
        _this.updateList(_this.memberDetails);
      });
    },
    // Update user list
    updateList: function updateList(member) {
      var tempRows = [];

      if (member.primary) {
        tempRows = [member.primary, member].concat(_toConsumableArray(member.primary.secondaries));
      } else {
        tempRows = [member].concat(_toConsumableArray(member.secondaries));
      }

      tempRows = tempRows.filter(function (thing, index, self) {
        return index === self.findIndex(function (t) {
          return t.id === thing.id;
        });
      });
      tempRows.map(function (row) {
        return row.effective_date = row.user_memberships && row.user_memberships.length ? new Date(Math.max.apply(Math, _toConsumableArray(row.user_memberships.map(function (e) {
          return new Date(e.effective_date);
        })))) : null;
      });
      this.rows = _toConsumableArray(tempRows);
      this.options.loading = false;
    }
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    row: Object,
    text: String,
    link: String,
    split: Boolean,
    edit: Boolean,
    placeholder: String,
    slug: {
      default: '',
      required: false
    },
    tab: {
      default: '',
      required: false
    },
    draftId: {
      default: null,
      required: false
    },
    id: {
      default: undefined,
      required: false
    }
  },
  computed: {
    resolvedDraftId: function resolvedDraftId() {
      if (this.draftId !== null && this.draftId !== undefined) {
        return this.draftId;
      }

      if (this.link === 'Events') {
        return this.row.id;
      }

      if (this.link === 'Create Event') {
        return this.row.draft_id;
      }

      return undefined;
    },
    resolvedEventId: function resolvedEventId() {
      return this.link === 'Create Event' ? this.row.id : undefined;
    }
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_EventBus_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Button__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DataTableFields_Text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MembershipHistoryFields_MembershipType__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MembershipHistoryFields_EffectiveDate__ = __webpack_require__(749);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MembersProfileMembershipHistory',
  props: ['memberID', 'membership_options'],
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_2__components_DataTable__["a" /* default */],
    MembershipType: __WEBPACK_IMPORTED_MODULE_6__MembershipHistoryFields_MembershipType__["a" /* default */],
    EffectiveDate: __WEBPACK_IMPORTED_MODULE_7__MembershipHistoryFields_EffectiveDate__["a" /* default */],
    tableButtonTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Button__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_5__components_DataTableFields_Text__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_3__components_Modal__["a" /* default */]
  },
  data: function data() {
    return {
      rows: [],
      columns: [{
        label: 'Membership Type',
        headerClass: 'd-none d-lg-table-cell',
        filterable: false,
        sortable: false,
        visible: true,
        component: {
          props: ['row'],
          components: {
            MembershipType: __WEBPACK_IMPORTED_MODULE_6__MembershipHistoryFields_MembershipType__["a" /* default */]
          },
          template: "<MembershipType :row=\"row\" />"
        },
        representedAs: 'membership_type_id'
      }, {
        label: 'Effective Date',
        field: 'effective_date',
        sortable: false,
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            EffectiveDate: __WEBPACK_IMPORTED_MODULE_7__MembershipHistoryFields_EffectiveDate__["a" /* default */]
          },
          template: "<EffectiveDate :row=\"row\" />"
        }
      }, {
        label: 'Valid Until',
        field: 'valid_until',
        sortable: false,
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_5__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.valid_until ? new Date(row.valid_until.replace(/-/g, '/')).toLocaleString('en-AU',{year: 'numeric', month: '2-digit', day: 'numeric'}) : ' '\" :row=\"row\" />"
        }
      }, {
        label: 'Action',
        sortable: false,
        filterable: false,
        headerClass: 'column-lg-small d-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          data: function data() {
            return {
              userRole: localStorage.role
            };
          },
          methods: {
            edit: function edit(rowID) {
              __WEBPACK_IMPORTED_MODULE_1__store_EventBus_js__["a" /* default */].$emit('edit', rowID);
            },
            deleteRow: function deleteRow(rowID) {
              __WEBPACK_IMPORTED_MODULE_1__store_EventBus_js__["a" /* default */].$emit('delete', rowID);
            }
          },
          template: "\n            <div class=\"d-lg-flex\">\n              <button v-if=\"row.editable && (userRole === 'Admin' || userRole === 'SuperAdmin')\" class=\"btn btn-sm btn-primary\" @click=\"edit(row)\">\n                <div v-if=\"row.processing\" class=\"spinner-border text-light\" role=\"status\"><span class=\"sr-only\">Loading...</span></div>\n                <span v-else>{{ row.editing ? 'Save' : 'Edit' }}</span>\n              </button>\n              <button v-if=\"row.editable && (userRole === 'Admin' || userRole === 'SuperAdmin')\" class=\"btn btn-sm btn-primary ml-lg-2\" @click=\"deleteRow(row)\">\n                <div v-if=\"row.processing\" class=\"spinner-border text-light\" role=\"status\"><span class=\"sr-only\">Loading...</span></div>\n                <span v-else>Delete</span>\n              </button>\n            </div>"
        }
      }],
      options: {
        search: false,
        loaded: false
      },
      success: '',
      errors: [],
      userRole: localStorage.role,
      showModal: false,
      modalData: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.getRows(this.memberID); // Edit line

    __WEBPACK_IMPORTED_MODULE_1__store_EventBus_js__["a" /* default */].$on('edit', function (editRow) {
      _this.toggleEdit(editRow);
    });
    __WEBPACK_IMPORTED_MODULE_1__store_EventBus_js__["a" /* default */].$on('delete', function (deleteRow) {
      _this.modalData = deleteRow;
      _this.showModal = true;
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__store_EventBus_js__["a" /* default */].$off('edit');
    __WEBPACK_IMPORTED_MODULE_1__store_EventBus_js__["a" /* default */].$off('delete');
  },
  methods: {
    getRows: function getRows(memberID) {
      var _this2 = this;

      // Get history
      this.rows = [];
      this.options.loaded = false;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/user-membership/").concat(memberID)).then(function (response) {
        _this2.options.loaded = true;

        if (response.data.status === 'success') {
          _this2.rows = response.data.data.map(function (row) {
            var tempRow = row;
            tempRow.membership_options = _this2.membership_options;
            tempRow.editing = false;
            tempRow.processing = false;
            return tempRow;
          });
        }
      }).catch(function (error) {
        // eslint-disable-next-line
        console.log(error);
      });
    },
    toggleEdit: function toggleEdit(editRow) {
      if (editRow.editing) {
        this.save(editRow);
      } else {
        editRow.editing = true;
      }
    },
    add: function add() {
      this.rows = this.rows.map(function (row) {
        var tempRow = row;
        tempRow.editing = false;
        return tempRow;
      });
      this.rows.splice(0, 0, {
        user_id: this.memberID,
        membership_options: this.membership_options,
        membership_type_id: null,
        effective_date: null,
        editable: true,
        editing: true,
        processing: false
      });
    },
    save: function save(saveRow) {
      var _this3 = this;

      if (!saveRow.processing) {
        saveRow.processing = true;
        this.success = '';
        this.errors = [];
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/").concat(saveRow.id ? 'update' : 'add', "-membership"), saveRow).then(function (response) {
          saveRow.processing = false;
          saveRow.editing = false;

          if (response.data.status === 'success' || response.status === 'success') {
            _this3.success = 'Record Saved.';

            _this3.getRows(saveRow.user_id);
          } else if (response.data.status === 'validation_error' || response.data.status === 'error') {
            _this3.errors = Object.values(response.data.errors);
          }
        }).catch(function (error) {
          // eslint-disable-next-line
          console.log(error);
        });
      }
    },
    deleteRecord: function deleteRecord(deleteRow) {
      var _this4 = this;

      if (!deleteRow.processing) {
        deleteRow.processing = true;
        this.success = '';
        this.errors = [];
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/delete-membership"), {
          id: deleteRow.id
        }).then(function (response) {
          deleteRow.processing = false;

          if (response.data.status === 'success' || response.status === 'success') {
            _this4.success = 'Record Deleted.';

            _this4.getRows(deleteRow.user_id);
          } else if (response.data.status === 'validation_error') {
            _this4.errors = Object.values(response.data.errors);
          }
        }).catch(function (error) {
          // eslint-disable-next-line
          console.log(error);
        });
      }
    }
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['row'],
  data: function data() {
    return {
      userRole: localStorage.role
    };
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_legacyBrowsers_js__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['row'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_legacyBrowsers_js__["a" /* default */]],
  data: function data() {
    return {
      userRole: localStorage.role
    };
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "JudgePerformance",
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_1__components_DataTable__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
  },
  props: ['memberId'],
  data: function data() {
    return {
      rows: [],
      options: {
        filter: {},
        search: false,
        loaded: false
      },
      columns: [{
        label: 'Draft',
        sortable: false,
        headerClass: 'd-none d-lg-table-cell col-3',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.draft_name\" :row=\"row\"/>"
        }
      }, {
        label: 'Event',
        sortable: false,
        headerClass: 'd-none d-lg-table-cell col-3',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.event_name\" :slug=\"row.id\" :row=\"row\"/>"
        }
      }, {
        label: 'Average Rating',
        sortable: false,
        headerClass: 'd-none d-lg-table-cell col-2',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.rating\" :row=\"row\"/>"
        }
      }, {
        label: 'Comments',
        filterable: false,
        sortable: false,
        headerClass: 'd-none d-lg-table-cell col-4',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.comment\" :row=\"row\"/>"
        }
      }],
      success: null,
      error: null
    };
  },
  mounted: function mounted() {
    this.getJudgePerformanceRating();
  },
  methods: {
    getJudgePerformanceRating: function getJudgePerformanceRating() {
      var _this = this;

      var userId = this.memberId;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/judges/").concat(userId, "/performance-rating")).then(function (response) {
        if (response.data.status === 'success') {
          _this.error = '';
          _this.rows = response.data.data;
          _this.options.loaded = true;
        } else {
          _this.error = 'Something went wrong. Please try again later.';
        }
      }).catch(function (error) {
        // eslint-disable-next-line
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BoyStatus_BoyStatusHistoryTable__ = __webpack_require__(284);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'MemberProfileBoyHistory',
  components: {
    BoyStatusHistoryTable: __WEBPACK_IMPORTED_MODULE_1__components_BoyStatus_BoyStatusHistoryTable__["a" /* default */]
  },
  props: ['memberID']
}));

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoyStatusHistoryTable_vue__ = __webpack_require__(285);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c23ff6f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BoyStatusHistoryTable_vue__ = __webpack_require__(775);
function injectStyle (ssrContext) {
  __webpack_require__(755)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c23ff6f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoyStatusHistoryTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c23ff6f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BoyStatusHistoryTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__composables_useBoyStatusHistory__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__composables_useActionGate__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ActionGateModal__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AppAlert__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ConfirmModal__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ResponsiveTable__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_date__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BoyStatusFormModal__ = __webpack_require__(763);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









 // BOY status -> /titles-preview title id. Rider statuses map 1:1 onto their
// namesake title; horse "Rookie"/"Maiden" have no boy_status-driven title
// (Rookie Horse is granted via the horse's `rookies` flag, not this status).

var TITLE_ID_BY_BOY_STATUS = {
  rider: {
    Maiden: 8,
    Novice: 7,
    Open: 6
  },
  horse: {
    Novice: 2,
    Open: 1
  }
}; // ACA season rolls over at the start of February, matching SeasonSelect.vue

function seasonYear(dateString) {
  var date = new Date(dateString);
  return date.getUTCMonth() < 1 ? date.getUTCFullYear() - 1 : date.getUTCFullYear();
}

function buildColumns(type) {
  var columns = [{
    key: 'effective_date',
    label: 'Effective Date',
    sortable: true
  }, {
    key: 'boy',
    label: 'BOY Status'
  }, {
    key: 'status',
    label: type === 'horse' ? 'Horse Status' : 'Rider Status'
  }];
  if (type === 'horse') columns.push({
    key: 'owner',
    label: 'Owner'
  });
  if (type === 'rider') columns.push({
    key: 'zone',
    label: 'Zone'
  });
  columns.push({
    key: 'changed_by',
    label: 'Changed By'
  }, {
    key: 'actions',
    label: 'Actions',
    width: '150px'
  });
  return columns;
} // Below 560px: collapsed to an accordion. The summary line (Effective Date + BOY status)
// is always visible; the detail list repeats them alongside Status/Owner/Changed By/Actions


function buildBreakpoints(type) {
  var rows = [['effective_date'], ['boy'], ['status']];
  if (type === 'horse') rows.push(['owner']);
  if (type === 'rider') rows.push(['zone']);
  rows.push(['changed_by'], ['actions']);
  return [{
    maxWidth: 560,
    hideHeader: true,
    accordion: {
      summary: [{
        keys: ['effective_date'],
        hideLabel: true
      }, {
        keys: ['boy'],
        hideLabel: true
      }]
    },
    rows: rows
  }];
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'BoyStatusHistoryTable',
  components: {
    ActionGateModal: __WEBPACK_IMPORTED_MODULE_3__components_ActionGateModal__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_4__components_AppButton__["a" /* default */],
    AppAlert: __WEBPACK_IMPORTED_MODULE_5__components_AppAlert__["a" /* default */],
    ConfirmModal: __WEBPACK_IMPORTED_MODULE_6__components_ConfirmModal__["a" /* default */],
    ResponsiveTable: __WEBPACK_IMPORTED_MODULE_7__components_ResponsiveTable__["a" /* default */],
    BoyStatusFormModal: __WEBPACK_IMPORTED_MODULE_9__BoyStatusFormModal__["a" /* default */]
  },
  props: {
    entityId: {
      type: [String, Number],
      default: null
    },
    type: {
      type: String,
      required: true,
      validator: function validator(value) {
        return ['rider', 'horse'].includes(value);
      }
    }
  },
  setup: function setup(props) {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var _toRefs = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["n" /* toRefs */])(props),
        entityId = _toRefs.entityId;

    var columns = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return buildColumns(props.type);
    });
    var breakpoints = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return buildBreakpoints(props.type);
    });

    var _useBoyStatusHistory = Object(__WEBPACK_IMPORTED_MODULE_1__composables_useBoyStatusHistory__["a" /* default */])(props.type),
        history = _useBoyStatusHistory.history,
        loading = _useBoyStatusHistory.loading,
        statusOptions = _useBoyStatusHistory.statusOptions,
        ownerOptions = _useBoyStatusHistory.ownerOptions,
        ownerLoading = _useBoyStatusHistory.ownerLoading,
        saving = _useBoyStatusHistory.saving,
        fetch = _useBoyStatusHistory.fetch,
        fetchStatusOptions = _useBoyStatusHistory.fetchStatusOptions,
        searchOwnerOptions = _useBoyStatusHistory.searchOwnerOptions,
        seedOwnerOptions = _useBoyStatusHistory.seedOwnerOptions,
        save = _useBoyStatusHistory.save,
        clearRecalculationFlag = _useBoyStatusHistory.clearRecalculationFlag,
        remove = _useBoyStatusHistory.remove;

    var actionGate = Object(__WEBPACK_IMPORTED_MODULE_2__composables_useActionGate__["a" /* default */])();
    var formVisible = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var formError = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var editingRow = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var clearingFlagRow = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var deletingRow = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var sortField = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var sortDir = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);

    function setSort(field) {
      if (sortField.value !== field) {
        sortField.value = field;
        sortDir.value = 'asc';
      } else if (sortDir.value === 'asc') {
        sortDir.value = 'desc';
      } else {
        sortField.value = null;
        sortDir.value = null;
      }
    }

    var sortedHistory = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      if (!sortField.value) return history.value;
      var dir = sortDir.value === 'asc' ? 1 : -1;
      return _toConsumableArray(history.value).sort(function (a, b) {
        return (new Date(a[sortField.value]) - new Date(b[sortField.value])) * dir;
      });
    });

    function load(id) {
      actionGate.runGated(function () {
        return fetch(id);
      }).catch(function () {});
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      fetchStatusOptions();
      if (entityId.value != null) load(entityId.value);
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(entityId, function (id, oldId) {
      if (id != null && id !== oldId) load(id);
    });

    function openAdd() {
      editingRow.value = null;
      formError.value = null;
      formVisible.value = true;
    }

    function openEdit(row) {
      editingRow.value = row;
      formError.value = null;
      seedOwnerOptions(row.owner);
      formVisible.value = true;
    }

    function onOwnerSearch(query) {
      actionGate.runGated(function () {
        return searchOwnerOptions(entityId.value, query);
      }).catch(function () {});
    }

    function viewResults(row) {
      proxy.$router.push({
        name: props.type === 'horse' ? 'Horse BOY Affected Results' : 'Member BOY Affected Results',
        params: {
          entityId: props.entityId,
          stateId: row.id
        }
      });
    }

    function boyStatusTitleLink(row) {
      var map = props.type === 'horse' ? TITLE_ID_BY_BOY_STATUS.horse : TITLE_ID_BY_BOY_STATUS.rider;
      var titleId = map[row.boy_status.name];
      if (!titleId) return null;
      return {
        path: '/titles-preview',
        query: {
          title: String(titleId),
          year: String(seasonYear(row.effective_date))
        }
      };
    }

    function closeForm() {
      formVisible.value = false;
      editingRow.value = null;
      formError.value = null;
    }

    function extractError(err) {
      var data = err.response != null ? err.response.data : null;
      return data != null && data.message != null ? data.message : 'A server error occurred. Please try again later.';
    }

    function handleSubmit(_x) {
      return _handleSubmit.apply(this, arguments);
    }

    function _handleSubmit() {
      _handleSubmit = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(payload) {
        var stateId;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                formError.value = null;
                stateId = editingRow.value ? editingRow.value.id : null;
                _context.prev = 2;
                _context.next = 5;
                return actionGate.runGated(function () {
                  return save(entityId.value, stateId, payload);
                });

              case 5:
                closeForm();
                _context.next = 8;
                return fetch(entityId.value);

              case 8:
                _context.next = 15;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);

                if (!_context.t0.isGateCancelled) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt("return");

              case 14:
                formError.value = extractError(_context.t0);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 10]]);
      }));
      return _handleSubmit.apply(this, arguments);
    }

    function confirmClearFlag(row) {
      clearingFlagRow.value = row;
    }

    function handleClearFlag() {
      return _handleClearFlag.apply(this, arguments);
    }

    function _handleClearFlag() {
      _handleClearFlag = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var row;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                row = clearingFlagRow.value;
                _context2.prev = 1;
                _context2.next = 4;
                return actionGate.runGated(function () {
                  return clearRecalculationFlag(entityId.value, row.id);
                });

              case 4:
                clearingFlagRow.value = null;
                _context2.next = 7;
                return fetch(entityId.value);

              case 7:
                _context2.next = 11;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](1);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 9]]);
      }));
      return _handleClearFlag.apply(this, arguments);
    }

    function confirmDelete(row) {
      deletingRow.value = row;
    }

    function handleDelete() {
      return _handleDelete.apply(this, arguments);
    }

    function _handleDelete() {
      _handleDelete = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var row;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                row = deletingRow.value;
                _context3.prev = 1;
                _context3.next = 4;
                return actionGate.runGated(function () {
                  return remove(entityId.value, row.id);
                });

              case 4:
                deletingRow.value = null;
                _context3.next = 7;
                return fetch(entityId.value);

              case 7:
                _context3.next = 11;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](1);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 9]]);
      }));
      return _handleDelete.apply(this, arguments);
    }

    function rowClass(row) {
      return {
        'rtable__record--warning': row.needs_recalculation
      };
    }

    return _objectSpread({
      history: history,
      sortedHistory: sortedHistory,
      sortField: sortField,
      sortDir: sortDir,
      setSort: setSort,
      loading: loading,
      statusOptions: statusOptions,
      ownerOptions: ownerOptions,
      ownerLoading: ownerLoading,
      saving: saving,
      formVisible: formVisible,
      formError: formError,
      editingRow: editingRow,
      clearingFlagRow: clearingFlagRow,
      deletingRow: deletingRow,
      formatDate: __WEBPACK_IMPORTED_MODULE_8__utils_date__["a" /* formatDate */],
      openAdd: openAdd,
      openEdit: openEdit,
      onOwnerSearch: onOwnerSearch,
      viewResults: viewResults,
      boyStatusTitleLink: boyStatusTitleLink,
      closeForm: closeForm,
      handleSubmit: handleSubmit,
      confirmClearFlag: confirmClearFlag,
      handleClearFlag: handleClearFlag,
      confirmDelete: confirmDelete,
      handleDelete: handleDelete,
      rowClass: rowClass,
      columns: columns,
      breakpoints: breakpoints
    }, actionGate);
  }
}));

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ActionGateModal',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__components_Modal__["a" /* default */]
  },
  props: {
    error: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      password: ''
    };
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppButton',
  props: {
    type: {
      type: String,
      default: 'button'
    },
    variant: {
      type: String,
      default: 'primary'
    },
    size: {
      type: String,
      default: null
    },
    block: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes: function classes() {
      return ['btn', "btn-".concat(this.variant), this.block ? 'btn-block' : null, this.size ? "btn-".concat(this.size) : null].filter(Boolean);
    }
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppAlert_vue__ = __webpack_require__(289);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e87caa6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppAlert_vue__ = __webpack_require__(762);
function injectStyle (ssrContext) {
  __webpack_require__(761)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e87caa6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e87caa6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_EventBus__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppAlert',
  data: function data() {
    return {
      message: null,
      type: 'warning',
      timer: null
    };
  },
  created: function created() {
    var _this = this;

    this._onError = function (msg) {
      return _this.show(msg, 'warning', true);
    };

    this._onPersistentError = function (msg) {
      return _this.show(msg, 'warning', false);
    };

    this._onSuccess = function (msg) {
      return _this.show(msg, 'success', true);
    };

    __WEBPACK_IMPORTED_MODULE_0__store_EventBus__["a" /* default */].$on('http-error', this._onError);
    __WEBPACK_IMPORTED_MODULE_0__store_EventBus__["a" /* default */].$on('http-error-persistent', this._onPersistentError);
    __WEBPACK_IMPORTED_MODULE_0__store_EventBus__["a" /* default */].$on('show-success', this._onSuccess);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__store_EventBus__["a" /* default */].$off('http-error', this._onError);
    __WEBPACK_IMPORTED_MODULE_0__store_EventBus__["a" /* default */].$off('http-error-persistent', this._onPersistentError);
    __WEBPACK_IMPORTED_MODULE_0__store_EventBus__["a" /* default */].$off('show-success', this._onSuccess);
    clearTimeout(this.timer);
  },
  methods: {
    // Click on the message closes it right away
    dismiss: function dismiss() {
      clearTimeout(this.timer);
      this.message = null;
    },
    apply: function apply(msg, autoDismiss) {
      var _this2 = this;

      this.message = msg;
      this.$nextTick(function () {
        if (_this2.$el) _this2.$el.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      });

      if (autoDismiss) {
        this.timer = setTimeout(function () {
          _this2.message = null;
        }, 5000);
      }
    },
    show: function show(msg, type, autoDismiss) {
      var _this3 = this;

      clearTimeout(this.timer);
      this.type = type;

      if (this.message != null) {
        this.message = null;
        this.$nextTick(function () {
          return _this3.apply(msg, autoDismiss);
        });
      } else {
        this.apply(msg, autoDismiss);
      }
    }
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormFields_FText__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FormFields_FCheckbox__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FormFields_Base_FGroup__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FormFields_FSearchSelect__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AppMultiselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__composables_useZones__ = __webpack_require__(444);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'BoyStatusFormModal',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_1__components_Modal__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_2__components_AppButton__["a" /* default */],
    FText: __WEBPACK_IMPORTED_MODULE_3__components_FormFields_FText__["a" /* default */],
    FCheckbox: __WEBPACK_IMPORTED_MODULE_4__components_FormFields_FCheckbox__["a" /* default */],
    FGroup: __WEBPACK_IMPORTED_MODULE_5__components_FormFields_Base_FGroup__["a" /* default */],
    FSearchSelect: __WEBPACK_IMPORTED_MODULE_6__components_FormFields_FSearchSelect__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_7__components_AppMultiselect__["a" /* default */]
  },
  props: {
    type: {
      type: String,
      required: true
    },
    statusOptions: {
      type: Array,
      required: true
    },
    ownerOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    ownerLoading: {
      type: Boolean,
      default: false
    },
    saving: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    },
    editing: {
      type: Object,
      default: null
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var isEditing = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.editing != null;
    });
    var statusFieldKey = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.type === 'horse' ? 'horse_status_id' : 'rider_status_id';
    }); // Zone is rider-only. On Add New it's resolved server-side by default (checkbox ticked); on
    // Backdate there's no checkbox — it's a plain manual field, pre-filled from the entry.

    var _useZones = Object(__WEBPACK_IMPORTED_MODULE_8__composables_useZones__["a" /* default */])(),
        zoneOptions = _useZones.zones,
        zoneLoading = _useZones.loading;

    var form = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])({
      boyStatus: null,
      status: null,
      effectiveDate: '',
      owner: null,
      // owner_id (primitive) — FSearchSelect works off ids, not option objects
      useAutoZone: true,
      zone: null
    }); // Tracks the full {id, name} of whatever owner is currently chosen (start value, or
    // whatever the admin picks afterwards) — kept separate from the search-results page so a
    // fresh search (which replaces `ownerOptions` wholesale) never makes the current pick vanish
    // from the list and appear to "reset" the field.

    var selectedOwnerOption = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(props.editing && props.editing.owner ? props.editing.owner : null);

    if (props.editing) {
      var statusField = props.type === 'horse' ? props.editing.horse_status : props.editing.rider_status;
      form.boyStatus = props.statusOptions.find(function (o) {
        return o.id === props.editing.boy_status.id;
      }) || null;
      form.status = props.statusOptions.find(function (o) {
        return o.id === statusField.id;
      }) || null;
      form.effectiveDate = new Date(props.editing.effective_date).toISOString().slice(0, 10);

      if (props.type === 'horse' && props.editing.owner) {
        form.owner = props.editing.owner.id;
      }

      if (props.type === 'rider' && props.editing.zone) {
        form.zone = {
          id: props.editing.zone.id,
          name: props.editing.zone.name
        };
      }
    }

    var ownerOptionsWithSelected = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var current = selectedOwnerOption.value;
      if (!current || props.ownerOptions.some(function (o) {
        return o.id === current.id;
      })) return props.ownerOptions;
      return [current].concat(_toConsumableArray(props.ownerOptions));
    });

    function onOwnerSelect(option) {
      selectedOwnerOption.value = option;
    } // Only the pre-filled current owner can carry `deleted` (from the resource) — search
    // results from searchOwners() never include deleted members, so this is a no-op for them.


    function ownerLabel(option) {
      return option.deleted ? "".concat(option.name, " (deleted)") : option.name;
    }

    function onOwnerSearch(query) {
      emit('owner-search', query);
    } // Owner is required on Backdate (existing entry) — Add New always auto-resolves it
    // server-side and never shows the field, so it's excluded from this check.


    var ownerRequired = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.type === 'horse' && isEditing.value;
    }); // Zone is only required on Add New when the admin unticks auto-detect — Backdate's manual
    // field can be left blank (clears the zone) and Add New's auto path never shows the field.

    var zoneRequired = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.type === 'rider' && !isEditing.value && !form.useAutoZone;
    }); // Client-side "required" checks below used to fail silently (Save just did nothing) — this
    // surfaces what's missing via the same alert box used for server errors.

    var validationError = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);

    function handleSubmit() {
      var _payload;

      validationError.value = null;

      if (!form.boyStatus || !form.status || !form.effectiveDate) {
        validationError.value = 'Please fill in all required fields.';
        return;
      }

      if (ownerRequired.value && !form.owner) {
        validationError.value = 'Owner is required.';
        return;
      }

      if (zoneRequired.value && !form.zone) {
        validationError.value = 'Please select a zone, or tick "Automatically determine zone".';
        return;
      }

      var payload = (_payload = {
        boy_status_id: form.boyStatus.id
      }, _defineProperty(_payload, statusFieldKey.value, form.status.id), _defineProperty(_payload, "effective_date", form.effectiveDate), _payload);

      if (ownerRequired.value) {
        payload.owner_id = form.owner;
      }

      if (props.type === 'rider') {
        if (isEditing.value) {
          // Plain manual field — always send whatever is picked, including a deliberate clear.
          payload.zone_id = form.zone ? form.zone.id : null;
        } else {
          payload.use_auto_zone = form.useAutoZone;

          if (!form.useAutoZone) {
            payload.zone_id = form.zone.id;
          }
        }
      }

      emit('submit', payload);
    }

    return {
      form: form,
      isEditing: isEditing,
      zoneOptions: zoneOptions,
      zoneLoading: zoneLoading,
      validationError: validationError,
      ownerOptionsWithSelected: ownerOptionsWithSelected,
      onOwnerSelect: onOwnerSelect,
      onOwnerSearch: onOwnerSearch,
      ownerLabel: ownerLabel,
      handleSubmit: handleSubmit
    };
  }
}));

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Base_FGroup__ = __webpack_require__(75);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FText',
  components: {
    FGroup: __WEBPACK_IMPORTED_MODULE_0__Base_FGroup__["a" /* default */]
  },
  props: {
    value: {
      default: ''
    },
    label: String,
    id: {
      type: String,
      required: true
    },
    type: {
      default: 'text'
    },
    min: {
      default: null
    },
    max: {
      default: null
    },
    required: Boolean,
    disabled: Boolean,
    placeholder: String,
    maxlength: {
      type: [String, Number],
      default: null
    },
    pattern: {
      type: String,
      default: null
    },
    tooltip: String,
    hint: String,
    error: {
      type: String,
      default: null
    }
  },
  computed: {
    isDateType: function isDateType() {
      return this.type === 'date' || this.type === 'datetime-local';
    },
    // "-" is only ever invalid input when a non-negative min is enforced
    blocksMinus: function blocksMinus() {
      return this.type === 'number' && this.min != null && Number(this.min) >= 0;
    }
  },
  methods: {
    blockBelowMinKey: function blockBelowMinKey(event) {
      if (this.blocksMinus && event.key === '-') event.preventDefault();
    },
    onInput: function onInput(event) {
      var val = event.target.value; // Guards against a pasted negative value slipping past the keydown block above

      if (this.blocksMinus && val !== '' && Number(val) < Number(this.min)) {
        val = val.replace('-', '');
        event.target.value = val;
      } // Clamps a typed/pasted value above max — native :max only blocks the spinner, not typing


      if (this.type === 'number' && this.max != null && val !== '' && Number(val) > Number(this.max)) {
        val = String(this.max);
        event.target.value = val;
      }

      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FLabel__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FHint__ = __webpack_require__(767);
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FGroup',
  components: {
    FLabel: __WEBPACK_IMPORTED_MODULE_0__FLabel__["a" /* default */],
    FHint: __WEBPACK_IMPORTED_MODULE_1__FHint__["a" /* default */]
  },
  props: {
    label: String,
    id: String,
    required: Boolean,
    tooltip: String,
    hint: String,
    error: {
      type: String,
      default: null
    }
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FLabel',
  props: {
    label: String,
    id: String,
    required: Boolean
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FHint',
  props: {
    hint: String
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppMultiselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Base_FGroup__ = __webpack_require__(75);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Sets data-tooltip on the closest .multiselect__option row (not the slot's inner span),
// so the tooltip's hover trigger is the whole already-full-size row vue-multiselect renders —
// no CSS box-model changes needed, and no dead zone at the row's own padding/boundary.

function setOptionTooltip(el, text) {
  var row = el.closest('.multiselect__option');
  if (!row) return;

  if (text) {
    row.setAttribute('data-tooltip', text);
  } else {
    row.removeAttribute('data-tooltip');
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FSearchSelect',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_0__components_AppMultiselect__["a" /* default */],
    FGroup: __WEBPACK_IMPORTED_MODULE_1__Base_FGroup__["a" /* default */]
  },
  directives: {
    optionTooltip: {
      inserted: function inserted(el, binding) {
        setOptionTooltip(el, binding.value);
      },
      update: function update(el, binding) {
        setOptionTooltip(el, binding.value);
      }
    }
  },
  props: {
    id: {
      type: String,
      required: true
    },
    label: String,
    value: {
      default: null
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    optionLabel: {
      type: String,
      default: 'name'
    },
    customLabel: {
      type: Function,
      default: null
    },
    optionTooltip: {
      type: Function,
      default: function _default() {
        return '';
      }
    },
    placeholder: {
      type: String,
      default: 'Select...'
    },
    multiple: Boolean,
    lockedIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: Boolean,
    loadingMore: Boolean,
    disabled: Boolean,
    searchable: {
      type: Boolean,
      default: true
    },
    required: Boolean,
    showReset: {
      type: Boolean,
      default: true
    },
    resetLabel: {
      type: String,
      default: '— All —'
    },
    tooltip: String,
    hint: String,
    error: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      searchQuery: '',
      scrollEl: null,
      onScroll: null
    };
  },
  computed: {
    resetOption: function resetOption() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, this.trackBy, null), _defineProperty(_ref, this.optionLabel, this.resetLabel), _ref;
    },
    displayOptions: function displayOptions() {
      if (!this.showReset || this.required || this.multiple) return this.options;
      return [this.resetOption].concat(_toConsumableArray(this.options));
    },
    selected: function selected() {
      var _this = this;

      if (this.multiple) {
        if (!this.value || !this.value.length) return [];
        return this.options.filter(function (o) {
          return _this.value.includes(o[_this.trackBy]);
        });
      }

      if (!this.value) return null;
      return this.options.find(function (o) {
        return o[_this.trackBy] === _this.value;
      }) || null;
    },
    showTooltip: function showTooltip() {
      return this.required && !this.value;
    },
    hasTooltips: function hasTooltips() {
      var _this2 = this;

      return this.options.some(function (o) {
        return !!_this2.optionTooltip(o);
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.detachScrollListener();
  },
  methods: {
    optionText: function optionText(option) {
      if (option && option[this.trackBy] === null) return this.resetLabel;
      return this.customLabel ? this.customLabel(option) : option[this.optionLabel];
    },
    onSearchChange: function onSearchChange(query) {
      this.searchQuery = query;
      this.$emit('search-change', query);
    },
    onSelect: function onSelect(option) {
      var _this3 = this;

      if (this.multiple) {
        this.$emit('input', option ? option.map(function (o) {
          return o[_this3.trackBy];
        }) : []);
        this.$emit('select', option);
        return;
      }

      if (option && option[this.trackBy] === null) {
        this.$emit('input', null);
        this.$emit('select', null);
        return;
      }

      this.$emit('input', option ? option[this.trackBy] : null);
      this.$emit('select', option);
    },
    onOpen: function onOpen() {
      this.$emit('open');
      this.$nextTick(this.attachScrollListener);
    },
    onClose: function onClose() {
      this.detachScrollListener();
    },
    // Infinite scroll: vue-multiselect has no built-in "load more" hook, so we watch the
    // dropdown's own scroll container and emit load-more when the user nears the bottom.
    attachScrollListener: function attachScrollListener() {
      var _this4 = this;

      var root = this.$refs.multiselect && this.$refs.multiselect.$el;
      var wrapper = root && root.querySelector('.multiselect__content-wrapper');
      if (!wrapper) return;
      this.scrollEl = wrapper;

      this.onScroll = function () {
        if (wrapper.scrollHeight - wrapper.scrollTop - wrapper.clientHeight < 40) {
          _this4.$emit('load-more');
        }
      };

      wrapper.addEventListener('scroll', this.onScroll);
    },
    detachScrollListener: function detachScrollListener() {
      if (this.scrollEl && this.onScroll) {
        this.scrollEl.removeEventListener('scroll', this.onScroll);
      }

      this.scrollEl = null;
      this.onScroll = null;
    }
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ResponsiveTable__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Pagination__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_filters_FilterBar__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_filters_FilterMultiselect__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_filters_HorseMemberRelationFilter__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_HorseMemberRelationBadges__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ListNameCell__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__composables_horses_useHorsesList__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__composables_useUserRole__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Horses_Listing_columns__ = __webpack_require__(302);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'MemberProfileHorses',
  components: {
    ResponsiveTable: __WEBPACK_IMPORTED_MODULE_1__components_ResponsiveTable__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_2__components_Pagination__["a" /* default */],
    FilterBar: __WEBPACK_IMPORTED_MODULE_3__components_filters_FilterBar__["a" /* default */],
    FilterMultiselect: __WEBPACK_IMPORTED_MODULE_4__components_filters_FilterMultiselect__["a" /* default */],
    HorseMemberRelationFilter: __WEBPACK_IMPORTED_MODULE_5__components_filters_HorseMemberRelationFilter__["a" /* default */],
    HorseMemberRelationBadges: __WEBPACK_IMPORTED_MODULE_6__components_HorseMemberRelationBadges__["a" /* default */],
    ListNameCell: __WEBPACK_IMPORTED_MODULE_7__components_ListNameCell__["a" /* default */]
  },
  props: ['memberId'],
  setup: function setup(props) {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var store = proxy.$store;

    var _useUserRole = Object(__WEBPACK_IMPORTED_MODULE_9__composables_useUserRole__["a" /* default */])(),
        isAdmin = _useUserRole.isAdmin;

    var memberId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.memberId;
    });

    var _useHorsesList = Object(__WEBPACK_IMPORTED_MODULE_8__composables_horses_useHorsesList__["a" /* default */])(false, memberId),
        horses = _useHorsesList.horses,
        loading = _useHorsesList.loading,
        page = _useHorsesList.page,
        totalPages = _useHorsesList.totalPages,
        filters = _useHorsesList.filters,
        perPageOptions = _useHorsesList.perPageOptions,
        fetch = _useHorsesList.fetch,
        setPage = _useHorsesList.setPage,
        setSort = _useHorsesList.setSort,
        setPerPage = _useHorsesList.setPerPage,
        setSearch = _useHorsesList.setSearch,
        setFilter = _useHorsesList.setFilter,
        clearFilter = _useHorsesList.clearFilter,
        clearFilters = _useHorsesList.clearFilters;

    var columns = Object(__WEBPACK_IMPORTED_MODULE_10__views_Horses_Listing_columns__["c" /* buildColumns */])('secretary');
    var breakpoints = Object(__WEBPACK_IMPORTED_MODULE_10__views_Horses_Listing_columns__["b" /* buildBreakpoints */])('secretary');
    var tabs = __WEBPACK_IMPORTED_MODULE_10__views_Horses_Listing_columns__["a" /* REGISTRATION_TABS */]; // Every horse this member's account touches goes to their own /admin-horses or
    // /secretary-horses profile route, matching whichever the viewing admin/secretary has.

    var profileRoute = isAdmin ? 'Admin Horse Profile' : 'Secretary Horse Profile';
    var zoneOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return store.state.listZones || [];
    });
    var statusOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return store.state.horseStatus || [];
    });
    var hasActiveFilters = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return Boolean(filters.search) || filters.registration_state !== 'all' || filters.zone_id.length > 0 || filters.status_id.length > 0 || filters.boy_status_id.length > 0 || filters.relation.length > 0;
    });
    var searchInput = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(filters.search || '');

    function zoneCode(id) {
      var zone = store.state.listZones.find(function (z) {
        return z.id === id;
      });
      return zone ? zone.code : '';
    }

    function statusName(id) {
      var status = store.state.horseStatus.find(function (s) {
        return s.id === id;
      });
      return status ? status.name : '';
    }

    var searchTimer = null;

    function applySearch() {
      clearTimeout(searchTimer);
      if (searchInput.value !== filters.search) setSearch(searchInput.value);
    }

    function clearAll() {
      clearTimeout(searchTimer);
      searchInput.value = '';
      clearFilters();
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(searchInput, function (val) {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
        if (val !== filters.search) setSearch(val);
      }, 500);
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["h" /* onBeforeUnmount */])(function () {
      return clearTimeout(searchTimer);
    });

    function onTabChange(value) {
      setFilter('registration_state', value);
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(fetch);
    return {
      columns: columns,
      breakpoints: breakpoints,
      tabs: tabs,
      profileRoute: profileRoute,
      horses: horses,
      loading: loading,
      page: page,
      totalPages: totalPages,
      filters: filters,
      perPageOptions: perPageOptions,
      searchInput: searchInput,
      zoneOptions: zoneOptions,
      statusOptions: statusOptions,
      hasActiveFilters: hasActiveFilters,
      setPage: setPage,
      setSort: setSort,
      setPerPage: setPerPage,
      setFilter: setFilter,
      clearFilter: clearFilter,
      clearAll: clearAll,
      applySearch: applySearch,
      onTabChange: onTabChange,
      zoneCode: zoneCode,
      statusName: statusName
    };
  }
}));

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseMemberRelationFilter_vue__ = __webpack_require__(298);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_625ac13c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseMemberRelationFilter_vue__ = __webpack_require__(779);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseMemberRelationFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_625ac13c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseMemberRelationFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_horseMemberRelation__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FilterMultiselect__ = __webpack_require__(59);
//
//
//
//
//
//
//
//
//
//
//


/**
 * The `relation` (Owner/Rider/Family) filter, shared by the Member Profile "Horses" tab
 * (CAM-1505) and the Horse Profile "Members" tab (CAM-1504) — same label, placeholder and
 * options in both places, just the `relation` filter value/handlers differ per page. Wraps
 * FilterMultiselect instead of duplicating its five bound props in every consumer.
 *
 *   <horse-member-relation-filter
 *     :value="filters.relation"
 *     @input="ids => setFilter('relation', ids)"
 *     @clear="clearFilter('relation')"
 *   />
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HorseMemberRelationFilter',
  components: {
    FilterMultiselect: __WEBPACK_IMPORTED_MODULE_1__FilterMultiselect__["a" /* default */]
  },
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      options: __WEBPACK_IMPORTED_MODULE_0__constants_horseMemberRelation__["a" /* HORSE_MEMBER_RELATION_OPTIONS */]
    };
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseMemberRelationBadges_vue__ = __webpack_require__(300);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ba0f380_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseMemberRelationBadges_vue__ = __webpack_require__(781);
function injectStyle (ssrContext) {
  __webpack_require__(780)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ba0f380"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseMemberRelationBadges_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ba0f380_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseMemberRelationBadges_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/**
 * The Owner/Rider/Family badge group, shared by the Member Profile "Horses" tab (CAM-1505) and
 * the Horse Profile "Members" tab (CAM-1504) — both render it inside ListNameCell's #badges
 * slot, next to that list's own status badges. `isOwner`/`isRider` name the row's own direct
 * link; neither true means the row is visible only via another family member (see
 * HorseMemberRelation on the API side).
 *
 * `display: contents` on the wrapper (below) keeps this component invisible to layout — its
 * 1-3 badge spans become direct flex items of ListNameCell's `.list-name-cell__badges`, exactly
 * as if they were written inline there, so the existing gap/wrap CSS still applies to each badge.
 *
 *   <horse-member-relation-badges :is-owner="row.isOwner" :is-rider="row.isRider" />
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HorseMemberRelationBadges',
  props: {
    isOwner: {
      type: Boolean,
      default: false
    },
    isRider: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useHorsesList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_horses__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__composables_useServerList__ = __webpack_require__(58);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





function mapRow(h) {
  return {
    id: h.id,
    name: h.name,
    dob: h.dob,
    horseStatusId: h.horse_status_id,
    boyStatusId: h.boy_status_id,
    registrationDate: h.registration_date,
    active: h.active,
    beginningOfYearStatus: h.beginning_of_year_status,
    ownerId: h.owner_id,
    ownerName: h.owner_name,
    ownerDisplayName: h.owner_display_name,
    riders: h.riders,
    zoneId: h.zone_id,
    // Only present (true/false) when the request carried member_id — the Member Profile
    // "Horses" tab (CAM-1505). Undefined everywhere else. Both false = the member sees the
    // horse only because a family member owns/rides it (can be both true at once).
    isOwner: h.is_owner,
    isRider: h.is_rider
  };
}
/**
 * Horses list — /horses, /secretary-horses, /admin-horses and the Member Profile "Horses" tab
 * all use this. Server decides the scope from the token (+ `memberId` below); here we only
 * carry the shared table state (page / sort / per-page / search / registration tab), URL-synced
 * via useServerList.
 *
 * @param {boolean|import('@vue/composition-api').Ref<boolean>} own  the "My Horses" page passes
 *   this (a ref, so it tracks route changes when this component is reused) so a member-Secretary
 *   sees only their own horses there — they still get the whole register on /secretary-horses.
 *   Not user-facing, fixed per page.
 * @param {number|import('@vue/composition-api').Ref<number>|null} memberId  the Member Profile
 *   "Horses" tab passes the profile's member id so a secretary/admin sees THAT member's family
 *   instead of the whole register. Mutually exclusive with `own`. Backend rejects this param for
 *   anyone below secretary (HorseIndexRequest::authorize()).
 */


function useHorsesList() {
  var own = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var memberId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var getList = function getList(params) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["o" /* unref */])(own)) return __WEBPACK_IMPORTED_MODULE_1__services_api_horses__["a" /* default */].getList(_objectSpread({}, params, {
      own: 1
    }));
    var mid = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["o" /* unref */])(memberId);
    return __WEBPACK_IMPORTED_MODULE_1__services_api_horses__["a" /* default */].getList(mid ? _objectSpread({}, params, {
      member_id: mid
    }) : params);
  };

  var list = Object(__WEBPACK_IMPORTED_MODULE_2__composables_useServerList__["a" /* default */])(getList, {
    defaultSort: 'name',
    defaultDirection: 'asc',
    defaultPerPage: 20,
    // Array defaults => multi-value filters: CSV in the URL / request, number[] in state
    // (string[] for `relation`, see stringMultiFilters below).
    extraFilters: {
      registration_state: 'all',
      active: '',
      // '' = all, '1' = active, '0' = archived
      zone_id: [],
      status_id: [],
      boy_status_id: [],
      // 'owner' | 'rider' | 'family' — only meaningful together with `memberId` (Member Profile
      // "Horses" tab); a no-op filter for the other three pages, which never render its control.
      relation: []
    },
    stringMultiFilters: ['relation']
  });
  var horses = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return list.rows.value.map(mapRow);
  });
  return _objectSpread({}, list, {
    horses: horses
  });
}

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = buildColumns;
/* harmony export (immutable) */ __webpack_exports__["b"] = buildBreakpoints;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REGISTRATION_TABS; });
// Column keys double as the backend sort keys (HorseFilters::SORTABLE) so ResponsiveTable's
// sort arrows light up against `filters.sort` with no translation layer.
function buildColumns(variant) {
  var columns = [{
    key: 'name',
    label: 'Horse Name',
    sortable: true,
    minWidth: '160px'
  }, {
    key: 'owner_name',
    label: 'Owner',
    sortable: true,
    minWidth: '140px'
  }, {
    key: 'zone_id',
    label: 'Zone',
    sortable: true,
    width: '90px'
  }, {
    key: 'beginning_of_year_status',
    label: 'BoY Status',
    sortable: true,
    width: '100px'
  }, {
    key: 'horse_status_id',
    label: 'Status',
    sortable: true,
    width: '90px'
  }];

  if (variant === 'admin') {
    // Fixed, not `max-content`: each rtable__line (header, each row) is its own independent
    // CSS Grid, so a content-sized track is computed per line and drifts out of alignment —
    // the header's "Remove" label and a row's (shrunk, see .remove-btn) button aren't the
    // same width. A shared px value is what keeps every line's column edges lined up.
    columns.push({
      key: 'remove',
      label: 'Remove',
      width: '80px',
      cellClass: 'text-left'
    });
  }

  return columns;
} // Below 700px the row collapses into an accordion: the horse name stays visible, the rest
// drops into the expanded detail — matching the legacy DataTable expandedHeader / expandedRow.

function buildBreakpoints(variant) {
  var rows = [['owner_name'], ['zone_id'], ['beginning_of_year_status'], ['horse_status_id']];
  if (variant === 'admin') rows.push(['remove']);
  return [{
    maxWidth: 700,
    hideHeader: true,
    accordion: {
      summary: [{
        keys: ['name'],
        hideLabel: true
      }]
    },
    rows: rows
  }];
}
var REGISTRATION_TABS = [{
  value: 'all',
  label: 'All'
}, {
  value: 'registered',
  label: 'Registered'
}, {
  value: 'unregistered',
  label: 'Unregistered'
}];

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataTableFields_Text__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MemberProfileScore',
  components: {
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_1__components_DataTableFields_Text__["a" /* default */]
  },
  data: function data() {
    return {
      results: {},
      errors: '',
      loaded: false
    };
  },
  methods: {
    getResults: function getResults(id) {
      var _this = this;

      this.errors = '';
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/results-rider/").concat(id)).then(function (response) {
        _this.loaded = true;

        if (response.data.status === 'success' && response.data.data !== null) {
          _this.tweakResults(response.data.data);
        } else {
          _this.errors = 'There was a server error. Please contact us.';
        }
      }).catch(function () {
        _this.loaded = true;
        _this.errors = 'There was a server error. Please contact us.';
      });
    },
    tweakResults: function tweakResults(theData) {
      // Put results in to a usable format
      var tempResults = {};

      if (Array.isArray(theData.results)) {
        theData.results.forEach(function (result) {
          if (typeof tempResults[result.year] === 'undefined') {
            tempResults[result.year] = [result];
          } else {
            tempResults[result.year].push(result);
          }
        });
      } else {
        Object.keys(theData.results).forEach(function (key) {
          if (typeof tempResults[theData.results[key].year] === 'undefined') {
            tempResults[theData.results[key].year] = [theData.results[key]];
          } else {
            tempResults[theData.results[key].year].push(theData.results[key]);
          }
        });
      }

      this.results = tempResults;
    }
  },
  computed: {
    memberId: function memberId() {
      return this.$route.params.slug;
    }
  },
  mounted: function mounted() {
    this.getResults(this.memberId);
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_memberProfileStore_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Members_Tabs_Details__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Members_Tabs_Financials__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Members_Tabs_Membership__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Members_Tabs_MembershipHistory__ = __webpack_require__(88);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MemberProfileChild',
  props: ['details'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__store_memberProfileStore_js__["a" /* default */]],
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    'member-profile-details': __WEBPACK_IMPORTED_MODULE_2__views_Members_Tabs_Details__["a" /* default */],
    'member-profile-membership': __WEBPACK_IMPORTED_MODULE_4__views_Members_Tabs_Membership__["a" /* default */],
    'member-profile-financials': __WEBPACK_IMPORTED_MODULE_3__views_Members_Tabs_Financials__["a" /* default */],
    'member-profile-history': __WEBPACK_IMPORTED_MODULE_5__views_Members_Tabs_MembershipHistory__["a" /* default */]
  },
  data: function data() {
    return {
      selectedTab: 'details',
      child: true,
      primaryMember: this.$store.state.viewedMember,
      userRole: localStorage.role
    };
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_memberProfileStore_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ResponsiveTable__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Pagination__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ListNameCell__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_api_members__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__columns__ = __webpack_require__(789);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */
// TODO feature/OSESD-837: Add merge button in confirmation modal connecting to BE logic - check BE connection










var PER_PAGE_OPTIONS = [20, 50, 100, 200];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MemberMerge',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__store_memberProfileStore_js__["a" /* default */]],
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_3__components_ListingLayout__["a" /* default */],
    ResponsiveTable: __WEBPACK_IMPORTED_MODULE_4__components_ResponsiveTable__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_5__components_Pagination__["a" /* default */],
    ListNameCell: __WEBPACK_IMPORTED_MODULE_6__components_ListNameCell__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_7__components_Modal__["a" /* default */]
  },
  // Mirrors views/Members/Join/MemberJoin.vue's server-paginated picker table (same
  // ResponsiveTable + Pagination + checkbox shape) instead of the old unbounded GET /users dump.
  // Unlike MemberJoin, this route has a real path segment (`/members/:slug/merge`), so there's no
  // risk of `router.replace({query})` wiping route.params — but state still isn't URL-synced here,
  // matching the legacy page (its client-side vuejs-datatable pagination was never URL-persisted
  // either).
  setup: function setup() {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var store = proxy.$store;
    var rows = Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["l" /* ref */])([]);
    var loading = Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["l" /* ref */])(false);
    var page = Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["l" /* ref */])(1);
    var totalPages = Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["l" /* ref */])(1);
    var perPageOptions = PER_PAGE_OPTIONS;
    var filters = Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["k" /* reactive */])({
      sort: 'last_name',
      direction: 'asc',
      per_page: 20,
      search: ''
    });

    function buildParams() {
      // The legacy GET /users picker only ever returned primary accounts (secondaries have no
      // row of their own in user_attributes, the table that query was driven from) — keep that
      // scope so merge targets match what the page showed before.
      var params = {
        page: page.value,
        per_page: filters.per_page,
        primary_only: 1
      };

      if (filters.sort) {
        params.sort = filters.sort;
        params.direction = filters.direction;
      }

      if (filters.search) params.search = filters.search;
      return params;
    }

    function fetch() {
      return _fetch.apply(this, arguments);
    }

    function _fetch() {
      _fetch = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var res, body, meta;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading.value = true;
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_api_members__["a" /* default */].getList(buildParams());

              case 4:
                res = _context.sent;
                body = res.data != null ? res.data : {};
                rows.value = body.data != null ? body.data : [];
                meta = body.meta != null ? body.meta : {};
                page.value = meta.current_page != null ? meta.current_page : 1;
                totalPages.value = meta.last_page != null ? meta.last_page : 1;
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](1);
                rows.value = [];

              case 15:
                _context.prev = 15;
                loading.value = false;
                return _context.finish(15);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 12, 15, 18]]);
      }));
      return _fetch.apply(this, arguments);
    }

    function setPage(p) {
      page.value = p;
      fetch();
    }

    function setSort(field) {
      if (filters.sort !== field) {
        filters.sort = field;
        filters.direction = 'asc';
      } else if (filters.direction === 'asc') {
        filters.direction = 'desc';
      } else {
        filters.sort = 'last_name';
        filters.direction = 'asc';
      }

      page.value = 1;
      fetch();
    }

    function setPerPage(n) {
      filters.per_page = Number(n);
      page.value = 1;
      fetch();
    }

    function setSearch(value) {
      filters.search = value || '';
      page.value = 1;
      fetch();
    }

    var columns = Object(__WEBPACK_IMPORTED_MODULE_9__columns__["b" /* buildColumns */])();
    var breakpoints = Object(__WEBPACK_IMPORTED_MODULE_9__columns__["a" /* buildBreakpoints */])();

    function zoneCode(id) {
      var zone = (store.state.listZones || []).find(function (z) {
        return z.id === id;
      });
      return zone ? zone.code : '';
    }

    var searchInput = Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["l" /* ref */])(filters.search || '');
    var searchTimer = null;

    function applySearch() {
      clearTimeout(searchTimer);
      if (searchInput.value !== filters.search) setSearch(searchInput.value);
    }

    Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["h" /* onBeforeUnmount */])(function () {
      return clearTimeout(searchTimer);
    });
    Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["p" /* watch */])(searchInput, function (val) {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
        if (val !== filters.search) setSearch(val);
      }, 500);
    });
    Object(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api__["i" /* onMounted */])(fetch);
    return {
      columns: columns,
      breakpoints: breakpoints,
      rows: rows,
      loading: loading,
      page: page,
      totalPages: totalPages,
      filters: filters,
      perPageOptions: perPageOptions,
      searchInput: searchInput,
      applySearch: applySearch,
      setPage: setPage,
      setSort: setSort,
      setPerPage: setPerPage,
      zoneCode: zoneCode,
      fetch: fetch
    };
  },
  data: function data() {
    return {
      success: '',
      errors: '',
      removeMember: {},
      showModal: false
    };
  },
  computed: {
    memberZone: function memberZone() {
      var _this = this;

      var tempKeepMember = this.$store.state.listZones.find(function (zone) {
        return zone.id === (_this.memberDetails.zone_id || _this.memberDetails.attributes && _this.memberDetails.attributes.zone_id);
      });
      return this.$store.state.listZones.length ? tempKeepMember ? tempKeepMember.code : '' : '';
    },
    removeMemberZone: function removeMemberZone() {
      return Object.keys(this.removeMember).length ? this.zoneCode(this.removeMember.zone_id) : '';
    },
    // The member being kept must never also appear as a selectable merge target.
    visibleRows: function visibleRows() {
      var _this2 = this;

      return this.rows.filter(function (row) {
        return row.id !== _this2.memberDetails.id;
      });
    }
  },
  watch: {
    // When changing user, get new user details from back-end
    '$route': function $route(to, from) {
      // eslint-disable-line
      if (to.params && to.params.slug) {
        this.getMemberFromAPI(to.params.slug);
      }
    }
  },
  methods: {
    isSelected: function isSelected(id) {
      return this.removeMember.id === id;
    },
    // Checkbox visuals, but only one member can ever be the merge target — checking a new row
    // replaces the previous selection (same "last one wins" behaviour the legacy DataTable
    // enforced via its selectedRows watcher).
    toggleSelect: function toggleSelect(row) {
      this.removeMember = this.isSelected(row.id) ? {} : row;
    },
    deselectAll: function deselectAll() {
      this.removeMember = {};
    },
    mergeMembers: function mergeMembers() {
      var _this3 = this;

      this.success = '';
      this.errors = '';
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/merge-members/").concat(this.memberDetails.id, "/").concat(this.removeMember.id)).then(function (response) {
        _this3.deselectAll();

        if (response.data.status === 'success') {
          _this3.success = 'Members were merged successfully.';

          _this3.fetch();
        } else {
          _this3.errors = 'There was an error. Please contact support.';
        }
      }).catch(function (error) {
        // eslint-disable-next-line
        console.log(error.response);
        _this3.errors = error.response.data.error || 'There was an error. Please contact support.';
      });
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Members_Tabs_Details__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_memberProfileStore_js__ = __webpack_require__(25);
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MemberProfile',
  props: ['details'],
  mixins: [__WEBPACK_IMPORTED_MODULE_2__store_memberProfileStore_js__["a" /* default */]],
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    'member-profile-details': __WEBPACK_IMPORTED_MODULE_1__views_Members_Tabs_Details__["a" /* default */]
  },
  data: function data() {
    return {
      selectedTab: 'details',
      split: true,
      child: true
    };
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Button__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DataTableFields_Download__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_EventBus_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_legacyBrowsers_js__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PendingInvoices',
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_legacyBrowsers_js__["a" /* default */]],
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__["a" /* default */],
    'data-table': __WEBPACK_IMPORTED_MODULE_2__components_DataTable__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */],
    tableButtonTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Button__["a" /* default */],
    tableDownloadTemplate: __WEBPACK_IMPORTED_MODULE_5__components_DataTableFields_Download__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_6__components_Modal__["a" /* default */]
  },
  data: function data() {
    return {
      rows: [],
      rowID: 0,
      success: '',
      error: '',
      processing: false,
      columns: [{
        label: 'Membership No.',
        field: 'user.member_number',
        filterable: true,
        sortable: true,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.user.member_number\" :row=\"row\" :options=\"{}\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.user.member_number);
        }
      }, {
        label: 'User',
        field: 'user.first_name',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.user.first_name + ' ' + row.user.last_name\" :row=\"row\" :options=\"{}\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.user.first_name, " ").concat(row.user.last_name);
        }
      }, {
        label: 'Amount',
        field: 'total',
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"'$' + row.total\" :row=\"row\" :options=\"{ showPaid: true }\" />"
        },
        representedAs: 'total'
      }, {
        label: 'Payment Method',
        field: 'payment_method',
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.payment_method.charAt(0).toUpperCase() + row.payment_method.slice(1)\" :row=\"row\" :options=\"{}\" />"
        },
        representedAs: 'payment_method'
      }, {
        label: 'Purchase',
        field: 'type',
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.type.charAt(0).toUpperCase() + row.type.slice(1)\" :row=\"row\" :options=\"{}\" />"
        },
        representedAs: 'type'
      }, {
        label: 'Approve',
        align: 'left',
        sortable: false,
        filterable: false,
        headerClass: 'column-lg-small d-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            modal: __WEBPACK_IMPORTED_MODULE_6__components_Modal__["a" /* default */],
            tableButtonTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Button__["a" /* default */]
          },
          data: function data() {
            return {
              showApproveModal: false,
              processing: false,
              payment: {
                paymentDate: null,
                invoiceNumber: null
              }
            };
          },
          methods: {
            approveModal: function approveModal() {
              this.showApproveModal = true; // Resetting approve fields

              this.payment.paymentDate = null;
              this.payment.invoiceNumber = null;
            },
            approve: function approve() {
              var _this = this;

              this.processing = true;
              this.success = '';
              __WEBPACK_IMPORTED_MODULE_7__store_EventBus_js__["a" /* default */].$emit('errors', []);
              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/update-invoice"), {
                id: this.row.id,
                status: 'paid',
                invoice_number: this.payment.invoiceNumber,
                paid_date: this.payment.paymentDate,
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
              }).then(function (response) {
                _this.processing = false;

                if (response.data.status === 'success') {
                  _this.success = 'The payment has been approved.';
                  __WEBPACK_IMPORTED_MODULE_7__store_EventBus_js__["a" /* default */].$emit('approve', _this.payment);
                } else if (response.data.errors) {
                  __WEBPACK_IMPORTED_MODULE_7__store_EventBus_js__["a" /* default */].$emit('errors', response.data.errors);
                }
              }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error);
                _this.success = '';
                _this.error = ['Unable to receive data from the server. Please reload the page.'];
              });
            }
          },
          template: "\n              <div>\n                <button :class=\"['btn btn-sm btn-block mb-2 mb-lg-0', processing ? 'btn-primary-dark' : 'btn-primary']\" @click.prevent=\"approveModal\">\n                  {{ !processing ? 'Approve' : '' }}\n                  <div v-if=\"processing\" class=\"spinner-border text-light\" role=\"status\"><span class=\"sr-only\">Loading...</span></div>\n                </button>\n                <modal v-if=\"showApproveModal\" @close=\"showApproveModal = false\">\n                  <div slot=\"body\">\n                    <div class=\"alert alert-warning\">\n                      You are about to approve the payment from member \u2018{{row.user.first_name + ' ' + row.user.last_name}}\u2019. Notify user and proceed with approval?\n                    </div>\n                    <div class=\"form-row\">\n                      <div class=\"form-group col\">\n                        <label for=\"payment_date_desktop\">Payment Date</label>\n                        <input v-model=\"payment.paymentDate\" class=\"form-control\" id=\"payment_date_desktop\" type=\"date\" placeholder=\"dd/mm/yyyy\" pattern=\"[0-9]{4}-[0-9]{2}-[0-9]{2}\">\n                      </div>\n                      <div class=\"form-group col\">\n                        <label for=\"invoice_number\">Invoice Number</label>\n                        <input v-model=\"payment.invoiceNumber\" type=\"number\" class=\"form-control\">\n                      </div>\n                    </div>\n                    <div class=\"d-flex justify-content-center\">\n                      <button class=\"btn btn-outline-primary\" @click.prevent=\"showApproveModal = false\">Cancel</button>\n                      <button class=\"btn btn-primary ml-2\" @click.prevent=\"approve();showApproveModal = false\">Approve</button>\n                    </div>\n                  </div>\n                </modal>\n              </div>"
        }
      }, {
        label: 'Deny',
        align: 'left',
        sortable: false,
        filterable: false,
        headerClass: 'column-lg-small d-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            modal: __WEBPACK_IMPORTED_MODULE_6__components_Modal__["a" /* default */],
            tableButtonTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Button__["a" /* default */]
          },
          data: function data() {
            return {
              showDenyModal: false,
              processing: false
            };
          },
          methods: {
            denyModal: function denyModal() {
              this.showDenyModal = true;
            },
            deny: function deny() {
              var _this2 = this;

              this.processing = true;
              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/update-invoice"), {
                id: this.row.id,
                status: 'deny'
              }).then(function (response) {
                _this2.processing = false;

                if (response.data.status === 'success') {
                  _this2.success = 'The payment has been denied.';
                  __WEBPACK_IMPORTED_MODULE_7__store_EventBus_js__["a" /* default */].$emit('deny');
                }
              }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error);
                _this2.success = '';
                _this2.error = ['Unable to receive data from the server. Please reload the page.'];
              });
            }
          },
          template: "\n              <div>\n                <button :class=\"['btn btn-sm btn-block mb-2 mb-lg-0', processing ? 'btn-primary-dark' : 'btn-primary']\" @click.prevent=\"denyModal\">\n                  {{ !processing ? 'Deny' : '' }}\n                  <div v-if=\"processing\" class=\"spinner-border text-light\" role=\"status\"><span class=\"sr-only\">Loading...</span></div>\n                </button>\n                <modal v-if=\"showDenyModal\" @close=\"showDenyModal = false\">\n                  <div slot=\"body\">\n                    <div class=\"alert alert-warning\">\n                      You are about to deny the payment from member \u2018{{row.user.first_name + ' ' + row.user.last_name}}\u2019. Do you wish to proceed?\n                    </div>\n                    <div class=\"d-flex justify-content-center\">\n                      <button class=\"btn btn-outline-primary\" @click.prevent=\"showDenyModal = false\">Cancel</button>\n                      <button class=\"btn btn-primary ml-2\" @click.prevent=\"deny();showDenyModal = false\">Confirm</button>\n                    </div>\n                  </div>\n                </modal>\n              </div>"
        }
      }],
      options: {
        search: true,
        loaded: false
      },
      showApproveModal: false,
      showDenyModal: false,
      payment: {
        paymentDate: null,
        invoiceNumber: null
      }
    };
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/pending-invoices")).then(function (response) {
      _this3.options.loaded = true;

      if (response.data.status === 'success') {
        _this3.error = [];
        _this3.rows = response.data.data;
      } else {
        _this3.error = ['Unable to receive data from the server. Please reload the page.'];
      }
    });
    __WEBPACK_IMPORTED_MODULE_7__store_EventBus_js__["a" /* default */].$on('approve', function (payment) {
      _this3.payment = payment;
      _this3.success = 'The payment has been approved.';
      _this3.error = [];
      _this3.rows = [];
      _this3.options.loaded = false;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(_this3.$api, "/admin/pending-invoices"), _this3.payment).then(function (response) {
        _this3.options.loaded = true;

        if (response.data.status === 'success') {
          _this3.rows = response.data.data;
        } else {
          _this3.error = ['Unable to receive data from the server. Please reload the page.'];
        }
      });
    });
    __WEBPACK_IMPORTED_MODULE_7__store_EventBus_js__["a" /* default */].$on('deny', function () {
      _this3.success = 'The payment has been denied.';
      _this3.rows = [];
      _this3.error = [];
      _this3.options.loaded = false;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(_this3.$api, "/admin/pending-invoices"), _this3.payment).then(function (response) {
        _this3.options.loaded = true;

        if (response.data.status === 'success') {
          _this3.rows = response.data.data;
        } else {
          _this3.error = ['Unable to receive data from the server. Please reload the page.'];
        }
      });
    });
    __WEBPACK_IMPORTED_MODULE_7__store_EventBus_js__["a" /* default */].$on('errors', function (errors) {
      _this3.success = '';
      _this3.error = Object.values(errors).flat();
    });
  },
  methods: {
    approveModal: function approveModal(theRowID) {
      this.rowID = theRowID;
      this.showApproveModal = true; // Resetting approve fields

      this.payment.paymentDate = null;
      this.payment.invoiceNumber = null;
    },
    approve: function approve() {
      var _this4 = this;

      this.processing = true;
      this.success = '';
      this.error = [];
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/update-invoice"), {
        id: this.rowID,
        status: 'paid',
        invoice_number: this.payment.invoiceNumber,
        paid_date: this.payment.paymentDate,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      }).then(function (response) {
        _this4.processing = false;

        if (response.data.status === 'success') {
          _this4.success = 'The payment has been approved.';
          __WEBPACK_IMPORTED_MODULE_7__store_EventBus_js__["a" /* default */].$emit('approve');
        } else if (response.data.errors) {
          _this4.error = Object.values(response.data.errors).flat();
        }
      }).catch(function (error) {
        _this4.processing = false; // eslint-disable-next-line

        console.log(error);
        _this4.error = ['Unable to receive data from the server. Please reload the page.'];
      });
    },
    denyModal: function denyModal(theRowID) {
      this.rowID = theRowID;
      this.showDenyModal = true;
    },
    deny: function deny() {
      var _this5 = this;

      this.processing = true;
      this.success = '';
      this.error = [];
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/update-invoice"), {
        id: this.rowID,
        status: 'deny'
      }).then(function (response) {
        _this5.processing = false;

        if (response.data.status === 'success') {
          _this5.success = 'The payment has been denied.';
          __WEBPACK_IMPORTED_MODULE_7__store_EventBus_js__["a" /* default */].$emit('deny');
        }
      }).catch(function (error) {
        _this5.processing = false; // eslint-disable-next-line

        console.log(error);
        _this5.error = ['Unable to receive data from the server. Please reload the page.'];
      });
    }
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PendingRegistrations',
  props: ['success', 'status'],
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__["a" /* default */],
    'data-table': __WEBPACK_IMPORTED_MODULE_2__components_DataTable__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
  },
  data: function data() {
    return {
      error: '',
      rows: [],
      columns: [{
        label: 'Horse Name',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.name\" :link=\"'Pending Horse'\" :row=\"row\" :options=\"{ showLinks: true, showRegistered: true }\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.name);
        }
      }, {
        label: 'Owner',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.owner\" :row=\"row\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.owner);
        }
      }, {
        label: 'Date of Birth',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.dob ? new Date(row.dob.replace(/-/g, '/')).toLocaleDateString('en-AU') : ''\" :row=\"row\" :options=\"{}\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.dob ? new Date(row.dob.replace(/-/g, '/')).toLocaleDateString('en-AU') : '');
        }
      }, {
        label: 'Sex',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.gender\" :row=\"row\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.gender);
        }
      }, {
        label: 'Status',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.status ? row.status.name : ''\" :row=\"row\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.status ? row.status.name : '');
        }
      }],
      options: {
        filter: {
          registered: [{
            name: 'All',
            value: 'all'
          }, {
            name: 'Registered',
            value: true
          }, {
            name: 'Unregistered',
            value: false
          }]
        },
        activeFilter: {
          registered: 'all'
        },
        search: true,
        addHorse: this.$isUser || this.$isSecretary,
        loaded: false
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/horse-pending")).then(function (response) {
      if (response.data.status === 'success') {
        _this.options.loaded = true;
        response.data.data.forEach(function (horse) {
          horse.owner = '';
          horse.owners.forEach(function (value, key, array) {
            horse.owner += "".concat(value.first_name, " ").concat(value.last_name);

            if (key !== array.length - 1) {
              horse.owner += ', ';
            }
          }); // eslint-disable-next-line

          var theOwners = horse.owners.reduce(function (a, b) {
            return a.concat(b);
          }, []); // eslint-disable-next-line

          theOwners = theOwners.map(function (o) {
            return _defineProperty({}, o.id, o.name);
          }); // console.log(theOwners)
        });
        _this.error = ''; // console.log(response.data.data)

        _this.rows = response.data.data;
      } else {
        _this.error = 'Unable to receive data from the server. Please reload the page.';
      }
    });
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Horses_Profile_HorseProfileScore__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HorseDetails__ = __webpack_require__(799);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PendingHorse',
  props: ['details'],
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    'horse-profile-details': __WEBPACK_IMPORTED_MODULE_2__HorseDetails__["a" /* default */],
    'horse-profile-score': __WEBPACK_IMPORTED_MODULE_1__views_Horses_Profile_HorseProfileScore__["a" /* default */]
  },
  data: function data() {
    return {
      pending: true
    };
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseProfileScore_vue__ = __webpack_require__(311);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eeddb13e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseProfileScore_vue__ = __webpack_require__(798);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseProfileScore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eeddb13e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseProfileScore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataTableFields_Text__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HorseProfileScore',
  components: {
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_1__components_DataTableFields_Text__["a" /* default */]
  },
  data: function data() {
    return {
      results: {},
      errors: '',
      loaded: false
    };
  },
  methods: {
    getResults: function getResults(id) {
      var _this = this;

      this.errors = '';
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/results-horse/").concat(id)).then(function (response) {
        _this.loaded = true;

        if (response.data.status === 'success' && response.data.data !== null) {
          _this.tweakResults(response.data.data);
        } else {
          _this.errors = 'There was a server error. Please contact us.';
        }
      }).catch(function () {
        _this.loaded = true;
        _this.errors = 'There was a server error. Please contact us.';
      });
    },
    tweakResults: function tweakResults(theData) {
      // Put results in to a usable format
      var tempResults = {};

      if (Array.isArray(theData.results)) {
        theData.results.forEach(function (result) {
          if (typeof tempResults[result.year] === 'undefined') {
            tempResults[result.year] = [result];
          } else {
            tempResults[result.year].push(result);
          }
        });
      } else {
        Object.keys(theData.results).forEach(function (key) {
          if (typeof tempResults[theData.results[key].year] === 'undefined') {
            tempResults[theData.results[key].year] = [theData.results[key]];
          } else {
            tempResults[theData.results[key].year].push(theData.results[key]);
          }
        });
      }

      this.results = tempResults;
    }
  },
  computed: {
    horseId: function horseId() {
      return this.$route.params.slug;
    }
  },
  mounted: function mounted() {
    this.getResults(this.horseId);
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_legacyBrowsers_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__voerro_vue_tagsinput__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DesktopActionBar__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Horses_HorseSearchSelect__ = __webpack_require__(60);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PendingHorseDetails',
  props: ['horseDetails'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_legacyBrowsers_js__["a" /* default */]],
  components: {
    'tags-input': __WEBPACK_IMPORTED_MODULE_3__voerro_vue_tagsinput__["a" /* default */],
    'horse-search-select': __WEBPACK_IMPORTED_MODULE_6__components_Horses_HorseSearchSelect__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_4__components_Modal__["a" /* default */],
    DesktopActionBar: __WEBPACK_IMPORTED_MODULE_5__components_DesktopActionBar__["a" /* default */]
  },
  data: function data() {
    return {
      horse: JSON.parse(this.horseDetails.requests[this.horseDetails.requests.length - 1].before),
      horsePending: JSON.parse(this.horseDetails.requests[this.horseDetails.requests.length - 1].after),
      ownersList: {},
      user: localStorage.role,
      showModal: false,
      processing: [false, false],
      errorStatus: '',
      errors: ''
    };
  },
  methods: {
    updateHorse: function updateHorse() {
      var _this = this;

      this.processing.splice(0, 1, true);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/horse-update"), {
        id: this.horseDetails.id,
        name: this.horsePending.name,
        dob: this.horsePending.dob,
        gender: this.horsePending.gender,
        owners: this.horsePending.owners,
        horse_status_id: this.horsePending.status.id
      }).then(function (response) {
        _this.processing.splice(0, 1, false); // eslint-disable-next-line
        // console.log(response)


        if (response.data.status === 'success') {
          // eslint-disable-next-line
          // console.log('success')
          _this.$router.push({
            name: 'Horse Updates',
            params: {
              success: 'The horse change has been approved.'
            }
          });
        } else if (response.data.status === 'validation_error' && response.data.errors.dob) {
          // DoB
          _this.errorStatus = 'validation_error';
          _this.errors = "Please include the Date of Birth in the format".concat(_this.isLegacy() ? ' yyyy-mm-dd' : ' dd/mm/yyyy', ".");
        } else {// eslint-disable-next-line
          // console.log('fail')
        }
      }).catch(function (error) {
        _this.processing.splice(0, 1, false); // eslint-disable-next-line


        console.log(error);
      });
    },
    denyHorse: function denyHorse() {
      var _this2 = this;

      this.processing.splice(1, 1, true);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/horse-deny-all"), {
        id: this.horseDetails.id
      }).then(function (response) {
        _this2.processing.splice(1, 1, false); // eslint-disable-next-line
        // console.log(response)


        if (response.data.status === 'success') {
          // eslint-disable-next-line
          // console.log('success')
          _this2.$router.push({
            name: 'Horse Updates',
            params: {
              status: 'The horse change has been denied.'
            }
          });
        } else {// eslint-disable-next-line
          // console.log('fail')
        }
      }).catch(function (error) {
        _this2.processing.splice(1, 1, false); // eslint-disable-next-line


        console.log(error);
      });
    },
    update: function update(event) {
      event.preventDefault();

      if (this.horsePending.owners.length > 0) {
        this.updateHorse();
      }
    }
  },
  computed: {
    isInvalidPending: function isInvalidPending() {
      return this.wasValidated && this.horsePending.owners.length === 0;
    },
    isInvalidExisting: function isInvalidExisting() {
      return this.wasValidated && this.horse.owners.length === 0;
    }
  },
  created: function created() {
    if (!this.horse.status) {
      this.horse.status = {
        name: null
      };
    } // sire_id / dam_id come from the request JSON as scalars; the pickers work with [id].


    var toIdArray = function toIdArray(obj, key) {
      if (obj[key]) obj[key] = [obj[key].toString()];
    };

    toIdArray(this.horsePending, 'sire_id');
    toIdArray(this.horsePending, 'dam_id');
    toIdArray(this.horse, 'sire_id');
    toIdArray(this.horse, 'dam_id');
  },
  mounted: function mounted() {
    var _this3 = this;

    if (Object.keys(this.horseDetails).length > 0) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/users")).then(function (response) {
        if (response.data.status === 'success') {
          _this3.ownersList = response.data.data.reduce(function (resultItem, currentArray) {
            resultItem[currentArray.id] = "".concat(currentArray.member_number, ": ").concat(currentArray.first_name, " ").concat(currentArray.last_name);
            return resultItem;
          }, {});

          if (_typeof(_this3.horse.owners[0]) === 'object') {
            _this3.horse.owners = _this3.horse.owners[0].id.toString();
          }

          if (_typeof(_this3.horsePending.owners[0]) === 'object') {
            _this3.horsePending.owners = _this3.horsePending.owners[0].id.toString();
          }
        }
      });
    }
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppMultiselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_horses__ = __webpack_require__(86);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Server-backed replacement for the legacy `<tags-input :existing-tags="{id: 'owner: name'}">`
// horse pickers. Same behaviour: type >= 2 chars, match horse OR owner name, archived horses
// included, and the picked horse shows as a removable chip BELOW the field (input stays empty).
// `value` / `input` keep the tags-input shape: an array with the id string, or [].

var MIN_CHARS = 2;
var DEBOUNCE_MS = 300;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HorseSearchSelect',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_0__components_AppMultiselect__["a" /* default */]
  },
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    elementId: {
      type: String,
      required: true
    },
    // Pre-resolved { id, name, owner_name } for the currently selected horse, supplied by the
    // parent's main request (e.g. event-details). When it matches `value`, the chip renders
    // from it and no /v2/horses/options lookup is fired. Search stays per-field, on typing.
    initialOption: {
      type: Object,
      default: null
    },
    placeholder: {
      type: String,
      default: 'Start typing...'
    },
    disabled: Boolean,
    required: Boolean
  },
  data: function data() {
    return {
      searchOptions: [],
      selectedCache: [],
      // Kept as plain data (rebuilt via watchers), NOT a computed: with the global
      // @vue/composition-api shim active, an Options-API computed that returns a fresh
      // array can lose its cache and hand vue-multiselect a new `:options` ref on every
      // render — its internal `filteredOptions` watcher then fires every render, and a
      // pageful of these pickers locks the tab.
      mergedOptions: [],
      // The searchable <input> is only rendered while THIS field is focused. A pageful of
      // always-searchable vue-multiselects each keep an <input>, and a password-manager
      // extension focus-pinging every one of them makes their activate()/$nextTick(focus)
      // ping-pong forever (see Call tree: flushCallbacks -> focus -> _onDocumentFocus).
      active: false,
      loading: false,
      loadingMore: false,
      nextCursor: null,
      term: '',
      searchTimer: null,
      scrollEl: null,
      onScroll: null
    };
  },
  computed: {
    selectedId: function selectedId() {
      var raw = this.value && this.value.length ? this.value[0] : null;
      return raw != null && raw !== '' ? Number(raw) : null;
    },
    selectedOption: function selectedOption() {
      var _this = this;

      if (this.selectedId == null) return null;
      return this.mergedOptions.find(function (o) {
        return o.id === _this.selectedId;
      }) || null;
    }
  },
  watch: {
    // Watch the resolved numeric id, not the `value` array prop: parents commonly bind
    // `:value="foo || []"`, which hands a fresh `[]` on every render — watching `value`
    // would re-run hydrateSelected() (and its request) on every parent re-render.
    // rebuildOptions() is called here too: this immediate handler runs during initWatch,
    // BEFORE the selectedCache/searchOptions watchers below exist, so the synchronous
    // selectedCache write inside hydrateSelected() (the initialOption path) would otherwise
    // not rebuild mergedOptions and the chip never shows.
    selectedId: {
      immediate: true,
      handler: function handler() {
        this.hydrateSelected();
        this.rebuildOptions();
      }
    },
    selectedCache: function selectedCache() {
      this.rebuildOptions();
    },
    searchOptions: function searchOptions() {
      this.rebuildOptions();
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.searchTimer);
    this.detachScroll();
  },
  methods: {
    labelFor: function labelFor(h) {
      if (!h) return '';
      return h.owner_name ? "".concat(h.owner_name, ": ").concat(h.name) : h.name;
    },
    extract: function extract(res) {
      var d = res && res.data && res.data.data || {};
      return {
        items: d.items || [],
        nextCursor: d.next_cursor || null
      };
    },
    rebuildOptions: function rebuildOptions() {
      var seen = new Set(this.searchOptions.map(function (o) {
        return o.id;
      }));
      this.mergedOptions = [].concat(_toConsumableArray(this.selectedCache.filter(function (o) {
        return !seen.has(o.id);
      })), _toConsumableArray(this.searchOptions));
    },
    hydrateSelected: function hydrateSelected() {
      var _this2 = this;

      var id = this.selectedId; // Reject null / NaN / 0 / negatives — a bad id would hit /v2/horses/options with an
      // empty `ids` list, which the API can only answer with an unfiltered whole-table scan.

      if (!Number.isInteger(id) || id <= 0) {
        this.selectedCache = [];
        return;
      }

      if (this.selectedCache.some(function (o) {
        return o.id === id;
      }) || this.searchOptions.some(function (o) {
        return o.id === id;
      })) return; // Use the option the parent already resolved — no per-row API call.

      if (this.initialOption && Number(this.initialOption.id) === id) {
        this.selectedCache = [_objectSpread({}, this.initialOption, {
          id: id
        })];
        return;
      } // Fallback: only when the selected id wasn't supplied by the parent (legacy data).


      __WEBPACK_IMPORTED_MODULE_1__services_api_horses__["a" /* default */].options({
        ids: String(id)
      }).then(function (res) {
        _this2.selectedCache = _this2.extract(res).items;
      }).catch(function () {});
    },
    onSelect: function onSelect(option) {
      if (option && option.id != null) {
        // Keep the picked horse so the chip survives searchOptions being cleared
        // when the field blurs / the search term resets after selection.
        this.selectedCache = [option];
        this.$emit('input', [String(option.id)]);
      } // The selection is shown by our own chip below; the multiselect must stay a
      // plain search box. vue-multiselect 2.0.8 keeps its pick in its own
      // `internalValue` and only re-syncs it when the `:value` prop changes — and
      // ours is a static `null` — so wipe that internal state after every select.


      this.resetMultiselect();
    },
    resetMultiselect: function resetMultiselect() {
      var ms = this.$refs.ms;
      if (!ms) return;
      ms.internalValue = [];
      ms.search = '';
    },
    clear: function clear() {
      if (this.disabled) return; // Drop every trace of the current pick: the emitted value, the hydrated chip,
      // stale search state and the multiselect's own retained selection.

      clearTimeout(this.searchTimer);
      this.term = '';
      this.searchOptions = [];
      this.selectedCache = [];
      this.nextCursor = null; // mergedOptions is plain data (see note above) — rebuild it now instead of
      // waiting for the async selectedCache/searchOptions watchers, so `selectedOption`
      // (and the chip) clears in the same tick as the click.

      this.rebuildOptions();
      this.resetMultiselect();
      var ms = this.$refs.ms;
      if (ms && typeof ms.deactivate === 'function') ms.deactivate();
      this.$emit('input', []);
    },
    onSearch: function onSearch(query) {
      var _this3 = this;

      this.term = query || '';
      clearTimeout(this.searchTimer);

      if (this.term.length < MIN_CHARS) {
        this.searchOptions = [];
        this.nextCursor = null;
        return;
      }

      this.searchTimer = setTimeout(function () {
        return _this3.runSearch();
      }, DEBOUNCE_MS);
    },
    runSearch: function runSearch() {
      var _this4 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__services_api_horses__["a" /* default */].options({
        search: this.term
      }).then(function (res) {
        var _this4$extract = _this4.extract(res),
            items = _this4$extract.items,
            nextCursor = _this4$extract.nextCursor;

        _this4.searchOptions = items;
        _this4.nextCursor = nextCursor;
      }).catch(function () {
        _this4.searchOptions = [];
      }).finally(function () {
        _this4.loading = false;
      });
    },
    loadMore: function loadMore() {
      var _this5 = this;

      if (!this.nextCursor || this.loadingMore || this.loading) return;
      this.loadingMore = true;
      __WEBPACK_IMPORTED_MODULE_1__services_api_horses__["a" /* default */].options({
        search: this.term,
        cursor: this.nextCursor
      }).then(function (res) {
        var _this5$extract = _this5.extract(res),
            items = _this5$extract.items,
            nextCursor = _this5$extract.nextCursor;

        _this5.searchOptions = [].concat(_toConsumableArray(_this5.searchOptions), _toConsumableArray(items));
        _this5.nextCursor = nextCursor;
      }).catch(function () {}).finally(function () {
        _this5.loadingMore = false;
      });
    },
    onFocusIn: function onFocusIn(e) {
      var _this6 = this;

      if (this.active || this.disabled) return; // Focus landing on the chip's remove button (keyboard tab, or a browser that
      // still focuses it despite @mousedown.prevent) must not activate the search.

      if (e && e.target && e.target.closest && e.target.closest('.tags-input')) return;
      this.active = true; // Re-render with searchable=true, then open the dropdown and focus the freshly
      // rendered <input> (activate() alone no-ops once isOpen is already true).

      this.$nextTick(function () {
        var ms = _this6.$refs.ms;
        if (!ms) return;
        if (!ms.isOpen) ms.activate();
        var input = ms.$refs && ms.$refs.search;
        if (input && document.activeElement !== input) input.focus();
      });
    },
    onFocusOut: function onFocusOut(e) {
      // Ignore focus moving between elements inside this component.
      if (e && e.relatedTarget && this.$el.contains(e.relatedTarget)) return;
      this.active = false;
    },
    onOpen: function onOpen() {
      this.$nextTick(this.attachScroll);
    },
    onClose: function onClose() {
      this.detachScroll();
    },
    // vue-multiselect has no "load more" hook — watch the dropdown's scroll container.
    attachScroll: function attachScroll() {
      var _this7 = this;

      var root = this.$refs.ms && this.$refs.ms.$el;
      var wrapper = root && root.querySelector('.multiselect__content-wrapper');
      if (!wrapper) return;
      this.scrollEl = wrapper;

      this.onScroll = function () {
        if (wrapper.scrollHeight - wrapper.scrollTop - wrapper.clientHeight < 40) _this7.loadMore();
      };

      wrapper.addEventListener('scroll', this.onScroll);
    },
    detachScroll: function detachScroll() {
      if (this.scrollEl && this.onScroll) this.scrollEl.removeEventListener('scroll', this.onScroll);
      this.scrollEl = null;
      this.onScroll = null;
    }
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Admin_Add_AdminAdd__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_memberProfileStore_js__ = __webpack_require__(25);
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminProfile',
  props: ['details'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__store_memberProfileStore_js__["a" /* default */]],
  components: {
    'admin-profile': __WEBPACK_IMPORTED_MODULE_0__views_Admin_Add_AdminAdd__["a" /* default */]
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminAdd_vue__ = __webpack_require__(316);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebe2a07e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminAdd_vue__ = __webpack_require__(807);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebe2a07e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdminAddDetails__ = __webpack_require__(805);
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MemberAdminAdd',
  props: ['memberDetails', 'edit'],
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    'member-admin-add-details': __WEBPACK_IMPORTED_MODULE_1__AdminAddDetails__["a" /* default */]
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DesktopActionBar__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminAddDetails',
  props: ['memberDetails', 'edit'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__["a" /* default */]],
  components: {
    modal: __WEBPACK_IMPORTED_MODULE_2__components_Modal__["a" /* default */],
    DesktopActionBar: __WEBPACK_IMPORTED_MODULE_3__components_DesktopActionBar__["a" /* default */]
  },
  data: function data() {
    return {
      memberPages: 1,
      memberUpdate: {
        attributes: {}
      },
      memberDetailsHasData: false,
      showModal: false,
      success: '',
      errors: '',
      loggedInUser: Number(localStorage.userID)
    };
  },
  watch: {
    memberDetails: function memberDetails() {
      if (Object.keys(this.memberDetails).length > 0) {
        this.memberUpdate = this.memberDetails;
        this.memberDetailsHasData = true;
      }
    }
  },
  methods: {
    addAdmin: function addAdmin() {
      var _this = this;

      setTimeout(function () {
        var fields = _this.memberUpdate;
        var id = _this.memberDetails ? _this.memberDetails.id : null;

        if (_this.formComplete) {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(_this.$api, "/admin/admin"), {
            id: id,
            title: fields.title,
            first_name: fields.first_name,
            last_name: fields.last_name,
            email: fields.attributes.email,
            phone: fields.attributes.phone,
            password: _this.password.password,
            password_confirmation: _this.password.confirmPassword,
            edit: !!_this.edit
          }).then(function (response) {
            // eslint-disable-next-line
            // console.log(response)
            if (response.data.status === 'success') {
              _this.$router.push({
                name: 'Admin Users',
                params: {
                  success: "Admin ".concat(_this.edit ? 'edited' : 'created', " successfully.")
                }
              });
            } else if (response.data.errors.email) {
              var _response$data, _response$data$errors;

              _this.success = '';

              if (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$errors = _response$data.errors) === null || _response$data$errors === void 0 ? void 0 : _response$data$errors.email[0]) {
                _this.errors = response.data.errors.email[0];
              } else {
                _this.errors = 'Please include correct email address.';
              }
            } else {
              _this.success = '';
              _this.errors = 'Please ensure all fields are completed.';
            }
          }).catch(function (error) {
            // eslint-disable-next-line
            console.log(error);
          });
        }
      }, 10);
    },
    deleteAdmin: function deleteAdmin() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/delete-admin"), {
        id: this.memberUpdate.id
      }).then(function (response) {
        // eslint-disable-next-line
        // console.log(response)
        if (response.data.status === 'success') {
          _this2.$router.push({
            name: 'Admin Users',
            params: {
              success: 'Admin removed successfully.'
            }
          });
        } else if (response.data.status === 'self_deletion') {
          _this2.success = '';
          _this2.errors = 'You are unable to delete your own account.';
        } else {// eslint-disable-next-line
          // console.log(response.data)
        }
      }).catch(function (error) {
        // eslint-disable-next-line
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Admin_Add_SecretaryAdd__ = __webpack_require__(319);
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SecretaryProfile',
  components: {
    'secretary-profile': __WEBPACK_IMPORTED_MODULE_1__views_Admin_Add_SecretaryAdd__["a" /* default */]
  },
  data: function data() {
    return {
      memberDetails: {}
    };
  },
  mounted: function mounted() {
    if (this.$route.params && this.$route.params.slug) {
      this.getData(this.$route.params.slug);
    }
  },
  methods: {
    getData: function getData(slug) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/secretary/").concat(slug)).then(function (response) {
        if (response.status === 200) {
          _this.memberDetails = response.data.data;
        }
      }).catch(function (error) {
        // eslint-disable-next-line
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecretaryAdd_vue__ = __webpack_require__(320);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2766a604_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecretaryAdd_vue__ = __webpack_require__(813);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecretaryAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2766a604_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecretaryAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SecretaryAddDetails__ = __webpack_require__(810);
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SecretaryAdd',
  props: ['memberDetails', 'edit'],
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    'secretary-add-details': __WEBPACK_IMPORTED_MODULE_1__SecretaryAddDetails__["a" /* default */]
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Members_SuperSecretaryToggle__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DesktopActionBar__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FormFields_Base_FGroup__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FormFields_FText__ = __webpack_require__(146);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var TITLES = ['Mr', 'Ms', 'Miss', 'Mrs', 'Dr'];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SecretaryAddDetails',
  props: ['memberDetails', 'edit'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__["a" /* default */]],
  components: {
    modal: __WEBPACK_IMPORTED_MODULE_2__components_Modal__["a" /* default */],
    SuperSecretaryToggle: __WEBPACK_IMPORTED_MODULE_3__components_Members_SuperSecretaryToggle__["a" /* default */],
    DesktopActionBar: __WEBPACK_IMPORTED_MODULE_4__components_DesktopActionBar__["a" /* default */],
    PageHeading: __WEBPACK_IMPORTED_MODULE_5__components_PageHeading__["a" /* default */],
    FGroup: __WEBPACK_IMPORTED_MODULE_6__components_FormFields_Base_FGroup__["a" /* default */],
    FText: __WEBPACK_IMPORTED_MODULE_7__components_FormFields_FText__["a" /* default */]
  },
  data: function data() {
    return {
      TITLES: TITLES,
      memberUpdate: {
        attributes: {}
      },
      memberDetailsHasData: false,
      showModal: false,
      success: '',
      errors: '',
      loggedInUser: Number(localStorage.userID)
    };
  },
  watch: {
    memberDetails: function memberDetails() {
      if (Object.keys(this.memberDetails).length > 0) {
        this.memberUpdate = this.memberDetails;
        this.memberDetailsHasData = true;
      }
    }
  },
  methods: {
    addAdmin: function addAdmin() {
      var _this = this;

      setTimeout(function () {
        var fields = _this.memberUpdate;
        var id = _this.memberDetails ? _this.memberDetails.id : null;

        if (_this.formComplete) {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(_this.$api, "/admin/secretary"), {
            id: id,
            title: fields.title,
            first_name: fields.first_name,
            last_name: fields.last_name,
            email: fields.attributes.email,
            phone: fields.attributes.phone,
            password: _this.password.password,
            password_confirmation: _this.password.confirmPassword,
            edit: !!_this.edit
          }).then(function (response) {
            if (response.data.status === 'success') {
              _this.$router.push({
                name: 'Secretary Users',
                params: {
                  success: "Secretary ".concat(_this.edit ? 'edited' : 'created', " successfully.")
                }
              });
            } else if (response.data.errors.email) {
              var _response$data, _response$data$errors;

              // Email
              _this.success = '';
              _this.errorStatus = 'email';

              if (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$errors = _response$data.errors) === null || _response$data$errors === void 0 ? void 0 : _response$data$errors.email[0]) {
                _this.errors = response.data.errors.email[0];
              } else {
                _this.errors = 'Please include correct email address.';
              }
            } else {
              _this.success = '';
              _this.errors = 'Please ensure all fields are completed.';
            }
          }).catch(function (error) {
            // eslint-disable-next-line
            console.log(error);
          });
        }
      }, 10);
    },
    deleteSecretary: function deleteSecretary() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/delete-secretary"), {
        id: this.memberUpdate.id
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this2.$router.push({
            name: 'Secretary Users',
            params: {
              success: 'Secretary removed successfully.'
            }
          });
        } else if (response.data.status === 'self_deletion') {
          _this2.success = '';
          _this2.errors = 'You are unable to delete your own account.';
        }
      }).catch(function (error) {
        // eslint-disable-next-line
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppAlert__ = __webpack_require__(288);
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PageHeading',
  components: {
    AppAlert: __WEBPACK_IMPORTED_MODULE_0__AppAlert__["a" /* default */]
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_memberProfileStore_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Admin_Tabs_MemberDetails__ = __webpack_require__(816);
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminProfileChild',
  props: ['details'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__store_memberProfileStore_js__["a" /* default */]],
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    'member-profile-details': __WEBPACK_IMPORTED_MODULE_2__views_Admin_Tabs_MemberDetails__["a" /* default */]
  },
  data: function data() {
    return {
      child: true,
      selectedTab: 'details'
    };
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_getFieldLists_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DesktopActionBar__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* FILE UNUSED */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MembersProfileDetails',
  props: ['memberDetails', 'split', 'my'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_formValidation_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_getFieldLists_js__["a" /* default */]],
  components: {
    DesktopActionBar: __WEBPACK_IMPORTED_MODULE_2__components_DesktopActionBar__["a" /* default */]
  },
  data: function data() {
    return {
      parentConsent: false,
      memberUpdate: this.memberDetails
    };
  },
  watch: {
    memberDetails: function memberDetails() {
      this.memberUpdate = this.memberDetails;
    }
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_memberProfileStore_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Members_Tabs_Details__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Members_Tabs_Financials__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Members_Tabs_MembershipHistory__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MyMembershipMembership__ = __webpack_require__(272);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */
// 'My Profile'






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['renewing', 'tabSelect', 'child', 'completePaymentProfile', 'returnTo'],
  name: 'MyMembership',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__store_memberProfileStore_js__["a" /* default */]],
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    'member-profile-details': __WEBPACK_IMPORTED_MODULE_2__views_Members_Tabs_Details__["a" /* default */],
    'member-profile-membership': __WEBPACK_IMPORTED_MODULE_5__MyMembershipMembership__["a" /* default */],
    'member-profile-financials': __WEBPACK_IMPORTED_MODULE_3__views_Members_Tabs_Financials__["a" /* default */],
    'member-profile-history': __WEBPACK_IMPORTED_MODULE_4__views_Members_Tabs_MembershipHistory__["a" /* default */]
  },
  data: function data() {
    return {
      selectedTab: this.tabSelect ? this.tabSelect : 'details',
      renew: this.renewing ? this.renewing : false,
      userID: localStorage.userID,
      userRole: localStorage.role
    };
  },
  watch: {
    selectedTab: function selectedTab() {
      if (this.selectedTab === 'details' && !this.memberDetails) {
        this.memberDetails = this.$store.state.viewedMember || this.$store.state.childMember;
      }
    }
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Members_Tabs_Details__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Members_Tabs_MembershipHistory__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_memberProfileStore_js__ = __webpack_require__(25);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */
// /my-account/user-details




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MyMembershipDetails',
  props: ['details'],
  mixins: [__WEBPACK_IMPORTED_MODULE_3__store_memberProfileStore_js__["a" /* default */]],
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    'member-profile-details': __WEBPACK_IMPORTED_MODULE_1__views_Members_Tabs_Details__["a" /* default */],
    'member-profile-history': __WEBPACK_IMPORTED_MODULE_2__views_Members_Tabs_MembershipHistory__["a" /* default */]
  },
  data: function data() {
    return {
      child: this.details.parent_id !== null,
      selectedTab: 'details'
    };
  },
  methods: {
    renew: function renew() {
      this.$router.push({
        name: 'My Profile',
        params: {
          renewing: true,
          tabSelect: 'membership',
          memberDetails: this.details,
          child: this.child
        }
      });
    }
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cart_Cart__ = __webpack_require__(825);
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MyMembershipCart',
  props: {
    backTo: String,
    preselectedYear: String
  },
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    cart: __WEBPACK_IMPORTED_MODULE_1__Cart_Cart__["a" /* default */]
  },
  data: function data() {
    return {
      cartMembers: this.$store.state.cartMembers
    };
  },
  methods: {
    cartChanged: function cartChanged() {
      this.cartMembers = this.$store.state.cartMembers;
    }
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__ = __webpack_require__(8);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Cart',
  props: {
    cartMembers: {
      type: Object,
      default: {
        items: [],
        users: [],
        total: 0
      }
    },
    backTo: {
      type: String,
      default: 'members'
    },
    preselectedYear: String
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__["a" /* default */]],
  data: function data() {
    return {
      errors: '',
      total: this.cartMembers.total,
      memberUpdate: this.cartMembers.users,
      cartList: this.cartMembers.items,
      // eslint-disable-next-line
      processing: this.cartMembers.items ? _toConsumableArray(this.cartMembers.items.map(function (item) {
        return false;
      })) : [],
      terms: false,
      rules: false,
      userRole: localStorage.role
    };
  },
  methods: {
    remove: function remove(index) {
      var _this = this;

      var data = _toConsumableArray(this.cartList);

      if (data.length > 1) {
        data.splice(index, 1); // eslint-disable-next-line
        // console.log(data)

        data = data.filter(function (item) {
          return !item.hasOwnProperty('products');
        });
        data = data.map(function (item) {
          return item.id;
        }); // eslint-disable-next-line
        // console.log(data)

        this.processing.splice(index, 1, true);
        var parentId = this.memberUpdate.filter(function (row) {
          return row.parent_id;
        }).length > 0 ? this.memberUpdate.filter(function (row) {
          return row.parent_id;
        })[0].parent_id : this.memberUpdate[0].id;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/total-cart"), {
          data: data,
          user_id: parentId
        }).then(function (response) {
          // eslint-disable-next-line
          // console.log(response.data)
          _this.processing.splice(index, 1, false);

          if (response.data.status === 'success') {
            var cart = response.data;
            cart.payer_user_id = _this.cartMembers.payer_user_id;
            cart.payer_email = _this.cartMembers.payer_email;

            _this.memberUpdate.splice(index, 1);

            cart.users = _toConsumableArray(_this.memberUpdate);

            _this.$store.commit('updateCartMembers', cart);

            _this.$emit('cartChanged');
          }
        }).catch(function (error) {
          _this.processing.splice(index, 1, false); // eslint-disable-next-line


          console.log(error);
        });
      } else {
        this.$store.commit('updateCartMembers', {
          items: [],
          total: 0,
          users: []
        });
        this.$emit('cartChanged');
      }
    },
    payment: function payment() {
      var _this2 = this;

      setTimeout(function () {
        if (_this2.formComplete) {
          _this2.$router.push({
            name: 'My Membership Payment'
          });
        }
      }, 10);
    }
  },
  watch: {
    cartMembers: {
      deep: true,
      handler: function handler() {
        this.total = this.cartMembers.total;
        this.memberUpdate = this.cartMembers.users;
        this.cartList = this.cartMembers.items;
      }
    }
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Payment__ = __webpack_require__(140);
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MyMembershipPayment',
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    payment: __WEBPACK_IMPORTED_MODULE_1__components_Payment__["a" /* default */]
  },
  data: function data() {
    return {
      cartMembers: this.$store.state.cartMembers
    };
  },
  mounted: function mounted() {
    if (this.cartMembers.hasOwnProperty('total') === false) {
      this.$router.push('/my-account/cart');
    }
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slide_toggle__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StripeCardModal__ = __webpack_require__(829);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Payment',
  components: {
    VueSlideToggle: __WEBPACK_IMPORTED_MODULE_1_vue_slide_toggle__["a" /* VueSlideToggle */],
    StripeCardModal: __WEBPACK_IMPORTED_MODULE_3__components_StripeCardModal__["a" /* default */]
  },
  props: {
    cartMembers: {
      type: Object,
      default: {
        items: [],
        horses: [],
        users: [],
        total: 0
      }
    },
    type: String
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_formValidation_js__["a" /* default */]],
  data: function data() {
    return {
      success: '',
      errors: '',
      paymentMethod: 'stripe',
      stripe: {
        email: this.getEmail()
      },
      env: "production",
      userID: localStorage.userID,
      processing: false,
      profileIncomplete: false,
      showCardModal: false
    };
  },
  computed: {
    totalDisplay: function totalDisplay() {
      return Number(this.cartMembers.total || 0).toFixed(2);
    },
    theMemberNumber: function theMemberNumber() {
      if (this.cartMembers.horses) {
        return this.cartMembers.horses[0].member_number;
      } else if (this.cartMembers.committee && this.cartMembers.secretary) {
        return this.cartMembers.secretary.member_number;
      }

      return this.cartMembers.users.filter(function (user) {
        return user.parent_id === null;
      }).length > 0 ? this.cartMembers.users.filter(function (user) {
        return user.primary === null;
      })[0].member_number : this.cartMembers.users.length > 0 ? this.cartMembers.users[0].parent_member_number : null;
    },
    theUserID: function theUserID() {
      if (this.cartMembers.horses) {
        return this.userID;
      } else if (this.cartMembers.committee && this.cartMembers.secretary) {
        return this.cartMembers.secretary.id;
      } else if (this.cartMembers.payer_user_id) {
        return this.cartMembers.payer_user_id;
      } else if (this.cartMembers.users && this.cartMembers.users.length) {
        var user = this.cartMembers.users[0];

        if (user.attributes && user.attributes.user_id) {
          return user.attributes.user_id;
        }

        return user.parent_id || user.id;
      }

      return null;
    },
    paymentReturnRoute: function paymentReturnRoute() {
      return {
        name: this.$route.name,
        params: _objectSpread({}, this.$route.params)
      };
    },
    profileRoute: function profileRoute() {
      if (localStorage.role === 'Admin' || localStorage.role === 'SuperAdmin') {
        return {
          name: 'Member Profile',
          params: {
            slug: String(this.theUserID),
            completePaymentProfile: true,
            returnTo: this.paymentReturnRoute
          },
          hash: '#details'
        };
      }

      return {
        name: 'My Profile',
        params: {
          tabSelect: 'details',
          completePaymentProfile: true,
          returnTo: this.paymentReturnRoute
        }
      };
    }
  },
  methods: {
    buildPaymentData: function buildPaymentData(token, preflight) {
      var _this = this;

      var userId = this.theUserID;

      if (!userId) {
        throw new Error('payer_user_id_missing');
      }

      return {
        user_id: userId,
        type: this.type,
        method: this.paymentMethod,
        total: this.cartMembers.total,
        items: this.cartMembers.items.map(function (item) {
          return item.id;
        }),
        token: token,
        preflight: Boolean(preflight),
        data: this.cartMembers.items.map(function (item, index) {
          var tempObject = _objectSpread({}, item);

          if (_this.type === 'registration' || _this.type === 'rookie-nomination') {
            tempObject.horse_id = _this.cartMembers.horses[index].id;
          } else if (_this.type === 'committee-affiliation') {
            tempObject.committee_id = _this.cartMembers.committee.id;
          } else {
            tempObject.userData = _this.cartMembers.users[index];
          }

          delete tempObject.active;
          delete tempObject.price;
          delete tempObject.sku;
          return tempObject;
        })
      };
    },
    showPaymentError: function showPaymentError(error) {
      var responseData = error.response && error.response.data ? error.response.data : null;
      this.success = '';
      this.profileIncomplete = Boolean(responseData && responseData.status === 'profile_incomplete');
      this.errors = responseData && responseData.message ? responseData.message : 'A server error occurred. Please try again later.';
    },
    checkPaymentProfile: function checkPaymentProfile() {
      var _this2 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(_this2.$api, "/payment"), _this2.buildPaymentData(null, true));

              case 3:
                response = _context.sent;

                if (!(response.data.status === 'success')) {
                  _context.next = 9;
                  break;
                }

                _this2.profileIncomplete = false;
                _this2.errors = '';

                if (response.data.email) {
                  _this2.stripe.email = response.data.email;
                }

                return _context.abrupt("return", true);

              case 9:
                _this2.success = '';
                _this2.profileIncomplete = response.data.status === 'profile_incomplete';
                _this2.errors = response.data.message || 'A server error occurred. Please try again later.';
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](0);

                if (_context.t0.message === 'payer_user_id_missing') {
                  _this2.success = '';
                  _this2.profileIncomplete = true;
                  _this2.errors = 'Your account details are incomplete. Please update your profile before making a payment.';
                } else {
                  _this2.showPaymentError(_context.t0);
                }

              case 17:
                return _context.abrupt("return", false);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 14]]);
      }))();
    },
    addInvoice: function addInvoice(token) {
      var _this3 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var data, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.processing = true;
                _context2.prev = 1;
                data = _this3.buildPaymentData(token, false);
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(_this3.$api, "/payment"), data);

              case 5:
                response = _context2.sent;

                if (response.data.status === 'success') {
                  _this3.resetCart();

                  _this3.success = _this3.paymentMethod === 'voucher' || _this3.paymentMethod === 'bank' ? 'Thank you. Waiting for payment.' : 'Payment completed successfully.';
                } else if (response.data.status === 'error_payment_not_taken') {
                  _this3.success = '';
                  _this3.errors = 'An error occurred with the payment provider. You have not been charged. Please try again later.';
                } else if (response.data.status === 'card_error') {
                  _this3.success = '';
                  _this3.errors = response.data.message;
                } else if (response.data.status === 'error') {
                  _this3.success = '';
                  _this3.errors = response.data.message;
                } else {
                  _this3.success = '';
                  _this3.errors = response.data && response.data.message ? response.data.message : 'A server error occurred. Please try again later.';
                }

                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](1);

                if (_context2.t0.message === 'payer_user_id_missing') {
                  _this3.success = '';
                  _this3.profileIncomplete = true;
                  _this3.errors = 'Your account details are incomplete. Please update your profile before making a payment.';
                } else {
                  _this3.showPaymentError(_context2.t0);
                }

              case 12:
                _context2.prev = 12;
                _this3.processing = false;
                return _context2.finish(12);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 9, 12, 15]]);
      }))();
    },
    getEmail: function getEmail() {
      if (typeof this.cartMembers.payer_email === 'string' && this.cartMembers.payer_email.trim()) {
        return this.cartMembers.payer_email.trim();
      }

      if (this.cartMembers.hasOwnProperty('users')) {
        var user = this.cartMembers.users.find(function (item) {
          return item.attributes && typeof item.attributes.email === 'string' && item.attributes.email.trim();
        });
        return user ? user.attributes.email.trim() : '';
      } else if (this.cartMembers.hasOwnProperty('horses')) {
        return this.cartMembers.horses[0].member_email;
      } else if (this.cartMembers.committee && this.cartMembers.secretary) {
        return this.cartMembers.secretary.email;
      }

      return '';
    },
    makePayment: function makePayment() {
      var _this4 = this;

      setTimeout(
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var profileReady;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this4.formComplete && !_this4.processing)) {
                  _context3.next = 19;
                  break;
                }

                _this4.processing = true;
                _context3.next = 4;
                return _this4.checkPaymentProfile();

              case 4:
                profileReady = _context3.sent;
                _this4.processing = false;

                if (profileReady) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return");

              case 8:
                _context3.t0 = _this4.paymentMethod;
                _context3.next = _context3.t0 === 'stripe' ? 11 : _context3.t0 === 'voucher' ? 14 : _context3.t0 === 'bank' ? 16 : 18;
                break;

              case 11:
                _context3.next = 13;
                return _this4.stripePayment();

              case 13:
                return _context3.abrupt("break", 19);

              case 14:
                _this4.done();

                return _context3.abrupt("break", 19);

              case 16:
                _this4.done();

                return _context3.abrupt("break", 19);

              case 18:
                return _context3.abrupt("break", 19);

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })), 10);
    },
    resetCart: function resetCart() {
      /* Reset cart/selection data after payment */
      this.$store.commit('updateCartMembers', {});
      this.$store.commit('deselectAllRows');
    },
    stripePayment: function stripePayment() {
      this.errors = '';
      this.processing = false;
      this.showCardModal = true;
    },
    onCardToken: function onCardToken(token) {
      this.showCardModal = false;
      this.done({
        token: _objectSpread({}, token, {
          email: this.stripe.email
        })
      });
    },
    closeCardModal: function closeCardModal() {
      this.showCardModal = false;
      this.processing = false;
    },
    done: function done(token) {
      this.addInvoice(token);
    }
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stripe_stripe_js__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppButton__ = __webpack_require__(92);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'StripeCardModal',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_Modal__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_3__components_AppButton__["a" /* default */]
  },
  props: {
    amount: {
      type: String,
      default: ''
    }
  },
  emits: ['token', 'close'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;

    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var cardEl = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var ready = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var submitting = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var errorMessage = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('');
    var stripe = null;
    var card = null;
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var elements;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return Object(__WEBPACK_IMPORTED_MODULE_1__stripe_stripe_js__["a" /* loadStripe */])(proxy.$stripePk);

            case 3:
              stripe = _context.sent;
              elements = stripe.elements();
              card = elements.create('card', {
                hidePostalCode: true
              });
              card.mount(cardEl.value);
              card.on('change', function (event) {
                errorMessage.value = event.error != null ? event.error.message : '';
              });
              ready.value = true;
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              errorMessage.value = 'Unable to load the payment form. Please try again.';

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 11]]);
    })));
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["h" /* onBeforeUnmount */])(function () {
      if (card != null) card.destroy();
    });

    function submit() {
      return _submit.apply(this, arguments);
    }

    function _submit() {
      _submit = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(stripe == null || card == null || submitting.value)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                submitting.value = true;
                errorMessage.value = '';
                _context2.prev = 4;
                _context2.next = 7;
                return stripe.createToken(card);

              case 7:
                result = _context2.sent;

                if (!(result.error != null)) {
                  _context2.next = 11;
                  break;
                }

                errorMessage.value = result.error.message;
                return _context2.abrupt("return");

              case 11:
                emit('token', result.token);
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](4);
                errorMessage.value = 'The card could not be processed. Please try again.';

              case 17:
                _context2.prev = 17;
                submitting.value = false;
                return _context2.finish(17);

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 14, 17, 20]]);
      }));
      return _submit.apply(this, arguments);
    }

    function close(event) {
      if (event != null && typeof event.preventDefault === 'function') {
        event.preventDefault();
      }

      if (submitting.value) return;
      emit('close');
    }

    return {
      cardEl: cardEl,
      ready: ready,
      submitting: submitting,
      errorMessage: errorMessage,
      submit: submit,
      close: close
    };
  }
}));

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MemberAddDetails__ = __webpack_require__(836);
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MemberAdd',
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    'member-add-details': __WEBPACK_IMPORTED_MODULE_1__MemberAddDetails__["a" /* default */]
  },
  data: function data() {
    return {
      selectedTab: 'details'
    };
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_legacyBrowsers_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_calcType_js__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DesktopActionBar__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FormFields_PhoneInput__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_TestPhoneNumbers__ = __webpack_require__(68);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MemberAddDetails',
  props: ['details'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_calcType_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_legacyBrowsers_js__["a" /* default */]],
  components: {
    TestPhoneNumbers: __WEBPACK_IMPORTED_MODULE_7__components_TestPhoneNumbers__["a" /* default */],
    PhoneInput: __WEBPACK_IMPORTED_MODULE_6__components_FormFields_PhoneInput__["a" /* default */],
    DesktopActionBar: __WEBPACK_IMPORTED_MODULE_5__components_DesktopActionBar__["a" /* default */]
  },
  data: function data() {
    return {
      memberPages: 1,
      memberUpdate: [{
        notes: '',
        file_name: ''
      }],
      memberTypesCount: {},
      userID: localStorage.userID,
      userRole: localStorage.role,
      processing: false,
      errorStatus: '',
      errors: [],
      commonError: '',
      files: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.userRole === 'Admin' || this.userRole === 'SuperAdmin') {
      setTimeout(function () {
        if (_this.$store.state.viewedMember === '' && _this.$store.state.childMember === '') {
          _this.$router.push('/');
        }
      }, 1);
    }
  },
  methods: {
    setPrice: function setPrice(index) {
      this.memberUpdate[index].price = this.$store.state.products[index].price;
      this.getTotal();
    },
    getTotal: function getTotal() {
      var _this2 = this;

      // eslint-disable-next-line
      this.memberTypesCount = this.memberUpdate.reduce(function (member, o) {
        return member[o.type] = (member[o.type] || 0) + 1, member;
      }, {});
      delete this.memberTypesCount.undefined;
      /* Do Couples/Family Discount */

      if (this.memberTypesCount.Adult > 1) {
        var couples = Math.floor(this.memberTypesCount.Adult / 2);

        if (this.memberTypesCount.Juvenile > 0 && (this.memberTypesCount.Junior > 0 || this.memberTypesCount.Mini > 0)) {
          var families = null;

          if (this.memberTypesCount.Junior > 0 && this.memberTypesCount.Mini > 0) {
            families = Math.min(couples, Math.min(this.memberTypesCount.Juvenile, Math.max(this.memberTypesCount.Junior, this.memberTypesCount.Mini)));
          } else if (this.memberTypesCount.Junior > 0) {
            families = Math.min(couples, Math.min(this.memberTypesCount.Juvenile, this.memberTypesCount.Junior));
          } else {
            families = Math.min(couples, Math.min(this.memberTypesCount.Juvenile, this.memberTypesCount.Mini));
          } // this.memberTypesCount.Juvenile -= families
          // this.memberTypesCount.Junior -= families
          // this.memberTypesCount.Adult -= families * 2


          couples -= families;
          this.memberTypesCount['Family Discount'] = families;
        }

        if (couples > 0) {// this.memberTypesCount.Adult -= couples * 2
        }

        this.memberTypesCount['Couples Dicsount'] = couples;
        /* Remove keys from cart with zero in them */

        Object.keys(this.memberTypesCount).forEach(function (key) {
          return _this2.memberTypesCount[key] === 0 && delete _this2.memberTypesCount[key];
        });
      }
    },
    saveMembers: function saveMembers() {
      var _this3 = this;

      setTimeout(function () {
        if (_this3.formComplete && _this3.errors.length === 0 && !_this3.commonError) {
          _this3.processing = true;

          var membersSend = _this3.memberUpdate.map(function (member) {
            member.dob = member.dateOfBirth;
            member.rider_status_id = _this3.$store.state.riderStatus.filter(function (item) {
              return item.name === member.riderStatus;
            })[0].id;
            return member;
          });

          var fields = {
            primary_id: _this3.userRole !== 'Admin' && _this3.userRole !== 'SuperAdmin' ? _this3.userID : _this3.$store.state.viewedMember ? _this3.$store.state.viewedMember.primary ? _this3.$store.state.viewedMember.primary.id : _this3.$store.state.viewedMember.id : _this3.$store.state.childMember ? _this3.$store.state.childMember.primary.id : null,
            secondaries: membersSend
          };
          var formData = new FormData();

          for (var i = 0; i < _this3.files.length; i++) {
            var file = _this3.files[i];

            if (_this3.files[i] && _this3.files[i].size > 1024 * 1024) {
              _this3.errorStatus = 'file';
              _this3.errors[i] = "The Proof of Age file may not be greater than 1 mb.";
            }

            formData.append("files[".concat(i, "]"), file);
          }

          formData.append('fields', JSON.stringify(fields));
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(_this3.$api, "/add-secondary"), formData).then(function (response) {
            _this3.errors = []; // eslint-disable-next-line
            // console.log(response.data)

            _this3.processing = false;

            if (response.data.status === 'success') {
              var users = response.data;
              users.users = _this3.memberUpdate; // this.$store.commit('updateCartMembers', users)

              _this3.$router.push({
                name: _this3.$isAdmin ? 'Member Profile' : 'My Profile',
                params: {
                  renewing: true,
                  tabSelect: 'details',
                  details: _this3.$store.state.viewedMember || _this3.$store.state.childMember ? _this3.$store.state.childMember : undefined
                }
              });
            } else if (response.data.status === 'validation_error' && Object.keys(response.data.errors).filter(function (k) {
              return k.includes("dob");
            }).length > 0) {
              // Do any keys in the error object contain the text 'dob'?
              // DoB
              _this3.errorStatus = 'validation_error';
              _this3.errors[Object.keys(response.data.errors).filter(function (k) {
                return k.includes("dob");
              })[0].match(/\d+/)[0]] = "Please include the Date of Birth in the format".concat(_this3.isLegacy() ? ' yyyy-mm-dd' : ' dd/mm/yyyy', ".");
            } else if (Object.keys(response.data.errors).filter(function (k) {
              return k.includes("first_name");
            }).length > 0) {
              _this3.errors[Object.keys(response.data.errors).filter(function (k) {
                return k.includes("first_name");
              })[0].match(/\d+/)[0]] = "Please include a First Name with a maximum of 40 characters.";
            } else if (Object.keys(response.data.errors).filter(function (k) {
              return k.includes("last_name");
            }).length > 0) {
              _this3.errors[Object.keys(response.data.errors).filter(function (k) {
                return k.includes("last_name");
              })[0].match(/\d+/)[0]] = "Please include a Last Name with a maximum of 40 characters.";
            } else if (response.data.status === 'validation_error' && Object.keys(response.data.errors).filter(function (k) {
              return k.includes("secondary_phone");
            }).length > 0) {
              _this3.errorStatus = 'incorrect_phone';
              _this3.errors[Object.keys(response.data.errors).filter(function (k) {
                return k.includes("secondary_phone");
              })[0].match(/\d+/)[0]] = "Please include correct phone number.";
            } else if (response.data.status === 'validation_error' && Object.keys(response.data.errors).filter(function (k) {
              return k.includes("secondary_phone");
            }).length > 0) {
              _this3.errorStatus = 'carbon_copy_mobile';
              _this3.errors[Object.keys(response.data.errors).filter(function (k) {
                return k.includes("carbon_copy_mobile");
              })[0].match(/\d+/)[0]] = "Please include correct CC mobile.";
            } else if (response.data.status === 'validation_error' && Object.keys(response.data.errors).filter(function (k) {
              return k.includes("member_number");
            }).length > 0) {
              _this3.errorStatus = 'member_number';
              _this3.errors[Object.keys(response.data.errors).filter(function (k) {
                return k.includes("secondary_phone");
              })[0].match(/\d+/)[0]] = "The member number has already been taken.";
            } else if (response.data.status === 'validation_error' && Object.keys(response.data.errors).filter(function (k) {
              return k.includes("secondary_email");
            }).length > 0) {
              _this3.errorStatus = 'secondary_email';
              _this3.errors[Object.keys(response.data.errors).filter(function (k) {
                return k.includes("secondary_email");
              })[0].match(/\d+/)[0]] = "Please include correct email address";
            } else if (response.data.status === 'validation_error' && Object.keys(response.data.errors).filter(function (k) {
              return k.includes("file");
            }).length > 0) {
              _this3.errorStatus = 'file';
              _this3.errors[Object.keys(response.data.errors).filter(function (k) {
                return k.includes("secondary_email");
              })[0].match(/\d+/)[0]] = "The Proof of Age file may not be greater than 1 mb.";
            }
          }).catch(function (error) {
            if (error.response.status === 413) {
              _this3.success = '';
              _this3.errorStatus = 'file';
              _this3.commonError = "The Proof of Age file may not be greater than 1 mb.";
            }

            _this3.errors = [];
            _this3.processing = false; // eslint-disable-next-line

            console.log(error);
          });
        }
      }, 10);
    },
    getPrice: function getPrice(type, typeKey) {
      var result = null;

      if (this.$store.state.products.filter(function (item) {
        return item.name === typeKey;
      }).length > 0) {
        result = (this.$store.state.products.filter(function (item) {
          return item.name === typeKey;
        })[0].price * type).toFixed(2);
      } else {
        result = (this.$store.state.discounts.filter(function (item) {
          return item.name === typeKey;
        })[0].price * type).toFixed(2);
      }

      return result;
    },
    fileUpload: function fileUpload(event, index) {
      this.errorStatus = '';
      this.memberUpdate[index].file_name = ''; // eslint-disable-next-line

      __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.remove(this.errors, function (value, ind) {
        return ind === index;
      });

      var uploadedFile = event.target.files[0];
      this.files[index] = uploadedFile;

      if (uploadedFile && this.files[index].size > 1024 * 1024) {
        this.errorStatus = 'file';
        this.errors[index] = "The Proof of Age file may not be greater than 1 mb.";
      }

      if (uploadedFile) {
        this.memberUpdate[index].file_name = uploadedFile.name;
      }
    },
    deleteAttachment: function deleteAttachment(index) {
      delete this.files[index];
      this.files[index] = undefined;
      this.memberUpdate[index].file_name = '';
      this.errorStatus = ''; // eslint-disable-next-line

      __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.remove(this.errors, function (value, ind) {
        return ind === index;
      });
    }
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ResponsiveTable__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Pagination__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Committees_CommitteeSecretariesLink__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_api_committees__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__composables_committees_useCommitteesList__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_committeeFinancialFilter__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__committeesColumns__ = __webpack_require__(845);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









 // Admin Committee List: server-side search / financial tab / sort / pagination (same pattern as
// Secretary Users and the Members/Horses/Drafts lists).

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'CommitteesList',
  props: ['success'],
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__["a" /* default */],
    ResponsiveTable: __WEBPACK_IMPORTED_MODULE_2__components_ResponsiveTable__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_3__components_Pagination__["a" /* default */],
    CommitteeSecretariesLink: __WEBPACK_IMPORTED_MODULE_5__components_Committees_CommitteeSecretariesLink__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_4__components_Modal__["a" /* default */]
  },
  setup: function setup(props) {
    var _useCommitteesList = Object(__WEBPACK_IMPORTED_MODULE_7__composables_committees_useCommitteesList__["a" /* default */])(),
        rows = _useCommitteesList.rows,
        loading = _useCommitteesList.loading,
        page = _useCommitteesList.page,
        totalPages = _useCommitteesList.totalPages,
        filters = _useCommitteesList.filters,
        perPageOptions = _useCommitteesList.perPageOptions,
        fetch = _useCommitteesList.fetch,
        setPage = _useCommitteesList.setPage,
        setSort = _useCommitteesList.setSort,
        setPerPage = _useCommitteesList.setPerPage,
        setSearch = _useCommitteesList.setSearch,
        setFilter = _useCommitteesList.setFilter;

    var columns = Object(__WEBPACK_IMPORTED_MODULE_9__committeesColumns__["b" /* buildColumns */])();
    var breakpoints = Object(__WEBPACK_IMPORTED_MODULE_9__committeesColumns__["a" /* buildBreakpoints */])();
    var successMessage = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(props.success || '');
    var errorMessage = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('');

    function profileRoute(row) {
      return {
        name: 'Committee Profile',
        params: {
          id: String(row.id)
        }
      };
    } // Search-as-you-type with a 500ms debounce; Enter / the icon fire it immediately.


    var searchInput = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(filters.search || '');
    var searchTimer = null;

    function applySearch() {
      clearTimeout(searchTimer);
      if (searchInput.value !== filters.search) setSearch(searchInput.value);
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(searchInput, function (val) {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
        if (val !== filters.search) setSearch(val);
      }, 500);
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["h" /* onBeforeUnmount */])(function () {
      return clearTimeout(searchTimer);
    }); // --- Remove committee ---

    var rowToRemove = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var removing = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

    function askRemove(row) {
      rowToRemove.value = row;
    }

    function remove() {
      var id = rowToRemove.value.id;
      rowToRemove.value = null;
      removing.value = true;
      successMessage.value = '';
      errorMessage.value = '';
      __WEBPACK_IMPORTED_MODULE_6__services_api_committees__["a" /* default */].remove(id).then(function (response) {
        if (response.data.status === 'success') {
          successMessage.value = 'The committee has been removed.';
          fetch();
        } else {
          errorMessage.value = 'Unable to remove the committee. Please try again.';
        }
      }).catch(function () {
        errorMessage.value = 'Unable to receive data from the server. Please reload the page.';
      }).finally(function () {
        removing.value = false;
      });
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      return fetch();
    });
    return {
      columns: columns,
      breakpoints: breakpoints,
      rows: rows,
      loading: loading,
      page: page,
      totalPages: totalPages,
      filters: filters,
      perPageOptions: perPageOptions,
      searchInput: searchInput,
      successMessage: successMessage,
      errorMessage: errorMessage,
      rowToRemove: rowToRemove,
      removing: removing,
      COMMITTEE_FINANCIAL_TABS: __WEBPACK_IMPORTED_MODULE_8__constants_committeeFinancialFilter__["b" /* COMMITTEE_FINANCIAL_TABS */],
      setPage: setPage,
      setSort: setSort,
      setPerPage: setPerPage,
      setFilter: setFilter,
      applySearch: applySearch,
      profileRoute: profileRoute,
      askRemove: askRemove,
      remove: remove
    };
  }
}));

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeSecretariesLink_vue__ = __webpack_require__(336);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f629326_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeSecretariesLink_vue__ = __webpack_require__(843);
function injectStyle (ssrContext) {
  __webpack_require__(842)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f629326"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeSecretariesLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f629326_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeSecretariesLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppTooltip__ = __webpack_require__(94);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
 // Admin shortcut: jumps to Secretary Users pre-searched by this committee's name, so an admin can
// quickly find one of its secretaries and log in as them. Used by the Drafts and Committee lists.

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CommitteeSecretariesLink',
  components: {
    AppTooltip: __WEBPACK_IMPORTED_MODULE_0__components_AppTooltip__["a" /* default */]
  },
  props: {
    committeeName: {
      type: String,
      default: ''
    }
  }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMMITTEE_FINANCIAL_ALL; });
/* unused harmony export COMMITTEE_FINANCIAL_FINANCIAL */
/* unused harmony export COMMITTEE_FINANCIAL_UNFINANCIAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMMITTEE_FINANCIAL_TABS; });
// Mirror of App\Enums\CommitteeFinancialFilter (campdraftone-api) — `is_financial` filter of
// /v2/committees. Keep in sync by hand. Labels stay here: it is a filter, not a stored column.
var COMMITTEE_FINANCIAL_ALL = 'all';
var COMMITTEE_FINANCIAL_FINANCIAL = 'financial';
var COMMITTEE_FINANCIAL_UNFINANCIAL = 'unfinancial';
var COMMITTEE_FINANCIAL_TABS = [{
  value: COMMITTEE_FINANCIAL_ALL,
  label: 'All'
}, {
  value: COMMITTEE_FINANCIAL_FINANCIAL,
  label: 'Financial'
}, {
  value: COMMITTEE_FINANCIAL_UNFINANCIAL,
  label: 'Unfinancial'
}];

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ResponsiveTable__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Pagination__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ListNameCell__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__composables_committees_useSwitchableCommittees__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_actingCommittee__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__switchCommitteeColumns__ = __webpack_require__(850);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







 // CAM-1533: Super Secretary committee switcher. The API lists financial committees only and
// rejects (acting_committee_invalid) any other in X-Acting-Committee.

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'SwitchCommittee',
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__["a" /* default */],
    ResponsiveTable: __WEBPACK_IMPORTED_MODULE_2__components_ResponsiveTable__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_3__components_Pagination__["a" /* default */],
    ListNameCell: __WEBPACK_IMPORTED_MODULE_4__components_ListNameCell__["a" /* default */]
  },
  setup: function setup() {
    var _useSwitchableCommitt = Object(__WEBPACK_IMPORTED_MODULE_5__composables_committees_useSwitchableCommittees__["a" /* default */])(),
        rows = _useSwitchableCommitt.rows,
        loading = _useSwitchableCommitt.loading,
        page = _useSwitchableCommitt.page,
        totalPages = _useSwitchableCommitt.totalPages,
        filters = _useSwitchableCommitt.filters,
        perPageOptions = _useSwitchableCommitt.perPageOptions,
        fetch = _useSwitchableCommitt.fetch,
        setPage = _useSwitchableCommitt.setPage,
        setSort = _useSwitchableCommitt.setSort,
        setPerPage = _useSwitchableCommitt.setPerPage,
        setSearch = _useSwitchableCommitt.setSearch;

    var columns = Object(__WEBPACK_IMPORTED_MODULE_7__switchCommitteeColumns__["b" /* buildColumns */])();
    var breakpoints = Object(__WEBPACK_IMPORTED_MODULE_7__switchCommitteeColumns__["a" /* buildBreakpoints */])();
    var errorMessage = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('');
    var ownCommitteeId = localStorage.own_committee_id ? Number(localStorage.own_committee_id) : null;

    var isOwn = function isOwn(committee) {
      return committee.id === ownCommitteeId;
    };

    function isCurrent(committee) {
      var acting = Object(__WEBPACK_IMPORTED_MODULE_6__services_actingCommittee__["a" /* getActingCommittee */])();
      return committee.id === (acting ? acting.id : ownCommitteeId);
    } // The user's own committee returns to normal: no header is sent any more.


    function switchTo(committee) {
      Object(__WEBPACK_IMPORTED_MODULE_6__services_actingCommittee__["b" /* setActingCommittee */])(isOwn(committee) ? null : committee); // Every page's data is committee-scoped — start clean on the nominations dashboard

      window.location.assign('/committees/dashboard');
    }

    var searchInput = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(filters.search || '');
    var searchTimer = null;

    function applySearch() {
      clearTimeout(searchTimer);
      if (searchInput.value !== filters.search) setSearch(searchInput.value);
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(searchInput, function (val) {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
        if (val !== filters.search) setSearch(val);
      }, 500);
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["h" /* onBeforeUnmount */])(function () {
      return clearTimeout(searchTimer);
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      return fetch();
    });
    return {
      columns: columns,
      breakpoints: breakpoints,
      rows: rows,
      loading: loading,
      page: page,
      totalPages: totalPages,
      filters: filters,
      perPageOptions: perPageOptions,
      searchInput: searchInput,
      errorMessage: errorMessage,
      setPage: setPage,
      setSort: setSort,
      setPerPage: setPerPage,
      applySearch: applySearch,
      isOwn: isOwn,
      isCurrent: isCurrent,
      switchTo: switchTo
    };
  }
}));

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CommitteeSecretaries__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CommitteeAffiliation__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CommitteeProfileAllDetails__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CommitteeProfileFinancials__ = __webpack_require__(350);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CommitteeProfile',
  props: ['details', 'id'],
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */],
    'committee-profile-all-details': __WEBPACK_IMPORTED_MODULE_4__CommitteeProfileAllDetails__["a" /* default */],
    'committee-profile-financials': __WEBPACK_IMPORTED_MODULE_5__components_CommitteeProfileFinancials__["a" /* default */],
    'committee-secretaries': __WEBPACK_IMPORTED_MODULE_2__components_CommitteeSecretaries__["a" /* default */],
    'committee-affiliation': __WEBPACK_IMPORTED_MODULE_3__components_CommitteeAffiliation__["a" /* default */]
  },
  data: function data() {
    return {
      committee: null,
      isLoading: true,
      selectedTab: this.tabSelect ? this.tabSelect : 'details'
    };
  },
  mounted: function mounted() {
    var _this = this;

    var committeeId = this.id || this.details && (this.details.committee ? this.details.committee.id : this.details.id);

    if (committeeId) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/committee-details/").concat(committeeId)).then(function (response) {
        _this.committee = response.data.data;
        _this.isLoading = false;
      }).catch(function (error) {
        // eslint-disable-next-line
        console.log(error);
        _this.isLoading = false;
      });
    } else {
      this.isLoading = false;
    }
  },
  watch: {
    committee: function committee() {
      if (this.selectedTab === 'loading') {
        this.selectedTab = 'details';
      }
    }
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeSecretaries_vue__ = __webpack_require__(341);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38a26658_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeSecretaries_vue__ = __webpack_require__(862);
function injectStyle (ssrContext) {
  __webpack_require__(853)
  __webpack_require__(854)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38a26658"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeSecretaries_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38a26658_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeSecretaries_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_typeahead__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CommitteeSecretaries',
  props: ['committeeDetails'],
  components: {
    VueBootstrapTypeahead: __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_typeahead__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_formValidation_js__["a" /* default */]],
  data: function data() {
    return {
      committee: _objectSpread({}, this.committeeDetails),
      user: localStorage.role,
      processing: false,
      errors: '',
      errorStatus: '',
      secretaries: [],
      secretariesSearch: '',
      selectedSecretary: null,
      addedSecretaries: this.committeeDetails.secretaries,
      removeProcessing: false
    };
  },
  methods: {
    getSecretaries: function getSecretaries(search_term) {
      var _this = this;

      if (!search_term) {
        this.secretaries = [];
      } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/secretaries/list"), {
          params: {
            search_term: search_term
          }
        }).then(function (response) {
          if (response.data.status === 'success') {
            _this.errors = '';
            _this.secretaries = response.data.data;
          } else {
            _this.errors = 'Something went wrong. Please reload the page.';
          }
        });
      }
    },
    handleAddSecretary: function handleAddSecretary() {
      var _this2 = this;

      this.processing = true;

      if (this.selectedSecretary) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/committee/").concat(this.committee.id, "/add-secretary"), {
          secretary_id: this.selectedSecretary.id
        }).then(function (response) {
          if (response.data.status === 'success') {
            _this2.processing = false;
            _this2.errors = '';

            if (_this2.selectedSecretary) {
              _this2.addedSecretaries.push(_this2.selectedSecretary);
            }

            _this2.selectedSecretary = null;
          } else {
            _this2.errors = 'Something went wrong. Please reload the page.';
          }
        });
      }

      this.processing = false;
    },
    removeSecretary: function removeSecretary(secretary_id, index) {
      var _this3 = this;

      this.$refs['secretary-item'][index].setAttribute('disabled', 'disabled');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/committee/").concat(this.committee.id, "/remove-secretary"), {
        secretary_id: secretary_id
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this3.addedSecretaries = _this3.addedSecretaries.filter(function (secretary) {
            return secretary.id !== secretary_id;
          });
          _this3.errors = '';
        } else {
          _this3.errors = 'Something went wrong. Please reload the page.';
        }
      });
    }
  },
  watch: {
    // eslint-disable-next-line func-names
    secretariesSearch: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (value) {
      this.getSecretaries(value);
    }, 500)
  }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueBootstrapTypeaheadList_vue__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resize_observer_polyfill__ = __webpack_require__(860);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueBootstrapTypehead',
  components: {
    VueBootstrapTypeaheadList: __WEBPACK_IMPORTED_MODULE_0__VueBootstrapTypeaheadList_vue__["a" /* default */]
  },
  props: {
    size: {
      type: String,
      default: null,
      validator: function validator(size) {
        return ['lg', 'sm'].indexOf(size) > -1;
      }
    },
    value: {
      type: String
    },
    data: {
      type: Array,
      required: true,
      validator: function validator(d) {
        return d instanceof Array;
      }
    },
    serializer: {
      type: Function,
      default: function _default(d) {
        return d;
      },
      validator: function validator(d) {
        return d instanceof Function;
      }
    },
    backgroundVariant: String,
    textVariant: String,
    inputClass: {
      type: String,
      default: ''
    },
    maxMatches: {
      type: Number,
      default: 10
    },
    minMatchingChars: {
      type: Number,
      default: 2
    },
    placeholder: String,
    prepend: String,
    append: String
  },
  computed: {
    sizeClasses: function sizeClasses() {
      return this.size ? "input-group input-group-".concat(this.size) : 'input-group';
    },
    formattedData: function formattedData() {
      var _this = this;

      if (!(this.data instanceof Array)) {
        return [];
      }

      return this.data.map(function (d, i) {
        return {
          id: i,
          data: d,
          text: _this.serializer(d)
        };
      });
    }
  },
  methods: {
    resizeList: function resizeList(el) {
      var rect = el.getBoundingClientRect();
      var listStyle = this.$refs.list.$el.style; // Set the width of the list on resize

      listStyle.width = rect.width + 'px'; // Set the margin when the prepend prop or slot is populated
      // (setting the "left" CSS property doesn't work)

      if (this.$refs.prependDiv) {
        var prependRect = this.$refs.prependDiv.getBoundingClientRect();
        listStyle.marginLeft = prependRect.width + 'px';
      }
    },
    handleHit: function handleHit(evt) {
      if (typeof this.value !== 'undefined') {
        this.$emit('input', evt.text);
      }

      this.inputValue = evt.text;
      this.$emit('hit', evt.data);
      this.$refs.input.blur();
      this.isFocused = false;
    },
    handleBlur: function handleBlur(evt) {
      var tgt = evt.relatedTarget;

      if (tgt && tgt.classList.contains('vbst-item')) {
        return;
      }

      this.isFocused = false;
    },
    handleInput: function handleInput(newValue) {
      this.inputValue = newValue; // If v-model is being used, emit an input event

      if (typeof this.value !== 'undefined') {
        this.$emit('input', newValue);
      }
    }
  },
  data: function data() {
    return {
      isFocused: false,
      inputValue: ''
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$_ro = new __WEBPACK_IMPORTED_MODULE_1_resize_observer_polyfill__["a" /* default */](function (e) {
      _this2.resizeList(_this2.$refs.input);
    });
    this.$_ro.observe(this.$refs.input);
    this.$_ro.observe(this.$refs.list.$el);
  },
  beforeDestroy: function beforeDestroy() {
    this.$_ro.disconnect();
  }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VueBootstrapTypeaheadListItem_vue__ = __webpack_require__(857);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function sanitize(text) {
  return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueBootstrapTypeaheadList',
  components: {
    VueBootstrapTypeaheadListItem: __WEBPACK_IMPORTED_MODULE_0__VueBootstrapTypeaheadListItem_vue__["a" /* default */]
  },
  props: {
    data: {
      type: Array,
      required: true,
      validator: function validator(d) {
        return d instanceof Array;
      }
    },
    query: {
      type: String,
      default: ''
    },
    backgroundVariant: {
      type: String
    },
    textVariant: {
      type: String
    },
    maxMatches: {
      type: Number,
      default: 10
    },
    minMatchingChars: {
      type: Number,
      default: 2
    }
  },
  computed: {
    highlight: function highlight() {
      var _this = this;

      return function (text) {
        text = sanitize(text);

        if (_this.query.length === 0) {
          return text;
        }

        var re = new RegExp(_this.escapedQuery, 'gi');
        return text.replace(re, "<strong>$&</strong>");
      };
    },
    escapedQuery: function escapedQuery() {
      return escapeRegExp(sanitize(this.query));
    },
    matchedItems: function matchedItems() {
      if (this.query.length === 0 || this.query.length < this.minMatchingChars) {
        return [];
      }

      var re = new RegExp(this.escapedQuery, 'gi'); // Filter, sort, and concat

      return this.data.filter(function (i) {
        return i.text.match(re) !== null;
      }).sort(function (a, b) {
        var aIndex = a.text.indexOf(a.text.match(re)[0]);
        var bIndex = b.text.indexOf(b.text.match(re)[0]);

        if (aIndex < bIndex) {
          return -1;
        }

        if (aIndex > bIndex) {
          return 1;
        }

        return 0;
      }).slice(0, this.maxMatches);
    }
  },
  methods: {
    handleHit: function handleHit(item, evt) {
      this.$emit('hit', item);
      evt.preventDefault();
    }
  }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueBootstrapTypeaheadListItem',
  props: {
    data: {},
    htmlText: {
      type: String
    },
    backgroundVariant: {
      type: String
    },
    textVariant: {
      type: String
    }
  },
  data: function data() {
    return {
      active: false
    };
  },
  computed: {
    textClasses: function textClasses() {
      var classes = '';
      classes += this.active ? 'active' : '';
      classes += this.backgroundVariant ? " bg-".concat(this.backgroundVariant) : '';
      classes += this.textVariant ? " text-".concat(this.textVariant) : '';
      return "vbst-item list-group-item list-group-item-action ".concat(classes);
    }
  }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeAffiliation_vue__ = __webpack_require__(346);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0536e361_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeAffiliation_vue__ = __webpack_require__(888);
function injectStyle (ssrContext) {
  __webpack_require__(863)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0536e361"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeAffiliation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0536e361_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeAffiliation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DesktopActionBar__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuelidate___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CommitteeAffiliation",
  props: ['committeeDetails'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__["a" /* default */]],
  components: {
    DesktopActionBar: __WEBPACK_IMPORTED_MODULE_5__components_DesktopActionBar__["a" /* default */]
  },
  data: function data() {
    return {
      processing: false,
      errors: '',
      affiliation: this.committeeDetails.affiliations[0],
      drafts: JSON.parse(this.committeeDetails.affiliations[0].drafts)
    };
  },
  validations: function validations() {
    return {
      affiliation: {
        mailing_address: {
          required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
        },
        grounds_address: {
          required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
        },
        president_name: {
          required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
        },
        secretary_name: {
          required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
        },
        treasurer_name: {
          required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
        }
      }
    };
  },
  methods: {
    updateCommittee: function updateCommittee() {
      var _this = this;

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR';
        return;
      }

      this.processing = true;
      this.data = this.affiliation;
      this.submitStatus = 'PENDING';
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch("".concat(this.$api, "/admin/committee/affiliation"), this.data).then(function (response) {
        _this.processing = false; // eslint-disable-next-line

        if (response.data.status === 'success') {
          // eslint-disable-next-line
          _this.submitStatus = 'SUCCESS';

          _this.$router.push({
            name: 'Committees',
            params: {
              success: 'Committee saved successfully'
            }
          });
        } else {
          _this.fieldsValidation(response);

          if (response.data.errors.contact_email) {
            var _response$data, _response$data$errors;

            // Contact email
            _this.success = '';
            _this.errorStatus = 'email';

            if (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$errors = _response$data.errors) === null || _response$data$errors === void 0 ? void 0 : _response$data$errors.contact_email[0]) {
              _this.errors = response.data.errors.contact_email[0];
            } else {
              _this.errors = 'Please include correct email address.';
            }
          }

          if (response.data.status === 'validation_error') {
            if (response.data.errors.contact_email !== undefined) {
              _this.errors = 'Committee email must be unique among committee and user emails';
              _this.errorFields.contact_email = true;
            } else if (response.data.errors.account_number !== undefined) {
              _this.errors = 'Committee account number is not valid';
              _this.errorFields.account_number = true;
            } else if (response.data.errors.routing_number !== undefined) {
              _this.errors = 'Committee BSB is not valid';
              _this.errorFields.routing_number = true;
            } else if (response.data.errors.postal_code !== undefined) {
              _this.errors = 'Committee postcode is not valid';
              _this.errorFields.postal_code = true;
            } else if (response.data.errors.city !== undefined) {
              _this.errors = 'Committee city is not valid';
              _this.errorFields.city = true;
            } else if (response.data.errors.line1 !== undefined) {
              _this.errors = 'Committee address file is not valid';
              _this.errorFields.line1 = true;
            } else if (response.data.errors.phone !== undefined) {
              _this.errors = 'Contact Phone is not valid';
              _this.errorFields.phone = true;
            } else if (response.data.errors.contact_phone !== undefined) {
              _this.errors = 'Contact Phone is not valid';
              _this.errorFields.contact_phone = true;
            } else if (response.data.errors.abn !== undefined) {
              _this.errorStatus = 'Committee ABN is not valid';
              _this.errorFields.abn = true;
            } else if (response.data.errors.name !== undefined) {
              _this.errorStatus = response.data.errors.name[0];
              _this.errorFields.name = true;
            } else {
              _this.errors = 'server validation error';
            }
          }
        }
      }).catch(function (error) {
        _this.processing = false; // eslint-disable-next-line

        console.log(error);
      });
    },
    update: function update(event) {
      var _this2 = this;

      event.preventDefault();
      setTimeout(function () {
        if (_this2.formComplete) {
          _this2.updateCommittee();
        }
      }, 10);
    }
  }
});

/***/ }),
/* 347 */,
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CommitteeProfileDetails__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CommitteeSecretaries__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CommitteeAffiliation__ = __webpack_require__(345);
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CommitteeProfile',
  props: ['committeeDetails', 'isLoading'],
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    'committee-profile-details': __WEBPACK_IMPORTED_MODULE_1__CommitteeProfileDetails__["a" /* default */],
    'committee-secretaries': __WEBPACK_IMPORTED_MODULE_2__components_CommitteeSecretaries__["a" /* default */],
    'committee-affiliation': __WEBPACK_IMPORTED_MODULE_3__components_CommitteeAffiliation__["a" /* default */]
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DesktopActionBar__ = __webpack_require__(15);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var bsbRegex = __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["helpers"].regex('bsbRegex', /^[[\d]{3}[-]{1}[\d]{3}$/);
var phoneRegex = __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["helpers"].regex('phoneRegex', /^([+][7][0-9]{10})|([+][6][1][0-9]{1,10})$/);
var abnRegex = __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["helpers"].regex('abnRegex', /^[\d]{11}$/);
var nameRegex = __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["helpers"].regex('name', /^[A-Za-z\s]*$/);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuelidate___default.a);

var isValidLogoSize = function isValidLogoSize(value) {
  if (!value) {
    return true;
  }

  return value.size < 512 * 512;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CommitteeProfileDetails',
  props: ['committeeDetails', 'isLoading'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__["a" /* default */]],
  components: {
    DesktopActionBar: __WEBPACK_IMPORTED_MODULE_5__components_DesktopActionBar__["a" /* default */]
  },
  data: function data() {
    return {
      committee: _objectSpread({}, this.committeeDetails),
      user: localStorage.role,
      processing: false,
      zoneNotFound: false,
      zoneFound: false,
      zoneNotSpecified: false,
      zoneLocations: [],
      errors: '',
      errorStatus: '',
      file_name: null,
      logo_name: null,
      files: [],
      logo_file: [],
      fileError: {
        fileSize: false,
        required: false
      },
      logoError: {
        logoSize: false,
        required: false
      },
      errorFields: {}
    };
  },
  validations: function validations() {
    var validationRules = {
      committee: {
        state: {},
        post_code: {},
        zone_id: {
          required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
        },
        name: {
          required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
          nameRegex: nameRegex
        },
        contact_email: {
          required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
          email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"]
        },
        contact_phone: {
          required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
          phoneRegex: phoneRegex
        },
        pic_number: {},
        abn: {
          abnRegex: abnRegex
        },
        cheques_to: {},
        address: {},
        city: {},
        account_number: {},
        bsb: {
          bsbRegex: bsbRegex
        },
        contact_name: {
          required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
        },
        bank_abbreviation: {},
        bank_owner_first_name: {},
        bank_owner_last_name: {},
        bank_owner_dob: {},
        notes: {}
      }
    };

    if (Number(this.committee.is_enabled_stripe)) {
      validationRules.committee.bank_owner_first_name = {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      };
      validationRules.committee.bank_owner_last_name = {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      };
      validationRules.committee.bank_owner_dob = {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      };
      validationRules.committee.state = {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      };
      validationRules.committee.post_code = {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      };
      validationRules.committee.abn = {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
        abnRegex: abnRegex
      };
      validationRules.committee.address = {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      };
      validationRules.committee.city = {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      };
      validationRules.committee.account_number = {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      };
      validationRules.committee.bsb = {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
        bsbRegex: bsbRegex
      };
    }

    if (this.committee.id) {
      validationRules.committee.cheques_to = {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      };
    } else {
      validationRules.committee.is_financial = {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      };
    }

    return validationRules;
  },
  mounted: function mounted() {
    var _this = this;

    if (this.committee.id) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/committee-details/").concat(this.committee.id)).then(function (response) {
        // eslint-disable-next-line
        _this.committee = response.data.data;
      }).catch(function (error) {
        // eslint-disable-next-line
        console.log(error);
      });
    }

    this.setDefaultValues();
  },
  created: function created() {
    this.getZoneLocations();
  },
  watch: {
    committeeDetails: function committeeDetails() {
      this.committee = this.committeeDetails;
    }
  },
  methods: {
    scrollToError: function scrollToError() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.$refs.errorAlert) {
          _this2.$refs.errorAlert.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      });
    },
    updateCommittee: function updateCommittee() {
      var _this3 = this;

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR';
        return;
      }

      this.processing = true;
      this.data = {
        id: this.committee.id,
        zone_id: this.committee.zone_id,
        name: this.committee.name,
        contact_name: this.committee.contact_name,
        contact_email: this.committee.contact_email,
        contact_phone: this.committee.contact_phone,
        is_financial: this.committee.is_financial,
        gst_registered: this.committee.gst_registered,
        cheques_to: this.committee.cheques_to,
        pic_number: this.committee.pic_number,
        account_number: this.committee.account_number,
        bsb: this.committee.bsb,
        post_code: this.committee.post_code,
        state: this.committee.state,
        city: this.committee.city,
        abn: this.committee.abn,
        is_enabled_stripe: this.committee.is_enabled_stripe,
        address: this.committee.address,
        bank_owner_first_name: this.committee.bank_owner_first_name,
        bank_owner_last_name: this.committee.bank_owner_last_name,
        bank_owner_dob: this.committee.bank_owner_dob,
        bank_abbreviation: this.committee.bank_abbreviation,
        is_stripe_verified: this.committee.is_stripe_verified,
        file_name: null,
        logo_name: null,
        file: [],
        logo_file: [],
        fileError: {
          fileSize: false,
          required: false
        },
        logoError: {
          logoSize: false,
          required: false
        },
        notes: this.committee.notes
      };
      this.submitStatus = 'PENDING';
      var formData = new FormData();
      formData.append('identity_file', this.file);
      formData.append('logo_file', this.logo_file);
      formData.append('fields', JSON.stringify(this.data)); // eslint-disable-next-line

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/committee-edit"), formData).then(function (response) {
        _this3.processing = false; // eslint-disable-next-line

        if (response.data.status === 'success') {
          // eslint-disable-next-line
          _this3.submitStatus = 'SUCCESS';

          _this3.$router.push({
            name: 'Committees',
            params: {
              success: 'Committee saved successfully'
            }
          });
        } else {
          _this3.fieldsValidation(response);

          if (response.data.errors.contact_email) {
            var _response$data, _response$data$errors;

            // Contact email
            _this3.success = '';
            _this3.errorStatus = 'email';

            if (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$errors = _response$data.errors) === null || _response$data$errors === void 0 ? void 0 : _response$data$errors.contact_email[0]) {
              _this3.errors = response.data.errors.contact_email[0];
            } else {
              _this3.errors = 'Please include correct email address.';
            }
          }

          if (response.data.status === 'validation_error') {
            if (response.data.errors.contact_email !== undefined) {
              _this3.errors = 'Committee email must be unique among committee and user emails';
              _this3.errorFields.contact_email = true;
            } else if (response.data.errors.account_number !== undefined) {
              _this3.errors = 'Committee account number is not valid';
              _this3.errorFields.account_number = true;
            } else if (response.data.errors.routing_number !== undefined) {
              _this3.errors = 'Committee BSB is not valid';
              _this3.errorFields.routing_number = true;
            } else if (response.data.errors.postal_code !== undefined) {
              _this3.errors = 'Committee postcode is not valid';
              _this3.errorFields.postal_code = true;
            } else if (response.data.errors.city !== undefined) {
              _this3.errors = 'Committee city is not valid';
              _this3.errorFields.city = true;
            } else if (response.data.errors.line1 !== undefined) {
              _this3.errors = 'Committee address file is not valid';
              _this3.errorFields.line1 = true;
            } else if (response.data.errors.phone !== undefined) {
              _this3.errors = 'Contact Phone is not valid';
              _this3.errorFields.phone = true;
            } else if (response.data.errors.contact_phone !== undefined) {
              _this3.errors = 'Contact Phone is not valid';
              _this3.errorFields.contact_phone = true;
            } else if (response.data.errors.abn !== undefined) {
              _this3.errorStatus = 'Committee ABN is not valid';
              _this3.errorFields.abn = true;
            } else if (response.data.errors.name !== undefined) {
              _this3.errorStatus = response.data.errors.name[0];
              _this3.errorFields.name = true;
            } else {
              _this3.errors = 'server validation error';
            }
          }

          _this3.scrollToError();
        }
      }).catch(function (error) {
        _this3.processing = false; // eslint-disable-next-line

        console.log(error);
      });
    },
    findZone: function findZone() {
      var _this$committee,
          _this4 = this,
          _this$committee2;

      var coincidenceZones = [];

      if ((_this$committee = this.committee) === null || _this$committee === void 0 ? void 0 : _this$committee.city) {
        coincidenceZones = this.zoneLocations.filter(function (location) {
          var _this4$committee;

          return ((_this4$committee = _this4.committee) === null || _this4$committee === void 0 ? void 0 : _this4$committee.city.toLowerCase()) === location.suburb.toLowerCase();
        });
      }

      if ((_this$committee2 = this.committee) === null || _this$committee2 === void 0 ? void 0 : _this$committee2.post_code) {
        // eslint-disable-next-line
        coincidenceZones = this.zoneLocations.filter(function (location) {
          var _this4$committee2, _this4$committee3;

          return ((_this4$committee2 = _this4.committee) === null || _this4$committee2 === void 0 ? void 0 : _this4$committee2.post_code) === location.postcode && ((_this4$committee3 = _this4.committee) === null || _this4$committee3 === void 0 ? void 0 : _this4$committee3.city.toLowerCase()) === location.suburb.toLowerCase();
        });
      }

      if (coincidenceZones.length === 1) {
        this.zoneNotFound = false;
        this.zoneFound = true;
        this.committee.zone_id = coincidenceZones[0].zone_id;
      } else if (coincidenceZones.length > 1) {
        this.zoneNotSpecified = true;
        this.zoneFound = true;
        this.zoneNotFound = false;
      } else {
        this.zoneNotFound = true;
        this.zoneFound = false;
        this.zoneNotSpecified = false;
      }
    },
    getZoneLocations: function getZoneLocations() {
      var _this5 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _ref, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(_this5.$api, "/zone-location/list"));

              case 3:
                _ref = _context.sent;
                data = _ref.data.data;
                _this5.zoneLocations = data || [];
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                _this5.errorStatus = 'Can\'t fetch zone locations error';

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }))();
    },
    update: function update(event) {
      var _this6 = this;

      event.preventDefault();
      setTimeout(function () {
        if (_this6.formComplete) {
          _this6.updateCommittee();
        }
      }, 10);
    },
    fieldsValidation: function fieldsValidation(data) {
      if (data.data.status === 'validation_error' && data.data.errors.contact_phone) {
        this.errorStatus = 'contact_phone';
        this.errors = "Please enter correct mobile number";
      }
    },
    fileUpload: function fileUpload(event) {
      this.fileError = {
        fileSize: false,
        required: false
      };
      this.file_name = '';
      var uploadedFile = event.target.files[0];
      this.file = uploadedFile;

      if (uploadedFile) {
        this.file_name = uploadedFile.name;
      }
    },
    logoUpload: function logoUpload(event) {
      this.logoError = {
        logoSize: false,
        required: false
      };
      this.logo_name = '';
      var uploadedFile = event.target.files[0];
      this.logo_file = uploadedFile;

      if (uploadedFile) {
        this.logo_name = uploadedFile.name;
      }

      if (!isValidLogoSize(uploadedFile)) {
        this.submitStatus = 'ERROR';
        this.logoError.fileSize = true;
        delete this.logo_file;
        this.logo_file = undefined;
        this.logo_name = '';
      }
    },
    deleteLogoAttachment: function deleteLogoAttachment() {
      delete this.logo_file;
      this.logo_file = undefined;
      this.logo_name = '';
    },
    deleteAttachment: function deleteAttachment() {
      delete this.file;
      this.file = undefined;
      this.file_name = '';
    },
    deleteExistsAttachment: function deleteExistsAttachment() {
      this.committee.logo_file_path = '';
      this.committee.logo_file_name = '';
    },
    downloadLogoFile: function downloadLogoFile(id) {
      if (id) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/committees/download/").concat(id)).then(function (response) {
          window.open(response.data.path, '_blank');
        });
      }
    },
    validateBankBsb: function validateBankBsb(event) {
      var _event$data;

      var value = event.target.value.replaceAll(/[^0-9]/g, '');
      var valueLength = value.length;
      var newValue = value;

      if (event.data === '-' && valueLength < 3 || event.inputType === 'insertFromPaste' || ((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.match(/[0-9]/)) && valueLength === 3 || valueLength > 2) {
        newValue = "".concat(value.replaceAll(/[^0-9]/g, '').slice(0, 3), "-").concat(value.replaceAll(/[^0-9]/g, '').slice(3));
      }

      if ((event.inputType === 'deleteContentBackward' || event.inputType === 'deleteContentForward') && valueLength === 3 || valueLength < 3) {
        newValue = value.replaceAll(/[^0-9]/g, '');
      }

      this.committee.bsb = newValue;
    },
    setDefaultValues: function setDefaultValues() {
      if (!this.committee.id) {
        this.committee = {
          notes: null,
          name: null,
          contact_email: null,
          contact_phone: null,
          contact_name: null,
          is_financial: 0,
          zone_id: null
        };
      }
    }
  }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeProfileFinancials_vue__ = __webpack_require__(351);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d5b3a3b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeProfileFinancials_vue__ = __webpack_require__(893);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeProfileFinancials_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d5b3a3b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeProfileFinancials_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Download__ = __webpack_require__(139);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'committeeProfileFinancials',
  props: ['committeeId'],
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_1__components_DataTable__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */],
    tableDownloadTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Download__["a" /* default */]
  },
  data: function data() {
    return {
      isAdmin: this.$isAdmin,
      columns: [{
        label: 'Invoice No.',
        field: 'id',
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.invoice_number\" :row=\"row\" :options=\"{}\" />"
        },
        representedAs: 'id'
      }, {
        label: 'Amount',
        field: 'total',
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"'$' + row.displayTotal\" :row=\"row\" :options=\"{ showPaid: true }\" />"
        },
        representedAs: 'total'
      }, {
        label: 'Date',
        field: 'paid_date',
        sortable: true,
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.paid_date ? new Date(row.paid_date).toLocaleString('en-AU').substring(0, 10) : new Date(row.created_at.replace(/-/g, '/')).toLocaleString('en-AU').substring(0, 10)\" :row=\"row\" :options=\"{}\" />"
        },
        representedAs: "new Date(row.paid_date).toLocaleString('en-AU').substring(0, 10)"
      }, {
        label: 'Purchase',
        field: 'type',
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.type.charAt(0).toUpperCase() + row.type.slice(1)\" :row=\"row\" :options=\"{}\" />"
        },
        representedAs: 'type'
      }, {
        label: 'Download',
        align: 'left',
        sortable: false,
        filterable: false,
        headerClass: 'column-lg-small d-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableDownloadTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Download__["a" /* default */]
          },
          template: "<tableDownloadTemplate :row=\"row\" />"
        }
      }],
      options: {
        filter: {
          status: [{
            name: 'All',
            value: 'all'
          }, {
            name: 'Paid',
            value: 'paid'
          }, {
            name: 'Pending',
            value: 'pending'
          }]
        },
        activeFilter: {
          status: 'all'
        },
        search: true,
        loaded: false
      }
    };
  },
  computed: {
    invoicesWithTotal: function invoicesWithTotal() {
      var _this = this;

      return this.$store.state.invoices.map(function (row) {
        return _objectSpread({}, row, {
          displayTotal: _this.getDisplayTotal(row)
        });
      });
    }
  },
  methods: {
    getDisplayTotal: function getDisplayTotal(row) {
      var fee = parseFloat(row.processing_fee || 0);

      if (Number.isFinite(fee) && fee > 0) {
        return row.total_with_fee;
      }

      return row.total;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (!this.committeeId) {
      return;
    } // CAM-1533: another committee's financials are not available (the API rejects it too)


    if (this.$isActingForOtherCommittee) {
      this.$store.commit('updateInvoices', []);
      this.options.loaded = true;
      return;
    }

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/committee-invoices/").concat(this.committeeId)).then(function (response) {
      _this2.options.loaded = true;

      if (response.data.status === 'success') {
        _this2.$store.commit('updateInvoices', response.data.data);
      }
    }).catch(function (error) {
      // eslint-disable-next-line
      console.log(error);
    });
  }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ResponsiveTable__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Pagination__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_filters_FilterBar__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_filters_FilterMultiselect__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ListNameCell__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_api_http__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__composables_horses_useHorsesList__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AdminHorseReports__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__columns__ = __webpack_require__(302);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var DEFAULT_CONFIG = {
  title: 'Horses',
  variant: 'secretary',
  profileRoute: 'Secretary Horse Profile',
  addRoute: null
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'HorsesListing',
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__["a" /* default */],
    ResponsiveTable: __WEBPACK_IMPORTED_MODULE_2__components_ResponsiveTable__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_3__components_Pagination__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_4__components_Modal__["a" /* default */],
    FilterBar: __WEBPACK_IMPORTED_MODULE_5__components_filters_FilterBar__["a" /* default */],
    FilterMultiselect: __WEBPACK_IMPORTED_MODULE_6__components_filters_FilterMultiselect__["a" /* default */],
    ListNameCell: __WEBPACK_IMPORTED_MODULE_7__components_ListNameCell__["a" /* default */],
    AdminHorseReports: __WEBPACK_IMPORTED_MODULE_10__AdminHorseReports__["a" /* default */]
  },
  setup: function setup() {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var store = proxy.$store; // Computed, not a const: the same component instance is reused when navigating between
    // /horses, /secretary-horses and /admin-horses, so this must re-derive on route change.

    var config = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return _objectSpread({}, DEFAULT_CONFIG, {}, proxy.$route.meta.horseList || {});
    });
    var own = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return config.value.variant === 'member';
    });

    var _useHorsesList = Object(__WEBPACK_IMPORTED_MODULE_9__composables_horses_useHorsesList__["a" /* default */])(own),
        horses = _useHorsesList.horses,
        loading = _useHorsesList.loading,
        page = _useHorsesList.page,
        totalPages = _useHorsesList.totalPages,
        filters = _useHorsesList.filters,
        perPageOptions = _useHorsesList.perPageOptions,
        fetch = _useHorsesList.fetch,
        setPage = _useHorsesList.setPage,
        setSort = _useHorsesList.setSort,
        setPerPage = _useHorsesList.setPerPage,
        setSearch = _useHorsesList.setSearch,
        setFilter = _useHorsesList.setFilter,
        clearFilter = _useHorsesList.clearFilter,
        clearFilters = _useHorsesList.clearFilters,
        syncFromQuery = _useHorsesList.syncFromQuery;

    var columns = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return Object(__WEBPACK_IMPORTED_MODULE_11__columns__["c" /* buildColumns */])(config.value.variant);
    });
    var breakpoints = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return Object(__WEBPACK_IMPORTED_MODULE_11__columns__["b" /* buildBreakpoints */])(config.value.variant);
    });
    var tabs = __WEBPACK_IMPORTED_MODULE_11__columns__["a" /* REGISTRATION_TABS */]; // Filter dropdown options come from the store (loaded app-wide); Status and BoY Status
    // share the single horse_statuses lookup.

    var zoneOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return store.state.listZones || [];
    });
    var statusOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return store.state.horseStatus || [];
    });
    var hasActiveFilters = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return Boolean(filters.search) || filters.registration_state !== 'all' || filters.zone_id.length > 0 || filters.status_id.length > 0 || filters.boy_status_id.length > 0;
    });
    var searchInput = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(filters.search || '');
    var alertMessage = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('');
    var errorMessage = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('');

    function zoneCode(id) {
      var zone = store.state.listZones.find(function (z) {
        return z.id === id;
      });
      return zone ? zone.code : '';
    }

    function statusName(id) {
      var status = store.state.horseStatus.find(function (s) {
        return s.id === id;
      });
      return status ? status.name : '';
    } // Search-as-you-type with a 500ms debounce; Enter / the icon fire it immediately.


    var searchTimer = null;

    function applySearch() {
      clearTimeout(searchTimer);
      if (searchInput.value !== filters.search) setSearch(searchInput.value);
    }

    function resetSearch() {
      clearTimeout(searchTimer);
      searchInput.value = '';
      setSearch('');
    } // "Clear all filters" — wipe search + every dropdown/tab back to defaults in one shot.


    function clearAll() {
      clearTimeout(searchTimer);
      searchInput.value = '';
      clearFilters();
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(searchInput, function (val) {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
        if (val !== filters.search) setSearch(val);
      }, 500);
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["h" /* onBeforeUnmount */])(function () {
      return clearTimeout(searchTimer);
    });

    function onTabChange(value) {
      setFilter('registration_state', value);
    } // --- member-only banners: keep the lightweight legacy summary call, table stays on /v2 ---


    var hasUnregistered = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var canPayRookie = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

    function loadMemberBanners() {
      if (config.value.variant !== 'member') return;
      var role = localStorage.getItem('role');
      __WEBPACK_IMPORTED_MODULE_8__services_api_http__["a" /* default */].post('/horse/my-horses', {
        id: localStorage.getItem('userID')
      }).then(function (response) {
        var data = response.data || {};
        if (data.status !== 'success') return;
        var familyIds = data.usersIds || [];
        var list = data.data || [];
        hasUnregistered.value = list.some(function (h) {
          return familyIds.includes(h.owner_id) && !h.registration_date;
        });
        canPayRookie.value = Boolean(data.haveRegisteredHorse) && role !== 'Volunteer';
      }).catch(function () {
        /* banners are best-effort */
      });
    } // --- admin-only remove ---


    var horseToRemove = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var removingId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);

    function askRemove(row) {
      horseToRemove.value = row;
    }

    function confirmRemove() {
      var row = horseToRemove.value;
      horseToRemove.value = null;
      removingId.value = row.id;
      alertMessage.value = '';
      errorMessage.value = '';
      __WEBPACK_IMPORTED_MODULE_8__services_api_http__["a" /* default */].delete("/admin/horse/".concat(row.id)).then(function (response) {
        var data = response.data || {};

        if (data.errors === true) {
          errorMessage.value = data.message;
        } else {
          alertMessage.value = data.message;
          fetch();
        }
      }).catch(function () {
        errorMessage.value = 'Unable to remove the horse. Please try again later.';
      }).finally(function () {
        removingId.value = null;
      });
    }

    function loadPage() {
      var query = proxy.$route.query;

      if (query.success) {
        alertMessage.value = query.success;

        var rest = _objectSpread({}, query);

        delete rest.success;
        proxy.$router.replace({
          query: rest
        }).catch(function () {});
      }

      fetch();
      loadMemberBanners();
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(loadPage); // Re-load when switching between the shared routes (My Horses <-> Horses <-> Admin Horses)
    // — the component instance is kept, so onMounted won't fire again.

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(function () {
      return proxy.$route.path;
    }, function () {
      clearTimeout(searchTimer);
      syncFromQuery();
      searchInput.value = filters.search || '';
      hasUnregistered.value = false;
      canPayRookie.value = false;
      alertMessage.value = '';
      errorMessage.value = '';
      loadPage();
    });
    return {
      config: config,
      columns: columns,
      breakpoints: breakpoints,
      tabs: tabs,
      horses: horses,
      loading: loading,
      page: page,
      totalPages: totalPages,
      filters: filters,
      perPageOptions: perPageOptions,
      searchInput: searchInput,
      alertMessage: alertMessage,
      errorMessage: errorMessage,
      hasUnregistered: hasUnregistered,
      canPayRookie: canPayRookie,
      horseToRemove: horseToRemove,
      removingId: removingId,
      zoneOptions: zoneOptions,
      statusOptions: statusOptions,
      hasActiveFilters: hasActiveFilters,
      setPage: setPage,
      setSort: setSort,
      setPerPage: setPerPage,
      setFilter: setFilter,
      clearFilter: clearFilter,
      clearAll: clearAll,
      applySearch: applySearch,
      resetSearch: resetSearch,
      onTabChange: onTabChange,
      askRemove: askRemove,
      confirmRemove: confirmRemove,
      zoneCode: zoneCode,
      statusName: statusName
    };
  }
}));

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminHorseReports',
  components: {
    modal: __WEBPACK_IMPORTED_MODULE_2__components_Modal__["a" /* default */]
  },
  data: function data() {
    return {
      processing: false,
      certProcessing: false,
      certModal: false,
      secretaryName: '',
      alertMessage: ''
    };
  },
  validations: {
    secretaryName: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/horse-certificates-printer-name")).then(function (response) {
      _this.secretaryName = response.data.printerName;
    });
  },
  methods: {
    downloadPointsReport: function downloadPointsReport() {
      var _this2 = this;

      this.processing = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/horse-report-points")).then(function (response) {
        _this2.processing = false;
        var url = (window.URL || window.webkitURL).createObjectURL(new Blob([response.data], {
          type: 'data:text/csv;charset=utf-8'
        }));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'horses_points.csv');
        document.body.appendChild(link);
        link.click();
        setTimeout(function () {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 0);
      }).catch(function () {
        _this2.processing = false;
      });
    },
    downloadCertificates: function downloadCertificates() {
      var _this3 = this;

      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.certModal = false;
      this.certProcessing = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/horse-certificates-generate"), {
        Accept: 'application/pdf',
        responseType: 'arraybuffer',
        params: {
          secretaryName: this.secretaryName
        }
      }).then(function (response) {
        _this3.certProcessing = false;
        var blob = new Blob([response.data], {
          type: 'application/pdf'
        });

        if (blob.size > 0) {
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = 'certificates.pdf';
          link.click();
        } else {
          _this3.alertMessage = 'Nothing to generate.';
        }
      }).catch(function () {
        _this3.certProcessing = false;
      });
    }
  }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Horses_Tabs_Members__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HorseProfileDetails__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HorseProfileScore__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HorseProfileBoyHistory__ = __webpack_require__(907);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HorseProfile',
  props: ['details'],
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */]
  },
  data: function data() {
    return {
      selectedTab: this.$route.hash ? this.$route.hash.slice(1) : 'details',
      userRole: localStorage.role
    };
  },
  mounted: function mounted() {
    if (this.$route.params && this.$route.params.score) {
      // Go to score tab if coming from another score tab
      this.selectTab('score');
    }
  },
  computed: {
    isPrivileged: function isPrivileged() {
      return this.userRole === 'Admin' || this.userRole === 'SuperAdmin';
    },
    isSecretaryOrAdmin: function isSecretaryOrAdmin() {
      return this.isPrivileged || this.userRole === 'Secretary' || this.userRole === 'SecretaryOnly';
    },
    // Single source of truth for every tab on this page — add/remove/reorder tabs here only.
    tabs: function tabs() {
      return [{
        key: 'details',
        label: 'Details',
        component: __WEBPACK_IMPORTED_MODULE_2__HorseProfileDetails__["a" /* default */],
        show: true
      }, {
        key: 'score',
        label: 'Results',
        component: __WEBPACK_IMPORTED_MODULE_3__HorseProfileScore__["a" /* default */],
        show: true
      }, {
        key: 'members',
        label: 'Members',
        component: __WEBPACK_IMPORTED_MODULE_1__views_Horses_Tabs_Members__["a" /* default */],
        show: this.isSecretaryOrAdmin
      }, {
        key: 'boy-history',
        label: 'BOY History',
        component: __WEBPACK_IMPORTED_MODULE_4__HorseProfileBoyHistory__["a" /* default */],
        show: this.isPrivileged
      }];
    },
    visibleTabs: function visibleTabs() {
      return this.tabs.filter(function (t) {
        return t.show;
      });
    },
    currentTab: function currentTab() {
      var _this = this;

      return this.visibleTabs.find(function (t) {
        return t.key === _this.selectedTab;
      }) || this.visibleTabs[0] || null;
    }
  },
  methods: {
    selectTab: function selectTab(key) {
      this.selectedTab = key;

      if (this.$route.hash !== "#".concat(key)) {
        this.$router.replace({
          hash: "#".concat(key)
        }).catch(function () {});
      }
    }
  }
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ResponsiveTable__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Pagination__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_filters_FilterBar__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_filters_FilterMultiselect__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_filters_HorseMemberRelationFilter__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_HorseMemberRelationBadges__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ListNameCell__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__composables_members_useMembersList__ = __webpack_require__(252);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var COLUMNS = [{
  key: 'first_name',
  label: 'First Name',
  sortable: true,
  minWidth: '100px',
  width: '1.3fr'
}, {
  key: 'last_name',
  label: 'Last Name',
  sortable: true,
  minWidth: '150px',
  width: '2.4fr'
}, {
  key: 'member_number',
  label: 'Member No.',
  minWidth: '90px',
  width: '1.2fr'
}, {
  key: 'zone_id',
  label: 'Zone',
  sortable: true,
  minWidth: '60px',
  width: '0.6fr'
}, {
  key: 'beginning_of_year_status',
  label: 'BoY Status',
  sortable: true,
  minWidth: '90px',
  width: '1.3fr'
}];
var BREAKPOINTS = [{
  maxWidth: 700,
  hideHeader: true,
  accordion: {
    summary: [{
      keys: ['name'],
      hideLabel: true
    }]
  },
  rows: [['member_number'], ['zone_id'], ['beginning_of_year_status']]
}];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'HorseProfileMembers',
  components: {
    ResponsiveTable: __WEBPACK_IMPORTED_MODULE_1__components_ResponsiveTable__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_2__components_Pagination__["a" /* default */],
    FilterBar: __WEBPACK_IMPORTED_MODULE_3__components_filters_FilterBar__["a" /* default */],
    FilterMultiselect: __WEBPACK_IMPORTED_MODULE_4__components_filters_FilterMultiselect__["a" /* default */],
    HorseMemberRelationFilter: __WEBPACK_IMPORTED_MODULE_5__components_filters_HorseMemberRelationFilter__["a" /* default */],
    HorseMemberRelationBadges: __WEBPACK_IMPORTED_MODULE_6__components_HorseMemberRelationBadges__["a" /* default */],
    ListNameCell: __WEBPACK_IMPORTED_MODULE_7__components_ListNameCell__["a" /* default */]
  },
  setup: function setup() {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var store = proxy.$store; // Mirrors HorseProfileBoyHistory.vue / HorseProfileScore.vue on this same page — the horse id
    // comes from the route, not a prop (HorseProfile.vue's <component> binds no props at all).

    var horseId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return proxy.$route.params.slug;
    });

    var _useMembersList = Object(__WEBPACK_IMPORTED_MODULE_8__composables_members_useMembersList__["a" /* default */])(horseId),
        rows = _useMembersList.rows,
        loading = _useMembersList.loading,
        page = _useMembersList.page,
        totalPages = _useMembersList.totalPages,
        filters = _useMembersList.filters,
        perPageOptions = _useMembersList.perPageOptions,
        fetch = _useMembersList.fetch,
        setPage = _useMembersList.setPage,
        setSort = _useMembersList.setSort,
        setPerPage = _useMembersList.setPerPage,
        setSearch = _useMembersList.setSearch,
        setFilter = _useMembersList.setFilter,
        clearFilter = _useMembersList.clearFilter,
        clearFilters = _useMembersList.clearFilters;

    var columns = COLUMNS;
    var breakpoints = BREAKPOINTS;
    var zoneOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return store.state.listZones || [];
    });
    var riderStatusOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return store.state.riderStatus || [];
    });
    var hasActiveFilters = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return Boolean(filters.search) || filters.zone_id.length > 0 || filters.status_id.length > 0 || filters.boy_status_id.length > 0 || filters.relation.length > 0;
    });
    var searchInput = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(filters.search || '');

    function zoneCode(id) {
      var zone = (store.state.listZones || []).find(function (z) {
        return z.id === id;
      });
      return zone ? zone.code : 'Unspecified';
    } // Mirrors Members.vue's statusBadgeLabel/Class (legacy Text.vue `showActive` badge).


    function statusBadgeLabel(row) {
      if (row.membership_status !== 'Active') return row.membership_status === 'Onhold' ? 'On Hold' : row.membership_status;
      return row.financial ? 'Financial' : 'Unfinancial';
    }

    function statusBadgeClass(row) {
      if (row.membership_status !== 'Active') {
        if (row.membership_status === 'Lifetime') return 'alert-info';
        if (row.membership_status === 'Archived') return 'alert-dark';
        return 'alert-danger';
      }

      return row.financial ? 'alert-info' : 'alert-warning';
    }

    var searchTimer = null;

    function applySearch() {
      clearTimeout(searchTimer);
      if (searchInput.value !== filters.search) setSearch(searchInput.value);
    }

    function clearAll() {
      clearTimeout(searchTimer);
      searchInput.value = '';
      clearFilters();
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(searchInput, function (val) {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
        if (val !== filters.search) setSearch(val);
      }, 500);
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["h" /* onBeforeUnmount */])(function () {
      return clearTimeout(searchTimer);
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(fetch);
    return {
      columns: columns,
      breakpoints: breakpoints,
      rows: rows,
      loading: loading,
      page: page,
      totalPages: totalPages,
      filters: filters,
      perPageOptions: perPageOptions,
      searchInput: searchInput,
      zoneOptions: zoneOptions,
      riderStatusOptions: riderStatusOptions,
      hasActiveFilters: hasActiveFilters,
      setPage: setPage,
      setSort: setSort,
      setPerPage: setPerPage,
      setFilter: setFilter,
      clearFilter: clearFilter,
      clearAll: clearAll,
      applySearch: applySearch,
      zoneCode: zoneCode,
      statusBadgeLabel: statusBadgeLabel,
      statusBadgeClass: statusBadgeClass
    };
  }
}));

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_legacyBrowsers_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DesktopActionBar__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Horses_HorseSearchSelect__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Members_MemberSearchSelect__ = __webpack_require__(89);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HorseProfileDetails',
  props: ['horseDetails'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_legacyBrowsers_js__["a" /* default */]],
  components: {
    'horse-search-select': __WEBPACK_IMPORTED_MODULE_5__components_Horses_HorseSearchSelect__["a" /* default */],
    'member-search-select': __WEBPACK_IMPORTED_MODULE_6__components_Members_MemberSearchSelect__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_3__components_Modal__["a" /* default */],
    DesktopActionBar: __WEBPACK_IMPORTED_MODULE_4__components_DesktopActionBar__["a" /* default */]
  },
  data: function data() {
    return {
      horse: _objectSpread({}, this.horseDetails),
      horseOwnerData: {},
      // Pre-resolved {id, label} for the currently-assigned owner/rider(s) — fed to
      // MemberSearchSelect as `initial-options` so an owner who no longer matches the picker's
      // own dataset (soft-deleted, or SecretaryOnly — see memberLabel()) still shows a chip
      // without a doomed /v2/members/options?ids= lookup (that context excludes both).
      ownerInitialOptions: [],
      memberInitialOptions: [],
      selectedOwners: [],
      selectedMembers: [],
      selectedSire: [],
      selectedDam: [],
      user: localStorage.role,
      showModal: false,
      processing: false,
      errors: '',
      errorStatus: '',
      is_owner: false,
      isMember: false,
      userIsSecretary: false,
      userIsNotAdmin: false,
      file_name: '',
      file: '',
      file_path: '',
      exists_file_name: '',
      totalAch: this.totalAch,
      totalRom: this.totalRom
    };
  },
  methods: {
    updateHorse: function updateHorse() {
      var _this = this;

      if (!this.errors) {
        if (this.file && this.file.size > 1024 * 1024) {
          this.errorStatus = 'file';
          this.errors = "The Proof of Age file may not be greater than 1 mb.";
        }

        this.processing = true;
        var horseData = {
          id: this.horse.id,
          name: this.horse.name,
          dob: this.horse.dob,
          gender: this.horse.gender,
          owners: this.horse.owners,
          user_id: this.selectedMembers || (this.horse.user ? this.horse.user.id : null),
          horse_status_id: this.horse.horse_status_id,
          sire_id: this.horse.sire,
          dam_id: this.horse.dam,
          ashs_number: this.horse.ashs_number,
          aqhs_number: this.horse.aqhs_number,
          active: this.horse.active,
          registration_date: this.horse.registration_date,
          notes: this.horse.notes,
          boy_status_id: this.horse.boy_status_id,
          file_path: this.file_path,
          historic_point_ach: this.horse.historic_point_ach,
          historic_point_rom: this.horse.historic_point_rom,
          owner_display_name: this.horse.owner_display_name
        };
        var formData = new FormData();
        formData.append('file', this.file);
        formData.append('fields', JSON.stringify(horseData)); // eslint-disable-next-line

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api).concat(this.userIsSecretary && !this.is_owner ? '/admin/horse-update' : this.is_owner || this.horse.active == false ? '/horse/update' : '/'), formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function (response) {
          _this.processing = false; // eslint-disable-next-line
          // console.log(response)

          if (response.data.status === 'success') {
            var isAdminDetails = _this.$route.path.match('/admin-horses');

            var isSecretaryDetails = _this.$route.path.match('/secretary-horses');

            _this.$router.push({
              path: isAdminDetails ? '/admin-horses' : isSecretaryDetails ? '/secretary-horses' : '/horses',
              params: {
                // eslint-disable-next-line
                success: "".concat(_this.userIsSecretary && !_this.is_owner || _this.horseOwnerData.id.toString() === localStorage.userID || _this.horse.active == false ? 'Horse updated successfully' : 'Changes to registered horse successfully sent for approval', ".")
              }
            });
          } else if (response.data.status === 'horse_limit') {
            _this.errors = response.data.message;
          } else if (response.data.status === 'validation_error') {
            if (response.data.errors.dob) {
              // DoB
              _this.success = '';
              _this.errorStatus = 'dob';
              _this.errors = "Please include the Date of Birth in the format".concat(_this.isLegacy() ? ' yyyy-mm-dd' : ' dd/mm/yyyy', ".");
            } else if (response.data.errors.ashs_number) {
              // ashs_number
              _this.success = '';
              _this.errorStatus = 'ashs';
              _this.errors = "The ASHS number has already been taken.";
            } else if (response.data.errors.aqhs_number) {
              // aqhs_number
              _this.success = '';
              _this.errorStatus = 'aqhs';
              _this.errors = "The AQHA number has already been taken.";
            } else if (response.data.errors.file) {
              _this.success = '';
              _this.errorStatus = 'file';
              _this.errors = Object.values(response.data.errors.file).flat()[0];
            }
          } else if (response.data.status === 'invalid_data') {
            _this.success = '';
            _this.errorStatus = '';
            _this.errors = response.data.message;
          } else if (response.data.status === 'verification_error') {
            _this.errorStatus = 'verification_error';
            _this.errors = response.data.errors.message;
          } else {
            _this.success = '';
            _this.errorStatus = '';
            _this.errors = "Something went wrong. Please reload the page.";
          }
        }).catch(function (error) {
          if (error.response.status === 413) {
            _this.success = '';
            _this.errorStatus = 'file';
            _this.errors = "The Proof of Age file may not be greater than 1 mb.";
          } else {
            _this.success = '';
            _this.errorStatus = '';
            _this.errors = "Something went wrong. Please reload the page.";
          }

          _this.processing = false; // eslint-disable-next-line
          // console.log(error)
        });
      }
    },
    update: function update(event) {
      var _this2 = this;

      event.preventDefault();
      setTimeout(function () {
        if (_this2.horse.owners.length > 0 && _this2.formComplete) {
          // eslint-disable-next-line
          if (_this2.userIsSecretary || _this2.is_owner) {
            _this2.updateHorse();
          } else {
            _this2.showModal = true;
          }
        }
      }, 10);
    },
    toggleRegisteredDate: function toggleRegisteredDate() {
      if (this.horse.registered === false) {
        this.horse.registration_date = null;
      }
    },
    unlinkMemberHorse: function unlinkMemberHorse(horse_id) {
      var _this3 = this;

      if (horse_id) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete("".concat(this.$api, "/horse/unlink-member"), {
          params: {
            horse_id: horse_id
          }
        }).then(function (response) {
          if (response.data.status === 'success') {
            _this3.$router.push('/horses');
          }
        }).catch();
      }
    },
    downloadAgeProofFile: function downloadAgeProofFile(horse_id) {
      if (horse_id) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/horse/download/").concat(horse_id)).then(function (response) {
          window.open(response.data.path, '_blank');
        });
      }
    },
    fileUpload: function fileUpload(event) {
      this.errorStatus = '';
      this.errors = '';
      this.file_name = '';
      var uploadedFile = event.target.files[0];
      this.file = uploadedFile;

      if (uploadedFile && this.file.size > 1024 * 1024) {
        this.success = '';
        this.errorStatus = 'file';
        this.errors = "The Proof of Age file may not be greater than 1 mb.";
      }

      if (uploadedFile) {
        this.file_name = uploadedFile.name;
      }

      this.deleteExistsAttachment();
    },
    deleteAttachment: function deleteAttachment() {
      delete this.file;
      this.file = undefined;
      this.file_name = '';
      this.errorStatus = '';
      this.errors = '';
    },
    deleteExistsAttachment: function deleteExistsAttachment() {
      this.file_path = '';
      this.exists_file_name = '';
    },
    actionPointAch: function actionPointAch(event) {
      var value = event.target.value.replaceAll(/[^0-9.]/g, '');
      this.horse.historic_point_ach = value;
      this.totalAch = (parseFloat(this.horse.ach_points) + parseFloat(value)).toFixed(2);
    },
    actionPointRom: function actionPointRom(event) {
      var value = event.target.value.replaceAll(/[^0-9.]/g, '');
      this.horse.historic_point_rom = value;
      this.totalRom = (parseFloat(this.horse.rom_points) + parseFloat(value)).toFixed(2);
    },
    // Owner/rider pickers (MemberSearchSelect, context=owner) only offer live, non-SecretaryOnly
    // members — if a horse already has a soft-deleted or SecretaryOnly user attached, that id
    // would come back empty from a fresh lookup. Building the label from data the horse's own
    // fetch already carries (see mounted()) keeps the chip visible and flags it for cleanup,
    // without ever calling the picker API for an id it can't answer.
    buildMemberLabel: function buildMemberLabel(person) {
      var label = "".concat(person.member_number, ": ").concat(person.first_name.replace(/[^a-z0-9áéíóúñü .,_-]/gim, ""), " ").concat(person.last_name.replace(/[^a-z0-9áéíóúñü .,_-]/gim, ""));

      if (person.role === 'SecretaryOnly') {
        label += ' (Secretary - need to delete)';
      }

      return label;
    }
  },
  computed: {
    isInvalid: function isInvalid() {
      return this.wasValidated && this.horse.owners.length === 0;
    },
    isUserInvalid: function isUserInvalid() {
      return this.wasValidated && !this.horse.user_id;
    }
  },
  created: function created() {
    if (!this.horse.status) {
      this.horse.status = {
        name: null
      };
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    /* Check if a user role is Admin or Secretary or Secretary Only */
    if (this.user === 'Admin' || this.user === 'SuperAdmin' || this.user === 'Secretary' || this.user === 'SecretaryOnly') {
      this.userIsSecretary = true;
    }

    if (this.user !== 'Admin' && this.user !== 'SuperAdmin') {
      this.userIsNotAdmin = true;
    }
    /* Get latest horse data */


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/horse"), {
      id: this.$route.params && this.$route.params.slug && !isNaN(parseInt(this.$route.params.slug, 10)) ? this.$route.params.slug : this.horse.id
    }).then(function (response) {
      if (response.data.status === 'success') {
        _this4.horse = _objectSpread({}, response.data.data);
        _this4.is_owner = response.data.is_owner;

        _this4.$store.commit('updateViewedHorse', _this4.horse);

        _this4.totalAch = (parseFloat(_this4.horse.historic_point_ach) + parseFloat(_this4.horse.ach_points)).toFixed(2);
        _this4.totalRom = (parseFloat(_this4.horse.historic_point_rom) + parseFloat(_this4.horse.rom_points)).toFixed(2);
        _this4.selectedSire = _this4.horse.sire_id ? [_this4.horse.sire_id.toString()] : [];
        _this4.selectedDam = _this4.horse.dam_id ? [_this4.horse.dam_id.toString()] : [];
        _this4.horse.user_id = _this4.horse.user_id ? [_this4.horse.user_id.toString()] : [];
        /* Assigning owner data to separate variable because weird stuff is happening */

        if (response.data.data.owners && response.data.data.owners.length > 0) {
          _this4.horseOwnerData = _objectSpread({}, response.data.data.owners[0]);
        }

        _this4.selectedMembers = response.data.data.members.map(function (a) {
          return a.id.toString();
        });
        _this4.memberInitialOptions = response.data.data.members.map(function (m) {
          return {
            id: m.id,
            label: _this4.buildMemberLabel(m)
          };
        });
        _this4.isMember = _this4.selectedMembers.includes(localStorage.userID.toString());

        if (response.data.data.owners.length > 0 && _this4.horseOwnerData.id) {
          _this4.selectedOwners = [_this4.horseOwnerData.id.toString()];
          _this4.ownerInitialOptions = [{
            id: _this4.horseOwnerData.id,
            label: _this4.buildMemberLabel(_this4.horseOwnerData)
          }];
        }

        if (response.data.data.age_proof_file_path) {
          _this4.file_path = response.data.data.age_proof_file_path;
          _this4.exists_file_name = response.data.data.age_proof_file_name;
        }
      } else {
        // Any non-success (undefined_error, invalid_user, …). This page gets no horse object
        // passed in, so `POST /horse` is the only data source — without this the spinners
        // would just hang. Bounce back to the list with a message.
        var horseError = response.data.status === 'invalid_user' ? "You don't have access to that horse." : "That horse couldn't be found.";

        _this4.$router.push({
          path: _this4.userIsNotAdmin ? '/horses' : '/admin-horses',
          params: {
            horseError: horseError
          }
        }).catch(function () {});
      }
    }).catch(function () {
      _this4.$router.push({
        path: _this4.userIsNotAdmin ? '/horses' : '/admin-horses',
        params: {
          horseError: 'Unable to load that horse. Please try again.'
        }
      }).catch(function () {});
    });
  },
  watch: {
    selectedOwners: function selectedOwners() {
      this.horse.owners = this.selectedOwners;
    },
    selectedMembers: function selectedMembers() {
      this.errors = '';
      this.errorStatus = '';
      this.success = '';
    },
    selectedSire: function selectedSire() {
      this.horse.sire = this.selectedSire;
    },
    selectedDam: function selectedDam() {
      this.horse.dam = this.selectedDam;
    },
    horse: {
      handler: function handler() {
        this.errors = '';
        this.errorStatus = '';
        this.success = '';
      },
      deep: true
    }
  }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppMultiselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_members__ = __webpack_require__(70);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Server-backed replacement for the legacy `<tags-input :existing-tags="{id: 'member_number: name'}">`
// member pickers (horse owner, horse rider/s, event competitor — CAM-1477 part 2). Mirrors
// HorseSearchSelect.vue (same freeze-prevention checklist: searchable only while focused,
// mergedOptions kept as plain data not computed, initial values hydrated from the parent's own
// request instead of a per-instance API call) but generalised to support `multiple` (Rider/s
// allows up to 10). `value` / `input` keep the tags-input shape: an array of id strings.

var MIN_CHARS = 2;
var DEBOUNCE_MS = 300;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MemberSearchSelect',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_0__components_AppMultiselect__["a" /* default */]
  },
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    elementId: {
      type: String,
      required: true
    },
    // 'owner' (horse owner/rider pickers) or 'competitor' (event result picker) — selects which
    // legacy role exclusion the backend replicates. See MemberService::pickerOptions().
    context: {
      type: String,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    // Cap on selections when `multiple` — null means no cap. Mirrors tags-input's `:limit`.
    limit: {
      type: Number,
      default: null
    },
    // Pre-resolved [{id, label}] for the currently selected member(s), supplied by the parent's
    // main request (e.g. horse details already embeds `owners`/`members`). When every id in
    // `value` is covered here, no /v2/members/options hydration call is fired.
    initialOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: 'Start typing...'
    },
    disabled: Boolean,
    required: Boolean
  },
  data: function data() {
    return {
      searchOptions: [],
      selectedCache: [],
      // Kept as plain data (rebuilt via watchers), NOT a computed — see HorseSearchSelect.vue
      // for why: an Options-API computed returning a fresh array loses its cache under the
      // global @vue/composition-api shim, handing vue-multiselect a new `:options` ref every
      // render, which locks the tab once there are several of these on one page.
      mergedOptions: [],
      // The searchable <input> only renders while THIS field is focused — see the focus-pinging
      // freeze documented on HorseSearchSelect.vue (a password-manager extension pings every
      // always-searchable multiselect on the page in an infinite loop).
      active: false,
      loading: false,
      loadingMore: false,
      nextCursor: null,
      term: '',
      searchTimer: null,
      scrollEl: null,
      onScroll: null
    };
  },
  computed: {
    selectedIds: function selectedIds() {
      return (this.value || []).map(function (v) {
        return Number(v);
      }).filter(function (id) {
        return Number.isInteger(id) && id > 0;
      });
    },
    selectedOptions: function selectedOptions() {
      var _this = this;

      return this.selectedIds.map(function (id) {
        return _this.mergedOptions.find(function (o) {
          return o.id === id;
        });
      }).filter(Boolean);
    },
    atLimit: function atLimit() {
      return this.multiple && this.limit != null && this.selectedIds.length >= this.limit;
    }
  },
  watch: {
    // Watch the resolved id list, not the `value` array prop directly: parents commonly bind
    // `:value="foo || []"`, which hands a fresh `[]` on every render — comparing the joined
    // string avoids re-running hydrateSelected() (and its request) on every parent re-render.
    selectedIds: {
      immediate: true,
      handler: function handler(ids, oldIds) {
        if (oldIds && ids.join(',') === oldIds.join(',')) return;
        this.hydrateSelected();
        this.rebuildOptions();
      }
    },
    selectedCache: function selectedCache() {
      this.rebuildOptions();
    },
    searchOptions: function searchOptions() {
      this.rebuildOptions();
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.searchTimer);
    this.detachScroll();
  },
  methods: {
    labelFor: function labelFor(o) {
      return o ? o.label : '';
    },
    extract: function extract(res) {
      var d = res && res.data && res.data.data || {};
      return {
        items: d.items || [],
        nextCursor: d.next_cursor || null
      };
    },
    rebuildOptions: function rebuildOptions() {
      var seen = new Set(this.searchOptions.map(function (o) {
        return o.id;
      }));
      this.mergedOptions = [].concat(_toConsumableArray(this.selectedCache.filter(function (o) {
        return !seen.has(o.id);
      })), _toConsumableArray(this.searchOptions));
    },
    hydrateSelected: function hydrateSelected() {
      var _this2 = this;

      var known = new Set([].concat(_toConsumableArray(this.selectedCache.map(function (o) {
        return o.id;
      })), _toConsumableArray(this.searchOptions.map(function (o) {
        return o.id;
      })), _toConsumableArray(this.initialOptions.map(function (o) {
        return Number(o.id);
      }))));
      var missing = this.selectedIds.filter(function (id) {
        return !known.has(id);
      }); // Always fold in whatever the parent already resolved for currently-selected ids.

      var fromParent = this.initialOptions.filter(function (o) {
        return _this2.selectedIds.includes(Number(o.id));
      }).map(function (o) {
        return _objectSpread({}, o, {
          id: Number(o.id)
        });
      });
      this.selectedCache = [].concat(_toConsumableArray(this.selectedCache.filter(function (o) {
        return !fromParent.some(function (p) {
          return p.id === o.id;
        });
      })), _toConsumableArray(fromParent)); // Reject anything not a positive integer before it reaches the API — a bad id would hit
      // /v2/members/options with an empty `ids` list, which can only answer with an unfiltered
      // whole-table scan.

      var toFetch = missing.filter(function (id) {
        return !fromParent.some(function (p) {
          return p.id === id;
        }) && Number.isInteger(id) && id > 0;
      });
      if (toFetch.length === 0) return;
      __WEBPACK_IMPORTED_MODULE_1__services_api_members__["a" /* default */].options({
        context: this.context,
        ids: toFetch.join(',')
      }).then(function (res) {
        var fetched = _this2.extract(res).items;

        var seen = new Set(_this2.selectedCache.map(function (o) {
          return o.id;
        }));
        _this2.selectedCache = [].concat(_toConsumableArray(_this2.selectedCache), _toConsumableArray(fetched.filter(function (o) {
          return !seen.has(o.id);
        })));
      }).catch(function () {});
    },
    onSelect: function onSelect(option) {
      if (!option || option.id == null) return;

      if (this.multiple) {
        if (this.atLimit || this.selectedIds.includes(option.id)) {
          this.resetMultiselect();
          return;
        }

        this.selectedCache = [].concat(_toConsumableArray(this.selectedCache.filter(function (o) {
          return o.id !== option.id;
        })), [option]);
        this.$emit('input', [].concat(_toConsumableArray(this.value.map(String)), [String(option.id)]));
      } else {
        this.selectedCache = [option];
        this.$emit('input', [String(option.id)]);
      } // The selection is shown by our own chip(s) below; the multiselect must stay a plain
      // search box. vue-multiselect keeps its pick in its own `internalValue` and only re-syncs
      // it when the `:value` prop changes — and ours is a static `null` — so wipe that internal
      // state after every select.


      this.resetMultiselect();
    },
    resetMultiselect: function resetMultiselect() {
      var ms = this.$refs.ms;
      if (!ms) return;
      ms.internalValue = [];
      ms.search = '';
    },
    remove: function remove(id) {
      if (this.disabled) return;
      this.$emit('input', this.selectedIds.filter(function (i) {
        return i !== id;
      }).map(String));
    },
    onSearch: function onSearch(query) {
      var _this3 = this;

      this.term = query || '';
      clearTimeout(this.searchTimer);

      if (this.term.length < MIN_CHARS) {
        this.searchOptions = [];
        this.nextCursor = null;
        return;
      }

      this.searchTimer = setTimeout(function () {
        return _this3.runSearch();
      }, DEBOUNCE_MS);
    },
    runSearch: function runSearch() {
      var _this4 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__services_api_members__["a" /* default */].options({
        context: this.context,
        search: this.term
      }).then(function (res) {
        var _this4$extract = _this4.extract(res),
            items = _this4$extract.items,
            nextCursor = _this4$extract.nextCursor;

        _this4.searchOptions = items;
        _this4.nextCursor = nextCursor;
      }).catch(function () {
        _this4.searchOptions = [];
      }).finally(function () {
        _this4.loading = false;
      });
    },
    loadMore: function loadMore() {
      var _this5 = this;

      if (!this.nextCursor || this.loadingMore || this.loading) return;
      this.loadingMore = true;
      __WEBPACK_IMPORTED_MODULE_1__services_api_members__["a" /* default */].options({
        context: this.context,
        search: this.term,
        cursor: this.nextCursor
      }).then(function (res) {
        var _this5$extract = _this5.extract(res),
            items = _this5$extract.items,
            nextCursor = _this5$extract.nextCursor;

        _this5.searchOptions = [].concat(_toConsumableArray(_this5.searchOptions), _toConsumableArray(items));
        _this5.nextCursor = nextCursor;
      }).catch(function () {}).finally(function () {
        _this5.loadingMore = false;
      });
    },
    onFocusIn: function onFocusIn(e) {
      var _this6 = this;

      if (this.active || this.disabled || this.atLimit) return; // Focus landing on a chip's remove button (keyboard tab, or a browser that still focuses
      // it despite @mousedown.prevent) must not activate the search.

      if (e && e.target && e.target.closest && e.target.closest('.tags-input')) return;
      this.active = true;
      this.$nextTick(function () {
        var ms = _this6.$refs.ms;
        if (!ms) return;
        if (!ms.isOpen) ms.activate();
        var input = ms.$refs && ms.$refs.search;
        if (input && document.activeElement !== input) input.focus();
      });
    },
    onFocusOut: function onFocusOut(e) {
      if (e && e.relatedTarget && this.$el.contains(e.relatedTarget)) return;
      this.active = false;
    },
    onOpen: function onOpen() {
      this.$nextTick(this.attachScroll);
    },
    onClose: function onClose() {
      this.detachScroll();
    },
    // vue-multiselect has no "load more" hook — watch the dropdown's scroll container.
    attachScroll: function attachScroll() {
      var _this7 = this;

      var root = this.$refs.ms && this.$refs.ms.$el;
      var wrapper = root && root.querySelector('.multiselect__content-wrapper');
      if (!wrapper) return;
      this.scrollEl = wrapper;

      this.onScroll = function () {
        if (wrapper.scrollHeight - wrapper.scrollTop - wrapper.clientHeight < 40) _this7.loadMore();
      };

      wrapper.addEventListener('scroll', this.onScroll);
    },
    detachScroll: function detachScroll() {
      if (this.scrollEl && this.onScroll) this.scrollEl.removeEventListener('scroll', this.onScroll);
      this.scrollEl = null;
      this.onScroll = null;
    }
  }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BoyStatus_BoyStatusHistoryTable__ = __webpack_require__(284);
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'HorseProfileBoyHistory',
  components: {
    BoyStatusHistoryTable: __WEBPACK_IMPORTED_MODULE_1__components_BoyStatus_BoyStatusHistoryTable__["a" /* default */]
  },
  setup: function setup(props, _ref) {
    var root = _ref.root;
    var horseId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return root.$route.params.slug;
    });
    return {
      horseId: horseId
    };
  }
}));

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HorseAddDetails__ = __webpack_require__(911);
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HorseAdd',
  props: ['edit', 'register', 'horseRegistrants'],
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    'horse-add-details': __WEBPACK_IMPORTED_MODULE_1__HorseAddDetails__["a" /* default */]
  }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_legacyBrowsers_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slide_toggle__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DesktopActionBar__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Horses_HorseSearchSelect__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Members_MemberSearchSelect__ = __webpack_require__(89);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HorseAddDetails',
  props: ['edit', 'register', 'horseRegistrants'],
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_formValidation_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_legacyBrowsers_js__["a" /* default */]],
  components: {
    'horse-search-select': __WEBPACK_IMPORTED_MODULE_6__components_Horses_HorseSearchSelect__["a" /* default */],
    'member-search-select': __WEBPACK_IMPORTED_MODULE_7__components_Members_MemberSearchSelect__["a" /* default */],
    VueSlideToggle: __WEBPACK_IMPORTED_MODULE_4_vue_slide_toggle__["a" /* VueSlideToggle */],
    DesktopActionBar: __WEBPACK_IMPORTED_MODULE_5__components_DesktopActionBar__["a" /* default */]
  },
  data: function data() {
    return {
      horsePages: 1,
      horseDetails: [{
        gender: 'Mare',
        notes: '',
        file_name: ''
      }],
      horseDetailsHasData: false,
      horseList: {},
      horseListPrice: 36.30,
      errorStatus: '',
      errors: [],
      commonError: '',
      userRole: localStorage.role,
      horseInput: {
        name: '',
        index: 0
      },
      horseNames: [''],
      matchingNames: [],
      nameMatches: [],
      newMemberHorse: false,
      linkedHorses: [],
      userIsSecretary: false,
      files: []
    };
  },
  watch: {
    horseNames: {
      handler: function handler() {
        this.getNameMatch();
      },
      deep: true
    }
  },
  created: function created() {
    var _this = this;

    this.getNameMatch = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function () {
      _this.matchName();
    }, 300);
  },
  computed: {},
  methods: {
    // sire_id / dam_id are submitted as [id] (HorseController reads `[0]`); keep that shape.
    setHorseParent: function setHorseParent(index, key, value) {
      this.$set(this.horseDetails[index], key, Array.isArray(value) ? value : []);
    },
    // owners / user_id are submitted as-is to /horse/add (array of id strings) — same shape the
    // legacy tags-input v-model produced.
    setHorseOwners: function setHorseOwners(index, value) {
      this.$set(this.horseDetails[index], 'owners', value);
    },
    setHorseMembers: function setHorseMembers(index, value) {
      this.$set(this.horseDetails[index], 'user_id', value);
    },
    isOwnerInvalid: function isOwnerInvalid(index) {
      if (this.wasValidated) {
        return !this.horseDetails[index].owners || this.horseDetails[index].owners.length === 0;
      }

      return false;
    },
    isMemberInvalid: function isMemberInvalid(index) {
      if (this.wasValidated) {
        if (this.horseDetails[index].user_id === undefined) {
          return true;
        } else if (this.horseDetails[index].user_id.length === 0) {
          return true;
        }
      }

      return false;
    },
    completeForm: function completeForm() {
      var _this2 = this;

      setTimeout(function () {
        if (_this2.formComplete) {
          if (_this2.register) {
            _this2.checkout();
          } else {
            _this2.addHorses();
          }
        }
      }, 10);
    },
    addHorses: function addHorses() {
      var _this3 = this;

      var formData = new FormData();

      for (var i = 0; i < this.files.length; i++) {
        var file = this.files[i];

        if (this.files[i] && this.files[i].size > 1024 * 1024) {
          this.errorStatus = 'file';
          this.errors[i] = "The Proof of Age file may not be greater than 1 mb.";
        }

        formData.append("files[".concat(i, "]"), file);
      }

      formData.append('fields', JSON.stringify({
        horses: this.horseDetails,
        id: localStorage.userID
      }));
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/horse/add"), formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        _this3.errors = [];
        _this3.commonError = ''; // eslint-disable-next-line
        // console.log(response)

        if (response.data.status === 'success') {
          var horseName = _this3.horseDetails.reduce(function (previousValue, currentValue) {
            return previousValue.concat(currentValue.name, ', ');
          }, '');

          horseName = horseName.slice(0, -2);

          _this3.$router.push({
            path: _this3.$route.name === 'Add Horses' ? '/admin-horses' : _this3.$route.name === 'Secretary Add Horses' ? '/secretary-horses' : '/horses',
            query: {
              success: "".concat(horseName, " ").concat(_this3.horseDetails.length > 1 ? 'have' : 'has', "  been added successfully.")
            }
          });
        } else if (response.data.errors) {
          if (Object.keys(response.data.errors).filter(function (k) {
            return k.includes("dob");
          }).length > 0) {
            // DoB
            _this3.errorStatus = 'dob';
            _this3.errors[Object.keys(response.data.errors).filter(function (k) {
              return k.includes("dob");
            })[0].match(/\d+/)[0]] = "Please include the Date of Birth in the format ".concat(_this3.isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy', ".");
          } else if (Object.keys(response.data.errors).filter(function (k) {
            return k.includes("ashs");
          }).length > 0) {
            _this3.errorStatus = 'ashs';
            _this3.errors[Object.keys(response.data.errors).filter(function (k) {
              return k.includes("ashs");
            })[0].match(/\d+/)[0]] = "Please include a different ASHS#. This one is taken.";
          } else if (Object.keys(response.data.errors).filter(function (k) {
            return k.includes("aqhs");
          }).length > 0) {
            _this3.errorStatus = 'aqhs';
            _this3.errors[Object.keys(response.data.errors).filter(function (k) {
              return k.includes("aqhs");
            })[0].match(/\d+/)[0]] = "Please include a different AQHA#. This one is taken.";
          } else if (Object.keys(response.data.errors).filter(function (k) {
            return k.includes("file");
          }).length > 0) {
            _this3.errorStatus = 'file';
            var fileKey = Object.keys(response.data.errors).filter(function (k) {
              return k.includes("file");
            })[0];
            _this3.errors[fileKey.match(/\d+/)[0]] = Object.values(response.data.errors[fileKey]).flat()[0];
          }
        } else if (response.data.status === 'horse_limit' || response.data.status === 'invalid_data') {
          _this3.commonError = response.data.message;
        } else {
          _this3.errors.splice(0, 1, Object.entries(response.data.errors)[0][1][0]);
        }
      }).catch(function (error) {
        var _error$response;

        if (((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 413 || !error.response) {
          _this3.success = '';
          _this3.errorStatus = 'file';
          _this3.commonError = "The Proof of Age file may not be greater than 1 mb.";
        }

        _this3.errors = []; // eslint-disable-next-line

        console.log(error);
      });
    },
    checkout: function checkout() {
      var _this4 = this;

      setTimeout(function () {
        if (_this4.formComplete) {
          var horses = {
            primary_id: localStorage.userID,
            horses: _this4.horseDetails
          };

          _this4.$store.commit('updateCartMembers', horses);

          _this4.$router.push({
            name: 'Register Horse Cart',
            params: horses
          });
        }
      }, 10);
    },
    toggleRegisteredDate: function toggleRegisteredDate(index) {
      if (this.horseDetails[index].registered === false) {
        this.horseDetails[index].registration_date = null;
      }
    },
    matchName: function matchName() {
      var _this$horseInput,
          _this$horseInput2,
          _this5 = this;

      if (((_this$horseInput = this.horseInput) === null || _this$horseInput === void 0 ? void 0 : _this$horseInput.name) && ((_this$horseInput2 = this.horseInput) === null || _this$horseInput2 === void 0 ? void 0 : _this$horseInput2.name.length) > 0) {
        var index = this.horseInput.index;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/horse-search"), {
          name: this.horseInput.name
        }).then(function (response) {
          _this5.nameMatches.splice(index, 1, true);

          if (response.data.matching.length || _typeof(response.data.matching) === 'object') {
            _this5.matchingNames.splice(index, 1, response.data.matching);

            if (_this5.userRole === 'Volunteer' && response.data.matching.length === 0) {
              _this5.commonError = 'There are no results.';
            } else {
              _this5.commonError = '';
            }
          } else {
            _this5.matchingNames[index] = [];
          }
        });
      }
    },
    newHorseToggle: function newHorseToggle(index) {
      this.newMemberHorse = true;
      this.nameMatches.splice(index, 1, false);
      this.horseDetails[index].name = this.horseNames[index];
      this.horseDetails[index].notes = '';
    },
    linkMemberHorse: function linkMemberHorse(horse_id) {
      var _this6 = this;

      if (horse_id) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/horse/link-member"), {
          horse_id: horse_id
        }).then(function (response) {
          if (response.data.status === 'success') {
            _this6.linkedHorses.push(horse_id);

            if (_this6.$route.name === 'Admin Add Horse' && (_this6.userRole === 'Admin' || _this6.userRole === 'SuperAdmin')) {
              _this6.$router.push('/admin-horses');
            } else if (_this6.$route.name === 'Admin Add Horse' && (_this6.userRole === 'Secretary' || _this6.userRole === 'SecretaryOnly')) {
              _this6.$router.push('/secretary-horses');
            } else {
              _this6.$router.push('/horses');
            }
          } else if (response.data.status === 'horse_limit') {
            _this6.commonError = response.data.message;
          }
        }).catch(function (error) {
          return console.log(error);
        });
      }
    },
    linked: function linked(horse_id) {
      return this.linkedHorses.includes(horse_id);
    },
    fileUpload: function fileUpload(event, index) {
      this.errorStatus = '';
      this.horseDetails[index].file_name = ''; // eslint-disable-next-line

      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(this.errors, function (value, ind) {
        return ind === index;
      });

      var uploadedFile = event.target.files[0];
      this.files[index] = uploadedFile;

      if (uploadedFile && this.files[index].size > 1024 * 1024) {
        this.errorStatus = 'file';
        this.errors[index] = "The Proof of Age file may not be greater than 1 mb.";
      }

      if (uploadedFile) {
        this.horseDetails[index].file_name = uploadedFile.name;
      }
    },
    deleteAttachment: function deleteAttachment(index) {
      delete this.files[index];
      this.files[index] = undefined;
      this.horseDetails[index].file_name = '';
      this.errorStatus = ''; // eslint-disable-next-line

      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(this.errors, function (value, ind) {
        return ind === index;
      });
    },
    validatePointAch: function validatePointAch(event, index) {
      this.horseDetails[index].historic_point_ach = event.target.value.replaceAll(/[^0-9.]/g, '');
    },
    validatePointRom: function validatePointRom(event, index) {
      this.horseDetails[index].historic_point_rom = event.target.value.replaceAll(/[^0-9.]/g, '');
    },
    setHorseName: function setHorseName(index) {
      this.horseInput = {
        name: this.horseNames[index],
        index: index
      };
    },
    addAnotherHorse: function addAnotherHorse() {
      if (this.userRole === 'Volunteer') {
        return;
      }

      this.horseDetails.push({
        gender: 'Mare',
        notes: '',
        boyStatusDiffers: false,
        file_name: '',
        name: ''
      });
      this.horseNames.push('');
      this.horsePages++;
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    /* Check if a user role is Admin or Secretary or Secretary Only */
    if (this.userRole === 'Admin' || this.userRole === 'SuperAdmin' || this.userRole === 'Secretary' || this.userRole === 'SecretaryOnly') {
      this.userIsSecretary = true;
    }
    /* Get horses to register */


    if (this.register && this.horseRegistrants.length > 0) {
      this.horseDetails = [];
      this.$store.state.selectedRows.forEach(function (row) {
        _this7.horseDetails.push(row);
      });
      this.horsePages = this.horseRegistrants.length;
    }
  }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_SelectRow__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_EventBus_js__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HorseRegister',
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__["a" /* default */],
    'data-table': __WEBPACK_IMPORTED_MODULE_2__components_DataTable__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */],
    tableSelectRowTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_SelectRow__["a" /* default */]
  },
  data: function data() {
    return {
      error: '',
      rows: [],
      columns: [{
        label: '',
        field: '',
        headerClass: 'column-lg-small d-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableSelectRowTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_SelectRow__["a" /* default */]
          },
          template: "<tableSelectRowTemplate :row=\"row\" :options=\"{ requireFinancial: true }\" />"
        }
      }, {
        label: 'Horse Name',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.name\" :row=\"row\" :options=\"{ showRegistered: true }\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.name);
        }
      }, {
        label: 'Owner',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.owner_name\" :row=\"row\" :options=\"{ showFinancial: true }\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.owner);
        }
      }, {
        label: 'Age',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"String(row.age)\" :row=\"row\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.age);
        }
      }, {
        label: 'Sex',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.gender\" :row=\"row\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.gender);
        }
      }, {
        label: 'Status',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.horse_status ? row.horse_status.name : ''\" :row=\"row\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.status ? row.status.name : '');
        }
      }],
      options: {
        selectRows: true,
        registerHorseText: true,
        loaded: false,
        search: true
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.commit('deselectAllRows');
    __WEBPACK_IMPORTED_MODULE_5__store_EventBus_js__["a" /* default */].$on('financial-error', function (message) {
      _this.error = message;
    });
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/horse/unregistered-horses")).then(function (response) {
      if (response.data.status === 'success') {
        _this.options.loaded = true; // Done

        if (response.data.data.length === 0) {
          _this.status = 'You have no horses in your list. Press add to add your first horse.';
        }

        _this.error = '';
        _this.rows = response.data.data;
      }
    }).catch(function (error) {
      _this.options.loaded = true; // eslint-disable-next-line

      console.log(error);
    });
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_5__store_EventBus_js__["a" /* default */].$off('financial-error');
  },
  methods: {
    deselectAll: function deselectAll() {
      __WEBPACK_IMPORTED_MODULE_5__store_EventBus_js__["a" /* default */].$emit('deselect-all');
    }
  }
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_SelectRow__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Modal__ = __webpack_require__(5);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NominateRookie',
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__["a" /* default */],
    'data-table': __WEBPACK_IMPORTED_MODULE_2__components_DataTable__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */],
    tableSelectRowTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_SelectRow__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_5__components_Modal__["a" /* default */]
  },
  props: {
    member: {
      type: Object
    }
  },
  data: function data() {
    return {
      error: '',
      rows: [],
      warningText: '',
      columns: [{
        label: '',
        field: '',
        headerClass: 'column-lg-small d-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableSelectRowTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_SelectRow__["a" /* default */]
          },
          template: "<tableSelectRowTemplate :row=\"row\" />"
        }
      }, {
        label: 'Horse Name',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.name\" :row=\"row\" :options=\"{ showRegistered: true }\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.name);
        }
      }, {
        label: 'Owner',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.owner_name\" :row=\"row\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.owner_name);
        }
      }, {
        label: 'Age',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"String(row.age)\" :row=\"row\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.age);
        }
      }, {
        label: 'Sex',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.gender\" :row=\"row\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.gender);
        }
      }, {
        label: 'Status',
        field: 'horse_status_id',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"rowStatus(row.horse_status_id)\" :row=\"row\" />",
          methods: {
            rowStatus: function rowStatus(theID) {
              return this.$store.state.horseStatus.some(function (status) {
                return status.id === theID;
              }) ? this.$store.state.horseStatus.find(function (status) {
                return status.id === theID;
              }).name : '';
            }
          }
        },
        representedAs: function representedAs(row) {
          return "".concat(row.horse_status_name);
        }
      }],
      options: {
        selectRows: true,
        registerHorseText: true,
        loaded: false,
        activeFilter: {
          // Has to be registered before you can nominate
          registration_date: true
        },
        search: true
      },
      processing: false,
      loggedInRole: localStorage.role,
      rookieYears: [],
      selectedSeason: false,
      startYear: 0,
      saveRows: [],
      showSeasonConfirmModal: false
    };
  },
  computed: {
    horseStatus: function horseStatus() {
      return this.$store.state.horseStatus;
    }
  },
  watch: {
    horseStatus: function horseStatus() {
      var _this = this;

      // Match horse status id to horse status name
      if (this.horseStatus.length) {
        this.rows = this.rows.map(function (item) {
          var tempItem = item;
          tempItem.horse_status_name = _this.horseStatus.some(function (status) {
            return status.id === tempItem.horse_status_id;
          }) ? _this.horseStatus.find(function (status) {
            return status.id === tempItem.horse_status_id;
          }).name : '';
          return tempItem;
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if ((this.loggedInRole === 'Admin' || this.loggedInRole === 'SuperAdmin') && !this.member) {
      this.$router.push('/');
    }

    this.$store.commit('deselectAllRows');
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/horse/my-horses"), {
      id: this.loggedInRole === 'Admin' || this.loggedInRole === 'SuperAdmin' ? this.member.id : localStorage.userID,
      ownedOnly: true
    }).then(function (response) {
      if (response.data.status === 'success') {
        _this2.options.loaded = true;

        if (response.data.data.length === 0) {
          _this2.status = 'You have no horses in your list. Press add to add your first horse.';
        }

        var tempRows = response.data.data; // Match horse status id to horse status name

        if (_this2.horseStatus.length) {
          tempRows = response.data.data.map(function (item) {
            var tempItem = item;
            tempItem.horse_status_name = _this2.horseStatus.some(function (status) {
              return status.id === tempItem.horse_status_id;
            }) ? _this2.horseStatus.find(function (status) {
              return status.id === tempItem.horse_status_id;
            }).name : '';
            return tempItem;
          });
        } // We only want horses that aren't already rookies


        _this2.rows = tempRows.filter(function (item) {
          return !item.is_rookie;
        });
        _this2.saveRows = _toConsumableArray(tempRows);
      }
    }).catch(function (error) {
      _this2.options.loaded = true; // eslint-disable-next-line

      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/horse/rookie-years")).then(function (response) {
      _this2.rookieYears = response.data;
      _this2.startYear = response.data[0];
      _this2.selectedSeason = response.data[0];
    });
  },
  methods: {
    deselectAll: function deselectAll() {
      this.$store.commit('deselectAllRows');
    },
    checkout: function checkout() {
      this.processing = true;
      var products = this.$store.getters.selectedRows; // Products data may not have loaded yet - gotta wait for that

      if (this.$store.state.products.length) {
        this.goToCart(products);
      } else {
        this.waitForProducts(products);
      }
    },
    goToCart: function goToCart(products) {
      var _this3 = this;

      // Populate Array of length equalling the number of selected horses with the id of the rookie nomination product
      var productIds = Array(products.length).fill(this.$store.state.products.find(function (product) {
        return product.sku === "rookie-nomination-".concat(_this3.selectedSeason);
      }).id);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/total-cart"), {
        data: productIds
      }).then(function (response) {
        _this3.processing = false;

        if (response.data.status === 'success') {
          var horseData = response.data;
          horseData.horses = products;

          _this3.$store.commit('updateCartMembers', horseData);

          _this3.$router.push({
            name: 'Nominate Rookie Cart',
            params: {
              nominate: 'rookie'
            }
          });
        }
      });
    },
    waitForProducts: function waitForProducts(products) {
      var _this4 = this;

      setTimeout(function () {
        if (_this4.$store.state.products.length) {
          _this4.goToCart(products);
        } else {
          _this4.waitForProducts(products);
        }
      }, 10);
    },
    seasonsList: function seasonsList() {
      var years = []; // eslint-disable-line prefer-const

      this.rookieYears.forEach(function (year) {
        if (year) {
          var description = "April 1, ".concat(year, " to March 31, ").concat(year + 1);
          years.push({
            year: year,
            description: description
          });
        }
      });
      return years;
    },
    setSelectedSeason: function setSelectedSeason(event) {
      this.selectedSeason = event.target.value;
      this.rows = this.saveRows;
      this.rows = this.rows.filter(function (item) {
        return !item.is_rookie;
      });
    },
    checkSelectedSeason: function checkSelectedSeason() {
      if (String(this.startYear) !== String(this.selectedSeason)) {
        this.warningText = "Rookie horse season doesn't start until 1st April - Horses must not have started in an open age event to be eligible. Proceed?";
        this.showSeasonConfirmModal = true;
      } else {
        this.showSeasonConfirmModal = false;
        this.checkout();
      }
    }
  }
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HorseRegisterConfirmDetails__ = __webpack_require__(919);
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HorseConfirm',
  props: ['nominate'],
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    'horse-confirm-details': __WEBPACK_IMPORTED_MODULE_1__HorseRegisterConfirmDetails__["a" /* default */]
  }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_legacyBrowsers_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DesktopActionBar__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Members_MemberSearchSelect__ = __webpack_require__(89);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HorseRegisterConfirm',
  props: ['nominate'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_legacyBrowsers_js__["a" /* default */]],
  components: {
    'member-search-select': __WEBPACK_IMPORTED_MODULE_4__components_Members_MemberSearchSelect__["a" /* default */],
    DesktopActionBar: __WEBPACK_IMPORTED_MODULE_3__components_DesktopActionBar__["a" /* default */]
  },
  data: function data() {
    return {
      horsePages: 1,
      horseDetails: [{
        gender: 'Mare'
      }],
      initialHorseDetails: [],
      horseDetailsHasData: false,
      processing: {
        save: false,
        checkOut: false
      },
      errorStatus: '',
      errors: [],
      commonError: '',
      disableCheckOut: false,
      saveSuccessMessage: '',
      checkoutErrorMessage: '',
      user: localStorage.role,
      userIsNotAdmin: false,
      saveErrorMessage: '',
      year: new Date(this.$store.state.currentDate).getFullYear() > 2023 ? new Date(this.$store.state.currentDate).getFullYear() : 2022
    };
  },
  watch: {
    horseDetails: {
      /* Count number of each type selected */
      handler: function handler(horseDetails) {
        var _this = this;

        this.checkValidity();
        this.initialHorseDetails.forEach(function (row, index) {
          if (!horseDetails[index]) {
            return;
          }

          Object.keys(row).forEach(function (field) {
            if (field === 'members') {
              return;
            }

            if (JSON.stringify(row[field]) !== JSON.stringify(horseDetails[index][field])) {
              _this.disableCheckOut = true;
            }
          });
        });
      },
      deep: true
    }
  },
  methods: {
    isOwnerInvalid: function isOwnerInvalid(index) {
      if (this.wasValidated) {
        if (this.horseDetails[index].owner_id === undefined) {
          this.disableCheckOut = true;
          return true;
        } else if (this.horseDetails[index].owner_id.length === 0) {
          this.disableCheckOut = true;
          return true;
        }
      }

      return false;
    },
    isMemberInvalid: function isMemberInvalid(index) {
      if (this.wasValidated) {
        if (this.horseDetails[index].selectedMembers === undefined) {
          this.disableCheckOut = true;
          return true;
        } else if (this.horseDetails[index].selectedMembers.length === 0) {
          this.disableCheckOut = true;
          return true;
        }
      }

      return false;
    },
    horseListPrice: function horseListPrice(productType) {
      var _this2 = this;

      var filtered = this.$store.state.products.filter(function (product) {
        return product.sku === (productType === 'rookie' ? 'rookie-nomination' : 'horse-registration-'.concat(_this2.year));
      });
      return filtered.length > 0 ? Number(filtered[0].price) : 0;
    },
    saveHorsesData: function saveHorsesData() {
      var _this3 = this;

      this.processing.save = true;
      this.checkValidity();
      var formData = new FormData();
      formData.append('fields', JSON.stringify({
        horses: this.horseDetails,
        id: localStorage.userID
      }));
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/horse/update-horses"), formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        _this3.errors = [];
        _this3.commonError = '';
        _this3.processing.save = false; // eslint-disable-next-line
        // console.log(response)

        if (response.data.status === 'success') {
          if (response.data.updatedHorses.length > 0) {
            _this3.horseDetails = [];
            response.data.updatedHorses.forEach(function (row) {
              if (row !== null) {
                row.owner_id = [row.owner_id.toString()];

                _this3.horseDetails.push(row);
              }
            });

            _this3.horseDetails.forEach(function (horse, index) {
              _this3.$set(_this3.horseDetails[index], 'selectedMembers', horse.members.map(function (a) {
                return a.id.toString();
              }));
            });

            _this3.initialHorseDetails = JSON.parse(JSON.stringify(_this3.horseDetails));
          }

          _this3.saveErrorMessage = '';
          _this3.saveSuccessMessage = 'Horses data saved successfully.';
          setTimeout(function () {
            _this3.saveSuccessMessage = '';
          }, 3000);
          _this3.disableCheckOut = false;
        } else if (response.data.errors && response.data.status === 'validation_error') {
          _this3.saveErrorMessage = 'Please fill in all fields';
        } else if (response.data.errors && response.data.status === 'verification_error') {
          _this3.saveErrorMessage = response.data.errors.message;
        } else if (response.data.status === 'horse_limit') {
          _this3.commonError = response.data.message;
        } else if (response.data.status === 'invalid_data') {
          _this3.commonError = response.data.message;
        } else {
          _this3.errors.splice(0, 1, Object.entries(response.data.errors)[0][1][0]);
        }
      });
    },
    checkout: function checkout() {
      var _this4 = this;

      this.checkValidity();
      setTimeout(function () {
        if (_this4.formComplete === true) {
          _this4.processing.checkOut = true; // eslint-disable-next-line

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(_this4.$api, "/total-cart"), {
            data: _this4.horseDetails.map(function (horse) {
              return _this4.$store.state.products.filter(function (product) {
                return product.sku === (_this4.nominate === 'rookie' ? 'rookie-nomination' : 'horse-registration-'.concat(_this4.year));
              })[0].id;
            })
          }).then(function (response) {
            // eslint-disable-next-line
            // console.log(response.data)
            _this4.processing.checkOut = false;

            if (response.data.status === 'success') {
              var horseData = response.data;
              horseData.horses = _this4.horseDetails.map(function (item) {
                var tempItem = item;
                tempItem.owner_name = tempItem.owner_name;
                return item;
              });

              _this4.$store.commit('updateCartMembers', horseData);

              _this4.$router.push({
                name: _this4.nominate === 'rookie' ? 'Nominate Rookie Cart' : 'Register Horse Cart',
                params: {
                  nominate: _this4.nominate
                }
              });
            } else if (response.data.status === 'validation_error' && Object.keys(response.data.errors).some(function (k) {
              return k.indexOf("dob");
            })) {
              // Do any keys in the error object contain the text 'dob'?
              // DoB
              _this4.errorStatus = 'validation_error';
              _this4.errors[Object.keys(response.data.errors).filter(function (k) {
                return k.includes("dob");
              })[0].match(/\d+/)[0]] = "Please include the Date of Birth in the format".concat(_this4.isLegacy() ? ' yyyy-mm-dd' : ' dd/mm/yyyy', ".");
            }
          });
        } else {
          _this4.disableCheckOut = true;
          _this4.checkoutErrorMessage = 'Please fill in all required fields before checking out.';
        }
      }, 10);
    }
  },
  computed: {
    horseList: function horseList() {
      var list = this.horseDetails.reduce(function (horse, o) {
        if (o.name) horse[o.name] = (horse[o.name] || 0) + 1;
        return horse;
      }, {});
      return list;
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    if (this.user !== 'Admin' && this.user !== 'SuperAdmin') {
      this.userIsNotAdmin = true;
    }
    /* Get horses to register */


    if (this.$store.state.selectedRows.length > 0) {
      this.horseDetails = [];
      this.$store.state.selectedRows.forEach(function (row) {
        row.owner_id = [row.owner_id.toString()];

        _this5.horseDetails.push(row);
      });
      this.horseDetails.forEach(function (horse, index) {
        _this5.$set(_this5.horseDetails[index], 'selectedMembers', horse.members.map(function (a) {
          return a.id.toString();
        }));
      });
      this.initialHorseDetails = JSON.parse(JSON.stringify(this.horseDetails));
      this.horsePages = this.$store.state.selectedRows.length;
    } else {
      this.$router.push({
        name: this.nominate === 'rookie' ? 'Nominate Rookie' : 'Register Horse'
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.processing.checkOut = false;
    this.processing.save = false;
  }
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CartDetails__ = __webpack_require__(923);
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HorseRegisterCart',
  props: ['nominate'],
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    cart: __WEBPACK_IMPORTED_MODULE_1__CartDetails__["a" /* default */]
  },
  data: function data() {
    return {
      cartMembers: this.$store.state.cartMembers
    };
  },
  methods: {
    cartChanged: function cartChanged() {
      this.cartMembers = this.$store.state.cartMembers;
    }
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__ = __webpack_require__(8);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Cart',
  props: {
    cartMembers: {
      type: Object,
      default: {
        items: [],
        horses: [],
        total: 0
      }
    },
    nominate: {
      type: String,
      default: ''
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__["a" /* default */]],
  data: function data() {
    return {
      errors: '',
      total: this.cartMembers.total,
      cartList: this.cartMembers.items,
      horseList: this.cartMembers.horses,
      // eslint-disable-next-line
      processing: this.cartMembers.items ? _toConsumableArray(this.cartMembers.items.map(function (item) {
        return false;
      })) : [],
      userID: localStorage.userID
    };
  },
  methods: {
    remove: function remove(index) {
      var _this = this;

      var data = _toConsumableArray(this.cartList);

      if (data.length > 1) {
        data.splice(index, 1);
        data = data.filter(function (item) {
          return !item.hasOwnProperty('products');
        });
        data = data.map(function (item) {
          return item.id;
        });
        this.processing.splice(index, 1, true);
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/total-cart"), {
          data: data,
          user_id: this.userID
        }).then(function (response) {
          // eslint-disable-next-line
          // console.log(response.data)
          _this.processing.splice(index, 1, false);

          if (response.data.status === 'success') {
            var horseData = response.data;

            _this.horseList.splice(index, 1);

            horseData.horses = _toConsumableArray(_this.horseList);

            _this.$store.commit('updateCartMembers', horseData);

            _this.$emit('cartChanged');
          }
        }).catch(function (error) {
          _this.processing.splice(index, 1, false); // eslint-disable-next-line


          console.log(error);
        });
      } else {
        this.$store.commit('updateCartMembers', {
          items: [],
          total: 0,
          horses: []
        });
        this.$emit('cartChanged');
      }
    },
    payment: function payment() {
      var _this2 = this;

      setTimeout(function () {
        if (_this2.formComplete) {
          _this2.$router.push({
            name: _this2.nominate === 'rookie' ? 'Nominate Rookie Payment' : 'Register Horse Payment',
            params: {
              nominate: _this2.nominate
            }
          });
        }
      }, 10);
    }
  },
  watch: {
    cartMembers: function cartMembers() {
      this.cartList = this.cartMembers.items;
      this.total = this.cartMembers.total; // eslint-disable-next-line

      this.processing = _toConsumableArray(this.cartMembers.items.map(function (item) {
        return false;
      }));
    }
  }
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Payment__ = __webpack_require__(140);
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MyMembershipPayment',
  props: ['nominate'],
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    payment: __WEBPACK_IMPORTED_MODULE_1__components_Payment__["a" /* default */]
  },
  data: function data() {
    return {
      cartMembers: this.$store.state.cartMembers,
      type: 'registration'
    };
  },
  beforeMount: function beforeMount() {
    if (this.nominate === 'rookie') {
      this.type = 'rookie-nomination';
    }
  },
  mounted: function mounted() {
    if (this.cartMembers.hasOwnProperty('total') === false) {
      this.$router.push('/horses/register-horse/cart');
    }
  }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ResponsiveTable__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pagination__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AppTooltip__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Committees_CommitteeSecretariesLink__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ActionGateModal__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_filters_FilterBar__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_filters_FilterMultiselect__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_filters_FilterCheckbox__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ListNameCell__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__composables_drafts_useDraftsList__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__composables_useActionGate__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__composables_drafts_useDeleteDraft__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__composables_drafts_useRestoreDraft__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__composables_drafts_usePublishNominations__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constants_draftStatus__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__columns__ = __webpack_require__(935);
var _STATUS_BADGE;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















 // Keyed by id (DraftStatus enum, CAM-1503), not by the label text the API sends — a status name
// changing in the backend enum's label() no longer silently breaks the badge colour. Anything
// without an explicit colour (e.g. Cancelled) falls back to 'alert-danger' in statusBadgeClass().

var STATUS_BADGE = (_STATUS_BADGE = {}, _defineProperty(_STATUS_BADGE, __WEBPACK_IMPORTED_MODULE_18__constants_draftStatus__["c" /* DRAFT_STATUS_PUBLISHED */], 'alert-success'), _defineProperty(_STATUS_BADGE, __WEBPACK_IMPORTED_MODULE_18__constants_draftStatus__["a" /* DRAFT_STATUS_PENDING */], 'alert-info'), _defineProperty(_STATUS_BADGE, __WEBPACK_IMPORTED_MODULE_18__constants_draftStatus__["b" /* DRAFT_STATUS_POSTPONED */], 'alert-warning'), _STATUS_BADGE); // Second tag shown next to the status badge only while the "Open for Nominations" checkbox is on
// (CAM-1503) — mirrors the 3 states Nominations/DraftsList.vue distinguishes with a button
// (nominating now / entries closed but not yet Finalised / Finalise state = waitlist operating),
// computed server-side (Draft::nominationStage()) so the timezone-aware noms_closed comparison
// isn't duplicated on the frontend.

var NOMINATION_STAGE_BADGE = {
  nominating: {
    label: 'Open',
    badgeClass: 'alert-success'
  },
  finalising: {
    label: 'Being Finalised',
    badgeClass: 'alert-warning'
  },
  waitlist: {
    label: 'Waitlist',
    badgeClass: 'alert-info'
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'DraftsList',
  props: ['success'],
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__["a" /* default */],
    PageHeading: __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__["a" /* default */],
    ResponsiveTable: __WEBPACK_IMPORTED_MODULE_3__components_ResponsiveTable__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_4__components_Pagination__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_5__components_Modal__["a" /* default */],
    AppTooltip: __WEBPACK_IMPORTED_MODULE_6__components_AppTooltip__["a" /* default */],
    CommitteeSecretariesLink: __WEBPACK_IMPORTED_MODULE_7__components_Committees_CommitteeSecretariesLink__["a" /* default */],
    ActionGateModal: __WEBPACK_IMPORTED_MODULE_8__components_ActionGateModal__["a" /* default */],
    FilterBar: __WEBPACK_IMPORTED_MODULE_9__components_filters_FilterBar__["a" /* default */],
    FilterMultiselect: __WEBPACK_IMPORTED_MODULE_10__components_filters_FilterMultiselect__["a" /* default */],
    FilterCheckbox: __WEBPACK_IMPORTED_MODULE_11__components_filters_FilterCheckbox__["a" /* default */],
    ListNameCell: __WEBPACK_IMPORTED_MODULE_12__components_ListNameCell__["a" /* default */]
  },
  setup: function setup(props) {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var store = proxy.$store;

    var _useDraftsList = Object(__WEBPACK_IMPORTED_MODULE_13__composables_drafts_useDraftsList__["b" /* default */])(),
        rows = _useDraftsList.rows,
        loading = _useDraftsList.loading,
        page = _useDraftsList.page,
        totalPages = _useDraftsList.totalPages,
        filters = _useDraftsList.filters,
        perPageOptions = _useDraftsList.perPageOptions,
        fetch = _useDraftsList.fetch,
        setPage = _useDraftsList.setPage,
        setSort = _useDraftsList.setSort,
        setPerPage = _useDraftsList.setPerPage,
        setSearch = _useDraftsList.setSearch,
        setFilter = _useDraftsList.setFilter,
        setFilters = _useDraftsList.setFilters,
        clearFilter = _useDraftsList.clearFilter,
        clearFilters = _useDraftsList.clearFilters,
        syncFromQuery = _useDraftsList.syncFromQuery;

    var actionGate = Object(__WEBPACK_IMPORTED_MODULE_14__composables_useActionGate__["a" /* default */])();
    var runGated = actionGate.runGated;

    var _useDeleteDraft = Object(__WEBPACK_IMPORTED_MODULE_15__composables_drafts_useDeleteDraft__["a" /* default */])(),
        deleteDraft = _useDeleteDraft.deleteDraft;

    var _useRestoreDraft = Object(__WEBPACK_IMPORTED_MODULE_16__composables_drafts_useRestoreDraft__["a" /* default */])(),
        restoreDraft = _useRestoreDraft.restoreDraft;

    var _usePublishNomination = Object(__WEBPACK_IMPORTED_MODULE_17__composables_drafts_usePublishNominations__["a" /* default */])({
      runGated: runGated
    }),
        publish = _usePublishNomination.publish;

    var columns = Object(__WEBPACK_IMPORTED_MODULE_19__columns__["b" /* buildColumns */])();
    var breakpoints = Object(__WEBPACK_IMPORTED_MODULE_19__columns__["a" /* buildBreakpoints */])(); // All + one tab per admin draft status. Unpublished / Deleted / Open for Nominations are now
    // independent checkboxes in the filter bar (CAM-1503), not tab values.

    var tabs = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var statuses = store.getters.getDraftStatusesAdmin || [];
      return [{
        value: 'all',
        label: 'All'
      }].concat(_toConsumableArray(statuses.map(function (s) {
        return {
          value: String(s.id),
          label: s.name
        };
      })));
    });
    var zoneOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return store.state.listZones || [];
    });

    function statusBadgeClass(id) {
      return STATUS_BADGE[id] || 'alert-danger';
    }

    function isPublishedStatus(id) {
      return id === __WEBPACK_IMPORTED_MODULE_18__constants_draftStatus__["c" /* DRAFT_STATUS_PUBLISHED */];
    }

    function nominationStageBadge(row) {
      return NOMINATION_STAGE_BADGE[row.nomination_stage] || null;
    }

    function formatDmy(value) {
      if (!value) return '';
      var d = new Date(value);
      if (Number.isNaN(d.getTime())) return '';
      return "".concat(d.getDate(), "/").concat(d.getMonth() + 1, "/").concat(String(d.getFullYear()).slice(2));
    }

    var hasActiveFilters = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return Boolean(filters.search) || filters.tab !== 'all' || filters.from_date !== Object(__WEBPACK_IMPORTED_MODULE_13__composables_drafts_useDraftsList__["a" /* acaYearStart */])() || Boolean(filters.to_date) || filters.zone_id.length > 0 || Boolean(filters.unpublished) || Boolean(filters.deleted) || Boolean(filters.open_for_nominations);
    });
    var searchInput = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(filters.search || '');
    var alertMessage = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('');
    var errorMessage = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('');
    var searchTimer = null;

    function applySearch() {
      clearTimeout(searchTimer);
      if (searchInput.value !== filters.search) setSearch(searchInput.value);
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(searchInput, function (val) {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
        if (val !== filters.search) setSearch(val);
      }, 500);
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["h" /* onBeforeUnmount */])(function () {
      return clearTimeout(searchTimer);
    });

    function onTabChange(value) {
      setFilter('tab', value);
    } // Unpublished / Deleted / Open for Nominations are mutually exclusive (2026-09-14 revision):
    // each one narrows the list on its own (same as a tab would), so checking one clears the
    // other two rather than combining with them. setFilters() (not repeated setFilter() calls)
    // batches all 3 into a single syncQuery()/fetch() — setFilter() fetches on every call, which
    // was firing up to 3 requests for one click.


    var EXCLUSIVE_CHECKBOXES = ['unpublished', 'deleted', 'open_for_nominations'];

    function setExclusiveCheckbox(name, value) {
      var updates = _defineProperty({}, name, value);

      if (value === '1') {
        EXCLUSIVE_CHECKBOXES.forEach(function (key) {
          if (key !== name) updates[key] = '';
        });
      }

      setFilters(updates);
    } // "Unpublished" keeps the same password gate the legacy filterGuard applied to its tab —
    // only checking it (not unchecking) needs the gate.


    function onUnpublishedToggle(_x) {
      return _onUnpublishedToggle.apply(this, arguments);
    }

    function _onUnpublishedToggle() {
      _onUnpublishedToggle = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(value) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(value === '1')) {
                  _context.next = 9;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return runGated(function () {
                  return true;
                });

              case 4:
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](1);
                return _context.abrupt("return");

              case 9:
                setExclusiveCheckbox('unpublished', value);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 6]]);
      }));
      return _onUnpublishedToggle.apply(this, arguments);
    }

    function onDeletedToggle(value) {
      setExclusiveCheckbox('deleted', value);
    }

    function onOpenForNominationsToggle(value) {
      setExclusiveCheckbox('open_for_nominations', value);
    }

    function clearAll() {
      clearTimeout(searchTimer);
      searchInput.value = '';
      clearFilters();
    } // --- row actions ---


    var draftToDelete = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var publishingId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var restoringId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);

    function askDelete(row) {
      draftToDelete.value = row;
    }

    function confirmDelete() {
      return _confirmDelete.apply(this, arguments);
    }

    function _confirmDelete() {
      _confirmDelete = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var row, ok;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                row = draftToDelete.value;
                draftToDelete.value = null;
                _context2.next = 4;
                return deleteDraft(row.id);

              case 4:
                ok = _context2.sent;
                if (ok) fetch();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _confirmDelete.apply(this, arguments);
    }

    function publishDraft(_x2) {
      return _publishDraft.apply(this, arguments);
    }

    function _publishDraft() {
      _publishDraft = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(row) {
        var ok;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                publishingId.value = row.id;
                _context3.next = 3;
                return publish(row.id);

              case 3:
                ok = _context3.sent;
                publishingId.value = null;
                if (ok) fetch();

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _publishDraft.apply(this, arguments);
    }

    function restoreDraftRow(_x3) {
      return _restoreDraftRow.apply(this, arguments);
    }

    function _restoreDraftRow() {
      _restoreDraftRow = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4(row) {
        var ok;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                restoringId.value = row.id;
                _context4.next = 3;
                return restoreDraft(row.id);

              case 3:
                ok = _context4.sent;
                restoringId.value = null;
                if (ok) fetch();

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _restoreDraftRow.apply(this, arguments);
    }

    function loadPage() {
      var query = proxy.$route.query;
      var success = props.success || query.success;

      if (success) {
        alertMessage.value = success;

        if (query.success) {
          var rest = _objectSpread({}, query);

          delete rest.success;
          proxy.$router.replace({
            query: rest
          }).catch(function () {});
        }
      }

      fetch();
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(loadPage); // Re-load if the same component instance is reused for this route.

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(function () {
      return proxy.$route.path;
    }, function () {
      clearTimeout(searchTimer);
      syncFromQuery();
      searchInput.value = filters.search || '';
      alertMessage.value = '';
      errorMessage.value = '';
      loadPage();
    });
    return _objectSpread({}, actionGate, {
      columns: columns,
      breakpoints: breakpoints,
      tabs: tabs,
      zoneOptions: zoneOptions,
      rows: rows,
      loading: loading,
      page: page,
      totalPages: totalPages,
      filters: filters,
      perPageOptions: perPageOptions,
      searchInput: searchInput,
      alertMessage: alertMessage,
      errorMessage: errorMessage,
      hasActiveFilters: hasActiveFilters,
      draftToDelete: draftToDelete,
      publishingId: publishingId,
      restoringId: restoringId,
      setPage: setPage,
      setSort: setSort,
      setPerPage: setPerPage,
      setFilter: setFilter,
      clearFilter: clearFilter,
      applySearch: applySearch,
      onTabChange: onTabChange,
      onUnpublishedToggle: onUnpublishedToggle,
      onDeletedToggle: onDeletedToggle,
      onOpenForNominationsToggle: onOpenForNominationsToggle,
      clearAll: clearAll,
      askDelete: askDelete,
      confirmDelete: confirmDelete,
      publishDraft: publishDraft,
      restoreDraftRow: restoreDraftRow,
      statusBadgeClass: statusBadgeClass,
      isPublishedStatus: isPublishedStatus,
      nominationStageBadge: nominationStageBadge,
      formatDmy: formatDmy
    });
  }
}));

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DraftAddDetails__ = __webpack_require__(938);
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DraftCreate',
  props: ['draftId'],
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */],
    'draft-add-details': __WEBPACK_IMPORTED_MODULE_2__DraftAddDetails__["a" /* default */]
  },
  data: function data() {
    return {
      details: null,
      loadError: ''
    };
  },
  watch: {
    draftId: 'loadDraft'
  },
  created: function created() {
    this.loadDraft();
  },
  methods: {
    loadDraft: function loadDraft() {
      var _this = this;

      this.details = null;
      this.loadError = '';
      if (!this.draftId) return;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/draft-details/").concat(this.draftId)).then(function (response) {
        if (response.data.status === 'success') {
          _this.details = response.data.data;
        } else {
          _this.loadError = 'Draft not found.';
        }
      }).catch(function () {
        _this.loadError = 'Unable to receive data from the server. Please reload the page.';
      });
    }
  }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_legacyBrowsers_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__voerro_vue_tagsinput__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DesktopActionBar__ = __webpack_require__(15);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuelidate___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DraftCreateDetails',
  props: ['details', 'edit'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_legacyBrowsers_js__["a" /* default */]],
  components: {
    'tags-input': __WEBPACK_IMPORTED_MODULE_3__voerro_vue_tagsinput__["a" /* default */],
    DesktopActionBar: __WEBPACK_IMPORTED_MODULE_7__components_DesktopActionBar__["a" /* default */]
  },
  data: function data() {
    return {
      draftDetails: this.details ? _objectSpread({}, this.details) : {
        attachment: '',
        blog_source: '',
        zone_id: null
      },
      fileName: '',
      listCommittees: this.$store.getters.getCommittees,
      selectedCommittee: [],
      errorStatus: '',
      errors: '',
      processing: false,
      zoneFieldDisabled: true,
      committeeIsInvalid: false,
      secretary_program: null,
      success: null,
      temporaryFileData: {
        name: null
      }
    };
  },
  validations: function validations() {
    return {
      draftDetails: {
        blog_source: {
          url: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["url"]
        }
      }
    };
  },
  computed: {
    listCommitteesCount: function listCommitteesCount() {
      return this.$store.state.listCommittees.length;
    }
  },
  watch: {
    selectedCommittee: function selectedCommittee() {
      this.draftDetails.committee_id = Number(this.selectedCommittee.toString());

      if (this.selectedCommittee.length !== 0 && this.draftDetails.committee_id !== undefined) {
        var _this$draftDetails;

        this.committeeIsInvalid = false;

        if (((_this$draftDetails = this.draftDetails) === null || _this$draftDetails === void 0 ? void 0 : _this$draftDetails.committee_id) && !this.draftDetails.id) {
          var committee = this.$store.getters.getCommittee(this.draftDetails.committee_id);
          this.draftDetails.zone_id = (committee === null || committee === void 0 ? void 0 : committee.zone_id) ? committee.zone_id : null;
        }
      } else {
        this.committeeIsInvalid = true;
      }
    },
    listCommitteesCount: function listCommitteesCount() {
      this.listCommittees = this.$store.getters.getCommittees;
    }
  },
  methods: {
    isInvalid: function isInvalid() {
      if (this.wasValidated) {
        var _this$draftDetails$co;

        if (this.draftDetails.committee_id === undefined) {
          return true;
        } else if (((_this$draftDetails$co = this.draftDetails.committee_id) === null || _this$draftDetails$co === void 0 ? void 0 : _this$draftDetails$co.length) === 0) {
          return true;
        }
      }

      return false;
    },
    completeForm: function completeForm() {
      var _this = this;

      if (this.selectedCommittee.length === 0) {
        this.committeeIsInvalid = true;
      }

      setTimeout(function () {
        if (_this.formComplete && _this.draftDetails.committee_id) {
          _this.addDraft();
        }
      }, 10);
    },
    addDraft: function addDraft() {
      var _this2 = this;

      var formData = new FormData();
      formData.append('file', this.draftDetails.attachment);
      formData.append('fields', JSON.stringify(this.draftDetails));
      this.processing = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/draft-edit"), formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        // eslint-disable-next-line
        // console.log(response)
        _this2.processing = false;

        if (response.data.status === 'success') {
          _this2.$router.push({
            name: 'Drafts',
            params: {
              success: "Great! Your draft has been successfully ".concat(_this2.edit ? 'edited' : 'created', ". You can now begin adding events.")
            }
          });
        } else if (response.data.status === 'validation_error' && response.data.errors.zone_id_changed) {
          // Zone Id Changed
          _this2.success = '';
          _this2.errorStatus = 'zone_id_changed';
          _this2.errors = "The Zone cannot be changed for drafts that have event results.";
        } else if (response.data.status === 'validation_error' && response.data.errors.blog_source) {
          // Blog Source
          _this2.success = '';
          _this2.errorStatus = 'blog_source';
          _this2.errors = "The blog source is invalid.";
        } else {
          // Error
          _this2.success = '';
          _this2.errors = 'Please check for errors & omissions.';
        }
      }).catch(function (error) {
        // eslint-disable-next-line
        console.log(error);
        _this2.processing = false;
        _this2.error = 'Unable to receive data from the server. Please reload the page.';
      });
    },
    deleteDraft: function deleteDraft() {},
    fileUpload: function fileUpload(event) {
      var uploadedFile = event.target.files[0];

      if (!uploadedFile.name.endsWith('.pdf')) {
        this.deleteAttachment();
        this.errorStatus = 'filetype_pdf';
      } else if (uploadedFile.size > 3 * 1024 * 1024) {
        this.deleteAttachment();
        this.errorStatus = 'filesize_pdf';
      } else {
        this.draftDetails.attachment = uploadedFile; // this.fileName = uploadedFile.name

        this.temporaryFileData.name = uploadedFile.name;
        this.errorStatus = null;
      }
    },
    deleteAttachment: function deleteAttachment() {
      this.draftDetails.attachment = null;
      this.draftDetails.fileName = null;
    },
    downloadProgram: function downloadProgram(id, field) {
      if (id) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/drafts/download-program/").concat(id, "/").concat(field)).then(function (response) {
          window.open(response.data.path, '_blank');
        });
      }
    },
    approveSecretaryProgram: function approveSecretaryProgram(id) {
      var _this3 = this;

      if (id) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/drafts/approve-program/").concat(id)).then(function (response) {
          if (response.data.status === 'success') {
            _this3.draftDetails.attachment = _this3.secretary_program.filepath;
            _this3.draftDetails.filename = _this3.secretary_program.filename;
            _this3.secretary_program = null;
            _this3.success = 'Secretary program successfully approved. It will be published on the website https://www.campdraft.com.au';
          }
        });
      }
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    // eslint-disable-next-line eqeqeq
    var draftZoneIsNull = !this.draftDetails.zone_id;

    if (draftZoneIsNull) {
      this.zoneFieldDisabled = false;
    }
    /* Get owners list */


    this.$nextTick(function () {
      if (_this4.details && _this4.details.committee_id) {
        _this4.selectedCommittee.splice(0, 1, _this4.details.committee_id.toString());
      }

      if (_this4.details && _this4.details.id) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(_this4.$api, "/admin/draft-details/").concat(_this4.details.id, "/")).then(function (response) {
          // eslint-disable-next-line
          // console.log(response)
          if (response.data.status === 'success') {
            _this4.secretary_program = response.data.data.secretary_program;
            _this4.draftDetails = response.data.data;
          } else {
            _this4.error = 'Unable to receive data from the server. Please reload the page.';
          }
        });
      }
    });
  }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Button__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DataTableFields_SelectRow__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_EventBus_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_legacyBrowsers_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_date__ = __webpack_require__(148);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
* to their respective fields in the ListingLayout component. */










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EventsList',
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_legacyBrowsers_js__["a" /* default */]],
  props: ['details', 'success', 'placeholder'],
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__["a" /* default */],
    'data-table': __WEBPACK_IMPORTED_MODULE_2__components_DataTable__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */],
    tableButtonTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Button__["a" /* default */],
    tableSelectRowTemplate: __WEBPACK_IMPORTED_MODULE_5__components_DataTableFields_SelectRow__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_6__components_Modal__["a" /* default */]
  },
  data: function data() {
    return {
      draftId: this.$route.params.draftId,
      draftDetails: this.details || this.$store.state.draft || {},
      successMessage: this.success || '',
      status: '',
      error: '',
      warningItems: [],
      changeStatuses: [],
      errorStatus: '',
      rows: [],
      showModal: false,
      processing: false,
      processing2: false,
      publishing: false,
      columns: [{
        label: 'Event',
        headerClass: 'd-none d-lg-table-cell',
        sortable: true,
        filterable: true,
        visible: true,
        component: {
          props: ['row'],
          computed: {
            eventTo: function eventTo() {
              return {
                name: 'Create Event',
                params: {
                  draftId: String(this.$route.params.draftId || this.row.draft_id),
                  eventId: String(this.row.id)
                }
              };
            },
            statusClass: function statusClass() {
              return this.row.status === 'Finalised' ? 'alert-success' : this.row.status === 'Pending' ? 'alert-info' : 'alert-warning';
            }
          },
          // Real <router-link> (an <a href>), not the legacy `<router-link tag="button">`,
          // so the event opens with middle-click / "open in new tab". EventAdd loads by :eventId.
          template: "<span class=\"d-inline-flex align-items-center flex-wrap\" style=\"gap: 4px\"><router-link :to=\"eventTo\" class=\"btn btn-link text-wrap text-left p-0\">{{ row.name }}</router-link><span v-if=\"row.status\" class=\"badge\" :class=\"statusClass\" style=\"min-width: 0\">{{ row.status }}</span></span>"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.name);
        }
      }, {
        label: 'Rounds',
        field: '',
        align: 'left',
        sortable: false,
        filterable: false,
        visible: true,
        headerClass: 'd-none d-lg-table-cell column-lg-medium',
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.rounds === 0 ? '-' : String(row.rounds)\" :row=\"row\" />"
        }
      }, {
        label: 'Event Type',
        field: '',
        align: 'left',
        sortable: false,
        filterable: false,
        visible: true,
        headerClass: 'd-none d-lg-table-cell column-lg-medium',
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.typeName\" :row=\"row\" />"
        }
      }, {
        label: 'Edit',
        field: '',
        align: 'left',
        sortable: false,
        filterable: false,
        headerClass: 'd-none d-lg-table-cell column-lg-medium',
        visible: true,
        component: {
          props: ['row'],
          computed: {
            eventTo: function eventTo() {
              return {
                name: 'Create Event',
                params: {
                  draftId: String(this.$route.params.draftId || this.row.draft_id),
                  eventId: String(this.row.id)
                }
              };
            }
          },
          template: "<router-link :to=\"eventTo\" class=\"btn btn-sm btn-primary mb-2 mb-lg-0 px-lg-3 px-xl-4\">Edit</router-link>"
        }
      }, {
        label: 'Remove',
        field: '',
        align: 'left',
        sortable: false,
        filterable: false,
        headerClass: 'd-none d-lg-table-cell column-lg-medium',
        visible: true,
        component: {
          props: ['row'],
          components: {
            modal: __WEBPACK_IMPORTED_MODULE_6__components_Modal__["a" /* default */],
            tableButtonTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Button__["a" /* default */]
          },
          data: function data() {
            return {
              showModal: false,
              processing: false
            };
          },
          methods: {
            removeModal: function removeModal() {
              this.showModal = true;
            },
            remove: function remove() {
              var _this = this;

              this.processing = true;
              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/event-delete"), {
                id: this.row.id
              }).then(function (response) {
                _this.processing = false;

                if (response.data.status === 'success') {
                  _this.successMessage = 'The event has been removed.';
                  __WEBPACK_IMPORTED_MODULE_7__store_EventBus_js__["a" /* default */].$emit('removed');
                }
              }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error);
                _this.successMessage = '';
                _this.error = 'Unable to receive data from the server. Please reload the page.';
              });
            }
          },
          template: "\n              <div>\n                <button :class=\"['btn btn-sm mb-2 mb-lg-0', processing ? 'btn-primary-dark' : 'btn-primary']\" @click.prevent=\"removeModal\">\n                  {{ !processing ? 'Remove' : '' }}\n                  <div v-if=\"processing\" class=\"spinner-border text-light\" role=\"status\"><span class=\"sr-only\">Loading...</span></div>\n                </button>\n                <modal v-if=\"showModal\" @close=\"showModal = false\">\n                  <div slot=\"body\">\n                    <div class=\"alert alert-warning text-center\">\n                      Removing an event will cause associated points and scores to also be removed.<br>\n                      You are about to remove the event \u2018{{row.name}}\u2019. Are you sure?\n                    </div>\n                    <div class=\"d-flex justify-content-center\">\n                      <button class=\"btn btn-outline-primary\" @click.prevent=\"showModal = false\">Cancel</button>\n                      <button class=\"btn btn-primary ml-2\" @click.prevent=\"remove();showModal = false\">Confirm</button>\n                    </div>\n                  </div>\n                </modal>\n              </div>"
        }
      }],
      options: {
        loaded: false,
        addEvent: true,
        theDraft: this.details ? this.details.id : Object.entries(this.$store.state.draft).length ? this.$store.state.draft.id : null,
        theDraftFinal: this.details ? this.details.is_final : Object.entries(this.$store.state.draft).length ? this.$store.state.draft.is_final : false
      }
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.details) {
      // Instant placeholder render while the real draft details load below.
      this.draftDetails = this.details;
      this.$store.commit('updateDraft', this.details);
      this.$store.commit('updatePlaceholder', this.details.name);
    }

    if (this.draftId) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/draft-details/").concat(this.draftId)).then(function (response) {
        if (response.data.status === 'success') {
          _this2.draftDetails = response.data.data;

          _this2.$store.commit('updateDraft', _this2.draftDetails);

          _this2.$store.commit('updatePlaceholder', _this2.draftDetails.name);

          _this2.getEvents();
        } else {
          _this2.$router.push({
            name: 'Drafts'
          });
        }
      }).catch(function () {
        _this2.$router.push({
          name: 'Drafts'
        });
      });
    } else {
      this.$router.push({
        name: 'Drafts'
      });
    }
  },
  methods: {
    formatDateTime: __WEBPACK_IMPORTED_MODULE_9__utils_date__["b" /* formatDateTime */],
    removeModal: function removeModal(theRowID) {
      this.rowID = theRowID;
      this.showModal = true;
    },
    getEvents: function getEvents() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/event-list/").concat(this.draftId)).then(function (response) {
        // eslint-disable-next-line
        // console.log(response)
        if (response.data.status === 'success') {
          _this3.error = '';
          var theRows = response.data.data;
          theRows.forEach(function (row) {
            row.draftName = _this3.draftDetails.name;
            row.typeName = row.type ? row.type.name : '-';
          });
          _this3.rows = theRows;
          _this3.options.loaded = true;
        } else {
          _this3.error = 'Unable to receive data from the server. Please reload the page.';
        }
      });
    },
    remove: function remove() {
      var _this4 = this;

      this.processing = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/event-delete"), {
        id: this.rowID
      }).then(function (response) {
        _this4.processing = false;

        if (response.data.status === 'success') {
          _this4.successMessage = 'The payment has been removed.';
          _this4.error = '';
          __WEBPACK_IMPORTED_MODULE_7__store_EventBus_js__["a" /* default */].$emit('removed');
        }
      }).catch(function (error) {
        _this4.processing = false; // eslint-disable-next-line

        console.log(error);
        _this4.successMessage = '';
        _this4.error = 'Unable to receive data from the server. Please reload the page.';
      });
    },
    exportEventMembers: function exportEventMembers(draft_id) {
      var _this5 = this;

      this.processing = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/export/draft/").concat(draft_id, "/event-members")).then(function (response) {
        _this5.processing = false;

        if (response.data.status === 'success') {
          var fileName = 'Casual Members';

          if (window.navigator.msSaveOrOpenBlob) {
            var blobObject = new Blob([response.data.results]);
            window.navigator.msSaveOrOpenBlob(blobObject, "".concat(fileName, " - ").concat(_this5.draftDetails.name, ".csv"));
          } else if (_this5.isIOS()) {
            var reader = new FileReader();
            reader.fileName = "".concat(fileName, ".csv");
            var out = new Blob([response.data.results], {
              type: 'data:text/csv;charset=utf-8'
            });

            reader.onload = function () {
              window.location.href = reader.result;
            };

            reader.readAsDataURL(out);
          } else {
            var url = window.URL ? window.URL.createObjectURL(new Blob([response.data.results], {
              type: 'data:text/csv;charset=utf-8'
            })) : window.webkitURL.createObjectURL(new Blob([response.data.results], {
              type: 'data:text/csv;charset=utf-8'
            }));
            var link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "".concat(fileName, " - ").concat(_this5.draftDetails.name, ".csv"));
            document.body.appendChild(link);
            link.click();
            setTimeout(function () {
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }, 0);
          }
        } else if (response.data.status === 'error') {
          _this5.error = response.data.message;
        }
      }).catch(function (error) {
        _this5.processing = false;
        console.log(error);
      });
    },
    publishEvents: function publishEvents() {
      var _this$draftDetails,
          _this6 = this;

      if (((_this$draftDetails = this.draftDetails) === null || _this$draftDetails === void 0 ? void 0 : _this$draftDetails.zone_id) === null) {
        // eslint-disable-next-line no-alert
        alert('Please fill in the zone field in the draft');
        return;
      }

      this.processing2 = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/event-publish"), {
        eventIds: this.$store.getters.selectedRows.map(function (select) {
          return select.id;
        })
      }).then(function (response) {
        _this6.processing2 = false;
        _this6.publishing = false; // eslint-disable-next-line
        // console.log(response)

        if (response.data.status === 'success') {
          var _response$data$data, _response$data$data$f, _response$data$data2, _response$data$data2$;

          _this6.successMessage = 'The events have been successfully published.';
          _this6.warningItems = ((_response$data$data = response.data.data) === null || _response$data$data === void 0 ? void 0 : (_response$data$data$f = _response$data$data.failedEvents) === null || _response$data$data$f === void 0 ? void 0 : _response$data$data$f.length) > 0 ? response.data.data.failedEvents : [];
          _this6.changeStatuses = ((_response$data$data2 = response.data.data) === null || _response$data$data2 === void 0 ? void 0 : (_response$data$data2$ = _response$data$data2.changeStatuses) === null || _response$data$data2$ === void 0 ? void 0 : _response$data$data2$.length) > 0 ? response.data.data.changeStatuses : [];
          _this6.rows = [];
          _this6.options.loaded = false;

          _this6.getEvents();

          __WEBPACK_IMPORTED_MODULE_7__store_EventBus_js__["a" /* default */].$emit('deselect-all');
        }
      }).catch(function (error) {
        _this6.processing2 = false; // eslint-disable-next-line

        console.log(error);
        _this6.successMessage = '';
        _this6.error = 'Unable to receive data from the server. Please reload the page.';
      });
    }
  },
  watch: {
    publishing: function publishing() {
      /* Add checkbox field if publishing events */
      if (this.publishing && this.columns.filter(function (column) {
        return column.publishing === true;
      }).length === 0) {
        this.columns.unshift({
          label: '',
          field: '',
          headerClass: 'column-lg-small d-none d-lg-table-cell',
          visible: true,
          component: {
            props: ['row'],
            components: {
              tableSelectRowTemplate: __WEBPACK_IMPORTED_MODULE_5__components_DataTableFields_SelectRow__["a" /* default */]
            },
            template: "<tableSelectRowTemplate :row=\"row\" />"
          },
          publishing: true
        });
        window.scrollTo(0, 0);
      } else {
        this.columns.shift();
        __WEBPACK_IMPORTED_MODULE_7__store_EventBus_js__["a" /* default */].$emit('deselect-all');
        this.$store.commit('deselectAllRows');
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_7__store_EventBus_js__["a" /* default */].$emit('deselect-all');
    this.$store.commit('deselectAllRows');
  },
  created: function created() {
    var _this7 = this;

    __WEBPACK_IMPORTED_MODULE_7__store_EventBus_js__["a" /* default */].$on('removed', function () {
      _this7.options.loaded = false;
      _this7.rows = [];

      _this7.getEvents();
    });
  }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventAddDetails__ = __webpack_require__(944);
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EventCreate',
  props: ['details', 'edit', 'eventId', 'draftId'],
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    'draft-add-details': __WEBPACK_IMPORTED_MODULE_1__EventAddDetails__["a" /* default */]
  },
  computed: {
    // When this page is opened directly from a URL (e.g. a new tab), `details`/`edit`
    // never arrive as route params — only the path segments (`draftId`/`eventId`) do.
    // Fall back to a minimal details object so EventAddDetails fetches the rest itself.
    resolvedEdit: function resolvedEdit() {
      return this.edit || !!this.eventId;
    },
    resolvedDetails: function resolvedDetails() {
      if (this.details) return this.details;
      if (this.eventId) return {
        id: this.eventId,
        draft_id: this.draftId
      }; // Create mode opened straight from a URL (Add Event in a new tab): EventAddDetails only
      // needs `details` truthy with `.id` = the parent draft id (it redirects back to the
      // events list when `details` is falsy).

      if (this.draftId) return {
        id: this.draftId
      };
      return null;
    }
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_legacyBrowsers_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DesktopActionBar__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Horses_HorseSearchSelect__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Members_MemberSearchSelect__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Judges_JudgeSearchSelect__ = __webpack_require__(946);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







 // One shared reference for "no horse selected" rows so the horse-search-select `:value`
// prop keeps the same identity across renders.

var EMPTY_SELECTION = Object.freeze([]);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EventCreateDetails',
  props: ['details', 'edit'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_legacyBrowsers_js__["a" /* default */]],
  components: {
    'horse-search-select': __WEBPACK_IMPORTED_MODULE_5__components_Horses_HorseSearchSelect__["a" /* default */],
    'member-search-select': __WEBPACK_IMPORTED_MODULE_6__components_Members_MemberSearchSelect__["a" /* default */],
    'judge-search-select': __WEBPACK_IMPORTED_MODULE_7__components_Judges_JudgeSearchSelect__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_3__components_Modal__["a" /* default */],
    DesktopActionBar: __WEBPACK_IMPORTED_MODULE_4__components_DesktopActionBar__["a" /* default */]
  },
  data: function data() {
    return {
      eventDetails: this.details && this.edit ? _objectSpread({}, this.details, {
        results: []
      }) : {
        results: []
      },
      resultPages: 1,
      fileName: '',
      // Pre-resolved {id, label} for the already-assigned judge(s), built once from
      // eventDetails.judges[i].user (see setSelectedJudges()) so JudgeSearchSelect shows the
      // chip immediately, without a hydration request. eventDetails.judges itself is
      // overwritten to a plain array of ids by updateJudgeSelection() (the shape
      // /admin/event-edit expects), so the full objects have to live here instead.
      judgeInitialOptions: [],
      selectedCompetitor: [],
      selectedHorse: [],
      errorStatus: '',
      errors: '',
      warningItems: [],
      showChangeModal: false,
      showRemoveModal: false,
      processing: false,
      processing2: false,
      processing3: false,
      calculating: false,
      draftZoneId: '',
      // True while results are being hydrated from the API. Hydration sets selectedHorse /
      // selectedCompetitor directly (not through onHorsePicked/onCompetitorPicked), so this
      // mostly guards against a stray focusOnHorse() call landing mid-hydration — kept because
      // focusing N vue-multiselect search inputs in one tick makes their activate()/focus()
      // bounce between each other and lock the tab (see MemberSearchSelect/HorseSearchSelect).
      mountingResults: false
    };
  },
  computed: {
    // "No Horse Required" (id 22) is not supported by this legacy form — it never gets
    // draws/rounds/horse fields, which this page assumes every event type has.
    // Excluded here rather than fixed, per CAM-1392 (this page is legacy and not maintained).
    legacyEventTypes: function legacyEventTypes() {
      return this.$store.state.listEventTypes.filter(function (type) {
        return type.id !== 22;
      });
    },
    judgeIds: function judgeIds() {
      return this.eventDetails.judges || [];
    }
  },
  watch: {
    selectedCompetitor: function selectedCompetitor() {
      var _this = this;

      this.selectedCompetitor.forEach(function (result, index) {
        if (_this.eventDetails.results[index].rider_id !== undefined) {
          _this.eventDetails.results[index].rider_id = Number(_this.selectedCompetitor[index].toString());
        }
      });
    },
    selectedHorse: function selectedHorse() {
      var _this2 = this;

      this.selectedHorse.forEach(function (result, index) {
        if (_this2.eventDetails.results[index].horse_id !== undefined) {
          _this2.eventDetails.results[index].horse_id = _this2.selectedHorse[index].length > 0 ? Number(_this2.selectedHorse[index].toString()) : null;
        }
      });
    }
  },
  methods: {
    addAnotherResult: function addAnotherResult(is_cutout) {
      this.eventDetails.results.push({
        rider_id: {},
        horse_id: null,
        score: null,
        points: null,
        position: null,
        is_cutout: is_cutout ? 1 : 0
      });
    },
    // The competitor field only renders an <input> while focused (member-search-select — see
    // its freeze-prevention notes), so a freshly-added or just-calculated row may have none yet;
    // guard the same way focusOnHorse() already does for the horse field below.
    focusNew: function focusNew() {
      var _this3 = this;

      setTimeout(function () {
        var input = document.body.querySelector("#competitordiv".concat(_this3.eventDetails.results.length - 1, " input"));
        if (input) input.focus();
      }, 10);
    },
    focusOnHorse: function focusOnHorse(index) {
      if (this.mountingResults) return; // Only jump focus into an empty Horse field — onCompetitorPicked() calls this on every
      // pick, including one made on a row that already has a horse; re-focusing there would
      // just steal focus mid-edit for no reason.

      if (this.selectedHorse[index] && this.selectedHorse[index].length) return; // HorseSearchSelect only renders its <input> while active, so this always finds
      // nothing and silently no-ops - focus its always-present .multiselect root instead,
      // which triggers HorseSearchSelect's own focusin handling to activate + focus it.

      var target = document.body.querySelector("#horsediv".concat(index, " .multiselect"));

      if (this.eventDetails.results.length > 0 && target) {
        this.$nextTick(function () {
          target.focus();
        });
      }
    },
    focusOnScore: function focusOnScore(index) {
      if (this.eventDetails.results.length > 0 && document.body.querySelector("#score".concat(index)) !== null) {
        this.$nextTick(function () {
          document.body.querySelector("#score".concat(index)).focus();
        });
      }
    },
    onHorsePicked: function onHorsePicked(index, value) {
      this.$set(this.selectedHorse, index, Array.isArray(value) ? value : []);
      if (value && value.length) this.focusOnScore(index);
    },
    // Stable empty array for unset rows — never `selectedHorse[i] || []` inline in the
    // template (a fresh `[]` every render churns the horse-search-select prop).
    horseValue: function horseValue(index) {
      return this.selectedHorse[index] || EMPTY_SELECTION;
    },
    onCompetitorPicked: function onCompetitorPicked(index, value) {
      this.$set(this.selectedCompetitor, index, Array.isArray(value) ? value : []);
      if (value && value.length) this.focusOnHorse(index);
    },
    // Stable empty array for unset rows — same reasoning as horseValue() above.
    competitorValue: function competitorValue(index) {
      return this.selectedCompetitor[index] || EMPTY_SELECTION;
    },
    // getEventDetails() already embeds the result's rider (id, first_name, last_name,
    // member_number) precisely so this field never needs a per-row /v2/members/options?ids=
    // lookup just to show the chip on an existing result — see MemberSearchSelect's freeze
    // checklist item on hydration.
    competitorInitialOptions: function competitorInitialOptions(index) {
      var rider = this.eventDetails.results[index] && this.eventDetails.results[index].rider;
      if (!rider) return EMPTY_SELECTION;
      return [{
        id: rider.id,
        label: "".concat(rider.member_number, ": ").concat(rider.first_name, " ").concat(rider.last_name)
      }];
    },
    removeResult: function removeResult(index) {
      // this.$delete(this.eventDetails.results, index)
      this.eventDetails.results.splice(index, 1);
      this.selectedCompetitor.splice(index, 1);
      this.selectedHorse.splice(index, 1);
    },
    isInvalid: function isInvalid(index) {
      if (this.wasValidated) {
        if (this.eventDetails.results[index].horse_id === undefined || this.eventDetails.results[index].horse_id === null) {
          return true;
        }
      }

      return false;
    },
    completeForm: function completeForm(event) {
      var _this4 = this;

      event.preventDefault();
      setTimeout(function () {
        if (_this4.formComplete) {
          if (_this4.edit && (_this4.eventDetails.showCutout !== _this4.details.showCutout || _this4.eventDetails.showResults !== _this4.details.showResults)) {
            _this4.showChangeModal = true;
          } else if (!_this4.calculating) {
            _this4.addEvent(false);
          }
        }
      }, 10);
    },
    calculate: function calculate() {
      var _this5 = this;

      this.checkValidity();
      setTimeout(function () {
        if (_this5.formComplete) {
          _this5.addEvent(true);
        }
      }, 20);
    },
    addEvent: function addEvent(calculating) {
      var _this6 = this;

      if (this.draftZoneId === null) {
        // eslint-disable-next-line no-alert
        alert('Please fill in the zone field in the draft');
        return;
      }

      this.errorStatus = '';
      this.errors = '';
      this.warningItems = [];
      this.eventDetails.draft_id = this.eventDetails.draft_id || this.details.id;

      if (calculating) {
        this.processing3 = true;
      } else {
        this.processing = true;
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/event-edit"), this.eventDetails).then(function (response) {
        if (calculating) {
          _this6.processing3 = false;
        } else {
          _this6.processing = false;
        }

        if (response.data.status === 'success') {
          // eslint-disable-next-line
          // console.log(response)
          if (calculating) {
            var tempData = response.data.data;
            tempData.results = tempData.results.sort(function (a, b) {
              return a.place > b.place ? 1 : b.place > a.place ? -1 : 0;
            });

            if (tempData.results.filter(function (result) {
              return result.is_cutout === 1;
            }).length === 0) {
              tempData.results.push({
                rider_id: {},
                horse_id: null,
                score: null,
                points: null,
                is_cutout: 1
              });
            }

            tempData.results.push({
              position: null,
              rider_id: {},
              horse_id: null,
              score: null,
              points: null,
              is_cutout: 0
            });
            _this6.eventDetails = tempData;
            _this6.mountingResults = true;
            tempData.results.forEach(function (result, index) {
              if (result.horse_id !== undefined && result.horse_id !== null) {
                _this6.$set(_this6.selectedHorse, index, [result.horse_id.toString()]);

                _this6.selectedCompetitor[index] = [result.rider_id.toString()];
              } else {
                _this6.selectedHorse.splice(index, 1);

                _this6.selectedCompetitor.splice(index, 1);
              }
            });

            _this6.$nextTick(function () {
              _this6.mountingResults = false;
            });

            if (_this6.eventDetails.judges) {
              _this6.setSelectedJudges(_this6.eventDetails.judges);
            }

            _this6.$nextTick(function () {
              var input = document.body.querySelector("#competitordiv".concat(_this6.eventDetails.results.length - 1, " input"));
              if (input) input.focus();
            });

            _this6.warningItems = response.data.warnings || [];
            _this6.calculating = false;
            _this6.formComplete = false;

            _this6.removeValidation();

            _this6.focusNew();
          } else {
            _this6.$router.push({
              name: 'Events',
              params: {
                draftId: _this6.$route.params.draftId,
                success: "Great! Your event has been successfully ".concat(_this6.edit ? 'edited' : 'created', ".")
              }
            });
          }
        } else if (response.data.status === 'invalid_judge' && response.data.errors) {
          _this6.errors = 'The status of the judge should be open';
        } else {
          if (calculating) {
            _this6.processing3 = false;
          } else {
            _this6.processing = false;
          }

          if (response.data.errors && Object.keys(response.data.errors).length > 0) {
            _this6.errorStatus = 'starters';
            var errorKey = Object.keys(response.data.errors)[0];
            _this6.errors = errorKey === 'starters' ? 'Please include the number of Starters.' : response.data.errors[errorKey][0];
          }
        }
      });
    },
    removeEvent: function removeEvent() {
      var _this7 = this;

      this.processing2 = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/event-delete"), {
        id: this.eventDetails.id
      }).then(function (response) {
        _this7.processing2 = false;

        if (response.data.status === 'success') {
          _this7.$router.push({
            name: 'Events',
            params: {
              draftId: _this7.$route.params.draftId,
              success: "Your event has been successfully removed."
            }
          });
        } else {
          _this7.processing2 = false;
          _this7.errors = 'Unable to receive data from the server. Please reload the page.';
        }
      });
    },
    fileUpload: function fileUpload(event) {
      var uploadedFile = event.target.files[0];

      if (uploadedFile.name.endsWith('.pdf')) {
        this.eventDetails.file = uploadedFile;
        this.fileName = uploadedFile.name;
      } else {
        delete this.eventDetails.file;
        this.fileName = '';
        this.errorStatus = 'filetype_pdf';
      }
    },
    setName: function setName() {
      if (!this.eventDetails.name) {
        this.eventDetails.name = this.$store.state.listEventTypes[this.eventDetails.event_type_id - 1].name;
      }
    },
    // eventDetails.judges (from admin/event-details/{id}) already embeds each judge's `user`
    // relation — build the same {id, label} shape /v2/judges/options returns directly from
    // that, no extra request needed to show the already-assigned judge(s) as chips. Also
    // resets eventDetails.judges itself to the plain id array /admin/event-edit expects.
    setSelectedJudges: function setSelectedJudges(judgesList) {
      this.judgeInitialOptions = (judgesList || []).map(function (judge) {
        return {
          id: judge.id,
          label: judge.user ? "".concat(judge.user.member_number || '', ": ").concat(judge.user.first_name, " ").concat(judge.user.last_name).replace(/^: /, '') : ''
        };
      });
      this.eventDetails.judges = this.judgeInitialOptions.map(function (j) {
        return String(j.id);
      });
    },
    updateJudgeSelection: function updateJudgeSelection(ids) {
      this.eventDetails.judges = ids;
    }
  },
  mounted: function mounted() {
    var _this8 = this;

    if (!this.details) {
      this.$router.push({
        name: 'Events',
        params: {
          draftId: this.$route.params.draftId
        }
      });
    } else if (this.details.id && this.edit) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/event-details/").concat(this.details.id)).then(function (response) {
        if (response.data.status === 'success') {
          _this8.eventDetails = response.data.data;

          if (_this8.eventDetails.draft && _this8.eventDetails.draft.name) {
            _this8.$store.commit('updatePlaceholder', _this8.eventDetails.draft.name);
          }

          _this8.mountingResults = true;

          _this8.eventDetails.results.forEach(function (result, index) {
            _this8.$set(_this8.selectedHorse, index, [result.horse_id.toString()]);

            _this8.selectedCompetitor[index] = [result.rider_id.toString()];
          });

          _this8.$nextTick(function () {
            _this8.mountingResults = false;
          });

          if (_this8.eventDetails.results.length === 0) {
            _this8.addAnotherResult(false); // Add a non-cutout


            _this8.addAnotherResult(true); // Add a cutout

          } else if (_this8.eventDetails.results.filter(function (result) {
            return result.is_cutout === 1;
          }).length === 0) {
            _this8.addAnotherResult(true); // Add a cutout

          }

          if (_this8.eventDetails.judges) {
            _this8.setSelectedJudges(_this8.eventDetails.judges);
          }
        } else {
          _this8.error = 'Unable to receive data from the server. Please reload the page.';
        }
      }).finally(function () {
        _this8.draftZoneId = _this8.eventDetails.draft.zone_id !== null ? _this8.eventDetails.draft.zone_id : null;
      });
    }

    this.eventDetails.results = this.eventDetails.results || [{
      rider_id: {},
      horse_id: null,
      score: null,
      points: null
    }];

    if (this.eventDetails.results.length === 0) {
      this.addAnotherResult(false); // Add a non-cutout

      this.addAnotherResult(true); // Add a cutout
    }
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppMultiselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_judges__ = __webpack_require__(442);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Server-backed replacement for the legacy `<tags-input :existing-tags="{id: 'member_number: name'}">`
// event Judge picker (CAM-1477 follow-up). Structural clone of MemberSearchSelect.vue (same
// freeze-prevention checklist, same chip-below-field layout instead of vue-multiselect's own
// inline tags) — kept as its own file rather than parameterising MemberSearchSelect further,
// since the backing resource (Judge, not User) and endpoint differ. `value` / `input` keep the
// tags-input shape: an array of id strings.

var MIN_CHARS = 2;
var DEBOUNCE_MS = 300;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'JudgeSearchSelect',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_0__components_AppMultiselect__["a" /* default */]
  },
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    elementId: {
      type: String,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    // Pre-resolved [{id, label}] for the currently selected judge(s), supplied by the parent's
    // main request (event details already embeds `judges`). When every id in `value` is covered
    // here, no /v2/judges/options hydration call is fired.
    initialOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: 'Start typing...'
    },
    disabled: Boolean,
    required: Boolean
  },
  data: function data() {
    return {
      searchOptions: [],
      selectedCache: [],
      // Plain data (rebuilt via watchers), NOT a computed — see MemberSearchSelect.vue for why.
      mergedOptions: [],
      // The searchable <input> only renders while THIS field is focused — see the focus-pinging
      // freeze documented on HorseSearchSelect.vue.
      active: false,
      loading: false,
      loadingMore: false,
      nextCursor: null,
      term: '',
      searchTimer: null,
      scrollEl: null,
      onScroll: null
    };
  },
  computed: {
    selectedIds: function selectedIds() {
      return (this.value || []).map(function (v) {
        return Number(v);
      }).filter(function (id) {
        return Number.isInteger(id) && id > 0;
      });
    },
    selectedOptions: function selectedOptions() {
      var _this = this;

      return this.selectedIds.map(function (id) {
        return _this.mergedOptions.find(function (o) {
          return o.id === id;
        });
      }).filter(Boolean);
    }
  },
  watch: {
    // Watch the resolved id list, not the `value` array prop directly — see MemberSearchSelect.
    selectedIds: {
      immediate: true,
      handler: function handler(ids, oldIds) {
        if (oldIds && ids.join(',') === oldIds.join(',')) return;
        this.hydrateSelected();
        this.rebuildOptions();
      }
    },
    selectedCache: function selectedCache() {
      this.rebuildOptions();
    },
    searchOptions: function searchOptions() {
      this.rebuildOptions();
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.searchTimer);
    this.detachScroll();
  },
  methods: {
    labelFor: function labelFor(o) {
      return o ? o.label : '';
    },
    extract: function extract(res) {
      var d = res && res.data && res.data.data || {};
      return {
        items: d.items || [],
        nextCursor: d.next_cursor || null
      };
    },
    rebuildOptions: function rebuildOptions() {
      var seen = new Set(this.searchOptions.map(function (o) {
        return o.id;
      }));
      this.mergedOptions = [].concat(_toConsumableArray(this.selectedCache.filter(function (o) {
        return !seen.has(o.id);
      })), _toConsumableArray(this.searchOptions));
    },
    hydrateSelected: function hydrateSelected() {
      var _this2 = this;

      var known = new Set([].concat(_toConsumableArray(this.selectedCache.map(function (o) {
        return o.id;
      })), _toConsumableArray(this.searchOptions.map(function (o) {
        return o.id;
      })), _toConsumableArray(this.initialOptions.map(function (o) {
        return Number(o.id);
      }))));
      var missing = this.selectedIds.filter(function (id) {
        return !known.has(id);
      });
      var fromParent = this.initialOptions.filter(function (o) {
        return _this2.selectedIds.includes(Number(o.id));
      }).map(function (o) {
        return _objectSpread({}, o, {
          id: Number(o.id)
        });
      });
      this.selectedCache = [].concat(_toConsumableArray(this.selectedCache.filter(function (o) {
        return !fromParent.some(function (p) {
          return p.id === o.id;
        });
      })), _toConsumableArray(fromParent));
      var toFetch = missing.filter(function (id) {
        return !fromParent.some(function (p) {
          return p.id === id;
        }) && Number.isInteger(id) && id > 0;
      });
      if (toFetch.length === 0) return;
      __WEBPACK_IMPORTED_MODULE_1__services_api_judges__["a" /* default */].options({
        ids: toFetch.join(',')
      }).then(function (res) {
        var fetched = _this2.extract(res).items;

        var seen = new Set(_this2.selectedCache.map(function (o) {
          return o.id;
        }));
        _this2.selectedCache = [].concat(_toConsumableArray(_this2.selectedCache), _toConsumableArray(fetched.filter(function (o) {
          return !seen.has(o.id);
        })));
      }).catch(function () {});
    },
    onSelect: function onSelect(option) {
      if (!option || option.id == null) return;

      if (this.multiple) {
        if (this.selectedIds.includes(option.id)) {
          this.resetMultiselect();
          return;
        }

        this.selectedCache = [].concat(_toConsumableArray(this.selectedCache.filter(function (o) {
          return o.id !== option.id;
        })), [option]);
        this.$emit('input', [].concat(_toConsumableArray(this.value.map(String)), [String(option.id)]));
      } else {
        this.selectedCache = [option];
        this.$emit('input', [String(option.id)]);
      }

      this.resetMultiselect();
    },
    resetMultiselect: function resetMultiselect() {
      var ms = this.$refs.ms;
      if (!ms) return;
      ms.internalValue = [];
      ms.search = '';
    },
    remove: function remove(id) {
      if (this.disabled) return;
      this.$emit('input', this.selectedIds.filter(function (i) {
        return i !== id;
      }).map(String));
    },
    onSearch: function onSearch(query) {
      var _this3 = this;

      this.term = query || '';
      clearTimeout(this.searchTimer);

      if (this.term.length < MIN_CHARS) {
        this.searchOptions = [];
        this.nextCursor = null;
        return;
      }

      this.searchTimer = setTimeout(function () {
        return _this3.runSearch();
      }, DEBOUNCE_MS);
    },
    runSearch: function runSearch() {
      var _this4 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__services_api_judges__["a" /* default */].options({
        search: this.term
      }).then(function (res) {
        var _this4$extract = _this4.extract(res),
            items = _this4$extract.items,
            nextCursor = _this4$extract.nextCursor;

        _this4.searchOptions = items;
        _this4.nextCursor = nextCursor;
      }).catch(function () {
        _this4.searchOptions = [];
      }).finally(function () {
        _this4.loading = false;
      });
    },
    loadMore: function loadMore() {
      var _this5 = this;

      if (!this.nextCursor || this.loadingMore || this.loading) return;
      this.loadingMore = true;
      __WEBPACK_IMPORTED_MODULE_1__services_api_judges__["a" /* default */].options({
        search: this.term,
        cursor: this.nextCursor
      }).then(function (res) {
        var _this5$extract = _this5.extract(res),
            items = _this5$extract.items,
            nextCursor = _this5$extract.nextCursor;

        _this5.searchOptions = [].concat(_toConsumableArray(_this5.searchOptions), _toConsumableArray(items));
        _this5.nextCursor = nextCursor;
      }).catch(function () {}).finally(function () {
        _this5.loadingMore = false;
      });
    },
    onFocusIn: function onFocusIn(e) {
      var _this6 = this;

      if (this.active || this.disabled) return;
      if (e && e.target && e.target.closest && e.target.closest('.tags-input')) return;
      this.active = true;
      this.$nextTick(function () {
        var ms = _this6.$refs.ms;
        if (!ms) return;
        if (!ms.isOpen) ms.activate();
        var input = ms.$refs && ms.$refs.search;
        if (input && document.activeElement !== input) input.focus();
      });
    },
    onFocusOut: function onFocusOut(e) {
      if (e && e.relatedTarget && this.$el.contains(e.relatedTarget)) return;
      this.active = false;
    },
    onOpen: function onOpen() {
      this.$nextTick(this.attachScroll);
    },
    onClose: function onClose() {
      this.detachScroll();
    },
    attachScroll: function attachScroll() {
      var _this7 = this;

      var root = this.$refs.ms && this.$refs.ms.$el;
      var wrapper = root && root.querySelector('.multiselect__content-wrapper');
      if (!wrapper) return;
      this.scrollEl = wrapper;

      this.onScroll = function () {
        if (wrapper.scrollHeight - wrapper.scrollTop - wrapper.clientHeight < 40) _this7.loadMore();
      };

      wrapper.addEventListener('scroll', this.onScroll);
    },
    detachScroll: function detachScroll() {
      if (this.scrollEl && this.onScroll) this.scrollEl.removeEventListener('scroll', this.onScroll);
      this.scrollEl = null;
      this.onScroll = null;
    }
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Button__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
* to their respective fields in the ListingLayout component. */





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TitlesList',
  props: ['success'],
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__["a" /* default */],
    'data-table': __WEBPACK_IMPORTED_MODULE_2__components_DataTable__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */],
    tableButtonTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Button__["a" /* default */]
  },
  data: function data() {
    return {
      status: '',
      error: '',
      rows: [],
      columns: [{
        label: 'Title',
        headerClass: 'd-none d-lg-table-cell',
        sortable: true,
        filterable: true,
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.name\" :link=\"'Edit Title'\" :row=\"row\" :edit=\"true\" :options=\"{ showLinks: true, showStatus: true }\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.name);
        }
      }, {
        label: 'Edit',
        field: '',
        align: 'left',
        sortable: false,
        filterable: false,
        headerClass: 'd-none d-lg-table-cell column-lg-medium',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableButtonTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Button__["a" /* default */]
          },
          template: "<tableButtonTemplate :text=\"'Edit'\" :link=\"'Edit Title'\" :row=\"row\" :edit=\"true\" />"
        }
      }],
      options: {
        loaded: false
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/title-list")).then(function (response) {
      // eslint-disable-next-line
      // console.log(response)
      if (response.data.status === 'success') {
        _this.error = '';
        _this.rows = response.data.data;
        _this.options.loaded = true;
      } else {
        _this.error = 'Unable to receive data from the server. Please reload the page.';
      }
    });
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TitleEditDetails__ = __webpack_require__(954);
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TitleEdit',
  props: ['details'],
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    'title-edit-details': __WEBPACK_IMPORTED_MODULE_1__TitleEditDetails__["a" /* default */]
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DesktopActionBar__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TitleEditDetailsSire__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TitleEditDetailsRookie__ = __webpack_require__(957);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TitleEditDetails',
  props: ['details'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formValidation_js__["a" /* default */]],
  components: {
    rookie: __WEBPACK_IMPORTED_MODULE_4__TitleEditDetailsRookie__["a" /* default */],
    sire: __WEBPACK_IMPORTED_MODULE_3__TitleEditDetailsSire__["a" /* default */],
    DesktopActionBar: __WEBPACK_IMPORTED_MODULE_2__components_DesktopActionBar__["a" /* default */]
  },
  data: function data() {
    return {
      titleDetails: this.details ? _objectSpread({}, this.details) : {
        sponsor_logo_file: '',
        title_logo_file: ''
      },
      sponsorLogoFileName: this.details ? this.details.sponsor_logo : '',
      titleLogoFileName: this.details ? this.details.title_logo : '',
      validation: {
        title_logo: {
          status: '',
          message: ''
        },
        sponsor_logo: {
          status: '',
          message: ''
        }
      },
      errors: '',
      processing: false
    };
  },
  methods: {
    completeForm: function completeForm() {
      var _this = this;

      setTimeout(function () {
        if (_this.formComplete) {
          _this.addTitle();
        }
      }, 10);
    },
    addTitle: function addTitle() {
      var _this2 = this;

      var formData = new FormData();
      formData.append('sponsor_logo_file', this.titleDetails.sponsor_logo_file);
      formData.append('title_logo_file', this.titleDetails.title_logo_file);
      formData.append('fields', JSON.stringify(this.titleDetails));
      this.processing = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/title-edit"), formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        _this2.processing = false;

        if (response.data.status === 'success') {
          _this2.$router.push({
            name: 'Titles',
            params: {
              success: "Great! Your title has been successfully edited."
            }
          });
        } else {
          _this2.errors = 'Something went wrong. Please reload the page.';
        }
      }).catch(function () {
        _this2.processing = false;
        _this2.errors = 'Unable to receive data from the server. Please reload the page.';
      });
    },
    sponsorLogoFileUpload: function sponsorLogoFileUpload(event) {
      var uploadedFile = event.target.files[0];

      if (this.validateFile(uploadedFile, 'sponsor_logo', 2)) {
        this.titleDetails.sponsor_logo_file = uploadedFile;
        this.titleDetails.sponsor_logo = URL.createObjectURL(uploadedFile);
        this.sponsorLogoFileName = uploadedFile.name;
      }
    },
    titleLogoFileUpload: function titleLogoFileUpload(event) {
      var uploadedFile = event.target.files[0];

      if (this.validateFile(uploadedFile, 'title_logo', 2)) {
        this.titleDetails.title_logo_file = uploadedFile;
        this.titleDetails.title_logo = URL.createObjectURL(uploadedFile);
        this.titleLogoFileName = uploadedFile.name;
      }
    },
    validateFile: function validateFile(uploadedFile, key, maxSizeMB) {
      var maxSize = maxSizeMB * 1024 * 1024;
      var status = true;

      if (uploadedFile.size > maxSize) {
        status = false;
        this.errors = 'The file you are uploading is too large.';
        this.validation[key].status = 'error';
        this.validation[key].message = 'The file should be less that 2MB.';
      } else {
        this.errors = '';
        this.validation[key].status = '';
        this.validation[key].message = '';
      }

      return status;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    /* Boot out user if there's no details to show */
    this.$nextTick(function () {
      if (!_this3.details) {
        _this3.$router.push({
          name: 'Titles'
        });
      }
    });
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_legacyBrowsers_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Horses_HorseSearchSelect__ = __webpack_require__(60);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'horse-search-select': __WEBPACK_IMPORTED_MODULE_2__components_Horses_HorseSearchSelect__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_legacyBrowsers_js__["a" /* default */]],
  data: function data() {
    return {
      selectedHorses: [],
      selectedYear: 0,
      years: [],
      siresHaveChanged: false,
      processing: false,
      sireSuccess: '',
      sireError: ''
    };
  },
  methods: {
    saveSires: function saveSires(theYear) {
      var _this = this;

      this.processing = true;
      this.sireSuccess = '';
      this.sireError = '';
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/sire-eligibility"), {
        year: theYear,
        horseIds: this.selectedHorses.flat(1)
      }).then(function (response) {
        _this.$nextTick(function () {
          _this.siresHaveChanged = false;
        });

        _this.processing = false;

        if (response.data.status === 'success') {
          _this.sireSuccess = "Sire List for ".concat(theYear, " saved successfully.");
        } else {
          _this.sireError = "Please check the data in your submission.";
        }
      }).catch(function () {
        _this.processing = false;
        _this.sireError = "Please check the data in your submission.";
      });
    },
    getSires: function getSires() {
      var _this2 = this;

      this.selectedHorses = [];
      this.$nextTick(function () {
        _this2.siresHaveChanged = false;
      });
      this.sireSuccess = '';
      this.sireError = '';
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/sire-eligibility"), {
        params: {
          year: this.selectedYear === 0 ? null : this.selectedYear
        }
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this2.selectedHorses = response.data.data.map(function (horse) {
            return [horse.horse_id.toString()];
          });

          _this2.addAnotherResult();

          setTimeout(function () {
            _this2.siresHaveChanged = false;
          }, 100);
        } else {
          _this2.sireError = "Sire list retrieval failed. Please try again later.";
        }
      }).catch(function () {
        _this2.sireError = "Sire list retrieval failed. Please try again later.";
      });
    },
    focusNew: function focusNew() {
      var _this3 = this;

      setTimeout(function () {
        // HorseSearchSelect only renders its <input> while active, so a freshly added
        // row has no <input> yet - focus its always-present .multiselect root instead,
        // which triggers HorseSearchSelect's own focusin handling to activate + focus it.
        var target = document.body.querySelector("#horsediv".concat(_this3.selectedHorses.length - 1, " .multiselect"));
        if (target) target.focus();
      }, 10);
    },
    removeResult: function removeResult(index) {
      this.selectedHorses.splice(index, 1);
    },
    addAnotherResult: function addAnotherResult() {
      var _this4 = this;

      this.selectedHorses.push(null);
      /* Workaround for VueJS reactivity bug - scheduled to be fixed in VueJS 3. */

      this.$forceUpdate();
      this.$nextTick(function () {
        _this4.siresHaveChanged = false;
      });
    }
  },
  watch: {
    selectedYear: function selectedYear(newVal, oldVal) {
      if (newVal !== oldVal && oldVal !== 0 && this.siresHaveChanged) {
        this.siresHaveChanged = false;
        this.saveSires(oldVal);
      }
    },
    selectedHorses: {
      deep: true,
      handler: function handler() {
        this.siresHaveChanged = true;
      }
    }
  },
  mounted: function mounted() {
    /* Get year data */
    var today = this.$store.state.currentDate ? new Date(this.$store.state.currentDate) : new Date();
    this.selectedYear = today.getFullYear();

    for (var Y = this.selectedYear; Y >= 2015; Y--) {
      this.years.push({
        id: Y,
        name: "".concat(Y, " / ").concat(Y + 1)
      });
    }
    /* Get sire data */


    this.getSires();
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_legacyBrowsers_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Horses_HorseSearchSelect__ = __webpack_require__(60);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'horse-search-select': __WEBPACK_IMPORTED_MODULE_2__components_Horses_HorseSearchSelect__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_legacyBrowsers_js__["a" /* default */]],
  data: function data() {
    return {
      selectedHorses: [],
      selectedYear: 0,
      years: [],
      processing: false,
      rookieSuccess: '',
      rookieError: ''
    };
  },
  methods: {
    // rookie.horse.id may be undefined (new), a string (loaded), or ['id'] (just picked).
    rookieHorseValue: function rookieHorseValue(rookie) {
      var id = rookie && rookie.horse ? rookie.horse.id : null;
      if (!id) return [];
      return Array.isArray(id) ? id : [id.toString()];
    },
    saveRookie: function saveRookie(horseIndex) {
      var _this = this;

      this.processing = true;
      this.rookieSuccess = '';
      this.rookieError = '';
      var data = JSON.parse(JSON.stringify(this.selectedHorses[horseIndex]));
      data.year = this.selectedYear;

      if (data.horse.id && data.horse.id.length) {
        data.horse.id = Number(data.horse.id);
      } else {
        data.horse.id = null;
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/rookie-nominations"), data).then(function (response) {
        _this.processing = false;
        _this.rookieSuccess = "Rookie List for ".concat(_this.selectedYear, " saved successfully.");
        var newData = JSON.parse(JSON.stringify(_this.selectedHorses));
        var returnedData = response.data; // ID is being sent to front-end as a Number - needs to be string for comparison

        returnedData.horse.id = returnedData.horse.id.toString(); // Return new data with id from back-end instead of entered data on front-end

        newData = newData.map(function (item) {
          return item.horse.id[0] === returnedData.horse.id ? returnedData : item;
        });
        _this.selectedHorses = newData;
      }).catch(function () {
        _this.processing = false;
        _this.rookieError = "Please check the data in your submission.";
      });
    },
    getRookies: function getRookies() {
      var _this2 = this;

      this.selectedHorses = [];
      this.rookieSuccess = '';
      this.rookieError = '';
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/rookie-nominations"), {
        params: {
          year: this.selectedYear === 0 ? null : this.selectedYear
        }
      }).then(function (response) {
        _this2.selectedHorses = response.data.map(function (horse) {
          var tempHorse = horse;

          if (tempHorse.horse && tempHorse.horse.id) {
            tempHorse.horse.id = tempHorse.horse.id.toString();
          }

          return tempHorse;
        });

        _this2.addAnotherResult();
      }).catch(function () {
        _this2.rookieError = "Rookie list retrieval failed. Please try again later.";
      });
    },
    focusNew: function focusNew() {
      var _this3 = this;

      setTimeout(function () {
        // HorseSearchSelect only renders its <input> while active, so a freshly added
        // row has no <input> yet - focus its always-present .multiselect root instead,
        // which triggers HorseSearchSelect's own focusin handling to activate + focus it.
        var target = document.body.querySelector("#horsediv".concat(_this3.selectedHorses.length - 1, " .multiselect"));
        if (target) target.focus();
      }, 10);
    },
    removeResult: function removeResult(index) {
      var _this4 = this;

      this.rookieSuccess = '';
      this.rookieError = '';

      if (this.selectedHorses[index].id) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete("".concat(this.$api, "/admin/rookie-nominations/").concat(this.selectedHorses[index].id)).then(function () {
          // Not sure why this doesn't need this.$forceUpdate()
          _this4.selectedHorses.splice(index, 1);
        }).catch(function () {
          _this4.rookieError = "Could not remove record.";
        });
      } else {
        // Not sure why this doesn't need this.$forceUpdate()
        this.selectedHorses.splice(index, 1);
      }
    },
    addAnotherResult: function addAnotherResult() {
      this.selectedHorses.push({
        horse: {},
        eligible_from: this.getHolderDate()
      });
      /* Workaround for VueJS reactivity bug - scheduled to be fixed in VueJS 3. */

      this.$forceUpdate();
    },
    getHolderDate: function getHolderDate() {
      var d = this.$store.state.currentDate ? new Date(this.$store.state.currentDate) : new Date(); // 0 indexed for Jan so add 1 to get current

      var day = d.getDate();
      var dayString = "0".concat(day).slice(-2);
      var month = d.getMonth() + 1;
      var monthString = "0".concat(month).slice(-2);
      var year = d.getFullYear().toString(); // Return the start of the ACA year

      return [year, monthString, dayString].join('-');
    }
  },
  mounted: function mounted() {
    /* Get year data */
    var today = this.$store.state.currentDate ? new Date(this.$store.state.currentDate) : new Date();

    if (today.getMonth() < 3) {
      this.selectedYear = today.getFullYear() - 1;
    } else {
      this.selectedYear = today.getFullYear();
    }

    var earliestYear = 2019;

    for (var i = earliestYear; i < this.selectedYear; i++) {
      this.years.push({
        id: i,
        name: "".concat(i, " / ").concat(i + 1)
      });
    }

    this.years.push({
      id: this.selectedYear,
      name: "".concat(this.selectedYear, " / ").concat(this.selectedYear + 1)
    });
    this.years.push({
      id: this.selectedYear + 1,
      name: "".concat(this.selectedYear + 1, " / ").concat(this.selectedYear + 2)
    });
    /* Get rookie data */

    this.getRookies();
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Button__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SeasonSelect__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ZoneSelect__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AppMultiselect__ = __webpack_require__(29);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
* to their respective fields in the ListingLayout component. */








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TitlesPreview',
  props: ['success'],
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__["a" /* default */],
    'data-table': __WEBPACK_IMPORTED_MODULE_2__components_DataTable__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */],
    tableButtonTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Button__["a" /* default */],
    SeasonSelect: __WEBPACK_IMPORTED_MODULE_5__components_SeasonSelect__["a" /* default */],
    ZoneSelect: __WEBPACK_IMPORTED_MODULE_6__components_ZoneSelect__["a" /* default */],
    AppMultiselect: __WEBPACK_IMPORTED_MODULE_7__components_AppMultiselect__["a" /* default */]
  },
  data: function data() {
    return {
      columns: [],
      columnsNotSire: [{
        label: 'Pos',
        headerClass: 'd-none d-lg-table-cell',
        sortable: true,
        filterable: true,
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"String(row.place)\" :row=\"row\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.place);
        }
      }, {
        label: this.rows ? this.rows[0].hasOwnProperty("rider_name") ? 'Rider' : 'Horse' : '',
        headerClass: 'd-none d-lg-table-cell',
        sortable: true,
        filterable: true,
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.rider_name || row.horse_name\" :row=\"row\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.rider_name || row.horse_name);
        }
      }, {
        label: 'Owner',
        headerClass: 'd-none d-lg-table-cell',
        sortable: true,
        filterable: true,
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.owner\" :row=\"row\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.owner);
        }
      }, {
        label: 'Points',
        headerClass: 'd-none d-lg-table-cell',
        sortable: true,
        filterable: true,
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.total\" :row=\"row\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.total);
        }
      }, {
        label: 'Zone',
        headerClass: 'd-none d-lg-table-cell',
        sortable: true,
        filterable: true,
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"rowZone(row.rider_zone || row.horse_zone)\" :row=\"row\" />",
          methods: {
            rowZone: function rowZone(zoneID) {
              return this.$store.state.listZones && zoneID ? this.$store.state.listZones.filter(function (zone) {
                return zone.id === zoneID;
              })[0].code : '';
            }
          }
        }
      }],
      columnsSire: [{
        label: 'Pos',
        headerClass: 'd-none d-lg-table-cell',
        sortable: true,
        filterable: true,
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"String(row.place)\" :row=\"row\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.place);
        }
      }, {
        label: 'Horse',
        headerClass: 'd-none d-lg-table-cell',
        sortable: true,
        filterable: true,
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.sire.name\" :row=\"row\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.sire.name);
        }
      }, {
        label: 'Owner',
        headerClass: 'd-none d-lg-table-cell',
        sortable: true,
        filterable: true,
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.owner.name\" :row=\"row\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.owner.name);
        }
      }, {
        label: 'Points',
        headerClass: 'd-none d-lg-table-cell',
        sortable: true,
        filterable: true,
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.total_points.toFixed(2)\" :row=\"row\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.total_points.toFixed(2));
        }
      }],
      rows: [],
      status: '',
      error: '',
      year: 0,
      title: '',
      titles: [],
      processing: false,
      options: {
        loaded: false
      },
      zone: 0,
      zones: []
    };
  },
  computed: {
    titleOptions: function titleOptions() {
      return this.titles.map(function (title) {
        return {
          label: title.name,
          value: title.id
        };
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/title-list")).then(function (response) {
      if (response.data.status === 'success') {
        _this.error = '';
        _this.titles = response.data.data;
      } else {
        _this.error = 'Unable to receive data from the server. Please reload the page.';
      }
    });
    var _this$$route$query = this.$route.query,
        title = _this$$route$query.title,
        year = _this$$route$query.year,
        zone = _this$$route$query.zone;

    if (title) {
      this.title = Number(title);
      if (year) this.year = Number(year);
      if (zone) this.zone = Number(zone);
      this.getStandings();
    }
  },
  methods: {
    onTitleChange: function onTitleChange(option) {
      this.title = option ? option.value : '';
      this.rows = [];
      this.options.loaded = false;
    },
    getZoneLength: function getZoneLength(zoneID) {
      return this.zones.length > 0 ? this.zones.filter(function (zone) {
        return zone.id === zoneID;
      }).length : '';
    },
    getZone: function getZone(zoneID) {
      return this.getZoneLength(zoneID) > 0 ? this.zones.filter(function (zone) {
        return zone.id === zoneID;
      })[0].name : '';
    },
    getStandings: function getStandings() {
      var _this2 = this;

      this.processing = true;
      var query = {
        title: String(this.title),
        year: String(this.year)
      };
      if (this.zone && this.title !== 5) query.zone = String(this.zone);
      this.$router.replace({
        query: query
      }).catch(function () {});
      var url = "".concat(this.$api, "/preview-results-title/").concat(this.year, "/").concat(this.title);

      if (this.zone && this.title !== 5) {
        url += "/".concat(this.zone);
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
        _this2.processing = false;

        if (response.data.status === 'success') {
          _this2.options.loaded = true;
          _this2.error = '';

          if (_this2.title === 5) {
            var _this2$columns;

            (_this2$columns = _this2.columns).splice.apply(_this2$columns, [0, _this2.columns.length].concat(_toConsumableArray(_this2.columnsSire)));

            _this2.rows = response.data.data.results.map(function (row, index) {
              var temp = row;
              temp.place = index + 1;
              return temp;
            });
          } else if (Object.keys(response.data.data).length > 0 && response.data.data.results.length > 0) {
            var _this2$columns2;

            var temp = [].concat(_this2.columnsNotSire); // If Rider titles

            if (_this2.title > 5) {
              temp.splice(2, 1);
            }

            (_this2$columns2 = _this2.columns).splice.apply(_this2$columns2, [0, _this2.columns.length].concat(_toConsumableArray(temp)));

            _this2.rows = response.data.data.results;

            _this2.setColumnName();
          } else {
            _this2.rows = [];
          }
        } else {
          _this2.error = 'Unable to receive data from the server. Please reload the page.';
        }
      });
    },
    setColumnName: function setColumnName() {
      if (this.columns[1].label === '' || this.columns[1].label === 'Rider' || this.columns[1].label === 'Horse') {
        this.columns[1].label = this.rows[0].hasOwnProperty("rider_name") ? 'Rider' : 'Horse';
      }
    }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeasonSelect_vue__ = __webpack_require__(382);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17eb686f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeasonSelect_vue__ = __webpack_require__(962);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeasonSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17eb686f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeasonSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppMultiselect__ = __webpack_require__(29);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SeasonSelect',
  components: {
    AppMultiselect: __WEBPACK_IMPORTED_MODULE_0__components_AppMultiselect__["a" /* default */]
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      default: 'Season Year'
    }
  },
  data: function data() {
    return {
      years: []
    };
  },
  computed: {
    options: function options() {
      return this.years.map(function (year) {
        return {
          label: year.name,
          value: year.id
        };
      });
    }
  },
  created: function created() {
    var today = this.$store.state.currentDate ? new Date(this.$store.state.currentDate) : new Date();
    var startYear = today.getMonth() < 1 ? today.getFullYear() - 1 : today.getFullYear();

    for (var Y = startYear; Y >= 2019; Y--) {
      this.years.push({
        id: Y,
        name: "".concat(Y, " / ").concat(Y + 1)
      });
    }

    this.$emit('input', startYear);
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZoneSelect_vue__ = __webpack_require__(384);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_268dd17c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZoneSelect_vue__ = __webpack_require__(963);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZoneSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_268dd17c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZoneSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppMultiselect__ = __webpack_require__(29);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ZoneSelect',
  components: {
    AppMultiselect: __WEBPACK_IMPORTED_MODULE_1__components_AppMultiselect__["a" /* default */]
  },
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      zones: []
    };
  },
  computed: {
    options: function options() {
      return [{
        label: '-- National --',
        value: 0
      }].concat(this.zones.map(function (zone) {
        return {
          label: zone.name,
          value: zone.id
        };
      }));
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/zone/list")).then(function (response) {
      if (response.data.status === 'success') {
        _this.zones = response.data.data;

        _this.$emit('loaded', _this.zones);
      }
    });
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_legacyBrowsers_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SeasonSelect__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ZoneSelect__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AppMultiselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_api_horses__ = __webpack_require__(86);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Report',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_legacyBrowsers_js__["a" /* default */]],
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_2__components_ListingLayout__["a" /* default */],
    SeasonSelect: __WEBPACK_IMPORTED_MODULE_4__components_SeasonSelect__["a" /* default */],
    ZoneSelect: __WEBPACK_IMPORTED_MODULE_5__components_ZoneSelect__["a" /* default */],
    AppMultiselect: __WEBPACK_IMPORTED_MODULE_6__components_AppMultiselect__["a" /* default */]
  },
  data: function data() {
    return {
      horse: null,
      horseOptions: [],
      horseSearchLoading: false,
      calendarFilter: {
        to_date: this.getHolderDate(),
        from_date: this.getHolderDate()
      },
      selectedZone: '',
      zone: 0,
      zones: [],
      zoneName: '',
      fileName: '',
      processing: false,
      error: '',
      report: '',
      year: '',
      years: [],
      userRole: localStorage.role
    };
  },
  created: function created() {
    this.debouncedSearchHorses = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(this.searchHorses, 500);
  },
  mounted: function mounted() {
    this.getYears();
  },
  watch: {
    zone: function zone(id) {
      var found = this.zones.find(function (z) {
        return z.id === id;
      });
      this.zoneName = found ? found.code : '';
    },
    report: function report() {
      this.error = '';
      this.horse = null;
      this.horseOptions = [];

      switch (this.report) {
        case 'results':
          break;

        case 'activemembers':
          this.fileName = 'registered-users-list';
          this.year = this.getYear();
          break;

        case 'mailinglist':
          this.fileName = 'mail-list';
          this.year = this.getYear();
          break;

        case 'secretary-financial-members':
          this.fileName = 'financial-members';
          this.year = this.getYear();
          break;

        case 'calendar-of-events':
          this.fileName = 'calendar-of-events';
          this.year = '';
          break;

        default:
          if (this.report) {
            this.fileName = this.report;
          }

          break;
      }
    }
  },
  computed: {
    listZones: function listZones() {
      return this.$store.state.listZones;
    },
    isAdmin: function isAdmin() {
      return this.userRole === 'Admin' || this.userRole === 'SuperAdmin';
    },
    canSubmit: function canSubmit() {
      if (!this.report) return false;
      if (this.report === 'horse-progress-report') return !!this.horse;
      return true;
    }
  },
  methods: {
    onHorseSearch: function onHorseSearch(query) {
      this.horseSearchLoading = true;
      this.debouncedSearchHorses(query);
    },
    searchHorses: function searchHorses(query) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_7__services_api_horses__["a" /* default */].search(query).then(function (response) {
        _this.horseOptions = response.data.data;
      }).catch(function () {
        _this.horseOptions = [];
      }).finally(function () {
        _this.horseSearchLoading = false;
      });
    },
    getYear: function getYear() {
      // Get year data
      var today = this.$store.state.currentDate ? new Date(this.$store.state.currentDate) : new Date();
      return today.getFullYear();
    },
    getYears: function getYears() {
      for (var Y = this.getYear(); Y >= 2019; Y--) {
        this.years.push({
          id: Y,
          name: "".concat(Y)
        });
      }
    },
    getHolderDate: function getHolderDate() {
      var d = this.$store.state.currentDate ? new Date(this.$store.state.currentDate) : new Date(); // 0 indexed for Jan so add 1 to get current

      var day = d.getDate();
      var dayString = "0".concat(day).slice(-2);
      var month = d.getMonth() + 1;
      var monthString = "0".concat(month).slice(-2);
      var year = d.getFullYear().toString(); // Return the start of the ACA year

      return [year, monthString, dayString].join('-');
    },
    runReport: function runReport() {
      event.preventDefault();

      switch (this.report) {
        case 'results':
          this.exportResults();
          break;

        case 'profiles':
          this.exportProfiles();
          break;

        case 'standings-points':
          this.exportStandingsPoints();
          break;

        case 'app-import':
          this.exportAppImport();
          break;

        case 'horse-progress-report':
          this.exportHorseProgressReport();
          break;

        case 'activemembers':
        case 'mailinglist':
        case 'secretary-financial-members':
        case 'calendar-of-events':
        default:
          this.exportList();
          break;
      }
    },
    exportResults: function exportResults() {
      var _this2 = this;

      this.processing = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/export/results?from_date=").concat(this.calendarFilter.from_date, "&to_date=").concat(this.calendarFilter.to_date)).then(function (response) {
        _this2.processing = false;

        if (window.navigator.msSaveOrOpenBlob) {
          var blobObject = new Blob([response.data]);
          window.navigator.msSaveOrOpenBlob(blobObject, "results.csv");
        } else if (_this2.isIOS()) {
          var reader = new FileReader();
          reader.fileName = "results.csv";
          var out = new Blob([response.data], {
            type: 'data:text/csv;charset=utf-8'
          });

          reader.onload = function () {
            window.location.href = reader.result;
          };

          reader.readAsDataURL(out);
        } else {
          var url = window.URL ? window.URL.createObjectURL(new Blob([response.data], {
            type: 'data:text/csv;charset=utf-8'
          })) : window.webkitURL.createObjectURL(new Blob([response.data], {
            type: 'data:text/csv;charset=utf-8'
          }));
          var link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', "results.csv");
          document.body.appendChild(link);
          link.click();
          setTimeout(function () {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 0);
        }
      }).catch(function (error) {
        _this2.processing = false; // eslint-disable-next-line

        console.log(error);

        _this2.$rollbar.error(error);
      });
    },
    exportList: function exportList() {
      var _this3 = this;

      this.processing = true;
      var params = '';

      if (this.report === 'calendar-of-events') {
        params += "?from_date=".concat(this.calendarFilter.from_date, "&to_date=").concat(this.calendarFilter.to_date); // For when they ask for zone filtering for calendar of events
        // params += this.selectedZone ? `&zone=${this.selectedZone}` : ''
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/export/").concat(this.report, "/").concat(this.year).concat(params)).then(function (response) {
        _this3.processing = false;

        if (window.navigator.msSaveOrOpenBlob) {
          var blobObject = new Blob([response.data]);
          window.navigator.msSaveOrOpenBlob(blobObject, "".concat(_this3.fileName, "-").concat(_this3.year, ".csv"));
        } else if (_this3.isIOS()) {
          var reader = new FileReader();
          reader.fileName = "".concat(_this3.fileName, ".csv");
          var out = new Blob([response.data], {
            type: 'data:text/csv;charset=utf-8'
          });

          reader.onload = function () {
            window.location.href = reader.result;
          };

          reader.readAsDataURL(out);
        } else {
          var url = window.URL ? window.URL.createObjectURL(new Blob([response.data], {
            type: 'data:text/csv;charset=utf-8'
          })) : window.webkitURL.createObjectURL(new Blob([response.data], {
            type: 'data:text/csv;charset=utf-8'
          }));
          var link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', "".concat(_this3.fileName, "-").concat(_this3.year, ".csv"));
          document.body.appendChild(link);
          link.click();
          setTimeout(function () {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 0);
        }
      }).catch(function (error) {
        _this3.processing = false; // eslint-disable-next-line

        console.log(error);
      });
    },
    exportStandingsPoints: function exportStandingsPoints() {
      var _this4 = this;

      this.processing = true;
      var url = this.zone ? "".concat(this.$api, "/admin/export/standings-points/").concat(this.year, "/").concat(this.zone) : "".concat(this.$api, "/admin/export/standings-points/").concat(this.year);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, {
        responseType: 'blob'
      }).then(function (response) {
        _this4.processing = false;
        var zonePart = _this4.zoneName ? "".concat(_this4.zoneName.slice(0, -1), " ZONE ") : 'NATIONAL ZONE ';
        var fileName = "".concat(zonePart).concat(_this4.year, " ").concat(_this4.year + 1, ".xlsx");
        var blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else if (_this4.isIOS()) {
          var reader = new FileReader();

          reader.onload = function () {
            window.location.href = reader.result;
          };

          reader.readAsDataURL(blob);
        } else {
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          setTimeout(function () {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          }, 0);
        }
      }).catch(function (error) {
        _this4.processing = false;
        console.log(error);

        _this4.$rollbar.error(error);
      });
    },
    exportAppImport: function exportAppImport() {
      var _this5 = this;

      this.processing = true;
      this.error = '';
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/export/app-import")).then(function (response) {
        _this5.processing = false;

        if (response.data && response.data.status === 'undefined_error') {
          _this5.error = 'A server error occurred. Please try again later.';
          return;
        }

        if (window.navigator.msSaveOrOpenBlob) {
          var blobObject = new Blob([response.data]);
          window.navigator.msSaveOrOpenBlob(blobObject, "app-import.csv");
        } else if (_this5.isIOS()) {
          var reader = new FileReader();
          reader.fileName = "app-import.csv";
          var out = new Blob([response.data], {
            type: 'data:text/csv;charset=utf-8'
          });

          reader.onload = function () {
            window.location.href = reader.result;
          };

          reader.readAsDataURL(out);
        } else {
          var url = window.URL ? window.URL.createObjectURL(new Blob([response.data], {
            type: 'data:text/csv;charset=utf-8'
          })) : window.webkitURL.createObjectURL(new Blob([response.data], {
            type: 'data:text/csv;charset=utf-8'
          }));
          var link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', "app-import.csv");
          document.body.appendChild(link);
          link.click();
          setTimeout(function () {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 0);
        }
      }).catch(function (error) {
        _this5.processing = false;
        console.log(error);

        _this5.$rollbar.error(error);
      });
    },
    exportProfiles: function exportProfiles() {
      var _this6 = this;

      this.processing = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/export/profiles")).then(function (response) {
        _this6.processing = false;

        if (window.navigator.msSaveOrOpenBlob) {
          var blobObject = new Blob([response.data]);
          window.navigator.msSaveOrOpenBlob(blobObject, "profiles-report.csv");
        } else if (_this6.isIOS()) {
          var reader = new FileReader();
          reader.fileName = "profiles-report.csv";
          var out = new Blob([response.data], {
            type: 'data:text/csv;charset=utf-8'
          });

          reader.onload = function () {
            window.location.href = reader.result;
          };

          reader.readAsDataURL(out);
        } else {
          var url = window.URL ? window.URL.createObjectURL(new Blob([response.data], {
            type: 'data:text/csv;charset=utf-8'
          })) : window.webkitURL.createObjectURL(new Blob([response.data], {
            type: 'data:text/csv;charset=utf-8'
          }));
          var link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', "profiles-report.csv");
          document.body.appendChild(link);
          link.click();
          setTimeout(function () {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 0);
        }
      }).catch(function (error) {
        _this6.processing = false;
        console.log(error);

        _this6.$rollbar.error(error);
      });
    },
    exportHorseProgressReport: function exportHorseProgressReport() {
      var _this7 = this;

      if (!this.horse) return;
      this.processing = true;
      var horseName = this.horse.name.replace(/[^A-Za-z0-9]+/g, '-');
      var fileName = "horse-progress-report-".concat(horseName, ".csv");
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/export/horse-progress-report?horse_id=").concat(this.horse.id)).then(function (response) {
        _this7.processing = false;

        if (window.navigator.msSaveOrOpenBlob) {
          var blobObject = new Blob([response.data]);
          window.navigator.msSaveOrOpenBlob(blobObject, fileName);
        } else if (_this7.isIOS()) {
          var reader = new FileReader();
          reader.fileName = fileName;
          var out = new Blob([response.data], {
            type: 'data:text/csv;charset=utf-8'
          });

          reader.onload = function () {
            window.location.href = reader.result;
          };

          reader.readAsDataURL(out);
        } else {
          var url = window.URL ? window.URL.createObjectURL(new Blob([response.data], {
            type: 'data:text/csv;charset=utf-8'
          })) : window.webkitURL.createObjectURL(new Blob([response.data], {
            type: 'data:text/csv;charset=utf-8'
          }));
          var link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          setTimeout(function () {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 0);
        }
      }).catch(function (error) {
        _this7.processing = false;
        console.log(error);

        _this7.$rollbar.error(error);
      });
    }
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Auth",
  mounted: function mounted() {
    this.getToken();
  },
  methods: {
    getToken: function getToken() {
      var _this = this;

      var token = localStorage.getItem('bearer');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/auth/accessToken"), {
        headers: {
          Authorization: "Bearer ".concat(token)
        }
      }).then(function (response) {
        window.location.href = "".concat(_this.$coy, "/users/login/").concat(response.data.accessToken);
      });
    }
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NotFound'
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_memberProfileStore_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DownloadBlankAlert__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_JudgeApplicationForm__ = __webpack_require__(976);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'JudgeApplication',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__store_memberProfileStore_js__["a" /* default */]],
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__["a" /* default */],
    'download-blank': __WEBPACK_IMPORTED_MODULE_2__components_DownloadBlankAlert__["a" /* default */],
    'application-form': __WEBPACK_IMPORTED_MODULE_3__components_JudgeApplicationForm__["a" /* default */]
  },
  data: function data() {
    return {
      userID: localStorage.userID,
      userRole: localStorage.role
    };
  },
  mounted: function mounted() {
    if (!this.checkHasFinancialMembers) {
      this.$router.push({
        name: 'Dashboard'
      });
    }
  },
  methods: {
    checkHasFinancialMembers: function checkHasFinancialMembers() {
      return !!this.memberDetails.secondaries.find(function (member) {
        return member.financial;
      }) || this.memberDetails.financial;
    }
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "DownloadBlankFormAlert",
  methods: {
    openDocument: function openDocument() {
      if (this.$route.params.member_id) {
        window.open("".concat(this.$openApplicationFilePath), '_blank');
      } else {
        window.open("".concat(this.$trialApplicationFilePath), '_blank');
      }
    }
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Judges_constants_js__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormFields_PhoneInput__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TestPhoneNumbers__ = __webpack_require__(68);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TestPhoneNumbers: __WEBPACK_IMPORTED_MODULE_3__components_TestPhoneNumbers__["a" /* default */],
    PhoneInput: __WEBPACK_IMPORTED_MODULE_2__components_FormFields_PhoneInput__["a" /* default */]
  },
  name: "JudgeApplicationForm",
  props: ['memberDetails'],
  data: function data() {
    return {
      user_id: this.$route.params.member_id ? this.$route.params.member_id : null,
      file: '',
      file_name: null,
      additional_email: null,
      additional_phone: null,
      is_call_first: false,
      type: null,
      status: null,
      errors: [],
      applicationTypes: __WEBPACK_IMPORTED_MODULE_1__views_Judges_constants_js__["a" /* applicationTypes */]
    };
  },
  computed: {
    membersSelect: function membersSelect() {
      var _this = this;

      var secondaries = this.memberDetails.secondaries.map(function (secondary) {
        return {
          id: secondary.id,
          name: "".concat(secondary.first_name, " ").concat(secondary.last_name),
          phoneNumber: secondary.secondary_phone || '',
          zoneCode: _this.memberDetails.attributes && _this.memberDetails.attributes.zone ? _this.memberDetails.attributes.zone.code : '',
          suburb: _this.memberDetails.attributes && _this.memberDetails.attributes.address.suburb ? _this.memberDetails.attributes.address.suburb : '',
          isFinancial: secondary.financial && !secondary.has_event_membership || false
        };
      });
      return [{
        id: this.memberDetails.id,
        name: "".concat(this.memberDetails.first_name, " ").concat(this.memberDetails.last_name),
        phoneNumber: this.memberDetails.attributes.phone || '',
        zoneCode: this.memberDetails.attributes && this.memberDetails.attributes.zone ? this.memberDetails.attributes.zone.code : '',
        suburb: this.memberDetails.attributes && this.memberDetails.attributes.address.suburb ? this.memberDetails.attributes.address.suburb : '',
        isFinancial: this.memberDetails.financial && !this.memberDetails.has_event_membership || false
      }].concat(_toConsumableArray(secondaries));
    },
    judgeStatusesSelect: function judgeStatusesSelect() {
      return [{
        id: 0,
        title: __WEBPACK_IMPORTED_MODULE_1__views_Judges_constants_js__["a" /* applicationTypes */].TRIAL_TYPE
      }, {
        id: 1,
        title: __WEBPACK_IMPORTED_MODULE_1__views_Judges_constants_js__["a" /* applicationTypes */].OPEN_TYPE
      }];
    },
    selectedMemberData: function selectedMemberData() {
      var _this2 = this;

      if (this.user_id) return this.membersSelect.find(function (member) {
        return member.id === Number(_this2.user_id);
      });
      return '';
    }
  },
  methods: {
    fileUpload: function fileUpload(event) {
      this.removeError('file');
      var uploadedFile = event.target.files[0];
      this.file = uploadedFile;

      if (uploadedFile) {
        this.file_name = uploadedFile.name;
      }
    },
    deleteAttachment: function deleteAttachment() {
      this.removeError('file');
      delete this.file;
      this.file = undefined;
      this.file_name = '';
    },
    putErrors: function putErrors(errorField, errorMessage) {
      if (!this.errors.find(function (error) {
        return error[errorField];
      })) this.errors.push(_defineProperty({}, errorField, errorMessage));
    },
    removeError: function removeError(errorField) {
      this.errors = this.errors.filter(function (error) {
        return !error[errorField];
      });
    },
    resetErrors: function resetErrors() {
      this.errors = [];
    },
    checkForm: function checkForm() {
      this.errors = [];
      if (!this.user_id) this.putErrors('member', 'Member is required.');
      if (this.user_id) this.checkIsFinancial();
      if (!this.file) this.putErrors('file', 'File is required.');
      if (this.file && this.file.size > 1024 * 1024) this.putErrors('file', 'File may not be greater than 1 mb.');
    },
    checkIsFinancial: function checkIsFinancial() {
      var _this3 = this;

      var current = this.membersSelect.find(function (member) {
        return member.id === Number(_this3.user_id);
      });
      if (!current.isFinancial) this.putErrors('member', 'Please pay ACA membership to apply for a Judge position.');
    },
    create: function create() {
      var _this4 = this;

      this.checkForm();

      if (this.errors.length === 0) {
        this.processing = true;
        var data = {
          user_id: this.user_id,
          file_name: this.file_name,
          additional_email: this.additional_email,
          additional_phone: this.additional_phone,
          is_call_first: this.is_call_first,
          type: this.$route.params.member_id ? __WEBPACK_IMPORTED_MODULE_1__views_Judges_constants_js__["a" /* applicationTypes */].OPEN_TYPE : __WEBPACK_IMPORTED_MODULE_1__views_Judges_constants_js__["a" /* applicationTypes */].TRIAL_TYPE
        };
        var formData = new FormData();
        formData.append('file', this.file);
        formData.append('fields', JSON.stringify(data));
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/judges/application"), formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function (response) {
          _this4.processing = false;

          if (response.data.status === 'success') {
            _this4.$router.push({
              name: 'Judges Dashboard',
              params: {
                success: 'Thanks for your application! Your application will be considered at the next ACA Management Committee meeting and you will be advised on the outcome within five (5) business days.'
              }
            });
          } else if (response.data.status === 'application_exists') {
            _this4.putErrors('common', 'Application already exists.');
          } else if (response.data.status === 'undefined_error') {
            _this4.putErrors('common', 'Something went wrong.');
          } else if (response.data.status === 'forbidden') {
            _this4.putErrors('common', 'This type of application is not available for this user');
          } else if (response.data.status === 'validation_error') {
            if (response.data.errors && response.data.errors.user_id) _this4.putErrors('member', 'Member is required.');
            if (response.data.errors && response.data.errors.additional_email) _this4.putErrors('email', 'The additional email must be a valid email address.');
            if (response.data.errors && response.data.errors.additional_phone) _this4.putErrors('phone', 'Please enter valid mobile number.');
            if (response.data.errors && response.data.errors.user_id) _this4.putErrors('member', 'Member is required.');
          } else if (response.data.status === 'judge_is_suspended' && response.data.errors) {
            _this4.putErrors('common', 'The judge is suspended');
          } else {
            _this4.success = '';
          }
        }).catch(function () {
          _this4.success = '';

          _this4.putErrors('common', 'Something went wrong.');

          _this4.processing = false;
        });
      }
    }
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_PdfIcon__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ListAppsTable__ = __webpack_require__(983);
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminJudgeAppsList',
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__["a" /* default */],
    'data-table': __WEBPACK_IMPORTED_MODULE_1__components_DataTable__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */],
    tablePdfIconTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_PdfIcon__["a" /* default */],
    listAppsTable: __WEBPACK_IMPORTED_MODULE_4__components_ListAppsTable__["a" /* default */]
  },
  data: function data() {
    return {
      error: '',
      success: localStorage.getItem("judge-app-status")
    };
  },
  mounted: function mounted() {
    localStorage.removeItem("judge-app-status");
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PdfIcon_vue__ = __webpack_require__(393);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16de5c83_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PdfIcon_vue__ = __webpack_require__(982);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PdfIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16de5c83_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PdfIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Download',
  props: ['row'],
  methods: {
    downloadFile: function downloadFile(id) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/judges-app-download/").concat(id)).then(function (response) {
        window.open(response.data.path, '_blank');
      });
    }
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_PdfIcon__ = __webpack_require__(392);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'listAppsTable',
  components: {
    'data-table': __WEBPACK_IMPORTED_MODULE_1__components_DataTable__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */],
    tablePdfIconTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_PdfIcon__["a" /* default */]
  },
  data: function data() {
    return {
      error: '',
      success: '',
      rows: [],
      columns: [{
        label: 'First Name',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.first_name\" :link=\"'Member Profile'\" :slug=\"row.id\" :row=\"row\" :options=\"{ showLinks: true }\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.first_name);
        }
      }, {
        label: 'Last Name',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.last_name\" :link=\"'Member Profile'\" :slug=\"row.id\" :row=\"row\" :options=\"{ showLinks: true, showActive: true }\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.last_name);
        }
      }, {
        label: 'Judge Application',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tablePdfIconTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_PdfIcon__["a" /* default */]
          },
          template: "<tablePdfIconTemplate :row=\"row\" />"
        }
      }, {
        label: 'Phone number',
        field: 'judge_phone',
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate\n              :text=\"row.judge_phone === null || row.judge_phone === '' ? row.mobile_phone === null ? row.phone === null ?\n                row.secondary_phone : row.phone : row.mobile_phone : row.judge_phone\"\n              :row=\"row\" />"
        }
      }, {
        label: 'Suburb',
        field: 'suburb',
        filterable: false,
        sortable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.suburb\" :row=\"row\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.suburb);
        }
      }, {
        label: 'Zone',
        field: 'zone_id',
        filterable: false,
        sortable: true,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"rowZone(row.zone_id)\" :row=\"row\" />",
          methods: {
            rowZone: function rowZone(theID) {
              return this.$store.state.listZones.filter(function (zone) {
                return zone.id === theID;
              }).length ? this.$store.state.listZones.find(function (zone) {
                return zone.id === theID;
              }).code : 'Unspecified';
            }
          }
        }
      }, {
        label: 'Judge Status',
        field: 'type',
        filterable: false,
        sortable: true,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_2__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.type.charAt(0).toUpperCase() + row.type.substring(1)\" :row=\"row\" />"
        }
      }, {
        label: 'Approve',
        field: '',
        align: 'left',
        sortable: false,
        filterable: false,
        headerClass: 'd-none d-lg-table-cell column-lg-small',
        visible: true,
        component: {
          props: ['row'],
          template: "\n              <button :class=\"['btn btn-sm mb-2 mb-lg-0 px-lg-3 px-xl-4', processing ? 'btn-primary-dark' : 'btn-primary']\" @click.prevent=\"approve(row.judge_app_id)\">\n                {{ !processing ? 'Approve' : '' }}\n                  <div v-if=\"processing\" class=\"spinner-border text-light\" role=\"status\"><span class=\"sr-only\">Loading...</span></div>\n              </button>",
          data: function data() {
            return {
              processing: false
            };
          },
          methods: {
            approve: function approve(id) {
              var _this = this;

              this.processing = true;
              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/judges-approve"), {
                id: id
              }).then(function (response) {
                _this.processing = false;
                localStorage.setItem("judge-app-status", response.data.message);
                location.reload();
              }).catch(function (error) {
                _this.status = 'undefined_error'; // eslint-disable-next-line

                console.log(error);
              });
            }
          }
        }
      }, {
        label: 'Deny',
        field: '',
        align: 'left',
        sortable: false,
        filterable: false,
        headerClass: 'd-none d-lg-table-cell column-lg-small',
        visible: true,
        component: {
          props: ['row'],
          template: "\n              <button :class=\"['btn btn-sm mb-2 mb-lg-0 px-lg-3 px-xl-4', processing ? 'btn-primary-dark' : 'btn-primary']\" @click.prevent=\"deny(row.judge_app_id)\">\n                {{ !processing ? 'Deny' : '' }}\n                  <div v-if=\"processing\" class=\"spinner-border text-light\" role=\"status\"><span class=\"sr-only\">Loading...</span></div>\n              </button>",
          data: function data() {
            return {
              processing: false
            };
          },
          methods: {
            deny: function deny(id) {
              var _this2 = this;

              this.processing = true;
              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/judges-deny"), {
                id: id
              }).then(function (response) {
                _this2.processing = false;
                localStorage.setItem("judge-app-status", response.data.message);
                location.reload();
              }).catch(function (error) {
                _this2.status = 'undefined_error'; // eslint-disable-next-line

                console.log(error);
              });
            }
          }
        }
      }],
      options: {
        // filter: {
        //   status: [
        //     { name: 'All', value: 'all' },
        //     { name: 'Active', value: 1 },
        //     { name: 'Suspended', value: 0 }
        //   ]
        // },
        // activeFilter: {
        //   status: 'all'
        // },
        search: true,
        loaded: false
      },
      processing: false
    };
  },
  computed: {
    listZones: function listZones() {
      return this.$store.state.listZones;
    }
  },
  watch: {
    listZones: function listZones() {
      var _this3 = this;

      if (this.listZones.length > 0) {
        this.rows.map(function (item) {
          var tempItem = item;
          tempItem.zone_name = _this3.listZones.filter(function (zone) {
            return zone.id === tempItem.zone_id;
          }).length > 0 ? _this3.listZones.filter(function (zone) {
            return zone.id === tempItem.zone_id;
          })[0].code : 'Unspecified';
          return tempItem;
        });
      }
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.$store.commit('deselectAllRows');
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/judges-apps-list")).then(function (response) {
      if (response.data.status === 'success') {
        _this4.error = '';
        var theRows = response.data.data;

        if (_this4.listZones.length > 0) {
          theRows.map(function (item) {
            var tempItem = item;
            tempItem.zone_name = _this4.listZones.filter(function (zone) {
              return zone.id === tempItem.zone_id;
            }).length > 0 ? _this4.listZones.filter(function (zone) {
              return zone.id === tempItem.zone_id;
            })[0].code : 'Unspecified';
            return tempItem;
          });
        }

        _this4.rows = theRows;
        _this4.options.loaded = true;
      } else {
        _this4.error = 'Unable to receive data from the server. Please reload the page.';
      }
    });
  },
  methods: {
    rowZone: function rowZone(theID) {
      return this.$store.state.listZones.filter(function (zone) {
        return zone.id === theID;
      }).length ? this.$store.state.listZones.find(function (zone) {
        return zone.id === theID;
      }).code : 'Unspecified';
    },
    approve: function approve(id) {
      var _this5 = this;

      this.processing = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/judges-approve"), {
        id: id
      }).then(function (response) {
        _this5.processing = false;
        localStorage.setItem("judge-app-status", response.data.message);
        location.reload();
      }).catch(function (error) {
        _this5.status = 'undefined_error'; // eslint-disable-next-line

        console.log(error);
      });
    },
    deny: function deny(id) {
      var _this6 = this;

      this.processing = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/judges-deny"), {
        id: id
      }).then(function (response) {
        _this6.processing = false;
        localStorage.setItem("judge-app-status", response.data.message);
        location.reload();
      }).catch(function (error) {
        _this6.status = 'undefined_error'; // eslint-disable-next-line

        console.log(error);
      });
    }
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_memberProfileStore_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_legacyBrowsers_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'JudgeAdminDashboard',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__store_memberProfileStore_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_legacyBrowsers_js__["a" /* default */]],
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_2__components_ListingLayout__["a" /* default */]
  },
  data: function data() {
    return {
      userID: localStorage.userID,
      userRole: localStorage.role,
      drafts: [],
      loaded: false,
      processing: false
    };
  },
  mounted: function mounted() {
    this.loadDrafts();
  },
  methods: {
    loadDrafts: function loadDrafts() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("".concat(this.$api, "/judges/surveys/drafts")).then(function (response) {
        if (response.data.status === 'success') {
          _this.error = '';
          _this.drafts = response.data.data;
          _this.loaded = true;
        } else {
          _this.error = 'Unable to receive data from the server. Please reload the page.';
        }
      });
    },
    downloadPdf: function downloadPdf(draftId) {
      var _this2 = this;

      this.processing = true;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("".concat(this.$api, "/judges/surveys/reports/").concat(draftId, "/pdf"), {
        Accept: 'application/pdf',
        responseType: 'arraybuffer'
      }).then(function (response) {
        _this2.processing = false;
        var newBlob = new Blob([response.data], {
          type: 'application/pdf'
        });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }

        var data = window.URL.createObjectURL(newBlob);
        var link = document.createElement('a');
        link.href = data;
        link.download = 'survey_reports.pdf';
        link.click();
        link.remove();
        setTimeout(function () {
          window.URL.revokeObjectURL(data);
        }, 100);
      });
    },
    downloadCsv: function downloadCsv(draftId) {
      var _this3 = this;

      this.processing = true;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("".concat(this.$api, "/judges/surveys/reports/").concat(draftId, "/csv"), {
        responseType: 'blob'
      }).then(function (response) {
        _this3.processing = false;

        if (window.navigator.msSaveOrOpenBlob) {
          var blobObject = new Blob([response.data]);
          window.navigator.msSaveOrOpenBlob(blobObject, "survey_report.csv");
        } else if (_this3.isIOS()) {
          var reader = new FileReader();
          reader.fileName = "survey_report.csv";
          var out = new Blob([response.data], {
            type: 'data:text/csv;charset=utf-8'
          });

          reader.onload = function () {
            window.location.href = reader.result;
          };

          reader.readAsDataURL(out);
        } else {
          var url = window.URL ? window.URL.createObjectURL(new Blob([response.data], {
            type: 'data:text/csv;charset=utf-8'
          })) : window.webkitURL.createObjectURL(new Blob([response.data], {
            type: 'data:text/csv;charset=utf-8'
          }));
          var link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', "survey_report.csv");
          document.body.appendChild(link);
          link.click();
          setTimeout(function () {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 0);
        }
      });
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Button__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_EventBus_js__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */


 // import tableButtonTemplate from '@/components/DataTableFields/Button'





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Members',
  props: ['success'],
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__["a" /* default */],
    'data-table': __WEBPACK_IMPORTED_MODULE_2__components_DataTable__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_5__components_Modal__["a" /* default */]
  },
  data: function data() {
    return {
      error: '',
      rows: [],
      columns: [{
        label: 'First Name',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.first_name\" :link=\"'Member Profile'\" :slug=\"row.id\" :row=\"row\" :options=\"{ showLinks: true }\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.first_name);
        }
      }, {
        label: 'Last Name',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.last_name\" :link=\"'Member Profile'\" :slug=\"row.id\" :row=\"row\" :options=\"{ showLinks: true, showActive: true }\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.last_name);
        }
      }, {
        label: 'Phone number',
        field: 'judge_phone',
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate\n              :text=\"row.judge_phone === null ? row.mobile_phone === null ? row.phone === null ? row.secondary_phone : row.phone : row.mobile_phone : row.judge_phone\"\n              :row=\"row\" />"
        }
      }, {
        label: 'Suburb',
        field: 'suburb',
        filterable: false,
        sortable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.suburb\" :row=\"row\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.suburb);
        }
      }, {
        label: 'Zone',
        field: 'zone_id',
        filterable: false,
        sortable: true,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"rowZone(row.zone_id)\" :row=\"row\" />",
          methods: {
            rowZone: function rowZone(theID) {
              return this.$store.state.listZones.filter(function (zone) {
                return zone.id === theID;
              }).length ? this.$store.state.listZones.find(function (zone) {
                return zone.id === theID;
              }).code : 'Unspecified';
            }
          }
        }
      }, {
        label: 'Judge Status',
        field: 'status',
        filterable: false,
        sortable: true,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.status.charAt(0).toUpperCase() + row.status.substring(1)\" :row=\"row\" />"
        }
      }, {
        label: 'Actions',
        field: '',
        align: 'left',
        sortable: false,
        filterable: false,
        headerClass: 'd-none d-lg-table-cell column-lg-medium',
        visible: true,
        component: {
          props: ['row'],
          components: {
            modal: __WEBPACK_IMPORTED_MODULE_5__components_Modal__["a" /* default */],
            tableButtonTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Button__["a" /* default */]
          },
          data: function data() {
            return {
              showModal: false,
              showSuspendModal: false,
              showEndSuspensionModal: false,
              processing: false
            };
          },
          methods: {
            removeModal: function removeModal() {
              this.showModal = true;
            },
            suspendModal: function suspendModal() {
              this.showSuspendModal = true;
            },
            endSuspensionModal: function endSuspensionModal() {
              this.showEndSuspensionModal = true;
            },
            remove: function remove(id) {
              var _this = this;

              this.processing = true;
              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/judge-delete/").concat(id)).then(function (response) {
                _this.processing = false;

                if (response.data.status === 'success') {
                  __WEBPACK_IMPORTED_MODULE_6__store_EventBus_js__["a" /* default */].$emit('removed');
                }
              }).catch(function (error) {
                console.log(error);
                _this.error = 'Unable to receive data from the server. Please reload the page.';
              });
            },
            suspend: function suspend(id) {
              var _this2 = this;

              this.processing = true;
              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/judges/").concat(id, "/suspend")).then(function (response) {
                _this2.processing = false;

                if (response.data.status === 'success') {
                  __WEBPACK_IMPORTED_MODULE_6__store_EventBus_js__["a" /* default */].$emit('suspended');
                } else {
                  _this2.error = 'Something went wrong. Please try again later.';
                }
              }).catch(function (error) {
                console.log(error);
                _this2.error = 'Unable to receive data from the server. Please reload the page.';
              });
            },
            endSuspension: function endSuspension(id) {
              var _this3 = this;

              this.processing = true;
              __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/judges/").concat(id, "/end-suspension")).then(function (response) {
                _this3.processing = false;

                if (response.data.status === 'success') {
                  __WEBPACK_IMPORTED_MODULE_6__store_EventBus_js__["a" /* default */].$emit('end-suspension');
                } else {
                  _this3.error = 'Something went wrong. Please try again later.';
                }
              }).catch(function (error) {
                console.log(error);
                _this3.error = 'Unable to receive data from the server. Please reload the page.';
              });
            }
          },
          template: "\n              <div class=\"judges-list__actions\">\n                <div class=\"mr-1\" v-if=\"!row.is_suspended\">\n                  <button :class=\"['btn btn-sm mb-2 mb-lg-0', !processing ? 'btn-primary actions-suspend' : 'btn-primary-dark']\" @click.prevent=\"suspendModal\">\n                    {{ !processing ? 'Suspend' : '' }}\n                    <div v-if=\"processing\" class=\"spinner-border text-light\" role=\"status\"><span class=\"sr-only\">Loading...</span></div>\n                  </button>\n                  <modal v-if=\"showSuspendModal\" @close=\"showSuspendModal = false\">\n                    <div slot=\"body\">\n                      <div class=\"alert alert-warning text-center\">\n                        You are about to suspend the judge {{row.first_name}}.\n                        Are you sure?\n                      </div>\n                      <div class=\"d-flex justify-content-center\">\n                        <button class=\"btn btn-outline-primary\" @click.prevent=\"showSuspendModal = false\">Cancel</button>\n                        <button class=\"btn btn-primary ml-2\" @click.prevent=\"suspend(row.id);showSuspendModal = false\">Confirm</button>\n                      </div>\n                    </div>\n                  </modal>\n                </div>\n                <div class=\"mr-1\" v-else>\n                  <button :class=\"['btn btn-sm mb-2 mb-lg-0', !processing ? 'btn-outline-primary actions-end_suspension' : 'btn-primary-dark']\" @click.prevent=\"endSuspensionModal\">\n                    {{ !processing ? 'End Suspension' : '' }}\n                    <div v-if=\"processing\" class=\"spinner-border text-light\" role=\"status\"><span class=\"sr-only\">Loading...</span></div>\n                  </button>\n                  <modal v-if=\"showEndSuspensionModal\" @close=\"showEndSuspensionModal = false\">\n                    <div slot=\"body\">\n                      <div class=\"alert alert-warning text-center\">\n                        You are about to end suspension the judge {{row.first_name}}.\n                        Are you sure?\n                      </div>\n                      <div class=\"d-flex justify-content-center\">\n                        <button class=\"btn btn-outline-primary\" @click.prevent=\"showEndSuspensionModal = false\">Cancel</button>\n                        <button class=\"btn btn-primary ml-2\" @click.prevent=\"endSuspension(row.id);showEndSuspensionModal = false\">Confirm</button>\n                      </div>\n                    </div>\n                  </modal>\n                </div>\n                <div>\n                  <button :class=\"['btn btn-sm mb-2 mb-lg-0 actions-remove', !processing ? row.is_suspend ? 'btn-primary actions-end_suspension' : 'btn-primary' : 'btn-primary-dark']\" @click.prevent=\"removeModal\">\n                    {{ !processing ? 'Remove' : '' }}\n                    <div v-if=\"processing\" class=\"spinner-border text-light\" role=\"status\"><span class=\"sr-only\">Loading...</span></div>\n                  </button>\n                  <modal v-if=\"showModal\" @close=\"showModal = false\">\n                    <div slot=\"body\">\n                      <div class=\"alert alert-warning text-center\">\n                        You are about to remove the judge {{row.first_name}}.\n                        Are you sure?\n                      </div>\n                      <div class=\"d-flex justify-content-center\">\n                        <button class=\"btn btn-outline-primary\" @click.prevent=\"showModal = false\">Cancel</button>\n                        <button class=\"btn btn-primary ml-2\" @click.prevent=\"remove(row.id);showModal = false\">Confirm</button>\n                      </div>\n                    </div>\n                  </modal>\n                </div>\n              </div>"
        }
      }],
      options: {
        search: true,
        loaded: false,
        filter: {
          is_suspended: [{
            name: 'All',
            value: 'all'
          }, {
            name: 'Active',
            value: 0
          }, {
            name: 'Suspended',
            value: 1
          }]
        },
        activeFilter: {
          is_suspended: 'all',
          membership_status: 'all'
        }
      },
      showModal: false,
      showSuspendModal: false,
      showEndSuspensionModal: false,
      processing: false
    };
  },
  computed: {
    listZones: function listZones() {
      return this.$store.state.listZones;
    }
  },
  watch: {
    listZones: function listZones() {
      var _this4 = this;

      if (this.listZones.length > 0) {
        this.rows.map(function (item) {
          var tempItem = item;
          tempItem.zone_name = _this4.listZones.filter(function (zone) {
            return zone.id === tempItem.zone_id;
          }).length > 0 ? _this4.listZones.filter(function (zone) {
            return zone.id === tempItem.zone_id;
          })[0].code : 'Unspecified';
          return tempItem;
        });
      }
    }
  },
  mounted: function mounted() {
    this.$store.commit('deselectAllRows');
    this.getJudgesList();
  },
  methods: {
    rowZone: function rowZone(theID) {
      return this.$store.state.listZones.filter(function (zone) {
        return zone.id === theID;
      }).length ? this.$store.state.listZones.find(function (zone) {
        return zone.id === theID;
      }).code : 'Unspecified';
    },
    getJudgesList: function getJudgesList() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/judges-list")).then(function (response) {
        if (response.data.status === 'success') {
          _this5.error = '';
          var theRows = response.data.data;

          if (_this5.listZones.length > 0) {
            theRows.map(function (item) {
              var tempItem = item;
              tempItem.zone_name = _this5.listZones.filter(function (zone) {
                return zone.id === tempItem.zone_id;
              }).length > 0 ? _this5.listZones.filter(function (zone) {
                return zone.id === tempItem.zone_id;
              })[0].code : 'Unspecified';
              return tempItem;
            });
          }

          _this5.rows = theRows;
          _this5.options.loaded = true;
        } else {
          _this5.error = 'Unable to receive data from the server. Please reload the page.';
        }
      });
    },
    removeModal: function removeModal() {
      this.showModal = true;
    },
    suspendModal: function suspendModal() {
      this.showSuspendModal = true;
    },
    endSuspensionModal: function endSuspensionModal() {
      this.showEndSuspensionModal = true;
    },
    remove: function remove(id) {
      var _this6 = this;

      this.processing = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/judge-delete/").concat(id)).then(function (response) {
        _this6.processing = false;

        if (response.data.status === 'success') {
          __WEBPACK_IMPORTED_MODULE_6__store_EventBus_js__["a" /* default */].$emit('removed');
        }
      }).catch(function (error) {
        console.log(error);
        _this6.error = 'Unable to receive data from the server. Please reload the page.';
      });
    },
    suspend: function suspend(id) {
      var _this7 = this;

      this.processing = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/judges/").concat(id, "/suspend")).then(function (response) {
        _this7.processing = false;

        if (response.data.status === 'success') {
          __WEBPACK_IMPORTED_MODULE_6__store_EventBus_js__["a" /* default */].$emit('suspended');
        } else {
          _this7.error = 'Something went wrong. Please try again later.';
        }
      }).catch(function (error) {
        console.log(error);
        _this7.error = 'Unable to receive data from the server. Please reload the page.';
      });
    },
    endSuspension: function endSuspension(id) {
      var _this8 = this;

      this.processing = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/judges/").concat(id, "/end-suspension")).then(function (response) {
        _this8.processing = false;

        if (response.data.status === 'success') {
          __WEBPACK_IMPORTED_MODULE_6__store_EventBus_js__["a" /* default */].$emit('end-suspension');
        } else {
          _this8.error = 'Something went wrong. Please try again later.';
        }
      }).catch(function (error) {
        console.log(error);
        _this8.error = 'Unable to receive data from the server. Please reload the page.';
      });
    }
  },
  created: function created() {
    var _this9 = this;

    __WEBPACK_IMPORTED_MODULE_6__store_EventBus_js__["a" /* default */].$on('removed', function () {
      _this9.options.loaded = false;
      _this9.rows = [];
      _this9.success = 'The judge has been removed.';

      _this9.getJudgesList();
    });
  },
  updated: function updated() {
    var _this10 = this;

    __WEBPACK_IMPORTED_MODULE_6__store_EventBus_js__["a" /* default */].$on('suspended', function () {
      _this10.options.loaded = false;
      _this10.rows = [];
      _this10.success = 'The judge has been suspended.';

      _this10.getJudgesList();
    });
    __WEBPACK_IMPORTED_MODULE_6__store_EventBus_js__["a" /* default */].$on('end-suspension', function () {
      _this10.options.loaded = false;
      _this10.rows = [];
      _this10.success = 'The judge has been restored.';

      _this10.getJudgesList();
    });
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PublicLayout__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Judges',
  components: {
    'public-layout': __WEBPACK_IMPORTED_MODULE_1__components_PublicLayout__["a" /* default */],
    'data-table': __WEBPACK_IMPORTED_MODULE_2__components_DataTable__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
  },
  data: function data() {
    return {
      error: '',
      rows: [],
      entireJudges: [],
      callFirstJudges: [],
      columns: [{
        label: 'First Name',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.first_name\" :slug=\"row.id\" :row=\"row\"/>"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.first_name);
        }
      }, {
        label: 'Last Name',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.last_name\" :slug=\"row.id\" :row=\"row\"/>"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.last_name);
        }
      }, {
        label: 'Status',
        field: 'status',
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.status.charAt(0).toUpperCase() + row.status.substring(1)\" :row=\"row\"/>"
        },
        representedAs: 'status'
      }, {
        label: 'Contact',
        field: 'phone',
        filterable: false,
        sortable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.phone\" :row=\"row\" :mobile=\"row.phone\" :options=\"{ isMobile: true }\" />"
        },
        representedAs: 'phone'
      }, {
        label: 'Suburb',
        field: 'suburb',
        filterable: false,
        sortable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.suburb\" :row=\"row\"/>"
        },
        representedAs: 'suburb'
      }, {
        label: 'Zone',
        field: 'zone_id',
        filterable: false,
        sortable: true,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate class=\"js-parity\" :data-parity=\"row.parity\" :text=\"rowZone(row.zone_id)\" :row=\"row\" />",
          methods: {
            rowZone: function rowZone(theID) {
              return this.$store.state.listZones.filter(function (zone) {
                return zone.id === theID;
              }).length ? this.$store.state.listZones.find(function (zone) {
                return zone.id === theID;
              }).code : 'Unspecified';
            }
          }
        }
      }],
      options: {
        filter: {},
        activeFilter: {},
        search: true,
        loaded: false,
        groupByZone: true,
        searchOnAllTables: true
      }
    };
  },
  computed: {
    listZones: function listZones() {
      return this.$store.state.listZones;
    }
  },
  watch: {
    listZones: function listZones() {
      var _this = this;

      if (this.listZones.length > 0) {
        this.rows.map(function (item) {
          var tempItem = item;
          tempItem.zone_name = _this.listZones.filter(function (zone) {
            return zone.id === tempItem.zone_id;
          }).length > 0 ? _this.listZones.filter(function (zone) {
            return zone.id === tempItem.zone_id;
          })[0].code : 'Unspecified';
          return tempItem;
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/judges-list")).then(function (response) {
      if (response.data.status === 'success') {
        _this2.error = '';
        var entireJudges = response.data.data.entire;
        var callFirstJudges = response.data.data.is_call_first;

        if (_this2.listZones.length > 0) {
          entireJudges.map(function (item) {
            var tempItem = item;
            tempItem.zone_name = _this2.listZones.filter(function (zone) {
              return zone.id === tempItem.zone_id;
            }).length > 0 ? _this2.listZones.filter(function (zone) {
              return zone.id === tempItem.zone_id;
            })[0].code : 'Unspecified';
            return tempItem;
          });
        }

        _this2.entireJudges = entireJudges;
        _this2.callFirstJudges = callFirstJudges;
        _this2.options.loaded = true;
      } else {
        _this2.error = 'Unable to receive data from the server. Please reload the page.';
      }
    });
  },
  methods: {
    colorTableFields: function colorTableFields() {
      var _this3 = this;

      // eslint-disable-next-line
      var tables = document.querySelectorAll('tbody');
      tables.forEach(function (table) {
        var cellsHtmlCollection = table.getElementsByTagName('tr');

        var cells = _this3.htmlCollectionToArray(cellsHtmlCollection);

        cells.forEach(function (cell) {
          var _cell$querySelector, _cell$querySelector$d;

          var parity = (_cell$querySelector = cell.querySelector('.js-parity')) === null || _cell$querySelector === void 0 ? void 0 : (_cell$querySelector$d = _cell$querySelector.dataset) === null || _cell$querySelector$d === void 0 ? void 0 : _cell$querySelector$d.parity;

          if (!parity) {
            return;
          }

          if (parity === 'even') {
            cell.classList.add('row-odd');
          } else {
            cell.classList.add('row-even');
          }
        });
      });
    },
    htmlCollectionToArray: function htmlCollectionToArray(htmlCollection) {
      var array = [];

      for (var i = 0; i < htmlCollection.length; i++) {
        array.push(htmlCollection[i]);
      }

      return array;
    }
  },
  updated: function updated() {
    this.colorTableFields();
  }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Public-Layout"
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__["a" /* default */]
  },
  name: "ExpressionInterest",
  data: function data() {
    return {
      success: '',
      errors: '',
      loaded: false,
      drafts: [],
      judgeId: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.judgeId = this.$route.params.slug;

    if (!this.judgeId) {
      this.$router.push({
        name: 'Judges Dashboard'
      });
    }

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("".concat(this.$api, "/judges/").concat(this.judgeId, "/published-drafts")).then(function (response) {
      if (response.data.status === 'success') {
        _this.errors = '';
        _this.drafts = response.data.data;
        _this.loaded = true;
      } else if (response.data.status === 'forbidden') {
        _this.$router.push({
          name: 'Judges Dashboard'
        });
      } else {
        _this.errors = 'Unable to receive data from the server. Please reload the page.';
      }
    });
  },
  methods: {
    takeInterest: function takeInterest(draftId, judgeId) {
      var _this2 = this;

      var formData = new FormData();
      formData.append('fields', JSON.stringify({
        draft_id: draftId
      }));
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("".concat(this.$api, "/judges/").concat(judgeId, "/drafts/application"), formData).then(function (response) {
        if (response.data.status === 'success') {
          // Done
          _this2.success = 'The draft has been submitted.';
          _this2.errors = '';
          location.reload();
        } else if (response.data.status === 'application_exists') {
          _this2.success = '';
          _this2.errors = 'The application is not unique.';
        } else if (response.data.status === 'invalid_user' && response.data.errors) {
          _this2.success = '';
          _this2.errors = 'The user is not the judge';
        } else if (response.data.status === 'judge_is_suspended' && response.data.errors) {
          _this2.success = '';
          _this2.errors = 'The judge is suspended';
        } else if (response.data.status === 'unfinancial_user' && response.data.errors) {
          _this2.success = '';
          _this2.errors = 'Please pay a subscription for a judge';
        } else {
          _this2.success = '';
          _this2.errors = 'Something went wrong. Please try again later.';
        }
      }).catch(function () {
        _this2.success = '';
        _this2.errors = 'There was a server error. Please try again later.';
      });
    }
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__["a" /* default */]
  },
  name: "ActiveDrafts",
  data: function data() {
    return {
      success: localStorage.getItem("judge-app-status"),
      errors: '',
      loaded: false,
      applications: [],
      judgeId: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.judgeId = this.$route.params.slug;
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("".concat(this.$api, "/judges/").concat(this.judgeId, "/active-drafts")).then(function (response) {
      if (response.data.status === 'success') {
        _this.errors = '';
        _this.applications = response.data.data;
        _this.loaded = true;
      } else if (response.data.status === 'invalid_user') {
        _this.$router.push({
          name: 'Judges Dashboard'
        });
      } else {
        _this.errors = 'Unable to receive data from the server. Please reload the page.';
      }
    });
    localStorage.removeItem("judge-app-status");
  },
  methods: {
    cancelApplication: function cancelApplication(applicationId) {
      var _this2 = this;

      if (!confirm('Are you sure you want to cancel this application?')) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("".concat(this.$api, "/judges/").concat(this.judgeId, "/drafts/application/").concat(applicationId, "/cancel")).then(function (response) {
        if (response.data.status === 'success') {
          // Done
          localStorage.setItem("judge-app-status", 'The application has been cancelled.');
          _this2.errors = '';
          location.reload();
        } else if (response.data.status === 'application_not_found' || response.data.status === 'forbidden') {
          _this2.success = '';
          _this2.errors = 'You cannot cancel this application.';
        } else {
          _this2.success = '';
          _this2.errors = 'Something went wrong.';
        }
      }).catch(function () {
        _this2.success = '';
        _this2.errors = 'There was a server error. Please try again later.';
      });
    }
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "JudgeSecretaryDashboard",
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__["a" /* default */]
  },
  data: function data() {
    return {
      userID: localStorage.userID,
      userRole: localStorage.role
    };
  },
  mounted: function mounted() {},
  methods: {}
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PendingExpressionInterest",
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__["a" /* default */],
    'data-table': __WEBPACK_IMPORTED_MODULE_2__components_DataTable__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
  },
  data: function data() {
    return {
      success: localStorage.getItem("judge-app-status"),
      error: '',
      rows: [],
      columns: [{
        label: 'First Name',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.first_name\" :slug=\"row.user_id\" :link=\"'Member Profile'\" :row=\"row\" :options=\"{ showLinks: true }\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.first_name);
        }
      }, {
        label: 'Last Name',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.last_name\" :slug=\"row.user_id\" :link=\"'Member Profile'\" :row=\"row\" :options=\"{ showLinks: true }\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.last_name);
        }
      }, {
        label: 'Draft',
        field: 'draft_name',
        filterable: false,
        sortable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.draft_name\" :row=\"row\" />"
        },
        representedAs: 'phone'
      }, {
        label: 'Phone Number',
        field: 'contact',
        filterable: false,
        sortable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.phone\" :row=\"row\" :mobile=\"row.phone\" :options=\"{ isMobile: true }\" />"
        },
        representedAs: 'phone'
      }, {
        label: 'Suburb',
        field: 'suburb',
        filterable: false,
        sortable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.suburb\" :row=\"row\"/>"
        },
        representedAs: 'suburb'
      }, {
        label: 'Zone',
        field: 'zone_id',
        filterable: false,
        sortable: true,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate class=\"js-parity\" :data-parity=\"row.parity\" :text=\"rowZone(row.zone_id)\" :row=\"row\" />",
          methods: {
            rowZone: function rowZone(theID) {
              return this.$store.state.listZones.filter(function (zone) {
                return zone.id === theID;
              }).length ? this.$store.state.listZones.find(function (zone) {
                return zone.id === theID;
              }).code : 'Unspecified';
            }
          }
        }
      }, {
        label: 'Judge Status',
        field: 'status',
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.status\" :row=\"row\"/>"
        },
        representedAs: 'status'
      }, {
        label: 'Actions',
        field: 'status',
        filterable: false,
        headerClass: 'd-none d-lg-table-cell table_header-actions',
        visible: true,
        component: {
          props: ['row'],
          data: function data() {
            return {
              processing: false
            };
          },
          methods: {
            approveApplication: function approveApplication(applicationId) {
              var _this = this;

              this.processing = true;
              __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("".concat(this.$api, "/judges/draft-applications/").concat(applicationId, "/approve")).then(function (response) {
                if (response.data.status === 'success') {
                  // Done
                  localStorage.setItem("judge-app-status", response.data.message);
                  _this.error = '';
                  _this.processing = false;
                  location.reload();
                } else {
                  _this.success = '';
                  _this.error = 'Something went wrong. Please try again later.';
                }
              }).catch(function () {
                _this.success = '';
                _this.error = 'There was a server error. Please try again later.';
              }).finally(function () {
                return _this.processing = false;
              });
            },
            denyApplication: function denyApplication(applicationId) {
              var _this2 = this;

              this.processing = true;
              __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("".concat(this.$api, "/judges/draft-applications/").concat(applicationId, "/deny")).then(function (response) {
                if (response.data.status === 'success') {
                  // Done
                  localStorage.setItem("judge-app-status", response.data.message);
                  _this2.error = '';
                  _this2.processing = false;
                  location.reload();
                } else {
                  _this2.success = '';
                  _this2.error = 'Something went wrong. Please try again later.';
                }
              }).catch(function () {
                _this2.success = '';
                _this2.error = 'There was a server error. Please try again later.';
              }).finally(function () {
                return _this2.processing = false;
              });
            }
          },
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "\n              <div class=\"d-flex flex-wrap mt-2\">\n                <div class=\"mr-1\">\n                  <button\n                    class=\"btn-default btn-small btn btn-sm btn-primary btn-actions mr-2 mb-2\"\n                    @click=\"approveApplication(row.id)\"\n                    :disabled=\"processing\"\n                  >\n                    <div v-if=\"processing\" class=\"d-flex align-items-center\">\n                      <div class=\"spinner-border spinner-border-sm text-light mr-2\" role=\"status\"></div>\n                    </div>\n                    <div v-else>\n                      Approve\n                    </div>\n                  </button>\n                </div>\n               <div>\n                 <button\n                   class=\"btn-default btn-small btn btn-sm btn-primary btn-actions mr-2\"\n                   @click=\"denyApplication(row.id)\"\n                    :disabled=\"processing\"\n                 >\n                   <div v-if=\"processing\" class=\"d-flex align-items-center\">\n                      <div class=\"spinner-border spinner-border-sm text-light mr-2\" role=\"status\"></div>\n                    </div>\n                    <div v-else>\n                      Deny\n                    </div>\n                  </button>\n               </div>\n              </div>\n            "
        },
        representedAs: 'actions'
      }],
      options: {
        filter: {},
        activeFilter: {},
        search: false,
        loaded: false
      },
      processing: false
    };
  },
  computed: {
    listZones: function listZones() {
      return this.$store.state.listZones;
    }
  },
  watch: {
    listZones: function listZones() {
      var _this3 = this;

      if (this.listZones.length > 0) {
        this.rows.map(function (item) {
          var tempItem = item;
          tempItem.zone_name = _this3.listZones.filter(function (zone) {
            return zone.id === tempItem.zone_id;
          }).length > 0 ? _this3.listZones.filter(function (zone) {
            return zone.id === tempItem.zone_id;
          })[0].code : 'Unspecified';
          return tempItem;
        });
      }
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("".concat(this.$api, "/judges/draft-applications/pending-applications")).then(function (response) {
      if (response.data.status === 'success') {
        _this4.error = '';
        var rows = response.data.data;

        if (_this4.listZones.length > 0) {
          rows.map(function (item) {
            var tempItem = item;
            tempItem.zone_name = _this4.listZones.filter(function (zone) {
              return zone.id === tempItem.zone_id;
            }).length > 0 ? _this4.listZones.filter(function (zone) {
              return zone.id === tempItem.zone_id;
            })[0].code : 'Unspecified';
            return tempItem;
          });
        }

        _this4.rows = rows;
        _this4.options.loaded = true;
      } else {
        _this4.error = 'Unable to receive data from the server. Please reload the page.';
      }
    });
    localStorage.removeItem("judge-app-status");
  },
  methods: {
    approveApplication: function approveApplication(applicationId) {
      var _this5 = this;

      this.processing = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("".concat(this.$api, "/judges/draft-applications/").concat(applicationId, "/approve")).then(function (response) {
        if (response.data.status === 'success') {
          // Done
          localStorage.setItem("judge-app-status", response.data.message);
          _this5.error = '';
          _this5.processing = false;
          location.reload();
        } else if (response.data.status === 'judge_is_suspended' && response.data.errors) {
          _this5.success = '';
          _this5.errors = 'The judge is suspended';
        } else {
          _this5.success = '';
          _this5.error = 'Something went wrong. Please try again later.';
        }
      }).catch(function () {
        _this5.success = '';
        _this5.error = 'There was a server error. Please try again later.';
      }).finally(function () {
        return _this5.processing = false;
      });
    },
    denyApplication: function denyApplication(applicationId) {
      var _this6 = this;

      this.processing = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("".concat(this.$api, "/judges/draft-applications/").concat(applicationId, "/deny")).then(function (response) {
        if (response.data.status === 'success') {
          // Done
          localStorage.setItem("judge-app-status", response.data.message);
          _this6.error = '';
          _this6.processing = false;
          location.reload();
        } else {
          _this6.success = '';
          _this6.error = 'Something went wrong. Please try again later.';
        }
      }).catch(function () {
        _this6.success = '';
        _this6.error = 'There was a server error. Please try again later.';
      }).finally(function () {
        return _this6.processing = false;
      });
    }
  }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DraftAndEvents__ = __webpack_require__(1009);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ApprovedExpressionInterest",
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__["a" /* default */],
    'data-table': __WEBPACK_IMPORTED_MODULE_2__components_DataTable__["a" /* default */],
    DraftAndEvents: __WEBPACK_IMPORTED_MODULE_4__components_DraftAndEvents__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
  },
  data: function data() {
    return {
      success: localStorage.getItem("judge-app-status"),
      error: '',
      rows: [],
      columns: [{
        label: 'First Name',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.user.first_name\" :slug=\"row.user.user_id\" :link=\"'Member Profile'\" :row=\"row\" :options=\"{ showLinks: true }\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.user.first_name);
        }
      }, {
        label: 'Last Name',
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.user.last_name\" :slug=\"row.user.user_id\" :link=\"'Member Profile'\" :row=\"row\" :options=\"{ showLinks: true }\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.user.last_name);
        }
      }, {
        label: 'Draft and Events',
        field: 'draft_and_events',
        filterable: false,
        sortable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            DraftAndEvents: __WEBPACK_IMPORTED_MODULE_4__components_DraftAndEvents__["a" /* default */]
          },
          template: "<DraftAndEvents :data=\"row\" />"
        },
        representedAs: 'draft_and_events'
      }, {
        label: 'Phone Number',
        field: 'contact',
        filterable: false,
        sortable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.user.phone\" :row=\"row\" :mobile=\"row.user.phone\" :options=\"{ isMobile: true }\" />"
        },
        representedAs: 'phone'
      }, {
        label: 'Suburb',
        field: 'suburb',
        filterable: false,
        sortable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.user.suburb\" :row=\"row\"/>"
        },
        representedAs: 'suburb'
      }, {
        label: 'Zone',
        field: 'zone_id',
        filterable: false,
        sortable: true,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate class=\"js-parity\" :data-parity=\"row.parity\" :text=\"rowZone(row.user.zone_id)\" :row=\"row\" />",
          methods: {
            rowZone: function rowZone(theID) {
              return this.$store.state.listZones.filter(function (zone) {
                return zone.id === theID;
              }).length ? this.$store.state.listZones.find(function (zone) {
                return zone.id === theID;
              }).code : 'Unspecified';
            }
          }
        }
      }, {
        label: 'Judge Status',
        field: 'status',
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_3__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.user.status\" :row=\"row\"/>"
        },
        representedAs: 'status'
      }, {
        label: 'Expression Status',
        field: 'status',
        filterable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          template: "<span :class=\"['badge ml-1 my-auto alert-warning', row.draft_application.status !== 'cancelByJudge' ? 'd-none' : '']\">Cancelled</span>"
        },
        representedAs: 'status'
      }],
      options: {
        filter: {},
        activeFilter: {},
        search: false,
        loaded: false
      }
    };
  },
  computed: {
    listZones: function listZones() {
      return this.$store.state.listZones;
    }
  },
  watch: {
    listZones: function listZones() {
      var _this = this;

      if (this.listZones.length > 0) {
        this.rows.map(function (item) {
          var tempItem = item;
          tempItem.zone_name = _this.listZones.filter(function (zone) {
            return zone.id === tempItem.zone_id;
          }).length > 0 ? _this.listZones.filter(function (zone) {
            return zone.id === tempItem.zone_id;
          })[0].code : 'Unspecified';
          return tempItem;
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("".concat(this.$api, "/judges/draft-applications/approved-applications")).then(function (response) {
      if (response.data.status === 'success') {
        _this2.error = '';
        var rows = response.data.data;

        if (_this2.listZones.length > 0) {
          rows.map(function (item) {
            var tempItem = item;
            tempItem.zone_name = _this2.listZones.filter(function (zone) {
              return zone.id === tempItem.zone_id;
            }).length > 0 ? _this2.listZones.filter(function (zone) {
              return zone.id === tempItem.zone_id;
            })[0].code : 'Unspecified';
            return tempItem;
          });
        }

        _this2.rows = rows;
        _this2.options.loaded = true;
      } else {
        _this2.error = 'Unable to receive data from the server. Please reload the page.';
      }
    });
    localStorage.removeItem("judge-app-status");
  },
  methods: {}
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "DraftAndEvents",
  props: {
    data: Object
  },
  data: function data() {
    return {
      showModal: false,
      loaded: false,
      modalError: '',
      modalSuccess: '',
      eventList: [],
      checkedEvents: [],
      assignEvents: [],
      draft: {},
      user: {},
      draftApplication: {},
      processing: false
    };
  },
  mounted: function mounted() {
    this.draft = this.data.draft;
    this.user = this.data.user;
    this.draftApplication = this.data.draft_application;
  },
  methods: {
    openModal: function openModal() {
      this.showModal = true;
      var draftId = this.draft.id;

      if (!draftId) {
        this.modalError = 'Unable to receive data from the server. Please reload the page.';
        return;
      }

      this.getEventListByDraftId(draftId);
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.setDefaultValues();
    },
    setDefaultValues: function setDefaultValues() {
      this.loaded = false;
      this.modalError = '';
      this.modalSuccess = '';
    },
    getEventListByDraftId: function getEventListByDraftId(draftId) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/drafts/").concat(draftId, "/event-list")).then(function (response) {
        if (response.data.status === 'success') {
          _this.modalError = '';
          _this.eventList = response.data.data;

          _this.checkElementIfApplicationIsApproved();

          _this.loaded = true;
        } else {
          _this.modalError = 'Unable to receive data from the server. Please reload the page.';
        }
      });
    },
    checkElementIfApplicationIsApproved: function checkElementIfApplicationIsApproved() {
      var _this2 = this;

      var eventList = this.eventList; // all events in a draft

      var events = this.draft.events;
      this.checkedEvents = [];
      eventList.forEach(function (event) {
        var found = events.find(function (checkedEvent) {
          return checkedEvent.id === event.id;
        });

        if (found) {
          _this2.checkedEvents.push(event.id);
        }
      });
      this.cancelAssignJudge();
    },
    assignJudgeToEvents: function assignJudgeToEvents(judgeId, draftId, eventIds) {
      var _this3 = this;

      this.processing = true;
      var formData = new FormData();
      formData.append('fields', JSON.stringify({
        draft_id: draftId,
        event_ids: eventIds
      }));
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/judges/").concat(judgeId, "/assign-events"), formData).then(function (response) {
        var _response$data$errors;

        if (response.data.status === 'success') {
          // Done
          _this3.modalSuccess = "Judge successfully assigned to the event".concat(eventIds.length > 1 ? 's' : '', ".");
          _this3.modalError = '';
          _this3.checkedEvents = _this3.assignEvents;
          _this3.draft.events = _this3.eventList.filter(function (event) {
            return _this3.checkedEvents.includes(event.id);
          });
        } else if (response.data.status === 'invalid_judge' && response.data.errors) {
          _this3.modalSuccess = '';
          _this3.modalError = 'The status of the judge should be open';
        } else if (response.data.status === 'forbidden' && ((_response$data$errors = response.data.errors) === null || _response$data$errors === void 0 ? void 0 : _response$data$errors.status)) {
          _this3.modalSuccess = '';
          _this3.modalError = 'The status of the judge should be open';
        } else if (response.data.status === 'judge_is_suspended' && response.data.errors) {
          _this3.success = '';
          _this3.errors = 'The judge is suspended';
        } else {
          _this3.modalSuccess = '';
          _this3.modalError = 'Something went wrong. Please try again later.';
        }
      }).catch(function () {
        _this3.success = '';
        _this3.errors = 'There was a server error. Please try again later.';
      }).finally(function () {
        return _this3.processing = false;
      });
    },
    cancelAssignJudge: function cancelAssignJudge() {
      // set only assigned events
      this.assignEvents = this.checkedEvents;
    }
  }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Survey",
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__["a" /* default */]
  },
  data: function data() {
    return {
      error: '',
      success: '',
      surveys: [],
      questions: [],
      judges: [],
      respondingJudgeId: "",
      userAnswers: [],
      resultUserAnswers: [],
      loaded: false,
      surveyLoaded: false,
      closed: false
    };
  },
  computed: {
    surveyQuestions: function surveyQuestions() {
      return this.questions.filter(function (question) {
        return !question.parent_question_id;
      });
    }
  },
  watch: {
    resultUserAnswers: function resultUserAnswers() {
      this.userAnswers = _toConsumableArray(this.userAnswers);
    },
    respondingJudgeId: function respondingJudgeId() {
      this.success = '';

      if (this.loaded) {
        this.getSurveys();
      }
    }
  },
  mounted: function mounted() {
    this.getSurveys();
  },
  methods: {
    getSurveys: function getSurveys() {
      var _this = this;

      this.surveyLoaded = false;
      var configs = {};

      if (this.respondingJudgeId) {
        configs = {
          params: {
            responding_judge_id: this.respondingJudgeId
          }
        };
      }

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("".concat(this.$api, "/judges/surveys"), configs).then(function (response) {
        if (response.data.status === 'success') {
          _this.error = '';
          var data = response.data.data;
          _this.judges = data.judges;

          if (!_this.loaded && _this.judges && _this.judges[0]) {
            _this.respondingJudgeId = _this.judges[0].id;
          }

          _this.surveys = _toConsumableArray(data.surveys);
          _this.questions = data.questions;
          _this.resultUserAnswers = [];

          if (_this.surveys) {
            var surveyData = _this.surveys;
            surveyData.forEach(function (item) {
              item.events.forEach(function (survey) {
                var surveyId = survey.id;

                if (!_this.userAnswers[surveyId]) {
                  _this.userAnswers[surveyId] = _objectSpread({}, _this.userAnswers[surveyId], {
                    events: []
                  });
                } // eslint-disable-next-line


                if (!_this.userAnswers[surveyId].events[survey.event_id]) {
                  _this.userAnswers[surveyId].events[survey.event_id] = _objectSpread({}, _this.userAnswers[surveyId].events[survey.event_id], {
                    judges: []
                  });
                }

                survey.event.judges.forEach(function (judge) {
                  _this.userAnswers[surveyId].events[survey.event_id].judges[judge.id] = _objectSpread({}, _this.userAnswers[surveyId].events[survey.event_id].judges[judge.id], {
                    questions: []
                  });
                });
              });
            });
          }

          _this.loaded = true;
          _this.surveyLoaded = true;
        } else if (response.data.status === 'survey_closed') {
          _this.loaded = true;
          _this.closed = true;
        } else {
          _this.error = 'Unable to receive data from the server. Please reload the page.';
        }
      });
    },
    updateUserAnswers: function updateUserAnswers(survey, judgeId, questionId) {
      var custom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var answer = this.userAnswers[survey.id].events[survey.event_id].judges[judgeId].questions[questionId];
      var saveData = {
        survey_id: survey.id,
        judge_id: judgeId,
        question_id: questionId,
        answer: answer,
        custom: custom
      }; // eslint-disable-next-line

      var index = this.resultUserAnswers.findIndex(function (item) {
        return item.survey_id === survey.id && item.judge_id === judgeId && item.question_id === questionId;
      });

      if (index === -1) {
        this.resultUserAnswers.push(saveData);
      } else {
        this.resultUserAnswers.splice(index, 1, saveData);
      }
    },
    showAdditionalQuestions: function showAdditionalQuestions(survey, judgeId, question) {
      var parentQuestion = this.questions.find(function (questionData) {
        return (questionData === null || questionData === void 0 ? void 0 : questionData.id) === (question === null || question === void 0 ? void 0 : question.parent_question_id);
      });

      if (!parentQuestion) {
        return false;
      }

      var answerId = this.userAnswers[survey.id].events[survey.event_id].judges[judgeId].questions[parentQuestion.id];

      if (!answerId) {
        return false;
      }

      var answers = parentQuestion.answers;
      var answersWithAdditionalQuestions = answers.filter(function (answer) {
        return question.id === answer.additional_question_id;
      });
      var answersWithAdditionalQuestionsIds = [];

      if (answersWithAdditionalQuestions.length) {
        answersWithAdditionalQuestions.forEach(function (answer) {
          answersWithAdditionalQuestionsIds.push(answer.id);
        });
      }

      return answersWithAdditionalQuestionsIds.includes(answerId);
    },
    getAdditionalQuestions: function getAdditionalQuestions(question) {
      var answers = question.answers;
      var additionalQuestions = [];
      var additionalQuestionsIds = [];

      if (answers) {
        answers.forEach(function (answer) {
          if (answer.additional_question && !additionalQuestionsIds.includes(answer.additional_question.id)) {
            additionalQuestionsIds.push(answer.additional_question.id);
            additionalQuestions.push(answer.additional_question);
          }
        });
      }

      return additionalQuestions;
    },
    sendSurveyResults: function sendSurveyResults() {
      var _this2 = this;

      var resultUserAnswers = this.resultUserAnswers;

      if (!this.respondingJudgeId) {
        this.error = 'Select the responding judge, please.';
        return;
      }

      resultUserAnswers.map(function (item) {
        item.responding_judge_id = _this2.respondingJudgeId;
        return item;
      });
      var data = resultUserAnswers.filter(function (item) {
        return item.responding_judge_id !== item.judge_id;
      });
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("".concat(this.$api, "/judges/surveys/send"), data).then(function (response) {
        if (response.data.status === 'success') {
          _this2.error = '';
          _this2.success = 'Survey results successfully saved.';

          _this2.getSurveys();
        } else {
          _this2.success = '';
          _this2.error = 'Something went wrong. Please, try again later.';
        }
      });
    },
    showJudge: function showJudge(survey, respondingJudgeId, judgeId) {
      if (!respondingJudgeId) return true;
      var respondingJudge = this.judges.find(function (judge) {
        return judge.id === respondingJudgeId;
      });
      if (!respondingJudge) return false;
      var surveyResponsible = respondingJudge.responding_survey_responsible;
      if (!surveyResponsible) return true; // eslint-disable-next-line

      var existingSurveyResponsible = surveyResponsible.find(function (item) {
        return item.survey_id === survey.id && item.responding_judge_id === respondingJudgeId && item.judge_id === judgeId;
      });
      return !existingSurveyResponsible;
    },
    isQuestionRequired: function isQuestionRequired(survey, judgeId, question) {
      if ((question === null || question === void 0 ? void 0 : question.slug) === 'comments' && this.isPositivePerformanceRating(survey, judgeId)) {
        return false;
      }

      return true;
    },
    getQuestionText: function getQuestionText(survey, judgeId, question) {
      var questionText = question.question;

      if ((question === null || question === void 0 ? void 0 : question.slug) === 'comments' && this.isPositivePerformanceRating(survey, judgeId)) {
        questionText = 'Comment:';
      }

      return questionText;
    },
    isPositivePerformanceRating: function isPositivePerformanceRating(survey, judgeId) {
      var performanceRatingQuestion = this.questions.find(function (item) {
        return item.slug === 'performance-rating';
      });
      var answerId = this.userAnswers[survey.id].events[survey.event_id].judges[judgeId].questions[performanceRatingQuestion.id];
      var answer = performanceRatingQuestion.answers.find(function (item) {
        return item.id === answerId;
      });
      return (answer === null || answer === void 0 ? void 0 : answer.answer) && ['Good', 'Excellent'].includes(answer.answer);
    }
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Pagination__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_getAppearances__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AppearancesDraftsHeader__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AppearancesDraftsDesktopBanner__ = __webpack_require__(96);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LeadersDrafts',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_getAppearances__["a" /* default */]],
  props: ['success'],
  components: {
    AppearancesDraftsHeader: __WEBPACK_IMPORTED_MODULE_4__components_AppearancesDraftsHeader__["a" /* default */],
    AppearancesDraftsDesktopBanner: __WEBPACK_IMPORTED_MODULE_5__components_AppearancesDraftsDesktopBanner__["a" /* default */],
    'listing-layout': __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__["a" /* default */],
    pagination: __WEBPACK_IMPORTED_MODULE_1__components_Pagination__["a" /* default */]
  },
  data: function data() {
    return {
      draftsList: [],
      error: null,
      options: {
        loaded: false
      },
      currentPage: null,
      totalPages: null
    };
  },
  methods: {
    getDraftsList: function getDraftsList() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("".concat(this.$api, "/leaders/drafts"), {
        params: {
          page: this.currentPage
        }
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this.draftsList = response.data.data.drafts;
          _this.totalPages = response.data.meta.last_page;
        } else {
          _this.error = 'Unable to receive data from the server. Please reload the page.';
        }

        _this.options.loaded = true;
      });
    },
    handlePageChange: function handlePageChange(page) {
      this.$router.push({
        query: _objectSpread({}, this.$route.query, {
          page: page
        })
      });
    },
    formatDate: function formatDate(dateStr) {
      var date = new Date(dateStr);
      return date.toLocaleDateString('en-US', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
    }
  },
  watch: {
    '$route.query.page': {
      immediate: true,
      handler: function handler(page) {
        this.currentPage = Number(page) || 1;
        this.getDraftsList();
      }
    }
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppearancesDraftsHeader',
  props: {
    appearances: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasBanners: function hasBanners() {
      return this.appearances.sponsor_logo_1 || this.appearances.sponsor_logo_2 || this.appearances.sponsor_logo_3;
    }
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppearancesDraftsDesktopBanner',
  props: {
    appearances: {
      type: Object,
      required: true
    }
  },
  computed: {
    computedUrl: function computedUrl() {
      var url = this.appearances.sponsor_link || '';

      if (url && !/^https?:\/\//i.test(url)) {
        url = "https://".concat(url);
      }

      return url || null;
    }
  }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_getAppearances__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppearancesDraftsHeader__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppearancesDraftsDesktopBanner__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_getStatistics__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Statistics__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DraftEventsList__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DraftRidersList__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_RoundTabs__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Search__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_apiHelpers__ = __webpack_require__(39);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LeadersDraft',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_getAppearances__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_getStatistics__["a" /* default */]],
  props: ['success'],
  computed: {
    entity: function entity() {
      return {
        model: 'draft',
        id: this.$route.params.draft_id
      };
    },
    computedColor: function computedColor() {
      return this.appearances && this.appearances.schema_color ? "".concat(this.appearances.schema_color) : 'var(--primary)';
    }
  },
  watch: {
    '$route.query.tab': {
      immediate: true,
      handler: function handler(tab) {
        var _this$$route$query, _this$$route$query2, _this$$route$query3;

        var newTab = tab ? tab.toLowerCase() : this.tabs[0].name;
        var newQuery = {};

        switch (newTab) {
          case 'search':
            newQuery.select = (_this$$route$query = this.$route.query) === null || _this$$route$query === void 0 ? void 0 : _this$$route$query.select;
            newQuery.id = (_this$$route$query2 = this.$route.query) === null || _this$$route$query2 === void 0 ? void 0 : _this$$route$query2.id;
            break;

          case 'riders':
            newQuery.page = (_this$$route$query3 = this.$route.query) === null || _this$$route$query3 === void 0 ? void 0 : _this$$route$query3.page;
            break;

          default:
            break;
        }

        newQuery.tab = newTab;
        var queryChanged = JSON.stringify(this.$route.query) !== JSON.stringify(newQuery);

        if (queryChanged) {
          this.$router.replace({
            query: newQuery
          }).catch(function () {});
        }

        this.currentTab = newTab;
        this.fetchTabContent(tab);
      }
    }
  },
  components: {
    AppearancesDraftsHeader: __WEBPACK_IMPORTED_MODULE_2__components_AppearancesDraftsHeader__["a" /* default */],
    AppearancesDraftsDesktopBanner: __WEBPACK_IMPORTED_MODULE_3__components_AppearancesDraftsDesktopBanner__["a" /* default */],
    'listing-layout': __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__["a" /* default */],
    Statistics: __WEBPACK_IMPORTED_MODULE_5__components_Statistics__["a" /* default */],
    'draft-events-list': __WEBPACK_IMPORTED_MODULE_6__components_DraftEventsList__["a" /* default */],
    'draft-riders-list': __WEBPACK_IMPORTED_MODULE_7__components_DraftRidersList__["a" /* default */],
    'round-tabs': __WEBPACK_IMPORTED_MODULE_8__components_RoundTabs__["a" /* default */],
    search: __WEBPACK_IMPORTED_MODULE_9__components_Search__["a" /* default */]
  },
  data: function data() {
    var tabs = [{
      name: 'leaderboard'
    }, {
      name: 'riders'
    }, {
      name: 'search'
    }];
    return {
      draft: null,
      error: null,
      options: {
        loaded: false
      },
      tabs: tabs,
      currentTab: null
    };
  },
  provide: function provide() {
    return {
      entity: this.entity
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var draft;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = _this.draft;

              if (_context.t0) {
                _context.next = 5;
                break;
              }

              _context.next = 4;
              return _this.fetchDraft();

            case 4:
              _context.t0 = _context.sent;

            case 5:
              draft = _context.t0;

              if (!(draft && !_this.statistics)) {
                _context.next = 10;
                break;
              }

              _context.next = 9;
              return _this.fetchStatistics();

            case 9:
              _this.fetchTabContent(_this.$route.query.tab || _this.tabs[0].name);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchTabContent: function fetchTabContent(tabName) {
      if (!this.error) {
        this.currentTab = tabName;
      }
    },
    formatDate: function formatDate(dateStr) {
      var date = new Date(dateStr);
      return date.toLocaleDateString('en-US', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
    },
    fetchDraft: function fetchDraft() {
      var _this2 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_10__mixins_apiHelpers__["a" /* default */])("".concat(_this2.$api, "/leaders/drafts/").concat(_this2.entity.id), function (response) {
                  _this2.draft = response.data.data.draft;
                }, _this2);

              case 2:
                return _context2.abrupt("return", _this2.draft);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  inject: {
    entity: {
      default: null
    }
  },
  props: {
    statistics: {
      type: Object,
      required: true
    },
    appearances: {
      type: Object,
      required: false
    }
  },
  computed: {
    leader: function leader() {
      return this.statistics.draftLeader || this.statistics.eventLeader || null;
    },
    scores: function scores() {
      return this.statistics.draftScores || this.statistics.eventScores || null;
    },
    computedColor: function computedColor() {
      return this.appearances && this.appearances.schema_color ? "".concat(this.appearances.schema_color, "65") : 'var(--primary-opasity)';
    },
    cutoutRoute: function cutoutRoute() {
      if (!this.entity) return null;

      if (this.entity.model === 'draft' && this.entity.id) {
        return {
          name: 'LeadersDraftCutoutHighest',
          params: {
            draft_id: this.entity.id
          }
        };
      }

      if (this.entity.model === 'event' && this.entity.event_id) {
        return {
          name: 'LeadersEventCutoutHighest',
          params: {
            event_id: this.entity.event_id,
            round: this.$route.params.round || 0
          }
        };
      }

      return null;
    }
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_apiHelpers__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RoundTabs__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Links_LinkRider__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Links_LinkEvent__ = __webpack_require__(143);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['entity'],
  components: {
    'round-tabs': __WEBPACK_IMPORTED_MODULE_1__RoundTabs__["a" /* default */],
    'link-rider': __WEBPACK_IMPORTED_MODULE_2__Links_LinkRider__["a" /* default */],
    'link-event': __WEBPACK_IMPORTED_MODULE_3__Links_LinkEvent__["a" /* default */]
  },
  data: function data() {
    return {
      events: []
    };
  },
  props: {
    appearances: {
      type: Object,
      required: false
    }
  },
  computed: {
    computedColor: function computedColor() {
      return this.appearances && this.appearances.schema_color ? "".concat(this.appearances.schema_color) : 'var(--primary)';
    }
  },
  methods: {
    getDraftsInfo: function getDraftsInfo() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_0__mixins_apiHelpers__["a" /* default */])("".concat(this.$api, "/leaders/drafts/").concat(this.entity.id, "/events"), function (response) {
        _this.events = response.data.data.events;
      }, this);
    }
  },
  mounted: function mounted() {
    this.getDraftsInfo();
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Links_LinkEvent__ = __webpack_require__(143);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'link-event': __WEBPACK_IMPORTED_MODULE_0__Links_LinkEvent__["a" /* default */]
  },
  props: {
    isEventPage: {
      type: Boolean,
      required: false,
      default: false
    },
    tabs: {
      type: Array,
      required: true
    },
    event: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    isMain: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    tabRoute: function tabRoute(name) {
      return {
        name: this.$route.name,
        params: this.$route.params,
        query: _objectSpread({}, this.$route.query, {
          tab: name
        })
      };
    },
    isActive: function isActive(tab) {
      var _this$$route$params;

      if (tab.round === Number(this.event.current_active_round)) {
        return 'active';
      }

      if (tab.round === Number((_this$$route$params = this.$route.params) === null || _this$$route$params === void 0 ? void 0 : _this$$route$params.round)) {
        return 'active';
      }

      return '';
    }
  },
  computed: {
    activeTab: function activeTab() {
      return this.$route.query.tab || this.tabs[0].name;
    }
  }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  inheritAttrs: false,
  props: {
    round: {
      type: Object,
      required: true
    }
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['entity'],
  props: {
    draw: {
      type: Object,
      required: true
    }
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Pagination__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_apiHelpers__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Links_LinkRider__ = __webpack_require__(73);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['entity'],
  components: {
    pagination: __WEBPACK_IMPORTED_MODULE_0__components_Pagination__["a" /* default */],
    'link-rider': __WEBPACK_IMPORTED_MODULE_2__Links_LinkRider__["a" /* default */]
  },
  data: function data() {
    return {
      draws: null,
      meta: null,
      currentPage: 1
    };
  },
  props: {
    appearances: {
      type: Object,
      required: false
    }
  },
  methods: {
    getRiders: function getRiders() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_1__mixins_apiHelpers__["a" /* default */])("".concat(this.$api, "/leaders/drafts/").concat(this.entity.id, "/riders"), function (response) {
        _this.draws = response.data.data.draws;
        _this.meta = response.data.meta; // eslint-disable-next-line
        // console.log(this.draws)
      }, this, {
        params: {
          page: this.currentPage
        }
      });
    },
    handlePageChange: function handlePageChange(page) {
      this.$router.push({
        query: _objectSpread({}, this.$route.query, {
          page: page
        })
      });
    }
  },
  watch: {
    '$route.query.page': {
      immediate: true,
      handler: function handler(page) {
        this.currentPage = Number(page) || 1;
        this.getRiders();
      }
    }
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_apiHelpers__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Search_SearchForm__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Links_LinkEvent__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_formatScore__ = __webpack_require__(418);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['entity'],
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_formatScore__["a" /* default */]],
  components: {
    'search-form': __WEBPACK_IMPORTED_MODULE_1__Search_SearchForm__["a" /* default */],
    'link-event': __WEBPACK_IMPORTED_MODULE_2__Links_LinkEvent__["a" /* default */]
  },
  data: function data() {
    return {
      draws: null,
      selectBy: null
    };
  },
  watch: {
    '$route.query': {
      handler: function handler(newQuery) {
        var oldQuery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var id = newQuery.id;
        var select = newQuery.select;

        if (id && id !== oldQuery.id || select && select !== oldQuery.select) {
          this.fetchDaws(id, select);
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    fetchDaws: function fetchDaws(id, selectBy) {
      var _this = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var url;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!id || !selectBy)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this.selectBy = selectBy;
                url = "/leaders/drafts/".concat(_this.entity.id, "/").concat(selectBy === 'competitor' ? 'riders' : 'horses', "/").concat(id, "/draws");
                Object(__WEBPACK_IMPORTED_MODULE_0__mixins_apiHelpers__["a" /* default */])("".concat(_this.$api).concat(url), function (response) {
                  _this.draws = response.data.data.draws;
                }, _this);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppMultiselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_apiHelpers__ = __webpack_require__(39);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['entity'],
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_0__components_AppMultiselect__["a" /* default */]
  },
  data: function data() {
    return {
      selectBy: this.$route.query.select === 'horse' ? 'horse' : 'competitor',
      results: [],
      isLoading: false,
      timeout: null,
      draftId: null,
      selected: null,
      searchTimeout: null,
      isSelecting: false
    };
  },
  watch: {
    selectBy: function selectBy() {
      this.results = [];
      this.selected = null;
    }
  },
  computed: {
    labelField: function labelField() {
      return this.selectBy === 'competitor' ? 'rider_name' : 'name';
    },
    trackField: function trackField() {
      return this.selectBy === 'competitor' ? 'user_member_id' : 'horse_id';
    }
  },
  methods: {
    onInput: function onInput() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.search, 500);
    },
    onOpen: function onOpen() {
      if (this.results.length === 0) {
        this.search();
      }
    },
    onSearchChange: function onSearchChange(query) {
      var _this = this;

      if (this.isSelecting) {
        this.isSelecting = false;
        return;
      }

      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(function () {
        _this.search(query);
      }, 500);
    },
    search: function search(query) {
      var _this2 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var url;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.results = [];
                _this2.isLoading = true;
                url = _this2.selectBy === 'competitor' ? "/leaders/drafts/".concat(_this2.entity.id, "/competitors") : "/leaders/drafts/".concat(_this2.entity.id, "/horses");
                Object(__WEBPACK_IMPORTED_MODULE_1__mixins_apiHelpers__["a" /* default */])("".concat(_this2.$api).concat(url), function (response) {
                  var _response$data$data, _response$data$data2;

                  _this2.results = ((_response$data$data = response.data.data) === null || _response$data$data === void 0 ? void 0 : _response$data$data.riders) || ((_response$data$data2 = response.data.data) === null || _response$data$data2 === void 0 ? void 0 : _response$data$data2.horses);
                  _this2.isLoading = false;
                }, _this2, {
                  params: _defineProperty({}, "".concat(_this2.selectBy === 'competitor' ? 'rider_name' : 'name'), query)
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    selectItem: function selectItem(item) {
      if (!item) return;
      this.isSelecting = true;

      var currentQuery = _objectSpread({}, this.$route.query);

      currentQuery.id = item[this.trackField];
      currentQuery.select = this.selectBy;
      this.$router.push({
        path: this.$route.path,
        query: currentQuery
      }).catch(function () {});
    }
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    formatScore: function formatScore(value) {
      var num = Number(value);
      return num % 1 === 0 ? num : num.toFixed(2);
    }
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_getAppearances__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppearancesDraftsHeader__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppearancesDraftsDesktopBanner__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_getStatistics__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Statistics__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_RoundTabs__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_apiHelpers__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Links_LinkRider__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_formatScore__ = __webpack_require__(418);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LeadersEvent',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_getAppearances__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_getStatistics__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_formatScore__["a" /* default */]],
  props: ['success'],
  computed: {
    entity: function entity() {
      return {
        model: 'event',
        id: this.event ? this.event.draft_id : null,
        event_id: this.$route.params.main_event_id
      };
    },
    computedColor: function computedColor() {
      return this.appearances && this.appearances.schema_color ? "".concat(this.appearances.schema_color) : 'var(--primary)';
    },
    selectedRound: function selectedRound() {
      return this.$route.params.round || 0;
    },
    sortQuery: function sortQuery() {
      return this.$route.query.sort || null;
    },
    dirQuery: function dirQuery() {
      return this.$route.query.dir || 'asc';
    }
  },
  watch: {
    '$route.params.main_event_id': {
      immediate: false,
      handler: function handler() {
        this.statistics = null;
        this.fetchStatistics();
      }
    },
    '$route.query': {
      immediate: true,
      handler: function handler() {
        this.resetAndFetch();
      }
    }
  },
  components: {
    AppearancesDraftsHeader: __WEBPACK_IMPORTED_MODULE_2__components_AppearancesDraftsHeader__["a" /* default */],
    AppearancesDraftsDesktopBanner: __WEBPACK_IMPORTED_MODULE_3__components_AppearancesDraftsDesktopBanner__["a" /* default */],
    'listing-layout': __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__["a" /* default */],
    Statistics: __WEBPACK_IMPORTED_MODULE_5__components_Statistics__["a" /* default */],
    'round-tabs': __WEBPACK_IMPORTED_MODULE_6__components_RoundTabs__["a" /* default */],
    'link-rider': __WEBPACK_IMPORTED_MODULE_8__components_Links_LinkRider__["a" /* default */]
  },
  data: function data() {
    return {
      event: null,
      draws: [],
      error: null,
      page: 1,
      loading: false,
      finished: false
    };
  },
  provide: function provide() {
    var self = this;
    return {
      get entity() {
        return {
          model: 'event',
          id: self.event ? self.event.draft_id : null,
          event_id: self.$route.params.main_event_id
        };
      }

    };
  },
  methods: {
    // IntersectionObserver only reports visibility *changes*, so a hit that
    // arrives while a page is loading (or batched behind an older entry) is
    // lost and the list stalls until the user scrolls away and back. Measure
    // the distance to the trigger directly on scroll and after every page.
    loadMoreIfNeeded: function loadMoreIfNeeded() {
      var trigger = this.$refs.infiniteTrigger;
      if (!trigger || this.loading || this.finished || this.error) return;

      if (trigger.getBoundingClientRect().top <= window.innerHeight + 300) {
        this.fetchEvent();
      }
    },
    resetAndFetch: function resetAndFetch() {
      this.page = 1;
      this.draws = [];
      this.finished = false;
      this.fetchEvent();
    },
    fetchEvent: function fetchEvent() {
      var _this = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var query, subEventPart;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.loading || _this.finished)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this.loading = true;
                query = new URLSearchParams();

                if (_this.sortQuery) {
                  query.append('sort', _this.sortQuery);
                  query.append('dir', _this.dirQuery);
                }

                query.append('page', _this.page);
                subEventPart = _this.$route.params.sub_event_id ? "/".concat(_this.$route.params.sub_event_id) : '';
                _context.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_7__mixins_apiHelpers__["a" /* default */])("".concat(_this.$api, "/leaders/events/").concat(_this.$route.params.main_event_id, "/").concat(_this.$route.params.round).concat(subEventPart, "?").concat(query.toString()), function (response) {
                  var event = response.data.data.event;
                  var newDraws = response.data.data.draws;
                  _this.event = event;

                  if (!newDraws.length) {
                    _this.finished = true;
                  } else {
                    var _this$draws;

                    (_this$draws = _this.draws).push.apply(_this$draws, _toConsumableArray(newDraws));

                    _this.page++;
                  }

                  if (!_this.statistics) {
                    _this.fetchStatistics();
                  }

                  _this.$root.$emit('update-breadcrumb', {
                    name: 'Draft',
                    link: "leaders/drafts/".concat(_this.event.draft_id)
                  });
                }, _this);

              case 9:
                _this.loading = false;

                _this.$nextTick(_this.loadMoreIfNeeded);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    changeSort: function changeSort(column) {
      var dir = 'asc';

      if (this.sortQuery === column) {
        dir = this.dirQuery === 'asc' ? 'desc' : 'asc';
      }

      this.$router.push({
        query: _objectSpread({}, this.$route.query, {
          sort: column,
          dir: dir
        })
      });
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.loadMoreIfNeeded, {
      passive: true
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.loadMoreIfNeeded);
  }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Listing_mixins_getAppearances__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Listing_mixins_getStatistics__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Listing_components_Statistics__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_apiHelpers__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Listing_components_Links_LinkRider__ = __webpack_require__(73);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LeadersDraftCutoutHighest',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__Listing_mixins_getAppearances__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__Listing_mixins_getStatistics__["a" /* default */]],
  computed: {
    entity: function entity() {
      return {
        model: 'draft',
        id: this.$route.params.draft_id
      };
    },
    computedColor: function computedColor() {
      return this.appearances && this.appearances.schema_color ? "".concat(this.appearances.schema_color) : 'var(--primary)';
    }
  },
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__["a" /* default */],
    Statistics: __WEBPACK_IMPORTED_MODULE_3__Listing_components_Statistics__["a" /* default */],
    'link-rider': __WEBPACK_IMPORTED_MODULE_5__Listing_components_Links_LinkRider__["a" /* default */]
  },
  data: function data() {
    return {
      draft: null,
      draws: [],
      error: null,
      page: 1,
      loading: false,
      finished: false,
      observer: null
    };
  },
  provide: function provide() {
    var self = this;
    return {
      get entity() {
        return {
          model: 'draft',
          id: self.$route.params.draft_id
        };
      }

    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.fetchDraft();

            case 2:
              _context.next = 4;
              return _this.fetchStatistics();

            case 4:
              _this.fetchDraws();

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    initObserver: function initObserver() {
      var _this2 = this;

      if (!this.$refs.infiniteTrigger) return;
      this.observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && !_this2.loading && !_this2.finished) {
          _this2.fetchDraws();
        }
      }, {
        root: null,
        rootMargin: '300px',
        threshold: 0
      });
      this.observer.observe(this.$refs.infiniteTrigger);
    },
    fetchDraft: function fetchDraft() {
      var _this3 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_4__mixins_apiHelpers__["a" /* default */])("".concat(_this3.$api, "/leaders/drafts/").concat(_this3.entity.id), function (response) {
                  _this3.draft = response.data.data.draft;

                  _this3.$root.$emit('update-breadcrumb', {
                    name: 'Draft',
                    link: "leaders/drafts/".concat(_this3.entity.id)
                  });
                }, _this3);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    fetchDraws: function fetchDraws() {
      var _this4 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var query;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this4.loading || _this4.finished)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                _this4.loading = true;
                query = new URLSearchParams();
                query.append('page', _this4.page);
                _context3.next = 7;
                return Object(__WEBPACK_IMPORTED_MODULE_4__mixins_apiHelpers__["a" /* default */])("".concat(_this4.$api, "/leaders/drafts/").concat(_this4.$route.params.draft_id, "/cutout-highest?").concat(query.toString()), function (response) {
                  var _this4$draws;

                  var data = response.data.data;
                  var meta = response.data.meta;
                  var newDraws = data.draws || [];

                  (_this4$draws = _this4.draws).push.apply(_this4$draws, _toConsumableArray(newDraws));

                  if (!newDraws.length || meta && _this4.page >= meta.last_page) {
                    _this4.finished = true;
                  } else {
                    _this4.page++;

                    _this4.$nextTick(function () {
                      if (!_this4.observer) _this4.initObserver();
                    });
                  }
                }, _this4);

              case 7:
                _this4.loading = false;

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Listing_mixins_getAppearances__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Listing_mixins_getStatistics__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Listing_components_Statistics__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_apiHelpers__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Listing_components_Links_LinkRider__ = __webpack_require__(73);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LeadersEventCutoutHighest',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__Listing_mixins_getAppearances__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__Listing_mixins_getStatistics__["a" /* default */]],
  computed: {
    entity: function entity() {
      return {
        model: 'event',
        id: this.event ? this.event.draft_id : null,
        event_id: this.$route.params.event_id
      };
    },
    computedColor: function computedColor() {
      return this.appearances && this.appearances.schema_color ? "".concat(this.appearances.schema_color) : 'var(--primary)';
    },
    selectedRound: function selectedRound() {
      return Number(this.$route.params.round) || 0;
    }
  },
  watch: {
    '$route.params': {
      immediate: true,
      handler: function handler() {
        this.fetchEventData();
      }
    }
  },
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_0__components_ListingLayout__["a" /* default */],
    Statistics: __WEBPACK_IMPORTED_MODULE_3__Listing_components_Statistics__["a" /* default */],
    'link-rider': __WEBPACK_IMPORTED_MODULE_5__Listing_components_Links_LinkRider__["a" /* default */]
  },
  data: function data() {
    return {
      event: null,
      draws: [],
      error: null,
      loading: false
    };
  },
  provide: function provide() {
    var self = this;
    return {
      get entity() {
        return {
          model: 'event',
          id: self.event ? self.event.draft_id : null,
          event_id: self.$route.params.event_id
        };
      }

    };
  },
  methods: {
    isRoundActive: function isRoundActive(round) {
      return round.round === this.selectedRound;
    },
    roundLabel: function roundLabel(round) {
      if (round.name === 'Final') return 'Final';
      if (round.name && round.name.toLowerCase().includes('run-off')) return round.name.toUpperCase();
      return round.name;
    },
    fetchEventData: function fetchEventData() {
      var _this = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var round, url;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _this.draws = [];
                round = _this.$route.params.round || 0;
                url = "".concat(_this.$api, "/leaders/events/").concat(_this.$route.params.event_id, "/cutout-highest/").concat(round);
                _context.next = 6;
                return Object(__WEBPACK_IMPORTED_MODULE_4__mixins_apiHelpers__["a" /* default */])(url, function (response) {
                  var newEvent = response.data.data.event; // rounds list comes from round=0, preserve it when switching rounds

                  if (newEvent.rounds && newEvent.rounds.length) {
                    _this.event = newEvent;
                  } else if (_this.event) {
                    _this.event = _objectSpread({}, newEvent, {
                      rounds: _this.event.rounds
                    });
                  } else {
                    _this.event = newEvent;
                  }

                  _this.draws = response.data.data.draws || [];

                  if (!_this.statistics) {
                    _this.fetchStatistics();
                  }

                  if (_this.event && _this.event.draft_id) {
                    _this.$root.$emit('update-breadcrumb', {
                      name: 'Draft',
                      link: "leaders/drafts/".concat(_this.event.draft_id)
                    });

                    _this.$root.$emit('update-breadcrumb', {
                      name: 'Event',
                      link: "leaders/events/".concat(_this.$route.params.event_id, "/").concat(_this.selectedRound)
                    });
                  }
                }, _this);

              case 6:
                _this.loading = false;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Text__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DataTableFields_Button__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Add_TokenAdd__ = __webpack_require__(1055);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
* to their respective fields in the ListingLayout component. */







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ApiTokens',
  props: [],
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__["a" /* default */],
    'data-table': __WEBPACK_IMPORTED_MODULE_2__components_DataTable__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Text__["a" /* default */],
    tableButtonTemplate: __WEBPACK_IMPORTED_MODULE_5__components_DataTableFields_Button__["a" /* default */],
    'form-token-create': __WEBPACK_IMPORTED_MODULE_6__Add_TokenAdd__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_3__components_Modal__["a" /* default */]
  },
  data: function data() {
    return {
      status: '',
      error: '',
      success: '',
      rows: [],
      showDeleteModal: false,
      rowToDelete: null,
      columns: [{
        label: 'Name',
        headerClass: 'd-none d-lg-table-cell',
        sortable: true,
        filterable: false,
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.name\" :row=\"row\" />"
        },
        representedAs: function representedAs(row) {
          return "".concat(row.name);
        }
      }, {
        label: 'Status',
        headerClass: 'd-none d-lg-table-cell',
        sortable: true,
        filterable: true,
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :row=\"row\" :options=\"{ showActiveToken: true, inline: true }\"/>"
        }
      }, {
        label: 'Last Active',
        headerClass: 'd-none d-lg-table-cell',
        sortable: true,
        filterable: true,
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<tableTextTemplate :text=\"row.last_used_at?row.last_used_at: '-'\" :row=\"row\" :options=\"{ inline: true }\" />"
        }
      }, {
        label: 'Actions',
        field: '',
        align: 'left',
        sortable: false,
        filterable: false,
        headerClass: 'd-none d-lg-table-cell column-lg-medium',
        visible: true,
        component: {
          props: ['row'],
          template: "\n              <div class=\"d-flex\">\n                <button class=\"btn btn-sm btn-primary mr-2\" @click=\"toggleActive(row)\">\n                  {{ row.is_active ? 'Deactivate' : 'Activate' }}\n                </button>\n                <button class=\"btn btn-sm btn-primary\" @click=\"confirmDelete(row)\">\n                  Delete\n                </button>\n              </div>\n            ",
          methods: {
            toggleActive: this.toggleActive,
            confirmDelete: this.confirmDelete
          }
        }
      }],
      options: {
        loaded: false
      }
    };
  },
  mounted: function mounted() {
    this.loadRows();
  },
  methods: {
    loadRows: function loadRows() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/api-tokens")).then(function (response) {
        if (response.data.status === 'success') {
          _this.rows = response.data.data.api_tokens;
          _this.options.loaded = true;
        } else {
          _this.error = 'Unable to receive data from the server. Please reload the page.';
        }
      });
    },
    toggleActive: function toggleActive(row) {
      var _this2 = this;

      var action = row.is_active ? 'deactivate' : 'activate';
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch("".concat(this.$api, "/admin/api-tokens/").concat(row.id, "/").concat(action)).then(function (response) {
        if (response.data.status === 'success') {
          _this2.success = "Token ".concat(row.is_active ? 'deactivated' : 'activated', "!");

          _this2.loadRows();
        } else {
          _this2.error = response.data.error ? response.data.error : 'Unable to receive data from the server. Please reload the page.';
        }
      }).catch(function (err) {
        // eslint-disable-next-line
        console.log(err);
      });
    },
    confirmDelete: function confirmDelete(row) {
      this.rowToDelete = row;
      this.showDeleteModal = true;
    },
    deleteConfirmed: function deleteConfirmed() {
      var _this3 = this;

      if (!this.rowToDelete) return;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete("".concat(this.$api, "/admin/api-tokens/").concat(this.rowToDelete.id)).then(function (response) {
        if (response.data.status === 'success') {
          _this3.success = "Token deleted successfully!";

          _this3.loadRows();
        } else {
          _this3.error = response.data.error ? response.data.error : 'Unable to receive data from the server. Please reload the page.';
        }

        _this3.showDeleteModal = false;
        _this3.rowToDelete = null;
      }).catch(function (err) {
        // eslint-disable-next-line
        console.log(err);
      });
    }
  }
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: {
        name: ''
      },
      processing: false,
      errors: {},
      createdToken: null
    };
  },
  methods: {
    createToken: function createToken() {
      var _this = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.processing = true;
                _this.errors = {};
                _this.createdToken = null;
                _context.prev = 3;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(_this.$api, "/admin/api-tokens"), _this.form);

              case 6:
                response = _context.sent;

                if (response.data.status === 'success') {
                  _this.createdToken = response.data.data.token;

                  _this.$emit('created', response.data.data.token);

                  _this.form.name = '';
                } else {
                  _this.errors = response.data.errors || {};

                  _this.$emit('error', response.data.error || 'Unable to receive data from the server. Please reload the page.');
                }

                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);

                _this.$emit('error', _context.t0);

              case 13:
                _context.prev = 13;
                _this.processing = false;
                return _context.finish(13);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 10, 13, 16]]);
      }))();
    },
    copyToken: function copyToken() {
      var _this2 = this;

      if (!this.createdToken) return;
      navigator.clipboard.writeText(this.createdToken).then(function () {
        _this2.$emit('success', 'Token copied!');
      }).catch(function () {// alert('Failed to copy token.')
      });
    }
  }
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_memberProfileStore_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DataTable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Text__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'JudgeDashboard',
  props: ['success'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__store_memberProfileStore_js__["a" /* default */]],
  components: {
    'listing-layout': __WEBPACK_IMPORTED_MODULE_2__components_ListingLayout__["a" /* default */],
    'data-table': __WEBPACK_IMPORTED_MODULE_3__components_DataTable__["a" /* default */],
    tableTextTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Text__["a" /* default */]
  },
  data: function data() {
    return {
      userID: localStorage.userID,
      userRole: localStorage.role,
      loggedInUser: localStorage.role,
      status: '',
      error: '',
      rows: [],
      unregisterExist: false,
      columns: [{
        label: 'First Name',
        sortable: false,
        headerClass: 'd-none d-lg-table-cell judge-dashboard-name',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Text__["a" /* default */]
          },
          template: "\n              <tableTextTemplate :text=\"row.first_name\" :slug=\"row.id\" :row=\"row\"/>"
        }
      }, {
        label: 'Last Name',
        sortable: false,
        headerClass: 'd-none d-lg-table-cell judge-dashboard-name',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Text__["a" /* default */]
          },
          template: "\n              <tableTextTemplate :text=\"row.last_name\" :row=\"row\"/>"
        }
      }, {
        label: 'Judge Status',
        sortable: false,
        headerClass: 'd-none d-lg-table-cell judge-dashboard-status',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Text__["a" /* default */]
          },
          template: "\n              <tableTextTemplate :text=\"_.capitalize(row.judge_type)\" :row=\"row\"/>"
        }
      }, {
        label: 'State',
        filterable: false,
        sortable: false,
        headerClass: 'd-none d-lg-table-cell',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Text__["a" /* default */]
          },
          template: "<span :class=\"['badge ml-1 my-auto', row.status === 'denied' ? 'alert-danger' : (row.status === 'approved' ? 'alert-success' : 'alert-warning')]\">{{ _.capitalize(row.status) }}</span>"
        }
      }, {
        label: 'Active Drafts',
        sortable: false,
        headerClass: 'd-none d-lg-table-cell judge-dashboard-actions',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Text__["a" /* default */]
          },
          template: "\n              <router-link\n                :to=\"{ name: 'Active Drafts', params: { slug: row.judge_id } }\"\n                tag=\"button\" class=\"btn btn-block mb-2 btn-outline-primary btn-sm\"\n                :class=\"!row.judge_id ? 'disabled' : ''\"\n                :disabled=\"!row.judge_id\"\n                style=\"width: 170px\">\n                View Drafts\n              </router-link>"
        }
      }, {
        label: 'Actions',
        sortable: false,
        headerClass: 'd-none d-lg-table-cell judge-dashboard-actions',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Text__["a" /* default */]
          },
          template: "\n              <router-link\n                :to=\"{ name: 'Expression Of Interest', params: { slug: row.judge_id } }\"\n                tag=\"button\" class=\"btn btn-block mb-2 btn-primary btn-sm\"\n                :class=\"!row.judge_id ? 'disabled' : ''\"\n                :disabled=\"!row.judge_id\"\n                style=\"width: 170px\">\n                Express Interest\n              </router-link>"
        }
      }, {
        label: '',
        sortable: false,
        headerClass: 'd-none d-lg-table-cell judge-dashboard-actions',
        visible: true,
        component: {
          props: ['row'],
          components: {
            tableTextTemplate: __WEBPACK_IMPORTED_MODULE_4__components_DataTableFields_Text__["a" /* default */]
          },
          template: "\n              <router-link\n                :to=\"{ name: 'Judge Application', params: { member_id: row.user_id} }\"\n                tag=\"button\" class=\"btn btn-block mb-2 btn-primary btn-sm\" style=\"width: 170px\"\n                v-if=\"(row.judge_type === 'trial')\">\n                Apply for Open\n              </router-link>"
        }
      }],
      options: {
        filter: {},
        activeFilter: {
          registration_date: 'all'
        },
        search: false,
        addHorse: false,
        loaded: false
      }
    };
  },
  computed: {
    checkHasFinancialMembers: function checkHasFinancialMembers() {
      return !!this.memberDetails.secondaries.find(function (member) {
        return member.financial && !member.has_event_membership;
      }) || this.memberDetails.financial && !this.memberDetails.has_event_membership;
    }
  },
  mounted: function mounted() {
    this.$store.commit('deselectAllRows');
    this.getJudgeList();

    if (this.horseError) {
      this.error = this.horseError;
    }
  },
  methods: {
    getJudgeList: function getJudgeList() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("".concat(this.$api, "/judges/dashboard"), {
        id: localStorage.userID
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this.error = _this.horseError || '';
          _this.rows = response.data.data;
          _this.options.loaded = true;
        }
      }).catch(function (error) {
        // eslint-disable-next-line
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_memberProfileStore__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CommitteeAffiliationForm__ = __webpack_require__(1064);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CommitteeAffiliation',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__store_memberProfileStore__["a" /* default */]],
  components: {
    listingLayout: __WEBPACK_IMPORTED_MODULE_1__components_ListingLayout__["a" /* default */],
    CommitteeAffiliationForm: __WEBPACK_IMPORTED_MODULE_3__components_CommitteeAffiliationForm__["a" /* default */]
  },
  data: function data() {
    return {
      userID: localStorage.userID,
      userRole: localStorage.role,
      committee: null,
      isLoading: true,
      allowCommittee: true,
      isDeleted: false
    };
  },
  watch: {
    memberDetails: function memberDetails() {
      var _this = this;

      if (!this.memberDetails.committee_id) {
        this.$router.push('/committees/not-registered');
      }

      this.allowCommittee = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/committee-details/").concat(this.memberDetails.committee_id)).then(function (response) {
        var _response$data, _response$data2;

        _this.isLoading = false;

        if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.status) === 'success') {
          _this.committee = response.data.data;

          if (_this.committee.is_financial || _this.committee.current_affiliation && _this.committee.current_affiliation.is_invoice_created === 1) {
            _this.$router.push('/committees/edit');
          }
        } else if ((response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.status) === 'committee_is_deleted') {
          _this.isDeleted = true;
        }
      }).catch(function (error) {
        // eslint-disable-next-line
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Modal__ = __webpack_require__(5);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var nameRegex = __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["helpers"].regex('name', /^[A-Za-z\s]*$/);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuelidate___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CommitteeAffiliationForm',
  props: ['secretary', 'committeeDetails', 'isLoading'],
  components: {
    modal: __WEBPACK_IMPORTED_MODULE_4__components_Modal__["a" /* default */]
  },
  data: function data() {
    return {
      showModal: false,
      errors: [],
      errorStatus: null,
      fields: {
        committee_id: '',
        mailing_address: '',
        suburb: '',
        drafts: [{
          start: '',
          end: ''
        }],
        grounds_address: '',
        grounds_suburb: '',
        grounds_state: '',
        grounds_postcode: '',
        president_name: '',
        secretary_name: '',
        treasurer_name: '',
        other_name: '',
        internet_access: '',
        phone_service: '',
        event_membership_agree: false
      },
      data: {
        affiliation_id: '',
        is_invoice_created: '',
        post_code: '',
        state: '',
        name: ''
      },
      submitStatus: null,
      hasOnlinePayments: false,
      errorFields: {}
    };
  },
  validations: function validations() {
    var validationRules = {
      fields: {
        mailing_address: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        suburb: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        drafts: {
          $each: {
            start: {},
            end: {}
          }
        },
        grounds_address: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        grounds_suburb: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        grounds_state: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        grounds_postcode: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        president_name: {},
        secretary_name: {},
        treasurer_name: {},
        other_name: {},
        internet_access: {},
        phone_service: {},
        event_membership_agree: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        }
      },
      data: {
        state: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        post_code: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        name: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
          nameRegex: nameRegex
        }
      }
    };
    return validationRules;
  },
  watch: {
    committeeDetails: function committeeDetails() {
      this.data = _objectSpread({}, this.committeeDetails);
      this.fields.committee_id = this.committeeDetails.id;
      this.prefillAffiliationFormData();
    }
  },
  methods: {
    handleShowModal: function handleShowModal() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR';
      } else {
        this.submitStatus = 'OK';
        this.showModal = true;
      }
    },
    prefillAffiliationFormData: function prefillAffiliationFormData() {
      var currentAffiliation = this.committeeDetails.current_affiliation;

      if (currentAffiliation) {
        this.data.affiliation_id = currentAffiliation.id;
        this.data.is_invoice_created = currentAffiliation.is_invoice_created;
        this.fields.committee_id = currentAffiliation.committee_id;
        this.fields.mailing_address = currentAffiliation.mailing_address;
        this.fields.suburb = currentAffiliation.suburb;
        this.fields.grounds_address = currentAffiliation.grounds_address;
        this.fields.grounds_suburb = currentAffiliation.grounds_suburb;
        this.fields.grounds_state = currentAffiliation.grounds_state;
        this.fields.grounds_postcode = currentAffiliation.grounds_postcode;
        this.fields.president_name = currentAffiliation.president_name;
        this.fields.drafts = JSON.parse(currentAffiliation.drafts);
        this.fields.secretary_name = currentAffiliation.secretary_name;
        this.fields.treasurer_name = currentAffiliation.treasurer_name;
        this.fields.other_name = currentAffiliation.other_name;
        this.fields.internet_access = currentAffiliation.internet_access === 1;
        this.fields.phone_service = currentAffiliation.phone_service === 1;
        this.fields.event_membership_agree = currentAffiliation.event_membership_agree;
      }
    },
    addDraft: function addDraft() {
      this.fields.drafts.push({
        start: '',
        end: ''
      });
    },
    submit: function submit() {
      var _this = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var mergedData, formData, result, product;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$v.$touch();

                if (!_this.$v.$invalid) {
                  _context.next = 5;
                  break;
                }

                _this.submitStatus = 'ERROR';
                _context.next = 14;
                break;

              case 5:
                // do your submit logic here
                _this.submitStatus = 'PENDING';
                mergedData = _objectSpread({}, _this.data, {}, _this.fields);
                formData = new FormData();
                formData.append('fields', JSON.stringify(mergedData));
                _context.next = 11;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(_this.$api, "/committee/affiliation"), formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 11:
                result = _context.sent;

                if (result.data.status === 'success') {
                  product = _this.$store.state.products.find(function (item) {
                    return item.type === 'Committee' && item.active === 1;
                  });
                  __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(_this.$api, "/total-cart"), {
                    data: [product.id],
                    user_id: _this.secretary.id
                  }).then(function (response) {
                    if (response.data.status === 'success') {
                      var committeeData = _objectSpread({
                        committee: _this.committeeDetails
                      }, response.data, {
                        secretary: {
                          id: _this.secretary.id,
                          email: _this.secretary.attributes.email,
                          member_number: _this.secretary.member_number
                        }
                      });

                      _this.$store.commit('updateCartMembers', committeeData);

                      _this.$router.push({
                        name: 'Committee Cart',
                        params: {
                          backTo: 'pay'
                        }
                      });

                      _this.submitStatus = 'SUCCESS';
                    }
                  }).catch(function (error) {
                    _this.processing = false; // eslint-disable-next-line

                    console.log(error);
                  });
                } else if (result.data.errors.name !== undefined) {
                  _this.errorStatus = result.data.errors.name[0];
                  _this.errorFields.name = true;
                } else {
                  _this.submitStatus = 'OK';
                  _this.errorStatus = 'Something went wrong. Please try again.';
                  _this.showModal = false;
                }

                _this.processing = false;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CommitteeNotRegistered',
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */]
  }
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CartForm__ = __webpack_require__(1071);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CommitteeCart",
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    CartForm: __WEBPACK_IMPORTED_MODULE_1__components_CartForm__["a" /* default */]
  },
  data: function data() {
    return {
      cartMembers: this.$store.getters.getCartMembers
    };
  }
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CartForm",
  props: ['cartMembers'],
  data: function data() {
    return {
      errors: '',
      committee: 'committee' in this.cartMembers ? this.cartMembers.committee : null,
      product: 'items' in this.cartMembers ? this.cartMembers.items[0] : null,
      total: 'total' in this.cartMembers ? this.cartMembers.total : 0
    };
  },
  methods: {
    submit: function submit() {
      this.$router.push('/committees/payment');
    }
  }
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Payment__ = __webpack_require__(140);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CommitteePayment",
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    payment: __WEBPACK_IMPORTED_MODULE_1__components_Payment__["a" /* default */]
  },
  data: function data() {
    return {
      cartMembers: this.$store.state.cartMembers
    };
  },
  mounted: function mounted() {
    if (!('total' in this.cartMembers)) {
      this.$router.push('/committees/cart');
    }
  }
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_memberProfileStore_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CommitteeDetailsSecretaries__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CommitteeDetailsMembersStatus__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CommitteeEdit__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Profile_components_CommitteeProfileFinancials__ = __webpack_require__(350);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */
// 'My Profile'






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CommitteeEditSecretary',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__store_memberProfileStore_js__["a" /* default */]],
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_0__components_TabLayout__["a" /* default */],
    'committee-edit': __WEBPACK_IMPORTED_MODULE_4__CommitteeEdit__["a" /* default */],
    'committee-details-secretaries': __WEBPACK_IMPORTED_MODULE_2__components_CommitteeDetailsSecretaries__["a" /* default */],
    'committee-profile-financials': __WEBPACK_IMPORTED_MODULE_5__Profile_components_CommitteeProfileFinancials__["a" /* default */],
    'committee-details-members-status': __WEBPACK_IMPORTED_MODULE_3__components_CommitteeDetailsMembersStatus__["a" /* default */]
  },
  data: function data() {
    return {
      selectedTab: this.tabSelect ? this.tabSelect : 'details',
      renew: this.renewing ? this.renewing : false,
      userID: localStorage.userID,
      userRole: localStorage.role
    };
  }
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_typeahead__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CommitteeDetailsSecretaries',
  props: ['committeeId'],
  components: {
    VueBootstrapTypeahead: __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_typeahead__["a" /* default */]
  },
  data: function data() {
    return {
      committee: null,
      user: localStorage.role,
      processing: false,
      errors: '',
      errorStatus: '',
      secretaries: [],
      secretariesSearch: '',
      selectedSecretary: null,
      addedSecretaries: '',
      removeProcessing: false,
      committeeDetails: null,
      isLoading: true
    };
  },
  methods: {
    getSecretaries: function getSecretaries(search_term) {
      var _this = this;

      if (!search_term) {
        this.secretaries = [];
      } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/secretaries/list"), {
          params: {
            search_term: search_term
          }
        }).then(function (response) {
          if (response.data.status === 'success') {
            _this.errors = '';
            _this.secretaries = response.data.data;
          } else {
            _this.errors = 'Something went wrong. Please reload the page.';
          }
        });
      }
    },
    handleAddSecretary: function handleAddSecretary() {
      var _this2 = this;

      this.processing = true;

      if (this.selectedSecretary) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/committee/").concat(this.committee.id, "/add-secretary"), {
          secretary_id: this.selectedSecretary.id
        }).then(function (response) {
          if (response.data.status === 'success') {
            _this2.processing = false;
            _this2.errors = '';

            if (_this2.selectedSecretary) {
              _this2.addedSecretaries.push(_this2.selectedSecretary);
            }

            _this2.selectedSecretary = null;
          } else {
            _this2.errors = 'Something went wrong. Please reload the page.';
          }
        });
      }

      this.processing = false;
    },
    removeSecretary: function removeSecretary(secretary_id, index) {
      var _this3 = this;

      this.$refs['secretary-item'][index].setAttribute('disabled', 'disabled');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(this.$api, "/admin/committee/").concat(this.committee.id, "/remove-secretary"), {
        secretary_id: secretary_id
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this3.addedSecretaries = _this3.addedSecretaries.filter(function (secretary) {
            return secretary.id !== secretary_id;
          });
          _this3.errors = '';
        } else {
          _this3.errors = 'Something went wrong. Please reload the page.';
        }
      });
    },
    getCommittee: function getCommittee(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/committee-details/").concat(id)).then(function (response) {
        var _response$data;

        if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.status) === 'success') {
          _this4.committeeDetails = response.data.data;
          _this4.isLoading = false;
        }
      }).catch(function (error) {
        // eslint-disable-next-line
        console.log(error);
        _this4.isLoading = false;
      });
    }
  },
  mounted: function mounted() {
    this.getCommittee(this.committeeId);
  },
  watch: {
    committeeDetails: function committeeDetails() {
      this.committee = _objectSpread({}, this.committeeDetails);
      this.addedSecretaries = this.committeeDetails.secretaries;
    },
    // eslint-disable-next-line func-names
    secretariesSearch: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (value) {
      this.getSecretaries(value);
    }, 500)
  }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_typeahead__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Modal__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CommitteeDetailsMembersStatus',
  props: ['committeeId'],
  components: {
    modal: __WEBPACK_IMPORTED_MODULE_3__components_Modal__["a" /* default */],
    VueBootstrapTypeahead: __WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_typeahead__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    this.getCommitteeMemberStatuses();
  },
  computed: {
    currentMembersIds: function currentMembersIds() {
      var ids = [];
      this.currentCommitteeMembers.forEach(function (member) {
        ids.push(member.id);
      });
      return ids;
    }
  },
  data: function data() {
    return {
      errors: '',
      checkedStatuses: [],
      committeeMembers: [],
      currentCommitteeMembers: [],
      formDataCheckboxes: [],
      foundCommitteeMembers: [],
      processing: false,
      searchMember: '',
      selectedMember: [],
      showModal: false,
      singleMemberEdit: [],
      singleMemberEditStatuses: [],
      singleMemberModal: false,
      success: '',
      statusesList: [],
      committeeDetails: null,
      isLoading: true
    };
  },
  methods: {
    checkMemberStatuses: function checkMemberStatuses() {
      var _this = this;

      this.checkedStatuses = [];
      this.committeeMembers.forEach(function (member) {
        if (!_this.checkedStatuses[member.id]) {
          _this.checkedStatuses[member.id] = [];
        }

        member.committee_membership_statuses.forEach(function (checked) {
          _this.checkedStatuses[member.id].push(checked.id);
        });
      });
      this.getCurrentCommitteeMembers();
    },
    getCommitteeMemberStatuses: function getCommitteeMemberStatuses() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("".concat(this.$api, "/committee/memberStatusList")).then(function (response) {
        _this2.statusesList = response.data.statuses;
      });
    },
    getCurrentCommitteeMembers: function getCurrentCommitteeMembers() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("".concat(this.$api, "/admin/committee/currentMembers/").concat(this.committeeDetails.id)).then(function (response) {
        if (response.data.status === 'success') {
          _this3.errors = '';
          _this3.currentCommitteeMembers = response.data.members;
        } else {
          _this3.errors = 'Something went wrong. Please reload the page.';
        }
      });
    },
    removeCommitteeMemberStatus: function removeCommitteeMemberStatus(member_id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("".concat(this.$api, "/admin/committees/save-member-status"), {
        params: {
          user_id: member_id,
          statuses: []
        }
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this4.getCurrentCommitteeMembers();
        }
      });
    },
    saveCommitteeMemberStatus: function saveCommitteeMemberStatus(member_id) {
      var _this5 = this;

      var edit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var form = document.getElementById("".concat(edit, "form_").concat(member_id));
      var checkboxes = form.querySelectorAll('input[type=checkbox]:checked');
      this.formDataCheckboxes = [];
      checkboxes.forEach(function (element) {
        _this5.formDataCheckboxes.push({
          committee_id: _this5.committeeDetails.id,
          user_id: member_id,
          status_id: element.value
        });
      });
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("".concat(this.$api, "/admin/committees/save-member-status"), {
        params: {
          user_id: member_id,
          statuses: this.formDataCheckboxes
        }
      }).then(function (response) {
        if (response.data.status === 'success') {
          _this5.getCurrentCommitteeMembers();

          _this5.success = "The member has been updated.";
        }
      });
    },
    searchCommitteeMember: function searchCommitteeMember(search_term) {
      var _this6 = this;

      var isSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!search_term) {
        this.committeeMembers = [];
      } else {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("".concat(this.$api, "/admin/committees/member-search"), {
          params: {
            searchMember: search_term
          }
        }).then(function (response) {
          if (response.data.status === 'success') {
            _this6.errors = '';

            if (isSearch) {
              _this6.committeeMembers = response.data.members;

              _this6.checkMemberStatuses();
            } else {
              _this6.foundCommitteeMembers = response.data.members;
            }
          } else {
            _this6.errors = 'Something went wrong. Please reload the page.';
          }
        });
      }
    },
    selectMember: function selectMember(selected) {
      this.committeeMembers = [];
      this.committeeMembers.push(selected);
      this.checkMemberStatuses();
    },
    setSingleMemberEdit: function setSingleMemberEdit(member_id) {
      var _this7 = this;

      this.singleMemberEdit = [];
      this.singleMemberEditStatuses = [];
      this.currentCommitteeMembers.forEach(function (member) {
        if (member.id === member_id) {
          _this7.singleMemberEdit = member;
          _this7.singleMemberEditStatuses[member.id] = [];
          member.committee_membership_statuses.forEach(function (checked) {
            _this7.singleMemberEditStatuses[member.id].push(checked.id);
          });
        }
      });
      this.singleMemberModal = true;
    },
    getCommittee: function getCommittee(id) {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("".concat(this.$api, "/admin/committee-details/").concat(id)).then(function (response) {
        var _response$data;

        if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.status) === 'success') {
          _this8.committeeDetails = response.data.data;
          _this8.isLoading = false;
        }
      }).catch(function (error) {
        // eslint-disable-next-line
        console.log(error);
        _this8.isLoading = false;
      });
    }
  },
  mounted: function mounted() {
    this.getCommittee(this.committeeId);
  },
  watch: {
    committeeDetails: function committeeDetails() {
      this.getCurrentCommitteeMembers();
    },
    // eslint-disable-next-line func-names
    searchMember: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function (value) {
      this.searchCommitteeMember(value);
    }, 500),
    // eslint-disable-next-line func-names
    selectedMember: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function (value) {
      this.selectMember(value);
    }, 500)
  }
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ListingLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CommitteeDetailsForm__ = __webpack_require__(1086);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var bsbRegex = __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["helpers"].regex('bsbRegex', /^[\d]{3}[-]{1}[\d]{3}$/);
var phoneRegex = __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["helpers"].regex('phoneRegex', /^([+][7][0-9]{10})|([+][6][1][0-9]{1,10})$/);
var abnRegex = __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["helpers"].regex('abnRegex', /^[\d]{11}$/);
var nameRegex = __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["helpers"].regex('name', /^[A-Za-z\s]*$/);
var accountNumberRegex = __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["helpers"].regex('accountNumberRegex', /^[\d]{6,10}$/);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuelidate___default.a);

var isValidFileSize = function isValidFileSize(value) {
  if (!value) {
    return true;
  }

  var file = value;
  return file.size < 1024 * 1024;
};

var isValidLogoSize = function isValidLogoSize(value) {
  if (!value) {
    return true;
  }

  var file = value;
  return file.size < 512 * 512;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CommitteeEdit',
  props: ['memberDetails'],
  components: {
    CommitteeDetailsForm: __WEBPACK_IMPORTED_MODULE_5__components_CommitteeDetailsForm__["a" /* default */],
    listingLayout: __WEBPACK_IMPORTED_MODULE_4__components_ListingLayout__["a" /* default */]
  },
  data: function data() {
    return {
      userID: localStorage.userID,
      userRole: localStorage.role,
      errors: [],
      errorFields: {},
      errorStatus: null,
      zoneNotFound: false,
      zoneFound: false,
      zoneNotSpecified: false,
      zoneLocations: [],
      data: {
        post_code: '',
        zone_id: '',
        state: '',
        name: '',
        contact_name: '',
        contact_email: '',
        contact_phone: '',
        abn: '',
        cheques_to: '',
        address: '',
        city: '',
        account_number: '',
        bsb: '',
        bank_abbreviation: '',
        gst_registered: '',
        bank_owner_first_name: '',
        bank_owner_last_name: '',
        bank_owner_dob: '',
        is_enabled_stripe: '',
        is_stripe_verified: '',
        logo_file_path: '',
        logo_file_name: '',
        is_financial: ''
      },
      submitStatus: null,
      file_name: null,
      files: [],
      fileError: {
        fileSize: false,
        required: false
      },
      logoError: {
        logoSize: false,
        required: false
      },
      logo_file: [],
      logo_name: null,
      isLoading: true,
      isDeleted: false
    };
  },
  validations: function validations() {
    var validationRules = {
      data: {
        state: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        post_code: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        zone_id: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        name: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
          nameRegex: nameRegex
        },
        contact_email: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
          email: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["email"]
        },
        contact_phone: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
          phoneRegex: phoneRegex
        },
        abn: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
          abnRegex: abnRegex
        },
        cheques_to: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        pic_number: {},
        address: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        city: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        account_number: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
          accountNumberRegex: accountNumberRegex
        },
        bsb: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
          bsbRegex: bsbRegex
        },
        contact_name: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        bank_abbreviation: {},
        gst_registered: {}
      }
    };

    if (Number(this.data.is_enabled_stripe)) {
      validationRules.data.bank_owner_first_name = {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      };
      validationRules.data.bank_owner_last_name = {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      };
      validationRules.data.bank_owner_dob = {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      };
    }

    return validationRules;
  },
  created: function created() {
    this.getZoneLocations();
  },
  mounted: function mounted() {
    if (this.memberDetails.committee_id) {
      this.getCommittee(this.memberDetails.committee_id);
    }
  },
  watch: {
    memberDetails: function memberDetails() {
      if (!this.memberDetails.committee_id) {
        this.$router.push('/committees/not-registered');
      }

      this.getCommittee(this.memberDetails.committee_id);
    },
    'data.is_stripe_verified': function dataIs_stripe_verified(value) {
      if (value > 0) {
        this.file = null;
        this.file_name = null;
      }
    }
  },
  methods: {
    scrollToValidationError: function scrollToValidationError() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.$refs.validationErrorAlert) {
          _this.$refs.validationErrorAlert.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var formData, result, _result$data, _result$data$errors;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.errorFields = {};
                _this2.fileError = {
                  fileSize: false,
                  required: false
                };
                _this2.errorStatus = null; // eslint-disable-next-line eqeqeq

                if (_this2.data.is_enabled_stripe === '1' && !_this2.data.is_stripe_verified && !_this2.file) {
                  _this2.submitStatus = 'ERROR';
                  _this2.fileError.required = true;
                } else if (!isValidFileSize(_this2.file)) {
                  _this2.submitStatus = 'ERROR';
                  _this2.fileError.fileSize = true;
                }

                _this2.$v.$touch();

                if (!(_this2.$v.$invalid || _this2.fileError.required === true || _this2.fileError.fileSize)) {
                  _context.next = 10;
                  break;
                }

                _this2.submitStatus = 'ERROR';

                _this2.scrollToValidationError();

                _context.next = 20;
                break;

              case 10:
                // do your submit logic here
                _this2.submitStatus = 'PENDING';
                formData = new FormData();
                formData.append('identity_file', _this2.file);
                formData.append('logo_file', _this2.logo_file);
                formData.append('fields', JSON.stringify(_this2.data));
                _context.next = 17;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(_this2.$api, "/committees/edit"), formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 17:
                result = _context.sent;

                if (result.data.status === 'success') {
                  _this2.submitStatus = 'SUCCESS';
                  _this2.data.is_stripe_verified = result.data.data.is_stripe_verified;
                  _this2.data.logo_file_name = result.data.data.logo_file_name;
                  _this2.data.logo_file_path = result.data.data.logo_file_path;

                  _this2.deleteLogoAttachment();
                } else {
                  _this2.submitStatus = 'OK';
                  _this2.errorStatus = 'Something went wrong. Please try again.';
                }

                if (result.data.status === 'validation_error') {
                  _this2.submitStatus = 'ERROR';

                  if (result.data.errors.contact_email !== undefined) {
                    _this2.errorStatus = (result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : (_result$data$errors = _result$data.errors) === null || _result$data$errors === void 0 ? void 0 : _result$data$errors.contact_email[0]) ? result.data.errors.contact_email[0] : 'Committee email must be unique among committee and user emails';
                    _this2.errorFields.contact_email = true;
                  } else if (result.data.errors.account_number !== undefined) {
                    _this2.errorStatus = 'Committee account number is not valid';
                    _this2.errorFields.account_number = true;
                  } else if (result.data.errors.routing_number !== undefined) {
                    _this2.errorStatus = 'Committee BSB is not valid';
                    _this2.errorFields.routing_number = true;
                  } else if (result.data.errors.postal_code !== undefined) {
                    _this2.errorStatus = 'Committee postcode is not valid';
                    _this2.errorFields.postal_code = true;
                  } else if (result.data.errors.city !== undefined) {
                    _this2.errorStatus = 'Committee city is not valid';
                    _this2.errorFields.city = true;
                  } else if (result.data.errors.line1 !== undefined) {
                    _this2.errorStatus = 'Committee address file is not valid';
                    _this2.errorFields.line1 = true;
                  } else if (result.data.errors.abn !== undefined) {
                    _this2.errorStatus = 'Committee ABN is not valid';
                    _this2.errorFields.abn = true;
                  } else if (result.data.errors.name !== undefined) {
                    _this2.errorStatus = result.data.errors.name[0];
                    _this2.errorFields.name = true;
                  } else {
                    _this2.errorStatus = 'server validation error';
                  }

                  _this2.scrollToValidationError();
                }

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    findZone: function findZone() {
      var _this$data,
          _this3 = this,
          _this$data2;

      var coincidenceZones = [];

      if ((_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.city) {
        coincidenceZones = this.zoneLocations.filter(function (location) {
          var _this3$data;

          return ((_this3$data = _this3.data) === null || _this3$data === void 0 ? void 0 : _this3$data.city.toLowerCase()) === location.suburb.toLowerCase();
        });
      }

      if ((_this$data2 = this.data) === null || _this$data2 === void 0 ? void 0 : _this$data2.post_code) {
        // eslint-disable-next-line
        coincidenceZones = this.zoneLocations.filter(function (location) {
          var _this3$data2, _this3$data3;

          return ((_this3$data2 = _this3.data) === null || _this3$data2 === void 0 ? void 0 : _this3$data2.post_code) === location.postcode && ((_this3$data3 = _this3.data) === null || _this3$data3 === void 0 ? void 0 : _this3$data3.city.toLowerCase()) === location.suburb.toLowerCase();
        });
      }

      if (coincidenceZones.length === 1) {
        this.zoneNotFound = false;
        this.zoneFound = true;
        this.data.zone_id = coincidenceZones[0].zone_id;
      } else if (coincidenceZones.length > 1) {
        this.zoneNotSpecified = true;
        this.zoneFound = true;
        this.zoneNotFound = false;
      } else {
        this.zoneNotFound = true;
        this.zoneFound = false;
        this.zoneNotSpecified = false;
      }
    },
    getZoneLocations: function getZoneLocations() {
      var _this4 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var _ref, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(_this4.$api, "/zone-location/list"));

              case 3:
                _ref = _context2.sent;
                data = _ref.data.data;
                _this4.zoneLocations = data || [];
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                _this4.errorStatus = 'Can\'t fetch zone locations error';

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 8]]);
      }))();
    },
    isCurrentAffiliationExist: function isCurrentAffiliationExist() {
      return this.data.current_affiliation;
    },
    isCurrentAffiliationCompleted: function isCurrentAffiliationCompleted() {
      return this.data.current_affiliation.is_completed === 1;
    },
    isCurrentAffiliationinvoiceCreated: function isCurrentAffiliationinvoiceCreated() {
      return this.data.current_affiliation.is_invoice_created === 1;
    },
    fileUpload: function fileUpload(event) {
      this.fileError = {
        fileSize: false,
        required: false
      };
      this.file_name = '';
      var uploadedFile = event.target.files[0];
      this.file = uploadedFile;

      if (uploadedFile) {
        this.file_name = uploadedFile.name;
      }
    },
    logoUpload: function logoUpload(event) {
      this.logoError = {
        logoSize: false,
        required: false
      };
      this.logo_name = '';
      var uploadedFile = event.target.files[0];
      this.logo_file = uploadedFile;

      if (uploadedFile) {
        this.logo_name = uploadedFile.name;
      }

      if (!isValidLogoSize(uploadedFile)) {
        this.submitStatus = 'ERROR';
        this.logoError.fileSize = true;
        delete this.logo_file;
        this.logo_file = undefined;
        this.logo_name = '';
      }
    },
    deleteLogoAttachment: function deleteLogoAttachment() {
      delete this.logo_file;
      this.logo_file = undefined;
      this.logo_name = '';
    },
    deleteAttachment: function deleteAttachment() {
      delete this.file;
      this.file = undefined;
      this.file_name = '';
    },
    deleteExistsAttachment: function deleteExistsAttachment() {
      this.data.logo_file_path = '';
      this.data.logo_file_name = '';
    },
    downloadLogoFile: function downloadLogoFile(id) {
      if (id) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/committees/download/").concat(id)).then(function (response) {
          window.open(response.data.path, '_blank');
        });
      }
    },
    validateBankBsb: function validateBankBsb(event) {
      var _event$data;

      var value = event.target.value.replaceAll(/[^0-9]/g, '');
      var valueLength = value.length;
      var newValue = value;

      if (event.data === '-' && valueLength < 3 || event.inputType === 'insertFromPaste' || ((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.match(/[0-9]/)) && valueLength === 3 || valueLength > 2) {
        newValue = "".concat(value.replaceAll(/[^0-9]/g, '').slice(0, 3), "-").concat(value.replaceAll(/[^0-9]/g, '').slice(3));
      }

      if ((event.inputType === 'deleteContentBackward' || event.inputType === 'deleteContentForward') && valueLength === 3 || valueLength < 3) {
        newValue = value.replaceAll(/[^0-9]/g, '');
      }

      this.data.bsb = newValue;
    },
    getCommittee: function getCommittee(id) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/committee-details/").concat(id)).then(function (response) {
        var _response$data, _response$data2;

        if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.status) === 'success') {
          _this5.data = response.data.data;
          _this5.isLoading = false;
        } else if ((response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.status) === 'committee_is_deleted') {
          _this5.isDeleted = true;
        }
      }).catch(function (error) {
        // eslint-disable-next-line
        console.log(error);
        _this5.isLoading = false;
      });
    },
    redirectToAffiliationPage: function redirectToAffiliationPage() {
      var _this6 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this6.submit();

              case 2:
                if (_this6.submitStatus === 'SUCCESS' || _this6.submitStatus === 'OK') {
                  _this6.$router.push('/committees/affiliation');
                }

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    redirectToCartPage: function redirectToCartPage() {
      var _this7 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        var product;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                product = _this7.$store.state.products.find(function (item) {
                  return item.type === 'Committee' && item.active === 1;
                });
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(_this7.$api, "/total-cart"), {
                  data: [product.id],
                  user_id: _this7.memberDetails.id
                }).then(function (response) {
                  if (response.data.status === 'success') {
                    var committeeData = _objectSpread({
                      committee: _this7.data
                    }, response.data, {
                      secretary: {
                        id: _this7.memberDetails.id,
                        email: _this7.memberDetails.attributes.email,
                        member_number: _this7.memberDetails.member_number
                      }
                    });

                    _this7.$store.commit('updateCartMembers', committeeData);

                    _this7.$router.push({
                      name: 'Committee Cart',
                      params: {
                        backTo: 'pay'
                      }
                    });

                    _this7.submitStatus = 'SUCCESS';
                  }
                }).catch(function (error) {
                  _this7.processing = false; // eslint-disable-next-line

                  console.log(error);
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    cancelAffiliation: function cancelAffiliation() {
      var _this8 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete("".concat(_this8.$api, "/committee/affiliation/").concat(_this8.data.current_affiliation.id, "/cancel")).then(function (response) {
                  var _response$data3;

                  if ((response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.status) === 'success') {
                    window.location.reload();
                  }
                }).catch(function (error) {
                  // eslint-disable-next-line
                  console.log(error);
                  _this8.isLoading = false;
                });

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  },
  computed: {
    zoneErrorMessage: function zoneErrorMessage() {
      return this.warningMessage ? this.warningMessage : null;
    }
  }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var bsbRegex = __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["helpers"].regex('bsbRegex', /^[[\d]{3}[-]{1}[\d]{3}$/);
var phoneRegex = __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["helpers"].regex('phoneRegex', /^([+][7][0-9]{10})|([+][6][1][0-9]{1,10})$/);
var abnRegex = __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["helpers"].regex('abnRegex', /^[\d]{11}$/);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuelidate___default.a);

var isValidFileSize = function isValidFileSize(value) {
  if (!value) {
    return true;
  }

  var file = value;
  return file.size < 1024 * 1024;
};

var isValidLogoSize = function isValidLogoSize(value) {
  if (!value) {
    return true;
  }

  var file = value;
  return file.size < 512 * 512;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CommitteeDetailsForm',
  props: ['committeeDetails', 'isLoading'],
  data: function data() {
    return {
      errors: [],
      errorFields: {},
      errorStatus: null,
      zoneNotFound: false,
      zoneFound: false,
      zoneNotSpecified: false,
      zoneLocations: [],
      data: {
        post_code: '',
        zone_id: '',
        state: '',
        name: '',
        contact_name: '',
        contact_email: '',
        contact_phone: '',
        abn: '',
        cheques_to: '',
        address: '',
        city: '',
        account_number: '',
        bsb: '',
        bank_abbreviation: '',
        gst_registered: '',
        bank_owner_first_name: '',
        bank_owner_last_name: '',
        bank_owner_dob: '',
        is_enabled_stripe: '',
        is_stripe_verified: '',
        logo_file_path: '',
        logo_file_name: ''
      },
      submitStatus: null,
      file_name: null,
      files: [],
      fileError: {
        fileSize: false,
        required: false
      },
      logoError: {
        logoSize: false,
        required: false
      },
      logo_file: [],
      logo_name: null
    };
  },
  validations: function validations() {
    var validationRules = {
      data: {
        state: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        post_code: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        zone_id: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        name: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        contact_email: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
          email: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["email"]
        },
        contact_phone: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
          phoneRegex: phoneRegex
        },
        abn: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
          abnRegex: abnRegex
        },
        cheques_to: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        pic_number: {},
        address: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        city: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        account_number: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        bsb: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
          bsbRegex: bsbRegex
        },
        contact_name: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        bank_abbreviation: {},
        gst_registered: {}
      }
    };

    if (Number(this.data.is_enabled_stripe)) {
      validationRules.data.bank_owner_first_name = {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      };
      validationRules.data.bank_owner_last_name = {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      };
      validationRules.data.bank_owner_dob = {
        required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
      };
    }

    return validationRules;
  },
  created: function created() {
    this.getZoneLocations();
  },
  watch: {
    committeeDetails: function committeeDetails() {
      this.data = _objectSpread({}, this.committeeDetails);
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var formData, result, _result$data, _result$data$errors;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.errorFields = {};
                _this.fileError = {
                  fileSize: false,
                  required: false
                };
                _this.errorStatus = null; // eslint-disable-next-line eqeqeq

                if (_this.data.is_enabled_stripe === '1' && !_this.data.is_stripe_verified && !_this.file) {
                  _this.submitStatus = 'ERROR';
                  _this.fileError.required = true;
                } else if (!isValidFileSize(_this.file)) {
                  _this.submitStatus = 'ERROR';
                  _this.fileError.fileSize = true;
                }

                _this.$v.$touch();

                if (!(_this.$v.$invalid || _this.fileError.required === true || _this.fileError.fileSize)) {
                  _context.next = 9;
                  break;
                }

                _this.submitStatus = 'ERROR';
                _context.next = 19;
                break;

              case 9:
                // do your submit logic here
                _this.submitStatus = 'PENDING';
                formData = new FormData();
                formData.append('identity_file', _this.file);
                formData.append('logo_file', _this.logo_file);
                formData.append('fields', JSON.stringify(_this.data));
                _context.next = 16;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(_this.$api, "/committees/edit"), formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                });

              case 16:
                result = _context.sent;

                if (result.data.status === 'success') {
                  _this.submitStatus = 'SUCCESS';
                  _this.data.is_stripe_verified = result.data.data.is_stripe_verified;
                  _this.data.logo_file_name = result.data.data.logo_file_name;
                  _this.data.logo_file_path = result.data.data.logo_file_path;

                  _this.deleteLogoAttachment();
                } else {
                  _this.submitStatus = 'OK';
                  _this.errorStatus = 'Something went wrong. Please try again.';
                }

                if (result.data.status === 'validation_error') {
                  _this.submitStatus = 'ERROR';

                  if (result.data.errors.contact_email !== undefined) {
                    _this.errorStatus = (result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : (_result$data$errors = _result$data.errors) === null || _result$data$errors === void 0 ? void 0 : _result$data$errors.contact_email[0]) ? result.data.errors.contact_email[0] : 'Committee email must be unique among committee and user emails';
                    _this.errorFields.contact_email = true;
                  } else if (result.data.errors.account_number !== undefined) {
                    _this.errorStatus = 'Committee account number is not valid';
                    _this.errorFields.account_number = true;
                  } else if (result.data.errors.routing_number !== undefined) {
                    _this.errorStatus = 'Committee BSB is not valid';
                    _this.errorFields.routing_number = true;
                  } else if (result.data.errors.postal_code !== undefined) {
                    _this.errorStatus = 'Committee postcode is not valid';
                    _this.errorFields.postal_code = true;
                  } else if (result.data.errors.city !== undefined) {
                    _this.errorStatus = 'Committee city is not valid';
                    _this.errorFields.city = true;
                  } else if (result.data.errors.line1 !== undefined) {
                    _this.errorStatus = 'Committee address file is not valid';
                    _this.errorFields.line1 = true;
                  } else if (result.data.errors.abn !== undefined) {
                    _this.errorStatus = 'Committee ABN is not valid';
                    _this.errorFields.abn = true;
                  } else {
                    _this.errorStatus = 'server validation error';
                  }
                }

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    findZone: function findZone() {
      var _this$data,
          _this2 = this,
          _this$data2;

      var coincidenceZones = [];

      if ((_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.city) {
        coincidenceZones = this.zoneLocations.filter(function (location) {
          var _this2$data;

          return ((_this2$data = _this2.data) === null || _this2$data === void 0 ? void 0 : _this2$data.city.toLowerCase()) === location.suburb.toLowerCase();
        });
      }

      if ((_this$data2 = this.data) === null || _this$data2 === void 0 ? void 0 : _this$data2.post_code) {
        // eslint-disable-next-line
        coincidenceZones = this.zoneLocations.filter(function (location) {
          var _this2$data2, _this2$data3;

          return ((_this2$data2 = _this2.data) === null || _this2$data2 === void 0 ? void 0 : _this2$data2.post_code) === location.postcode && ((_this2$data3 = _this2.data) === null || _this2$data3 === void 0 ? void 0 : _this2$data3.city.toLowerCase()) === location.suburb.toLowerCase();
        });
      }

      if (coincidenceZones.length === 1) {
        this.zoneNotFound = false;
        this.zoneFound = true;
        this.data.zone_id = coincidenceZones[0].zone_id;
      } else if (coincidenceZones.length > 1) {
        this.zoneNotSpecified = true;
        this.zoneFound = true;
        this.zoneNotFound = false;
      } else {
        this.zoneNotFound = true;
        this.zoneFound = false;
        this.zoneNotSpecified = false;
      }
    },
    getZoneLocations: function getZoneLocations() {
      var _this3 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var _ref, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(_this3.$api, "/zone-location/list"));

              case 3:
                _ref = _context2.sent;
                data = _ref.data.data;
                _this3.zoneLocations = data || [];
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                _this3.errorStatus = 'Can\'t fetch zone locations error';

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 8]]);
      }))();
    },
    fileUpload: function fileUpload(event) {
      this.fileError = {
        fileSize: false,
        required: false
      };
      this.file_name = '';
      var uploadedFile = event.target.files[0];
      this.file = uploadedFile;

      if (uploadedFile) {
        this.file_name = uploadedFile.name;
      }
    },
    logoUpload: function logoUpload(event) {
      this.logoError = {
        logoSize: false,
        required: false
      };
      this.logo_name = '';
      console.log(event.target.files);
      var uploadedFile = event.target.files[0];
      this.logo_file = uploadedFile;

      if (uploadedFile) {
        this.logo_name = uploadedFile.name;
      }

      if (!isValidLogoSize(uploadedFile)) {
        this.submitStatus = 'ERROR';
        this.logoError.fileSize = true;
        delete this.logo_file;
        this.logo_file = undefined;
        this.logo_name = '';
      }
    },
    deleteLogoAttachment: function deleteLogoAttachment() {
      delete this.logo_file;
      this.logo_file = undefined;
      this.logo_name = '';
    },
    deleteAttachment: function deleteAttachment() {
      delete this.file;
      this.file = undefined;
      this.file_name = '';
    },
    deleteExistsAttachment: function deleteExistsAttachment() {
      this.data.logo_file_path = '';
      this.data.logo_file_name = '';
    },
    downloadLogoFile: function downloadLogoFile(id) {
      if (id) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("".concat(this.$api, "/admin/committees/download/").concat(id)).then(function (response) {
          window.open(response.data.path, '_blank');
        });
      }
    },
    validateBankBsb: function validateBankBsb(event) {
      var _event$data;

      var value = event.target.value.replaceAll(/[^0-9]/g, '');
      var valueLength = value.length;
      var newValue = value;

      if (event.data === '-' && valueLength < 3 || event.inputType === 'insertFromPaste' || ((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.match(/[0-9]/)) && valueLength === 3 || valueLength > 2) {
        newValue = "".concat(value.replaceAll(/[^0-9]/g, '').slice(0, 3), "-").concat(value.replaceAll(/[^0-9]/g, '').slice(3));
      }

      if ((event.inputType === 'deleteContentBackward' || event.inputType === 'deleteContentForward') && valueLength === 3 || valueLength < 3) {
        newValue = value.replaceAll(/[^0-9]/g, '');
      }

      this.data.bsb = newValue;
    }
  },
  computed: {
    zoneErrorMessage: function zoneErrorMessage() {
      return this.warningMessage ? this.warningMessage : null;
    }
  }
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FSearchSelect_vue__ = __webpack_require__(295);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cae96b6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FSearchSelect_vue__ = __webpack_require__(772);
function injectStyle (ssrContext) {
  __webpack_require__(771)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8cae96b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FSearchSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cae96b6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FSearchSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  getLists: function getLists() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/nomination-lists');
  },
  getDashboard: function getDashboard(draftId, params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/nominations"), {
      params: params
    });
  },
  draft: function draft(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/nominations/drafts/".concat(draftId));
  },
  members: function members(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/nominations/members', {
      params: params
    });
  },
  membersSearch: function membersSearch(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/nominations/members-search', {
      params: params
    });
  },
  draftEvents: function draftEvents(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/nominations/drafts/".concat(draftId, "/events"));
  },
  memberHorses: function memberHorses(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/nominations/members/".concat(userId, "/horses"), {
      params: params
    });
  },
  horseEvents: function horseEvents(horseId, params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/nominations/horses/".concat(horseId, "/events"), {
      params: params
    });
  },
  submissionEventsForDraft: function submissionEventsForDraft(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/nominations/drafts/".concat(draftId, "/submission-events"));
  },
  submissionQuantityForMember: function submissionQuantityForMember(userId, params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/nominations/members/".concat(userId, "/submission-quantity"), {
      params: params
    });
  },
  create: function create(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/v2/nominations', data, {
      silent: true
    });
  },
  storeSubmission: function storeSubmission(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/v2/nominations/submissions', data, {
      silent: true
    });
  },
  userNominations: function userNominations(draftId, params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/nominations/drafts/".concat(draftId, "/user"), {
      params: params
    });
  },
  deleteNomination: function deleteNomination(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete("/v2/nominations/".concat(id), {
      silent: true,
      localSuccess: true
    });
  },
  bulkScratch: function bulkScratch(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/v2/nominations/bulk-scratch', data, {
      silent: true,
      localSuccess: true
    });
  },
  updateNomination: function updateNomination(id, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/nominations/".concat(id), data, {
      silent: true,
      localSuccess: true
    });
  },
  reorderNominations: function reorderNominations(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/v2/nominations/reorder', data, {
      silent: true,
      localSuccess: true
    });
  },
  reorderRuns: function reorderRuns(draftId, eventId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/drafts/".concat(draftId, "/events/").concat(eventId, "/nominations/run-order"), data, {
      silent: true,
      localSuccess: true
    });
  },
  bulkMove: function bulkMove(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/v2/nominations/bulk-move', data, {
      silent: true,
      localSuccess: true
    });
  },
  accountDetail: function accountDetail(draftId, params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/nominations/account-detail"), {
      params: params
    });
  },
  moveToEvent: function moveToEvent(nominationId, eventId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/nominations/".concat(nominationId, "/move-to-event"), {
      event_id: eventId
    }, {
      silent: true,
      localSuccess: true
    });
  },
  getCommits: function getCommits() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/nomination-commits');
  },
  updateCommit: function updateCommit(draftId, payload) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/drafts/".concat(draftId, "/nominations/commit"), payload, {
      silent: true,
      localSuccess: true
    });
  },
  getPaymentStatuses: function getPaymentStatuses() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/nomination-payment-statuses');
  },
  updatePaymentStatus: function updatePaymentStatus(draftId, payload) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/drafts/".concat(draftId, "/nominations/payment-status"), payload, {
      silent: true,
      localSuccess: true
    });
  },
  bulkMessageOptions: function bulkMessageOptions(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/nominations/bulk-message/options"));
  },
  bulkMessage: function bulkMessage(draftId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/drafts/".concat(draftId, "/nominations/bulk-message"), data, {
      silent: true
    });
  },
  getReassignCandidates: function getReassignCandidates(draftId, type, params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/nominations/reassign-candidates/").concat(type), {
      params: params
    });
  },
  getReassignSource: function getReassignSource(draftId, type, id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/nominations/reassign-source/").concat(type, "/").concat(id));
  },
  searchReassign: function searchReassign(draftId, type, params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/nominations/reassign-search/").concat(type), {
      params: params
    });
  },
  reassign: function reassign(draftId, type, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/drafts/".concat(draftId, "/nominations/reassign/").concat(type), data, {
      silent: true
    });
  },
  getFilterStatuses: function getFilterStatuses() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/nomination-filter-statuses');
  },
  getStatisticsByEvent: function getStatisticsByEvent(eventId, params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/events/".concat(eventId, "/nominations/statistics"), {
      params: params
    });
  },
  scratchByStatus: function scratchByStatus(eventId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/events/".concat(eventId, "/nominations/scratch-by-status"), data, {
      silent: true
    });
  }
});

/***/ }),
/* 438 */,
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


/* harmony default export */ __webpack_exports__["a"] = ({
  getDashboard: function getDashboard(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/drafts/draws-dashboard', {
      params: params
    });
  },
  getPublicDrawsInfo: function getPublicDrawsInfo(eventId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/events/".concat(eventId, "/draws/public/info"));
  },
  getPublicDraws: function getPublicDraws(eventId, round) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/events/".concat(eventId, "/draws/public"), {
      params: _objectSpread({}, params, {
        round: round
      })
    });
  },
  getEventInfo: function getEventInfo(eventId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/events/".concat(eventId, "/draws/info"));
  },
  getRoundCheck: function getRoundCheck(eventId, round) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/events/".concat(eventId, "/draws/rounds/").concat(round, "/check"));
  },
  getTieCheck: function getTieCheck(eventId, round) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/events/".concat(eventId, "/draws/rounds/").concat(round, "/tie-check"));
  },
  getEventMeta: function getEventMeta(eventId, params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/events/".concat(eventId, "/draws/meta"), {
      params: params
    });
  },
  getRoundDraws: function getRoundDraws(eventId, round, params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/events/".concat(eventId, "/draws/rounds/").concat(round), {
      params: params
    });
  },
  getRoundResults: function getRoundResults(eventId, round) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/events/".concat(eventId, "/draws/rounds/").concat(round, "/results"));
  },
  markDraw: function markDraw(drawId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/draws/".concat(drawId, "/mark"), data, {
      silent: true,
      localSuccess: true
    });
  },
  deleteDraw: function deleteDraw(drawId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete("/v2/draws/".concat(drawId), {
      silent: true
    });
  },
  moveDraw: function moveDraw(drawId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/draws/".concat(drawId, "/move"), data, {
      silent: true
    });
  },
  swapDraws: function swapDraws(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/v2/draws/swap', data, {
      silent: true
    });
  },
  cleanSlate: function cleanSlate(data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch('/v2/draws/clean-slate', data, {
      silent: true
    });
  },
  publishRound: function publishRound(eventId, round) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/events/".concat(eventId, "/draws/rounds/").concat(round, "/publish"), {}, {
      silent: true
    });
  },
  resetTotalScore: function resetTotalScore(eventId, round) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/events/".concat(eventId, "/draws/rounds/").concat(round, "/reset-total-score"), {}, {
      silent: true
    });
  },
  publishAll: function publishAll(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/drafts/".concat(draftId, "/draws/publish-all"), {}, {
      silent: true,
      localSuccess: true
    });
  },
  resendNotifications: function resendNotifications(draftId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/drafts/".concat(draftId, "/draws/resend-notifications"), data, {
      silent: true
    });
  },
  queueGenerate: function queueGenerate(eventId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/events/".concat(eventId, "/draws/queue-generate"), data, {
      silent: true,
      localSuccess: true
    });
  },
  queueGenerateAll: function queueGenerateAll(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/drafts/".concat(draftId, "/draws/queue-generate-all"), {}, {
      silent: true,
      localSuccess: true
    });
  },
  setWinner: function setWinner(drawId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/draws/".concat(drawId, "/winner"), {}, {
      silent: true
    });
  },
  updateStatus: function updateStatus(drawId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/draws/".concat(drawId, "/status"), data, {
      silent: true
    });
  },
  generateRound: function generateRound(eventId, round) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/events/".concat(eventId, "/draws/rounds/").concat(round, "/generate"), {}, {
      silent: true
    });
  },
  generateNext: function generateNext(eventId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/events/".concat(eventId, "/draws/generate-next"), data, {
      silent: true
    });
  },
  generateInto: function generateInto(fromEvent, toEvent, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/events/".concat(fromEvent, "/draws/generate-into/").concat(toEvent), data, {
      silent: true
    });
  },
  regenerateFirstRound: function regenerateFirstRound(eventId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/events/".concat(eventId, "/draws/regenerate-first-round"), {}, {
      silent: true
    });
  },
  memberSearch: function memberSearch(eventId, round, params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/events/".concat(eventId, "/draws/rounds/").concat(round, "/members/search"), {
      params: params
    });
  },
  memberHorses: function memberHorses(eventId, round, memberId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/events/".concat(eventId, "/draws/rounds/").concat(round, "/members/").concat(memberId, "/horses"));
  },
  insert: function insert(eventId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/events/".concat(eventId, "/draws"), data, {
      silent: true
    });
  },
  restore: function restore(drawId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/draws/".concat(drawId, "/restore"), data, {
      silent: true
    });
  },
  reorder: function reorder(eventId, round, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/events/".concat(eventId, "/draws/rounds/").concat(round, "/reorder"), data, {
      silent: true
    });
  },
  getEmptySlots: function getEmptySlots(eventId, round) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/events/".concat(eventId, "/draws/rounds/").concat(round, "/empty-slots"));
  },
  swapCandidates: function swapCandidates(eventId, round, params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/events/".concat(eventId, "/draws/rounds/").concat(round, "/swap-candidates"), {
      params: params
    });
  },
  refund: function refund(eventId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/events/".concat(eventId, "/draws/refunds"), data, {
      silent: true
    });
  },
  refundStatus: function refundStatus(eventId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/events/".concat(eventId, "/draws/refund-status"));
  },
  generateRunOff: function generateRunOff(eventId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/events/".concat(eventId, "/draws/run-off/generate"), {}, {
      silent: true
    });
  },
  getPublicDashboard: function getPublicDashboard() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/drafts/draws/public');
  },
  updateNominationCommit: function updateNominationCommit(draftId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/drafts/".concat(draftId, "/draws/nominations/commit"), data, {
      silent: true
    });
  },
  updateNominationPayment: function updateNominationPayment(draftId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/drafts/".concat(draftId, "/draws/nominations/payment-status"), data, {
      silent: true
    });
  },
  printPdf: function printPdf(eventId, round, type) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/events/".concat(eventId, "/draws/rounds/").concat(round, "/print/").concat(type), {
      responseType: 'blob'
    });
  },
  exportCsv: function exportCsv(eventId, round) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/events/".concat(eventId, "/draws/rounds/").concat(round, "/export.csv"), {
      responseType: 'blob'
    });
  }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppCheckbox_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9bc3f38_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppCheckbox_vue__ = __webpack_require__(712);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppCheckbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9bc3f38_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppCheckbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocModal_vue__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a4e4630_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocModal_vue__ = __webpack_require__(731);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a4e4630_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  availableForEvent: function availableForEvent(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/judges/available-for-event', {
      params: params
    });
  },
  // Cursor-paginated picker (CAM-1477 follow-up) — EventAddDetails.vue's search-select.
  options: function options(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/judges/options', {
      params: params
    });
  }
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  riderHistory: function riderHistory(memberId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/members/".concat(memberId, "/boy-status-history"));
  },
  horseHistory: function horseHistory(horseId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/horses/".concat(horseId, "/boy-status-history"));
  },
  riderStatuses: function riderStatuses() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/rider-statuses');
  },
  horseStatuses: function horseStatuses() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/horse-statuses');
  },
  horseOwnerOptions: function horseOwnerOptions(horseId, search) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/horses/".concat(horseId, "/boy-status-owner-options"), {
      params: {
        search: search
      }
    });
  },
  createRider: function createRider(memberId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/members/".concat(memberId, "/boy-status-history"), data, {
      silent: true
    });
  },
  updateRider: function updateRider(memberId, riderStateId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/members/".concat(memberId, "/boy-status-history/").concat(riderStateId), data, {
      silent: true
    });
  },
  createHorse: function createHorse(horseId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/horses/".concat(horseId, "/boy-status-history"), data, {
      silent: true
    });
  },
  updateHorse: function updateHorse(horseId, horseStateId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/horses/".concat(horseId, "/boy-status-history/").concat(horseStateId), data, {
      silent: true
    });
  },
  riderAffectedResults: function riderAffectedResults(memberId, riderStateId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/members/".concat(memberId, "/boy-status-history/").concat(riderStateId, "/affected-results"));
  },
  horseAffectedResults: function horseAffectedResults(horseId, horseStateId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/horses/".concat(horseId, "/boy-status-history/").concat(horseStateId, "/affected-results"));
  },
  riderRecalculatePreview: function riderRecalculatePreview(memberId, riderStateId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/members/".concat(memberId, "/boy-status-history/").concat(riderStateId, "/recalculate-preview"), {}, {
      silent: true
    });
  },
  horseRecalculatePreview: function horseRecalculatePreview(horseId, horseStateId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/horses/".concat(horseId, "/boy-status-history/").concat(horseStateId, "/recalculate-preview"), {}, {
      silent: true
    });
  },
  riderRecalculate: function riderRecalculate(memberId, riderStateId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/members/".concat(memberId, "/boy-status-history/").concat(riderStateId, "/recalculate"), {}, {
      silent: true
    });
  },
  horseRecalculate: function horseRecalculate(horseId, horseStateId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/horses/".concat(horseId, "/boy-status-history/").concat(horseStateId, "/recalculate"), {}, {
      silent: true
    });
  },
  clearRiderRecalculationFlag: function clearRiderRecalculationFlag(memberId, riderStateId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/members/".concat(memberId, "/boy-status-history/").concat(riderStateId, "/clear-recalculation-flag"), {}, {
      silent: true
    });
  },
  clearHorseRecalculationFlag: function clearHorseRecalculationFlag(horseId, horseStateId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/horses/".concat(horseId, "/boy-status-history/").concat(horseStateId, "/clear-recalculation-flag"), {}, {
      silent: true
    });
  },
  deleteRiderState: function deleteRiderState(memberId, riderStateId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete("/v2/members/".concat(memberId, "/boy-status-history/").concat(riderStateId), {
      silent: true
    });
  },
  deleteHorseState: function deleteHorseState(horseId, horseStateId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete("/v2/horses/".concat(horseId, "/boy-status-history/").concat(horseStateId), {
      silent: true
    });
  }
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useZones;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_zones__ = __webpack_require__(773);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



function useZones() {
  var zones = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

  function fetch() {
    return _fetch.apply(this, arguments);
  }

  function _fetch() {
    _fetch = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_zones__["a" /* default */].list();

            case 4:
              res = _context.sent;
              zones.value = res.data.data;
              _context.next = 10;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);

            case 10:
              _context.prev = 10;
              loading.value = false;
              return _context.finish(10);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8, 10, 13]]);
    }));
    return _fetch.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(fetch);
  return {
    zones: zones,
    loading: loading
  };
}

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dist_index_mjs__ = __webpack_require__(831);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_index_mjs__["a"]; });



/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(447);


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_symbol__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es_symbol_description__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es_symbol_description___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es_symbol_description__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_symbol_async_iterator__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_symbol_async_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_symbol_async_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_symbol_has_instance__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_symbol_has_instance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_symbol_has_instance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_symbol_is_concat_spreadable__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_symbol_is_concat_spreadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_symbol_is_concat_spreadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es_symbol_iterator__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es_symbol_match__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es_symbol_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es_symbol_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es_symbol_replace__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es_symbol_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es_symbol_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es_symbol_search__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es_symbol_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es_symbol_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es_symbol_species__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es_symbol_species___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es_symbol_species__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es_symbol_split__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es_symbol_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es_symbol_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es_symbol_to_primitive__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es_symbol_to_primitive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es_symbol_to_primitive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es_symbol_to_string_tag__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es_symbol_to_string_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es_symbol_to_string_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es_symbol_unscopables__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es_symbol_unscopables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es_symbol_unscopables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es_array_concat__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es_array_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es_array_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es_array_find__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es_array_find_index__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es_json_to_string_tag__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es_json_to_string_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es_json_to_string_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es_math_to_string_tag__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es_math_to_string_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es_math_to_string_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es_object_assign__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es_object_to_string__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es_object_to_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es_object_to_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es_promise__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es_promise_finally__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es_promise_finally___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es_promise_finally__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es_string_includes__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es_string_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es_string_iterator__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es_string_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es_string_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_esnext_aggregate_error__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_esnext_aggregate_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_esnext_aggregate_error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_esnext_promise_all_settled__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_esnext_promise_all_settled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_esnext_promise_all_settled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_esnext_promise_any__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_esnext_promise_any___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_esnext_promise_any__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_esnext_promise_try__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_esnext_promise_try___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_esnext_promise_try__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_esnext_symbol_dispose__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_esnext_symbol_dispose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_core_js_modules_esnext_symbol_dispose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_esnext_symbol_observable__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_esnext_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_core_js_modules_esnext_symbol_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_esnext_symbol_pattern_match__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_esnext_symbol_pattern_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_core_js_modules_esnext_symbol_pattern_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_web_dom_collections_iterator__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_web_dom_collections_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_core_js_modules_web_dom_collections_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__sentry_vue__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__sentry_tracing__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_regenerator_runtime_runtime__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_regenerator_runtime_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_regenerator_runtime_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__services_actingCommittee__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__App__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__router__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__store__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__filters__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__composables_useUserRole__ = __webpack_require__(50);


































var _Vue$prototype$$sentr;

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













__WEBPACK_IMPORTED_MODULE_37_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_38__vue_composition_api__["b" /* default */]);
Object.defineProperties(__WEBPACK_IMPORTED_MODULE_37_vue__["default"].prototype, {
  $role: {
    get: function get() {
      return Object(__WEBPACK_IMPORTED_MODULE_45__composables_useUserRole__["a" /* default */])().role;
    }
  },
  $isUser: {
    get: function get() {
      return Object(__WEBPACK_IMPORTED_MODULE_45__composables_useUserRole__["a" /* default */])().isUser;
    }
  },
  $isVolunteer: {
    get: function get() {
      return Object(__WEBPACK_IMPORTED_MODULE_45__composables_useUserRole__["a" /* default */])().isVolunteer;
    }
  },
  $isSecretary: {
    get: function get() {
      return Object(__WEBPACK_IMPORTED_MODULE_45__composables_useUserRole__["a" /* default */])().isSecretary;
    }
  },
  $isSecretaryMember: {
    get: function get() {
      return Object(__WEBPACK_IMPORTED_MODULE_45__composables_useUserRole__["a" /* default */])().isSecretaryMember;
    }
  },
  $isAdmin: {
    get: function get() {
      return Object(__WEBPACK_IMPORTED_MODULE_45__composables_useUserRole__["a" /* default */])().isAdmin;
    }
  },
  $isSuperAdmin: {
    get: function get() {
      return Object(__WEBPACK_IMPORTED_MODULE_45__composables_useUserRole__["a" /* default */])().isSuperAdmin;
    }
  },
  $isSecretaryOrAdmin: {
    get: function get() {
      return Object(__WEBPACK_IMPORTED_MODULE_45__composables_useUserRole__["a" /* default */])().isSecretaryOrAdmin;
    }
  },
  $isSuperSecretary: {
    get: function get() {
      return Object(__WEBPACK_IMPORTED_MODULE_45__composables_useUserRole__["a" /* default */])().isSuperSecretary;
    }
  },
  $isActingForOtherCommittee: {
    get: function get() {
      return Object(__WEBPACK_IMPORTED_MODULE_45__composables_useUserRole__["a" /* default */])().isActingForOtherCommittee;
    }
  }
});
var token = localStorage.getItem('bearer');

if (token) {
  __WEBPACK_IMPORTED_MODULE_39_axios___default.a.defaults.headers.common.Authorization = "Bearer ".concat(token);
}

Object(__WEBPACK_IMPORTED_MODULE_40__services_actingCommittee__["d" /* syncActingCommitteeHeader */])();
/* Eslint doesn't like ga not being defined but it seems to work? */
// eslint-disable-next-line

ga('set', 'page', __WEBPACK_IMPORTED_MODULE_42__router__["a" /* default */].currentRoute.path); // eslint-disable-next-line

ga('send', 'pageview');
__WEBPACK_IMPORTED_MODULE_42__router__["a" /* default */].afterEach(function (to) {
  // eslint-disable-next-line
  ga('set', 'page', to.path); // eslint-disable-next-line

  ga('send', 'pageview');
});

if ((_Vue$prototype$$sentr = __WEBPACK_IMPORTED_MODULE_37_vue__["default"].prototype.$sentry) === null || _Vue$prototype$$sentr === void 0 ? void 0 : _Vue$prototype$$sentr.dsn) {
  __WEBPACK_IMPORTED_MODULE_33__sentry_vue__["a" /* init */]({
    Vue: __WEBPACK_IMPORTED_MODULE_37_vue__["default"],
    dsn: "".concat(__WEBPACK_IMPORTED_MODULE_37_vue__["default"].prototype.$sentry.dsn),
    integrations: [new __WEBPACK_IMPORTED_MODULE_34__sentry_tracing__["a" /* Integrations */].BrowserTracing({
      routingInstrumentation: __WEBPACK_IMPORTED_MODULE_33__sentry_vue__["b" /* vueRouterInstrumentation */](__WEBPACK_IMPORTED_MODULE_42__router__["a" /* default */]),
      tracingOrigins: ["".concat(__WEBPACK_IMPORTED_MODULE_37_vue__["default"].prototype.$api), /^\//]
    })],
    environment: "".concat(__WEBPACK_IMPORTED_MODULE_37_vue__["default"].prototype.$sentry.environment),
    disablePerformance: true,
    // Benign browser warning, not an app error: fires when a ResizeObserver callback
    // triggers another resize within the same frame (e.g. ResponsiveTable's own
    // ResizeObserver reacting to a layout change it just caused). The browser just
    // defers the notification to the next frame — nothing is broken or undelivered
    // for good. Wording differs by engine, hence both variants.
    ignoreErrors: ['ResizeObserver loop completed with undelivered notifications.', 'ResizeObserver loop limit exceeded']
  });
}
/* eslint-disable no-new */


new __WEBPACK_IMPORTED_MODULE_37_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_42__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_43__store__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_41__App__["a" /* default */]
  }
});

/***/ }),
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74884ab9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(597);
function injectStyle (ssrContext) {
  __webpack_require__(588)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74884ab9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var HANDLERESIZE = {
  // bind event handlers to the `handleResize` method (defined below)
  created: function created() {
    window.addEventListener('resize', this.handleResize);
    this.$store.commit('updateExpand', document.documentElement.clientWidth < 1024 ? true : false);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // whenever the document is resized, re-set the 'fullHeight' variable
    handleResize: function handleResize() {
      this.$store.commit('updateExpand', document.documentElement.clientWidth < 1024 ? true : false);
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (HANDLERESIZE);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavbarTop_vue__ = __webpack_require__(202);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_693241a4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavbarTop_vue__ = __webpack_require__(593);
function injectStyle (ssrContext) {
  __webpack_require__(591)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-693241a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavbarTop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_693241a4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavbarTop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */,
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"navbar-top-header",class:_vm.hasToken ? _vm.isDevelopment ? 'bg-info text-white' : 'bg-lightest' : 'bg-primary'},[_c('nav',{class:['container-fluid navbar navbar-top navbar-expand-lg justify-content-between align-items-center px-4', _vm.hasToken ? 'py-2' : 'navbar-dark text-white py-3']},[_c('span',{staticClass:"sr-only"},[_vm._v("Campdraft One")]),_vm._v(" "),(_vm.hasToken)?_c('a',{attrs:{"href":"/"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1764 400","height":"29","width":"128"}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"a","x2":"1","y1":".5","y2":".5"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#aa2d41"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#d92340"}})],1)],1),_c('g',{staticClass:"currentLayer"},[_c('path',{attrs:{"fill":"#333","d":"M359.9 249.4q-16.3-16.2-16.3-45 0-30.4 15.8-47t46.7-16.4a104.7 104.7 0 0 1 36 6v22a88.9 88.9 0 0 0-34.1-6.4q-20.5 0-29.6 10.2t-9.1 31.7q0 20 9.7 29.9t29.3 9.8a88.8 88.8 0 0 0 34-6.3v22.3a115.7 115.7 0 0 1-36 5.4q-30 0-46.4-16.2zm139.6-106.5h27.8l46 120.9H547l-11.4-29.2h-44.5l-11.3 29h-26.3zm32.3 72.3l-18.5-48.6-18.4 48.6zm56.3-72.3h25.6l35.4 72.6 35.5-72.6H710v120.9h-25.5V185l-28 57.9h-14.7l-28.3-58v78.8h-25.4zm145.1 0h56.7q20.5 0 31 11.5t10.6 30.2a44 44 0 0 1-5.2 21.6 35.9 35.9 0 0 1-14.8 14.4q-9.6 5.2-22.3 5.2h-30.7v37.9h-25.4zm50.7 62.9q10.7 0 16.3-5.6t5.7-15.6q0-10.5-5.3-16t-15.8-5.6h-26.2v42.8zm63.4-63H898q27.8 0 41.3 14.5t13.5 46.6q0 30.8-13.5 45.3T898 263.8h-50.7zm47.2 101.5q11.4 0 18.4-3.4t10.6-12.3q3.7-8.8 3.7-24.8 0-16.1-3.3-24.8t-10.3-12q-7-3.2-19.1-3.2h-21.8v80.4zm77.8-101.4h58q20.3 0 30.4 10.7t10 29.8q0 12.2-6.3 21t-17.8 12.8a25.1 25.1 0 0 1 4.6 5.2 49.9 49.9 0 0 1 3.9 7.6l14.6 33.8h-26.2l-14.3-32.5q-1.8-4.3-4.2-6t-7.4-1.5h-19.9v40h-25.2zm51.5 59.9q10.3 0 15.8-4.6t5.4-14.7q0-10.2-4.9-15t-14.8-4.6h-27.6v38.9zm100.4-60h27.8l46 121h-26.3l-11.4-29.1h-44.5l-11.3 29H1078zm32.3 72.4l-18.6-48.6-18.4 48.6zm61-72.3h85v19.7h-59.7v31h52.7V213h-52.7v50.7h-25.3zm130.4 19.5h-37.1v-19.5h99.5v19.5h-37v101.4h-25.4z"}}),_c('path',{attrs:{"fill":"#aa2d41","d":"M1411.9 203.9q0-32.7 14.6-47.8t44.2-15q29.7 0 44.2 15t14.5 47.8q0 61.8-58.7 61.8t-58.8-61.8zm83.7 30.3q8.1-9.8 8.1-30.3 0-22.3-7.9-31.8t-25.1-9.5q-17.3 0-25.2 9.5t-7.8 31.8q0 20.5 8 30.3t25 9.8q16.9 0 25-9.8zm53.4-91.3h22l57.2 80.5v-80.5h25.3v120.9h-22l-57.3-80.5v80.5h-25.3zm127.8 0h86.7v19.7h-61.4v31h54.4V213h-54.4v31.2h61.4v19.5h-86.7z"}}),_c('path',{attrs:{"fill":"url(#a)","d":"M118.5 104.4c23.8-18.3 51.3-30.2 81.6-30.2 14 0 27.7 1.8 40.4 6.6 42.4 16.3 47.5 57.7 62 43.3l73.8-74L350.1 24l-6.1 6.2a26.2 26.2 0 0 1-33 3.3A199.7 199.7 0 0 0 177.8 1.3 197.3 197.3 0 0 0 77.5 42 199.5 199.5 0 0 0 0 200.2C0 249 14.8 303.9 59.3 348.4c-22.2-96.3 5.2-202.8 59.1-244zM263.1 37a11.1 11.1 0 1 1-11 11 11.1 11.1 0 0 1 11-11zm-66.6-14.8a11.1 11.1 0 1 1-11 11 11.1 11.1 0 0 1 11-11zM129.8 37a11.1 11.1 0 1 1-11.1 11 11.1 11.1 0 0 1 11.1-11z"}}),_c('path',{attrs:{"fill":"#333","d":"M241.1 319.3a99.7 99.7 0 0 1-41 6.9c-33.7 0-59.3-7.4-89.1-37-11-10.7-28.1-38.7-37-66.8-4.2 42-7.3 111.2 16.2 145a200.4 200.4 0 0 0 220.3-.3 23.7 23.7 0 0 1 29.8 3l9.8 9.9 26.2-26.2-73.8-73.8c-14.5-14.5-25.7 23.3-61.4 39.3zm-111.4 44a11.1 11.1 0 1 1 11.1-11.2 11.1 11.1 0 0 1-11 11zm66.7 14.8a11.1 11.1 0 1 1 11.2-11.1 11.1 11.1 0 0 1-11.2 11zm66.7-14.8a11.1 11.1 0 1 1 11.2-11.2 11.1 11.1 0 0 1-11.2 11z"}})])])]):_c('svg',{staticClass:"mx-auto ml-lg-0",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1764 400","height":"29","width":"128"}},[_c('rect',{attrs:{"id":"backgroundrect","width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('path',{attrs:{"id":"svg_1","d":"M360 249.3c-10.9-10.8-16.3-25.8-16.3-45 0-20.3 5.3-35.9 15.9-46.9 10.6-11 26.1-16.5 46.6-16.5a105 105 0 0 1 36 6V169a88.4 88.4 0 0 0-34.1-6.5c-13.6 0-23.5 3.4-29.6 10.2s-9.1 17.4-9.1 31.6c0 13.4 3.2 23.4 9.7 30 6.4 6.5 16.2 9.8 29.4 9.8 11.6.1 23.2-2 34-6.4V260a115.5 115.5 0 0 1-36 5.4c-20.1.2-35.6-5.3-46.5-16z","fill":"#fff"}}),_c('path',{attrs:{"id":"svg_2","d":"M499.6 142.8h27.8l46 121h-26.2l-11.5-29.2h-44.5l-11.3 29.1h-26.5l46.2-120.9zm32.3 72.3l-18.5-48.6-18.4 48.6h36.9z","fill":"#fff"}}),_c('path',{attrs:{"id":"svg_3","d":"M588.2 142.8h25.5l35.5 72.6 35.5-72.6H710v121h-25.4V185l-28 57.8h-14.7L613.6 185v78.6h-25.4V142.8z","fill":"#fff"}}),_c('path',{attrs:{"id":"svg_4","d":"M733.3 142.8H790c13.6 0 24 3.8 31 11.5s10.5 17.7 10.5 30.2c.1 7.5-1.6 15-5.2 21.6a36 36 0 0 1-14.7 14.5 46.8 46.8 0 0 1-22.3 5.2h-30.6v38h-25.3v-121zm50.7 63c7.1 0 12.6-2 16.3-5.7 3.8-3.8 5.6-8.9 5.6-15.6 0-7-1.8-12.3-5.3-16-3.5-3.7-8.8-5.5-15.8-5.5h-26.3v42.8H784z","fill":"#fff"}}),_c('path',{attrs:{"id":"svg_5","d":"M847.4 142.8h50.7c18.5 0 32.3 4.8 41.3 14.4s13.5 25.1 13.5 46.6c0 20.5-4.5 35.6-13.5 45.3s-22.8 14.5-41.3 14.5h-50.7V142.8zm47.2 101.4c7.6 0 13.8-1 18.4-3.4 4.6-2.3 8.2-6.3 10.6-12.2a67.4 67.4 0 0 0 3.7-24.8c0-10.8-1.1-19-3.3-24.8a20.4 20.4 0 0 0-10.2-11.9c-4.6-2.2-11-3.3-19.2-3.3h-21.8v80.3l21.8.1z","fill":"#fff"}}),_c('path',{attrs:{"id":"svg_6","d":"M972.4 142.8h58c13.5 0 23.6 3.6 30.3 10.7s10 17.1 10 29.8c0 8.1-2.1 15.1-6.3 21a35.5 35.5 0 0 1-17.7 12.8c1.8 1.5 3.3 3.2 4.6 5.2a45 45 0 0 1 3.8 7.6l14.6 33.8h-26.1l-14.3-32.5c-1.3-2.9-2.7-4.9-4.2-5.9s-4-1.6-7.4-1.6h-19.9v40h-25.3l-.1-120.9zm51.5 60c6.9 0 12.1-1.6 15.8-4.7 3.6-3 5.4-8 5.4-14.7 0-6.8-1.6-11.7-4.9-14.8-3.3-3-8.2-4.7-14.8-4.7h-27.6v39h26.1z","fill":"#fff"}}),_c('path',{attrs:{"id":"svg_7","d":"M1124.3 142.8h27.8l46 121h-26.3l-11.4-29.2h-44.5l-11.3 29.1h-26.5l46.2-120.9zm32.3 72.3l-18.6-48.6-18.4 48.6h37z","fill":"#fff"}}),_c('path',{attrs:{"id":"svg_8","d":"M1217.6 142.8h85v19.7h-59.7v31h52.7V213h-52.7v50.7h-25.3V142.8z","fill":"#fff"}}),_c('path',{attrs:{"id":"svg_9","d":"M1348 162.3h-37.2v-19.5h99.5v19.5h-37v101.4H1348V162.3z","fill":"#fff"}}),_c('path',{attrs:{"id":"svg_10","d":"M1412 203.8c0-21.8 4.9-37.7 14.6-47.8 9.7-10 24.4-15 44.2-15 19.8 0 34.5 5 44.2 15 9.7 10.1 14.5 26 14.6 47.8 0 41.2-19.6 61.8-58.8 61.8-39.2 0-58.8-20.6-58.8-61.8zm83.7 30.3c5.4-6.6 8.1-16.7 8.1-30.3 0-14.9-2.6-25.5-7.9-31.8s-13.6-9.5-25.1-9.5c-11.5 0-19.9 3.2-25.2 9.5-5.3 6.3-7.9 17-7.9 31.8 0 13.6 2.7 23.7 8.1 30.3 5.4 6.6 13.7 10 25 10s19.6-3.4 24.9-10z","fill":"#fff"}}),_c('path',{attrs:{"id":"svg_11","d":"M1549.1 142.8h22l57.2 80.5v-80.5h25.3v121h-22l-57.2-80.6v80.5h-25.3V142.8z","fill":"#fff"}}),_c('path',{attrs:{"id":"svg_12","d":"M1676.9 142.8h86.7v19.7h-61.4v31h54.4V213h-54.4v31.2h61.4v19.5h-86.7V142.8z","fill":"#fff"}}),_c('path',{attrs:{"id":"svg_13","d":"M118.5 104.3c23.8-18.2 51.4-30.2 81.7-30.2 13.9 0 27.7 1.8 40.3 6.6 42.4 16.3 47.5 57.7 62 43.3l73.9-73.9L350.2 24l-6.2 6.2a26.2 26.2 0 0 1-33 3.3A199.5 199.5 0 0 0 177.8 1.2c-36.6 4-71.3 18-100.3 40.7A199.3 199.3 0 0 0 0 200.1c0 49 14.8 103.8 59.3 148.2-22.1-96.3 5.3-202.8 59.2-244zM263.2 37c6.1 0 11.1 5 11.1 11.1s-5 11.1-11.1 11.1-11.1-5-11.1-11c0-6.2 5-11.2 11.1-11.2zm-66.7-14.8c6.1 0 11.1 5 11.1 11.1s-5 11.1-11.1 11.1-11.1-5-11.1-11c0-6.2 5-11.2 11.1-11.2zM129.8 37c6.1 0 11.1 5 11.1 11.1s-5 11.1-11.1 11.1-11.1-5-11.1-11c0-6.2 5-11.2 11.1-11.2z","fill":"#fff"}}),_c('path',{attrs:{"id":"svg_14","d":"M241.2 319.2a100.3 100.3 0 0 1-41 6.8c-33.7 0-59.3-7.4-89.1-36.9-10.9-10.8-28.1-38.8-36.9-66.9-4.3 42-7.4 111.2 16.1 145a200.3 200.3 0 0 0 220.3-.3 23.6 23.6 0 0 1 29.8 3.1l9.8 9.8 26.2-26.2-73.8-73.7c-14.5-14.5-25.7 23.3-61.4 39.3zm-111.4 44c-6.1 0-11.1-5-11.1-11s5-11.2 11.1-11.2 11.1 5 11.1 11.1a11 11 0 0 1-11.1 11.1zm66.7 14.8c-6.1 0-11.1-5-11.1-11s5-11.2 11.1-11.2 11.1 5 11.1 11.1a11 11 0 0 1-11.1 11.1zm66.7-14.8c-6.1 0-11.1-5-11.1-11s5-11.2 11.1-11.2 11.1 5 11.1 11.1a11 11 0 0 1-11.1 11.1z","fill":"#fff"}})])]),_vm._v(" "),(_vm.isDevelopment)?_c('p',{staticClass:"ml-auto mb-0"},[_vm._v("Dev Environment")]):_vm._e(),_vm._v(" "),(_vm.hasToken)?_c('ul',{staticClass:"navbar-nav ml-auto d-none d-lg-flex"},[_c('li',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.userMenuClose),expression:"userMenuClose"}],staticClass:"nav-item dropdown"},[_c('a',{staticClass:"nav-link dropdown-toggle rounded",attrs:{"href":"#","id":"navbarDropdown","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":_vm.$store.state.userToggleOpen},on:{"click":function($event){$event.preventDefault();return _vm.userMenuToggle($event)}}},[_c('svg',{staticClass:"d-lg-none",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13 16","width":"14","height":"17"}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('g',[_c('path',{attrs:{"d":"M6.5 9c-2.2 0-4-2-4-4.5S4.3 0 6.5 0s4 2 4 4.5S8.7 9 6.5 9zm0-8c-1.7 0-3 1.6-3 3.5S4.8 8 6.5 8s3-1.6 3-3.5S8.2 1 6.5 1z"}}),_c('path',{attrs:{"d":"M12.5 15.8c-.3 0-.5-.2-.5-.5v-3.4c0-1.9-1.5-3.4-3.4-3.4h-.3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h.4c2.4 0 4.4 2 4.4 4.4v3.4c-.1.3-.3.5-.6.5zM.5 15.8c-.3 0-.5-.2-.5-.5v-3.4c0-2.4 2-4.4 4.4-4.4h.4c.3 0 .5.2.5.5s-.2.5-.5.5h-.4A3.4 3.4 0 0 0 1 11.9v3.4c0 .3-.2.5-.5.5z"}})])])]),_vm._v(" "),_c('span',{staticClass:"d-none d-lg-inline"},[_vm._v(_vm._s(_vm.userName))])]),_vm._v(" "),_c('VueSlideToggle',{staticClass:"dropdown-menu dropdown-menu-right show",attrs:{"open":_vm.$store.state.userToggleOpen,"tag":"div","duration":200,"id":"navbarSide","aria-labelledby":"navbarDropdown"}},[_c('div',{staticClass:"rounded border"},[_c('router-link',{staticClass:"dropdown-item",attrs:{"tag":"a","to":{ name: 'Log Out' }},nativeOn:{"click":function($event){return _vm.closeMenus($event)}}},[_vm._v("Log Out")])],1)])],1)]):_vm._e(),_vm._v(" "),(_vm.hasToken)?_c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","aria-controls":"navbarSide","aria-expanded":_vm.menuOpen,"aria-label":"Toggle navigation"},on:{"click":function($event){$event.preventDefault();return _vm.menuToggle($event)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13 10","width":"21","height":"17"}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M12.5 1H.5C.2 1 0 .8 0 .5S.2 0 .5 0h12c.3 0 .5.2.5.5s-.2.5-.5.5zM12.5 5.5H.5C.2 5.5 0 5.3 0 5s.2-.5.5-.5h12c.3 0 .5.2.5.5s-.2.5-.5.5zM12.5 10H.5c-.3 0-.5-.2-.5-.5S.2 9 .5 9h12c.3 0 .5.2.5.5s-.2.5-.5.5z"}})])])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActingCommitteeBar_vue__ = __webpack_require__(203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bfb8f1a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActingCommitteeBar_vue__ = __webpack_require__(596);
function injectStyle (ssrContext) {
  __webpack_require__(595)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bfb8f1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActingCommitteeBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bfb8f1a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActingCommitteeBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.actingCommittee)?_c('div',{staticClass:"acting-committee-bar bg-warning text-dark px-4 py-2 d-flex flex-wrap align-items-center"},[_c('span',{staticClass:"mr-3"},[_vm._v("Working on committee: "),_c('strong',[_vm._v(_vm._s(_vm.actingCommittee.name))])]),_vm._v(" "),_c('a',{staticClass:"text-primary font-weight-bold acting-committee-bar__return",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.returnToOwnCommittee($event)}}},[_vm._v("Return to my committee")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grow-1 d-flex flex-column min-vh-100",attrs:{"id":"app"}},[(_vm.isIE())?_c('div',{staticClass:"alert alert-warning mb-0 p-2 rounded-0",attrs:{"role":"alert"}},[_vm._v("\n    You will experience limited functionality with your current browser. Please use this site with a modern browser such as "),_c('a',{attrs:{"href":"https://www.mozilla.org/firefox","target":"_blank","rel":"noreferrer"}},[_vm._v("Firefox")]),(_vm.afterEdgeRelease())?_c('span',[_vm._v(", "),_c('a',{attrs:{"href":"https://www.microsoft.com/en-us/windows/microsoft-edge","target":"_blank","rel":"noreferrer"}},[_vm._v("Edge")])]):_vm._e(),_vm._v(" or "),_c('a',{attrs:{"href":"https://www.google.com/chrome","target":"_blank","rel":"noreferrer"}},[_vm._v("Chrome")]),_vm._v(".\n  ")]):_vm._e(),_vm._v(" "),_c('navbar',{class:[_vm.$route.name === 'Login' ? 'd-none d-lg-block' : '']}),_vm._v(" "),_c('acting-committee-bar'),_vm._v(" "),_c('router-view',{class:['position-relative', _vm.isIE() ? 'min-vh-100-ie' : '']})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Account_Login__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Account_Maintenance__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Account_LoginOnce_LoginOnce__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Dashboard_Dashboard__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Admin_Listing_AdminUsers__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Admin_Listing_SecretaryUsers__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Admin_Register_Register__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Members_Listing_Members__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Members_Join_MemberJoin__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Members_Profile_MemberProfileMembers__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Members_Profile_MemberProfileChild__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Members_Merge_MemberMerge__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Members_Profile_MemberSplit__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Admin_Pending_PendingInvoices__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Admin_Pending_PendingRegistrations__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Admin_Pending_Horse_Horse__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_Admin_Profile_AdminProfile__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_Admin_Profile_SecretaryProfile__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_Admin_Profile_AdminProfileChild__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_MyMembership_MyMembershipProfile__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_MyMembership_MyMembershipProfileChild__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_MyMembership_MyMembershipCart__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_MyMembership_MyMembershipPayment__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_MyMembership_Add_MemberAdd__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_Admin_Add_AdminAdd__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_Admin_Add_SecretaryAdd__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_Committees_Listing_Committees__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_Committees_Switch_SwitchCommittee__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_Committees_Profile_CommitteeProfile__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_Horses_Listing_HorsesListing__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_Horses_Profile_HorseProfile__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_Horses_Add_HorseAdd__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_Horses_Register_HorseRegister__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_Horses_Nominate_NominateRookie__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_Horses_Register_HorseRegisterConfirm__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_Horses_Cart_Cart__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_Horses_Cart_Payment__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__views_Drafts_Listing_Drafts__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__views_Drafts_Add_DraftAdd__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__views_Drafts_Events_Listing_Events__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__views_Drafts_Events_Add_EventAdd__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__views_Titles_Listing_Titles__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__views_Titles_Edit_TitleEdit__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__views_Titles_Preview_TitlesPreview__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__views_Export_Report__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__views_Account_Auth__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__views_Common_NotFound__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__views_Judges_Application_JudgeApplication_vue__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__views_Judges_Application_AdminJudgeAppsList_vue__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__views_Judges_Admin_JudgeAdminDashboard_vue__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__views_Judges_Admin_AdminJudgesList_vue__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__views_Judges_Listing_Judges__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__views_Judges_ExpressionOfInterest_ExpressionInterest__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__views_Judges_ExpressionOfInterest_ActiveDrafts__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__views_Judges_Secretary_JudgeSecretaryDashboard__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__views_Judges_Secretary_PendingExpressionInterest__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__views_Judges_Secretary_ApprovedExpressionInterest__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__views_Judges_Surveys_Survey__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__views_Leaders_Listing_Drafts__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__views_Leaders_Listing_Draft__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__views_Leaders_Listing_Event__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__views_Leaders_CutoutHighest_Draft__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__views_Leaders_CutoutHighest_Event__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__views_ApiTokens_Listing_ApiTokens__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__vars__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__views_Judges_Dashboard_JudgeDashboard__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__views_Committees_Affiliation_CommitteeAffiliation__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__views_Committees_Profile_components_CommitteeNotRegistered__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__views_Committees_Cart_Cart__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__views_Committees_Cart_Payment__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__views_Committees_Edit_CommitteeEditSecretary__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__composables_useUserRole__ = __webpack_require__(50);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }












































































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var SecretaryDraftAdd = function SecretaryDraftAdd() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1096));
};

var SecretaryDraftEdit = function SecretaryDraftEdit() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1097));
};

var SecretaryDraftView = function SecretaryDraftView() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1098));
};

var SecretaryEventCreate = function SecretaryEventCreate() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1099));
};

var SecretaryEventEdit = function SecretaryEventEdit() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1100));
};

var AppearanceEdit = function AppearanceEdit() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1101));
};

var Import = function Import() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1102));
};

var TermsAndConditions = function TermsAndConditions() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1103));
};

var CommitteeDashboard = function CommitteeDashboard() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1104));
};

var NominationsDraftsList = function NominationsDraftsList() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1105));
};

var NominationsAdd = function NominationsAdd() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1106));
};

var HorseMerge = function HorseMerge() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1107));
}; // Draws (step 4)


var DrawsDashboard = function DrawsDashboard() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1108));
};

var DrawsPublic = function DrawsPublic() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1109));
};

var DrawsPublicList = function DrawsPublicList() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1110));
};

var DrawsEventView = function DrawsEventView() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1111));
};

var DrawsResult = function DrawsResult() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1112));
}; // Nominations extras (step 4)


var NominationsBulkEmail = function NominationsBulkEmail() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1113));
};

var NominationsReassign = function NominationsReassign() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1114));
}; // Committees extras (step 4)


var CommitteesBulkMail = function CommitteesBulkMail() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1115));
}; // Reports (step 4)


var ReportsIncoming = function ReportsIncoming() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1116));
};

var ReportsOutgoing = function ReportsOutgoing() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1117));
}; // Invoices (step 4)


var InvoicesList = function InvoicesList() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1118));
}; // Biosecurity (step 4)


var BiosecurityForm = function BiosecurityForm() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1119));
}; // Calculators (step 4)


var CalculatorView = function CalculatorView() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1120));
}; // Prizes (step 4)


var PrizesView = function PrizesView() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1121));
};

var PrizeSummaryView = function PrizeSummaryView() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1122));
}; // Draft Event Members (step 4)


var DraftEventMembers = function DraftEventMembers() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1123));
}; // Competitors


var CompetitorsList = function CompetitorsList() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1124));
}; // BOY Status (affected results)


var AffectedResultsView = function AffectedResultsView() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1125));
};

var routes = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: "history",
  linkExactActiveClass: "active",
  routes: [{
    path: "/",
    name: "Dashboard",
    component: __WEBPACK_IMPORTED_MODULE_6__views_Dashboard_Dashboard__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }],
      showInNavar: true
    }
  }, {
    path: '/committees/not-registered',
    name: "Committee Not Registered",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_70__views_Committees_Profile_components_CommitteeNotRegistered__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Committee"
      }],
      showInNavar: false,
      icon: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 640 512" width="24" height="19"><path fill="currentColor" d="M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z"/></svg>',
      requiresAuth: ["Secretary", "SecretaryOnly"],
      childOf: "Committees"
    }
  }, {
    path: '/committees/dashboard/:draftId?',
    name: "Committees Dashboard",
    displayName: "Committees",
    component: CommitteeDashboard,
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Committee"
      }],
      showInNavar: true,
      icon: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 640 512" width="24" height="19"><path fill="currentColor" d="M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z"/></svg>',
      requiresAuth: ["Secretary", "SecretaryOnly"]
    }
  }, {
    path: '/committees/dashboard',
    name: "Nomination Dashboard",
    component: CommitteeDashboard,
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Committee"
      }],
      showInNavar: true,
      childOf: "Committees Dashboard",
      requiresAuth: ["Secretary", "SecretaryOnly"]
    }
  }, {
    path: '/drafts/setup',
    name: "Draft Setup",
    component: SecretaryDraftAdd,
    meta: {
      showInNavar: true,
      childOf: "Committees Dashboard",
      requiresAuth: ["Secretary", "SecretaryOnly"],
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Create Draft"
      }]
    }
  }, {
    path: '/drafts/view/:id',
    name: "Draft View",
    component: SecretaryDraftView,
    props: function props(route) {
      return {
        draftId: route.params.id
      };
    },
    meta: {
      requiresAuth: ["Secretary", "SecretaryOnly"],
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Committee",
        link: "committees/dashboard"
      }, {
        name: "View Draft"
      }]
    }
  }, {
    path: '/drafts/edit/:id',
    name: "Draft Edit",
    component: SecretaryDraftEdit,
    props: function props(route) {
      return {
        draftId: route.params.id
      };
    },
    meta: {
      requiresAuth: ["Secretary", "SecretaryOnly"],
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Committee",
        link: "committees/dashboard"
      }, {
        name: "Edit Draft"
      }]
    }
  }, {
    path: '/drafts/view/:id/events/add',
    name: "Event Create",
    component: SecretaryEventCreate,
    props: function props(route) {
      return {
        draftId: route.params.id
      };
    },
    meta: {
      requiresAuth: ["Secretary", "SecretaryOnly"],
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Committee",
        link: "committees/dashboard"
      }, {
        name: "View Draft",
        link: ""
      }, {
        name: "Create Event"
      }]
    }
  }, {
    path: '/drafts/view/:id/events/:eventId/edit',
    name: "Event Edit",
    component: SecretaryEventEdit,
    props: function props(route) {
      return {
        draftId: route.params.id,
        eventId: route.params.eventId
      };
    },
    meta: {
      requiresAuth: ["Secretary", "SecretaryOnly"],
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Committee",
        link: "committees/dashboard"
      }, {
        name: "View Draft",
        link: ""
      }, {
        name: "Edit Event"
      }]
    }
  }, {
    path: '/drafts/add-old',
    beforeEnter: function beforeEnter() {
      location.href = "".concat(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$coy, "/drafts/add");
    },
    name: "Draft Setup Old",
    meta: {
      requiresAuth: ["Secretary", "SecretaryOnly"]
    }
  }, {
    path: '/committees/edit',
    name: "Committee",
    component: __WEBPACK_IMPORTED_MODULE_73__views_Committees_Edit_CommitteeEditSecretary__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Committees"
      }],
      showInNavar: true,
      childOf: "Committees Dashboard",
      requiresAuth: ["Secretary", "SecretaryOnly"]
    }
  }, {
    path: '/committees/affiliation',
    name: "Committee Affiliation",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_69__views_Committees_Affiliation_CommitteeAffiliation__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Committee"
      }],
      showInNavar: false,
      icon: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 640 512" width="24" height="19"><path fill="currentColor" d="M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z"/></svg>',
      requiresAuth: ["Secretary", "SecretaryOnly"],
      childOf: "Committees"
    }
  }, {
    path: "/committees/cart",
    name: "Committee Cart",
    component: __WEBPACK_IMPORTED_MODULE_71__views_Committees_Cart_Cart__["a" /* default */],
    props: true,
    meta: {
      cartFlow: true,
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Committee",
        link: "committees/affiliation"
      }, {
        name: "Cart",
        link: "committees/cart"
      }],
      showInNavar: false,
      requiresAuth: ["Secretary", "SecretaryOnly"]
    }
  }, {
    path: "/committees/payment",
    name: "Committee Payment",
    component: __WEBPACK_IMPORTED_MODULE_72__views_Committees_Cart_Payment__["a" /* default */],
    props: true,
    meta: {
      cartFlow: true,
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Committee",
        link: "committees/affiliation"
      }, {
        name: "Cart",
        link: "committees/payment"
      }],
      showInNavar: false,
      requiresAuth: ["Secretary", "SecretaryOnly"]
    }
  }, {
    path: '/draws/view',
    redirect: '/draws/dashboard',
    meta: {
      showInNavar: false
    }
  }, {
    path: '/draws/dashboard',
    name: 'DrawsDashboard',
    displayName: 'Draws Dashboard',
    component: DrawsDashboard,
    meta: {
      breadcrumb: [{
        name: 'Dashboard',
        link: ''
      }, {
        name: 'Draws Dashboard'
      }],
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 19" width="24" height="23"><g><path fill="currentColor" d="M8.7999977 12.437501h-.2l-2.2-.9-2.2.9c-.2.1-.5 0-.6-.3l-1-2.1-2.1-1c-.2-.1-.4-.4-.3-.6l.8-2.2-.8-2.2c-.1-.2 0-.5.3-.6l2.1-1 1-2.1c.1-.2.4-.4.6-.3l2.2.8 2.2-.8c.2-.1.5 0 .6.3l1 2.1 2.1 1c.2.1.4.4.3.6l-.8 2.2.8 2.2c.1.2 0 .5-.3.6l-2.1 1-1 2.1c-.1.2-.3.3-.4.3zm-2.4-1.9h.2l1.9.7.9-1.8c0-.1.1-.2.2-.2l1.9-.9-.7-1.9v-.3l.7-1.9-1.9-.9c-.1 0-.2-.1-.2-.2l-.9-1.9-1.9.7h-.3l-1.9-.7-1 1.8c0 .1-.1.2-.2.2l-1.9.9.7 1.9v.3l-.7 1.9 1.9.9c.1 0 .2.1.2.2l.9 1.9 1.9-.7h.2z"/><path fill="currentColor" d="M3.3999977 10.037501l-2.2 6 1.9-.3c.2 0 .4 0 .5.2l1.2 1.5 2.2-6 .9.3-2.5 6.8c-.1.2-.2.3-.4.3h-.1c-.2 0-.3-.1-.4-.2l-1.5-1.9-2.4.4c-.2 0-.4 0-.5-.2-.1-.1-.1-.3-.1-.5l2.5-6.8.9.4z"/><path fill="currentColor" d="M10.2999977 9.737501l2.6 6.8c.1.2 0 .4-.1.5-.1.1-.3.2-.5.2l-2.4-.4-1.5 1.9c-.1.1-.2.2-.4.2h-.1c-.2 0-.3-.1-.4-.3l-1.6-4.2.9-.4 1.2 3.3 1.2-1.5c.1-.1.3-.2.5-.2l1.9.3-2.2-6 .9-.2z"/></g></svg>',
      showInNavar: true,
      childOf: 'Committees Dashboard',
      requiresAuth: ['Secretary', 'SecretaryOnly']
    }
  }, {
    path: '/draws/public/:eventId/:round',
    name: 'DrawsPublic',
    component: DrawsPublic,
    meta: {
      breadcrumb: [{
        name: 'Draws',
        link: 'draws/public'
      }, {
        name: 'Draw Results'
      }],
      requiresAuth: null
    }
  }, {
    path: '/draws/results/:eventId/:round',
    name: 'DrawsResult',
    component: DrawsResult,
    meta: {
      breadcrumb: [{
        name: 'Dashboard',
        link: ''
      }, {
        name: 'Draws Dashboard',
        link: 'draws/dashboard'
      }, {
        name: 'Round Results'
      }],
      requiresAuth: ['Secretary', 'SecretaryOnly']
    }
  }, {
    path: '/draws/:draftId/:eventId/:round',
    name: 'DrawsEventView',
    component: DrawsEventView,
    meta: {
      breadcrumb: [{
        name: 'Dashboard',
        link: ''
      }, {
        name: 'Draws Dashboard',
        link: 'draws/dashboard'
      }, {
        name: 'Event'
      }],
      requiresAuth: ['Secretary', 'SecretaryOnly']
    }
  }, {
    path: '/competitors',
    name: 'Competitors',
    component: CompetitorsList,
    meta: {
      breadcrumb: [{
        name: 'Dashboard',
        link: ''
      }, {
        name: 'Competitors'
      }],
      showInNavar: true,
      childOf: 'Committees Dashboard',
      requiresAuth: ['Secretary', 'SecretaryOnly']
    }
  }, {
    path: "/secretary-horses",
    name: "Horses",
    component: __WEBPACK_IMPORTED_MODULE_32__views_Horses_Listing_HorsesListing__["a" /* default */],
    props: true,
    meta: {
      horseList: {
        title: "Horses",
        variant: "secretary",
        profileRoute: "Secretary Horse Profile",
        addRoute: "Secretary Add Horses"
      },
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Horses"
      }],
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 189.42 179.46"><g data-name="Layer 2"><g fill="currentColor" data-name="Layer 1"><path d="M57.34 126.27c-5.58 5.48-11.15 11-16.77 16.42-1 .92-.15 1.4.23 2q11 16.53 22 33a3.12 3.12 0 0 1 .86 1.76h-11c-.68 0-1-.4-1.26-.87L27.58 143c-.57-.84-.34-1.23.26-1.81 2.75-2.66 5.4-5.42 8.21-8 1.1-1 .91-1.68.21-2.75-4.52-6.89-8.93-13.87-12-21.53-5.3-13-6.11-26.25-.94-39.53a31 31 0 0 1 11.83-15c1-.65.93-1 .16-1.75-3.51-3.42-7.4-3.64-11.62-.53S17 59.3 14.93 63.83a58.7 58.7 0 0 0-4.38 31.92 74.6 74.6 0 0 0 9.64 28 2.41 2.41 0 0 1-.34 3.3c-3.42 4-6.75 8-10 12.07-.72.9-1.18 1.11-2.11.26-1.78-1.61-3.64-3.14-5.53-4.61-.87-.67-1-1.09-.22-2 2.12-2.4 4.09-4.92 6.18-7.35a1.91 1.91 0 0 0 .32-2.42A80.54 80.54 0 0 1 .37 94.88c0-.26-.08-.48-.37-.54V80.28c.9-2.4.9-5 1.48-7.45 2-8.79 5.27-17 11.14-24 3.31-3.95 7.27-7 12.33-8.36 6-1.59 11.44-.14 16.16 3.9a10.4 10.4 0 0 1 2.35 2.33c1.68 2.83 4 3.26 7.18 3.23 22.31-.18 44.63-.1 66.94-.1h2.14a76.63 76.63 0 0 0-6.17 6.25c-2.48 3.16-5.48 4-9.41 3.9-17.32-.22-34.64-.1-52-.1-9.92 0-16 4.08-19.61 13.38-4.16 10.83-3.38 21.58 1.09 32.14 2.88 6.82 6.81 13 10.82 19.28l7.28-7.21c0-.79.6-1.19 1.06-1.65 4.89-4.86 10-9.43 14.78-14.43 1-1 1.8-1 2.79 0 1.61 1.69 3.29 3.32 4.94 5a1.56 1.56 0 0 1 .06 2.54c-5.85 5.73-11.35 11.83-17.67 17.21a.93.93 0 0 1-.34.13zM189.41 0v76.21a37 37 0 0 1-1.88 12.71c-3.25 8.94-9.45 11-16.9 10.87-.95 0-1.25-.65-1.67-1.23L156.35 81c-.27-.38-.58-.74-1-1.28a128 128 0 0 0-5.88 15.16c-1.41 4.3-2.51 8.69-3.63 13.07-.34 1.36 0 1.66 1.38 1.64 6-.06 12 .26 17.94-.1a13.55 13.55 0 0 1 13.72 17.6c-2.16 7.9-6.25 14.79-10.69 21.53-.78 1.18-1.66 2.3-2.43 3.48-.45.7-.81.69-1.44.19-2-1.59-4.08-3.18-6.2-4.67-.91-.64-.79-1.06-.21-1.86a89.12 89.12 0 0 0 9.47-16 26.83 26.83 0 0 0 2-6.12 3.14 3.14 0 0 0-3.19-4h-21.45c-1.38 0-1.3.88-1.41 1.64q-1.23 8-2 16.12c-1.3 13.58-1.6 27.2-1.7 40.82 0 1-.26 1.27-1.24 1.24-2.53-.06-5.06-.05-7.58 0-.93 0-1.28-.2-1.27-1.21.07-10.3.36-20.59.94-30.87.52-9.29 1.64-18.52 2.79-27.74-.38-1.88.25-3.67.58-5.46 2.7-14.59 6.83-28.73 13.43-42.07a7.84 7.84 0 0 1 1.51-2.3l5-9.18c.69.16.85.75 1.16 1.18q9.38 13 18.72 26.08c1.34 1.88 1.66 1.69 3.16.08s2-4.08 2.22-6.33a55.48 55.48 0 0 0 .4-6.82V0z"/><path d="M169.44 0c0 9.55 0 19.1.05 28.65 0 1.06-.31 1.35-1.34 1.32-2.47-.07-4.93 0-7.4 0a1.58 1.58 0 0 1-1.56-.85c-3.64-5.47-8.59-9-15.33-9.11-7.51-.16-15-.08-22.55 0-1.5 0-1.86-.44-1.79-1.85.11-2.28.08-4.56 0-6.84 0-1 .21-1.38 1.31-1.37 8.81.05 17.62 0 26.43.1a18.77 18.77 0 0 1 12.18 4.79V0zM139.77 29.9c-3.5 3.46-6.61 6.51-9.7 9.59a1.86 1.86 0 0 1-1.52.44h-27.54c-1.17 0-1.46-.37-1.43-1.48.08-2.4.07-4.8 0-7.21 0-1 .21-1.39 1.31-1.39 12.76.07 25.51.05 38.88.05zM62.91 134.47c7.94-7.8 15.9-15.59 23.8-23.43a4.54 4.54 0 0 1 3.53-1.48c10.83.06 21.66 0 32.49 0 2.32 0 2.32 0 1.94 2.18q-.66 3.9-1.33 7.8a3.76 3.76 0 0 1-2 .19H93.98a3.75 3.75 0 0 0-2.93 1.16q-10.59 10.57-21.3 21c-.91.89-1.08 1.43-.3 2.57 5.19 7.64 10.27 15.34 15.38 23 .36.54.71 1.09 1.24 1.92H74.61c-.71 0-.92-.55-1.21-1q-8.55-12.81-17.11-25.62a1.3 1.3 0 0 1 .21-2c2.18-1.98 4.28-4.15 6.41-6.29z"/></g></g></svg>',
      showInNavar: true,
      childOf: "Committees Dashboard",
      requiresAuth: ["Secretary", "SecretaryOnly"]
    }
  }, {
    path: "/secretary-horses/:slug",
    name: "Secretary Horse Profile",
    component: __WEBPACK_IMPORTED_MODULE_33__views_Horses_Profile_HorseProfile__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Horses",
        link: "secretary-horses"
      }, {
        name: "Horse Profile",
        link: "secretary-horses/horse-profile"
      }],
      showInNavar: false,
      requiresAuth: ["Secretary", "SecretaryOnly"]
    }
  }, {
    path: "/secretary-add-horse",
    name: "Secretary Add Horses",
    component: __WEBPACK_IMPORTED_MODULE_34__views_Horses_Add_HorseAdd__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Horses",
        link: "secretary-horses"
      }, {
        name: "Add Horse",
        link: "secretary-add-horse"
      }],
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 189.42 179.46"><g data-name="Layer 2"><g fill="currentColor" data-name="Layer 1"><path d="M57.34 126.27c-5.58 5.48-11.15 11-16.77 16.42-1 .92-.15 1.4.23 2q11 16.53 22 33a3.12 3.12 0 0 1 .86 1.76h-11c-.68 0-1-.4-1.26-.87L27.58 143c-.57-.84-.34-1.23.26-1.81 2.75-2.66 5.4-5.42 8.21-8 1.1-1 .91-1.68.21-2.75-4.52-6.89-8.93-13.87-12-21.53-5.3-13-6.11-26.25-.94-39.53a31 31 0 0 1 11.83-15c1-.65.93-1 .16-1.75-3.51-3.42-7.4-3.64-11.62-.53S17 59.3 14.93 63.83a58.7 58.7 0 0 0-4.38 31.92 74.6 74.6 0 0 0 9.64 28 2.41 2.41 0 0 1-.34 3.3c-3.42 4-6.75 8-10 12.07-.72.9-1.18 1.11-2.11.26-1.78-1.61-3.64-3.14-5.53-4.61-.87-.67-1-1.09-.22-2 2.12-2.4 4.09-4.92 6.18-7.35a1.91 1.91 0 0 0 .32-2.42A80.54 80.54 0 0 1 .37 94.88c0-.26-.08-.48-.37-.54V80.28c.9-2.4.9-5 1.48-7.45 2-8.79 5.27-17 11.14-24 3.31-3.95 7.27-7 12.33-8.36 6-1.59 11.44-.14 16.16 3.9a10.4 10.4 0 0 1 2.35 2.33c1.68 2.83 4 3.26 7.18 3.23 22.31-.18 44.63-.1 66.94-.1h2.14a76.63 76.63 0 0 0-6.17 6.25c-2.48 3.16-5.48 4-9.41 3.9-17.32-.22-34.64-.1-52-.1-9.92 0-16 4.08-19.61 13.38-4.16 10.83-3.38 21.58 1.09 32.14 2.88 6.82 6.81 13 10.82 19.28l7.28-7.21c0-.79.6-1.19 1.06-1.65 4.89-4.86 10-9.43 14.78-14.43 1-1 1.8-1 2.79 0 1.61 1.69 3.29 3.32 4.94 5a1.56 1.56 0 0 1 .06 2.54c-5.85 5.73-11.35 11.83-17.67 17.21a.93.93 0 0 1-.34.13zM189.41 0v76.21a37 37 0 0 1-1.88 12.71c-3.25 8.94-9.45 11-16.9 10.87-.95 0-1.25-.65-1.67-1.23L156.35 81c-.27-.38-.58-.74-1-1.28a128 128 0 0 0-5.88 15.16c-1.41 4.3-2.51 8.69-3.63 13.07-.34 1.36 0 1.66 1.38 1.64 6-.06 12 .26 17.94-.1a13.55 13.55 0 0 1 13.72 17.6c-2.16 7.9-6.25 14.79-10.69 21.53-.78 1.18-1.66 2.3-2.43 3.48-.45.7-.81.69-1.44.19-2-1.59-4.08-3.18-6.2-4.67-.91-.64-.79-1.06-.21-1.86a89.12 89.12 0 0 0 9.47-16 26.83 26.83 0 0 0 2-6.12 3.14 3.14 0 0 0-3.19-4h-21.45c-1.38 0-1.3.88-1.41 1.64q-1.23 8-2 16.12c-1.3 13.58-1.6 27.2-1.7 40.82 0 1-.26 1.27-1.24 1.24-2.53-.06-5.06-.05-7.58 0-.93 0-1.28-.2-1.27-1.21.07-10.3.36-20.59.94-30.87.52-9.29 1.64-18.52 2.79-27.74-.38-1.88.25-3.67.58-5.46 2.7-14.59 6.83-28.73 13.43-42.07a7.84 7.84 0 0 1 1.51-2.3l5-9.18c.69.16.85.75 1.16 1.18q9.38 13 18.72 26.08c1.34 1.88 1.66 1.69 3.16.08s2-4.08 2.22-6.33a55.48 55.48 0 0 0 .4-6.82V0z"/><path d="M169.44 0c0 9.55 0 19.1.05 28.65 0 1.06-.31 1.35-1.34 1.32-2.47-.07-4.93 0-7.4 0a1.58 1.58 0 0 1-1.56-.85c-3.64-5.47-8.59-9-15.33-9.11-7.51-.16-15-.08-22.55 0-1.5 0-1.86-.44-1.79-1.85.11-2.28.08-4.56 0-6.84 0-1 .21-1.38 1.31-1.37 8.81.05 17.62 0 26.43.1a18.77 18.77 0 0 1 12.18 4.79V0zM139.77 29.9c-3.5 3.46-6.61 6.51-9.7 9.59a1.86 1.86 0 0 1-1.52.44h-27.54c-1.17 0-1.46-.37-1.43-1.48.08-2.4.07-4.8 0-7.21 0-1 .21-1.39 1.31-1.39 12.76.07 25.51.05 38.88.05zM62.91 134.47c7.94-7.8 15.9-15.59 23.8-23.43a4.54 4.54 0 0 1 3.53-1.48c10.83.06 21.66 0 32.49 0 2.32 0 2.32 0 1.94 2.18q-.66 3.9-1.33 7.8a3.76 3.76 0 0 1-2 .19H93.98a3.75 3.75 0 0 0-2.93 1.16q-10.59 10.57-21.3 21c-.91.89-1.08 1.43-.3 2.57 5.19 7.64 10.27 15.34 15.38 23 .36.54.71 1.09 1.24 1.92H74.61c-.71 0-.92-.55-1.21-1q-8.55-12.81-17.11-25.62a1.3 1.3 0 0 1 .21-2c2.18-1.98 4.28-4.15 6.41-6.29z"/></g></g></svg>',
      showInNavar: false,
      requiresAuth: ["Secretary", "SecretaryOnly"]
    }
  }, {
    path: "/switch-committee",
    name: "Switch Committee",
    component: __WEBPACK_IMPORTED_MODULE_30__views_Committees_Switch_SwitchCommittee__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Switch Committee"
      }],
      showInNavar: true,
      requiresSuperSecretary: true,
      icon: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 640 512" width="24" height="19"><path fill="currentColor" d="M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z"/></svg>',
      requiresAuth: ["Secretary", "SecretaryOnly"]
    }
  }, {
    path: "/export-reports",
    name: "Export Reports",
    component: __WEBPACK_IMPORTED_MODULE_47__views_Export_Report__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Export Reports"
      }],
      showInNavar: true,
      requiresAuth: ["Admin", "SuperAdmin", "Secretary", "SecretaryOnly"],
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" width="24" height="24"><g><path fill="currentColor" d="M7.5 9.5c-.1 0-.3 0-.4-.1l-3-3c-.2-.2-.2-.5 0-.7s.5-.2.7 0l2.6 2.6L10 5.7c.2-.2.5-.2.7 0s.2.5 0 .7l-3 3c.1.1-.1.1-.2.1z"/><path fill="currentColor" d="M7.5 9c-.3 0-.5-.2-.5-.5v-8c0-.3.2-.5.5-.5s.5.2.5.5v8c0 .3-.2.5-.5.5z"/><g><path fill="currentColor" d="M12.5 15h-10C1.1 15 0 13.9 0 12.5v-2c0-.3.2-.5.5-.5s.5.2.5.5v2c0 .8.7 1.5 1.5 1.5h10c.8 0 1.5-.7 1.5-1.5v-2c0-.3.2-.5.5-.5s.5.2.5.5v2c0 1.4-1.1 2.5-2.5 2.5z"/></g></g></svg>'
    }
  }, {
    path: "/my-account",
    name: "My Profile",
    component: __WEBPACK_IMPORTED_MODULE_22__views_MyMembership_MyMembershipProfile__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "My Profile",
        link: "my-account"
      }],
      icon: '<svg width="24" height="19" viewBox="-42 0 512 512.001" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="m210.351562 246.632812c33.882813 0 63.21875-12.152343 87.195313-36.128906 23.96875-23.972656 36.125-53.304687 36.125-87.191406 0-33.875-12.152344-63.210938-36.128906-87.191406-23.976563-23.96875-53.3125-36.121094-87.191407-36.121094-33.886718 0-63.21875 12.152344-87.191406 36.125s-36.128906 53.308594-36.128906 87.1875c0 33.886719 12.15625 63.222656 36.128906 87.195312 23.980469 23.96875 53.316406 36.125 87.191406 36.125zm-65.972656-189.292968c18.394532-18.394532 39.972656-27.335938 65.972656-27.335938 25.996094 0 47.578126 8.941406 65.976563 27.335938 18.394531 18.398437 27.339844 39.980468 27.339844 65.972656 0 26-8.945313 47.578125-27.339844 65.976562-18.398437 18.398438-39.980469 27.339844-65.976563 27.339844-25.992187 0-47.570312-8.945312-65.972656-27.339844-18.398437-18.394531-27.34375-39.976562-27.34375-65.976562 0-25.992188 8.945313-47.574219 27.34375-65.972656zm0 0"/><path fill="currentColor" d="m426.128906 393.703125c-.691406-9.976563-2.089844-20.859375-4.148437-32.351563-2.078125-11.578124-4.753907-22.523437-7.957031-32.527343-3.3125-10.339844-7.808594-20.550781-13.375-30.335938-5.769532-10.15625-12.550782-19-20.160157-26.277343-7.957031-7.613282-17.699219-13.734376-28.964843-18.199219-11.226563-4.441407-23.667969-6.691407-36.976563-6.691407-5.226563 0-10.28125 2.144532-20.042969 8.5-6.007812 3.917969-13.035156 8.449219-20.878906 13.460938-6.707031 4.273438-15.792969 8.277344-27.015625 11.902344-10.949219 3.542968-22.066406 5.339844-33.042969 5.339844-10.96875 0-22.085937-1.796876-33.042968-5.339844-11.210938-3.621094-20.300782-7.625-26.996094-11.898438-7.769532-4.964844-14.800782-9.496094-20.898438-13.46875-9.753906-6.355468-14.808594-8.5-20.035156-8.5-13.3125 0-25.75 2.253906-36.972656 6.699219-11.257813 4.457031-21.003906 10.578125-28.96875 18.199219-7.609375 7.28125-14.390625 16.121094-20.15625 26.273437-5.558594 9.785157-10.058594 19.992188-13.371094 30.339844-3.199219 10.003906-5.875 20.945313-7.953125 32.523437-2.0625 11.476563-3.457031 22.363282-4.148437 32.363282-.679688 9.777344-1.023438 19.953125-1.023438 30.234375 0 26.726562 8.496094 48.363281 25.25 64.320312 16.546875 15.746094 38.4375 23.730469 65.066406 23.730469h246.53125c26.621094 0 48.511719-7.984375 65.0625-23.730469 16.757813-15.945312 25.253906-37.589843 25.253906-64.324219-.003906-10.316406-.351562-20.492187-1.035156-30.242187zm-44.90625 72.828125c-10.933594 10.40625-25.449218 15.464844-44.378906 15.464844h-246.527344c-18.933594 0-33.449218-5.058594-44.378906-15.460938-10.722656-10.207031-15.933594-24.140625-15.933594-42.585937 0-9.59375.316406-19.066407.949219-28.160157.617187-8.921874 1.878906-18.722656 3.75-29.136718 1.847656-10.285156 4.199219-19.9375 6.996094-28.675782 2.683593-8.378906 6.34375-16.675781 10.882812-24.667968 4.332031-7.617188 9.316407-14.152344 14.816407-19.417969 5.144531-4.925781 11.628906-8.957031 19.269531-11.980469 7.066406-2.796875 15.007812-4.328125 23.628906-4.558594 1.050781.558594 2.921875 1.625 5.953125 3.601563 6.167969 4.019531 13.277344 8.605469 21.136719 13.625 8.859375 5.648437 20.273437 10.75 33.910156 15.152344 13.941406 4.507812 28.160156 6.796875 42.273437 6.796875 14.113282 0 28.335938-2.289063 42.269532-6.792969 13.648437-4.410156 25.058594-9.507813 33.929687-15.164063 8.042969-5.140624 14.953125-9.59375 21.121094-13.617187 3.03125-1.972656 4.902344-3.042969 5.953125-3.601563 8.625.230469 16.566406 1.761719 23.636719 4.558594 7.636719 3.023438 14.121093 7.058594 19.265625 11.980469 5.5 5.261719 10.484375 11.796875 14.816406 19.421875 4.542969 7.988281 8.207031 16.289062 10.886719 24.660156 2.800781 8.75 5.15625 18.398438 7 28.675782 1.867187 10.433593 3.132812 20.238281 3.75 29.144531v.007812c.636719 9.058594.957031 18.527344.960937 28.148438-.003906 18.449219-5.214844 32.378906-15.9375 42.582031zm0 0"/></svg>',
      showInNavar: true,
      requiresAuth: ["Member", "Secretary", "SecretaryOnly", "Volunteer"]
    }
  }, {
    path: '/invoices',
    name: 'InvoicesList',
    component: InvoicesList,
    displayName: 'My Invoices',
    meta: {
      breadcrumb: [{
        name: 'Dashboard',
        link: ''
      }, {
        name: 'Invoices'
      }],
      showInNavar: true,
      childOf: 'Nominations',
      requiresAuth: ['Member', 'Secretary', 'Volunteer']
    }
  }, {
    path: "/login",
    name: "Login",
    component: __WEBPACK_IMPORTED_MODULE_3__views_Account_Login__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Log In"
      }],
      requiresAuth: null
    }
  }, {
    path: "/maintenance",
    name: "Maintenance",
    component: __WEBPACK_IMPORTED_MODULE_4__views_Account_Maintenance__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Maintenance"
      }],
      requiresAuth: null
    }
  }, {
    path: "/members",
    name: "Members",
    component: __WEBPACK_IMPORTED_MODULE_10__views_Members_Listing_Members__["a" /* default */],
    meta: {
      memberList: {
        title: "Members"
      },
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Members"
      }],
      requiresAuth: ["Secretary", "SecretaryOnly"],
      showInNavar: true,
      childOf: "Committees Dashboard",
      icon: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 640 512" width="24" height="19"><path fill="currentColor" d="M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z"/></svg>'
    }
  }, {
    path: "/admin-members",
    name: "Members ",
    component: __WEBPACK_IMPORTED_MODULE_10__views_Members_Listing_Members__["a" /* default */],
    meta: {
      memberList: {
        title: "Members"
      },
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Members"
      }],
      requiresAuth: ["Admin", "SuperAdmin"],
      showInNavar: true,
      icon: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 640 512" width="24" height="19"><path fill="currentColor" d="M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z"/></svg>'
    }
  }, {
    path: "/admin-register",
    name: "Register Member ",
    component: __WEBPACK_IMPORTED_MODULE_9__views_Admin_Register_Register__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Register Member"
      }],
      requiresAuth: ["Admin", "SuperAdmin"],
      showInNavar: true,
      icon: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 640 512" width="24" height="19"><path fill="currentColor" d="M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z"/></svg>'
    }
  }, {
    path: "/members/:slug/merge",
    name: "Merge Member",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_14__views_Members_Merge_MemberMerge__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Members",
        link: "members"
      }, {
        name: "Member Profile",
        params: {
          slug: true
        }
      }, {
        name: "Merge Member"
      }],
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/members/:slug",
    name: "Member Profile",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_12__views_Members_Profile_MemberProfileMembers__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Members",
        link: "members"
      }, {
        name: "Member Profile"
      }],
      requiresAuth: ["Admin", "SuperAdmin", "Member", "Secretary", "SecretaryOnly"]
    }
  }, {
    path: "/members/:entityId/boy-status-history/:stateId/affected-results",
    name: "Member BOY Affected Results",
    component: AffectedResultsView,
    props: function props(route) {
      return {
        type: "rider",
        entityId: route.params.entityId,
        stateId: route.params.stateId
      };
    },
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Members",
        link: "members"
      }, {
        name: "Member Profile",
        link: "members/member-profile"
      }, {
        name: "Affected Results"
      }],
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/registrations-pending/horse",
    name: "Pending Horse",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_18__views_Admin_Pending_Horse_Horse__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Pending Horse Updates",
        link: "registrations-pending"
      }, {
        name: "Pending Horse"
      }],
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/members/member-profile/member-profile-child",
    name: "Member Profile Child",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_13__views_Members_Profile_MemberProfileChild__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Members",
        link: "members"
      }, {
        name: "Member Profile",
        link: "members/member-profile"
      }, {
        name: "Member Profile Child"
      }],
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/members/member-profile/join-members",
    name: "Join Members",
    component: __WEBPACK_IMPORTED_MODULE_11__views_Members_Join_MemberJoin__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Members",
        link: "members"
      }, {
        name: "Member Profile",
        link: "members/member-profile"
      }, {
        name: "Join Members",
        link: "/members/member-profile/join-members"
      }],
      showInNavar: false,
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/my-account/user-details",
    name: "My Membership Child",
    component: __WEBPACK_IMPORTED_MODULE_23__views_MyMembership_MyMembershipProfileChild__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "My Profile",
        link: "my-account"
      }, {
        name: "Account Details",
        link: "my-account/user-details"
      }],
      showInNavar: false,
      requiresAuth: ["Member", "Secretary", "SecretaryOnly"]
    }
  }, {
    path: "/my-account/cart",
    name: "My Membership Cart",
    component: __WEBPACK_IMPORTED_MODULE_24__views_MyMembership_MyMembershipCart__["a" /* default */],
    props: true,
    meta: {
      cartFlow: true,
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "My Profile",
        link: "my-account"
      }, {
        name: "Cart",
        link: "my-account/cart"
      }],
      showInNavar: false,
      requiresAuth: ["Admin", "SuperAdmin", "Member", "Secretary", "SecretaryOnly"]
    }
  }, {
    path: "/my-account/payment",
    name: "My Membership Payment",
    component: __WEBPACK_IMPORTED_MODULE_25__views_MyMembership_MyMembershipPayment__["a" /* default */],
    props: true,
    meta: {
      cartFlow: true,
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "My Profile",
        link: "my-account"
      }, {
        name: "Payment",
        link: "my-account/payment"
      }],
      showInNavar: false,
      requiresAuth: ["Admin", "SuperAdmin", "Member", "Secretary", "SecretaryOnly"]
    }
  }, {
    path: "/judges/application/:member_id?",
    name: "Judge Application",
    component: __WEBPACK_IMPORTED_MODULE_50__views_Judges_Application_JudgeApplication_vue__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Judge Application"
      }],
      icon: '<svg width="17" height="19" viewBox="0 0 17 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.4479 2.51785C14.5937 2.87379 12.6909 2.53772 10.7919 1.51932C8.00016 0.0215335 5.54815 0.0865566 3.9828 0.404766C2.2793 0.751005 1.2443 1.45222 1.20114 1.48213C1.1084 1.5458 1.05262 1.6486 1.05204 1.75821L1.0256 5.60695C1.01393 5.61447 1.00597 5.61974 1.00445 5.62086L1.02532 5.6486L0.994427 10.1748C0.994409 10.1774 0.994225 10.1798 0.994376 10.1823L0.940708 18.071C0.939417 18.2602 1.09822 18.4144 1.29563 18.4156C1.49304 18.4169 1.65393 18.2647 1.65523 18.0755L1.70783 10.368C2.45769 9.93136 5.97238 8.16994 10.3855 10.5372C12.4332 11.6359 14.4976 11.9972 16.5209 11.6118C16.5914 11.5984 16.6536 11.5655 16.7019 11.5198C16.7675 11.4578 16.8077 11.372 16.8085 11.2785L16.8753 2.85613C16.8761 2.75331 16.8285 2.65502 16.7455 2.58945C16.6626 2.52387 16.5534 2.49752 16.4479 2.51785ZM12.5437 2.98201L12.5198 6.44981C11.879 6.26177 11.237 6.00236 10.5952 5.65805C10.1405 5.41419 9.69516 5.21414 9.25902 5.04707L9.2827 1.57653C9.66118 1.72693 10.0481 1.90467 10.4431 2.11668C11.1422 2.49186 11.8431 2.77923 12.5437 2.98201ZM8.56988 1.32379L8.54598 4.80127C7.35501 4.4385 6.25241 4.33377 5.27851 4.37512L5.30216 0.909101C6.25614 0.850024 7.36 0.943953 8.56988 1.32379ZM1.76547 1.94558C2.13216 1.72672 3.1392 1.19822 4.58727 0.984851L4.56357 4.43263C3.33258 4.57859 2.35854 4.93667 1.74294 5.22257L1.76547 1.94558ZM1.71321 9.57866L1.73769 5.99255C2.21445 5.73725 3.20779 5.2897 4.5589 5.11705L4.53412 8.72302C4.31882 8.75186 4.11527 8.78658 3.92533 8.8251C2.94733 9.02398 2.18935 9.33999 1.71321 9.57866ZM5.2493 8.65502L5.27387 5.05502C6.23616 5.01214 7.34073 5.12432 8.54107 5.52056L8.51709 9.03371C7.29741 8.68335 6.18774 8.60198 5.2493 8.65502ZM9.23007 9.26385L9.25381 5.78557C9.57917 5.92046 9.90978 6.07508 10.2463 6.25557C11.0012 6.66064 11.7585 6.96467 12.5149 7.16877L12.4909 10.6803C11.9058 10.4963 11.3201 10.2539 10.7344 9.93998C10.2203 9.66378 9.71785 9.44174 9.23007 9.26385ZM16.0963 10.989C15.1419 11.1341 14.1753 11.0906 13.2042 10.8727L13.2285 7.33064C14.1985 7.51138 15.1662 7.52568 16.125 7.37317L16.0963 10.989ZM16.1306 6.67439C15.1749 6.84193 14.2068 6.82456 13.2332 6.62701L13.2568 3.15873C14.2281 3.35885 15.1969 3.39446 16.1574 3.26085L16.1306 6.67439Z" fill="currentColor"/></svg>',
      showInNavar: false,
      requiresAuth: ["Member", "Secretary"]
    }
  }, {
    path: "/judges/dashboard",
    name: "Judges Dashboard",
    component: __WEBPACK_IMPORTED_MODULE_68__views_Judges_Dashboard_JudgeDashboard__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Judge Application"
      }],
      icon: '<svg width="17" height="19" viewBox="0 0 17 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.4479 2.51785C14.5937 2.87379 12.6909 2.53772 10.7919 1.51932C8.00016 0.0215335 5.54815 0.0865566 3.9828 0.404766C2.2793 0.751005 1.2443 1.45222 1.20114 1.48213C1.1084 1.5458 1.05262 1.6486 1.05204 1.75821L1.0256 5.60695C1.01393 5.61447 1.00597 5.61974 1.00445 5.62086L1.02532 5.6486L0.994427 10.1748C0.994409 10.1774 0.994225 10.1798 0.994376 10.1823L0.940708 18.071C0.939417 18.2602 1.09822 18.4144 1.29563 18.4156C1.49304 18.4169 1.65393 18.2647 1.65523 18.0755L1.70783 10.368C2.45769 9.93136 5.97238 8.16994 10.3855 10.5372C12.4332 11.6359 14.4976 11.9972 16.5209 11.6118C16.5914 11.5984 16.6536 11.5655 16.7019 11.5198C16.7675 11.4578 16.8077 11.372 16.8085 11.2785L16.8753 2.85613C16.8761 2.75331 16.8285 2.65502 16.7455 2.58945C16.6626 2.52387 16.5534 2.49752 16.4479 2.51785ZM12.5437 2.98201L12.5198 6.44981C11.879 6.26177 11.237 6.00236 10.5952 5.65805C10.1405 5.41419 9.69516 5.21414 9.25902 5.04707L9.2827 1.57653C9.66118 1.72693 10.0481 1.90467 10.4431 2.11668C11.1422 2.49186 11.8431 2.77923 12.5437 2.98201ZM8.56988 1.32379L8.54598 4.80127C7.35501 4.4385 6.25241 4.33377 5.27851 4.37512L5.30216 0.909101C6.25614 0.850024 7.36 0.943953 8.56988 1.32379ZM1.76547 1.94558C2.13216 1.72672 3.1392 1.19822 4.58727 0.984851L4.56357 4.43263C3.33258 4.57859 2.35854 4.93667 1.74294 5.22257L1.76547 1.94558ZM1.71321 9.57866L1.73769 5.99255C2.21445 5.73725 3.20779 5.2897 4.5589 5.11705L4.53412 8.72302C4.31882 8.75186 4.11527 8.78658 3.92533 8.8251C2.94733 9.02398 2.18935 9.33999 1.71321 9.57866ZM5.2493 8.65502L5.27387 5.05502C6.23616 5.01214 7.34073 5.12432 8.54107 5.52056L8.51709 9.03371C7.29741 8.68335 6.18774 8.60198 5.2493 8.65502ZM9.23007 9.26385L9.25381 5.78557C9.57917 5.92046 9.90978 6.07508 10.2463 6.25557C11.0012 6.66064 11.7585 6.96467 12.5149 7.16877L12.4909 10.6803C11.9058 10.4963 11.3201 10.2539 10.7344 9.93998C10.2203 9.66378 9.71785 9.44174 9.23007 9.26385ZM16.0963 10.989C15.1419 11.1341 14.1753 11.0906 13.2042 10.8727L13.2285 7.33064C14.1985 7.51138 15.1662 7.52568 16.125 7.37317L16.0963 10.989ZM16.1306 6.67439C15.1749 6.84193 14.2068 6.82456 13.2332 6.62701L13.2568 3.15873C14.2281 3.35885 15.1969 3.39446 16.1574 3.26085L16.1306 6.67439Z" fill="currentColor"/></svg>',
      showInNavar: true,
      requiresAuth: ["Member", "Secretary"]
    }
  }, {
    path: "/judges/admin-dashboard",
    name: "Judges",
    component: __WEBPACK_IMPORTED_MODULE_52__views_Judges_Admin_JudgeAdminDashboard_vue__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Admin Judge Dashboard"
      }],
      icon: '<svg width="24" height="24" viewBox="0 0 17 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.4479 2.51785C14.5937 2.87379 12.6909 2.53772 10.7919 1.51932C8.00016 0.0215335 5.54815 0.0865566 3.9828 0.404766C2.2793 0.751005 1.2443 1.45222 1.20114 1.48213C1.1084 1.5458 1.05262 1.6486 1.05204 1.75821L1.0256 5.60695C1.01393 5.61447 1.00597 5.61974 1.00445 5.62086L1.02532 5.6486L0.994427 10.1748C0.994409 10.1774 0.994225 10.1798 0.994376 10.1823L0.940708 18.071C0.939417 18.2602 1.09822 18.4144 1.29563 18.4156C1.49304 18.4169 1.65393 18.2647 1.65523 18.0755L1.70783 10.368C2.45769 9.93136 5.97238 8.16994 10.3855 10.5372C12.4332 11.6359 14.4976 11.9972 16.5209 11.6118C16.5914 11.5984 16.6536 11.5655 16.7019 11.5198C16.7675 11.4578 16.8077 11.372 16.8085 11.2785L16.8753 2.85613C16.8761 2.75331 16.8285 2.65502 16.7455 2.58945C16.6626 2.52387 16.5534 2.49752 16.4479 2.51785ZM12.5437 2.98201L12.5198 6.44981C11.879 6.26177 11.237 6.00236 10.5952 5.65805C10.1405 5.41419 9.69516 5.21414 9.25902 5.04707L9.2827 1.57653C9.66118 1.72693 10.0481 1.90467 10.4431 2.11668C11.1422 2.49186 11.8431 2.77923 12.5437 2.98201ZM8.56988 1.32379L8.54598 4.80127C7.35501 4.4385 6.25241 4.33377 5.27851 4.37512L5.30216 0.909101C6.25614 0.850024 7.36 0.943953 8.56988 1.32379ZM1.76547 1.94558C2.13216 1.72672 3.1392 1.19822 4.58727 0.984851L4.56357 4.43263C3.33258 4.57859 2.35854 4.93667 1.74294 5.22257L1.76547 1.94558ZM1.71321 9.57866L1.73769 5.99255C2.21445 5.73725 3.20779 5.2897 4.5589 5.11705L4.53412 8.72302C4.31882 8.75186 4.11527 8.78658 3.92533 8.8251C2.94733 9.02398 2.18935 9.33999 1.71321 9.57866ZM5.2493 8.65502L5.27387 5.05502C6.23616 5.01214 7.34073 5.12432 8.54107 5.52056L8.51709 9.03371C7.29741 8.68335 6.18774 8.60198 5.2493 8.65502ZM9.23007 9.26385L9.25381 5.78557C9.57917 5.92046 9.90978 6.07508 10.2463 6.25557C11.0012 6.66064 11.7585 6.96467 12.5149 7.16877L12.4909 10.6803C11.9058 10.4963 11.3201 10.2539 10.7344 9.93998C10.2203 9.66378 9.71785 9.44174 9.23007 9.26385ZM16.0963 10.989C15.1419 11.1341 14.1753 11.0906 13.2042 10.8727L13.2285 7.33064C14.1985 7.51138 15.1662 7.52568 16.125 7.37317L16.0963 10.989ZM16.1306 6.67439C15.1749 6.84193 14.2068 6.82456 13.2332 6.62701L13.2568 3.15873C14.2281 3.35885 15.1969 3.39446 16.1574 3.26085L16.1306 6.67439Z" fill="currentColor"/></svg>',
      showInNavar: true,
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/judges/admin-judges-list",
    name: "Judges list",
    component: __WEBPACK_IMPORTED_MODULE_53__views_Judges_Admin_AdminJudgesList_vue__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Admin Judge Dashboard",
        link: "judges/admin-dashboard"
      }, {
        name: "Judges list",
        link: ""
      }],
      icon: '<svg width="17" height="19" viewBox="0 0 17 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.4479 2.51785C14.5937 2.87379 12.6909 2.53772 10.7919 1.51932C8.00016 0.0215335 5.54815 0.0865566 3.9828 0.404766C2.2793 0.751005 1.2443 1.45222 1.20114 1.48213C1.1084 1.5458 1.05262 1.6486 1.05204 1.75821L1.0256 5.60695C1.01393 5.61447 1.00597 5.61974 1.00445 5.62086L1.02532 5.6486L0.994427 10.1748C0.994409 10.1774 0.994225 10.1798 0.994376 10.1823L0.940708 18.071C0.939417 18.2602 1.09822 18.4144 1.29563 18.4156C1.49304 18.4169 1.65393 18.2647 1.65523 18.0755L1.70783 10.368C2.45769 9.93136 5.97238 8.16994 10.3855 10.5372C12.4332 11.6359 14.4976 11.9972 16.5209 11.6118C16.5914 11.5984 16.6536 11.5655 16.7019 11.5198C16.7675 11.4578 16.8077 11.372 16.8085 11.2785L16.8753 2.85613C16.8761 2.75331 16.8285 2.65502 16.7455 2.58945C16.6626 2.52387 16.5534 2.49752 16.4479 2.51785ZM12.5437 2.98201L12.5198 6.44981C11.879 6.26177 11.237 6.00236 10.5952 5.65805C10.1405 5.41419 9.69516 5.21414 9.25902 5.04707L9.2827 1.57653C9.66118 1.72693 10.0481 1.90467 10.4431 2.11668C11.1422 2.49186 11.8431 2.77923 12.5437 2.98201ZM8.56988 1.32379L8.54598 4.80127C7.35501 4.4385 6.25241 4.33377 5.27851 4.37512L5.30216 0.909101C6.25614 0.850024 7.36 0.943953 8.56988 1.32379ZM1.76547 1.94558C2.13216 1.72672 3.1392 1.19822 4.58727 0.984851L4.56357 4.43263C3.33258 4.57859 2.35854 4.93667 1.74294 5.22257L1.76547 1.94558ZM1.71321 9.57866L1.73769 5.99255C2.21445 5.73725 3.20779 5.2897 4.5589 5.11705L4.53412 8.72302C4.31882 8.75186 4.11527 8.78658 3.92533 8.8251C2.94733 9.02398 2.18935 9.33999 1.71321 9.57866ZM5.2493 8.65502L5.27387 5.05502C6.23616 5.01214 7.34073 5.12432 8.54107 5.52056L8.51709 9.03371C7.29741 8.68335 6.18774 8.60198 5.2493 8.65502ZM9.23007 9.26385L9.25381 5.78557C9.57917 5.92046 9.90978 6.07508 10.2463 6.25557C11.0012 6.66064 11.7585 6.96467 12.5149 7.16877L12.4909 10.6803C11.9058 10.4963 11.3201 10.2539 10.7344 9.93998C10.2203 9.66378 9.71785 9.44174 9.23007 9.26385ZM16.0963 10.989C15.1419 11.1341 14.1753 11.0906 13.2042 10.8727L13.2285 7.33064C14.1985 7.51138 15.1662 7.52568 16.125 7.37317L16.0963 10.989ZM16.1306 6.67439C15.1749 6.84193 14.2068 6.82456 13.2332 6.62701L13.2568 3.15873C14.2281 3.35885 15.1969 3.39446 16.1574 3.26085L16.1306 6.67439Z" fill="currentColor"/></svg>',
      showInNavar: false,
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/judges/admin-apps-list",
    name: "Admin Judges Applications List",
    component: __WEBPACK_IMPORTED_MODULE_51__views_Judges_Application_AdminJudgeAppsList_vue__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Admin Judges Applications List"
      }],
      icon: '<svg width="17" height="19" viewBox="0 0 17 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.4479 2.51785C14.5937 2.87379 12.6909 2.53772 10.7919 1.51932C8.00016 0.0215335 5.54815 0.0865566 3.9828 0.404766C2.2793 0.751005 1.2443 1.45222 1.20114 1.48213C1.1084 1.5458 1.05262 1.6486 1.05204 1.75821L1.0256 5.60695C1.01393 5.61447 1.00597 5.61974 1.00445 5.62086L1.02532 5.6486L0.994427 10.1748C0.994409 10.1774 0.994225 10.1798 0.994376 10.1823L0.940708 18.071C0.939417 18.2602 1.09822 18.4144 1.29563 18.4156C1.49304 18.4169 1.65393 18.2647 1.65523 18.0755L1.70783 10.368C2.45769 9.93136 5.97238 8.16994 10.3855 10.5372C12.4332 11.6359 14.4976 11.9972 16.5209 11.6118C16.5914 11.5984 16.6536 11.5655 16.7019 11.5198C16.7675 11.4578 16.8077 11.372 16.8085 11.2785L16.8753 2.85613C16.8761 2.75331 16.8285 2.65502 16.7455 2.58945C16.6626 2.52387 16.5534 2.49752 16.4479 2.51785ZM12.5437 2.98201L12.5198 6.44981C11.879 6.26177 11.237 6.00236 10.5952 5.65805C10.1405 5.41419 9.69516 5.21414 9.25902 5.04707L9.2827 1.57653C9.66118 1.72693 10.0481 1.90467 10.4431 2.11668C11.1422 2.49186 11.8431 2.77923 12.5437 2.98201ZM8.56988 1.32379L8.54598 4.80127C7.35501 4.4385 6.25241 4.33377 5.27851 4.37512L5.30216 0.909101C6.25614 0.850024 7.36 0.943953 8.56988 1.32379ZM1.76547 1.94558C2.13216 1.72672 3.1392 1.19822 4.58727 0.984851L4.56357 4.43263C3.33258 4.57859 2.35854 4.93667 1.74294 5.22257L1.76547 1.94558ZM1.71321 9.57866L1.73769 5.99255C2.21445 5.73725 3.20779 5.2897 4.5589 5.11705L4.53412 8.72302C4.31882 8.75186 4.11527 8.78658 3.92533 8.8251C2.94733 9.02398 2.18935 9.33999 1.71321 9.57866ZM5.2493 8.65502L5.27387 5.05502C6.23616 5.01214 7.34073 5.12432 8.54107 5.52056L8.51709 9.03371C7.29741 8.68335 6.18774 8.60198 5.2493 8.65502ZM9.23007 9.26385L9.25381 5.78557C9.57917 5.92046 9.90978 6.07508 10.2463 6.25557C11.0012 6.66064 11.7585 6.96467 12.5149 7.16877L12.4909 10.6803C11.9058 10.4963 11.3201 10.2539 10.7344 9.93998C10.2203 9.66378 9.71785 9.44174 9.23007 9.26385ZM16.0963 10.989C15.1419 11.1341 14.1753 11.0906 13.2042 10.8727L13.2285 7.33064C14.1985 7.51138 15.1662 7.52568 16.125 7.37317L16.0963 10.989ZM16.1306 6.67439C15.1749 6.84193 14.2068 6.82456 13.2332 6.62701L13.2568 3.15873C14.2281 3.35885 15.1969 3.39446 16.1574 3.26085L16.1306 6.67439Z" fill="currentColor"/></svg>',
      showInNavar: false,
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/judges-list",
    name: "Public Judges List",
    component: __WEBPACK_IMPORTED_MODULE_54__views_Judges_Listing_Judges__["a" /* default */],
    props: true,
    meta: {
      requiresAuth: null
    }
  }, {
    path: "/judges/:slug/expression-interest",
    name: "Expression Of Interest",
    component: __WEBPACK_IMPORTED_MODULE_55__views_Judges_ExpressionOfInterest_ExpressionInterest__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Judge Dashboard",
        link: "judges/dashboard"
      }, {
        name: "Expression Of Interest",
        link: ""
      }],
      icon: '<svg width="17" height="19" viewBox="0 0 17 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.4479 2.51785C14.5937 2.87379 12.6909 2.53772 10.7919 1.51932C8.00016 0.0215335 5.54815 0.0865566 3.9828 0.404766C2.2793 0.751005 1.2443 1.45222 1.20114 1.48213C1.1084 1.5458 1.05262 1.6486 1.05204 1.75821L1.0256 5.60695C1.01393 5.61447 1.00597 5.61974 1.00445 5.62086L1.02532 5.6486L0.994427 10.1748C0.994409 10.1774 0.994225 10.1798 0.994376 10.1823L0.940708 18.071C0.939417 18.2602 1.09822 18.4144 1.29563 18.4156C1.49304 18.4169 1.65393 18.2647 1.65523 18.0755L1.70783 10.368C2.45769 9.93136 5.97238 8.16994 10.3855 10.5372C12.4332 11.6359 14.4976 11.9972 16.5209 11.6118C16.5914 11.5984 16.6536 11.5655 16.7019 11.5198C16.7675 11.4578 16.8077 11.372 16.8085 11.2785L16.8753 2.85613C16.8761 2.75331 16.8285 2.65502 16.7455 2.58945C16.6626 2.52387 16.5534 2.49752 16.4479 2.51785ZM12.5437 2.98201L12.5198 6.44981C11.879 6.26177 11.237 6.00236 10.5952 5.65805C10.1405 5.41419 9.69516 5.21414 9.25902 5.04707L9.2827 1.57653C9.66118 1.72693 10.0481 1.90467 10.4431 2.11668C11.1422 2.49186 11.8431 2.77923 12.5437 2.98201ZM8.56988 1.32379L8.54598 4.80127C7.35501 4.4385 6.25241 4.33377 5.27851 4.37512L5.30216 0.909101C6.25614 0.850024 7.36 0.943953 8.56988 1.32379ZM1.76547 1.94558C2.13216 1.72672 3.1392 1.19822 4.58727 0.984851L4.56357 4.43263C3.33258 4.57859 2.35854 4.93667 1.74294 5.22257L1.76547 1.94558ZM1.71321 9.57866L1.73769 5.99255C2.21445 5.73725 3.20779 5.2897 4.5589 5.11705L4.53412 8.72302C4.31882 8.75186 4.11527 8.78658 3.92533 8.8251C2.94733 9.02398 2.18935 9.33999 1.71321 9.57866ZM5.2493 8.65502L5.27387 5.05502C6.23616 5.01214 7.34073 5.12432 8.54107 5.52056L8.51709 9.03371C7.29741 8.68335 6.18774 8.60198 5.2493 8.65502ZM9.23007 9.26385L9.25381 5.78557C9.57917 5.92046 9.90978 6.07508 10.2463 6.25557C11.0012 6.66064 11.7585 6.96467 12.5149 7.16877L12.4909 10.6803C11.9058 10.4963 11.3201 10.2539 10.7344 9.93998C10.2203 9.66378 9.71785 9.44174 9.23007 9.26385ZM16.0963 10.989C15.1419 11.1341 14.1753 11.0906 13.2042 10.8727L13.2285 7.33064C14.1985 7.51138 15.1662 7.52568 16.125 7.37317L16.0963 10.989ZM16.1306 6.67439C15.1749 6.84193 14.2068 6.82456 13.2332 6.62701L13.2568 3.15873C14.2281 3.35885 15.1969 3.39446 16.1574 3.26085L16.1306 6.67439Z" fill="currentColor"/></svg>',
      showInNavar: false,
      requiresAuth: ["Member", "Secretary"]
    }
  }, {
    path: "/judges/:slug/active-drafts",
    name: "Active Drafts",
    component: __WEBPACK_IMPORTED_MODULE_56__views_Judges_ExpressionOfInterest_ActiveDrafts__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Judge Dashboard",
        link: "judges/dashboard"
      }, {
        name: "Active Drafts",
        link: ""
      }],
      icon: '<svg width="17" height="19" viewBox="0 0 17 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16.4479 2.51785C14.5937 2.87379 12.6909 2.53772 10.7919 1.51932C8.00016 0.0215335 5.54815 0.0865566 3.9828 0.404766C2.2793 0.751005 1.2443 1.45222 1.20114 1.48213C1.1084 1.5458 1.05262 1.6486 1.05204 1.75821L1.0256 5.60695C1.01393 5.61447 1.00597 5.61974 1.00445 5.62086L1.02532 5.6486L0.994427 10.1748C0.994409 10.1774 0.994225 10.1798 0.994376 10.1823L0.940708 18.071C0.939417 18.2602 1.09822 18.4144 1.29563 18.4156C1.49304 18.4169 1.65393 18.2647 1.65523 18.0755L1.70783 10.368C2.45769 9.93136 5.97238 8.16994 10.3855 10.5372C12.4332 11.6359 14.4976 11.9972 16.5209 11.6118C16.5914 11.5984 16.6536 11.5655 16.7019 11.5198C16.7675 11.4578 16.8077 11.372 16.8085 11.2785L16.8753 2.85613C16.8761 2.75331 16.8285 2.65502 16.7455 2.58945C16.6626 2.52387 16.5534 2.49752 16.4479 2.51785ZM12.5437 2.98201L12.5198 6.44981C11.879 6.26177 11.237 6.00236 10.5952 5.65805C10.1405 5.41419 9.69516 5.21414 9.25902 5.04707L9.2827 1.57653C9.66118 1.72693 10.0481 1.90467 10.4431 2.11668C11.1422 2.49186 11.8431 2.77923 12.5437 2.98201ZM8.56988 1.32379L8.54598 4.80127C7.35501 4.4385 6.25241 4.33377 5.27851 4.37512L5.30216 0.909101C6.25614 0.850024 7.36 0.943953 8.56988 1.32379ZM1.76547 1.94558C2.13216 1.72672 3.1392 1.19822 4.58727 0.984851L4.56357 4.43263C3.33258 4.57859 2.35854 4.93667 1.74294 5.22257L1.76547 1.94558ZM1.71321 9.57866L1.73769 5.99255C2.21445 5.73725 3.20779 5.2897 4.5589 5.11705L4.53412 8.72302C4.31882 8.75186 4.11527 8.78658 3.92533 8.8251C2.94733 9.02398 2.18935 9.33999 1.71321 9.57866ZM5.2493 8.65502L5.27387 5.05502C6.23616 5.01214 7.34073 5.12432 8.54107 5.52056L8.51709 9.03371C7.29741 8.68335 6.18774 8.60198 5.2493 8.65502ZM9.23007 9.26385L9.25381 5.78557C9.57917 5.92046 9.90978 6.07508 10.2463 6.25557C11.0012 6.66064 11.7585 6.96467 12.5149 7.16877L12.4909 10.6803C11.9058 10.4963 11.3201 10.2539 10.7344 9.93998C10.2203 9.66378 9.71785 9.44174 9.23007 9.26385ZM16.0963 10.989C15.1419 11.1341 14.1753 11.0906 13.2042 10.8727L13.2285 7.33064C14.1985 7.51138 15.1662 7.52568 16.125 7.37317L16.0963 10.989ZM16.1306 6.67439C15.1749 6.84193 14.2068 6.82456 13.2332 6.62701L13.2568 3.15873C14.2281 3.35885 15.1969 3.39446 16.1574 3.26085L16.1306 6.67439Z" fill="currentColor"/></svg>',
      showInNavar: false,
      requiresAuth: ["Member", "Secretary", "Admin", "SuperAdmin"]
    }
  }, {
    path: "/judges/secretary-dashboard",
    name: "Judges Secretary Dashboard",
    displayName: "Judges",
    component: __WEBPACK_IMPORTED_MODULE_57__views_Judges_Secretary_JudgeSecretaryDashboard__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Secretary Judges Dashboard",
        link: ""
      }],
      showInNavar: true,
      requiresAuth: ["Secretary", "SecretaryOnly"],
      childOf: "Committees Dashboard"
    }
  }, {
    path: "/judges/secretary/expression-interest/pending",
    name: "Pending Expression Of Interest",
    component: __WEBPACK_IMPORTED_MODULE_58__views_Judges_Secretary_PendingExpressionInterest__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Secretary Judges Dashboard",
        link: "judges/secretary-dashboard"
      }, {
        name: "Pending Expression Of Interest",
        link: ""
      }],
      showInNavar: false,
      requiresAuth: ["Secretary", "SecretaryOnly"],
      childOf: "Committees"
    }
  }, {
    path: "/judges/secretary/expression-interest/approved",
    name: "Approved Expression Of Interest",
    component: __WEBPACK_IMPORTED_MODULE_59__views_Judges_Secretary_ApprovedExpressionInterest__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Secretary Judges Dashboard",
        link: "judges/secretary-dashboard"
      }, {
        name: "Approved Expression Of Interest",
        link: ""
      }],
      showInNavar: false,
      requiresAuth: ["Secretary", "SecretaryOnly"],
      childOf: "Committees"
    }
  }, {
    path: "/judges/survey",
    name: "Judge Survey",
    component: __WEBPACK_IMPORTED_MODULE_60__views_Judges_Surveys_Survey__["a" /* default */],
    props: false,
    meta: {
      breadcrumb: [{
        name: "Judge Survey",
        link: ""
      }],
      showInNavar: false,
      requiresAuth: ["Member", "Secretary"]
    }
  }, {
    path: "/horses",
    name: "My Horses",
    component: __WEBPACK_IMPORTED_MODULE_32__views_Horses_Listing_HorsesListing__["a" /* default */],
    props: true,
    meta: {
      horseList: {
        title: "My Horses",
        variant: "member",
        profileRoute: "Horse Profile",
        addRoute: "Add Horse"
      },
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "My Horses"
      }],
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 189.42 179.46"><g data-name="Layer 2"><g fill="currentColor" data-name="Layer 1"><path d="M57.34 126.27c-5.58 5.48-11.15 11-16.77 16.42-1 .92-.15 1.4.23 2q11 16.53 22 33a3.12 3.12 0 0 1 .86 1.76h-11c-.68 0-1-.4-1.26-.87L27.58 143c-.57-.84-.34-1.23.26-1.81 2.75-2.66 5.4-5.42 8.21-8 1.1-1 .91-1.68.21-2.75-4.52-6.89-8.93-13.87-12-21.53-5.3-13-6.11-26.25-.94-39.53a31 31 0 0 1 11.83-15c1-.65.93-1 .16-1.75-3.51-3.42-7.4-3.64-11.62-.53S17 59.3 14.93 63.83a58.7 58.7 0 0 0-4.38 31.92 74.6 74.6 0 0 0 9.64 28 2.41 2.41 0 0 1-.34 3.3c-3.42 4-6.75 8-10 12.07-.72.9-1.18 1.11-2.11.26-1.78-1.61-3.64-3.14-5.53-4.61-.87-.67-1-1.09-.22-2 2.12-2.4 4.09-4.92 6.18-7.35a1.91 1.91 0 0 0 .32-2.42A80.54 80.54 0 0 1 .37 94.88c0-.26-.08-.48-.37-.54V80.28c.9-2.4.9-5 1.48-7.45 2-8.79 5.27-17 11.14-24 3.31-3.95 7.27-7 12.33-8.36 6-1.59 11.44-.14 16.16 3.9a10.4 10.4 0 0 1 2.35 2.33c1.68 2.83 4 3.26 7.18 3.23 22.31-.18 44.63-.1 66.94-.1h2.14a76.63 76.63 0 0 0-6.17 6.25c-2.48 3.16-5.48 4-9.41 3.9-17.32-.22-34.64-.1-52-.1-9.92 0-16 4.08-19.61 13.38-4.16 10.83-3.38 21.58 1.09 32.14 2.88 6.82 6.81 13 10.82 19.28l7.28-7.21c0-.79.6-1.19 1.06-1.65 4.89-4.86 10-9.43 14.78-14.43 1-1 1.8-1 2.79 0 1.61 1.69 3.29 3.32 4.94 5a1.56 1.56 0 0 1 .06 2.54c-5.85 5.73-11.35 11.83-17.67 17.21a.93.93 0 0 1-.34.13zM189.41 0v76.21a37 37 0 0 1-1.88 12.71c-3.25 8.94-9.45 11-16.9 10.87-.95 0-1.25-.65-1.67-1.23L156.35 81c-.27-.38-.58-.74-1-1.28a128 128 0 0 0-5.88 15.16c-1.41 4.3-2.51 8.69-3.63 13.07-.34 1.36 0 1.66 1.38 1.64 6-.06 12 .26 17.94-.1a13.55 13.55 0 0 1 13.72 17.6c-2.16 7.9-6.25 14.79-10.69 21.53-.78 1.18-1.66 2.3-2.43 3.48-.45.7-.81.69-1.44.19-2-1.59-4.08-3.18-6.2-4.67-.91-.64-.79-1.06-.21-1.86a89.12 89.12 0 0 0 9.47-16 26.83 26.83 0 0 0 2-6.12 3.14 3.14 0 0 0-3.19-4h-21.45c-1.38 0-1.3.88-1.41 1.64q-1.23 8-2 16.12c-1.3 13.58-1.6 27.2-1.7 40.82 0 1-.26 1.27-1.24 1.24-2.53-.06-5.06-.05-7.58 0-.93 0-1.28-.2-1.27-1.21.07-10.3.36-20.59.94-30.87.52-9.29 1.64-18.52 2.79-27.74-.38-1.88.25-3.67.58-5.46 2.7-14.59 6.83-28.73 13.43-42.07a7.84 7.84 0 0 1 1.51-2.3l5-9.18c.69.16.85.75 1.16 1.18q9.38 13 18.72 26.08c1.34 1.88 1.66 1.69 3.16.08s2-4.08 2.22-6.33a55.48 55.48 0 0 0 .4-6.82V0z"/><path d="M169.44 0c0 9.55 0 19.1.05 28.65 0 1.06-.31 1.35-1.34 1.32-2.47-.07-4.93 0-7.4 0a1.58 1.58 0 0 1-1.56-.85c-3.64-5.47-8.59-9-15.33-9.11-7.51-.16-15-.08-22.55 0-1.5 0-1.86-.44-1.79-1.85.11-2.28.08-4.56 0-6.84 0-1 .21-1.38 1.31-1.37 8.81.05 17.62 0 26.43.1a18.77 18.77 0 0 1 12.18 4.79V0zM139.77 29.9c-3.5 3.46-6.61 6.51-9.7 9.59a1.86 1.86 0 0 1-1.52.44h-27.54c-1.17 0-1.46-.37-1.43-1.48.08-2.4.07-4.8 0-7.21 0-1 .21-1.39 1.31-1.39 12.76.07 25.51.05 38.88.05zM62.91 134.47c7.94-7.8 15.9-15.59 23.8-23.43a4.54 4.54 0 0 1 3.53-1.48c10.83.06 21.66 0 32.49 0 2.32 0 2.32 0 1.94 2.18q-.66 3.9-1.33 7.8a3.76 3.76 0 0 1-2 .19H93.98a3.75 3.75 0 0 0-2.93 1.16q-10.59 10.57-21.3 21c-.91.89-1.08 1.43-.3 2.57 5.19 7.64 10.27 15.34 15.38 23 .36.54.71 1.09 1.24 1.92H74.61c-.71 0-.92-.55-1.21-1q-8.55-12.81-17.11-25.62a1.3 1.3 0 0 1 .21-2c2.18-1.98 4.28-4.15 6.41-6.29z"/></g></g></svg>',
      showInNavar: true,
      requiresAuth: ["Member", "Secretary", "Volunteer"]
    }
  }, {
    path: '/draws/public',
    name: 'DrawsPublicList',
    component: DrawsPublicList,
    displayName: 'Draws',
    meta: {
      breadcrumb: [{
        name: 'Draws'
      }],
      showInNavar: true,
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 19" width="24" height="23"><g><path fill="currentColor" d="M8.7999977 12.437501h-.2l-2.2-.9-2.2.9c-.2.1-.5 0-.6-.3l-1-2.1-2.1-1c-.2-.1-.4-.4-.3-.6l.8-2.2-.8-2.2c-.1-.2 0-.5.3-.6l2.1-1 1-2.1c.1-.2.4-.4.6-.3l2.2.8 2.2-.8c.2-.1.5 0 .6.3l1 2.1 2.1 1c.2.1.4.4.3.6l-.8 2.2.8 2.2c.1.2 0 .5-.3.6l-2.1 1-1 2.1c-.1.2-.3.3-.4.3zm-2.4-1.9h.2l1.9.7.9-1.8c0-.1.1-.2.2-.2l1.9-.9-.7-1.9v-.3l.7-1.9-1.9-.9c-.1 0-.2-.1-.2-.2l-.9-1.9-1.9.7h-.3l-1.9-.7-1 1.8c0 .1-.1.2-.2.2l-1.9.9.7 1.9v.3l-.7 1.9 1.9.9c.1 0 .2.1.2.2l.9 1.9 1.9-.7h.2z"/><path fill="currentColor" d="M3.3999977 10.037501l-2.2 6 1.9-.3c.2 0 .4 0 .5.2l1.2 1.5 2.2-6 .9.3-2.5 6.8c-.1.2-.2.3-.4.3h-.1c-.2 0-.3-.1-.4-.2l-1.5-1.9-2.4.4c-.2 0-.4 0-.5-.2-.1-.1-.1-.3-.1-.5l2.5-6.8.9.4z"/><path fill="currentColor" d="M10.2999977 9.737501l2.6 6.8c.1.2 0 .4-.1.5-.1.1-.3.2-.5.2l-2.4-.4-1.5 1.9c-.1.1-.2.2-.4.2h-.1c-.2 0-.3-.1-.4-.3l-1.6-4.2.9-.4 1.2 3.3 1.2-1.5c.1-.1.3-.2.5-.2l1.9.3-2.2-6 .9-.2z"/></g></svg>',
      requiresAuth: ['Member', 'Volunteer', 'Secretary', 'SecretaryOnly']
    }
  }, {
    path: "/admin-horses",
    name: "Horses",
    component: __WEBPACK_IMPORTED_MODULE_32__views_Horses_Listing_HorsesListing__["a" /* default */],
    props: true,
    meta: {
      horseList: {
        title: "Horses",
        variant: "admin",
        profileRoute: "Admin Horse Profile",
        addRoute: "Add Horses"
      },
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Horses"
      }],
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 189.42 179.46"><g data-name="Layer 2"><g fill="currentColor" data-name="Layer 1"><path d="M57.34 126.27c-5.58 5.48-11.15 11-16.77 16.42-1 .92-.15 1.4.23 2q11 16.53 22 33a3.12 3.12 0 0 1 .86 1.76h-11c-.68 0-1-.4-1.26-.87L27.58 143c-.57-.84-.34-1.23.26-1.81 2.75-2.66 5.4-5.42 8.21-8 1.1-1 .91-1.68.21-2.75-4.52-6.89-8.93-13.87-12-21.53-5.3-13-6.11-26.25-.94-39.53a31 31 0 0 1 11.83-15c1-.65.93-1 .16-1.75-3.51-3.42-7.4-3.64-11.62-.53S17 59.3 14.93 63.83a58.7 58.7 0 0 0-4.38 31.92 74.6 74.6 0 0 0 9.64 28 2.41 2.41 0 0 1-.34 3.3c-3.42 4-6.75 8-10 12.07-.72.9-1.18 1.11-2.11.26-1.78-1.61-3.64-3.14-5.53-4.61-.87-.67-1-1.09-.22-2 2.12-2.4 4.09-4.92 6.18-7.35a1.91 1.91 0 0 0 .32-2.42A80.54 80.54 0 0 1 .37 94.88c0-.26-.08-.48-.37-.54V80.28c.9-2.4.9-5 1.48-7.45 2-8.79 5.27-17 11.14-24 3.31-3.95 7.27-7 12.33-8.36 6-1.59 11.44-.14 16.16 3.9a10.4 10.4 0 0 1 2.35 2.33c1.68 2.83 4 3.26 7.18 3.23 22.31-.18 44.63-.1 66.94-.1h2.14a76.63 76.63 0 0 0-6.17 6.25c-2.48 3.16-5.48 4-9.41 3.9-17.32-.22-34.64-.1-52-.1-9.92 0-16 4.08-19.61 13.38-4.16 10.83-3.38 21.58 1.09 32.14 2.88 6.82 6.81 13 10.82 19.28l7.28-7.21c0-.79.6-1.19 1.06-1.65 4.89-4.86 10-9.43 14.78-14.43 1-1 1.8-1 2.79 0 1.61 1.69 3.29 3.32 4.94 5a1.56 1.56 0 0 1 .06 2.54c-5.85 5.73-11.35 11.83-17.67 17.21a.93.93 0 0 1-.34.13zM189.41 0v76.21a37 37 0 0 1-1.88 12.71c-3.25 8.94-9.45 11-16.9 10.87-.95 0-1.25-.65-1.67-1.23L156.35 81c-.27-.38-.58-.74-1-1.28a128 128 0 0 0-5.88 15.16c-1.41 4.3-2.51 8.69-3.63 13.07-.34 1.36 0 1.66 1.38 1.64 6-.06 12 .26 17.94-.1a13.55 13.55 0 0 1 13.72 17.6c-2.16 7.9-6.25 14.79-10.69 21.53-.78 1.18-1.66 2.3-2.43 3.48-.45.7-.81.69-1.44.19-2-1.59-4.08-3.18-6.2-4.67-.91-.64-.79-1.06-.21-1.86a89.12 89.12 0 0 0 9.47-16 26.83 26.83 0 0 0 2-6.12 3.14 3.14 0 0 0-3.19-4h-21.45c-1.38 0-1.3.88-1.41 1.64q-1.23 8-2 16.12c-1.3 13.58-1.6 27.2-1.7 40.82 0 1-.26 1.27-1.24 1.24-2.53-.06-5.06-.05-7.58 0-.93 0-1.28-.2-1.27-1.21.07-10.3.36-20.59.94-30.87.52-9.29 1.64-18.52 2.79-27.74-.38-1.88.25-3.67.58-5.46 2.7-14.59 6.83-28.73 13.43-42.07a7.84 7.84 0 0 1 1.51-2.3l5-9.18c.69.16.85.75 1.16 1.18q9.38 13 18.72 26.08c1.34 1.88 1.66 1.69 3.16.08s2-4.08 2.22-6.33a55.48 55.48 0 0 0 .4-6.82V0z"/><path d="M169.44 0c0 9.55 0 19.1.05 28.65 0 1.06-.31 1.35-1.34 1.32-2.47-.07-4.93 0-7.4 0a1.58 1.58 0 0 1-1.56-.85c-3.64-5.47-8.59-9-15.33-9.11-7.51-.16-15-.08-22.55 0-1.5 0-1.86-.44-1.79-1.85.11-2.28.08-4.56 0-6.84 0-1 .21-1.38 1.31-1.37 8.81.05 17.62 0 26.43.1a18.77 18.77 0 0 1 12.18 4.79V0zM139.77 29.9c-3.5 3.46-6.61 6.51-9.7 9.59a1.86 1.86 0 0 1-1.52.44h-27.54c-1.17 0-1.46-.37-1.43-1.48.08-2.4.07-4.8 0-7.21 0-1 .21-1.39 1.31-1.39 12.76.07 25.51.05 38.88.05zM62.91 134.47c7.94-7.8 15.9-15.59 23.8-23.43a4.54 4.54 0 0 1 3.53-1.48c10.83.06 21.66 0 32.49 0 2.32 0 2.32 0 1.94 2.18q-.66 3.9-1.33 7.8a3.76 3.76 0 0 1-2 .19H93.98a3.75 3.75 0 0 0-2.93 1.16q-10.59 10.57-21.3 21c-.91.89-1.08 1.43-.3 2.57 5.19 7.64 10.27 15.34 15.38 23 .36.54.71 1.09 1.24 1.92H74.61c-.71 0-.92-.55-1.21-1q-8.55-12.81-17.11-25.62a1.3 1.3 0 0 1 .21-2c2.18-1.98 4.28-4.15 6.41-6.29z"/></g></g></svg>',
      showInNavar: true,
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: '/draws',
    redirect: '/draws/dashboard',
    meta: {
      showInNavar: false
    }
  }, {
    path: '/leaders/drafts',
    name: "Leaderboard",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_61__views_Leaders_Listing_Drafts__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Leaderboard"
      }],
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 19" width="24" height="23"><g><path fill="currentColor" d="M8.7999977 12.437501h-.2l-2.2-.9-2.2.9c-.2.1-.5 0-.6-.3l-1-2.1-2.1-1c-.2-.1-.4-.4-.3-.6l.8-2.2-.8-2.2c-.1-.2 0-.5.3-.6l2.1-1 1-2.1c.1-.2.4-.4.6-.3l2.2.8 2.2-.8c.2-.1.5 0 .6.3l1 2.1 2.1 1c.2.1.4.4.3.6l-.8 2.2.8 2.2c.1.2 0 .5-.3.6l-2.1 1-1 2.1c-.1.2-.3.3-.4.3zm-2.4-1.9h.2l1.9.7.9-1.8c0-.1.1-.2.2-.2l1.9-.9-.7-1.9v-.3l.7-1.9-1.9-.9c-.1 0-.2-.1-.2-.2l-.9-1.9-1.9.7h-.3l-1.9-.7-1 1.8c0 .1-.1.2-.2.2l-1.9.9.7 1.9v.3l-.7 1.9 1.9.9c.1 0 .2.1.2.2l.9 1.9 1.9-.7h.2z"/><path fill="currentColor" d="M3.3999977 10.037501l-2.2 6 1.9-.3c.2 0 .4 0 .5.2l1.2 1.5 2.2-6 .9.3-2.5 6.8c-.1.2-.2.3-.4.3h-.1c-.2 0-.3-.1-.4-.2l-1.5-1.9-2.4.4c-.2 0-.4 0-.5-.2-.1-.1-.1-.3-.1-.5l2.5-6.8.9.4z"/><path fill="currentColor" d="M10.2999977 9.737501l2.6 6.8c.1.2 0 .4-.1.5-.1.1-.3.2-.5.2l-2.4-.4-1.5 1.9c-.1.1-.2.2-.4.2h-.1c-.2 0-.3-.1-.4-.3l-1.6-4.2.9-.4 1.2 3.3 1.2-1.5c.1-.1.3-.2.5-.2l1.9.3-2.2-6 .9-.2z"/></g></svg>',
      showInNavar: true,
      requiresAuth: ["Member", "Secretary", "SecretaryOnly", "Admin", "SuperAdmin"]
    }
  }, {
    path: '/leaders/drafts/:draft_id',
    name: 'LeadersDraft',
    component: __WEBPACK_IMPORTED_MODULE_62__views_Leaders_Listing_Draft__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Leaderboard",
        link: "leaders/drafts"
      }, {
        name: "Draft"
      }],
      showInNavar: false,
      requiresAuth: ["Member", "Secretary", "SecretaryOnly", "Admin", "SuperAdmin"]
    }
  }, {
    path: '/leaders/drafts/:draft_id/cutout-highest',
    name: 'LeadersDraftCutoutHighest',
    component: __WEBPACK_IMPORTED_MODULE_64__views_Leaders_CutoutHighest_Draft__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Leaderboard",
        link: "leaders/drafts"
      }, {
        name: "Draft"
      }, {
        name: "Cutout Highest"
      }],
      showInNavar: false,
      requiresAuth: ["Member", "Secretary", "SecretaryOnly", "Admin"]
    }
  }, {
    path: '/leaders/events/:event_id/cutout-highest/:round?',
    name: 'LeadersEventCutoutHighest',
    component: __WEBPACK_IMPORTED_MODULE_65__views_Leaders_CutoutHighest_Event__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Leaderboard",
        link: "leaders/drafts"
      }, {
        name: "Draft"
      }, {
        name: "Event"
      }, {
        name: "Cutout Highest"
      }],
      showInNavar: false,
      requiresAuth: ["Member", "Secretary", "SecretaryOnly", "Admin"]
    }
  }, {
    path: '/leaders/events/:main_event_id/:round?/:sub_event_id?',
    name: 'LeadersEvent',
    component: __WEBPACK_IMPORTED_MODULE_63__views_Leaders_Listing_Event__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Leaderboard",
        link: "leaders/drafts"
      }, {
        name: "Draft"
      }, {
        name: "Event"
      }],
      showInNavar: false,
      requiresAuth: ["Member", "Secretary", "SecretaryOnly", "Admin", "SuperAdmin"]
    }
  }, {
    path: '/leaders-old',
    beforeEnter: function beforeEnter() {
      location.href = "".concat(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$coy, "/leaders");
    },
    name: "Leaderboard old",
    meta: {
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 19" width="24" height="23"><g><path fill="currentColor" d="M8.7999977 12.437501h-.2l-2.2-.9-2.2.9c-.2.1-.5 0-.6-.3l-1-2.1-2.1-1c-.2-.1-.4-.4-.3-.6l.8-2.2-.8-2.2c-.1-.2 0-.5.3-.6l2.1-1 1-2.1c.1-.2.4-.4.6-.3l2.2.8 2.2-.8c.2-.1.5 0 .6.3l1 2.1 2.1 1c.2.1.4.4.3.6l-.8 2.2.8 2.2c.1.2 0 .5-.3.6l-2.1 1-1 2.1c-.1.2-.3.3-.4.3zm-2.4-1.9h.2l1.9.7.9-1.8c0-.1.1-.2.2-.2l1.9-.9-.7-1.9v-.3l.7-1.9-1.9-.9c-.1 0-.2-.1-.2-.2l-.9-1.9-1.9.7h-.3l-1.9-.7-1 1.8c0 .1-.1.2-.2.2l-1.9.9.7 1.9v.3l-.7 1.9 1.9.9c.1 0 .2.1.2.2l.9 1.9 1.9-.7h.2z"/><path fill="currentColor" d="M3.3999977 10.037501l-2.2 6 1.9-.3c.2 0 .4 0 .5.2l1.2 1.5 2.2-6 .9.3-2.5 6.8c-.1.2-.2.3-.4.3h-.1c-.2 0-.3-.1-.4-.2l-1.5-1.9-2.4.4c-.2 0-.4 0-.5-.2-.1-.1-.1-.3-.1-.5l2.5-6.8.9.4z"/><path fill="currentColor" d="M10.2999977 9.737501l2.6 6.8c.1.2 0 .4-.1.5-.1.1-.3.2-.5.2l-2.4-.4-1.5 1.9c-.1.1-.2.2-.4.2h-.1c-.2 0-.3-.1-.4-.3l-1.6-4.2.9-.4 1.2 3.3 1.2-1.5c.1-.1.3-.2.5-.2l1.9.3-2.2-6 .9-.2z"/></g></svg>',
      showInNavar: false,
      requiresAuth: ["Member", "Secretary", "SecretaryOnly", "Admin", "SuperAdmin"]
    }
  }, {
    path: '/nominations',
    name: "Nominations",
    component: NominationsDraftsList,
    meta: {
      breadcrumb: [{
        name: 'Dashboard',
        link: ''
      }, {
        name: 'Nominations'
      }],
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 19" width="24" height="23"><g><path fill="currentColor" d="M8.7999977 12.437501h-.2l-2.2-.9-2.2.9c-.2.1-.5 0-.6-.3l-1-2.1-2.1-1c-.2-.1-.4-.4-.3-.6l.8-2.2-.8-2.2c-.1-.2 0-.5.3-.6l2.1-1 1-2.1c.1-.2.4-.4.6-.3l2.2.8 2.2-.8c.2-.1.5 0 .6.3l1 2.1 2.1 1c.2.1.4.4.3.6l-.8 2.2.8 2.2c.1.2 0 .5-.3.6l-2.1 1-1 2.1c-.1.2-.3.3-.4.3zm-2.4-1.9h.2l1.9.7.9-1.8c0-.1.1-.2.2-.2l1.9-.9-.7-1.9v-.3l.7-1.9-1.9-.9c-.1 0-.2-.1-.2-.2l-.9-1.9-1.9.7h-.3l-1.9-.7-1 1.8c0 .1-.1.2-.2.2l-1.9.9.7 1.9v.3l-.7 1.9 1.9.9c.1 0 .2.1.2.2l.9 1.9 1.9-.7h.2z"/><path fill="currentColor" d="M3.3999977 10.037501l-2.2 6 1.9-.3c.2 0 .4 0 .5.2l1.2 1.5 2.2-6 .9.3-2.5 6.8c-.1.2-.2.3-.4.3h-.1c-.2 0-.3-.1-.4-.2l-1.5-1.9-2.4.4c-.2 0-.4 0-.5-.2-.1-.1-.1-.3-.1-.5l2.5-6.8.9.4z"/><path fill="currentColor" d="M10.2999977 9.737501l2.6 6.8c.1.2 0 .4-.1.5-.1.1-.3.2-.5.2l-2.4-.4-1.5 1.9c-.1.1-.2.2-.4.2h-.1c-.2 0-.3-.1-.4-.3l-1.6-4.2.9-.4 1.2 3.3 1.2-1.5c.1-.1.3-.2.5-.2l1.9.3-2.2-6 .9-.2z"/></g></svg>',
      showInNavar: true,
      requiresAuth: ["Member", "Secretary", "Volunteer", "SecretaryOnly", "Admin", "SuperAdmin"]
    }
  }, {
    path: '/nominations/add/:draftId',
    name: 'Nominations Add',
    component: NominationsAdd,
    props: function props(route) {
      return {
        draftId: route.params.draftId
      };
    },
    meta: {
      breadcrumb: [{
        name: 'Dashboard',
        link: ''
      }, {
        name: 'Nominations',
        link: 'nominations'
      }, {
        name: 'Nominate'
      }],
      requiresAuth: ['Member', 'Secretary', 'Volunteer', 'SecretaryOnly', 'Admin', 'SuperAdmin']
    }
  }, {
    path: '/reports/incoming',
    name: 'ReportsIncoming',
    displayName: 'Reports',
    component: ReportsIncoming,
    meta: {
      breadcrumb: [{
        name: 'Dashboard',
        link: ''
      }, {
        name: 'Reports'
      }],
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 19" width="24" height="23"><g><path fill="currentColor" d="M8.7999977 12.437501h-.2l-2.2-.9-2.2.9c-.2.1-.5 0-.6-.3l-1-2.1-2.1-1c-.2-.1-.4-.4-.3-.6l.8-2.2-.8-2.2c-.1-.2 0-.5.3-.6l2.1-1 1-2.1c.1-.2.4-.4.6-.3l2.2.8 2.2-.8c.2-.1.5 0 .6.3l1 2.1 2.1 1c.2.1.4.4.3.6l-.8 2.2.8 2.2c.1.2 0 .5-.3.6l-2.1 1-1 2.1c-.1.2-.3.3-.4.3zm-2.4-1.9h.2l1.9.7.9-1.8c0-.1.1-.2.2-.2l1.9-.9-.7-1.9v-.3l.7-1.9-1.9-.9c-.1 0-.2-.1-.2-.2l-.9-1.9-1.9.7h-.3l-1.9-.7-1 1.8c0 .1-.1.2-.2.2l-1.9.9.7 1.9v.3l-.7 1.9 1.9.9c.1 0 .2.1.2.2l.9 1.9 1.9-.7h.2z"/><path fill="currentColor" d="M3.3999977 10.037501l-2.2 6 1.9-.3c.2 0 .4 0 .5.2l1.2 1.5 2.2-6 .9.3-2.5 6.8c-.1.2-.2.3-.4.3h-.1c-.2 0-.3-.1-.4-.2l-1.5-1.9-2.4.4c-.2 0-.4 0-.5-.2-.1-.1-.1-.3-.1-.5l2.5-6.8.9.4z"/><path fill="currentColor" d="M10.2999977 9.737501l2.6 6.8c.1.2 0 .4-.1.5-.1.1-.3.2-.5.2l-2.4-.4-1.5 1.9c-.1.1-.2.2-.4.2h-.1c-.2 0-.3-.1-.4-.3l-1.6-4.2.9-.4 1.2 3.3 1.2-1.5c.1-.1.3-.2.5-.2l1.9.3-2.2-6 .9-.2z"/></g></svg>',
      showInNavar: true,
      childOf: 'Committees Dashboard',
      requiresAuth: ['Secretary', 'SecretaryOnly']
    }
  }, {
    path: '/reports/outgoing',
    name: 'ReportsOutgoing',
    component: ReportsOutgoing,
    meta: {
      breadcrumb: [{
        name: 'Dashboard',
        link: ''
      }, {
        name: 'Reports'
      }],
      showInNavar: false,
      childOf: 'Committees Dashboard',
      requiresAuth: ['Secretary', 'SecretaryOnly']
    }
  }, {
    path: "/add-horse",
    name: "Add Horses",
    component: __WEBPACK_IMPORTED_MODULE_34__views_Horses_Add_HorseAdd__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Horses",
        link: "admin-horses"
      }, {
        name: "Add Horse",
        link: "add-horse"
      }],
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 189.42 179.46"><g data-name="Layer 2"><g fill="currentColor" data-name="Layer 1"><path d="M57.34 126.27c-5.58 5.48-11.15 11-16.77 16.42-1 .92-.15 1.4.23 2q11 16.53 22 33a3.12 3.12 0 0 1 .86 1.76h-11c-.68 0-1-.4-1.26-.87L27.58 143c-.57-.84-.34-1.23.26-1.81 2.75-2.66 5.4-5.42 8.21-8 1.1-1 .91-1.68.21-2.75-4.52-6.89-8.93-13.87-12-21.53-5.3-13-6.11-26.25-.94-39.53a31 31 0 0 1 11.83-15c1-.65.93-1 .16-1.75-3.51-3.42-7.4-3.64-11.62-.53S17 59.3 14.93 63.83a58.7 58.7 0 0 0-4.38 31.92 74.6 74.6 0 0 0 9.64 28 2.41 2.41 0 0 1-.34 3.3c-3.42 4-6.75 8-10 12.07-.72.9-1.18 1.11-2.11.26-1.78-1.61-3.64-3.14-5.53-4.61-.87-.67-1-1.09-.22-2 2.12-2.4 4.09-4.92 6.18-7.35a1.91 1.91 0 0 0 .32-2.42A80.54 80.54 0 0 1 .37 94.88c0-.26-.08-.48-.37-.54V80.28c.9-2.4.9-5 1.48-7.45 2-8.79 5.27-17 11.14-24 3.31-3.95 7.27-7 12.33-8.36 6-1.59 11.44-.14 16.16 3.9a10.4 10.4 0 0 1 2.35 2.33c1.68 2.83 4 3.26 7.18 3.23 22.31-.18 44.63-.1 66.94-.1h2.14a76.63 76.63 0 0 0-6.17 6.25c-2.48 3.16-5.48 4-9.41 3.9-17.32-.22-34.64-.1-52-.1-9.92 0-16 4.08-19.61 13.38-4.16 10.83-3.38 21.58 1.09 32.14 2.88 6.82 6.81 13 10.82 19.28l7.28-7.21c0-.79.6-1.19 1.06-1.65 4.89-4.86 10-9.43 14.78-14.43 1-1 1.8-1 2.79 0 1.61 1.69 3.29 3.32 4.94 5a1.56 1.56 0 0 1 .06 2.54c-5.85 5.73-11.35 11.83-17.67 17.21a.93.93 0 0 1-.34.13zM189.41 0v76.21a37 37 0 0 1-1.88 12.71c-3.25 8.94-9.45 11-16.9 10.87-.95 0-1.25-.65-1.67-1.23L156.35 81c-.27-.38-.58-.74-1-1.28a128 128 0 0 0-5.88 15.16c-1.41 4.3-2.51 8.69-3.63 13.07-.34 1.36 0 1.66 1.38 1.64 6-.06 12 .26 17.94-.1a13.55 13.55 0 0 1 13.72 17.6c-2.16 7.9-6.25 14.79-10.69 21.53-.78 1.18-1.66 2.3-2.43 3.48-.45.7-.81.69-1.44.19-2-1.59-4.08-3.18-6.2-4.67-.91-.64-.79-1.06-.21-1.86a89.12 89.12 0 0 0 9.47-16 26.83 26.83 0 0 0 2-6.12 3.14 3.14 0 0 0-3.19-4h-21.45c-1.38 0-1.3.88-1.41 1.64q-1.23 8-2 16.12c-1.3 13.58-1.6 27.2-1.7 40.82 0 1-.26 1.27-1.24 1.24-2.53-.06-5.06-.05-7.58 0-.93 0-1.28-.2-1.27-1.21.07-10.3.36-20.59.94-30.87.52-9.29 1.64-18.52 2.79-27.74-.38-1.88.25-3.67.58-5.46 2.7-14.59 6.83-28.73 13.43-42.07a7.84 7.84 0 0 1 1.51-2.3l5-9.18c.69.16.85.75 1.16 1.18q9.38 13 18.72 26.08c1.34 1.88 1.66 1.69 3.16.08s2-4.08 2.22-6.33a55.48 55.48 0 0 0 .4-6.82V0z"/><path d="M169.44 0c0 9.55 0 19.1.05 28.65 0 1.06-.31 1.35-1.34 1.32-2.47-.07-4.93 0-7.4 0a1.58 1.58 0 0 1-1.56-.85c-3.64-5.47-8.59-9-15.33-9.11-7.51-.16-15-.08-22.55 0-1.5 0-1.86-.44-1.79-1.85.11-2.28.08-4.56 0-6.84 0-1 .21-1.38 1.31-1.37 8.81.05 17.62 0 26.43.1a18.77 18.77 0 0 1 12.18 4.79V0zM139.77 29.9c-3.5 3.46-6.61 6.51-9.7 9.59a1.86 1.86 0 0 1-1.52.44h-27.54c-1.17 0-1.46-.37-1.43-1.48.08-2.4.07-4.8 0-7.21 0-1 .21-1.39 1.31-1.39 12.76.07 25.51.05 38.88.05zM62.91 134.47c7.94-7.8 15.9-15.59 23.8-23.43a4.54 4.54 0 0 1 3.53-1.48c10.83.06 21.66 0 32.49 0 2.32 0 2.32 0 1.94 2.18q-.66 3.9-1.33 7.8a3.76 3.76 0 0 1-2 .19H93.98a3.75 3.75 0 0 0-2.93 1.16q-10.59 10.57-21.3 21c-.91.89-1.08 1.43-.3 2.57 5.19 7.64 10.27 15.34 15.38 23 .36.54.71 1.09 1.24 1.92H74.61c-.71 0-.92-.55-1.21-1q-8.55-12.81-17.11-25.62a1.3 1.3 0 0 1 .21-2c2.18-1.98 4.28-4.15 6.41-6.29z"/></g></g></svg>',
      showInNavar: false,
      requiresAuth: ["Admin", "SuperAdmin", "Secretary", "SecretaryOnly"]
    }
  }, {
    path: "/registrations-pending",
    name: "Horse Updates",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_17__views_Admin_Pending_PendingRegistrations__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Pending Horse Updates"
      }],
      showInNavar: true,
      requiresAuth: ["Admin", "SuperAdmin"],
      childOf: "Horses"
    }
  }, {
    path: "/horses/add-horse",
    name: "Add Horse",
    component: __WEBPACK_IMPORTED_MODULE_34__views_Horses_Add_HorseAdd__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "My Horses",
        link: "horses"
      }, {
        name: "Add Horse",
        link: "horses/add-horse"
      }],
      showInNavar: false,
      childOf: "Horses",
      requiresAuth: ["Admin", "SuperAdmin", "Member", "Secretary", "SecretaryOnly", "Volunteer"]
    }
  }, {
    // Numeric constraint so sibling static routes (/horses/add-horse, /horses/register-horse,
    // /horses/nominate-rookie) resolve to their own page instead of being read as a slug —
    // which is what breaks "open in a new tab" on those links.
    path: "/horses/:slug(\\d+)",
    name: "Horse Profile",
    component: __WEBPACK_IMPORTED_MODULE_33__views_Horses_Profile_HorseProfile__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "My Horses",
        link: "horses"
      }, {
        name: "Horse Profile",
        link: "horses/horse-profile"
      }],
      showInNavar: false,
      requiresAuth: null
    }
  }, {
    path: "/horses/:entityId/boy-status-history/:stateId/affected-results",
    name: "Horse BOY Affected Results",
    component: AffectedResultsView,
    props: function props(route) {
      return {
        type: "horse",
        entityId: route.params.entityId,
        stateId: route.params.stateId
      };
    },
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "My Horses",
        link: "horses"
      }, {
        name: "Horse Profile",
        link: "horses/horse-profile"
      }, {
        name: "Affected Results"
      }],
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/admin-horses/:slug/merge",
    name: "Merge Horse",
    component: HorseMerge,
    props: function props(route) {
      return {
        sourceHorseId: route.params.slug
      };
    },
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Horses",
        link: "admin-horses"
      }, {
        name: "Admin Horse Profile",
        params: {
          slug: true
        }
      }, {
        name: "Merge Horse"
      }],
      showInNavar: false,
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/admin-horses/:slug",
    name: "Admin Horse Profile",
    component: __WEBPACK_IMPORTED_MODULE_33__views_Horses_Profile_HorseProfile__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Horses",
        link: "admin-horses"
      }, {
        name: "Horse Profile",
        link: "admin-horses/horse-profile"
      }],
      showInNavar: false,
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/admin-horses/add-horse",
    name: "Admin Add Horse",
    component: __WEBPACK_IMPORTED_MODULE_34__views_Horses_Add_HorseAdd__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Horses",
        link: "admin-horses"
      }, {
        name: "Add Horse",
        link: "admin-horses/add-horse"
      }],
      showInNavar: false,
      childOf: "Horses",
      requiresAuth: ["Admin", "SuperAdmin", "Secretary", "SecretaryOnly"]
    }
  }, {
    path: "/horses/register-horse",
    name: "Register Horse",
    component: __WEBPACK_IMPORTED_MODULE_35__views_Horses_Register_HorseRegister__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Horses",
        link: "horses"
      }, {
        name: "Register Horse",
        link: "horses/register-horse"
      }],
      showInNavar: false,
      childOf: "Horses",
      requiresAuth: ["Member", "Secretary"]
    }
  }, {
    path: "/horses/nominate-rookie",
    name: "Nominate Rookie",
    component: __WEBPACK_IMPORTED_MODULE_36__views_Horses_Nominate_NominateRookie__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Horses",
        link: "horses"
      }, {
        name: "Nominate Rookie",
        link: "horses/nominate-rookie"
      }],
      showInNavar: false,
      childOf: "Horses",
      requiresAuth: ["Admin", "SuperAdmin", "Member", "Secretary", "SecretaryOnly"]
    }
  }, {
    path: "/horses/register-horse/confirm",
    name: "Confirm Horse",
    component: __WEBPACK_IMPORTED_MODULE_37__views_Horses_Register_HorseRegisterConfirm__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Horses",
        link: "horses"
      }, {
        name: "Register Horse",
        link: "horses/register-horse"
      }, {
        name: "Confirm Horse",
        link: "horses/register-horse/confirm"
      }],
      showInNavar: false,
      requiresAuth: ["Admin", "SuperAdmin", "Member", "Secretary", "SecretaryOnly"]
    }
  }, {
    path: "/horses/nominate-rookie/confirm",
    name: "Confirm Rookie Status",
    component: __WEBPACK_IMPORTED_MODULE_37__views_Horses_Register_HorseRegisterConfirm__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Horses",
        link: "horses"
      }, {
        name: "Nominate Rookie",
        link: "horses/nominate-rookie"
      }, {
        name: "Confirm Rookie Status",
        link: "horses/nominate-rookie/confirm"
      }],
      showInNavar: false,
      requiresAuth: ["Admin", "SuperAdmin", "Member", "Secretary", "SecretaryOnly"]
    }
  }, {
    path: "/horses/register-horse/cart",
    name: "Register Horse Cart",
    component: __WEBPACK_IMPORTED_MODULE_38__views_Horses_Cart_Cart__["a" /* default */],
    props: true,
    meta: {
      cartFlow: true,
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Horses",
        link: "horses"
      }, {
        name: "Register Horse",
        link: "horses/register-horse"
      }, {
        name: "Cart",
        link: "horses/register-horse/cart"
      }],
      showInNavar: false,
      requiresAuth: ["Admin", "SuperAdmin", "Member", "Secretary", "SecretaryOnly"]
    }
  }, {
    path: "/horses/nominate-rookie/cart",
    name: "Nominate Rookie Cart",
    component: __WEBPACK_IMPORTED_MODULE_38__views_Horses_Cart_Cart__["a" /* default */],
    props: true,
    meta: {
      cartFlow: true,
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Horses",
        link: "horses"
      }, {
        name: "Nominate Rookie",
        link: "horses/nominate-rookie"
      }, {
        name: "Cart",
        link: "horses/nominate-rookie/cart"
      }],
      showInNavar: false,
      requiresAuth: ["Admin", "SuperAdmin", "Member", "Secretary", "SecretaryOnly"]
    }
  }, {
    path: "/horses/register-horse/cart/payment",
    name: "Register Horse Payment",
    component: __WEBPACK_IMPORTED_MODULE_39__views_Horses_Cart_Payment__["a" /* default */],
    props: true,
    meta: {
      cartFlow: true,
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Horses",
        link: "horses"
      }, {
        name: "Register Horse",
        link: "horses/register-horse"
      }, {
        name: "Cart",
        link: "horses/register-horse/cart"
      }, {
        name: "Payment",
        link: "horses/register-horse/cart/payment"
      }],
      showInNavar: false,
      requiresAuth: ["Member", "Secretary"]
    }
  }, {
    path: "/horses/nominate-rookie/cart/payment",
    name: "Nominate Rookie Payment",
    component: __WEBPACK_IMPORTED_MODULE_39__views_Horses_Cart_Payment__["a" /* default */],
    props: true,
    meta: {
      cartFlow: true,
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Horses",
        link: "horses"
      }, {
        name: "Nominate Rookie",
        link: "horses/nominate-rookie"
      }, {
        name: "Cart",
        link: "horses/nominate-rookie/cart"
      }, {
        name: "Payment",
        link: "horses/nominate-rookie/cart/payment"
      }],
      showInNavar: false,
      requiresAuth: ["Admin", "SuperAdmin", "Member", "Secretary", "SecretaryOnly"]
    }
  }, {
    path: "/drafts-list",
    name: "Drafts",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_40__views_Drafts_Listing_Drafts__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Drafts List"
      }],
      showInNavar: true,
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 32.182 27.092"><g id="fence" transform="translate(-862 -273.796)"><path id="Path_7252" data-name="Path 7252" d="M28.32,91.095h-4.6a.663.663,0,0,1-.663-.664V67.109a.664.664,0,0,1,.168-.441L25.4,64.227A.664.664,0,0,1,25.873,64a.635.635,0,0,1,.488.2l2.429,2.441a.663.663,0,0,1,.193.468V90.431A.664.664,0,0,1,28.32,91.095Zm-3.938-1.328h3.274V67.383l-1.738-1.747-1.536,1.725Z" transform="translate(841.187 209.793)" fill="currentColor"/><path id="Path_7253" data-name="Path 7253" d="M102.684,91.091H98a.664.664,0,0,1-.664-.664V67.105a.663.663,0,0,1,.172-.445l2.21-2.441A.662.662,0,0,1,100.2,64a.642.642,0,0,1,.485.191l2.469,2.441a.666.666,0,0,1,.2.472V90.427A.664.664,0,0,1,102.684,91.091Zm-4.016-1.328h3.352V67.382l-1.779-1.758-1.573,1.737Z" transform="translate(774.124 209.797)" fill="currentColor"/><path id="Path_7254" data-name="Path 7254" d="M178.331,91.1H173.71a.664.664,0,0,1-.663-.664V67.11a.661.661,0,0,1,.169-.442l2.182-2.441a.662.662,0,0,1,.476-.221.639.639,0,0,1,.488.194l2.438,2.441a.662.662,0,0,1,.194.469V90.432A.664.664,0,0,1,178.331,91.1Zm-3.957-1.328h3.293V67.385l-1.748-1.75-1.545,1.728Z" transform="translate(705.778 209.792)" fill="currentColor"/><path id="Path_7255" data-name="Path 7255" d="M252.7,91.094H248a.664.664,0,0,1-.664-.664V67.108a.662.662,0,0,1,.172-.446l2.219-2.441A.665.665,0,0,1,250.2,64a.657.657,0,0,1,.483.191l2.479,2.441a.662.662,0,0,1,.2.473V90.43A.664.664,0,0,1,252.7,91.094Zm-4.034-1.328h3.371V67.387l-1.789-1.761-1.582,1.74Z" transform="translate(638.708 209.794)" fill="currentColor"/><path id="Path_7256" data-name="Path 7256" d="M31.642,276.241H.54a.678.678,0,0,1,0-1.327h31.1a.678.678,0,0,1,0,1.327Z" transform="translate(862 19.389)" fill="currentColor"/><path id="Path_7257" data-name="Path 7257" d="M33.026,112.5H2.259a.678.678,0,0,1,0-1.327H33.026a.678.678,0,0,1,0,1.327Z" transform="translate(860.448 167.215)" fill="currentColor"/></g></svg>',
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/drafts-list/draft-create",
    name: "Create Draft",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_41__views_Drafts_Add_DraftAdd__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Drafts List",
        link: "drafts-list"
      }, {
        name: "Create Draft"
      }],
      showInNavar: false,
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/drafts-list/:draftId/edit",
    name: "Edit Draft",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_41__views_Drafts_Add_DraftAdd__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Drafts List",
        link: "drafts-list"
      }, {
        name: "Edit Draft"
      }],
      showInNavar: false,
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/drafts-list/:draftId/events-list",
    name: "Events",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_42__views_Drafts_Events_Listing_Events__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Drafts List",
        link: "drafts-list"
      }, {
        name: "Placeholder"
      }],
      showInNavar: false,
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/drafts-list/:draftId/events-list/event-create/:eventId?",
    name: "Create Event",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_43__views_Drafts_Events_Add_EventAdd__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Drafts List",
        link: "drafts-list"
      }, {
        name: "Placeholder",
        link: "placeholder",
        routeName: "Events"
      }, {
        name: "Create Event"
      }],
      showInNavar: false,
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/titles-list",
    name: "Titles",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_44__views_Titles_Listing_Titles__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Titles List"
      }],
      showInNavar: true,
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 19" width="24" height="23"><g><path fill="currentColor" d="M8.7999977 12.437501h-.2l-2.2-.9-2.2.9c-.2.1-.5 0-.6-.3l-1-2.1-2.1-1c-.2-.1-.4-.4-.3-.6l.8-2.2-.8-2.2c-.1-.2 0-.5.3-.6l2.1-1 1-2.1c.1-.2.4-.4.6-.3l2.2.8 2.2-.8c.2-.1.5 0 .6.3l1 2.1 2.1 1c.2.1.4.4.3.6l-.8 2.2.8 2.2c.1.2 0 .5-.3.6l-2.1 1-1 2.1c-.1.2-.3.3-.4.3zm-2.4-1.9h.2l1.9.7.9-1.8c0-.1.1-.2.2-.2l1.9-.9-.7-1.9v-.3l.7-1.9-1.9-.9c-.1 0-.2-.1-.2-.2l-.9-1.9-1.9.7h-.3l-1.9-.7-1 1.8c0 .1-.1.2-.2.2l-1.9.9.7 1.9v.3l-.7 1.9 1.9.9c.1 0 .2.1.2.2l.9 1.9 1.9-.7h.2z"/><path fill="currentColor" d="M3.3999977 10.037501l-2.2 6 1.9-.3c.2 0 .4 0 .5.2l1.2 1.5 2.2-6 .9.3-2.5 6.8c-.1.2-.2.3-.4.3h-.1c-.2 0-.3-.1-.4-.2l-1.5-1.9-2.4.4c-.2 0-.4 0-.5-.2-.1-.1-.1-.3-.1-.5l2.5-6.8.9.4z"/><path fill="currentColor" d="M10.2999977 9.737501l2.6 6.8c.1.2 0 .4-.1.5-.1.1-.3.2-.5.2l-2.4-.4-1.5 1.9c-.1.1-.2.2-.4.2h-.1c-.2 0-.3-.1-.4-.3l-1.6-4.2.9-.4 1.2 3.3 1.2-1.5c.1-.1.3-.2.5-.2l1.9.3-2.2-6 .9-.2z"/></g></svg>',
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/titles-list/title-edit",
    name: "Edit Title",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_45__views_Titles_Edit_TitleEdit__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Titles List",
        link: "titles-list"
      }, {
        name: "Edit Title"
      }],
      showInNavar: false,
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/titles-preview",
    name: "Preview Standings",
    component: __WEBPACK_IMPORTED_MODULE_46__views_Titles_Preview_TitlesPreview__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Preview Standings"
      }],
      requiresAuth: ["Admin", "SuperAdmin"],
      showInNavar: true,
      childOf: "Titles"
    }
  }, {
    path: "/committee-list",
    name: "Committees",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_29__views_Committees_Listing_Committees__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Committee List"
      }],
      showInNavar: true,
      icon: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 640 512" width="24" height="19"><path fill="currentColor" d="M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z"/></svg>',
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: '/nominations/:draftId/bulk-email',
    name: 'NominationsBulkEmail',
    component: NominationsBulkEmail,
    meta: {
      breadcrumb: [{
        name: 'Dashboard',
        link: ''
      }, {
        name: 'Nominations',
        link: 'nominations'
      }, {
        name: 'Bulk Email'
      }],
      requiresAuth: ['Secretary', 'SecretaryOnly']
    }
  }, {
    path: '/nominations/:draftId/reassign-:type',
    name: 'NominationsReassign',
    component: NominationsReassign,
    meta: {
      breadcrumb: [{
        name: 'Dashboard',
        link: ''
      }, {
        name: 'Draws',
        link: 'draws/dashboard'
      }, {
        name: 'Reassign'
      }],
      requiresAuth: ['Secretary', 'SecretaryOnly']
    }
  }, {
    path: '/committees/:draftId/bulk-mail',
    name: 'CommitteesBulkMail',
    component: CommitteesBulkMail,
    meta: {
      breadcrumb: [{
        name: 'Dashboard',
        link: ''
      }, {
        name: 'Committees',
        link: 'committees/dashboard'
      }, {
        name: 'Bulk Mail'
      }],
      requiresAuth: ['Secretary', 'SecretaryOnly']
    }
  }, {
    path: '/biosecurity/:draftId',
    name: 'BiosecurityForm',
    component: BiosecurityForm,
    meta: {
      breadcrumb: [{
        name: 'Dashboard',
        link: ''
      }, {
        name: 'Nominations',
        link: 'nominations'
      }, {
        name: 'Biosecurity'
      }],
      requiresAuth: ['Member', 'Secretary', 'SecretaryOnly']
    }
  }, {
    path: '/calculators/:eventId',
    name: 'CalculatorView',
    component: CalculatorView,
    meta: {
      breadcrumb: [{
        name: 'Dashboard',
        link: ''
      }, {
        name: 'Draws',
        link: 'draws/dashboard'
      }, {
        name: 'Calculator'
      }],
      requiresAuth: ['Secretary', 'SecretaryOnly']
    }
  }, {
    path: '/prizes/:eventId',
    name: 'PrizesView',
    component: PrizesView,
    meta: {
      breadcrumb: [{
        name: 'Dashboard',
        link: ''
      }, {
        name: 'Draws',
        link: 'draws/dashboard'
      }, {
        name: 'Prizes'
      }],
      requiresAuth: ['Secretary', 'SecretaryOnly']
    }
  }, {
    path: '/drafts/:draftId/prize-summary',
    name: 'PrizeSummaryView',
    component: PrizeSummaryView,
    meta: {
      breadcrumb: [{
        name: 'Dashboard',
        link: ''
      }, {
        name: 'Draws',
        link: 'draws/dashboard'
      }, {
        name: 'Prize Money Summary'
      }],
      requiresAuth: ['Secretary', 'SecretaryOnly']
    }
  }, {
    path: '/draft-members/:draftId',
    name: 'DraftEventMembers',
    component: DraftEventMembers,
    meta: {
      breadcrumb: [{
        name: 'Dashboard',
        link: ''
      }, {
        name: 'Committees',
        link: 'committees/dashboard'
      }, {
        name: 'Event Members'
      }],
      requiresAuth: ['Secretary', 'SecretaryOnly']
    }
  }, {
    path: "/committees/bulk-mailing",
    name: "Bulk Mailing",
    component: CommitteesBulkMail,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Committees Bulk Mailing"
      }],
      requiresAuth: ["Admin", "SuperAdmin"],
      showInNavar: true,
      childOf: "Committees"
    }
  }, {
    path: "/committee-list/committee-profile/:id?",
    name: "Committee Profile",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_31__views_Committees_Profile_CommitteeProfile__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Committee List",
        link: "committee-list"
      }, {
        name: "Committee Profile"
      }],
      showInNavar: false,
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/secretary-users",
    name: "Secretary Users",
    component: __WEBPACK_IMPORTED_MODULE_8__views_Admin_Listing_SecretaryUsers__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Secretary Users"
      }],
      requiresAuth: ["Admin", "SuperAdmin"],
      showInNavar: true,
      icon: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 640 512" width="24" height="19"><path fill="currentColor" d="M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z"/></svg>'
    }
  }, {
    path: "/admin-users",
    name: "Admin Users",
    component: __WEBPACK_IMPORTED_MODULE_7__views_Admin_Listing_AdminUsers__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Admin Users"
      }],
      requiresAuth: ["Admin", "SuperAdmin"],
      showInNavar: true,
      icon: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 16 13" width="24" height="20"><g class="currentLayer" fill="currentColor"><g><path d="M13.3 12.8H2.8c-.8 0-1.5-.6-1.5-1.4L.6 5.1c0-.2.1-.4.3-.5.2-.1.5 0 .6.2.9 1.3 2.2 2.8 2.7 2.8.6 0 2.2-2.9 3.3-6 .1-.4.8-.4.9 0 1.1 3.2 2.7 6 3.3 6 .5 0 1.8-1.4 2.8-2.8.1-.2.4-.3.6-.2.2.1.3.3.3.5l-.6 6.3c-.1.8-.8 1.4-1.5 1.4zm-11.6-6l.5 4.5c0 .3.3.5.5.5h10.5c.3 0 .5-.2.5-.5l.5-4.5c-.7.9-1.7 1.8-2.5 1.8-1.4-.1-3-3.4-3.8-5.5-.8 2.1-2.4 5.3-3.7 5.5-.7 0-1.7-.9-2.5-1.8z"/><circle cx="1" cy="5.1" r="1"/><circle cx="8" cy="1" r="1"/><circle cx="15" cy="5.1" r="1"/><g><circle cx="8" cy="9.5" r="1"/></g></g></g></svg>'
    }
  }, {
    path: "/admin-users/admin-profile",
    name: "Admin Profile",
    component: __WEBPACK_IMPORTED_MODULE_19__views_Admin_Profile_AdminProfile__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Admin Users",
        link: "admin-users"
      }, {
        name: "Admin User Profile",
        link: "admin-users/admin-profile"
      }],
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/secretary-users/:slug",
    name: "Secretary Profile",
    component: __WEBPACK_IMPORTED_MODULE_20__views_Admin_Profile_SecretaryProfile__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Secretary Users",
        params: {
          slug: true
        }
      }, {
        name: "Secretary User Profile",
        link: "secretary-users/secretary-profile"
      }],
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/admin-users/admin-profile/member-profile",
    name: "Admin Profile Child",
    component: __WEBPACK_IMPORTED_MODULE_21__views_Admin_Profile_AdminProfileChild__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Admin Users",
        link: "admin-users"
      }, {
        name: "Admin User Profile",
        link: "admin-users/admin-profile"
      }, {
        name: "User Profile",
        link: "admin-users/admin-profile/member-profile"
      }],
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/members/member-profile/split",
    name: "Member Profile Split",
    component: __WEBPACK_IMPORTED_MODULE_15__views_Members_Profile_MemberSplit__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Members",
        link: "members"
      }, {
        name: "Member Profile",
        link: "members/member-profile"
      }, {
        name: "Split Member Profile",
        link: "members/member-profile/split"
      }],
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/my-account/add",
    name: "Add Members",
    component: __WEBPACK_IMPORTED_MODULE_26__views_MyMembership_Add_MemberAdd__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "My Profile",
        link: "my-account"
      }, {
        name: "Add"
      }],
      showInNavar: false,
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/admin-users/add",
    name: "Add Admin Members",
    component: __WEBPACK_IMPORTED_MODULE_27__views_Admin_Add_AdminAdd__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Admin Users",
        link: "admin-users"
      }, {
        name: "Add Admin"
      }],
      showInNavar: false
    }
  }, {
    path: "/secretary-users/add",
    name: "Add Secretary Members",
    component: __WEBPACK_IMPORTED_MODULE_28__views_Admin_Add_SecretaryAdd__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Secretary Users",
        link: "secretary-users"
      }, {
        name: "Add Secretary"
      }],
      showInNavar: false
    }
  }, {
    path: "/invoices-pending",
    name: "Payments",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_16__views_Admin_Pending_PendingInvoices__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Invoices Pending"
      }],
      requiresAuth: ["Admin", "SuperAdmin"],
      showInNavar: true,
      icon: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 17 12" width="24" height="17"><g><path fill="currentColor" d="M15.5 12h-14C.7 12 0 11.3 0 10.5v-9C0 .7.7 0 1.5 0h14c.8 0 1.5.7 1.5 1.5v9c0 .8-.7 1.5-1.5 1.5zM1.5 1c-.3 0-.5.2-.5.5v9c0 .3.2.5.5.5h14c.3 0 .5-.2.5-.5v-9c0-.3-.2-.5-.5-.5h-14z"/><path fill="currentColor" d="M.5 2.2999992h16v1H.5zM.5 4.1000004h16v1H.5zM5.2 7.4H2.6c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2.6c.3 0 .5.2.5.5s-.2.5-.5.5zM8.7 9.5H2.6c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h6.1c.3 0 .5.2.5.5s-.3.5-.5.5z"/></g></svg>'
    }
  }, {
    path: "/pages/termsAndConditions",
    name: "ACA Terms & Conditions",
    component: TermsAndConditions,
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "ACA Terms & Conditions"
      }],
      requiresAuth: ["Admin", "SuperAdmin"],
      showInNavar: true
    }
  }, {
    path: '/leaderboardAppearance',
    name: "Leaderboard Appearance",
    component: AppearanceEdit,
    props: {
      frame: 'leaderboard'
    },
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Leaderboard Appearance"
      }],
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 19" width="24" height="23"><g><path fill="currentColor" d="M8.7999977 12.437501h-.2l-2.2-.9-2.2.9c-.2.1-.5 0-.6-.3l-1-2.1-2.1-1c-.2-.1-.4-.4-.3-.6l.8-2.2-.8-2.2c-.1-.2 0-.5.3-.6l2.1-1 1-2.1c.1-.2.4-.4.6-.3l2.2.8 2.2-.8c.2-.1.5 0 .6.3l1 2.1 2.1 1c.2.1.4.4.3.6l-.8 2.2.8 2.2c.1.2 0 .5-.3.6l-2.1 1-1 2.1c-.1.2-.3.3-.4.3zm-2.4-1.9h.2l1.9.7.9-1.8c0-.1.1-.2.2-.2l1.9-.9-.7-1.9v-.3l.7-1.9-1.9-.9c-.1 0-.2-.1-.2-.2l-.9-1.9-1.9.7h-.3l-1.9-.7-1 1.8c0 .1-.1.2-.2.2l-1.9.9.7 1.9v.3l-.7 1.9 1.9.9c.1 0 .2.1.2.2l.9 1.9 1.9-.7h.2z"/><path fill="currentColor" d="M3.3999977 10.037501l-2.2 6 1.9-.3c.2 0 .4 0 .5.2l1.2 1.5 2.2-6 .9.3-2.5 6.8c-.1.2-.2.3-.4.3h-.1c-.2 0-.3-.1-.4-.2l-1.5-1.9-2.4.4c-.2 0-.4 0-.5-.2-.1-.1-.1-.3-.1-.5l2.5-6.8.9.4z"/><path fill="currentColor" d="M10.2999977 9.737501l2.6 6.8c.1.2 0 .4-.1.5-.1.1-.3.2-.5.2l-2.4-.4-1.5 1.9c-.1.1-.2.2-.4.2h-.1c-.2 0-.3-.1-.4-.3l-1.6-4.2.9-.4 1.2 3.3 1.2-1.5c.1-.1.3-.2.5-.2l1.9.3-2.2-6 .9-.2z"/></g></svg>',
      showInNavar: true,
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: '/nominationAppearance',
    name: "Nominations Appearance",
    component: AppearanceEdit,
    props: {
      frame: 'nominations'
    },
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Nominations Appearance"
      }],
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 19" width="24" height="23"><g><path fill="currentColor" d="M8.7999977 12.437501h-.2l-2.2-.9-2.2.9c-.2.1-.5 0-.6-.3l-1-2.1-2.1-1c-.2-.1-.4-.4-.3-.6l.8-2.2-.8-2.2c-.1-.2 0-.5.3-.6l2.1-1 1-2.1c.1-.2.4-.4.6-.3l2.2.8 2.2-.8c.2-.1.5 0 .6.3l1 2.1 2.1 1c.2.1.4.4.3.6l-.8 2.2.8 2.2c.1.2 0 .5-.3.6l-2.1 1-1 2.1c-.1.2-.3.3-.4.3zm-2.4-1.9h.2l1.9.7.9-1.8c0-.1.1-.2.2-.2l1.9-.9-.7-1.9v-.3l.7-1.9-1.9-.9c-.1 0-.2-.1-.2-.2l-.9-1.9-1.9.7h-.3l-1.9-.7-1 1.8c0 .1-.1.2-.2.2l-1.9.9.7 1.9v.3l-.7 1.9 1.9.9c.1 0 .2.1.2.2l.9 1.9 1.9-.7h.2z"/><path fill="currentColor" d="M3.3999977 10.037501l-2.2 6 1.9-.3c.2 0 .4 0 .5.2l1.2 1.5 2.2-6 .9.3-2.5 6.8c-.1.2-.2.3-.4.3h-.1c-.2 0-.3-.1-.4-.2l-1.5-1.9-2.4.4c-.2 0-.4 0-.5-.2-.1-.1-.1-.3-.1-.5l2.5-6.8.9.4z"/><path fill="currentColor" d="M10.2999977 9.737501l2.6 6.8c.1.2 0 .4-.1.5-.1.1-.3.2-.5.2l-2.4-.4-1.5 1.9c-.1.1-.2.2-.4.2h-.1c-.2 0-.3-.1-.4-.3l-1.6-4.2.9-.4 1.2 3.3 1.2-1.5c.1-.1.3-.2.5-.2l1.9.3-2.2-6 .9-.2z"/></g></svg>',
      showInNavar: true,
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: "/api-tokens",
    name: "Access API Tokens",
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_66__views_ApiTokens_Listing_ApiTokens__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Dashboard",
        link: ""
      }, {
        name: "Access API Tokens"
      }],
      showInNavar: true,
      icon: '<svg width="24" height="24" viewBox="144 144 512 512" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><g><path d="m412.84 319.58c-18.125-.75-33.98 12.082-39.27 29.449-3.0195 9.8164 12.082 13.594 14.348 3.7734 3.0195-10.57 13.594-18.125 24.922-18.125 11.328.0 21.145 7.5508 24.164 18.879s-2.2656 22.656-12.836 28.695h-.75391-61.168c-8.3086.0-15.102 6.7969-15.102 15.105v67.961c0 8.3086 6.7969 15.105 15.102 15.105h75.516c8.3086.0 15.102-6.7969 15.102-15.105v-67.961c0-5.2891-3.7773-10.574-8.3086-13.594 6.7969-9.0625 9.8164-21.145 6.7969-33.23-3.7773-18.125-19.633-30.961-38.512-30.961zm-50.594 77.781s-.75391.0.0.0h75.516v67.961h-75.516z"/><path d="m400.75 238.78c-2.2656.0-4.5312 1.5-6.043 3.7734-13.594 19.637-57.391 37.004-107.23 37.004h-.75391-.75391c-3.7773.0-6.7969 2.2461-7.5508 6.0391.0.0-7.5508 33.98-11.328 74.762-3.7773 41.535-4.5312 89.105 12.082 120.82 12.082 22.656 41.535 41.535 67.965 55.883 24.918 13.594 45.309 21.898 48.328 22.656 1.5117.75 3.0195 1.5 4.5312 1.5s3.0195-.75 4.5312-1.5c2.2656-.75 23.41-9.0625 47.574-22.656 26.43-14.348 55.879-33.23 68.719-55.883 16.613-31.719 15.859-79.289 12.082-120.82-3.7773-40.777-11.328-74.762-11.328-74.762-.75391-3.7734-4.5312-6.0391-8.3086-6.0391-48.328.0-90.617-16.613-104.96-35.492-1.5117-3.0312-4.5312-5.2891-7.5508-5.2891zm0 19.633c21.145 22.656 61.922 34.738 106.48 36.246 1.5117 6.7969 6.7969 32.473 10.57 67.207 3.7773 40.027 3.0195 86.844-10.57 111.77-9.0625 17.367-37.004 36.246-61.922 50.594-23.41 12.082-41.535 19.637-45.309 21.145-3.7773-1.5-22.656-9.0625-45.309-21.145-25.676-14.344-52.859-33.227-61.922-50.594-13.594-24.922-14.348-71.738-10.57-111.77 3.0195-34.734 8.3047-60.41 9.8164-67.207 46.062-1.5 87.598-13.594 108.74-36.246z"/></g></svg>',
      requiresAuth: ["Admin", "SuperAdmin"]
    }
  }, {
    path: '/import',
    name: 'Import',
    component: Import,
    meta: {
      breadcrumb: [{
        name: 'Dashboard',
        link: ''
      }, {
        name: 'Import'
      }],
      showInNavar: true,
      requiresAuth: ['SuperAdmin']
    }
  }, {
    path: "/login-once",
    name: "Login Once",
    component: __WEBPACK_IMPORTED_MODULE_5__views_Account_LoginOnce_LoginOnce__["a" /* default */],
    props: true,
    meta: {
      breadcrumb: [{
        name: "Login Once"
      }],
      showInNavar: false,
      requiresAuth: ["Member", "Secretary", "SecretaryOnly"]
    }
  }, {
    path: "/login",
    name: "Log Out",
    component: __WEBPACK_IMPORTED_MODULE_3__views_Account_Login__["a" /* default */],
    meta: {
      breadcrumb: [{
        name: "Log Out"
      }],
      showInNavar: true
    }
  }, {
    path: "/auth/getAccessToken",
    name: "Get Access Token",
    component: __WEBPACK_IMPORTED_MODULE_48__views_Account_Auth__["a" /* default */],
    meta: {
      showInNavar: false,
      requiresAuth: ["Member", "Secretary", "Admin", "SuperAdmin", "SecretaryOnly", "Volunteer"]
    }
  }, {
    path: '*',
    name: 'Not Found',
    component: __WEBPACK_IMPORTED_MODULE_49__views_Common_NotFound__["a" /* default */],
    meta: {
      showInNavar: false,
      requiresAuth: ["Member", "Secretary", "Admin", "SuperAdmin", "SecretaryOnly", "Volunteer"]
    }
  }]
});
routes.beforeEach(
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(to, from, next) {
    var _useUserRole, role, isUser, isAdmin, isSuperSecretary;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _useUserRole = Object(__WEBPACK_IMPORTED_MODULE_74__composables_useUserRole__["a" /* default */])(), role = _useUserRole.role, isUser = _useUserRole.isUser, isAdmin = _useUserRole.isAdmin, isSuperSecretary = _useUserRole.isSuperSecretary;

            if (to.meta.requiresSuperSecretary && !isSuperSecretary) {
              next({
                path: "/"
              });
            } else if (localStorage.role === undefined && to.name !== "Login" && to.name !== "Maintenance" && to.name !== "Public Judges List" && to.name !== "Register" || isUser && to.name !== "Login Once" && to.name !== "Login" && localStorage.is_onboarded !== "true") {
              next({
                path: "/login"
              });
            } else if (to.name === "My Profile" && isAdmin) {
              next({
                path: "/admin-members"
              });
            } else if (to.matched.some(function (record) {
              return record.meta.requiresAuth !== null && record.meta.requiresAuth && !record.meta.requiresAuth.includes(role);
            })) {
              next({
                path: "/login",
                query: to.fullPath === "/" ? "" : {
                  redirect: to.fullPath
                }
              });
            } else if (to.path === "/mail-list" || to.path === "/registered-users-list") {
              /* Back to dashboard if a user accesses these paths directly */
              next({
                path: "/"
              });
            } else {
              /* The cart is only valid inside the cart/payment flow — drop it on any other page so it never leaks between members/horses/committees */
              if (!to.matched.some(function (record) {
                return record.meta.cartFlow;
              }) && Object.keys(__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.cartMembers).length > 0) {
                __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('updateCartMembers', {});
              }

              next();
            }

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
/* After a deploy the old chunks are gone, so a tab running the previous build fails to lazy-load a route chunk.
   Reload once straight to the target route to pick up the new build; the timestamp guard prevents a reload loop
   if the chunk is really unreachable (offline, blocked). */

routes.onError(function (error, to) {
  var isChunkError = /Loading (CSS )?chunk [\w-]+ failed/i.test(error && error.message);
  if (!isChunkError) return;

  try {
    var lastReload = Number(sessionStorage.getItem("chunk_reload_at")) || 0;
    if (Date.now() - lastReload < 30000) return;
    sessionStorage.setItem("chunk_reload_at", String(Date.now()));
  } catch (e) {
    return;
  }

  window.location.assign(to ? to.fullPath : window.location.href);
});
/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 599 */,
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_nominations__ = __webpack_require__(437);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: function state() {
    return {
      lists: null,
      defaultList: 'unprocessed'
    };
  },
  mutations: {
    SET_LISTS: function SET_LISTS(state, _ref) {
      var items = _ref.items,
          defaultList = _ref.defaultList;
      state.lists = items;
      state.defaultList = defaultList;
    }
  },
  actions: {
    fetchLists: function fetchLists(_ref2) {
      var state = _ref2.state,
          commit = _ref2.commit;
      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var res, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(state.lists !== null)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_0__services_api_nominations__["a" /* default */].getLists();

              case 4:
                res = _context.sent;
                data = res.data.data;
                commit('SET_LISTS', {
                  items: data.items,
                  defaultList: data.default
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  getters: {
    listItems: function listItems(state) {
      if (state.lists !== null) return state.lists;
      return [{
        value: 'unprocessed',
        label: 'Unprocessed'
      }, {
        value: 'accept',
        label: 'Accepted'
      }, {
        value: 'waitlist',
        label: 'Waitlist'
      }, {
        value: 'scratched',
        label: 'Scratched'
      }];
    },
    defaultList: function defaultList(state) {
      return state.defaultList;
    }
  }
});

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_horses__ = __webpack_require__(86);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: function state() {
    return {
      searchResults: [],
      searchLoading: false,
      searchRequestId: 0,
      preview: null,
      previewLoading: false,
      previewRequestId: 0,
      merging: false
    };
  },
  mutations: {
    SET_SEARCH_RESULTS: function SET_SEARCH_RESULTS(state, results) {
      state.searchResults = results;
    },
    SET_SEARCH_LOADING: function SET_SEARCH_LOADING(state, loading) {
      state.searchLoading = loading;
    },
    BUMP_SEARCH_REQUEST_ID: function BUMP_SEARCH_REQUEST_ID(state) {
      state.searchRequestId += 1;
    },
    SET_PREVIEW: function SET_PREVIEW(state, preview) {
      state.preview = preview;
    },
    SET_PREVIEW_LOADING: function SET_PREVIEW_LOADING(state, loading) {
      state.previewLoading = loading;
    },
    BUMP_PREVIEW_REQUEST_ID: function BUMP_PREVIEW_REQUEST_ID(state) {
      state.previewRequestId += 1;
    },
    SET_MERGING: function SET_MERGING(state, merging) {
      state.merging = merging;
    }
  },
  actions: {
    search: function search(_ref, _ref2) {
      var state = _ref.state,
          commit = _ref.commit;
      var query = _ref2.query,
          sourceHorseId = _ref2.sourceHorseId;
      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var requestId, response, results;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit('BUMP_SEARCH_REQUEST_ID');
                requestId = state.searchRequestId;
                commit('SET_SEARCH_LOADING', true);
                _context.prev = 3;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_0__services_api_horses__["a" /* default */].search(query);

              case 6:
                response = _context.sent;
                results = response.data.data.filter(function (horse) {
                  return String(horse.id) !== String(sourceHorseId);
                });
                if (state.searchRequestId === requestId) commit('SET_SEARCH_RESULTS', results);

              case 9:
                _context.prev = 9;
                if (state.searchRequestId === requestId) commit('SET_SEARCH_LOADING', false);
                return _context.finish(9);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3,, 9, 12]]);
      }))();
    },
    preview: function preview(_ref3, data) {
      var state = _ref3.state,
          commit = _ref3.commit;
      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var requestId, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit('BUMP_PREVIEW_REQUEST_ID');
                requestId = state.previewRequestId;
                commit('SET_PREVIEW_LOADING', true);
                commit('SET_PREVIEW', null);
                _context2.prev = 4;
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_0__services_api_horses__["a" /* default */].previewMerge(data);

              case 7:
                response = _context2.sent;
                if (state.previewRequestId === requestId) commit('SET_PREVIEW', response.data.data);
                return _context2.abrupt("return", response.data.data);

              case 10:
                _context2.prev = 10;
                if (state.previewRequestId === requestId) commit('SET_PREVIEW_LOADING', false);
                return _context2.finish(10);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4,, 10, 13]]);
      }))();
    },
    merge: function merge(_ref4, data) {
      var commit = _ref4.commit;
      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commit('SET_MERGING', true);
                _context3.prev = 1;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_0__services_api_horses__["a" /* default */].merge(data);

              case 4:
                response = _context3.sent;
                return _context3.abrupt("return", response.data);

              case 6:
                _context3.prev = 6;
                commit('SET_MERGING', false);
                return _context3.finish(6);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1,, 6, 9]]);
      }))();
    },
    clearPreview: function clearPreview(_ref5) {
      var commit = _ref5.commit;
      commit('BUMP_PREVIEW_REQUEST_ID');
      commit('SET_PREVIEW', null);
    },
    reset: function reset(_ref6) {
      var commit = _ref6.commit;
      commit('BUMP_SEARCH_REQUEST_ID');
      commit('BUMP_PREVIEW_REQUEST_ID');
      commit('SET_SEARCH_RESULTS', []);
      commit('SET_PREVIEW', null);
    }
  },
  getters: {
    searchResults: function searchResults(state) {
      return state.searchResults;
    },
    searchLoading: function searchLoading(state) {
      return state.searchLoading;
    },
    preview: function preview(state) {
      return state.preview;
    },
    previewLoading: function previewLoading(state) {
      return state.previewLoading;
    },
    merging: function merging(state) {
      return state.merging;
    }
  }
});

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_draws__ = __webpack_require__(439);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: function state() {
    return {
      event: {},
      infoLoading: false,
      infoRequestId: 0,
      rounds: [],
      draws: [],
      meta: {},
      loading: false,
      requestId: 0
    };
  },
  mutations: {
    START_INFO: function START_INFO(state) {
      state.infoRequestId += 1;
      state.infoLoading = true;
      state.event = {};
      state.rounds = [];
    },
    RECEIVE_INFO: function RECEIVE_INFO(state, data) {
      state.event = data.event || {};
      state.rounds = data.rounds || [];
    },
    FINISH_INFO: function FINISH_INFO(state) {
      state.infoLoading = false;
    },
    START: function START(state) {
      state.requestId += 1;
      state.loading = true;
    },
    RECEIVE: function RECEIVE(state, data) {
      state.draws = data.draws || [];
      state.meta = data.meta || {};
    },
    FINISH: function FINISH(state) {
      state.loading = false;
    }
  },
  actions: {
    fetchInfo: function fetchInfo(_ref, eventId) {
      var state = _ref.state,
          commit = _ref.commit;
      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var requestId, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit('START_INFO');
                requestId = state.infoRequestId;
                _context.prev = 2;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_0__services_api_draws__["a" /* default */].getPublicDrawsInfo(eventId);

              case 5:
                res = _context.sent;
                if (requestId === state.infoRequestId) commit('RECEIVE_INFO', res.data.data);
                _context.next = 11;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);

              case 11:
                _context.prev = 11;
                if (requestId === state.infoRequestId) commit('FINISH_INFO');
                return _context.finish(11);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 9, 11, 14]]);
      }))();
    },
    fetch: function fetch(_ref2, _ref3) {
      var state = _ref2.state,
          commit = _ref2.commit;
      var eventId = _ref3.eventId,
          round = _ref3.round,
          page = _ref3.page,
          perPage = _ref3.perPage;
      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var requestId, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit('START');
                requestId = state.requestId;
                _context2.prev = 2;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_0__services_api_draws__["a" /* default */].getPublicDraws(eventId, round, {
                  page: page,
                  per_page: perPage
                });

              case 5:
                res = _context2.sent;
                if (requestId === state.requestId) commit('RECEIVE', res.data.data);
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](2);
                if (requestId === state.requestId) commit('RECEIVE', {});

              case 12:
                _context2.prev = 12;
                if (requestId === state.requestId) commit('FINISH');
                return _context2.finish(12);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 9, 12, 15]]);
      }))();
    }
  }
});

/***/ }),
/* 603 */,
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e2670a3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(612);
function injectStyle (ssrContext) {
  __webpack_require__(605)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e2670a3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e2670a3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_beacb18e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logo_vue__ = __webpack_require__(607);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_beacb18e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1514 678","width":"216","height":"97"}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"a","x2":"1"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#aa2d41"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#d92340"}})],1)],1),_c('g',{staticClass:"currentLayer"},[_c('path',{attrs:{"fill":"#333","d":"M17 661Q0 643 0 613q0-33 17-50t50-18a112 112 0 0 1 38 7v23a95 95 0 0 0-36-7q-22 0-32 11t-10 34q0 21 11 32t31 10a95 95 0 0 0 36-7v24a123 123 0 0 1-38 6q-32 0-50-17zm149-114h30l49 129h-28l-12-31h-48l-12 31h-28zm35 77l-20-52-20 52zm60-77h27l38 78 38-78h27v129h-27v-84l-30 62h-16l-30-62v84h-27zm154 0h61q22 0 33 12t11 33a47 47 0 0 1-5 23 38 38 0 0 1-16 15q-10 6-24 6h-33v40h-27zm54 67q12 0 18-6t6-16q0-12-6-17t-17-6h-28v45zm68-67h54q30 0 44 16t15 49q0 33-15 49t-44 15h-54zm50 108q13 0 20-3t11-13q4-10 4-27t-3-26-11-13q-8-3-21-3h-23v85zm83-108h62q22 0 33 12t10 31q0 13-6 23t-19 13a27 27 0 0 1 5 6 53 53 0 0 1 4 8l15 36h-28l-15-35-4-6q-2-2-8-2h-22v43h-27zm55 64q11 0 17-5t6-16q0-10-5-15t-16-5h-30v41zm107-64h30l49 129h-28l-12-31h-48l-12 31h-28zm35 77l-20-52-20 52zm65-77h90v21h-63v33h56v21h-56v54h-27zm139 21h-40v-21h106v21h-39v108h-27z"}}),_c('path',{attrs:{"fill":"#aa2d41","d":"M1139 612q0-35 16-51t47-16q31 0 47 16t15 51q0 66-62 66t-63-66zm89 33q9-11 9-33 0-24-8-34t-27-10q-19 0-27 10t-8 34q0 22 8 33t27 10q18 0 26-10zm57-98h24l61 86v-86h27v129h-24l-61-86v86h-27zm137 0h92v21h-65v33h58v21h-58v33h65v21h-92z"}}),_c('path',{attrs:{"fill":"url(#a)","d":"M678 119a152 152 0 0 1 140-27c48 19 54 66 71 50l84-85-30-30-7 7a30 30 0 0 1-37 4C854 9 801-5 746 1a226 226 0 0 0-115 47c-57 44-88 110-88 181 0 56 17 119 67 170-25-111 6-232 68-280zm166-77a13 13 0 1 1-13 13 13 13 0 0 1 13-13zm-77-17a13 13 0 1 1-12 13 13 13 0 0 1 12-13zm-76 17a13 13 0 1 1-13 13 13 13 0 0 1 13-13z"}}),_c('path',{attrs:{"fill":"#333","d":"M819 366c-15 6-31 7-47 7-39 0-68-8-102-42-13-12-33-44-43-76-4 48-8 127 19 166a229 229 0 0 0 252-1 27 27 0 0 1 34 4l11 11 30-30-84-85c-17-16-30 27-70 46zm-128 50a13 13 0 1 1 13-13 13 13 0 0 1-13 13zm76 17a13 13 0 1 1 13-13 13 13 0 0 1-13 13zm77-17a13 13 0 1 1 13-13 13 13 0 0 1-13 13z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61aef802_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logoWhite_vue__ = __webpack_require__(609);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61aef802_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logoWhite_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1514 678","width":"178","height":"80"}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"a","x2":"1"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#fff"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#d92340"}})],1)],1),_c('g',{staticClass:"currentLayer"},[_c('path',{attrs:{"fill":"#fff","d":"M17 661Q0 643 0 613q0-33 17-50t50-18a112 112 0 0 1 38 7v23a95 95 0 0 0-36-7q-22 0-32 11t-10 34q0 21 11 32t31 10a95 95 0 0 0 36-7v24a123 123 0 0 1-38 6q-32 0-50-17zm149-114h30l49 129h-28l-12-31h-48l-12 31h-28zm35 77l-20-52-20 52zm60-77h27l38 78 38-78h27v129h-27v-84l-30 62h-16l-30-62v84h-27zm154 0h61q22 0 33 12t11 33a47 47 0 0 1-5 23 38 38 0 0 1-16 15q-10 6-24 6h-33v40h-27zm54 67q12 0 18-6t6-16q0-12-6-17t-17-6h-28v45zm68-67h54q30 0 44 16t15 49q0 33-15 49t-44 15h-54zm50 108q13 0 20-3t11-13q4-10 4-27t-3-26-11-13q-8-3-21-3h-23v85zm83-108h62q22 0 33 12t10 31q0 13-6 23t-19 13a27 27 0 0 1 5 6 53 53 0 0 1 4 8l15 36h-28l-15-35-4-6q-2-2-8-2h-22v43h-27zm55 64q11 0 17-5t6-16q0-10-5-15t-16-5h-30v41zm107-64h30l49 129h-28l-12-31h-48l-12 31h-28zm35 77l-20-52-20 52zm65-77h90v21h-63v33h56v21h-56v54h-27zm139 21h-40v-21h106v21h-39v108h-27z"}}),_c('path',{attrs:{"fill":"#fff","d":"M1139 612q0-35 16-51t47-16q31 0 47 16t15 51q0 66-62 66t-63-66zm89 33q9-11 9-33 0-24-8-34t-27-10q-19 0-27 10t-8 34q0 22 8 33t27 10q18 0 26-10zm57-98h24l61 86v-86h27v129h-24l-61-86v86h-27zm137 0h92v21h-65v33h58v21h-58v33h65v21h-92z"}}),_c('path',{attrs:{"fill":"#fff","d":"M678 119a152 152 0 0 1 140-27c48 19 54 66 71 50l84-85-30-30-7 7a30 30 0 0 1-37 4C854 9 801-5 746 1a226 226 0 0 0-115 47c-57 44-88 110-88 181 0 56 17 119 67 170-25-111 6-232 68-280zm166-77a13 13 0 1 1-13 13 13 13 0 0 1 13-13zm-77-17a13 13 0 1 1-12 13 13 13 0 0 1 12-13zm-76 17a13 13 0 1 1-13 13 13 13 0 0 1 13-13z"}}),_c('path',{attrs:{"fill":"#fff","d":"M819 366c-15 6-31 7-47 7-39 0-68-8-102-42-13-12-33-44-43-76-4 48-8 127 19 166a229 229 0 0 0 252-1 27 27 0 0 1 34 4l11 11 30-30-84-85c-17-16-30 27-70 46zm-128 50a13 13 0 1 1 13-13 13 13 0 0 1-13 13zm76 17a13 13 0 1 1 13-13 13 13 0 0 1-13 13zm77-17a13 13 0 1 1 13-13 13 13 0 0 1-13 13z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 610 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal fade show d-block",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered z-1",class:_vm.size ? ("modal-" + _vm.size) : null,attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content p-3",class:_vm.contentClass},[_c('div',{staticClass:"modal-header justify-content-center"},[_vm._t("header"),_vm._v(" "),_c('button',{staticClass:"close text-primary border-0 border-primary",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.$emit('close', $event)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","aria-hidden":"true","viewBox":"0 0 18 18"}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer",attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"}}),_c('path',{attrs:{"d":"M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"}}),_c('path',{attrs:{"d":"M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"}})])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-body justify-content-center",class:_vm.bodyClass},[_vm._t("body")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer justify-content-center"},[_vm._t("footer")],2)])]),_vm._v(" "),_c('div',{staticClass:"modal-backdrop fade show z-0",on:{"click":function($event){return _vm.$emit('close')}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"d-flex flex-column flex-grow-1 align-items-center justify-content-center bg-primary"},[_c('section',{staticClass:"container py-3 py-sm-4 d-flex flex-grow-1 align-items-lg-center flex-lg-grow-0 position-relative"},[_c('div',{staticClass:"col-12 col-dialog px-0 mx-auto mt-5 mt-md-0 position-static"},[_c('div',{staticClass:"bg-lg-white text-white text-lg-body rounded p-md-4 p-lg-5"},[_c('logo',{staticClass:"mx-auto d-none d-lg-block mb-lg-5"}),_vm._v(" "),_c('logo-white',{staticClass:"mx-auto d-block d-lg-none mb-5"}),_vm._v(" "),(_vm.maintenance)?_c('div',{staticClass:"alert alert-warning"},[_c('strong',[_vm._v("Scheduled Maintenance.")]),_vm._v(" We're currently performing maintenance. Please check back soon.\n        ")]):_vm._e(),_vm._v(" "),_c('VueSlideToggle',{staticClass:"mb-lg-0 px-lg-1",attrs:{"open":!_vm.forgot,"tag":"div","duration":500}},[_c('form',{staticClass:"needs-validation pt-5 pt-lg-0",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('h1',{staticClass:"h3 mb-3 mb-sm-4 sr-only"},[_vm._v("Sign in to Campdraft One")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"email","id":"email","maxlength":"255","required":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Email Address.")])]),_vm._v(" "),_c('div',{staticClass:"form-group mb-4 mb-lg-3"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.password),expression:"password.password"}],class:['form-control', _vm.status === 'invalid_credentials' ? 'is-invalid' : ''],attrs:{"type":"password","id":"password","maxlength":"30","required":""},domProps:{"value":(_vm.password.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "password", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v(_vm._s(_vm.status === 'invalid_credentials' ? 'Please check your password.' : 'Please include your Password.'))])]),_vm._v(" "),_c('button',{class:['btn btn-block mb-4 btn-primary-dark'],attrs:{"type":"submit","disabled":_vm.showCaptcha && !_vm.captchaReady},on:{"click":_vm.handleSubmit}},[_vm._v("\n              "+_vm._s(!_vm.processing[0] && !(_vm.showCaptcha && !_vm.captchaReady) ? 'Sign In' : '')+"\n              "),(_vm.processing[0] || (_vm.showCaptcha && !_vm.captchaReady))?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]),_vm._v(" "),(_vm.showCaptcha)?_c('div',{ref:"recaptcha",staticClass:"mb-4 mb-lg-3 m-auto",staticStyle:{"width":"304px"}}):_vm._e(),_vm._v(" "),(_vm.status === 'requires_verification')?_c('div',{staticClass:"alert alert-info"},[_vm._v("Please check your registration email to verify your account.")]):(_vm.status === 'invalid_credentials')?_c('div',{staticClass:"alert alert-warning"},[_vm._v("Please check your login details and try again. "),_c('div',{domProps:{"textContent":_vm._s(_vm.message)}})]):(_vm.status === 'invalid_captcha')?_c('div',{staticClass:"alert alert-warning",domProps:{"textContent":_vm._s(_vm.message)}}):(_vm.status === 'too_many_attempts')?_c('div',{staticClass:"alert alert-danger",domProps:{"textContent":_vm._s(_vm.message)}}):(_vm.status === 'onhold')?_c('div',{staticClass:"alert alert-danger"},[_vm._v("Oops! Looks like your membership is on hold, please contact the ACA office on (07) 4622 3110.")]):(_vm.status === 'maintenance')?_c('div',{staticClass:"alert alert-warning"},[_vm._v("We're currently performing maintenance. Please check back soon.")]):(_vm.status === 'undefined_error' || _vm.status === 'token_error')?_c('div',{staticClass:"alert alert-danger"},[_vm._v("There was a server error. Please try again later.")]):(_vm.status === 'reset_request')?_c('div',{staticClass:"alert alert-info"},[_vm._v("Your password reset request has been sent.")]):_vm._e()])]),_vm._v(" "),_c('VueSlideToggle',{staticClass:"d-sm-flex justify-content-sm-between px-lg-1",attrs:{"open":!_vm.forgot,"tag":"div","duration":500}},[_c('a',{staticClass:"d-block mb-2 mb-sm-0",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.resetForm();_vm.forgot = !_vm.forgot}}},[_vm._v("Forgot your password?")]),_vm._v(" "),_c('a',{staticClass:"d-block mb-2 mb-sm-0 text-sm-right",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.registerModal($event)}}},[_vm._v("Need to create a new account?")])]),_vm._v(" "),_c('VueSlideToggle',{staticClass:"mb-lg-0 px-lg-1",attrs:{"open":_vm.forgot,"tag":"div","duration":500}},[_c('form',{staticClass:"needs-validation",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.recoverPassword($event)}}},[_c('h1',{staticClass:"h3 mb-4 pb-2 pb-lg-0 font-weight-normal text-center"},[_vm._v("Forgot your password?")]),_vm._v(" "),_c('div',{staticClass:"form-group mb-4 mb-lg-3"},[_c('label',{attrs:{"for":"forgotEmail"}},[_vm._v("Email Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"email","id":"forgotEmail","required":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Email Address.")])]),_vm._v(" "),_c('button',{class:['btn btn-block mb-4', _vm.processing[1] ? 'btn-primary-dark' : 'btn-primary-dark'],attrs:{"type":"submit"},on:{"click":_vm.handleSubmit}},[_vm._v("\n              "+_vm._s(!_vm.processing[1] ? 'Recover Password' : '')+"\n              "),(_vm.processing[1])?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]),_vm._v(" "),(_vm.status === 'reset_request' || _vm.status === 'password_sent')?_c('div',{staticClass:"alert alert-success"},[_vm._v("Your password request has been sent. You will receive an email with instructions on how to continue.")]):_vm._e(),_vm._v(" "),(_vm.status === 'invalid_credentials')?_c('div',{staticClass:"alert alert-warning"},[_vm._v("An account wasn't found with those details. Please check the email address supplied.")]):_vm._e(),_vm._v(" "),(_vm.status === 'onhold')?_c('div',{staticClass:"alert alert-danger"},[_vm._v("Oops! Looks like your membership is on hold, please contact the ACA office on (07) 4622 3110.")]):_vm._e(),_vm._v(" "),(_vm.status === 'password_cannot_send')?_c('div',{staticClass:"alert alert-danger"},[_vm._v("Admins and Secretary Only cannot request a password reset. Please ask another admin to change your password on your behalf")]):_vm._e(),_vm._v(" "),(_vm.status === 'undefined_error')?_c('div',{staticClass:"alert alert-danger"},[_vm._v("There was a server error. Please try again later.")]):_vm._e()])]),_vm._v(" "),_c('VueSlideToggle',{attrs:{"open":_vm.forgot,"tag":"div","duration":500}},[_vm._v("\n          Back to "),_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.resetForm();_vm.forgot = !_vm.forgot}}},[_vm._v("Sign in")]),_vm._v(".\n        ")])],1)]),_vm._v(" "),(_vm.showRegisterModal)?_c('modal',{on:{"close":function($event){_vm.showRegisterModal = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n          To create a Campdraft One account please contact the office on  07 4622 3110, Monday to Friday 8.30am - 4pm\n        ")])])]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Maintenance_vue__ = __webpack_require__(207);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b93fc640_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Maintenance_vue__ = __webpack_require__(614);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Maintenance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b93fc640_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Maintenance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"d-flex flex-column flex-grow-1 align-items-center justify-content-center bg-primary"},[_c('section',{staticClass:"container py-3 py-sm-4 d-flex flex-grow-1 align-items-lg-center flex-lg-grow-0 position-relative"},[_c('div',{staticClass:"col-12 col-dialog px-0 mx-auto mt-5 mt-md-0 position-static text-center"},[_c('div',{staticClass:"bg-lg-white text-white text-lg-body rounded p-md-4 p-lg-5"},[_c('logo',{staticClass:"mx-auto d-none d-lg-block mb-lg-5"}),_vm._v(" "),_c('logo-white',{staticClass:"mx-auto d-block d-lg-none mb-5"}),_vm._v(" "),_c('h1',{staticClass:"h3 mb-3"},[_vm._v("Scheduled Maintenance")]),_vm._v(" "),_vm._m(0)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mb-4"},[_vm._v("We're currently performing maintenance."),_c('br'),_vm._v("Please check back soon.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginOnce_vue__ = __webpack_require__(208);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f6ee93_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginOnce_vue__ = __webpack_require__(634);
function injectStyle (ssrContext) {
  __webpack_require__(616)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39f6ee93"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginOnce_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f6ee93_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginOnce_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 616 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginOnceNav_vue__ = __webpack_require__(209);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c1a253e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginOnceNav_vue__ = __webpack_require__(619);
function injectStyle (ssrContext) {
  __webpack_require__(618)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c1a253e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginOnceNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c1a253e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginOnceNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 618 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"mb-4 my-md-5"},[_c('ul',{staticClass:"nav nav-once d-flex justify-content-between w-100"},_vm._l((3),function(pageNumber){return _c('li',{key:pageNumber,class:['nav-item', pageNumber === 1 ? 'mr-auto' : pageNumber === 3 ? 'ml-auto' : 'mx-auto']},[_c('button',{class:['nav-link', { 'active': pageNumber === _vm.page }, { 'disabled': pageNumber > _vm.maxPage || pageNumber === _vm.page }],attrs:{"tabindex":pageNumber <= _vm.maxPage ? false : '-1',"aria-disabled":pageNumber > _vm.maxPage || pageNumber === _vm.page},on:{"click":function($event){pageNumber <= _vm.maxPage && pageNumber !== _vm.page ? _vm.goToPage(pageNumber) : false}}},[(pageNumber === 3)?_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"17","aria-hidden":"true","viewBox":"0 0 448 512"}},[_c('path',{attrs:{"fill":"currentColor","d":"M413.505 91.951L133.49 371.966l-98.995-98.995c-4.686-4.686-12.284-4.686-16.971 0L6.211 284.284c-4.686 4.686-4.686 12.284 0 16.971l118.794 118.794c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-11.314-11.314c-4.686-4.686-12.284-4.686-16.97 0z"}})]):_c('span',[_vm._v(_vm._s(pageNumber))])])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginOnceWelcome_vue__ = __webpack_require__(210);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bbd5798_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginOnceWelcome_vue__ = __webpack_require__(621);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginOnceWelcome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bbd5798_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginOnceWelcome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-auto text-white text-center"},[_c('h1',{staticClass:"text-white mb-4"},[_vm._v("Welcome to CampdraftONE!")]),_vm._v(" "),_c('p',{staticClass:"lead mb-4 mb-md-5 mx-auto",staticStyle:{"max-width":"450px","font-size":"19px"}},[_c('strong',[_vm._v("G’day "+_vm._s(_vm.name))]),_vm._v(", before you get started, we need to make sure your membership details are correct.")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary-dark px-4 px-md-5 py-2",on:{"click":function($event){$event.preventDefault();return _vm.$emit('proceed')}}},[_vm._v("Check my details")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginOnce1_vue__ = __webpack_require__(211);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44a7c5d7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginOnce1_vue__ = __webpack_require__(627);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginOnce1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44a7c5d7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginOnce1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PHONE_HINT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PHONE_PREFIX; });
/* unused harmony export PHONE_DIGITS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PHONE_MASK_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isForeignPhone; });
/* harmony export (immutable) */ __webpack_exports__["f"] = nationalDigits;
/* harmony export (immutable) */ __webpack_exports__["c"] = applyMask;
/* harmony export (immutable) */ __webpack_exports__["g"] = toModel;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return caretAfterDigits; });
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Mask for Australian mobile numbers: "+61" is fixed in the field, the user fills the 9 national
// digits, unfilled positions show "_":   +61 4__ ___ ___  →  +61 412 345 678
// The backend (PhoneNumberService) stores E.164 (+61412345678) and accepts the spaced value as is.
var PHONE_HINT = 'Please enter the phone in a similar format +614 **** **** without spaces';
var PHONE_PREFIX = '+61 ';
var PHONE_DIGITS = 9;
var PHONE_MASK_LENGTH = PHONE_PREFIX.length + PHONE_DIGITS + 2; // two group separators

var groupDigits = function groupDigits(digits) {
  return [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6, 9)];
}; // Non-AU numbers (e.g. legacy "+7…") are not masked — the field falls back to plain text for them


var isForeignPhone = function isForeignPhone(value) {
  return /^\s*\+\s*(?!6\s*1)/.test(String(value == null ? '' : value));
}; // National digits out of anything the user can type, paste, or the DB can hold
// (+61 412…, 0412…, 61412…, +610412…, partially deleted prefix "+6 412…").

function nationalDigits(raw) {
  var str = String(raw == null ? '' : raw);

  if (/^\s*\+/.test(str)) {
    str = str.replace(/^\s*\+\s*6?\s*1?/, '');
  }

  var digits = str.replace(/\D/g, ''); // National AU numbers never start with 61, so any leftover country code is stripped. Needed when
  // the browser (Ctrl+Z, paste into the middle) leaves a second "+61 …" inside the mask.

  while (digits.startsWith('61')) {
    digits = digits.slice(2);
  }

  return digits.replace(/^0+/, '').slice(0, PHONE_DIGITS);
}
function applyMask(digits) {
  var _groupDigits$map = groupDigits(digits).map(function (part) {
    return part.padEnd(3, '_');
  }),
      _groupDigits$map2 = _slicedToArray(_groupDigits$map, 3),
      a = _groupDigits$map2[0],
      b = _groupDigits$map2[1],
      c = _groupDigits$map2[2];

  return "".concat(PHONE_PREFIX).concat(a, " ").concat(b, " ").concat(c);
} // Value written to the form model: spaced number without placeholders, '' when nothing is typed

function toModel(digits) {
  return digits ? "".concat(PHONE_PREFIX).concat(groupDigits(digits).filter(Boolean).join(' ')) : '';
} // Caret index in the mask right after the k-th digit (k = 0 → right after the fixed prefix)

var caretAfterDigits = function caretAfterDigits(k) {
  return k === 0 ? PHONE_PREFIX.length : PHONE_PREFIX.length + k + Math.floor((k - 1) / 3);
};

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"form-control",attrs:{"type":_vm.foreign ? 'text' : 'tel',"inputmode":"tel","autocomplete":"off","maxlength":_vm.foreign ? 20 : null},domProps:{"value":_vm.display},on:{"input":_vm.onInput,"paste":_vm.onPaste,"focus":_vm.keepCaretAfterPrefix,"click":_vm.keepCaretAfterPrefix,"keydown":_vm.onKeydown}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"test-phone-numbers small mt-1"},[_c('span',{staticClass:"text-muted"},[_vm._v("Test environment — use only these numbers, nobody can receive an SMS on them:")]),_vm._v(" "),_vm._l((_vm.numbers),function(number){return _c('code',{key:number,staticClass:"test-phone-numbers__number"},[_vm._v(_vm._s(number))])})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation row mx-0 mb-3",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.confirm($event)}}},[_c('section',{staticClass:"col-12 col-md bg-white rounded p-4 p-xl-5"},[(_vm.errors)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors))]):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"h3 mb-2"},[_vm._v("Your Details")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-12 col-md-6 row no-gutters pr-xl-4"},[_c('div',{staticClass:"col-12 col-md-auto form-group"},[_c('label',{attrs:{"for":"title"}},[_vm._v("Title")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.title),expression:"userInfo.title"}],staticClass:"form-control",attrs:{"id":"title","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.userInfo, "title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',{attrs:{"value":"Mr"}},[_vm._v("Mr")]),_vm._v(" "),_c('option',{attrs:{"value":"Ms"}},[_vm._v("Ms")]),_vm._v(" "),_c('option',{attrs:{"value":"Miss"}},[_vm._v("Miss")]),_vm._v(" "),_c('option',{attrs:{"value":"Mrs"}},[_vm._v("Mrs")]),_vm._v(" "),_c('option',{attrs:{"value":"Dr"}},[_vm._v("Dr")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your title.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md pl-md-4 form-group"},[_c('label',{attrs:{"for":"firstName"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.first_name),expression:"userInfo.first_name"}],staticClass:"form-control",attrs:{"type":"text","id":"firstName","maxlength":"40","required":""},domProps:{"value":(_vm.userInfo.first_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "first_name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your First Name.")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"lastName"}},[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.last_name),expression:"userInfo.last_name"}],staticClass:"form-control",attrs:{"type":"text","id":"lastName","maxlength":"40","required":""},domProps:{"value":(_vm.userInfo.last_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "last_name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Last Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":"dateOfBirth"}},[_vm._v("Date of Birth")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.dob),expression:"userInfo.dob"}],class:['form-control form-date', _vm.errorStatus === 'validation_error' ? 'is-invalid' : ''],attrs:{"max":_vm.today(),"required":"","id":"dateOfBirth","type":"date","placeholder":[_vm.isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy'],"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}","value":"1988-01-01"},domProps:{"value":(_vm.userInfo.dob)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "dob", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Date of Birth"+_vm._s(_vm.isLegacy() ? ' in the format yyyy-mm-dd' : '')+".")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"gender"}},[_vm._v("Gender")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.gender),expression:"userInfo.gender"}],staticClass:"form-control",attrs:{"id":"gender","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.userInfo, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',[_vm._v("Male")]),_vm._v(" "),_c('option',[_vm._v("Female")]),_vm._v(" "),_c('option',[_vm._v("Unspecified")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Gender.")])]),_vm._v(" "),(_vm.userInfo.attributes.address)?_c('div',{staticClass:"row w-100 mx-0"},[_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":"address"}},[_vm._v("Address Line 1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.attributes.address.street_1),expression:"userInfo.attributes.address.street_1"}],staticClass:"form-control",attrs:{"type":"text","id":"address","maxlength":"80","required":"","pattern":".{5,}"},domProps:{"value":(_vm.userInfo.attributes.address.street_1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo.attributes.address, "street_1", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include an address of at least 5 characters.")]),_vm._v(" "),_c('small',{staticClass:"d-block"},[_vm._v("Must be at least 5 characters")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.attributes.address.street_2),expression:"userInfo.attributes.address.street_2"}],staticClass:"form-control",attrs:{"type":"text","id":"address2","maxlength":"80"},domProps:{"value":(_vm.userInfo.attributes.address.street_2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo.attributes.address, "street_2", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include an address of at least 5 characters.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":"suburb"}},[_vm._v("Suburb")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.attributes.address.suburb),expression:"userInfo.attributes.address.suburb"}],staticClass:"form-control",attrs:{"type":"text","id":"suburb","maxlength":"40","required":""},domProps:{"value":(_vm.userInfo.attributes.address.suburb)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo.attributes.address, "suburb", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Suburb.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group pl-xl-4 mb-4"},[_c('label',{attrs:{"for":"postcode"}},[_vm._v("Postcode")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.attributes.address.postcode),expression:"userInfo.attributes.address.postcode"}],staticClass:"form-control",attrs:{"type":"text","id":"postcode","maxlength":"4","required":"","pattern":"\\d{4}"},domProps:{"value":(_vm.userInfo.attributes.address.postcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo.attributes.address, "postcode", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include a four-digit Postcode.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group pr-xl-4 mb-4"},[_c('label',{attrs:{"for":"state"}},[_vm._v("State")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.attributes.address.state),expression:"userInfo.attributes.address.state"}],staticClass:"form-control",attrs:{"id":"state","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.userInfo.attributes.address, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',{attrs:{"value":"QLD"}},[_vm._v("Queensland")]),_vm._v(" "),_c('option',{attrs:{"value":"NSW"}},[_vm._v("New South Wales")]),_vm._v(" "),_c('option',{attrs:{"value":"VIC"}},[_vm._v("Victoria")]),_vm._v(" "),_c('option',{attrs:{"value":"ACT"}},[_vm._v("Australian Capital Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"SA"}},[_vm._v("South Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"NT"}},[_vm._v("Northern Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"WA"}},[_vm._v("Western Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"TAS"}},[_vm._v("Tasmania")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your State.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group pl-xl-4 mb-4"},[_vm._m(2),_vm._v(" "),_c('phone-input',{attrs:{"id":"mobile"},model:{value:(_vm.userInfo.attributes.mobile_phone),callback:function ($$v) {_vm.$set(_vm.userInfo.attributes, "mobile_phone", $$v)},expression:"userInfo.attributes.mobile_phone"}}),_vm._v(" "),_c('test-phone-numbers')],1)]):_vm._e(),_vm._v(" "),(_vm.isUnder17)?_c('div',{staticClass:"col-12 mb-4"},[_c('h2',{staticClass:"h3 mb-4"},[_vm._v("Parent / Guardian Details")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":"parentFirstName"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.guardian_first_name),expression:"userInfo.guardian_first_name"}],staticClass:"form-control",attrs:{"type":"text","id":"parentFirstName","maxlength":"40","required":""},domProps:{"value":(_vm.userInfo.guardian_first_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "guardian_first_name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the First Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"parentLastName"}},[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.guardian_last_name),expression:"userInfo.guardian_last_name"}],staticClass:"form-control",attrs:{"type":"text","id":"parentLastName","maxlength":"40","required":""},domProps:{"value":(_vm.userInfo.guardian_last_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "guardian_last_name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Last Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":"parentEmail"}},[_vm._v("Email Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.guardian_email),expression:"userInfo.guardian_email"}],staticClass:"form-control",attrs:{"type":"email","id":"parentEmail","maxlength":"255","required":""},domProps:{"value":(_vm.userInfo.guardian_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "guardian_email", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Email Address.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"mobile"}},[_vm._v("Phone Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.guardian_phone),expression:"userInfo.guardian_phone"}],staticClass:"form-control",attrs:{"type":"text","id":"mobile","maxlength":"15","required":""},domProps:{"value":(_vm.userInfo.guardian_phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "guardian_phone", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Phone Number.")])])])]):_vm._e(),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group pr-xl-4"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.password),expression:"password.password"}],staticClass:"form-control",attrs:{"type":"password","id":"password","maxlength":"30","required":"","pattern":"([A-Za-z0-9]){6,}"},domProps:{"value":(_vm.password.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "password", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include a Password between 6 and 30 characters, using only letters and numbers.")]),_vm._v(" "),_c('small',{staticClass:"d-block"},[_vm._v("Must be between 6 and 30 characters, using only letters and numbers")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group pl-xl-4"},[_c('label',{attrs:{"for":"confirmPassword"}},[_vm._v("Confirm Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.confirmPassword),expression:"password.confirmPassword"}],staticClass:"form-control",attrs:{"type":"password","id":"confirmPassword","maxlength":"30","required":"","pattern":"([A-Za-z0-9]){6,}"},domProps:{"value":(_vm.password.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "confirmPassword", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please ensure your Password matches.")])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-12 d-lg-flex justify-content-end align-items-center"},[_c('p',{staticClass:"pr-lg-3 mb-2 mb-lg-0"},[_vm._v("Take me to step 2")]),_vm._v(" "),_c('button',{class:['btn btn-block-mob px-md-5', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],attrs:{"type":"submit"},on:{"click":_vm.handleSubmit}},[_vm._v("\n          "+_vm._s(!_vm.processing ? 'Confirm' : '')+"\n          "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mb-4"},[_vm._v("It looks like some details are missing from your "),_c('strong',[_vm._v("profile")]),_vm._v(". "),_c('br'),_vm._v("Please complete the necessary fields.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"address2"}},[_vm._v("Address Line 2 "),_c('small',[_vm._v("(optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"mobile"}},[_vm._v("Mobile Number "),_c('small',{staticClass:"d-inline-block"},[_vm._v("(optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('h2',{staticClass:"h3 mb-2"},[_vm._v("Set Your Password")]),_vm._v(" "),_c('p',{staticClass:"mb-4"},[_vm._v("Please set your new password. This will be used when logging into CampdraftONE in future. Make sure it’s easily remembered.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mb-md-4"},[_c('hr')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginOnce2_vue__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10a9ecdc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginOnce2_vue__ = __webpack_require__(630);
function injectStyle (ssrContext) {
  __webpack_require__(629)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10a9ecdc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginOnce2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10a9ecdc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginOnce2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation row mb-3 mx-0",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.confirm(true)}}},[_c('section',{staticClass:"col-12 col-md bg-white rounded p-4 p-xl-5"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),(_vm.errors)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors))]):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"h3 mb-2"},[_vm._v("Your Members")]),_vm._v(" "),_vm._m(2),_vm._v(" "),(_vm.userInfo.length > 0)?_c('div',_vm._l((_vm.userInfo),function(user,index){return _c('div',{key:index,staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('button',{class:['btn btn-link btn-block border-bottom rounded-0 py-3 text-left text-dark d-flex justify-content-between align-items-center', _vm.selectedSection === index ? 'bg-lighter' : ''],attrs:{"type":"button","aria-expanded":_vm.selectedSection === index,"aria-controls":'memberSection' + index},on:{"click":function($event){_vm.selectedSection = _vm.selectedSection === index ? -1 : index}}},[_c('h2',{staticClass:"h5 mb-0",attrs:{"id":'member' + index}},[_vm._v("Member "+_vm._s(index + 1))]),_vm._v(" "),(index in _vm.fieldsValidity ? !_vm.fieldsValidity[index] : false)?_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 16","width":"22","height":"21"}},[_c('g',{staticClass:"currentLayer"},[_c('g',[_c('path',{attrs:{"fill":"#AA2D41","d":"M8.4749994 9.7999992c-.3 0-.5-.2-.5-.5v-3.6c0-.3.2-.5.5-.5s.5.2.5.5v3.6c0 .3-.2.5-.5.5zM8.4749994 12.3999992c-.1 0-.3 0-.4-.1-.1-.1-.1-.2-.1-.4 0-.1 0-.3.1-.4.2-.2.5-.2.7 0 .1.1.1.2.1.4 0 .1-.1.3-.2.4.1.1-.1.1-.2.1z"}}),_c('g',[_c('path',{attrs:{"fill":"#AA2D41","d":"M14.3749994 15.4999992h-11.8c-.9 0-1.8-.5-2.2-1.3-.5-.8-.5-1.8 0-2.6l5.9-10.3c.5-.8 1.3-1.3 2.2-1.3s1.8.5 2.2 1.3l5.9 10.3c.5.8.5 1.8 0 2.6-.4.8-1.2 1.3-2.2 1.3zm-5.9-14.4c-.6 0-1.1.3-1.3.8l-5.9 10.3c-.3.5-.3 1.1 0 1.6s.8.8 1.3.8h11.9c.6 0 1.1-.3 1.3-.8.3-.5.3-1.1 0-1.6l-5.9-10.3c-.3-.5-.8-.8-1.4-.8z"}})])])])]):_vm._e()])]),_vm._v(" "),_c('VueSlideToggle',{staticClass:"row w-100 align-items-start mx-0",attrs:{"open":_vm.selectedSection === index,"id":'memberSection' + index,"aria-labelledby":'member' + index}},[_c('div',{staticClass:"col-12 col-md-6 row no-gutters pr-xl-4 pt-3"},[_c('div',{staticClass:"col-12 col-md-auto form-group"},[_c('label',{attrs:{"for":'title' + index}},[_vm._v("Title")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo[index].title),expression:"userInfo[index].title"}],ref:'title' + index,refInFor:true,staticClass:"form-control",attrs:{"id":'title' + index,"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.userInfo[index], "title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateValidity(index)}]}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',{attrs:{"value":"Mr"}},[_vm._v("Mr")]),_vm._v(" "),_c('option',{attrs:{"value":"Ms"}},[_vm._v("Ms")]),_vm._v(" "),_c('option',{attrs:{"value":"Miss"}},[_vm._v("Miss")]),_vm._v(" "),_c('option',{attrs:{"value":"Mrs"}},[_vm._v("Mrs")]),_vm._v(" "),_c('option',{attrs:{"value":"Dr"}},[_vm._v("Dr")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the title.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md pl-md-4 form-group"},[_c('label',{attrs:{"for":'firstName' + index}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo[index].first_name),expression:"userInfo[index].first_name"}],ref:'firstName' + index,refInFor:true,staticClass:"form-control",attrs:{"type":"text","id":'firstName' + index,"required":""},domProps:{"value":(_vm.userInfo[index].first_name)},on:{"change":function($event){return _vm.updateValidity(index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo[index], "first_name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the First Name.")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group pt-md-3"},[_c('label',{attrs:{"for":'lastName' + index}},[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo[index].last_name),expression:"userInfo[index].last_name"}],ref:'lastName' + index,refInFor:true,staticClass:"form-control",attrs:{"type":"text","id":'lastName' + index,"required":""},domProps:{"value":(_vm.userInfo[index].last_name)},on:{"change":function($event){return _vm.updateValidity(index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo[index], "last_name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Last Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":'dateOfBirth' + index}},[_vm._v("Date of Birth")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo[index].dob),expression:"userInfo[index].dob"}],ref:'dob' + index,refInFor:true,class:['form-control form-date', _vm.errorStatus === 'validation_error' ? 'is-invalid' : ''],attrs:{"max":_vm.today(),"required":"","id":'dateOfBirth' + index,"type":"date","placeholder":[_vm.isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy'],"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}","value":"1988-01-01"},domProps:{"value":(_vm.userInfo[index].dob)},on:{"change":function($event){_vm.checkDoB(index);_vm.updateValidity(index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo[index], "dob", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Date of Birth"+_vm._s(_vm.isLegacy() ? ' in the format yyyy-mm-dd' : '')+".")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":'gender' + index}},[_vm._v("Gender")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo[index].gender),expression:"userInfo[index].gender"}],ref:'gender' + index,refInFor:true,staticClass:"form-control",attrs:{"id":'gender' + index,"required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.userInfo[index], "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateValidity(index)}]}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',[_vm._v("Male")]),_vm._v(" "),_c('option',[_vm._v("Female")]),_vm._v(" "),_c('option',[_vm._v("Unspecified")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Gender.")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('hr',{staticClass:"mb-0"})])])],1)}),0):_c('div',{staticClass:"row"},[_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"row mt-3 mt-xl-4"},[(_vm.success)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-success text-center",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.success))])]):_vm._e(),_vm._v(" "),(_vm.fieldsValidity.includes(false))?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-danger text-center",attrs:{"role":"alert"}},[_vm._v("Please complete the member details above.")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 d-lg-flex justify-content-end align-items-center mt-md-3"},[_c('p',{staticClass:"pr-lg-3 mb-2 mb-lg-0 text-center"},[_vm._v("Take me to Account Overview")]),_vm._v(" "),_c('button',{class:['btn btn-block-mob mb-2 mb-lg-0 px-md-5', _vm.processing ? 'btn-primary-dark' : 'btn-primary', _vm.userInfo.length > 0 ? 'mr-lg-2' : ''],attrs:{"type":"submit"},on:{"click":function($event){_vm.handleSubmit();_vm.confirm(true)}}},[_vm._v("\n          "+_vm._s(!_vm.processing ? 'Confirm' : '')+"\n          "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]),_vm._v(" "),(_vm.userInfo.length > 0)?_c('button',{class:['btn btn-block-mob px-md-5', _vm.processing2 ? 'btn-primary-dark' : 'btn-outline-primary'],attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.saveData(false)}}},[_vm._v("\n          "+_vm._s(!_vm.processing2 ? 'Save & Continue Later' : '')+"\n          "),(_vm.processing2)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-warning text-center mb-4",attrs:{"role":"alert"}},[_c('p',{staticClass:"mb-0"},[_c('strong',[_vm._v("Running short on time?")]),_vm._v(" Don't worry! You can save and continue later.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-info text-center mb-4",attrs:{"role":"alert"}},[_c('p',{staticClass:"mb-0"},[_c('strong',[_vm._v("Are there members here that shouldn't be?")]),_vm._v(" Please contact us after completing the form.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mb-4"},[_vm._v("The following "),_c('strong',[_vm._v("members")]),_vm._v(" are registered under your account. "),_c('br'),_vm._v("Please check all details.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-info text-center",attrs:{"role":"alert"}},[_c('p',{staticClass:"mb-0"},[_vm._v("There are no other members in our records. Members can be added later.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginOnce4_vue__ = __webpack_require__(215);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19f396e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginOnce4_vue__ = __webpack_require__(633);
function injectStyle (ssrContext) {
  __webpack_require__(632)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19f396e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginOnce4_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19f396e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginOnce4_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-3 mx-0"},[_c('section',{staticClass:"col-12 col-md bg-white rounded p-4 p-xl-5"},[_c('h1',{staticClass:"h3 mb-4"},[_vm._v("Account Overview")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',{staticClass:"flex-grow-1"},[_c('h2',{staticClass:"h5 mb-3"},[_vm._v("Your Details")]),_vm._v(" "),_c('span',{staticClass:"text-muted",staticStyle:{"line-height":"1.7"}},[_vm._v("\n          "+_vm._s(_vm.user.title)+" "+_vm._s(_vm.user.first_name)+" "+_vm._s(_vm.user.last_name)+" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"pr-3 pr-md-4"},[_vm._v(_vm._s(_vm.user.dob))]),_vm._v(" "+_vm._s(_vm.user.gender)+" "),_c('br'),_vm._v("\n          "+_vm._s(_vm.getAddress(_vm.user.attributes.address))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"blockButtons position-relative align-self-start"},[_c('button',{staticClass:"d-flex justify-content-center align-items-center",on:{"click":function($event){return _vm.editPage(1)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15 15","width":"15","height":"15"}},[_c('g',{staticClass:"currentLayer"},[_c('g',[_c('path',{attrs:{"fill":"#AA2D41","d":"M13.1 5.9999996c-.1 0-.3 0-.4-.1l-3.2-3.2c-.1-.1-.1-.2-.1-.4s.1-.3.1-.4l1.3-1.3c.8-.8 2.1-.8 2.8 0l1.1 1.1c.8.8.8 2.1 0 2.8l-1.3 1.3c0 .2-.2.2-.3.2zm-2.5-3.7l2.5 2.5 1-1c.4-.4.4-1 0-1.4l-1.1-1.1c-.4-.4-1-.4-1.4 0l-1 1z"}}),_c('path',{attrs:{"fill":"#AA2D41","d":"M.5 15.3999996c-.1 0-.3-.1-.4-.1-.1-.2-.1-.3-.1-.5l.6-3.8c0-.1.1-.2.1-.3l8.8-8.8c.2-.2.5-.2.7 0l3.2 3.2c.1.1.1.2.1.4s-.1.3-.1.4l-8.8 8.8c-.1.1-.2.1-.3.1l-3.8.6c.1 0 0 0 0 0zm1.1-4.1l-.5 3 3-.5 8.3-8.3-2.5-2.5-8.3 8.3z"}}),_c('path',{attrs:{"fill":"#AA2D41","d":"M5.2 13.8999996c-.1 0-.3 0-.4-.1l-3.2-3.2c-.2-.2-.2-.5 0-.7s.5-.2.7 0l3.2 3.2c.2.2.2.5 0 .7 0 0-.1.1-.3.1z"}})])])])])])]),_vm._v(" "),(_vm.secondaryInfo.length > 0)?_c('div',[_c('hr',{staticClass:"my-4"}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',{staticClass:"flex-grow-1"},[_c('h2',{staticClass:"h5 mb-3"},[_vm._v("Your Members")]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.secondaryInfo),function(secondary,secondaryIndex){return _c('div',{key:secondaryIndex,staticClass:"col-12 col-md-6 mb-3 text-muted",staticStyle:{"line-height":"1.7"}},[_vm._v("\n              "+_vm._s(secondary.title)+" "+_vm._s(secondary.first_name)+" "+_vm._s(secondary.last_name)+" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"pr-3 pr-md-4"},[_vm._v(_vm._s(secondary.dob))]),_vm._v(" "+_vm._s(secondary.gender)+" "),_c('br')])}),0)]),_vm._v(" "),_c('div',{staticClass:"blockButtons position-relative align-self-start"},[_c('button',{staticClass:"d-flex justify-content-center align-items-center",on:{"click":function($event){return _vm.editPage(2)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15 15","width":"15","height":"15"}},[_c('g',{staticClass:"currentLayer"},[_c('g',[_c('path',{attrs:{"fill":"#AA2D41","d":"M13.1 5.9999996c-.1 0-.3 0-.4-.1l-3.2-3.2c-.1-.1-.1-.2-.1-.4s.1-.3.1-.4l1.3-1.3c.8-.8 2.1-.8 2.8 0l1.1 1.1c.8.8.8 2.1 0 2.8l-1.3 1.3c0 .2-.2.2-.3.2zm-2.5-3.7l2.5 2.5 1-1c.4-.4.4-1 0-1.4l-1.1-1.1c-.4-.4-1-.4-1.4 0l-1 1z"}}),_c('path',{attrs:{"fill":"#AA2D41","d":"M.5 15.3999996c-.1 0-.3-.1-.4-.1-.1-.2-.1-.3-.1-.5l.6-3.8c0-.1.1-.2.1-.3l8.8-8.8c.2-.2.5-.2.7 0l3.2 3.2c.1.1.1.2.1.4s-.1.3-.1.4l-8.8 8.8c-.1.1-.2.1-.3.1l-3.8.6c.1 0 0 0 0 0zm1.1-4.1l-.5 3 3-.5 8.3-8.3-2.5-2.5-8.3 8.3z"}}),_c('path',{attrs:{"fill":"#AA2D41","d":"M5.2 13.8999996c-.1 0-.3 0-.4-.1l-3.2-3.2c-.2-.2-.2-.5 0-.7s.5-.2.7 0l3.2 3.2c.2.2.2.5 0 .7 0 0-.1.1-.3.1z"}})])])])])])])]):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"my-4"}),_vm._v(" "),_c('div',{staticClass:"row mt-3 mt-xl-4"},[_c('div',{staticClass:"col-12 d-lg-flex justify-content-end align-items-center"},[_c('button',{class:['btn btn-block-mob mb-2 mb-lg-0 px-md-5', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],attrs:{"type":"submit"},on:{"click":_vm.saveData}},[_vm._v("\n          "+_vm._s(!_vm.processing ? 'Enter CampdraftONE' : '')+"\n          "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"d-flex flex-column flex-grow-1 align-items-center justify-content-center bg-primary"},[_c('div',{staticClass:"container py-3 py-sm-4"},[(_vm.page > 0)?_c('navbar',{attrs:{"page":_vm.page,"maxPage":_vm.maxPage},on:{"proceed":function($event){_vm.page = $event}}}):_vm._e(),_vm._v(" "),(_vm.page === 0)?_c('welcome',{attrs:{"name":_vm.user ? _vm.user.first_name : ''},on:{"proceed":function($event){_vm.page = 1}}}):_vm._e(),_vm._v(" "),(_vm.page === 1)?_c('page1',{attrs:{"user":_vm.user},on:{"proceed":function($event){_vm.page = 2}}}):_vm._e(),_vm._v(" "),(_vm.page === 2)?_c('page2',{attrs:{"user":_vm.user},on:{"proceed":function($event){_vm.page = 3}}}):_vm._e(),_vm._v(" "),(_vm.page === 3)?_c('page4',{attrs:{"user":_vm.user},on:{"proceed":function($event){_vm.page = $event}}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47c66776_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(651);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47c66776_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueSlideToggle',{ref:"menu",staticClass:"col-12 col-navbar d-lg-flex align-items-start flex-column bg-dark px-0",style:(_vm.menuCollapsed ? 'max-width: 20px;': ''),attrs:{"open":!_vm.$store.state.showExpand || _vm.$store.state.menuOpen,"tag":"nav","aria-label":"site navigation","duration":500,"id":"navbarSide"}},[_c('button',{staticClass:"menu-collapse-toggle",style:(_vm.menuCollapsed ? 'opacity: 1;' : ''),attrs:{"aria-hidden":"true","title":"Toggle Menu","tabindex":"-1"},on:{"click":function($event){$event.preventDefault();_vm.menuCollapsed = !_vm.menuCollapsed}}},[_vm._v("\n    Toggle Menu\n    "),(!_vm.menuCollapsed)?_c('svg',{staticStyle:{"margin-left":"-1px"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 192 512","width":"7"}},[_c('path',{attrs:{"fill":"currentColor","d":"M4.2 247.5L151 99.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17L69.3 256l118.5 119.7c4.7 4.7 4.7 12.3 0 17L168 412.5c-4.7 4.7-12.3 4.7-17 0L4.2 264.5c-4.7-4.7-4.7-12.3 0-17z"}})]):_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 192 512","width":"7"}},[_c('path',{attrs:{"fill":"currentColor","d":"M187.8 264.5L41 412.5c-4.7 4.7-12.3 4.7-17 0L4.2 392.7c-4.7-4.7-4.7-12.3 0-17L122.7 256 4.2 136.3c-4.7-4.7-4.7-12.3 0-17L24 99.5c4.7-4.7 12.3-4.7 17 0l146.8 148c4.7 4.7 4.7 12.3 0 17z"}})])]),_vm._v(" "),_c('div',{staticClass:"navbar navbar-expand navbar-dark flex-grow-1 align-items-start flex-column w-100"},[_c('ul',{staticClass:"nav navbar-nav flex-column flex-grow-1 w-100"},_vm._l((_vm.navItemList),function(navItem,idx){return (!navItem.meta.hasOwnProperty('childOf'))?_c('li',{key:idx,class:['nav-item', navItem.name === 'Log Out' ? 'mt-auto' : '']},[_c('router-link',{class:['nav-link d-flex align-items-center', {'active': _vm.isActive(navItem)}, {'nohover': _vm.navItemList[idx].meta.noLink}, _vm.slugify(("nav-" + (navItem.name)))],attrs:{"tabindex":(_vm.$store.state.showExpand && !_vm.$store.state.menuOpen) ? '-1' : false,"tag":"a","to":_vm.navPath(_vm.navItemList[idx].path)}},[(navItem.meta.icon)?_c('span',{staticClass:"d-flex align-items-center mr-1 pr-2",domProps:{"innerHTML":_vm._s(navItem.meta.icon)}}):_vm._e(),_vm._v("\n          "+_vm._s(navItem.displayName ? navItem.displayName : (navItem.name === 'Horses' ? (_vm.loggedInUser === 'Member') ? 'My Horses' : navItem.name : navItem.name))+"\n        ")]),_vm._v(" "),(_vm.getChildren(_vm.navItemList[idx]))?_c('ul',{staticClass:"pl-0"},_vm._l((_vm.getChildren(_vm.navItemList[idx])),function(navItemChild,childIdx){return _c('li',{key:childIdx,staticClass:"nav-item"},[_c('router-link',{class:['nav-link', {'active': _vm.isActive(_vm.getChildren(_vm.navItemList[idx])[childIdx])}],attrs:{"tabindex":(_vm.$store.state.showExpand && !_vm.$store.state.menuOpen) ? '-1' : false,"tag":"a","to":_vm.navPath(_vm.getChildren(_vm.navItemList[idx])[childIdx].path)}},[_vm._v(_vm._s(_vm.getChildrenDisplayName(_vm.navItemList[idx], childIdx)))])],1)}),0):_vm._e()],1):_vm._e()}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ul',{staticClass:"breadcrumb"},_vm._l((_vm.breadcrumbList),function(breadcrumb,idx){return _c('li',{key:idx,class:['breadcrumb-item', {'active': !breadcrumb.link}],attrs:{"aria-current":breadcrumb.link ? false : 'page'}},[(_vm.breadcrumbList.length > idx+1)?_c('router-link',{attrs:{"tag":"a","to":_vm.breadPath(_vm.breadcrumbList[idx])}},[_vm._v(_vm._s(breadcrumb.name))]):_vm._e(),_vm._v(_vm._s(_vm.breadcrumbList.length <= idx+1 ? breadcrumb.name : '')+"\n    ")],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"container-fluid flex-grow-1 d-flex bg-lighter"},[_c('div',{staticClass:"row flex-grow-1"},[_c('navbar'),_vm._v(" "),_c('div',{staticClass:"col px-4 content-col"},[_c('breadcrumb'),_vm._v(" "),_c('section',{class:['bg-white rounded mb-4 p-3', { 'p-sm-4': !_vm.noSmPadding }]},[_vm._t("heading"),_vm._v(" "),_vm._t("content")],2)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardStat_vue__ = __webpack_require__(222);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75b2e0da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardStat_vue__ = __webpack_require__(643);
function injectStyle (ssrContext) {
  __webpack_require__(642)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75b2e0da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardStat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75b2e0da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardStat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:['col-6 col-md mb-2 mb-md-3', _vm.isEven ? 'pl-1 pl-md-2 pr-md-0' : 'pr-1 pr-md-2']},[(_vm.stat.link)?_c('router-link',{staticClass:"dashboard-stat d-flex flex-column h-100 text-white text-left rounded border-0 w-100 p-2 p-sm-3 p-xl-4 bg-primary btn-hover",attrs:{"tag":"button","to":{ name: _vm.stat.link }}},[_c('span',{staticClass:"stat-name d-block text-uppercase"},[_vm._v(_vm._s(_vm.stat.name))]),_vm._v(" "),_c('span',{staticClass:"h1 mt-auto mb-0 text-white"},[_vm._v(_vm._s(_vm.stat.value ? _vm.stat.value : 0))])]):_c('div',{staticClass:"dashboard-stat d-flex flex-column h-100 text-white rounded p-2 p-sm-3 p-md-4 bg-medium"},[_c('span',{staticClass:"stat-name d-block text-uppercase"},[_vm._v(_vm._s(_vm.stat.name))]),_vm._v(" "),_c('span',{staticClass:"h1 mt-auto mb-0 text-white"},[_vm._v(_vm._s(_vm.stat.value ? _vm.stat.value : 0))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardBlock_vue__ = __webpack_require__(223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c621f964_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardBlock_vue__ = __webpack_require__(648);
function injectStyle (ssrContext) {
  __webpack_require__(645)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c621f964"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c621f964_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitBlock($event)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newBlock.id),expression:"newBlock.id"}],attrs:{"type":"hidden","id":"id"},domProps:{"value":(_vm.newBlock.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newBlock, "id", $event.target.value)}}}),_vm._v(" "),_c('fieldset',{staticClass:"form-row mb-4"},[_c('label',{staticClass:"col-12 mb-3"},[_vm._v("1. Select your card style")]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap align-items-end"},[_c('div',{staticClass:"custom-control custom-radio custom-control-inline flex-wrap mb-2"},[_c('label',{staticClass:"w-100 mb-3 d-flex align-items-center justify-content-center",staticStyle:{"height":"100px"},attrs:{"for":"styleA"}},[_c('svg',{staticClass:"styleNudge",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 142.3 119.9","height":"100","aria-labelledby":"stylea"}},[_c('title',{attrs:{"id":"stylea"}},[_vm._v("Style A")]),_c('g',{attrs:{"transform":"translate(-672 -267)"}},[_c('g',{attrs:{"transform":"translate(672 267)"}},[_c('path',{attrs:{"fill":"#f2f3f4","d":"M5 0h132.3a5 5 0 0 1 5 5v43.2H0V5a5 5 0 0 1 5-5z"}})]),_c('g',{attrs:{"transform":"translate(672 314.6)"}},[_c('g',{attrs:{"fill":"none","stroke":"#e0e0e0"}},[_c('path',{attrs:{"stroke":"none","d":"M5 0h132.3a5 5 0 0 1 5 5v67.3H0V5a5 5 0 0 1 5-5z","transform":"rotate(180 71.2 36.2)"}}),_c('path',{attrs:{"d":"M5 .5h132.3a4.5 4.5 0 0 1 4.5 4.5v66.3a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V5A4.5 4.5 0 0 1 5 .5z","transform":"rotate(180 71.2 36.2)"}})])]),_c('path',{attrs:{"d":"M0 0h94.3v6H0z","fill":"#a2a0a0","transform":"translate(696 333)"}}),_c('path',{attrs:{"d":"M0 0h94.3v6H0z","fill":"#a2a0a0","transform":"translate(696 344)"}}),_c('path',{attrs:{"d":"M0 0h94.3v6H0z","fill":"#a2a0a0","transform":"translate(696 355)"}})])])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newBlock.style),expression:"newBlock.style"}],staticClass:"custom-control-input",attrs:{"type":"radio","name":"paymentMethod","id":"styleA","value":"A","checked":""},domProps:{"checked":_vm._q(_vm.newBlock.style,"A")},on:{"change":function($event){return _vm.$set(_vm.newBlock, "style", "A")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label font-weight-normal text-nowrap",attrs:{"for":"styleA"}},[_vm._v("Style A")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline flex-wrap mb-2"},[_c('label',{staticClass:"w-100 mb-3 d-flex align-items-center justify-content-center",staticStyle:{"height":"100px"},attrs:{"for":"styleB"}},[_c('svg',{staticClass:"styleNudge",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 142.3 119.9","height":"100","aria-labelledby":"styleb"}},[_c('title',{attrs:{"id":"stylea"}},[_vm._v("Style B")]),_c('path',{attrs:{"id":"_3ed56ded9ef27dcaae8064def0d86512","fill":"#f2f3f4","d":"M5 0h132.3a5 5 0 0 1 5 5v109.9a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5z"}}),_c('path',{attrs:{"id":"Rectangle_1873","d":"M24 46h94.3v6H24z","fill":"#a2a0a0"}}),_c('path',{attrs:{"id":"Rectangle_1874","d":"M24 57h94.3v6H24z","fill":"#a2a0a0"}}),_c('path',{attrs:{"id":"Rectangle_1875","d":"M24 68h94.3v6H24z","fill":"#a2a0a0"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newBlock.style),expression:"newBlock.style"}],staticClass:"custom-control-input",attrs:{"type":"radio","name":"paymentMethod","id":"styleB","value":"B"},domProps:{"checked":_vm._q(_vm.newBlock.style,"B")},on:{"change":function($event){return _vm.$set(_vm.newBlock, "style", "B")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label font-weight-normal text-nowrap",attrs:{"for":"styleB"}},[_vm._v("Style B")])])])]),_vm._v(" "),_c('fieldset',{staticClass:"form-row"},[_c('label',{staticClass:"col-12 mb-3"},[_vm._v("2. Add your content")]),_vm._v(" "),_c('div',{staticClass:"form-group col-12"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newBlock.title),expression:"newBlock.title"}],staticClass:"form-control",attrs:{"type":"text","id":"title","placeholder":"Type the main title here"},domProps:{"value":(_vm.newBlock.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newBlock, "title", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("Please add your title")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-12"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newBlock.text),expression:"newBlock.text"}],staticClass:"form-control",attrs:{"type":"text","id":"text","maxlength":"142"},domProps:{"value":(_vm.newBlock.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newBlock, "text", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("Please add your text")]),_vm._v(" "),_c('small',[_vm._v("(Content is limited to 142 characters)")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-12"},[_c('label',{attrs:{"for":"image"}},[_vm._v("Image")]),_vm._v(" "),_c('div',{staticClass:"custom-file"},[_c('input',{ref:"image",staticClass:"custom-file-input font-weight-normal",attrs:{"type":"file","id":"image","accept":"image/*","required":!_vm.existingBlock},on:{"change":_vm.fileUpload}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label font-weight-normal",attrs:{"for":"image"}},[_vm._v(_vm._s(_vm.newBlock.image ? _vm.fileName : 'Choose file...'))]),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("Please select an image")])]),_vm._v(" "),(_vm.newBlock.image)?_c('div',{staticClass:"border border-light rounded p-3 mt-2"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.newBlock.image}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group col-12"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"input-group"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newBlock.link),expression:"newBlock.link"}],staticClass:"form-control",attrs:{"type":"text","id":"link"},domProps:{"value":(_vm.newBlock.link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newBlock, "link", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end mt-3"},[_c('button',{class:['btn ml-2', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],attrs:{"type":"submit"},on:{"click":_vm.handleSubmit}},[_vm._v("\n        "+_vm._s(!_vm.processing ? 'Confirm' : '')+"\n        "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"title"}},[_vm._v("Title "),_c('small',[_vm._v("(optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"text"}},[_vm._v("Text "),_c('small',[_vm._v("(optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"link"}},[_vm._v("Link Destination "),_c('small',[_vm._v("(optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("https://")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"col-12 col-md-6 col-lg-4 mb-3"},[_c('div',{staticClass:"bg-primary rounded d-flex flex-column position-relative border border-lighter",class:{'blockOverlay' : _vm.block.style === 'B' && (_vm.block.text || _vm.block.title)},staticStyle:{"height":"300px"},style:([_vm.block.style === 'B' ? _vm.getBackgroundImage : false])},[((_vm.loggedInUser === 'Admin' || _vm.loggedInUser === 'SuperAdmin'))?_c('div',{staticClass:"blockButtons d-flex flex-column"},[_c('button',{staticClass:"d-flex justify-content-center align-items-center border border-white mb-2",on:{"click":function($event){$event.preventDefault();_vm.showModalEdit = true}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15"}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M13.1 5.9999996c-.1 0-.3 0-.4-.1l-3.2-3.2c-.1-.1-.1-.2-.1-.4s.1-.3.1-.4l1.3-1.3c.8-.8 2.1-.8 2.8 0l1.1 1.1c.8.8.8 2.1 0 2.8l-1.3 1.3c0 .2-.2.2-.3.2zm-2.5-3.7l2.5 2.5 1-1c.4-.4.4-1 0-1.4l-1.1-1.1c-.4-.4-1-.4-1.4 0l-1 1z"}}),_c('path',{attrs:{"fill":"#231815","d":"M.5 15.3999996c-.1 0-.3-.1-.4-.1-.1-.2-.1-.3-.1-.5l.6-3.8c0-.1.1-.2.1-.3l8.8-8.8c.2-.2.5-.2.7 0l3.2 3.2c.1.1.1.2.1.4s-.1.3-.1.4l-8.8 8.8c-.1.1-.2.1-.3.1l-3.8.6c.1 0 0 0 0 0zm1.1-4.1l-.5 3 3-.5 8.3-8.3-2.5-2.5-8.3 8.3z"}}),_c('path',{attrs:{"fill":"#231815","d":"M5.2 13.8999996c-.1 0-.3 0-.4-.1l-3.2-3.2c-.2-.2-.2-.5 0-.7s.5-.2.7 0l3.2 3.2c.2.2.2.5 0 .7 0 0-.1.1-.3.1z"}})])])])]),_vm._v(" "),_c('button',{staticClass:"d-flex justify-content-center align-items-center border border-white",on:{"click":function($event){$event.preventDefault();_vm.showModalDelete = true}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"11","height":"11"}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M10.5499992 10.9500008c-.1 0-.3 0-.4-.1l-10-10c-.2-.2-.2-.5 0-.7s.5-.2.7 0l10 10c.2.2.2.5 0 .7 0 .1-.2.1-.3.1z"}}),_c('path',{attrs:{"fill":"#231815","d":"M.5499992 10.9500008c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l10-10c.2-.2.5-.2.7 0s.2.5 0 .7l-10 10c0 .1-.2.1-.3.1z"}})])])])])]):_vm._e(),_vm._v(" "),(_vm.block.style === 'A')?_c('div',{staticStyle:{"height":"120px"},style:([_vm.getBackgroundImage])}):_vm._e(),_vm._v(" "),_c('div',{class:['p-3 p-md-4', _vm.block.style === 'B' ? 'text-white my-auto' : 'bg-white flex-grow-1']},[(_vm.block.title)?_c('h2',{staticClass:"h3"},[_vm._v(_vm._s(_vm.block.title))]):_vm._e(),_vm._v(" "),(_vm.block.text)?_c('p',{staticClass:"blockText"},[_vm._v(_vm._s(_vm.block.text))]):_vm._e()]),_vm._v(" "),(_vm.block.link)?_c('a',{staticClass:"blockLink",attrs:{"href":_vm.block.link,"aria-label":"Follow Link","target":"_blank","rel":"nofollow"}}):_vm._e()]),_vm._v(" "),(_vm.showModalEdit)?_c('modal',{on:{"close":function($event){_vm.showModalEdit = false}}},[_c('div',{staticClass:"py-0 px-md-4",attrs:{"slot":"body"},slot:"body"},[_c('dashboard-form',{attrs:{"existingBlock":_vm.block},on:{"submitBlock":function($event){return _vm.editBlock($event)},"removeBlock":function($event){return _vm.removeBlock(_vm.block.id)},"closeModal":function($event){_vm.showModalEdit = false}}})],1)]):_vm._e(),_vm._v(" "),(_vm.showModalDelete)?_c('modal',{on:{"close":function($event){_vm.showModalDelete = false}}},[_c('div',{staticClass:"py-0 px-md-4",attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n        You are about to delete this block permanently. Are you sure?\n      ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.showModalDelete = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{class:['btn ml-2', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],on:{"click":function($event){$event.preventDefault();return _vm.removeBlock(_vm.block.id)}}},[_vm._v("\n          "+_vm._s(!_vm.processing ? 'Confirm' : '')+"\n          "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardNew_vue__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34442302_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardNew_vue__ = __webpack_require__(650);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34442302_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"bg-lighter text-center rounded p-3 d-flex align-items-center justify-content-center",staticStyle:{"height":"300px","cursor":"pointer"},on:{"click":function($event){$event.preventDefault();_vm.showModal = true}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 17","width":"33","height":"33"}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"}}),_c('path',{attrs:{"fill":"#231815","d":"M11 9H6c-.3 0-.5-.2-.5-.5S5.7 8 6 8h5c.3 0 .5.2.5.5s-.2.5-.5.5z"}}),_c('path',{attrs:{"fill":"#231815","d":"M8.5 11.5c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5s.5.2.5.5v5c0 .3-.2.5-.5.5z"}})])])])]),_vm._v(" "),(_vm.showModal)?_c('modal',{on:{"close":function($event){_vm.showModal = false}}},[_c('div',{staticClass:"py-0 px-md-4",attrs:{"slot":"body"},slot:"body"},[_c('dashboard-form',{on:{"submitBlock":function($event){_vm.newBlock = $event;_vm.addBlock()},"closeModal":function($event){_vm.showModal = false}}})],1)]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('h1',{staticClass:"sr-only",attrs:{"slot":"heading"},slot:"heading"},[_vm._v("Dashboard")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('h2',{staticClass:"mb-3"},[_vm._v("Welcome "+_vm._s(_vm.user))]),_vm._v(" "),(_vm.status)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.status))]):_vm._e(),_vm._v(" "),(_vm.stats.length > 0)?_c('div',{staticClass:"px-0"},[_c('h3',{staticClass:"h6 mb-3"},[_vm._v("Your month at a glance:")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled mb-2 mb-md-0 row flex-wrap"},_vm._l((_vm.stats),function(stat,index){return _c('dashboard-stat',{key:index,class:stat.class,attrs:{"stat":stat,"isEven":index % 2}})}),1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"px-0"},[_c('ul',{staticClass:"list-unstyled mb-0 row flex-wrap"},[_vm._l((_vm.blocks),function(block,index){return (_vm.blocks.length > 0)?_c('dashboard-block',{key:index,attrs:{"block":block},on:{"editBlock":_vm.blocksEdited,"blockRemoved":function($event){return _vm.blocksEdited()}}}):_vm._e()}),_vm._v(" "),(_vm.stats.length > 0)?_c('dashboard-new',{on:{"addBlock":_vm.blocksEdited}}):_vm._e()],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUsers_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d064bde_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUsers_vue__ = __webpack_require__(669);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUsers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d064bde_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUsers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 654 */,
/* 655 */,
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filter_vue__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d492041e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Filter_vue__ = __webpack_require__(657);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d492041e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.options.filter),function(filterOption,filterKey){return _c('div',{key:filterKey,class:['d-flex col-12 col-md-auto px-0 mb-3', Object.keys(_vm.options.filter).length > 1 ? 'mb-md-2' : 'mb-md-0']},[_c('label',{staticClass:"sr-only",attrs:{"for":"filter"}},[_vm._v("Filter")]),_vm._v(" "),_c('div',{staticClass:"filter"},_vm._l((filterOption),function(filterOptionOption,childIndex){return (_vm.$store.state.showExpand ? childIndex < 5 : true)?_c('div',{key:childIndex,staticClass:"form-check pl-0"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":'show' + filterKey,"id":'show' + filterOptionOption.name + filterKey},domProps:{"value":filterOptionOption.value,"checked":_vm.activeFilter[filterKey] === filterOptionOption.value},on:{"change":function($event){return _vm.$emit('setFilter', {filterKey: filterKey, filterChosen: filterOptionOption.value })}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":'show' + filterOptionOption.name + filterKey}},[_vm._v(_vm._s(filterOptionOption.name))])]):_vm._e()}),0)])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdvancedFilter_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49acfc25_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdvancedFilter_vue__ = __webpack_require__(662);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdvancedFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49acfc25_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdvancedFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VoerroTagsInput_vue__ = __webpack_require__(231);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0b3e435b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VoerroTagsInput_vue__ = __webpack_require__(661);
function injectStyle (ssrContext) {
  __webpack_require__(660)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VoerroTagsInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0b3e435b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VoerroTagsInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags-input-root flex-grow-1"},[_c('div',{staticClass:"d-flex position-relative"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input),expression:"input"}],ref:"taginput",class:['form-control w-100', {'is-invalid': _vm.tags.length === 0}],attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":(_vm.input)},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.tagFromInput($event)},function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==8){ return null; }return _vm.removeLastTag($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.nextSearchResult($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.prevSearchResult($event)},_vm.onKeyDown],"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.ignoreSearchResults($event)},_vm.searchTag],"focus":_vm.onFocus,"blur":_vm.hideTypeahead,"value":_vm.tags,"input":function($event){if($event.target.composing){ return; }_vm.input=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchResults.length),expression:"searchResults.length"}]},[(_vm.typeaheadStyle === 'badges')?_c('p',{class:("typeahead-" + _vm.typeaheadStyle)},_vm._l((_vm.searchResults),function(tag,index){return _c('span',{key:index,staticClass:"tags-input-badge",class:{
                        'tags-input-typeahead-item-default': index != _vm.searchSelection,
                        'tags-input-typeahead-item-highlighted-default': index == _vm.searchSelection
                    },domProps:{"textContent":_vm._s(tag.text)},on:{"mouseover":function($event){_vm.searchSelection = index},"mousedown":function($event){$event.preventDefault();return _vm.tagFromSearchOnClick(tag)}}})}),0):(_vm.typeaheadStyle === 'dropdown')?_c('ul',{class:("typeahead-" + _vm.typeaheadStyle)},_vm._l((_vm.searchResults),function(tag,index){return _c('li',{key:index,class:{
                    'tags-input-typeahead-item-default': index != _vm.searchSelection,
                    'tags-input-typeahead-item-highlighted-default': index == _vm.searchSelection
                },domProps:{"textContent":_vm._s(tag.text)},on:{"mouseover":function($event){_vm.searchSelection = index},"mousedown":function($event){$event.preventDefault();return _vm.tagFromSearchOnClick(tag)}}})}),0):_vm._e()])]),_vm._v(" "),(_vm.instruction)?_c('small',[_vm._v(_vm._s(_vm.instruction))]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.wrapperClass + ' tags-input'},[_vm._l((_vm.tagBadges),function(badge,index){return _c('span',{key:index,staticClass:"badge badge-primary badge-pill tags-input-badge-selected-default",on:{"click":function($event){$event.preventDefault();return _vm.removeTag(index)}}},[_c('i',{staticClass:"tags-input-remove",attrs:{"href":"#"}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(badge)}})])}),_vm._v(" "),(_vm.elementId)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hiddenInput),expression:"hiddenInput"}],attrs:{"type":"hidden","name":_vm.elementId,"id":_vm.elementId},domProps:{"value":(_vm.hiddenInput)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hiddenInput=$event.target.value}}}):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px-0 mt-2"},[_c('form',{staticClass:"needs-validation d-flex mb-3 pt-3 p-1 p-sm-3 bg-lighter border-top",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.sendFilter($event)}}},[_c('label',{staticClass:"sr-only",attrs:{"for":"filter"}},[_vm._v("Advanced Filters")]),_vm._v(" "),_c('div',{staticClass:"align-items-start d-flex flex-wrap w-100"},[_c('div',{staticClass:"px-md-3 pr-lg-0 mb-sm-3 mb-xl-2 col-12 col-md-6 col-lg-4 col-xl-3"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedFilter.from_date),expression:"selectedFilter.from_date"}],class:['form-control form-date w-100', _vm.errorStatus === 'validation_error' ? 'is-invalid' : ''],attrs:{"max":_vm.selectedFilter.to_date,"id":"startDate","type":"date","placeholder":[_vm.isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy'],"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}"},domProps:{"value":(_vm.selectedFilter.from_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedFilter, "from_date", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[(_vm.selectedFilter.from_date > _vm.selectedFilter.to_date)?_c('span',[_vm._v("Ensure the \"from\" date is before the \"to\" date.")]):_c('span',[_vm._v("Please include the Date"+_vm._s(_vm.isLegacy() ? ' in the format yyyy-mm-dd' : '')+".")])])])]),_vm._v(" "),_c('div',{staticClass:"mb-sm-4 mb-xl-2 px-md-3 col-12 col-md-6 col-lg-4 col-xl-3"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedFilter.to_date),expression:"selectedFilter.to_date"}],class:['form-control form-date w-100', _vm.errorStatus === 'validation_error' ? 'is-invalid' : ''],attrs:{"min":_vm.selectedFilter.from_date,"id":"endDate","type":"date","placeholder":[_vm.isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy'],"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}"},domProps:{"value":(_vm.selectedFilter.to_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedFilter, "to_date", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[(_vm.selectedFilter.from_date > _vm.selectedFilter.to_date)?_c('span',[_vm._v("Ensure the \"from\" date is before the \"to\" date.")]):_c('span',[_vm._v("Please include the Date"+_vm._s(_vm.isLegacy() ? ' in the format yyyy-mm-dd' : '')+".")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-lg-auto px-lg-0"},[_c('label',{staticClass:"w-100 d-none d-lg-block",attrs:{"aria-hidden":"true"}},[_vm._v(" ")]),_vm._v(" "),_c('button',{class:['btn btn-block-mob mt-auto mx-lg-0 mb-3 mb-lg-4 mb-xl-2', _vm.processing ? 'btn-primary-dark' : 'btn-outline-primary'],attrs:{"type":"submit"},on:{"click":_vm.handleSubmit}},[_vm._v("\n          "+_vm._s(!_vm.processing ? 'Filter' : '')+"\n          "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"startDate"}},[_vm._v("Date "),_c('small',[_vm._v("(from)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"endDate"}},[_vm._v("Date "),_c('small',[_vm._v("(to)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(232);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea95b7e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(664);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea95b7e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"d-none d-lg-inline mr-xl-2 mb-0 pr-2 font-weight-normal",attrs:{"for":"search"}},[_vm._v("Search")]),_vm._v(" "),_c('div',{class:['input-append d-flex flex-grow-1 flex-md-grow-0', _vm.options.addAdmin || _vm.options.addSecretary || _vm.options.addHorse || _vm.options.addDraft || _vm.options.addEvent || _vm.options.addCommittee ? 'mr-md-2 mr-sm-2' : '']},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control mb-0 flex-grow-1 flex-md-grow-0",attrs:{"type":"text","id":"search","placeholder":_vm.$store.state.showExpand ? 'Search' : ''},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_c('svg',{staticClass:"append",attrs:{"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14","width":"16","height":"16"}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M5.5 11C2.5 11 0 8.5 0 5.5S2.5 0 5.5 0 11 2.5 11 5.5 8.5 11 5.5 11zm0-10C3 1 1 3 1 5.5S3 10 5.5 10 10 8 10 5.5 8 1 5.5 1z"}}),_c('path',{attrs:{"fill":"#231815","d":"M9.5 8.8l4.4 4.4c.2.2.2.5 0 .7l-.4.1-.4-.1-4.4-4.4.8-.7z"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ed35f34_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShowEntries_vue__ = __webpack_require__(666);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ed35f34_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShowEntries_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-none d-md-flex form-group mb-2 mb-md-0 col-12 col-md-auto px-0"},[_c('label',{staticClass:"mr-2 font-weight-normal",attrs:{"for":"show"}},[_vm._v("Show")]),_vm._v(" "),_c('select',{staticClass:"form-control mr-2",attrs:{"id":"show"},on:{"change":function($event){return _vm.$emit('perPage', $event.target.value)}}},[_c('option',{attrs:{"selected":""}},[_vm._v("20")]),_vm._v(" "),_c('option',[_vm._v("50")]),_vm._v(" "),_c('option',[_vm._v("100")]),_vm._v(" "),_c('option',[_vm._v("200")])]),_vm._v(" "),_c('span',[_vm._v("Entries")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"col-12 px-0 d-flex flex-column position-relative z-1",attrs:{"id":"table"}},[_c('div',{staticClass:"form-inline mb-sm-3 d-flex justify-content-between"},[(_vm.options.advancedFilter)?_c('advancedFilter',{attrs:{"loaded":_vm.options.loaded}}):_vm._e(),_vm._v(" "),(_vm.options.filter)?_c('rowsFilter',{attrs:{"options":_vm.options,"activeFilter":_vm.activeFilter},on:{"setFilter":function($event){return _vm.setActiveFilter($event)}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-lg-auto mt-2 mt-lg-0 mt-xl-0 ml-auto px-0 action_section"},[(_vm.options.search)?_c('search',{attrs:{"options":_vm.options,"search":_vm.search},on:{"search":function($event){_vm.search = $event}}}):_vm._e(),_vm._v(" "),(_vm.options.addAdmin)?_c('router-link',{staticClass:"btn d-none d-md-block btn-primary mt-2 mt-sm-0",attrs:{"tag":"button","to":{ name: 'Add Admin Members' }}},[_vm._v("Add Admin")]):_vm._e(),_vm._v(" "),(_vm.options.addSecretary)?_c('router-link',{staticClass:"btn d-none d-md-block btn-primary mt-2 mt-sm-0",attrs:{"tag":"button","to":{ name: 'Add Secretary Members' }}},[_vm._v("Add\n          Secretary")]):_vm._e(),_vm._v(" "),(_vm.options.addHorse && !_vm.options.hideHorses)?_c('router-link',{staticClass:"btn btn-fz-sm btn-primary d-block px-xl-5 mt-2 mt-sm-0 ml-md-0",attrs:{"tag":"button","to":{ name: (_vm.userRole === 'Admin' || _vm.userRole === 'SuperAdmin') ? 'Add Horses' : (_vm.userRole === 'Member' || _vm.userRole === 'Volunteer') ? 'Add Horse' : 'Secretary Add Horses' }}},[_vm._v("Add"),_c('span',{staticClass:"d-inline"},[_vm._v(" Horse")])]):_vm._e(),_vm._v(" "),(_vm.options.addDraft)?_c('router-link',{staticClass:"btn d-none d-md-block btn-primary px-lg-3 px-xl-5 mt-2 mt-sm-0",attrs:{"tag":"button","to":{ name: 'Create Draft' }}},[_vm._v("Create"),_c('span',{staticClass:"d-none d-xl-inline"},[_vm._v(" Draft")])]):_vm._e(),_vm._v(" "),(_vm.options.addCommittee)?_c('router-link',{staticClass:"btn d-none d-md-block btn-primary px-xl-5 mt-2 mt-sm-0",attrs:{"tag":"button","to":{ name: 'Committee Profile' }}},[_vm._v("Add"),_c('span',{staticClass:"d-none d-xl-inline"},[_vm._v(" Committee")])]):_vm._e()],1)],1),_vm._v(" "),_c('datatable',{class:['position-relative z-0 table-headers-sticky', _vm.dataRows.length === 0 ? 'mb-0' : ''],attrs:{"columns":_vm.visibleColumns,"data":_vm.filtering ? _vm.filteredRows : _vm.dataRows,"filter-by":_vm.search},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [(_vm.$store.state.showExpand && !_vm.options.disableExpand)?_c('tr',[_c('td',{attrs:{"colspan":"100%"}},[_c('div',{class:['d-flex justify-content-between align-items-center position-relative', _vm.options.flexWrap ? 'flex-wrap' : '']},[_vm._t("expandedSelect",null,{"row":row}),_vm._v(" "),_vm._t("expandedHeader",null,{"row":row}),_vm._v(" "),_vm._t("expandedCustom",null,{"row":row}),_vm._v(" "),_c('button',{staticClass:"btn btn-xs btn-link position-relative z-1",attrs:{"slot":"expandToggle"},on:{"click":function($event){return _vm.expand(row.id)}},slot:"expandToggle"},[(_vm.expanded == row.id)?_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13 6","width":"13","height":"6"}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_vm._v(" "),_c('g',{staticClass:"currentLayer"},[_c('path',{attrs:{"fill":"#231815","d":"M12.6 6h-.4L7.6 1.4C7 .8 6 .8 5.5 1.4L.9 6c-.2.2-.5.2-.7 0s-.2-.5 0-.7L4.8.7c.9-1 2.6-1 3.5 0l4.6 4.6c.2.2.2.5 0 .7h-.3z"}})])]):_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13 6","width":"13","height":"6"}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_vm._v(" "),_c('g',{staticClass:"currentLayer"},[_c('path',{attrs:{"fill":"#231815","d":"M6.5 6.2c-.7 0-1.3-.3-1.8-.7L.1.9C0 .7 0 .4.1.2s.5-.2.7 0l4.6 4.6c.6.6 1.5.6 2.1 0L12.1.2c.2-.2.5-.2.7 0s.2.5 0 .7L8.2 5.5c-.4.4-1 .7-1.7.7z"}})])])])],2),_vm._v(" "),(_vm.expanded === row.id)?_vm._t("expandedRow",null,{"row":row}):_vm._e()],2)]):_c('tr',[_vm._l((_vm.visibleColumns),function(column,j){return [(!column.hidden)?_c('datatable-cell',{key:j,attrs:{"column":column,"row":row}}):_vm._e()]})],2)]}},{key:"footer",fn:function(ref){
var rows = ref.rows;
return [_c('tr',[_c('td',{staticClass:"p-0 border-0",attrs:{"colspan":"100%"}},[(_vm.dataRows.length === 0 && _vm.options.loaded !== true)?_c('div',{staticClass:"text-center py-2"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])]):_vm._e(),_vm._v(" "),((_vm.dataRows.length > 0 || _vm.options.loaded) && rows ? rows.length === 0 : false)?_c('div',{staticClass:"alert alert-warning rounded-0 mb-0"},[_vm._v("There are no results.\n            ")]):_vm._e()])])]}}],null,true)})],1),_vm._v(" "),_c('div',{staticClass:"form-inline justify-content-between align-items-start"},[(_vm.dataRows.length > 20)?_c('show-entries',{on:{"perPage":function($event){_vm.per_page = Number($event)}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-block d-md-none text-center mb-2 flex-grow-1"},[_vm._v("\n      Showing "+_vm._s(_vm.per_page > (_vm.rowsLength === 0 ? _vm.dataRows.length : _vm.rowsLength) ? (_vm.rowsLength === 0 ? _vm.dataRows.length :
        _vm.rowsLength) : _vm.per_page)+" rows of "+_vm._s(_vm.rowsLength === 0 ? _vm.dataRows.length : _vm.rowsLength)+"\n    ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dataRows.length > _vm.per_page),expression:"dataRows.length > per_page"}],staticClass:"pagination-container form-group align-items-start justify-content-center"},[_c('datatable-pager',{attrs:{"type":"abbreviated","per-page":_vm.per_page},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.inline ? 'd-inline' : 'd-flex', 'justify-content-between', _vm.expandMobile ? 'flex-grow-1 pl-2' : '']},[(_vm.showLinks)?_c('router-link',{class:['btn btn-link text-wrap text-left p-0', _vm.buttonBreak ? 'text-break' : '', _vm.expandMobile ? 'btn-expand-sm' : ''],attrs:{"tag":"button","to":{ name: this.link, params: { details: this.row, draftId: _vm.resolvedDraftId, eventId: _vm.resolvedEventId, edit: _vm.edit, slug: _vm.slug, tab: _vm.tab, score: _vm.score, secretary: _vm.secretary, id: _vm.id } }}},[_vm._v(_vm._s(_vm.text))]):(_vm.isMobile)?_c('a',{attrs:{"href":'tel:' + _vm.mobile}},[_vm._v(_vm._s(_vm.text))]):(_vm.hasSeasons)?_c('span',_vm._l((_vm.row.seasons),function(value,key,index){return _c('span',{key:key},[_c('span',{class:['badge ml-1 my-auto', {'alert-danger': value === 0, 'alert-success': value === 1}]},[_vm._v(_vm._s(key))])])}),0):_c('span',{class:[_vm.textBreak ? 'text-break' : '']},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),(_vm.showActive && _vm.row.membership_status !== 'Active')?_c('span',{class:['badge ml-1 my-auto', _vm.row.membership_status === 'Lifetime' ? 'alert-info' : _vm.row.membership_status === 'Archived' ? 'alert-dark' : 'alert-danger']},[_vm._v(_vm._s(_vm.row.membership_status === 'Onhold' ? 'On Hold' : _vm.row.membership_status))]):(_vm.showActive)?_c('span',{class:['badge ml-1 my-auto', !!_vm.isFinancial ? 'alert-info' : 'alert-warning']},[_vm._v(_vm._s(!!_vm.isFinancial ? 'Financial' : 'Unfinancial'))]):(_vm.showActiveToken)?_c('span',{class:['badge ml-1 my-auto', !!_vm.row.is_active ? 'alert-success' : 'alert-danger']},[_vm._v(_vm._s(!!_vm.row.is_active ? 'Active' : 'Unactive'))]):_vm._e(),_vm._v(" "),(_vm.showFinancial)?_c('span',{class:['badge ml-1 my-auto', !!_vm.row.is_financial ? 'alert-info' : 'alert-warning']},[_vm._v(_vm._s(!!_vm.row.is_financial ? 'Financial' : 'Unfinancial'))]):_vm._e(),_vm._v(" "),(_vm.showHorseActive)?_c('span',{class:['badge ml-auto my-auto', _vm.row.active ? 'alert-success' : 'alert-warning']},[_vm._v(_vm._s(_vm.row.active ? 'Active' : 'Archived'))]):_vm._e(),_vm._v(" "),(_vm.showSecretaryOnly)?_c('span',{class:['badge ml-auto my-auto', _vm.row.role === 'SecretaryOnly' ? 'alert-info' : 'alert-warning']},[_vm._v(_vm._s(_vm.row.role === 'SecretaryOnly' ? 'Secretary Only' : 'Member Secretary'))]):_vm._e(),_vm._v(" "),(_vm.showRegistered)?_c('span',{class:['badge ml-1 my-auto', _vm.row.registration_date ? 'alert-info' : 'alert-warning']},[_vm._v(_vm._s(_vm.row.registration_date ? 'Registered' : 'Unregistered'))]):_vm._e(),_vm._v(" "),(_vm.showFinal && _vm.row.is_final)?_c('span',{class:['badge ml-1 my-auto alert-warning']},[_vm._v("Final")]):_vm._e(),_vm._v(" "),(_vm.showPaid)?_c('span',{class:['badge ml-1 my-auto', _vm.row.status === 'paid' ? 'alert-info' : 'alert-warning']},[_vm._v(_vm._s(_vm.row.status === 'paid' ? 'Paid' : 'Pending'))]):_vm._e(),_vm._v(" "),(_vm.showStatus && _vm.row.draft_status_id && _vm.$store.state.listDraftStatus.length > 0)?_c('span',{class:['badge ml-1 my-auto', _vm.$store.getters.getDraftStatus(_vm.row.draft_status_id) === 'Published' ? 'alert-success' : _vm.$store.getters.getDraftStatus(_vm.row.draft_status_id) === 'Pending' ? 'alert-info' : _vm.$store.getters.getDraftStatus(_vm.row.draft_status_id) === 'Postponed' ? 'alert-warning' : 'alert-danger']},[(_vm.row.points_status === 'finalised' && _vm.$store.getters.getDraftStatus(_vm.row.draft_status_id) === 'Published')?_c('svg',{staticClass:"ml-auto mr-1 text-success",attrs:{"title":"Finalised","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","width":"12"}},[_c('path',{attrs:{"fill":"currentColor","d":"M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"}})]):_vm._e(),_vm._v("\n    "+_vm._s(_vm.$store.getters.getDraftStatus(_vm.row.draft_status_id))+"\n  ")]):(_vm.showStatus)?_c('span',{class:['badge ml-1 my-auto', _vm.row.status === 'Finalised' ? 'alert-success' : _vm.row.status === 'Pending' ? 'alert-info' : 'alert-warning']},[_vm._v(_vm._s(_vm.row.status))]):(_vm.showJudgeStatus)?_c('span',{class:['badge ml-1 my-auto', _vm.row.status === 'denied' ? 'alert-danger' : (_vm.row.status === 'approved' ? 'alert-success' : 'alert-warning')]},[_vm._v(_vm._s(_vm.row.status[0].toUpperCase() + _vm.row.status.slice(1)))]):_vm._e(),_vm._v(" "),(!_vm.row.parent_id && _vm.showPrimary)?_c('span',{staticClass:"badge alert-prim my-auto ml-2"},[_vm._v("Primary")]):_vm._e(),_vm._v(" "),(_vm.showDeleted && _vm.row.deleted_at)?_c('span',{staticClass:"badge alert-danger my-auto ml-2"},[_vm._v("Deleted")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"h2 mb-0"},[_vm._v("Admin Users")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary d-md-none px-xl-5 mt-2 mt-sm-0",attrs:{"tag":"button","to":{ name: 'Add Admin Members' }}},[_vm._v("Add"),_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v("\n        Admin")])])],1),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.error)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),(_vm.success)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.success))]):_vm._e(),_vm._v(" "),_c('data-table',{attrs:{"dataRows":_vm.rows,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{attrs:{"text":row.first_name + ' ' + row.last_name,"link":'Admin Profile',"row":row,"options":{ showLinks: true, expandMobile: true }}})}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',[_c('strong',[_vm._v("Phone: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.attributes ? row.attributes.phone : null,"row":row,"options":{ inline: true }}})],1)])])}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecretaryUsers_vue__ = __webpack_require__(234);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d461d03_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecretaryUsers_vue__ = __webpack_require__(680);
function injectStyle (ssrContext) {
  __webpack_require__(671)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d461d03"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecretaryUsers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d461d03_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecretaryUsers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 671 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 672 */,
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",staticClass:"rtable",class:_vm.rootClasses,style:(_vm.cssVars)},[(_vm.loading)?_c('div',{staticClass:"table-overlay"},[_c('div',{staticClass:"table-spinner"})]):_vm._e(),_vm._v(" "),(!_vm.effectiveHideHeader && _vm.headerLines.length)?_c('div',{staticClass:"rtable__head"},_vm._l((_vm.headerLines),function(line,li){return _c('div',{key:("h-" + li),staticClass:"rtable__line rtable__line--head",style:(_vm.lineStyle(line))},_vm._l((line),function(cell,ci){return _c('div',{key:ci,staticClass:"rtable__cell rtable__cell--head",class:[_vm.cellClasses(cell), { 'rtable__cell--sort': _vm.isSortable(cell), 'rtable__cell--empty': !cell.keys.length }],on:{"click":function($event){_vm.isSortable(cell) && _vm.$emit('sort', cell.keys[0])}}},[_vm._v("\n        "+_vm._s(_vm.headerLabel(cell))+"\n        "),(_vm.isSortable(cell))?_c('span',{staticClass:"sort-arrows"},[_c('span',{class:['sort-arrow sort-arrow--up', { active: _vm.sort === cell.keys[0] && _vm.direction === 'asc' }]}),_vm._v(" "),_c('span',{class:['sort-arrow sort-arrow--down', { active: _vm.sort === cell.keys[0] && _vm.direction === 'desc' }]})]):_vm._e()])}),0)}),0):_vm._e(),_vm._v(" "),(_vm.effectiveHideHeader && _vm.sortableColumns.length)?_c('div',{staticClass:"rtable__mobile-sort"},_vm._l((_vm.sortableColumns),function(col){return _c('button',{key:col.key,staticClass:"rtable__mobile-sort-btn",class:{ 'rtable__mobile-sort-btn--active': _vm.sort === col.key },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('sort', col.key)}}},[_vm._v("\n      "+_vm._s(col.label)+"\n      "),_c('span',{staticClass:"sort-arrows"},[_c('span',{class:['sort-arrow sort-arrow--up', { active: _vm.sort === col.key && _vm.direction === 'asc' }]}),_vm._v(" "),_c('span',{class:['sort-arrow sort-arrow--down', { active: _vm.sort === col.key && _vm.direction === 'desc' }]})])])}),0):_vm._e(),_vm._v(" "),(!_vm.loading && !_vm.displayRows.length)?_c('div',{staticClass:"rtable__empty"},[_vm._v("\n    "+_vm._s(_vm.emptyText || 'No results found.')+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.draggable)?_c('draggable',{staticClass:"rtable__draggable-body",attrs:{"tag":"div","list":_vm.displayRows,"handle":".rtable__drag-handle"},on:{"start":function($event){_vm.$emit('drag-start', _vm.displayRows.map(function (r) { return r.id; }))},"end":function($event){_vm.$emit('drag-end', _vm.displayRows.map(function (r) { return r.id; }))}}},_vm._l((_vm.displayRows),function(row,index){return _c('div',{key:String(row.id),staticClass:"rtable__record",class:_vm.rowClasses(row, index)},[(_vm.accordionSummary)?_c('div',{staticClass:"rtable__line rtable__line--summary",style:(_vm.summaryLineStyle(_vm.accordionSummary)),on:{"click":function($event){return _vm.toggleRow(row.id)}}},[_vm._l((_vm.accordionSummary),function(cell,ci){return _c('div',{key:ci,staticClass:"rtable__cell",class:[_vm.cellClasses(cell), { 'rtable__cell--merged': cell.merged, 'rtable__cell--empty': !cell.keys.length }]},[(cell.merged)?_vm._l((cell.keys),function(k){return _c('div',{key:k,staticClass:"rtable__sub"},[(!cell.hideLabel)?_c('strong',{staticClass:"rtable__sub-label"},[_vm._v(_vm._s(_vm.labelFor(k))+": ")]):_vm._e(),_vm._v(" "),_vm._t(("cell:" + k),[_vm._v(_vm._s(row[k]))],{"row":row})],2)}):(cell.keys.length)?[(_vm.showCellLabel(cell))?_c('strong',{staticClass:"rtable__cell-label"},[_vm._v(_vm._s(_vm.labelFor(cell.keys[0]))+": ")]):_vm._e(),_vm._v(" "),_vm._t(("cell:" + (cell.keys[0])),[_vm._v(_vm._s(row[cell.keys[0]]))],{"row":row})]:_vm._e()],2)}),_vm._v(" "),_c('span',{staticClass:"rtable__accordion-toggle",class:{ 'rtable__accordion-toggle--open': _vm.resolvedOpenId === row.id }})],2):_vm._e(),_vm._v(" "),(_vm.accordionSummary)?[(_vm.resolvedOpenId === row.id)?_c('div',{staticClass:"rtable__accordion-detail"},_vm._l((_vm.accordionDetailCells),function(cell,ci){return _c('div',{key:ci,staticClass:"rtable__accordion-field"},[(cell.merged)?_vm._l((cell.keys),function(k){return _c('div',{key:k},[_c('strong',{staticClass:"rtable__cell-label"},[_vm._v(_vm._s(_vm.labelFor(k))+": ")]),_vm._v(" "),_vm._t(("cell:" + k),[_vm._v(_vm._s(row[k]))],{"row":row})],2)}):(cell.keys.length)?[_c('strong',{staticClass:"rtable__cell-label"},[_vm._v(_vm._s(_vm.labelFor(cell.keys[0]))+": ")]),_vm._v(" "),_vm._t(("cell:" + (cell.keys[0])),[_vm._v(_vm._s(row[cell.keys[0]]))],{"row":row})]:_vm._e()],2)}),0):_vm._e()]:_vm._l((_vm.bodyLines),function(line,li){return _c('div',{key:li,staticClass:"rtable__line rtable__line--data",style:(_vm.lineStyle(line))},_vm._l((line),function(cell,ci){return _c('div',{key:ci,staticClass:"rtable__cell",class:[_vm.cellClasses(cell), { 'rtable__cell--merged': cell.merged, 'rtable__cell--empty': !cell.keys.length }]},[(cell.merged)?_vm._l((cell.keys),function(k){return _c('div',{key:k,staticClass:"rtable__sub"},[(!cell.hideLabel)?_c('strong',{staticClass:"rtable__sub-label"},[_vm._v(_vm._s(_vm.labelFor(k))+": ")]):_vm._e(),_vm._v(" "),_vm._t(("cell:" + k),[_vm._v(_vm._s(row[k]))],{"row":row})],2)}):(cell.keys.length)?[(_vm.showCellLabel(cell))?_c('strong',{staticClass:"rtable__cell-label"},[_vm._v(_vm._s(_vm.labelFor(cell.keys[0]))+": ")]):_vm._e(),_vm._v(" "),_vm._t(("cell:" + (cell.keys[0])),[_vm._v(_vm._s(row[cell.keys[0]]))],{"row":row})]:_vm._e()],2)}),0)})],2)}),0):_vm._l((_vm.displayRows),function(row,index){return [_c('div',{key:String(row.id),staticClass:"rtable__record",class:_vm.rowClasses(row, index)},[(_vm.accordionSummary)?_c('div',{staticClass:"rtable__line rtable__line--summary",style:(_vm.summaryLineStyle(_vm.accordionSummary)),on:{"click":function($event){return _vm.toggleRow(row.id)}}},[_vm._l((_vm.accordionSummary),function(cell,ci){return _c('div',{key:ci,staticClass:"rtable__cell",class:[_vm.cellClasses(cell), { 'rtable__cell--merged': cell.merged, 'rtable__cell--empty': !cell.keys.length }]},[(cell.merged)?_vm._l((cell.keys),function(k){return _c('div',{key:k,staticClass:"rtable__sub"},[(!cell.hideLabel)?_c('strong',{staticClass:"rtable__sub-label"},[_vm._v(_vm._s(_vm.labelFor(k))+": ")]):_vm._e(),_vm._v(" "),_vm._t(("cell:" + k),[_vm._v(_vm._s(row[k]))],{"row":row})],2)}):(cell.keys.length)?[(_vm.showCellLabel(cell))?_c('strong',{staticClass:"rtable__cell-label"},[_vm._v(_vm._s(_vm.labelFor(cell.keys[0]))+": ")]):_vm._e(),_vm._v(" "),_vm._t(("cell:" + (cell.keys[0])),[_vm._v(_vm._s(row[cell.keys[0]]))],{"row":row})]:_vm._e()],2)}),_vm._v(" "),_c('span',{staticClass:"rtable__accordion-toggle",class:{ 'rtable__accordion-toggle--open': _vm.resolvedOpenId === row.id }})],2):_vm._e(),_vm._v(" "),(_vm.accordionSummary)?[(_vm.resolvedOpenId === row.id)?_c('div',{staticClass:"rtable__accordion-detail"},_vm._l((_vm.accordionDetailCells),function(cell,ci){return _c('div',{key:ci,staticClass:"rtable__accordion-field"},[(cell.merged)?_vm._l((cell.keys),function(k){return _c('div',{key:k},[_c('strong',{staticClass:"rtable__cell-label"},[_vm._v(_vm._s(_vm.labelFor(k))+": ")]),_vm._v(" "),_vm._t(("cell:" + k),[_vm._v(_vm._s(row[k]))],{"row":row})],2)}):(cell.keys.length)?[_c('strong',{staticClass:"rtable__cell-label"},[_vm._v(_vm._s(_vm.labelFor(cell.keys[0]))+": ")]),_vm._v(" "),_vm._t(("cell:" + (cell.keys[0])),[_vm._v(_vm._s(row[cell.keys[0]]))],{"row":row})]:_vm._e()],2)}),0):_vm._e()]:_vm._l((_vm.bodyLines),function(line,li){return _c('div',{key:li,staticClass:"rtable__line rtable__line--data",style:(_vm.lineStyle(line))},_vm._l((line),function(cell,ci){return _c('div',{key:ci,staticClass:"rtable__cell",class:[_vm.cellClasses(cell), { 'rtable__cell--merged': cell.merged, 'rtable__cell--empty': !cell.keys.length }]},[(cell.merged)?_vm._l((cell.keys),function(k){return _c('div',{key:k,staticClass:"rtable__sub"},[(!cell.hideLabel)?_c('strong',{staticClass:"rtable__sub-label"},[_vm._v(_vm._s(_vm.labelFor(k))+": ")]):_vm._e(),_vm._v(" "),_vm._t(("cell:" + k),[_vm._v(_vm._s(row[k]))],{"row":row})],2)}):(cell.keys.length)?[(_vm.showCellLabel(cell))?_c('strong',{staticClass:"rtable__cell-label"},[_vm._v(_vm._s(_vm.labelFor(cell.keys[0]))+": ")]):_vm._e(),_vm._v(" "),_vm._t(("cell:" + (cell.keys[0])),[_vm._v(_vm._s(row[cell.keys[0]]))],{"row":row,"toggle":function () { return _vm.toggleRow(row.id); },"isOpen":_vm.resolvedOpenId === row.id})]:_vm._e()],2)}),0)})],2),_vm._v(" "),(_vm.hasExpand && _vm.resolvedOpenId === row.id)?_c('div',{key:("x-" + (row.id)),staticClass:"rtable__expand"},[_vm._t("expand",null,{"row":row,"odd":index % 2 === 0})],2):_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination-container form-group align-items-start justify-content-center",class:{ 'pagination-container--disabled': _vm.disabled },style:({ '--apperances-color': _vm.color || 'var(--primary)' })},[_c('nav',{staticClass:"d-flex align-items-center mb-2"},[_c('ul',{staticClass:"pagination mb-0"},[_c('li',{class:['page-item', { disabled: _vm.disabled || _vm.currentPage === 1 }]},[_c('a',{staticClass:"page-link px-3 px-md-4",on:{"click":function($event){return _vm.goToPage(_vm.currentPage - 1)}}},[_vm._v("Prev")])]),_vm._v(" "),_vm._l((_vm.visiblePages),function(p){return _c('li',{key:p.key,class:['page-item', { active: p.number === _vm.currentPage, disabled: _vm.disabled || p.disabled }]},[_c('a',{staticClass:"page-link",on:{"click":function($event){!_vm.disabled && !p.disabled && _vm.goToPage(p.number)}}},[_vm._v("\n          "+_vm._s(p.display)+"\n        ")])])}),_vm._v(" "),_c('li',{class:['page-item', { disabled: _vm.disabled || _vm.currentPage === _vm.totalPages }]},[_c('a',{staticClass:"page-link px-3 px-md-4",on:{"click":function($event){return _vm.goToPage(_vm.currentPage + 1)}}},[_vm._v("Next")])])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-name-cell",class:("list-name-cell--" + _vm.align)},[(_vm.to)?_c('router-link',{staticClass:"btn btn-link text-wrap text-left p-0",attrs:{"to":_vm.to}},[_vm._v(_vm._s(_vm.label))]):_c('span',{staticClass:"text-wrap"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),(_vm.$scopedSlots.badges || _vm.$slots.badges)?_c('span',{staticClass:"list-name-cell__badges"},[_vm._t("badges")],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useSecretariesList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_secretaryListType__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_secretaries__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__composables_useServerList__ = __webpack_require__(58);


 // Admin /secretary-users list page (CAM-1477 follow-up). Search matches first/last name +
// committee name (server-side), same as the legacy DataTable search + Drafts' committee
// "find secretaries" deep link (?search=<committee name>).

function useSecretariesList() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__composables_useServerList__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__services_api_secretaries__["a" /* default */].getList, {
    defaultSort: 'last_name',
    defaultDirection: 'asc',
    defaultPerPage: 20,
    extraFilters: {
      committee_id: [],
      type: __WEBPACK_IMPORTED_MODULE_0__constants_secretaryListType__["a" /* SECRETARY_LIST_TYPE_ALL */]
    }
  });
}

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = buildColumns;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildBreakpoints;
// Column keys double as the backend sort keys (SecretaryFilters::SORTABLE) so ResponsiveTable's
// sort arrows light up against `filters.sort` with no translation layer. Phone is not sortable —
// matches the legacy DataTable definition (no `sortable`/`representedAs` on that column).
function buildColumns() {
  return [{
    key: 'first_name',
    label: 'First Name',
    sortable: true,
    minWidth: '110px',
    width: '1fr'
  }, {
    key: 'last_name',
    label: 'Last Name',
    sortable: true,
    minWidth: '150px',
    width: '1.6fr'
  }, {
    key: 'committee_name',
    label: 'Committee Name',
    sortable: true,
    minWidth: '150px',
    width: '2fr'
  }, {
    key: 'phone',
    label: 'Phone',
    minWidth: '110px',
    width: '1fr'
  }, // Fixed px, not minWidth+fr (see Horses' `remove` column for why a shared px value —
  // not max-content — is what keeps header/row column edges aligned): sized to the wider of
  // the "Action" header label and the shrunk .secretary-login-btn button.
  {
    key: 'login',
    label: 'Action',
    width: '80px',
    cellClass: 'text-center'
  }];
} // Below 700px the row collapses into an accordion: a combined First+Last name summary (the
// legacy expandedHeader showed both names together) plus the same detail fields the legacy
// expandedRow showed (Phone, Login).

function buildBreakpoints() {
  return [{
    maxWidth: 700,
    hideHeader: true,
    accordion: {
      summary: [{
        keys: ['name'],
        hideLabel: true
      }]
    },
    rows: [['committee_name'], ['phone'], ['login']]
  }];
}

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"h2 mb-0"},[_vm._v("Secretary Users")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary d-md-none px-xl-5 mt-2 mt-sm-0",attrs:{"to":{ name: 'Add Secretary Members' }}},[_vm._v("Add"),_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v(" Secretary")])])],1),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.errorMessage)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e(),_vm._v(" "),(_vm.successMessage)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.successMessage))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-inline mb-sm-3 d-flex justify-content-between"},[_c('div',{staticClass:"d-flex col-12 col-lg-auto px-0 mb-3 mb-lg-0"},[_c('label',{staticClass:"sr-only",attrs:{"for":"secretaryType-all"}},[_vm._v("Type")]),_vm._v(" "),_c('div',{staticClass:"filter flex-wrap"},_vm._l((_vm.SECRETARY_LIST_TYPE_TABS),function(tab){return _c('div',{key:tab.value,staticClass:"form-check pl-0"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":"secretaryType","id":'secretaryType-' + tab.value},domProps:{"value":tab.value,"checked":_vm.filters.type === tab.value},on:{"change":function($event){return _vm.setFilter('type', tab.value)}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":'secretaryType-' + tab.value}},[_vm._v(_vm._s(tab.label))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-lg-auto mt-2 mt-lg-0 ml-auto px-0 d-flex align-items-center"},[_c('label',{staticClass:"d-none d-lg-inline mr-xl-2 mb-0 pr-2 font-weight-normal",attrs:{"for":"secretariesSearch"}},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"input-append d-flex flex-grow-1 flex-md-grow-0 mr-md-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],staticClass:"form-control mb-0 flex-grow-1 flex-md-grow-0",attrs:{"id":"secretariesSearch","type":"text"},domProps:{"value":(_vm.searchInput)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applySearch($event)},"search":_vm.applySearch,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('svg',{staticClass:"append",attrs:{"role":"button","aria-label":"Search","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14","width":"16","height":"16"},on:{"click":_vm.applySearch}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M5.5 11C2.5 11 0 8.5 0 5.5S2.5 0 5.5 0 11 2.5 11 5.5 8.5 11 5.5 11zm0-10C3 1 1 3 1 5.5S3 10 5.5 10 10 8 10 5.5 8 1 5.5 1z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#231815","d":"M9.5 8.8l4.4 4.4c.2.2.2.5 0 .7l-.4.1-.4-.1-4.4-4.4.8-.7z"}})])])]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-fz-sm btn-primary d-none d-md-block px-xl-5 mt-2 mt-sm-0 ml-md-0",attrs:{"to":{ name: 'Add Secretary Members' }}},[_vm._v("Add"),_c('span',{staticClass:"d-inline"},[_vm._v(" Secretary")])])],1)]),_vm._v(" "),_c('div',{staticClass:"position-relative",staticStyle:{"min-height":"240px"}},[_c('responsive-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"loading":_vm.loading,"breakpoints":_vm.breakpoints,"sort":_vm.filters.sort,"direction":_vm.filters.direction,"empty-text":"No secretaries found."},on:{"sort":_vm.setSort},scopedSlots:_vm._u([{key:"cell:name",fn:function(ref){
var row = ref.row;
return [_c('list-name-cell',{attrs:{"align":"right","label":((row.first_name) + " " + (row.last_name)),"to":_vm.profileRoute(row)},scopedSlots:_vm._u([{key:"badges",fn:function(){return [_c('span',{staticClass:"badge",class:row.role === 'SecretaryOnly' ? 'alert-info' : 'alert-warning'},[_vm._v(_vm._s(row.role === 'SecretaryOnly' ? 'Secretary Only' : 'Member Secretary'))]),_vm._v(" "),(row.is_super_secretary)?_c('span',{staticClass:"badge alert-success"},[_vm._v("Super Secretary")]):_vm._e()]},proxy:true}],null,true)})]}},{key:"cell:first_name",fn:function(ref){
var row = ref.row;
return [_c('router-link',{attrs:{"to":_vm.profileRoute(row)}},[_vm._v(_vm._s(row.first_name))])]}},{key:"cell:last_name",fn:function(ref){
var row = ref.row;
return [_c('list-name-cell',{attrs:{"align":"right","label":row.last_name,"to":_vm.profileRoute(row)},scopedSlots:_vm._u([{key:"badges",fn:function(){return [_c('span',{staticClass:"badge",class:row.role === 'SecretaryOnly' ? 'alert-info' : 'alert-warning'},[_vm._v(_vm._s(row.role === 'SecretaryOnly' ? 'Secretary Only' : 'Member Secretary'))]),_vm._v(" "),(row.is_super_secretary)?_c('span',{staticClass:"badge alert-success"},[_vm._v("Super Secretary")]):_vm._e()]},proxy:true}],null,true)})]}},{key:"cell:committee_name",fn:function(ref){
var row = ref.row;
return [(row.committee_id)?_c('router-link',{attrs:{"to":{ name: 'Committee Profile', params: { id: String(row.committee_id) } }}},[_vm._v(_vm._s(row.committee_name))]):_vm._e()]}},{key:"cell:phone",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.phone))]}},{key:"cell:login",fn:function(ref){
var row = ref.row;
return [_c('button',{staticClass:"btn btn-sm btn-primary text-nowrap secretary-login-btn",attrs:{"disabled":_vm.loggingInId === row.id},on:{"click":function($event){return _vm.login(row.id)}}},[_vm._v("Login")])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"form-inline justify-content-between align-items-start mt-3"},[_c('div',{staticClass:"d-flex align-items-center justify-content-center justify-content-md-start form-group mb-3 mb-md-0 col-12 col-md-auto px-0"},[_c('label',{staticClass:"mr-2 mb-0 font-weight-normal",attrs:{"for":"secretariesShow"}},[_vm._v("Show")]),_vm._v(" "),_c('select',{staticClass:"form-control mr-2",attrs:{"id":"secretariesShow"},domProps:{"value":_vm.filters.per_page},on:{"change":function($event){_vm.setPerPage(Number($event.target.value))}}},_vm._l((_vm.perPageOptions),function(n){return _c('option',{key:n,domProps:{"value":n}},[_vm._v(_vm._s(n))])}),0),_vm._v(" "),_c('span',[_vm._v("Entries")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.totalPages > 1),expression:"totalPages > 1"}],staticClass:"pagination-container form-group align-items-start justify-content-center mb-3 mb-md-0"},[_c('pagination',{attrs:{"total-pages":_vm.totalPages,"page":_vm.page,"on-change":_vm.setPage,"disabled":_vm.loading}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__(240);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_191276c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__(693);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_191276c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"container-fluid flex-grow-1 d-flex bg-lighter"},[_c('div',{staticClass:"row flex-grow-1"},[(_vm.$slots.sidebar)?_vm._t("sidebar"):_c('navbar'),_vm._v(" "),_c('div',{staticClass:"col px-4 tab-layout__col"},[_c('breadcrumb'),_vm._v(" "),_c('div',{class:_vm.fullWidth ? 'w-100 px-0' : 'container container-full-mob ml-0 px-0'},[_c('ul',{staticClass:"nav nav-tabs col-md-11 px-0",attrs:{"id":"myTab","role":"tablist"}},[_vm._t("tabHeading")],2),_vm._v(" "),_vm._t("tabContent")],2)],1)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__(242);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2e1063c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__(692);
function injectStyle (ssrContext) {
  __webpack_require__(685)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f2e1063c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2e1063c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterExisting_vue__ = __webpack_require__(243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bb55e3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterExisting_vue__ = __webpack_require__(687);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterExisting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bb55e3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterExisting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-6 form-group pr-xl-4"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.password),expression:"password.password"}],staticClass:"form-control",attrs:{"type":"password","id":"password","maxlength":"30","required":""},domProps:{"value":(_vm.password.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "password", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Password.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 form-group pl-xl-4"},[_c('label',{attrs:{"for":"confirmPassword"}},[_vm._v("Confirm Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.confirmPassword),expression:"password.confirmPassword"}],staticClass:"form-control",attrs:{"type":"password","id":"confirmPassword","maxlength":"30","required":""},domProps:{"value":(_vm.password.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "confirmPassword", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please ensure your password matches.")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-6 form-group pr-xl-4"},[_c('label',{attrs:{"for":"memberNumber"}},[_vm._v("Member Number")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"memberNumber","required":""}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Member Number.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterNew_vue__ = __webpack_require__(244);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25e7b30b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterNew_vue__ = __webpack_require__(691);
function injectStyle (ssrContext) {
  __webpack_require__(689)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25e7b30b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 689 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 690 */,
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-3"},[(_vm.isAdmin)?_c('div',{staticClass:"col-12 form-group"},[_c('label',{attrs:{"for":"notes"}},[_vm._v("Notes")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.notes),expression:"userInfo.notes"}],staticClass:"form-control",attrs:{"id":"notes"},domProps:{"value":(_vm.userInfo.notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "notes", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.userRole)?_c('div',{staticClass:"col-12 row flex-md-nowrap no-gutters pr-md-4"},[_c('div',{staticClass:"col-12 col-md-auto form-group no-gutters"},[_c('label',{attrs:{"for":"role"}},[_vm._v("Role")]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":"role","required":"","disabled":(_vm.userRole !== 'Admin' && _vm.userRole !== 'SuperAdmin')}},[((_vm.userRole === 'Admin' || _vm.userRole === 'SuperAdmin'))?_c('option',{attrs:{"value":"Member"}},[_vm._v("Member")]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"value":"Volunteer"}},[_vm._v("Volunteers")])])])]):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticClass:"col-12 col-md-6 row flex-md-nowrap no-gutters pr-md-4"},[((_vm.userRole === 'Admin' || _vm.userRole === 'SuperAdmin'))?_c('div',{staticClass:"col-12 col-md form-group no-gutters pr-md-4"},[_c('label',{attrs:{"for":"memberNumber"}},[_vm._v("Member Number")]),_vm._v(" "),_c('input',{staticClass:"form-control",class:['form-control', _vm.errorStatus === 'member_number' ? 'is-invalid' : ''],attrs:{"type":"text","id":"memberNumber"}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v(_vm._s(_vm.errorStatus === 'member_number' ? 'Please include the another member number.' : ''))])]):_vm._e(),_vm._v(" "),_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticClass:"col-md-6"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":"firstName"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.firstName),expression:"userInfo.firstName"}],staticClass:"form-control",attrs:{"type":"text","id":"firstName","maxlength":"40","required":""},domProps:{"value":(_vm.userInfo.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "firstName", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your First Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"lastName"}},[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.lastName),expression:"userInfo.lastName"}],staticClass:"form-control",attrs:{"type":"text","id":"lastName","maxlength":"40","required":""},domProps:{"value":(_vm.userInfo.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "lastName", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Last Name.")])]),_vm._v(" "),(!_vm.isAdmin)?_c('VueSlideToggle',{staticClass:"col-12 px-lg-3",attrs:{"open":_vm.nameMatches,"tag":"div","duration":500}},[(_vm.matchingNames.length)?_c('div',[_c('p',[_vm._v("Do you already have an account? If you are one of the following members, please log in with your existing account.")]),_vm._v(" "),_c('table',{staticClass:"table table-striped"},[_c('thead',[_c('tr',[_c('td',[_vm._v("First Name")]),_vm._v(" "),_c('td',[_vm._v("Last Name")]),_vm._v(" "),_c('td',[_vm._v("Member Number")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.matchingNames),function(member){return _c('tr',{key:member.id,staticClass:"clickable-row",on:{"click":function($event){return _vm.getEmailAndRedirect(member)}}},[_c('td',[_vm._v(_vm._s(member.first_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(member.last_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(member.member_number))])])}),0)]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary mb-3",attrs:{"type":"button"},on:{"click":_vm.newMemberToggle}},[_vm._v("I am not listed above, I wish to register a new account")])]):_c('div',[_c('button',{staticClass:"btn btn-primary mb-3",attrs:{"type":"button"},on:{"click":_vm.newMemberToggle}},[_vm._v("I wish to proceed with account registration")])])]):_vm._e(),_vm._v(" "),_c('VueSlideToggle',{staticClass:"container",attrs:{"open":_vm.isAdmin || _vm.newMember,"tag":"div","duration":500}},[_c('div',{staticClass:"row"},[(!_vm.isAdmin)?_c('div',{staticClass:"col-12 col-md-6 form-group no-gutters",class:_vm.classAdminLeft},[_c('label',{attrs:{"for":"title"}},[_vm._v("Title")]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":"title","required":""}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',{attrs:{"value":"Mr"}},[_vm._v("Mr")]),_vm._v(" "),_c('option',{attrs:{"value":"Ms"}},[_vm._v("Ms")]),_vm._v(" "),_c('option',{attrs:{"value":"Miss"}},[_vm._v("Miss")]),_vm._v(" "),_c('option',{attrs:{"value":"Mrs"}},[_vm._v("Mrs")]),_vm._v(" "),_c('option',{attrs:{"value":"Dr"}},[_vm._v("Dr")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your title.")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group",class:_vm.classAdminRight},[_c('label',{attrs:{"for":"gender"}},[_vm._v("Gender")]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":"gender","required":""}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',[_vm._v("Male")]),_vm._v(" "),_c('option',[_vm._v("Female")]),_vm._v(" "),_c('option',[_vm._v("Unspecified")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Gender.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group",class:_vm.classAdminLeft},[_c('label',{attrs:{"for":"dateOfBirth"}},[_vm._v("Date of Birth")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateOfBirth),expression:"dateOfBirth"}],class:['form-control form-date', _vm.errorStatus === 'validation_error' ? 'is-invalid' : ''],attrs:{"max":_vm.today(),"required":"","id":"dateOfBirth","type":"date","placeholder":[_vm.isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy'],"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}","value":"1988-01-01"},domProps:{"value":(_vm.dateOfBirth)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dateOfBirth=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Date of Birth"+_vm._s(_vm.isLegacy() ? ' in the format yyyy-mm-dd' : '')+".")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group pr-xl-4"},[_c('label',{attrs:{"for":"riderStatus"}},[_vm._v("Rider Status")]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":"riderStatus"}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Maiden")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Novice")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Open")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Rider Status.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group pl-xl-4"},[_c('label',{attrs:{"for":"boyStatus"}},[_vm._v("Beginning of Year Status")]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":"boyStatus"}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Maiden")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Novice")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Open")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Rider Status.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group",class:_vm.classAdminRight},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.email),expression:"userInfo.email"}],class:['form-control', _vm.errorStatus === 'email' && _vm.errors ? 'is-invalid' : ''],attrs:{"type":"email","id":"email","maxlength":"255","required":""},domProps:{"value":(_vm.userInfo.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "email", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v(_vm._s(_vm.errorStatus === 'email' && _vm.errors ? _vm.errors : 'Please include your Email Address.'))]),_vm._v(" "),(_vm.isAdmin)?_c('VueSlideToggle',{attrs:{"open":_vm.emailFound,"tag":"div","duration":500}},[_c('p',{staticClass:"small"},[_vm._v("This email address is already in use.")])]):_c('VueSlideToggle',{staticClass:"col-12 px-lg-3",attrs:{"open":_vm.emailFound,"tag":"div","duration":500}},[_c('p',{staticClass:"small"},[_vm._v("This email address is already in use.\n            "),_c('router-link',{staticClass:"d-inline-block",attrs:{"tag":"a","to":{ name: 'Login', query: { email: _vm.userInfo.email } }}},[_vm._v("Please log in to your account here")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group",class:_vm.classAdminLeft},[_c('label',{attrs:{"for":"phone"}},[_vm._v("Phone Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userInfo.phone),expression:"userInfo.phone"}],staticClass:"form-control",attrs:{"type":"text","id":"phone","maxlength":"15","required":!_vm.userInfo.mobile_phone},domProps:{"value":(_vm.userInfo.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userInfo, "phone", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include either a Phone or Mobile Number.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group",class:_vm.classAdminRight},[_c('label',{attrs:{"for":"mobile"}},[_vm._v("Mobile Phone Number")]),_vm._v(" "),_c('phone-input',{class:[_vm.errorStatus === 'mobile_phone' ? 'is-invalid' : ''],attrs:{"id":"mobile","required":!_vm.userInfo.phone},model:{value:(_vm.userInfo.mobile_phone),callback:function ($$v) {_vm.$set(_vm.userInfo, "mobile_phone", $$v)},expression:"userInfo.mobile_phone"}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include correct mobile phone number.")]),_vm._v(" "),_c('small',[_vm._v("Please enter the phone in a similar format +614 **** **** without spaces")]),_vm._v(" "),_c('test-phone-numbers')],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group",class:_vm.classAdminLeft},[_c('label',{attrs:{"for":"carbon_copy_mobile"}},[_vm._v("CC Mobile "),_c('small',{staticClass:"d-inline-block"},[_vm._v("(optional)")])]),_vm._v(" "),_c('phone-input',{class:[_vm.errorStatus === 'carbon_copy_mobile' ? 'is-invalid' : ''],attrs:{"id":"carbon_copy_mobile"},model:{value:(_vm.userInfo.carbon_copy_mobile),callback:function ($$v) {_vm.$set(_vm.userInfo, "carbon_copy_mobile", $$v)},expression:"userInfo.carbon_copy_mobile"}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please enter correct CC mobile")]),_vm._v(" "),_c('small',[_vm._v("Please enter the phone in a similar format +614 **** **** without spaces")]),_vm._v(" "),_c('test-phone-numbers')],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group",class:_vm.classAdminRight},[_c('label',{attrs:{"for":"address"}},[_vm._v("Address Line 1")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"address","maxlength":"80","required":"","pattern":".{5,}"}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include an address of at least 5 characters.")]),_vm._v(" "),_c('small',{staticClass:"d-block"},[_vm._v("Must be at least 5 characters")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group",class:_vm.classAdminLeft},[_c('label',{attrs:{"for":"address2"}},[_vm._v("Address Line 2 "),_c('small',[_vm._v("(optional)")])]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"address2","maxlength":"80"}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include an address of at least 5 characters.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group",class:_vm.classAdminRight},[_c('label',{attrs:{"for":"suburb"}},[_vm._v("Suburb")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.suburb),expression:"suburb"}],staticClass:"form-control",attrs:{"type":"text","id":"suburb","maxlength":"40","required":""},domProps:{"value":(_vm.suburb)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.suburb=$event.target.value},function($event){return _vm.findZone()}]}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Suburb.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group",class:_vm.classAdminLeft},[_c('label',{attrs:{"for":"postcode"}},[_vm._v("Postcode")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.postcode),expression:"postcode"}],staticClass:"form-control",attrs:{"type":"text","id":"postcode","maxlength":"4","required":"","pattern":"\\d{4}"},domProps:{"value":(_vm.postcode)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.postcode=$event.target.value},function($event){return _vm.findZone()}]}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include a four-digit Postcode.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group",class:_vm.classAdminRight},[_c('label',{attrs:{"for":"state"}},[_vm._v("State")]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":"state","required":""}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',{attrs:{"value":"QLD"}},[_vm._v("Queensland")]),_vm._v(" "),_c('option',{attrs:{"value":"NSW"}},[_vm._v("New South Wales")]),_vm._v(" "),_c('option',{attrs:{"value":"VIC"}},[_vm._v("Victoria")]),_vm._v(" "),_c('option',{attrs:{"value":"ACT"}},[_vm._v("Australian Capital Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"SA"}},[_vm._v("South Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"NT"}},[_vm._v("Northern Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"WA"}},[_vm._v("Western Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"TAS"}},[_vm._v("Tasmania")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your State.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group",class:_vm.classAdminLeft},[_c('label',{attrs:{"for":"zone"}},[_vm._v("Zone")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.zone),expression:"zone"}],staticClass:"form-control",attrs:{"id":"zone"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.zone=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Unspecified")]),_vm._v(" "),_vm._l((_vm.$store.state.listZones.filter(function (zone) { return !zone.deleted_at; })),function(zone,index){return _c('option',{key:index,domProps:{"value":zone.id}},[_vm._v(_vm._s(zone.code))])})],2),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Zone.")]),_vm._v(" "),(_vm.zoneNotFound && !_vm.zoneNotSpecified)?_c('div',{staticClass:"alert alert-warning alert-sm"},[_vm._v("Unable to find matching Zone.")]):(_vm.zoneNotSpecified)?_c('div',{staticClass:"alert alert-warning alert-sm"},[_vm._v(_vm._s(_vm.warningMessage))]):(_vm.zoneFound)?_c('div',{staticClass:"alert alert-success alert-sm"},[_vm._v("Found matching Zone.")]):_c('div',{staticClass:"alert alert-sm"},[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group pl-xl-4"},[_c('label',{attrs:{"for":"proofOfAge"}},[_vm._v("Proof of Age")]),_vm._v(" "),_c('div',{staticClass:"custom-file"},[_c('input',{class:['custom-file-input font-weight-normal', { 'is-invalid': _vm.errorStatus === 'file' }],attrs:{"type":"file","id":"proofOfAge","accept":"image/*, application/pdf"},on:{"change":_vm.fileUpload}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label font-weight-normal",attrs:{"for":"proofOfAge"}},[_vm._v(_vm._s(_vm.file_name ? _vm.file_name : 'Choose file...'))]),_vm._v(" "),_c('small',[_vm._v("jpg, jpeg, png, tiff, gif, pdf file type required.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Your ID will be stored in a secure data storage")]),_vm._v(" "),(_vm.file_name)?_c('button',{staticClass:"btn btn-link px-2 pl-md-0 px-xl-2 pr-md-1",attrs:{"type":"button"},on:{"click":_vm.deleteAttachment}},[_c('span',{staticClass:"sr-only"},[_vm._v("Delete File")]),_vm._v(" "),_c('div',{staticClass:"btn-remove"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"}}),_c('path',{attrs:{"d":"M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"}}),_c('path',{attrs:{"d":"M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"}})])])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.password),expression:"password.password"}],staticClass:"form-control",attrs:{"type":"password","id":"password","maxlength":"30","required":"","pattern":"([A-Za-z0-9]){6,}"},domProps:{"value":(_vm.password.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "password", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include a Password between 6 and 30 characters, using only letters and numbers.")]),_vm._v(" "),_c('small',{staticClass:"d-block"},[_vm._v("Must be between 6 and 30 characters, using only letters and numbers")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pb-md-5 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"confirmPassword"}},[_vm._v("Confirm Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.confirmPassword),expression:"password.confirmPassword"}],staticClass:"form-control",attrs:{"type":"password","id":"confirmPassword","maxlength":"30","required":"","pattern":"([A-Za-z0-9]){6,}"},domProps:{"value":(_vm.password.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "confirmPassword", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please ensure your Password matches.")])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-auto form-group no-gutters"},[_c('label',{attrs:{"for":"title"}},[_vm._v("Title")]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":"title","required":""}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',{attrs:{"value":"Mr"}},[_vm._v("Mr")]),_vm._v(" "),_c('option',{attrs:{"value":"Ms"}},[_vm._v("Ms")]),_vm._v(" "),_c('option',{attrs:{"value":"Miss"}},[_vm._v("Miss")]),_vm._v(" "),_c('option',{attrs:{"value":"Mrs"}},[_vm._v("Mrs")]),_vm._v(" "),_c('option',{attrs:{"value":"Dr"}},[_vm._v("Dr")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your title.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{class:['d-flex flex-grow-1 bg-white', { 'bg-lg-primary': !_vm.isAdmin }]},[_c('section',{staticClass:"container py-3 py-sm-4"},[_c('div',{class:['col-12 px-0 mx-auto', { 'col-dialog': !_vm.isAdmin }]},[_c('form',{staticClass:"needs-validation bg-white rounded py-3 p-lg-4",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.register($event)}}},[_c('h1',{class:['mb-3 mb-sm-4', _vm.isAdmin ? _vm.success ? 'h2 text-center' : 'h2' : 'h3 pb-3 pb-sm-4 border-bottom text-center']},[_vm._v(_vm._s(_vm.success ? 'Thank You' : 'Register Member for Campdraft One'))]),_vm._v(" "),(!_vm.success)?_c('div',[(_vm.errors)?_c('div',{staticClass:"alert alert-warning d-flex justify-content-between align-items-center",attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(_vm.errors)+"\n            "),(_vm.responseStatus === 'email_exists' && !_vm.isAdmin)?_c('router-link',{staticClass:"btn btn-primary",attrs:{"tag":"button","to":"/login"}},[_vm._v("Sign in")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.existingMember === true)?_c('existing-member',{staticClass:"mb-3",on:{"input":function($event){_vm.password = $event}}}):_c('new-member',{attrs:{"errors":_vm.errors,"errorStatus":_vm.errorStatus,"responseStatus":_vm.responseStatus,"isAdmin":_vm.isAdmin},on:{"input":function($event){_vm.password = $event},"userInfo":function($event){_vm.userInfo = $event},"newMember":function($event){_vm.newMember = $event}}}),_vm._v(" "),(_vm.newMember)?_c('div',{class:['form-group form-check px-0 mb-sm-4', { 'sr-only': _vm.isAdmin }]},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.terms),expression:"terms"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"terms","required":""},domProps:{"checked":Array.isArray(_vm.terms)?_vm._i(_vm.terms,null)>-1:(_vm.terms)},on:{"change":function($event){var $$a=_vm.terms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.terms=$$a.concat([$$v]))}else{$$i>-1&&(_vm.terms=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.terms=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"terms"}},[_vm._v("\n                In consideration for me, and/or minors in my care, being allowed to participate in all events run by the Australian Campdraft Association Inc. (ACA), I hereby agree that I have permission to accept the membership waiver, on behalf of all persons for whom this membership is for, a full copy of which is available on the ACA website and the membership tax invoice.\n              ")]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please agree to the membership waiver.")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-sm-between flex-wrap"},[(!_vm.isAdmin)?_c('div',{staticClass:"mb-2 my-sm-auto order-1 order-lg-0"},[_vm._v("\n              Already have an ACA account?\n              "),_c('router-link',{attrs:{"tag":"a","to":"/login"}},[_vm._v("Sign in")]),_vm._v(".\n            ")],1):_vm._e(),_vm._v(" "),(_vm.newMember)?_c('button',{staticClass:"btn btn-primary btn-block-mob mb-3 mb-lg-0 ml-lg-auto",attrs:{"type":"submit","disabled":_vm.loading},on:{"click":_vm.handleSubmit}},[_vm._v("Register")]):_vm._e()])],1):(!_vm.isAdmin)?_c('div',{staticClass:"text-center"},[_c('p',[_vm._v("Please check your email "),(_vm.userInfo.email !== '')?_c('span',{staticClass:"text-primary"},[_vm._v(_vm._s(_vm.userInfo.email))]):_vm._e(),_vm._v(" for a welcome message from us.")]),_vm._v(" "),_c('div',[_vm._v("Back to "),_c('router-link',{attrs:{"tag":"a","to":"/login"}},[_vm._v("Sign in")]),_vm._v(".")],1)]):_c('div',{staticClass:"text-center"},[_c('p',[_vm._v("The user with email "),(_vm.userInfo.email !== '')?_c('span',{staticClass:"text-primary"},[_vm._v(_vm._s(_vm.userInfo.email))]):_vm._e(),_vm._v(" has been created successfully.")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"actionBar":true}},[_c('register',{staticClass:"row mx-0 show active",attrs:{"slot":"tabContent","isAdmin":true},slot:"tabContent"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Members_vue__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0af27c62_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Members_vue__ = __webpack_require__(705);
function injectStyle (ssrContext) {
  __webpack_require__(695)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0af27c62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Members_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0af27c62_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Members_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 695 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-bar bg-lighter rounded p-2 p-sm-3 mb-3"},[_c('div',{staticClass:"filter-bar__row"},[_vm._t("default"),_vm._v(" "),(_vm.active)?_c('div',{staticClass:"filter-field filter-field--action"},[_c('button',{staticClass:"btn btn-outline-primary filter-bar__clear-all",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('clear')}}},[_vm._v("Clear all filters")])]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 698 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 699 */,
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-field filter-ms"},[_c('div',{staticClass:"filter-field__label"},[_c('label',{staticClass:"mb-0 font-weight-bold",attrs:{"for":_vm.fieldId}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),(_vm.selectedIds.length)?_c('button',{staticClass:"btn btn-link btn-sm p-0 ml-2 filter-ms__clear",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('clear')}}},[_vm._v("Clear")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"filter-field__control"},[_c('app-multiselect',{attrs:{"id":_vm.fieldId,"value":_vm.selectedOptions,"options":_vm.options,"multiple":true,"close-on-select":false,"clear-on-select":false,"preserve-search":true,"allow-empty":true,"show-labels":false,"label":_vm.optionLabel,"track-by":_vm.trackBy,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"limit":2,"limit-text":function (count) { return ("+ " + count + " more"); }},on:{"input":_vm.onInput}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 701 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-field filter-checkbox"},[_c('div',{staticClass:"filter-field__control"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"id":_vm.fieldId,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('input', $event.target.checked ? '1' : '')}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":_vm.fieldId}},[_vm._v(_vm._s(_vm.label))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-tooltip",class:{ 'app-tooltip--right': _vm.align === 'right' },attrs:{"data-tooltip":_vm.text || ''}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = buildColumns;
/* harmony export (immutable) */ __webpack_exports__["c"] = buildBreakpoints;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FINANCIAL_TABS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MEMBERSHIP_STATUS_TABS; });
// Column keys double as the backend sort keys (UserFilters::LIST_SORTABLE) so ResponsiveTable's
// sort arrows light up against `filters.sort` with no translation layer. Member No. and
// Financial Seasons are not sortable — matches the legacy DataTable definition.
//
// Edit / Login / Restore are separate columns (not merged into one "Actions" column) because the
// legacy page toggles them as a whole between the "Deleted" tab and every other tab (Edit+Login
// disappear, Restore appears) — see Members.vue's `onDeletedTabChange`.
function buildColumns(isAdmin, isDeletedTab) {
  var columns = [{
    key: 'first_name',
    label: 'First Name',
    sortable: true,
    minWidth: '100px',
    width: '1.3fr'
  }, {
    key: 'last_name',
    label: 'Last Name',
    sortable: true,
    minWidth: '130px',
    width: '2.4fr'
  }, {
    key: 'member_number',
    label: 'Member No.',
    minWidth: '90px',
    width: '1.8fr'
  }, {
    key: 'seasons',
    label: 'Financial Seasons',
    minWidth: '100px',
    width: '1.7fr'
  }, {
    key: 'zone_id',
    label: 'Zone',
    sortable: true,
    minWidth: '60px',
    width: '0.6fr'
  }, {
    key: 'beginning_of_year_status',
    label: 'BoY Status',
    sortable: true,
    minWidth: '90px',
    width: '1.4fr'
  }]; // Fixed px, not minWidth+fr (see Horses' `remove` column for why): each sized to the wider
  // of its header label and the shrunk .member-action-btn button, at the same padding/font-size
  // for all three, so the numbers scale with the word alone — "Edit" < "Login" < "Restore".

  if (isDeletedTab) {
    if (isAdmin) columns.push({
      key: 'restore',
      label: 'Restore',
      width: '95px',
      cellClass: 'text-center'
    });
  } else {
    columns.push({
      key: 'edit',
      label: 'Edit',
      width: '70px',
      cellClass: 'text-center'
    });
    if (isAdmin) columns.push({
      key: 'login',
      label: 'Login',
      width: '75px',
      cellClass: 'text-center'
    });
  }

  return columns;
} // Below 930px the row collapses into an accordion: a combined First+Last name summary (the
// legacy expandedHeader showed both names together) plus the same detail fields the legacy
// expandedRow showed (Member No, Financial Seasons, Zone, BoY Status, Login).
//
// 930, not the ~852px the full grid's columns actually need (every column's minWidth/fixed
// width floor + cell padding + borders, widest case: admin, active tab, 8 columns incl.
// Edit/Login) — because NavbarSide.vue's sidebar is `position: absolute` (an overlay, costs
// the row 0px) below 1024px viewport width but a static `flex: 0 1 220px` column at 1024px
// and up. Container width therefore tracks the viewport 1:1 up to ~925px (viewport 1023, just
// under the sidebar's own breakpoint) and then drops by roughly 220px the moment the sidebar
// stops overlaying — so 852-920 left a ~5-10px viewport gap (observed at 1019-1023px) where
// the container was briefly wide enough for the full grid, sandwiched between accordion mode
// on both sides. 930 sits above that ~925px ceiling so the accordion is continuous across the
// gap instead of flashing back to the desktop grid for a few pixels. Recompute both numbers if
// columns are added/resized, or if NavbarSide's breakpoint or sidebar width changes.

function buildBreakpoints(isAdmin, isDeletedTab) {
  var rows = [['member_number'], ['seasons'], ['zone_id'], ['beginning_of_year_status']];

  if (isDeletedTab) {
    if (isAdmin) rows.push(['restore']);
  } else if (isAdmin) {
    rows.push(['login']);
  }

  return [{
    maxWidth: 930,
    hideHeader: true,
    accordion: {
      summary: [{
        keys: ['name'],
        hideLabel: true
      }]
    },
    rows: rows
  }];
}
var FINANCIAL_TABS = [{
  value: 'all',
  label: 'All'
}, {
  value: '1',
  label: 'Financial'
}, {
  value: '0',
  label: 'Unfinancial'
}, {
  value: 'Volunteer',
  label: 'Volunteer'
}];
var MEMBERSHIP_STATUS_TABS = [{
  value: 'all',
  label: 'All'
}, {
  value: 'Onhold',
  label: 'On Hold'
}, {
  value: 'Archived',
  label: 'Archived'
}, {
  value: 'Lifetime',
  label: 'Lifetime'
}, {
  value: 'Suspended',
  label: 'Suspended'
}, {
  value: 'Deleted',
  label: 'Deleted'
}];

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('h1',{staticClass:"h2 mb-3",attrs:{"slot":"heading"},slot:"heading"},[_vm._v(_vm._s(_vm.config.title))]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.successMessage)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.successMessage))]):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e(),_vm._v(" "),_c('filter-bar',{attrs:{"active":_vm.hasActiveFilters},on:{"clear":_vm.clearAll}},[_c('filter-multiselect',{attrs:{"label":"Zone","option-label":"code","placeholder":"Any zone","value":_vm.filters.zone_id,"options":_vm.zoneOptions},on:{"input":function (ids) { return _vm.setFilter('zone_id', ids); },"clear":function($event){return _vm.clearFilter('zone_id')}}}),_vm._v(" "),_c('filter-multiselect',{attrs:{"label":"Status","placeholder":"Any status","value":_vm.filters.status_id,"options":_vm.riderStatusOptions},on:{"input":function (ids) { return _vm.setFilter('status_id', ids); },"clear":function($event){return _vm.clearFilter('status_id')}}}),_vm._v(" "),_c('filter-multiselect',{attrs:{"label":"BoY Status","placeholder":"Any BoY status","value":_vm.filters.boy_status_id,"options":_vm.riderStatusOptions},on:{"input":function (ids) { return _vm.setFilter('boy_status_id', ids); },"clear":function($event){return _vm.clearFilter('boy_status_id')}}}),_vm._v(" "),_c('filter-checkbox',{attrs:{"label":"Primary Only","value":_vm.filters.primary_only},on:{"input":function (v) { return _vm.setFilter('primary_only', v); }}}),_vm._v(" "),(_vm.isAdmin)?_c('filter-checkbox',{attrs:{"label":"Member Secretaries","value":_vm.filters.secretary_members_only},on:{"input":function (v) { return _vm.setFilter('secretary_members_only', v); }}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-inline mb-sm-3 d-flex justify-content-between"},[_c('div',[_c('div',{staticClass:"d-flex col-12 col-md-auto px-0 mb-3 mb-md-2"},[_c('label',{staticClass:"sr-only",attrs:{"for":"showFinancial-all"}},[_vm._v("Financial")]),_vm._v(" "),_c('div',{staticClass:"filter flex-wrap"},_vm._l((_vm.FINANCIAL_TABS),function(tab){return _c('div',{key:tab.value,staticClass:"form-check pl-0"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":"showFinancial","id":'showFinancial-' + tab.value},domProps:{"value":tab.value,"checked":_vm.filters.financial === tab.value},on:{"change":function($event){return _vm.setFilter('financial', tab.value)}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":'showFinancial-' + tab.value}},[_vm._v(_vm._s(tab.label))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"d-flex col-12 col-md-auto px-0 mb-3 mb-md-2"},[_c('label',{staticClass:"sr-only",attrs:{"for":"showMembershipStatus-all"}},[_vm._v("Membership Status")]),_vm._v(" "),_c('div',{staticClass:"filter flex-wrap"},_vm._l((_vm.MEMBERSHIP_STATUS_TABS),function(tab){return _c('div',{key:tab.value,staticClass:"form-check pl-0"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":"showMembershipStatus","id":'showMembershipStatus-' + tab.value},domProps:{"value":tab.value,"checked":_vm.filters.membership_status === tab.value},on:{"change":function($event){return _vm.setFilter('membership_status', tab.value)}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":'showMembershipStatus-' + tab.value}},[_vm._v(_vm._s(tab.label))])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-lg-auto mt-2 mt-lg-0 mt-xl-0 ml-auto px-0 action_section"},[_c('label',{staticClass:"d-none d-lg-inline mr-xl-2 mb-0 pr-2 font-weight-normal",attrs:{"for":"membersSearch"}},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"input-append d-flex flex-grow-1 flex-md-grow-0 mr-md-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],staticClass:"form-control mb-0 flex-grow-1 flex-md-grow-0",attrs:{"id":"membersSearch","type":"text"},domProps:{"value":(_vm.searchInput)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applySearch($event)},"search":_vm.applySearch,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('svg',{staticClass:"append",attrs:{"role":"button","aria-label":"Search","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14","width":"16","height":"16"},on:{"click":_vm.applySearch}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M5.5 11C2.5 11 0 8.5 0 5.5S2.5 0 5.5 0 11 2.5 11 5.5 8.5 11 5.5 11zm0-10C3 1 1 3 1 5.5S3 10 5.5 10 10 8 10 5.5 8 1 5.5 1z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#231815","d":"M9.5 8.8l4.4 4.4c.2.2.2.5 0 .7l-.4.1-.4-.1-4.4-4.4.8-.7z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"position-relative",staticStyle:{"min-height":"240px"}},[_c('responsive-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"loading":_vm.loading,"breakpoints":_vm.breakpoints,"sort":_vm.filters.sort,"direction":_vm.filters.direction,"empty-text":"No members found."},on:{"sort":_vm.setSort},scopedSlots:_vm._u([{key:"cell:name",fn:function(ref){
var row = ref.row;
return [_c('list-name-cell',{attrs:{"label":((row.first_name) + " " + (row.last_name) + (row.is_event_membership ? ' (CM)' : '')),"to":{ name: 'Member Profile', params: { slug: row.id } }},scopedSlots:_vm._u([{key:"badges",fn:function(){return [(row.is_primary)?_c('span',{staticClass:"badge alert-prim"},[_vm._v("Primary")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"badge",class:_vm.statusBadgeClass(row)},[_vm._v(_vm._s(_vm.statusBadgeLabel(row)))])]},proxy:true}],null,true)})]}},{key:"cell:first_name",fn:function(ref){
var row = ref.row;
return [_c('router-link',{attrs:{"to":{ name: 'Member Profile', params: { slug: row.id } }}},[_vm._v(_vm._s(row.first_name))])]}},{key:"cell:last_name",fn:function(ref){
var row = ref.row;
return [_c('list-name-cell',{attrs:{"align":"right","label":("" + (row.last_name) + (row.is_event_membership ? ' (CM)' : '')),"to":{ name: 'Member Profile', params: { slug: row.id } }},scopedSlots:_vm._u([{key:"badges",fn:function(){return [_c('span',{staticClass:"badge",class:_vm.statusBadgeClass(row)},[_vm._v(_vm._s(_vm.statusBadgeLabel(row)))])]},proxy:true}],null,true)})]}},{key:"cell:member_number",fn:function(ref){
var row = ref.row;
return [_c('list-name-cell',{attrs:{"align":"right","label":row.member_number},scopedSlots:_vm._u([{key:"badges",fn:function(){return [(_vm.isAdmin && row.committee_id)?_c('app-tooltip',{attrs:{"text":("Committee: " + (row.committee_name) + " — click to open this committee")}},[_c('router-link',{staticClass:"member-committee-link",attrs:{"to":{ name: 'Committee Profile', params: { id: String(row.committee_id) } },"aria-label":("Open " + (row.committee_name) + " committee")}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":"16","height":"16","aria-hidden":"true"}},[_c('path',{attrs:{"fill":"currentColor","d":"M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"}})])])],1):_vm._e(),_vm._v(" "),(row.is_primary)?_c('span',{staticClass:"badge alert-prim"},[_vm._v("Primary")]):_vm._e()]},proxy:true}],null,true)})]}},{key:"cell:seasons",fn:function(ref){
var row = ref.row;
return [_c('span',{staticClass:"d-flex align-items-center flex-wrap"},_vm._l((row.seasons),function(value,season){return _c('span',{key:season,staticClass:"badge season-badge ml-1",class:value === 1 ? 'alert-success' : 'alert-danger'},[_vm._v(_vm._s(season))])}),0)]}},{key:"cell:zone_id",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(_vm.zoneCode(row.zone_id)))]}},{key:"cell:edit",fn:function(ref){
var row = ref.row;
return [_c('router-link',{staticClass:"btn btn-sm btn-primary text-nowrap member-action-btn",attrs:{"to":{ name: 'Member Profile', params: { slug: row.id } }}},[_vm._v("Edit")])]}},{key:"cell:login",fn:function(ref){
var row = ref.row;
return [_c('button',{staticClass:"btn btn-sm btn-primary text-nowrap member-action-btn",attrs:{"disabled":_vm.loggingInId === row.id},on:{"click":function($event){return _vm.login(row.parent_id || row.id)}}},[_vm._v("Login")])]}},{key:"cell:restore",fn:function(ref){
var row = ref.row;
return [_c('button',{staticClass:"btn btn-sm btn-primary text-nowrap member-action-btn",attrs:{"disabled":_vm.restoringId === row.id},on:{"click":function($event){return _vm.askRestore(row)}}},[_vm._v("Restore")])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"form-inline justify-content-between align-items-start mt-3"},[_c('div',{staticClass:"d-flex align-items-center justify-content-center justify-content-md-start form-group mb-3 mb-md-0 col-12 col-md-auto px-0"},[_c('label',{staticClass:"mr-2 mb-0 font-weight-normal",attrs:{"for":"membersShow"}},[_vm._v("Show")]),_vm._v(" "),_c('select',{staticClass:"form-control mr-2",attrs:{"id":"membersShow"},domProps:{"value":_vm.filters.per_page},on:{"change":function($event){_vm.setPerPage(Number($event.target.value))}}},_vm._l((_vm.perPageOptions),function(n){return _c('option',{key:n,domProps:{"value":n}},[_vm._v(_vm._s(n))])}),0),_vm._v(" "),_c('span',[_vm._v("Entries")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.totalPages > 1),expression:"totalPages > 1"}],staticClass:"pagination-container form-group align-items-start justify-content-center mb-3 mb-md-0"},[_c('pagination',{attrs:{"total-pages":_vm.totalPages,"page":_vm.page,"on-change":_vm.setPage,"disabled":_vm.loading}})],1)]),_vm._v(" "),(_vm.memberToRestore)?_c('modal',{on:{"close":function($event){_vm.memberToRestore = null}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning text-center"},[_vm._v("\n          You are about to restore "+_vm._s(_vm.memberToRestore.first_name)+" "+_vm._s(_vm.memberToRestore.last_name)+". Are you sure?\n        ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){_vm.memberToRestore = null}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary ml-2",on:{"click":_vm.confirmRestore}},[_vm._v("Confirm")])])])]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberJoin_vue__ = __webpack_require__(253);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aaa1d54_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberJoin_vue__ = __webpack_require__(708);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberJoin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aaa1d54_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberJoin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = buildColumns;
/* harmony export (immutable) */ __webpack_exports__["b"] = buildBreakpoints;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FINANCIAL_TABS; });
// Column keys double as backend sort keys (UserFilters::LIST_SORTABLE) — matches the convention
// established for Members/Listing/columns.js. `select` and `member_number` are not sortable,
// same as the legacy DataTable definition for this page.
function buildColumns() {
  return [{
    key: 'select',
    label: '',
    minWidth: '40px',
    width: '0.3fr'
  }, {
    key: 'first_name',
    label: 'First Name',
    sortable: true,
    minWidth: '100px',
    width: '1.4fr'
  }, {
    key: 'last_name',
    label: 'Last Name',
    sortable: true,
    minWidth: '130px',
    width: '2fr'
  }, {
    key: 'member_number',
    label: 'Membership No.',
    minWidth: '110px',
    width: '1.6fr'
  }, {
    key: 'zone_id',
    label: 'Zone',
    sortable: true,
    minWidth: '60px',
    width: '0.7fr'
  }];
} // Below 700px: checkbox + combined name always visible (legacy's `expandedSelect` +
// `expandedHeader` were never hidden behind the accordion toggle, only Membership No/Zone were).

function buildBreakpoints() {
  return [{
    maxWidth: 700,
    hideHeader: true,
    accordion: {
      summary: [{
        keys: ['select'],
        hideLabel: true
      }, {
        keys: ['name'],
        hideLabel: true
      }]
    },
    rows: [['member_number'], ['zone_id']]
  }];
} // Same 'financial' values the backend already filters on (UserFilters::applyListConditions) —
// just relabelled Active/Inactive to match this page's legacy wording instead of Members.vue's
// Financial/Unfinancial. No 'Volunteer' bucket here — the legacy page never had one.

var FINANCIAL_TABS = [{
  value: 'all',
  label: 'All'
}, {
  value: '1',
  label: 'Active'
}, {
  value: '0',
  label: 'Inactive'
}];

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('h1',{staticClass:"sr-only",attrs:{"slot":"heading"},slot:"heading"},[_vm._v("Join Members")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('h2',{staticClass:"mb-0",attrs:{"slot":"heading"},slot:"heading"},[_vm._v("Select Members To Join")]),_vm._v(" "),_c('h3',{staticClass:"h4 mb-4"},[_vm._v("Joining members to "+_vm._s(_vm.primary.first_name + ' ' + _vm.primary.last_name))]),_vm._v(" "),(_vm.successMessage)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.successMessage))]):(_vm.errorMessage)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-inline mb-sm-3 d-flex justify-content-between"},[_c('div',{staticClass:"d-flex col-12 col-md-auto px-0 mb-3 mb-md-2"},[_c('label',{staticClass:"sr-only",attrs:{"for":"showFinancial-all"}},[_vm._v("Financial")]),_vm._v(" "),_c('div',{staticClass:"filter"},_vm._l((_vm.FINANCIAL_TABS),function(tab){return _c('div',{key:tab.value,staticClass:"form-check pl-0"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":"showFinancial","id":'showFinancial-' + tab.value},domProps:{"value":tab.value,"checked":_vm.filters.financial === tab.value},on:{"change":function($event){return _vm.setFilter('financial', tab.value)}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":'showFinancial-' + tab.value}},[_vm._v(_vm._s(tab.label))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-lg-auto mt-2 mt-lg-0 mt-xl-0 ml-auto px-0 action_section"},[_c('label',{staticClass:"d-none d-lg-inline mr-xl-2 mb-0 pr-2 font-weight-normal",attrs:{"for":"joinMembersSearch"}},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"input-append d-flex flex-grow-1 flex-md-grow-0 mr-md-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],staticClass:"form-control mb-0 flex-grow-1 flex-md-grow-0",attrs:{"id":"joinMembersSearch","type":"text"},domProps:{"value":(_vm.searchInput)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applySearch($event)},"search":_vm.applySearch,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('svg',{staticClass:"append",attrs:{"role":"button","aria-label":"Search","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14","width":"16","height":"16"},on:{"click":_vm.applySearch}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M5.5 11C2.5 11 0 8.5 0 5.5S2.5 0 5.5 0 11 2.5 11 5.5 8.5 11 5.5 11zm0-10C3 1 1 3 1 5.5S3 10 5.5 10 10 8 10 5.5 8 1 5.5 1z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#231815","d":"M9.5 8.8l4.4 4.4c.2.2.2.5 0 .7l-.4.1-.4-.1-4.4-4.4.8-.7z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"position-relative",staticStyle:{"min-height":"240px"}},[_c('responsive-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"loading":_vm.loading,"breakpoints":_vm.breakpoints,"sort":_vm.filters.sort,"direction":_vm.filters.direction,"empty-text":"No members found."},on:{"sort":_vm.setSort},scopedSlots:_vm._u([{key:"cell:select",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"custom-control custom-checkbox custom-control-inline mr-0"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":("joinSelect" + (row.id))},domProps:{"checked":_vm.isSelected(row.id)},on:{"change":function($event){return _vm.toggleSelect(row)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":("joinSelect" + (row.id))}})])]}},{key:"cell:name",fn:function(ref){
var row = ref.row;
return [_c('list-name-cell',{attrs:{"label":((row.first_name) + " " + (row.last_name)),"to":{ name: 'Member Profile', params: { slug: row.id } }},scopedSlots:_vm._u([{key:"badges",fn:function(){return [_c('span',{staticClass:"badge",class:_vm.statusBadgeClass(row)},[_vm._v(_vm._s(_vm.statusBadgeLabel(row)))])]},proxy:true}],null,true)})]}},{key:"cell:first_name",fn:function(ref){
var row = ref.row;
return [_c('router-link',{attrs:{"to":{ name: 'Member Profile', params: { slug: row.id } }}},[_vm._v(_vm._s(row.first_name))])]}},{key:"cell:last_name",fn:function(ref){
var row = ref.row;
return [_c('list-name-cell',{attrs:{"align":"right","label":row.last_name,"to":{ name: 'Member Profile', params: { slug: row.id } }},scopedSlots:_vm._u([{key:"badges",fn:function(){return [_c('span',{staticClass:"badge",class:_vm.statusBadgeClass(row)},[_vm._v(_vm._s(_vm.statusBadgeLabel(row)))])]},proxy:true}],null,true)})]}},{key:"cell:member_number",fn:function(ref){
var row = ref.row;
return [_c('list-name-cell',{attrs:{"align":"right","label":row.member_number},scopedSlots:_vm._u([{key:"badges",fn:function(){return [_c('span',{staticClass:"badge alert-prim"},[_vm._v("Primary")])]},proxy:true}],null,true)})]}},{key:"cell:zone_id",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(_vm.zoneCode(row.zone_id)))]}}])})],1),_vm._v(" "),_c('div',{staticClass:"form-inline justify-content-between align-items-start mt-3"},[_c('div',{staticClass:"d-flex align-items-center justify-content-center justify-content-md-start form-group mb-3 mb-md-0 col-12 col-md-auto px-0"},[_c('label',{staticClass:"mr-2 mb-0 font-weight-normal",attrs:{"for":"joinMembersShow"}},[_vm._v("Show")]),_vm._v(" "),_c('select',{staticClass:"form-control mr-2",attrs:{"id":"joinMembersShow"},domProps:{"value":_vm.filters.per_page},on:{"change":function($event){_vm.setPerPage(Number($event.target.value))}}},_vm._l((_vm.perPageOptions),function(n){return _c('option',{key:n,domProps:{"value":n}},[_vm._v(_vm._s(n))])}),0),_vm._v(" "),_c('span',[_vm._v("Entries")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.totalPages > 1),expression:"totalPages > 1"}],staticClass:"pagination-container form-group align-items-start justify-content-center mb-3 mb-md-0"},[_c('pagination',{attrs:{"total-pages":_vm.totalPages,"page":_vm.page,"on-change":_vm.setPage,"disabled":_vm.loading}})],1)]),_vm._v(" "),(_vm.selected.length > 0)?_c('div',{staticClass:"sticky-bottom alert bg-primary text-white d-flex flex-wrap align-items-center mb-0",attrs:{"role":"alert"}},[_c('div',{staticClass:"flex-grow-1 pr-3 text-center text-lg-left"},[_c('strong',[_vm._v("You have selected: ")]),_vm._v(" "),_vm._l((_vm.selected),function(row,i){return _c('span',{key:row.id},[_vm._v("\n          "+_vm._s(row.first_name)+" "+_vm._s(row.last_name)+_vm._s(i === _vm.selected.length - 1 ? '' : ',')+"\n        ")])})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-white btn-block-mob mt-2 mt-lg-0 text-nowrap",on:{"click":_vm.joinMembers}},[_vm._v("Join Selected")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-white ml-lg-2 btn-block-mob",on:{"click":function($event){$event.preventDefault();_vm.selected = []}}},[_vm._v("Cancel")])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberProfileMembers_vue__ = __webpack_require__(254);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57647f84_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberProfileMembers_vue__ = __webpack_require__(785);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberProfileMembers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57647f84_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberProfileMembers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":_vm.id,"disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event.target.checked)}}}),_vm._v(" "),_c('label',{class:['custom-control-label', 'mb-0', _vm.labelClass],attrs:{"for":_vm.id}},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('app-checkbox',{attrs:{"id":_vm.id,"value":_vm.value,"disabled":_vm.disabled || _vm.lockedOnMount,"label-class":['h6', { 'font-weight-normal': _vm.fontNormal }]},on:{"input":function($event){return _vm.$emit('input', $event)}}},[_vm._v("\n    "+_vm._s(_vm.label)),(_vm.required)?_c('span',{staticClass:"text-danger ml-1"},[_vm._v("*")]):_vm._e(),_vm._t("after-label")],2),_vm._v(" "),(_vm.hint)?_c('small',{staticClass:"form-text text-muted"},[_vm._v(_vm._s(_vm.hint))]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"text-danger small mt-1"},[_vm._v(_vm._s(_vm.error))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocContent_vue__ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ad4f92_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocContent_vue__ = __webpack_require__(730);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ad4f92_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Reusable documentation blocks about splitting an event. Each block is one self-contained
// paragraph group that can be shown on its own or composed into a doc (see ../docs.js).
// Body item types are described in ../README.md.
/* harmony default export */ __webpack_exports__["a"] = ([{
  id: 'split.intro',
  body: [{
    p: 'Splitting divides an event into two halves, A and B. Regular, combined, and conjunction events are split differently.'
  }]
}, {
  id: 'split.availability',
  title: 'When can an event be split?',
  body: [{
    p: 'An event can be split when:'
  }, {
    ul: ['The draft has **Finalise** status.', 'The event has **2 rounds**.', 'It is a top-level event (the original event, not one of its Event 1 / Event 2 child events).', 'It has not already been split. An event created as a result of a split cannot be split again, and a split event cannot be changed to Combined or Conjunction.', 'No draws have been generated for the event yet.']
  }, {
    p: 'To split an event, use the split icon in the Events table on the Committee dashboard. A split cannot be undone.'
  }]
}, {
  id: 'split.regular',
  title: 'Regular event',
  body: [{
    ul: ['The event is divided into **Event A** and **Event B**, both with the same settings and judges.', 'Declared Prize Money is divided equally between A and B.', 'Nominations are distributed alternately between the two sides: every second nomination moves to B.', 'Each half has its own draw.']
  }]
}, {
  id: 'split.combined',
  title: 'Combined event',
  body: [{
    ul: ['Two independent combined events are created: **Combined A** (Event 1 A + Event 2 A) and **Combined B** (Event 1 B + Event 2 B).', 'Each side has its own combined first round and two finals. This creates four finals in total: Event 1 A, Event 1 B, Event 2 A, and Event 2 B.', 'Declared Prize Money is divided equally between A and B.', 'A combined nomination (Event 1 & 2) always stays together. Both parts are assigned to A or both to B. Nominations are distributed alternately between the two sides.', 'When adding a nomination through Draws, only options for the current side are available. For example, on side A, the options are Event 1 A, Event 2 A, or Event 1 A + Event 2 A.']
  }]
}, {
  id: 'split.conjunction',
  title: 'Conjunction event',
  body: [{
    ul: ['The two events are not split into independent combined pairs. Instead, they become **Event 1 A** and **Event 1 B**, with their first rounds run separately.', 'One shared final is created for Event 2. Only nominations entered into the second event (for example, an Event 1 & 2 nomination) can progress to this final, regardless of whether they were assigned to A or B during the split.', 'An Event 1 & 2 nomination always stays together on the same side and is never separated.']
  }]
}, {
  id: 'split.after',
  title: 'After the split',
  body: [{
    ul: ['A secretary can move individual nominations between A and B using **Move To** on the Accepted Nominations area.', 'An Event 1 & 2 nomination always moves as a whole, and its draw moves with it.', 'The draw is not recalculated when a nomination is moved. The moved run takes the first available slot on the other side or, if there are no available slots, is placed last.']
  }]
}]);

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Reusable documentation blocks about events and the settings of the event form.
// Body item types are described in ../README.md.
/* harmony default export */ __webpack_exports__["a"] = ([{
  id: 'events.what',
  title: 'What is an event?',
  body: [{
    p: 'An event is a class of competition within a draft (for example, Open, Maiden, or Novice). Members nominate a horse and rider for an event, and once the draft is closed, draws are generated for each event.'
  }]
}, {
  id: 'events.kinds.intro',
  title: 'Kinds of events',
  body: [{
    p: 'There are three kinds of events. The two checkboxes at the top of the form determine the kind:'
  }, {
    ul: ['If neither is selected, it is a regular event.', 'If **Combined** is selected, it is a combined event.', 'If both **Combined** and **Conjunction** are selected, it is a conjunction event.']
  }]
}, {
  id: 'events.kind.regular',
  title: 'Regular event',
  body: [{
    p: 'A single event with its own cost, restrictions, rounds, and draw. Members nominate directly into the event.'
  }]
}, {
  id: 'events.kind.combined',
  title: 'Combined event',
  body: [{
    ul: ['Consists of two events (Event 1 and Event 2), for example, a combined Maiden/Novice event. Members have three options to nominate: Event 1, Event 2, or Event 1 & 2.', '**Cost with a discount** applies when a member enters both events.', 'A combined event always has **2 rounds**. The first round is shared by both events, and each event has its own final.', 'No Horse Required and Hidden event types cannot be combined.', 'Once Combined is enabled, it cannot be undone.']
  }]
}, {
  id: 'events.kind.conjunction',
  title: 'Conjunction event',
  body: [{
    ul: ['Similar to a combined event, but designed for an event that runs in conjunction with another event, for example, M4M run in conjunction with a Maiden. Members have two options to nominate: Event 1 or Event 1 & 2.', 'Event 2 can only be entered together with Event 1.', 'Once Conjunction is enabled, it cannot be undone.']
  }]
}, {
  id: 'events.types',
  body: [{
    p: 'Choosing a Type fills the form with that event type\'s default settings. Depending on the type, these may include:'
  }, {
    ul: ['Rounds (only for Open – N Round types)', 'Rider minimum and maximum age', 'Rider sex', 'Maiden rider flag', 'Horse age', 'Horse class restrictions']
  }, {
    p: 'You can change any of these settings afterwards. If you select a different event type, the defaults for the newly selected type are applied again.'
  }, {
    p: 'Every type and the defaults it applies:'
  }, {
    dynamic: 'event-types-table'
  }]
}, {
  id: 'events.rounds',
  title: 'Rounds',
  body: [{
    p: 'Rounds is the total number of rounds in an event, including the final, and can be set from 1 to 5. The Open – 1 Round to Open – 5 Round types set the number of rounds automatically. For other event types, you choose the number of rounds manually. A combined event always has 2 rounds.'
  }]
}, {
  id: 'events.judges',
  title: 'Number of Judges',
  body: [{
    ul: ['Number of Judges (1 to 3) determines how many judges score each run. Each judge enters a cutout, work, and course score.', 'The run\'s cutout, work, and course scores, as well as its total score, are calculated by averaging the scores across all judges.', 'The Judges field is used to assign judges to the event.']
  }]
}, {
  id: 'events.noHorse',
  title: 'No Horse Required events',
  body: [{
    ul: ['The No Horse Required type is for events that do not involve riding. Members enter without a horse, and no draw is generated.', 'Instead of Max Horses, it uses **Maximum Submissions Per Person**. Leave this blank or set it to 0 to allow unlimited submissions.', 'Rounds, horse restrictions, Number of Judges, Judges, and Declared Prize Money are disabled for this event type.', 'A No Horse Required event cannot be part of a combined event and does not appear on the Draws Dashboard.']
  }]
}]);

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Reusable documentation blocks about the Super Secretary flag (CAM-1533).
// Body item types are described in ../README.md.
/* harmony default export */ __webpack_exports__["a"] = ([{
  id: 'secretaries.super.what',
  title: 'What is a Super Secretary?',
  body: [{
    p: 'A Super Secretary is an existing Secretary (either a Member Secretary or Secretary Only) who has been granted additional access by an admin.'
  }, {
    p: 'Super Secretary is not a separate user role. It is an additional permission that allows selected secretaries to work across multiple committees without changing their existing permissions or functionality.'
  }]
}, {
  id: 'secretaries.super.why',
  title: 'Why is it needed?',
  body: [{
    p: 'ACA occasionally requires secretaries to provide support for other committees, particularly on weekends. Instead of creating additional accounts, Super Secretaries can log in with their own credentials and switch between committees as needed. This eliminates the need for temporary accounts or shared login credentials, improves security, and ensures that actions can be traced back to the person who performed them.'
  }]
}, {
  id: 'secretaries.super.how',
  title: 'How does it work?',
  body: [{
    ul: ['A Super Secretary retains full access to their own committee, along with their existing Member functionality.', 'A new **Switch Committee** option appears in the left-hand menu, allowing them to select another committee to work with without accessing other secretaries\' accounts, personal details, or passwords.', 'Only **financial** committees are available for selection.', 'When working with another committee, a yellow notification bar appears at the top of the page, showing which committee is currently selected.', 'Super Secretaries can manage the selected committee\'s nominations, drafts, draws, and reports. However, the **Committee** page is read-only, so they can view committee details but cannot make changes.']
  }]
}]);

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Docs are ordered lists of sections built from the reusable blocks in ./blocks.
// A section is one of:
//   'block.id'                                   a block shown inline
//   { accordion: true, title, doc: 'doc.id' }    collapsible, shows the sections of another doc
//   { accordion: true, title, sections: [...] }  collapsible, shows its own list of sections
/* harmony default export */ __webpack_exports__["a"] = ({
  'events.settings': {
    title: 'Event type and its settings',
    sections: ['events.types', 'events.rounds', 'events.judges', 'events.noHorse']
  },
  'events.split': {
    title: 'How splitting events works',
    sections: ['split.intro', 'split.availability', 'split.regular', 'split.combined', 'split.conjunction', 'split.after']
  },
  'secretaries.super': {
    title: 'Super Secretary',
    sections: ['secretaries.super.what', 'secretaries.super.why', 'secretaries.super.how']
  },
  'events.guide': {
    title: 'How events work',
    sections: ['events.what', 'events.kinds.intro', 'events.kind.regular', 'events.kind.combined', 'events.kind.conjunction', {
      accordion: true,
      title: 'Event type and its settings',
      doc: 'events.settings'
    }, {
      accordion: true,
      title: 'How splitting events works',
      doc: 'events.split'
    }]
  }
});

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocBlock_vue__ = __webpack_require__(262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78afbfc4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocBlock_vue__ = __webpack_require__(726);
function injectStyle (ssrContext) {
  __webpack_require__(720)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78afbfc4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 720 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocText_vue__ = __webpack_require__(263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6e2910c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocText_vue__ = __webpack_require__(722);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6e2910c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._l((_vm.segments),function(segment,index){return [(segment.bold)?_c('strong',{key:index},[_vm._v(_vm._s(segment.text))]):_c('span',{key:index},[_vm._v(_vm._s(segment.text))])]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocEventTypesTable_vue__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c703673_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocEventTypesTable_vue__ = __webpack_require__(725);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocEventTypesTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c703673_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocEventTypesTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = roundsText;
/* harmony export (immutable) */ __webpack_exports__["b"] = ridersText;
/* harmony export (immutable) */ __webpack_exports__["a"] = horsesText;
// Turns the `defaults` of an event type (see EventType::defaults() in the API) into the short
// texts shown in the event types table of the docs.
var HORSE_CLASS_LABELS = {
  1: 'Futurity',
  2: 'Maiden',
  3: 'Novice',
  4: 'Open',
  5: 'Any'
};
var SEX_LABELS = {
  1: 'Male',
  2: 'Female'
};

function ageText(min, max) {
  if (min > 0 && max > 0) return "Age ".concat(min, "-").concat(max);
  if (min > 0) return "Age ".concat(min, "+");
  if (max > 0) return "Age up to ".concat(max);
  return null;
}

function roundsText(defaults) {
  if (defaults.has_rounds === false) return '-';
  return defaults.rounds > 0 ? String(defaults.rounds) : 'Set manually';
}
function ridersText(defaults) {
  var parts = [ageText(defaults.riders_min_age, defaults.riders_max_age), SEX_LABELS[defaults.riders_sex] || null, defaults.riders_maiden ? 'Maiden riders only' : null].filter(Boolean);
  return parts.length ? parts.join(', ') : 'No restrictions';
}
function horsesText(defaults) {
  if (defaults.has_horse_restrictions === false) return '-';
  var classes = defaults.horse_classes || [];
  var parts = [ageText(defaults.horses_min_age, defaults.horses_max_age), classes.includes(5) || !classes.length ? 'Any class' : classes.map(function (id) {
    return HORSE_CLASS_LABELS[id];
  }).filter(Boolean).join(', ')].filter(Boolean);
  return parts.join(', ');
}

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rows.length)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm table-bordered doc-event-types"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.rows),function(row){return _c('tr',{key:row.id},[_c('td',[_vm._v(_vm._s(row.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.rounds))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.riders))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.horses))])])}),0)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Rounds")]),_vm._v(" "),_c('th',[_vm._v("Riders")]),_vm._v(" "),_c('th',[_vm._v("Horses")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.resolved)?_c('div',{staticClass:"doc-block"},[(_vm.resolved.title)?_c('h5',{staticClass:"doc-block__title mt-4"},[_vm._v(_vm._s(_vm.resolved.title))]):_vm._e(),_vm._v(" "),_vm._l((_vm.resolved.body),function(item,index){return [(item.p)?_c('p',{key:index},[_c('doc-text',{attrs:{"text":item.p}})],1):(item.ul)?_c('ul',{key:index},_vm._l((item.ul),function(line,lineIndex){return _c('li',{key:lineIndex},[_c('doc-text',{attrs:{"text":line}})],1)}),0):(item.dynamic && _vm.dynamicComponents[item.dynamic])?_c(_vm.dynamicComponents[item.dynamic],{key:index,tag:"component",attrs:{"context":_vm.context}}):_vm._e()]})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocAccordion_vue__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bba0fee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocAccordion_vue__ = __webpack_require__(729);
function injectStyle (ssrContext) {
  __webpack_require__(728)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocAccordion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bba0fee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocAccordion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doc-accordion"},[_c('button',{staticClass:"doc-accordion__header",attrs:{"type":"button","aria-expanded":String(_vm.isOpen)},on:{"click":function($event){_vm.isOpen = !_vm.isOpen}}},[_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('span',{staticClass:"doc-accordion__caret",class:{ 'doc-accordion__caret--open': _vm.isOpen }})]),_vm._v(" "),(_vm.isOpen)?_c('div',{staticClass:"doc-accordion__body"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doc-content text-left"},[_vm._l((_vm.resolvedSections),function(section,index){return [(section.accordion)?_c('doc-accordion',{key:index,attrs:{"title":section.title}},[_c('doc-content',{attrs:{"sections":section.sections,"context":_vm.context}})],1):_c('doc-block',{key:index,attrs:{"id":section.block,"context":_vm.context}})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"size":"lg"},on:{"close":function($event){return _vm.$emit('close')}}},[_c('h3',{staticClass:"mb-0",attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.title || _vm.docTitle))]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('doc-content',{attrs:{"doc":_vm.doc,"sections":_vm.sections,"context":_vm.context}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Close")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"super-secretary-toggle"},[_c('f-checkbox',{attrs:{"id":"super-secretary","label":"Super Secretary","hint":"Can switch between committees and work on their behalf.","value":_vm.checked,"disabled":_vm.processing},on:{"input":_vm.save}},[_c('button',{staticClass:"super-secretary-help ml-2",attrs:{"slot":"after-label","type":"button","aria-label":"What is a Super Secretary?","title":"What is a Super Secretary?"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.showDoc = true}},slot:"after-label"},[_vm._v("?")])]),_vm._v(" "),(_vm.showDoc)?_c('doc-modal',{attrs:{"doc":"secretaries.super"},on:{"close":function($event){_vm.showDoc = false}}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.inlineMessage)?_c('div',{key:_vm.inlineMessage.id,class:['alert mb-0 alert-pop', ("alert-" + (_vm.inlineMessage.type))],staticStyle:{"cursor":"pointer"},attrs:{"role":"alert","title":"Click to dismiss"},on:{"click":function($event){_vm.inlineMessage = null}}},[_vm._v("\n      "+_vm._s(_vm.inlineMessage.text)+"\n    ")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-none d-lg-block col-action-bar"},[_c('div',{staticClass:"sticky-top"},[_c('div',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4 border-top border-light"},[_c('h2',{staticClass:"h4 mb-4"},[_vm._v("Action")]),_vm._v(" "),_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{on:{"close":function($event){return _vm.$emit('cancel')}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning text-center mb-0"},[_c('strong',[_vm._v("Warning!")]),_vm._v(" "),_vm._t("default",[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.message))])])],2),_vm._v(" "),_vm._t("extra")],2),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"col-12 d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.$emit('confirm')}}},[_vm._v("Confirm")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary ml-2",on:{"click":function($event){$event.preventDefault();return _vm.$emit('cancel')}}},[_vm._v("Cancel")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PhoneBeforeFix_vue__ = __webpack_require__(269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7774ea06_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PhoneBeforeFix_vue__ = __webpack_require__(737);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PhoneBeforeFix_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7774ea06_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PhoneBeforeFix_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"mt-2"},[_c('small',{staticClass:"d-block text-muted"},[_vm._v("Before fix, the value in the DB was:")]),_vm._v(" "),_c('input',{staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":"","readonly":""},domProps:{"value":_vm.value}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.update($event)}}},[(_vm.memberDetails ? _vm.memberDetails.id ? true : false : false)?_c('div',{staticClass:"col px-0 pr-lg-3"},[_c('section',{staticClass:"card bg-white rounded mb-4 p-3 p-sm-4"},[_c('div',{staticClass:"d-flex align-items-center",attrs:{"aria-expanded":_vm.selectedSection === 'details',"aria-controls":"details","id":"detailsHeading"},on:{"click":function($event){$event.preventDefault();_vm.selectedSection !== 'details' ? _vm.selectedSection = 'details' : _vm.selectedSection = 'null'}}},[_c('h1',{staticClass:"h2 mb-0"},[_vm._v(_vm._s(_vm.split ? 'Split Member Details' : _vm.my ? 'My Details' : 'Details'))]),_vm._v(" "),(_vm.loggedInRole !== 'Volunteer' && _vm.memberDetails.getedRole !== 'Volunteer' ? (_vm.memberDetails ? _vm.memberDetails.financial ? true : false : false) : false)?_c('span',{staticClass:"mx-2 mx-sm-3 badge badge-info"},[_vm._v("Financial")]):(_vm.loggedInRole !== 'Volunteer' && _vm.memberDetails.getedRole !== 'Volunteer')?_c('span',{staticClass:"mx-2 mx-sm-3 badge alert-warning"},[_vm._v("Unfinancial")]):_vm._e(),_vm._v(" "),(_vm.selectedSection === 'details' && _vm.$store.state.showExpand)?_c('img',{staticClass:"ml-auto",attrs:{"width":"13","height":"6","aria-hidden":"true","alt":"","src":"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI2Ij48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJub25lIi8+PGcgY2xhc3M9ImN1cnJlbnRMYXllciI+PHBhdGggZmlsbD0iIzIzMTgxNSIgZD0iTTEyLjYgNmgtLjRMNy42IDEuNEM3IC44IDYgLjggNS41IDEuNEwuOSA2Yy0uMi4yLS41LjItLjcgMHMtLjItLjUgMC0uN0w0LjguN2MuOS0xIDIuNi0xIDMuNSAwbDQuNiA0LjZjLjIuMi4yLjUgMCAuN2gtLjN6Ii8+PC9nPjwvc3ZnPg=="}}):(_vm.$store.state.showExpand)?_c('img',{staticClass:"ml-auto",attrs:{"width":"13","height":"6","aria-hidden":"true","alt":"","src":"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI2Ij48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJub25lIi8+PGcgY2xhc3M9ImN1cnJlbnRMYXllciI+PHBhdGggZmlsbD0iIzIzMTgxNSIgZD0iTTYuNSA2LjJjLS43IDAtMS4zLS4zLTEuOC0uN0wuMS45QzAgLjcgMCAuNC4xLjJzLjUtLjIuNyAwbDQuNiA0LjZjLjYuNiAxLjUuNiAyLjEgMEwxMi4xLjJjLjItLjIuNS0uMi43IDBzLjIuNSAwIC43TDguMiA1LjVjLS40LjQtMSAuNy0xLjcuN3oiLz48L2c+PC9zdmc+"}}):_vm._e()]),_vm._v(" "),(_vm.success)?_c('div',{staticClass:"alert alert-success mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.success))]):(_vm.errors)?_c('div',{staticClass:"alert alert-warning mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors))]):_vm._e(),_vm._v(" "),((_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin') || (_vm.loggedInRole != 'SecretaryOnly' && (_vm.memberDetails.id == _vm.loggedInId) && _vm.loggedInRole != 'Volunteer' && _vm.memberDetails.getedRole !== 'Volunteer') && !_vm.split && _vm.memberDetails ? _vm.memberDetails.product_options.length > 0 || (_vm.memberDetails.secondaries ? _vm.memberDetails.secondaries.some(function (member) { return member.product_options.length > 0; }) : false) : false)?_c('div',{staticClass:"alert alert-info mt-3 mb-0 d-lg-flex justify-content-between align-items-center text-center text-lg-left",attrs:{"role":"alert"}},[_c('span',[_vm._v("\n          Membership ready for payment.\n          "),(_vm.memberDetails.upgrade_available)?_c('span',[_c('br'),_vm._v("This member is eligible for upgrade.")]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-block-mob btn-primary ml-lg-auto mt-2 mt-lg-0",on:{"click":function($event){$event.preventDefault();return _vm.$emit('renew')}}},[_vm._v("Pay Membership")])]):(!_vm.split && _vm.memberDetails && _vm.memberDetails.upgrade_available)?_c('div',{staticClass:"alert alert-info mb-0 d-lg-flex justify-content-between align-items-center text-center text-lg-left",attrs:{"role":"alert"}},[_vm._v("\n        This member is eligible for upgrade.\n        "),_c('button',{staticClass:"btn btn-block-mob btn-primary ml-lg-auto mt-2 mt-lg-0",on:{"click":function($event){$event.preventDefault();return _vm.$emit('renew')}}},[_vm._v("Upgrade Membership")])]):_vm._e(),_vm._v(" "),_c('VueSlideToggle',{staticClass:"pt-2",attrs:{"open":_vm.selectedSection === 'details' || !_vm.$store.state.showExpand,"id":"details","aria-labelledby":"detailsHeading"}},[_c('div',{staticClass:"f-form pt-3"},[((_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin') && _vm.memberDetails.getedRole !== 'Volunteer' )?_c('div',{staticClass:"f-form__full"},[_c('strong',[_vm._v("Financial Seasons: ")]),_vm._v(" "),_vm._l((_vm.memberDetails.seasons),function(value,key,index){return _c('span',{key:key},[_c('span',{class:['badge ml-1 my-auto', {'alert-danger': value === 0, 'alert-success': value === 1}],attrs:{"title":[ value === 0 ? 'Unfinancial' : 'Financial']}},[_vm._v(_vm._s(key))])])})],2):_vm._e(),_vm._v(" "),((_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin'))?_c('div',{staticClass:"f-form__full form-group"},[_c('label',{attrs:{"for":"notes"}},[_vm._v("Notes")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.notes),expression:"memberUpdate.notes"}],staticClass:"form-control",attrs:{"id":"notes"},domProps:{"value":(_vm.memberUpdate.notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate, "notes", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"f-form__pair f-form__pair--1-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"title"}},[_vm._v("Title")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.title),expression:"memberUpdate.title"}],staticClass:"form-control",attrs:{"id":"title","required":"","disabled":_vm.disableField},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.memberUpdate, "title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',{attrs:{"value":"Mr"}},[_vm._v("Mr")]),_vm._v(" "),_c('option',{attrs:{"value":"Ms"}},[_vm._v("Ms")]),_vm._v(" "),_c('option',{attrs:{"value":"Miss"}},[_vm._v("Miss")]),_vm._v(" "),_c('option',{attrs:{"value":"Mrs"}},[_vm._v("Mrs")]),_vm._v(" "),_c('option',{attrs:{"value":"Dr"}},[_vm._v("Dr")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your title.")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"firstName"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.first_name),expression:"memberUpdate.first_name"}],staticClass:"form-control",attrs:{"type":"text","id":"firstName","required":"","disabled":_vm.disableField},domProps:{"value":(_vm.memberUpdate.first_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate, "first_name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your First Name.")])])]),_vm._v(" "),_c('div',{staticClass:"f-form__half form-group"},[_c('label',{attrs:{"for":"lastName"}},[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.last_name),expression:"memberUpdate.last_name"}],staticClass:"form-control",attrs:{"type":"text","id":"lastName","required":"","disabled":_vm.disableField},domProps:{"value":(_vm.memberUpdate.last_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate, "last_name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Last Name.")])]),_vm._v(" "),_c('div',{staticClass:"f-form__pair"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"gender"}},[_vm._v("Gender")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.gender),expression:"memberUpdate.gender"}],staticClass:"form-control",attrs:{"id":"gender","required":"","disabled":_vm.disableField},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.memberUpdate, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',[_vm._v("Male")]),_vm._v(" "),_c('option',[_vm._v("Female")]),_vm._v(" "),_c('option',[_vm._v("Unspecified")])]),_vm._v(" "),((_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin') && _vm.memberUpdate.gender === 'Female')?_c('small',[_vm._v("Lady Rider")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"riderStatus"}},[_vm._v("Rider Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.rider_status_id),expression:"memberUpdate.rider_status_id"}],staticClass:"form-control",attrs:{"id":"riderStatus","required":_vm.loggedInRole !== 'Member' && _vm.loggedInRole !== 'Secretary',"disabled":_vm.disableField || (_vm.loggedInRole !== 'Admin' && _vm.loggedInRole !== 'SuperAdmin')},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.memberUpdate, "rider_status_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"selected":!_vm.memberUpdate.rider_status_id}}),_vm._v(" "),_vm._l((_vm.$store.state.riderStatus),function(status,statusIndex){return _c('option',{key:statusIndex,domProps:{"value":status.id,"selected":_vm.memberUpdate.rider_status_id === status.id}},[_vm._v(_vm._s(status.name))])})],2),_vm._v(" "),((_vm.loggedInRole !== 'Admin' && _vm.loggedInRole !== 'SuperAdmin'))?_c('small',[_vm._v("If you need to update your status please contact the ACA office in business hours")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Rider Status.")])])]),_vm._v(" "),_c('div',{staticClass:"f-form__half form-group"},[_c('label',{attrs:{"for":"dateOfBirth"}},[_vm._v("Date of Birth")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.dateOfBirth),expression:"memberUpdate.dateOfBirth"}],class:['form-control form-date pl-md-2 pr-md-0 px-xl-3', _vm.errorStatus === 'dob' ? 'is-invalid' : ''],attrs:{"max":_vm.today(),"required":"","placeholder":[_vm.isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy'],"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}","id":"dateOfBirth","type":"date","disabled":_vm.disableField},domProps:{"value":(_vm.memberUpdate.dateOfBirth)},on:{"change":function($event){return _vm.calcType(-1)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate, "dateOfBirth", $event.target.value)}}}),_vm._v(" "),((_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin'))?_c('small',[_vm._v(_vm._s(_vm.isUnder8 ? 'Mini' : _vm.isUnder13 ? 'Junior' : _vm.isUnder17 ? 'Juvenile' : _vm.isUnder21 ? 'Associate' : _vm.isOver55 ? 'Master Rider' : ''))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Date of Birth"+_vm._s(_vm.isLegacy() ? ' in the format yyyy-mm-dd' : '')+".")])]),_vm._v(" "),((_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin') && _vm.memberUpdate.boy_status_id)?_c('div',{staticClass:"f-form__half form-group"},[_c('label',{attrs:{"for":"boyStatus"}},[_vm._v("Beginning of Year Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.boy_status_id),expression:"memberUpdate.boy_status_id"}],staticClass:"form-control",attrs:{"id":"boyStatus","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.memberUpdate, "boy_status_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"selected":!_vm.memberUpdate.boy_status_id}}),_vm._v(" "),_vm._l((_vm.$store.state.riderStatus),function(status,statusIndex){return _c('option',{key:statusIndex,domProps:{"value":status.id,"selected":_vm.memberUpdate.boy_status_id === status.id}},[_vm._v(_vm._s(status.name))])})],2),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Rider Status.")])]):_vm._e(),_vm._v(" "),(_vm.memberDetails.primary != null)?_c('div',{staticClass:"f-form__half form-group"},[_c('label',{attrs:{"for":"secondary_email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.secondary_email),expression:"memberUpdate.secondary_email"}],class:['form-control', _vm.errorStatus === 'secondary_email' ? 'is-invalid' : ''],attrs:{"type":"email","id":"secondary_email","maxlength":"40"},domProps:{"value":(_vm.memberUpdate.secondary_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate, "secondary_email", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v(_vm._s(_vm.errorStatus === 'secondary_email' ? 'Please include correct email.' : ''))])]):_vm._e(),_vm._v(" "),(_vm.memberDetails.primary != null)?_c('div',{staticClass:"f-form__half form-group"},[_c('label',{attrs:{"for":"secondary_phone"}},[_vm._v("Mobile number")]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the phone number.")]),_vm._v(" "),_c('phone-input',{class:[_vm.errorStatus === 'incorrect_phone' ? 'is-invalid' : ''],attrs:{"id":"secondary_phone"},model:{value:(_vm.memberUpdate.secondary_phone),callback:function ($$v) {_vm.$set(_vm.memberUpdate, "secondary_phone", $$v)},expression:"memberUpdate.secondary_phone"}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v(_vm._s(_vm.errorStatus === 'incorrect_phone' ? 'Please include correct phone number.' : 'Please include your phone number.'))]),_vm._v(" "),_c('small',[_vm._v("Please enter the phone in a similar format +614 **** **** without spaces")]),_vm._v(" "),_c('test-phone-numbers'),_vm._v(" "),_c('phone-before-fix',{attrs:{"value":_vm.phonesBeforeFix.secondary_phone}})],1):_vm._e(),_vm._v(" "),(_vm.memberDetails.primary != null)?_c('div',{staticClass:"f-form__half form-group"},[_c('label',{attrs:{"for":"carbon_copy_mobile"}},[_vm._v("CC Mobile "),_c('small',{staticClass:"d-inline-block"},[_vm._v("(optional)")])]),_vm._v(" "),_c('phone-input',{class:[_vm.errorStatus === 'carbon_copy_mobile' ? 'is-invalid' : ''],attrs:{"id":"carbon_copy_mobile"},model:{value:(_vm.memberDetails.carbon_copy_mobile),callback:function ($$v) {_vm.$set(_vm.memberDetails, "carbon_copy_mobile", $$v)},expression:"memberDetails.carbon_copy_mobile"}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please enter correct CC mobile")]),_vm._v(" "),_c('small',[_vm._v("Please enter the phone in a similar format +614 **** **** without spaces")]),_vm._v(" "),_c('test-phone-numbers'),_vm._v(" "),_c('phone-before-fix',{attrs:{"value":_vm.phonesBeforeFix.carbon_copy_mobile}})],1):_vm._e(),_vm._v(" "),((_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin'))?_c('div',{staticClass:"f-form__half form-group"},[_c('label',{attrs:{"for":"membershipStatus"}},[_vm._v("Member Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.membership_status),expression:"memberUpdate.membership_status"}],staticClass:"form-control px-md-2 px-xl-3",attrs:{"id":"membershipStatus","required":"","disabled":(_vm.loggedInRole !== 'Admin' && _vm.loggedInRole !== 'SuperAdmin')},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.memberUpdate, "membership_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',{attrs:{"value":"Active"}},[_vm._v("Active")]),_vm._v(" "),_c('option',{attrs:{"value":"Archived"}},[_vm._v("Archived")]),_vm._v(" "),_c('option',{attrs:{"value":"Onhold"}},[_vm._v("On Hold")]),_vm._v(" "),_c('option',{attrs:{"value":"Lifetime"}},[_vm._v("Lifetime")]),_vm._v(" "),_c('option',{attrs:{"value":"Suspended"}},[_vm._v("Suspended")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Membership Status.")])]):_vm._e(),_vm._v(" "),((_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin') || _vm.memberUpdate.member_number)?_c('div',{staticClass:"f-form__half form-group"},[_c('label',{attrs:{"for":"memberNumber"}},[_vm._v("Member Number")]),_vm._v(" "),_c('div',{staticClass:"input-append"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.member_number),expression:"memberUpdate.member_number"}],staticClass:"form-control",class:['form-control', _vm.errorStatus === 'member_number' ? 'is-invalid' : ''],attrs:{"type":"text","id":"memberNumber","readonly":(_vm.loggedInRole !== 'Admin' && _vm.loggedInRole !== 'SuperAdmin')},domProps:{"value":(_vm.memberUpdate.member_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate, "member_number", $event.target.value)}}}),_vm._v(" "),(_vm.memberDetails.primary === null && !_vm.memberUpdate.membership_type_id && (_vm.loggedInRole !== 'Admin' && _vm.loggedInRole !== 'SuperAdmin'))?_c('span',{staticClass:"append badge badge-prim"},[_vm._v("Primary")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v(_vm._s(_vm.errorStatus === 'member_number' ? 'Please include another member number.' : ''))])])]):_vm._e(),_vm._v(" "),((_vm.loggedInRole !== 'SecretaryOnly') ||
              ((_vm.loggedInRole === 'SecretaryOnly') && (_vm.memberDetails.id != _vm.loggedInId)))?_c('div',{staticClass:"f-form__half form-group"},[_c('label',{attrs:{"for":"proofOfAge"}},[_vm._v("Proof of Age")]),_vm._v(" "),_c('div',{staticClass:"custom-file"},[_c('input',{class:['custom-file-input font-weight-normal', { 'is-invalid': _vm.errorStatus === 'file' }],attrs:{"type":"file","id":"proofOfAge","accept":"image/*, application/pdf","disabled":_vm.disableField},on:{"change":_vm.fileUpload}}),_vm._v(" "),_c('label',{class:[{ 'no-after': _vm.disableField}, 'custom-file-label font-weight-normal'],attrs:{"for":"proofOfAge"}},[_vm._v(_vm._s(_vm.file_name ? _vm.file_name : 'Choose file...'))]),_vm._v(" "),_c('small',[_vm._v("jpg, jpeg, png, tiff, gif, pdf file type required.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Your ID will be stored in a secure data storage")]),_vm._v(" "),(_vm.file_name)?_c('button',{staticClass:"btn btn-link px-2 pl-md-0 px-xl-2 pr-md-1",attrs:{"type":"button","disabled":_vm.disableField},on:{"click":_vm.deleteAttachment}},[_c('span',{staticClass:"sr-only"},[_vm._v("Delete File")]),_vm._v(" "),_c('div',{staticClass:"btn-remove"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"}})])])])]):_vm._e()]),_vm._v(" "),(this.file_path)?_c('div',{staticClass:"attached-file-wrapper"},[_vm._v("\n              "+_vm._s(this.exists_file_name)+"\n              "),(!_vm.disableField || (_vm.loggedInRole === 'Secretary') || (_vm.loggedInRole === 'SecretaryOnly'))?_c('div',{staticClass:"btn-remove-file",on:{"click":_vm.deleteExistsAttachment}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btn-download-file",on:{"click":function($event){return _vm.downloadAgeProofFile(_vm.memberDetails.id)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"}})])])])]):_vm._e()]):_vm._e(),_vm._v(" "),((_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin') && _vm.memberDetails.primary === null)?_c('div',{staticClass:"f-form__half form-group"},[_c('label',{attrs:{"for":"role"}},[_vm._v("Role")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.role),expression:"memberUpdate.role"}],staticClass:"form-control px-md-2 px-xl-3",attrs:{"id":"role","required":"","disabled":(_vm.loggedInRole !== 'Admin' && _vm.loggedInRole !== 'SuperAdmin')},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.memberUpdate, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Member"}},[_vm._v("Member")]),_vm._v(" "),_c('option',{attrs:{"value":"Secretary"}},[_vm._v("Secretary")]),_vm._v(" "),_c('option',{attrs:{"value":"Volunteer"}},[_vm._v("Volunteer")])])]):_vm._e(),_vm._v(" "),((_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin') && _vm.memberDetails.primary === null && _vm.memberDetails.role === 'Secretary')?_c('div',{staticClass:"f-form__full"},[_c('super-secretary-toggle',{attrs:{"inline-alert":"","memberId":_vm.memberDetails.id},model:{value:(_vm.memberDetails.is_super_secretary),callback:function ($$v) {_vm.$set(_vm.memberDetails, "is_super_secretary", $$v)},expression:"memberDetails.is_super_secretary"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"f-form__full d-block d-lg-none"},[_c('button',{class:['btn btn-block d-lg-none mb-2', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],attrs:{"type":"submit"},on:{"click":_vm.handleSubmit}},[_vm._v("\n              "+_vm._s(!_vm.processing ? _vm.split ? 'Publish' : 'Update Details' : '')+"\n              "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]),_vm._v(" "),(_vm.memberDetails ? !_vm.memberDetails.financial || (_vm.memberDetails.secondaries ? _vm.memberDetails.secondaries.some(function (member) { return member.financial === 0; }) : false) : false)?_c('button',{staticClass:"btn btn-outline-primary btn-block ml-lg-2",on:{"click":function($event){$event.preventDefault();return _vm.$emit('renew')}}},[_vm._v("Pay Membership")]):_vm._e(),_vm._v(" "),(_vm.memberDetails && (_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin'))?_c('router-link',{staticClass:"btn btn-outline-primary btn-block ml-lg-2",attrs:{"tag":"a","to":{ name: 'Nominate Rookie', params: { member: { id: _vm.memberDetails.id, name: _vm.memberDetails.first_name + ' ' + _vm.memberDetails.last_name } } }}},[_vm._v("Nominate Horses")]):_vm._e(),_vm._v(" "),(_vm.memberDetails && (_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin'))?_c('router-link',{staticClass:"btn btn-outline-primary btn-block ml-lg-2 mt-2",attrs:{"tag":"a","to":{ name: 'Merge Member' }}},[_vm._v("Merge Accounts")]):_vm._e()],1)])])],1),_vm._v(" "),((_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin'))?_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('h2',{staticClass:"mb-0"},[_vm._v("Membership Details")]),_vm._v(" "),_c('VueSlideToggle',{staticClass:"pt-2",attrs:{"open":_vm.selectedSection === 'membership' || !_vm.$store.state.showExpand,"id":"membership","aria-labelledby":"membershipHeading"}},[_c('div',{staticClass:"col-12 col-md-auto form-group"},[_c('label',{attrs:{"for":"effectiveDate"}},[_vm._v("Effective Date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.effective_date),expression:"memberUpdate.effective_date"}],class:['form-control form-date pl-md-2 pr-md-0 px-xl-3', _vm.errorStatus === 'effective_date' ? 'is-invalid' : ''],attrs:{"placeholder":[_vm.isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy'],"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}","id":"effectiveDate","type":"date"},domProps:{"value":(_vm.memberUpdate.effective_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate, "effective_date", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include Effective Date"+_vm._s(_vm.isLegacy() ? ' in the format yyyy-mm-dd' : '')+".")])])])],1):_vm._e(),_vm._v(" "),(_vm.memberDetails.primary === null || _vm.split)?_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('div',{staticClass:"d-flex align-items-center",attrs:{"aria-expanded":_vm.selectedSection === 'contact',"aria-controls":"contact","id":"contactHeading"},on:{"click":function($event){$event.preventDefault();_vm.selectedSection !== 'contact' ? _vm.selectedSection = 'contact' : _vm.selectedSection = 'null'}}},[_c('h2',{staticClass:"mb-0"},[_vm._v("Contact Details")]),_vm._v(" "),(_vm.selectedSection === 'contact' && _vm.$store.state.showExpand)?_c('img',{staticClass:"ml-auto",attrs:{"width":"13","height":"6","aria-hidden":"true","alt":"","src":"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI2Ij48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJub25lIi8+PGcgY2xhc3M9ImN1cnJlbnRMYXllciI+PHBhdGggZmlsbD0iIzIzMTgxNSIgZD0iTTEyLjYgNmgtLjRMNy42IDEuNEM3IC44IDYgLjggNS41IDEuNEwuOSA2Yy0uMi4yLS41LjItLjcgMHMtLjItLjUgMC0uN0w0LjguN2MuOS0xIDIuNi0xIDMuNSAwbDQuNiA0LjZjLjIuMi4yLjUgMCAuN2gtLjN6Ii8+PC9nPjwvc3ZnPg=="}}):(_vm.$store.state.showExpand)?_c('img',{staticClass:"ml-auto",attrs:{"width":"13","height":"6","aria-hidden":"true","alt":"","src":"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI2Ij48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJub25lIi8+PGcgY2xhc3M9ImN1cnJlbnRMYXllciI+PHBhdGggZmlsbD0iIzIzMTgxNSIgZD0iTTYuNSA2LjJjLS43IDAtMS4zLS4zLTEuOC0uN0wuMS45QzAgLjcgMCAuNC4xLjJzLjUtLjIuNyAwbDQuNiA0LjZjLjYuNiAxLjUuNiAyLjEgMEwxMi4xLjJjLjItLjIuNS0uMi43IDBzLjIuNSAwIC43TDguMiA1LjVjLS40LjQtMSAuNy0xLjcuN3oiLz48L2c+PC9zdmc+"}}):_vm._e()]),_vm._v(" "),_c('VueSlideToggle',{staticClass:"pt-2",attrs:{"open":_vm.selectedSection === 'contact' || !_vm.$store.state.showExpand,"id":"contact","aria-labelledby":"contactHeading"}},[_c('div',{staticClass:"row pt-3"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberDetails.attributes.email),expression:"memberDetails.attributes.email"}],class:['form-control', _vm.errorStatus === 'email' && _vm.errors ? 'is-invalid' : ''],attrs:{"type":"email","id":"email","required":""},domProps:{"value":(_vm.memberDetails.attributes.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberDetails.attributes, "email", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v(_vm._s(_vm.errorStatus === 'email' && _vm.errors ? _vm.errors : 'Please include correct Email Address.'))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"phone"}},[_vm._v("Phone Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberDetails.attributes.phone),expression:"memberDetails.attributes.phone"}],staticClass:"form-control",attrs:{"type":"text","id":"phone","required":!_vm.memberDetails.attributes.mobile_phone},domProps:{"value":(_vm.memberDetails.attributes.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberDetails.attributes, "phone", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include either a Phone or Mobile Number.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"mobile"}},[_vm._v("Mobile Number "),_c('small',{staticClass:"d-inline-block"},[_vm._v("(optional)")])]),_vm._v(" "),_c('phone-input',{class:[_vm.errorStatus === 'mobile_phone' && _vm.memberDetails.attributes.mobile_phone != '' ? 'is-invalid' : ''],attrs:{"id":"mobile","required":!_vm.memberDetails.attributes.phone},model:{value:(_vm.memberDetails.attributes.mobile_phone),callback:function ($$v) {_vm.$set(_vm.memberDetails.attributes, "mobile_phone", $$v)},expression:"memberDetails.attributes.mobile_phone"}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please enter the correct mobile number")]),_vm._v(" "),_c('small',[_vm._v("Please enter the phone in a similar format +614 **** **** without spaces")]),_vm._v(" "),_c('test-phone-numbers'),_vm._v(" "),_c('phone-before-fix',{attrs:{"value":_vm.phonesBeforeFix.mobile_phone}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"carbon_copy_mobile"}},[_vm._v("CC Mobile "),_c('small',{staticClass:"d-inline-block"},[_vm._v("(optional)")])]),_vm._v(" "),_c('phone-input',{class:[_vm.errorStatus === 'carbon_copy_mobile' ? 'is-invalid' : ''],attrs:{"id":"carbon_copy_mobile"},model:{value:(_vm.memberDetails.carbon_copy_mobile),callback:function ($$v) {_vm.$set(_vm.memberDetails, "carbon_copy_mobile", $$v)},expression:"memberDetails.carbon_copy_mobile"}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please enter the correct CC mobile")]),_vm._v(" "),_c('small',[_vm._v("Please enter the phone in a similar format +614 **** **** without spaces")]),_vm._v(" "),_c('test-phone-numbers'),_vm._v(" "),_c('phone-before-fix',{attrs:{"value":_vm.phonesBeforeFix.carbon_copy_mobile}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"address1"}},[_vm._v("Address Line 1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.attributes.address.street_1),expression:"memberUpdate.attributes.address.street_1"}],staticClass:"form-control",attrs:{"type":"text","id":"address1","required":"","disabled":_vm.disableField},domProps:{"value":(_vm.memberUpdate.attributes.address.street_1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate.attributes.address, "street_1", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Address.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"address2"}},[_vm._v("Address Line 2 "),_c('small',[_vm._v("(optional)")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.attributes.address.street_2),expression:"memberUpdate.attributes.address.street_2"}],staticClass:"form-control",attrs:{"type":"text","id":"address2","disabled":_vm.disableField},domProps:{"value":(_vm.memberUpdate.attributes.address.street_2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate.attributes.address, "street_2", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"suburb"}},[_vm._v("Suburb")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.attributes.address.suburb),expression:"memberUpdate.attributes.address.suburb"}],staticClass:"form-control",attrs:{"type":"text","id":"suburb","required":"","disabled":_vm.disableField},domProps:{"value":(_vm.memberUpdate.attributes.address.suburb)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate.attributes.address, "suburb", $event.target.value)},function($event){return _vm.findZoneBy('suburb')}]}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Suburb.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 row no-gutters"},[_c('div',{staticClass:"col-12 col-md-6 col-md-auto form-group"},[_c('label',{attrs:{"for":"postcode"}},[_vm._v("Postcode")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.attributes.address.postcode),expression:"memberUpdate.attributes.address.postcode"}],staticClass:"form-control",attrs:{"type":"text","id":"postcode","required":"","pattern":"\\d{4}","disabled":_vm.disableField},domProps:{"value":(_vm.memberUpdate.attributes.address.postcode)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate.attributes.address, "postcode", $event.target.value)},function($event){return _vm.findZoneBy('postcode')}]}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include a four-digit Postcode.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-md pl-md-3 form-group"},[_c('label',{attrs:{"for":"state"}},[_vm._v("State")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.attributes.address.state),expression:"memberUpdate.attributes.address.state"}],staticClass:"form-control",attrs:{"id":"state","required":"","disabled":_vm.disableField},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.memberUpdate.attributes.address, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',{attrs:{"value":"QLD"}},[_vm._v("Queensland")]),_vm._v(" "),_c('option',{attrs:{"value":"NSW"}},[_vm._v("New South Wales")]),_vm._v(" "),_c('option',{attrs:{"value":"VIC"}},[_vm._v("Victoria")]),_vm._v(" "),_c('option',{attrs:{"value":"ACT"}},[_vm._v("Australian Capital Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"SA"}},[_vm._v("South Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"NT"}},[_vm._v("Northern Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"WA"}},[_vm._v("Western Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"TAS"}},[_vm._v("Tasmania")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your State.")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-4 form-group"},[_c('label',{attrs:{"for":"zone"}},[_vm._v("Zone")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.attributes.zone_id),expression:"memberUpdate.attributes.zone_id"}],staticClass:"form-control",attrs:{"id":"zone","required":"","disabled":(_vm.loggedInRole !== 'Admin' && _vm.loggedInRole !== 'SuperAdmin')},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.memberUpdate.attributes, "zone_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Unspecified")]),_vm._v(" "),_vm._l((_vm.$store.state.listZones.filter(function (zone) { return !zone.deleted_at; })),function(zone,index){return _c('option',{key:index,domProps:{"value":zone.id}},[_vm._v(_vm._s(zone.code))])})],2),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Zone.")]),_vm._v(" "),(_vm.zoneNotFound)?_c('div',{staticClass:"alert alert-warning alert-sm"},[_vm._v("Unable to find matching Zone.")]):(_vm.zoneFound)?_c('div',{staticClass:"alert alert-success alert-sm"},[_vm._v("Found matching Zone.")]):_c('div',{staticClass:"alert alert-sm"},[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"col-12"}),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"abn"}},[_vm._v("ABN")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberDetails.attributes.abn),expression:"memberDetails.attributes.abn"}],class:['form-control', _vm.errorStatus === 'abn' ? 'is-invalid' : ''],attrs:{"type":"number","id":"abn","disabled":_vm.disableField},domProps:{"value":(_vm.memberDetails.attributes.abn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberDetails.attributes, "abn", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("ABN must be 11 digits.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"bank_account_name"}},[_vm._v("Bank Account Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberDetails.attributes.bank_account_name),expression:"memberDetails.attributes.bank_account_name"}],class:['form-control', _vm.errorStatus === 'bank_account_name' ? 'is-invalid' : ''],attrs:{"type":"text","id":"bank_account_name","maxlength":"40","required":(_vm.loggedInRole !== 'Admin' && _vm.loggedInRole !== 'SuperAdmin'),"disabled":_vm.disableField},domProps:{"value":(_vm.memberDetails.attributes.bank_account_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberDetails.attributes, "bank_account_name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include Bank Account Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"bank_bsb"}},[_vm._v("Bank BSB")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberDetails.attributes.bank_bsb),expression:"memberDetails.attributes.bank_bsb"}],class:['form-control', _vm.errorStatus === 'bank_bsb' ? 'is-invalid' : ''],attrs:{"type":"text","id":"bank_bsb","maxlength":"40","required":(_vm.loggedInRole !== 'Admin' && _vm.loggedInRole !== 'SuperAdmin'),"disabled":_vm.disableField},domProps:{"value":(_vm.memberDetails.attributes.bank_bsb)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberDetails.attributes, "bank_bsb", $event.target.value)},_vm.validateBankBsb]}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please enter the correct bank's BSB")]),_vm._v(" "),_c('small',[_vm._v("Please enter the bank's BSB in the format XXX-YYY")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"bank_account_number"}},[_vm._v("Bank Account Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberDetails.attributes.bank_account_number),expression:"memberDetails.attributes.bank_account_number"}],class:['form-control', _vm.errorStatus === 'bank_account_number' ? 'is-invalid' : ''],attrs:{"type":"text","id":"bank_account_number","maxlength":"40","required":(_vm.loggedInRole !== 'Admin' && _vm.loggedInRole !== 'SuperAdmin'),"disabled":_vm.disableField},domProps:{"value":(_vm.memberDetails.attributes.bank_account_number)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberDetails.attributes, "bank_account_number", $event.target.value)},_vm.validateBankAccountNumber]}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please enter the correct Bank Account Number.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 form-group"},[_c('div',{staticClass:"form-group form-check px-0 mb-sm-4"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberDetails.attributes.gst_registered),expression:"memberDetails.attributes.gst_registered"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"gstRegistered","disabled":_vm.disableField},domProps:{"checked":Array.isArray(_vm.memberDetails.attributes.gst_registered)?_vm._i(_vm.memberDetails.attributes.gst_registered,null)>-1:(_vm.memberDetails.attributes.gst_registered)},on:{"change":function($event){var $$a=_vm.memberDetails.attributes.gst_registered,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.memberDetails.attributes, "gst_registered", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.memberDetails.attributes, "gst_registered", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.memberDetails.attributes, "gst_registered", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"gstRegistered"}},[_vm._v("\n                  I am GST Registered\n                ")])])])]),_vm._v(" "),(_vm.isUnder17 || (_vm.memberUpdate.guardian.consent && _vm.isUnder17) || ((_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin') && _vm.isUnder17))?_c('div',{staticClass:"col-12 form-group"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.guardian.consent),expression:"memberUpdate.guardian.consent"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"parentalConsent","required":""},domProps:{"checked":Array.isArray(_vm.memberUpdate.guardian.consent)?_vm._i(_vm.memberUpdate.guardian.consent,null)>-1:(_vm.memberUpdate.guardian.consent)},on:{"change":function($event){var $$a=_vm.memberUpdate.guardian.consent,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.memberUpdate.guardian, "consent", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.memberUpdate.guardian, "consent", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.memberUpdate.guardian, "consent", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"parentalConsent"}},[_vm._v("Parent or guardian gives consent.")])])]):_vm._e()]),_vm._v(" "),(_vm.memberUpdate.guardian.consent && _vm.isUnder17)?_c('div',[_c('h3',{staticClass:"mb-4"},[_vm._v("Parent / Guardian Details")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 pr-lg-2 form-group"},[_c('label',{attrs:{"for":"parentFirstName"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.guardian.first_name),expression:"memberUpdate.guardian.first_name"}],staticClass:"form-control",attrs:{"type":"text","id":"parentFirstName","required":""},domProps:{"value":(_vm.memberUpdate.guardian.first_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate.guardian, "first_name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the First Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"parentLastName"}},[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.guardian.last_name),expression:"memberUpdate.guardian.last_name"}],staticClass:"form-control",attrs:{"type":"text","id":"parentLastName","required":""},domProps:{"value":(_vm.memberUpdate.guardian.last_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate.guardian, "last_name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Last Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-lg-2 form-group"},[_c('label',{attrs:{"for":"parentEmail"}},[_vm._v("Email Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.guardian.email),expression:"memberUpdate.guardian.email"}],staticClass:"form-control",attrs:{"type":"email","id":"parentEmail","required":""},domProps:{"value":(_vm.memberUpdate.guardian.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate.guardian, "email", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Email Address.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"mobile"}},[_vm._v("Phone Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.guardian.phone),expression:"memberUpdate.guardian.phone"}],staticClass:"form-control",attrs:{"type":"text","id":"mobile","required":""},domProps:{"value":(_vm.memberUpdate.guardian.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate.guardian, "phone", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Phone Number.")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 px-0 d-flex d-lg-none justify-content-end"},[_c('button',{staticClass:"btn btn-primary btn-block-mob",on:{"click":_vm.handleSubmit}},[_vm._v(_vm._s(_vm.split ? 'Publish' : 'Update Details'))])])])],1):_vm._e(),_vm._v(" "),((((_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin') || _vm.loggedInRole === 'Member' || _vm.loggedInRole === 'Secretary' || _vm.loggedInRole === 'SecretaryOnly') && _vm.memberDetails.primary === null))?_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('div',{staticClass:"d-flex align-items-center",attrs:{"aria-expanded":_vm.selectedSection === 'vehicle',"aria-controls":"vehicle","id":"vehicleHeading"},on:{"click":function($event){$event.preventDefault();_vm.selectedSection !== 'vehicle' ? _vm.selectedSection = 'vehicle' : _vm.selectedSection = 'null'}}},[_c('h2',{staticClass:"mb-0"},[_vm._v("Truck/vehicle Details")]),_vm._v(" "),(_vm.selectedSection === 'vehicle' && _vm.$store.state.showExpand)?_c('img',{staticClass:"ml-auto",attrs:{"width":"13","height":"6","aria-hidden":"true","alt":"","src":"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI2Ij48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJub25lIi8+PGcgY2xhc3M9ImN1cnJlbnRMYXllciI+PHBhdGggZmlsbD0iIzIzMTgxNSIgZD0iTTEyLjYgNmgtLjRMNy42IDEuNEM3IC44IDYgLjggNS41IDEuNEwuOSA2Yy0uMi4yLS41LjItLjcgMHMtLjItLjUgMC0uN0w0LjguN2MuOS0xIDIuNi0xIDMuNSAwbDQuNiA0LjZjLjIuMi4yLjUgMCAuN2gtLjN6Ii8+PC9nPjwvc3ZnPg=="}}):(_vm.$store.state.showExpand)?_c('img',{staticClass:"ml-auto",attrs:{"width":"13","height":"6","aria-hidden":"true","alt":"","src":"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI2Ij48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJub25lIi8+PGcgY2xhc3M9ImN1cnJlbnRMYXllciI+PHBhdGggZmlsbD0iIzIzMTgxNSIgZD0iTTYuNSA2LjJjLS43IDAtMS4zLS4zLTEuOC0uN0wuMS45QzAgLjcgMCAuNC4xLjJzLjUtLjIuNyAwbDQuNiA0LjZjLjYuNiAxLjUuNiAyLjEgMEwxMi4xLjJjLjItLjIuNS0uMi43IDBzLjIuNSAwIC43TDguMiA1LjVjLS40LjQtMSAuNy0xLjcuN3oiLz48L2c+PC9zdmc+"}}):_vm._e()]),_vm._v(" "),(_vm.vehicleErrors)?_c('div',{staticClass:"alert alert-warning mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.vehicleErrors))]):_vm._e(),_vm._v(" "),_c('VueSlideToggle',{staticClass:"pt-2",attrs:{"open":_vm.selectedSection === 'vehicle' || !_vm.$store.state.showExpand,"id":"vehicle","aria-labelledby":"vehicleHeading"}},[_c('div',{staticClass:"row pt-3"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"vehicleRegistration"}},[_vm._v("Registration ")]),_vm._v(" "),( false)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vehicle.registration),expression:"vehicle.registration"}],staticClass:"form-control",attrs:{"id":"vehicleRegistration","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.vehicle.registration)?_vm._i(_vm.vehicle.registration,null)>-1:(_vm.vehicle.registration)},on:{"change":function($event){var $$a=_vm.vehicle.registration,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.vehicle, "registration", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.vehicle, "registration", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.vehicle, "registration", $$c)}}}}):( false)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vehicle.registration),expression:"vehicle.registration"}],staticClass:"form-control",attrs:{"id":"vehicleRegistration","type":"radio"},domProps:{"checked":_vm._q(_vm.vehicle.registration,null)},on:{"change":function($event){return _vm.$set(_vm.vehicle, "registration", null)}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vehicle.registration),expression:"vehicle.registration"}],staticClass:"form-control",attrs:{"id":"vehicleRegistration","type":'text'},domProps:{"value":(_vm.vehicle.registration)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.vehicle, "registration", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please ensure your Password matches.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"vehicleSize"}},[_vm._v("Size")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.vehicle.size),expression:"vehicle.size"}],staticClass:"form-control",attrs:{"id":"vehicleSize"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.vehicle, "size", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.$store.state.listVehiclesSizes),function(size){return _c('option',{key:size.id,domProps:{"value":size.id}},[_vm._v(_vm._s(size.name))])}),0),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the size.")])])]),_vm._v(" "),_c('div',{staticClass:"row pt-3"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"vehicleType"}},[_vm._v("Type")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.vehicle.type),expression:"vehicle.type"}],staticClass:"form-control",attrs:{"id":"vehicleType"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.vehicle, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.$store.state.listVehiclesTypes),function(type){return _c('option',{key:type.id,domProps:{"value":type.id}},[_vm._v(_vm._s(type.name))])}),0),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the type")])])]),_vm._v(" "),_c('div',{staticClass:"row pt-3"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.addVehicle}},[_vm._v("Add Vehicle")])])]),_vm._v(" "),_c('div',{staticClass:"row pt-3"},[_c('table',{staticClass:"table table-striped table-bordered border-0"},[_c('thead',[_c('tr',[_c('th',{staticClass:"position-relative"},[_vm._v("Registration")]),_vm._v(" "),_c('th',{staticClass:"position-relative"},[_vm._v("Size")]),_vm._v(" "),_c('th',{staticClass:"position-relative"},[_vm._v("Type")]),_vm._v(" "),_c('th',{staticClass:"position-relative"})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.memberUpdate.vehicles),function(vehicle){return _c('tr',{key:vehicle.id},[_c('td',[_vm._v(_vm._s(vehicle.registration))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(vehicle.size ? vehicle.size.name : null))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(vehicle.type ? vehicle.type.name : null))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.removeVehicle(vehicle.id)}}},[_vm._v("Remove")])])])}),0)])])])],1):_vm._e(),_vm._v(" "),((_vm.memberDetails.primary === null || _vm.split) && ((_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin') || this.my))?_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('div',{staticClass:"d-flex align-items-center",attrs:{"aria-expanded":_vm.selectedSection === 'login',"aria-controls":"login","id":"loginHeading"},on:{"click":function($event){$event.preventDefault();_vm.selectedSection !== 'login' ? _vm.selectedSection = 'login' : _vm.selectedSection = 'null'}}},[_c('h2',{staticClass:"mb-0"},[_vm._v("Login Details")]),_vm._v(" "),(_vm.selectedSection === 'login' && _vm.$store.state.showExpand)?_c('img',{staticClass:"ml-auto",attrs:{"width":"13","height":"6","aria-hidden":"true","alt":"","src":"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI2Ij48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJub25lIi8+PGcgY2xhc3M9ImN1cnJlbnRMYXllciI+PHBhdGggZmlsbD0iIzIzMTgxNSIgZD0iTTEyLjYgNmgtLjRMNy42IDEuNEM3IC44IDYgLjggNS41IDEuNEwuOSA2Yy0uMi4yLS41LjItLjcgMHMtLjItLjUgMC0uN0w0LjguN2MuOS0xIDIuNi0xIDMuNSAwbDQuNiA0LjZjLjIuMi4yLjUgMCAuN2gtLjN6Ii8+PC9nPjwvc3ZnPg=="}}):(_vm.$store.state.showExpand)?_c('img',{staticClass:"ml-auto",attrs:{"width":"13","height":"6","aria-hidden":"true","alt":"","src":"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI2Ij48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJub25lIi8+PGcgY2xhc3M9ImN1cnJlbnRMYXllciI+PHBhdGggZmlsbD0iIzIzMTgxNSIgZD0iTTYuNSA2LjJjLS43IDAtMS4zLS4zLTEuOC0uN0wuMS45QzAgLjcgMCAuNC4xLjJzLjUtLjIuNyAwbDQuNiA0LjZjLjYuNiAxLjUuNiAyLjEgMEwxMi4xLjJjLjItLjIuNS0uMi43IDBzLjIuNSAwIC43TDguMiA1LjVjLS40LjQtMSAuNy0xLjcuN3oiLz48L2c+PC9zdmc+"}}):_vm._e()]),_vm._v(" "),_c('VueSlideToggle',{staticClass:"pt-2",attrs:{"open":_vm.selectedSection === 'login' || !_vm.$store.state.showExpand,"id":"login","aria-labelledby":"loginHeading"}},[_c('div',{staticClass:"row pt-3"},[_c('div',{staticClass:"col-12 col-md-6 pr-lg-2 form-group"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),(((_vm.loggedInRole !== 'Admin' && _vm.loggedInRole !== 'SuperAdmin') ? 'password' : 'text')==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.password),expression:"password.password"}],staticClass:"form-control",attrs:{"id":"password","required":_vm.split,"pattern":"([A-Za-z0-9]){6,}","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.password.password)?_vm._i(_vm.password.password,null)>-1:(_vm.password.password)},on:{"change":function($event){var $$a=_vm.password.password,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.password, "password", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.password, "password", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.password, "password", $$c)}}}}):(((_vm.loggedInRole !== 'Admin' && _vm.loggedInRole !== 'SuperAdmin') ? 'password' : 'text')==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.password),expression:"password.password"}],staticClass:"form-control",attrs:{"id":"password","required":_vm.split,"pattern":"([A-Za-z0-9]){6,}","type":"radio"},domProps:{"checked":_vm._q(_vm.password.password,null)},on:{"change":function($event){return _vm.$set(_vm.password, "password", null)}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.password),expression:"password.password"}],staticClass:"form-control",attrs:{"id":"password","required":_vm.split,"pattern":"([A-Za-z0-9]){6,}","type":(_vm.loggedInRole !== 'Admin' && _vm.loggedInRole !== 'SuperAdmin') ? 'password' : 'text'},domProps:{"value":(_vm.password.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "password", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include a Password between 6 and 30 characters, using only letters and numbers.")]),_vm._v(" "),_c('small',{staticClass:"d-block"},[_vm._v("Must be between 6 and 30 characters, using only letters and numbers")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"confirmPassword"}},[_vm._v("Confirm Password")]),_vm._v(" "),(((_vm.loggedInRole !== 'Admin' && _vm.loggedInRole !== 'SuperAdmin') ? 'password' : 'text')==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.confirmPassword),expression:"password.confirmPassword"}],staticClass:"form-control",attrs:{"id":"confirmPassword","required":_vm.confirmRequired,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.password.confirmPassword)?_vm._i(_vm.password.confirmPassword,null)>-1:(_vm.password.confirmPassword)},on:{"change":function($event){var $$a=_vm.password.confirmPassword,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.password, "confirmPassword", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.password, "confirmPassword", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.password, "confirmPassword", $$c)}}}}):(((_vm.loggedInRole !== 'Admin' && _vm.loggedInRole !== 'SuperAdmin') ? 'password' : 'text')==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.confirmPassword),expression:"password.confirmPassword"}],staticClass:"form-control",attrs:{"id":"confirmPassword","required":_vm.confirmRequired,"type":"radio"},domProps:{"checked":_vm._q(_vm.password.confirmPassword,null)},on:{"change":function($event){return _vm.$set(_vm.password, "confirmPassword", null)}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.confirmPassword),expression:"password.confirmPassword"}],staticClass:"form-control",attrs:{"id":"confirmPassword","required":_vm.confirmRequired,"type":(_vm.loggedInRole !== 'Admin' && _vm.loggedInRole !== 'SuperAdmin') ? 'password' : 'text'},domProps:{"value":(_vm.password.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "confirmPassword", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please ensure your Password matches.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-flex d-lg-none justify-content-end"},[_c('button',{staticClass:"btn btn-primary btn-block-mob d-lg-none",on:{"click":_vm.handleSubmit}},[_vm._v(_vm._s(_vm.split ? 'Publish' : 'Update Details'))])])])])],1):_vm._e(),_vm._v(" "),(((_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin')) ||
        ((_vm.loggedInRole === 'Member' || _vm.loggedInRole === 'Secretary') && _vm.memberUpdate.judge && _vm.memberUpdate.judge.status) && !_vm.memberUpdate.judge.is_suspended)?_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('div',{staticClass:"d-flex align-items-center",attrs:{"aria-expanded":_vm.selectedSection === 'judge',"aria-controls":"judge","id":"judgeHeading"},on:{"click":function($event){$event.preventDefault();_vm.selectedSection !== 'judge' ? _vm.selectedSection = 'judge' : _vm.selectedSection = 'null'}}},[_c('h2',{staticClass:"mb-0"},[_vm._v("Judge Details")]),_vm._v(" "),(_vm.selectedSection === 'login' && _vm.$store.state.showExpand)?_c('img',{staticClass:"ml-auto",attrs:{"width":"13","height":"6","aria-hidden":"true","alt":"","src":"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI2Ij48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJub25lIi8+PGcgY2xhc3M9ImN1cnJlbnRMYXllciI+PHBhdGggZmlsbD0iIzIzMTgxNSIgZD0iTTEyLjYgNmgtLjRMNy42IDEuNEM3IC44IDYgLjggNS41IDEuNEwuOSA2Yy0uMi4yLS41LjItLjcgMHMtLjItLjUgMC0uN0w0LjguN2MuOS0xIDIuNi0xIDMuNSAwbDQuNiA0LjZjLjIuMi4yLjUgMCAuN2gtLjN6Ii8+PC9nPjwvc3ZnPg=="}}):(_vm.$store.state.showExpand)?_c('img',{staticClass:"ml-auto",attrs:{"width":"13","height":"6","aria-hidden":"true","alt":"","src":"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSI2Ij48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJub25lIi8+PGcgY2xhc3M9ImN1cnJlbnRMYXllciI+PHBhdGggZmlsbD0iIzIzMTgxNSIgZD0iTTYuNSA2LjJjLS43IDAtMS4zLS4zLTEuOC0uN0wuMS45QzAgLjcgMCAuNC4xLjJzLjUtLjIuNyAwbDQuNiA0LjZjLjYuNiAxLjUuNiAyLjEgMEwxMi4xLjJjLjItLjIuNS0uMi43IDBzLjIuNSAwIC43TDguMiA1LjVjLS40LjQtMSAuNy0xLjcuN3oiLz48L2c+PC9zdmc+"}}):_vm._e()]),_vm._v(" "),_c('VueSlideToggle',{staticClass:"pt-2",attrs:{"open":_vm.selectedSection === 'judge' || !_vm.$store.state.showExpand,"id":"judge","aria-labelledby":"judgeHeading"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 pr-lg-2 form-group"},[_c('label',{attrs:{"for":"zone"}},[_vm._v("Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.judge.status),expression:"memberUpdate.judge.status"}],staticClass:"form-control",attrs:{"id":"judge_status","disabled":(_vm.loggedInRole !== 'Admin' && _vm.loggedInRole !== 'SuperAdmin')},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.memberUpdate.judge, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("-")]),_vm._v(" "),_c('option',{domProps:{"value":'trial'}},[_vm._v("Trial")]),_vm._v(" "),_c('option',{domProps:{"value":'open'}},[_vm._v("Open")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please, select a judge status")])])]),_vm._v(" "),(_vm.memberUpdate.judge && _vm.memberUpdate.judge.status)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 pr-lg-2 form-group"},[_c('label',{attrs:{"for":"judge_email"}},[_vm._v("Additional Judge Email")]),_vm._v(" "),( false)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.judge.judge_email),expression:"memberUpdate.judge.judge_email"}],class:['form-control', _vm.errorStatus === 'judge_email' ? 'is-invalid' : ''],attrs:{"id":"judge_email","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.memberUpdate.judge.judge_email)?_vm._i(_vm.memberUpdate.judge.judge_email,null)>-1:(_vm.memberUpdate.judge.judge_email)},on:{"change":function($event){var $$a=_vm.memberUpdate.judge.judge_email,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.memberUpdate.judge, "judge_email", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.memberUpdate.judge, "judge_email", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.memberUpdate.judge, "judge_email", $$c)}}}}):( false)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.judge.judge_email),expression:"memberUpdate.judge.judge_email"}],class:['form-control', _vm.errorStatus === 'judge_email' ? 'is-invalid' : ''],attrs:{"id":"judge_email","type":"radio"},domProps:{"checked":_vm._q(_vm.memberUpdate.judge.judge_email,null)},on:{"change":function($event){return _vm.$set(_vm.memberUpdate.judge, "judge_email", null)}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.judge.judge_email),expression:"memberUpdate.judge.judge_email"}],class:['form-control', _vm.errorStatus === 'judge_email' ? 'is-invalid' : ''],attrs:{"id":"judge_email","type":'text'},domProps:{"value":(_vm.memberUpdate.judge.judge_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate.judge, "judge_email", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please enter the valid email address")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"judge_phone"}},[_vm._v("Additional Judge Phone")]),_vm._v(" "),_c('phone-input',{class:[_vm.errorStatus === 'judge_phone' ? 'is-invalid' : ''],attrs:{"id":"judge_phone"},model:{value:(_vm.memberUpdate.judge.judge_phone),callback:function ($$v) {_vm.$set(_vm.memberUpdate.judge, "judge_phone", $$v)},expression:"memberUpdate.judge.judge_phone"}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please enter the correct judge phone number.")]),_vm._v(" "),_c('small',[_vm._v("Please enter the phone in a similar format +614 **** **** without spaces")]),_vm._v(" "),_c('test-phone-numbers'),_vm._v(" "),_c('phone-before-fix',{attrs:{"value":_vm.phonesBeforeFix.judge_phone}})],1)]):_vm._e(),_vm._v(" "),(_vm.memberUpdate.judge && _vm.memberUpdate.judge.status)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 form-group"},[_c('div',{staticClass:"form-group form-check px-0 mb-sm-4"},[_c('div',{staticClass:"custom-control custom-checkbox d-flex flex-column"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.judge.is_call_first),expression:"memberUpdate.judge.is_call_first"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"isCallFirst"},domProps:{"checked":Array.isArray(_vm.memberUpdate.judge.is_call_first)?_vm._i(_vm.memberUpdate.judge.is_call_first,null)>-1:(_vm.memberUpdate.judge.is_call_first)},on:{"change":function($event){var $$a=_vm.memberUpdate.judge.is_call_first,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.memberUpdate.judge, "is_call_first", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.memberUpdate.judge, "is_call_first", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.memberUpdate.judge, "is_call_first", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"isCallFirst"}},[_vm._v("\n                  I would like to appear on the Call First list on the ACA Judges Register\n                ")]),_vm._v(" "),_c('small',[_vm._v("\n                  By selecting this box you acknowledge you are happy to be approached by committees first who\n                  are seeking judges for their event\n                ")])])])])]):_vm._e(),_vm._v(" "),(_vm.memberUpdate.judge && _vm.memberUpdate.judge.status && _vm.memberUpdate.judge.judge_app_id)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 form-group"},[_c('div',{staticClass:"form-group form-check px-0 mb-sm-4"},[_c('button',{staticClass:"btn btn-primary btn-block-mob",on:{"click":function($event){return _vm.downloadJudgeApplication(_vm.memberUpdate.judge.judge_app_id)}}},[_vm._v("Download Application")])])])]):_vm._e(),_vm._v(" "),(_vm.memberUpdate.judge && _vm.memberUpdate.judge.status && _vm.loggedInRole == 'Admin')?_c('div',{staticClass:"col-12 d-flex pl-0 pr-0"},[_c('button',{staticClass:"btn btn-primary btn-block-mob",on:{"click":_vm.makeJudge}},[_vm._v("Make a judge")])]):_vm._e()])],1):_vm._e()]):_c('div',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4 flex-grow-1 mr-lg-3"},[_vm._m(0)]),_vm._v(" "),_c('desktop-action-bar',[_c('button',{class:['btn btn-block mb-2', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],attrs:{"type":"submit"},on:{"click":_vm.handleSubmit}},[_vm._v("\n      "+_vm._s(!_vm.processing ? _vm.split ? 'Publish' : 'Update Details' : '')+"\n      "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]),_vm._v(" "),((_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin') && !_vm.split && _vm.memberDetails.primary === null)?_c('button',{staticClass:"btn btn-block btn-outline-primary mb-2",on:{"click":function($event){$event.preventDefault();return _vm.joinMembers($event)}}},[_vm._v("Join")]):_vm._e(),_vm._v(" "),(_vm.memberDetails && (_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin'))?_c('router-link',{staticClass:"btn btn-block btn-outline-primary mb-2",attrs:{"tag":"a","to":{ name: 'Nominate Rookie', params: { member: { id: _vm.memberDetails.id, name: _vm.memberDetails.first_name + ' ' + _vm.memberDetails.last_name } } }}},[_vm._v("Nominate Horses")]):_vm._e(),_vm._v(" "),(_vm.split)?_c('button',{staticClass:"btn btn-block btn-outline-primary",on:{"click":function($event){return _vm.$router.push('/members/member-profile')}}},[_vm._v("Cancel")]):_c('div',[(_vm.memberDetails ? ((_vm.loggedInRole != 'SecretaryOnly' && _vm.loggedInRole != 'Volunteer' && _vm.memberDetails.getedRole !== 'Volunteer') && !_vm.memberDetails.financial) || (_vm.memberDetails.secondaries ? _vm.memberDetails.secondaries.some(function (member) { return member.financial === 0; }) : false) : false)?_c('button',{staticClass:"btn btn-block btn-outline-primary",on:{"click":function($event){$event.preventDefault();return _vm.$emit('renew')}}},[_vm._v("\n        Pay Membership\n      ")]):_vm._e()]),_vm._v(" "),(_vm.memberDetails && (_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin'))?_c('router-link',{staticClass:"btn btn-block btn-primary mt-2",attrs:{"tag":"a","to":{ name: 'Merge Member' }}},[_vm._v("Merge Accounts")]):_vm._e(),_vm._v(" "),(_vm.memberDetails && (_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin') && _vm.memberDetails.role !== 'Admin' && String(_vm.memberDetails.id) !== String(_vm.loggedInId))?_c('button',{staticClass:"btn btn-block btn-outline-primary mt-2",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.deleteConfirm = true}}},[_vm._v("\n      Delete\n    ")]):_vm._e(),_vm._v(" "),(_vm.memberDetails && _vm.loggedInRole === 'SuperAdmin' && String(_vm.memberDetails.id) !== String(_vm.loggedInId))?_c('button',{staticClass:"btn btn-block btn-primary mt-2",attrs:{"type":"button","disabled":_vm.loggingIn},on:{"click":function($event){$event.preventDefault();return _vm.loginAsMember($event)}}},[(_vm.loggingIn)?_c('span',{staticClass:"spinner-border spinner-border-sm text-light",attrs:{"role":"status"}}):_c('span',[_vm._v("Login")])]):_vm._e()],1),_vm._v(" "),(_vm.deleteConfirm)?_c('confirm-modal',{attrs:{"message":_vm.deleteConfirmMessage,"loading":_vm.deleting},on:{"confirm":_vm.deleteMember,"cancel":function($event){_vm.deleteConfirm = false}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center p-2"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.row.status !== 'paid')?_c('button',{staticClass:"btn btn-block btn-sm btn-primary disabled",attrs:{"aria-disabled":"true","disabled":""}},[_vm._v("Pending")]):_c('a',{staticClass:"btn btn-block btn-sm btn-primary",attrs:{"href":_vm.$api + _vm.row.url,"download":""}},[_vm._v("Download")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h1',{staticClass:"h2 mb-3"},[_vm._v("Financials")]),_vm._v(" "),_c('data-table',{attrs:{"dataRows":_vm.invoicesWithTotal,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{attrs:{"text":row.id,"row":row,"options":{ expandMobile: true, showPaid: true }}})}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',[_c('strong',[_vm._v("Amount: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":'$' + _vm.getDisplayTotal(row),"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Date: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":new Date(row.created_at.replace(/-/g, '/')).toLocaleString('en-AU'),"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Purchase: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.type.charAt(0).toUpperCase() + row.type.slice(1),"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',{staticClass:"pt-3 d-block d-sm-inline-block"},[_c('tableDownloadTemplate',{attrs:{"row":row}})],1)])])}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showIfInactive ? _vm.row.membership_years && _vm.row.selectedSeason ? _vm.row.membership_years[_vm.row.selectedSeason].upgradeable && !!_vm.row.filtered_product_options.length : true : true),expression:"showIfInactive ? row.membership_years && row.selectedSeason ? row.membership_years[row.selectedSeason].upgradeable && !!row.filtered_product_options.length : true : true"}],staticClass:"custom-control custom-checkbox custom-control-inline mr-0 p-3"},[_c('input',{ref:"checkbox",staticClass:"custom-control-input",attrs:{"type":"checkbox","id":("customCheckInline" + (_vm.row.id)),"name":"customCheckInline1"},domProps:{"checked":_vm.selected},on:{"change":function($event){return _vm.selectRow(_vm.row)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":("customCheckInline" + (_vm.row.id))}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__(275);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a76df39_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__(743);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a76df39_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showIfInactive ? _vm.row.membership_years && _vm.row.selectedSeason ? _vm.row.membership_years[_vm.row.selectedSeason].upgradeable && !!_vm.row.filtered_product_options.length : true : false),expression:"showIfInactive ? row.membership_years && row.selectedSeason ? row.membership_years[row.selectedSeason].upgradeable && !!row.filtered_product_options.length : true : false"}],staticClass:"form-group mb-0"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control",attrs:{"id":'membershipType' + _vm.row.id,"required":_vm.required},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.selectMembership()}]}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_vm._l((_vm.row.filtered_product_options),function(membershipType,productsIndex){return _c('option',{key:_vm.row.id + productsIndex,domProps:{"value":membershipType.id}},[_vm._v(_vm._s(membershipType.name))])})],2),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Membership Type.")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.showIfInactive ? _vm.row.membership_years && _vm.row.selectedSeason ? _vm.row.membership_years[_vm.row.selectedSeason].upgradeable && !!_vm.row.filtered_product_options.length : true : false)),expression:"!(showIfInactive ? row.membership_years && row.selectedSeason ? row.membership_years[row.selectedSeason].upgradeable && !!row.filtered_product_options.length : true : false)"}]},[_vm._v(_vm._s(_vm.row.membership_years && _vm.row.selectedSeason ? _vm.row.membership_years[_vm.row.selectedSeason].name : ''))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{class:[_vm.renew ? 'needs-validation' : ''],attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.checkSeason($event)}}},[_c('section',{staticClass:"card bg-white rounded mr-lg-3 mb-4 p-3 p-sm-4 col"},[_c('div',{staticClass:"mb-3"},[(_vm.renew)?_c('h1',{staticClass:"h2 mb-0"},[_vm._v("Pay for Membership")]):_c('h1',{staticClass:"h2 mb-0"},[_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v("\n        My ")]),_vm._v("Membership "),_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v("Details")])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('button',{staticClass:"d-block d-lg-none btn btn-block btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.memberModal($event)}}},[_vm._v("\n        Need to add a member to your profile?\n      ")])]),_vm._v(" "),(_vm.renew)?_c('div',[_c('div',{staticClass:"alert alert-info"},[_vm._v("Please ensure you select the membership season you wish to renew for from the drop down box below.")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"financialYear"}},[_vm._v("Paying for Season")]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedSeason),expression:"selectedSeason"}],staticClass:"form-control",attrs:{"id":"financialYear"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedSeason=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.setSelectedSeason($event)}]}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_vm._l((_vm.getProductYears()),function(startYear){return _c('option',{key:startYear.year,domProps:{"value":startYear.year}},[_vm._v(_vm._s(startYear.description))])})],2),_vm._v(" "),_c('button',{staticClass:"btn btn-link px-2 pl-md-0 px-xl-2 pr-md-1",attrs:{"type":"button","title":"FAQs"},on:{"click":function($event){$event.preventDefault();_vm.showSeasonInfoModal = true}}},[_c('span',{staticClass:"sr-only"},[_vm._v("Frequently Asked Questions")]),_vm._v(" "),_c('div',{staticClass:"btn-remove"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"fill":"currentColor","d":"M256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28zm7.67-24h-16c-6.627 0-12-5.373-12-12v-.381c0-70.343 77.44-63.619 77.44-107.408 0-20.016-17.761-40.211-57.44-40.211-29.144 0-44.265 9.649-59.211 28.692-3.908 4.98-11.054 5.995-16.248 2.376l-13.134-9.15c-5.625-3.919-6.86-11.771-2.645-17.177C185.658 133.514 210.842 116 255.67 116c52.32 0 97.44 29.751 97.44 80.211 0 67.414-77.44 63.849-77.44 107.408V304c0 6.627-5.373 12-12 12zM256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8z"}})])])])])])]):_vm._e(),_vm._v(" "),_c('data-table',{staticClass:"flex-wrap",attrs:{"dataRows":_vm.rows,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedSelect",fn:function(ref){
var row = ref.row;
return (_vm.renew)?_c('tableSelectRowTemplate',{staticClass:"z-1 p-3",attrs:{"row":row,"options":{ showIfInactive: true }}}):_vm._e()}},{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{attrs:{"text":row.first_name + ' ' + row.last_name,"link":'Member Profile',"slug":row.id,"tab":'loading',"row":row,"options":{ showLinks: true, expandMobile: true, showActive: false }}})}},{key:"expandedCustom",fn:function(ref){
var row = ref.row;
return (_vm.renew)?_c('tableDropdownTemplate',{staticClass:"position-relative z-1 order-1 flex-grow-1 w-100 mt-2",attrs:{"row":row,"options":{ showIfInactive: true }}}):_vm._e()}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',[_c('strong',[_vm._v("Membership No: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.member_number,"row":row,"options":{ showPrimary: true, inline: true, showActive: true }}})],1),_vm._v(" "),(!_vm.renew)?_c('li',[_c('strong',[_vm._v("Membership Type: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.financial ? row.type : '',"row":row}})],1):_vm._e()])])}}],null,true)}),_vm._v(" "),(_vm.selectedRows.length > 0 && this.renew)?_c('div',{staticClass:"sticky-bottom alert bg-primary text-white d-lg-flex align-items-center text-center text-lg-left",attrs:{"role":"alert"}},[_c('div',{staticClass:"flex-grow-1 mb-2 mb-lg-0 pr-3"},[_c('strong',[_vm._v("You have selected: ")]),_vm._v(" "),_vm._l((_vm.selectedRows),function(row,i){return _c('span',{key:i},[_vm._v("\n          "+_vm._s(_vm._f("commaSeparateUsers")(_vm.selectedRows,i))+"\n        ")])})],2),_vm._v(" "),(_vm.selectedRows.length > 0)?_c('button',{class:['btn btn-block-mob text-nowrap', _vm.processing ? 'btn-primary-dark' : 'btn-outline-white'],attrs:{"type":"submit"},on:{"click":_vm.handleSubmit}},[_vm._v("\n        "+_vm._s(!_vm.processing ? 'Check Out' : '')+"\n        "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-block-mob btn-outline-white ml-lg-2",on:{"click":function($event){$event.preventDefault();return _vm.deselectAll($event)}}},[_vm._v("Cancel")])]):_vm._e()],1),_vm._v(" "),(_vm.renew && (_vm.user != 'Secretary' || _vm.user != 'SecretaryOnly'))?_c('desktop-action-bar',[_c('h3',{staticClass:"h6 mb-0"},[_vm._v(_vm._s(_vm.memberUpdate.filter(function (member) { return member.type; }).length ? 'Members added' : 'Please select members to Check Out'))]),_vm._v(" "),_c('table',{staticClass:"table table-borderless"},[_c('tbody',_vm._l((_vm.memberUpdate),function(type,index){return _c('tr',{key:'selected' + type.id + index},[(type.type)?_c('td',{staticClass:"pl-0"},[_vm._v(_vm._s(type.type))]):_vm._e(),_vm._v(" "),(type.price)?_c('td',{staticClass:"pr-0",attrs:{"align":"right"}},[_vm._v("$"+_vm._s(type.price))]):_vm._e()])}),0)]),_vm._v(" "),(_vm.$store.getters.selectedRows.length > 0)?_c('button',{class:['btn btn-block my-2', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],attrs:{"type":"submit"},on:{"click":_vm.handleSubmit}},[_vm._v("\n        "+_vm._s(!_vm.processing ? 'Check Out' : '')+"\n        "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$store.getters.selectedRows.length > 0)?_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 62.4 39.6","width":"25","height":"16","aria-labelledby":"mastercard"}},[_c('title',{attrs:{"id":"mastercard"}},[_vm._v("Mastercard")]),_c('circle',{attrs:{"cx":"19.5","cy":"19.7","r":"19","fill":"#ee0005"}}),_c('circle',{attrs:{"cx":"43","cy":"19.7","r":"19","fill":"#f9a000"}}),_c('path',{attrs:{"fill":"#ff6300","d":"M24.1 19.7a19 19 0 0 0 7.2 14.9c4.4-3.5 7.2-8.8 7.2-14.9S35.6 8.3 31.3 4.8a19 19 0 0 0-7.2 14.9z"}})]),_vm._v(" "),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 505 153","width":"35","height":"11","aria-labelledby":"visa"}},[_c('title',{attrs:{"id":"visa"}},[_vm._v("Visa")]),_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('path',{attrs:{"fill":"#3c58bf","d":"M185.3 149L210.9 5h40l-24.8 144z"}}),_c('path',{attrs:{"fill":"#293688","d":"M185.3 149L218.1 5h32.8l-24.8 144z"}}),_c('path',{attrs:{"fill":"#3c58bf","d":"M371 6.6C363 3.4 350 .2 334 .2c-40 0-68.8 20-68.8 48.8 0 21.6 20 32.8 36 40s20.8 12 20.8 18.4c0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 42.4 0 70.4-20 70.4-50.4 0-16.8-10.4-29.6-34.4-40-14.4-7.2-23.2-11.2-23.2-18.4 0-6.4 7.2-12.8 23.2-12.8 13.6 0 23.2 2.4 30.4 5.6l4 1.6L371 6.6z"}}),_c('path',{attrs:{"fill":"#293688","d":"M371 6.6C363 3.4 350 .2 334 .2c-40 0-61.6 20-61.6 48.8 0 21.6 12.8 32.8 28.8 40s20.8 12 20.8 18.4c0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 42.4 0 70.4-20 70.4-50.4 0-16.8-10.4-29.6-34.4-40-14.4-7.2-23.2-11.2-23.2-18.4 0-6.4 7.2-12.8 23.2-12.8 13.6 0 23.2 2.4 30.4 5.6l4 1.6L371 6.6z"}}),_c('path',{attrs:{"fill":"#3c58bf","d":"M439.7 5c-9.6 0-16.8.8-20.8 10.4L359 149h43.2l8-24h51.2l4.8 24h38.4L471 5h-31.2zm-18.4 96c2.4-7.2 16-42.4 16-42.4s3.2-8.8 5.6-14.4l2.4 13.6s8 36 9.6 44h-33.6v-.8z"}}),_c('path',{attrs:{"fill":"#293688","d":"M449.3 5c-9.6 0-16.8.8-20.8 10.4L359 149h43.2l8-24h51.2l4.8 24h38.4L471 5h-21.6zm-28 96c3.2-8 16-42.4 16-42.4s3.2-8.8 5.6-14.4l2.4 13.6s8 36 9.6 44h-33.6v-.8z"}}),_c('path',{attrs:{"fill":"#3c58bf","d":"M111.7 105.8l-4-20.8c-7.2-24-30.4-50.4-56-63.2l36 128H131l64.8-144h-43.2l-40.8 100z"}}),_c('path',{attrs:{"fill":"#293688","d":"M111.7 105.8l-4-20.8c-7.2-24-30.4-50.4-56-63.2l36 128H131l64.8-144h-35.2l-48.8 100z"}}),_c('path',{attrs:{"fill":"#ffbc00","d":"M.5 5l7.2 1.6C59 18.6 94.1 49 107.7 85L93.3 17C91 7.4 83.7 5 75 5H.5z"}}),_c('path',{attrs:{"fill":"#f7981d","d":"M.5 5c51.2 12 93.6 43.2 107.2 79.2L94.1 27.4A19.5 19.5 0 0 0 75 12.2L.5 5z"}}),_c('path',{attrs:{"fill":"#ed7c00","d":"M.5 5c51.2 12 93.6 43.2 107.2 79.2L98.1 53c-2.4-9.6-5.6-19.2-16.8-23.2L.5 5z"}}),_c('g',{attrs:{"fill":"#051244"}},[_c('path',{attrs:{"d":"M151.7 101l-27.2-27.2-12.8 30.4-3.2-20c-7.2-24-30.4-50.4-56-63.2l36 128h43.2l20-48zM226.1 149l-34.4-35.2-6.4 35.2zM318.1 99.4c3.2 3.2 4.8 5.6 4 8.8 0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 25.6 0 46.4-7.2 58.4-20l-34.4-33.6zM364.5 149h37.6l8-24h51.2l4.8 24h38.4L491 90.6l-48-46.4 2.4 12.8s8 36 9.6 44h-33.6c3.2-8 16-42.4 16-42.4s3.2-8.8 5.6-14.4"}})])])]),_vm._v(" "),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 12","width":"26","height":"18","aria-labelledby":"claimoucher"}},[_c('title',{attrs:{"id":"claimoucher"}},[_vm._v("Claim Voucher")]),_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M8 6.5H3.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H8c.3 0 .5.2.5.5s-.2.5-.5.5zM8 4H3.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H8c.3 0 .5.2.5.5S8.3 4 8 4z"}}),_c('path',{attrs:{"fill":"#231815","d":"M15.5 12h-14C.7 12 0 11.3 0 10.5v-9C0 .7.7 0 1.5 0h14c.8 0 1.5.7 1.5 1.5v9c0 .8-.7 1.5-1.5 1.5zM1.5 1c-.3 0-.5.2-.5.5v9c0 .3.2.5.5.5h14c.3 0 .5-.2.5-.5v-9c0-.3-.2-.5-.5-.5h-14z"}}),_c('path',{attrs:{"fill":"#231815","d":"M13.5 9h-10c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h10c.3 0 .5.2.5.5s-.2.5-.5.5z"}}),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M13.5 6.8h-2.6c-.3 0-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5h2.6c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5zm-2.1-1H13v-2h-1.6v2z"}})])])])]),_vm._v(" "),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 17","width":"22","height":"27","aria-labelledby":"banktransfer"}},[_c('title',{attrs:{"id":"banktransfer"}},[_vm._v("Bank Transfer")]),_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M11.5 17h-9A2.5 2.5 0 0 1 0 14.5v-12C0 1.1 1.1 0 2.5 0h9C12.9 0 14 1.1 14 2.5v12c0 1.4-1.1 2.5-2.5 2.5zm-9-16C1.7 1 1 1.7 1 2.5v12c0 .8.7 1.5 1.5 1.5h9c.8 0 1.5-.7 1.5-1.5v-12c0-.8-.7-1.5-1.5-1.5h-9z"}}),_c('path',{attrs:{"fill":"#231815","d":"M11.5 13h-9c-.3 0-.5-.2-.5-.5v-10c0-.3.2-.5.5-.5h9c.3 0 .5.2.5.5v10c0 .3-.2.5-.5.5zM3 12h8V3H3v9z"}}),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M7 15.6a1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7c0-.3.1-.5.3-.7a1 1 0 0 1 1.4 0c.2.2.3.4.3.7 0 .3-.1.5-.3.7a1 1 0 0 1-.7.3z"}})])])])])]):_vm._e()]):_c('desktop-action-bar',[_c('button',{staticClass:"d-none d-lg-block btn btn-block btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.memberModal($event)}}},[_vm._v("\n      Need to add a member to your profile?\n    ")])]),_vm._v(" "),(_vm.showSeasonInfoModal)?_c('modal',{on:{"close":function($event){_vm.showSeasonInfoModal = false}}},[_c('h3',{staticClass:"modal-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Frequently Asked Questions")]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('ul',[_c('li',[_c('strong',[_vm._v("When does the ACA Financial Year start & finish?")]),_vm._v(" "),_c('p',[_vm._v("The ACA competition year runs from 01 January through until 31 December each year.")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Where can I find a copy of the invoice for my paid membership?")]),_vm._v(" "),_c('p',[_vm._v("Once you have selected 'My Profile' from the menu, please go to the 'My Financials' tab and you will find invoices associated with your membership renewal that are available for download. You will also receive a PDF copy emailed directly to you each time you renew your membership.")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("My Rider Status is incorrect & I am unable to change it - what do I do?")]),_vm._v(" "),_c('p',[_vm._v("Please contact the ACA Office on "),_c('a',{attrs:{"href":"tel:0746223110","target":"_blank"}},[_vm._v("(07) 4622 3110")]),_vm._v(" and a member of the team will be able to fix this up for you. They are also able to adjust your DOB, Gender or Member Number if these are not correct.")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("I only renewed my membership in January, does this roll over into the next season?")]),_vm._v(" "),_c('p',[_vm._v("Unfortunately no, we do not offer memberships on a rolling basis. You must be financial for the season in which you are choosing to compete and this is why it is best to renew at the start of the season in order to get as much value as possible out of your membership.")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("I paid my membership via direct debit but I am not listed as financial on Campdraft One. When will this change?")]),_vm._v(" "),_c('p',[_vm._v("When paying your membership via direct deposit or voucher there will be a slight delay to allow for this to be processed by the ACA Office Team. We ask that you stay patient with us throughout this process; however, if you think something has been missed please do not hesitate to contact our office on "),_c('a',{attrs:{"href":"tel:0746223110","target":"_blank"}},[_vm._v("(07) 4622 3110")]),_vm._v(" or email us at "),_c('a',{attrs:{"href":"mailto:aca@campdraft.com.au","target":"_blank","rel":"noreferrer"}},[_vm._v("aca@campdraft.com.au")]),_vm._v(" and we can follow this up for you. Paying via card to renew your membership are directly linked with Campdraft One and the only way to guarantee an instant financial status.")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("I am not sure of my rider status or which zone I reside in?")]),_vm._v(" "),_c('p',[_vm._v("Please refer to our website - "),_c('a',{attrs:{"href":"//campdraft.com.au","target":"_blank"}},[_vm._v("campdraft.com.au")]),_vm._v(" - and go to our information tab. Here you will find a wealth of knowledge including the General Information Competition Rules & Guidelines, our Fees & Charges Schedule and our Zone list.")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.showSeasonInfoModal = false}}},[_vm._v("Close")])])]):_vm._e(),_vm._v(" "),(_vm.showMemberModal)?_c('modal',{on:{"close":function($event){_vm.showMemberModal = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n        Members can only be added to your profile via contacting the ACA Office on 07 4622 3110 Monday to Friday 8:30am to 4pm.\n      ")])])]):_vm._e(),_vm._v(" "),(_vm.showSeasonConfirmModal)?_c('modal',{on:{"close":function($event){$event.preventDefault();_vm.showSeasonConfirmModal = false}}},[_c('h3',{staticClass:"modal-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Season Confirmation")]),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("Please confirm your selected season: "),_c('span',{staticClass:"badge badge-primary"},[_vm._v(_vm._s(Number(_vm.selectedSeason)))])]),_vm._v(" "),_c('p',[_vm._v("Note: The ACA Financial/Membership Year runs from 1 January to 31 December.")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.showSeasonConfirmModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.checkout}},[_vm._v("Confirm")])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!this.link.includes('http') && _vm.text !== '')?_c('router-link',{staticClass:"btn btn-sm btn-primary mb-2 mb-lg-0 px-lg-3 px-xl-4",attrs:{"tag":"button","to":{ name: this.link, params: { details: this.row, draftId: _vm.resolvedDraftId, eventId: _vm.resolvedEventId, edit: _vm.edit, split: _vm.split, placeholder: _vm.placeholder, slug: _vm.slug, tab: _vm.tab, id: _vm.id } }}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")]):(_vm.text !== '')?_c('a',{staticClass:"btn btn-sm btn-primary mb-2 mb-lg-0",attrs:{"href":this.link,"target":"_blank","rel":"noreferrer"}},[_vm._v(_vm._s(_vm.text))]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"card bg-white rounded mr-lg-3 mb-4 p-3 p-sm-4 col"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between mb-3"},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v(_vm._s(_vm.my ? 'My ' : '')+"Membership Details")]),_vm._v(" "),_c('router-link',{staticClass:"d-block d-lg-none btn btn-primary text-nowrap",attrs:{"tag":"button","to":{ name: 'Add Members', params: { memberDetails: _vm.memberDetails } }}},[_vm._v("Add"),_c('span',{staticClass:"d-none d-md-inline"},[_vm._v(" Member/s")])])],1),_vm._v(" "),(_vm.success)?_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.success))]):_vm._e(),_vm._v(" "),_c('data-table',{attrs:{"dataRows":_vm.rows,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{attrs:{"text":row.first_name + ' ' + row.last_name,"link":'Member Profile',"slug":row.id,"tab":'loading',"row":row,"options":{ showLinks: !row.deleted_at, expandMobile: true, showActive: true, showDeleted: true }}})}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',[_c('strong',[_vm._v("Membership No: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.member_number,"row":row,"options":{ showPrimary: true, inline: true }}})],1),_vm._v(" "),(!row.deleted_at)?_c('li',{staticClass:"pt-3 d-inline-block"},[_c('tableButtonTemplate',{attrs:{"text":!row.parent_id ? '' : 'Split',"link":'Member Profile Split',"row":row,"split":true}})],1):_vm._e()])])}}])})],1),_vm._v(" "),_c('desktop-action-bar',[_c('button',{staticClass:"d-none d-lg-block btn btn-block btn-primary text-nowrap",on:{"click":function($event){$event.preventDefault();return _vm.addMembers($event)}}},[_vm._v("Add Member/s")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MembershipType_vue__ = __webpack_require__(280);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55021629_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MembershipType_vue__ = __webpack_require__(748);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MembershipType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55021629_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MembershipType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.row.editing && (_vm.userRole === 'Admin' || _vm.userRole === 'SuperAdmin'))?_c('div',{staticClass:"form-group mb-0"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.row.membership_type_id),expression:"row.membership_type_id"}],staticClass:"form-control",attrs:{"required":_vm.row.editing,"readonly":!_vm.row.editing},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.row, "membership_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_vm._l((_vm.row.membership_options),function(membershipType,membershipIndex){return _c('option',{key:'membershipType' + membershipIndex,domProps:{"value":membershipType.id}},[_vm._v(_vm._s(membershipType.name))])})],2),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Membership Type.")])]):_c('span',[_vm._v(_vm._s(_vm.row.membership_options.find(function (option) { return option.id === _vm.row.membership_type_id; }).name))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EffectiveDate_vue__ = __webpack_require__(281);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f76b798_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EffectiveDate_vue__ = __webpack_require__(750);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EffectiveDate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f76b798_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EffectiveDate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.row.editing && (_vm.userRole === 'Admin' || _vm.userRole === 'SuperAdmin'))?_c('div',{staticClass:"form-group mb-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.row.effective_date),expression:"row.effective_date"}],staticClass:"form-control form-date w-100",attrs:{"required":"","type":"date","placeholder":[_vm.isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy'],"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}"},domProps:{"value":(_vm.row.effective_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.row, "effective_date", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Date"+_vm._s(_vm.isLegacy() ? ' in the format yyyy-mm-dd' : '')+".")])]):_c('span',[_vm._v(_vm._s(new Date(_vm.row.effective_date.replace(/-/g, '/')).toLocaleString('en-AU',{year: "numeric", month: "2-digit", day: "numeric"})))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"d-flex justify-content-between align-items-start"},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v("Membership History")]),_vm._v(" "),((_vm.userRole === 'Admin' || _vm.userRole === 'SuperAdmin'))?_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.add($event)}}},[_vm._v("Add")]):_vm._e()]),_vm._v(" "),(_vm.success)?_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.success))]):(_vm.errors.length > 0)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_c('ul',{class:['mb-0', {'list-unstyled': _vm.errors.length === 1}]},_vm._l((_vm.errors),function(error,index){return _c('li',{key:index},[_vm._v("\n        "+_vm._s(Object.values(error)[0])+"\n      ")])}),0)]):_vm._e(),_vm._v(" "),_c('data-table',{attrs:{"dataRows":_vm.rows,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{attrs:{"text":((row.membership_options.find(function (option) { return option.id === row.membership_type_id; }).name) + " " + (new Date(row.effective_date.replace(/-/g, '/')).toLocaleString('en-AU',{ year: 'numeric', month: '2-digit', day: 'numeric' }))),"row":row,"options":{ expandMobile: true }}})}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',[_c('strong',[_vm._v("Membership Type: ")]),_vm._v(" "),_c('MembershipType',{attrs:{"row":row}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Effective Date: ")]),_vm._v(" "),_c('EffectiveDate',{attrs:{"row":row}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Valid Until: ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(row.valid_until ? new Date(row.valid_until.replace(/-/g, '/')).toLocaleString('en-AU',{year: 'numeric', month: '2-digit', day: 'numeric'}) : ''))])]),_vm._v(" "),(row.editable && (_vm.userRole === 'Admin' || _vm.userRole === 'SuperAdmin'))?_c('li',[_c('strong',[_vm._v("Action: ")]),_vm._v(" "),(row.editable && (_vm.userRole === 'Admin' || _vm.userRole === 'SuperAdmin'))?_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.toggleEdit(row)}}},[(row.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_c('span',[_vm._v(_vm._s(row.editing ? 'Save' : 'Edit'))])]):_vm._e(),_vm._v(" "),(row.editable && (_vm.userRole === 'Admin' || _vm.userRole === 'SuperAdmin'))?_c('button',{staticClass:"btn btn-sm btn-primary mt-2",on:{"click":function($event){_vm.modalData = row; _vm.showModal = true}}},[(row.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_c('span',[_vm._v("Delete")])]):_vm._e()]):_vm._e()])])}}])}),_vm._v(" "),(_vm.showModal)?_c('modal',{on:{"close":function($event){_vm.showModal = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n        You are about to delete the "+_vm._s(_vm.modalData.membership_options.find(function (option) { return option.id === _vm.modalData.membership_type_id; }).name)+" membership from "+_vm._s(new Date(_vm.modalData.effective_date.replace(/-/g, '/')).toLocaleString('en-AU',{year: 'numeric', month: '2-digit', day: 'numeric'}) +
          _vm.modalData.valid_until
            ? ("to " + (new Date(_vm.modalData.valid_until.replace(/-/g, '/')).toLocaleString('en-AU',{year: 'numeric', month: '2-digit', day: 'numeric'})))
            : '')+". Proceed with deletion?\n      ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.showModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary ml-2",on:{"click":function($event){$event.preventDefault();_vm.deleteRecord(_vm.modalData);_vm.showModal = false}}},[_vm._v("Approve")])])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JudgePerformance_vue__ = __webpack_require__(282);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04dfd645_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JudgePerformance_vue__ = __webpack_require__(753);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JudgePerformance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04dfd645_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JudgePerformance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"judge-performance"},[_c('h1',{staticClass:"h2 mb-0"},[_vm._v("Judge Performance")]),_vm._v(" "),(_vm.success)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.success))]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('data-table',{attrs:{"dataRows":_vm.rows,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{attrs:{"text":row.event_name,"row":row}})}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',[_c('strong',[_vm._v("Draft: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.draft_name,"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Event: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.event_name,"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Average Rating: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.rating,"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Comment: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.comment,"row":row,"options":{ inline: true }}})],1)])])}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BOYHistory_vue__ = __webpack_require__(283);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_087f440a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BOYHistory_vue__ = __webpack_require__(776);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BOYHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_087f440a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BOYHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 755 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useBoyStatusHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_boyStatus__ = __webpack_require__(443);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



function useBoyStatusHistory(entityType) {
  var history = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var statusOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var ownerOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var ownerLoading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var saving = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

  function fetch(_x) {
    return _fetch.apply(this, arguments);
  }

  function _fetch() {
    _fetch = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(entityId) {
      var fetcher, _ref, data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              fetcher = entityType === 'horse' ? __WEBPACK_IMPORTED_MODULE_1__services_api_boyStatus__["a" /* default */].horseHistory : __WEBPACK_IMPORTED_MODULE_1__services_api_boyStatus__["a" /* default */].riderHistory;
              _context.next = 5;
              return fetcher(entityId);

            case 5:
              _ref = _context.sent;
              data = _ref.data;
              history.value = data.data;

            case 8:
              _context.prev = 8;
              loading.value = false;
              return _context.finish(8);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1,, 8, 11]]);
    }));
    return _fetch.apply(this, arguments);
  }

  function fetchStatusOptions() {
    return _fetchStatusOptions.apply(this, arguments);
  } // Owner is horse-only — riders have no owner concept, so there's nothing to search for them.
  // Searches Members/Member Secretaries by name (server-side), triggered on dropdown open/typing.


  function _fetchStatusOptions() {
    _fetchStatusOptions = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2() {
      var fetcher, _ref2, data;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              fetcher = entityType === 'horse' ? __WEBPACK_IMPORTED_MODULE_1__services_api_boyStatus__["a" /* default */].horseStatuses : __WEBPACK_IMPORTED_MODULE_1__services_api_boyStatus__["a" /* default */].riderStatuses;
              _context2.next = 3;
              return fetcher();

            case 3:
              _ref2 = _context2.sent;
              data = _ref2.data;
              statusOptions.value = data.data;

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _fetchStatusOptions.apply(this, arguments);
  }

  function searchOwnerOptions(_x2, _x3) {
    return _searchOwnerOptions.apply(this, arguments);
  } // Pre-seeds the dropdown with the currently-assigned owner so it displays correctly
  // the moment the Backdate modal opens, before any search has run.


  function _searchOwnerOptions() {
    _searchOwnerOptions = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(entityId, search) {
      var _ref3, data;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(entityType !== 'horse')) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              ownerLoading.value = true;
              _context3.prev = 3;
              _context3.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_boyStatus__["a" /* default */].horseOwnerOptions(entityId, search);

            case 6:
              _ref3 = _context3.sent;
              data = _ref3.data;
              ownerOptions.value = data.data;

            case 9:
              _context3.prev = 9;
              ownerLoading.value = false;
              return _context3.finish(9);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3,, 9, 12]]);
    }));
    return _searchOwnerOptions.apply(this, arguments);
  }

  function seedOwnerOptions(owner) {
    ownerOptions.value = owner ? [owner] : [];
  }

  function save(_x4, _x5, _x6) {
    return _save.apply(this, arguments);
  }

  function _save() {
    _save = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4(entityId, stateId, payload) {
      var response;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              saving.value = true;
              _context4.prev = 1;

              if (!stateId) {
                _context4.next = 15;
                break;
              }

              if (!(entityType === 'horse')) {
                _context4.next = 9;
                break;
              }

              _context4.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_boyStatus__["a" /* default */].updateHorse(entityId, stateId, payload);

            case 6:
              _context4.t0 = _context4.sent;
              _context4.next = 12;
              break;

            case 9:
              _context4.next = 11;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_boyStatus__["a" /* default */].updateRider(entityId, stateId, payload);

            case 11:
              _context4.t0 = _context4.sent;

            case 12:
              response = _context4.t0;
              _context4.next = 25;
              break;

            case 15:
              if (!(entityType === 'horse')) {
                _context4.next = 21;
                break;
              }

              _context4.next = 18;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_boyStatus__["a" /* default */].createHorse(entityId, payload);

            case 18:
              _context4.t1 = _context4.sent;
              _context4.next = 24;
              break;

            case 21:
              _context4.next = 23;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_boyStatus__["a" /* default */].createRider(entityId, payload);

            case 23:
              _context4.t1 = _context4.sent;

            case 24:
              response = _context4.t1;

            case 25:
              return _context4.abrupt("return", response.data.message);

            case 26:
              _context4.prev = 26;
              saving.value = false;
              return _context4.finish(26);

            case 29:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1,, 26, 29]]);
    }));
    return _save.apply(this, arguments);
  }

  function clearRecalculationFlag(_x7, _x8) {
    return _clearRecalculationFlag.apply(this, arguments);
  }

  function _clearRecalculationFlag() {
    _clearRecalculationFlag = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee5(entityId, stateId) {
      var response;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              saving.value = true;
              _context5.prev = 1;

              if (!(entityType === 'horse')) {
                _context5.next = 8;
                break;
              }

              _context5.next = 5;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_boyStatus__["a" /* default */].clearHorseRecalculationFlag(entityId, stateId);

            case 5:
              _context5.t0 = _context5.sent;
              _context5.next = 11;
              break;

            case 8:
              _context5.next = 10;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_boyStatus__["a" /* default */].clearRiderRecalculationFlag(entityId, stateId);

            case 10:
              _context5.t0 = _context5.sent;

            case 11:
              response = _context5.t0;
              return _context5.abrupt("return", response.data.message);

            case 13:
              _context5.prev = 13;
              saving.value = false;
              return _context5.finish(13);

            case 16:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1,, 13, 16]]);
    }));
    return _clearRecalculationFlag.apply(this, arguments);
  }

  function remove(_x9, _x10) {
    return _remove.apply(this, arguments);
  }

  function _remove() {
    _remove = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee6(entityId, stateId) {
      var response;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              saving.value = true;
              _context6.prev = 1;

              if (!(entityType === 'horse')) {
                _context6.next = 8;
                break;
              }

              _context6.next = 5;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_boyStatus__["a" /* default */].deleteHorseState(entityId, stateId);

            case 5:
              _context6.t0 = _context6.sent;
              _context6.next = 11;
              break;

            case 8:
              _context6.next = 10;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_boyStatus__["a" /* default */].deleteRiderState(entityId, stateId);

            case 10:
              _context6.t0 = _context6.sent;

            case 11:
              response = _context6.t0;
              return _context6.abrupt("return", response.data.message);

            case 13:
              _context6.prev = 13;
              saving.value = false;
              return _context6.finish(13);

            case 16:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[1,, 13, 16]]);
    }));
    return _remove.apply(this, arguments);
  }

  return {
    history: history,
    loading: loading,
    statusOptions: statusOptions,
    ownerOptions: ownerOptions,
    ownerLoading: ownerLoading,
    saving: saving,
    fetch: fetch,
    fetchStatusOptions: fetchStatusOptions,
    searchOwnerOptions: searchOwnerOptions,
    seedOwnerOptions: seedOwnerOptions,
    save: save,
    clearRecalculationFlag: clearRecalculationFlag,
    remove: remove
  };
}

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  verify: function verify(password) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post('/v2/action-gate/verify', {
      password: password
    }, {
      silent: true
    });
  }
});

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{on:{"close":function($event){return _vm.$emit('cancel')}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Confirmation required")])]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("Enter the password to continue.")]),_vm._v(" "),_c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return _vm.$emit('confirm', _vm.password)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","name":"action-gate-password","autocomplete":"new-password","autofocus":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-danger mt-3 mb-0"},[_vm._v(_vm._s(_vm.error))]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"col-12 d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.loading || !_vm.password},on:{"click":function($event){$event.preventDefault();return _vm.$emit('confirm', _vm.password)}}},[_vm._v("Confirm")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary ml-2",on:{"click":function($event){$event.preventDefault();return _vm.$emit('cancel')}}},[_vm._v("Cancel")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:_vm.classes,attrs:{"type":_vm.type,"disabled":_vm.loading || _vm.disabled}},_vm.$listeners),[_c('span',{staticClass:"app-button__spinner",attrs:{"aria-hidden":"true"}},[(_vm.loading)?_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status"}}):_vm._e()]),_vm._v(" "),_c('span',{class:{ 'app-button__label--hidden': _vm.loading }},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.message)?_c('div',{staticClass:"app-alert",attrs:{"role":"alert"}},[_c('div',[_c('div',{class:("alert alert-" + _vm.type + " mb-0 alert-pop"),staticStyle:{"cursor":"pointer"},attrs:{"title":"Click to dismiss"},on:{"click":_vm.dismiss}},[_vm._v(_vm._s(_vm.message))])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoyStatusFormModal_vue__ = __webpack_require__(290);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_768be944_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BoyStatusFormModal_vue__ = __webpack_require__(774);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoyStatusFormModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_768be944_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BoyStatusFormModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 764 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FLabel_vue__ = __webpack_require__(293);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83fa6996_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FLabel_vue__ = __webpack_require__(766);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83fa6996_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.label)?_c('label',{attrs:{"for":_vm.id}},[_vm._v("\n  "+_vm._s(_vm.label)),(_vm.required)?_c('span',{staticClass:"text-danger ml-1"},[_vm._v("*")]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FHint_vue__ = __webpack_require__(294);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23111fb4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FHint_vue__ = __webpack_require__(768);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FHint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23111fb4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FHint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hint)?_c('small',{staticClass:"form-text text-muted"},[_vm._v(_vm._s(_vm.hint))]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('f-label',{attrs:{"label":_vm.label,"id":_vm.id,"required":_vm.required}}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('f-hint',{attrs:{"hint":_vm.hint}}),_vm._v(" "),_c('transition',{attrs:{"name":"f-tooltip"}},[(_vm.error)?_c('div',{key:_vm.error,staticClass:"invalid-tooltip"},[_vm._v(_vm._s(_vm.error))]):(_vm.tooltip)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v(_vm._s(_vm.tooltip))]):_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-group',{attrs:{"label":_vm.label,"id":_vm.id,"required":_vm.required,"tooltip":_vm.tooltip,"hint":_vm.hint,"error":_vm.error}},[_c('input',{class:['form-control', _vm.isDateType && 'form-date', _vm.error && 'is-invalid'],attrs:{"type":_vm.type,"id":_vm.id,"required":_vm.required,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"maxlength":_vm.maxlength,"pattern":_vm.pattern,"min":_vm.min,"max":_vm.max,"autocomplete":"off"},domProps:{"value":_vm.value},on:{"keydown":function($event){return _vm.blockBelowMinKey($event)},"input":function($event){return _vm.onInput($event)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-group',{attrs:{"label":_vm.label,"id":_vm.id,"required":_vm.required,"tooltip":_vm.showTooltip ? _vm.tooltip : null,"hint":_vm.hint,"error":_vm.error}},[_c('multiselect',{ref:"multiselect",class:{ 'is-invalid': !!_vm.error, 'multiselect--tooltip-overflow': _vm.hasTooltips },attrs:{"id":_vm.id,"value":_vm.selected,"options":_vm.displayOptions,"multiple":_vm.multiple,"track-by":_vm.trackBy,"label":_vm.customLabel ? undefined : _vm.optionLabel,"custom-label":_vm.customLabel || undefined,"placeholder":_vm.placeholder,"loading":_vm.loading,"disabled":_vm.disabled,"searchable":_vm.searchable,"allow-empty":!_vm.required,"select-label":"","deselect-label":"","selected-label":""},on:{"input":_vm.onSelect,"search-change":_vm.onSearchChange,"open":_vm.onOpen,"close":_vm.onClose},scopedSlots:_vm._u([{key:"option",fn:function(props){return [_c('span',{directives:[{name:"option-tooltip",rawName:"v-option-tooltip",value:(_vm.optionTooltip(props.option)),expression:"optionTooltip(props.option)"}]},[_vm._v(_vm._s(_vm.optionText(props.option)))])]}},{key:"tag",fn:function(props){return (_vm.multiple && _vm.lockedIds.length)?[_c('span',{staticClass:"multiselect__tag"},[_c('span',[_vm._v(_vm._s(_vm.optionText(props.option)))]),_vm._v(" "),(!_vm.lockedIds.includes(props.option[_vm.trackBy]))?_c('i',{staticClass:"multiselect__tag-icon",attrs:{"aria-hidden":"true","tabindex":"1"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return props.remove(props.option)},"mousedown":function($event){$event.preventDefault();return props.remove(props.option)}}}):_vm._e()])]:undefined}}],null,true)},[_vm._v(" "),_vm._v(" "),_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v("No results found.")]),_vm._v(" "),(!_vm.loading && !_vm.options.length && !_vm.searchQuery)?_c('li',{staticClass:"multiselect__element",attrs:{"slot":"afterList"},slot:"afterList"},[_c('span',{staticClass:"multiselect__option"},[_vm._v("No results found.")])]):_vm._e(),_vm._v(" "),(_vm.loadingMore)?_c('li',{staticClass:"multiselect__element",attrs:{"slot":"afterList"},slot:"afterList"},[_c('span',{staticClass:"multiselect__option text-muted"},[_vm._v("Loading more…")])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  list: function list() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/zones');
  }
});

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{on:{"close":function($event){return _vm.$emit('cancel')}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.isEditing ? 'Backdate BOY Status' : 'Add New BOY Status'))])]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit($event)}}},[_c('div',{staticClass:"f-form"},[_c('div',{staticClass:"f-form__full"},[_c('f-group',{attrs:{"label":"BOY Status","id":"boy_status_id","required":""}},[_c('multiselect',{attrs:{"options":_vm.statusOptions,"label":"name","track-by":"id","searchable":false,"select-label":"","deselect-label":"","selected-label":""},model:{value:(_vm.form.boyStatus),callback:function ($$v) {_vm.$set(_vm.form, "boyStatus", $$v)},expression:"form.boyStatus"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"f-form__full"},[_c('f-group',{attrs:{"label":"Status","id":"status_id","required":""}},[_c('multiselect',{attrs:{"options":_vm.statusOptions,"label":"name","track-by":"id","searchable":false,"select-label":"","deselect-label":"","selected-label":""},model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"f-form__full"},[_c('f-text',{attrs:{"id":"effective_date","label":"Effective Date","type":"date","required":""},model:{value:(_vm.form.effectiveDate),callback:function ($$v) {_vm.$set(_vm.form, "effectiveDate", $$v)},expression:"form.effectiveDate"}})],1),_vm._v(" "),(_vm.type === 'rider' && !_vm.isEditing)?_c('div',{staticClass:"f-form__full"},[_c('f-checkbox',{attrs:{"id":"use_auto_zone","label":"Automatically determine zone"},model:{value:(_vm.form.useAutoZone),callback:function ($$v) {_vm.$set(_vm.form, "useAutoZone", $$v)},expression:"form.useAutoZone"}})],1):_vm._e(),_vm._v(" "),(_vm.type === 'rider' && (_vm.isEditing || !_vm.form.useAutoZone))?_c('div',{staticClass:"f-form__full"},[_c('f-group',{attrs:{"label":"Zone","id":"zone_id","required":!_vm.isEditing}},[_c('multiselect',{attrs:{"options":_vm.zoneOptions,"loading":_vm.zoneLoading,"label":"name","track-by":"id","searchable":false,"select-label":"","deselect-label":"","selected-label":""},model:{value:(_vm.form.zone),callback:function ($$v) {_vm.$set(_vm.form, "zone", $$v)},expression:"form.zone"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.type === 'horse' && _vm.isEditing)?_c('div',{staticClass:"f-form__full"},[_c('f-search-select',{attrs:{"id":"owner_id","label":"Owner","options":_vm.ownerOptionsWithSelected,"loading":_vm.ownerLoading,"option-label":"name","custom-label":_vm.ownerLabel,"placeholder":"Search members...","required":""},on:{"select":_vm.onOwnerSelect,"search-change":_vm.onOwnerSearch,"open":function($event){return _vm.onOwnerSearch('')}},model:{value:(_vm.form.owner),callback:function ($$v) {_vm.$set(_vm.form, "owner", $$v)},expression:"form.owner"}})],1):_vm._e()])]),_vm._v(" "),(_vm.error || _vm.validationError)?_c('div',{staticClass:"alert alert-danger mt-3 mb-0"},[_vm._v(_vm._s(_vm.error || _vm.validationError))]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('app-button',{attrs:{"variant":"outline-primary","block":false},on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('app-button',{staticClass:"ml-2",attrs:{"block":false,"loading":_vm.saving},on:{"click":_vm.handleSubmit}},[_vm._v("Save")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"boy-history__header"},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v("BOY History")]),_vm._v(" "),_c('app-button',{attrs:{"block":false},on:{"click":_vm.openAdd}},[_vm._v("Add New BOY Status")])],1),_vm._v(" "),(_vm.type === 'horse')?_c('div',{staticClass:"alert alert-info"},[_vm._v("\n    Every BOY History entry for a horse must have an Owner — entries without one are excluded from\n    results and standings for any draft on or after their Effective Date.\n  ")]):_vm._e(),_vm._v(" "),_c('app-alert'),_vm._v(" "),_c('responsive-table',{attrs:{"columns":_vm.columns,"rows":_vm.sortedHistory,"loading":_vm.loading,"breakpoints":_vm.breakpoints,"sort":_vm.sortField,"direction":_vm.sortDir,"row-class":_vm.rowClass,"empty-text":"No BOY status history found."},on:{"sort":_vm.setSort},scopedSlots:_vm._u([{key:"cell:effective_date",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(_vm.formatDate(row.effective_date, 'long')))]}},{key:"cell:boy",fn:function(ref){
var row = ref.row;
return [(_vm.boyStatusTitleLink(row))?_c('router-link',{attrs:{"to":_vm.boyStatusTitleLink(row),"target":"_blank","title":"View this title's standings preview"}},[_vm._v(_vm._s(row.boy_status.name))]):[_vm._v(_vm._s(row.boy_status.name))]]}},{key:"cell:status",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(_vm.type === 'horse' ? row.horse_status.name : row.rider_status.name))]}},(_vm.type === 'horse')?{key:"cell:owner",fn:function(ref){
var row = ref.row;
return [(row.owner)?[_vm._v(_vm._s(row.owner.name)),(row.owner.deleted)?_c('small',{staticClass:"text-primary"},[_vm._v("(deleted)")]):_vm._e()]:[_vm._v("—")]]}}:null,(_vm.type === 'rider')?{key:"cell:zone",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.zone ? row.zone.name : '—'))]}}:null,{key:"cell:changed_by",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.changed_by.name)+" on "+_vm._s(_vm.formatDate(row.changed_by.date, 'long')))]}},{key:"cell:actions",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"actions__wrap"},[_c('button',{staticClass:"icon-btn icon-btn--edit",attrs:{"title":"Backdate"},on:{"click":function($event){return _vm.openEdit(row)}}}),_vm._v(" "),_c('button',{staticClass:"icon-btn icon-btn--view",attrs:{"title":"View Affected Results"},on:{"click":function($event){return _vm.viewResults(row)}}}),_vm._v(" "),(row.needs_recalculation)?_c('button',{staticClass:"icon-btn icon-btn--clear",attrs:{"title":"Clear recalculation flag","disabled":_vm.saving},on:{"click":function($event){return _vm.confirmClearFlag(row)}}}):_vm._e(),_vm._v(" "),(row.created_manually)?_c('button',{staticClass:"icon-btn icon-btn--delete",attrs:{"title":"Delete","disabled":_vm.saving},on:{"click":function($event){return _vm.confirmDelete(row)}}}):_vm._e(),_vm._v(" "),(row.needs_recalculation)?_c('span',{staticClass:"draws-dashboard__warn-icon",attrs:{"title":"Needs recalculation"}}):_vm._e()])]}}],null,true)}),_vm._v(" "),(_vm.formVisible)?_c('boy-status-form-modal',{attrs:{"type":_vm.type,"status-options":_vm.statusOptions,"owner-options":_vm.ownerOptions,"owner-loading":_vm.ownerLoading,"saving":_vm.saving,"error":_vm.formError,"editing":_vm.editingRow},on:{"owner-search":_vm.onOwnerSearch,"submit":_vm.handleSubmit,"cancel":_vm.closeForm}}):_vm._e(),_vm._v(" "),(_vm.clearingFlagRow)?_c('confirm-modal',{attrs:{"message":"Are you sure you want to clear the recalculation flag on this entry? It won't be marked as needing a recalculation anymore.","loading":_vm.saving},on:{"confirm":_vm.handleClearFlag,"cancel":function($event){_vm.clearingFlagRow = null}}}):_vm._e(),_vm._v(" "),(_vm.deletingRow)?_c('confirm-modal',{attrs:{"message":"Are you sure you want to delete this BOY status entry? This cannot be undone.","loading":_vm.saving},on:{"confirm":_vm.handleDelete,"cancel":function($event){_vm.deletingRow = null}}}):_vm._e(),_vm._v(" "),(_vm.gateVisible)?_c('action-gate-modal',{attrs:{"error":_vm.gateError,"loading":_vm.gateLoading},on:{"confirm":_vm.submitGatePassword,"cancel":_vm.cancelGate}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('boy-status-history-table',{attrs:{"entity-id":_vm.memberID,"type":"rider"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Horses_vue__ = __webpack_require__(296);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_393b020d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Horses_vue__ = __webpack_require__(782);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Horses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_393b020d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Horses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HORSE_MEMBER_RELATION_OWNER */
/* unused harmony export HORSE_MEMBER_RELATION_RIDER */
/* unused harmony export HORSE_MEMBER_RELATION_FAMILY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HORSE_MEMBER_RELATION_OPTIONS; });
// Mirror of App\Enums\HorseMemberRelation (campdraftone-api) — how a member is linked to a horse.
// Shared by the Member Profile "Horses" tab (CAM-1505) and the Horse Profile "Members" tab
// (CAM-1504) so the three values/options aren't hand-typed twice. Keep in sync by hand; there is
// no shared source of truth across the two repos.
//
// Labels ARE kept here (unlike e.g. draftStatus.js) — `is_owner`/`is_rider` are two independent
// per-row booleans, not one `*_id` column, so there is no single resource field to hang a
// `*_label` off; "Family" itself is derived client-side too (neither flag true).
var HORSE_MEMBER_RELATION_OWNER = 'owner';
var HORSE_MEMBER_RELATION_RIDER = 'rider';
var HORSE_MEMBER_RELATION_FAMILY = 'family'; // Ready-made options for FilterMultiselect's `relation` filter.

var HORSE_MEMBER_RELATION_OPTIONS = [{
  id: HORSE_MEMBER_RELATION_OWNER,
  name: 'Owner'
}, {
  id: HORSE_MEMBER_RELATION_RIDER,
  name: 'Rider'
}, {
  id: HORSE_MEMBER_RELATION_FAMILY,
  name: 'Family'
}];

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filter-multiselect',{attrs:{"label":"Relation","placeholder":"Owner, Rider or Family","value":_vm.value,"options":_vm.options},on:{"input":function (ids) { return _vm.$emit('input', ids); },"clear":function($event){return _vm.$emit('clear')}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 780 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"relation-badges"},[(_vm.isOwner)?_c('span',{staticClass:"badge alert-prim"},[_vm._v("Owner")]):_vm._e(),_vm._v(" "),(_vm.isRider)?_c('span',{staticClass:"badge alert-secondary"},[_vm._v("Rider")]):_vm._e(),_vm._v(" "),(!_vm.isOwner && !_vm.isRider)?_c('span',{staticClass:"badge alert-dark"},[_vm._v("Family")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col px-0"},[_c('section',{staticClass:"card bg-white rounded mb-4 p-3 p-sm-4"},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v("Horses")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('filter-bar',{attrs:{"active":_vm.hasActiveFilters},on:{"clear":_vm.clearAll}},[_c('filter-multiselect',{attrs:{"label":"Zone","option-label":"code","placeholder":"Any zone","value":_vm.filters.zone_id,"options":_vm.zoneOptions},on:{"input":function (ids) { return _vm.setFilter('zone_id', ids); },"clear":function($event){return _vm.clearFilter('zone_id')}}}),_vm._v(" "),_c('filter-multiselect',{attrs:{"label":"Status","placeholder":"Any status","value":_vm.filters.status_id,"options":_vm.statusOptions},on:{"input":function (ids) { return _vm.setFilter('status_id', ids); },"clear":function($event){return _vm.clearFilter('status_id')}}}),_vm._v(" "),_c('filter-multiselect',{attrs:{"label":"BoY Status","placeholder":"Any BoY status","value":_vm.filters.boy_status_id,"options":_vm.statusOptions},on:{"input":function (ids) { return _vm.setFilter('boy_status_id', ids); },"clear":function($event){return _vm.clearFilter('boy_status_id')}}}),_vm._v(" "),_c('horse-member-relation-filter',{attrs:{"value":_vm.filters.relation},on:{"input":function (ids) { return _vm.setFilter('relation', ids); },"clear":function($event){return _vm.clearFilter('relation')}}})],1),_vm._v(" "),_c('div',{staticClass:"form-inline mb-sm-3 d-flex justify-content-between"},[_c('div',{staticClass:"d-flex col-12 col-md-auto px-0 mb-3 mb-md-0"},[_c('label',{staticClass:"sr-only",attrs:{"for":"memberHorsesRegFilter"}},[_vm._v("Filter")]),_vm._v(" "),_c('div',{staticClass:"filter"},_vm._l((_vm.tabs),function(tab){return _c('div',{key:tab.value,staticClass:"form-check pl-0"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":"memberHorsesShowRegistrationState","id":'memberHorsesShowReg-' + tab.value},domProps:{"value":tab.value,"checked":_vm.filters.registration_state === tab.value},on:{"change":function($event){return _vm.onTabChange(tab.value)}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":'memberHorsesShowReg-' + tab.value}},[_vm._v(_vm._s(tab.label))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-lg-auto mt-2 mt-lg-0 ml-auto px-0 d-flex align-items-center"},[_c('label',{staticClass:"d-none d-lg-inline mr-xl-2 mb-0 pr-2 font-weight-normal",attrs:{"for":"memberHorsesSearch"}},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"input-append d-flex flex-grow-1 flex-md-grow-0 mr-md-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],staticClass:"form-control mb-0 flex-grow-1 flex-md-grow-0",attrs:{"id":"memberHorsesSearch","type":"text"},domProps:{"value":(_vm.searchInput)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applySearch($event)},"search":_vm.applySearch,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('svg',{staticClass:"append",attrs:{"role":"button","aria-label":"Search","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14","width":"16","height":"16"},on:{"click":_vm.applySearch}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M5.5 11C2.5 11 0 8.5 0 5.5S2.5 0 5.5 0 11 2.5 11 5.5 8.5 11 5.5 11zm0-10C3 1 1 3 1 5.5S3 10 5.5 10 10 8 10 5.5 8 1 5.5 1z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#231815","d":"M9.5 8.8l4.4 4.4c.2.2.2.5 0 .7l-.4.1-.4-.1-4.4-4.4.8-.7z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"position-relative",staticStyle:{"min-height":"240px"}},[_c('responsive-table',{attrs:{"columns":_vm.columns,"rows":_vm.horses,"loading":_vm.loading,"breakpoints":_vm.breakpoints,"sort":_vm.filters.sort,"direction":_vm.filters.direction,"empty-text":"No horses found."},on:{"sort":_vm.setSort},scopedSlots:_vm._u([{key:"cell:name",fn:function(ref){
var row = ref.row;
return [_c('list-name-cell',{attrs:{"align":"right","label":row.name,"to":{ name: _vm.profileRoute, params: { slug: row.id } }},scopedSlots:_vm._u([{key:"badges",fn:function(){return [_c('span',{staticClass:"badge",class:row.active ? 'alert-success' : 'alert-warning'},[_vm._v(_vm._s(row.active ? 'Active' : 'Archived'))]),_vm._v(" "),_c('span',{staticClass:"badge",class:row.registrationDate ? 'alert-info' : 'alert-warning'},[_vm._v(_vm._s(row.registrationDate ? 'Registered' : 'Unregistered'))]),_vm._v(" "),_c('horse-member-relation-badges',{attrs:{"is-owner":row.isOwner,"is-rider":row.isRider}})]},proxy:true}],null,true)})]}},{key:"cell:owner_name",fn:function(ref){
var row = ref.row;
return [_c('span',[(row.ownerId)?_c('router-link',{staticClass:"text-primary",attrs:{"to":{ name: 'Member Profile', params: { slug: row.ownerId } }}},[_vm._v(_vm._s(row.ownerName))]):[_vm._v(_vm._s(row.ownerName))],_vm._v(" "),(row.ownerDisplayName)?_c('span',{staticClass:"text-muted"},[_vm._v(" ("+_vm._s(row.ownerDisplayName)+")")]):_vm._e()],2)]}},{key:"cell:zone_id",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(_vm.zoneCode(row.zoneId)))]}},{key:"cell:beginning_of_year_status",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.beginningOfYearStatus))]}},{key:"cell:horse_status_id",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(_vm.statusName(row.horseStatusId)))]}}])})],1),_vm._v(" "),_c('div',{staticClass:"form-inline justify-content-between align-items-start mt-3"},[_c('div',{staticClass:"d-flex align-items-center justify-content-center justify-content-md-start form-group mb-3 mb-md-0 col-12 col-md-auto px-0"},[_c('label',{staticClass:"mr-2 mb-0 font-weight-normal",attrs:{"for":"memberHorsesShow"}},[_vm._v("Show")]),_vm._v(" "),_c('select',{staticClass:"form-control mr-2",attrs:{"id":"memberHorsesShow"},domProps:{"value":_vm.filters.per_page},on:{"change":function($event){_vm.setPerPage(Number($event.target.value))}}},_vm._l((_vm.perPageOptions),function(n){return _c('option',{key:n,domProps:{"value":n}},[_vm._v(_vm._s(n))])}),0),_vm._v(" "),_c('span',[_vm._v("Entries")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.totalPages > 1),expression:"totalPages > 1"}],staticClass:"pagination-container form-group align-items-start justify-content-center mb-3 mb-md-0"},[_c('pagination',{attrs:{"total-pages":_vm.totalPages,"page":_vm.page,"on-change":_vm.setPage,"disabled":_vm.loading}})],1)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-muted"},[_vm._v("\n    Horses this member (or another member on the same account) owns or rides.\n    "),_c('span',{staticClass:"badge alert-prim"},[_vm._v("Owner")]),_vm._v(" / "),_c('span',{staticClass:"badge alert-secondary"},[_vm._v("Rider")]),_vm._v("\n    mark this member's own direct link to the horse; "),_c('span',{staticClass:"badge alert-dark"},[_vm._v("Family")]),_vm._v("\n    means they can ride it only because a family member is its direct owner/rider.\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberProfileScore_vue__ = __webpack_require__(303);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68fb3b74_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberProfileScore_vue__ = __webpack_require__(784);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberProfileScore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68fb3b74_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberProfileScore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"needs-validation ml-0"},[(_vm.memberId)?_c('section',{staticClass:"col px-0 pr-lg-3"},[_vm._m(0),_vm._v(" "),(_vm.errors)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors))]):_vm._e(),_vm._v(" "),(Object.values(_vm.results).length && _vm.loaded)?_c('div',_vm._l((Object.values(_vm.results)),function(result,resultIndex){return _c('div',{key:("result" + resultIndex),staticClass:"mb-4"},[_c('h2',{staticClass:"h5"},[_vm._v("Results for ACA year "+_vm._s(Object.keys(_vm.results)[resultIndex]))]),_vm._v(" "),_c('table',{staticClass:"table table-striped table-sm mb-0"},[_vm._m(1,true),_vm._v(" "),_c('tbody',_vm._l((result),function(row,rowIndex){return _c('tr',{key:rowIndex},[_c('td',[(row.start_date)?_c('span',[_vm._v(_vm._s(new Date(row.start_date).toLocaleString('en-AU', { day: '2-digit', month: '2-digit', year: 'numeric' })))]):_vm._e()]),_vm._v(" "),_c('td',[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(row.draft.name))]),_vm._v(" "),_c('div',{staticClass:"d-lg-none"},[_c('div',[_vm._v("Zone: "+_vm._s(row.zone_name))]),_vm._v(" "),_c('div',[_vm._v("Event: "+_vm._s(row.event_name))]),_vm._v(" "),_c('div',[_vm._v("Horse: "),(row.horse && row.horse.name && row.horse.registration_date)?_c('tableTextTemplate',{attrs:{"text":row.horse.name,"link":'Horse Profile',"slug":row.horse.id,"row":row.horse,"score":true,"options":{ showLinks: true }}}):(row.horse && row.horse.name)?_c('span',[_vm._v(_vm._s(row.horse.name))]):_vm._e(),_vm._v(" "),(row.horse ? !row.horse.registration_date : false)?_c('small',{staticClass:"d-block font-italic text-primary"},[_vm._v("Unregistered")]):_vm._e()],1)])]),_vm._v(" "),_c('td',{staticClass:"d-none d-lg-table-cell"},[_vm._v(_vm._s(row.zone_name))]),_vm._v(" "),_c('td',{staticClass:"d-none d-lg-table-cell"},[_vm._v(_vm._s(row.event_name))]),_vm._v(" "),_c('td',{staticClass:"d-none d-lg-table-cell"},[(row.horse && row.horse.name && row.horse.registration_date)?_c('tableTextTemplate',{attrs:{"text":row.horse.name,"link":'Horse Profile',"slug":row.horse.id,"row":row.horse,"score":true,"options":{ showLinks: true }}}):(row.horse && row.horse.name)?_c('span',[_vm._v(_vm._s(row.horse.name))]):_vm._e(),_vm._v(" "),(row.horse ? !row.horse.registration_date : false)?_c('small',{staticClass:"d-block font-italic text-primary"},[_vm._v("Unregistered")]):_vm._e()],1),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(row.place)+"\n                "),_c('div',{staticClass:"d-lg-none"},[_c('div',[_vm._v("Score: "+_vm._s(row.score))]),_vm._v(" "),_c('div',[_vm._v("Points: "+_vm._s(row.points === '0.00' ? '-' : row.points))])])]),_vm._v(" "),_c('td',{staticClass:"d-none d-lg-table-cell"},[_vm._v(_vm._s(row.score))]),_vm._v(" "),_c('td',{staticClass:"d-none d-lg-table-cell"},[_vm._v(_vm._s(row.points === '0.00' ? '-' : row.points))])])}),0)])])}),0):(!_vm.loaded)?_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("\n      There are no results for this rider.\n    ")])]):_c('section',{staticClass:"col px-0 pr-lg-3"},[_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-between align-items-start mb-3"},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v("Rider Results")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-dark text-uppercase"},[_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Draft")]),_vm._v(" "),_c('th',{staticClass:"d-none d-lg-table-cell"},[_vm._v("Zone")]),_vm._v(" "),_c('th',{staticClass:"d-none d-lg-table-cell"},[_vm._v("Event")]),_vm._v(" "),_c('th',{staticClass:"d-none d-lg-table-cell"},[_vm._v("Horse")]),_vm._v(" "),_c('th',[_vm._v("Place")]),_vm._v(" "),_c('th',{staticClass:"d-none d-lg-table-cell"},[_vm._v("Score")]),_vm._v(" "),_c('th',{staticClass:"d-none d-lg-table-cell"},[_vm._v("Points")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',[_vm._l((_vm.visibleTabs),function(t){return _c('li',{key:t.key,staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === t.key ? 'active' : ''],attrs:{"href":"","id":((t.key) + "-tab"),"data-toggle":"tab","role":"tab","aria-controls":t.key,"aria-selected":_vm.selectedTab === t.key ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();return _vm.selectTab(t.key)}}},[_vm._v(_vm._s(t.label))])])}),_vm._v(" "),(_vm.selectedTab === 'loading')?_c('div',{staticClass:"tab-pane col-12 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active",attrs:{"slot":"tabContent","id":"loading","role":"tabpanel","aria-labelledby":"loading-tab"},slot:"tabContent"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])]):(_vm.currentTab)?_c(_vm.currentTab.component,_vm._g(_vm._b({tag:"component",class:_vm.currentTab.wrapperClass,attrs:{"slot":"tabContent","id":_vm.currentTab.key,"role":"tabpanel","aria-labelledby":((_vm.currentTab.key) + "-tab")},slot:"tabContent"},'component',_vm.currentTab.props,false),_vm.currentTab.on || {})):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberProfileChild_vue__ = __webpack_require__(304);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53d82c5e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberProfileChild_vue__ = __webpack_require__(787);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberProfileChild_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53d82c5e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberProfileChild_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',[_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'details' ? 'active' : ''],attrs:{"href":"","id":"details-tab","data-toggle":"tab","role":"tab","aria-controls":"details","aria-selected":_vm.selectedTab === 'details' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'details'}}},[_vm._v("Details")])]),_vm._v(" "),(_vm.memberDetails)?_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'membership' ? 'active' : ''],attrs:{"href":"","id":"membership-tab","data-toggle":"tab","role":"tab","aria-controls":"membership","aria-selected":_vm.selectedTab === 'membership' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'membership'}}},[_vm._v("Membership")])]):_vm._e(),_vm._v(" "),(_vm.memberDetails)?_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'financials' ? 'active' : ''],attrs:{"href":"","id":"financials-tab","data-toggle":"tab","role":"tab","aria-controls":"financials","aria-selected":_vm.selectedTab === 'financials' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'financials'}}},[_vm._v("Financials")])]):_vm._e(),_vm._v(" "),(_vm.memberDetails)?_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'history' ? 'active' : ''],attrs:{"href":"","id":"history-tab","data-toggle":"tab","role":"tab","aria-controls":"history","aria-selected":_vm.selectedTab === 'history' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'history'}}},[_vm._v("History")])]):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'details')?_c('member-profile-details',{staticClass:"tab-pane row mx-0 show active",attrs:{"slot":"tabContent","memberDetails":_vm.memberDetails,"id":"details","role":"tabpanel","aria-labelledby":"details-tab"},on:{"renew":function($event){return _vm.$router.push({ name: 'Member Profile', params: { renewing: true, tab: 'membership' } })}},slot:"tabContent"}):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'membership')?_c('member-profile-membership',{class:['tab-pane show active', (_vm.userRole === 'Admin' || _vm.userRole === 'SuperAdmin') ? 'row mx-0' : 'bg-white rounded mb-4 p-3 p-sm-4 col-12 col-xl-9'],attrs:{"slot":"tabContent","my":false,"memberDetails":_vm.primaryMember,"id":"membership","role":"tabpanel","aria-labelledby":"membership-tab"},slot:"tabContent"}):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'financials')?_c('member-profile-financials',{staticClass:"tab-pane col-12 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active",attrs:{"slot":"tabContent","memberID":_vm.memberDetails.id,"id":"financials","role":"tabpanel","aria-labelledby":"financials-tab"},slot:"tabContent"}):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'history')?_c('member-profile-history',{staticClass:"tab-pane col-md-11 col-lg-10 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active",attrs:{"slot":"tabContent","memberID":_vm.memberDetails.id,"membership_options":_vm.memberDetails.membership_options,"id":"history","role":"tabpanel","aria-labelledby":"history-tab"},slot:"tabContent"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberMerge_vue__ = __webpack_require__(305);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4454bfc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberMerge_vue__ = __webpack_require__(790);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberMerge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4454bfc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberMerge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = buildColumns;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildBreakpoints;
// Mirrors views/Members/Join/columns.js (same picker shape: checkbox + First/Last Name +
// Membership No. + Zone) — column keys double as backend sort keys (UserFilters::LIST_SORTABLE).
// 'select' and 'member_number' are not sortable, matching the legacy DataTable definition for
// this page.
function buildColumns() {
  return [{
    key: 'select',
    label: '',
    minWidth: '40px',
    width: '0.3fr'
  }, {
    key: 'first_name',
    label: 'First Name',
    sortable: true,
    minWidth: '100px',
    width: '1.4fr'
  }, {
    key: 'last_name',
    label: 'Last Name',
    sortable: true,
    minWidth: '130px',
    width: '2fr'
  }, {
    key: 'member_number',
    label: 'Membership No.',
    minWidth: '110px',
    width: '1.6fr'
  }, {
    key: 'zone_id',
    label: 'Zone',
    sortable: true,
    minWidth: '60px',
    width: '0.7fr'
  }];
} // Below 700px: checkbox + combined name always visible, same treatment as Join's columns.js.

function buildBreakpoints() {
  return [{
    maxWidth: 700,
    hideHeader: true,
    accordion: {
      summary: [{
        keys: ['select'],
        hideLabel: true
      }, {
        keys: ['name'],
        hideLabel: true
      }]
    },
    rows: [['member_number'], ['zone_id']]
  }];
}

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('h1',{staticClass:"h2",attrs:{"slot":"heading"},slot:"heading"},[_vm._v("Select Member To Merge")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.success)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.success))]):(_vm.errors)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.errors))]):_vm._e(),_vm._v(" "),_c('h2',{staticClass:"h4"},[_vm._v("This member will be kept")]),_vm._v(" "),_c('div',{staticClass:"bg-lighter rounded mb-3 py-2 px-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-auto"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.memberDetails.member_number),expression:"memberDetails.member_number"}]},[_vm._v(_vm._s(_vm.memberDetails.member_number)+": ")]),_vm._v(_vm._s(_vm.memberDetails.first_name)+" "+_vm._s(_vm.memberDetails.last_name)+" "),_c('br')]),_vm._v(" "),(_vm.memberZone)?_c('div',{staticClass:"col-md-auto"},[_vm._v("\n          "+_vm._s('Zone: ' + _vm.memberZone)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.memberDetails.dob)?_c('div',{staticClass:"col-md-auto"},[_vm._v("\n          "+_vm._s('DoB: ' + new Date(_vm.memberDetails.dob.replace(/-/g, '/')).toLocaleDateString('en-AU'))+" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.memberDetails.membership_status)?_c('div',{staticClass:"col-md-auto"},[_vm._v("\n          "+_vm._s('Status: ' + _vm.memberDetails.membership_status)+"\n        ")]):_vm._e()])]),_vm._v(" "),_c('h2',{staticClass:"h4"},[_vm._v("Select member to merge with the above")]),_vm._v(" "),_c('p',[_vm._v("Only one member can be selected from the table below for merge with the above member.")]),_vm._v(" "),_c('div',{staticClass:"form-inline mb-sm-3 d-flex justify-content-end"},[_c('div',{staticClass:"form-group col-12 col-lg-auto mt-2 mt-lg-0 mt-xl-0 ml-auto px-0 action_section"},[_c('label',{staticClass:"d-none d-lg-inline mr-xl-2 mb-0 pr-2 font-weight-normal",attrs:{"for":"mergeMembersSearch"}},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"input-append d-flex flex-grow-1 flex-md-grow-0 mr-md-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],staticClass:"form-control mb-0 flex-grow-1 flex-md-grow-0",attrs:{"id":"mergeMembersSearch","type":"text"},domProps:{"value":(_vm.searchInput)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applySearch($event)},"search":_vm.applySearch,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('svg',{staticClass:"append",attrs:{"role":"button","aria-label":"Search","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14","width":"16","height":"16"},on:{"click":_vm.applySearch}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M5.5 11C2.5 11 0 8.5 0 5.5S2.5 0 5.5 0 11 2.5 11 5.5 8.5 11 5.5 11zm0-10C3 1 1 3 1 5.5S3 10 5.5 10 10 8 10 5.5 8 1 5.5 1z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#231815","d":"M9.5 8.8l4.4 4.4c.2.2.2.5 0 .7l-.4.1-.4-.1-4.4-4.4.8-.7z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"position-relative",staticStyle:{"min-height":"240px"}},[_c('responsive-table',{attrs:{"columns":_vm.columns,"rows":_vm.visibleRows,"loading":_vm.loading,"breakpoints":_vm.breakpoints,"sort":_vm.filters.sort,"direction":_vm.filters.direction,"empty-text":"No members found."},on:{"sort":_vm.setSort},scopedSlots:_vm._u([{key:"cell:select",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"custom-control custom-checkbox custom-control-inline mr-0"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":("mergeSelect" + (row.id))},domProps:{"checked":_vm.isSelected(row.id)},on:{"change":function($event){return _vm.toggleSelect(row)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":("mergeSelect" + (row.id))}})])]}},{key:"cell:name",fn:function(ref){
var row = ref.row;
return [_c('list-name-cell',{attrs:{"label":((row.first_name) + " " + (row.last_name)),"to":{ name: 'Member Profile', params: { slug: row.id } }}})]}},{key:"cell:first_name",fn:function(ref){
var row = ref.row;
return [_c('router-link',{attrs:{"to":{ name: 'Member Profile', params: { slug: row.id } }}},[_vm._v(_vm._s(row.first_name))])]}},{key:"cell:last_name",fn:function(ref){
var row = ref.row;
return [_c('router-link',{attrs:{"to":{ name: 'Member Profile', params: { slug: row.id } }}},[_vm._v(_vm._s(row.last_name))])]}},{key:"cell:member_number",fn:function(ref){
var row = ref.row;
return [_c('list-name-cell',{attrs:{"align":"right","label":row.member_number},scopedSlots:_vm._u([{key:"badges",fn:function(){return [(row.is_primary)?_c('span',{staticClass:"badge alert-prim"},[_vm._v("Primary")]):_vm._e()]},proxy:true}],null,true)})]}},{key:"cell:zone_id",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(_vm.zoneCode(row.zone_id)))]}}])})],1),_vm._v(" "),_c('div',{staticClass:"form-inline justify-content-between align-items-start mt-3"},[_c('div',{staticClass:"d-flex align-items-center justify-content-center justify-content-md-start form-group mb-3 mb-md-0 col-12 col-md-auto px-0"},[_c('label',{staticClass:"mr-2 mb-0 font-weight-normal",attrs:{"for":"mergeMembersShow"}},[_vm._v("Show")]),_vm._v(" "),_c('select',{staticClass:"form-control mr-2",attrs:{"id":"mergeMembersShow"},domProps:{"value":_vm.filters.per_page},on:{"change":function($event){_vm.setPerPage(Number($event.target.value))}}},_vm._l((_vm.perPageOptions),function(n){return _c('option',{key:n,domProps:{"value":n}},[_vm._v(_vm._s(n))])}),0),_vm._v(" "),_c('span',[_vm._v("Entries")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.totalPages > 1),expression:"totalPages > 1"}],staticClass:"pagination-container form-group align-items-start justify-content-center mb-3 mb-md-0"},[_c('pagination',{attrs:{"total-pages":_vm.totalPages,"page":_vm.page,"on-change":_vm.setPage,"disabled":_vm.loading}})],1)]),_vm._v(" "),(Object.keys(_vm.memberDetails).length && Object.keys(_vm.removeMember).length)?_c('div',{staticClass:"sticky-bottom alert bg-primary text-white d-flex flex-wrap align-items-center mb-0",attrs:{"role":"alert"}},[_c('div',{staticClass:"flex-grow-1 pr-3 text-center text-lg-left"},[_c('strong',[_vm._v("You have selected: ")]),_vm._v("\n        "+_vm._s(_vm.removeMember.first_name + ' ' + _vm.removeMember.last_name)+"\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-white btn-block-mob mt-2 mt-lg-0 text-nowrap",on:{"click":function($event){_vm.showModal = true}}},[_vm._v("Merge Selected")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-white ml-lg-2 btn-block-mob",on:{"click":function($event){$event.preventDefault();return _vm.deselectAll($event)}}},[_vm._v("Cancel")])]):_vm._e(),_vm._v(" "),(_vm.showModal)?_c('modal',{on:{"close":function($event){_vm.showModal = false}}},[_c('h3',{staticClass:"modal-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Please confirm the members to be merged")]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n          This operation cannot be undone.\n        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h4',[_vm._v("Member To Keep")]),_vm._v(" "),_c('div',{staticClass:"bg-lighter rounded mb-3 py-2 px-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-auto"},[_vm._v("\n                  "+_vm._s(_vm.memberDetails.member_number + ': ' + _vm.memberDetails.first_name + ' ' + _vm.memberDetails.last_name)+" "),_c('br')]),_vm._v(" "),(_vm.memberZone)?_c('div',{staticClass:"col-md-auto"},[_vm._v("\n                  "+_vm._s('Zone: ' + _vm.memberZone)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.memberDetails.dob)?_c('div',{staticClass:"col-md-auto"},[_vm._v("\n                  "+_vm._s('DoB: ' + new Date(_vm.memberDetails.dob.replace(/-/g, '/')).toLocaleDateString('en-AU'))+" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.memberDetails.membership_status)?_c('div',{staticClass:"col-md-auto"},[_vm._v("\n                  "+_vm._s('Status: ' + _vm.memberDetails.membership_status)+"\n                ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h4',[_vm._v("Member To Remove")]),_vm._v(" "),_c('div',{staticClass:"bg-lighter rounded mb-3 py-2 px-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-auto"},[_vm._v("\n                  "+_vm._s(_vm.removeMember.member_number + ': ' + _vm.removeMember.first_name + ' ' + _vm.removeMember.last_name)+" "),_c('br')]),_vm._v(" "),(_vm.removeMemberZone)?_c('div',{staticClass:"col-md-auto"},[_vm._v("\n                  "+_vm._s('Zone: ' + _vm.removeMemberZone)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.removeMember.dob)?_c('div',{staticClass:"col-md-auto"},[_vm._v("\n                  "+_vm._s('DoB: ' + new Date(_vm.removeMember.dob.replace(/-/g, '/')).toLocaleDateString('en-AU'))+" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.removeMember.membership_status)?_c('div',{staticClass:"col-md-auto"},[_vm._v("\n                  "+_vm._s('Status: ' + _vm.removeMember.membership_status)+"\n                ")]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"w-100 d-flex justify-content-end",attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.mergeMembers(); _vm.showModal = false}}},[_vm._v("Confirm")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary ml-2",on:{"click":function($event){$event.preventDefault();_vm.deselectAll(); _vm.showModal = false}}},[_vm._v("Cancel")])])]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberSplit_vue__ = __webpack_require__(306);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_404de4aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberSplit_vue__ = __webpack_require__(792);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberSplit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_404de4aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberSplit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',[_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'details' ? 'active' : ''],attrs:{"href":"","id":"details-tab","data-toggle":"tab","role":"tab","aria-controls":"details","aria-selected":_vm.selectedTab === 'details' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'details'}}},[_vm._v("Details")])]),_vm._v(" "),(_vm.selectedTab === 'details')?_c('member-profile-details',{staticClass:"tab-pane row mx-0 show active",attrs:{"slot":"tabContent","memberDetails":_vm.memberDetails,"split":true,"id":"details","role":"tabpanel","aria-labelledby":"details-tab"},slot:"tabContent"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PendingInvoices_vue__ = __webpack_require__(307);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77f95c18_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PendingInvoices_vue__ = __webpack_require__(794);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PendingInvoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77f95c18_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PendingInvoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"h2 mb-0"},[_vm._v("Pending Payments")])]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.success)?_c('div',{ref:"success",staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.success))]):_vm._e(),_vm._v(" "),(_vm.error.length)?_c('div',{ref:"error",staticClass:"alert alert-warning"},[_c('ul',{staticClass:"list-unstyled mb-0"},_vm._l((_vm.error),function(item,key){return _c('li',{key:key},[_vm._v(_vm._s(item))])}),0)]):_vm._e(),_vm._v(" "),_c('data-table',{attrs:{"dataRows":_vm.rows,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{attrs:{"text":row.user.first_name + ' ' + row.user.last_name,"row":row,"options":{ expandMobile: true, showPaid: true }}})}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',[_c('strong',[_vm._v("Membership No: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":new Date(row.created_at.replace(/-/g, '/')).toLocaleString('en-AU'),"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Amount: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":'$' + row.total,"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Payment Method: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.payment_method.charAt(0).toUpperCase() + row.payment_method.slice(1),"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Purchase: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.type.charAt(0).toUpperCase() + row.type.slice(1),"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',{staticClass:"pt-3 d-block"},[_c('button',{class:['btn btn-block-mob btn-sm mb-2 mb-lg-0', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],on:{"click":function($event){$event.preventDefault();return _vm.approveModal(row.id)}}},[_vm._v("\n              "+_vm._s(!_vm.processing ? 'Approve' : '')+"\n              "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]),_vm._v(" "),_c('button',{class:['btn btn-block-mob btn-sm mb-2 mb-lg-0', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],on:{"click":function($event){$event.preventDefault();return _vm.denyModal(row.id)}}},[_vm._v("\n              "+_vm._s(!_vm.processing ? 'Deny' : '')+"\n              "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]),_vm._v(" "),(_vm.showApproveModal)?_c('modal',{on:{"close":function($event){_vm.showApproveModal = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n                  You are about to approve the payment from member ‘"+_vm._s(row.user.first_name + ' ' + row.user.last_name)+"’. Notify user and proceed with approval?\n                ")]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col"},[_c('label',{attrs:{"for":"payment_date"}},[_vm._v("Payment Date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment.paymentDate),expression:"payment.paymentDate"}],staticClass:"form-control",attrs:{"id":"payment_date","type":"date","placeholder":[_vm.isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy'],"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}"},domProps:{"value":(_vm.payment.paymentDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.payment, "paymentDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col"},[_c('label',{attrs:{"for":"invoice_number"}},[_vm._v("Invoice Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment.invoiceNumber),expression:"payment.invoiceNumber"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.payment.invoiceNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.payment, "invoiceNumber", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.showApproveModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary ml-2",on:{"click":function($event){$event.preventDefault();_vm.approve();_vm.showApproveModal = false}}},[_vm._v("Approve")])])])]):_vm._e(),_vm._v(" "),(_vm.showDenyModal)?_c('modal',{on:{"close":function($event){_vm.showDenyModal = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n                  You are about to deny the payment from member ‘"+_vm._s(row.user.first_name + ' ' + row.user.last_name)+"’. Notify user and proceed?\n                ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.showDenyModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary ml-2",on:{"click":function($event){$event.preventDefault();_vm.deny();_vm.showDenyModal = false}}},[_vm._v("Confirm")])])])]):_vm._e()],1)])])}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PendingRegistrations_vue__ = __webpack_require__(308);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_792b9abe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PendingRegistrations_vue__ = __webpack_require__(796);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PendingRegistrations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_792b9abe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PendingRegistrations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"h2 mb-0"},[_vm._v("Pending Horse Updates")])]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.success)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.success))]):_vm._e(),_vm._v(" "),(_vm.status)?_c('div',{staticClass:"alert alert-info"},[_vm._v(_vm._s(_vm.status))]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('data-table',{attrs:{"dataRows":_vm.rows,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{attrs:{"text":row.name,"link":'Pending Horse',"row":row,"options":{ showLinks: true, expandMobile: true }}})}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',[_c('strong',[_vm._v("Owner: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.owner,"row":row,"options":{ showRegistered: true, inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Date of Birth: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.dob ? new Date(row.dob.replace(/-/g, '/')).toLocaleDateString('en-AU') : '',"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Sex: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.gender,"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Status: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.status ? row.status.name : '',"row":row,"options":{ inline: true }}})],1)])])}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Horse_vue__ = __webpack_require__(309);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05a00b76_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Horse_vue__ = __webpack_require__(803);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Horse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05a00b76_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Horse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"needs-validation ml-0"},[(_vm.horseId)?_c('div',{staticClass:"col px-0 pr-lg-3"},[_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_vm._m(0),_vm._v(" "),(_vm.errors)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors))]):_vm._e(),_vm._v(" "),(Object.values(_vm.results).length && _vm.loaded)?_c('div',_vm._l((Object.values(_vm.results)),function(result,resultIndex){return _c('div',{key:("result" + resultIndex),staticClass:"mb-4"},[_c('h2',{staticClass:"h5"},[_vm._v("Results for ACA year "+_vm._s(Object.keys(_vm.results)[resultIndex]))]),_vm._v(" "),_c('table',{staticClass:"table table-striped table-sm mb-0"},[_vm._m(1,true),_vm._v(" "),_c('tbody',_vm._l((result),function(row,rowIndex){return _c('tr',{key:("row" + rowIndex)},[_c('td',[(row.start_date)?_c('span',[_vm._v(_vm._s(new Date(row.start_date).toLocaleString('en-AU', { day: '2-digit', month: '2-digit', year: 'numeric' })))]):_vm._e()]),_vm._v(" "),_c('td',[(row.draft)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(row.draft.name))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-lg-none"},[_c('div',[_vm._v("Zone: "+_vm._s(row.zone_name))]),_vm._v(" "),_c('div',[_vm._v("Event: "+_vm._s(row.event_name))]),_vm._v(" "),_c('div',[_vm._v("Rider: "),(row.rider)?_c('a',{attrs:{"href":'/rider/' + row.rider.id}},[_vm._v(_vm._s(row.rider.name))]):_vm._e()])])]),_vm._v(" "),_c('td',{staticClass:"d-none d-lg-table-cell"},[_vm._v(_vm._s(row.zone_name))]),_vm._v(" "),_c('td',{staticClass:"d-none d-lg-table-cell"},[_vm._v(_vm._s(row.event_name))]),_vm._v(" "),_c('td',{staticClass:"d-none d-lg-table-cell"},[_c('tableTextTemplate',{attrs:{"text":row.rider.name,"link":'Member Profile',"slug":row.rider.id,"row":row.rider,"score":true,"options":{ showLinks: true }}})],1),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(row.place)+"\n                  "),_c('div',{staticClass:"d-lg-none"},[_c('div',[_vm._v("Score: "+_vm._s(row.score))]),_vm._v(" "),_c('div',[_vm._v("Points: "+_vm._s(row.points === '0.00' ? '-' : row.points))])])]),_vm._v(" "),_c('td',{staticClass:"d-none d-lg-table-cell"},[_vm._v(_vm._s(row.score))]),_vm._v(" "),_c('td',{staticClass:"d-none d-lg-table-cell"},[_vm._v(_vm._s(row.points === '0.00' ? '-' : row.points))])])}),0)])])}),0):(!_vm.loaded)?_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("\n        There are no results for this horse.\n      ")])])]):_c('section',{staticClass:"col px-0 pr-lg-3"},[_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-between align-items-start mb-3"},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v("Horse Results")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-dark text-uppercase"},[_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Draft")]),_vm._v(" "),_c('th',{staticClass:"d-none d-lg-table-cell"},[_vm._v("Zone")]),_vm._v(" "),_c('th',{staticClass:"d-none d-lg-table-cell"},[_vm._v("Event")]),_vm._v(" "),_c('th',{staticClass:"d-none d-lg-table-cell"},[_vm._v("Rider")]),_vm._v(" "),_c('th',[_vm._v("Place")]),_vm._v(" "),_c('th',{staticClass:"d-none d-lg-table-cell"},[_vm._v("Score")]),_vm._v(" "),_c('th',{staticClass:"d-none d-lg-table-cell"},[_vm._v("Points")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseDetails_vue__ = __webpack_require__(312);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d0e7537_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseDetails_vue__ = __webpack_require__(802);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d0e7537_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hss",on:{"focusin":_vm.onFocusIn,"focusout":_vm.onFocusOut}},[_c('multiselect',{ref:"ms",attrs:{"id":_vm.elementId,"value":null,"options":_vm.mergedOptions,"loading":_vm.loading,"internal-search":false,"searchable":_vm.active,"allow-empty":true,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"track-by":"id","custom-label":_vm.labelFor,"select-label":"","selected-label":"","deselect-label":""},on:{"select":_vm.onSelect,"search-change":_vm.onSearch,"open":_vm.onOpen,"close":_vm.onClose}},[_c('template',{slot:"noResult"},[(!_vm.loading)?_c('span',[_vm._v("No horses found.")]):_vm._e()]),_vm._v(" "),_c('template',{slot:"noOptions"},[_vm._v("Start typing to search...")]),_vm._v(" "),(_vm.loadingMore)?_c('li',{staticClass:"multiselect__element",attrs:{"slot":"afterList"},slot:"afterList"},[_c('span',{staticClass:"multiselect__option text-muted"},[_vm._v("Loading more...")])]):_vm._e()],2),_vm._v(" "),(_vm.selectedOption)?_c('div',{staticClass:"tags-input mt-1"},[_c('span',{staticClass:"badge"},[(!_vm.disabled)?_c('button',{staticClass:"tags-input-remove",attrs:{"type":"button","aria-label":"Remove"},on:{"mousedown":function($event){$event.preventDefault();},"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.clear($event)}}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"tags-input-label"},[_vm._v(_vm._s(_vm.labelFor(_vm.selectedOption)))])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation ml-0",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.update($event)}}},[(_vm.horse ? _vm.horse.id ? true : false : false)?_c('div',{staticClass:"col px-0 pr-lg-3"},[_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('div',{staticClass:"d-flex justify-content-between align-items-start"},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v("Horse Profile - Pending")]),_vm._v(" "),(_vm.horse.registration_date)?_c('span',{staticClass:"badge badge-info flex-shrink-0"},[_vm._v("Registered")]):_c('span',{staticClass:"badge alert-warning flex-shrink-0"},[_vm._v("Unregistered")])]),_vm._v(" "),(_vm.errors)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":"horseNamePending"}},[_vm._v("Horse Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horsePending.name),expression:"horsePending.name"}],staticClass:"form-control",attrs:{"type":"text","id":"horseNamePending","required":""},domProps:{"value":(_vm.horsePending.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horsePending, "name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Horse Name.")])]),_vm._v(" "),(Object.keys(_vm.ownersList).length > 0)?_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"horseOwnerPending"}},[_vm._v("Owner")]),_vm._v(" "),_c('div',{staticClass:"form-inline align-items-start"},[_c('tags-input',{ref:"tagsInput",attrs:{"element-id":"horseOwnerPending","existing-tags":_vm.ownersList,"onlyExistingTags":true,"addTagsOnComma":true,"typeahead":true,"typeaheadStyle":'dropdown',"typeaheadMaxResults":20,"typeaheadActivationThreshold":2,"limit":1,"placeholder":'Start Typing...',"instruction":'Maximum of one owner'},model:{value:(_vm.horsePending.owners),callback:function ($$v) {_vm.$set(_vm.horsePending, "owners", $$v)},expression:"horsePending.owners"}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip",style:(_vm.isInvalidPending ? 'display: block': '')},[_vm._v("Please include the Owner of the horse.")])],1)]):_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 text-center py-2 m-auto"},[_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg form-group"},[_c('label',{attrs:{"for":"horseDobPending"}},[_vm._v("Date of Birth")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horsePending.dob),expression:"horsePending.dob"}],class:['form-control form-date', _vm.errorStatus === 'validation_error' ? 'is-invalid' : ''],attrs:{"type":"date","id":"horseDobPending","required":"","placeholder":[_vm.isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy'],"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}"},domProps:{"value":(_vm.horsePending.dob)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horsePending, "dob", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Date of Birth of the horse"+_vm._s(_vm.isLegacy() ? ' in the format yyyy-mm-dd' : '')+".")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-auto form-group"},[_c('label',{attrs:{"for":"sexPending"}},[_vm._v("Sex")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.horsePending.gender),expression:"horsePending.gender"}],staticClass:"form-control",attrs:{"id":"sexPending","required":"","name":"horseSex"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.horsePending, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"default":""}}),_vm._v(" "),_c('option',{attrs:{"value":"Mare"}},[_vm._v("Mare")]),_vm._v(" "),_c('option',{attrs:{"value":"Gelding"}},[_vm._v("Gelding")]),_vm._v(" "),_c('option',{attrs:{"value":"Stallion"}},[_vm._v("Stallion")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-3 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"statusPending"}},[_vm._v("Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.horsePending.status.id),expression:"horsePending.status.id"}],staticClass:"form-control",attrs:{"id":"statusPending","required":(_vm.user === 'Admin' || _vm.user === 'SuperAdmin'),"disabled":_vm.user === 'Member' || _vm.user === 'Secretary'},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.horsePending.status, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.$store.state.horseStatus),function(status,index){return _c('option',{key:index,domProps:{"value":status.id}},[_vm._v(_vm._s(status.name))])}),0),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Status.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"not-required"},[_c('horse-search-select',{attrs:{"element-id":"horseSirePending","value":_vm.horsePending.sire_id || []},on:{"input":function (v) { return _vm.horsePending.sire_id = v; }}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"not-required"},[_c('horse-search-select',{attrs:{"element-id":"horseDamPending","value":_vm.horsePending.dam_id || []},on:{"input":function (v) { return _vm.horsePending.dam_id = v; }}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horsePending.ashs_number),expression:"horsePending.ashs_number"}],staticClass:"form-control",attrs:{"type":"text","id":"ashsPending"},domProps:{"value":(_vm.horsePending.ashs_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horsePending, "ashs_number", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_vm._m(4),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horsePending.aqhs_number),expression:"horsePending.aqhs_number"}],staticClass:"form-control",attrs:{"type":"text","id":"aqhsPending"},domProps:{"value":(_vm.horsePending.aqhs_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horsePending, "aqhs_number", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 d-flex flex-wrap d-lg-none justify-content-end"},[_c('button',{class:['btn btn-block-mob', _vm.processing[0] ? 'btn-primary-dark' : 'btn-primary'],on:{"click":_vm.handleSubmit}},[_vm._v("\n            "+_vm._s(!_vm.processing[0] ? 'Approve' : '')+"\n            "),(_vm.processing[0])?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]),_vm._v(" "),_c('button',{class:['btn btn-block-mob', _vm.processing[1] ? 'btn-primary-dark' : 'btn-outline-primary'],on:{"click":function($event){$event.preventDefault();return _vm.denyHorse($event)}}},[_vm._v("\n            "+_vm._s(!_vm.processing[1] ? 'Deny' : '')+"\n            "),(_vm.processing[1])?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])])])]),_vm._v(" "),_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":"horseName"}},[_vm._v("Horse Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horse.name),expression:"horse.name"}],staticClass:"form-control",attrs:{"type":"text","id":"horseName","disabled":""},domProps:{"value":(_vm.horse.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horse, "name", $event.target.value)}}})]),_vm._v(" "),(Object.keys(_vm.ownersList).length > 0)?_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"horseOwner"}},[_vm._v("Owner")]),_vm._v(" "),_c('div',{staticClass:"form-inline align-items-start click-events-none not-required"},[_c('tags-input',{ref:"tagsInput",attrs:{"element-id":"horseOwner","existing-tags":_vm.ownersList,"onlyExistingTags":true,"addTagsOnComma":true,"typeahead":true,"typeaheadStyle":'dropdown',"typeaheadMaxResults":20,"typeaheadActivationThreshold":2,"limit":1,"placeholder":'Start Typing...',"instruction":'Maximum of one owner'},model:{value:(_vm.horse.owners),callback:function ($$v) {_vm.$set(_vm.horse, "owners", $$v)},expression:"horse.owners"}})],1)]):_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 text-center py-2 m-auto"},[_vm._m(6)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg form-group"},[_c('label',{attrs:{"for":"horseDob"}},[_vm._v("Date of Birth")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horse.dob),expression:"horse.dob"}],staticClass:"form-control",attrs:{"type":"date","id":"horseDob","disabled":"","placeholder":"dd/mm/yyyy"},domProps:{"value":(_vm.horse.dob)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horse, "dob", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-auto form-group"},[_c('label',[_vm._v("Sex")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.horse.gender),expression:"horse.gender"}],staticClass:"form-control",attrs:{"disabled":"","name":"horseSex"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.horse, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"default":""}}),_vm._v(" "),_c('option',{attrs:{"value":"Mare"}},[_vm._v("Mare")]),_vm._v(" "),_c('option',{attrs:{"value":"Gelding"}},[_vm._v("Gelding")]),_vm._v(" "),_c('option',{attrs:{"value":"Stallion"}},[_vm._v("Stallion")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-3 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"status"}},[_vm._v("Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.horse.status.name),expression:"horse.status.name"}],staticClass:"form-control",attrs:{"id":"status","disabled":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.horse.status, "name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.$store.state.horseStatus),function(status,index){return _c('option',{key:index},[_vm._v(_vm._s(status.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":"horseSire"}},[_vm._v("Sire")]),_vm._v(" "),_c('div',{staticClass:"not-required"},[_c('horse-search-select',{attrs:{"element-id":"horseSire","value":_vm.horse.sire_id || [],"disabled":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"horseDam"}},[_vm._v("Dam")]),_vm._v(" "),_c('div',{staticClass:"not-required"},[_c('horse-search-select',{attrs:{"element-id":"horseDam","value":_vm.horse.dam_id || [],"disabled":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_vm._m(7),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horse.ashs_number),expression:"horse.ashs_number"}],staticClass:"form-control",attrs:{"type":"text","id":"ashs","disabled":""},domProps:{"value":(_vm.horse.ashs_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horse, "ashs_number", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_vm._m(8),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horse.aqhs_number),expression:"horse.aqhs_number"}],staticClass:"form-control",attrs:{"type":"text","id":"aqhs","disabled":""},domProps:{"value":(_vm.horse.aqhs_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horse, "aqhs_number", $event.target.value)}}})])])])]):_vm._e(),_vm._v(" "),_c('desktop-action-bar',[_c('button',{class:['btn btn-block mb-2', _vm.processing[0] ? 'btn-primary-dark' : 'btn-primary'],on:{"click":_vm.handleSubmit}},[_vm._v("\n      "+_vm._s(!_vm.processing[0] ? 'Approve' : '')+"\n      "),(_vm.processing[0])?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]),_vm._v(" "),_c('button',{class:['btn btn-block', _vm.processing[1] ? 'btn-primary-dark' : 'btn-outline-primary'],on:{"click":function($event){$event.preventDefault();return _vm.denyHorse($event)}}},[_vm._v("\n      "+_vm._s(!_vm.processing[1] ? 'Deny' : '')+"\n      "),(_vm.processing[1])?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])]),_vm._v(" "),(_vm.showModal)?_c('modal',{on:{"close":function($event){_vm.showModal = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n        You are about to approve changes to this horse registration, are you sure?\n      ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.showModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary ml-2",on:{"click":function($event){$event.preventDefault();_vm.updateHorse();_vm.showModal = false}}},[_vm._v("Confirm")])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"horseSirePending"}},[_vm._v("Sire "),_c('small',[_vm._v("(optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"horseDamPending"}},[_vm._v("Dam "),_c('small',[_vm._v("(optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"ashsPending"}},[_c('abbr',{attrs:{"title":"Australian Stock Horse Number"}},[_vm._v("ASHS#")]),_vm._v(" "),_c('small',[_vm._v("(optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"aqhsPending"}},[_c('abbr',{attrs:{"title":"Australian Quarter Horse Number"}},[_vm._v("AQHA#")]),_vm._v(" "),_c('small',[_vm._v("(optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-between align-items-start"},[_c('h2',{staticClass:"mb-3"},[_vm._v("Horse Profile - Existing")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"ashs"}},[_c('abbr',{attrs:{"title":"Australian Stock Horse Number"}},[_vm._v("ASHS#")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"aqhs"}},[_c('abbr',{attrs:{"title":"Australian Quarter Horse Number"}},[_vm._v("AQHA#")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',[_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'details' ? 'active' : ''],attrs:{"href":"","id":"details-tab","data-toggle":"tab","role":"tab","aria-controls":"details","aria-selected":_vm.selectedTab === 'details' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'details'}}},[_vm._v("Details")])]),_vm._v(" "),_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'score' ? 'active' : ''],attrs:{"href":"","id":"score-tab","data-toggle":"tab","role":"tab","aria-controls":"score","aria-selected":_vm.selectedTab === 'score' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'score'}}},[_vm._v("Results")])]),_vm._v(" "),(_vm.selectedTab === 'details')?_c('horse-profile-details',{staticClass:"tab-pane row mx-0 show active",attrs:{"slot":"tabContent"},slot:"tabContent"}):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'score')?_c('horse-profile-score',{staticClass:"tab-pane row mx-0 show active",attrs:{"slot":"tabContent"},slot:"tabContent"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminProfile_vue__ = __webpack_require__(314);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc311e1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminProfile_vue__ = __webpack_require__(808);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc311e1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminAddDetails_vue__ = __webpack_require__(317);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e7e351d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminAddDetails_vue__ = __webpack_require__(806);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminAddDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e7e351d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminAddDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.addAdmin($event)}}},[_c('div',{staticClass:"col px-0 pr-lg-3"},_vm._l((_vm.memberPages),function(memberDetail,index){return _c('section',{key:index,staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[(index === 0)?_c('h1',{staticClass:"h2 mb-3"},[_vm._v(_vm._s(_vm.edit ? 'Edit' : 'Add')+" Admin")]):_vm._e(),_vm._v(" "),(!_vm.memberDetailsHasData && _vm.edit)?_c('div',{staticClass:"col-12 flex-grow-1"},[_vm._m(0,true)]):_vm._e(),_vm._v(" "),(_vm.errors)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.errors))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group row no-gutters pr-xl-4"},[_c('div',{staticClass:"col-auto"},[_c('label',{attrs:{"for":"title"}},[_vm._v("Title")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.title),expression:"memberUpdate.title"}],staticClass:"form-control",attrs:{"id":"title","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.memberUpdate, "title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',{attrs:{"value":"Mr"}},[_vm._v("Mr")]),_vm._v(" "),_c('option',{attrs:{"value":"Ms"}},[_vm._v("Ms")]),_vm._v(" "),_c('option',{attrs:{"value":"Miss"}},[_vm._v("Miss")]),_vm._v(" "),_c('option',{attrs:{"value":"Mrs"}},[_vm._v("Mrs")]),_vm._v(" "),_c('option',{attrs:{"value":"Dr"}},[_vm._v("Dr")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the title.")])]),_vm._v(" "),_c('div',{staticClass:"col pl-3"},[_c('label',{attrs:{"for":"firstName"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.first_name),expression:"memberUpdate.first_name"}],staticClass:"form-control",attrs:{"type":"text","id":"firstName","maxlength":"40","required":""},domProps:{"value":(_vm.memberUpdate.first_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate, "first_name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the First Name.")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"lastName"}},[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.last_name),expression:"memberUpdate.last_name"}],staticClass:"form-control",attrs:{"type":"text","id":"lastName","maxlength":"40","required":""},domProps:{"value":(_vm.memberUpdate.last_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate, "last_name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Last Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.attributes.email),expression:"memberUpdate.attributes.email"}],staticClass:"form-control",attrs:{"type":"email","id":"email","maxlength":"255","required":""},domProps:{"value":(_vm.memberUpdate.attributes.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate.attributes, "email", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Email Address.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"phone"}},[_vm._v("Phone Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.attributes.phone),expression:"memberUpdate.attributes.phone"}],staticClass:"form-control",attrs:{"type":"text","id":"phone","maxlength":"15","required":""},domProps:{"value":(_vm.memberUpdate.attributes.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate.attributes, "phone", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Phone Number.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group pr-xl-4 mb-lg-0"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.password),expression:"password.password"}],staticClass:"form-control",attrs:{"type":"password","id":"password","maxlength":"30","required":!_vm.edit,"pattern":"([A-Za-z0-9]){6,}"},domProps:{"value":(_vm.password.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "password", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include a Password of at least 6 characters, using only letters and numbers.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group pl-xl-4 mb-lg-0"},[_c('label',{attrs:{"for":"confirmPassword"}},[_vm._v("Confirm Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.confirmPassword),expression:"password.confirmPassword"}],staticClass:"form-control",attrs:{"type":"password","id":"confirmPassword","maxlength":"30","required":!_vm.edit},domProps:{"value":(_vm.password.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "confirmPassword", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please ensure the password matches.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-lg-none justify-content-end"},[(_vm.edit && _vm.memberUpdate.id && _vm.loggedInUser !== _vm.memberUpdate.id)?_c('button',{staticClass:"btn btn-block-mob btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.showModal = true}}},[_vm._v("Delete")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-block-mob btn-primary ml-lg-2",attrs:{"type":"submit"},on:{"click":_vm.handleSubmit}},[_vm._v(_vm._s(_vm.edit ? 'Update' : 'Add Admin'))])])])])}),0),_vm._v(" "),_c('desktop-action-bar',[_c('button',{staticClass:"btn btn-block btn-primary",attrs:{"type":"submit"},on:{"click":_vm.handleSubmit}},[_vm._v(_vm._s(_vm.edit ? 'Update' : 'Add Admin'))]),_vm._v(" "),(_vm.edit && _vm.memberUpdate.id && _vm.loggedInUser !== _vm.memberUpdate.id)?_c('button',{staticClass:"btn btn-block btn-outline-primary mt-2",on:{"click":function($event){$event.preventDefault();_vm.showModal = true}}},[_vm._v("Delete")]):_vm._e()]),_vm._v(" "),(_vm.showModal)?_c('modal',{on:{"close":function($event){_vm.showModal = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning text-center"},[_c('strong',[_vm._v("Warning!")]),_vm._v(" "),_c('p',[_vm._v("You are about to delete this record permanently. Are you sure?")])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"col-12 d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.showModal = false;_vm.deleteAdmin()}}},[_vm._v("Confirm")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary ml-2",on:{"click":function($event){$event.preventDefault();_vm.showModal = false}}},[_vm._v("Cancel")])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center p-2"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"actionBar":true}},[_c('member-admin-add-details',{staticClass:"tab-pane row mx-0 show active",attrs:{"slot":"tabContent","memberDetails":_vm.memberDetails,"edit":_vm.edit},slot:"tabContent"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('admin-profile',{attrs:{"memberDetails":_vm.memberDetails,"edit":true}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecretaryProfile_vue__ = __webpack_require__(318);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85ab20a0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecretaryProfile_vue__ = __webpack_require__(814);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecretaryProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85ab20a0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecretaryProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecretaryAddDetails_vue__ = __webpack_require__(321);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61d376e9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecretaryAddDetails_vue__ = __webpack_require__(812);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecretaryAddDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61d376e9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecretaryAddDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4"},[_c('h1',{staticClass:"h2 mb-3"},[_vm._t("default")],2),_vm._v(" "),_c('app-alert')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.addAdmin($event)}}},[_c('div',{staticClass:"col px-0 pr-lg-3"},[_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('page-heading',[_vm._v(_vm._s(_vm.edit ? 'Edit' : 'Add')+" Secretary")]),_vm._v(" "),(!_vm.memberDetailsHasData && _vm.edit)?_c('div',{staticClass:"text-center p-2"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.errors)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.errors))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"f-form"},[_c('div',{staticClass:"f-form__pair f-form__pair--1-3"},[_c('f-group',{attrs:{"label":"Title","id":"title","required":"","tooltip":"Please include the title."}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.title),expression:"memberUpdate.title"}],staticClass:"form-control",attrs:{"id":"title","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.memberUpdate, "title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_vm._l((_vm.TITLES),function(title){return _c('option',{key:title,domProps:{"value":title}},[_vm._v(_vm._s(title))])})],2)]),_vm._v(" "),_c('f-text',{attrs:{"id":"firstName","label":"First Name","required":"","maxlength":"40","tooltip":"Please include the First Name."},model:{value:(_vm.memberUpdate.first_name),callback:function ($$v) {_vm.$set(_vm.memberUpdate, "first_name", $$v)},expression:"memberUpdate.first_name"}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__half"},[_c('f-text',{attrs:{"id":"lastName","label":"Last Name","required":"","maxlength":"40","tooltip":"Please include the Last Name."},model:{value:(_vm.memberUpdate.last_name),callback:function ($$v) {_vm.$set(_vm.memberUpdate, "last_name", $$v)},expression:"memberUpdate.last_name"}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__half"},[_c('f-text',{attrs:{"id":"email","label":"Email Address","type":"email","required":"","maxlength":"255","tooltip":"Please include the Email Address."},model:{value:(_vm.memberUpdate.attributes.email),callback:function ($$v) {_vm.$set(_vm.memberUpdate.attributes, "email", $$v)},expression:"memberUpdate.attributes.email"}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__half"},[_c('f-text',{attrs:{"id":"phone","label":"Phone Number","required":"","maxlength":"15","tooltip":"Please include the Phone Number."},model:{value:(_vm.memberUpdate.attributes.phone),callback:function ($$v) {_vm.$set(_vm.memberUpdate.attributes, "phone", $$v)},expression:"memberUpdate.attributes.phone"}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__half"},[_c('f-text',{attrs:{"id":"password","label":"Password","type":"password","required":!_vm.edit,"maxlength":"30","pattern":"([A-Za-z0-9]){6,}","tooltip":"Please include a Password of at least 6 characters, using only letters and numbers."},model:{value:(_vm.password.password),callback:function ($$v) {_vm.$set(_vm.password, "password", $$v)},expression:"password.password"}})],1),_vm._v(" "),_c('div',{staticClass:"f-form__half"},[_c('f-text',{attrs:{"id":"confirmPassword","label":"Confirm Password","type":"password","required":!_vm.edit,"maxlength":"30","tooltip":"Please ensure the password matches."},model:{value:(_vm.password.confirmPassword),callback:function ($$v) {_vm.$set(_vm.password, "confirmPassword", $$v)},expression:"password.confirmPassword"}})],1),_vm._v(" "),(_vm.edit && _vm.memberUpdate.id)?_c('div',{staticClass:"f-form__full"},[_c('super-secretary-toggle',{attrs:{"memberId":_vm.memberUpdate.id},model:{value:(_vm.memberUpdate.is_super_secretary),callback:function ($$v) {_vm.$set(_vm.memberUpdate, "is_super_secretary", $$v)},expression:"memberUpdate.is_super_secretary"}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-lg-none justify-content-end"},[(_vm.edit && _vm.memberUpdate.id && _vm.loggedInUser !== _vm.memberUpdate.id && _vm.memberUpdate.role !== 'Secretary')?_c('button',{staticClass:"btn btn-block-mob btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.showModal = true}}},[_vm._v("Delete")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-block-mob btn-primary ml-lg-2",on:{"click":_vm.handleSubmit}},[_vm._v(_vm._s(_vm.edit ? 'Update' : 'Add Secretary'))])])],1)]),_vm._v(" "),_c('desktop-action-bar',[_c('button',{staticClass:"btn btn-block btn-primary",on:{"click":_vm.handleSubmit}},[_vm._v(_vm._s(_vm.edit ? 'Update' : 'Add Secretary'))]),_vm._v(" "),(_vm.edit && _vm.memberUpdate.id && _vm.loggedInUser !== _vm.memberUpdate.id && _vm.memberUpdate.role !== 'Secretary')?_c('button',{staticClass:"btn btn-block btn-outline-primary mt-2",on:{"click":function($event){$event.preventDefault();_vm.showModal = true}}},[_vm._v("Delete")]):_vm._e()]),_vm._v(" "),(_vm.showModal)?_c('modal',{on:{"close":function($event){_vm.showModal = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning text-center"},[_c('strong',[_vm._v("Warning!")]),_vm._v(" "),_c('p',[_vm._v("You are about to delete this record permanently. Are you sure?")])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"col-12 d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.showModal = false;_vm.deleteSecretary()}}},[_vm._v("Confirm")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary ml-2",on:{"click":function($event){$event.preventDefault();_vm.showModal = false}}},[_vm._v("Cancel")])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"actionBar":true}},[_c('secretary-add-details',{staticClass:"tab-pane row mx-0 show active",attrs:{"slot":"tabContent","memberDetails":_vm.memberDetails,"edit":_vm.edit},slot:"tabContent"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('secretary-profile',{attrs:{"memberDetails":_vm.memberDetails,"edit":true}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminProfileChild_vue__ = __webpack_require__(323);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4784c70_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminProfileChild_vue__ = __webpack_require__(819);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminProfileChild_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4784c70_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminProfileChild_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberDetails_vue__ = __webpack_require__(324);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06cfa080_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberDetails_vue__ = __webpack_require__(818);
function injectStyle (ssrContext) {
  __webpack_require__(817)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06cfa080"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06cfa080_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 817 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.memberDetails ? _vm.memberDetails.id ? true : false : false)?_c('div',{staticClass:"col px-0 pr-lg-3"},[_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('div',{staticClass:"d-flex justify-content-between align-items-start"},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v(_vm._s(_vm.split ? 'Split Member Details' : _vm.my ? 'My Details' : 'Details'))]),_vm._v(" "),(_vm.memberDetails ? _vm.memberDetails.isActive ? true : false : false)?_c('span',{staticClass:"badge badge-info"},[_vm._v("Active")]):_c('span',{staticClass:"badge alert-warning"},[_vm._v("Inactive")])]),_vm._v(" "),(_vm.memberDetails ? _vm.memberDetails.isActive ? false : true : true)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("\n        Please renew membership.\n      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":"memberNumber"}},[_vm._v("Member Number")]),_vm._v(" "),_c('div',{staticClass:"input-append"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"memberNumber","maxlength":"10","readonly":""},domProps:{"value":_vm.memberDetails.member_number}}),_vm._v(" "),_c('span',{staticClass:"append badge badge-prim"},[_vm._v("Primary")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"membershipType"}},[_vm._v("Membership Type")]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":"membershipType","required":""},domProps:{"value":_vm.memberDetails ? _vm.memberDetails.type: ''}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_vm._l((_vm.$store.state.products.filter(function (item) { return item.type === 'Membership' || item.type === 'Addon'; })),function(membershipType,productsIndex){return _c('option',{key:productsIndex},[_vm._v(_vm._s(membershipType.name))])})],2),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Membership Type.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":"firstName"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"firstName","maxlength":"40","required":""},domProps:{"value":_vm.memberDetails ? _vm.memberDetails.first_name: ''}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your First Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"lastName"}},[_vm._v("Last Name")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"lastName","maxlength":"40","required":""},domProps:{"value":_vm.memberDetails ? _vm.memberDetails.last_name: ''}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Last Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 no-gutters pr-xl-4"},[_c('div',{staticClass:"col-12 col-xl-auto form-group"},[_c('label',{attrs:{"for":"dateOfBirth"}},[_vm._v("Date of Birth")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateOfBirth),expression:"dateOfBirth"}],staticClass:"form-control",attrs:{"max":_vm.today(),"id":"dateOfBirth","type":"date","placeholder":"dd/mm/yyyy","value":"1988-01-01","required":""},domProps:{"value":(_vm.dateOfBirth)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dateOfBirth=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Date of Birth.")])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 mb-3 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"riderStatus"}},[_vm._v("Rider Status")]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":"riderStatus","required":""}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_vm._l((_vm.$store.state.riderStatus),function(rStatus,rStatusIndex){return _c('option',{key:rStatusIndex},[_vm._v(_vm._s(rStatus.name))])})],2),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Rider Status.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 mb-3 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"membershipStatus"}},[_vm._v("Membership Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberDetails.membership_status),expression:"memberDetails.membership_status"}],staticClass:"form-control",attrs:{"id":"membershipStatus","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.memberDetails, "membership_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',{attrs:{"value":"Active"}},[_vm._v("Active")]),_vm._v(" "),_c('option',{attrs:{"value":"Archived"}},[_vm._v("Archived")]),_vm._v(" "),_c('option',{attrs:{"value":"Onhold"}},[_vm._v("On Hold")]),_vm._v(" "),_c('option',{attrs:{"value":"Lifetime"}},[_vm._v("Lifetime")]),_vm._v(" "),_c('option',{attrs:{"value":"Suspended"}},[_vm._v("Suspended")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Membership Status.")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-12 d-flex justify-content-end"},[_c('button',{staticClass:"btn btn-primary d-lg-none",on:{"click":_vm.handleSubmit}},[_vm._v(_vm._s(_vm.split ? 'Publish' : 'Update'))]),_vm._v(" "),(_vm.memberDetails ? _vm.memberDetails.isActive ? false : true : true)?_c('button',{staticClass:"btn btn-primary ml-2"},[_vm._v("Renew")]):_vm._e()])])]),_vm._v(" "),_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('h2',{staticClass:"mb-4"},[_vm._v("Contact Details")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email Address")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"email","id":"email","maxlength":"255","required":""},domProps:{"value":_vm.memberDetails ? _vm.memberDetails.email: ''}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Email Address.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"phone"}},[_vm._v("Phone Number")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"phone","maxlength":"15"},domProps:{"value":_vm.memberDetails ? _vm.memberDetails.phone: ''}})]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"address1"}},[_vm._v("Address")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"address1","maxlength":"80","required":""},domProps:{"value":_vm.memberDetails ? _vm.memberDetails.attributes.address.street_1: ''}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Address.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":"suburb"}},[_vm._v("Suburb")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"suburb","maxlength":"40","required":""},domProps:{"value":_vm.memberDetails ? _vm.memberDetails.attributes.address.suburb: ''}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Suburb.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 mb-4 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"zone"}},[_vm._v("Zone")]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":"zone","required":""}},_vm._l((_vm.$store.state.listZones),function(zone,index){return _c('option',{key:index},[_vm._v(_vm._s(zone.code))])}),0),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Zone.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-6 row no-gutters pr-xl-4"},[_c('div',{staticClass:"col-12 col-md-6 col-xl-auto pr-md-3 pr-xl-0 form-group"},[_c('label',{attrs:{"for":"postcode"}},[_vm._v("Postcode")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.attributes.address.postcode),expression:"memberUpdate.attributes.address.postcode"}],staticClass:"form-control",attrs:{"type":"text","id":"postcode","maxlength":"4","requred":"","pattern":"\\d{4}"},domProps:{"value":(_vm.memberUpdate.attributes.address.postcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate.attributes.address, "postcode", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include a four-digit Postcode.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-xl pl-md-3 form-group"},[_c('label',{attrs:{"for":"state"}},[_vm._v("State")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.attributes.address.state),expression:"memberUpdate.attributes.address.state"}],staticClass:"form-control",attrs:{"id":"state","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.memberUpdate.attributes.address, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',{attrs:{"value":"QLD"}},[_vm._v("Queensland")]),_vm._v(" "),_c('option',{attrs:{"value":"NSW"}},[_vm._v("New South Wales")]),_vm._v(" "),_c('option',{attrs:{"value":"VIC"}},[_vm._v("Victoria")]),_vm._v(" "),_c('option',{attrs:{"value":"ACT"}},[_vm._v("Australian Capital Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"SA"}},[_vm._v("South Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"NT"}},[_vm._v("Northern Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"WA"}},[_vm._v("Western Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"TAS"}},[_vm._v("Tasmania")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your State.")])])]),_vm._v(" "),(_vm.memberUpdate.guardian.consent ? _vm.memberUpdate.guardian.consent : _vm.isUnder17)?_c('div',{staticClass:"col-12 form-group"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.guardian.consent),expression:"memberUpdate.guardian.consent"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"parentalConsent","required":""},domProps:{"checked":Array.isArray(_vm.memberUpdate.guardian.consent)?_vm._i(_vm.memberUpdate.guardian.consent,null)>-1:(_vm.memberUpdate.guardian.consent)},on:{"change":function($event){var $$a=_vm.memberUpdate.guardian.consent,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.memberUpdate.guardian, "consent", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.memberUpdate.guardian, "consent", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.memberUpdate.guardian, "consent", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"parentalConsent"}},[_vm._v("Parent or guardian gives consent.")])])]):_vm._e()]),_vm._v(" "),(_vm.parentConsent || _vm.memberUpdate.guardian.consent)?_c('div',[_c('h3',{staticClass:"mb-4"},[_vm._v("Parent / Guardian Details")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":"parentFirstName"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate.guardian.first_name),expression:"memberUpdate.guardian.first_name"}],staticClass:"form-control",attrs:{"type":"text","id":"parentFirstName","maxlength":"40","required":""},domProps:{"value":(_vm.memberUpdate.guardian.first_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate.guardian, "first_name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the First Name.")])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 px-0 d-flex d-lg-none justify-content-end"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.handleSubmit}},[_vm._v(_vm._s(_vm.split ? 'Publish' : 'Update'))])])]),_vm._v(" "),_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('h2',{staticClass:"mb-4"},[_vm._v("Login Details")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.password),expression:"password.password"}],staticClass:"form-control",attrs:{"type":"password","id":"password","maxlength":"30"},domProps:{"value":(_vm.password.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "password", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your password.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"confirmPassword"}},[_vm._v("Confirm Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.confirmPassword),expression:"password.confirmPassword"}],staticClass:"form-control",attrs:{"type":"password","id":"confirmPassword","maxlength":"30","required":_vm.confirmRequired},domProps:{"value":(_vm.password.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "confirmPassword", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please ensure your passwords match.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-flex d-lg-none justify-content-end"},[_c('button',{staticClass:"btn btn-primary d-lg-none",on:{"click":_vm.handleSubmit}},[_vm._v(_vm._s(_vm.split ? 'Publish' : 'Update'))])])])])]):_vm._e(),_vm._v(" "),_c('desktop-action-bar',[_c('button',{staticClass:"btn btn-block btn-primary mb-2",on:{"click":_vm.handleSubmit}},[_vm._v(_vm._s(_vm.split ? 'Publish' : 'Update'))]),_vm._v(" "),(_vm.split)?_c('button',{staticClass:"btn btn-block btn-outline-primary"},[_vm._v("Cancel")]):_c('div',[(_vm.memberDetails ? _vm.memberDetails.isActive ? false : true : true)?_c('button',{staticClass:"btn btn-block btn-outline-primary"},[_vm._v("Renew")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-block btn-outline-primary"},[_vm._v("Deactivate")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-xl pl-xl-3 form-group"},[_c('label',{attrs:{"for":"gender"}},[_vm._v("Gender")]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"id":"gender"}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',[_vm._v("Male")]),_vm._v(" "),_c('option',[_vm._v("Female")]),_vm._v(" "),_c('option',[_vm._v("Unspecified")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 form-group"},[_c('label',[_vm._v("Eligible for this award")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","name":"eligibleAward","id":"eligibleMaiden","checked":""}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label font-weight-normal",attrs:{"for":"eligibleMaiden"}},[_vm._v("Maiden Rider")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","name":"eligibleAward","id":"eligibleNovice"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label font-weight-normal",attrs:{"for":"eligibleNovice"}},[_vm._v("Novice Rider")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","name":"eligibleAward","id":"eligibleNone"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label font-weight-normal",attrs:{"for":"eligibleNone"}},[_vm._v("N/A")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 form-group"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"nonCompetingMembership"}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"nonCompetingMembership"}},[_vm._v("Non-Competing Membership")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-sm-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":"mobile"}},[_vm._v("Mobile Number")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"mobile","maxlength":"15","required":""}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Mobile Number.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-sm-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"parentLastName"}},[_vm._v("Last Name")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"parentLastName","maxlength":"40","required":""}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Last Name.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-sm-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":"parentEmail"}},[_vm._v("Email Address")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"email","id":"parentEmail","maxlength":"255","required":""}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Email Address.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-sm-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"mobile"}},[_vm._v("Phone Number")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"mobile","maxlength":"15","required":""}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Phone Number.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',[_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'details' ? 'active' : ''],attrs:{"href":"","id":"details-tab","data-toggle":"tab","role":"tab","aria-controls":"details","aria-selected":_vm.selectedTab === 'details' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'details'}}},[_vm._v("Details")])]),_vm._v(" "),(_vm.selectedTab === 'details')?_c('member-profile-details',{staticClass:"tab-pane row mx-0 show active",attrs:{"slot":"tabContent","memberDetails":_vm.memberDetails,"id":"details","role":"tabpanel","aria-labelledby":"details-tab"},slot:"tabContent"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyMembershipProfile_vue__ = __webpack_require__(325);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f917419_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyMembershipProfile_vue__ = __webpack_require__(821);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyMembershipProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f917419_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyMembershipProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',[_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'details' ? 'active' : ''],attrs:{"href":"","id":"details-tab","data-toggle":"tab","role":"tab","aria-controls":"details","aria-selected":_vm.selectedTab === 'details' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'details'}}},[_vm._v("My Details")])]),_vm._v(" "),(_vm.memberDetails)?_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'membership' ? 'active' : ''],attrs:{"href":"","id":"membership-tab","data-toggle":"tab","role":"tab","aria-controls":"membership","aria-selected":_vm.selectedTab === 'membership' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'membership'}}},[_vm._v("My Membership")])]):_vm._e(),_vm._v(" "),(_vm.memberDetails && _vm.userRole !=='Volunteer' )?_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'financials' ? 'active' : ''],attrs:{"href":"","id":"financials-tab","data-toggle":"tab","role":"tab","aria-controls":"financials","aria-selected":_vm.selectedTab === 'financials' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'financials'}}},[_vm._v("My Financials")])]):_vm._e(),_vm._v(" "),(_vm.memberDetails && _vm.userRole !=='Volunteer' )?_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'history' ? 'active' : ''],attrs:{"href":"","id":"history-tab","data-toggle":"tab","role":"tab","aria-controls":"history","aria-selected":_vm.selectedTab === 'history' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'history'}}},[_vm._v("My History")])]):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'details')?_c('member-profile-details',{staticClass:"tab-pane row mx-0 show active",attrs:{"slot":"tabContent","memberDetails":_vm.memberDetails,"my":true,"completePaymentProfile":_vm.completePaymentProfile,"returnTo":_vm.returnTo,"id":"details","role":"tabpanel","aria-labelledby":"details-tab"},on:{"renew":function($event){_vm.renew = true;_vm.selectedTab = 'membership'}},slot:"tabContent"}):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'membership')?_c('member-profile-membership',{staticClass:"tab-pane row mx-0 show active",attrs:{"slot":"tabContent","my":true,"child":_vm.child,"memberDetails":_vm.memberDetails,"renew":_vm.renew,"id":"membership","role":"tabpanel","aria-labelledby":"membership-tab"},on:{"noRenew":function($event){_vm.renew = false}},slot:"tabContent"}):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'financials')?_c('member-profile-financials',{staticClass:"tab-pane col-md-11 col-lg-10 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active",attrs:{"slot":"tabContent","memberID":_vm.memberDetails.id,"id":"financials","role":"tabpanel","aria-labelledby":"financials-tab"},slot:"tabContent"}):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'history')?_c('member-profile-history',{staticClass:"tab-pane col-md-11 col-lg-10 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active",attrs:{"slot":"tabContent","memberID":_vm.memberDetails.id,"membership_options":_vm.memberDetails.membership_options,"id":"history","role":"tabpanel","aria-labelledby":"history-tab"},slot:"tabContent"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyMembershipProfileChild_vue__ = __webpack_require__(326);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_422b520d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyMembershipProfileChild_vue__ = __webpack_require__(823);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyMembershipProfileChild_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_422b520d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyMembershipProfileChild_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',[_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'details' ? 'active' : ''],attrs:{"href":"","id":"details-tab","data-toggle":"tab","role":"tab","aria-controls":"details","aria-selected":_vm.selectedTab === 'details' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'details'}}},[_vm._v("Details")])]),_vm._v(" "),_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'history' ? 'active' : ''],attrs:{"href":"","id":"history-tab","data-toggle":"tab","role":"tab","aria-controls":"history","aria-selected":_vm.selectedTab === 'history' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'history'}}},[_vm._v("History")])]),_vm._v(" "),(_vm.selectedTab === 'details')?_c('member-profile-details',{staticClass:"tab-pane row mx-0 show active",attrs:{"slot":"tabContent","memberDetails":_vm.memberDetails,"d":"details","role":"tabpanel","aria-labelledby":"details-tab"},on:{"renew":_vm.renew},slot:"tabContent"}):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'history')?_c('member-profile-history',{staticClass:"tab-pane col-md-11 col-lg-10 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active",attrs:{"slot":"tabContent","memberID":_vm.memberDetails.id,"membership_options":_vm.memberDetails.membership_options,"id":"history","role":"tabpanel","aria-labelledby":"history-tab"},slot:"tabContent"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyMembershipCart_vue__ = __webpack_require__(327);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b10b26c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyMembershipCart_vue__ = __webpack_require__(827);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyMembershipCart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b10b26c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyMembershipCart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__ = __webpack_require__(328);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08e552ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__ = __webpack_require__(826);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08e552ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.payment($event)}}},[_c('section',{staticClass:"bg-white rounded mb-2 p-3 p-sm-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-3"},[_c('h1',{staticClass:"h2"},[_vm._v("Your Cart")]),_vm._v(" "),(_vm.errors)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors))]):_vm._e()]),_vm._v(" "),(_vm.memberUpdate)?_c('div',{staticClass:"col-12"},[(!_vm.$store.state.showExpand && _vm.memberUpdate.length > 0)?_c('table',{staticClass:"table table-striped table-bordered border-0"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.memberUpdate),function(member,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(member.first_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(member.last_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(member.type))]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v("$"+_vm._s(_vm.cartList[index].price))]),_vm._v(" "),_c('td',[_c('button',{class:['btn btn-block', _vm.processing[index] ? 'btn-primary-dark' : 'btn-primary'],on:{"click":function($event){return _vm.remove(index)}}},[_vm._v("\n                  "+_vm._s(!_vm.processing[index] ? 'Remove' : '')+"\n                  "),(_vm.processing[index])?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])])])}),0),_vm._v(" "),_c('tfoot',[_vm._l((_vm.cartList),function(cartItem,cartIndex){return (_vm.cartList.length > _vm.memberUpdate.length && cartIndex > (_vm.memberUpdate.length - 1))?_c('tr',{key:cartIndex},[_c('td',{attrs:{"colspan":"3"}},[_c('strong',{staticClass:"label"},[_vm._v(_vm._s(_vm.$store.state.discounts.filter(function (discount) { return discount.id === cartItem.id; })[0].name))])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(cartItem.price && typeof cartItem.price !== "string" ? cartItem.price.toFixed(2) : cartItem.price))])]),_vm._v(" "),_c('td')]):_vm._e()}),_vm._v(" "),_c('tr',[_c('td',{staticClass:"border-0",attrs:{"align":"right","colspan":"4"}},[_c('strong',[_vm._v("Your total: $"+_vm._s(_vm.total.toFixed(2)))])]),_vm._v(" "),_c('td',{staticClass:"border-0"})]),_vm._v(" "),_vm._m(1)],2)]):(_vm.memberUpdate.length > 0)?_c('table',{staticClass:"table table-striped table-bordered border-0"},[_c('tbody',_vm._l((_vm.memberUpdate),function(member,index){return _c('tr',{key:index},[_c('td',[_c('div',{staticClass:"d-sm-flex justify-content-between align-items-center"},[_c('div',{staticClass:"mb-2 mb-sm-0"},[_vm._v("\n                    "+_vm._s(member.first_name)+" "+_vm._s(member.last_name)),_c('br'),_c('br'),_vm._v(" "),_c('strong',{staticClass:"label"},[_vm._v("Type: ")]),_vm._v(" "+_vm._s(member.type)),_c('br'),_vm._v(" "),_c('strong',{staticClass:"label"},[_vm._v("Price: ")]),_vm._v(" "+_vm._s(_vm.cartList[index].price)),_c('br')]),_vm._v(" "),_c('div',{staticClass:"flex-shrink-1"},[_c('button',{staticClass:"btn btn-block btn-primary",on:{"click":function($event){return _vm.remove(index)}}},[_vm._v("Remove")])])])])])}),0),_vm._v(" "),_c('tfoot',[_vm._l((_vm.cartList),function(cartItem,cartIndex){return (_vm.cartList.length > _vm.memberUpdate.length && cartIndex > (_vm.memberUpdate.length - 1))?_c('tr',{key:cartIndex},[_c('td',{attrs:{"colspan":"3"}},[_c('div',{staticClass:"d-sm-flex justify-content-between align-items-center"},[_c('strong',{staticClass:"label"},[_vm._v(_vm._s(_vm.$store.state.discounts.filter(function (discount) { return discount.id === cartItem.id; })[0].name))]),_vm._v(" "),_c('div',{staticClass:"flex-shrink-1"},[_c('strong',[_vm._v(_vm._s(cartItem.price && typeof cartItem.price !== "string" ? cartItem.price.toFixed(2) : cartItem.price))])])])])]):_vm._e()}),_vm._v(" "),_c('tr',[_c('td',{staticClass:"border-0",attrs:{"align":"center"}},[_c('strong',[_vm._v("Your total: $"+_vm._s(_vm.total.toFixed(2)))])])])],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-check px-0 mb-sm-4"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rules),expression:"rules"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"rules","required":""},domProps:{"checked":Array.isArray(_vm.rules)?_vm._i(_vm.rules,null)>-1:(_vm.rules)},on:{"change":function($event){var $$a=_vm.rules,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.rules=$$a.concat([$$v]))}else{$$i>-1&&(_vm.rules=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.rules=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"rules"}},[_vm._v("\n              By checking this box, I agree to adhere to the General Information Competition Rules and Guidelines, the ACA Constitution and Disciplinary Bylaw.\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-check px-0 mb-sm-4"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.terms),expression:"terms"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"terms","required":""},domProps:{"checked":Array.isArray(_vm.terms)?_vm._i(_vm.terms,null)>-1:(_vm.terms)},on:{"change":function($event){var $$a=_vm.terms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.terms=$$a.concat([$$v]))}else{$$i>-1&&(_vm.terms=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.terms=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"terms"}},[_vm._v("\n              In consideration for me, and/or minors in my care, being allowed to participate in all events run by the Australian Campdraft Association Inc. (ACA), I hereby agree that I have permission to accept the membership waiver, on behalf of all persons for whom this membership is for, a full copy of which is available on the ACA website and the membership tax invoice.\n            ")]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please agree to the membership waiver.")])])])]):_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-info",attrs:{"role":"alert"}},[_vm._v("Your cart is empty")])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-flex flex-wrap justify-content-end"},[(_vm.backTo === 'members')?_c('router-link',{staticClass:"btn btn-block-mob btn-outline-primary order-1 order-lg-0",attrs:{"tag":"button","to":{ name: 'Add Members' }}},[_vm._v("Back to Add Members")]):(_vm.userRole === 'Member' || _vm.userRole === 'Secretary')?_c('router-link',{staticClass:"btn btn-block-mob btn-outline-primary order-1 order-lg-0",attrs:{"tag":"button","to":{ name: 'My Profile', params: { renewing: true, tabSelect: 'membership', preselectedYear: _vm.preselectedYear } }}},[_vm._v("Back to Membership")]):_c('router-link',{staticClass:"btn btn-block-mob btn-outline-primary order-1 order-lg-0",attrs:{"tag":"button","to":{ name: 'Member Profile', params: { renewing: true, tab: 'membership', preselectedYear: _vm.preselectedYear } }}},[_vm._v("Back to Membership")]),_vm._v(" "),(_vm.cartList ? _vm.cartList.length > 0 : false)?_c('button',{class:['btn btn-block-mob btn-primary mb-2 mb-lg-0 ml-lg-2', { 'disabled': (!_vm.terms || !_vm.rules) }],on:{"click":_vm.handleSubmit}},[_vm._v("Proceed to Payment")]):_vm._e()],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"position-relative"},[_vm._v("First name")]),_vm._v(" "),_c('th',{staticClass:"position-relative"},[_vm._v("Last Name")]),_vm._v(" "),_c('th',{staticClass:"position-relative"},[_vm._v("Type")]),_vm._v(" "),_c('th',{staticClass:"position-relative column-lg-small",attrs:{"align":"center"}},[_vm._v("Price")]),_vm._v(" "),_c('th',{staticClass:"position-relative column-lg-small"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"border-0",attrs:{"align":"right","colspan":"5"}}),_vm._v(" "),_c('td',{staticClass:"border-0"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',[_c('cart',{staticClass:"tab-pane col-12 col-xl-9 px-0 show active",attrs:{"slot":"tabContent","cartMembers":_vm.cartMembers,"backTo":_vm.backTo,"preselectedYear":_vm.preselectedYear,"id":"cart","role":"tabpanel","aria-label":"Cart"},on:{"cartChanged":_vm.cartChanged},slot:"tabContent"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyMembershipPayment_vue__ = __webpack_require__(329);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb0c65c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyMembershipPayment_vue__ = __webpack_require__(834);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyMembershipPayment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb0c65c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyMembershipPayment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StripeCardModal_vue__ = __webpack_require__(331);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3652e3ef_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StripeCardModal_vue__ = __webpack_require__(832);
function injectStyle (ssrContext) {
  __webpack_require__(830)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3652e3ef"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StripeCardModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3652e3ef_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StripeCardModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 830 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadStripe; });
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var RELEASE_TRAIN = 'dahlia';

var runtimeVersionToUrlVersion = function runtimeVersionToUrlVersion(version) {
  return version === 3 ? 'v3' : version;
};

var ORIGIN = 'https://js.stripe.com';
var STRIPE_JS_URL = "".concat(ORIGIN, "/").concat(RELEASE_TRAIN, "/stripe.js");
var V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var STRIPE_JS_URL_REGEX = /^https:\/\/js\.stripe\.com\/(v3|[a-z]+)\/stripe\.js(\?.*)?$/;
var EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';

var isStripeJSURL = function isStripeJSURL(url) {
  return V3_URL_REGEX.test(url) || STRIPE_JS_URL_REGEX.test(url);
};

var findScript = function findScript() {
  var scripts = document.querySelectorAll("script[src^=\"".concat(ORIGIN, "\"]"));

  for (var i = 0; i < scripts.length; i++) {
    var script = scripts[i];

    if (!isStripeJSURL(script.src)) {
      continue;
    }

    return script;
  }

  return null;
};

var injectScript = function injectScript(params) {
  var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
  var script = document.createElement('script');
  script.src = "".concat(STRIPE_JS_URL).concat(queryString);
  var headOrBody = document.head || document.body;

  if (!headOrBody) {
    throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
  }

  headOrBody.appendChild(script);
  return script;
};

var registerWrapper = function registerWrapper(stripe, startTime) {
  if (!stripe || !stripe._registerWrapper) {
    return;
  }

  stripe._registerWrapper({
    name: 'stripe-js',
    version: "9.9.0",
    startTime: startTime
  });
};

var stripePromise$1 = null;
var onErrorListener = null;
var onLoadListener = null;

var onError = function onError(reject) {
  return function (cause) {
    reject(new Error('Failed to load Stripe.js', {
      cause: cause
    }));
  };
};

var onLoad = function onLoad(resolve, reject) {
  return function () {
    if (window.Stripe) {
      resolve(window.Stripe);
    } else {
      reject(new Error('Stripe.js not available'));
    }
  };
};

var loadScript = function loadScript(params) {
  // Ensure that we only attempt to load Stripe.js at most once
  if (stripePromise$1 !== null) {
    return stripePromise$1;
  }

  stripePromise$1 = new Promise(function (resolve, reject) {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      // Resolve to null when imported server side. This makes the module
      // safe to import in an isomorphic code base.
      resolve(null);
      return;
    }

    if (window.Stripe && params) {
      console.warn(EXISTING_SCRIPT_MESSAGE);
    }

    if (window.Stripe) {
      resolve(window.Stripe);
      return;
    }

    try {
      var script = findScript();

      if (script && params) {
        console.warn(EXISTING_SCRIPT_MESSAGE);
      } else if (!script) {
        script = injectScript(params);
      } else if (script && onLoadListener !== null && onErrorListener !== null) {
        var _script$parentNode;

        // remove event listeners
        script.removeEventListener('load', onLoadListener);
        script.removeEventListener('error', onErrorListener); // if script exists, but we are reloading due to an error,
        // reload script to trigger 'load' event

        (_script$parentNode = script.parentNode) === null || _script$parentNode === void 0 ? void 0 : _script$parentNode.removeChild(script);
        script = injectScript(params);
      }

      onLoadListener = onLoad(resolve, reject);
      onErrorListener = onError(reject);
      script.addEventListener('load', onLoadListener);
      script.addEventListener('error', onErrorListener);
    } catch (error) {
      reject(error);
      return;
    }
  }); // Resets stripePromise on error

  return stripePromise$1["catch"](function (error) {
    stripePromise$1 = null;
    return Promise.reject(error);
  });
};
var initStripe = function initStripe(maybeStripe, args, startTime) {
  if (maybeStripe === null) {
    return null;
  }

  var pk = args[0];

  if (typeof pk !== 'string') {
    throw new Error("Expected publishable key to be of type string, got type ".concat(_typeof(pk), " instead."));
  }

  var isTestKey = pk.match(/^pk_test/); // @ts-expect-error this is not publicly typed

  var version = runtimeVersionToUrlVersion(maybeStripe.version);
  var expectedVersion = RELEASE_TRAIN;

  if (isTestKey && version !== expectedVersion) {
    console.warn("Stripe.js@".concat(version, " was loaded on the page, but @stripe/stripe-js@").concat("9.9.0", " expected Stripe.js@").concat(expectedVersion, ". This may result in unexpected behavior. For more information, see https://docs.stripe.com/sdks/stripejs-versioning"));
  }

  var stripe = maybeStripe.apply(undefined, args);
  registerWrapper(stripe, startTime);
  return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

var stripePromise;
var loadCalled = false;

var getStripePromise = function getStripePromise() {
  if (stripePromise) {
    return stripePromise;
  }

  stripePromise = loadScript(null)["catch"](function (error) {
    // clear cache on error
    stripePromise = null;
    return Promise.reject(error);
  });
  return stripePromise;
}; // Execute our own script injection after a tick to give users time to do their
// own script injection.


Promise.resolve().then(function () {
  return getStripePromise();
})["catch"](function (error) {
  if (!loadCalled) {
    console.warn(error);
  }
});
var loadStripe = function loadStripe() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  loadCalled = true;
  var startTime = Date.now(); // if previous attempts are unsuccessful, will re-load script

  return getStripePromise().then(function (maybeStripe) {
    return initStripe(maybeStripe, args, startTime);
  });
};




/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"size":"md","content-class":"p-sm-4"},on:{"close":_vm.close},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h5',{staticClass:"mb-0"},[_vm._v("Card Payment")])]},proxy:true},{key:"body",fn:function(){return [(_vm.amount)?_c('p',{staticClass:"text-center mb-3"},[_vm._v("\n      Amount to pay: "),_c('strong',[_vm._v("$"+_vm._s(_vm.amount))])]):_vm._e(),_vm._v(" "),_c('label',{staticClass:"d-block mb-1 small text-muted"},[_vm._v("Card details")]),_vm._v(" "),_c('div',{ref:"cardEl",staticClass:"form-control stripe-card-modal__element"}),_vm._v(" "),(_vm.errorMessage)?_c('div',{staticClass:"text-danger small mt-2"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()]},proxy:true},{key:"footer",fn:function(){return [_c('app-button',{attrs:{"variant":"outline-primary","disabled":_vm.submitting},on:{"click":_vm.close}},[_vm._v("Cancel")]),_vm._v(" "),_c('app-button',{attrs:{"loading":_vm.submitting,"disabled":!_vm.ready},on:{"click":_vm.submit}},[_vm._v("Pay Now")])]},proxy:true}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.makePayment($event)}}},[_c('section',{staticClass:"bg-white rounded mb-2 p-3 p-sm-4"},[(!_vm.success)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-3"},[_c('h1',{staticClass:"h2"},[_vm._v("Payment Options")]),_vm._v(" "),(_vm.errors)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_c('span',[_vm._v(_vm._s(_vm.errors))]),_vm._v(" "),(_vm.profileIncomplete && _vm.theUserID)?_c('router-link',{staticClass:"btn btn-primary btn-block-mob d-block d-sm-inline-block mt-3 mt-sm-0 ml-sm-3",attrs:{"to":_vm.profileRoute}},[_vm._v("Update Profile")]):_vm._e()],1):_vm._e()]),_vm._v(" "),(_vm.cartMembers.total <= 0)?_c('div',{staticClass:"col-12 mb-3"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 form-group mb-4"},[_c('label',{staticClass:"sr-only"},[_vm._v("Payment Method")]),_vm._v(" "),_c('div',{staticClass:"payment-options d-flex flex-wrap align-items-end"},[(_vm.cartMembers.total)?_c('div',{staticClass:"custom-control custom-radio custom-control-inline flex-wrap col-6 col-sm-auto"},[_c('label',{staticClass:"w-100 mb-2 ml-sm-n5 pl-2 d-flex align-items-center justify-content-center",staticStyle:{"height":"43px"},attrs:{"for":"stripe"}},[_c('svg',{staticClass:"ml-1",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 62.4 39.6","width":"38","height":"24","aria-labelledby":"mastercard"}},[_c('title',{attrs:{"id":"mastercard"}},[_vm._v("Mastercard")]),_c('circle',{attrs:{"cx":"19.5","cy":"19.7","r":"19","fill":"#ee0005"}}),_c('circle',{attrs:{"cx":"43","cy":"19.7","r":"19","fill":"#f9a000"}}),_c('path',{attrs:{"fill":"#ff6300","d":"M24.1 19.7a19 19 0 0 0 7.2 14.9c4.4-3.5 7.2-8.8 7.2-14.9S35.6 8.3 31.3 4.8a19 19 0 0 0-7.2 14.9z"}})]),_vm._v(" "),_c('svg',{staticClass:"ml-1",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 505 153","width":"46","height":"14","aria-labelledby":"visa"}},[_c('title',{attrs:{"id":"visa"}},[_vm._v("Visa")]),_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('path',{attrs:{"fill":"#3c58bf","d":"M185.3 149L210.9 5h40l-24.8 144z"}}),_c('path',{attrs:{"fill":"#293688","d":"M185.3 149L218.1 5h32.8l-24.8 144z"}}),_c('path',{attrs:{"fill":"#3c58bf","d":"M371 6.6C363 3.4 350 .2 334 .2c-40 0-68.8 20-68.8 48.8 0 21.6 20 32.8 36 40s20.8 12 20.8 18.4c0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 42.4 0 70.4-20 70.4-50.4 0-16.8-10.4-29.6-34.4-40-14.4-7.2-23.2-11.2-23.2-18.4 0-6.4 7.2-12.8 23.2-12.8 13.6 0 23.2 2.4 30.4 5.6l4 1.6L371 6.6z"}}),_c('path',{attrs:{"fill":"#293688","d":"M371 6.6C363 3.4 350 .2 334 .2c-40 0-61.6 20-61.6 48.8 0 21.6 12.8 32.8 28.8 40s20.8 12 20.8 18.4c0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 42.4 0 70.4-20 70.4-50.4 0-16.8-10.4-29.6-34.4-40-14.4-7.2-23.2-11.2-23.2-18.4 0-6.4 7.2-12.8 23.2-12.8 13.6 0 23.2 2.4 30.4 5.6l4 1.6L371 6.6z"}}),_c('path',{attrs:{"fill":"#3c58bf","d":"M439.7 5c-9.6 0-16.8.8-20.8 10.4L359 149h43.2l8-24h51.2l4.8 24h38.4L471 5h-31.2zm-18.4 96c2.4-7.2 16-42.4 16-42.4s3.2-8.8 5.6-14.4l2.4 13.6s8 36 9.6 44h-33.6v-.8z"}}),_c('path',{attrs:{"fill":"#293688","d":"M449.3 5c-9.6 0-16.8.8-20.8 10.4L359 149h43.2l8-24h51.2l4.8 24h38.4L471 5h-21.6zm-28 96c3.2-8 16-42.4 16-42.4s3.2-8.8 5.6-14.4l2.4 13.6s8 36 9.6 44h-33.6v-.8z"}}),_c('path',{attrs:{"fill":"#3c58bf","d":"M111.7 105.8l-4-20.8c-7.2-24-30.4-50.4-56-63.2l36 128H131l64.8-144h-43.2l-40.8 100z"}}),_c('path',{attrs:{"fill":"#293688","d":"M111.7 105.8l-4-20.8c-7.2-24-30.4-50.4-56-63.2l36 128H131l64.8-144h-35.2l-48.8 100z"}}),_c('path',{attrs:{"fill":"#ffbc00","d":"M.5 5l7.2 1.6C59 18.6 94.1 49 107.7 85L93.3 17C91 7.4 83.7 5 75 5H.5z"}}),_c('path',{attrs:{"fill":"#f7981d","d":"M.5 5c51.2 12 93.6 43.2 107.2 79.2L94.1 27.4A19.5 19.5 0 0 0 75 12.2L.5 5z"}}),_c('path',{attrs:{"fill":"#ed7c00","d":"M.5 5c51.2 12 93.6 43.2 107.2 79.2L98.1 53c-2.4-9.6-5.6-19.2-16.8-23.2L.5 5z"}}),_c('g',{attrs:{"fill":"#051244"}},[_c('path',{attrs:{"d":"M151.7 101l-27.2-27.2-12.8 30.4-3.2-20c-7.2-24-30.4-50.4-56-63.2l36 128h43.2l20-48zM226.1 149l-34.4-35.2-6.4 35.2zM318.1 99.4c3.2 3.2 4.8 5.6 4 8.8 0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 25.6 0 46.4-7.2 58.4-20l-34.4-33.6zM364.5 149h37.6l8-24h51.2l4.8 24h38.4L491 90.6l-48-46.4 2.4 12.8s8 36 9.6 44h-33.6c3.2-8 16-42.4 16-42.4s3.2-8.8 5.6-14.4"}})])])])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paymentMethod),expression:"paymentMethod"}],staticClass:"custom-control-input",attrs:{"type":"radio","name":"paymentMethod","id":"stripe","value":"stripe","checked":""},domProps:{"checked":_vm._q(_vm.paymentMethod,"stripe")},on:{"change":function($event){_vm.paymentMethod="stripe"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label font-weight-normal text-nowrap",attrs:{"for":"stripe"}},[_vm._v("Credit Card")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline flex-wrap col-6 col-sm-auto"},[_c('label',{staticClass:"w-100 mb-2 ml-sm-n4 d-flex align-items-center justify-content-center",staticStyle:{"height":"43px"},attrs:{"for":"claimVoucher"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 12","width":"43","height":"30","aria-labelledby":"claimoucher"}},[_c('title',{attrs:{"id":"claimvoucher"}},[_vm._v("Claim Voucher")]),_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M8 6.5H3.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H8c.3 0 .5.2.5.5s-.2.5-.5.5zM8 4H3.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H8c.3 0 .5.2.5.5S8.3 4 8 4z"}}),_c('path',{attrs:{"fill":"#231815","d":"M15.5 12h-14C.7 12 0 11.3 0 10.5v-9C0 .7.7 0 1.5 0h14c.8 0 1.5.7 1.5 1.5v9c0 .8-.7 1.5-1.5 1.5zM1.5 1c-.3 0-.5.2-.5.5v9c0 .3.2.5.5.5h14c.3 0 .5-.2.5-.5v-9c0-.3-.2-.5-.5-.5h-14z"}}),_c('path',{attrs:{"fill":"#231815","d":"M13.5 9h-10c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h10c.3 0 .5.2.5.5s-.2.5-.5.5z"}}),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M13.5 6.8h-2.6c-.3 0-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5h2.6c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5zm-2.1-1H13v-2h-1.6v2z"}})])])])])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paymentMethod),expression:"paymentMethod"}],staticClass:"custom-control-input",attrs:{"type":"radio","name":"paymentMethod","id":"claimVoucher","value":"voucher"},domProps:{"checked":_vm._q(_vm.paymentMethod,"voucher")},on:{"change":function($event){_vm.paymentMethod="voucher"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label font-weight-normal text-nowrap",attrs:{"for":"claimVoucher"}},[_vm._v("Claim Voucher")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline flex-wrap col-6 col-sm-auto"},[_c('label',{staticClass:"w-100 mb-2 ml-sm-n4 d-flex align-items-center justify-content-center",staticStyle:{"height":"43px"},attrs:{"for":"bankTransfer"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 17","width":"36","height":"43","aria-labelledby":"banktransfer"}},[_c('title',{attrs:{"id":"banktransfer"}},[_vm._v("Bank Transfer")]),_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M11.5 17h-9A2.5 2.5 0 0 1 0 14.5v-12C0 1.1 1.1 0 2.5 0h9C12.9 0 14 1.1 14 2.5v12c0 1.4-1.1 2.5-2.5 2.5zm-9-16C1.7 1 1 1.7 1 2.5v12c0 .8.7 1.5 1.5 1.5h9c.8 0 1.5-.7 1.5-1.5v-12c0-.8-.7-1.5-1.5-1.5h-9z"}}),_c('path',{attrs:{"fill":"#231815","d":"M11.5 13h-9c-.3 0-.5-.2-.5-.5v-10c0-.3.2-.5.5-.5h9c.3 0 .5.2.5.5v10c0 .3-.2.5-.5.5zM3 12h8V3H3v9z"}}),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M7 15.6a1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7c0-.3.1-.5.3-.7a1 1 0 0 1 1.4 0c.2.2.3.4.3.7 0 .3-.1.5-.3.7a1 1 0 0 1-.7.3z"}})])])])])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paymentMethod),expression:"paymentMethod"}],staticClass:"custom-control-input",attrs:{"type":"radio","name":"paymentMethod","id":"bankTransfer","value":"bank"},domProps:{"checked":_vm._q(_vm.paymentMethod,"bank")},on:{"change":function($event){_vm.paymentMethod="bank"}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label font-weight-normal text-nowrap",attrs:{"for":"bankTransfer"}},[_vm._v("Bank Transfer")])])])]),_vm._v(" "),_c('VueSlideToggle',{staticClass:"col-12",attrs:{"open":_vm.paymentMethod === 'voucher',"tag":"div","duration":500}},[_c('div',{staticClass:"alert alert-info"},[_vm._v("Paying by Claiming Voucher")]),_vm._v(" "),_c('ol',{staticClass:"mb-5"},[_c('li',{staticClass:"mb-3"},[_vm._v("All memberships paid via voucher to be processed separately from other memberships.")]),_vm._v(" "),_c('li',{staticClass:"mb-3"},[_vm._v("Email Voucher to aca@campdraft.com.au")]),_vm._v(" "),_c('li',{staticClass:"mb-3"},[_vm._v("\n            Play On Voucher for 17 year olds or Juvenile Riding for Adults points transfer balance to:"),_c('br'),_c('br'),_vm._v("  \n            Australian Campdraft Association Inc. "),_c('br'),_vm._v(" \n            BSB: 034-171 (Westpac) "),_c('br'),_vm._v(" \n            ACC: 171918 "),_c('br'),_vm._v(" \n            Reference: Juveniles Member Number "),_c('br')]),_vm._v(" "),_c('li',{staticClass:"mb-3"},[_vm._v("Click "),_c('span',{staticStyle:{"color":"var(--primary)"}},[_vm._v("MAKE PAYMENT")]),_vm._v(" for voucher to be processed.")]),_vm._v(" "),_c('li',{staticClass:"mb-3"},[_vm._v("Once ACA has confirmed the voucher and received any due balance to the bank account the child’s profile will be made financial.")]),_vm._v(" "),_c('li',{staticClass:"mb-3"},[_vm._v("Please allow 3 business days on receipt of voucher and bank payment for processing.")])])]),_vm._v(" "),_c('VueSlideToggle',{staticClass:"col-12",attrs:{"open":_vm.paymentMethod === 'bank',"tag":"div","duration":500}},[_c('div',{staticClass:"alert alert-info"},[_vm._v("You must now click ‘Make Payment’ to notify the ACA of your payment.")]),_vm._v(" "),_c('ol',{staticClass:"mb-5"},[_c('li',{staticClass:"mb-3"},[_vm._v("\n            Please make your bank transfer to:"),_c('br'),_c('br'),_vm._v("\n            Australian Campdraft Association Inc."),_c('br'),_vm._v("\n            BSB: 034-171 (Westpac)"),_c('br'),_vm._v("\n            ACC: 171918"),_c('br')]),_vm._v(" "),_c('li',{staticClass:"mb-3"},[_vm._v("Ensure you include your Member Number "),_c('small',{staticClass:"border border-light px-2 rounded bg-lighter"},[_vm._v(_vm._s(_vm.theMemberNumber))]),_vm._v(" & Surname as the transaction reference.")]),_vm._v(" "),_c('li',{staticClass:"mb-3"},[_vm._v("You may now click ‘Make Payment’ to notify the ACA of your payment.")]),_vm._v(" "),_c('li',{staticClass:"mb-3"},[_vm._v("Please allow 3 days for Bank Transfer and Claim Voucher payments to be processed.")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-flex justify-content-center justify-content-lg-end align-items-center flex-wrap text-right text-lg-left"},[_c('div',{staticClass:"d-flex flex-column flex-lg-row align-items-center align-items-lg-center w-100 justify-content-lg-end"},[_c('div',{staticClass:"mr-lg-3 text-center text-lg-right"},[(_vm.cartMembers.total)?_c('strong',{staticClass:"d-block d-lg-inline"},[_vm._v("\n              Your total: $"+_vm._s(_vm.totalDisplay)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('button',{class:['btn btn-block-mob mt-2 mt-lg-0', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],attrs:{"type":"submit"},on:{"click":_vm.handleSubmit}},[_vm._v("\n            "+_vm._s(!_vm.processing ? 'Make Payment' : '')+"\n            "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])])]),_vm._v(" "),(_vm.showCardModal)?_c('stripe-card-modal',{attrs:{"amount":_vm.totalDisplay},on:{"token":_vm.onCardToken,"close":_vm.closeCardModal}}):_vm._e()],1):_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h1',{staticClass:"h2 mb-4"},[_vm._v("Thank You")]),_vm._v(" "),(_vm.success)?_c('div',{class:['alert alert-success', {'mb-3': !_vm.errors}],attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.success))]):(_vm.errors)?_c('div',{staticClass:"alert alert-warning mb-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors))]):_vm._e(),_vm._v(" "),_c('h2',{staticClass:"h3"},[_vm._v("Have an issue?")]),_vm._v(" "),_c('p',[_vm._v("Your transaction is complete. If you experience some difficulties with payment processing or are not sure what the status of your payment is, please contact us on (07) 4622 3110.")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("\n          A Family Membership is at least two adults, one juvenile and one mini or junior. As you have added additional mini, junior or juvenile membership/s, please use the "),_c('strong',[_vm._v("Bank Transfer")]),_vm._v("  option to check out. This will result in the membership being processed at no additional cost.\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',[_c('payment',{staticClass:"tab-pane col-12 col-xl-9 px-0 show active",attrs:{"slot":"tabContent","cartMembers":_vm.cartMembers,"type":'membership',"id":"payment","role":"tabpanel","aria-label":"Payment"},slot:"tabContent"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberAdd_vue__ = __webpack_require__(332);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d82b292_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberAdd_vue__ = __webpack_require__(839);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d82b292_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberAddDetails_vue__ = __webpack_require__(333);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61ed18e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberAddDetails_vue__ = __webpack_require__(838);
function injectStyle (ssrContext) {
  __webpack_require__(837)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61ed18e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberAddDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61ed18e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberAddDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 837 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.saveMembers($event)}}},[_c('div',{staticClass:"col px-0 pr-lg-3"},[_vm._l((_vm.memberPages),function(memberDetail,index){return _c('section',{key:index,staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[(index === 0)?_c('h1',{staticClass:"h2 mb-3"},[_vm._v("Add Member")]):_vm._e(),_vm._v(" "),(_vm.errors[index])?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors[index]))]):_vm._e(),_vm._v(" "),(_vm.commonError)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.commonError))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row align-items-start"},[_c('div',{staticClass:"col-12 col-md-6 form-group row no-gutters"},[_c('div',{staticClass:"col-auto"},[_c('label',{attrs:{"for":("title" + index)}},[_vm._v("Title")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate[index].title),expression:"memberUpdate[index].title"}],staticClass:"form-control",attrs:{"id":("title" + index),"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.memberUpdate[index], "title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',{attrs:{"value":"Mr"}},[_vm._v("Mr")]),_vm._v(" "),_c('option',{attrs:{"value":"Ms"}},[_vm._v("Ms")]),_vm._v(" "),_c('option',{attrs:{"value":"Miss"}},[_vm._v("Miss")]),_vm._v(" "),_c('option',{attrs:{"value":"Mrs"}},[_vm._v("Mrs")]),_vm._v(" "),_c('option',{attrs:{"value":"Dr"}},[_vm._v("Dr")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the title.")])]),_vm._v(" "),_c('div',{staticClass:"col pl-3"},[_c('label',{attrs:{"for":("firstName" + index)}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate[index].first_name),expression:"memberUpdate[index].first_name"}],staticClass:"form-control",attrs:{"type":"text","id":("firstName" + index),"required":"","maxlength":"40"},domProps:{"value":(_vm.memberUpdate[index].first_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate[index], "first_name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the First Name.")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":("lastName" + index)}},[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate[index].last_name),expression:"memberUpdate[index].last_name"}],staticClass:"form-control",attrs:{"type":"text","id":'lastName' + index,"required":"","maxlength":"40"},domProps:{"value":(_vm.memberUpdate[index].last_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate[index], "last_name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Last Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-6 row no-gutters"},[_c('div',{staticClass:"col-12 col-md-6 col-xl-auto form-group mb-xl-0 pr-md-3 pr-xl-0"},[_c('label',{attrs:{"for":("gender" + index)}},[_vm._v("Gender")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate[index].gender),expression:"memberUpdate[index].gender"}],staticClass:"form-control",attrs:{"id":'gender' + index,"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.memberUpdate[index], "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',[_vm._v("Male")]),_vm._v(" "),_c('option',[_vm._v("Female")]),_vm._v(" "),_c('option',[_vm._v("Unspecified")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Gender.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-xl form-group mb-xl-0 pl-md-3"},[_c('label',{attrs:{"for":("riderStatus" + index)}},[_vm._v("Rider Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate[index].riderStatus),expression:"memberUpdate[index].riderStatus"}],staticClass:"form-control",attrs:{"id":'riderStatus' + index,"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.memberUpdate[index], "riderStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_vm._l((_vm.$store.state.riderStatus),function(status,statusIndex){return _c('option',{key:statusIndex},[_vm._v(_vm._s(status.name))])})],2),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Rider Status.")])])]),_vm._v(" "),((_vm.userRole === 'Admin' || _vm.userRole === 'SuperAdmin'))?_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"boyStatus"}},[_vm._v("Beginning of Year Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate[index].boy_status_id),expression:"memberUpdate[index].boy_status_id"}],staticClass:"form-control",attrs:{"id":"boyStatus","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.memberUpdate[index], "boy_status_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"selected":!_vm.memberUpdate[index].boy_status_id}}),_vm._v(" "),_vm._l((_vm.$store.state.riderStatus),function(status,statusIndex){return _c('option',{key:statusIndex,domProps:{"value":status.id,"selected":_vm.memberUpdate[index].boy_status_id === status.id}},[_vm._v(_vm._s(status.name))])})],2),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Rider Status.")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 no-gutters form-group"},[_c('label',{attrs:{"for":("dateOfBirth" + index)}},[_vm._v("Date of Birth")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate[index].dateOfBirth),expression:"memberUpdate[index].dateOfBirth"}],class:['form-control form-date', _vm.errorStatus === 'validation_error' && _vm.errors[index] ? 'is-invalid' : ''],attrs:{"max":_vm.today(),"id":'dateOfBirth' + index,"type":"date","placeholder":[_vm.isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy'],"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}","value":"1988-01-01","required":""},domProps:{"value":(_vm.memberUpdate[index].dateOfBirth)},on:{"change":function($event){return _vm.calcType(index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate[index], "dateOfBirth", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Date of Birth.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":("secondary_email" + index)}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate[index].secondary_email),expression:"memberUpdate[index].secondary_email"}],class:['form-control', _vm.errorStatus === 'secondary_email' ? 'is-invalid' : ''],attrs:{"type":"email","id":("secondary_email" + index),"maxlength":"40"},domProps:{"value":(_vm.memberUpdate[index].secondary_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate[index], "secondary_email", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include correct the email.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":("secondary_phone" + index)}},[_vm._v("Mobile number")]),_vm._v(" "),_c('phone-input',{class:[_vm.errorStatus === 'incorrect_phone' ? 'is-invalid' : ''],attrs:{"id":("secondary_phone" + index)},model:{value:(_vm.memberUpdate[index].secondary_phone),callback:function ($$v) {_vm.$set(_vm.memberUpdate[index], "secondary_phone", $$v)},expression:"memberUpdate[index].secondary_phone"}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v(_vm._s(_vm.errorStatus === 'incorrect_phone' ? 'Please include correct phone number.' : 'Please include your phone number.'))]),_vm._v(" "),_c('small',[_vm._v("Please enter the phone in a similar format +614 **** **** without spaces")]),_vm._v(" "),_c('test-phone-numbers')],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(0,true),_vm._v(" "),_c('phone-input',{class:[_vm.errorStatus === 'carbon_copy_mobile' ? 'is-invalid' : ''],attrs:{"id":("carbon_copy_mobile" + index)},model:{value:(_vm.memberUpdate[index].carbon_copy_mobile),callback:function ($$v) {_vm.$set(_vm.memberUpdate[index], "carbon_copy_mobile", $$v)},expression:"memberUpdate[index].carbon_copy_mobile"}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please enter correct CC mobile")]),_vm._v(" "),_c('small',[_vm._v("Please enter the phone in a similar format +614 **** **** without spaces")]),_vm._v(" "),_c('test-phone-numbers')],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 no-gutters form-group"},[_c('label',{attrs:{"for":"proofOfAge"}},[_vm._v("Proof of Age")]),_vm._v(" "),_c('div',{staticClass:"custom-file"},[_c('input',{class:['custom-file-input font-weight-normal', { 'is-invalid': _vm.errorStatus === 'file' }],attrs:{"type":"file","id":"proofOfAge","accept":"image/*, application/pdf"},on:{"change":function($event){return _vm.fileUpload($event, index)}}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label font-weight-normal",attrs:{"for":"proofOfAge"}},[_vm._v(_vm._s(_vm.memberUpdate[index].file_name ? _vm.memberUpdate[index].file_name : 'Choose file...'))]),_vm._v(" "),_c('small',[_vm._v("jpg, jpeg, png, tiff, gif, pdf file type required.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Your ID will be stored in a secure data storage")]),_vm._v(" "),(_vm.memberUpdate[index].file_name)?_c('button',{staticClass:"btn btn-link px-2 pl-md-0 px-xl-2 pr-md-1",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteAttachment(index)}}},[_c('span',{staticClass:"sr-only"},[_vm._v("Delete File")]),_vm._v(" "),_c('div',{staticClass:"btn-remove"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"}}),_c('path',{attrs:{"d":"M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"}}),_c('path',{attrs:{"d":"M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"}})])])])]):_vm._e()])]),_vm._v(" "),((_vm.userRole === 'Admin' || _vm.userRole === 'SuperAdmin'))?_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":("memberNumber" + index)}},[_vm._v("Member Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.memberUpdate[index].member_number),expression:"memberUpdate[index].member_number"}],staticClass:"form-control",class:['form-control', _vm.errorStatus === 'member_number' ? 'is-invalid' : ''],attrs:{"type":"text","id":("memberNumber" + index)},domProps:{"value":(_vm.memberUpdate[index].member_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.memberUpdate[index], "member_number", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v(_vm._s(_vm.errorStatus === 'member_number' ? 'Please include another member number.' : ''))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 d-flex flex-wrap justify-content-end"},[(_vm.memberPages > 1)?_c('button',{staticClass:"btn btn-outline-primary btn-block-mob mt-3 mb-2 mb-lg-0",on:{"click":function($event){_vm.memberUpdate.splice(index,1);_vm.memberPages--}}},[_vm._v("Remove")]):_vm._e(),_vm._v(" "),_c('button',{class:['d-block d-lg-none btn btn-block-mob btn-primary text-nowrap', _vm.memberPages > 1 ? '' : 'mt-3'],on:{"click":function($event){$event.preventDefault();_vm.memberUpdate.push({name:{}});_vm.memberPages++;_vm.resetForm()}}},[_vm._v("Add Another")])])])])}),_vm._v(" "),_c('button',{staticClass:"d-lg-none btn btn-block btn-primary mb-3",attrs:{"type":"submit","disabled":this.errors.length !== 0 && this.commonError},on:{"click":_vm.handleSubmit}},[_vm._v("Finalise List")])],2),_vm._v(" "),_c('desktop-action-bar',[_c('button',{staticClass:"d-none d-lg-block btn btn-block btn-outline-primary text-nowrap",on:{"click":function($event){$event.preventDefault();_vm.memberUpdate.push({name:{}, notes: '', file_name: ''});_vm.memberPages++;_vm.resetForm()}}},[_vm._v("Add Another")]),_vm._v(" "),_c('button',{class:['btn btn-block mb-2', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],attrs:{"type":"submit"},on:{"click":_vm.handleSubmit}},[_vm._v("\n      "+_vm._s(!_vm.processing ? 'Finalise List' : '')+"\n      "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"carbon_copy_mobile"}},[_vm._v("CC Mobile "),_c('small',{staticClass:"d-inline-block"},[_vm._v("(optional)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',[_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'details' ? 'active' : ''],attrs:{"href":"","id":"details-tab","data-toggle":"tab","role":"tab","aria-controls":"details","aria-selected":_vm.selectedTab === 'details' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'details'}}},[_vm._v("Details")])]),_vm._v(" "),(_vm.selectedTab === 'details')?_c('member-add-details',{staticClass:"tab-pane row mx-0 show active",attrs:{"slot":"tabContent","id":"details","role":"tabpanel","aria-labelledby":"details-tab"},slot:"tabContent"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Committees_vue__ = __webpack_require__(334);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d6fb6f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Committees_vue__ = __webpack_require__(846);
function injectStyle (ssrContext) {
  __webpack_require__(841)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d6fb6f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Committees_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d6fb6f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Committees_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 841 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 842 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.committeeName)?_c('app-tooltip',{attrs:{"text":"Find this committee's secretaries (to log in as)"}},[_c('router-link',{staticClass:"committee-secretaries-link",attrs:{"to":{ name: 'Secretary Users', query: { search: _vm.committeeName } },"aria-label":"Find committee secretaries"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":"16","height":"16","aria-hidden":"true"}},[_c('path',{attrs:{"fill":"currentColor","d":"M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"}})])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useCommitteesList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__composables_useServerList__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_committees__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_committeeFinancialFilter__ = __webpack_require__(337);


 // Admin /committee-list page: server-side search / sort / pagination / financial tab, URL state.

function useCommitteesList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__composables_useServerList__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__services_api_committees__["a" /* default */].getList, {
    defaultSort: 'name',
    defaultDirection: 'asc',
    defaultPerPage: 20,
    extraFilters: {
      is_financial: __WEBPACK_IMPORTED_MODULE_2__constants_committeeFinancialFilter__["a" /* COMMITTEE_FINANCIAL_ALL */]
    }
  });
}

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = buildColumns;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildBreakpoints;
// Column keys double as the backend sort keys (CommitteeFilters::SORTABLE).
function buildColumns() {
  return [{
    key: 'name',
    label: 'Committee Name',
    sortable: true,
    minWidth: '200px',
    width: '1fr'
  }, {
    key: 'edit',
    label: 'Edit',
    width: '70px',
    cellClass: 'text-center'
  }, {
    key: 'remove',
    label: 'Remove',
    width: '80px',
    cellClass: 'text-center'
  }];
} // Below 700px the row collapses into an accordion: the name as summary, Edit/Remove as detail.

function buildBreakpoints() {
  return [{
    maxWidth: 700,
    hideHeader: true,
    accordion: {
      summary: [{
        keys: ['name'],
        hideLabel: true
      }]
    },
    rows: [['edit'], ['remove']]
  }];
}

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"h2 mb-0"},[_vm._v("Committee List")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary d-md-none px-xl-5 mt-2 mt-sm-0",attrs:{"to":{ name: 'Committee Profile' }}},[_vm._v("Create"),_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v(" committee")])])],1),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.successMessage)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.successMessage))]):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-inline mb-sm-3 d-flex justify-content-between"},[_c('div',{staticClass:"d-flex col-12 col-lg-auto px-0 mb-3 mb-lg-0"},[_c('label',{staticClass:"sr-only",attrs:{"for":"committeeFinancial-all"}},[_vm._v("Financial")]),_vm._v(" "),_c('div',{staticClass:"filter flex-wrap"},_vm._l((_vm.COMMITTEE_FINANCIAL_TABS),function(tab){return _c('div',{key:tab.value,staticClass:"form-check pl-0"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":"committeeFinancial","id":'committeeFinancial-' + tab.value},domProps:{"value":tab.value,"checked":_vm.filters.is_financial === tab.value},on:{"change":function($event){return _vm.setFilter('is_financial', tab.value)}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":'committeeFinancial-' + tab.value}},[_vm._v(_vm._s(tab.label))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-lg-auto mt-2 mt-lg-0 ml-auto px-0 d-flex align-items-center"},[_c('label',{staticClass:"d-none d-lg-inline mr-xl-2 mb-0 pr-2 font-weight-normal",attrs:{"for":"committeesSearch"}},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"input-append d-flex flex-grow-1 flex-md-grow-0 mr-md-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],staticClass:"form-control mb-0 flex-grow-1 flex-md-grow-0",attrs:{"id":"committeesSearch","type":"text"},domProps:{"value":(_vm.searchInput)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applySearch($event)},"search":_vm.applySearch,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('svg',{staticClass:"append",attrs:{"role":"button","aria-label":"Search","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14","width":"16","height":"16"},on:{"click":_vm.applySearch}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M5.5 11C2.5 11 0 8.5 0 5.5S2.5 0 5.5 0 11 2.5 11 5.5 8.5 11 5.5 11zm0-10C3 1 1 3 1 5.5S3 10 5.5 10 10 8 10 5.5 8 1 5.5 1z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#231815","d":"M9.5 8.8l4.4 4.4c.2.2.2.5 0 .7l-.4.1-.4-.1-4.4-4.4.8-.7z"}})])])]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-fz-sm btn-primary d-none d-md-block px-xl-5 mt-2 mt-sm-0 ml-md-0",attrs:{"to":{ name: 'Committee Profile' }}},[_vm._v("Add Committee")])],1)]),_vm._v(" "),_c('div',{staticClass:"position-relative",staticStyle:{"min-height":"240px"}},[_c('responsive-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"loading":_vm.loading,"breakpoints":_vm.breakpoints,"sort":_vm.filters.sort,"direction":_vm.filters.direction,"empty-text":"No committees found."},on:{"sort":_vm.setSort},scopedSlots:_vm._u([{key:"cell:name",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"committee-name-cell"},[_c('span',{staticClass:"committee-name-cell__name"},[_c('router-link',{staticClass:"btn btn-link text-wrap text-left p-0",attrs:{"to":_vm.profileRoute(row)}},[_vm._v(_vm._s(row.name))]),_vm._v(" "),_c('committee-secretaries-link',{attrs:{"committee-name":row.name}})],1),_vm._v(" "),_c('span',{staticClass:"badge",class:row.is_financial ? 'alert-info' : 'alert-warning'},[_vm._v(_vm._s(row.is_financial ? 'Financial' : 'Unfinancial'))])])]}},{key:"cell:edit",fn:function(ref){
var row = ref.row;
return [_c('router-link',{staticClass:"btn btn-sm btn-primary text-nowrap committee-action-btn",attrs:{"to":_vm.profileRoute(row)}},[_vm._v("Edit")])]}},{key:"cell:remove",fn:function(ref){
var row = ref.row;
return [_c('button',{staticClass:"btn btn-sm btn-primary text-nowrap committee-action-btn",attrs:{"disabled":_vm.removing},on:{"click":function($event){return _vm.askRemove(row)}}},[_vm._v("Remove")])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"form-inline justify-content-between align-items-start mt-3"},[_c('div',{staticClass:"d-flex align-items-center justify-content-center justify-content-md-start form-group mb-3 mb-md-0 col-12 col-md-auto px-0"},[_c('label',{staticClass:"mr-2 mb-0 font-weight-normal",attrs:{"for":"committeesShow"}},[_vm._v("Show")]),_vm._v(" "),_c('select',{staticClass:"form-control mr-2",attrs:{"id":"committeesShow"},domProps:{"value":_vm.filters.per_page},on:{"change":function($event){_vm.setPerPage(Number($event.target.value))}}},_vm._l((_vm.perPageOptions),function(n){return _c('option',{key:n,domProps:{"value":n}},[_vm._v(_vm._s(n))])}),0),_vm._v(" "),_c('span',[_vm._v("Entries")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.totalPages > 1),expression:"totalPages > 1"}],staticClass:"pagination-container form-group align-items-start justify-content-center mb-3 mb-md-0"},[_c('pagination',{attrs:{"total-pages":_vm.totalPages,"page":_vm.page,"on-change":_vm.setPage,"disabled":_vm.loading}})],1)]),_vm._v(" "),(_vm.rowToRemove)?_c('modal',{on:{"close":function($event){_vm.rowToRemove = null}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning text-center"},[_vm._v("\n          You are about to remove the committee ‘"+_vm._s(_vm.rowToRemove.name)+"’. Are you sure?\n        ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.rowToRemove = null}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary ml-2",on:{"click":function($event){$event.preventDefault();return _vm.remove($event)}}},[_vm._v("Confirm")])])])]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SwitchCommittee_vue__ = __webpack_require__(338);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95790490_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SwitchCommittee_vue__ = __webpack_require__(851);
function injectStyle (ssrContext) {
  __webpack_require__(848)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-95790490"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SwitchCommittee_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95790490_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SwitchCommittee_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 848 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useSwitchableCommittees;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__composables_useServerList__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_committees__ = __webpack_require__(93);

 // Super Secretary /switch-committee list (CAM-1533): financial committees, server-side
// search / sort / pagination with URL state.

function useSwitchableCommittees() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__composables_useServerList__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__services_api_committees__["a" /* default */].getSwitchable, {
    defaultSort: 'name',
    defaultDirection: 'asc',
    defaultPerPage: 20
  });
}

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = buildColumns;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildBreakpoints;
// Column keys double as the backend sort keys (CommitteeFilters::SORTABLE).
function buildColumns() {
  return [{
    key: 'name',
    label: 'Committee Name',
    sortable: true,
    minWidth: '200px',
    width: '1fr'
  }, {
    key: 'switch',
    label: 'Action',
    width: '80px',
    cellClass: 'text-center'
  }];
} // Two short columns: the desktop layout stays as-is on narrow screens (no accordion needed).

function buildBreakpoints() {
  return [];
}

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"h2 mb-0"},[_vm._v("Switch Committee")])]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"alert alert-info"},[_vm._v("\n      When you switch to a committee you're not part of, you'll have limited access to its functionality.\n      You'll be able to manage the selected committee's nominations, drafts, draws, and reports. However,\n      the Committee page will be view-only, and you won't have access to other Secretaries' personal information.\n    ")]),_vm._v(" "),(_vm.errorMessage)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-inline mb-sm-3 d-flex justify-content-end"},[_c('div',{staticClass:"form-group col-12 col-lg-auto mt-2 mt-lg-0 ml-auto px-0 d-flex align-items-center"},[_c('label',{staticClass:"d-none d-lg-inline mr-xl-2 mb-0 pr-2 font-weight-normal",attrs:{"for":"committeesSearch"}},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"input-append d-flex flex-grow-1 flex-md-grow-0"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],staticClass:"form-control mb-0 flex-grow-1 flex-md-grow-0",attrs:{"id":"committeesSearch","type":"text"},domProps:{"value":(_vm.searchInput)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applySearch($event)},"search":_vm.applySearch,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('svg',{staticClass:"append",attrs:{"role":"button","aria-label":"Search","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14","width":"16","height":"16"},on:{"click":_vm.applySearch}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M5.5 11C2.5 11 0 8.5 0 5.5S2.5 0 5.5 0 11 2.5 11 5.5 8.5 11 5.5 11zm0-10C3 1 1 3 1 5.5S3 10 5.5 10 10 8 10 5.5 8 1 5.5 1z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#231815","d":"M9.5 8.8l4.4 4.4c.2.2.2.5 0 .7l-.4.1-.4-.1-4.4-4.4.8-.7z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"position-relative",staticStyle:{"min-height":"240px"}},[_c('responsive-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"loading":_vm.loading,"breakpoints":_vm.breakpoints,"sort":_vm.filters.sort,"direction":_vm.filters.direction,"empty-text":"No committees found."},on:{"sort":_vm.setSort},scopedSlots:_vm._u([{key:"cell:name",fn:function(ref){
var row = ref.row;
return [_c('list-name-cell',{attrs:{"align":"right","label":row.name},scopedSlots:_vm._u([{key:"badges",fn:function(){return [(_vm.isOwn(row))?_c('span',{staticClass:"badge alert-info"},[_vm._v("My Committee")]):_vm._e()]},proxy:true}],null,true)})]}},{key:"cell:switch",fn:function(ref){
var row = ref.row;
return [_c('button',{staticClass:"btn btn-sm btn-primary text-nowrap committee-action-btn",attrs:{"disabled":_vm.isCurrent(row)},on:{"click":function($event){return _vm.switchTo(row)}}},[_vm._v("\n            "+_vm._s(_vm.isCurrent(row) ? 'Current' : 'Switch')+"\n          ")])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"form-inline justify-content-between align-items-start mt-3"},[_c('div',{staticClass:"d-flex align-items-center justify-content-center justify-content-md-start form-group mb-3 mb-md-0 col-12 col-md-auto px-0"},[_c('label',{staticClass:"mr-2 mb-0 font-weight-normal",attrs:{"for":"committeesShow"}},[_vm._v("Show")]),_vm._v(" "),_c('select',{staticClass:"form-control mr-2",attrs:{"id":"committeesShow"},domProps:{"value":_vm.filters.per_page},on:{"change":function($event){_vm.setPerPage(Number($event.target.value))}}},_vm._l((_vm.perPageOptions),function(n){return _c('option',{key:n,domProps:{"value":n}},[_vm._v(_vm._s(n))])}),0),_vm._v(" "),_c('span',[_vm._v("Entries")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.totalPages > 1),expression:"totalPages > 1"}],staticClass:"pagination-container form-group align-items-start justify-content-center mb-3 mb-md-0"},[_c('pagination',{attrs:{"total-pages":_vm.totalPages,"page":_vm.page,"on-change":_vm.setPage,"disabled":_vm.loading}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeProfile_vue__ = __webpack_require__(339);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_759f9d58_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeProfile_vue__ = __webpack_require__(894);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_759f9d58_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 853 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 854 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 855 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadList_vue__ = __webpack_require__(343);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25372712_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadList_vue__ = __webpack_require__(859);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25372712_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadListItem_vue__ = __webpack_require__(344);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_bbc90f24_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadListItem_vue__ = __webpack_require__(858);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueBootstrapTypeaheadListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_bbc90f24_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueBootstrapTypeaheadListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.textClasses,attrs:{"tabindex":"0","href":"#"},on:{"mouseover":function($event){_vm.active = true},"mouseout":function($event){_vm.active = false}}},[_vm._t("suggestion",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.htmlText)}})],null,{ data: _vm.data, htmlText: _vm.htmlText })],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-group shadow"},_vm._l((_vm.matchedItems),function(item,id){return _c('vue-bootstrap-typeahead-list-item',{key:id,attrs:{"data":item.data,"html-text":_vm.highlight(item.text),"background-variant":_vm.backgroundVariant,"text-variant":_vm.textVariant},nativeOn:{"click":function($event){return _vm.handleHit(item, $event)}},scopedSlots:_vm._u([{key:"suggestion",fn:function(ref){
var data = ref.data;
var htmlText = ref.htmlText;
return (_vm.$scopedSlots.suggestion)?[_vm._t("suggestion",null,null,{ data: data, htmlText: htmlText })]:undefined}}],null,true)})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 860 */,
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.sizeClasses},[(_vm.$slots.prepend || _vm.prepend)?_c('div',{ref:"prependDiv",staticClass:"input-group-prepend"},[_vm._t("prepend",[_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(_vm.prepend))])])],2):_vm._e(),_vm._v(" "),_c('input',{ref:"input",class:("form-control " + _vm.inputClass),attrs:{"type":"search","placeholder":_vm.placeholder,"aria-label":_vm.placeholder,"autocomplete":"off"},domProps:{"value":_vm.inputValue},on:{"focus":function($event){_vm.isFocused = true},"blur":_vm.handleBlur,"input":function($event){return _vm.handleInput($event.target.value)}}}),_vm._v(" "),(_vm.$slots.append || _vm.append)?_c('div',{staticClass:"input-group-append"},[_vm._t("append",[_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(_vm.append))])])],2):_vm._e()]),_vm._v(" "),_c('vue-bootstrap-typeahead-list',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFocused && _vm.data.length > 0),expression:"isFocused && data.length > 0"}],ref:"list",staticClass:"vbt-autcomplete-list",attrs:{"query":_vm.inputValue,"data":_vm.formattedData,"background-variant":_vm.backgroundVariant,"text-variant":_vm.textVariant,"maxMatches":_vm.maxMatches,"minMatchingChars":_vm.minMatchingChars},on:{"hit":_vm.handleHit},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(slot,slotName){return {key:slotName,fn:function(ref){
var data = ref.data;
var htmlText = ref.htmlText;
return [_vm._t(slotName,null,null,{ data: data, htmlText: htmlText })]}}})],null,true)})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation ml-0",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.update($event)}}},[_c('div',{staticClass:"col px-0 pr-lg-3"},[_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('h2',{staticClass:"h2 mb-3"},[_vm._v("Committee Secretaries")]),_vm._v(" "),(_vm.errors)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',[_vm._v("Select a Secretary")]),_vm._v(" "),_c('vue-bootstrap-typeahead',{attrs:{"data":_vm.secretaries,"serializer":function (s) { return s.first_name + ' ' + s.last_name; },"placeholder":"Start typing..."},on:{"hit":function($event){_vm.selectedSecretary = $event}},model:{value:(_vm.secretariesSearch),callback:function ($$v) {_vm.secretariesSearch=$$v},expression:"secretariesSearch"}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Secretary.")])],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group button-add-secretary-wrapper"},[_c('button',{class:['btn btn-block button-add-secretary', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],attrs:{"disabled":_vm.processing},on:{"click":_vm.handleAddSecretary}},[_vm._v("\n            "+_vm._s(_vm.processing ? '' : 'Add Secretary')+"\n            "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-10 col-md-5 form-group"},_vm._l((_vm.addedSecretaries),function(secretary,index){return _c('div',{staticClass:"secretaries-list-item"},[_c('div',[_vm._v(_vm._s(secretary.first_name + ' ' + secretary.last_name))]),_vm._v(" "),_c('div',[_c('button',{key:secretary.id,ref:'secretary-item',refInFor:true,staticClass:"btn btn-sm button-remove-secretary",on:{"click":function($event){return _vm.removeSecretary(secretary.id, index)}}},[_vm._v(_vm._s(_vm.removeProcessing ? '' : 'Remove')+"\n              ")])])])}),0)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 863 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation ml-0",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.update($event)}}},[_c('div',{staticClass:"col px-0 pr-lg-3"},[_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v("Committee Affiliation Details")]),_vm._v(" "),(_vm.errors)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"affiliation-form-wrapper"},[_c('div',{staticClass:"row block"},[_c('div',{staticClass:" col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"committeeName"}},[_vm._v("Committee Name")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"committeeName","disabled":""},domProps:{"value":_vm.affiliation.name}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"committeeEmail"}},[_vm._v("Mailing Address ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.affiliation.mailing_address.$model),expression:"$v.affiliation.mailing_address.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.affiliation.mailing_address.$error },attrs:{"type":"text","id":"committeeEmail"},domProps:{"value":(_vm.$v.affiliation.mailing_address.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.affiliation.mailing_address, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Mailing Address.")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:" col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"committeeSuburb"}},[_vm._v("Suburb ")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"committeeSuburb","disabled":""},domProps:{"value":_vm.affiliation.suburb}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_c('label',[_vm._v("State")]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"disabled":""},domProps:{"value":_vm.affiliation.state}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',{attrs:{"value":"QLD"}},[_vm._v("Queensland")]),_vm._v(" "),_c('option',{attrs:{"value":"NSW"}},[_vm._v("New South Wales")]),_vm._v(" "),_c('option',{attrs:{"value":"VIC"}},[_vm._v("Victoria")]),_vm._v(" "),_c('option',{attrs:{"value":"ACT"}},[_vm._v("Australian Capital Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"SA"}},[_vm._v("South Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"NT"}},[_vm._v("Northern Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"WA"}},[_vm._v("Western Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"TAS"}},[_vm._v("Tasmania")])])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_c('label',{attrs:{"for":"CommitteePostcode"}},[_vm._v("Postcode ")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"CommitteePostcode","disabled":""},domProps:{"value":_vm.affiliation.post_code}})])])]),_vm._v(" "),_c('div',{staticClass:"row block"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"committeeGroundsAddress"}},[_vm._v("Campdraft Grounds Address ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.affiliation.grounds_address.$model),expression:"$v.affiliation.grounds_address.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.affiliation.grounds_address.$error },attrs:{"type":"text","id":"committeeGroundsAddress"},domProps:{"value":(_vm.$v.affiliation.grounds_address.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.affiliation.grounds_address, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Campdraft Grounds Address.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"committeeGroundsAddressSuburb"}},[_vm._v("Suburb ")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"committeeGroundsAddressSuburb","disabled":""},domProps:{"value":_vm.affiliation.grounds_suburb}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',[_vm._v("State ")]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"disabled":""},domProps:{"value":_vm.affiliation.grounds_state}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',{attrs:{"value":"QLD"}},[_vm._v("Queensland")]),_vm._v(" "),_c('option',{attrs:{"value":"NSW"}},[_vm._v("New South Wales")]),_vm._v(" "),_c('option',{attrs:{"value":"VIC"}},[_vm._v("Victoria")]),_vm._v(" "),_c('option',{attrs:{"value":"ACT"}},[_vm._v("Australian Capital Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"SA"}},[_vm._v("South Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"NT"}},[_vm._v("Northern Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"WA"}},[_vm._v("Western Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"TAS"}},[_vm._v("Tasmania")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',[_vm._v("Postcode ")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.affiliation.grounds_postcode}})])]),_vm._v(" "),_c('div',{staticClass:"row block"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',[_vm._v("President Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.affiliation.president_name.$model),expression:"$v.affiliation.president_name.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.affiliation.president_name.$error },attrs:{"type":"text"},domProps:{"value":(_vm.$v.affiliation.president_name.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.affiliation.president_name, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the President Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',[_vm._v("Secretary Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.affiliation.secretary_name.$model),expression:"$v.affiliation.secretary_name.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.affiliation.secretary_name.$error },attrs:{"type":"text"},domProps:{"value":(_vm.$v.affiliation.secretary_name.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.affiliation.secretary_name, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Secretary Name.")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',[_vm._v("Treasurer Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.affiliation.treasurer_name.$model),expression:"$v.affiliation.treasurer_name.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.affiliation.treasurer_name.$error },attrs:{"type":"text"},domProps:{"value":(_vm.$v.affiliation.treasurer_name.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.affiliation.treasurer_name, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Treasurer Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',[_vm._v("Other Name: (Campdraft Steward etc)")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.affiliation.other_name}})])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-bottom":"20px"}},[_c('div',{staticClass:"col-4 col-md-3 form-group"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"internet_access","disabled":""},domProps:{"checked":_vm.affiliation.internet_access}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label access-to",attrs:{"for":"internet_access"}},[_vm._v("\n              Internet access\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-4 col-md-3 form-group"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"phone_service","disabled":""},domProps:{"checked":_vm.affiliation.phone_service}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label access-to",attrs:{"for":"phone_service"}},[_vm._v("\n              Phone service\n            ")])])])]),_vm._v(" "),_vm._l((_vm.drafts),function(draft){return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-3 form-group"},[_c('label',[_vm._v("Proposed Campdraft Start Date")]),_vm._v(" "),_c('input',{staticClass:"form-control form-date",attrs:{"type":"date","disabled":""},domProps:{"value":draft.start}})]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_c('label',[_vm._v("Proposed Campdraft End Date")]),_vm._v(" "),_c('input',{staticClass:"form-control form-date",attrs:{"type":"date","disabled":""},domProps:{"value":draft.end}})])])])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"event_membership_agree","disabled":""},domProps:{"checked":_vm.affiliation.event_membership_agree}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label access-to",attrs:{"for":"event_membership_agree"}},[_vm._v("\n              By checking this box, your committee consents to receiving an invoice for Event Membership Fees\n              collected on behalf of ACA, if your committee chooses to accept Casual Members\n            ")])])])]),_vm._v(" "),_c('h1',{staticClass:"h2 mb-3 mt-4",staticStyle:{"font-size":"40px"}},[_vm._v("ACA Property Owner’s/Lessee’s Liability")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"w-25 ml-3 mt-2"},[_c('a',{staticClass:"btn btn-primary btn-block",staticStyle:{"color":"var(--white)"},attrs:{"href":_vm.affiliation.file_path,"target":"_blank"}},[_vm._v("\n            Download Application\n          ")])])])],2)]),_vm._v(" "),_c('desktop-action-bar',[_c('button',{class:['btn btn-block', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],on:{"click":_vm.handleSubmit}},[_vm._v("\n      "+_vm._s(!_vm.processing ? 'Save' : '')+"\n      "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row block"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('b',{staticStyle:{"font-size":"18px"}},[_vm._v("At your campdraft grounds, does the committee have access to: ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeProfileAllDetails_vue__ = __webpack_require__(348);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23fe8f2b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeProfileAllDetails_vue__ = __webpack_require__(892);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeProfileAllDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23fe8f2b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeProfileAllDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeProfileDetails_vue__ = __webpack_require__(349);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7750029e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeProfileDetails_vue__ = __webpack_require__(891);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeProfileDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7750029e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeProfileDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation ml-0",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.update($event)}}},[_c('div',{staticClass:"col px-0 pr-lg-3"},[_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[(!_vm.isLoading)?_c('div',[_c('h1',{staticClass:"h2 mb-3"},[_vm._v(_vm._s(_vm.committee.id ? 'Committee Profile' : 'New Committee'))]),_vm._v(" "),(_vm.errors)?_c('div',{ref:"errorAlert",staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors))]):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 form-group"},[_c('label',{attrs:{"for":"notes"}},[_vm._v("Notes")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.$v.committee.notes.$model),expression:"$v.committee.notes.$model"}],staticClass:"form-control",attrs:{"id":"notes"},domProps:{"value":(_vm.$v.committee.notes.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.committee.notes, "$model", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.committee.name.$model),expression:"$v.committee.name.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.committee.name.$error || _vm.errorFields.name},attrs:{"type":"text","id":"committeeName","required":""},domProps:{"value":(_vm.$v.committee.name.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.committee.name, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Committee name must contain letters and spaces only.")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_vm._m(1),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.committee.zone_id.$model),expression:"$v.committee.zone_id.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.committee.zone_id.$error },attrs:{"id":"e-zone","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.$v.committee.zone_id, "$model", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Unspecified")]),_vm._v(" "),_vm._l((_vm.$store.state.listZones.filter(function (zone) { return !zone.deleted_at; })),function(zone,index){return _c('option',{key:index,domProps:{"value":zone.id}},[_vm._v(_vm._s(zone.code)+"\n                ")])})],2),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Zone.")]),_vm._v(" "),(_vm.zoneNotFound && !_vm.zoneNotSpecified)?_c('div',{staticClass:"alert alert-warning alert-sm"},[_vm._v("Unable to find matching\n                Zone.\n              ")]):(_vm.zoneNotSpecified)?_c('div',{staticClass:"alert alert-warning alert-sm zone-alert"},[_vm._v("Please refine the postcode to find zone matches.")]):(_vm.zoneFound)?_c('div',{staticClass:"alert alert-success alert-sm zone-alert"},[_vm._v("Found matching Zone.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.committee.contact_name.$model),expression:"$v.committee.contact_name.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid' : _vm.$v.committee.contact_name.$error || _vm.errorFields.contact_name },attrs:{"type":"text","id":"contactName","required":""},domProps:{"value":(_vm.$v.committee.contact_name.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.committee.contact_name, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("\n                Please include the valid contact name.\n              ")])]),_vm._v(" "),(_vm.committee && _vm.committee.id)?_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.committee.cheques_to.$model),expression:"$v.committee.cheques_to.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid' : _vm.$v.committee.cheques_to.$error },attrs:{"type":"text","id":"chequesTo"},domProps:{"value":(_vm.$v.committee.cheques_to.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.committee.cheques_to, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("\n                Please include the valid cheques to.\n              ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"committeeLogoFile"}},[_vm._v("Committee logo")]),_vm._v(" "),_c('div',{staticClass:"custom-file"},[_c('input',{staticClass:"form-control custom-file-input",class:{ 'is-invalid': _vm.logoError.fileSize },attrs:{"type":"file","name":_vm.logo_file,"id":"committeeLogoFile","accept":"image/*"},on:{"change":_vm.logoUpload}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label font-weight-normal",attrs:{"for":"committeeLogoFile"}},[_vm._v(_vm._s(_vm.logo_name ? _vm.logo_name : 'Choose file...'))]),_vm._v(" "),_c('small',[_vm._v("jpg, jpeg, png, tiff, gif file type required.")]),_vm._v(" "),(_vm.logoError.fileSize)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Logo File may not be greater than 250 kilobytes")]):_vm._e(),_vm._v(" "),(_vm.logo_name)?_c('button',{staticClass:"btn btn-link px-2 pl-md-0 px-xl-2 pr-md-1",attrs:{"type":"button"},on:{"click":_vm.deleteLogoAttachment}},[_c('span',{staticClass:"sr-only"},[_vm._v("Delete File")]),_vm._v(" "),_c('div',{staticClass:"btn-remove"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"}})])])])]):_vm._e()]),_vm._v(" "),(this.committee.logo_file_path)?_c('div',{staticClass:"attached-file-wrapper"},[_vm._v("\n                "+_vm._s(this.committee.logo_file_name)+"\n                "),_c('div',{staticClass:"btn-remove-file",on:{"click":_vm.deleteExistsAttachment}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"}})])])]),_vm._v(" "),_c('div',{staticClass:"btn-download-file",on:{"click":function($event){return _vm.downloadLogoFile(_vm.committee.id)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"}})])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"picNumber"}},[_vm._v("PIC number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.committee.pic_number.$model),expression:"$v.committee.pic_number.$model",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":"picNumber"},domProps:{"value":(_vm.$v.committee.pic_number.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.committee.pic_number, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(4),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.$v.committee.contact_email.$model),expression:"$v.committee.contact_email.$model",modifiers:{"lazy":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.committee.contact_email.$error || _vm.errorFields.contact_email},attrs:{"type":"text","id":"contactEmail","required":""},domProps:{"value":(_vm.$v.committee.contact_email.$model)},on:{"blur":function($event){return _vm.$v.committee.contact_email.$touch()},"change":function($event){return _vm.$set(_vm.$v.committee.contact_email, "$model", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the valid Email.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(5),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.committee.contact_phone.$model),expression:"$v.committee.contact_phone.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid':  _vm.$v.committee.contact_phone.$error || _vm.errorFields.contact_phone },attrs:{"type":"text","id":"committeePhone","required":""},domProps:{"value":(_vm.$v.committee.contact_phone.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.committee.contact_phone, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(!_vm.$v.committee.contact_phone.required)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Phone number.")]):_vm._e(),_vm._v(" "),(!_vm.$v.committee.contact_phone.phoneRegex)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the valid Phone number.")]):_vm._e()]),_vm._v(" "),(!_vm.committee.id)?_c('div',{staticClass:"col-12 col-md-6 mb-4 form-group"},[_c('label',{attrs:{"for":"c-isFinancial"}},[_vm._v("Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.committee.is_financial),expression:"committee.is_financial"}],staticClass:"form-control",attrs:{"id":"c-isFinancial","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.committee, "is_financial", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":0}},[_vm._v("Unfinancial")]),_vm._v(" "),_c('option',{domProps:{"value":1}},[_vm._v("Financial")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Status.")])]):_vm._e(),_vm._v(" "),(_vm.committee && _vm.committee.id)?_c('div',{staticClass:"d-flex flex-wrap"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(6),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.committee.abn.$model),expression:"$v.committee.abn.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.committee.abn.$error },attrs:{"type":"text","id":"committeeAbn"},domProps:{"value":(_vm.$v.committee.abn.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.committee.abn, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the ABN.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(7),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.committee.address.$model),expression:"$v.committee.address.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.committee.address.$error || _vm.errorFields.line1},attrs:{"type":"text","id":"committeeAddress"},domProps:{"value":(_vm.$v.committee.address.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.committee.address, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the valid address.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(8),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.committee.city.$model),expression:"$v.committee.city.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{'is-invalid': _vm.$v.committee.city.$error || _vm.errorFields.city },attrs:{"type":"text","id":"committeeCity"},domProps:{"value":(_vm.$v.committee.city.$model)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.committee.city, "$model", $event.target.value.trim())},function($event){return _vm.findZone()}],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the valid city.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(9),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.committee.state.$model),expression:"$v.committee.state.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.committee.state.$error },attrs:{"id":"state"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.$v.committee.state, "$model", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',{attrs:{"value":"QLD"}},[_vm._v("Queensland")]),_vm._v(" "),_c('option',{attrs:{"value":"NSW"}},[_vm._v("New South Wales")]),_vm._v(" "),_c('option',{attrs:{"value":"VIC"}},[_vm._v("Victoria")]),_vm._v(" "),_c('option',{attrs:{"value":"ACT"}},[_vm._v("Australian Capital Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"SA"}},[_vm._v("South Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"NT"}},[_vm._v("Northern Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"WA"}},[_vm._v("Western Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"TAS"}},[_vm._v("Tasmania")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your State.")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_vm._m(10),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.committee.post_code.$model),expression:"$v.committee.post_code.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.committee.post_code.$error || _vm.errorFields.postal_code},attrs:{"type":"text","id":"postcode","maxlength":"4","pattern":"\\d{4}"},domProps:{"value":(_vm.$v.committee.post_code.$model)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.committee.post_code, "$model", $event.target.value.trim())},function($event){return _vm.findZone()}],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the valid postcode.")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_c('label',{attrs:{"for":"committeeBankAbbreviation"}},[_vm._v("Bank Abbreviation")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.committee.bank_abbreviation.$model),expression:"$v.committee.bank_abbreviation.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.committee.bank_abbreviation.$error },attrs:{"type":"text","id":"committeeBankAbbreviation"},domProps:{"value":(_vm.$v.committee.bank_abbreviation.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.committee.bank_abbreviation, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Bank Abbreviation.")]),_vm._v(" "),_c('small',{staticClass:"small-notes small-notes-per"},[_vm._v("The bank abbreviation must be approved Financial Institution\n                  abbreviation.")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_vm._m(11),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.committee.bsb.$model),expression:"$v.committee.bsb.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.committee.bsb.$error || _vm.errorFields.routing_number},attrs:{"type":"text","id":"committeeBSB","maxlength":"7"},domProps:{"value":(_vm.$v.committee.bsb.$model)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.committee.bsb, "$model", $event.target.value.trim())},_vm.validateBankBsb],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(!_vm.$v.committee.bsb.bsbRegex || _vm.$v.committee.bsb.$error || _vm.errorFields.routing_number)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the valid BSB.")]):_vm._e(),_vm._v(" "),_c('small',{staticClass:"small-notes small-notes-per"},[_vm._v("Please enter the bank's BSB in the format XXX-YYY.")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_vm._m(12),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.committee.account_number.$model),expression:"$v.committee.account_number.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.committee.account_number.$error || _vm.errorFields.account_number},attrs:{"type":"text","id":"committeeAccountNumber"},domProps:{"value":(_vm.$v.committee.account_number.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.committee.account_number, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include correct the Account Number.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-4 form-group"},[_c('label',[_vm._v("Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.committee.is_financial),expression:"committee.is_financial"}],staticClass:"form-control",attrs:{"id":"isFinancial"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.committee, "is_financial", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":0}},[_vm._v("Unfinancial")]),_vm._v(" "),_c('option',{domProps:{"value":1}},[_vm._v("Financial")])])])]):_vm._e()]),_vm._v(" "),(_vm.committee && _vm.committee.id)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(13),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.committee.is_enabled_stripe),expression:"committee.is_enabled_stripe"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"accept","value":"1"},domProps:{"checked":_vm.committee.is_enabled_stripe == '1',"checked":_vm._q(_vm.committee.is_enabled_stripe,"1")},on:{"change":function($event){return _vm.$set(_vm.committee, "is_enabled_stripe", "1")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label font-weight-normal",attrs:{"for":"accept"}},[_vm._v("Accept")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.committee.is_enabled_stripe),expression:"committee.is_enabled_stripe"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"notAccept","value":"0"},domProps:{"checked":_vm.committee.is_enabled_stripe == '0',"checked":_vm._q(_vm.committee.is_enabled_stripe,"0")},on:{"change":function($event){return _vm.$set(_vm.committee, "is_enabled_stripe", "0")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label font-weight-normal",attrs:{"for":"notAccept"}},[_vm._v("Not Accept")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticClass:"small-notes small-notes-per"},[_vm._v("To accept instant online payments such as credit card for nomination fees.")])])]),_vm._v(" "),(_vm.committee.is_enabled_stripe == '1')?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-3 form-group"},[_c('label',[_vm._v("Bank Owner First Name ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.committee.bank_owner_first_name.$model),expression:"$v.committee.bank_owner_first_name.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.committee.bank_owner_first_name.$error },attrs:{"type":"text","required":""},domProps:{"value":(_vm.$v.committee.bank_owner_first_name.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.committee.bank_owner_first_name, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Bank Owner First Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_c('label',[_vm._v("Bank Owner Last Name ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.committee.bank_owner_last_name.$model),expression:"$v.committee.bank_owner_last_name.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.committee.bank_owner_last_name.$error },attrs:{"type":"text","required":""},domProps:{"value":(_vm.$v.committee.bank_owner_last_name.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.committee.bank_owner_last_name, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Bank Owner Last Name.")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-3 form-group"},[_c('label',{attrs:{"for":"bankOwnerDOB"}},[_vm._v("Bank Owner Day Of Birth ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.committee.bank_owner_dob.$model),expression:"$v.committee.bank_owner_dob.$model",modifiers:{"trim":true}}],staticClass:"form-control form-date",class:{ 'is-invalid': _vm.$v.committee.bank_owner_dob.$error },attrs:{"type":"date","id":"bankOwnerDOB","required":"","placeholder":'dd.mm.yyyy',"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}"},domProps:{"value":(_vm.$v.committee.bank_owner_dob.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.committee.bank_owner_dob, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Bank Owner Day Of Birth.")])]),_vm._v(" "),(!_vm.committee.is_stripe_verified)?_c('div',{staticClass:"col-6 col-md-3 form-group"},[_c('label',{attrs:{"for":"bankIdentityFile"}},[_vm._v("Bank Identity File")]),_vm._v(" "),_c('div',{staticClass:"custom-file"},[_c('input',{staticClass:"form-control custom-file-input",class:{ 'is-invalid': _vm.fileError.required || _vm.fileError.fileSize },attrs:{"type":"file","id":"bankIdentityFile","accept":"image/*, application/pdf"},on:{"change":_vm.fileUpload}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label font-weight-normal",attrs:{"for":"bankIdentityFile"}},[_vm._v(_vm._s(_vm.file_name ? _vm.file_name : 'Choose file...'))]),_vm._v(" "),(_vm.fileError.required)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Bank Identity File.")]):_vm._e(),_vm._v(" "),(_vm.fileError.fileSize)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Bank Identity File may not be greater than 1 mb")]):_vm._e(),_vm._v(" "),_c('small',[_vm._v("File needs to include BOTH sides of your identification in colour")]),_vm._v(" "),(_vm.file_name)?_c('button',{staticClass:"btn btn-link px-2 pl-md-0 px-xl-2 pr-md-1",attrs:{"type":"button"},on:{"click":_vm.deleteAttachment}},[_c('span',{staticClass:"sr-only"},[_vm._v("Delete File")]),_vm._v(" "),_c('div',{staticClass:"btn-remove"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"}})])])])]):_vm._e()])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-3 form-group gst_registered"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.committee.gst_registered),expression:"committee.gst_registered"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"gst_registered"},domProps:{"checked":Array.isArray(_vm.committee.gst_registered)?_vm._i(_vm.committee.gst_registered,null)>-1:(_vm.committee.gst_registered)},on:{"change":function($event){var $$a=_vm.committee.gst_registered,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.committee, "gst_registered", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.committee, "gst_registered", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.committee, "gst_registered", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"gst_registered"}},[_vm._v("\n                    I am GST registered\n                  ")]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include true or false.")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-flex d-lg-none justify-content-end"},[_c('button',{class:['btn btn-block-mob', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],on:{"click":_vm.handleSubmit}},[_vm._v("\n                "+_vm._s(!_vm.processing ? 'Update' : '')+"\n                "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"text-center p-2"},[_vm._m(14)]):_vm._e()])]),_vm._v(" "),_c('desktop-action-bar',[_c('button',{class:['btn btn-block', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],on:{"click":_vm.handleSubmit}},[_vm._v("\n      "+_vm._s(!_vm.processing ? 'Save' : '')+"\n      "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeName"}},[_vm._v("Committee Name "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"e-zone"}},[_vm._v("Zone "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"contactName"}},[_vm._v("Contact Name "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"chequesTo"}},[_vm._v("Cheques To "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"contactEmail"}},[_vm._v("Contact Email "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeePhone"}},[_vm._v("Contact Phone "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeAbn"}},[_vm._v("ABN "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeAddress"}},[_vm._v("Address "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeCity"}},[_vm._v("City "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"state"}},[_vm._v("State "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"postcode"}},[_vm._v("Postcode "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeBSB"}},[_vm._v("BSB "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeName"}},[_vm._v("Account Number "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',[_vm._v("Credit Card Payments")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('committee-profile-details',{staticClass:"tab-pane row mx-0 show active",attrs:{"committeeDetails":_vm.committeeDetails,"isLoading":_vm.isLoading}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h1',{staticClass:"h2 mb-3"},[_vm._v("Financials")]),_vm._v(" "),_c('data-table',{attrs:{"dataRows":_vm.invoicesWithTotal,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{attrs:{"text":row.id,"row":row,"options":{ expandMobile: true, showPaid: true }}})}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',[_c('strong',[_vm._v("Amount: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":'$' + _vm.getDisplayTotal(row),"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Date: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":new Date(row.created_at.replace(/-/g, '/')).toLocaleString('en-AU'),"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Purchase: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.type.charAt(0).toUpperCase() + row.type.slice(1),"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',{staticClass:"pt-3 d-block d-sm-inline-block"},[_c('tableDownloadTemplate',{attrs:{"row":row}})],1)])])}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',[_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'details' ? 'active' : ''],attrs:{"href":"","id":"details-tab","data-toggle":"tab","role":"tab","aria-controls":"details","aria-selected":_vm.selectedTab === 'details' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'details'}}},[_vm._v("Details")])]),_vm._v(" "),(_vm.committee)?_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'financials' ? 'active' : ''],attrs:{"href":"","id":"financials-tab","data-toggle":"tab","role":"tab","aria-controls":"financials","aria-selected":_vm.selectedTab === 'financials' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'financials'}}},[_vm._v("Financials")])]):_vm._e(),_vm._v(" "),(_vm.committee)?_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'secretaries' ? 'active' : ''],attrs:{"href":"","id":"secretaries-tab","data-toggle":"tab","role":"tab","aria-controls":"secretaries","aria-selected":_vm.selectedTab === 'secretaries' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'secretaries'}}},[_vm._v("Secretaries")])]):_vm._e(),_vm._v(" "),(_vm.committee && _vm.committee.affiliations.length > 0 && _vm.committee.affiliations[0].is_completed == true)?_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'affiliations' ? 'active' : ''],attrs:{"href":"","id":"affiliations-tab","data-toggle":"tab","role":"tab","aria-controls":"affiliations","aria-selected":_vm.selectedTab === 'affiliations' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'affiliations'}}},[_vm._v("Affiliations")])]):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'details')?_c('committee-profile-all-details',{staticClass:"tab-pane row mx-0 show active",attrs:{"slot":"tabContent","committeeDetails":_vm.committee,"isLoading":_vm.isLoading,"id":"details","role":"tabpanel","aria-labelledby":"details-tab"},on:{"renew":function($event){_vm.renew = true;_vm.selectedTab = 'details'}},slot:"tabContent"}):_vm._e(),_vm._v(" "),(_vm.committee  && _vm.selectedTab === 'financials')?_c('committee-profile-financials',{staticClass:"tab-pane col-12 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active",attrs:{"slot":"tabContent","committeeId":_vm.committee.id,"id":"financials","role":"tabpanel","aria-labelledby":"financials-tab"},slot:"tabContent"}):_vm._e(),_vm._v(" "),(_vm.committee  && _vm.selectedTab === 'secretaries')?_c('committee-secretaries',{staticClass:"tab-pane col-12 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active",attrs:{"slot":"tabContent","committeeDetails":_vm.committee,"id":"secretaries","role":"tabpanel","aria-labelledby":"secretaries-tab"},slot:"tabContent"}):_vm._e(),_vm._v(" "),(_vm.committee  && _vm.selectedTab === 'affiliations')?_c('committee-affiliation',{staticClass:"tab-pane row mx-0 show active",attrs:{"slot":"tabContent","committeeDetails":_vm.committee,"id":"affiliations","role":"tabpanel","aria-labelledby":"affiliations-tab"},slot:"tabContent"}):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'loading')?_c('div',{staticClass:"tab-pane col-12 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active",attrs:{"slot":"tabContent","id":"loading","role":"tabpanel","aria-labelledby":"loading-tab"},slot:"tabContent"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorsesListing_vue__ = __webpack_require__(352);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b272cd0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorsesListing_vue__ = __webpack_require__(899);
function injectStyle (ssrContext) {
  __webpack_require__(896)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b272cd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorsesListing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b272cd0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorsesListing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 896 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminHorseReports_vue__ = __webpack_require__(353);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7541416e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminHorseReports_vue__ = __webpack_require__(898);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminHorseReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7541416e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminHorseReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.alertMessage)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.alertMessage))]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"align":"end"}},[_c('button',{staticClass:"btn btn-block-mob btn-primary ml-lg-auto mt-2",on:{"click":_vm.downloadPointsReport}},[(_vm.processing)?_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"spinner-border spinner-border-sm text-light mr-2",attrs:{"role":"status"}}),_vm._v("Review ROM and ACH Report\n      ")]):_vm._e(),_vm._v(" "),(!_vm.processing)?_c('span',[_vm._v("Review ROM and ACH Report")]):_vm._e()])]),_vm._v(" "),_c('div',{attrs:{"align":"end"}},[_c('button',{staticClass:"btn btn-block-mob btn-primary ml-lg-auto mt-2 mb-2",on:{"click":function($event){_vm.certModal = true}}},[(_vm.certProcessing)?_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"spinner-border spinner-border-sm text-light mr-2",attrs:{"role":"status"}}),_vm._v("\n        Issue Certificates\n      ")]):_vm._e(),_vm._v(" "),(!_vm.certProcessing)?_c('span',[_vm._v("Issue Certificates")]):_vm._e()])]),_vm._v(" "),(_vm.certModal)?_c('modal',{on:{"close":function($event){_vm.certModal = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n        You are about to issue ACH and ROM certificates for all horses who attained the necessary points.\n        Proceed with the certificates generation?\n      ")]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col"},[_c('label',{attrs:{"for":"secretaryName"}},[_vm._v("Secretary name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.secretaryName.$model),expression:"$v.secretaryName.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.secretaryName.$error },attrs:{"type":"text","id":"secretaryName","placeholder":"Secretary name"},domProps:{"value":(_vm.$v.secretaryName.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.secretaryName, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Secretary Name.")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.certModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary ml-2",on:{"click":function($event){$event.preventDefault();return _vm.downloadCertificates($event)}}},[_vm._v("Confirm")])])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('div',{staticClass:"d-flex flex-wrap justify-content-between align-items-center mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"h2 mb-0"},[_vm._v(_vm._s(_vm.config.title))]),_vm._v(" "),(_vm.config.addRoute)?_c('router-link',{staticClass:"btn btn-primary d-md-none px-xl-5 mt-2 mt-sm-0",attrs:{"to":{ name: _vm.config.addRoute }}},[_vm._v("Add"),_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v(" Horse")])]):_vm._e()],1),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.config.variant === 'admin')?_c('admin-horse-reports'):_vm._e(),_vm._v(" "),(_vm.alertMessage)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.alertMessage))]):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e(),_vm._v(" "),(_vm.config.variant === 'member' && _vm.hasUnregistered)?_c('div',{staticClass:"alert alert-info d-lg-flex justify-content-between align-items-center text-center text-lg-left",attrs:{"role":"alert"}},[_c('span',[_vm._v("You have unregistered horses.")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-block-mob btn-primary ml-lg-auto mt-2 mt-lg-0",attrs:{"to":{ name: 'Register Horse' }}},[_vm._v("Register Horses")])],1):_vm._e(),_vm._v(" "),(_vm.config.variant === 'member' && _vm.canPayRookie)?_c('div',{staticClass:"alert alert-info justify-content-between align-items-right text-center text-lg-right",attrs:{"role":"alert"}},[_c('router-link',{staticClass:"btn btn-block-mob btn-primary",attrs:{"to":{ name: 'Nominate Rookie' }}},[_vm._v("Pay Rookie Horse Nomination")])],1):_vm._e(),_vm._v(" "),_c('filter-bar',{attrs:{"active":_vm.hasActiveFilters},on:{"clear":_vm.clearAll}},[_c('filter-multiselect',{attrs:{"label":"Zone","option-label":"code","placeholder":"Any zone","value":_vm.filters.zone_id,"options":_vm.zoneOptions},on:{"input":function (ids) { return _vm.setFilter('zone_id', ids); },"clear":function($event){return _vm.clearFilter('zone_id')}}}),_vm._v(" "),_c('filter-multiselect',{attrs:{"label":"Status","placeholder":"Any status","value":_vm.filters.status_id,"options":_vm.statusOptions},on:{"input":function (ids) { return _vm.setFilter('status_id', ids); },"clear":function($event){return _vm.clearFilter('status_id')}}}),_vm._v(" "),_c('filter-multiselect',{attrs:{"label":"BoY Status","placeholder":"Any BoY status","value":_vm.filters.boy_status_id,"options":_vm.statusOptions},on:{"input":function (ids) { return _vm.setFilter('boy_status_id', ids); },"clear":function($event){return _vm.clearFilter('boy_status_id')}}})],1),_vm._v(" "),_c('div',{staticClass:"form-inline mb-sm-3 d-flex justify-content-between"},[_c('div',{staticClass:"d-flex col-12 col-md-auto px-0 mb-3 mb-md-0"},[_c('label',{staticClass:"sr-only",attrs:{"for":"horsesRegFilter"}},[_vm._v("Filter")]),_vm._v(" "),_c('div',{staticClass:"filter"},_vm._l((_vm.tabs),function(tab){return _c('div',{key:tab.value,staticClass:"form-check pl-0"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":"showRegistrationState","id":'showReg-' + tab.value},domProps:{"value":tab.value,"checked":_vm.filters.registration_state === tab.value},on:{"change":function($event){return _vm.onTabChange(tab.value)}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":'showReg-' + tab.value}},[_vm._v(_vm._s(tab.label))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-lg-auto mt-2 mt-lg-0 ml-auto px-0 d-flex align-items-center"},[_c('label',{staticClass:"d-none d-lg-inline mr-xl-2 mb-0 pr-2 font-weight-normal",attrs:{"for":"horsesSearch"}},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"input-append d-flex flex-grow-1 flex-md-grow-0 mr-md-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],staticClass:"form-control mb-0 flex-grow-1 flex-md-grow-0",attrs:{"id":"horsesSearch","type":"text"},domProps:{"value":(_vm.searchInput)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applySearch($event)},"search":_vm.applySearch,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('svg',{staticClass:"append",attrs:{"role":"button","aria-label":"Search","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14","width":"16","height":"16"},on:{"click":_vm.applySearch}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M5.5 11C2.5 11 0 8.5 0 5.5S2.5 0 5.5 0 11 2.5 11 5.5 8.5 11 5.5 11zm0-10C3 1 1 3 1 5.5S3 10 5.5 10 10 8 10 5.5 8 1 5.5 1z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#231815","d":"M9.5 8.8l4.4 4.4c.2.2.2.5 0 .7l-.4.1-.4-.1-4.4-4.4.8-.7z"}})])])]),_vm._v(" "),(_vm.config.addRoute)?_c('router-link',{staticClass:"btn btn-fz-sm btn-primary d-none d-md-block px-xl-5 mt-2 mt-sm-0 ml-md-0",attrs:{"to":{ name: _vm.config.addRoute }}},[_vm._v("Add"),_c('span',{staticClass:"d-inline"},[_vm._v(" Horse")])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"position-relative",staticStyle:{"min-height":"240px"}},[_c('responsive-table',{attrs:{"columns":_vm.columns,"rows":_vm.horses,"loading":_vm.loading,"breakpoints":_vm.breakpoints,"sort":_vm.filters.sort,"direction":_vm.filters.direction,"empty-text":"No horses found."},on:{"sort":_vm.setSort},scopedSlots:_vm._u([{key:"cell:name",fn:function(ref){
var row = ref.row;
return [_c('list-name-cell',{attrs:{"align":"right","label":row.name,"to":{ name: _vm.config.profileRoute, params: { slug: row.id } }},scopedSlots:_vm._u([{key:"badges",fn:function(){return [_c('span',{staticClass:"badge",class:row.active ? 'alert-success' : 'alert-warning'},[_vm._v(_vm._s(row.active ? 'Active' : 'Archived'))]),_vm._v(" "),_c('span',{staticClass:"badge",class:row.registrationDate ? 'alert-info' : 'alert-warning'},[_vm._v(_vm._s(row.registrationDate ? 'Registered' : 'Unregistered'))])]},proxy:true}],null,true)})]}},{key:"cell:owner_name",fn:function(ref){
var row = ref.row;
return [_c('span',[(_vm.config.variant !== 'member' && row.ownerId)?_c('router-link',{staticClass:"text-primary",attrs:{"to":{ name: 'Member Profile', params: { slug: row.ownerId } }}},[_vm._v(_vm._s(row.ownerName))]):[_vm._v(_vm._s(row.ownerName))],_vm._v(" "),(row.ownerDisplayName)?_c('span',{staticClass:"text-muted"},[_vm._v(" ("+_vm._s(row.ownerDisplayName)+")")]):_vm._e()],2)]}},{key:"cell:zone_id",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(_vm.zoneCode(row.zoneId)))]}},{key:"cell:beginning_of_year_status",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.beginningOfYearStatus))]}},{key:"cell:horse_status_id",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(_vm.statusName(row.horseStatusId)))]}},(_vm.config.variant === 'admin')?{key:"cell:remove",fn:function(ref){
var row = ref.row;
return [_c('button',{staticClass:"btn btn-sm btn-primary text-nowrap remove-btn",attrs:{"disabled":_vm.removingId === row.id},on:{"click":function($event){return _vm.askRemove(row)}}},[(_vm.removingId === row.id)?_c('span',{staticClass:"spinner-border spinner-border-sm text-light",attrs:{"role":"status"}}):_c('span',[_vm._v("Remove")])])]}}:null],null,true)})],1),_vm._v(" "),_c('div',{staticClass:"form-inline justify-content-between align-items-start mt-3"},[_c('div',{staticClass:"d-flex align-items-center justify-content-center justify-content-md-start form-group mb-3 mb-md-0 col-12 col-md-auto px-0"},[_c('label',{staticClass:"mr-2 mb-0 font-weight-normal",attrs:{"for":"horsesShow"}},[_vm._v("Show")]),_vm._v(" "),_c('select',{staticClass:"form-control mr-2",attrs:{"id":"horsesShow"},domProps:{"value":_vm.filters.per_page},on:{"change":function($event){_vm.setPerPage(Number($event.target.value))}}},_vm._l((_vm.perPageOptions),function(n){return _c('option',{key:n,domProps:{"value":n}},[_vm._v(_vm._s(n))])}),0),_vm._v(" "),_c('span',[_vm._v("Entries")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.totalPages > 1),expression:"totalPages > 1"}],staticClass:"pagination-container form-group align-items-start justify-content-center mb-3 mb-md-0"},[_c('pagination',{attrs:{"total-pages":_vm.totalPages,"page":_vm.page,"on-change":_vm.setPage,"disabled":_vm.loading}})],1)]),_vm._v(" "),(_vm.horseToRemove)?_c('modal',{on:{"close":function($event){_vm.horseToRemove = null}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning text-center"},[_vm._v("\n          You are about to remove the horse ‘"+_vm._s(_vm.horseToRemove.name)+"’. Are you sure?\n        ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){_vm.horseToRemove = null}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary ml-2",on:{"click":_vm.confirmRemove}},[_vm._v("Confirm")])])])]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseProfile_vue__ = __webpack_require__(354);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ebc1378_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseProfile_vue__ = __webpack_require__(909);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ebc1378_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Members_vue__ = __webpack_require__(355);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b02c406_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Members_vue__ = __webpack_require__(902);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Members_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b02c406_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Members_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col px-0 pr-lg-3"},[_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v("Members")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('filter-bar',{attrs:{"active":_vm.hasActiveFilters},on:{"clear":_vm.clearAll}},[_c('filter-multiselect',{attrs:{"label":"Zone","option-label":"code","placeholder":"Any zone","value":_vm.filters.zone_id,"options":_vm.zoneOptions},on:{"input":function (ids) { return _vm.setFilter('zone_id', ids); },"clear":function($event){return _vm.clearFilter('zone_id')}}}),_vm._v(" "),_c('filter-multiselect',{attrs:{"label":"Status","placeholder":"Any status","value":_vm.filters.status_id,"options":_vm.riderStatusOptions},on:{"input":function (ids) { return _vm.setFilter('status_id', ids); },"clear":function($event){return _vm.clearFilter('status_id')}}}),_vm._v(" "),_c('filter-multiselect',{attrs:{"label":"BoY Status","placeholder":"Any BoY status","value":_vm.filters.boy_status_id,"options":_vm.riderStatusOptions},on:{"input":function (ids) { return _vm.setFilter('boy_status_id', ids); },"clear":function($event){return _vm.clearFilter('boy_status_id')}}}),_vm._v(" "),_c('horse-member-relation-filter',{attrs:{"value":_vm.filters.relation},on:{"input":function (ids) { return _vm.setFilter('relation', ids); },"clear":function($event){return _vm.clearFilter('relation')}}})],1),_vm._v(" "),_c('div',{staticClass:"form-inline mb-sm-3 d-flex justify-content-end"},[_c('div',{staticClass:"form-group col-12 col-lg-auto mt-2 mt-lg-0 ml-auto px-0 d-flex align-items-center"},[_c('label',{staticClass:"d-none d-lg-inline mr-xl-2 mb-0 pr-2 font-weight-normal",attrs:{"for":"horseMembersSearch"}},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"input-append d-flex flex-grow-1 flex-md-grow-0 mr-md-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],staticClass:"form-control mb-0 flex-grow-1 flex-md-grow-0",attrs:{"id":"horseMembersSearch","type":"text"},domProps:{"value":(_vm.searchInput)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applySearch($event)},"search":_vm.applySearch,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('svg',{staticClass:"append",attrs:{"role":"button","aria-label":"Search","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14","width":"16","height":"16"},on:{"click":_vm.applySearch}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M5.5 11C2.5 11 0 8.5 0 5.5S2.5 0 5.5 0 11 2.5 11 5.5 8.5 11 5.5 11zm0-10C3 1 1 3 1 5.5S3 10 5.5 10 10 8 10 5.5 8 1 5.5 1z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#231815","d":"M9.5 8.8l4.4 4.4c.2.2.2.5 0 .7l-.4.1-.4-.1-4.4-4.4.8-.7z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"position-relative",staticStyle:{"min-height":"240px"}},[_c('responsive-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"loading":_vm.loading,"breakpoints":_vm.breakpoints,"sort":_vm.filters.sort,"direction":_vm.filters.direction,"empty-text":"No members found."},on:{"sort":_vm.setSort},scopedSlots:_vm._u([{key:"cell:first_name",fn:function(ref){
var row = ref.row;
return [_c('router-link',{attrs:{"to":{ name: 'Member Profile', params: { slug: row.id } }}},[_vm._v(_vm._s(row.first_name))])]}},{key:"cell:last_name",fn:function(ref){
var row = ref.row;
return [_c('list-name-cell',{attrs:{"align":"right","label":row.last_name,"to":{ name: 'Member Profile', params: { slug: row.id } }},scopedSlots:_vm._u([{key:"badges",fn:function(){return [(row.is_primary)?_c('span',{staticClass:"badge alert-prim"},[_vm._v("Primary")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"badge",class:_vm.statusBadgeClass(row)},[_vm._v(_vm._s(_vm.statusBadgeLabel(row)))]),_vm._v(" "),_c('horse-member-relation-badges',{attrs:{"is-owner":row.is_owner,"is-rider":row.is_rider}})]},proxy:true}],null,true)})]}},{key:"cell:name",fn:function(ref){
var row = ref.row;
return [_c('list-name-cell',{attrs:{"label":((row.first_name) + " " + (row.last_name)),"to":{ name: 'Member Profile', params: { slug: row.id } }},scopedSlots:_vm._u([{key:"badges",fn:function(){return [(row.is_primary)?_c('span',{staticClass:"badge alert-prim"},[_vm._v("Primary")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"badge",class:_vm.statusBadgeClass(row)},[_vm._v(_vm._s(_vm.statusBadgeLabel(row)))]),_vm._v(" "),_c('horse-member-relation-badges',{attrs:{"is-owner":row.is_owner,"is-rider":row.is_rider}})]},proxy:true}],null,true)})]}},{key:"cell:zone_id",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(_vm.zoneCode(row.zone_id)))]}},{key:"cell:beginning_of_year_status",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(row.beginning_of_year_status))]}}])})],1),_vm._v(" "),_c('div',{staticClass:"form-inline justify-content-between align-items-start mt-3"},[_c('div',{staticClass:"d-flex align-items-center justify-content-center justify-content-md-start form-group mb-3 mb-md-0 col-12 col-md-auto px-0"},[_c('label',{staticClass:"mr-2 mb-0 font-weight-normal",attrs:{"for":"horseMembersShow"}},[_vm._v("Show")]),_vm._v(" "),_c('select',{staticClass:"form-control mr-2",attrs:{"id":"horseMembersShow"},domProps:{"value":_vm.filters.per_page},on:{"change":function($event){_vm.setPerPage(Number($event.target.value))}}},_vm._l((_vm.perPageOptions),function(n){return _c('option',{key:n,domProps:{"value":n}},[_vm._v(_vm._s(n))])}),0),_vm._v(" "),_c('span',[_vm._v("Entries")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.totalPages > 1),expression:"totalPages > 1"}],staticClass:"pagination-container form-group align-items-start justify-content-center mb-3 mb-md-0"},[_c('pagination',{attrs:{"total-pages":_vm.totalPages,"page":_vm.page,"on-change":_vm.setPage,"disabled":_vm.loading}})],1)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-muted"},[_vm._v("\n    Members who own or ride this horse, or who are on the same account as someone who does.\n    "),_c('span',{staticClass:"badge alert-prim"},[_vm._v("Owner")]),_vm._v(" / "),_c('span',{staticClass:"badge alert-secondary"},[_vm._v("Rider")]),_vm._v("\n    mark a member's own direct link to the horse; "),_c('span',{staticClass:"badge alert-dark"},[_vm._v("Family")]),_vm._v("\n    means they can ride it only because a family member is its direct owner/rider.\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseProfileDetails_vue__ = __webpack_require__(356);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1279eec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseProfileDetails_vue__ = __webpack_require__(906);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseProfileDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1279eec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseProfileDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 904 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mss",on:{"focusin":_vm.onFocusIn,"focusout":_vm.onFocusOut}},[_c('multiselect',{ref:"ms",attrs:{"id":_vm.elementId,"value":null,"options":_vm.mergedOptions,"loading":_vm.loading,"internal-search":false,"searchable":_vm.active,"allow-empty":true,"disabled":_vm.disabled || _vm.atLimit,"placeholder":_vm.atLimit ? ("Maximum of " + _vm.limit + " reached") : _vm.placeholder,"track-by":"id","custom-label":_vm.labelFor,"select-label":"","selected-label":"","deselect-label":""},on:{"select":_vm.onSelect,"search-change":_vm.onSearch,"open":_vm.onOpen,"close":_vm.onClose}},[_c('template',{slot:"noResult"},[(!_vm.loading)?_c('span',[_vm._v("No members found.")]):_vm._e()]),_vm._v(" "),_c('template',{slot:"noOptions"},[_vm._v("Start typing to search...")]),_vm._v(" "),(_vm.loadingMore)?_c('li',{staticClass:"multiselect__element",attrs:{"slot":"afterList"},slot:"afterList"},[_c('span',{staticClass:"multiselect__option text-muted"},[_vm._v("Loading more...")])]):_vm._e()],2),_vm._v(" "),(_vm.selectedOptions.length)?_c('div',{staticClass:"tags-input mt-1 d-flex flex-wrap"},_vm._l((_vm.selectedOptions),function(o){return _c('span',{key:o.id,staticClass:"badge mr-1 mb-1"},[(!_vm.disabled)?_c('button',{staticClass:"tags-input-remove",attrs:{"type":"button","aria-label":"Remove"},on:{"mousedown":function($event){$event.preventDefault();},"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.remove(o.id)}}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"tags-input-label"},[_vm._v(_vm._s(_vm.labelFor(o)))])])}),0):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation ml-0",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.update($event)}}},[(_vm.horse ? _vm.horse.id ? true : false : false)?_c('div',{staticClass:"col px-0 pr-lg-3"},[_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('div',{staticClass:"d-flex justify-content-between align-items-start"},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v("Horse Profile")]),_vm._v(" "),(_vm.horse.registration_date)?_c('span',{staticClass:"badge badge-info"},[_vm._v("Registered")]):_c('span',{staticClass:"badge alert-warning"},[_vm._v("Unregistered")])]),_vm._v(" "),(_vm.errors)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors))]):_vm._e(),_vm._v(" "),(!_vm.horse.active)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("Please activate the horse to save horse data.")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[((_vm.user === 'Admin' || _vm.user === 'SuperAdmin'))?_c('div',{staticClass:"col-12 form-group"},[_c('label',{attrs:{"for":"notes"}},[_vm._v("Notes")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.horse.notes),expression:"horse.notes"}],staticClass:"form-control",attrs:{"id":"notes","disabled":!_vm.is_owner && !_vm.userIsSecretary},domProps:{"value":(_vm.horse.notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horse, "notes", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"role":"presentation"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horse.active),expression:"horse.active"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"active"},domProps:{"checked":Array.isArray(_vm.horse.active)?_vm._i(_vm.horse.active,null)>-1:(_vm.horse.active)},on:{"change":function($event){var $$a=_vm.horse.active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.horse, "active", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.horse, "active", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.horse, "active", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"active"}},[_vm._v("Active")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group mb-md-1"},[_c('label',{attrs:{"for":"horseMember"}},[_vm._v("Rider/s")]),_vm._v(" "),_c('div',{class:['align-items-start', {'click-events-none not-required': !_vm.horse.active || (!_vm.is_owner && !_vm.userIsSecretary)}]},[_c('member-search-select',{attrs:{"element-id":"horseMember","context":"owner","multiple":"","limit":10,"value":_vm.selectedMembers,"initial-options":_vm.memberInitialOptions},on:{"input":function (v) { _vm.selectedMembers = v }}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip",style:(_vm.isUserInvalid ? 'display: block': '')},[_vm._v("Please include the Rider/s associated with the horse.")])],1),_vm._v(" "),_c('small',[_vm._v("Add here all of the members that need to nominate on this horse.")]),_vm._v(" "),(_vm.horse.user && _vm.horse.user.deleted_at && _vm.horse.user.id === Number(_vm.horse.user_id[0]))?_c('small',{staticClass:"text-danger"},[_vm._v("Deleted")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"horseName"}},[_vm._v("Horse Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horse.name),expression:"horse.name"}],staticClass:"form-control",attrs:{"type":"text","id":"horseName","required":"","disabled":!_vm.horse.active || (!_vm.is_owner && !_vm.userIsSecretary)},domProps:{"value":(_vm.horse.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horse, "name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Horse Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"horseOwner"}},[_vm._v("Owner")]),_vm._v(" "),_c('div',{class:['align-items-start', { 'click-events-none not-required' : (!_vm.horse.active || !(_vm.user === 'Admin' || _vm.user === 'SuperAdmin')) }]},[_c('member-search-select',{attrs:{"element-id":"horseOwner","context":"owner","value":_vm.selectedOwners,"initial-options":_vm.ownerInitialOptions},on:{"input":function (v) { _vm.selectedOwners = v }}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip",style:(_vm.isInvalid ? 'display: block': '')},[_vm._v("Please include the Owner of the horse.")])],1),_vm._v(" "),_c('small',[_vm._v("This must be an ACA member")]),_vm._v(" "),(_vm.horseOwnerData.deleted_at && _vm.horseOwnerData.id === Number(_vm.horse.owners[0]))?_c('small',{staticClass:"text-danger"},[_vm._v("Deleted")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-6 form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"horseDob"}},[_vm._v("Date of Birth")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horse.dob),expression:"horse.dob"}],class:['form-control form-date pr-xl-3', _vm.errorStatus === 'dob' ? 'is-invalid' : ''],attrs:{"type":"date","disabled":!_vm.horse.active || (!_vm.is_owner && !_vm.userIsSecretary),"id":"horseDob","placeholder":[_vm.isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy'],"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}"},domProps:{"value":(_vm.horse.dob)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horse, "dob", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Date of Birth of the horse"+_vm._s(_vm.isLegacy() ? ' in the format yyyy-mm-dd' : '')+".")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group pl-xl-0"},[_c('label',[_vm._v("Sex")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.horse.gender),expression:"horse.gender"}],staticClass:"form-control",attrs:{"required":"","name":"horseSex","disabled":!_vm.horse.active || (!_vm.is_owner && !_vm.userIsSecretary)},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.horse, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"default":""}}),_vm._v(" "),_c('option',{attrs:{"value":"Mare"}},[_vm._v("Mare")]),_vm._v(" "),_c('option',{attrs:{"value":"Gelding"}},[_vm._v("Gelding")]),_vm._v(" "),_c('option',{attrs:{"value":"Stallion"}},[_vm._v("Stallion")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Sex of the horse.")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-3 form-group"},[_c('label',{attrs:{"for":"status"}},[_vm._v("Horse Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.horse.horse_status_id),expression:"horse.horse_status_id"}],staticClass:"form-control",attrs:{"id":"status","required":(_vm.user === 'Admin' || _vm.user === 'SuperAdmin'),"disabled":!_vm.horse.active || _vm.userIsNotAdmin},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.horse, "horse_status_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.$store.state.horseStatus),function(status,index){return _c('option',{key:index,domProps:{"value":status.id}},[_vm._v(_vm._s(status.name))])}),0),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Status.")]),_vm._v(" "),(_vm.userIsNotAdmin)?_c('small',[_vm._v("If you need to update your horses status please contact the ACA office in business hours")]):_vm._e()]),_vm._v(" "),(_vm.horse.boy_status_id)?_c('div',{staticClass:"col-12 col-md-6 mb-3 form-group"},[_c('label',{attrs:{"for":"boyStatus"}},[_vm._v("Beginning of Year Horse Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.horse.boy_status_id),expression:"horse.boy_status_id"}],staticClass:"form-control",attrs:{"id":"boyStatus","required":"","disabled":!_vm.horse.active || _vm.userIsNotAdmin},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.horse, "boy_status_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"selected":!_vm.horse.boy_status_id}}),_vm._v(" "),_vm._l((_vm.$store.state.horseStatus),function(status,statusIndex){return _c('option',{key:statusIndex,domProps:{"value":status.id,"selected":_vm.horse.boy_status_id === status.id}},[_vm._v(_vm._s(status.name))])})],2),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Rider Status.")]),_vm._v(" "),(_vm.userIsNotAdmin)?_c('small',[_vm._v("If you need to update your horses status please contact the ACA office in business hours")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(0),_vm._v(" "),_c('div',{class:['not-required', { 'click-events-none' : (!_vm.horse.active || (!_vm.userIsSecretary)) }]},[_c('horse-search-select',{attrs:{"element-id":"horseSire","disabled":!_vm.horse.active || !_vm.userIsSecretary},model:{value:(_vm.selectedSire),callback:function ($$v) {_vm.selectedSire=$$v},expression:"selectedSire"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(1),_vm._v(" "),_c('div',{class:['not-required', { 'click-events-none' : (!_vm.horse.active || (!_vm.is_owner && !_vm.userIsSecretary)) }]},[_c('horse-search-select',{attrs:{"element-id":"horseDam","disabled":!_vm.horse.active || (!_vm.is_owner && !_vm.userIsSecretary)},model:{value:(_vm.selectedDam),callback:function ($$v) {_vm.selectedDam=$$v},expression:"selectedDam"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horse.ashs_number),expression:"horse.ashs_number"}],class:['form-control', _vm.errorStatus === 'ashs' ? 'is-invalid' : ''],attrs:{"type":"text","id":"ashs","maxlength":"15","disabled":!_vm.horse.active || (!_vm.is_owner && !_vm.userIsSecretary)},domProps:{"value":(_vm.horse.ashs_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horse, "ashs_number", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include a different ASHS#. This one is taken.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horse.aqhs_number),expression:"horse.aqhs_number"}],class:['form-control', _vm.errorStatus === 'aqhs' ? 'is-invalid' : ''],attrs:{"type":"text","id":"aqhs","maxlength":"15","disabled":!_vm.horse.active || (!_vm.is_owner && !_vm.userIsSecretary)},domProps:{"value":(_vm.horse.aqhs_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horse, "aqhs_number", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include a different AQHA#. This one is taken.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(4),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horse.owner_display_name),expression:"horse.owner_display_name"}],staticClass:"form-control",attrs:{"type":"text","id":"ownerDisplayName","disabled":!_vm.horse.active || (!_vm.is_owner && !_vm.userIsSecretary)},domProps:{"value":(_vm.horse.owner_display_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horse, "owner_display_name", $event.target.value)}}}),_vm._v(" "),_c('small',[_vm._v("This is how the horse owner will be displayed on the draws and the leaderboard")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"proofOfAge"}},[_vm._v("Proof of Age")]),_vm._v(" "),_c('div',{staticClass:"custom-file"},[_c('input',{class:['custom-file-input font-weight-normal', { 'is-invalid': _vm.errorStatus === 'file' }],attrs:{"type":"file","id":"proofOfAge","accept":"image/*, application/pdf","disabled":(!_vm.is_owner && !_vm.userIsSecretary) || !_vm.horse.active},on:{"change":_vm.fileUpload}}),_vm._v(" "),_c('label',{class:[{ 'no-after': (!_vm.is_owner && !_vm.userIsSecretary) || !_vm.horse.active}, 'custom-file-label font-weight-normal'],attrs:{"for":"proofOfAge"}},[_vm._v(_vm._s(_vm.file_name ? _vm.file_name : 'Choose file...'))]),_vm._v(" "),_c('small',[_vm._v("jpg, jpeg, png, tiff, gif, pdf file type required.")]),_vm._v(" "),(_vm.file_name)?_c('button',{staticClass:"btn btn-link px-2 pl-md-0 px-xl-2 pr-md-1",attrs:{"type":"button","disabled":(!_vm.is_owner && !_vm.userIsSecretary) || !_vm.horse.active},on:{"click":_vm.deleteAttachment}},[_c('span',{staticClass:"sr-only"},[_vm._v("Delete File")]),_vm._v(" "),_c('div',{staticClass:"btn-remove"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"}})])])])]):_vm._e()]),_vm._v(" "),(this.file_path)?_c('div',{staticClass:"attached-file-wrapper"},[_vm._v("\n            "+_vm._s(this.exists_file_name)+"\n            "),((_vm.is_owner || _vm.userIsSecretary) && _vm.horse.active)?_c('div',{staticClass:"btn-remove-file",on:{"click":_vm.deleteExistsAttachment}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btn-download-file",on:{"click":function($event){return _vm.downloadAgeProofFile(_vm.horse.id)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"}})])])])]):_vm._e()]),_vm._v(" "),((_vm.user === 'Admin' || _vm.user === 'SuperAdmin'))?_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"horseAchPoints"}},[_vm._v("Historic ACH points:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horse.historic_point_ach),expression:"horse.historic_point_ach"}],class:['form-control'],attrs:{"type":"text","id":"horseAchPoints","min":"0.00","max":"1000.00"},domProps:{"value":(_vm.horse.historic_point_ach)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.horse, "historic_point_ach", $event.target.value)},_vm.actionPointAch]}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"horseRomPoints"}},[_vm._v("Historic ROM points:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horse.historic_point_rom),expression:"horse.historic_point_rom"}],class:['form-control'],attrs:{"type":"text","id":"horseRomPoints","min":"0.00","max":"1000.00"},domProps:{"value":(_vm.horse.historic_point_rom)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.horse, "historic_point_rom", $event.target.value)},_vm.actionPointRom]}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"horseAchPoints"}},[_vm._v("Total ACH points:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalAch),expression:"totalAch"}],class:['form-control'],attrs:{"type":"text","id":"horseAchPoints","disabled":1},domProps:{"value":(_vm.totalAch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.totalAch=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"horseRomPoints"}},[_vm._v("Total ROM points:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalRom),expression:"totalRom"}],class:['form-control'],attrs:{"type":"text","id":"horseRomPoints","disabled":1},domProps:{"value":(_vm.totalRom)},on:{"input":function($event){if($event.target.composing){ return; }_vm.totalRom=$event.target.value}}})])])]):_vm._e(),_vm._v(" "),((_vm.user === 'Admin' || _vm.user === 'SuperAdmin'))?_c('div',{staticClass:"col-12 form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horse.registered),expression:"horse.registered"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"horseRegistered","disabled":!_vm.horse.active},domProps:{"checked":Array.isArray(_vm.horse.registered)?_vm._i(_vm.horse.registered,null)>-1:(_vm.horse.registered)},on:{"change":[function($event){var $$a=_vm.horse.registered,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.horse, "registered", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.horse, "registered", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.horse, "registered", $$c)}},function($event){return _vm.toggleRegisteredDate()}]}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"horseRegistered"}},[_vm._v("Registered")])])]),_vm._v(" "),(_vm.horse.registered)?_c('div',{staticClass:"col-12 col-md-6"},[_c('label',{attrs:{"for":"horseRegisteredDate"}},[_vm._v("Registered Date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horse.registration_date),expression:"horse.registration_date"}],class:['form-control form-date', _vm.errorStatus === 'registration_date' && _vm.errors ? 'is-invalid' : ''],attrs:{"type":"date","id":"horseRegisteredDate","required":"","disabled":!_vm.horse.active,"placeholder":[_vm.isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy'],"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}"},domProps:{"value":(_vm.horse.registration_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horse, "registration_date", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Registered Date of the horse"+_vm._s(_vm.isLegacy() ? ' in the format yyyy-mm-dd' : '')+".")])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.user != 'Admin' && _vm.user != 'SuperAdmin' && _vm.isMember)?_c('div',{staticClass:"col-12 form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('button',{staticClass:"btn btn-primary mb-3",attrs:{"type":"button"},on:{"click":function($event){return _vm.unlinkMemberHorse(_vm.horse.id)}}},[_vm._v("Unlink")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 d-flex d-lg-none justify-content-end"},[_c('div',{staticClass:"w-100"},[(_vm.user === 'Admin' || _vm.user === 'SuperAdmin')?_c('router-link',{staticClass:"btn btn-outline-primary btn-block mb-2",attrs:{"to":{ name: 'Merge Horse', params: { slug: _vm.horse.id } }}},[_vm._v("Merge Horse")]):_vm._e(),_vm._v(" "),_c('button',{class:['btn btn-block-mob', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],on:{"click":_vm.handleSubmit}},[_vm._v("\n            "+_vm._s(!_vm.processing ? 'Update' : '')+"\n            "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])],1)])]),_vm._v(" "),(_vm.showModal)?_c('modal',{on:{"close":function($event){$event.preventDefault();_vm.showModal = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n            Changes to your registered horse must first be approved. Send to admin for approval?\n          ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.showModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary ml-2",on:{"click":function($event){$event.preventDefault();_vm.updateHorse();_vm.showModal = false}}},[_vm._v("Confirm")])])])]):_vm._e()],1)]):_c('div',{staticClass:"col px-0 pr-lg-3"},[_vm._m(5)]),_vm._v(" "),(_vm.is_owner || _vm.userIsSecretary)?_c('desktop-action-bar',[_c('button',{class:['btn btn-block', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],on:{"click":_vm.handleSubmit}},[_vm._v("\n      "+_vm._s(!_vm.processing ? 'Update' : '')+"\n      "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]),_vm._v(" "),(_vm.user === 'Admin' || _vm.user === 'SuperAdmin')?_c('router-link',{staticClass:"btn btn-outline-primary btn-block mt-2",attrs:{"to":{ name: 'Merge Horse', params: { slug: _vm.horse.id } }}},[_vm._v("Merge Horse")]):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"horseSire"}},[_vm._v("Sire "),_c('small',[_vm._v("(optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"horseDam"}},[_vm._v("Dam "),_c('small',[_vm._v("(optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"ashs"}},[_c('abbr',{attrs:{"title":"Australian Stock Horse Number"}},[_vm._v("ASHS#")]),_vm._v(" "),_c('small',[_vm._v("(optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"aqhs"}},[_c('abbr',{attrs:{"title":"Australian Quarter Horse Number"}},[_vm._v("AQHA#")]),_vm._v(" "),_c('small',[_vm._v("(optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"ownerDisplayName"}},[_vm._v("Horse Owner Display Name "),_c('small',[_vm._v("(optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseProfileBoyHistory_vue__ = __webpack_require__(358);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e8173d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseProfileBoyHistory_vue__ = __webpack_require__(908);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseProfileBoyHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e8173d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseProfileBoyHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"needs-validation ml-0"},[(_vm.horseId)?_c('div',{staticClass:"col px-0 pr-lg-3"},[_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('boy-status-history-table',{attrs:{"entity-id":_vm.horseId,"type":"horse"}})],1)]):_c('section',{staticClass:"col px-0 pr-lg-3"},[_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',[_vm._l((_vm.visibleTabs),function(t){return _c('li',{key:t.key,staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === t.key ? 'active' : ''],attrs:{"href":"","id":((t.key) + "-tab"),"data-toggle":"tab","role":"tab","aria-controls":t.key,"aria-selected":_vm.selectedTab === t.key ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();return _vm.selectTab(t.key)}}},[_vm._v(_vm._s(t.label))])])}),_vm._v(" "),(_vm.currentTab)?_c(_vm.currentTab.component,{tag:"component",staticClass:"tab-pane row mx-0 show active",attrs:{"slot":"tabContent","id":_vm.currentTab.key,"role":"tabpanel","aria-labelledby":((_vm.currentTab.key) + "-tab")},slot:"tabContent"}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseAdd_vue__ = __webpack_require__(359);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06c1a569_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseAdd_vue__ = __webpack_require__(913);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06c1a569_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseAddDetails_vue__ = __webpack_require__(360);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8838baf8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseAddDetails_vue__ = __webpack_require__(912);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseAddDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8838baf8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseAddDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation ml-0",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.completeForm($event)}}},[_c('div',{staticClass:"col px-0 pr-lg-3"},_vm._l((_vm.horsePages),function(memberDetail,index){return _c('section',{key:index,staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[(index === 0)?_c('div',{staticClass:"d-flex justify-content-between align-items-start"},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v("\n          "+_vm._s(_vm.edit ? 'Edit' : _vm.register ? 'Register' : 'Add')+" Horse"),_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v("s")])]),_vm._v(" "),_c('button',{staticClass:"btn btn btn-primary d-inline-block d-lg-none",on:{"click":function($event){$event.preventDefault();return _vm.addAnotherHorse()}}},[_vm._v("\n          Add"),_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v(" Another")])])]):_vm._e(),_vm._v(" "),(_vm.errors[index])?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors[index]))]):_vm._e(),_vm._v(" "),(_vm.commonError)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.commonError))]):_vm._e(),_vm._v(" "),((_vm.userRole !== 'Admin' && _vm.userRole !== 'SuperAdmin') && _vm.userRole !== 'SecretaryOnly')?_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"horseName"}},[_vm._v("Horse Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horseNames[index]),expression:"horseNames[index]"}],staticClass:"form-control",attrs:{"type":"text","id":"horseName","maxlength":"40","required":""},domProps:{"value":(_vm.horseNames[index])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.horseNames, index, $event.target.value)},function($event){return _vm.setHorseName(index)}]}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include horse Name.")])]),_vm._v(" "),_c('VueSlideToggle',{staticClass:"col-12 px-lg-3",attrs:{"open":_vm.nameMatches[index],"tag":"div","duration":500}},[(_vm.matchingNames[index] && (_vm.matchingNames[index].length || Object.keys(_vm.matchingNames[index]).length))?_c('div',[_c('p',[_vm._v("\n              Horses similar to this one already exist in the system. Please, note that you do not need to add a new\n              horse in case you see it on the list. Link the horse to your account in order to nominate with it.\n            ")]),_vm._v(" "),_c('table',{staticClass:"table table-striped"},[_c('thead',[_c('tr',[_c('td',[_vm._v("Horse name")]),_vm._v(" "),_c('td',[_vm._v("Owner Name")]),_vm._v(" "),_c('td',[_vm._v("Owner's Member Number")]),_vm._v(" "),_c('td',[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.matchingNames[index]),function(horse){return _c('tr',{key:horse.id,staticClass:"clickable-row"},[_c('td',[_vm._v(_vm._s(horse.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(horse.owner_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(horse.member_number))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary mb-3",attrs:{"type":"button","disabled":_vm.linked(horse.id)},on:{"click":function($event){return _vm.linkMemberHorse(horse.id)}}},[_vm._v("Link")])])])}),0)]),_vm._v(" "),(_vm.userRole !== 'Volunteer')?_c('button',{staticClass:"btn btn-primary mb-3",attrs:{"type":"button"},on:{"click":function($event){return _vm.newHorseToggle(index)}}},[_vm._v("I didn't find the right match, I want to create a horse myself")]):_vm._e()]):(_vm.horseNames[index] && _vm.userRole !== 'Volunteer')?_c('div',[_c('button',{staticClass:"btn btn-primary mb-3",attrs:{"type":"button"},on:{"click":function($event){return _vm.newHorseToggle(index)}}},[_vm._v("I want to add my own horse")])]):_vm._e()])],1):_vm._e(),_vm._v(" "),(_vm.newMemberHorse || _vm.userIsSecretary)?_c('div',{staticClass:"row align-items-start"},[((_vm.userRole === 'Admin' || _vm.userRole === 'SuperAdmin'))?_c('div',{staticClass:"col-12 form-group"},[_c('label',{attrs:{"for":"notes"}},[_vm._v("Notes")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.horseDetails[index].notes),expression:"horseDetails[index].notes"}],staticClass:"form-control",attrs:{"id":"notes"},domProps:{"value":(_vm.horseDetails[index].notes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horseDetails[index], "notes", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group row no-gutters"},[_c('label',{attrs:{"for":'horseName' + index}},[_vm._v("Horse Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horseDetails[index].name),expression:"horseDetails[index].name"}],staticClass:"form-control",attrs:{"type":"text","id":'horseName' + index,"required":""},domProps:{"value":(_vm.horseDetails[index].name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horseDetails[index], "name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Horse Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group mb-md-1"},[_c('label',{attrs:{"for":'horseOwner' + index}},[_vm._v("Owner")]),_vm._v(" "),_c('div',{staticClass:"not-required"},[_c('member-search-select',{attrs:{"element-id":'horseOwner' + index,"context":"owner","value":_vm.horseDetails[index].owners || []},on:{"input":function (v) { return _vm.setHorseOwners(index, v); }}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip",style:(_vm.isOwnerInvalid(index) ? 'display: block': '')},[_vm._v("Please include the Owner of the horse.")])],1),_vm._v(" "),_c('small',[_vm._v("Maximum of one owner. This must be an ACA member")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":'horseDob' + index}},[_vm._v("Date of Birth")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horseDetails[index].dob),expression:"horseDetails[index].dob"}],class:['form-control form-date', _vm.errorStatus === 'dob' && _vm.errors[index] ? 'is-invalid' : ''],attrs:{"type":"date","id":'horseDob' + index,"placeholder":[_vm.isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy'],"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}"},domProps:{"value":(_vm.horseDetails[index].dob)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horseDetails[index], "dob", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Date of Birth of the horse"+_vm._s(_vm.isLegacy() ? ' in the format yyyy-mm-dd' : '')+".")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"horseSex"}},[_vm._v("Sex")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.horseDetails[index].gender),expression:"horseDetails[index].gender"}],staticClass:"form-control",attrs:{"required":"","name":"horseSex","id":"horseSex"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.horseDetails[index], "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"default":""}}),_vm._v(" "),_c('option',{attrs:{"value":"Mare"}},[_vm._v("Mare")]),_vm._v(" "),_c('option',{attrs:{"value":"Gelding"}},[_vm._v("Gelding")]),_vm._v(" "),_c('option',{attrs:{"value":"Stallion"}},[_vm._v("Stallion")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"not-required"},[_c('horse-search-select',{attrs:{"element-id":'horseSire' + index,"value":_vm.horseDetails[index].sire_id || []},on:{"input":function (v) { return _vm.setHorseParent(index, 'sire_id', v); }}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"not-required"},[_c('horse-search-select',{attrs:{"element-id":'horseDam' + index,"value":_vm.horseDetails[index].dam_id || []},on:{"input":function (v) { return _vm.setHorseParent(index, 'dam_id', v); }}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(2,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horseDetails[index].ashs_number),expression:"horseDetails[index].ashs_number"}],class:['form-control', _vm.errorStatus === 'ashs' && _vm.errors[index] ? 'is-invalid' : ''],attrs:{"type":"text","id":"ashs","maxlength":"15"},domProps:{"value":(_vm.horseDetails[index].ashs_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horseDetails[index], "ashs_number", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include a different ASHS#. This one is taken.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(3,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horseDetails[index].aqhs_number),expression:"horseDetails[index].aqhs_number"}],class:['form-control', _vm.errorStatus === 'aqhs' && _vm.errors[index] ? 'is-invalid' : ''],attrs:{"type":"text","id":"aqhs","maxlength":"15"},domProps:{"value":(_vm.horseDetails[index].aqhs_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horseDetails[index], "aqhs_number", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include a different AQHA#. This one is taken.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":'ownerDisplayName' + index}},[_vm._v("Horse Owner Display Name "),_c('small',[_vm._v("(optional)")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horseDetails[index].owner_display_name),expression:"horseDetails[index].owner_display_name"}],staticClass:"form-control",attrs:{"type":"text","id":'ownerDisplayName' + index},domProps:{"value":(_vm.horseDetails[index].owner_display_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horseDetails[index], "owner_display_name", $event.target.value)}}}),_vm._v(" "),_c('small',[_vm._v("This is how the horse owner will be displayed on the draws and the leaderboard")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group mb-md-1"},[_c('label',{attrs:{"for":'horseMember' + index}},[_vm._v("Rider/s")]),_vm._v(" "),_c('member-search-select',{attrs:{"element-id":'horseMember' + index,"context":"owner","multiple":"","limit":10,"value":_vm.horseDetails[index].user_id || []},on:{"input":function (v) { return _vm.setHorseMembers(index, v); }}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip",style:(_vm.isMemberInvalid(index) ? 'display: block': '')},[_vm._v("Please include the Rider/s.")])],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-3 form-group"},[_c('label',{attrs:{"for":"status"}},[_vm._v("Horse Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.horseDetails[index].horse_status_id),expression:"horseDetails[index].horse_status_id"}],staticClass:"form-control",attrs:{"id":"status","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.horseDetails[index], "horse_status_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.$store.state.horseStatus),function(status,index){return _c('option',{key:index,domProps:{"value":status.id}},[_vm._v(_vm._s(status.name))])}),0),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Status.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":'horseBoyStatus' + index}},[_vm._v("Beginning of Year Horse Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.horseDetails[index].boy_status_id),expression:"horseDetails[index].boy_status_id"}],staticClass:"form-control",attrs:{"id":"horseBoyStatus","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.horseDetails[index], "boy_status_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.$store.state.horseStatus),function(status,index){return _c('option',{key:index,domProps:{"value":status.id}},[_vm._v(_vm._s(status.name))])}),0),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Beginning of Year Status.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"proofOfAge"}},[_vm._v("Proof of Age")]),_vm._v(" "),_c('div',{staticClass:"custom-file"},[_c('input',{class:['custom-file-input font-weight-normal', { 'is-invalid': _vm.errorStatus === 'file' }],attrs:{"type":"file","id":"proofOfAge","accept":"image/*, application/pdf"},on:{"change":function($event){return _vm.fileUpload($event, index)}}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label font-weight-normal",attrs:{"for":"proofOfAge"}},[_vm._v(_vm._s(_vm.horseDetails[index].file_name ? _vm.horseDetails[index].file_name : 'Choose file...'))]),_vm._v(" "),_c('small',[_vm._v("jpg, jpeg, png, tiff, gif, pdf file type required.")]),_vm._v(" "),(_vm.horseDetails[index].file_name)?_c('button',{staticClass:"btn btn-link px-2 pl-md-0 px-xl-2 pr-md-1",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteAttachment(index)}}},[_c('span',{staticClass:"sr-only"},[_vm._v("Delete File")]),_vm._v(" "),_c('div',{staticClass:"btn-remove"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"}}),_c('path',{attrs:{"d":"M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"}}),_c('path',{attrs:{"d":"M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"}})])])])]):_vm._e()])]),_vm._v(" "),((_vm.userRole === 'Admin' || _vm.userRole === 'SuperAdmin'))?_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"horseAchPoints"}},[_vm._v("Historic ACH points:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horseDetails[index].historic_point_ach),expression:"horseDetails[index].historic_point_ach"}],class:['form-control'],attrs:{"type":"text","id":"horseAchPoints","min":"0.00","max":"1000.00"},domProps:{"value":(_vm.horseDetails[index].historic_point_ach)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.horseDetails[index], "historic_point_ach", $event.target.value)},function($event){return _vm.validatePointAch($event, index)}]}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"horseRomPoints"}},[_vm._v("Historic ROM points:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horseDetails[index].historic_point_rom),expression:"horseDetails[index].historic_point_rom"}],class:['form-control'],attrs:{"type":"text","id":"horseRomPoints","min":"0.00","max":"1000.00"},domProps:{"value":(_vm.horseDetails[index].historic_point_rom)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.horseDetails[index], "historic_point_rom", $event.target.value)},function($event){return _vm.validatePointRom($event, index)}]}})])])]):_vm._e()]):_vm._e(),_vm._v(" "),((_vm.userRole === 'Admin' || _vm.userRole === 'SuperAdmin'))?_c('div',{staticClass:"row align-items-start"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horseDetails[index].registered),expression:"horseDetails[index].registered"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":'horseRegistered' + index},domProps:{"checked":Array.isArray(_vm.horseDetails[index].registered)?_vm._i(_vm.horseDetails[index].registered,null)>-1:(_vm.horseDetails[index].registered)},on:{"change":[function($event){var $$a=_vm.horseDetails[index].registered,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.horseDetails[index], "registered", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.horseDetails[index], "registered", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.horseDetails[index], "registered", $$c)}},function($event){return _vm.toggleRegisteredDate(index)}]}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":'horseRegistered' + index}},[_vm._v("Registered")])])]),_vm._v(" "),(_vm.horseDetails[index].registered)?_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":'horseRegisteredDate' + index}},[_vm._v("Registered Date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horseDetails[index].registration_date),expression:"horseDetails[index].registration_date"}],class:['form-control form-date', _vm.errorStatus === 'registration_date' && _vm.errors[index] ? 'is-invalid' : ''],attrs:{"type":"date","id":'horseRegisteredDate' + index,"required":"","placeholder":[_vm.isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy'],"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}"},domProps:{"value":(_vm.horseDetails[index].registration_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horseDetails[index], "registration_date", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Registered Date of the horse"+_vm._s(_vm.isLegacy() ? ' in the format yyyy-mm-dd' : '')+".")])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 d-flex justify-content-end"},[(_vm.horsePages > 1)?_c('button',{staticClass:"btn btn-block-mob btn-outline-primary px-lg-5",on:{"click":function($event){$event.preventDefault();_vm.horseDetails.splice(index,1);_vm.horsePages--}}},[_vm._v("Remove")]):_vm._e()])])}),0),_vm._v(" "),(_vm.userRole !== 'Volunteer')?_c('desktop-action-bar',[(!_vm.register)?_c('button',{staticClass:"btn btn-block btn-primary px-4 mb-4",on:{"click":function($event){$event.preventDefault();return _vm.addAnotherHorse()}}},[_vm._v("\n      Add Another\n    ")]):_vm._e(),_vm._v(" "),_c('div',[_c('h2',{staticClass:"h4 mb-4"},[_vm._v(_vm._s(_vm.register ? 'Cart' : 'My Horses'))]),_vm._v(" "),_c('h3',{staticClass:"h6 mb-4"},[_vm._v("Horses "+_vm._s(_vm.register ? 'ready for registration' : 'being added to list')+":")]),_vm._v(" "),_c('table',{staticClass:"table table-borderless"},[_c('tbody',_vm._l((_vm.horseDetails),function(horse,horseIndex){return _c('tr',{key:horseIndex},[_c('td',{staticClass:"pl-0 pt-0"},[_vm._v(_vm._s(horse.name))])])}),0)]),_vm._v(" "),_c('button',{class:['btn btn-block btn-primary', _vm.register ? 'mb-2' : ''],attrs:{"type":"submit"},on:{"click":_vm.handleSubmit}},[_vm._v(_vm._s(_vm.register ? 'Check Out' : 'Add horse'))]),_vm._v(" "),(_vm.register)?_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 62.4 39.6","width":"25","height":"16","aria-labelledby":"mastercard"}},[_c('title',{attrs:{"id":"mastercard"}},[_vm._v("Mastercard")]),_c('circle',{attrs:{"cx":"19.5","cy":"19.7","r":"19","fill":"#ee0005"}}),_c('circle',{attrs:{"cx":"43","cy":"19.7","r":"19","fill":"#f9a000"}}),_c('path',{attrs:{"fill":"#ff6300","d":"M24.1 19.7a19 19 0 0 0 7.2 14.9c4.4-3.5 7.2-8.8 7.2-14.9S35.6 8.3 31.3 4.8a19 19 0 0 0-7.2 14.9z"}})]),_vm._v(" "),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 505 153","width":"35","height":"11","aria-labelledby":"visa"}},[_c('title',{attrs:{"id":"visa"}},[_vm._v("Visa")]),_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('path',{attrs:{"fill":"#3c58bf","d":"M185.3 149L210.9 5h40l-24.8 144z"}}),_c('path',{attrs:{"fill":"#293688","d":"M185.3 149L218.1 5h32.8l-24.8 144z"}}),_c('path',{attrs:{"fill":"#3c58bf","d":"M371 6.6C363 3.4 350 .2 334 .2c-40 0-68.8 20-68.8 48.8 0 21.6 20 32.8 36 40s20.8 12 20.8 18.4c0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 42.4 0 70.4-20 70.4-50.4 0-16.8-10.4-29.6-34.4-40-14.4-7.2-23.2-11.2-23.2-18.4 0-6.4 7.2-12.8 23.2-12.8 13.6 0 23.2 2.4 30.4 5.6l4 1.6L371 6.6z"}}),_c('path',{attrs:{"fill":"#293688","d":"M371 6.6C363 3.4 350 .2 334 .2c-40 0-61.6 20-61.6 48.8 0 21.6 12.8 32.8 28.8 40s20.8 12 20.8 18.4c0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 42.4 0 70.4-20 70.4-50.4 0-16.8-10.4-29.6-34.4-40-14.4-7.2-23.2-11.2-23.2-18.4 0-6.4 7.2-12.8 23.2-12.8 13.6 0 23.2 2.4 30.4 5.6l4 1.6L371 6.6z"}}),_c('path',{attrs:{"fill":"#3c58bf","d":"M439.7 5c-9.6 0-16.8.8-20.8 10.4L359 149h43.2l8-24h51.2l4.8 24h38.4L471 5h-31.2zm-18.4 96c2.4-7.2 16-42.4 16-42.4s3.2-8.8 5.6-14.4l2.4 13.6s8 36 9.6 44h-33.6v-.8z"}}),_c('path',{attrs:{"fill":"#293688","d":"M449.3 5c-9.6 0-16.8.8-20.8 10.4L359 149h43.2l8-24h51.2l4.8 24h38.4L471 5h-21.6zm-28 96c3.2-8 16-42.4 16-42.4s3.2-8.8 5.6-14.4l2.4 13.6s8 36 9.6 44h-33.6v-.8z"}}),_c('path',{attrs:{"fill":"#3c58bf","d":"M111.7 105.8l-4-20.8c-7.2-24-30.4-50.4-56-63.2l36 128H131l64.8-144h-43.2l-40.8 100z"}}),_c('path',{attrs:{"fill":"#293688","d":"M111.7 105.8l-4-20.8c-7.2-24-30.4-50.4-56-63.2l36 128H131l64.8-144h-35.2l-48.8 100z"}}),_c('path',{attrs:{"fill":"#ffbc00","d":"M.5 5l7.2 1.6C59 18.6 94.1 49 107.7 85L93.3 17C91 7.4 83.7 5 75 5H.5z"}}),_c('path',{attrs:{"fill":"#f7981d","d":"M.5 5c51.2 12 93.6 43.2 107.2 79.2L94.1 27.4A19.5 19.5 0 0 0 75 12.2L.5 5z"}}),_c('path',{attrs:{"fill":"#ed7c00","d":"M.5 5c51.2 12 93.6 43.2 107.2 79.2L98.1 53c-2.4-9.6-5.6-19.2-16.8-23.2L.5 5z"}}),_c('g',{attrs:{"fill":"#051244"}},[_c('path',{attrs:{"d":"M151.7 101l-27.2-27.2-12.8 30.4-3.2-20c-7.2-24-30.4-50.4-56-63.2l36 128h43.2l20-48zM226.1 149l-34.4-35.2-6.4 35.2zM318.1 99.4c3.2 3.2 4.8 5.6 4 8.8 0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 25.6 0 46.4-7.2 58.4-20l-34.4-33.6zM364.5 149h37.6l8-24h51.2l4.8 24h38.4L491 90.6l-48-46.4 2.4 12.8s8 36 9.6 44h-33.6c3.2-8 16-42.4 16-42.4s3.2-8.8 5.6-14.4"}})])])]),_vm._v(" "),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 12","width":"26","height":"18","aria-labelledby":"claimoucher"}},[_c('title',{attrs:{"id":"claimvoucher"}},[_vm._v("Claim Voucher")]),_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M8 6.5H3.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H8c.3 0 .5.2.5.5s-.2.5-.5.5zM8 4H3.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H8c.3 0 .5.2.5.5S8.3 4 8 4z"}}),_c('path',{attrs:{"fill":"#231815","d":"M15.5 12h-14C.7 12 0 11.3 0 10.5v-9C0 .7.7 0 1.5 0h14c.8 0 1.5.7 1.5 1.5v9c0 .8-.7 1.5-1.5 1.5zM1.5 1c-.3 0-.5.2-.5.5v9c0 .3.2.5.5.5h14c.3 0 .5-.2.5-.5v-9c0-.3-.2-.5-.5-.5h-14z"}}),_c('path',{attrs:{"fill":"#231815","d":"M13.5 9h-10c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h10c.3 0 .5.2.5.5s-.2.5-.5.5z"}}),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M13.5 6.8h-2.6c-.3 0-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5h2.6c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5zm-2.1-1H13v-2h-1.6v2z"}})])])])]),_vm._v(" "),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 17","width":"22","height":"27","aria-labelledby":"banktransfer"}},[_c('title',{attrs:{"id":"banktransfer"}},[_vm._v("Bank Transfer")]),_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M11.5 17h-9A2.5 2.5 0 0 1 0 14.5v-12C0 1.1 1.1 0 2.5 0h9C12.9 0 14 1.1 14 2.5v12c0 1.4-1.1 2.5-2.5 2.5zm-9-16C1.7 1 1 1.7 1 2.5v12c0 .8.7 1.5 1.5 1.5h9c.8 0 1.5-.7 1.5-1.5v-12c0-.8-.7-1.5-1.5-1.5h-9z"}}),_c('path',{attrs:{"fill":"#231815","d":"M11.5 13h-9c-.3 0-.5-.2-.5-.5v-10c0-.3.2-.5.5-.5h9c.3 0 .5.2.5.5v10c0 .3-.2.5-.5.5zM3 12h8V3H3v9z"}}),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M7 15.6a1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7c0-.3.1-.5.3-.7a1 1 0 0 1 1.4 0c.2.2.3.4.3.7 0 .3-.1.5-.3.7a1 1 0 0 1-.7.3z"}})])])])])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"d-lg-none btn btn-block btn-primary mb-2",attrs:{"type":"submit"},on:{"click":_vm.handleSubmit}},[_vm._v("Add horse")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"horseSire"}},[_vm._v("Sire "),_c('small',[_vm._v("(optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"horseDam"}},[_vm._v("Dam "),_c('small',[_vm._v("(optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"ashs"}},[_c('abbr',{attrs:{"title":"Australian Stock Horse Number"}},[_vm._v("ASHS#")]),_vm._v(" "),_c('small',[_vm._v("(optional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"aqhs"}},[_c('abbr',{attrs:{"title":"Australian Quarter Horse Number"}},[_vm._v("AQHA#")]),_vm._v(" "),_c('small',[_vm._v("(optional)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"actionBar":true}},[_c('horse-add-details',{staticClass:"row mx-0 show active",attrs:{"slot":"tabContent","edit":_vm.edit,"register":_vm.register,"horseRegistrants":_vm.horseRegistrants},slot:"tabContent"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseRegister_vue__ = __webpack_require__(361);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39d50bd0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseRegister_vue__ = __webpack_require__(915);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseRegister_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39d50bd0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseRegister_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('h1',{staticClass:"sr-only",attrs:{"slot":"heading"},slot:"heading"},[_vm._v("Register Horses")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('h2',{staticClass:"mb-4",attrs:{"slot":"heading"},slot:"heading"},[_vm._v("Select Horses To Register")]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('data-table',{attrs:{"dataRows":_vm.rows,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedSelect",fn:function(ref){
var row = ref.row;
return _c('tableSelectRowTemplate',{staticClass:"z-1 p-3",attrs:{"row":row,"options":{ requireFinancial: true }}})}},{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{attrs:{"text":row.name,"row":row,"options":{ expandMobile: true , showRegistered: true, inline: true }}})}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',{staticClass:"d-flex"},[_c('strong',{staticStyle:{"padding-right":"2px"}},[_vm._v("Owner: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.owner_name,"row":row,"options":{ showFinancial: true, inline: true  }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Age: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":String(row.age),"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Sex: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.gender,"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Status: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.horse_status ? row.horse_status.name : '',"row":row,"options":{ inline: true }}})],1)])])}}])}),_vm._v(" "),(_vm.$store.getters.selectedRows.length > 0)?_c('div',{staticClass:"sticky-bottom alert bg-primary text-white d-flex flex-wrap align-items-center mb-0",attrs:{"role":"alert"}},[_c('div',{staticClass:"flex-grow-1 pr-3 text-center text-lg-left"},[_c('strong',[_vm._v("You have selected: ")]),_vm._v(" "),_vm._l((_vm.$store.getters.selectedRows),function(row,i){return _c('span',{key:i},[_vm._v("\n          "+_vm._s(row.hasOwnProperty('first_name') ? (row.first_name + ' ' + row.last_name) : row.name + (i == _vm.$store.getters.selectedRows.length -1 ? '' : ','))+"\n        ")])})],2),_vm._v(" "),(_vm.options.registerHorseText && _vm.$store.getters.selectedRows.length > 0)?_c('router-link',{staticClass:"btn btn-outline-white btn-block-mob mt-2 mt-lg-0 text-nowrap",attrs:{"tag":"button","to":{ name: 'Confirm Horse' }}},[_vm._v("\n        Register Horses\n      ")]):_vm._e(),_vm._v(" "),(_vm.options.joinButtonText || _vm.options.registerHorseText)?_c('button',{staticClass:"btn btn-outline-white ml-lg-2 btn-block-mob",on:{"click":function($event){$event.preventDefault();return _vm.deselectAll($event)}}},[_vm._v("Cancel")]):_vm._e()],1):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominateRookie_vue__ = __webpack_require__(362);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_752ec936_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominateRookie_vue__ = __webpack_require__(917);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominateRookie_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_752ec936_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NominateRookie_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('h1',{staticClass:"sr-only",attrs:{"slot":"heading"},slot:"heading"},[_vm._v("Rookie Nominations")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('h2',{staticClass:"mb-4",attrs:{"slot":"heading"},slot:"heading"},[_vm._v("Select Horses To Nominate For Rookie Status"+_vm._s((_vm.loggedInRole === 'Admin' || _vm.loggedInRole === 'SuperAdmin') && this.member ? (' for ' + this.member.name) : ''))]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"financialYear"}},[_vm._v("Paying for Season")]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedSeason),expression:"selectedSeason"}],staticClass:"form-control",attrs:{"id":"financialYear"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedSeason=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.setSelectedSeason($event)}]}},_vm._l((_vm.seasonsList()),function(startYear){return _c('option',{key:startYear.year,domProps:{"value":startYear.year}},[_vm._v(_vm._s(startYear.description))])}),0)])]),_vm._v(" "),(_vm.showSeasonConfirmModal)?_c('modal',{on:{"close":function($event){$event.preventDefault();_vm.showSeasonConfirmModal = false}}},[_c('h3',{staticClass:"modal-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Warning")]),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v(_vm._s(this.warningText))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.showSeasonConfirmModal = false}}},[_vm._v("No")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.checkout}},[_vm._v("Yes")])])]):_vm._e(),_vm._v(" "),_c('data-table',{attrs:{"dataRows":_vm.rows,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedSelect",fn:function(ref){
var row = ref.row;
return _c('tableSelectRowTemplate',{staticClass:"z-1 p-3",attrs:{"row":row}})}},{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{attrs:{"text":row.name,"row":row,"options":{ expandMobile: true }}})}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',[_c('strong',[_vm._v("Owner: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.owner_name,"row":row,"options":{ showRegistered: true, inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Age: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":String(row.age),"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Sex: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.gender,"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Status: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":_vm.$store.state.horseStatus.some(function (status) { return status.id === row.horse_status_id; }) ? _vm.$store.state.horseStatus.filter(function (status) { return status.id === row.horse_status_id; })[0].name : '',"row":row,"options":{ inline: true }}})],1)])])}}])}),_vm._v(" "),(_vm.$store.getters.selectedRows.length > 0)?_c('div',{staticClass:"sticky-bottom alert bg-primary text-white d-flex flex-wrap align-items-center mb-0",attrs:{"role":"alert"}},[_c('div',{staticClass:"flex-grow-1 pr-3 text-center text-lg-left"},[_c('strong',[_vm._v("You have selected: ")]),_vm._v(" "),_vm._l((_vm.$store.getters.selectedRows),function(row,i){return _c('span',{key:i},[_vm._v("\n          "+_vm._s(row.hasOwnProperty('first_name') ? (row.first_name + ' ' + row.last_name) : row.name + (i == _vm.$store.getters.selectedRows.length -1 ? '' : ','))+"\n        ")])})],2),_vm._v(" "),_c('button',{class:['btn  btn-block-mob mt-2 mt-lg-0 text-nowrap', _vm.processing ? 'btn-primary-dark' : 'btn-outline-white'],attrs:{"type":"submit"},on:{"click":function($event){return _vm.checkSelectedSeason()}}},[_vm._v("\n        "+_vm._s(!_vm.processing ? 'Nominate For Rookie Status' : '')+"\n        "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]),_vm._v(" "),(_vm.options.joinButtonText || _vm.options.registerHorseText)?_c('button',{staticClass:"btn btn-outline-white ml-lg-2 btn-block-mob",on:{"click":_vm.deselectAll}},[_vm._v("Cancel")]):_vm._e()]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseRegisterConfirm_vue__ = __webpack_require__(363);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_214aa1ce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseRegisterConfirm_vue__ = __webpack_require__(921);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseRegisterConfirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_214aa1ce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseRegisterConfirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseRegisterConfirmDetails_vue__ = __webpack_require__(364);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a51f8ffe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseRegisterConfirmDetails_vue__ = __webpack_require__(920);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorseRegisterConfirmDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a51f8ffe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HorseRegisterConfirmDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation ml-0",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.checkout($event)}}},[_c('div',{staticClass:"col px-0 pr-lg-3"},[(_vm.saveErrorMessage)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.saveErrorMessage))]):_vm._e(),_vm._v(" "),(_vm.checkoutErrorMessage)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.checkoutErrorMessage))]):_vm._e(),_vm._v(" "),(_vm.saveSuccessMessage)?_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.saveSuccessMessage))]):_vm._e(),_vm._v(" "),_vm._l((_vm.horsePages),function(memberDetail,index){return _c('section',{key:index,staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[(index === 0)?_c('div',{staticClass:"d-flex justify-content-between align-items-start"},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v(_vm._s(_vm.nominate === 'rookie' ? 'Nominate Horses For Rookie Status' : 'Register Horses'))])]):_vm._e(),_vm._v(" "),(_vm.errors[index])?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors[index]))]):_vm._e(),_vm._v(" "),(_vm.commonError)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.commonError))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group row no-gutters pr-xl-4"},[_c('label',{attrs:{"for":'horseName' + index}},[_vm._v("Horse Name "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horseDetails[index].name),expression:"horseDetails[index].name"}],class:['form-control', _vm.errorStatus === 'name' && _vm.errors[index] ? 'is-invalid' : ''],attrs:{"type":"text","id":'horseName' + index,"required":""},domProps:{"value":(_vm.horseDetails[index].name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horseDetails[index], "name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Horse Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":'horseDob' + index}},[_vm._v("Date of Birth "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.horseDetails[index].dob),expression:"horseDetails[index].dob"}],class:['form-control form-date', _vm.errorStatus === 'validation_error' && _vm.errors[index] ? 'is-invalid' : ''],attrs:{"type":"date","id":'horseDob' + index,"required":"","placeholder":[_vm.isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy'],"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}"},domProps:{"value":(_vm.horseDetails[index].dob)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.horseDetails[index], "dob", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Date of Birth of the horse"+_vm._s(_vm.isLegacy() ? ' in the format yyyy-mm-dd' : '')+".")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_vm._m(0,true),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.horseDetails[index].gender),expression:"horseDetails[index].gender"}],class:['form-control', _vm.errorStatus === 'gender' && _vm.errors[index] ? 'is-invalid' : ''],attrs:{"required":"","name":"horseSex","id":"horseSex"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.horseDetails[index], "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"default":""}}),_vm._v(" "),_c('option',{attrs:{"value":"Mare"}},[_vm._v("Mare")]),_vm._v(" "),_c('option',{attrs:{"value":"Gelding"}},[_vm._v("Gelding")]),_vm._v(" "),_c('option',{attrs:{"value":"Stallion"}},[_vm._v("Stallion")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please choose a gender.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"not-required"},[_c('member-search-select',{attrs:{"element-id":'horseOwner' + index,"context":"owner","value":_vm.horseDetails[index].owner_id || []},on:{"input":function (v) { return _vm.$set(_vm.horseDetails[index], 'owner_id', v); }}})],1),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip",style:(_vm.isOwnerInvalid(index) ? 'display: block': '')},[_vm._v("Please include the Owner of the horse.")]),_vm._v(" "),_c('small',[_vm._v("Maximum of one owner")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":'horseMembers' + index}},[_vm._v("Rider/s "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('member-search-select',{attrs:{"element-id":'horseMembers' + index,"context":"owner","multiple":"","limit":10,"value":_vm.horseDetails[index].selectedMembers || []},on:{"input":function (v) { return _vm.$set(_vm.horseDetails[index], 'selectedMembers', v); }}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip",style:(_vm.isMemberInvalid(index) ? 'display: block': '')},[_vm._v("Please include the Rider/s.")])],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"status"}},[_vm._v("Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.horseDetails[index].horse_status_id),expression:"horseDetails[index].horse_status_id"}],class:['form-control', _vm.errorStatus === 'horse_status_id' && _vm.errors[index] ? 'is-invalid' : ''],attrs:{"id":"status","disabled":_vm.userIsNotAdmin},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.horseDetails[index], "horse_status_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.$store.state.horseStatus),function(status,index){return _c('option',{key:index,domProps:{"value":status.id}},[_vm._v(_vm._s(status.name))])}),0),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Status.")]),_vm._v(" "),(_vm.userIsNotAdmin)?_c('small',[_vm._v("If you need to update your horses status please contact the ACA office in business hours")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_vm._m(2,true),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.horseDetails[index].boy_status_id),expression:"horseDetails[index].boy_status_id"}],class:['form-control', _vm.errorStatus === 'boy_status_id' && _vm.errors[index] ? 'is-invalid' : ''],attrs:{"id":"boyStatus","required":"","disabled":_vm.userIsNotAdmin},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.horseDetails[index], "boy_status_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""},domProps:{"selected":!_vm.horseDetails[index].boy_status_id}}),_vm._v(" "),_vm._l((_vm.$store.state.horseStatus),function(status,statusIndex){return _c('option',{key:statusIndex,domProps:{"value":status.id,"selected":_vm.horseDetails[index].boy_status_id === status.id}},[_vm._v(_vm._s(status.name))])})],2),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Rider Status.")]),_vm._v(" "),(_vm.userIsNotAdmin)?_c('small',[_vm._v("If you need to update your horses status please contact the ACA office in business hours")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 d-flex justify-content-end"},[(_vm.horsePages > 1)?_c('button',{staticClass:"btn btn-block-mob btn-outline-primary px-lg-5",on:{"click":function($event){$event.preventDefault();_vm.horseDetails.splice(index,1);_vm.horsePages--}}},[_vm._v("Remove")]):_vm._e()])])])}),_vm._v(" "),_c('div',{staticClass:"d-lg-none bg-white rounded mb-4 p-3 p-sm-4 border-top border-light flex-grow-1"},[_c('h2',{staticClass:"h4 mb-4"},[_vm._v("Save horses data")]),_vm._v(" "),_c('button',{class:['btn btn-block mb-2', _vm.processing.save ? 'btn-primary-dark' : 'btn-primary'],on:{"click":function($event){$event.preventDefault();return _vm.saveHorsesData()}}},[_vm._v("\n        "+_vm._s(!_vm.processing.save ? 'Save' : '')+"\n        "),(_vm.processing.save)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"d-lg-none bg-white rounded mb-4 p-3 p-sm-4 border-top border-light flex-grow-1"},[_c('h2',{staticClass:"h4 mb-4"},[_vm._v("Cart")]),_vm._v(" "),_c('h3',{staticClass:"h6 mb-4"},[_vm._v("Horses ready for Check Out:")]),_vm._v(" "),_c('table',{staticClass:"table table-borderless"},[_c('tbody',_vm._l((_vm.horseList),function(type,typeKey,typeIndex){return _c('tr',{key:typeIndex},[_c('td',{staticClass:"pl-0"},[_vm._v(_vm._s(typeKey))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(type))]),_vm._v(" "),_c('td',{staticClass:"pr-0",attrs:{"align":"right"}},[_vm._v("$"+_vm._s((_vm.horseListPrice(_vm.nominate || 'register') * type).toFixed(2)))])])}),0)]),_vm._v(" "),(_vm.disableCheckOut)?_c('small',{staticClass:"d-block mb-2",staticStyle:{"color":"var(--black) !important"}},[_c('strong',[_vm._v("Please save your changes before checking out.")])]):_vm._e(),_vm._v(" "),_c('button',{class:['btn btn-block mb-2', _vm.processing.checkOut ? 'btn-primary-dark' : 'btn-primary'],attrs:{"type":"submit","disabled":_vm.errorStatus !== '' || _vm.errors.length !== 0 || _vm.disableCheckOut},on:{"click":_vm.handleSubmit}},[_vm._v("\n        "+_vm._s(!_vm.processing.checkOut ? 'Check Out' : '')+"\n        "),(_vm.processing.checkOut)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 62.4 39.6","width":"25","height":"16","aria-labelledby":"mastercard"}},[_c('title',{attrs:{"id":"mastercard"}},[_vm._v("Mastercard")]),_c('circle',{attrs:{"cx":"19.5","cy":"19.7","r":"19","fill":"#ee0005"}}),_c('circle',{attrs:{"cx":"43","cy":"19.7","r":"19","fill":"#f9a000"}}),_c('path',{attrs:{"fill":"#ff6300","d":"M24.1 19.7a19 19 0 0 0 7.2 14.9c4.4-3.5 7.2-8.8 7.2-14.9S35.6 8.3 31.3 4.8a19 19 0 0 0-7.2 14.9z"}})]),_vm._v(" "),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 505 153","width":"35","height":"11","aria-labelledby":"visa"}},[_c('title',{attrs:{"id":"visa"}},[_vm._v("Visa")]),_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('path',{attrs:{"fill":"#3c58bf","d":"M185.3 149L210.9 5h40l-24.8 144z"}}),_c('path',{attrs:{"fill":"#293688","d":"M185.3 149L218.1 5h32.8l-24.8 144z"}}),_c('path',{attrs:{"fill":"#3c58bf","d":"M371 6.6C363 3.4 350 .2 334 .2c-40 0-68.8 20-68.8 48.8 0 21.6 20 32.8 36 40s20.8 12 20.8 18.4c0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 42.4 0 70.4-20 70.4-50.4 0-16.8-10.4-29.6-34.4-40-14.4-7.2-23.2-11.2-23.2-18.4 0-6.4 7.2-12.8 23.2-12.8 13.6 0 23.2 2.4 30.4 5.6l4 1.6L371 6.6z"}}),_c('path',{attrs:{"fill":"#293688","d":"M371 6.6C363 3.4 350 .2 334 .2c-40 0-61.6 20-61.6 48.8 0 21.6 12.8 32.8 28.8 40s20.8 12 20.8 18.4c0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 42.4 0 70.4-20 70.4-50.4 0-16.8-10.4-29.6-34.4-40-14.4-7.2-23.2-11.2-23.2-18.4 0-6.4 7.2-12.8 23.2-12.8 13.6 0 23.2 2.4 30.4 5.6l4 1.6L371 6.6z"}}),_c('path',{attrs:{"fill":"#3c58bf","d":"M439.7 5c-9.6 0-16.8.8-20.8 10.4L359 149h43.2l8-24h51.2l4.8 24h38.4L471 5h-31.2zm-18.4 96c2.4-7.2 16-42.4 16-42.4s3.2-8.8 5.6-14.4l2.4 13.6s8 36 9.6 44h-33.6v-.8z"}}),_c('path',{attrs:{"fill":"#293688","d":"M449.3 5c-9.6 0-16.8.8-20.8 10.4L359 149h43.2l8-24h51.2l4.8 24h38.4L471 5h-21.6zm-28 96c3.2-8 16-42.4 16-42.4s3.2-8.8 5.6-14.4l2.4 13.6s8 36 9.6 44h-33.6v-.8z"}}),_c('path',{attrs:{"fill":"#3c58bf","d":"M111.7 105.8l-4-20.8c-7.2-24-30.4-50.4-56-63.2l36 128H131l64.8-144h-43.2l-40.8 100z"}}),_c('path',{attrs:{"fill":"#293688","d":"M111.7 105.8l-4-20.8c-7.2-24-30.4-50.4-56-63.2l36 128H131l64.8-144h-35.2l-48.8 100z"}}),_c('path',{attrs:{"fill":"#ffbc00","d":"M.5 5l7.2 1.6C59 18.6 94.1 49 107.7 85L93.3 17C91 7.4 83.7 5 75 5H.5z"}}),_c('path',{attrs:{"fill":"#f7981d","d":"M.5 5c51.2 12 93.6 43.2 107.2 79.2L94.1 27.4A19.5 19.5 0 0 0 75 12.2L.5 5z"}}),_c('path',{attrs:{"fill":"#ed7c00","d":"M.5 5c51.2 12 93.6 43.2 107.2 79.2L98.1 53c-2.4-9.6-5.6-19.2-16.8-23.2L.5 5z"}}),_c('g',{attrs:{"fill":"#051244"}},[_c('path',{attrs:{"d":"M151.7 101l-27.2-27.2-12.8 30.4-3.2-20c-7.2-24-30.4-50.4-56-63.2l36 128h43.2l20-48zM226.1 149l-34.4-35.2-6.4 35.2zM318.1 99.4c3.2 3.2 4.8 5.6 4 8.8 0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 25.6 0 46.4-7.2 58.4-20l-34.4-33.6zM364.5 149h37.6l8-24h51.2l4.8 24h38.4L491 90.6l-48-46.4 2.4 12.8s8 36 9.6 44h-33.6c3.2-8 16-42.4 16-42.4s3.2-8.8 5.6-14.4"}})])])]),_vm._v(" "),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 12","width":"26","height":"18","aria-labelledby":"claimoucher"}},[_c('title',{attrs:{"id":"claimoucher"}},[_vm._v("Claim Voucher")]),_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M8 6.5H3.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H8c.3 0 .5.2.5.5s-.2.5-.5.5zM8 4H3.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H8c.3 0 .5.2.5.5S8.3 4 8 4z"}}),_c('path',{attrs:{"fill":"#231815","d":"M15.5 12h-14C.7 12 0 11.3 0 10.5v-9C0 .7.7 0 1.5 0h14c.8 0 1.5.7 1.5 1.5v9c0 .8-.7 1.5-1.5 1.5zM1.5 1c-.3 0-.5.2-.5.5v9c0 .3.2.5.5.5h14c.3 0 .5-.2.5-.5v-9c0-.3-.2-.5-.5-.5h-14z"}}),_c('path',{attrs:{"fill":"#231815","d":"M13.5 9h-10c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h10c.3 0 .5.2.5.5s-.2.5-.5.5z"}}),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M13.5 6.8h-2.6c-.3 0-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5h2.6c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5zm-2.1-1H13v-2h-1.6v2z"}})])])])]),_vm._v(" "),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 17","width":"22","height":"27","aria-labelledby":"banktransfer"}},[_c('title',{attrs:{"id":"banktransfer"}},[_vm._v("Bank Transfer")]),_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M11.5 17h-9A2.5 2.5 0 0 1 0 14.5v-12C0 1.1 1.1 0 2.5 0h9C12.9 0 14 1.1 14 2.5v12c0 1.4-1.1 2.5-2.5 2.5zm-9-16C1.7 1 1 1.7 1 2.5v12c0 .8.7 1.5 1.5 1.5h9c.8 0 1.5-.7 1.5-1.5v-12c0-.8-.7-1.5-1.5-1.5h-9z"}}),_c('path',{attrs:{"fill":"#231815","d":"M11.5 13h-9c-.3 0-.5-.2-.5-.5v-10c0-.3.2-.5.5-.5h9c.3 0 .5.2.5.5v10c0 .3-.2.5-.5.5zM3 12h8V3H3v9z"}}),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M7 15.6a1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7c0-.3.1-.5.3-.7a1 1 0 0 1 1.4 0c.2.2.3.4.3.7 0 .3-.1.5-.3.7a1 1 0 0 1-.7.3z"}})])])])])])])],2),_vm._v(" "),_c('desktop-action-bar',[_c('div',[_c('h2',{staticClass:"h4 mb-4"},[_vm._v("Save horses data")]),_vm._v(" "),_c('button',{class:['btn btn-block mb-2', _vm.processing.save ? 'btn-primary-dark' : 'btn-primary'],on:{"click":function($event){$event.preventDefault();return _vm.saveHorsesData()}}},[_vm._v("\n          "+_vm._s(!_vm.processing.save ? 'Save' : '')+"\n          "),(_vm.processing.save)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"mt-4"},[_c('h2',{staticClass:"h4 mb-4"},[_vm._v("Cart")]),_vm._v(" "),_c('h3',{staticClass:"h6 mb-4"},[_vm._v("Horses ready for Check Out:")]),_vm._v(" "),_c('table',{staticClass:"table table-borderless"},[_c('tbody',_vm._l((_vm.horseList),function(type,typeKey,typeIndex){return _c('tr',{key:typeIndex},[_c('td',{staticClass:"pl-0"},[_vm._v(_vm._s(typeKey))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(type))]),_vm._v(" "),_c('td',{staticClass:"pr-0",attrs:{"align":"right"}},[_vm._v("$"+_vm._s((_vm.horseListPrice(_vm.nominate || 'register') * type).toFixed(2)))])])}),0)]),_vm._v(" "),(_vm.disableCheckOut)?_c('small',{staticClass:"d-block mb-2",staticStyle:{"color":"var(--black) !important"}},[_c('strong',[_vm._v("Please save your changes before checking out.")])]):_vm._e(),_vm._v(" "),_c('button',{class:['btn btn-block mb-2', _vm.processing.checkOut ? 'btn-primary-dark' : 'btn-primary'],attrs:{"type":"submit","disabled":_vm.errorStatus !== '' || _vm.errors.length !== 0 || _vm.disableCheckOut},on:{"click":_vm.handleSubmit}},[_vm._v("\n          "+_vm._s(!_vm.processing.checkOut ? 'Check Out' : '')+"\n        "),(_vm.processing.checkOut)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 62.4 39.6","width":"25","height":"16","aria-labelledby":"mastercard"}},[_c('title',{attrs:{"id":"mastercard"}},[_vm._v("Mastercard")]),_c('circle',{attrs:{"cx":"19.5","cy":"19.7","r":"19","fill":"#ee0005"}}),_c('circle',{attrs:{"cx":"43","cy":"19.7","r":"19","fill":"#f9a000"}}),_c('path',{attrs:{"fill":"#ff6300","d":"M24.1 19.7a19 19 0 0 0 7.2 14.9c4.4-3.5 7.2-8.8 7.2-14.9S35.6 8.3 31.3 4.8a19 19 0 0 0-7.2 14.9z"}})]),_vm._v(" "),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 505 153","width":"35","height":"11","aria-labelledby":"visa"}},[_c('title',{attrs:{"id":"visa"}},[_vm._v("Visa")]),_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('path',{attrs:{"fill":"#3c58bf","d":"M185.3 149L210.9 5h40l-24.8 144z"}}),_c('path',{attrs:{"fill":"#293688","d":"M185.3 149L218.1 5h32.8l-24.8 144z"}}),_c('path',{attrs:{"fill":"#3c58bf","d":"M371 6.6C363 3.4 350 .2 334 .2c-40 0-68.8 20-68.8 48.8 0 21.6 20 32.8 36 40s20.8 12 20.8 18.4c0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 42.4 0 70.4-20 70.4-50.4 0-16.8-10.4-29.6-34.4-40-14.4-7.2-23.2-11.2-23.2-18.4 0-6.4 7.2-12.8 23.2-12.8 13.6 0 23.2 2.4 30.4 5.6l4 1.6L371 6.6z"}}),_c('path',{attrs:{"fill":"#293688","d":"M371 6.6C363 3.4 350 .2 334 .2c-40 0-61.6 20-61.6 48.8 0 21.6 12.8 32.8 28.8 40s20.8 12 20.8 18.4c0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 42.4 0 70.4-20 70.4-50.4 0-16.8-10.4-29.6-34.4-40-14.4-7.2-23.2-11.2-23.2-18.4 0-6.4 7.2-12.8 23.2-12.8 13.6 0 23.2 2.4 30.4 5.6l4 1.6L371 6.6z"}}),_c('path',{attrs:{"fill":"#3c58bf","d":"M439.7 5c-9.6 0-16.8.8-20.8 10.4L359 149h43.2l8-24h51.2l4.8 24h38.4L471 5h-31.2zm-18.4 96c2.4-7.2 16-42.4 16-42.4s3.2-8.8 5.6-14.4l2.4 13.6s8 36 9.6 44h-33.6v-.8z"}}),_c('path',{attrs:{"fill":"#293688","d":"M449.3 5c-9.6 0-16.8.8-20.8 10.4L359 149h43.2l8-24h51.2l4.8 24h38.4L471 5h-21.6zm-28 96c3.2-8 16-42.4 16-42.4s3.2-8.8 5.6-14.4l2.4 13.6s8 36 9.6 44h-33.6v-.8z"}}),_c('path',{attrs:{"fill":"#3c58bf","d":"M111.7 105.8l-4-20.8c-7.2-24-30.4-50.4-56-63.2l36 128H131l64.8-144h-43.2l-40.8 100z"}}),_c('path',{attrs:{"fill":"#293688","d":"M111.7 105.8l-4-20.8c-7.2-24-30.4-50.4-56-63.2l36 128H131l64.8-144h-35.2l-48.8 100z"}}),_c('path',{attrs:{"fill":"#ffbc00","d":"M.5 5l7.2 1.6C59 18.6 94.1 49 107.7 85L93.3 17C91 7.4 83.7 5 75 5H.5z"}}),_c('path',{attrs:{"fill":"#f7981d","d":"M.5 5c51.2 12 93.6 43.2 107.2 79.2L94.1 27.4A19.5 19.5 0 0 0 75 12.2L.5 5z"}}),_c('path',{attrs:{"fill":"#ed7c00","d":"M.5 5c51.2 12 93.6 43.2 107.2 79.2L98.1 53c-2.4-9.6-5.6-19.2-16.8-23.2L.5 5z"}}),_c('g',{attrs:{"fill":"#051244"}},[_c('path',{attrs:{"d":"M151.7 101l-27.2-27.2-12.8 30.4-3.2-20c-7.2-24-30.4-50.4-56-63.2l36 128h43.2l20-48zM226.1 149l-34.4-35.2-6.4 35.2zM318.1 99.4c3.2 3.2 4.8 5.6 4 8.8 0 9.6-12.8 14.4-24 14.4a87 87 0 0 1-38.4-8l-5.6-2.4-5.6 32.8c9.6 4 27.2 8 45.6 8 25.6 0 46.4-7.2 58.4-20l-34.4-33.6zM364.5 149h37.6l8-24h51.2l4.8 24h38.4L491 90.6l-48-46.4 2.4 12.8s8 36 9.6 44h-33.6c3.2-8 16-42.4 16-42.4s3.2-8.8 5.6-14.4"}})])])]),_vm._v(" "),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 12","width":"26","height":"18","aria-labelledby":"claimoucher"}},[_c('title',{attrs:{"id":"claimoucher"}},[_vm._v("Claim Voucher")]),_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M8 6.5H3.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H8c.3 0 .5.2.5.5s-.2.5-.5.5zM8 4H3.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H8c.3 0 .5.2.5.5S8.3 4 8 4z"}}),_c('path',{attrs:{"fill":"#231815","d":"M15.5 12h-14C.7 12 0 11.3 0 10.5v-9C0 .7.7 0 1.5 0h14c.8 0 1.5.7 1.5 1.5v9c0 .8-.7 1.5-1.5 1.5zM1.5 1c-.3 0-.5.2-.5.5v9c0 .3.2.5.5.5h14c.3 0 .5-.2.5-.5v-9c0-.3-.2-.5-.5-.5h-14z"}}),_c('path',{attrs:{"fill":"#231815","d":"M13.5 9h-10c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h10c.3 0 .5.2.5.5s-.2.5-.5.5z"}}),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M13.5 6.8h-2.6c-.3 0-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5h2.6c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5zm-2.1-1H13v-2h-1.6v2z"}})])])])]),_vm._v(" "),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 17","width":"22","height":"27","aria-labelledby":"banktransfer"}},[_c('title',{attrs:{"id":"banktransfer"}},[_vm._v("Bank Transfer")]),_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_c('g',{staticClass:"currentLayer"},[_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M11.5 17h-9A2.5 2.5 0 0 1 0 14.5v-12C0 1.1 1.1 0 2.5 0h9C12.9 0 14 1.1 14 2.5v12c0 1.4-1.1 2.5-2.5 2.5zm-9-16C1.7 1 1 1.7 1 2.5v12c0 .8.7 1.5 1.5 1.5h9c.8 0 1.5-.7 1.5-1.5v-12c0-.8-.7-1.5-1.5-1.5h-9z"}}),_c('path',{attrs:{"fill":"#231815","d":"M11.5 13h-9c-.3 0-.5-.2-.5-.5v-10c0-.3.2-.5.5-.5h9c.3 0 .5.2.5.5v10c0 .3-.2.5-.5.5zM3 12h8V3H3v9z"}}),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M7 15.6a1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7c0-.3.1-.5.3-.7a1 1 0 0 1 1.4 0c.2.2.3.4.3.7 0 .3-.1.5-.3.7a1 1 0 0 1-.7.3z"}})])])])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"horseSex"}},[_vm._v("Sex "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"horseOwner"}},[_vm._v("Owner "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"boyStatus"}},[_vm._v("Beginning of Year Status "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"actionBar":true}},[_c('horse-confirm-details',{staticClass:"tab-pane row mx-0 show active",attrs:{"slot":"tabContent","nominate":_vm.nominate},slot:"tabContent"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__ = __webpack_require__(365);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66abf744_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__ = __webpack_require__(925);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66abf744_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartDetails_vue__ = __webpack_require__(366);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d683e49_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartDetails_vue__ = __webpack_require__(924);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d683e49_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.payment($event)}}},[_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-3"},[_c('h1',{staticClass:"h2"},[_vm._v("Your Cart")]),_vm._v(" "),(_vm.errors)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors))]):_vm._e()]),_vm._v(" "),(_vm.cartList)?_c('div',{staticClass:"col-12"},[(!_vm.$store.state.showExpand && _vm.cartList.length > 0 && _vm.total)?_c('table',{staticClass:"table table-striped table-bordered border-0"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.cartList),function(member,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(_vm.horseList[index].name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.horseList[index].owner_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.horseList[index].age))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.horseList[index].gender))]),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v("$"+_vm._s(member.price))]),_vm._v(" "),_c('td',[_c('button',{class:['btn btn-block', _vm.processing[index] ? 'btn-primary-dark' : 'btn-primary'],on:{"click":function($event){return _vm.remove(index)}}},[_vm._v("\n                  "+_vm._s(!_vm.processing[index] ? 'Remove' : '')+"\n                  "),(_vm.processing[index])?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])])])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',{staticClass:"border-0",attrs:{"align":"right","colspan":"5"}},[_c('strong',[_vm._v("Your total: $"+_vm._s(_vm.total.toFixed(2)))])]),_vm._v(" "),_c('td',{staticClass:"border-0"})]),_vm._v(" "),_vm._m(1)])]):(_vm.cartList.length > 0)?_c('table',{staticClass:"table table-striped table-bordered border-0"},[_c('tbody',_vm._l((_vm.cartList),function(member,index){return _c('tr',{key:index},[_c('td',[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',[_vm._v("\n                    "+_vm._s(_vm.horseList[index].name)),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Owner: ")]),_vm._v(" "+_vm._s(_vm.horseList[index].owner_name[0])),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Age: ")]),_vm._v(" "+_vm._s(_vm.horseList[index].age)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Sex: ")]),_vm._v(" "+_vm._s(_vm.horseList[index].gender)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Price: ")]),_vm._v(" $"+_vm._s(member.price)),_c('br')]),_vm._v(" "),_c('div',{staticClass:"flex-shrink-1"},[_c('button',{class:['btn', _vm.processing[index] ? 'btn-primary-dark' : 'btn-primary'],on:{"click":function($event){return _vm.remove(index)}}},[_vm._v("\n                      "+_vm._s(!_vm.processing[index] ? 'Remove' : '')+"\n                      "),(_vm.processing[index])?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])])])])])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',{staticClass:"border-0",attrs:{"align":"center"}},[_c('strong',[_vm._v("Your total: $"+_vm._s(_vm.total.toFixed(2)))])])])])]):_vm._e()]):_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-info",attrs:{"role":"alert"}},[_vm._v("Your cart is empty")])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-flex flex-wrap justify-content-end"},[_c('router-link',{staticClass:"btn btn-block-mob btn-outline-primary order-1 order-lg-0",attrs:{"tag":"button","to":{ name: this.nominate === 'rookie' ? 'Nominate Rookie' : 'Confirm Horse', params: { nominate: this.nominate } }}},[_vm._v(_vm._s(("Back to " + (this.nominate === 'rookie' ? 'Rookie Nomination' : 'Horse Registration'))))]),_vm._v(" "),(_vm.cartList ? _vm.cartList.length > 0 : false)?_c('button',{staticClass:"btn btn-block-mob btn-primary mb-2 mb-lg-0 ml-lg-2",on:{"click":_vm.handleSubmit}},[_vm._v("Proceed to Payment")]):_vm._e()],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"position-relative"},[_vm._v("Horse Name")]),_vm._v(" "),_c('th',{staticClass:"position-relative"},[_vm._v("Owner")]),_vm._v(" "),_c('th',{staticClass:"position-relative"},[_vm._v("Age")]),_vm._v(" "),_c('th',{staticClass:"position-relative"},[_vm._v("Sex")]),_vm._v(" "),_c('th',{staticClass:"position-relative column-lg-small"},[_vm._v("Price")]),_vm._v(" "),_c('th',{staticClass:"position-relative column-lg-small"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"border-0",attrs:{"align":"right","colspan":"5"}}),_vm._v(" "),_c('td',{staticClass:"border-0"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',[_c('cart',{staticClass:"tab-pane col-12 col-xl-9 px-0 show active",attrs:{"slot":"tabContent","cartMembers":_vm.cartMembers,"nominate":_vm.nominate,"id":"cart","role":"tabpanel","aria-label":"Cart"},on:{"cartChanged":function($event){return _vm.cartChanged()}},slot:"tabContent"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__ = __webpack_require__(367);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e594bf2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__ = __webpack_require__(927);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e594bf2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',[_c('payment',{staticClass:"tab-pane col-12 col-xl-9 px-0 show active",attrs:{"slot":"tabContent","cartMembers":_vm.cartMembers,"type":_vm.type,"id":"payment","role":"tabpanel","aria-label":"Payment"},slot:"tabContent"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drafts_vue__ = __webpack_require__(368);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0efc9387_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Drafts_vue__ = __webpack_require__(936);
function injectStyle (ssrContext) {
  __webpack_require__(929)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0efc9387"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drafts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0efc9387_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Drafts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 929 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = acaYearStart;
/* harmony export (immutable) */ __webpack_exports__["b"] = useDraftsList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api_drafts__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__composables_useServerList__ = __webpack_require__(58);


/**
 * Start of the current ACA year (1 April; before April it's last year's) — the same default
 * the legacy DataTable AdvancedFilter sent as `from_date` on the /drafts-list page.
 */

function acaYearStart() {
  var now = new Date();
  var year = now.getMonth() + 1 <= 3 ? now.getFullYear() - 1 : now.getFullYear();
  return "".concat(year, "-04-01");
}
/**
 * Admin /drafts-list table state (page / sort / per-page / search / tab / date range),
 * URL-synced via useServerList. The endpoint is admin-only, so there is no per-role scope here.
 * Rows are passed through raw (snake_case, as the API returns them) so the Edit link can hand
 * the untouched draft object to the Create Draft screen the way the legacy page did.
 */

function useDraftsList() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__composables_useServerList__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__services_api_drafts__["a" /* default */].getList, {
    defaultSort: 'start_date',
    defaultDirection: 'asc',
    defaultPerPage: 20,
    extraFilters: {
      tab: 'all',
      from_date: acaYearStart(),
      to_date: '',
      committee_id: '',
      zone_id: [],
      // Unpublished / Deleted / Open for Nominations (CAM-1503) — each narrows on top of
      // tab/zone/date/search, but the three are mutually exclusive with each other (checking one
      // clears the other two, enforced in Drafts.vue's setExclusiveCheckbox). Plain '' / '1'
      // scalars (not real booleans) keep them out of the URL/request when unset, same convention
      // as every other scalar filter here.
      unpublished: '',
      deleted: '',
      open_for_nominations: ''
    }
  });
}

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useDeleteDraft;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_EventBus__ = __webpack_require__(18);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




function useDeleteDraft() {
  var deleting = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

  function deleteDraft(_x) {
    return _deleteDraft.apply(this, arguments);
  }

  function _deleteDraft() {
    _deleteDraft = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(id) {
      var data, msg;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              deleting.value = true;
              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__["a" /* default */].delete(id);

            case 4:
              return _context.abrupt("return", true);

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              data = _context.t0.response != null ? _context.t0.response.data : null;
              msg = data != null && data.message != null ? data.message : 'A server error occurred. Please try again later.';
              __WEBPACK_IMPORTED_MODULE_2__store_EventBus__["a" /* default */].$emit('http-error', msg);
              return _context.abrupt("return", false);

            case 13:
              _context.prev = 13;
              deleting.value = false;
              return _context.finish(13);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7, 13, 16]]);
    }));
    return _deleteDraft.apply(this, arguments);
  }

  return {
    deleteDraft: deleteDraft,
    deleting: deleting
  };
}

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRestoreDraft;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_EventBus__ = __webpack_require__(18);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




function useRestoreDraft() {
  var restoring = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

  function restoreDraft(_x) {
    return _restoreDraft.apply(this, arguments);
  }

  function _restoreDraft() {
    _restoreDraft = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(id) {
      var data, msg;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              restoring.value = true;
              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__["a" /* default */].restore(id);

            case 4:
              return _context.abrupt("return", true);

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              data = _context.t0.response != null ? _context.t0.response.data : null;
              msg = data != null && data.message != null ? data.message : 'A server error occurred. Please try again later.';
              __WEBPACK_IMPORTED_MODULE_2__store_EventBus__["a" /* default */].$emit('http-error', msg);
              return _context.abrupt("return", false);

            case 13:
              _context.prev = 13;
              restoring.value = false;
              return _context.finish(13);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7, 13, 16]]);
    }));
    return _restoreDraft.apply(this, arguments);
  }

  return {
    restoreDraft: restoreDraft,
    restoring: restoring
  };
}

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = usePublishNominations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_EventBus__ = __webpack_require__(18);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




function usePublishNominations() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      runGated = _ref.runGated;

  var publishing = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

  function publish(_x) {
    return _publish.apply(this, arguments);
  }

  function _publish() {
    _publish = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(id) {
      var call, data, msg;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              publishing.value = true;
              _context.prev = 1;

              call = function call() {
                return __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__["a" /* default */].publishNominations(id);
              };

              _context.next = 5;
              return runGated ? runGated(call) : call();

            case 5:
              return _context.abrupt("return", true);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);

              if (!_context.t0.isGateCancelled) {
                data = _context.t0.response != null ? _context.t0.response.data : null;
                msg = data != null && data.message != null ? data.message : 'A server error occurred. Please try again later.';
                __WEBPACK_IMPORTED_MODULE_2__store_EventBus__["a" /* default */].$emit('http-error', msg);
              }

              return _context.abrupt("return", false);

            case 12:
              _context.prev = 12;
              publishing.value = false;
              return _context.finish(12);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8, 12, 15]]);
    }));
    return _publish.apply(this, arguments);
  }

  return {
    publish: publish,
    publishing: publishing
  };
}

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DRAFT_STATUS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DRAFT_STATUS_PUBLISHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DRAFT_STATUS_POSTPONED; });
/* unused harmony export DRAFT_STATUS_CANCELLED */
// Mirror of App\Enums\DraftStatus (campdraftone-api) — `drafts.draft_status_id`. Keep in sync by
// hand; there is no shared source of truth across the two repos. Labels are NOT duplicated here —
// the API sends the ready-to-display `draft_status_label` (DraftStatus::label()) on each row,
// same pattern as `nomination_status_label` elsewhere, so the frontend never re-derives status text.
var DRAFT_STATUS_PENDING = 1;
var DRAFT_STATUS_PUBLISHED = 2;
var DRAFT_STATUS_POSTPONED = 3;
var DRAFT_STATUS_CANCELLED = 4;

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = buildColumns;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildBreakpoints;
// Column keys double as the backend sort keys (DraftFilters::LIST_SORTABLE) so ResponsiveTable's
// sort arrows light up against `filters.sort` with no translation layer. Status is not sortable
// (matches the legacy /drafts-list page).
function buildColumns() {
  return [{
    key: 'name',
    label: 'Draft',
    sortable: true,
    minWidth: '180px'
  }, {
    key: 'committee',
    label: 'Committee',
    sortable: true,
    minWidth: '160px'
  }, // Wider than a plain zone-code column (Horses' equivalent is 90px) — this cell also carries
  // the "Final" badge next to the code, which clipped/wrapped awkwardly at 90px. Kept as a
  // fixed `width` (not `minWidth`) so it doesn't compete for flex space with Draft/Committee.
  {
    key: 'zone',
    label: 'Zone',
    sortable: true,
    width: '145px'
  }, {
    key: 'start_date',
    label: 'From',
    sortable: true,
    width: '110px'
  }, {
    key: 'end_date',
    label: 'To',
    sortable: true,
    width: '110px'
  }, {
    key: 'actions',
    label: 'Actions',
    width: '150px',
    minWidth: '150px',
    cellClass: 'text-left'
  }];
} // Below 900px the row collapses into an accordion: the draft name stays visible, the rest
// drops into the expanded detail — matching the legacy DataTable expandedHeader / expandedRow.

function buildBreakpoints() {
  return [{
    maxWidth: 900,
    hideHeader: true,
    accordion: {
      summary: [{
        keys: ['name'],
        hideLabel: true
      }]
    },
    rows: [['committee'], ['zone'], ['start_date'], ['end_date'], ['actions']]
  }];
}

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('div',{staticClass:"d-flex flex-wrap justify-content-between align-items-center mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('page-heading',{staticClass:"mb-0"},[_vm._v("Drafts")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary d-md-none px-xl-5 mt-2 mt-sm-0",attrs:{"to":{ name: 'Create Draft' }}},[_vm._v("Create"),_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v(" Draft")])])],1),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.alertMessage)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.alertMessage))]):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e(),_vm._v(" "),_c('filter-bar',{attrs:{"active":_vm.hasActiveFilters},on:{"clear":_vm.clearAll}},[_c('div',{staticClass:"filter-field"},[_c('span',{staticClass:"filter-field__label"},[_vm._v("Date "),_c('small',[_vm._v("(from)")])]),_vm._v(" "),_c('div',{staticClass:"filter-field__control"},[_c('input',{staticClass:"form-control form-date",attrs:{"type":"date","max":_vm.filters.to_date || null},domProps:{"value":_vm.filters.from_date},on:{"change":function($event){return _vm.setFilter('from_date', $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"filter-field"},[_c('span',{staticClass:"filter-field__label"},[_vm._v("Date "),_c('small',[_vm._v("(to)")])]),_vm._v(" "),_c('div',{staticClass:"filter-field__control"},[_c('input',{staticClass:"form-control form-date",attrs:{"type":"date","min":_vm.filters.from_date || null},domProps:{"value":_vm.filters.to_date},on:{"change":function($event){return _vm.setFilter('to_date', $event.target.value)}}})])]),_vm._v(" "),_c('filter-multiselect',{attrs:{"label":"Zone","option-label":"code","placeholder":"Any zone","value":_vm.filters.zone_id,"options":_vm.zoneOptions},on:{"input":function (ids) { return _vm.setFilter('zone_id', ids); },"clear":function($event){return _vm.clearFilter('zone_id')}}}),_vm._v(" "),_c('filter-checkbox',{attrs:{"label":"Unpublished","value":_vm.filters.unpublished},on:{"input":_vm.onUnpublishedToggle}}),_vm._v(" "),_c('filter-checkbox',{attrs:{"label":"Deleted","value":_vm.filters.deleted},on:{"input":_vm.onDeletedToggle}}),_vm._v(" "),_c('filter-checkbox',{attrs:{"label":"Open for Nominations","value":_vm.filters.open_for_nominations},on:{"input":_vm.onOpenForNominationsToggle}})],1),_vm._v(" "),_c('div',{staticClass:"form-inline mb-sm-3 d-flex justify-content-between"},[_c('div',{staticClass:"d-flex col-12 col-md-auto px-0 mb-3 mb-md-0"},[_c('label',{staticClass:"sr-only"},[_vm._v("Filter")]),_vm._v(" "),_c('div',{staticClass:"filter flex-wrap"},_vm._l((_vm.tabs),function(tab){return _c('div',{key:tab.value,staticClass:"form-check pl-0"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"radio","name":"draftTabFilter","id":'draftTab-' + tab.value},domProps:{"value":tab.value,"checked":_vm.filters.tab === tab.value},on:{"change":function($event){return _vm.onTabChange(tab.value)}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":'draftTab-' + tab.value}},[_vm._v(_vm._s(tab.label))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-lg-auto mt-2 mt-lg-0 ml-auto px-0 d-flex align-items-center"},[_c('label',{staticClass:"d-none d-lg-inline mr-xl-2 mb-0 pr-2 font-weight-normal",attrs:{"for":"draftsSearch"}},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"input-append d-flex flex-grow-1 flex-md-grow-0 mr-md-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],staticClass:"form-control mb-0 flex-grow-1 flex-md-grow-0",attrs:{"id":"draftsSearch","type":"text"},domProps:{"value":(_vm.searchInput)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.applySearch($event)},"search":_vm.applySearch,"input":function($event){if($event.target.composing){ return; }_vm.searchInput=$event.target.value}}}),_vm._v(" "),_c('svg',{staticClass:"append",attrs:{"role":"button","aria-label":"Search","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14","width":"16","height":"16"},on:{"click":_vm.applySearch}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":"none"}}),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M5.5 11C2.5 11 0 8.5 0 5.5S2.5 0 5.5 0 11 2.5 11 5.5 8.5 11 5.5 11zm0-10C3 1 1 3 1 5.5S3 10 5.5 10 10 8 10 5.5 8 1 5.5 1z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#231815","d":"M9.5 8.8l4.4 4.4c.2.2.2.5 0 .7l-.4.1-.4-.1-4.4-4.4.8-.7z"}})])])]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-fz-sm btn-primary d-none d-md-block px-xl-5 mt-2 mt-sm-0 ml-md-0",attrs:{"to":{ name: 'Create Draft' }}},[_vm._v("Create"),_c('span',{staticClass:"d-inline"},[_vm._v(" Draft")])])],1)]),_vm._v(" "),_c('div',{staticClass:"position-relative",staticStyle:{"min-height":"240px"}},[_c('responsive-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"loading":_vm.loading,"breakpoints":_vm.breakpoints,"sort":_vm.filters.sort,"direction":_vm.filters.direction,"empty-text":"No drafts found."},on:{"sort":_vm.setSort},scopedSlots:_vm._u([{key:"cell:name",fn:function(ref){
var row = ref.row;
return [_c('list-name-cell',{attrs:{"align":"right","label":row.name,"to":{ name: 'Events', params: { draftId: String(row.id) } }},scopedSlots:_vm._u([{key:"badges",fn:function(){return [(row.draft_status_id && row.draft_status_label)?_c('span',{staticClass:"badge dl-status-badge",class:_vm.statusBadgeClass(row.draft_status_id)},[(row.points_status === 'finalised' && _vm.isPublishedStatus(row.draft_status_id))?_c('svg',{staticClass:"text-success",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","width":"12"}},[_c('path',{attrs:{"fill":"currentColor","d":"M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"}})]):_vm._e(),_vm._v("\n                "+_vm._s(row.draft_status_label)+"\n              ")]):_vm._e(),_vm._v(" "),(row.deleted)?_c('span',{staticClass:"badge alert-secondary"},[_vm._v("Deleted")]):_vm._e(),_vm._v(" "),(_vm.filters.open_for_nominations === '1' && _vm.nominationStageBadge(row))?_c('span',{staticClass:"badge",class:_vm.nominationStageBadge(row).badgeClass},[_vm._v(_vm._s(_vm.nominationStageBadge(row).label))]):_vm._e()]},proxy:true}],null,true)})]}},{key:"cell:committee",fn:function(ref){
var row = ref.row;
return [_c('span',{staticClass:"dl-committee"},[(row.committee_id)?_c('router-link',{staticClass:"text-primary dl-committee__name",attrs:{"to":{ name: 'Committee Profile', params: { id: String(row.committee_id) } }}},[_vm._v(_vm._s(row.committee_name))]):_c('span',{staticClass:"dl-committee__name"},[_vm._v(_vm._s(row.committee_name))]),_vm._v(" "),_c('committee-secretaries-link',{attrs:{"committee-name":row.committee_name}})],1)]}},{key:"cell:zone",fn:function(ref){
var row = ref.row;
return [_c('span',{staticClass:"dl-zone"},[_c('span',[_vm._v(_vm._s(row.zone_code))]),_vm._v(" "),(row.is_final)?_c('span',{staticClass:"badge alert-warning"},[_vm._v("Final")]):_vm._e()])]}},{key:"cell:start_date",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(_vm.formatDmy(row.start_date)))]}},{key:"cell:end_date",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(_vm.formatDmy(row.end_date)))]}},{key:"cell:actions",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"actions__wrap"},[(!row.deleted)?[_c('app-tooltip',{attrs:{"text":"Edit Draft"}},[_c('span',{staticClass:"d-inline-flex align-items-center justify-content-center",staticStyle:{"width":"24px","height":"24px"}},[_c('router-link',{staticClass:"icon-btn icon-btn--edit",attrs:{"to":{ name: 'Edit Draft', params: { draftId: String(row.id) } }}})],1)]),_vm._v(" "),_c('app-tooltip',{attrs:{"text":"View Events"}},[_c('span',{staticClass:"d-inline-flex align-items-center justify-content-center",staticStyle:{"width":"24px","height":"24px"}},[_c('router-link',{staticClass:"icon-btn icon-btn--view",attrs:{"to":{ name: 'Events', params: { draftId: String(row.id) } }}})],1)]),_vm._v(" "),_c('app-tooltip',{attrs:{"text":"Delete Draft","align":"right"}},[_c('span',{staticClass:"d-inline-flex align-items-center justify-content-center",staticStyle:{"width":"24px","height":"24px"}},[_c('button',{staticClass:"btn-actions btn-delete",on:{"click":function($event){return _vm.askDelete(row)}}})])]),_vm._v(" "),(Number(row.has_settings) === 1 && Number(row.is_nominations_published) === 0)?_c('app-tooltip',{attrs:{"text":"Publish draft","align":"right"}},[_c('span',{staticClass:"d-inline-flex align-items-center justify-content-center",staticStyle:{"width":"24px","height":"24px"}},[_c('button',{staticClass:"icon-btn icon-btn--publish",attrs:{"disabled":_vm.publishingId === row.id},on:{"click":function($event){return _vm.publishDraft(row)}}})])]):_vm._e()]:_c('app-tooltip',{attrs:{"text":"Restore Draft"}},[_c('span',{staticClass:"d-inline-flex align-items-center justify-content-center",staticStyle:{"width":"24px","height":"24px"}},[_c('button',{staticClass:"icon-btn icon-btn--restore",attrs:{"disabled":_vm.restoringId === row.id},on:{"click":function($event){return _vm.restoreDraftRow(row)}}})])])],2)]}}])})],1),_vm._v(" "),_c('div',{staticClass:"form-inline justify-content-between align-items-start mt-3"},[_c('div',{staticClass:"d-flex align-items-center justify-content-center justify-content-md-start form-group mb-3 mb-md-0 col-12 col-md-auto px-0"},[_c('label',{staticClass:"mr-2 mb-0 font-weight-normal",attrs:{"for":"draftsShow"}},[_vm._v("Show")]),_vm._v(" "),_c('select',{staticClass:"form-control mr-2",attrs:{"id":"draftsShow"},domProps:{"value":_vm.filters.per_page},on:{"change":function($event){_vm.setPerPage(Number($event.target.value))}}},_vm._l((_vm.perPageOptions),function(n){return _c('option',{key:n,domProps:{"value":n}},[_vm._v(_vm._s(n))])}),0),_vm._v(" "),_c('span',[_vm._v("Entries")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.totalPages > 1),expression:"totalPages > 1"}],staticClass:"pagination-container form-group align-items-start justify-content-center mb-3 mb-md-0"},[_c('pagination',{attrs:{"total-pages":_vm.totalPages,"page":_vm.page,"on-change":_vm.setPage,"disabled":_vm.loading}})],1)]),_vm._v(" "),(_vm.draftToDelete)?_c('modal',{on:{"close":function($event){_vm.draftToDelete = null}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning text-center"},[_vm._v("\n          You are about to delete this draft. It will move to the Deleted tab and can be restored later. Are you sure?\n        ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){_vm.draftToDelete = null}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary ml-2",on:{"click":_vm.confirmDelete}},[_vm._v("Delete")])])])]):_vm._e(),_vm._v(" "),(_vm.gateVisible)?_c('action-gate-modal',{attrs:{"error":_vm.gateError,"loading":_vm.gateLoading},on:{"confirm":_vm.submitGatePassword,"cancel":_vm.cancelGate}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraftAdd_vue__ = __webpack_require__(369);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a50c503_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DraftAdd_vue__ = __webpack_require__(940);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraftAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a50c503_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DraftAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraftAddDetails_vue__ = __webpack_require__(370);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22cf93b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DraftAddDetails_vue__ = __webpack_require__(939);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraftAddDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22cf93b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DraftAddDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation ml-0",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.completeForm($event)}}},[_c('div',{staticClass:"col px-0 pr-lg-3"},[_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('div',{staticClass:"d-flex justify-content-between align-items-start mb-4"},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v(_vm._s(_vm.edit ? 'Edit' : 'Create')+" Draft")])]),_vm._v(" "),(_vm.errors)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors))]):_vm._e(),_vm._v(" "),(_vm.success)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.success))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row align-items-start"},[_c('div',{staticClass:"col-12 col-md-6 form-group row no-gutters pr-xl-4"},[_c('label',{attrs:{"for":"draftName"}},[_vm._v("Draft Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.draftDetails.name),expression:"draftDetails.name"}],staticClass:"form-control",attrs:{"type":"text","id":"draftName","required":""},domProps:{"value":(_vm.draftDetails.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.draftDetails, "name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Draft Name.")])]),_vm._v(" "),(Object.keys(_vm.listCommittees).length > 0)?_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"committeeName"}},[_vm._v("Committee")]),_vm._v(" "),_c('div',{staticClass:"form-inline align-items-start"},[_c('tags-input',{ref:"tagsInput",attrs:{"element-id":"committeeName","existing-tags":_vm.listCommittees,"onlyExistingTags":true,"addTagsOnComma":true,"typeahead":true,"typeaheadStyle":'dropdown',"typeaheadMaxResults":20,"typeaheadActivationThreshold":2,"limit":1,"placeholder":'Start Typing...'},model:{value:(_vm.selectedCommittee),callback:function ($$v) {_vm.selectedCommittee=$$v},expression:"selectedCommittee"}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip",class:{ 'd-block': _vm.committeeIsInvalid }},[_vm._v("Please include the Committee Name.")])],1)]):_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group align-self-end"},[_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-6 pr-xl-4 form-group"},[_c('label',{staticClass:"d-none d-xl-block",attrs:{"for":"draftFrom"}},[_vm._v("Date")]),_vm._v(" "),_c('div',{staticClass:"row align-items-start"},[_c('div',{staticClass:"col-12 col-md-6 mb-4 mb-md-2 mb-xl-0 pr-xl-1"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.draftDetails.start_date),expression:"draftDetails.start_date"}],class:['form-control form-date', _vm.errorStatus === 'validation_error' && _vm.errors ? 'is-invalid' : ''],attrs:{"type":"date","id":"draftFrom","required":"","max":_vm.draftDetails.end_date,"placeholder":[_vm.isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy'],"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}"},domProps:{"value":(_vm.draftDetails.start_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.draftDetails, "start_date", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Start Date"+_vm._s(_vm.isLegacy() ? ' in the format yyyy-mm-dd' : '')+".")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 mb-xl-0 pl-xl-1"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.draftDetails.end_date),expression:"draftDetails.end_date"}],class:['form-control form-date', _vm.errorStatus === 'validation_error' && _vm.errors ? 'is-invalid' : ''],attrs:{"type":"date","id":"draftTo","required":"","min":_vm.draftDetails.start_date,"placeholder":[_vm.isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy'],"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}"},domProps:{"value":(_vm.draftDetails.end_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.draftDetails, "end_date", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the End Date"+_vm._s(_vm.isLegacy() ? ' in the format yyyy-mm-dd' : '')+".")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"zone"}},[_vm._v("Zone")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.draftDetails.zone_id),expression:"draftDetails.zone_id"}],staticClass:"form-control",attrs:{"id":"zone","required":"","disabled":_vm.zoneFieldDisabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.draftDetails, "zone_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_vm._l((_vm.$store.state.listZones),function(zone,index){return _c('option',{key:index,domProps:{"value":zone.id}},[_vm._v(_vm._s(zone.code))])})],2),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Zone.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":"status"}},[_vm._v("Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.draftDetails.draft_status_id),expression:"draftDetails.draft_status_id"}],staticClass:"form-control",attrs:{"id":"status","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.draftDetails, "draft_status_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_vm._l((_vm.$store.getters.getDraftStatusesAdmin),function(status,index){return _c('option',{key:index,domProps:{"value":status.id}},[_vm._v(_vm._s(status.nameAdmin || status.name))])})],2),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Status.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"program"}},[_vm._v("Program")]),_vm._v(" "),_c('div',{staticClass:"custom-file"},[_c('input',{class:['custom-file-input font-weight-normal', { 'is-invalid': _vm.errorStatus === 'filetype_pdf' || _vm.errorStatus === 'filesize_pdf' }],attrs:{"type":"file","id":"program","accept":"application/pdf"},on:{"change":_vm.fileUpload}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label font-weight-normal",attrs:{"for":"program"}},[_vm._v("\n              "+_vm._s(this.temporaryFileData.name ? this.temporaryFileData.name : this.draftDetails.attachment ? this.draftDetails.attachment : 'Choose file...')+"\n            ")]),_vm._v(" "),(_vm.errorStatus === 'filesize_pdf')?_c('div',{staticClass:"invalid-tooltip"},[_vm._v("File is too large. Maximum allowed size is 3MB.")]):_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please select a PDF file.")]),_vm._v(" "),_c('small',[_vm._v("PDF file type required.")]),_vm._v(" "),(this.draftDetails.filename)?_c('button',{staticClass:"btn btn-link px-2 pl-md-0 px-xl-2 pr-md-1",attrs:{"type":"button"},on:{"click":_vm.deleteAttachment}},[_c('span',{staticClass:"sr-only"},[_vm._v("Delete Program")]),_vm._v(" "),_c('div',{staticClass:"btn-remove"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"}}),_c('path',{attrs:{"d":"M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"}}),_c('path',{attrs:{"d":"M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"}})])])])]):_vm._e()]),_vm._v(" "),(this.draftDetails.attachment && this.draftDetails.filename)?_c('div',{staticClass:"attached-file-wrapper ml-2 mb-2",attrs:{"id":"secretaryProgram"}},[_vm._v("\n            "+_vm._s(this.draftDetails.filename)+"\n            "),_c('div',{staticClass:"btn-download-file",on:{"click":function($event){return _vm.downloadProgram(_vm.draftDetails.id, 'attachment')}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"}})])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":"blogSource"}},[_vm._v("Blog source")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.draftDetails.blog_source.$model),expression:"$v.draftDetails.blog_source.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.draftDetails.blog_source.$error},attrs:{"type":"text","id":"blogSource","autocomplete":"off"},domProps:{"value":(_vm.$v.draftDetails.blog_source.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.draftDetails.blog_source, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(!_vm.$v.draftDetails.blog_source.url)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include correct source address.")]):_vm._e()]),_vm._v(" "),(this.secretary_program && this.secretary_program.filename)?_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('label',{staticClass:"ml-xl-2"},[_vm._v("Secretary program")]),_vm._v(" "),(this.secretary_program && this.secretary_program.filename)?_c('div',{staticClass:"attached-file-wrapper ml-2 mb-2",attrs:{"id":"secretaryProgram"}},[_vm._v("\n            "+_vm._s(this.secretary_program.filename)+"\n            "),_c('div',{staticClass:"btn-download-file",on:{"click":function($event){return _vm.downloadProgram(_vm.draftDetails.id, 'secretary_program')}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"}})])])])]):_vm._e(),_vm._v(" "),(this.secretary_program && this.secretary_program.filename)?_c('button',{staticClass:"btn btn-link px-2 pl-md-0 px-xl-2 pr-md-1",attrs:{"type":"button"},on:{"click":function($event){return _vm.approveSecretaryProgram(_vm.draftDetails.id)}}},[_c('span',{staticClass:"sr-only"},[_vm._v("Approve secretary program")]),_vm._v(" "),_c('div',{staticClass:"btn btn-block px-md-3 btn-primary"},[_vm._v("\n              Approve program\n            ")])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 align-self-end form-group"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.draftDetails.is_final),expression:"draftDetails.is_final"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"is_final"},domProps:{"checked":Array.isArray(_vm.draftDetails.is_final)?_vm._i(_vm.draftDetails.is_final,null)>-1:(_vm.draftDetails.is_final)},on:{"change":function($event){var $$a=_vm.draftDetails.is_final,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.draftDetails, "is_final", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.draftDetails, "is_final", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.draftDetails, "is_final", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label font-weight-normal h6 mb-0",attrs:{"for":"is_final"}},[_vm._v("Yes, this is the National Finals Draft")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 align-self-end form-group"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.draftDetails.is_futurity),expression:"draftDetails.is_futurity"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"is_futurity"},domProps:{"checked":Array.isArray(_vm.draftDetails.is_futurity)?_vm._i(_vm.draftDetails.is_futurity,null)>-1:(_vm.draftDetails.is_futurity)},on:{"change":function($event){var $$a=_vm.draftDetails.is_futurity,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.draftDetails, "is_futurity", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.draftDetails, "is_futurity", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.draftDetails, "is_futurity", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label font-weight-normal h6 mb-0",attrs:{"for":"is_futurity"}},[_vm._v("Yes, there is a Futurity on this program")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-lg-none mt-4"},[_c('button',{staticClass:"btn btn-block-mob btn-primary",attrs:{"type":"submit"},on:{"click":_vm.handleSubmit}},[_vm._v(_vm._s(_vm.edit ? 'Update' : 'Create'))])])])])]),_vm._v(" "),_c('desktop-action-bar',[_c('button',{class:['btn btn-block px-md-5', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],attrs:{"type":"submit"},on:{"click":_vm.handleSubmit}},[_vm._v("\n      "+_vm._s(!_vm.processing ? _vm.edit ? 'Update' : 'Create' : '')+"\n      "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center py-2 m-auto"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"d-xl-none",attrs:{"for":"draftFrom"}},[_vm._v("Date "),_c('small',[_vm._v("(from)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"d-xl-none",attrs:{"for":"draftFrom"}},[_vm._v("Date "),_c('small',[_vm._v("(to)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"actionBar":true}},[(_vm.loadError)?_c('div',{staticClass:"alert alert-warning",attrs:{"slot":"tabContent","role":"alert"},slot:"tabContent"},[_vm._v(_vm._s(_vm.loadError))]):(_vm.draftId && !_vm.details)?_c('div',{staticClass:"text-center py-5",attrs:{"slot":"tabContent"},slot:"tabContent"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])]):_c('draft-add-details',{staticClass:"row mx-0 show active",attrs:{"slot":"tabContent","details":_vm.details,"edit":!!_vm.draftId},slot:"tabContent"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Events_vue__ = __webpack_require__(371);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da7e52e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Events_vue__ = __webpack_require__(942);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Events_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da7e52e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Events_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('div',{attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v(_vm._s(_vm.publishing ? 'Select Events to Publish' : _vm.draftDetails.name + ' Events'))]),_vm._v(" "),(!_vm.publishing)?_c('div',{staticClass:"mb-3",staticStyle:{"color":"#000"}},[_c('div',[_c('strong',[_vm._v("Draft ID:")]),_vm._v(" "+_vm._s(_vm.draftId))]),_vm._v(" "),(_vm.draftDetails.created_at)?_c('div',[_c('strong',[_vm._v("Created:")]),_vm._v(" "+_vm._s(_vm.formatDateTime(_vm.draftDetails.created_at)))]):_vm._e(),_vm._v(" "),(_vm.draftDetails.updated_at)?_c('div',[_c('strong',[_vm._v("Updated:")]),_vm._v(" "+_vm._s(_vm.formatDateTime(_vm.draftDetails.updated_at)))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-md-flex d-block flex-wrap ms-auto justify-content-end mb-2"},[_c('button',{staticClass:"btn btn-primary px-xl-5 mt-2 mt-sm-0 mr-md-2",on:{"click":function($event){return _vm.exportEventMembers(_vm.draftDetails.id)}}},[_vm._v("\n        Export\n        "),_c('span',{staticClass:"d-none d-xl-inline"},[_vm._v(" Casual Members")]),_vm._v(" "),_c('span',{staticClass:"d-inline d-xl-none"},[_vm._v(" CM")])]),_vm._v(" "),(_vm.options.addEvent)?_c('router-link',{staticClass:"btn btn-primary px-xl-5 mt-2 mt-sm-0",attrs:{"to":{ name: 'Create Event', params: { draftId: String(_vm.draftId) } }}},[_vm._v("\n        Add\n        "),_c('span',{staticClass:"d-none d-xl-inline"},[_vm._v(" Event")])]):_vm._e()],1)]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.successMessage)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.successMessage))]):_vm._e(),_vm._v(" "),(_vm.status)?_c('div',{staticClass:"alert alert-info"},[_vm._v(_vm._s(_vm.status))]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),(_vm.changeStatuses.filter(function (i) { return i.changed; }).length)?_c('div',{staticClass:"alert alert-info"},[_vm._v("\n      The following statuses were updated after publishing:\n      "),_c('ul',{staticClass:"mb-0 mt-1"},_vm._l((_vm.changeStatuses.filter(function (i) { return i.changed; })),function(item,i){return _c('li',{key:i},[_vm._v("\n          "+_vm._s(item.type === 'horse' ? 'Horse' : 'Member')+" "),_c('strong',[_vm._v(_vm._s(item.name))]),_vm._v(" ("+_vm._s(item.event_name)+"): status "+_vm._s(item.old_status_name)+" → "+_vm._s(item.new_status_name)+"\n        ")])}),0)]):_vm._e(),_vm._v(" "),(_vm.warningItems.length)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n      There are issues with the following events:\n      "),_c('ul',{staticClass:"mb-0 mt-1"},_vm._l((_vm.warningItems),function(item,i){return _c('li',{key:i},[_vm._v(_vm._s(item.name)+": "),_c('strong',[_vm._v(_vm._s(item.reason))])])}),0)]):_vm._e(),_vm._v(" "),(_vm.draftDetails.is_final)?_c('strong',[_vm._v("This draft is marked as the National Finals")]):_vm._e(),_vm._v(" "),_c('data-table',{attrs:{"dataRows":_vm.rows,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedSelect",fn:function(ref){
var row = ref.row;
return (_vm.publishing)?_c('tableSelectRowTemplate',{staticClass:"z-1 p-3",attrs:{"row":row}}):_vm._e()}},{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return [_c('span',{staticClass:"d-inline-flex align-items-center flex-wrap flex-grow-1 pl-2",staticStyle:{"gap":"4px"}},[_c('router-link',{staticClass:"btn btn-link text-wrap text-left p-0 btn-expand-sm",attrs:{"to":{ name: 'Create Event', params: { draftId: String(_vm.draftId), eventId: String(row.id) } }}},[_vm._v(_vm._s(row.name))]),_vm._v(" "),(row.status)?_c('span',{staticClass:"badge",class:row.status === 'Finalised' ? 'alert-success' : row.status === 'Pending' ? 'alert-info' : 'alert-warning',staticStyle:{"min-width":"0"}},[_vm._v(_vm._s(row.status))]):_vm._e()],1)]}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',{staticClass:"pt-3 d-block"},[_c('router-link',{staticClass:"btn btn-sm btn-primary mb-2 mb-lg-0 px-lg-3 px-xl-4",attrs:{"to":{ name: 'Create Event', params: { draftId: String(_vm.draftId), eventId: String(row.id) } }}},[_vm._v("Edit")]),_vm._v(" "),_c('button',{class:['btn btn-sm btn-block-mob mb-2 mb-lg-0', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],on:{"click":function($event){$event.preventDefault();return _vm.removeModal(row.id)}}},[_vm._v("\n              "+_vm._s(!_vm.processing ? 'Remove' : '')+"\n              "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]),_vm._v(" "),(_vm.showModal)?_c('modal',{on:{"close":function($event){_vm.showModal = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning text-center"},[_vm._v("\n                  You are about to remove the event ‘"+_vm._s(row.name)+"’. Are you sure?\n                ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.showModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary ml-2",on:{"click":function($event){$event.preventDefault();_vm.remove(); _vm.showModal = false}}},[_vm._v("Remove")])])])]):_vm._e()],1)])])}}],null,true)}),_vm._v(" "),(_vm.publishing)?_c('div',{staticClass:"sticky-bottom alert bg-primary text-white d-flex flex-wrap align-items-center mb-0",attrs:{"role":"alert"}},[(_vm.$store.getters.selectedRows.length)?_c('div',{staticClass:"flex-grow-1 pr-3 text-center text-lg-left"},[_c('strong',[_vm._v("You have selected: ")]),_vm._v(" "),_vm._l((_vm.$store.getters.selectedRows),function(row,i){return _c('span',{key:i},[_vm._v("\n          "+_vm._s(row.name + (i == _vm.$store.getters.selectedRows.length - 1 ? '' : ','))+"\n        ")])})],2):_vm._e(),_vm._v(" "),(_vm.$store.getters.selectedRows.length)?_c('button',{class:['btn btn-block-mob mt-2 mt-lg-0 text-nowrap', _vm.processing2 ? 'btn-primary-dark' : 'btn-outline-white'],on:{"click":_vm.publishEvents}},[_vm._v("\n        "+_vm._s(!_vm.processing2 ? 'Publish Events' : '')+"\n        "),(_vm.processing2)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('button',{class:['btn btn-outline-white btn-block-mob', _vm.$store.getters.selectedRows.length ? 'ml-lg-2' : 'ml-lg-auto'],on:{"click":function($event){$event.preventDefault();_vm.publishing = !_vm.publishing}}},[_vm._v("Cancel")])]):_vm._e(),_vm._v(" "),(!_vm.publishing && _vm.rows.length)?_c('div',{staticClass:"d-lg-flex justify-content-between align-items-end mt-3"},[_c('p',{staticClass:"mb-lg-0"},[_vm._v("Now that you have added your event, you can choose to publish the points associated with it.\n        "),_c('br',{staticClass:"d-none d-xl-block"}),_vm._v("This will publicly display the event results to the ACA public website.\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-block-mob btn-primary flex-md-shrink-0 mb-2 mb-lg-0 ml-lg-4",on:{"click":function($event){$event.preventDefault();_vm.publishing = !_vm.publishing}}},[_vm._v("Publish Points")])]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventAdd_vue__ = __webpack_require__(372);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17d3f264_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventAdd_vue__ = __webpack_require__(950);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17d3f264_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventAddDetails_vue__ = __webpack_require__(373);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06cb3801_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventAddDetails_vue__ = __webpack_require__(949);
function injectStyle (ssrContext) {
  __webpack_require__(945)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06cb3801"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventAddDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06cb3801_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventAddDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 945 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JudgeSearchSelect_vue__ = __webpack_require__(374);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0b971f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JudgeSearchSelect_vue__ = __webpack_require__(948);
function injectStyle (ssrContext) {
  __webpack_require__(947)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b0b971f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JudgeSearchSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0b971f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JudgeSearchSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 947 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jss",on:{"focusin":_vm.onFocusIn,"focusout":_vm.onFocusOut}},[_c('multiselect',{ref:"ms",attrs:{"id":_vm.elementId,"value":null,"options":_vm.mergedOptions,"loading":_vm.loading,"internal-search":false,"searchable":_vm.active,"allow-empty":true,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"track-by":"id","custom-label":_vm.labelFor,"select-label":"","selected-label":"","deselect-label":""},on:{"select":_vm.onSelect,"search-change":_vm.onSearch,"open":_vm.onOpen,"close":_vm.onClose}},[_c('template',{slot:"noResult"},[(!_vm.loading)?_c('span',[_vm._v("No judges found.")]):_vm._e()]),_vm._v(" "),_c('template',{slot:"noOptions"},[_vm._v("Start typing to search...")]),_vm._v(" "),(_vm.loadingMore)?_c('li',{staticClass:"multiselect__element",attrs:{"slot":"afterList"},slot:"afterList"},[_c('span',{staticClass:"multiselect__option text-muted"},[_vm._v("Loading more...")])]):_vm._e()],2),_vm._v(" "),(_vm.selectedOptions.length)?_c('div',{staticClass:"tags-input mt-1 d-flex flex-wrap"},_vm._l((_vm.selectedOptions),function(o){return _c('span',{key:o.id,staticClass:"badge mr-1 mb-1"},[(!_vm.disabled)?_c('button',{staticClass:"tags-input-remove",attrs:{"type":"button","aria-label":"Remove"},on:{"mousedown":function($event){$event.preventDefault();},"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.remove(o.id)}}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"tags-input-label"},[_vm._v(_vm._s(_vm.labelFor(o)))])])}),0):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation ml-0",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.completeForm($event)}}},[_c('button',{staticClass:"sr-only",attrs:{"aria-hidden":"true"},on:{"click":function($event){_vm.calculating = true;_vm.calculate()}}},[_vm._v("Calculate")]),_vm._v(" "),_c('div',{staticClass:"col px-0 pr-lg-3"},[_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('div',{staticClass:"d-flex justify-content-between align-items-start mb-4"},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v(_vm._s(_vm.edit ? 'Edit' : 'Create')+" Event")])]),_vm._v(" "),(_vm.details && _vm.details.draftIsFinal)?_c('p',[_c('strong',[_vm._v("This draft is marked as the National Finals")])]):_vm._e(),_vm._v(" "),(_vm.draftZoneId !== '' && _vm.draftZoneId === null)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("Please fill in the zone field in the draft")]):_vm._e(),_vm._v(" "),(_vm.errors)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row align-items-start"},[_c('div',{staticClass:"col-12 col-md-6 form-group no-gutters pr-xl-4"},[_c('label',{attrs:{"for":"eventType"}},[_vm._v("Event Type")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.eventDetails.event_type_id),expression:"eventDetails.event_type_id"}],staticClass:"form-control",attrs:{"id":"eventType","required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.eventDetails, "event_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.setName]}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_vm._l((_vm.legacyEventTypes),function(type,index){return _c('option',{key:index,domProps:{"value":type.id}},[_vm._v(_vm._s(type.name))])})],2),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Event Type.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"eventName"}},[_vm._v("Event Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eventDetails.name),expression:"eventDetails.name"}],staticClass:"form-control",attrs:{"type":"text","id":"eventName","required":""},domProps:{"value":(_vm.eventDetails.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eventDetails, "name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Event Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 not-required"},[_c('label',{attrs:{"for":"judgeName"}},[_vm._v("Judge")]),_vm._v(" "),_c('judge-search-select',{attrs:{"element-id":"judgeName","multiple":"","value":_vm.judgeIds,"initial-options":_vm.judgeInitialOptions},on:{"input":_vm.updateJudgeSelection}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 align-self-end form-group"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eventDetails.is_affiliated),expression:"eventDetails.is_affiliated"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"is_affiliated"},domProps:{"checked":Array.isArray(_vm.eventDetails.is_affiliated)?_vm._i(_vm.eventDetails.is_affiliated,null)>-1:(_vm.eventDetails.is_affiliated)},on:{"change":function($event){var $$a=_vm.eventDetails.is_affiliated,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.eventDetails, "is_affiliated", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.eventDetails, "is_affiliated", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.eventDetails, "is_affiliated", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label font-weight-normal h6 mb-0",attrs:{"for":"is_affiliated"}},[_vm._v("Yes, this is an affiliated event")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-lg-none mt-4"},[(_vm.edit)?_c('button',{staticClass:"btn btn-block-mob btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.$nextTick(function () {_vm.showRemoveModal = !_vm.calculating})}}},[_vm._v("Remove")]):_vm._e(),_vm._v(" "),_c('button',{class:['btn btn-block-mob', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],on:{"click":function($event){_vm.calculating = false;_vm.handleSubmit()}}},[_vm._v("\n            "+_vm._s(!_vm.processing ? _vm.edit ? 'Post Points' : 'Create' : '')+"\n            "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])])])]),_vm._v(" "),_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('h2',{staticClass:"mb-sm-3"},[_vm._v("Results")]),_vm._v(" "),(_vm.warningItems.length)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n        There are issues with the following results:\n        "),_c('ul',{staticClass:"mb-0 mt-1"},_vm._l((_vm.warningItems),function(item,i){return _c('li',{key:i},[_vm._v("Place "+_vm._s(item.place)+": "),_c('strong',[_vm._v(_vm._s(item.reason))])])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row align-items-start"},[_c('div',{staticClass:"col-12 col-md-auto form-group no-gutters pr-xl-4"},[_c('label',{attrs:{"for":"starters"}},[_vm._v("Starters")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eventDetails.starters),expression:"eventDetails.starters"}],staticClass:"form-control",attrs:{"type":"number","id":"starters","min":"0","required":_vm.errorStatus === 'starters'},domProps:{"value":(_vm.eventDetails.starters)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eventDetails, "starters", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the number of Starters.")])])]),_vm._v(" "),_vm._l((_vm.eventDetails.results),function(result,resultIndex){return (result.is_cutout !== 1)?_c('div',{key:resultIndex,staticClass:"form-row align-items-start"},[_c('div',{class:['col-12 col-md form-group', _vm.isLegacy() ? 'col-lg-1' : 'flex-grow-0']},[_c('label',{attrs:{"for":'position' + resultIndex}},[_vm._v("Place")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eventDetails.results[resultIndex].place),expression:"eventDetails.results[resultIndex].place"}],staticClass:"form-control",attrs:{"type":"text","id":'position' + resultIndex,"required":"","disabled":""},domProps:{"value":(_vm.eventDetails.results[resultIndex].place)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eventDetails.results[resultIndex], "place", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md form-group",staticStyle:{"min-width":"200px"}},[_c('label',{attrs:{"for":'competitor' + resultIndex}},[_vm._v("Competitor")]),_vm._v(" "),_c('div',{staticClass:"not-required",attrs:{"id":'competitordiv' + resultIndex}},[_c('member-search-select',{attrs:{"element-id":'competitor' + resultIndex,"context":"competitor","value":_vm.competitorValue(resultIndex),"initial-options":_vm.competitorInitialOptions(resultIndex)},on:{"input":function (v) { return _vm.onCompetitorPicked(resultIndex, v); }}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md form-group",staticStyle:{"min-width":"200px"}},[_c('label',{attrs:{"for":'horse' + resultIndex}},[_vm._v("Horse")]),_vm._v(" "),_c('div',{class:[{ 'not-required' : !_vm.eventDetails.results[resultIndex].score }],attrs:{"id":'horsediv' + resultIndex}},[_c('horse-search-select',{attrs:{"element-id":'horse' + resultIndex,"value":_vm.horseValue(resultIndex),"initial-option":_vm.eventDetails.results[resultIndex] && _vm.eventDetails.results[resultIndex].horse},on:{"input":function (v) { return _vm.onHorsePicked(resultIndex, v); }}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip",style:(_vm.isInvalid(resultIndex) && _vm.eventDetails.results[resultIndex].score ? 'display: block': '')},[_vm._v("Please include the Horse.")])],1)]),_vm._v(" "),_c('div',{class:['col-12 col-md form-group', _vm.isLegacy() ? 'col-lg-1' : 'flex-grow-0']},[_c('label',{staticClass:"pr-md-4 pr-xl-5",attrs:{"for":'score' + resultIndex}},[_vm._v("Score")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eventDetails.results[resultIndex].score),expression:"eventDetails.results[resultIndex].score"}],staticClass:"form-control pr-md-2",attrs:{"type":"text","id":'score' + resultIndex,"required":_vm.eventDetails.results[resultIndex].horse_id},domProps:{"value":(_vm.eventDetails.results[resultIndex].score)},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.calculating = true;},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eventDetails.results[resultIndex], "score", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Score.")])]),_vm._v(" "),_c('div',{class:['col-12 col-md form-group', _vm.isLegacy() ? 'col-lg-1' : 'flex-grow-0']},[_c('label',{staticClass:"pr-md-4 pr-xl-5",attrs:{"for":'points' + resultIndex}},[_vm._v("Points")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eventDetails.results[resultIndex].points),expression:"eventDetails.results[resultIndex].points"}],staticClass:"form-control",attrs:{"type":"text","id":'points' + resultIndex,"required":"","disabled":""},domProps:{"value":(_vm.eventDetails.results[resultIndex].points)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eventDetails.results[resultIndex], "points", $event.target.value)}}}),_vm._v(" "),(_vm.eventDetails.event_type_id === 9 || _vm.eventDetails.event_type_id === 10)?_c('div',{staticClass:"custom-control custom-checkbox mt-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eventDetails.results[resultIndex].zero_rider_points_override),expression:"eventDetails.results[resultIndex].zero_rider_points_override"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":'nopoints' + resultIndex},domProps:{"checked":Array.isArray(_vm.eventDetails.results[resultIndex].zero_rider_points_override)?_vm._i(_vm.eventDetails.results[resultIndex].zero_rider_points_override,null)>-1:(_vm.eventDetails.results[resultIndex].zero_rider_points_override)},on:{"change":function($event){var $$a=_vm.eventDetails.results[resultIndex].zero_rider_points_override,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.eventDetails.results[resultIndex], "zero_rider_points_override", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.eventDetails.results[resultIndex], "zero_rider_points_override", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.eventDetails.results[resultIndex], "zero_rider_points_override", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label font-weight-normal text-nowrap",attrs:{"for":'nopoints' + resultIndex}},[_vm._v("No Points")])]):_vm._e()]),_vm._v(" "),_c('div',{class:['col-12 col-md form-group pb-lg-1 pl-md-0', _vm.isLegacy() ? 'col-lg-1' : 'flex-grow-0']},[_c('label',{staticClass:"d-none d-md-block",attrs:{"aria-hidden":"true"}},[_vm._v(" ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-link px-2 pl-md-0 px-xl-2 pr-md-1 mr-n2 d-none d-md-block",attrs:{"aria-label":"Remove Result"},on:{"click":function($event){$event.preventDefault();return _vm.removeResult(resultIndex)}}},[_c('div',{staticClass:"btn-remove"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"}}),_c('path',{attrs:{"d":"M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"}}),_c('path',{attrs:{"d":"M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"}})])])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-block-mob btn-outline-primary d-md-none",attrs:{"aria-label":"Remove Result"},on:{"click":function($event){return _vm.removeResult(resultIndex)}}},[_vm._v("Remove")])])]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"d-lg-flex justify-content-end mt-3"},[_c('button',{staticClass:"btn btn-block-mob btn-outline-primary mr-lg-2",on:{"click":function($event){$event.preventDefault();_vm.addAnotherResult(false);_vm.focusNew()}}},[_vm._v("Add More Results")]),_vm._v(" "),_c('button',{class:['btn btn-block-mob', _vm.processing3 ? 'btn-primary-dark' : 'btn-primary'],on:{"click":function($event){_vm.calculating = true;_vm.calculate()}}},[_vm._v("\n          "+_vm._s(!_vm.processing3 ? 'Calculate' : '')+"\n          "),(_vm.processing3)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])])],2),_vm._v(" "),_vm._l((_vm.eventDetails.results),function(result,resultIndex){return (result.is_cutout !== 0)?_c('section',{key:resultIndex,staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('h2',{staticClass:"mb-sm-3"},[_vm._v("Cut Out")]),_vm._v(" "),_c('div',{staticClass:"form-row align-items-start"},[_c('div',{staticClass:"col-12 col-md form-group",staticStyle:{"min-width":"200px"}},[_c('label',{attrs:{"for":'competitor' + resultIndex}},[_vm._v("Competitor")]),_vm._v(" "),_c('div',{staticClass:"not-required",attrs:{"id":'competitordiv' + resultIndex}},[_c('member-search-select',{attrs:{"element-id":'competitor' + resultIndex,"context":"competitor","value":_vm.competitorValue(resultIndex),"initial-options":_vm.competitorInitialOptions(resultIndex)},on:{"input":function (v) { return _vm.onCompetitorPicked(resultIndex, v); }}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md form-group",staticStyle:{"min-width":"200px"}},[_c('label',{attrs:{"for":'horse' + resultIndex}},[_vm._v("Horse")]),_vm._v(" "),_c('div',{class:[{ 'not-required' : !_vm.eventDetails.results[resultIndex].score }],attrs:{"id":'horsediv' + resultIndex}},[_c('horse-search-select',{attrs:{"element-id":'horse' + resultIndex,"value":_vm.horseValue(resultIndex),"initial-option":_vm.eventDetails.results[resultIndex] && _vm.eventDetails.results[resultIndex].horse},on:{"input":function (v) { return _vm.onHorsePicked(resultIndex, v); }}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip",style:(_vm.isInvalid(resultIndex) && _vm.eventDetails.results[resultIndex].score ? 'display: block': '')},[_vm._v("Please include the Horse.")])],1)]),_vm._v(" "),_c('div',{class:['col-12 col-md form-group', _vm.isLegacy() ? 'col-lg-1' : 'flex-grow-0']},[_c('label',{staticClass:"pr-md-4 pr-xl-5",attrs:{"for":'score' + resultIndex}},[_vm._v("Score")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eventDetails.results[resultIndex].score),expression:"eventDetails.results[resultIndex].score"}],staticClass:"form-control pr-md-2",attrs:{"type":"text","min":"0","id":'score' + resultIndex,"required":_vm.eventDetails.results[resultIndex].horse_id && _vm.eventDetails.results[resultIndex].horse_id !== 0},domProps:{"value":(_vm.eventDetails.results[resultIndex].score)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eventDetails.results[resultIndex], "score", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Score.")])]),_vm._v(" "),_c('div',{class:['col-12 col-md form-group', _vm.isLegacy() ? 'col-lg-1' : 'flex-grow-0']},[_c('label',{staticClass:"pr-md-4 pr-xl-5",attrs:{"for":"pointsCutout"}},[_vm._v("Points")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eventDetails.results[resultIndex].points),expression:"eventDetails.results[resultIndex].points"}],staticClass:"form-control",attrs:{"type":"number","id":"pointsCutout","required":"","disabled":""},domProps:{"value":(_vm.eventDetails.results[resultIndex].points)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.eventDetails.results[resultIndex], "points", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end mt-3"},[_c('button',{class:['btn btn-block-mob', _vm.processing3 ? 'btn-primary-dark' : 'btn-primary'],on:{"click":function($event){_vm.calculating = true;_vm.calculate()}}},[_vm._v("\n          "+_vm._s(!_vm.processing3 ? 'Calculate' : '')+"\n          "),(_vm.processing3)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])])]):_vm._e()})],2),_vm._v(" "),_c('desktop-action-bar',[(_vm.edit)?_c('button',{staticClass:"btn btn-block btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.$nextTick(function () {_vm.showRemoveModal = !_vm.calculating})}}},[_vm._v("Remove")]):_vm._e(),_vm._v(" "),_c('button',{class:['btn btn-block', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],on:{"click":function($event){_vm.calculating = false;_vm.handleSubmit()}}},[_vm._v("\n      "+_vm._s(!_vm.processing ? _vm.edit ? 'Post Points' : 'Create' : '')+"\n      "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])]),_vm._v(" "),(_vm.showChangeModal)?_c('modal',{on:{"close":function($event){$event.preventDefault();_vm.showChangeModal = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning text-center"},[_c('strong',[_vm._v("Warning!")]),_vm._v(" "),(_vm.eventDetails.showResults !== _vm.details.showResults)?_c('p',{staticClass:"mb-0"},[_vm._v("You are about to "+_vm._s(_vm.eventDetails.showResults ? 'show' : 'hide')+" the Results. Are you sure?")]):_vm._e(),_vm._v(" "),(_vm.eventDetails.showCutout !== _vm.details.showCutout)?_c('p',{staticClass:"mb-0"},[_vm._v("You are about to "+_vm._s(_vm.eventDetails.showCutout ? 'show' : 'hide')+" the Cut Out. Are you sure?")]):_vm._e()])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"col-12 d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.addEvent()}}},[_vm._v("Confirm")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary ml-2",on:{"click":function($event){$event.preventDefault();_vm.showChangeModal = false}}},[_vm._v("Cancel")])])])]):_vm._e(),_vm._v(" "),(_vm.showRemoveModal)?_c('modal',{on:{"close":function($event){$event.preventDefault();_vm.showRemoveModal = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning text-center"},[_c('strong',[_vm._v("Warning!")]),_vm._v(" "),_c('p',[_vm._v("Removing an event will cause associated points and scores to also be removed. You are about to remove this event. Are you sure?")])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"col-12 d-flex justify-content-center"},[_c('button',{class:['btn', _vm.processing2 ? 'btn-primary-dark' : 'btn-primary'],on:{"click":function($event){$event.preventDefault();return _vm.removeEvent()}}},[_vm._v("\n          "+_vm._s(!_vm.processing2 ? 'Confirm' : '')+"\n          "),(_vm.processing2)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary ml-2",on:{"click":function($event){$event.preventDefault();_vm.showRemoveModal = false}}},[_vm._v("Cancel")])])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"actionBar":true}},[_c('draft-add-details',{staticClass:"row mx-0 show active",attrs:{"slot":"tabContent","details":_vm.resolvedDetails,"edit":_vm.resolvedEdit},slot:"tabContent"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Titles_vue__ = __webpack_require__(375);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e8135e9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Titles_vue__ = __webpack_require__(952);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Titles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e8135e9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Titles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('h1',{staticClass:"h2",attrs:{"slot":"heading"},slot:"heading"},[_vm._v("Titles")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.success)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.success))]):_vm._e(),_vm._v(" "),_c('data-table',{attrs:{"dataRows":_vm.rows,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{attrs:{"text":row.name,"link":'Edit Title',"row":row,"edit":true,"options":{ showLinks: true, expandMobile: true, showStatus: true }}})}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',{staticClass:"pt-2"},[_c('tableButtonTemplate',{attrs:{"text":'Edit Title',"link":'Edit Title',"row":row,"edit":true}})],1)])])}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TitleEdit_vue__ = __webpack_require__(376);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d4d59d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TitleEdit_vue__ = __webpack_require__(960);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TitleEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d4d59d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TitleEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TitleEditDetails_vue__ = __webpack_require__(377);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45d4841d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TitleEditDetails_vue__ = __webpack_require__(959);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TitleEditDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45d4841d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TitleEditDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TitleEditDetailsSire_vue__ = __webpack_require__(378);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61166b50_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TitleEditDetailsSire_vue__ = __webpack_require__(956);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TitleEditDetailsSire_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61166b50_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TitleEditDetailsSire_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('h2',{staticClass:"mb-sm-3"},[_vm._v("Sire Award Eligibility")]),_vm._v(" "),_c('div',{staticClass:"row align-items-start"},[_c('div',{staticClass:"col-12 col-md-auto form-group"},[_c('label',{attrs:{"for":"year"}},[_vm._v("Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedYear),expression:"selectedYear"}],staticClass:"form-control pr-5",attrs:{"id":"year"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedYear=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.$nextTick(function () {_vm.getSires()})}]}},_vm._l((_vm.years),function(year,yearIndex){return _c('option',{key:yearIndex,domProps:{"value":year.id}},[_vm._v(_vm._s(year.name))])}),0),_vm._v(" "),_c('small',[_vm._v("Changing the year will save the current list.")])])]),_vm._v(" "),_vm._l((_vm.selectedHorses),function(sire,sireIndex){return _c('div',{key:sireIndex,staticClass:"form-row align-items-start"},[_c('div',{staticClass:"col-12 col-md form-group"},[_c('label',{attrs:{"for":'horse' + sireIndex}},[_vm._v("Horse")]),_vm._v(" "),_c('div',{attrs:{"id":'horsediv' + sireIndex}},[_c('horse-search-select',{attrs:{"element-id":'horse' + sireIndex,"value":_vm.selectedHorses[sireIndex] || []},on:{"input":function (v) { return _vm.$set(_vm.selectedHorses, sireIndex, v); }}})],1)]),_vm._v(" "),_c('div',{class:['col-12 col-md form-group pb-lg-1 pl-md-0', _vm.isLegacy() ? 'col-lg-1' : 'flex-grow-0']},[_c('label',{staticClass:"d-none d-md-block",attrs:{"aria-hidden":"true"}},[_vm._v(" ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-link px-2 pl-md-0 px-xl-2 pr-md-1 mr-n-2 d-none d-md-block",attrs:{"aria-label":"Remove Result"},on:{"click":function($event){$event.preventDefault();return _vm.removeResult(sireIndex)}}},[_c('div',{staticClass:"btn-remove"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"}}),_c('path',{attrs:{"d":"M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"}}),_c('path',{attrs:{"d":"M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"}})])])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-block-mob btn-outline-primary d-md-none",attrs:{"aria-label":"Remove Result"},on:{"click":function($event){return _vm.removeResult(sireIndex)}}},[_vm._v("Remove")])])])}),_vm._v(" "),(_vm.selectedHorses.length === 0)?_c('div',{staticClass:"col-12 col-md form-group align-self-end"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-lg-flex justify-content-end mt-3"},[_c('button',{staticClass:"btn btn-block-mob btn-outline-primary mr-lg-2",on:{"click":function($event){$event.preventDefault();_vm.addAnotherResult();_vm.focusNew()}}},[_vm._v("Add Another Sire")]),_vm._v(" "),_c('button',{class:['btn btn-block-mob', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],on:{"click":function($event){return _vm.saveSires(_vm.selectedYear)}}},[_vm._v("\n      "+_vm._s(!_vm.processing ? 'Save' : '')+"\n      "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])]),_vm._v(" "),(_vm.sireSuccess)?_c('div',{staticClass:"alert alert-success mt-3 mb-0",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.sireSuccess))]):_vm._e(),_vm._v(" "),(_vm.sireError)?_c('div',{staticClass:"alert alert-warning mt-3 mb-0",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.sireError))]):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center py-2 m-auto"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TitleEditDetailsRookie_vue__ = __webpack_require__(379);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b6f98b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TitleEditDetailsRookie_vue__ = __webpack_require__(958);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TitleEditDetailsRookie_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b6f98b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TitleEditDetailsRookie_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('h2',{staticClass:"mb-sm-3"},[_vm._v("Rookie Horse Nominations")]),_vm._v(" "),_c('div',{staticClass:"row align-items-start"},[_c('div',{staticClass:"col-12 col-md-auto form-group"},[_c('label',{attrs:{"for":"year"}},[_vm._v("Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedYear),expression:"selectedYear"}],staticClass:"form-control pr-5",attrs:{"id":"year"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedYear=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.$nextTick(function () {_vm.getRookies()})}]}},_vm._l((_vm.years),function(year,yearIndex){return _c('option',{key:yearIndex,domProps:{"value":year.id}},[_vm._v(_vm._s(year.name))])}),0),_vm._v(" "),_c('small',[_vm._v("Please save any nomination changes before changing the year.")])])]),_vm._v(" "),_vm._l((_vm.selectedHorses),function(rookie,rookieIndex){return _c('div',{key:rookieIndex,staticClass:"form-row align-items-start"},[_c('div',{staticClass:"col-12 col-md form-group"},[_c('label',{attrs:{"for":'horse' + rookieIndex}},[_vm._v("Horse")]),_vm._v(" "),_c('div',{class:[{ 'click-events-none not-required' : rookie.id }],attrs:{"id":'horsediv' + rookieIndex}},[_c('horse-search-select',{attrs:{"element-id":'horse' + rookieIndex,"value":_vm.rookieHorseValue(rookie),"disabled":!!rookie.id},on:{"input":function (v) { return _vm.$set(_vm.selectedHorses[rookieIndex].horse, 'id', v); }}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md form-group"},[_c('label',{attrs:{"for":'horseDate' + rookieIndex}},[_vm._v("Eligible From")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedHorses[rookieIndex].eligible_from),expression:"selectedHorses[rookieIndex].eligible_from"}],staticClass:"form-control",attrs:{"type":"date","id":'horseDate' + rookieIndex,"disabled":!!rookie.id},domProps:{"value":(_vm.selectedHorses[rookieIndex].eligible_from)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedHorses[rookieIndex], "eligible_from", $event.target.value)}}})]),_vm._v(" "),(!rookie.id)?_c('div',{staticClass:"col-12 col-md-auto form-group"},[_c('label',{staticClass:"d-none d-md-block",attrs:{"aria-hidden":"true"}},[_vm._v(" ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-block-mob btn-outline-primary",on:{"click":function($event){return _vm.saveRookie(rookieIndex)}}},[_vm._v("Save")])]):_vm._e(),_vm._v(" "),_c('div',{class:['col-12 col-md form-group pb-lg-1 pl-md-0', _vm.isLegacy() ? 'col-lg-1' : 'flex-grow-0']},[_c('label',{staticClass:"d-none d-md-block",attrs:{"aria-hidden":"true"}},[_vm._v(" ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-link px-2 pl-md-0 px-xl-2 pr-md-1 mr-n-2 d-none d-md-block",attrs:{"aria-label":"Remove Result"},on:{"click":function($event){$event.preventDefault();return _vm.removeResult(rookieIndex)}}},[_c('div',{staticClass:"btn-remove"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"}}),_c('path',{attrs:{"d":"M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"}}),_c('path',{attrs:{"d":"M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"}})])])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-block-mob btn-outline-primary d-md-none",attrs:{"aria-label":"Remove Result"},on:{"click":function($event){return _vm.removeResult(rookieIndex)}}},[_vm._v("Remove")])])])}),_vm._v(" "),(_vm.selectedHorses.length === 0)?_c('div',{staticClass:"col-12 col-md form-group align-self-end"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-lg-flex justify-content-end mt-3"},[_c('button',{staticClass:"btn btn-block-mob btn-primary",on:{"click":function($event){$event.preventDefault();_vm.addAnotherResult();_vm.focusNew()}}},[_vm._v("Add Another Rookie")])]),_vm._v(" "),(_vm.rookieSuccess)?_c('div',{staticClass:"alert alert-success mt-3 mb-0",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.rookieSuccess))]):_vm._e(),_vm._v(" "),(_vm.rookieError)?_c('div',{staticClass:"alert alert-warning mt-3 mb-0",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.rookieError))]):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center py-2 m-auto"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation ml-0",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.completeForm($event)}}},[_c('div',{staticClass:"col px-0 pr-lg-3"},[_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('div',{staticClass:"d-flex justify-content-between align-items-start mb-4"},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v(_vm._s(_vm.details ? _vm.details.name : ''))])]),_vm._v(" "),(_vm.errors)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row align-items-start"},[_c('div',{staticClass:"col-12 col-md-6 form-group no-gutters pr-xl-4"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.titleDetails.championship_name),expression:"titleDetails.championship_name"}],staticClass:"form-control",attrs:{"type":"text","id":"titleName","required":""},domProps:{"value":(_vm.titleDetails.championship_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.titleDetails, "championship_name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the National Title Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.titleDetails.name),expression:"titleDetails.name"}],staticClass:"form-control",attrs:{"type":"text","id":"titleNameZone","required":""},domProps:{"value":(_vm.titleDetails.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.titleDetails, "name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Zone Title Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('div',{staticClass:"mb-3"},[_c('label',{attrs:{"for":"sponsorName"}},[_vm._v("Sponsor")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.titleDetails.sponsor_name),expression:"titleDetails.sponsor_name"}],staticClass:"form-control",attrs:{"type":"text","id":"sponsorName"},domProps:{"value":(_vm.titleDetails.sponsor_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.titleDetails, "sponsor_name", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Sponsor Name.")])]),_vm._v(" "),_c('label',{attrs:{"for":"sponsorLink"}},[_vm._v("Sponsor Link")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.titleDetails.sponsor_link),expression:"titleDetails.sponsor_link"}],staticClass:"form-control",attrs:{"type":"text","id":"sponsorLink"},domProps:{"value":(_vm.titleDetails.sponsor_link)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.titleDetails, "sponsor_link", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Sponsor Link.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"sponsorLogo"}},[_vm._v("Sponsor Logo")]),_vm._v(" "),_c('div',{staticClass:"custom-file"},[_c('input',{class:['custom-file-input font-weight-normal', { 'is-invalid': _vm.validation['sponsor_logo'].status === 'error' }],attrs:{"type":"file","id":"sponsorLogo","accept":"image/jpeg,image/png,image/webp,image/svg+xml,image/bmp"},on:{"change":_vm.sponsorLogoFileUpload}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label font-weight-normal",attrs:{"for":"sponsorLogo"}},[_vm._v(_vm._s(_vm.sponsorLogoFileName ?
              _vm.sponsorLogoFileName : 'Choose file...'))]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v(_vm._s(_vm.validation['sponsor_logo'].message))])]),_vm._v(" "),(_vm.titleDetails.sponsor_logo)?_c('div',{staticClass:"border border-light rounded p-3 mt-2 position-relative"},[_c('div',{staticClass:"blockButtons d-flex flex-column"},[_c('button',{staticClass:"d-flex justify-content-center align-items-center border border-white m-2",attrs:{"aria-label":"Remove Logo"},on:{"click":function($event){$event.preventDefault();_vm.sponsorLogoFileName = ''; _vm.titleDetails.sponsor_logo_file = ''; _vm.titleDetails.sponsor_logo = ''}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"11","height":"11"}},[_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M10.5499992 10.9500008c-.1 0-.3 0-.4-.1l-10-10c-.2-.2-.2-.5 0-.7s.5-.2.7 0l10 10c.2.2.2.5 0 .7 0 .1-.2.1-.3.1z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#231815","d":"M.5499992 10.9500008c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l10-10c.2-.2.5-.2.7 0s.2.5 0 .7l-10 10c0 .1-.2.1-.3.1z"}})])])])]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.titleDetails.sponsor_logo,"alt":_vm.titleDetails.sponsor_name}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"}),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pl-xl-4 form-group"},[_c('label',{attrs:{"for":"titleLogo"}},[_vm._v("Title Logo")]),_vm._v(" "),_c('div',{staticClass:"custom-file"},[_c('input',{class:['custom-file-input font-weight-normal', { 'is-invalid': _vm.validation['title_logo'].status === 'error' }],attrs:{"type":"file","id":"titleLogo","accept":"image/jpeg,image/png,image/webp,image/svg+xml,image/bmp"},on:{"change":_vm.titleLogoFileUpload}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label font-weight-normal",attrs:{"for":"titleLogo"}},[_vm._v(_vm._s(_vm.titleLogoFileName ?
              _vm.titleLogoFileName : 'Choose file...'))]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v(_vm._s(_vm.validation['title_logo'].message))])]),_vm._v(" "),(_vm.titleDetails.title_logo)?_c('div',{staticClass:"border border-light rounded p-3 mt-2 position-relative"},[_c('div',{staticClass:"blockButtons d-flex flex-column"},[_c('button',{staticClass:"d-flex justify-content-center align-items-center border border-white m-2",attrs:{"aria-label":"Remove Logo"},on:{"click":function($event){$event.preventDefault();_vm.titleLogoFileName = ''; _vm.titleDetails.title_logo_file = ''; _vm.titleDetails.title_logo = ''}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"11","height":"11"}},[_c('g',[_c('path',{attrs:{"fill":"#231815","d":"M10.5499992 10.9500008c-.1 0-.3 0-.4-.1l-10-10c-.2-.2-.2-.5 0-.7s.5-.2.7 0l10 10c.2.2.2.5 0 .7 0 .1-.2.1-.3.1z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#231815","d":"M.5499992 10.9500008c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l10-10c.2-.2.5-.2.7 0s.2.5 0 .7l-10 10c0 .1-.2.1-.3.1z"}})])])])]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.titleDetails.title_logo,"alt":_vm.titleDetails.sponsor_name}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 d-lg-none"},[_c('button',{staticClass:"btn btn-block-mob btn-primary",attrs:{"type":"submit"},on:{"click":_vm.handleSubmit}},[_vm._v("Update")])])])]),_vm._v(" "),(_vm.titleDetails.id === 4)?_c('rookie'):_vm._e(),_vm._v(" "),(_vm.titleDetails.id === 5)?_c('sire'):_vm._e()],1),_vm._v(" "),_c('desktop-action-bar',[_c('button',{class:['btn btn-block px-md-5', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],attrs:{"type":"submit"},on:{"click":_vm.handleSubmit}},[_vm._v("\n      "+_vm._s(!_vm.processing ? 'Update' : '')+"\n      "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"titleName"}},[_vm._v("Title Name "),_c('small',[_vm._v("(National)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"titleNameZone"}},[_vm._v("Title Name "),_c('small',[_vm._v("(Zone)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"actionBar":true}},[_c('title-edit-details',{staticClass:"row mx-0 show active",attrs:{"slot":"tabContent","details":_vm.details},slot:"tabContent"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TitlesPreview_vue__ = __webpack_require__(380);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_037d5708_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TitlesPreview_vue__ = __webpack_require__(964);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TitlesPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_037d5708_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TitlesPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"year"}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('app-multiselect',{attrs:{"id":"year","value":_vm.options.find(function (o) { return o.value === _vm.value; }),"options":_vm.options,"label":"label","track-by":"value","allow-empty":false},on:{"input":function (option) { return _vm.$emit('input', option.value); }}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"zone"}},[_vm._v("Zone")]),_vm._v(" "),_c('app-multiselect',{attrs:{"id":"zone","value":_vm.options.find(function (o) { return o.value === _vm.value; }),"options":_vm.options,"label":"label","track-by":"value","placeholder":"-- National --"},on:{"input":function (option) { return _vm.$emit('input', option ? option.value : 0); }}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('h1',{staticClass:"h2",attrs:{"slot":"heading"},slot:"heading"},[_vm._v("Titles - Preview Standings")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.success)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.success))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 px-0 mt-2"},[_c('form',{staticClass:"needs-validation my-3",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.getStandings($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-4 form-group"},[_c('label',{attrs:{"for":"title-type"}},[_vm._v("Please select a title to begin")]),_vm._v(" "),_c('app-multiselect',{attrs:{"id":"title-type","value":_vm.titleOptions.find(function (o) { return o.value === _vm.title; }),"options":_vm.titleOptions,"label":"label","track-by":"value","placeholder":"-- Select Title --"},on:{"input":_vm.onTitleChange}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-4"},[_c('season-select',{model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}})],1),_vm._v(" "),(_vm.title && _vm.title != 5)?_c('div',{staticClass:"col-12 col-md-4"},[_c('zone-select',{on:{"loaded":function($event){_vm.zones = $event}},model:{value:(_vm.zone),callback:function ($$v) {_vm.zone=$$v},expression:"zone"}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-primary btn-block-mob mb-3 mb-lg-0 ml-lg-auto",attrs:{"type":"submit","disabled":!_vm.title}},[(_vm.processing)?_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"spinner-border spinner-border-sm text-light mr-2",attrs:{"role":"status"}}),_vm._v("Loading\n              ")]):(_vm.title)?_c('span',[_vm._v("Load Standings")]):_c('span',[_vm._v("Select a title to proceed")])])])])])]),_vm._v(" "),(_vm.title !== 5)?_c('div',[(_vm.rows.length > 0)?_c('div',{staticClass:"mb-5"},[_c('data-table',{attrs:{"dataRows":_vm.rows,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{attrs:{"text":((row.place) + ": " + (row.rider_name || row.horse_name)),"row":row,"options":{ expandMobile: true }}})}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',{staticClass:"pt-2"},[_vm._v("\n                Position: "),_c('tableTextTemplate',{attrs:{"text":row.place,"row":row,"options":{inline: true}}})],1),_vm._v(" "),_c('li',{staticClass:"pt-2"},[_vm._v("\n                "+_vm._s(_vm.rows.length ? _vm.rows[0].hasOwnProperty("rider_name") ? 'Rider' : 'Horse' : '')+": "),_c('tableTextTemplate',{attrs:{"text":row.horse_name,"row":row,"options":{inline: true}}})],1),_vm._v(" "),_c('li',{staticClass:"pt-2"},[_vm._v("\n                Owner: "),_c('tableTextTemplate',{attrs:{"text":row.owner,"row":row,"options":{inline: true}}})],1),_vm._v(" "),_c('li',{staticClass:"pt-2"},[_vm._v("\n                Points: "),_c('tableTextTemplate',{attrs:{"text":row.total,"row":row,"options":{inline: true}}})],1),_vm._v(" "),_c('li',{staticClass:"pt-2"},[_vm._v("\n                Zone: "),_c('tableTextTemplate',{attrs:{"text":_vm.zones.filter(function (zone) { return zone.id === (row.rider_zone || row.horse_zone); })[0].code,"row":row,"options":{inline: true}}})],1)])])}}],null,false,3829878575)})],1):(_vm.options.loaded)?_c('div',{staticClass:"alert alert-warning rounded-0 mb-0"},[_vm._v("There are no results.")]):_vm._e()]):(_vm.title === 5)?_c('div',[(Object.keys(_vm.rows).length > 0)?_c('div',{staticClass:"mb-5"},[_c('data-table',{attrs:{"dataRows":_vm.rows,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{attrs:{"text":((row.place) + ": " + (row.sire.name)),"row":row,"options":{ expandMobile: true }}})}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',{staticClass:"pt-2"},[_vm._v("\n                Position: "),_c('tableTextTemplate',{attrs:{"text":row.place,"row":row,"options":{inline: true}}})],1),_vm._v(" "),_c('li',{staticClass:"pt-2"},[_vm._v("\n                Owner: "),_c('tableTextTemplate',{attrs:{"text":row.owner.name,"row":row,"options":{inline: true}}})],1),_vm._v(" "),_c('li',{staticClass:"pt-2"},[_vm._v("\n                Horse: "),_c('tableTextTemplate',{attrs:{"text":row.sire.name,"row":row,"options":{inline: true}}})],1),_vm._v(" "),_c('li',{staticClass:"pt-2"},[_vm._v("\n                Points: "),_c('tableTextTemplate',{attrs:{"text":row.total_points.toFixed(2),"row":row,"options":{inline: true}}})],1)])])}}],null,false,2241324371)})],1):(_vm.options.loaded)?_c('div',{staticClass:"alert alert-warning rounded-0 mb-0"},[_vm._v("There are no results.")]):_vm._e()]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report_vue__ = __webpack_require__(385);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5196c09a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report_vue__ = __webpack_require__(966);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5196c09a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('div',{staticClass:"mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"h2 mb-0"},[_vm._v("Export Reports")]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"mt-3 alert alert-warning col-12",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.error))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form mb-sm-3 d-flex justify-content-between bg-lighter",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"col-12 px-0 mt-2"},[_c('form',{staticClass:"needs-validation mb-3 pt-3 p-1 p-sm-3",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.runReport($event)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 col-xl-4 form-group"},[_c('label',{attrs:{"for":"report-type"}},[_vm._v("Please select a report to begin")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.report),expression:"report"}],staticClass:"form-control",attrs:{"id":"report-type","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.report=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"selected":"","disabled":"","value":""}},[_vm._v("-- Select Report Type --")]),_vm._v(" "),(_vm.isAdmin)?_c('option',{attrs:{"value":"mailinglist"}},[_vm._v("Mailing List")]):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('option',{attrs:{"value":"activemembers"}},[_vm._v("Registered Users")]):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('option',{attrs:{"value":"results"}},[_vm._v("Results")]):_vm._e(),_vm._v(" "),_c('option',{attrs:{"value":"secretary-financial-members"}},[_vm._v("Financial Members")]),_vm._v(" "),_c('option',{attrs:{"value":"calendar-of-events"}},[_vm._v("Calendar of Events")]),_vm._v(" "),(_vm.isAdmin)?_c('option',{attrs:{"value":"profiles"}},[_vm._v("All Profiles")]):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('option',{attrs:{"value":"standings-points"}},[_vm._v("Standings Points")]):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('option',{attrs:{"value":"app-import"}},[_vm._v("App Import")]):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('option',{attrs:{"value":"horse-progress-report"}},[_vm._v("Horse Progress Report")]):_vm._e()])]),_vm._v(" "),(_vm.report === 'horse-progress-report')?_c('div',{staticClass:"col-12 col-md-6 col-xl-4 form-group"},[_c('label',{attrs:{"for":"report-horse"}},[_vm._v("Horse")]),_vm._v(" "),_c('app-multiselect',{attrs:{"id":"report-horse","options":_vm.horseOptions,"loading":_vm.horseSearchLoading,"internal-search":false,"placeholder":"Search horses...","label":"name","track-by":"id"},on:{"search-change":_vm.onHorseSearch},model:{value:(_vm.horse),callback:function ($$v) {_vm.horse=$$v},expression:"horse"}})],1):_vm._e(),_vm._v(" "),(_vm.report === 'standings-points')?_c('div',{staticClass:"col-12 col-md-6 col-xl-4"},[_c('season-select',{model:{value:(_vm.year),callback:function ($$v) {_vm.year=$$v},expression:"year"}})],1):_vm._e(),_vm._v(" "),(_vm.report === 'standings-points')?_c('div',{staticClass:"col-12 col-md-6 col-xl-4"},[_c('zone-select',{on:{"loaded":function($event){_vm.zones = $event}},model:{value:(_vm.zone),callback:function ($$v) {_vm.zone=$$v},expression:"zone"}})],1):_vm._e(),_vm._v(" "),(_vm.report === 'results' || _vm.report === 'calendar-of-events')?_c('div',{staticClass:"col-12 col-md-6 col-xl-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"startDate"}},[_vm._v("Date "),_c('small',[_vm._v("(from)")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.calendarFilter.from_date),expression:"calendarFilter.from_date"}],staticClass:"form-control form-date w-100",attrs:{"id":"startDate","type":"date","pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}","max":_vm.calendarFilter.to_date,"required":""},domProps:{"value":(_vm.calendarFilter.from_date)},on:{"change":function($event){_vm.wasValidated = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.calendarFilter, "from_date", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[(_vm.calendarFilter.from_date > _vm.calendarFilter.to_date)?_c('span',[_vm._v("Ensure the \"from\" date is before the \"to\" date.")]):_c('span',[_vm._v("Please include the Date"+_vm._s(_vm.isLegacy() ? ' in the format yyyy-mm-dd' : '')+".")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"endDate"}},[_vm._v("Date "),_c('small',[_vm._v("(to)")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.calendarFilter.to_date),expression:"calendarFilter.to_date"}],staticClass:"form-control form-date w-100",attrs:{"id":"endDate","type":"date","pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}","min":_vm.calendarFilter.from_date,"required":""},domProps:{"value":(_vm.calendarFilter.to_date)},on:{"change":function($event){_vm.wasValidated = true},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.calendarFilter, "to_date", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[(_vm.calendarFilter.from_date > _vm.calendarFilter.to_date)?_c('span',[_vm._v("Ensure the \"from\" date is before the \"to\" date.")]):_c('span',[_vm._v("Please include the Date"+_vm._s(_vm.isLegacy() ? ' in the format yyyy-mm-dd' : '')+".")])])])])])]):(_vm.report === 'profiles' || _vm.report === 'app-import' || _vm.report === 'horse-progress-report')?_c('div',{staticClass:"col-12 col-md-6 col-xl-8"}):(_vm.report && _vm.report !== 'standings-points')?_c('div',{staticClass:"col-12 col-md-6 col-xl-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"year"}},[_vm._v("Reporting Year")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.year),expression:"year"}],staticClass:"form-control pr-5",attrs:{"id":"year"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.year=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.years),function(year,yearIndex){return _c('option',{key:yearIndex,domProps:{"value":year.id}},[_vm._v(_vm._s(year.name))])}),0)])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-primary btn-block-mob mb-3 mb-lg-0 ml-lg-auto",attrs:{"type":"submit","disabled":!_vm.canSubmit}},[(_vm.processing)?_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"spinner-border spinner-border-sm text-light mr-2",attrs:{"role":"status"}}),_vm._v("Downloading\n              ")]):(_vm.report)?_c('span',[_vm._v("Download Report")]):_c('span',[_vm._v("Select a report to proceed")])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue__ = __webpack_require__(386);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73796e04_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__ = __webpack_require__(968);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73796e04_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"className":"post"}},[_c('div',{attrs:{"className":"loading"}},[_vm._v("\n    Loading...\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__ = __webpack_require__(387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e582576_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__(971);
function injectStyle (ssrContext) {
  __webpack_require__(970)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e582576"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e582576_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 970 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('center',[_c('h1',[_vm._v("Not Found!")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"/"}},[_vm._v("Go home?")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JudgeApplication_vue__ = __webpack_require__(388);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0786b9c0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JudgeApplication_vue__ = __webpack_require__(980);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JudgeApplication_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0786b9c0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JudgeApplication_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadBlankAlert_vue__ = __webpack_require__(389);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_846a30c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadBlankAlert_vue__ = __webpack_require__(975);
function injectStyle (ssrContext) {
  __webpack_require__(974)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-846a30c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadBlankAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_846a30c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadBlankAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 974 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-info wrapper"},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"btn btn-block btn-outline-primary button-download mb-2",on:{"click":_vm.openDocument}},[_vm._v("Download Blank Form\n  ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_vm._v(" Please upload completed Application to become an ACA Judge.\n    "),_c('br'),_vm._v("\n    Note – incomplete applications will not be considered.\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JudgeApplicationForm_vue__ = __webpack_require__(390);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b75cc1f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JudgeApplicationForm_vue__ = __webpack_require__(979);
function injectStyle (ssrContext) {
  __webpack_require__(977)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b75cc1f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JudgeApplicationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b75cc1f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JudgeApplicationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 977 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applicationTypes; });
/* unused harmony export applicationStatuses */
var TRIAL_TYPE = 'trial';
var OPEN_TYPE = 'open';
var PENDING_STATUS = 'pending';
var APPROVED_STATUS = 'approved';
var DENIED_STATUS = 'denied';
var applicationTypes = {
  TRIAL_TYPE: TRIAL_TYPE,
  OPEN_TYPE: OPEN_TYPE
};
var applicationStatuses = {
  PENDING_STATUS: PENDING_STATUS,
  APPROVED_STATUS: APPROVED_STATUS,
  DENIED_STATUS: DENIED_STATUS
};

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.errors.length > 0)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},_vm._l((_vm.errors),function(v,k){return _c('div',{key:k},_vm._l((v),function(error){return _c('div',{key:error,staticClass:"text-sm"},[_vm._v("\n        "+_vm._s(error)+"\n      ")])}),0)}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"file-upload-wrapper"},[_c('input',{ref:"fileInput",staticClass:"file-input-hidden",attrs:{"type":"file","accept":"image/*, application/pdf"},on:{"change":_vm.fileUpload}}),_vm._v(" "),_c('button',{staticClass:"btn btn-block mb-2 btn-primary button-upload",on:{"click":function($event){return _vm.$refs.fileInput.click()}}},[_vm._v("Upload Application\n      ")]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please upload file")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6 mb-3 pl-xl-4 form-group file-name"},[_vm._v("\n        "+_vm._s(_vm.file_name || 'Choose file...')+"\n        "),(_vm.file_name)?_c('button',{staticClass:"btn btn-link",attrs:{"type":"button"},on:{"click":_vm.deleteAttachment}},[_c('div',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"}})])])])]):_vm._e()])]),_vm._v(" "),_c('div',{on:{"change":_vm.resetErrors}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":_vm.user_id}},[_vm._v("Member to Apply For")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.user_id),expression:"user_id"}],staticClass:"form-control",attrs:{"id":"user_id","required":"","disabled":!!this.$route.params.member_id},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.user_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_vm._l((_vm.membersSelect),function(member,memberIndex){return _c('option',{key:memberIndex,domProps:{"value":member.id}},[_vm._v(_vm._s(member.name)+"\n          ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('label',{attrs:{"for":_vm.status}},[_vm._v("Status")]),_vm._v(" "),_c('input',{staticClass:"form-control",staticStyle:{"text-transform":"capitalize"},attrs:{"type":"text","id":"status","disabled":""},domProps:{"value":[(_vm.$route.params.member_id) ? _vm.applicationTypes.OPEN_TYPE : _vm.applicationTypes.TRIAL_TYPE]}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group "},[_c('label',[_vm._v("Phone Number")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","required":"","disabled":""},domProps:{"value":_vm.selectedMemberData.phoneNumber}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group "},[_c('label',{attrs:{"for":_vm.additional_email}},[_vm._v("Additional Judge Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.additional_email),expression:"additional_email"}],staticClass:"form-control",attrs:{"type":"text","id":"additional_email"},domProps:{"value":(_vm.additional_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.additional_email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group "},[_c('label',{attrs:{"for":_vm.additional_phone}},[_vm._v("Additional Judge Phone")]),_vm._v(" "),_c('phone-input',{attrs:{"id":"additional_phone"},model:{value:(_vm.additional_phone),callback:function ($$v) {_vm.additional_phone=$$v},expression:"additional_phone"}}),_vm._v(" "),_c('small',[_vm._v("Please enter the phone in a similar format +614 **** **** without spaces")]),_vm._v(" "),_c('test-phone-numbers')],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('label',[_vm._v("Suburb")]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"required":"","disabled":""}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',[_vm._v(_vm._s(_vm.selectedMemberData.suburb))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 pr-xl-4 form-group"},[_c('label',[_vm._v("Zone")]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"required":"","disabled":""}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',[_vm._v(_vm._s(_vm.selectedMemberData.zoneCode))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 form-group"},[_c('div',{staticClass:"form-group form-check px-0 mb-sm-4"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.is_call_first),expression:"is_call_first"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"is_call_first"},domProps:{"checked":Array.isArray(_vm.is_call_first)?_vm._i(_vm.is_call_first,null)>-1:(_vm.is_call_first)},on:{"change":function($event){var $$a=_vm.is_call_first,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.is_call_first=$$a.concat([$$v]))}else{$$i>-1&&(_vm.is_call_first=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.is_call_first=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"is_call_first"}},[_vm._v("\n              I would like to appear on the Call First list on the ACA Judges Register\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-6 small-text"},[_vm._v("\n            By selecting this box you acknowledge you are happy to be approached by committees first who are seeking\n            judges for their event\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 form-group"},[_c('button',{staticClass:"btn btn-block mb-2 btn-primary button-submit",on:{"click":_vm.create}},[_vm._v("Send Application")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',{attrs:{"actionBar":true}},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"h2 mb-0"},[_vm._v("Judge Application")])]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('download-blank'),_vm._v(" "),(_vm.memberDetails)?_c('application-form',{attrs:{"memberDetails":_vm.memberDetails}}):_c('div',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4 flex-grow-1 mr-lg-3"},[_c('div',{staticClass:"text-center p-2"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminJudgeAppsList_vue__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6a9f01a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminJudgeAppsList_vue__ = __webpack_require__(985);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminJudgeAppsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6a9f01a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminJudgeAppsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.row.file_path)?_c('div',{on:{"click":function($event){return _vm.downloadFile(_vm.row.judge_app_id)}}},[_c('svg',{attrs:{"width":"35","height":"35","viewBox":"0 0 35 35","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M33.8022 9.47167L24.8855 0.206309C24.7585 0.0745117 24.5834 0 24.4005 0H11.1107C9.62342 0 8.41339 1.20955 8.41339 2.69623V12.1154H3.02756C1.91481 12.1154 1.00952 13.0204 1.00952 14.1329V24.2326C1.00952 25.345 1.91481 26.25 3.02756 26.25H8.41339V32.3085C8.41339 33.7926 9.62342 35 11.1107 35H31.293C32.7803 35 33.9903 33.7933 33.9903 32.31V9.93843C33.9903 9.76438 33.9229 9.59711 33.8022 9.47167ZM24.5673 1.81706L31.8871 9.42307H24.5673V1.81706ZM3.02756 24.9039C2.65705 24.9039 2.35572 24.6027 2.35572 24.2326V14.1329C2.35572 13.7627 2.65712 13.4615 3.02756 13.4615H21.2031C21.5736 13.4615 21.8749 13.7627 21.8749 14.1329V24.2326C21.8749 24.6027 21.5735 24.9039 21.2031 24.9039H3.02756ZM32.6441 32.31C32.6441 33.051 32.038 33.6539 31.293 33.6539H11.1107C10.3657 33.6539 9.75952 33.0504 9.75952 32.3086V26.25H21.2031C22.3159 26.25 23.2211 25.345 23.2211 24.2326V14.1329C23.2211 13.0204 22.3159 12.1154 21.2031 12.1154H9.75952V2.69623C9.75952 1.95173 10.3657 1.34613 11.1107 1.34613H23.2211V10.0961C23.2211 10.4679 23.5225 10.7692 23.8941 10.7692H32.6441V32.31Z","fill":"#AA2D41"}}),_vm._v(" "),_c('path',{attrs:{"d":"M9.05634 17.0824C8.83287 16.7919 8.55547 16.6032 8.2242 16.5164C8.0086 16.4586 7.54587 16.4297 6.83596 16.4297H4.96265V22.2113H6.13002V20.0304H6.8912C7.41968 20.0304 7.82328 20.0028 8.10198 19.9475C8.30705 19.9028 8.50885 19.8115 8.70737 19.6734C8.90588 19.5354 9.06953 19.3454 9.19839 19.1036C9.32725 18.8617 9.39164 18.5633 9.39164 18.2083C9.39157 17.7482 9.27981 17.3729 9.05634 17.0824ZM8.05659 18.6737C7.96854 18.8026 7.84693 18.8972 7.69175 18.9577C7.53658 19.0182 7.22903 19.0484 6.7689 19.0484H6.13002V17.4078H6.69398C7.11466 17.4078 7.39466 17.4209 7.53398 17.4472C7.72327 17.4814 7.87974 17.5668 8.00327 17.7036C8.12686 17.8403 8.18866 18.0138 8.18866 18.2241C8.18872 18.395 8.14463 18.5449 8.05659 18.6737Z","fill":"#AA2D41"}}),_vm._v(" "),_c('path',{attrs:{"d":"M15.0036 18.0092C14.8774 17.6398 14.6933 17.3276 14.4515 17.0725C14.2096 16.8175 13.919 16.64 13.5799 16.5401C13.3275 16.4665 12.9607 16.4297 12.4796 16.4297H10.3459V22.2113H12.5427C12.9739 22.2113 13.3183 22.1706 13.5759 22.089C13.9204 21.9786 14.1938 21.8248 14.3962 21.6276C14.6644 21.3673 14.8708 21.0269 15.0154 20.6062C15.1338 20.2617 15.1929 19.8516 15.1929 19.3757C15.1929 18.8341 15.1298 18.3786 15.0036 18.0092ZM13.8678 20.3834C13.7889 20.6424 13.687 20.8284 13.5621 20.9414C13.4372 21.0545 13.2801 21.1347 13.0909 21.182C12.9463 21.2188 12.7109 21.2372 12.3849 21.2372H11.5133V17.4078H12.0378C12.5137 17.4078 12.8332 17.4262 12.9962 17.463C13.2144 17.5103 13.3945 17.601 13.5365 17.7351C13.6785 17.8693 13.7889 18.0559 13.8678 18.2951C13.9466 18.5344 13.9861 18.8775 13.9861 19.3245C13.9861 19.7714 13.9466 20.1244 13.8678 20.3834Z","fill":"#AA2D41"}}),_vm._v(" "),_c('path',{attrs:{"d":"M20.1542 17.4078V16.4297H16.1907V22.2113H17.358V19.7543H19.7717V18.7763H17.358V17.4078H20.1542Z","fill":"#AA2D41"}}),_vm._v(" "),_c('path',{attrs:{"d":"M31.4856 27.5495C31.4563 27.4652 31.388 27.4101 31.3122 27.4101H29.2555V21.7724C29.2555 21.6479 29.1714 21.5469 29.0678 21.5469H26.0649C25.9613 21.5469 25.8772 21.6479 25.8772 21.7724V27.4102H23.8127C23.7369 27.4102 23.6685 27.4652 23.6393 27.5491C23.6104 27.6334 23.6261 27.7304 23.6798 27.7949L27.4241 32.3087C27.4594 32.3511 27.5071 32.375 27.557 32.375C27.6069 32.375 27.6546 32.3511 27.6899 32.3091L31.445 27.7953C31.4987 27.7308 31.5148 27.6339 31.4856 27.5495Z","fill":"#AA2D41"}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListAppsTable_vue__ = __webpack_require__(394);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34341e88_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListAppsTable_vue__ = __webpack_require__(984);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListAppsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34341e88_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListAppsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{attrs:{"dataRows":_vm.rows,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{attrs:{"text":row.first_name + ' ' + row.last_name,"link":'Member Profile',"slug":row.id,"row":row,"options":{ showLinks: true, showPrimary: true }}})}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',[_c('strong',[_vm._v("First Name: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.first_name,"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Last Name: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.last_name,"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Judge Application: ")]),_vm._v(" "),_c('tablePdfIconTemplate',{attrs:{"row":row}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Phone number: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.judge_phone === null || row.judge_phone === '' ? row.mobile_phone === null ? row.phone === null ?
            row.secondary_phone : row.phone : row.mobile_phone : row.judge_phone,"row":row}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Suburb: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.suburb,"row":row}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Zone: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":_vm.rowZone(row.zone_id),"row":row}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Judge Status: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.type.charAt(0).toUpperCase() + row.type.substring(1),"row":row}})],1),_vm._v(" "),_c('li',[_c('button',{class:['btn btn-sm mb-2 mb-lg-0 px-lg-3 px-xl-4', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],on:{"click":function($event){$event.preventDefault();return _vm.approve(row.judge_app_id)}}},[_vm._v("\n          "+_vm._s(!_vm.processing ? 'Approve' : '')+"\n          "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])]),_vm._v(" "),_c('li',[_c('button',{class:['btn btn-sm mb-2 mb-lg-0 px-lg-3 px-xl-4', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],on:{"click":function($event){$event.preventDefault();return _vm.deny(row.judge_app_id)}}},[_vm._v("\n          "+_vm._s(!_vm.processing ? 'Deny' : '')+"\n          "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])])])])}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('h1',{staticClass:"h2 mb-3",attrs:{"slot":"heading"},slot:"heading"},[_vm._v("Judges Applications")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.error)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),(_vm.success)?_c('div',{staticClass:"alert alert-success mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.success))]):_vm._e(),_vm._v(" "),_c('listAppsTable')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JudgeAdminDashboard_vue__ = __webpack_require__(395);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7492b70_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JudgeAdminDashboard_vue__ = __webpack_require__(988);
function injectStyle (ssrContext) {
  __webpack_require__(987)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b7492b70"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JudgeAdminDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7492b70_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JudgeAdminDashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 987 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"h2 mb-0"},[_vm._v("Judges")])]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',[_c('h2',{staticClass:"h3 mb-3"},[_vm._v("Judges Applications")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary px-xl-5 mt-2 mt-sm-0 mb-5",attrs:{"tag":"button","to":{ name: 'Admin Judges Applications List' }}},[_vm._v("\n            Manage Applications\n        ")])],1),_vm._v(" "),_c('div',[_c('h2',{staticClass:"h3 mb-3"},[_vm._v("List of Judges")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary px-xl-5 mt-2 mt-sm-0 mb-5",attrs:{"tag":"button","to":{ name: 'Judges list' }}},[_vm._v("\n            View List\n        ")])],1),_vm._v(" "),_c('div',[_c('h2',{staticClass:"h3 mb-3"},[_vm._v("Judge Surveys")]),_vm._v(" "),(_vm.loaded)?_c('div',{staticClass:"drafts"},[(_vm.drafts && _vm.drafts.length)?_c('div',_vm._l((_vm.drafts),function(draft){return _c('div',{staticClass:"draft"},[_c('div',{staticClass:"draft-name m-2 m-md-0"},[_vm._v("\n              "+_vm._s(draft.name)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('button',{staticClass:"btn btn-primary px-xl-5 m-1 my-md-0 mr-2",attrs:{"disabled":_vm.processing},on:{"click":function($event){return _vm.downloadPdf(draft.id)}}},[(_vm.processing)?_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"spinner-border spinner-border-sm text-light mr-2",attrs:{"role":"status"}})]):_c('div',[_vm._v("\n                  Download PDF\n                ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary px-xl-5 m-1 my-md-0 mr-2",attrs:{"disabled":_vm.processing},on:{"click":function($event){return _vm.downloadCsv(draft.id)}}},[(_vm.processing)?_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"spinner-border spinner-border-sm text-light mr-2",attrs:{"role":"status"}})]):_c('div',[_vm._v("\n                  Download CSV\n                ")])])])])}),0):_c('div',[_vm._v("\n          There are no reports.\n        ")])]):_c('div',{staticClass:"loader"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminJudgesList_vue__ = __webpack_require__(396);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69483d83_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminJudgesList_vue__ = __webpack_require__(991);
function injectStyle (ssrContext) {
  __webpack_require__(990)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminJudgesList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69483d83_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminJudgesList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 990 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('h1',{staticClass:"h2 mb-3",attrs:{"slot":"heading"},slot:"heading"},[_vm._v("List of Judges")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.success)?_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.success))]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('data-table',{attrs:{"dataRows":_vm.rows,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{attrs:{"text":row.first_name + ' ' + row.last_name,"link":'Member Profile',"slug":row.id,"row":row,"options":{ showLinks: true, showPrimary: true }}})}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',[_c('strong',[_vm._v("First Name: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.first_name,"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Last Name: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.last_name,"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Phone number: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.judge_phone === null || row.judge_phone === '' ? row.mobile_phone === null ? row.phone === null ?
                row.secondary_phone : row.phone : row.mobile_phone : row.judge_phone,"row":row}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Suburb: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.suburb,"row":row}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Zone: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":_vm.rowZone(row.zone_id),"row":row}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Judge Status: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.status.charAt(0).toUpperCase() + row.status.substring(1),"row":row}})],1),_vm._v(" "),_c('li',[_c('div',{staticClass:"judges-list__actions"},[(!row.is_suspended)?_c('div',{staticClass:"mr-1"},[_c('button',{class:['btn btn-sm mb-2 mb-lg-0', !_vm.processing ? 'btn-primary actions-suspend' : 'btn-primary-dark'],on:{"click":function($event){$event.preventDefault();return _vm.suspendModal($event)}}},[_vm._v("\n                  "+_vm._s(!_vm.processing ? 'Suspend' : '')+"\n                  "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]),_vm._v(" "),(_vm.showSuspendModal)?_c('modal',{on:{"close":function($event){_vm.showSuspendModal = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning text-center"},[_vm._v("\n                      You are about to suspend the judge "+_vm._s(row.first_name)+".\n                      Are you sure?\n                    ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.showSuspendModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary ml-2",on:{"click":function($event){$event.preventDefault();_vm.suspend(row.id);_vm.showSuspendModal = false}}},[_vm._v("Confirm")])])])]):_vm._e()],1):_c('div',{staticClass:"mr-1"},[_c('button',{class:['btn btn-sm mb-2 mb-lg-0', !_vm.processing ? 'btn-outline-primary actions-end_suspension' : 'btn-primary-dark'],on:{"click":function($event){$event.preventDefault();return _vm.endSuspensionModal($event)}}},[_vm._v("\n                  "+_vm._s(!_vm.processing ? 'End Suspension' : '')+"\n                  "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]),_vm._v(" "),(_vm.showEndSuspensionModal)?_c('modal',{on:{"close":function($event){_vm.showEndSuspensionModal = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning text-center"},[_vm._v("\n                      You are about to end suspension the judge "+_vm._s(row.first_name)+".\n                      Are you sure?\n                    ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.showEndSuspensionModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary ml-2",on:{"click":function($event){$event.preventDefault();_vm.endSuspension(row.id);_vm.showEndSuspensionModal = false}}},[_vm._v("Confirm")])])])]):_vm._e()],1),_vm._v(" "),_c('div',[_c('button',{class:['btn btn-sm mb-2 mb-lg-0 actions-remove', !_vm.processing ? row.is_suspend ? 'btn-primary actions-end_suspension' : 'btn-primary' : 'btn-primary-dark'],on:{"click":function($event){$event.preventDefault();return _vm.removeModal($event)}}},[_vm._v("\n                  "+_vm._s(!_vm.processing ? 'Remove' : '')+"\n                  "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()]),_vm._v(" "),(_vm.showModal)?_c('modal',{on:{"close":function($event){_vm.showModal = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"alert alert-warning text-center"},[_vm._v("\n                      You are about to remove the judge "+_vm._s(row.first_name)+".\n                      Are you sure?\n                    ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.showModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary ml-2",on:{"click":function($event){$event.preventDefault();_vm.remove(row.id);_vm.showModal = false}}},[_vm._v("Confirm")])])])]):_vm._e()],1)])])])])}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Judges_vue__ = __webpack_require__(397);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f95fb9fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Judges_vue__ = __webpack_require__(995);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Judges_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f95fb9fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Judges_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicLayout_vue__ = __webpack_require__(398);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b047676_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicLayout_vue__ = __webpack_require__(994);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b047676_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"container-fluid flex-grow-1 d-flex bg-lighter"},[_c('div',{staticClass:"row flex-grow-1 mt-5"},[_c('div',{staticClass:"col px-4"},[_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_vm._t("heading"),_vm._v(" "),_vm._t("content")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('public-layout',[_c('h1',{staticClass:"h2 mb-3",attrs:{"slot":"heading"},slot:"heading"},[_vm._v("Judges")]),_vm._v(" "),_c('div',{staticClass:"public-judges",attrs:{"slot":"content"},slot:"content"},[(_vm.error)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('h3',[_vm._v("Call First List")]),_vm._v(" "),_c('data-table',{attrs:{"dataRows":_vm.callFirstJudges,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{staticClass:"js-parity",attrs:{"data-parity":row.parity,"text":row.first_name + ' ' + row.last_name,"link":'Member Profile',"slug":row.id,"row":row}})}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{staticClass:"js-parity",attrs:{"data-parity":row.parity}},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',[_c('strong',[_vm._v("Status: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.status.charAt(0).toUpperCase() + row.status.substring(1),"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Contact: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.phone,"row":row,"mobile":row.phone,"options":{ inline: true, isMobile: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Suburb: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.suburb,"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Zone: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":_vm.$store.state.listZones.filter(function (zone) { return zone.id === row.zone_id; }).length > 0 ? _vm.$store.state.listZones.filter(function (zone) { return zone.id === row.zone_id; })[0].code : 'Unspecified',"row":row,"options":{ inline: true }}})],1)])])}}])}),_vm._v(" "),_c('h3',{staticClass:"mt-4"},[_vm._v("Entire ACA Judges Panel")]),_vm._v(" "),_c('data-table',{attrs:{"dataRows":_vm.entireJudges,"dataColumns":_vm.columns,"options":_vm.options,"id":"entireAacJudgesPanel"},scopedSlots:_vm._u([{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{staticClass:"js-parity",attrs:{"data-parity":row.parity,"text":row.first_name + ' ' + row.last_name,"link":'Member Profile',"slug":row.id,"row":row}})}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',[_c('strong',[_vm._v("Status: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.status.charAt(0).toUpperCase() + row.status.substring(1),"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Contact: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.phone,"row":row,"mobile":row.phone,"options":{ inline: true, isMobile: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Suburb: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.suburb,"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Zone: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":_vm.$store.state.listZones.filter(function (zone) { return zone.id === row.zone_id; }).length > 0 ? _vm.$store.state.listZones.filter(function (zone) { return zone.id === row.zone_id; })[0].code : 'Unspecified',"row":row,"options":{ inline: true }}})],1)])])}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpressionInterest_vue__ = __webpack_require__(399);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ad79b10_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpressionInterest_vue__ = __webpack_require__(998);
function injectStyle (ssrContext) {
  __webpack_require__(997)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpressionInterest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ad79b10_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExpressionInterest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 997 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',{attrs:{"actionBar":true}},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"h2 mb-0"},[_vm._v("Expression Of Interest")])]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.success !== '')?_c('div',{staticClass:"alert alert-success mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.success))]):(_vm.errors !== '')?_c('div',{staticClass:"alert alert-warning mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors))]):_vm._e(),_vm._v(" "),(_vm.loaded)?_c('div',{staticClass:"expression-interest"},[(_vm.drafts.length > 0)?_c('div',{staticClass:"drafts"},_vm._l((_vm.drafts),function(draft){return _c('div',{key:draft.id,staticClass:"draft"},[_c('div',{staticClass:"draft_header table table-bordered p-3 bg-lighter justify-content-between align-items-center d-flex"},[_c('div',{staticClass:"draft-info"},[_c('div',{staticClass:"d-flex flex-wrap align-content-center"},[_c('h2',{staticClass:"h5 mr-2"},[_vm._v("\n                  "+_vm._s(draft.name)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"dates d-flex"},[_c('div',{staticClass:"start_date mr-3"},[_c('span',{staticClass:"font-weight-bolder"},[_vm._v("Start Date: ")]),_vm._v(" "+_vm._s(draft.start_date)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"finish_date"},[_c('span',{staticClass:"font-weight-bolder"},[_vm._v("Finish Date: ")]),_vm._v(" "+_vm._s(draft.end_date)+"\n                ")])])]),_vm._v(" "),_c('button',{staticClass:"btn-default btn-small btn btn-sm btn-primary btn-cancel_application",on:{"click":function($event){return _vm.takeInterest(draft.id, _vm.judgeId)}}},[_vm._v("Submit")])])])}),0):_c('div',{staticClass:"alert alert-warning rounded-0 mb-0"},[_vm._v("There are no results.")])]):_c('div',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4 flex-grow-1 mr-lg-3"},[_c('div',{staticClass:"text-center p-2"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActiveDrafts_vue__ = __webpack_require__(400);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ec63584_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActiveDrafts_vue__ = __webpack_require__(1001);
function injectStyle (ssrContext) {
  __webpack_require__(1000)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActiveDrafts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ec63584_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActiveDrafts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1000 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',{attrs:{"actionBar":true}},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"h2 mb-0"},[_vm._v("Active Drafts")])]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.success)?_c('div',{staticClass:"alert alert-success mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.success))]):(_vm.errors)?_c('div',{staticClass:"alert alert-warning mt-3",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors))]):_vm._e(),_vm._v(" "),(_vm.loaded)?_c('div',{staticClass:"active-drafts"},[(_vm.applications.length > 0)?_c('div',{staticClass:"drafts"},_vm._l((_vm.applications),function(application){return _c('div',{key:application.id,staticClass:"draft"},[_c('div',{staticClass:"draft_header table table-bordered p-3 bg-lighter justify-content-between align-items-center d-flex"},[_c('div',{staticClass:"draft-info"},[_c('div',{staticClass:"d-flex flex-wrap align-content-center"},[_c('h2',{staticClass:"h5 mr-2"},[_vm._v("\n                  "+_vm._s(application.draft.name)+"\n                ")]),_vm._v(" "),_c('span',{class:['badge mt-0 mb-auto', application.status === 'denied' ? 'alert-danger' : (application.status === 'approved' ? 'alert-success' : 'alert-warning')]},[_vm._v(_vm._s(application.status))])]),_vm._v(" "),_c('div',{staticClass:"dates d-flex"},[_c('div',{staticClass:"start_date mr-3"},[_c('span',{staticClass:"font-weight-bolder"},[_vm._v("Start Date: ")]),_vm._v(" "+_vm._s(application.draft.start_date)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"finish_date"},[_c('span',{staticClass:"font-weight-bolder"},[_vm._v("Finish Date: ")]),_vm._v(" "+_vm._s(application.draft.end_date)+"\n                ")])])]),_vm._v(" "),_c('button',{staticClass:"btn-default btn-small btn btn-sm btn-outline-primary btn-cancel_application",on:{"click":function($event){return _vm.cancelApplication(application.id)}}},[_vm._v("Cancel")])])])}),0):_c('div',{staticClass:"alert alert-warning rounded-0 mb-0"},[_vm._v("There are no results.")])]):_c('div',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4 flex-grow-1 mr-lg-3"},[_c('div',{staticClass:"text-center p-2"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JudgeSecretaryDashboard_vue__ = __webpack_require__(401);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75b03c3c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JudgeSecretaryDashboard_vue__ = __webpack_require__(1003);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JudgeSecretaryDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75b03c3c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JudgeSecretaryDashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"h2 mb-0"},[_vm._v("Judges")])]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',[_c('h2',{staticClass:"h3 mb-3"},[_vm._v("Pending Expressions of Interest")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary px-xl-5 mt-2 mt-sm-0 mb-5",attrs:{"tag":"button","to":{ name: 'Pending Expression Of Interest' }}},[_vm._v("\n        Manage Expressions\n      ")])],1),_vm._v(" "),_c('div',[_c('h2',{staticClass:"h3 mb-3"},[_vm._v("Approved Expressions of Interest")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary px-xl-5 mt-2 mt-sm-0 mb-5",attrs:{"tag":"button","to":{ name: 'Approved Expression Of Interest' }}},[_vm._v("\n        View Lists\n      ")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PendingExpressionInterest_vue__ = __webpack_require__(402);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_842e26f6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PendingExpressionInterest_vue__ = __webpack_require__(1006);
function injectStyle (ssrContext) {
  __webpack_require__(1005)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PendingExpressionInterest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_842e26f6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PendingExpressionInterest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1005 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"h2 mb-0"},[_vm._v("Pending Expressions Of Interest")])]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.success)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.success))]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('data-table',{attrs:{"dataRows":_vm.rows,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{attrs:{"text":row.first_name + ' ' + row.last_name,"link":'Member Profile',"slug":row.user_id,"row":row,"options":{ showLinks: true }}})}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',[_c('strong',[_vm._v("Draft Name: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.draft_name,"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Phone Number: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.phone,"row":row,"mobile":row.phone,"options":{ isMobile: true, inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Suburb: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.suburb,"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Zone: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":_vm.$store.state.listZones.filter(function (zone) { return zone.id === row.zone_id; }).length > 0 ? _vm.$store.state.listZones.filter(function (zone) { return zone.id === row.zone_id; })[0].code : 'Unspecified',"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Judge Status: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.status,"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('div',{staticClass:"d-flex flex-wrap mt-2"},[_c('div',{staticClass:"mr-1"},[_c('button',{staticClass:"btn-default btn-small btn btn-sm btn-primary btn-actions mr-2 mb-2",attrs:{"disabled":_vm.processing},on:{"click":function($event){return _vm.approveApplication(row.id)}}},[(_vm.processing)?_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"spinner-border spinner-border-sm text-light mr-2",attrs:{"role":"status"}})]):_c('div',[_vm._v("\n                    Approve\n                  ")])])]),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn-default btn-small btn btn-sm btn-primary btn-actions mr-2",on:{"click":function($event){return _vm.denyApplication(row.id)}}},[(_vm.processing)?_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"spinner-border spinner-border-sm text-light mr-2",attrs:{"role":"status"}})]):_c('div',[_vm._v("\n                    Deny\n                  ")])])])])])])])}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApprovedExpressionInterest_vue__ = __webpack_require__(403);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c548338_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApprovedExpressionInterest_vue__ = __webpack_require__(1012);
function injectStyle (ssrContext) {
  __webpack_require__(1008)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApprovedExpressionInterest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c548338_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApprovedExpressionInterest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1008 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraftAndEvents_vue__ = __webpack_require__(404);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc0b4cc6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DraftAndEvents_vue__ = __webpack_require__(1011);
function injectStyle (ssrContext) {
  __webpack_require__(1010)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraftAndEvents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc0b4cc6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DraftAndEvents_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1010 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"draft d-flex flex-wrap justify-content-between"},[_c('div',{staticClass:"draft-info"},[_c('div',{staticClass:"draft-name font-weight-bold"},[_c('span',{staticClass:"draft-label d-none"},[_vm._v("Draft Name: ")]),_vm._v(" "+_vm._s(_vm.draft.name)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"events"},[(_vm.draft.events && _vm.draft.events.length > 0)?_c('span',{staticClass:"events-label d-none font-weight-bold"},[_vm._v("Events: ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.draft.events),function(event){return _c('div',{staticClass:"event"},[_c('div',{staticClass:"event_name"},[_vm._v("\n          "+_vm._s(event.name)+"\n        ")])])})],2)]),_vm._v(" "),_c('div',{staticClass:"actions"},[(_vm.draftApplication.status === 'approved')?_c('div',{staticClass:"edit-events",on:{"click":function($event){return _vm.openModal()}}},[_c('svg',{attrs:{"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('rect',{attrs:{"width":"19","height":"19","fill":"url(#pattern0)"}}),_vm._v(" "),_c('defs',[_c('pattern',{attrs:{"id":"pattern0","patternContentUnits":"objectBoundingBox","width":"1","height":"1"}},[_c('use',{attrs:{"xlink:href":"#image0_1405_1933","transform":"translate(-3.38095 -4.33333) scale(0.047619)"}})]),_vm._v(" "),_c('image',{attrs:{"id":"image0_1405_1933","width":"153","height":"149","xlink:href":"data:image/png;base64,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"}})])])]):_vm._e()]),_vm._v(" "),(_vm.showModal)?_c('div',{staticClass:"events-modal ml-2 mr-2"},[_c('div',{staticClass:"block"},[_c('div',{staticClass:"actions"},[_c('div',{staticClass:"cancel-btn",on:{"click":function($event){return _vm.closeModal()}}},[_c('svg',{attrs:{"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.3889 20.7778C4.64444 20.7778 0 16.1333 0 10.3889C0 4.64444 4.64444 0 10.3889 0C16.1333 0 20.7778 4.64444 20.7778 10.3889C20.7778 16.1333 16.1333 20.7778 10.3889 20.7778ZM10.3889 1.22222C5.37778 1.22222 1.22222 5.37778 1.22222 10.3889C1.22222 15.4 5.37778 19.5556 10.3889 19.5556C15.4 19.5556 19.5556 15.4 19.5556 10.3889C19.5556 5.37778 15.4 1.22222 10.3889 1.22222Z","fill":"#AA2D41"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12.9555 13.5669C12.8332 13.5669 12.5888 13.5669 12.4666 13.4447L7.33324 8.31135C7.08879 8.06691 7.08879 7.70024 7.33324 7.45579C7.57768 7.21135 7.94435 7.21135 8.18879 7.45579L13.3221 12.5891C13.5666 12.8336 13.5666 13.2002 13.3221 13.4447C13.1999 13.4447 13.0777 13.5669 12.9555 13.5669Z","fill":"#AA2D41"}}),_vm._v(" "),_c('path',{attrs:{"d":"M7.82212 13.5669C7.6999 13.5669 7.45546 13.5669 7.33324 13.4447C7.08879 13.2002 7.08879 12.8336 7.33324 12.5891L12.4666 7.45579C12.711 7.21135 13.0777 7.21135 13.3221 7.45579C13.5666 7.70024 13.5666 8.06691 13.3221 8.31135L8.18879 13.4447C8.18879 13.4447 7.94435 13.5669 7.82212 13.5669Z","fill":"#AA2D41"}})])])]),_vm._v(" "),(_vm.modalSuccess)?_c('div',{staticClass:"alert alert-success mt-1"},[_vm._v(_vm._s(_vm.modalSuccess))]):_vm._e(),_vm._v(" "),(_vm.modalError)?_c('div',{staticClass:"alert alert-warning mt-1"},[_vm._v(_vm._s(_vm.modalError))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"header"},[_c('h4',{staticClass:"h6"},[_vm._v("Assign a Judge for Events")]),_vm._v(" "),_c('div',{staticClass:"mb-1"},[_vm._v("Judge: "+_vm._s(_vm.user.first_name + ' ' + _vm.user.last_name))])]),_vm._v(" "),_c('div',{staticClass:"events"},[_c('div',{staticClass:"draft_header table table-bordered p-2 bg-lighter justify-content-between align-items-center d-flex mb-0"},[_c('div',{staticClass:"draft-info"},[_c('div',{staticClass:"d-flex flex-wrap align-content-center mb-1"},[_c('div',{staticClass:"font-weight-bolder mr-2"},[_vm._v("\n                "+_vm._s(_vm.draft.name)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"dates d-flex"},[_c('div',{staticClass:"start_date mr-3"},[_c('span',{staticClass:"font-weight-bolder"},[_vm._v("Start Date: ")]),_vm._v(" "+_vm._s(_vm.draft.start_date)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"finish_date"},[_c('span',{staticClass:"font-weight-bolder"},[_vm._v("Finish Date: ")]),_vm._v(" "+_vm._s(_vm.draft.end_date)+"\n              ")])])])]),_vm._v(" "),(_vm.loaded)?_c('div',{staticClass:"event-list mb-5"},[_c('ul',{staticClass:"table table-bordered"},_vm._l((_vm.eventList),function(event){return _c('li',[_c('div',{staticClass:"event-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.assignEvents),expression:"assignEvents"}],attrs:{"type":"checkbox","name":"event[]","id":("event_" + (event.id))},domProps:{"value":event.id,"checked":Array.isArray(_vm.assignEvents)?_vm._i(_vm.assignEvents,event.id)>-1:(_vm.assignEvents)},on:{"change":function($event){var $$a=_vm.assignEvents,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=event.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.assignEvents=$$a.concat([$$v]))}else{$$i>-1&&(_vm.assignEvents=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.assignEvents=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"mb-0",attrs:{"for":("event_" + (event.id))}},[_vm._v(_vm._s(event.name))])])])}),0)]):_c('div',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4 flex-grow-1 mr-lg-3"},[_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"footer d-flex justify-content-center"},[_c('div',[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":_vm.cancelAssignJudge}},[_vm._v("\n              Cancel\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.eventList.length === 0 || _vm.processing},on:{"click":function($event){return _vm.assignJudgeToEvents(_vm.user.judge_id, _vm.draft.id, _vm.assignEvents)}}},[(_vm.processing)?_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"spinner-border spinner-border-sm text-light mr-2",attrs:{"role":"status"}})]):_c('div',[_vm._v("\n                Assign\n              ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"mask",on:{"click":function($event){return _vm.closeModal()}}})]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center p-2"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"h2 mb-0"},[_vm._v("Approved Expressions Of Interest")])]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.success)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.success))]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('data-table',{attrs:{"dataRows":_vm.rows,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{attrs:{"text":row.user.first_name + ' ' + row.user.last_name,"link":'Member Profile',"slug":row.user.user_id,"row":row,"options":{ showLinks: true }}})}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',[_c('strong',[_vm._v("Phone Number: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.user.phone,"row":row,"mobile":row.phone,"options":{ isMobile: true, inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Suburb: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.user.suburb,"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Zone: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":_vm.$store.state.listZones.filter(function (zone) { return zone.id === row.user.zone_id; }).length > 0 ? _vm.$store.state.listZones.filter(function (zone) { return zone.id === row.user.zone_id; })[0].code : 'Unspecified',"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Judge Status: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.user.status,"row":row,"options":{ inline: true }}})],1),_vm._v(" "),(row.draft_application.status === 'cancelByJudge')?_c('li',[_c('strong',[_vm._v("Expression Status: ")]),_vm._v(" "),_c('span',{class:['badge ml-1 my-auto alert-warning']},[_vm._v("Cancelled")])]):_vm._e(),_vm._v(" "),_c('li',[_c('DraftAndEvents',{attrs:{"data":row}})],1)])])}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Survey_vue__ = __webpack_require__(405);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5365e9b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Survey_vue__ = __webpack_require__(1015);
function injectStyle (ssrContext) {
  __webpack_require__(1014)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5365e9b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Survey_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5365e9b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Survey_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1014 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('h1',{staticClass:"h2 mb-3",attrs:{"slot":"heading"},slot:"heading"},[_vm._v("Judge Survey")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.error)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.error))]):(_vm.success)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.success))]):_vm._e(),_vm._v(" "),(_vm.loaded)?_c('div',[(!_vm.closed)?_c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.sendSurveyResults($event)}}},[_c('div',{staticClass:"responding-judge mb-3"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.respondingJudgeId),expression:"respondingJudgeId"}],class:['form-control'],attrs:{"name":"responding_judge_id","id":"select_responding_judge","required":!_vm.respondingJudgeId},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.respondingJudgeId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.judges),function(judge){return _c('option',{domProps:{"value":judge.id}},[_vm._v(_vm._s(judge.user.first_name)+" "+_vm._s(judge.user.last_name))])}),0)]),_vm._v(" "),(_vm.respondingJudgeId)?_c('div',[(_vm.surveyLoaded)?_c('div',[(_vm.surveys.length)?_c('div',{staticClass:"surveys"},[_vm._l((_vm.surveys),function(draft,draftKey){return _c('div',{staticClass:"draft"},[_c('div',[_c('h2',{staticClass:"h3 mb-3",attrs:{"slot":"heading"},slot:"heading"},[_vm._v(_vm._s(draft.draft.name))]),_vm._v(" "),_vm._l((draft.events),function(survey){return _c('div',{staticClass:"mb-2"},_vm._l((survey.event.judges),function(judge){return _c('div',[(judge.id !== _vm.respondingJudgeId && _vm.showJudge(survey, _vm.respondingJudgeId, judge.id, draftKey))?_c('div',{staticClass:"event"},[_c('h3',{staticClass:"h4 mb-2 font-weight-bold",attrs:{"slot":"heading"},slot:"heading"},[_vm._v(_vm._s(survey.event.name)+", "+_vm._s(judge.user.first_name)+" "+_vm._s(judge.user.last_name))]),_vm._v(" "),_vm._l((_vm.surveyQuestions),function(question,questionKey){return _c('div',{staticClass:"questions"},[_c('div',{staticClass:"number"},[_c('span',[_vm._v(_vm._s(Number(questionKey) + 1))])]),_vm._v(" "),_c('div',{staticClass:"question"},[_c('div',{staticClass:"question-text"},[_vm._v(_vm._s(_vm.getQuestionText(survey, judge.id, question)))]),_vm._v(" "),_c('div',{staticClass:"answers d-flex"},_vm._l((question.answers),function(answer){return _c('div',{staticClass:"answer"},[_c('div',{staticClass:"answer-info"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userAnswers[survey.id].events[survey.event_id].judges[judge.id].questions[question.id]),expression:"userAnswers[survey.id].events[survey.event_id].judges[judge.id].questions[question.id]"}],class:['input-answer custom-control-input'],attrs:{"type":"radio","id":("answer[" + (survey.event.id) + "][" + (judge.id) + "][" + (question.id) + "][" + (answer.id) + "]"),"name":("answer[" + (survey.event.id) + "][" + (judge.id) + "][" + (question.id) + "]"),"required":""},domProps:{"value":answer.id,"checked":_vm._q(_vm.userAnswers[survey.id].events[survey.event_id].judges[judge.id].questions[question.id],answer.id)},on:{"change":[function($event){return _vm.$set(_vm.userAnswers[survey.id].events[survey.event_id].judges[judge.id].questions, question.id, answer.id)},function($event){return _vm.updateUserAnswers(survey, judge.id, question.id)}]}}),_vm._v(" "),_c('label',{attrs:{"for":("answer[" + (survey.event.id) + "][" + (judge.id) + "][" + (question.id) + "][" + (answer.id) + "]")}},[_vm._v("\n                                      "+_vm._s(answer.answer)+"\n                                    ")])])])}),0),_vm._v(" "),_c('div',{staticClass:"additional-questions"},_vm._l((_vm.getAdditionalQuestions(question)),function(additionalQuestion){return _c('div',{staticClass:"additional-question"},[(_vm.showAdditionalQuestions(survey, judge.id, additionalQuestion))?_c('div',[_c('label',{staticClass:"question-text",attrs:{"for":("answer[" + (survey.event.id) + "][" + (judge.id) + "][" + (additionalQuestion.id) + "]")}},[_vm._v("\n                                      "+_vm._s(_vm.getQuestionText(survey, judge.id, additionalQuestion))+"\n                                    ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.userAnswers[survey.id].events[survey.event_id].judges[judge.id].questions[additionalQuestion.id]),expression:"userAnswers[survey.id].events[survey.event_id].judges[judge.id].questions[additionalQuestion.id]"}],class:['form-control'],attrs:{"id":("answer[" + (survey.event.id) + "][" + (judge.id) + "][" + (additionalQuestion.id) + "]"),"name":("answer[" + (survey.event.id) + "][" + (judge.id) + "][" + (additionalQuestion.id) + "]"),"placeholder":"Enter an answer","required":_vm.isQuestionRequired(survey, judge.id, additionalQuestion)},domProps:{"value":(_vm.userAnswers[survey.id].events[survey.event_id].judges[judge.id].questions[additionalQuestion.id])},on:{"change":function($event){return _vm.updateUserAnswers(survey, judge.id, additionalQuestion.id, 1)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userAnswers[survey.id].events[survey.event_id].judges[judge.id].questions, additionalQuestion.id, $event.target.value)}}})]):_vm._e()])}),0)])])})],2):_vm._e()])}),0)})],2)])}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("Submit Survey")])],2):_c('div',[_vm._v("\n                There are no surveys for this judge.\n              ")])]):_c('div',{staticClass:"loader"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])]):_vm._e()])]):_c('div',[_vm._v("\n        Sorry, the survey has already been closed.\n      ")])]):_c('div',{staticClass:"loader"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drafts_vue__ = __webpack_require__(406);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cde78f7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Drafts_vue__ = __webpack_require__(1021);
function injectStyle (ssrContext) {
  __webpack_require__(1017)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2cde78f7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drafts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cde78f7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Drafts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1017 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasBanners)?_c('div',{staticClass:"leaderboard__header"},[_c('div',{staticClass:"top-banners"},[(_vm.appearances.sponsor_logo_1)?_c('div',{staticClass:"banner logo"},[(_vm.appearances.sponsor_logo_1_link)?_c('a',{attrs:{"href":_vm.appearances.sponsor_logo_1_link,"target":"_blank"}},[_c('img',{attrs:{"src":("" + (_vm.appearances.sponsor_logo_1))}})]):_c('img',{attrs:{"src":("" + (_vm.appearances.sponsor_logo_1))}})]):_vm._e(),_vm._v(" "),(_vm.appearances.sponsor_logo_2)?_c('div',{staticClass:"banner logo"},[(_vm.appearances.sponsor_logo_2_link)?_c('a',{attrs:{"href":_vm.appearances.sponsor_logo_2_link,"target":"_blank"}},[_c('img',{attrs:{"src":("" + (_vm.appearances.sponsor_logo_2))}})]):_c('img',{attrs:{"src":("" + (_vm.appearances.sponsor_logo_2))}})]):_vm._e()]),_vm._v(" "),(_vm.appearances.sponsor_logo_3)?_c('div',{staticClass:"banner"},[(_vm.appearances.sponsor_logo_3_link)?_c('a',{attrs:{"href":_vm.appearances.sponsor_logo_3_link,"target":"_blank"}},[_c('img',{attrs:{"src":("" + (_vm.appearances.sponsor_logo_3))}})]):_c('img',{attrs:{"src":("" + (_vm.appearances.sponsor_logo_3))}})]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.appearances.sponsor_logo_desktop)?_c('div',{staticClass:"desktop-banner"},[_c('div',{staticClass:"__image"},[_c('img',{attrs:{"src":("" + (_vm.appearances.sponsor_logo_desktop))}})]),_vm._v(" "),_c('div',{staticClass:"__button"},[(_vm.computedUrl)?_c('a',{staticClass:"dynamic-color-schema nominate__click btn-primary btn btn-sm btn-block",style:({ '--apperances-color': _vm.appearances.schema_color || 'var(--primary)' }),attrs:{"href":_vm.computedUrl,"target":"_blank"}},[_vm._v("\n       More details\n     ")]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',{style:({ '--apperances-color': _vm.appearances && _vm.appearances.schema_color ? _vm.appearances.schema_color : 'var(--primary)' }),attrs:{"no-sm-padding":""}},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"nominate__title h2 mb-3"},[_vm._v("In-progress and Past Drafts")])]),_vm._v(" "),_c('div',{staticClass:"leaders",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"leaderboard nominate bg-white rounded"},[(_vm.success)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.success))]):_vm._e(),_vm._v(" "),_c('appearances-drafts-header',{attrs:{"appearances":_vm.appearances}}),_vm._v(" "),_c('div',{staticClass:"__container nominate__item _type-other-drafts"},[_c('appearances-drafts-desktop-banner',{attrs:{"appearances":_vm.appearances}}),_vm._v(" "),_vm._l((_vm.draftsList),function(draft){return _c('div',{key:draft.id,staticClass:"draft"},[_c('div',{staticClass:"nominate__item-wrap-name"},[_vm._v("\n            "+_vm._s(draft.name)+"\n          ")]),_vm._v("\n          Starts: "+_vm._s(_vm.formatDate(draft.start_date))+"\n          "),_c('router-link',{staticClass:"nominate__click btn btn-outline-primary btn-sm btn-block",style:({ '--apperances-color': _vm.appearances.schema_color || 'var(--primary)' }),attrs:{"to":{
              name: 'LeadersDraft',
              params: { draft_id: draft.id }
            }}},[_vm._v("\n            View results\n          ")])],1)})],2),_vm._v(" "),_c('div',{staticClass:"footer"})],1),_vm._v(" "),(_vm.totalPages)?_c('pagination',{staticClass:"paginate-leaderboard",attrs:{"page":_vm.currentPage,"total-pages":_vm.totalPages,"on-change":_vm.handlePageChange,"color":_vm.appearances.schema_color}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Draft_vue__ = __webpack_require__(409);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_918bd00c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Draft_vue__ = __webpack_require__(1044);
function injectStyle (ssrContext) {
  __webpack_require__(1023)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-918bd00c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Draft_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_918bd00c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Draft_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1023 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"leaders__stat",style:({ '--apperances-color': _vm.computedColor })},[_c('div',{staticClass:"leaders__stat-item"},[_c('div',{staticClass:"leaders__stat-numbers"},[_vm._v("\n      "+_vm._s(_vm.leader ? (_vm.leader.average_score ? _vm.leader.average_score : _vm.leader.average_total) : 'N/A')+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"leaders__stat-info"},[_c('span',[_vm._v("\n        "+_vm._s(_vm.leader && _vm.leader.member_name ? _vm.leader.member_name : 'None Available')+" \n        ("+_vm._s(_vm.leader && _vm.leader.total_runs ? _vm.leader.total_runs : 0)+" runs)\n      ")]),_vm._v(" "),_c('small',[_vm._v("Highest Average from "+_vm._s(_vm.scores && _vm.scores.competitors_count ? _vm.scores.competitors_count : 0)+" competitors")])])]),_vm._v(" "),_c('div',{staticClass:"leaders__stat-item"},[_c('div',{staticClass:"leaders__stat-numbers"},[_vm._v("\n      "+_vm._s(_vm.statistics.outsideScorePercentage)+"%\n    ")]),_vm._v(" "),_c('div',{staticClass:"leaders__stat-info"},[_c('span',[_vm._v("Outside scores")]),_vm._v(" "),_c('small',[_vm._v("\n        "+_vm._s(_vm.scores && _vm.scores.outside_score_noms_count ? _vm.scores.outside_score_noms_count : 0)+" \n        out of "+_vm._s(_vm.scores && _vm.scores.full_runs_count ? _vm.scores.full_runs_count : 0)+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"leaders__stat-item"},[_c('div',{staticClass:"leaders__stat-numbers"},[_vm._v("\n    "+_vm._s(_vm.statistics.courseScorePercentage)+"%\n    ")]),_vm._v(" "),_c('div',{staticClass:"leaders__stat-info"},[_c('span',[_vm._v("Full courses")]),_vm._v(" "),_c('small',[_vm._v("\n        "+_vm._s(_vm.scores && _vm.scores.course_score_noms_count ? _vm.scores.course_score_noms_count : 0)+" \n        out of "+_vm._s(_vm.scores && _vm.scores.full_runs_count ? _vm.scores.full_runs_count : 0)+"\n      ")])])]),_vm._v(" "),(_vm.cutoutRoute)?_c('router-link',{staticClass:"leaders__stat-item leaders__stat-max_cutout leaders__stat-item--link",attrs:{"to":_vm.cutoutRoute}},[_c('div',{staticClass:"leaders__stat-numbers js-max_cutout__link"},[_vm._v("\n      "+_vm._s(_vm.statistics.maxCutOut)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"leaders__stat-info"},[_c('span',{staticClass:"js-max_cutout__link"},[_vm._v("Highest cutout")]),_vm._v(" "),_c('small',[_vm._v("("+_vm._s(_vm.scores && _vm.scores.cutout_max_count_noms ? _vm.scores.cutout_max_count_noms : 0)+")")])])]):_c('div',{staticClass:"leaders__stat-item leaders__stat-max_cutout"},[_c('div',{staticClass:"leaders__stat-numbers js-max_cutout__link"},[_vm._v("\n      "+_vm._s(_vm.statistics.maxCutOut)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"leaders__stat-info"},[_c('span',{staticClass:"js-max_cutout__link"},[_vm._v("Highest cutout")]),_vm._v(" "),_c('small',[_vm._v("("+_vm._s(_vm.scores && _vm.scores.cutout_max_count_noms ? _vm.scores.cutout_max_count_noms : 0)+")")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraftEventsList_vue__ = __webpack_require__(411);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f34c620_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DraftEventsList_vue__ = __webpack_require__(1034);
function injectStyle (ssrContext) {
  __webpack_require__(1027)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8f34c620"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraftEventsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f34c620_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DraftEventsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1027 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',_vm._b({attrs:{"to":{
    name: 'LeadersEvent',
    params: {
      main_event_id: _vm.round.main_event_id,
      round: _vm.round.round,
      sub_event_id: _vm.round.sub_event_id
    }
  }}},'router-link',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['leaders__tabs', (!_vm.isMain) ? 'leaders__tabs_small m-0' : ''],style:((_vm.isMain) ? 'margin-left: 0;' : '')},[_vm._l((_vm.tabs),function(tab,i){return (_vm.isMain)?_c('router-link',{key:i,class:[
      'leaders__tab', 'leaders__tab_main', _vm.activeTab === tab.name ? 'active' : ''
    ],attrs:{"to":_vm.tabRoute(tab.name)}},[_vm._v("\n    "+_vm._s(tab.name.charAt(0).toUpperCase() + tab.name.slice(1))+"\n  ")]):_vm._e()}),_vm._v(" "),_vm._l((_vm.tabs),function(tab,i){return (!_vm.isMain)?_c('link-event',{key:i,class:[
      'leaders__tab', 'leaders__tab_round', _vm.isActive(tab)
    ],attrs:{"round":tab}},[_vm._v("\n    "+_vm._s((_vm.isEventPage && tab.name == 'Final') ? 'Final round'  
      : (_vm.isEventPage && tab.name && tab.name.toLowerCase().includes('run-off') 
        ? tab.name.toUpperCase() 
        : tab.name))+"\n  ")]):_vm._e()})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{
    name: 'LeadersDraft',
    params: { draft_id: _vm.entity.id },
    query: { tab: 'search', id: _vm.draw.rider.user_id, select: 'competitor' }
  }}},[_vm._v("\n  "+_vm._s(_vm.draw.rider.name)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaders__events",style:({ '--apperances-color': _vm.computedColor })},_vm._l((_vm.events),function(event){return _c('div',{key:event.id,staticClass:"leaders-event"},[_c('div',{staticClass:"leaders-event__header"},[_c('div',{staticClass:"leaders-event__top pb-4 pt-4 flex-wrap"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"pr-1"},[_c('link-event',{staticClass:"event-title",attrs:{"round":event.rounds[0]}},[_vm._v("\n              "+_vm._s(event.name.toUpperCase())+"\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"leaders__count"},[_vm._v("\n            ("+_vm._s(event.count_runs_in_first_round)+")\n          ")])]),_vm._v(" "),_c('round-tabs',{attrs:{"tabs":event.rounds,"event":event}})],1),_vm._v(" "),_c('div',{staticClass:"leaders-event__judge-name"},[_vm._v("\n        Judges: "+_vm._s(event.judges.map(function (j) { return j; }).join(', '))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"leaders-event__scores-tracker"},[_vm._v("\n        "+_vm._s(event.score_line)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"leaders-event__body active",attrs:{"data-content":"0"}},[_vm._m(0,true),_vm._v(" "),_vm._l((event.draws),function(draw,idx){return _c('ul',{key:draw.id},[_c('li',{staticClass:"col-1 tac"},[_vm._v(_vm._s(idx + 1))]),_vm._v(" "),_c('li',{staticClass:"col-9 display-mob"},[_c('div',[_c('span',[_vm._v("Rider name:")]),_vm._v(" "),_c('link-rider',{attrs:{"draw":draw}})],1),_vm._v(" "),_c('div',[_c('span',[_vm._v("Horse name:")]),_vm._v(" "+_vm._s(draw.horse_name))]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Owner name:")]),_vm._v(" "+_vm._s(draw.owner_name))])]),_vm._v(" "),_c('li',{staticClass:"col-3 hidden-mob"},[_c('link-rider',{attrs:{"draw":draw}})],1),_vm._v(" "),_c('li',{staticClass:"col-3 hidden-mob"},[_vm._v(_vm._s(draw.horse_name))]),_vm._v(" "),_c('li',{staticClass:"col-3 hidden-mob"},[_vm._v(_vm._s(draw.owner_name))]),_vm._v(" "),_c('li',{staticClass:"col-2 tac"},[_vm._v(_vm._s(draw.totals_sum))])])}),_vm._v(" "),_vm._l((10 - event.draws.length),function(p){return _c('ul',{key:p + event.draws.length},[_c('li',{staticClass:"col-1 tac"},[_vm._v(_vm._s(p + event.draws.length))]),_vm._v(" "),_c('li',{staticClass:"col-9 display-mob"}),_vm._v(" "),_c('li',{staticClass:"col-3 hidden-mob"}),_vm._v(" "),_c('li',{staticClass:"col-3 hidden-mob"}),_vm._v(" "),_c('li',{staticClass:"col-3 hidden-mob"}),_vm._v(" "),_c('li',{staticClass:"col-2 tac"})])})],2)])}),0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"leaders-event__main-row"},[_c('li',{staticClass:"col-1 tac"},[_vm._v("Rank")]),_vm._v(" "),_c('li',{staticClass:"col-9 display-mob"},[_vm._v("Info")]),_vm._v(" "),_c('li',{staticClass:"col-3 hidden-mob"},[_vm._v("Rider name")]),_vm._v(" "),_c('li',{staticClass:"col-3 hidden-mob"},[_vm._v("Horse name")]),_vm._v(" "),_c('li',{staticClass:"col-3 hidden-mob"},[_vm._v("Owner name")]),_vm._v(" "),_c('li',{staticClass:"col-2 tac"},[_vm._v("Score")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraftRidersList_vue__ = __webpack_require__(415);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_264e7d39_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DraftRidersList_vue__ = __webpack_require__(1037);
function injectStyle (ssrContext) {
  __webpack_require__(1036)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-264e7d39"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraftRidersList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_264e7d39_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DraftRidersList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1036 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"leaders-event__body active"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.draws),function(draw){return _c('ul',{key:draw.rank},[_c('li',{staticClass:"col-2 tac"},[_vm._v(_vm._s(draw.rank))]),_vm._v(" "),_c('li',{staticClass:"col-5"},[_c('link-rider',{attrs:{"draw":draw}})],1),_vm._v(" "),_c('li',{staticClass:"col-5"},[_vm._v("\n        "+_vm._s(draw.average_score)+"\n      ")])])})],2),_vm._v(" "),(_vm.meta && _vm.meta.last_page > 1)?_c('pagination',{staticClass:"paginate-leaderboard",attrs:{"page":_vm.currentPage,"total-pages":(_vm.meta && _vm.meta.last_page) ? _vm.meta.last_page : 0,"on-change":_vm.handlePageChange,"color":_vm.appearances.schema_color}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"leaders-event__main-row"},[_c('li',{staticClass:"col-2 tac"},[_vm._v("Rank")]),_vm._v(" "),_c('li',{staticClass:"col-5"},[_vm._v("Rider")]),_vm._v(" "),_c('li',{staticClass:"col-5"},[_vm._v("Average score")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(416);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8583d8b4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(1043);
function injectStyle (ssrContext) {
  __webpack_require__(1039)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8583d8b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8583d8b4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1039 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchForm_vue__ = __webpack_require__(417);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39d83be8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchForm_vue__ = __webpack_require__(1042);
function injectStyle (ssrContext) {
  __webpack_require__(1041)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39d83be8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39d83be8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1041 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-form"},[_c('div',{staticClass:"form-group text-left"},[_c('label',{staticClass:"nom_distance_label"},[_vm._v("Select")]),_vm._v(" "),_c('div',{staticClass:"order_by_distance_panel"},[_c('label',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectBy),expression:"selectBy"}],staticClass:"custom-control-input",attrs:{"type":"radio","value":"competitor"},domProps:{"checked":_vm._q(_vm.selectBy,"competitor")},on:{"change":function($event){_vm.selectBy="competitor"}}}),_vm._v(" "),_c('span',{staticClass:"custom-control-label font-weight-normal"},[_vm._v("Competitor")])]),_vm._v(" "),_c('label',{staticClass:"custom-control custom-radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectBy),expression:"selectBy"}],staticClass:"custom-control-input",attrs:{"type":"radio","value":"horse"},domProps:{"checked":_vm._q(_vm.selectBy,"horse")},on:{"change":function($event){_vm.selectBy="horse"}}}),_vm._v(" "),_c('span',{staticClass:"custom-control-label font-weight-normal"},[_vm._v("Horse")])])])]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.results,"searchable":true,"loading":_vm.isLoading,"clear-on-select":false,"hide-selected":true,"placeholder":("Select " + _vm.selectBy),"label":_vm.labelField,"track-by":_vm.trackField,"select-label":""},on:{"search-change":_vm.onSearchChange,"open":_vm.onOpen,"input":_vm.selectItem},scopedSlots:_vm._u([{key:"noResult",fn:function(){return [_vm._v("\n      No results found\n    ")]},proxy:true}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('search-form'),_vm._v(" "),(_vm.draws)?_c('div',[_c('div',{staticClass:"leaders__search-info"},[_c('span',{staticClass:"h5 mb-0"},[_vm._v(_vm._s(_vm.selectBy === 'horse' ? _vm.draws[0].horse_name : _vm.draws[0].rider.name))]),_vm._v(" "),_c('span',[_vm._v("Total nominations: "+_vm._s(_vm.draws.length))]),_vm._v(" "),_c('span',[_vm._v("Average score: "+_vm._s((_vm.draws.reduce(function (sum, draw) { return sum + (+draw.round_score || 0); }, 0) / _vm.draws.length).toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"cut-table leaders__search-results table-hover table-striped"},[_c('div',{staticClass:"cut-table__header"},[_c('div',{staticClass:"cut-table__row row m-0"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"cut-table__cell col-2 hidden-md"},[_c('strong',[_vm._v(_vm._s(_vm.selectBy === 'horse' ? 'Rider' : 'Horse'))])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7)])]),_vm._v(" "),_c('div',{staticClass:"cut-table__body js-search-infinite"},_vm._l((_vm.draws),function(draw){return _c('div',{key:draw.id,staticClass:"cut-table__row row m-0"},[_c('div',{staticClass:"cut-table__cell col-2 hidden-md"},[_c('div',{staticClass:"account_id"},[_c('link-event',{attrs:{"round":draw.event.round}},[_vm._v("\n                "+_vm._s(draw.event.name)+"\n              ")])],1)]),_vm._v(" "),_c('div',{staticClass:"cut-table__cell col-9 display-md"},[_c('div',[_c('strong',[_vm._v("Event: ")]),_vm._v(" "),_c('link-event',{attrs:{"round":draw.event.round}},[_vm._v("\n                "+_vm._s(draw.event.name)+"\n              ")])],1),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s(draw.event.round.name))])]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Horse:")]),_vm._v(" "+_vm._s(draw.horse_name)+" ")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Owner:")]),_vm._v(" "+_vm._s(draw.owner_name)+" ")]),_vm._v(" "),_c('div',{staticClass:"leaders-event__scores"},[_c('div',{staticClass:"leaders-event__scores-item"},[_c('span',[_vm._v("Cutout")]),_vm._v(_vm._s(_vm.formatScore(draw.cutout)))]),_vm._v(" "),_c('div',{staticClass:"leaders-event__scores-item"},[_c('span',[_vm._v("Horsework")]),_vm._v(_vm._s(_vm.formatScore(draw.work)))]),_vm._v(" "),_c('div',{staticClass:"leaders-event__scores-item"},[_c('span',[_vm._v("Course")]),_vm._v(_vm._s(_vm.formatScore(draw.course)))])])]),_vm._v(" "),_c('div',{staticClass:"cut-table__cell col-2 hidden-md"},[_vm._v(_vm._s(draw.event.round.name))]),_vm._v(" "),_c('div',{staticClass:"cut-table__cell col-2 hidden-md"},[_c('div',{staticClass:"form-group"},[_vm._v(_vm._s(_vm.selectBy === 'horse' ? draw.rider.name : draw.horse_name))])]),_vm._v(" "),_c('div',{staticClass:"cut-table__cell col-2 hidden-md"},[_c('div',{staticClass:"nom_distance"},[_vm._v(_vm._s(draw.owner_name))])]),_vm._v(" "),_c('div',{staticClass:"cut-table__cell col-1 hidden-md"},[_c('div',{staticClass:"form-group"},[_vm._v(_vm._s(draw.cutout ? _vm.formatScore(draw.cutout) : '-'))])]),_vm._v(" "),_c('div',{staticClass:"cut-table__cell col-1 hidden-md"},[_c('div',{staticClass:"form-group"},[_vm._v(_vm._s(draw.work ? _vm.formatScore(draw.work) : '-'))])]),_vm._v(" "),_c('div',{staticClass:"cut-table__cell col-1 hidden-md"},[_c('div',[_vm._v(_vm._s(draw.course ? _vm.formatScore(draw.course) : '-'))])]),_vm._v(" "),_c('div',{staticClass:"cut-table__cell col-3 col-md-1"},[_c('div',[_vm._v(_vm._s(_vm.formatScore(draw.round_score)))])])])}),0)])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cut-table__cell col-2 hidden-md"},[_c('strong',[_vm._v("Event")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cut-table__cell col-9 display-md"},[_c('strong',[_vm._v("Info")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cut-table__cell col-2 hidden-md"},[_c('strong',[_vm._v("Round")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cut-table__cell col-2 hidden-md"},[_c('strong',[_vm._v("Owner")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cut-table__cell col-1 hidden-md"},[_c('strong',[_vm._v("Cutout")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cut-table__cell col-1 hidden-md"},[_c('strong',[_vm._v("Horse-"),_c('br'),_vm._v("work")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cut-table__cell col-1 hidden-md"},[_c('strong',[_vm._v("Course")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cut-table__cell col-3 col-md-1"},[_c('strong',[_vm._v("Score Total")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',{style:({ '--apperances-color': _vm.computedColor }),attrs:{"no-sm-padding":""}},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"nominate__title h2 mb-3"},[_vm._v(_vm._s(_vm.draft && _vm.draft.name ? _vm.draft.name : ''))])]),_vm._v(" "),_c('div',{staticClass:"leaders",attrs:{"slot":"content"},slot:"content"},[(_vm.error)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),(_vm.success)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.success))]):_vm._e(),_vm._v(" "),_c('appearances-drafts-header',{attrs:{"appearances":_vm.appearances}}),_vm._v(" "),(_vm.statistics)?_c('statistics',{attrs:{"statistics":_vm.statistics,"appearances":_vm.appearances}}):_vm._e(),_vm._v(" "),_c('round-tabs',{attrs:{"tabs":_vm.tabs,"is-main":true}}),_vm._v(" "),(_vm.draft && _vm.currentTab === _vm.tabs[0].name)?_c('draft-events-list',{attrs:{"appearances":_vm.appearances}}):_vm._e(),_vm._v(" "),(_vm.draft && _vm.currentTab === _vm.tabs[1].name)?_c('draft-riders-list',{attrs:{"appearances":_vm.appearances}}):_vm._e(),_vm._v(" "),(_vm.draft && _vm.currentTab === _vm.tabs[2].name)?_c('search',{attrs:{"appearances":_vm.appearances}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"footer"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Event_vue__ = __webpack_require__(419);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c7ce45d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Event_vue__ = __webpack_require__(1047);
function injectStyle (ssrContext) {
  __webpack_require__(1046)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c7ce45d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Event_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c7ce45d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Event_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1046 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',{style:({ '--apperances-color': _vm.computedColor }),attrs:{"no-sm-padding":""}},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"nominate__title h2 mb-3"},[_vm._v(_vm._s(_vm.event && _vm.event.name ? _vm.event.name : ''))])]),_vm._v(" "),_c('div',{staticClass:"leaders",attrs:{"slot":"content"},slot:"content"},[(_vm.error)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),(_vm.success)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.success))]):_vm._e(),_vm._v(" "),_c('appearances-drafts-header',{attrs:{"appearances":_vm.appearances}}),_vm._v(" "),(_vm.statistics)?_c('statistics',{attrs:{"statistics":_vm.statistics,"appearances":_vm.appearances}}):_vm._e(),_vm._v(" "),(_vm.event)?_c('round-tabs',{attrs:{"tabs":_vm.event.rounds,"isEventPage":true}}):_vm._e(),_vm._v(" "),(_vm.entity.id)?_c('div',{staticClass:"leaders-event__body",staticStyle:{"margin-top":"24px"}},[_c('ul',{staticClass:"leaders-event__main-row"},[_c('li',{staticClass:"col-1 tac leaderboard-sort",on:{"click":function($event){return _vm.changeSort('order')}}},[_c('div',{staticClass:"column_name"},[_c('span',[_vm._v("Run")])]),_vm._v(" "),_c('div',{staticClass:"sort-icon"})]),_vm._v(" "),_c('li',{staticClass:"col-6 col-mob-9 display-md"},[_vm._v("Info")]),_vm._v(" "),_c('li',{staticClass:"col-2 hidden-md leaderboard-sort",on:{"click":function($event){return _vm.changeSort('rider_name')}}},[_c('div',{staticClass:"column_name mx-0"},[_vm._v("Rider name")]),_vm._v(" "),_c('div',{staticClass:"sort-icon"})]),_vm._v(" "),_c('li',{staticClass:"col-2 hidden-md"},[_vm._v("Horse name")]),_vm._v(" "),_c('li',{staticClass:"col-1 hidden-md"},[_vm._v("Owner name")]),_vm._v(" "),_c('li',{staticClass:"col-1 tac hidden-mob leaderboard-sort",on:{"click":function($event){return _vm.changeSort('cutout')}}},[_c('div',{staticClass:"column_name"},[_vm._v("Cutout")]),_vm._v(" "),_c('div',{staticClass:"sort-icon"})]),_vm._v(" "),_c('li',{staticClass:"col-1 tac hidden-mob"},[_c('span',{staticStyle:{"overflow-wrap":"break-word"}},[_vm._v("Horsework")])]),_vm._v(" "),_c('li',{staticClass:"col-1 tac hidden-mob"},[_vm._v("Course")]),_vm._v(" "),_c('li',{staticClass:"col-1 col-mob-2 tac leaderboard-sort",on:{"click":function($event){return _vm.changeSort('round_score')}}},[_c('div',{staticClass:"column_name"},[_vm._v(_vm._s(_vm.event.rounds[_vm.selectedRound].name !== 'Final' ? 'Round' : 'Final')+" score")]),_vm._v(" "),_c('div',{staticClass:"sort-icon"})]),_vm._v(" "),(_vm.selectedRound > 0)?_c('li',{staticClass:"col-1 col-mob-2 tac leaderboard-sort",on:{"click":function($event){return _vm.changeSort('previous_rounds_score')}}},[_c('div',{staticClass:"column_name"},[_vm._v("Previous rounds' score")]),_vm._v(" "),_c('div',{staticClass:"sort-icon"})]):_vm._e(),_vm._v(" "),(_vm.selectedRound > 0)?_c('li',{staticClass:"col-1 col-mob-2 tac leaderboard-sort",on:{"click":function($event){return _vm.changeSort('total_score')}}},[_c('div',{staticClass:"column_name"},[_vm._v("Total score")]),_vm._v(" "),_c('div',{staticClass:"sort-icon"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"js-event-infinite"},[_vm._l((_vm.draws),function(draw){return _c('ul',{key:draw.id},[_c('li',{staticClass:"col-1 tac"},[_vm._v("\n            "+_vm._s(draw.order)+"\n          ")]),_vm._v(" "),_c('li',{staticClass:"col-6 col-mob-9 display-md"},[_c('div',[_c('span',[_vm._v("Rider name:")]),_vm._v(" "),(_vm.entity.id)?_c('link-rider',{attrs:{"draw":draw}}):_vm._e()],1),_vm._v(" "),_c('div',[_c('span',[_vm._v("Horse name:")]),_vm._v(" "+_vm._s(draw.horse_name))]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Owner name:")]),_vm._v(" "+_vm._s(draw.owner_name))]),_vm._v(" "),_c('div',{staticClass:"display-mob leaders-event__scores"},[_c('div',{staticClass:"leaders-event__scores-item"},[_c('span',[_vm._v("Cutout")]),_vm._v(" "+_vm._s(draw.cutout !== null && draw.cutout !== undefined ? _vm.formatScore(draw.cutout) : '-')+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"leaders-event__scores-item"},[_c('span',[_vm._v("Horsework")]),_vm._v(" "+_vm._s(draw.work !== null && draw.work !== undefined ? _vm.formatScore(draw.work) : '-')+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"leaders-event__scores-item"},[_c('span',[_vm._v("Course")]),_vm._v(" "+_vm._s(draw.course !== null && draw.course !== undefined ? _vm.formatScore(draw.course) : '-')+"\n              ")])])]),_vm._v(" "),_c('li',{staticClass:"col-2 hidden-md"},[(_vm.entity.id)?_c('link-rider',{attrs:{"draw":draw}}):_vm._e()],1),_vm._v(" "),_c('li',{staticClass:"col-2 hidden-md text-wrap"},[_vm._v(_vm._s(draw.horse_name))]),_vm._v(" "),_c('li',{staticClass:"col-1 hidden-md"},[_vm._v(_vm._s(draw.owner_name))]),_vm._v(" "),_c('li',{staticClass:"col-1 tac hidden-mob"},[_vm._v(_vm._s(draw.cutout !== null && draw.cutout !== undefined ? _vm.formatScore(draw.cutout) : '-'))]),_vm._v(" "),_c('li',{staticClass:"col-1 tac hidden-mob"},[_vm._v(_vm._s(draw.work !== null && draw.work !== undefined ? _vm.formatScore(draw.work) : '-'))]),_vm._v(" "),_c('li',{staticClass:"col-1 tac hidden-mob"},[_vm._v(_vm._s(draw.course !== null && draw.course !== undefined ? _vm.formatScore(draw.course) : '-'))]),_vm._v(" "),_c('li',{staticClass:"col-1 col-mob-2 tac"},[_vm._v(_vm._s(draw.round_score !== null && draw.round_score !== undefined ? _vm.formatScore(draw.round_score) : '-'))]),_vm._v(" "),(_vm.selectedRound > 0)?_c('li',{staticClass:"col-1 col-mob-2 tac"},[_vm._v(_vm._s(draw.previous_rounds_score !== null && draw.previous_rounds_score !== undefined ? _vm.formatScore(draw.previous_rounds_score) : '-'))]):_vm._e(),_vm._v(" "),(_vm.selectedRound > 0)?_c('li',{staticClass:"col-1 col-mob-2 tac"},[_vm._v(_vm._s(draw.total_score !== null && draw.total_score !== undefined ? _vm.formatScore(draw.total_score) : '-'))]):_vm._e()])}),_vm._v(" "),(!_vm.finished && !_vm.loading && _vm.draws.length)?_c('div',{staticClass:"text-center py-3"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.fetchEvent}},[_vm._v("Load more")])]):_vm._e(),_vm._v(" "),_c('div',{ref:"infiniteTrigger"}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"text-center py-3"},[_vm._v("\n          Loading...\n        ")]):_vm._e()],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"footer"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Draft_vue__ = __webpack_require__(420);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ad0d5c1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Draft_vue__ = __webpack_require__(1050);
function injectStyle (ssrContext) {
  __webpack_require__(1049)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ad0d5c1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Draft_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ad0d5c1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Draft_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1049 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',{style:({ '--apperances-color': _vm.computedColor }),attrs:{"no-sm-padding":""}},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"nominate__title h2 mb-3"},[_vm._v(_vm._s(_vm.draft && _vm.draft.name ? _vm.draft.name : ''))])]),_vm._v(" "),_c('div',{staticClass:"leaders",attrs:{"slot":"content"},slot:"content"},[(_vm.error)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),(_vm.statistics)?_c('statistics',{attrs:{"statistics":_vm.statistics,"appearances":_vm.appearances}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"leaders-event__body",staticStyle:{"margin-top":"24px"}},[_c('ul',{staticClass:"leaders-event__main-row"},[_c('li',{staticClass:"col-1 col-sm-2 tac"},[_vm._v("Rank")]),_vm._v(" "),_c('li',{staticClass:"col-11 col-sm-10 display-mob"},[_vm._v("Info")]),_vm._v(" "),_c('li',{staticClass:"col-3 hidden-mob"},[_vm._v("Rider")]),_vm._v(" "),_c('li',{staticClass:"col-3 hidden-mob"},[_vm._v("Horse")]),_vm._v(" "),_c('li',{staticClass:"col-2 hidden-mob"},[_vm._v("Event Name")]),_vm._v(" "),_c('li',{staticClass:"col-1 hidden-mob"},[_vm._v("Round")]),_vm._v(" "),_c('li',{staticClass:"col-1 tac hidden-mob"},[_vm._v("Cutout")])]),_vm._v(" "),(_vm.loading && !_vm.draws.length)?_c('div',{staticClass:"text-center py-3"},[_vm._v("\n        Loading...\n      ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.draws),function(draw,idx){return _c('ul',{key:draw.id},[_c('li',{staticClass:"col-1 col-sm-2 tac"},[_vm._v(_vm._s(draw.rank || (idx + 1)))]),_vm._v(" "),_c('li',{staticClass:"col-11 col-sm-10 display-mob"},[_c('div',[_c('span',[_vm._v("Rider name:")]),_vm._v(" "),_c('link-rider',{attrs:{"draw":draw}})],1),_vm._v(" "),_c('div',[_c('span',[_vm._v("Horse name:")]),_vm._v(" "+_vm._s(draw.horse_name))]),_vm._v(" "),(draw.event)?_c('div',[_c('span',[_vm._v("Event name:")]),_vm._v(" "+_vm._s(draw.event.name))]):_vm._e(),_vm._v(" "),(draw.event && draw.event.round)?_c('div',[_c('span',[_vm._v("Round:")]),_vm._v(" "+_vm._s(draw.event.round.round + 1))]):_vm._e(),_vm._v(" "),_c('div',[_c('span',[_vm._v("Cutout:")]),_vm._v(" "+_vm._s(draw.cutout))])]),_vm._v(" "),_c('li',{staticClass:"col-3 hidden-mob"},[_c('link-rider',{attrs:{"draw":draw}})],1),_vm._v(" "),_c('li',{staticClass:"col-3 hidden-mob"},[_vm._v(_vm._s(draw.horse_name))]),_vm._v(" "),_c('li',{staticClass:"col-2 hidden-mob"},[_vm._v(_vm._s(draw.event ? draw.event.name : '—'))]),_vm._v(" "),_c('li',{staticClass:"col-1 hidden-mob"},[_vm._v(_vm._s(draw.event && draw.event.round ? draw.event.round.round + 1 : '—'))]),_vm._v(" "),_c('li',{staticClass:"col-1 tac hidden-mob"},[_vm._v(_vm._s(draw.cutout !== null && draw.cutout !== undefined ? draw.cutout : '-'))])])}),_vm._v(" "),_c('div',{ref:"infiniteTrigger"}),_vm._v(" "),(_vm.loading && _vm.draws.length)?_c('div',{staticClass:"text-center py-3"},[_vm._v("\n        Loading...\n      ")]):_vm._e()],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Event_vue__ = __webpack_require__(421);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb60439c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Event_vue__ = __webpack_require__(1053);
function injectStyle (ssrContext) {
  __webpack_require__(1052)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eb60439c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Event_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb60439c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Event_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1052 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',{style:({ '--apperances-color': _vm.computedColor }),attrs:{"no-sm-padding":""}},[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"nominate__title h2 mb-3"},[_vm._v(_vm._s(_vm.event && _vm.event.name ? _vm.event.name : ''))])]),_vm._v(" "),_c('div',{staticClass:"leaders",attrs:{"slot":"content"},slot:"content"},[(_vm.error)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),(_vm.statistics)?_c('statistics',{attrs:{"statistics":_vm.statistics,"appearances":_vm.appearances}}):_vm._e(),_vm._v(" "),(_vm.event && _vm.event.rounds && _vm.event.rounds.length)?_c('div',{staticClass:"leaders__tabs leaders__tabs_small m-0",style:({ '--apperances-color': _vm.computedColor })},_vm._l((_vm.event.rounds),function(round,i){return _c('router-link',{key:i,class:['leaders__tab', 'leaders__tab_round', _vm.isRoundActive(round) ? 'active' : ''],attrs:{"to":{
          name: 'LeadersEventCutoutHighest',
          params: { event_id: _vm.$route.params.event_id, round: round.round }
        }}},[_vm._v("\n        "+_vm._s(_vm.roundLabel(round))+"\n      ")])}),1):_vm._e(),_vm._v(" "),(_vm.entity.event_id)?_c('div',{staticClass:"leaders-event _single"},[_c('div',{staticClass:"leaders-event__body active",staticStyle:{"margin-top":"24px"}},[_c('ul',{staticClass:"leaders-event__main-row"},[_c('li',{staticClass:"col-1 tac"},[_vm._v("Run")]),_vm._v(" "),_c('li',{staticClass:"col-6 col-mob-9 display-md"},[_vm._v("Info")]),_vm._v(" "),_c('li',{staticClass:"col-3 hidden-md"},[_vm._v("Rider name")]),_vm._v(" "),_c('li',{staticClass:"col-3 hidden-md"},[_vm._v("Horse name")]),_vm._v(" "),_c('li',{staticClass:"col-2 tac hidden-md"},[_vm._v("Round")]),_vm._v(" "),_c('li',{staticClass:"col-2 hidden-sm tac"},[_vm._v("Cutout")])]),_vm._v(" "),_c('div',{staticClass:"js-event-infinite"},[(_vm.loading && !_vm.draws.length)?_c('div',{staticClass:"text-center py-3"},[_vm._v("\n            Loading...\n          ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.draws),function(draw,idx){return _c('ul',{key:draw.id},[_c('li',{staticClass:"col-1 tac"},[_vm._v(_vm._s(idx + 1))]),_vm._v(" "),_c('li',{staticClass:"col-6 col-mob-9 display-md"},[_c('div',[_c('span',[_vm._v("Rider name:")]),_vm._v(" "),_c('link-rider',{attrs:{"draw":draw}})],1),_vm._v(" "),_c('div',[_c('span',[_vm._v("Horse name:")]),_vm._v(" "+_vm._s(draw.horse_name))]),_vm._v(" "),(_vm.selectedRound > 0)?_c('div',[_c('span',[_vm._v("Round:")]),_vm._v(" "+_vm._s(_vm.selectedRound + 1))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"display-sm"},[_c('span',[_vm._v("Cutout: ")]),_vm._v(_vm._s(draw.cutout))])]),_vm._v(" "),_c('li',{staticClass:"col-3 hidden-md"},[_c('link-rider',{attrs:{"draw":draw}})],1),_vm._v(" "),_c('li',{staticClass:"col-3 hidden-md"},[_vm._v(_vm._s(draw.horse_name))]),_vm._v(" "),_c('li',{staticClass:"col-2 tac hidden-md"},[_vm._v(_vm._s(_vm.selectedRound + 1))]),_vm._v(" "),_c('li',{staticClass:"col-2 hidden-sm tac"},[_vm._v(_vm._s(draw.cutout !== null && draw.cutout !== undefined ? draw.cutout : '-'))])])})],2)])]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApiTokens_vue__ = __webpack_require__(422);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3998f58c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApiTokens_vue__ = __webpack_require__(1057);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApiTokens_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3998f58c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApiTokens_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TokenAdd_vue__ = __webpack_require__(423);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de862040_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TokenAdd_vue__ = __webpack_require__(1056);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TokenAdd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de862040_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TokenAdd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px-0 mt-2"},[_c('form',{staticClass:"needs-validation d-flex mb-3 pt-3 p-1 p-sm-3 bg-lighter border-top",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.createToken($event)}}},[_c('div',{staticClass:"align-items-start d-flex flex-wrap w-100"},[_c('div',{staticClass:"px-md-3 mb-3 col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"tokenName"}},[_vm._v("Token name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.name),expression:"form.name",modifiers:{"trim":true}}],class:[
              'form-control',
              _vm.errors.name ? 'is-invalid' : ''
            ],attrs:{"id":"tokenName","type":"text","required":"","placeholder":"Enter token name"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.errors.name)?_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n            "+_vm._s(_vm.errors.name[0])+"\n          ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-lg-auto px-lg-0"},[_c('label',{staticClass:"w-100 d-none d-lg-block",attrs:{"aria-hidden":"true"}},[_vm._v(" ")]),_vm._v(" "),_c('button',{class:[
            'btn btn-block-mob mt-auto',
            _vm.processing ? 'btn-primary-dark' : 'btn-outline-primary'
          ],attrs:{"type":"submit","disabled":_vm.processing}},[(!_vm.processing)?_c('span',[_vm._v("Create token")]):_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])])])]),_vm._v(" "),(_vm.createdToken)?_c('div',{staticClass:"alert alert-success mt-3"},[_c('strong',[_vm._v("Token created:")]),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('code',[_vm._v(_vm._s(_vm.createdToken))]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-secondary",attrs:{"type":"button"},on:{"click":_vm.copyToken}},[_vm._v("\n        Copy\n      ")])]),_vm._v(" "),_c('small',{staticClass:"text-muted d-block mt-1"},[_vm._v("\n      Copy this token now. You won’t be able to see it again.\n    ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('h1',{staticClass:"h2",attrs:{"slot":"heading"},slot:"heading"},[_vm._v("Access API Tokens")]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.success)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.success))]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('form-token-create',{on:{"created":_vm.loadRows,"error":function($event){_vm.error = $event},"success":function($event){_vm.success = $event}}}),_vm._v(" "),_c('data-table',{attrs:{"dataRows":_vm.rows,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{attrs:{"text":row.name,"row":row}})}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',{staticClass:"pt-2"},[_c('strong',[_vm._v("Status: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"row":row,"options":{ showActiveToken: true, inline: true }}})],1),_vm._v(" "),_c('li',{staticClass:"pt-2"},[_c('strong',[_vm._v("Last Active: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":("" + (row.last_used_at? row.last_used_at : '-')),"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',{staticClass:"pt-2"},[_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"btn btn-sm btn-primary mr-2",on:{"click":function($event){return _vm.toggleActive(row)}}},[_vm._v("\n                "+_vm._s(row.is_active ? 'Deactivate' : 'Activate')+"\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.confirmDelete(row)}}},[_vm._v("\n                Delete\n              ")])])])])])}}])}),_vm._v(" "),(_vm.showDeleteModal)?_c('modal',{on:{"close":function($event){$event.preventDefault();_vm.showDeleteModal = false}}},[_c('h3',{staticClass:"modal-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Delete Confirmation")]),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("Are you sure you want to delete this token?")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.showDeleteModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.deleteConfirmed}},[_vm._v("Delete")])])]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api = "https://api.campdraft.com.au";
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$coy = "https://nominate.campdraft.com.au";
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$trialApplicationFilePath = '/static/files/EXT027.pdf';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$openApplicationFilePath = '/static/files/EXT028.pdf';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$sentry = {
  dsn: "https://1c61c7a426c14ee0953485ec14eabe56@o1070396.ingest.sentry.io/6067940",
  environment: "production"
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$paypal = {
  production: "AQMOQk4LS_n30mQyp0L5nLx7dJV-ex-l3qLlYS2RYykplhgu5iX-upjyg1zIrEOS_WIW86WqxV5g-c7y",
  sandbox: "AQM6f2Ts_iCveaFNHbuKenv3iIFJUmWD8jxN9RG63AcThcha01BPIby8vwHUyDTSjBozAEfa8LJTbuZ8"
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$stripePk = "pk_live_iNp69gtcmC5qiSdSYkfukavK";
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$captchaSiteKey = "6Ld6xekrAAAAAAd8cAPUhV9M6SmAXk-dOM27ZvIc";

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JudgeDashboard_vue__ = __webpack_require__(424);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48140610_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JudgeDashboard_vue__ = __webpack_require__(1062);
function injectStyle (ssrContext) {
  __webpack_require__(1060)
  __webpack_require__(1061)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48140610"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JudgeDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48140610_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JudgeDashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1060 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('div',{staticClass:"d-flex justify-content-between align-items-center mb-3",attrs:{"slot":"heading"},slot:"heading"},[_c('h1',{staticClass:"h2 mb-0"},[_vm._v("Judge Dashboard")])]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.memberDetails)?_c('div',[(!_vm.checkHasFinancialMembers)?_c('div',[_vm._v("\n        Please pay ACA membership to apply for a Judge position.\n      ")]):_vm._e(),_vm._v(" "),(_vm.checkHasFinancialMembers)?_c('div',[_c('router-link',{staticClass:"btn btn-block mb-2 btn-primary button-link",attrs:{"tag":"button","to":{ name: 'Judge Application' }}},[_vm._v("Add a Trial Judge\n        ")]),_vm._v(" "),(_vm.success)?_c('div',{staticClass:"alert alert-success"},[_vm._v(_vm._s(_vm.success))]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('data-table',{attrs:{"dataRows":_vm.rows,"dataColumns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"expandedHeader",fn:function(ref){
var row = ref.row;
return _c('tableTextTemplate',{attrs:{"text":row.first_name + ' ' + row.last_name,"slug":row.id,"row":row}})}},{key:"expandedRow",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('ul',{staticClass:"list-unstyled mb-0 pt-2"},[_c('li',[_c('strong',[_vm._v("First Name: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.first_name,"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Last Name: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.last_name,"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Judge Status: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"text":row.judge_type,"row":row,"options":{ inline: true }}})],1),_vm._v(" "),_c('li',[_c('strong',[_vm._v("State: ")]),_vm._v(" "),_c('tableTextTemplate',{attrs:{"row":row,"options":{ inline: true, showJudgeStatus: true }}})],1),_vm._v(" "),_c('li',{staticClass:"mt-2 d-flex flex-wrap"},[_c('div',{staticClass:"mr-2"},[_c('router-link',{staticClass:"btn btn-block mb-2 btn-outline-primary btn-sm",class:!row.judge_id ? 'disabled' : '',staticStyle:{"width":"170px"},attrs:{"to":{ name: 'Active Drafts', params: { slug: row.judge_id } },"tag":"button","disabled":!row.judge_id}},[_vm._v("\n                    View Drafts\n                  ")])],1),_vm._v(" "),_c('div',{staticClass:"mr-2"},[_c('router-link',{staticClass:"btn btn-block mb-2 btn-primary btn-sm",class:!row.judge_id ? 'disabled' : '',staticStyle:{"width":"170px"},attrs:{"to":{ name: 'Expression Of Interest', params: { slug: row.judge_id } },"tag":"button","disabled":!row.judge_id}},[_vm._v("\n                    Express Interest\n                  ")])],1),_vm._v(" "),_c('div',{staticClass:"mr-2"},[((row.judge_type === 'trial'))?_c('router-link',{staticClass:"btn btn-block mb-2 btn-primary btn-sm",staticStyle:{"width":"170px"},attrs:{"to":{ name: 'Judge Application', params: { member_id: row.user_id} },"tag":"button"}},[_vm._v("\n                    Apply for Open\n                  ")]):_vm._e()],1)])])])}}],null,false,3656491622)})],1):_vm._e()]):_c('div',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4 flex-grow-1 mr-lg-3"},[_c('div',{staticClass:"text-center p-2"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeAffiliation_vue__ = __webpack_require__(425);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08378de4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeAffiliation_vue__ = __webpack_require__(1067);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeAffiliation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08378de4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeAffiliation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeAffiliationForm_vue__ = __webpack_require__(426);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23710eb0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeAffiliationForm_vue__ = __webpack_require__(1066);
function injectStyle (ssrContext) {
  __webpack_require__(1065)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23710eb0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeAffiliationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23710eb0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeAffiliationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1065 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation ml-0",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v("Committee Affiliation Application")]),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"text-center p-2"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('div',[(_vm.errors.length)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},_vm._l((_vm.errors),function(error){return _c('div',[_vm._v(_vm._s(error))])}),0):_vm._e(),_vm._v(" "),(_vm.submitStatus === 'ERROR')?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("\n      Please fill the form correctly.\n    ")]):_vm._e(),_vm._v(" "),(_vm.errorStatus)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("\n      "+_vm._s(_vm.errorStatus)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',[_c('b',[_vm._v("Paying for Season: ")]),_vm._v(" January 1, "+_vm._s(this.$store.state.currentDate ? new Date(this.$store.state.currentDate).getFullYear() : new Date().getFullYear())+" to December 31, "+_vm._s(this.$store.state.currentDate ? new Date(this.$store.state.currentDate).getFullYear() : new Date().getFullYear()))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"alert alert-info",attrs:{"role":"alert"}},[_vm._v("\n      Please note you should have the address filled in on your profile to complete the affiliation fee payment.\n      Make sure you have the address saved before you proceed.\n    ")]),_vm._v(" "),_c('div',{staticClass:"affiliation-form-wrapper"},[_c('h3',[_vm._v("Committee Affiliation Form")]),_vm._v(" "),_c('div',{staticClass:"row block"},[_c('div',{staticClass:" col-12 col-md-6 form-group"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.name.$model),expression:"$v.data.name.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.name.$error || _vm.errorFields.name},attrs:{"type":"text","id":"committeeName","required":""},domProps:{"value":(_vm.$v.data.name.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.name, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Committee name must contain letters and spaces only.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.fields.mailing_address.$model),expression:"$v.fields.mailing_address.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.fields.mailing_address.$error },attrs:{"type":"text","id":"mailingAddress","required":""},domProps:{"value":(_vm.$v.fields.mailing_address.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.fields.mailing_address, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(!_vm.$v.fields.mailing_address.required)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Mailing Address.\n          ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:" col-12 col-md-6 form-group"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.fields.suburb.$model),expression:"$v.fields.suburb.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.fields.suburb.$error },attrs:{"type":"text","id":"committeeSuburb","required":""},domProps:{"value":(_vm.$v.fields.suburb.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.fields.suburb, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Suburb.")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_vm._m(4),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.state.$model),expression:"$v.data.state.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.state.$error },attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.$v.data.state, "$model", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',{attrs:{"value":"QLD"}},[_vm._v("Queensland")]),_vm._v(" "),_c('option',{attrs:{"value":"NSW"}},[_vm._v("New South Wales")]),_vm._v(" "),_c('option',{attrs:{"value":"VIC"}},[_vm._v("Victoria")]),_vm._v(" "),_c('option',{attrs:{"value":"ACT"}},[_vm._v("Australian Capital Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"SA"}},[_vm._v("South Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"NT"}},[_vm._v("Northern Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"WA"}},[_vm._v("Western Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"TAS"}},[_vm._v("Tasmania")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the State.")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_vm._m(5),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.post_code.$model),expression:"$v.data.post_code.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.post_code.$error },attrs:{"type":"text","id":"CommitteePostcode","maxlength":"4","required":"","pattern":"\\d{4}"},domProps:{"value":(_vm.$v.data.post_code.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.post_code, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include a four-digit Postcode.")])])])]),_vm._v(" "),_c('div',{staticClass:"row block"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(6),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.fields.grounds_address.$model),expression:"$v.fields.grounds_address.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.fields.grounds_address.$error },attrs:{"type":"text","id":"committeeGroundsAddress","required":""},domProps:{"value":(_vm.$v.fields.grounds_address.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.fields.grounds_address, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include Campdraft Grounds Address.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(7),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.fields.grounds_suburb.$model),expression:"$v.fields.grounds_suburb.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.fields.grounds_suburb.$error },attrs:{"type":"text","id":"committeeGroundsAddressSuburb","required":""},domProps:{"value":(_vm.$v.fields.grounds_suburb.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.fields.grounds_suburb, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Suburb.")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(8),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.fields.grounds_state.$model),expression:"$v.fields.grounds_state.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.fields.grounds_state.$error },attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.$v.fields.grounds_state, "$model", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',{attrs:{"value":"QLD"}},[_vm._v("Queensland")]),_vm._v(" "),_c('option',{attrs:{"value":"NSW"}},[_vm._v("New South Wales")]),_vm._v(" "),_c('option',{attrs:{"value":"VIC"}},[_vm._v("Victoria")]),_vm._v(" "),_c('option',{attrs:{"value":"ACT"}},[_vm._v("Australian Capital Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"SA"}},[_vm._v("South Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"NT"}},[_vm._v("Northern Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"WA"}},[_vm._v("Western Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"TAS"}},[_vm._v("Tasmania")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the State.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(9),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.fields.grounds_postcode.$model),expression:"$v.fields.grounds_postcode.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.fields.grounds_postcode.$error },attrs:{"type":"text","maxlength":"4","required":"","pattern":"\\d{4}"},domProps:{"value":(_vm.$v.fields.grounds_postcode.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.fields.grounds_postcode, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include a four-digit Postcode.")])])]),_vm._v(" "),_c('div',{staticClass:"row block"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',[_vm._v("President Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.fields.president_name.$model),expression:"$v.fields.president_name.$model",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.$v.fields.president_name.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.fields.president_name, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',[_vm._v("Secretary Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.fields.secretary_name.$model),expression:"$v.fields.secretary_name.$model",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.$v.fields.secretary_name.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.fields.secretary_name, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',[_vm._v("Treasurer Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.fields.treasurer_name.$model),expression:"$v.fields.treasurer_name.$model",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.$v.fields.treasurer_name.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.fields.treasurer_name, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',[_vm._v("Other Name: (Campdraft Steward etc)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.fields.other_name.$model),expression:"$v.fields.other_name.$model",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.$v.fields.other_name.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.fields.other_name, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-bottom":"20px"}},[_c('div',{staticClass:"col-3 col-md-2 form-group"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.fields.internet_access.$model),expression:"$v.fields.internet_access.$model",modifiers:{"trim":true}}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"internet_access"},domProps:{"checked":Array.isArray(_vm.$v.fields.internet_access.$model)?_vm._i(_vm.$v.fields.internet_access.$model,null)>-1:(_vm.$v.fields.internet_access.$model)},on:{"change":function($event){var $$a=_vm.$v.fields.internet_access.$model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.$v.fields.internet_access, "$model", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.$v.fields.internet_access, "$model", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.$v.fields.internet_access, "$model", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label access-to",attrs:{"for":"internet_access"}},[_vm._v("\n            Internet access\n          ")]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include true or false.")])])]),_vm._v(" "),_c('div',{staticClass:"col-3 col-md-2 form-group"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.fields.phone_service.$model),expression:"$v.fields.phone_service.$model",modifiers:{"trim":true}}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"phone_service"},domProps:{"checked":Array.isArray(_vm.$v.fields.phone_service.$model)?_vm._i(_vm.$v.fields.phone_service.$model,null)>-1:(_vm.$v.fields.phone_service.$model)},on:{"change":function($event){var $$a=_vm.$v.fields.phone_service.$model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.$v.fields.phone_service, "$model", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.$v.fields.phone_service, "$model", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.$v.fields.phone_service, "$model", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label access-to",attrs:{"for":"phone_service"}},[_vm._v("\n            Phone service\n          ")]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include true or false.")])])])]),_vm._v(" "),_vm._l((_vm.$v.fields.drafts.$each.$iter),function(v,index){return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-3 form-group"},[_c('label',[_vm._v("Proposed Campdraft Start Date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(v.start.$model),expression:"v.start.$model",modifiers:{"trim":true}}],staticClass:"form-control form-date",class:{ 'is-invalid': v.start.$error },attrs:{"type":"date","maxlength":"4","required":"","placeholder":'dd.mm.yyyy',"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}"},domProps:{"value":(v.start.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(v.start, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Proposed Campdraft Start Date.")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_c('label',[_vm._v("Proposed Campdraft End Date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(v.end.$model),expression:"v.end.$model",modifiers:{"trim":true}}],staticClass:"form-control form-date",class:{ 'is-invalid': v.end.$error },attrs:{"type":"date","maxlength":"4","required":"","placeholder":'dd.mm.yyyy',"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}"},domProps:{"value":(v.end.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(v.end, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Proposed Campdraft End Date.")])]),_vm._v(" "),(index != 0)?_c('div',{staticClass:"col-1 col-md-1 form-group button-remove-draft",on:{"click":function($event){return _vm.fields.drafts.splice(index, 1)}}},[_vm._v("\n          ✕\n        ")]):_vm._e()])])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 col-offset-1 form-group right-end"},[_c('button',{staticClass:"btn btn-block mb-2 btn-primary button-add-draft",attrs:{"type":"button"},on:{"click":_vm.addDraft}},[_vm._v("Add One More\n          Draft\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.fields.event_membership_agree.$model),expression:"$v.fields.event_membership_agree.$model",modifiers:{"trim":true}}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"event_membership_agree"},domProps:{"checked":Array.isArray(_vm.$v.fields.event_membership_agree.$model)?_vm._i(_vm.$v.fields.event_membership_agree.$model,null)>-1:(_vm.$v.fields.event_membership_agree.$model)},on:{"change":function($event){var $$a=_vm.$v.fields.event_membership_agree.$model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.$v.fields.event_membership_agree, "$model", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.$v.fields.event_membership_agree, "$model", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.$v.fields.event_membership_agree, "$model", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label access-to",attrs:{"for":"event_membership_agree"}},[_vm._v("\n            By checking this box, your committee consents to receiving an invoice for Event Membership Fees\n            collected on behalf of ACA, if your committee chooses to accept Casual Members.\n          ")]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include true or false.")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 form-group save-details-button"},[_c('button',{staticClass:"btn btn-block mb-2 btn-primary",attrs:{"disabled":_vm.submitStatus == 'PENDING' || !_vm.fields.event_membership_agree,"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.handleShowModal($event)}}},[(_vm.submitStatus == 'PENDING')?_c('div',{staticClass:"spinner-border",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e(),_vm._v(" "),(_vm.submitStatus != 'PENDING' || !_vm.submitStatus)?_c('div',[_vm._v("Check Out")]):_vm._e()])])]),_vm._v(" "),_vm._m(11)],2):_vm._e(),_vm._v(" "),(_vm.showModal)?_c('modal',{on:{"close":function($event){_vm.showModal = false}}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"text"},[_c('h4',[_c('b',[_vm._v("Season Confirmation")])])]),_vm._v(" "),_c('div',{staticClass:"text pt-3"},[_c('b',{staticClass:"pr-2"},[_vm._v("Please confirm your selected season: ")]),_vm._v(" "),_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(new Date(this.$store.state.currentDate).getFullYear()))])]),_vm._v(" "),_c('div',{staticClass:"text pt-3"},[_vm._v("Note: The ACA Financial/Membership Year runs "),_c('br'),_vm._v(" from 1 January to 31 December.")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[(_vm.submitStatus != 'PENDING' || !_vm.submitStatus)?_c('div',{staticClass:"col-12 d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-outline-primary ml-2",on:{"click":function($event){$event.preventDefault();_vm.showModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary ml-2",on:{"click":function($event){$event.preventDefault();return _vm.submit($event)}}},[_vm._v("Confirm")])]):_vm._e(),_vm._v(" "),(_vm.submitStatus == 'PENDING')?_c('div',{staticClass:"text-center p-2"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])]):_vm._e()])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeName"}},[_vm._v("Committee Name "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"mailingAddress"}},[_vm._v("Mailing Address "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeSuburb"}},[_vm._v("Suburb "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("State "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"CommitteePostcode"}},[_vm._v("Postcode "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeGroundsAddress"}},[_vm._v("Campdraft Grounds Address "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeGroundsAddressSuburb"}},[_vm._v("Suburb "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("State "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Postcode "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row block"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('b',{staticStyle:{"font-size":"18px"}},[_vm._v("At your campdraft grounds, does the committee have access to: ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('img',{staticClass:"px-3",staticStyle:{"max-width":"250px"},attrs:{"src":"/static/img/checkout.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listing-layout',[_c('div',{class:{ 'acting-readonly': _vm.$isActingForOtherCommittee },attrs:{"slot":"content"},slot:"content"},[(_vm.isDeleted && !_vm.isLoading)?_c('div',[_c('h1',{staticClass:"h2 mb-3"},[_vm._v("Committee Affiliation Application")]),_vm._v(" "),_c('div',[_vm._v("\n        Error. Please contact the ACA office for further clarifications.\n      ")])]):_c('div',[(_vm.allowCommittee === true)?_c('div',[_c('committee-affiliation-form',{attrs:{"secretary":_vm.memberDetails,"committeeDetails":_vm.committee,"isLoading":_vm.isLoading}})],1):_vm._e()]),_vm._v(" "),(!_vm.allowCommittee)?_c('div',{staticClass:"text-center p-2"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeNotRegistered_vue__ = __webpack_require__(427);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b819cb5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeNotRegistered_vue__ = __webpack_require__(1069);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeNotRegistered_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b819cb5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeNotRegistered_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',[_c('div',{staticClass:"tab-pane row mx-0 show active",attrs:{"slot":"tabContent"},slot:"tabContent"},[_c('div',{staticClass:"col px-0 pr-lg-3"},[_c('section',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v("Committee")]),_vm._v(" "),_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n          As soon as you are approved to join a certain committee by Admin, you will gain access to Nominations Dashboard "),_c('br'),_vm._v("\n          and Committee area.\n        ")]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"40px","margin-bottom":"20px"}},[_c('h3',[_vm._v("Have an issue?")]),_vm._v(" "),_c('div',[_vm._v("If you experience some difficulties or are not sure what the status of your application is, please contact us on (07) 4622 3110.")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__ = __webpack_require__(428);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b32a9afc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__ = __webpack_require__(1073);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b32a9afc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartForm_vue__ = __webpack_require__(429);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_015b76f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartForm_vue__ = __webpack_require__(1072);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CartForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_015b76f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CartForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bg-white rounded mb-2 p-3 p-sm-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-3"},[_c('h1',{staticClass:"h2"},[_vm._v("Your Cart")]),_vm._v(" "),(_vm.errors)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors))]):_vm._e()]),_vm._v(" "),(_vm.committee && _vm.product)?_c('div',{staticClass:"col-12"},[(!_vm.$store.state.showExpand && _vm.cartMembers)?_c('table',{staticClass:"table table-striped table-bordered border-0"},[_vm._m(0),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.committee.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.product.name))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.product.price))])])]),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',{staticClass:"border-0",attrs:{"align":"right","colspan":"4"}},[_c('strong',[_vm._v("Your total: $"+_vm._s(_vm.total.toFixed(2)))])]),_vm._v(" "),_c('td',{staticClass:"border-0"})]),_vm._v(" "),_vm._m(1)])]):_vm._e()]):_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-info",attrs:{"role":"alert"}},[_vm._v("Your cart is empty")])]),_vm._v(" "),_c('div',{staticClass:"col-12 d-flex flex-wrap justify-content-end"},[_c('router-link',{staticClass:"btn btn-block-mob btn-outline-primary order-1 order-lg-0",attrs:{"tag":"button","to":"/committees/affiliation"}},[_vm._v("\n        Back to Form\n      ")]),_vm._v(" "),(!!_vm.product)?_c('button',{class:['btn btn-block-mob btn-primary mb-2 mb-lg-0 ml-lg-2'],on:{"click":_vm.submit}},[_vm._v("Proceed to Payment\n      ")]):_vm._e()],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"position-relative"},[_vm._v("Committee name")]),_vm._v(" "),_c('th',{staticClass:"position-relative"},[_vm._v("Type")]),_vm._v(" "),_c('th',{staticClass:"position-relative column-lg-small"},[_vm._v("Price")]),_vm._v(" "),_c('th',{staticClass:"position-relative column-lg-small"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"border-0",attrs:{"align":"right","colspan":"5"}}),_vm._v(" "),_c('td',{staticClass:"border-0"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',[_c('cart-form',{staticClass:"tab-pane col-12 col-xl-9 px-0 show active",attrs:{"slot":"tabContent","cartMembers":_vm.cartMembers,"id":"cart","role":"tabpanel","aria-label":"Cart"},slot:"tabContent"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__ = __webpack_require__(430);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27810dc0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__ = __webpack_require__(1075);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27810dc0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',[_c('payment',{staticClass:"tab-pane col-12 col-xl-9 px-0 show active",attrs:{"slot":"tabContent","cartMembers":_vm.cartMembers,"type":'committee-affiliation',"id":"payment","role":"tabpanel","aria-label":"Payment"},slot:"tabContent"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeEditSecretary_vue__ = __webpack_require__(431);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d5d25d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeEditSecretary_vue__ = __webpack_require__(1090);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeEditSecretary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d5d25d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeEditSecretary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeDetailsSecretaries_vue__ = __webpack_require__(432);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e05d5c7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeDetailsSecretaries_vue__ = __webpack_require__(1080);
function injectStyle (ssrContext) {
  __webpack_require__(1078)
  __webpack_require__(1079)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e05d5c7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeDetailsSecretaries_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e05d5c7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeDetailsSecretaries_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1078 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-0 block"},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v("Committee Secretaries")]),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"text-center p-2"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('div',[(_vm.errors)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',[_vm._v("Select a Secretary")]),_vm._v(" "),_c('vue-bootstrap-typeahead',{attrs:{"data":_vm.secretaries,"serializer":function (s) { return s.first_name + ' ' + s.last_name; },"placeholder":"Start typing..."},on:{"hit":function($event){_vm.selectedSecretary = $event}},model:{value:(_vm.secretariesSearch),callback:function ($$v) {_vm.secretariesSearch=$$v},expression:"secretariesSearch"}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Secretary.")])],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group button-add-secretary-wrapper"},[_c('button',{class:['btn btn-block button-add-secretary', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],attrs:{"disabled":_vm.processing},on:{"click":_vm.handleAddSecretary}},[_vm._v("\n          "+_vm._s(_vm.processing ? '' : 'Add Secretary')+"\n          "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-10 col-md-5 form-group"},_vm._l((_vm.addedSecretaries),function(secretary,index){return _c('div',{staticClass:"secretaries-list-item"},[_c('div',[_vm._v(_vm._s(secretary.first_name + ' ' + secretary.last_name))]),_vm._v(" "),_c('div',[_c('button',{key:secretary.id,ref:'secretary-item',refInFor:true,staticClass:"btn btn-sm button-remove-secretary",on:{"click":function($event){return _vm.removeSecretary(secretary.id, index)}}},[_vm._v(_vm._s(_vm.removeProcessing ? '' : 'Remove')+"\n            ")])])])}),0)])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeDetailsMembersStatus_vue__ = __webpack_require__(433);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1396bcc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeDetailsMembersStatus_vue__ = __webpack_require__(1083);
function injectStyle (ssrContext) {
  __webpack_require__(1082)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b1396bcc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeDetailsMembersStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1396bcc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeDetailsMembersStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1082 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-0 block"},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v("Committee Members List")]),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"text-center p-2"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('div',[(_vm.success)?_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.success))]):_vm._e(),_vm._v(" "),(_vm.errors)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.errors))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 form-group"},_vm._l((_vm.currentCommitteeMembers),function(member){return _c('p',{key:member.id},[_c('span',{staticClass:"col-12 row ml-0"},[_vm._v(" "+_vm._s(member.first_name + ' ' + member.last_name)+" ")]),_vm._v(" "),_vm._l((member.committee_membership_statuses),function(status){return _c('span',{key:status.id,staticClass:"badge row ml-3 alert-success"},[_vm._v("\n              "+_vm._s(status.name)+"\n            ")])}),_vm._v(" "),_c('span',{staticClass:"col-12 row ml-0"},[_c('a',{attrs:{"href":"#","disabled":_vm.processing},on:{"click":function($event){$event.preventDefault();return _vm.setSingleMemberEdit(member.id)}}},[_vm._v("Edit")]),_vm._v(" "),_c('a',{staticClass:"ml-2",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.removeCommitteeMemberStatus(member.id)}}},[_vm._v("Remove")])])],2)}),0)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-lg-5 col-12 form-group button-add-committee-member-wrapper"},[_c('button',{class:['btn btn-block button-add-committee-member', _vm.processing ? 'btn-primary-dark' : 'btn-primary'],attrs:{"disabled":_vm.processing},on:{"click":function($event){$event.preventDefault();_vm.showModal = true}}},[_vm._v("\n          "+_vm._s(_vm.processing ? '' : 'Add Member')+"\n          "),(_vm.processing)?_c('div',{staticClass:"spinner-border text-light",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e()])])])]):_vm._e(),_vm._v(" "),(_vm.showModal)?_c('modal',{on:{"close":function($event){_vm.showModal = false}}},[_c('h3',{staticClass:"modal-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Add a Member")]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 form-group"},[_c('vue-bootstrap-typeahead',{attrs:{"data":_vm.foundCommitteeMembers,"serializer":function (s) { return s.first_name + ' ' + s.last_name; },"placeholder":"Start typing..."},on:{"hit":function($event){_vm.selectedMember = $event}},model:{value:(_vm.searchMember),callback:function ($$v) {_vm.searchMember=$$v},expression:"searchMember"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-bordered border-0"},[_c('thead',[_c('tr',[_c('th',{staticClass:"position-relative"},[_vm._v("Name")]),_vm._v(" "),_c('th',{staticClass:"position-relative"},[_vm._v("Email")]),_vm._v(" "),_c('th',{staticClass:"position-relative"},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"position-relative"})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.committeeMembers),function(member){return _c('tr',{key:member.id},[_c('td',[_vm._v(_vm._s(member.first_name + ' ' + member.last_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(member.attributes.email))]),_vm._v(" "),_c('td',[_c('form',{attrs:{"id":("form_" + (member.id))}},[_c('ul',{staticClass:"col-12 member-status-list"},_vm._l((_vm.statusesList),function(status){return _c('li',{key:status.id},[_c('div',{staticClass:"member-status-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedStatuses[member.id]),expression:"checkedStatuses[member.id]"}],attrs:{"type":"checkbox","disabled":_vm.currentMembersIds.includes(member.id),"name":("status[" + (member.id) + "]"),"id":("status_" + (member.id) + (status.id))},domProps:{"value":status.id,"checked":Array.isArray(_vm.checkedStatuses[member.id])?_vm._i(_vm.checkedStatuses[member.id],status.id)>-1:(_vm.checkedStatuses[member.id])},on:{"change":function($event){var $$a=_vm.checkedStatuses[member.id],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=status.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.checkedStatuses, member.id, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.checkedStatuses, member.id, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.checkedStatuses, member.id, $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"mb-0",attrs:{"for":("status_" + (member.id) + (status.id))}},[_vm._v(_vm._s(status.name))])])])}),0)])]),_vm._v(" "),_c('td',[(_vm.currentMembersIds.includes(member.id))?_c('p',[_vm._v("Added")]):_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.saveCommitteeMemberStatus(member.id)}}},[_vm._v("Add to List")])])])}),0)])])])])]):_vm._e(),_vm._v(" "),(_vm.singleMemberModal)?_c('modal',{on:{"close":function($event){_vm.singleMemberModal = false}}},[_c('h3',{staticClass:"modal-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Edit Member")]),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-bordered table-responsive border-0"},[_c('thead',[_c('tr',[_c('th',{staticClass:"position-relative"},[_vm._v("Name")]),_vm._v(" "),_c('th',{staticClass:"position-relative"},[_vm._v("Email")]),_vm._v(" "),_c('th',{staticClass:"position-relative"},[_vm._v("Status")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.singleMemberEdit.first_name + ' ' + _vm.singleMemberEdit.last_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.singleMemberEdit.attributes.email))]),_vm._v(" "),_c('td',[_c('form',{attrs:{"id":("edit_form_" + (_vm.singleMemberEdit.id))}},[_c('ul',{staticClass:"member-status-list"},_vm._l((_vm.statusesList),function(status){return _c('li',{key:status.id},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.singleMemberEditStatuses[_vm.singleMemberEdit.id]),expression:"singleMemberEditStatuses[singleMemberEdit.id]"}],attrs:{"type":"checkbox","name":("status[" + (_vm.singleMemberEdit.id) + "]"),"id":("edit_status_" + (_vm.singleMemberEdit.id) + (status.id))},domProps:{"value":status.id,"checked":Array.isArray(_vm.singleMemberEditStatuses[_vm.singleMemberEdit.id])?_vm._i(_vm.singleMemberEditStatuses[_vm.singleMemberEdit.id],status.id)>-1:(_vm.singleMemberEditStatuses[_vm.singleMemberEdit.id])},on:{"change":function($event){var $$a=_vm.singleMemberEditStatuses[_vm.singleMemberEdit.id],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=status.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.singleMemberEditStatuses, _vm.singleMemberEdit.id, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.singleMemberEditStatuses, _vm.singleMemberEdit.id, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.singleMemberEditStatuses, _vm.singleMemberEdit.id, $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"mb-0",attrs:{"for":("edit_status_" + (_vm.singleMemberEdit.id) + (status.id))}},[_vm._v(_vm._s(status.name))])])}),0)])])])])])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"col-12 d-flex justify-content-center"},[_c('button',{staticClass:"btn btn-outline-primary ml-2",on:{"click":function($event){$event.preventDefault();_vm.singleMemberModal = false}}},[_vm._v("Cancel")]),_vm._v("\n         \n        "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.singleMemberModal = false;_vm.saveCommitteeMemberStatus(_vm.singleMemberEdit.id, 'edit_')}}},[_vm._v("\n          Save\n        ")])])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeEdit_vue__ = __webpack_require__(434);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d817452_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeEdit_vue__ = __webpack_require__(1089);
function injectStyle (ssrContext) {
  __webpack_require__(1085)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d817452"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d817452_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1085 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeDetailsForm_vue__ = __webpack_require__(435);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34377162_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeDetailsForm_vue__ = __webpack_require__(1088);
function injectStyle (ssrContext) {
  __webpack_require__(1087)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34377162"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommitteeDetailsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34377162_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommitteeDetailsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1087 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"needs-validation ml-0",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v("Committee Details")]),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"text-center p-2"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('div',[(_vm.errors.length)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},_vm._l((_vm.errors),function(error){return _c('div',[_vm._v(_vm._s(error))])}),0):_vm._e(),_vm._v(" "),(_vm.submitStatus === 'ERROR')?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("\n      Please fill the form correctly.\n    ")]):_vm._e(),_vm._v(" "),(_vm.submitStatus === 'SUCCESS')?_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n      The Committee data saved successfully.\n    ")]):_vm._e(),_vm._v(" "),(_vm.errorStatus)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("\n      "+_vm._s(_vm.errorStatus)+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.name.$model),expression:"$v.data.name.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.name.$error },attrs:{"type":"text","id":"committeeName","required":""},domProps:{"value":(_vm.$v.data.name.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.name, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Committee Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:( _vm.$v.data.contact_name.$model),expression:" $v.data.contact_name.$model"}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.contact_name.$error || _vm.errorFields.contact_name === true },attrs:{"type":"text","id":"contactNameCreate","required":""},domProps:{"value":( _vm.$v.data.contact_name.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.contact_name, "$model", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Contact Name.")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"committeeLogoFile"}},[_vm._v("Committee logo")]),_vm._v(" "),_c('div',{staticClass:"custom-file"},[_c('input',{staticClass:"form-control custom-file-input",class:{ 'is-invalid': _vm.logoError.fileSize },attrs:{"type":"file","name":_vm.logo_file,"id":"committeeLogoFile","accept":"image/*"},on:{"change":_vm.logoUpload}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label font-weight-normal",attrs:{"for":"committeeLogoFile"}},[_vm._v(_vm._s(_vm.logo_name ? _vm.logo_name : 'Choose file...'))]),_vm._v(" "),_c('small',[_vm._v("jpg, jpeg, png, tiff, gif file type required.")]),_vm._v(" "),(_vm.logoError.fileSize)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Logo File may not be greater than 250 kilobytes")]):_vm._e(),_vm._v(" "),(_vm.logo_name)?_c('button',{staticClass:"btn btn-link px-2 pl-md-0 px-xl-2 pr-md-1",attrs:{"type":"button"},on:{"click":_vm.deleteLogoAttachment}},[_c('span',{staticClass:"sr-only"},[_vm._v("Delete File")]),_vm._v(" "),_c('div',{staticClass:"btn-remove"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"}})])])])]):_vm._e()]),_vm._v(" "),(this.data.logo_file_path)?_c('div',{staticClass:"attached-file-wrapper"},[_vm._v("\n          "+_vm._s(this.data.logo_file_name)+"\n          "),_c('div',{staticClass:"btn-remove-file",on:{"click":_vm.deleteExistsAttachment}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"}})])])]),_vm._v(" "),_c('div',{staticClass:"btn-download-file",on:{"click":function($event){return _vm.downloadLogoFile(_vm.data.id)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"}})])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"picNumber"}},[_vm._v("PIC number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.pic_number.$model),expression:"$v.data.pic_number.$model",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":"picNumber"},domProps:{"value":(_vm.$v.data.pic_number.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.pic_number, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.$v.data.contact_email.$model),expression:"$v.data.contact_email.$model",modifiers:{"lazy":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.contact_email.$error || _vm.errorFields.contact_email === true},attrs:{"type":"text","id":"committeeEmail","required":""},domProps:{"value":(_vm.$v.data.contact_email.$model)},on:{"blur":function($event){return _vm.$v.data.contact_email.$touch()},"change":function($event){return _vm.$set(_vm.$v.data.contact_email, "$model", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("\n          "+_vm._s((_vm.$v.data.contact_email.$error || _vm.errorFields.contact_email === true) && _vm.errorStatus
              ? _vm.errorStatus
              : 'Please include the valid Email.')+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(4),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.contact_phone.$model),expression:"$v.data.contact_phone.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.contact_phone.$error },attrs:{"type":"text","id":"committeePhone","required":""},domProps:{"value":(_vm.$v.data.contact_phone.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.contact_phone, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(!_vm.$v.data.contact_phone.required)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Phone number.")]):_vm._e(),_vm._v(" "),(!_vm.$v.data.contact_phone.phoneRegex)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the valid Phone number.")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(5),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.abn.$model),expression:"$v.data.abn.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.abn.$error },attrs:{"type":"text","id":"committeeAbn","required":""},domProps:{"value":(_vm.$v.data.abn.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.abn, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the ABN.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(6),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.cheques_to.$model),expression:"$v.data.cheques_to.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.cheques_to.$error },attrs:{"type":"text","id":"committeeChequesTo","required":""},domProps:{"value":(_vm.$v.data.cheques_to.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.cheques_to, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Cheques To.")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(7),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.city.$model),expression:"$v.data.city.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{'is-invalid': _vm.$v.data.city.$error || _vm.errorFields.city === true},attrs:{"type":"text","id":"committeeCity","required":""},domProps:{"value":(_vm.$v.data.city.$model)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.city, "$model", $event.target.value.trim())},function($event){return _vm.findZone()}],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the valid city.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(8),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.state.$model),expression:"$v.data.state.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.state.$error },attrs:{"id":"state","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.$v.data.state, "$model", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',{attrs:{"value":"QLD"}},[_vm._v("Queensland")]),_vm._v(" "),_c('option',{attrs:{"value":"NSW"}},[_vm._v("New South Wales")]),_vm._v(" "),_c('option',{attrs:{"value":"VIC"}},[_vm._v("Victoria")]),_vm._v(" "),_c('option',{attrs:{"value":"ACT"}},[_vm._v("Australian Capital Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"SA"}},[_vm._v("South Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"NT"}},[_vm._v("Northern Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"WA"}},[_vm._v("Western Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"TAS"}},[_vm._v("Tasmania")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your State.")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-3 form-group"},[_vm._m(9),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.post_code.$model),expression:"$v.data.post_code.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.post_code.$error || _vm.errorFields.postal_code === true },attrs:{"type":"text","id":"postcode","maxlength":"4","required":"","pattern":"\\d{4}"},domProps:{"value":(_vm.$v.data.post_code.$model)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.post_code, "$model", $event.target.value.trim())},function($event){return _vm.findZone()}],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the valid postcode.")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_vm._m(10),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.zone_id.$model),expression:"$v.data.zone_id.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.zone_id.$error },attrs:{"id":"zone"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.$v.data.zone_id, "$model", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Unspecified")]),_vm._v(" "),_vm._l((_vm.$store.state.listZones.filter(function (zone) { return !zone.deleted_at; })),function(zone,index){return _c('option',{key:index,domProps:{"value":zone.id}},[_vm._v(_vm._s(zone.code)+"\n          ")])})],2),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Zone.")]),_vm._v(" "),(_vm.zoneNotFound && !_vm.zoneNotSpecified)?_c('div',{staticClass:"alert alert-warning alert-sm"},[_vm._v("Unable to find matching\n          Zone.\n        ")]):(_vm.zoneNotSpecified && _vm.zoneErrorMessage)?_c('div',{staticClass:"alert alert-warning alert-sm zone-alert"},[_vm._v(_vm._s(_vm.zoneErrorMessage))]):(_vm.zoneFound)?_c('div',{staticClass:"alert alert-success alert-sm zone-alert"},[_vm._v("Found matching Zone.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_vm._m(11),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.account_number.$model),expression:"$v.data.account_number.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.account_number.$error || _vm.errorFields.account_number === true },attrs:{"type":"text","id":"committeeAccountNumber","required":""},domProps:{"value":(_vm.$v.data.account_number.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.account_number, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include correct the Account Number.")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_vm._m(12),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.address.$model),expression:"$v.data.address.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.address.$error || _vm.errorFields.line1 === true},attrs:{"type":"text","id":"committeeAddress","required":""},domProps:{"value":(_vm.$v.data.address.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.address, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the valid address.")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-3 form-group"},[_vm._m(13),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.bsb.$model),expression:"$v.data.bsb.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.bsb.$error || _vm.errorFields.routing_number === true},attrs:{"type":"text","id":"committeeBSB","required":"","maxlength":"7"},domProps:{"value":(_vm.$v.data.bsb.$model)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.bsb, "$model", $event.target.value.trim())},_vm.validateBankBsb],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(!_vm.$v.data.bsb.bsbRegex || _vm.errorFields.routing_number === true)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the valid BSB.")]):_vm._e(),_vm._v(" "),_c('small',{staticClass:"small-notes small-notes-per"},[_vm._v("Please enter the bank's BSB in the format XXX-YYY.")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_c('label',{attrs:{"for":"committeeName"}},[_vm._v("Bank Abbreviation")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.bank_abbreviation.$model),expression:"$v.data.bank_abbreviation.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.bank_abbreviation.$error },attrs:{"type":"text","id":"committeeBankAbbreviation","required":""},domProps:{"value":(_vm.$v.data.bank_abbreviation.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.bank_abbreviation, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Bank Abbreviation.")]),_vm._v(" "),_c('small',{staticClass:"small-notes small-notes-per"},[_vm._v("The bank abbreviation must be approved Financial Institution\n          abbreviation.")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group gst_registered"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.gst_registered.$model),expression:"$v.data.gst_registered.$model",modifiers:{"trim":true}}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"gst_registered"},domProps:{"checked":Array.isArray(_vm.$v.data.gst_registered.$model)?_vm._i(_vm.$v.data.gst_registered.$model,null)>-1:(_vm.$v.data.gst_registered.$model)},on:{"change":function($event){var $$a=_vm.$v.data.gst_registered.$model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.$v.data.gst_registered, "$model", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.$v.data.gst_registered, "$model", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.$v.data.gst_registered, "$model", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"gst_registered"}},[_vm._v("\n            I am GST registered\n          ")]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include true or false.")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-3 form-group"},[_vm._m(14),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.is_enabled_stripe),expression:"data.is_enabled_stripe"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"accept","value":"1"},domProps:{"checked":_vm.data.is_enabled_stripe == '1',"checked":_vm._q(_vm.data.is_enabled_stripe,"1")},on:{"change":function($event){return _vm.$set(_vm.data, "is_enabled_stripe", "1")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label font-weight-normal",attrs:{"for":"accept"}},[_vm._v("Accept")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.is_enabled_stripe),expression:"data.is_enabled_stripe"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"notAccept","value":"0"},domProps:{"checked":_vm.data.is_enabled_stripe == '0',"checked":_vm._q(_vm.data.is_enabled_stripe,"0")},on:{"change":function($event){return _vm.$set(_vm.data, "is_enabled_stripe", "0")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label font-weight-normal",attrs:{"for":"notAccept"}},[_vm._v("Not Accept")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticClass:"small-notes small-notes-per"},[_vm._v("To accept instant online payments such as credit card for nomination fees.")])])]),_vm._v(" "),(_vm.data.is_enabled_stripe == '1')?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-3 form-group"},[_c('label',[_vm._v("Bank Owner First Name ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.bank_owner_first_name.$model),expression:"$v.data.bank_owner_first_name.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.bank_owner_first_name.$error },attrs:{"type":"text","required":""},domProps:{"value":(_vm.$v.data.bank_owner_first_name.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.bank_owner_first_name, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Bank Owner First Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_c('label',[_vm._v("Bank Owner Last Name ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.bank_owner_last_name.$model),expression:"$v.data.bank_owner_last_name.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.bank_owner_last_name.$error },attrs:{"type":"text","required":""},domProps:{"value":(_vm.$v.data.bank_owner_last_name.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.bank_owner_last_name, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Bank Owner Last Name.")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-3 form-group"},[_c('label',[_vm._v("Bank Owner Day Of Birth ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.bank_owner_dob.$model),expression:"$v.data.bank_owner_dob.$model",modifiers:{"trim":true}}],staticClass:"form-control form-date",class:{ 'is-invalid': _vm.$v.data.bank_owner_dob.$error },attrs:{"type":"date","id":"bankOwnerDOB","required":"","placeholder":'dd.mm.yyyy',"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}"},domProps:{"value":(_vm.$v.data.bank_owner_dob.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.bank_owner_dob, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Bank Owner Day Of Birth.")])]),_vm._v(" "),(!_vm.data.is_stripe_verified)?_c('div',{staticClass:"col-6 col-md-3 form-group"},[_c('label',{attrs:{"for":"bankIdentityFile"}},[_vm._v("Bank Identity File")]),_vm._v(" "),_c('div',{staticClass:"custom-file"},[_c('input',{staticClass:"form-control custom-file-input",class:{ 'is-invalid': _vm.fileError.required || _vm.fileError.fileSize },attrs:{"type":"file","id":"bankIdentityFile","accept":"image/*, application/pdf"},on:{"change":_vm.fileUpload}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label font-weight-normal",attrs:{"for":"bankIdentityFile"}},[_vm._v(_vm._s(_vm.file_name ? _vm.file_name : 'Choose file...'))]),_vm._v(" "),(_vm.fileError.required)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Bank Identity File.")]):_vm._e(),_vm._v(" "),(_vm.fileError.fileSize)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Bank Identity File may not be greater than 1 mb\n            ")]):_vm._e(),_vm._v(" "),_c('small',[_vm._v("File needs to include BOTH sides of your identification in colour")]),_vm._v(" "),(_vm.file_name)?_c('button',{staticClass:"btn btn-link px-2 pl-md-0 px-xl-2 pr-md-1",attrs:{"type":"button"},on:{"click":_vm.deleteAttachment}},[_c('span',{staticClass:"sr-only"},[_vm._v("Delete File")]),_vm._v(" "),_c('div',{staticClass:"btn-remove"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"}})])])])]):_vm._e()])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-3 form-group save-details-button"},[_c('button',{staticClass:"btn btn-block mb-2 btn-primary",attrs:{"disabled":_vm.submitStatus == 'PENDING',"type":"submit"}},[(_vm.submitStatus == 'PENDING')?_c('div',{staticClass:"spinner-border",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e(),_vm._v(" "),(_vm.submitStatus != 'PENDING' || !_vm.submitStatus)?_c('div',[_vm._v("Save Details")]):_vm._e()])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeName"}},[_vm._v("Committee Name "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"contactNameCreate"}},[_vm._v("Contact Name "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeName"}},[_vm._v("Contact Email "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeName"}},[_vm._v("Contact Phone "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeName"}},[_vm._v("ABN "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeName"}},[_vm._v("Cheques To "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeName"}},[_vm._v("City "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"state"}},[_vm._v("State "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"postcode"}},[_vm._v("Postcode "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"zone"}},[_vm._v("Zone "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeName"}},[_vm._v("Account Number "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeName"}},[_vm._v("Address "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeName"}},[_vm._v("BSB "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{},[_vm._v("Credit Card Payments")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-0 block"},[_c('div',{staticClass:"bg-white rounded mb-4 p-3 p-sm-4"},[_c('h1',{staticClass:"h2 mb-3 d-flex align-items-start"},[_vm._v("Committee\n      "),(!_vm.isDeleted && !_vm.isLoading)?_c('span',{staticClass:"badge ml-3 is-financial-badge",class:[_vm.data && _vm.data.is_financial ? 'alert-info' : 'alert-warning']},[_vm._v("\n        "+_vm._s(_vm.data && _vm.data.is_financial ? 'Financial' : 'Unfinancial')+"\n      ")]):_vm._e()]),_vm._v(" "),(_vm.isDeleted)?_c('div',[_vm._v("\n      Error. Please contact the ACA office for further clarifications.\n    ")]):_c('div',[(!_vm.isLoading && _vm.data.is_financial)?_c('div',{staticClass:"alert alert-info",attrs:{"role":"alert"}},[_c('b',[_vm._v("Paid seasons: ")]),_vm._v(" January 1, "+_vm._s(this.$store.state.currentDate ? new Date(this.$store.state.currentDate).getFullYear() : new Date().getFullYear())+" to December 31, "+_vm._s(this.$store.state.currentDate ? new Date(this.$store.state.currentDate).getFullYear() : new Date().getFullYear())+"\n      ")]):_vm._e(),_vm._v(" "),(!_vm.isLoading && !_vm.data.is_financial && _vm.isCurrentAffiliationExist() && _vm.isCurrentAffiliationinvoiceCreated())?_c('div',{staticClass:"alert alert-info",attrs:{"role":"alert"}},[_vm._v("\n        If you chose to pay via "),_c('strong',[_vm._v("Bank Transfer")]),_vm._v(" or "),_c('strong',[_vm._v("Claim Voucher")]),_vm._v(", please note:\n        "),_c('br'),_c('br'),_vm._v(" "),_vm._m(0),_vm._v("\n        If you have any questions or require further assistance, please don’t hesitate to contact the ACA Office in\n        business hours.\n        "),_c('br'),_c('br'),_vm._v("\n        Thank you for your patience and understanding.\n      ")]):_vm._e(),_vm._v(" "),(!_vm.isLoading && !_vm.data.is_financial && !_vm.isCurrentAffiliationExist())?_c('div',{staticClass:"alert alert-info d-flex justify-content-between align-items-center flex-wrap",attrs:{"role":"alert"}},[_c('div',{staticClass:"mb-md-0 mb-2"},[_vm._v("\n          Committee Affiliation Fee is ready for payment.\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-block btn-primary pay-affiliation",on:{"click":function($event){return _vm.redirectToAffiliationPage()}}},[_vm._v("\n          Pay Affiliation Fee\n        ")])]):_vm._e(),_vm._v(" "),(!_vm.isLoading && !_vm.data.is_financial && _vm.isCurrentAffiliationExist() && !_vm.isCurrentAffiliationCompleted() && !_vm.isCurrentAffiliationinvoiceCreated())?_c('div',{staticClass:"alert alert-info align-items-center d-block d-md-flex flex-wrap justify-content-between",attrs:{"role":"alert"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"d-block d-md-flex flex-wrap justify-content-between"},[_c('button',{staticClass:"btn btn-block-mob btn-primary mb-2 w-md-auto mb-md-0 mr-md-2 pay-affiliation",on:{"click":function($event){return _vm.redirectToCartPage()}}},[_vm._v("\n            Check Out\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-block-mob btn-primary mb-2 w-md-auto mb-md-0 mr-md-2 pay-affiliation",on:{"click":function($event){return _vm.redirectToAffiliationPage()}}},[_vm._v("\n            Back to Form\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-block-mob btn-primary w-md-100 pay-affiliation",on:{"click":function($event){return _vm.cancelAffiliation()}}},[_vm._v("\n            Cancel Application\n          ")])])]):_vm._e()]),_vm._v(" "),(!_vm.isLoading && !_vm.data.is_financial && _vm.data.curent_affiliation && _vm.data.curent_affiliation.is_completed == true)?_c('div',[_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n        Thank you. Waiting for payment.\n      ")]),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"text-center p-2"},[_vm._m(3)]):_vm._e(),_vm._v(" "),_c('form',{staticClass:"needs-validation ml-0",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('h1',{staticClass:"h2 mb-3"},[_vm._v("Committee Details")]),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"text-center p-2"},[_vm._m(4)]):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('div',[_c('div',{ref:"validationErrorAlert"},[(_vm.errors.length)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},_vm._l((_vm.errors),function(error){return _c('div',[_vm._v(_vm._s(error))])}),0):_vm._e(),_vm._v(" "),(_vm.submitStatus === 'ERROR')?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("\n            Please fill the form correctly.\n          ")]):_vm._e(),_vm._v(" "),(_vm.errorStatus)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("\n            "+_vm._s(_vm.errorStatus)+"\n          ")]):_vm._e()]),_vm._v(" "),(_vm.submitStatus === 'SUCCESS')?_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n          The Committee data saved successfully.\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(5),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.name.$model),expression:"$v.data.name.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.name.$error || _vm.errorFields.name},attrs:{"type":"text","id":"committeeName","required":""},domProps:{"value":(_vm.$v.data.name.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.name, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Committee name must contain letters and spaces only.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(6),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:( _vm.$v.data.contact_name.$model),expression:" $v.data.contact_name.$model"}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.contact_name.$error || _vm.errorFields.contact_name === true },attrs:{"type":"text","id":"contactNameCreate","required":""},domProps:{"value":( _vm.$v.data.contact_name.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.contact_name, "$model", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Contact Name.")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"committeeLogoFile"}},[_vm._v("Committee logo")]),_vm._v(" "),_c('div',{staticClass:"custom-file"},[_c('input',{staticClass:"form-control custom-file-input",class:{ 'is-invalid': _vm.logoError.fileSize },attrs:{"type":"file","name":_vm.logo_file,"id":"committeeLogoFile","accept":"image/*"},on:{"change":_vm.logoUpload}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label font-weight-normal",attrs:{"for":"committeeLogoFile"}},[_vm._v(_vm._s(_vm.logo_name ? _vm.logo_name : 'Choose file...'))]),_vm._v(" "),_c('small',[_vm._v("jpg, jpeg, png, tiff, gif file type required.")]),_vm._v(" "),(_vm.logoError.fileSize)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Logo File may not be greater than 250\n                kilobytes\n              ")]):_vm._e(),_vm._v(" "),(_vm.logo_name)?_c('button',{staticClass:"btn btn-link px-2 pl-md-0 px-xl-2 pr-md-1",attrs:{"type":"button"},on:{"click":_vm.deleteLogoAttachment}},[_c('span',{staticClass:"sr-only"},[_vm._v("Delete File")]),_vm._v(" "),_c('div',{staticClass:"btn-remove"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"}})])])])]):_vm._e()]),_vm._v(" "),(this.data.logo_file_path)?_c('div',{staticClass:"attached-file-wrapper"},[_c('span',{staticStyle:{"word-break":"break-all"}},[_vm._v("\n                "+_vm._s(this.data.logo_file_name)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"btn-remove-file",on:{"click":_vm.deleteExistsAttachment}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"}})])])]),_vm._v(" "),_c('div',{staticClass:"btn-download-file",on:{"click":function($event){return _vm.downloadLogoFile(_vm.data.id)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"}})])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_c('label',{attrs:{"for":"picNumber"}},[_vm._v("PIC number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.pic_number.$model),expression:"$v.data.pic_number.$model",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":"picNumber"},domProps:{"value":(_vm.$v.data.pic_number.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.pic_number, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(7),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.$v.data.contact_email.$model),expression:"$v.data.contact_email.$model",modifiers:{"lazy":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.contact_email.$error || _vm.errorFields.contact_email === true},attrs:{"type":"text","id":"committeeEmail","required":""},domProps:{"value":(_vm.$v.data.contact_email.$model)},on:{"blur":function($event){return _vm.$v.data.contact_email.$touch()},"change":function($event){return _vm.$set(_vm.$v.data.contact_email, "$model", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("\n              "+_vm._s((_vm.$v.data.contact_email.$error || _vm.errorFields.contact_email === true) && _vm.errorStatus
                  ? _vm.errorStatus
                  : 'Please include the valid Email.')+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(8),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.contact_phone.$model),expression:"$v.data.contact_phone.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.contact_phone.$error },attrs:{"type":"text","id":"committeePhone","required":""},domProps:{"value":(_vm.$v.data.contact_phone.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.contact_phone, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(!_vm.$v.data.contact_phone.required)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Phone number.\n            ")]):_vm._e(),_vm._v(" "),(!_vm.$v.data.contact_phone.phoneRegex)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the valid Phone\n              number.\n            ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(9),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.abn.$model),expression:"$v.data.abn.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.abn.$error },attrs:{"type":"text","id":"committeeAbn","required":""},domProps:{"value":(_vm.$v.data.abn.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.abn, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the ABN.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(10),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.cheques_to.$model),expression:"$v.data.cheques_to.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.cheques_to.$error },attrs:{"type":"text","id":"committeeChequesTo","required":""},domProps:{"value":(_vm.$v.data.cheques_to.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.cheques_to, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Cheques To.")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(11),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.city.$model),expression:"$v.data.city.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{'is-invalid': _vm.$v.data.city.$error || _vm.errorFields.city === true},attrs:{"type":"text","id":"committeeCity","required":""},domProps:{"value":(_vm.$v.data.city.$model)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.city, "$model", $event.target.value.trim())},function($event){return _vm.findZone()}],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the valid city.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 form-group"},[_vm._m(12),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.state.$model),expression:"$v.data.state.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.state.$error },attrs:{"id":"state","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.$v.data.state, "$model", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":""}}),_vm._v(" "),_c('option',{attrs:{"value":"QLD"}},[_vm._v("Queensland")]),_vm._v(" "),_c('option',{attrs:{"value":"NSW"}},[_vm._v("New South Wales")]),_vm._v(" "),_c('option',{attrs:{"value":"VIC"}},[_vm._v("Victoria")]),_vm._v(" "),_c('option',{attrs:{"value":"ACT"}},[_vm._v("Australian Capital Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"SA"}},[_vm._v("South Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"NT"}},[_vm._v("Northern Territory")]),_vm._v(" "),_c('option',{attrs:{"value":"WA"}},[_vm._v("Western Australia")]),_vm._v(" "),_c('option',{attrs:{"value":"TAS"}},[_vm._v("Tasmania")])]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your State.")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-3 form-group"},[_vm._m(13),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.post_code.$model),expression:"$v.data.post_code.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.post_code.$error || _vm.errorFields.postal_code === true },attrs:{"type":"text","id":"postcode","maxlength":"4","required":"","pattern":"\\d{4}"},domProps:{"value":(_vm.$v.data.post_code.$model)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.post_code, "$model", $event.target.value.trim())},function($event){return _vm.findZone()}],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the valid postcode.")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_vm._m(14),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.zone_id.$model),expression:"$v.data.zone_id.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.zone_id.$error },attrs:{"id":"zone"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.$v.data.zone_id, "$model", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Unspecified")]),_vm._v(" "),_vm._l((_vm.$store.state.listZones.filter(function (zone) { return !zone.deleted_at; })),function(zone,index){return _c('option',{key:index,domProps:{"value":zone.id}},[_vm._v(_vm._s(zone.code)+"\n              ")])})],2),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include your Zone.")]),_vm._v(" "),(_vm.zoneNotFound && !_vm.zoneNotSpecified)?_c('div',{staticClass:"alert alert-warning alert-sm"},[_vm._v("Unable to find\n              matching\n              Zone.\n            ")]):(_vm.zoneNotSpecified && _vm.zoneErrorMessage)?_c('div',{staticClass:"alert alert-warning alert-sm zone-alert"},[_vm._v("\n              "+_vm._s(_vm.zoneErrorMessage)+"\n            ")]):(_vm.zoneFound)?_c('div',{staticClass:"alert alert-success alert-sm zone-alert"},[_vm._v("Found matching Zone.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_vm._m(15),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.account_number.$model),expression:"$v.data.account_number.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.account_number.$error || _vm.errorFields.account_number === true || !_vm.$v.data.account_number.accountNumberRegex},attrs:{"type":"text","id":"committeeAccountNumber","required":""},domProps:{"value":(_vm.$v.data.account_number.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.account_number, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include a valid account number. It must be from 6 to 10 digits.")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_vm._m(16),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.address.$model),expression:"$v.data.address.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.address.$error || _vm.errorFields.line1 === true},attrs:{"type":"text","id":"committeeAddress","required":""},domProps:{"value":(_vm.$v.data.address.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.address, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the valid address.")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-3 form-group"},[_vm._m(17),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.bsb.$model),expression:"$v.data.bsb.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.bsb.$error || _vm.errorFields.routing_number === true},attrs:{"type":"text","id":"committeeBSB","required":"","maxlength":"7"},domProps:{"value":(_vm.$v.data.bsb.$model)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.bsb, "$model", $event.target.value.trim())},_vm.validateBankBsb],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(!_vm.$v.data.bsb.bsbRegex || _vm.errorFields.routing_number === true || !_vm.$v.data.bsb.required)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v("\n              Please include the valid BSB.\n            ")]):_vm._e(),_vm._v(" "),_c('small',{staticClass:"small-notes small-notes-per"},[_vm._v("Please enter the bank's BSB in the format XXX-YYY.")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_c('label',{attrs:{"for":"committeeName"}},[_vm._v("Bank Abbreviation")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.bank_abbreviation.$model),expression:"$v.data.bank_abbreviation.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.bank_abbreviation.$error },attrs:{"type":"text","id":"committeeBankAbbreviation","required":""},domProps:{"value":(_vm.$v.data.bank_abbreviation.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.bank_abbreviation, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Bank Abbreviation.")]),_vm._v(" "),_c('small',{staticClass:"small-notes small-notes-per"},[_vm._v("The bank abbreviation must be approved Financial\n              Institution\n              abbreviation.")])]),_vm._v(" "),_c('div',{staticClass:"col-12   col-md-3 form-group gst_registered"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.gst_registered.$model),expression:"$v.data.gst_registered.$model",modifiers:{"trim":true}}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"gst_registered"},domProps:{"checked":Array.isArray(_vm.$v.data.gst_registered.$model)?_vm._i(_vm.$v.data.gst_registered.$model,null)>-1:(_vm.$v.data.gst_registered.$model)},on:{"change":function($event){var $$a=_vm.$v.data.gst_registered.$model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.$v.data.gst_registered, "$model", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.$v.data.gst_registered, "$model", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.$v.data.gst_registered, "$model", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"gst_registered"}},[_vm._v("\n                I am GST registered\n              ")]),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include true or false.")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-3 form-group"},[_vm._m(18),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.is_enabled_stripe),expression:"data.is_enabled_stripe"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"accept","value":"1"},domProps:{"checked":_vm.data.is_enabled_stripe == '1',"checked":_vm._q(_vm.data.is_enabled_stripe,"1")},on:{"change":function($event){return _vm.$set(_vm.data, "is_enabled_stripe", "1")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label font-weight-normal",attrs:{"for":"accept"}},[_vm._v("Accept")])]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.is_enabled_stripe),expression:"data.is_enabled_stripe"}],staticClass:"custom-control-input",attrs:{"type":"radio","id":"notAccept","value":"0"},domProps:{"checked":_vm.data.is_enabled_stripe == '0',"checked":_vm._q(_vm.data.is_enabled_stripe,"0")},on:{"change":function($event){return _vm.$set(_vm.data, "is_enabled_stripe", "0")}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label font-weight-normal",attrs:{"for":"notAccept"}},[_vm._v("Not Accept")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticClass:"small-notes small-notes-per"},[_vm._v("To accept instant online payments such as credit card for\n              nomination fees.")])])]),_vm._v(" "),(_vm.data.is_enabled_stripe == '1')?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-3 form-group"},[_c('label',[_vm._v("Bank Owner First Name ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.bank_owner_first_name.$model),expression:"$v.data.bank_owner_first_name.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.bank_owner_first_name.$error },attrs:{"type":"text","required":""},domProps:{"value":(_vm.$v.data.bank_owner_first_name.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.bank_owner_first_name, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Bank Owner First Name.")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-md-3 form-group"},[_c('label',[_vm._v("Bank Owner Last Name ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.bank_owner_last_name.$model),expression:"$v.data.bank_owner_last_name.$model",modifiers:{"trim":true}}],staticClass:"form-control",class:{ 'is-invalid': _vm.$v.data.bank_owner_last_name.$error },attrs:{"type":"text","required":""},domProps:{"value":(_vm.$v.data.bank_owner_last_name.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.bank_owner_last_name, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Bank Owner Last Name.")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-3 form-group"},[_c('label',[_vm._v("Bank Owner Day Of Birth ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.$v.data.bank_owner_dob.$model),expression:"$v.data.bank_owner_dob.$model",modifiers:{"trim":true}}],staticClass:"form-control form-date",class:{ 'is-invalid': _vm.$v.data.bank_owner_dob.$error },attrs:{"type":"date","id":"bankOwnerDOB","required":"","placeholder":'dd.mm.yyyy',"pattern":"[0-9]{4}-[0-9]{2}-[0-9]{2}"},domProps:{"value":(_vm.$v.data.bank_owner_dob.$model)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$v.data.bank_owner_dob, "$model", $event.target.value.trim())},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Bank Owner Day Of Birth.")])]),_vm._v(" "),(!_vm.data.is_stripe_verified)?_c('div',{staticClass:"col-6 col-md-3 form-group"},[_c('label',{attrs:{"for":"bankIdentityFile"}},[_vm._v("Bank Identity File")]),_vm._v(" "),_c('div',{staticClass:"custom-file"},[_c('input',{staticClass:"form-control custom-file-input",class:{ 'is-invalid': _vm.fileError.required || _vm.fileError.fileSize },attrs:{"type":"file","id":"bankIdentityFile","accept":"image/*, application/pdf"},on:{"change":_vm.fileUpload}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label font-weight-normal",attrs:{"for":"bankIdentityFile"}},[_vm._v(_vm._s(_vm.file_name ? _vm.file_name : 'Choose file...'))]),_vm._v(" "),(_vm.fileError.required)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Please include the Bank Identity File.\n                ")]):_vm._e(),_vm._v(" "),(_vm.fileError.fileSize)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v("Bank Identity File may not be greater than\n                  1 mb\n                ")]):_vm._e(),_vm._v(" "),_c('small',[_vm._v("File needs to include BOTH sides of your identification in colour")]),_vm._v(" "),(_vm.file_name)?_c('button',{staticClass:"btn btn-link px-2 pl-md-0 px-xl-2 pr-md-1",attrs:{"type":"button"},on:{"click":_vm.deleteAttachment}},[_c('span',{staticClass:"sr-only"},[_vm._v("Delete File")]),_vm._v(" "),_c('div',{staticClass:"btn-remove"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","aria-hidden":"true","viewBox":"0 0 17 17"}},[_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"}})])])])]):_vm._e()])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-md-3 form-group save-details-button"},[_c('button',{staticClass:"btn btn-block mb-2 btn-primary",attrs:{"disabled":_vm.submitStatus == 'PENDING',"type":"submit"}},[(_vm.submitStatus == 'PENDING')?_c('div',{staticClass:"spinner-border",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])]):_vm._e(),_vm._v(" "),(_vm.submitStatus != 'PENDING' || !_vm.submitStatus)?_c('div',[_vm._v("Save Details")]):_vm._e()])])])]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("\n            Access to the committee system will only be granted once your payment has been reviewed and approved by an\n            administrator.\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('li',[_vm._v("\n            This process may take 1-3 business days.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2 mb-md-0"},[_vm._v("\n          The application has been filled\n          "),_c('br'),_vm._v("\n          but the fee hasn’t been paid.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-5"},[_c('h3',[_vm._v("Have an issue?")]),_vm._v(" "),_c('div',[_vm._v("If you experience some difficulties or are not sure what the status of your application is, please contact us on (07) 4622 3110.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeName"}},[_vm._v("Committee Name "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"contactNameCreate"}},[_vm._v("Contact Name "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeName"}},[_vm._v("Contact Email "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeName"}},[_vm._v("Contact Phone "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeName"}},[_vm._v("ABN "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeName"}},[_vm._v("Cheques To "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeName"}},[_vm._v("City "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"state"}},[_vm._v("State "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"postcode"}},[_vm._v("Postcode "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"zone"}},[_vm._v("Zone "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeName"}},[_vm._v("Account Number "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeName"}},[_vm._v("Address "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"committeeName"}},[_vm._v("BSB "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{},[_vm._v("Credit Card Payments")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',[_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'details' ? 'active' : ''],attrs:{"href":"","id":"details-tab","data-toggle":"tab","role":"tab","aria-controls":"details","aria-selected":_vm.selectedTab === 'details' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'details'}}},[_vm._v("Details")])]),_vm._v(" "),_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'financials' ? 'active' : ''],attrs:{"href":"","id":"financials-tab","data-toggle":"tab","role":"tab","aria-controls":"financials","aria-selected":_vm.selectedTab === 'financials' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'financials'}}},[_vm._v("Financials")])]),_vm._v(" "),_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'committeeSecretariesList' ? 'active' : ''],attrs:{"href":"","id":"committeeSecretariesList-tab","data-toggle":"tab","role":"tab","aria-controls":"committeeMembersList","aria-selected":_vm.selectedTab === 'committeeSecretariesList' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'committeeSecretariesList'}}},[_vm._v("Secretaries")])]),_vm._v(" "),_c('li',{staticClass:"nav-item",attrs:{"slot":"tabHeading"},slot:"tabHeading"},[_c('a',{class:['nav-link', _vm.selectedTab === 'committeeMembersList' ? 'active' : ''],attrs:{"href":"","id":"committeeMembersList-tab","data-toggle":"tab","role":"tab","aria-controls":"committeeMembersList","aria-selected":_vm.selectedTab === 'committeeMembersList' ? 'true' : 'false'},on:{"click":function($event){$event.preventDefault();_vm.selectedTab = 'committeeMembersList'}}},[_vm._v("Members")])]),_vm._v(" "),(_vm.selectedTab === 'details')?_c('committee-edit',{staticClass:"tab-pane col-12 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active",class:{ 'acting-readonly': _vm.$isActingForOtherCommittee },attrs:{"slot":"tabContent","memberDetails":_vm.memberDetails,"my":true,"id":"details","role":"tabpanel","aria-labelledby":"details-tab"},on:{"renew":function($event){_vm.renew = true;_vm.selectedTab = 'membership'}},slot:"tabContent"}):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'committeeMembersList' && _vm.memberDetails.committee_id)?_c('committee-details-members-status',{staticClass:"tab-pane col-12 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active",class:{ 'acting-readonly': _vm.$isActingForOtherCommittee },attrs:{"slot":"tabContent","committeeId":_vm.memberDetails.committee_id,"my":true,"id":"details","role":"tabpanel","aria-labelledby":"details-tab"},on:{"renew":function($event){_vm.renew = true;_vm.selectedTab = 'committeeMembersList'}},slot:"tabContent"}):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'committeeSecretariesList' && _vm.memberDetails.committee_id)?_c('committee-details-secretaries',{staticClass:"tab-pane col-12 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active",class:{ 'acting-readonly': _vm.$isActingForOtherCommittee },attrs:{"slot":"tabContent","committeeId":_vm.memberDetails.committee_id,"id":"committeeSecretariesList","role":"tabpanel","aria-labelledby":"committeeSecretariesList-tab"},slot:"tabContent"}):_vm._e(),_vm._v(" "),(_vm.selectedTab === 'financials' && _vm.memberDetails.committee_id)?_c('committee-profile-financials',{staticClass:"tab-pane col-12 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active",class:{ 'acting-readonly': _vm.$isActingForOtherCommittee },attrs:{"slot":"tabContent","committeeId":_vm.memberDetails.committee_id,"id":"financials","role":"tabpanel","aria-labelledby":"financials-tab"},slot:"tabContent"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
 // Put commas in a list of users (currently an object of objects as a result of wonky data-handling)

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('commaSeparateUsers', function (list, index) {
  return "".concat(list[index].first_name, " ").concat(list[index].last_name).concat(index === list.length - 1 ? '' : ',');
});

/***/ }),
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sprite.e23b38f.png";

/***/ })
],[446]);


// WEBPACK FOOTER //
// static/js/app.dbd771eb25a5a45b1fb4.js